(function () {

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

var $parcel$bundleURL;
function $parcel$resolve(url) {
  url = parcelRequire.i?.[url] || url;
  if (!$parcel$bundleURL) {
    try {
      throw new Error();
    } catch (err) {
      var matches = ('' + err.stack).match(
        /(https?|file|ftp|(chrome|moz|safari-web)-extension):\/\/[^)\n]+/g,
      );
      if (matches) {
        $parcel$bundleURL = matches[0];
      } else {
        return $parcel$distDir + url;
      }
    }
  }
  return new URL($parcel$distDir + url, $parcel$bundleURL).toString();
}

function $parcel$extendImportMap(map) {
  Object.assign(parcelRequire.i ??= {}, map);
}

function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  var $parcel$distDir = "./";

var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire164e"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire164e"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("iD4WH", function(module, exports) {
'use strict';

module.exports = (parcelRequire("jIgWH"));

});
parcelRegister("jIgWH", function(module, exports) {

$parcel$export(module.exports, "Fragment", function () { return $e59f457751cca0bb$export$ffb0004e005737fa; }, function (v) { return $e59f457751cca0bb$export$ffb0004e005737fa = v; });
$parcel$export(module.exports, "jsx", function () { return $e59f457751cca0bb$export$34b9dba7ce09269b; }, function (v) { return $e59f457751cca0bb$export$34b9dba7ce09269b = v; });
$parcel$export(module.exports, "jsxs", function () { return $e59f457751cca0bb$export$25062201e9e25d76; }, function (v) { return $e59f457751cca0bb$export$25062201e9e25d76 = v; });
/**
 * @license React
 * react-jsx-runtime.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $e59f457751cca0bb$export$ffb0004e005737fa;
var $e59f457751cca0bb$export$34b9dba7ce09269b;
var $e59f457751cca0bb$export$25062201e9e25d76;
'use strict';

var $dQFEZ = parcelRequire("dQFEZ");
var $e59f457751cca0bb$var$k = Symbol.for("react.element"), $e59f457751cca0bb$var$l = Symbol.for("react.fragment"), $e59f457751cca0bb$var$m = Object.prototype.hasOwnProperty, $e59f457751cca0bb$var$n = $dQFEZ.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, $e59f457751cca0bb$var$p = {
    key: !0,
    ref: !0,
    __self: !0,
    __source: !0
};
function $e59f457751cca0bb$var$q(c, a, g) {
    var b, d = {}, e = null, h = null;
    void 0 !== g && (e = "" + g);
    void 0 !== a.key && (e = "" + a.key);
    void 0 !== a.ref && (h = a.ref);
    for(b in a)$e59f457751cca0bb$var$m.call(a, b) && !$e59f457751cca0bb$var$p.hasOwnProperty(b) && (d[b] = a[b]);
    if (c && c.defaultProps) for(b in a = c.defaultProps, a)void 0 === d[b] && (d[b] = a[b]);
    return {
        $$typeof: $e59f457751cca0bb$var$k,
        type: c,
        key: e,
        ref: h,
        props: d,
        _owner: $e59f457751cca0bb$var$n.current
    };
}
$e59f457751cca0bb$export$ffb0004e005737fa = $e59f457751cca0bb$var$l;
$e59f457751cca0bb$export$34b9dba7ce09269b = $e59f457751cca0bb$var$q;
$e59f457751cca0bb$export$25062201e9e25d76 = $e59f457751cca0bb$var$q;

});
parcelRegister("dQFEZ", function(module, exports) {
'use strict';

module.exports = (parcelRequire("4SjaJ"));

});
parcelRegister("4SjaJ", function(module, exports) {

$parcel$export(module.exports, "Children", function () { return $38cb13c5a0250553$export$dca3b0875bd9a954; }, function (v) { return $38cb13c5a0250553$export$dca3b0875bd9a954 = v; });
$parcel$export(module.exports, "Component", function () { return $38cb13c5a0250553$export$16fa2f45be04daa8; }, function (v) { return $38cb13c5a0250553$export$16fa2f45be04daa8 = v; });
$parcel$export(module.exports, "Fragment", function () { return $38cb13c5a0250553$export$ffb0004e005737fa; }, function (v) { return $38cb13c5a0250553$export$ffb0004e005737fa = v; });
$parcel$export(module.exports, "Profiler", function () { return $38cb13c5a0250553$export$e2c29f18771995cb; }, function (v) { return $38cb13c5a0250553$export$e2c29f18771995cb = v; });
$parcel$export(module.exports, "PureComponent", function () { return $38cb13c5a0250553$export$221d75b3f55bb0bd; }, function (v) { return $38cb13c5a0250553$export$221d75b3f55bb0bd = v; });
$parcel$export(module.exports, "StrictMode", function () { return $38cb13c5a0250553$export$5f8d39834fd61797; }, function (v) { return $38cb13c5a0250553$export$5f8d39834fd61797 = v; });
$parcel$export(module.exports, "Suspense", function () { return $38cb13c5a0250553$export$74bf444e3cd11ea5; }, function (v) { return $38cb13c5a0250553$export$74bf444e3cd11ea5 = v; });
$parcel$export(module.exports, "__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED", function () { return $38cb13c5a0250553$export$ae55be85d98224ed; }, function (v) { return $38cb13c5a0250553$export$ae55be85d98224ed = v; });
$parcel$export(module.exports, "act", function () { return $38cb13c5a0250553$export$3ba232387fd5d6dd; }, function (v) { return $38cb13c5a0250553$export$3ba232387fd5d6dd = v; });
$parcel$export(module.exports, "cloneElement", function () { return $38cb13c5a0250553$export$e530037191fcd5d7; }, function (v) { return $38cb13c5a0250553$export$e530037191fcd5d7 = v; });
$parcel$export(module.exports, "createContext", function () { return $38cb13c5a0250553$export$fd42f52fd3ae1109; }, function (v) { return $38cb13c5a0250553$export$fd42f52fd3ae1109 = v; });
$parcel$export(module.exports, "createElement", function () { return $38cb13c5a0250553$export$c8a8987d4410bf2d; }, function (v) { return $38cb13c5a0250553$export$c8a8987d4410bf2d = v; });
$parcel$export(module.exports, "createFactory", function () { return $38cb13c5a0250553$export$d38cd72104c1f0e9; }, function (v) { return $38cb13c5a0250553$export$d38cd72104c1f0e9 = v; });
$parcel$export(module.exports, "createRef", function () { return $38cb13c5a0250553$export$7d1e3a5e95ceca43; }, function (v) { return $38cb13c5a0250553$export$7d1e3a5e95ceca43 = v; });
$parcel$export(module.exports, "forwardRef", function () { return $38cb13c5a0250553$export$257a8862b851cb5b; }, function (v) { return $38cb13c5a0250553$export$257a8862b851cb5b = v; });
$parcel$export(module.exports, "isValidElement", function () { return $38cb13c5a0250553$export$a8257692ac88316c; }, function (v) { return $38cb13c5a0250553$export$a8257692ac88316c = v; });
$parcel$export(module.exports, "lazy", function () { return $38cb13c5a0250553$export$488013bae63b21da; }, function (v) { return $38cb13c5a0250553$export$488013bae63b21da = v; });
$parcel$export(module.exports, "memo", function () { return $38cb13c5a0250553$export$7c73462e0d25e514; }, function (v) { return $38cb13c5a0250553$export$7c73462e0d25e514 = v; });
$parcel$export(module.exports, "startTransition", function () { return $38cb13c5a0250553$export$7568632d0d33d16d; }, function (v) { return $38cb13c5a0250553$export$7568632d0d33d16d = v; });
$parcel$export(module.exports, "unstable_act", function () { return $38cb13c5a0250553$export$88948ce120ea2619; }, function (v) { return $38cb13c5a0250553$export$88948ce120ea2619 = v; });
$parcel$export(module.exports, "useCallback", function () { return $38cb13c5a0250553$export$35808ee640e87ca7; }, function (v) { return $38cb13c5a0250553$export$35808ee640e87ca7 = v; });
$parcel$export(module.exports, "useContext", function () { return $38cb13c5a0250553$export$fae74005e78b1a27; }, function (v) { return $38cb13c5a0250553$export$fae74005e78b1a27 = v; });
$parcel$export(module.exports, "useDebugValue", function () { return $38cb13c5a0250553$export$dc8fbce3eb94dc1e; }, function (v) { return $38cb13c5a0250553$export$dc8fbce3eb94dc1e = v; });
$parcel$export(module.exports, "useDeferredValue", function () { return $38cb13c5a0250553$export$6a7bc4e911dc01cf; }, function (v) { return $38cb13c5a0250553$export$6a7bc4e911dc01cf = v; });
$parcel$export(module.exports, "useEffect", function () { return $38cb13c5a0250553$export$6d9c69b0de29b591; }, function (v) { return $38cb13c5a0250553$export$6d9c69b0de29b591 = v; });
$parcel$export(module.exports, "useId", function () { return $38cb13c5a0250553$export$f680877a34711e37; }, function (v) { return $38cb13c5a0250553$export$f680877a34711e37 = v; });
$parcel$export(module.exports, "useImperativeHandle", function () { return $38cb13c5a0250553$export$d5a552a76deda3c2; }, function (v) { return $38cb13c5a0250553$export$d5a552a76deda3c2 = v; });
$parcel$export(module.exports, "useInsertionEffect", function () { return $38cb13c5a0250553$export$aaabe4eda9ed9969; }, function (v) { return $38cb13c5a0250553$export$aaabe4eda9ed9969 = v; });
$parcel$export(module.exports, "useLayoutEffect", function () { return $38cb13c5a0250553$export$e5c5a5f917a5871c; }, function (v) { return $38cb13c5a0250553$export$e5c5a5f917a5871c = v; });
$parcel$export(module.exports, "useMemo", function () { return $38cb13c5a0250553$export$1538c33de8887b59; }, function (v) { return $38cb13c5a0250553$export$1538c33de8887b59 = v; });
$parcel$export(module.exports, "useReducer", function () { return $38cb13c5a0250553$export$13e3392192263954; }, function (v) { return $38cb13c5a0250553$export$13e3392192263954 = v; });
$parcel$export(module.exports, "useRef", function () { return $38cb13c5a0250553$export$b8f5890fc79d6aca; }, function (v) { return $38cb13c5a0250553$export$b8f5890fc79d6aca = v; });
$parcel$export(module.exports, "useState", function () { return $38cb13c5a0250553$export$60241385465d0a34; }, function (v) { return $38cb13c5a0250553$export$60241385465d0a34 = v; });
$parcel$export(module.exports, "useSyncExternalStore", function () { return $38cb13c5a0250553$export$306c0aa65ff9ec16; }, function (v) { return $38cb13c5a0250553$export$306c0aa65ff9ec16 = v; });
$parcel$export(module.exports, "useTransition", function () { return $38cb13c5a0250553$export$7b286972b8d8ccbf; }, function (v) { return $38cb13c5a0250553$export$7b286972b8d8ccbf = v; });
$parcel$export(module.exports, "version", function () { return $38cb13c5a0250553$export$83d89fbfd8236492; }, function (v) { return $38cb13c5a0250553$export$83d89fbfd8236492 = v; });
/**
 * @license React
 * react.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ 
var $bJtXW = parcelRequire("bJtXW");
var $38cb13c5a0250553$export$dca3b0875bd9a954;
var $38cb13c5a0250553$export$16fa2f45be04daa8;
var $38cb13c5a0250553$export$ffb0004e005737fa;
var $38cb13c5a0250553$export$e2c29f18771995cb;
var $38cb13c5a0250553$export$221d75b3f55bb0bd;
var $38cb13c5a0250553$export$5f8d39834fd61797;
var $38cb13c5a0250553$export$74bf444e3cd11ea5;
var $38cb13c5a0250553$export$ae55be85d98224ed;
var $38cb13c5a0250553$export$3ba232387fd5d6dd;
var $38cb13c5a0250553$export$e530037191fcd5d7;
var $38cb13c5a0250553$export$fd42f52fd3ae1109;
var $38cb13c5a0250553$export$c8a8987d4410bf2d;
var $38cb13c5a0250553$export$d38cd72104c1f0e9;
var $38cb13c5a0250553$export$7d1e3a5e95ceca43;
var $38cb13c5a0250553$export$257a8862b851cb5b;
var $38cb13c5a0250553$export$a8257692ac88316c;
var $38cb13c5a0250553$export$488013bae63b21da;
var $38cb13c5a0250553$export$7c73462e0d25e514;
var $38cb13c5a0250553$export$7568632d0d33d16d;
var $38cb13c5a0250553$export$88948ce120ea2619;
var $38cb13c5a0250553$export$35808ee640e87ca7;
var $38cb13c5a0250553$export$fae74005e78b1a27;
var $38cb13c5a0250553$export$dc8fbce3eb94dc1e;
var $38cb13c5a0250553$export$6a7bc4e911dc01cf;
var $38cb13c5a0250553$export$6d9c69b0de29b591;
var $38cb13c5a0250553$export$f680877a34711e37;
var $38cb13c5a0250553$export$d5a552a76deda3c2;
var $38cb13c5a0250553$export$aaabe4eda9ed9969;
var $38cb13c5a0250553$export$e5c5a5f917a5871c;
var $38cb13c5a0250553$export$1538c33de8887b59;
var $38cb13c5a0250553$export$13e3392192263954;
var $38cb13c5a0250553$export$b8f5890fc79d6aca;
var $38cb13c5a0250553$export$60241385465d0a34;
var $38cb13c5a0250553$export$306c0aa65ff9ec16;
var $38cb13c5a0250553$export$7b286972b8d8ccbf;
var $38cb13c5a0250553$export$83d89fbfd8236492;
'use strict';
var $38cb13c5a0250553$var$l = Symbol.for("react.element"), $38cb13c5a0250553$var$n = Symbol.for("react.portal"), $38cb13c5a0250553$var$p = Symbol.for("react.fragment"), $38cb13c5a0250553$var$q = Symbol.for("react.strict_mode"), $38cb13c5a0250553$var$r = Symbol.for("react.profiler"), $38cb13c5a0250553$var$t = Symbol.for("react.provider"), $38cb13c5a0250553$var$u = Symbol.for("react.context"), $38cb13c5a0250553$var$v = Symbol.for("react.forward_ref"), $38cb13c5a0250553$var$w = Symbol.for("react.suspense"), $38cb13c5a0250553$var$x = Symbol.for("react.memo"), $38cb13c5a0250553$var$y = Symbol.for("react.lazy"), $38cb13c5a0250553$var$z = Symbol.iterator;
function $38cb13c5a0250553$var$A(a) {
    if (null === a || "object" !== (typeof a === "undefined" ? "undefined" : (0, $bJtXW._)(a))) return null;
    a = $38cb13c5a0250553$var$z && a[$38cb13c5a0250553$var$z] || a["@@iterator"];
    return "function" === typeof a ? a : null;
}
var $38cb13c5a0250553$var$B = {
    isMounted: function isMounted() {
        return !1;
    },
    enqueueForceUpdate: function enqueueForceUpdate() {},
    enqueueReplaceState: function enqueueReplaceState() {},
    enqueueSetState: function enqueueSetState() {}
}, $38cb13c5a0250553$var$C = Object.assign, $38cb13c5a0250553$var$D = {};
function $38cb13c5a0250553$var$E(a, b, e) {
    this.props = a;
    this.context = b;
    this.refs = $38cb13c5a0250553$var$D;
    this.updater = e || $38cb13c5a0250553$var$B;
}
$38cb13c5a0250553$var$E.prototype.isReactComponent = {};
$38cb13c5a0250553$var$E.prototype.setState = function(a, b) {
    if ("object" !== (typeof a === "undefined" ? "undefined" : (0, $bJtXW._)(a)) && "function" !== typeof a && null != a) throw Error("setState(...): takes an object of state variables to update or a function which returns an object of state variables.");
    this.updater.enqueueSetState(this, a, b, "setState");
};
$38cb13c5a0250553$var$E.prototype.forceUpdate = function(a) {
    this.updater.enqueueForceUpdate(this, a, "forceUpdate");
};
function $38cb13c5a0250553$var$F() {}
$38cb13c5a0250553$var$F.prototype = $38cb13c5a0250553$var$E.prototype;
function $38cb13c5a0250553$var$G(a, b, e) {
    this.props = a;
    this.context = b;
    this.refs = $38cb13c5a0250553$var$D;
    this.updater = e || $38cb13c5a0250553$var$B;
}
var $38cb13c5a0250553$var$H = $38cb13c5a0250553$var$G.prototype = new $38cb13c5a0250553$var$F;
$38cb13c5a0250553$var$H.constructor = $38cb13c5a0250553$var$G;
$38cb13c5a0250553$var$C($38cb13c5a0250553$var$H, $38cb13c5a0250553$var$E.prototype);
$38cb13c5a0250553$var$H.isPureReactComponent = !0;
var $38cb13c5a0250553$var$I = Array.isArray, $38cb13c5a0250553$var$J = Object.prototype.hasOwnProperty, $38cb13c5a0250553$var$K = {
    current: null
}, $38cb13c5a0250553$var$L = {
    key: !0,
    ref: !0,
    __self: !0,
    __source: !0
};
function $38cb13c5a0250553$var$M(a, b, e) {
    var d, c = {}, k = null, h = null;
    if (null != b) for(d in void 0 !== b.ref && (h = b.ref), void 0 !== b.key && (k = "" + b.key), b)$38cb13c5a0250553$var$J.call(b, d) && !$38cb13c5a0250553$var$L.hasOwnProperty(d) && (c[d] = b[d]);
    var g = arguments.length - 2;
    if (1 === g) c.children = e;
    else if (1 < g) {
        for(var f = Array(g), m = 0; m < g; m++)f[m] = arguments[m + 2];
        c.children = f;
    }
    if (a && a.defaultProps) for(d in g = a.defaultProps, g)void 0 === c[d] && (c[d] = g[d]);
    return {
        $$typeof: $38cb13c5a0250553$var$l,
        type: a,
        key: k,
        ref: h,
        props: c,
        _owner: $38cb13c5a0250553$var$K.current
    };
}
function $38cb13c5a0250553$var$N(a, b) {
    return {
        $$typeof: $38cb13c5a0250553$var$l,
        type: a.type,
        key: b,
        ref: a.ref,
        props: a.props,
        _owner: a._owner
    };
}
function $38cb13c5a0250553$var$O(a) {
    return "object" === (typeof a === "undefined" ? "undefined" : (0, $bJtXW._)(a)) && null !== a && a.$$typeof === $38cb13c5a0250553$var$l;
}
function $38cb13c5a0250553$var$escape(a) {
    var b = {
        "=": "=0",
        ":": "=2"
    };
    return "$" + a.replace(/[=:]/g, function(a) {
        return b[a];
    });
}
var $38cb13c5a0250553$var$P = /\/+/g;
function $38cb13c5a0250553$var$Q(a, b) {
    return "object" === (typeof a === "undefined" ? "undefined" : (0, $bJtXW._)(a)) && null !== a && null != a.key ? $38cb13c5a0250553$var$escape("" + a.key) : b.toString(36);
}
function $38cb13c5a0250553$var$R(a, b, e, d, c) {
    var k = typeof a === "undefined" ? "undefined" : (0, $bJtXW._)(a);
    if ("undefined" === k || "boolean" === k) a = null;
    var h = !1;
    if (null === a) h = !0;
    else switch(k){
        case "string":
        case "number":
            h = !0;
            break;
        case "object":
            switch(a.$$typeof){
                case $38cb13c5a0250553$var$l:
                case $38cb13c5a0250553$var$n:
                    h = !0;
            }
    }
    if (h) return h = a, c = c(h), a = "" === d ? "." + $38cb13c5a0250553$var$Q(h, 0) : d, $38cb13c5a0250553$var$I(c) ? (e = "", null != a && (e = a.replace($38cb13c5a0250553$var$P, "$&/") + "/"), $38cb13c5a0250553$var$R(c, b, e, "", function(a) {
        return a;
    })) : null != c && ($38cb13c5a0250553$var$O(c) && (c = $38cb13c5a0250553$var$N(c, e + (!c.key || h && h.key === c.key ? "" : ("" + c.key).replace($38cb13c5a0250553$var$P, "$&/") + "/") + a)), b.push(c)), 1;
    h = 0;
    d = "" === d ? "." : d + ":";
    if ($38cb13c5a0250553$var$I(a)) for(var g = 0; g < a.length; g++){
        k = a[g];
        var f = d + $38cb13c5a0250553$var$Q(k, g);
        h += $38cb13c5a0250553$var$R(k, b, e, f, c);
    }
    else if (f = $38cb13c5a0250553$var$A(a), "function" === typeof f) for(a = f.call(a), g = 0; !(k = a.next()).done;)k = k.value, f = d + $38cb13c5a0250553$var$Q(k, g++), h += $38cb13c5a0250553$var$R(k, b, e, f, c);
    else if ("object" === k) throw b = String(a), Error("Objects are not valid as a React child (found: " + ("[object Object]" === b ? "object with keys {" + Object.keys(a).join(", ") + "}" : b) + "). If you meant to render a collection of children, use an array instead.");
    return h;
}
function $38cb13c5a0250553$var$S(a, b, e) {
    if (null == a) return a;
    var d = [], c = 0;
    $38cb13c5a0250553$var$R(a, d, "", "", function(a) {
        return b.call(e, a, c++);
    });
    return d;
}
function $38cb13c5a0250553$var$T(a) {
    if (-1 === a._status) {
        var b = a._result;
        b = b();
        b.then(function(b) {
            if (0 === a._status || -1 === a._status) a._status = 1, a._result = b;
        }, function(b) {
            if (0 === a._status || -1 === a._status) a._status = 2, a._result = b;
        });
        -1 === a._status && (a._status = 0, a._result = b);
    }
    if (1 === a._status) return a._result.default;
    throw a._result;
}
var $38cb13c5a0250553$var$U = {
    current: null
}, $38cb13c5a0250553$var$V = {
    transition: null
}, $38cb13c5a0250553$var$W = {
    ReactCurrentDispatcher: $38cb13c5a0250553$var$U,
    ReactCurrentBatchConfig: $38cb13c5a0250553$var$V,
    ReactCurrentOwner: $38cb13c5a0250553$var$K
};
function $38cb13c5a0250553$var$X() {
    throw Error("act(...) is not supported in production builds of React.");
}
$38cb13c5a0250553$export$dca3b0875bd9a954 = {
    map: $38cb13c5a0250553$var$S,
    forEach: function forEach(a, b, e) {
        $38cb13c5a0250553$var$S(a, function() {
            b.apply(this, arguments);
        }, e);
    },
    count: function count(a) {
        var b = 0;
        $38cb13c5a0250553$var$S(a, function() {
            b++;
        });
        return b;
    },
    toArray: function toArray(a) {
        return $38cb13c5a0250553$var$S(a, function(a) {
            return a;
        }) || [];
    },
    only: function only(a) {
        if (!$38cb13c5a0250553$var$O(a)) throw Error("React.Children.only expected to receive a single React element child.");
        return a;
    }
};
$38cb13c5a0250553$export$16fa2f45be04daa8 = $38cb13c5a0250553$var$E;
$38cb13c5a0250553$export$ffb0004e005737fa = $38cb13c5a0250553$var$p;
$38cb13c5a0250553$export$e2c29f18771995cb = $38cb13c5a0250553$var$r;
$38cb13c5a0250553$export$221d75b3f55bb0bd = $38cb13c5a0250553$var$G;
$38cb13c5a0250553$export$5f8d39834fd61797 = $38cb13c5a0250553$var$q;
$38cb13c5a0250553$export$74bf444e3cd11ea5 = $38cb13c5a0250553$var$w;
$38cb13c5a0250553$export$ae55be85d98224ed = $38cb13c5a0250553$var$W;
$38cb13c5a0250553$export$3ba232387fd5d6dd = $38cb13c5a0250553$var$X;
$38cb13c5a0250553$export$e530037191fcd5d7 = function(a, b, e) {
    if (null === a || void 0 === a) throw Error("React.cloneElement(...): The argument must be a React element, but you passed " + a + ".");
    var d = $38cb13c5a0250553$var$C({}, a.props), c = a.key, k = a.ref, h = a._owner;
    if (null != b) {
        void 0 !== b.ref && (k = b.ref, h = $38cb13c5a0250553$var$K.current);
        void 0 !== b.key && (c = "" + b.key);
        if (a.type && a.type.defaultProps) var g = a.type.defaultProps;
        for(f in b)$38cb13c5a0250553$var$J.call(b, f) && !$38cb13c5a0250553$var$L.hasOwnProperty(f) && (d[f] = void 0 === b[f] && void 0 !== g ? g[f] : b[f]);
    }
    var f = arguments.length - 2;
    if (1 === f) d.children = e;
    else if (1 < f) {
        g = Array(f);
        for(var m = 0; m < f; m++)g[m] = arguments[m + 2];
        d.children = g;
    }
    return {
        $$typeof: $38cb13c5a0250553$var$l,
        type: a.type,
        key: c,
        ref: k,
        props: d,
        _owner: h
    };
};
$38cb13c5a0250553$export$fd42f52fd3ae1109 = function(a) {
    a = {
        $$typeof: $38cb13c5a0250553$var$u,
        _currentValue: a,
        _currentValue2: a,
        _threadCount: 0,
        Provider: null,
        Consumer: null,
        _defaultValue: null,
        _globalName: null
    };
    a.Provider = {
        $$typeof: $38cb13c5a0250553$var$t,
        _context: a
    };
    return a.Consumer = a;
};
$38cb13c5a0250553$export$c8a8987d4410bf2d = $38cb13c5a0250553$var$M;
$38cb13c5a0250553$export$d38cd72104c1f0e9 = function(a) {
    var b = $38cb13c5a0250553$var$M.bind(null, a);
    b.type = a;
    return b;
};
$38cb13c5a0250553$export$7d1e3a5e95ceca43 = function() {
    return {
        current: null
    };
};
$38cb13c5a0250553$export$257a8862b851cb5b = function(a) {
    return {
        $$typeof: $38cb13c5a0250553$var$v,
        render: a
    };
};
$38cb13c5a0250553$export$a8257692ac88316c = $38cb13c5a0250553$var$O;
$38cb13c5a0250553$export$488013bae63b21da = function(a) {
    return {
        $$typeof: $38cb13c5a0250553$var$y,
        _payload: {
            _status: -1,
            _result: a
        },
        _init: $38cb13c5a0250553$var$T
    };
};
$38cb13c5a0250553$export$7c73462e0d25e514 = function(a, b) {
    return {
        $$typeof: $38cb13c5a0250553$var$x,
        type: a,
        compare: void 0 === b ? null : b
    };
};
$38cb13c5a0250553$export$7568632d0d33d16d = function(a) {
    var b = $38cb13c5a0250553$var$V.transition;
    $38cb13c5a0250553$var$V.transition = {};
    try {
        a();
    } finally{
        $38cb13c5a0250553$var$V.transition = b;
    }
};
$38cb13c5a0250553$export$88948ce120ea2619 = $38cb13c5a0250553$var$X;
$38cb13c5a0250553$export$35808ee640e87ca7 = function(a, b) {
    return $38cb13c5a0250553$var$U.current.useCallback(a, b);
};
$38cb13c5a0250553$export$fae74005e78b1a27 = function(a) {
    return $38cb13c5a0250553$var$U.current.useContext(a);
};
$38cb13c5a0250553$export$dc8fbce3eb94dc1e = function() {};
$38cb13c5a0250553$export$6a7bc4e911dc01cf = function(a) {
    return $38cb13c5a0250553$var$U.current.useDeferredValue(a);
};
$38cb13c5a0250553$export$6d9c69b0de29b591 = function(a, b) {
    return $38cb13c5a0250553$var$U.current.useEffect(a, b);
};
$38cb13c5a0250553$export$f680877a34711e37 = function() {
    return $38cb13c5a0250553$var$U.current.useId();
};
$38cb13c5a0250553$export$d5a552a76deda3c2 = function(a, b, e) {
    return $38cb13c5a0250553$var$U.current.useImperativeHandle(a, b, e);
};
$38cb13c5a0250553$export$aaabe4eda9ed9969 = function(a, b) {
    return $38cb13c5a0250553$var$U.current.useInsertionEffect(a, b);
};
$38cb13c5a0250553$export$e5c5a5f917a5871c = function(a, b) {
    return $38cb13c5a0250553$var$U.current.useLayoutEffect(a, b);
};
$38cb13c5a0250553$export$1538c33de8887b59 = function(a, b) {
    return $38cb13c5a0250553$var$U.current.useMemo(a, b);
};
$38cb13c5a0250553$export$13e3392192263954 = function(a, b, e) {
    return $38cb13c5a0250553$var$U.current.useReducer(a, b, e);
};
$38cb13c5a0250553$export$b8f5890fc79d6aca = function(a) {
    return $38cb13c5a0250553$var$U.current.useRef(a);
};
$38cb13c5a0250553$export$60241385465d0a34 = function(a) {
    return $38cb13c5a0250553$var$U.current.useState(a);
};
$38cb13c5a0250553$export$306c0aa65ff9ec16 = function(a, b, e) {
    return $38cb13c5a0250553$var$U.current.useSyncExternalStore(a, b, e);
};
$38cb13c5a0250553$export$7b286972b8d8ccbf = function() {
    return $38cb13c5a0250553$var$U.current.useTransition();
};
$38cb13c5a0250553$export$83d89fbfd8236492 = "18.3.1";

});
parcelRegister("bJtXW", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $88ab244363eded38$export$71511d61b312f219; });
function $88ab244363eded38$export$71511d61b312f219(obj) {
    "@swc/helpers - typeof";
    return obj && typeof Symbol !== "undefined" && obj.constructor === Symbol ? "symbol" : typeof obj;
}

});





parcelRegister("gZreO", function(module, exports) {

$parcel$export(module.exports, "__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED", function () { return $0331271bace68e97$export$ae55be85d98224ed; }, function (v) { return $0331271bace68e97$export$ae55be85d98224ed = v; });
$parcel$export(module.exports, "createPortal", function () { return $0331271bace68e97$export$d39a5bbd09211389; }, function (v) { return $0331271bace68e97$export$d39a5bbd09211389 = v; });
$parcel$export(module.exports, "createRoot", function () { return $0331271bace68e97$export$882461b6382ed46c; }, function (v) { return $0331271bace68e97$export$882461b6382ed46c = v; });
$parcel$export(module.exports, "findDOMNode", function () { return $0331271bace68e97$export$466bfc07425424d5; }, function (v) { return $0331271bace68e97$export$466bfc07425424d5 = v; });
$parcel$export(module.exports, "flushSync", function () { return $0331271bace68e97$export$cd75ccfd720a3cd4; }, function (v) { return $0331271bace68e97$export$cd75ccfd720a3cd4 = v; });
$parcel$export(module.exports, "hydrate", function () { return $0331271bace68e97$export$fa8d919ba61d84db; }, function (v) { return $0331271bace68e97$export$fa8d919ba61d84db = v; });
$parcel$export(module.exports, "hydrateRoot", function () { return $0331271bace68e97$export$757ceba2d55c277e; }, function (v) { return $0331271bace68e97$export$757ceba2d55c277e = v; });
$parcel$export(module.exports, "render", function () { return $0331271bace68e97$export$b3890eb0ae9dca99; }, function (v) { return $0331271bace68e97$export$b3890eb0ae9dca99 = v; });
$parcel$export(module.exports, "unmountComponentAtNode", function () { return $0331271bace68e97$export$502457920280e6be; }, function (v) { return $0331271bace68e97$export$502457920280e6be = v; });
$parcel$export(module.exports, "unstable_batchedUpdates", function () { return $0331271bace68e97$export$c78a37762a8d58e1; }, function (v) { return $0331271bace68e97$export$c78a37762a8d58e1 = v; });
$parcel$export(module.exports, "unstable_renderSubtreeIntoContainer", function () { return $0331271bace68e97$export$dc54d992c10e8a18; }, function (v) { return $0331271bace68e97$export$dc54d992c10e8a18 = v; });
$parcel$export(module.exports, "version", function () { return $0331271bace68e97$export$83d89fbfd8236492; }, function (v) { return $0331271bace68e97$export$83d89fbfd8236492 = v; });
/**
 * @license React
 * react-dom.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ /*
 Modernizr 3.0.0pre (Custom Build) | MIT
*/ 
var $bJtXW = parcelRequire("bJtXW");
var $0331271bace68e97$export$ae55be85d98224ed;
var $0331271bace68e97$export$d39a5bbd09211389;
var $0331271bace68e97$export$882461b6382ed46c;
var $0331271bace68e97$export$466bfc07425424d5;
var $0331271bace68e97$export$cd75ccfd720a3cd4;
var $0331271bace68e97$export$fa8d919ba61d84db;
var $0331271bace68e97$export$757ceba2d55c277e;
var $0331271bace68e97$export$b3890eb0ae9dca99;
var $0331271bace68e97$export$502457920280e6be;
var $0331271bace68e97$export$c78a37762a8d58e1;
var $0331271bace68e97$export$dc54d992c10e8a18;
var $0331271bace68e97$export$83d89fbfd8236492;
'use strict';

var $dQFEZ = parcelRequire("dQFEZ");

var $1iyD5 = parcelRequire("1iyD5");
function $0331271bace68e97$var$p(a) {
    for(var b = "https://reactjs.org/docs/error-decoder.html?invariant=" + a, c = 1; c < arguments.length; c++)b += "&args[]=" + encodeURIComponent(arguments[c]);
    return "Minified React error #" + a + "; visit " + b + " for the full message or use the non-minified dev environment for full errors and additional helpful warnings.";
}
var $0331271bace68e97$var$da = new Set, $0331271bace68e97$var$ea = {};
function $0331271bace68e97$var$fa(a, b) {
    $0331271bace68e97$var$ha(a, b);
    $0331271bace68e97$var$ha(a + "Capture", b);
}
function $0331271bace68e97$var$ha(a, b) {
    $0331271bace68e97$var$ea[a] = b;
    for(a = 0; a < b.length; a++)$0331271bace68e97$var$da.add(b[a]);
}
var $0331271bace68e97$var$ia = !("undefined" === typeof window || "undefined" === typeof window.document || "undefined" === typeof window.document.createElement), $0331271bace68e97$var$ja = Object.prototype.hasOwnProperty, $0331271bace68e97$var$ka = /^[:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD][:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD\-.0-9\u00B7\u0300-\u036F\u203F-\u2040]*$/, $0331271bace68e97$var$la = {}, $0331271bace68e97$var$ma = {};
function $0331271bace68e97$var$oa(a) {
    if ($0331271bace68e97$var$ja.call($0331271bace68e97$var$ma, a)) return !0;
    if ($0331271bace68e97$var$ja.call($0331271bace68e97$var$la, a)) return !1;
    if ($0331271bace68e97$var$ka.test(a)) return $0331271bace68e97$var$ma[a] = !0;
    $0331271bace68e97$var$la[a] = !0;
    return !1;
}
function $0331271bace68e97$var$pa(a, b, c, d) {
    if (null !== c && 0 === c.type) return !1;
    switch(typeof b === "undefined" ? "undefined" : (0, $bJtXW._)(b)){
        case "function":
        case "symbol":
            return !0;
        case "boolean":
            if (d) return !1;
            if (null !== c) return !c.acceptsBooleans;
            a = a.toLowerCase().slice(0, 5);
            return "data-" !== a && "aria-" !== a;
        default:
            return !1;
    }
}
function $0331271bace68e97$var$qa(a, b, c, d) {
    if (null === b || "undefined" === typeof b || $0331271bace68e97$var$pa(a, b, c, d)) return !0;
    if (d) return !1;
    if (null !== c) switch(c.type){
        case 3:
            return !b;
        case 4:
            return !1 === b;
        case 5:
            return isNaN(b);
        case 6:
            return isNaN(b) || 1 > b;
    }
    return !1;
}
function $0331271bace68e97$var$v(a, b, c, d, e, f, g) {
    this.acceptsBooleans = 2 === b || 3 === b || 4 === b;
    this.attributeName = d;
    this.attributeNamespace = e;
    this.mustUseProperty = c;
    this.propertyName = a;
    this.type = b;
    this.sanitizeURL = f;
    this.removeEmptyString = g;
}
var $0331271bace68e97$var$z = {};
"children dangerouslySetInnerHTML defaultValue defaultChecked innerHTML suppressContentEditableWarning suppressHydrationWarning style".split(" ").forEach(function(a) {
    $0331271bace68e97$var$z[a] = new $0331271bace68e97$var$v(a, 0, !1, a, null, !1, !1);
});
[
    [
        "acceptCharset",
        "accept-charset"
    ],
    [
        "className",
        "class"
    ],
    [
        "htmlFor",
        "for"
    ],
    [
        "httpEquiv",
        "http-equiv"
    ]
].forEach(function(a) {
    var b = a[0];
    $0331271bace68e97$var$z[b] = new $0331271bace68e97$var$v(b, 1, !1, a[1], null, !1, !1);
});
[
    "contentEditable",
    "draggable",
    "spellCheck",
    "value"
].forEach(function(a) {
    $0331271bace68e97$var$z[a] = new $0331271bace68e97$var$v(a, 2, !1, a.toLowerCase(), null, !1, !1);
});
[
    "autoReverse",
    "externalResourcesRequired",
    "focusable",
    "preserveAlpha"
].forEach(function(a) {
    $0331271bace68e97$var$z[a] = new $0331271bace68e97$var$v(a, 2, !1, a, null, !1, !1);
});
"allowFullScreen async autoFocus autoPlay controls default defer disabled disablePictureInPicture disableRemotePlayback formNoValidate hidden loop noModule noValidate open playsInline readOnly required reversed scoped seamless itemScope".split(" ").forEach(function(a) {
    $0331271bace68e97$var$z[a] = new $0331271bace68e97$var$v(a, 3, !1, a.toLowerCase(), null, !1, !1);
});
[
    "checked",
    "multiple",
    "muted",
    "selected"
].forEach(function(a) {
    $0331271bace68e97$var$z[a] = new $0331271bace68e97$var$v(a, 3, !0, a, null, !1, !1);
});
[
    "capture",
    "download"
].forEach(function(a) {
    $0331271bace68e97$var$z[a] = new $0331271bace68e97$var$v(a, 4, !1, a, null, !1, !1);
});
[
    "cols",
    "rows",
    "size",
    "span"
].forEach(function(a) {
    $0331271bace68e97$var$z[a] = new $0331271bace68e97$var$v(a, 6, !1, a, null, !1, !1);
});
[
    "rowSpan",
    "start"
].forEach(function(a) {
    $0331271bace68e97$var$z[a] = new $0331271bace68e97$var$v(a, 5, !1, a.toLowerCase(), null, !1, !1);
});
var $0331271bace68e97$var$ra = /[\-:]([a-z])/g;
function $0331271bace68e97$var$sa(a) {
    return a[1].toUpperCase();
}
"accent-height alignment-baseline arabic-form baseline-shift cap-height clip-path clip-rule color-interpolation color-interpolation-filters color-profile color-rendering dominant-baseline enable-background fill-opacity fill-rule flood-color flood-opacity font-family font-size font-size-adjust font-stretch font-style font-variant font-weight glyph-name glyph-orientation-horizontal glyph-orientation-vertical horiz-adv-x horiz-origin-x image-rendering letter-spacing lighting-color marker-end marker-mid marker-start overline-position overline-thickness paint-order panose-1 pointer-events rendering-intent shape-rendering stop-color stop-opacity strikethrough-position strikethrough-thickness stroke-dasharray stroke-dashoffset stroke-linecap stroke-linejoin stroke-miterlimit stroke-opacity stroke-width text-anchor text-decoration text-rendering underline-position underline-thickness unicode-bidi unicode-range units-per-em v-alphabetic v-hanging v-ideographic v-mathematical vector-effect vert-adv-y vert-origin-x vert-origin-y word-spacing writing-mode xmlns:xlink x-height".split(" ").forEach(function(a) {
    var b = a.replace($0331271bace68e97$var$ra, $0331271bace68e97$var$sa);
    $0331271bace68e97$var$z[b] = new $0331271bace68e97$var$v(b, 1, !1, a, null, !1, !1);
});
"xlink:actuate xlink:arcrole xlink:role xlink:show xlink:title xlink:type".split(" ").forEach(function(a) {
    var b = a.replace($0331271bace68e97$var$ra, $0331271bace68e97$var$sa);
    $0331271bace68e97$var$z[b] = new $0331271bace68e97$var$v(b, 1, !1, a, "http://www.w3.org/1999/xlink", !1, !1);
});
[
    "xml:base",
    "xml:lang",
    "xml:space"
].forEach(function(a) {
    var b = a.replace($0331271bace68e97$var$ra, $0331271bace68e97$var$sa);
    $0331271bace68e97$var$z[b] = new $0331271bace68e97$var$v(b, 1, !1, a, "http://www.w3.org/XML/1998/namespace", !1, !1);
});
[
    "tabIndex",
    "crossOrigin"
].forEach(function(a) {
    $0331271bace68e97$var$z[a] = new $0331271bace68e97$var$v(a, 1, !1, a.toLowerCase(), null, !1, !1);
});
$0331271bace68e97$var$z.xlinkHref = new $0331271bace68e97$var$v("xlinkHref", 1, !1, "xlink:href", "http://www.w3.org/1999/xlink", !0, !1);
[
    "src",
    "href",
    "action",
    "formAction"
].forEach(function(a) {
    $0331271bace68e97$var$z[a] = new $0331271bace68e97$var$v(a, 1, !1, a.toLowerCase(), null, !0, !0);
});
function $0331271bace68e97$var$ta(a, b, c, d) {
    var e = $0331271bace68e97$var$z.hasOwnProperty(b) ? $0331271bace68e97$var$z[b] : null;
    if (null !== e ? 0 !== e.type : d || !(2 < b.length) || "o" !== b[0] && "O" !== b[0] || "n" !== b[1] && "N" !== b[1]) $0331271bace68e97$var$qa(b, c, e, d) && (c = null), d || null === e ? $0331271bace68e97$var$oa(b) && (null === c ? a.removeAttribute(b) : a.setAttribute(b, "" + c)) : e.mustUseProperty ? a[e.propertyName] = null === c ? 3 === e.type ? !1 : "" : c : (b = e.attributeName, d = e.attributeNamespace, null === c ? a.removeAttribute(b) : (e = e.type, c = 3 === e || 4 === e && !0 === c ? "" : "" + c, d ? a.setAttributeNS(d, b, c) : a.setAttribute(b, c)));
}
var $0331271bace68e97$var$ua = $dQFEZ.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED, $0331271bace68e97$var$va = Symbol.for("react.element"), $0331271bace68e97$var$wa = Symbol.for("react.portal"), $0331271bace68e97$var$ya = Symbol.for("react.fragment"), $0331271bace68e97$var$za = Symbol.for("react.strict_mode"), $0331271bace68e97$var$Aa = Symbol.for("react.profiler"), $0331271bace68e97$var$Ba = Symbol.for("react.provider"), $0331271bace68e97$var$Ca = Symbol.for("react.context"), $0331271bace68e97$var$Da = Symbol.for("react.forward_ref"), $0331271bace68e97$var$Ea = Symbol.for("react.suspense"), $0331271bace68e97$var$Fa = Symbol.for("react.suspense_list"), $0331271bace68e97$var$Ga = Symbol.for("react.memo"), $0331271bace68e97$var$Ha = Symbol.for("react.lazy");
Symbol.for("react.scope");
Symbol.for("react.debug_trace_mode");
var $0331271bace68e97$var$Ia = Symbol.for("react.offscreen");
Symbol.for("react.legacy_hidden");
Symbol.for("react.cache");
Symbol.for("react.tracing_marker");
var $0331271bace68e97$var$Ja = Symbol.iterator;
function $0331271bace68e97$var$Ka(a) {
    if (null === a || "object" !== (typeof a === "undefined" ? "undefined" : (0, $bJtXW._)(a))) return null;
    a = $0331271bace68e97$var$Ja && a[$0331271bace68e97$var$Ja] || a["@@iterator"];
    return "function" === typeof a ? a : null;
}
var $0331271bace68e97$var$A = Object.assign, $0331271bace68e97$var$La;
function $0331271bace68e97$var$Ma(a) {
    if (void 0 === $0331271bace68e97$var$La) try {
        throw Error();
    } catch (c) {
        var b = c.stack.trim().match(/\n( *(at )?)/);
        $0331271bace68e97$var$La = b && b[1] || "";
    }
    return "\n" + $0331271bace68e97$var$La + a;
}
var $0331271bace68e97$var$Na = !1;
function $0331271bace68e97$var$Oa(a, b) {
    if (!a || $0331271bace68e97$var$Na) return "";
    $0331271bace68e97$var$Na = !0;
    var c = Error.prepareStackTrace;
    Error.prepareStackTrace = void 0;
    try {
        if (b) {
            if (b = function b() {
                throw Error();
            }, Object.defineProperty(b.prototype, "props", {
                set: function set() {
                    throw Error();
                }
            }), "object" === (typeof Reflect === "undefined" ? "undefined" : (0, $bJtXW._)(Reflect)) && Reflect.construct) {
                try {
                    Reflect.construct(b, []);
                } catch (l) {
                    var d = l;
                }
                Reflect.construct(a, [], b);
            } else {
                try {
                    b.call();
                } catch (l) {
                    d = l;
                }
                a.call(b.prototype);
            }
        } else {
            try {
                throw Error();
            } catch (l) {
                d = l;
            }
            a();
        }
    } catch (l) {
        if (l && d && "string" === typeof l.stack) {
            for(var e = l.stack.split("\n"), f = d.stack.split("\n"), g = e.length - 1, h = f.length - 1; 1 <= g && 0 <= h && e[g] !== f[h];)h--;
            for(; 1 <= g && 0 <= h; g--, h--)if (e[g] !== f[h]) {
                if (1 !== g || 1 !== h) {
                    do if (g--, h--, 0 > h || e[g] !== f[h]) {
                        var k = "\n" + e[g].replace(" at new ", " at ");
                        a.displayName && k.includes("<anonymous>") && (k = k.replace("<anonymous>", a.displayName));
                        return k;
                    }
                    while (1 <= g && 0 <= h);
                }
                break;
            }
        }
    } finally{
        $0331271bace68e97$var$Na = !1, Error.prepareStackTrace = c;
    }
    return (a = a ? a.displayName || a.name : "") ? $0331271bace68e97$var$Ma(a) : "";
}
function $0331271bace68e97$var$Pa(a) {
    switch(a.tag){
        case 5:
            return $0331271bace68e97$var$Ma(a.type);
        case 16:
            return $0331271bace68e97$var$Ma("Lazy");
        case 13:
            return $0331271bace68e97$var$Ma("Suspense");
        case 19:
            return $0331271bace68e97$var$Ma("SuspenseList");
        case 0:
        case 2:
        case 15:
            return a = $0331271bace68e97$var$Oa(a.type, !1), a;
        case 11:
            return a = $0331271bace68e97$var$Oa(a.type.render, !1), a;
        case 1:
            return a = $0331271bace68e97$var$Oa(a.type, !0), a;
        default:
            return "";
    }
}
function $0331271bace68e97$var$Qa(a) {
    if (null == a) return null;
    if ("function" === typeof a) return a.displayName || a.name || null;
    if ("string" === typeof a) return a;
    switch(a){
        case $0331271bace68e97$var$ya:
            return "Fragment";
        case $0331271bace68e97$var$wa:
            return "Portal";
        case $0331271bace68e97$var$Aa:
            return "Profiler";
        case $0331271bace68e97$var$za:
            return "StrictMode";
        case $0331271bace68e97$var$Ea:
            return "Suspense";
        case $0331271bace68e97$var$Fa:
            return "SuspenseList";
    }
    if ("object" === (typeof a === "undefined" ? "undefined" : (0, $bJtXW._)(a))) switch(a.$$typeof){
        case $0331271bace68e97$var$Ca:
            return (a.displayName || "Context") + ".Consumer";
        case $0331271bace68e97$var$Ba:
            return (a._context.displayName || "Context") + ".Provider";
        case $0331271bace68e97$var$Da:
            var b = a.render;
            a = a.displayName;
            a || (a = b.displayName || b.name || "", a = "" !== a ? "ForwardRef(" + a + ")" : "ForwardRef");
            return a;
        case $0331271bace68e97$var$Ga:
            return b = a.displayName || null, null !== b ? b : $0331271bace68e97$var$Qa(a.type) || "Memo";
        case $0331271bace68e97$var$Ha:
            b = a._payload;
            a = a._init;
            try {
                return $0331271bace68e97$var$Qa(a(b));
            } catch (c) {}
    }
    return null;
}
function $0331271bace68e97$var$Ra(a) {
    var b = a.type;
    switch(a.tag){
        case 24:
            return "Cache";
        case 9:
            return (b.displayName || "Context") + ".Consumer";
        case 10:
            return (b._context.displayName || "Context") + ".Provider";
        case 18:
            return "DehydratedFragment";
        case 11:
            return a = b.render, a = a.displayName || a.name || "", b.displayName || ("" !== a ? "ForwardRef(" + a + ")" : "ForwardRef");
        case 7:
            return "Fragment";
        case 5:
            return b;
        case 4:
            return "Portal";
        case 3:
            return "Root";
        case 6:
            return "Text";
        case 16:
            return $0331271bace68e97$var$Qa(b);
        case 8:
            return b === $0331271bace68e97$var$za ? "StrictMode" : "Mode";
        case 22:
            return "Offscreen";
        case 12:
            return "Profiler";
        case 21:
            return "Scope";
        case 13:
            return "Suspense";
        case 19:
            return "SuspenseList";
        case 25:
            return "TracingMarker";
        case 1:
        case 0:
        case 17:
        case 2:
        case 14:
        case 15:
            if ("function" === typeof b) return b.displayName || b.name || null;
            if ("string" === typeof b) return b;
    }
    return null;
}
function $0331271bace68e97$var$Sa(a) {
    switch(typeof a === "undefined" ? "undefined" : (0, $bJtXW._)(a)){
        case "boolean":
        case "number":
        case "string":
        case "undefined":
            return a;
        case "object":
            return a;
        default:
            return "";
    }
}
function $0331271bace68e97$var$Ta(a) {
    var b = a.type;
    return (a = a.nodeName) && "input" === a.toLowerCase() && ("checkbox" === b || "radio" === b);
}
function $0331271bace68e97$var$Ua(a) {
    var b = $0331271bace68e97$var$Ta(a) ? "checked" : "value", c = Object.getOwnPropertyDescriptor(a.constructor.prototype, b), d = "" + a[b];
    if (!a.hasOwnProperty(b) && "undefined" !== typeof c && "function" === typeof c.get && "function" === typeof c.set) {
        var e = c.get, f = c.set;
        Object.defineProperty(a, b, {
            configurable: !0,
            get: function get() {
                return e.call(this);
            },
            set: function set(a) {
                d = "" + a;
                f.call(this, a);
            }
        });
        Object.defineProperty(a, b, {
            enumerable: c.enumerable
        });
        return {
            getValue: function getValue() {
                return d;
            },
            setValue: function setValue(a) {
                d = "" + a;
            },
            stopTracking: function stopTracking() {
                a._valueTracker = null;
                delete a[b];
            }
        };
    }
}
function $0331271bace68e97$var$Va(a) {
    a._valueTracker || (a._valueTracker = $0331271bace68e97$var$Ua(a));
}
function $0331271bace68e97$var$Wa(a) {
    if (!a) return !1;
    var b = a._valueTracker;
    if (!b) return !0;
    var c = b.getValue();
    var d = "";
    a && (d = $0331271bace68e97$var$Ta(a) ? a.checked ? "true" : "false" : a.value);
    a = d;
    return a !== c ? (b.setValue(a), !0) : !1;
}
function $0331271bace68e97$var$Xa(a) {
    a = a || ("undefined" !== typeof document ? document : void 0);
    if ("undefined" === typeof a) return null;
    try {
        return a.activeElement || a.body;
    } catch (b) {
        return a.body;
    }
}
function $0331271bace68e97$var$Ya(a, b) {
    var c = b.checked;
    return $0331271bace68e97$var$A({}, b, {
        defaultChecked: void 0,
        defaultValue: void 0,
        value: void 0,
        checked: null != c ? c : a._wrapperState.initialChecked
    });
}
function $0331271bace68e97$var$Za(a, b) {
    var c = null == b.defaultValue ? "" : b.defaultValue, d = null != b.checked ? b.checked : b.defaultChecked;
    c = $0331271bace68e97$var$Sa(null != b.value ? b.value : c);
    a._wrapperState = {
        initialChecked: d,
        initialValue: c,
        controlled: "checkbox" === b.type || "radio" === b.type ? null != b.checked : null != b.value
    };
}
function $0331271bace68e97$var$ab(a, b) {
    b = b.checked;
    null != b && $0331271bace68e97$var$ta(a, "checked", b, !1);
}
function $0331271bace68e97$var$bb(a, b) {
    $0331271bace68e97$var$ab(a, b);
    var c = $0331271bace68e97$var$Sa(b.value), d = b.type;
    if (null != c) {
        if ("number" === d) {
            if (0 === c && "" === a.value || a.value != c) a.value = "" + c;
        } else a.value !== "" + c && (a.value = "" + c);
    } else if ("submit" === d || "reset" === d) {
        a.removeAttribute("value");
        return;
    }
    b.hasOwnProperty("value") ? $0331271bace68e97$var$cb(a, b.type, c) : b.hasOwnProperty("defaultValue") && $0331271bace68e97$var$cb(a, b.type, $0331271bace68e97$var$Sa(b.defaultValue));
    null == b.checked && null != b.defaultChecked && (a.defaultChecked = !!b.defaultChecked);
}
function $0331271bace68e97$var$db(a, b, c) {
    if (b.hasOwnProperty("value") || b.hasOwnProperty("defaultValue")) {
        var d = b.type;
        if (!("submit" !== d && "reset" !== d || void 0 !== b.value && null !== b.value)) return;
        b = "" + a._wrapperState.initialValue;
        c || b === a.value || (a.value = b);
        a.defaultValue = b;
    }
    c = a.name;
    "" !== c && (a.name = "");
    a.defaultChecked = !!a._wrapperState.initialChecked;
    "" !== c && (a.name = c);
}
function $0331271bace68e97$var$cb(a, b, c) {
    if ("number" !== b || $0331271bace68e97$var$Xa(a.ownerDocument) !== a) null == c ? a.defaultValue = "" + a._wrapperState.initialValue : a.defaultValue !== "" + c && (a.defaultValue = "" + c);
}
var $0331271bace68e97$var$eb = Array.isArray;
function $0331271bace68e97$var$fb(a, b, c, d) {
    a = a.options;
    if (b) {
        b = {};
        for(var e = 0; e < c.length; e++)b["$" + c[e]] = !0;
        for(c = 0; c < a.length; c++)e = b.hasOwnProperty("$" + a[c].value), a[c].selected !== e && (a[c].selected = e), e && d && (a[c].defaultSelected = !0);
    } else {
        c = "" + $0331271bace68e97$var$Sa(c);
        b = null;
        for(e = 0; e < a.length; e++){
            if (a[e].value === c) {
                a[e].selected = !0;
                d && (a[e].defaultSelected = !0);
                return;
            }
            null !== b || a[e].disabled || (b = a[e]);
        }
        null !== b && (b.selected = !0);
    }
}
function $0331271bace68e97$var$gb(a, b) {
    if (null != b.dangerouslySetInnerHTML) throw Error($0331271bace68e97$var$p(91));
    return $0331271bace68e97$var$A({}, b, {
        value: void 0,
        defaultValue: void 0,
        children: "" + a._wrapperState.initialValue
    });
}
function $0331271bace68e97$var$hb(a, b) {
    var c = b.value;
    if (null == c) {
        c = b.children;
        b = b.defaultValue;
        if (null != c) {
            if (null != b) throw Error($0331271bace68e97$var$p(92));
            if ($0331271bace68e97$var$eb(c)) {
                if (1 < c.length) throw Error($0331271bace68e97$var$p(93));
                c = c[0];
            }
            b = c;
        }
        null == b && (b = "");
        c = b;
    }
    a._wrapperState = {
        initialValue: $0331271bace68e97$var$Sa(c)
    };
}
function $0331271bace68e97$var$ib(a, b) {
    var c = $0331271bace68e97$var$Sa(b.value), d = $0331271bace68e97$var$Sa(b.defaultValue);
    null != c && (c = "" + c, c !== a.value && (a.value = c), null == b.defaultValue && a.defaultValue !== c && (a.defaultValue = c));
    null != d && (a.defaultValue = "" + d);
}
function $0331271bace68e97$var$jb(a) {
    var b = a.textContent;
    b === a._wrapperState.initialValue && "" !== b && null !== b && (a.value = b);
}
function $0331271bace68e97$var$kb(a) {
    switch(a){
        case "svg":
            return "http://www.w3.org/2000/svg";
        case "math":
            return "http://www.w3.org/1998/Math/MathML";
        default:
            return "http://www.w3.org/1999/xhtml";
    }
}
function $0331271bace68e97$var$lb(a, b) {
    return null == a || "http://www.w3.org/1999/xhtml" === a ? $0331271bace68e97$var$kb(b) : "http://www.w3.org/2000/svg" === a && "foreignObject" === b ? "http://www.w3.org/1999/xhtml" : a;
}
var $0331271bace68e97$var$mb, $0331271bace68e97$var$nb = function(a) {
    return "undefined" !== typeof MSApp && MSApp.execUnsafeLocalFunction ? function(b, c, d, e) {
        MSApp.execUnsafeLocalFunction(function() {
            return a(b, c, d, e);
        });
    } : a;
}(function(a, b) {
    if ("http://www.w3.org/2000/svg" !== a.namespaceURI || "innerHTML" in a) a.innerHTML = b;
    else {
        $0331271bace68e97$var$mb = $0331271bace68e97$var$mb || document.createElement("div");
        $0331271bace68e97$var$mb.innerHTML = "<svg>" + b.valueOf().toString() + "</svg>";
        for(b = $0331271bace68e97$var$mb.firstChild; a.firstChild;)a.removeChild(a.firstChild);
        for(; b.firstChild;)a.appendChild(b.firstChild);
    }
});
function $0331271bace68e97$var$ob(a, b) {
    if (b) {
        var c = a.firstChild;
        if (c && c === a.lastChild && 3 === c.nodeType) {
            c.nodeValue = b;
            return;
        }
    }
    a.textContent = b;
}
var $0331271bace68e97$var$pb = {
    animationIterationCount: !0,
    aspectRatio: !0,
    borderImageOutset: !0,
    borderImageSlice: !0,
    borderImageWidth: !0,
    boxFlex: !0,
    boxFlexGroup: !0,
    boxOrdinalGroup: !0,
    columnCount: !0,
    columns: !0,
    flex: !0,
    flexGrow: !0,
    flexPositive: !0,
    flexShrink: !0,
    flexNegative: !0,
    flexOrder: !0,
    gridArea: !0,
    gridRow: !0,
    gridRowEnd: !0,
    gridRowSpan: !0,
    gridRowStart: !0,
    gridColumn: !0,
    gridColumnEnd: !0,
    gridColumnSpan: !0,
    gridColumnStart: !0,
    fontWeight: !0,
    lineClamp: !0,
    lineHeight: !0,
    opacity: !0,
    order: !0,
    orphans: !0,
    tabSize: !0,
    widows: !0,
    zIndex: !0,
    zoom: !0,
    fillOpacity: !0,
    floodOpacity: !0,
    stopOpacity: !0,
    strokeDasharray: !0,
    strokeDashoffset: !0,
    strokeMiterlimit: !0,
    strokeOpacity: !0,
    strokeWidth: !0
}, $0331271bace68e97$var$qb = [
    "Webkit",
    "ms",
    "Moz",
    "O"
];
Object.keys($0331271bace68e97$var$pb).forEach(function(a) {
    $0331271bace68e97$var$qb.forEach(function(b) {
        b = b + a.charAt(0).toUpperCase() + a.substring(1);
        $0331271bace68e97$var$pb[b] = $0331271bace68e97$var$pb[a];
    });
});
function $0331271bace68e97$var$rb(a, b, c) {
    return null == b || "boolean" === typeof b || "" === b ? "" : c || "number" !== typeof b || 0 === b || $0331271bace68e97$var$pb.hasOwnProperty(a) && $0331271bace68e97$var$pb[a] ? ("" + b).trim() : b + "px";
}
function $0331271bace68e97$var$sb(a, b) {
    a = a.style;
    for(var c in b)if (b.hasOwnProperty(c)) {
        var d = 0 === c.indexOf("--"), e = $0331271bace68e97$var$rb(c, b[c], d);
        "float" === c && (c = "cssFloat");
        d ? a.setProperty(c, e) : a[c] = e;
    }
}
var $0331271bace68e97$var$tb = $0331271bace68e97$var$A({
    menuitem: !0
}, {
    area: !0,
    base: !0,
    br: !0,
    col: !0,
    embed: !0,
    hr: !0,
    img: !0,
    input: !0,
    keygen: !0,
    link: !0,
    meta: !0,
    param: !0,
    source: !0,
    track: !0,
    wbr: !0
});
function $0331271bace68e97$var$ub(a, b) {
    if (b) {
        if ($0331271bace68e97$var$tb[a] && (null != b.children || null != b.dangerouslySetInnerHTML)) throw Error($0331271bace68e97$var$p(137, a));
        if (null != b.dangerouslySetInnerHTML) {
            if (null != b.children) throw Error($0331271bace68e97$var$p(60));
            if ("object" !== (0, $bJtXW._)(b.dangerouslySetInnerHTML) || !("__html" in b.dangerouslySetInnerHTML)) throw Error($0331271bace68e97$var$p(61));
        }
        if (null != b.style && "object" !== (0, $bJtXW._)(b.style)) throw Error($0331271bace68e97$var$p(62));
    }
}
function $0331271bace68e97$var$vb(a, b) {
    if (-1 === a.indexOf("-")) return "string" === typeof b.is;
    switch(a){
        case "annotation-xml":
        case "color-profile":
        case "font-face":
        case "font-face-src":
        case "font-face-uri":
        case "font-face-format":
        case "font-face-name":
        case "missing-glyph":
            return !1;
        default:
            return !0;
    }
}
var $0331271bace68e97$var$wb = null;
function $0331271bace68e97$var$xb(a) {
    a = a.target || a.srcElement || window;
    a.correspondingUseElement && (a = a.correspondingUseElement);
    return 3 === a.nodeType ? a.parentNode : a;
}
var $0331271bace68e97$var$yb = null, $0331271bace68e97$var$zb = null, $0331271bace68e97$var$Ab = null;
function $0331271bace68e97$var$Bb(a) {
    if (a = $0331271bace68e97$var$Cb(a)) {
        if ("function" !== typeof $0331271bace68e97$var$yb) throw Error($0331271bace68e97$var$p(280));
        var b = a.stateNode;
        b && (b = $0331271bace68e97$var$Db(b), $0331271bace68e97$var$yb(a.stateNode, a.type, b));
    }
}
function $0331271bace68e97$var$Eb(a) {
    $0331271bace68e97$var$zb ? $0331271bace68e97$var$Ab ? $0331271bace68e97$var$Ab.push(a) : $0331271bace68e97$var$Ab = [
        a
    ] : $0331271bace68e97$var$zb = a;
}
function $0331271bace68e97$var$Fb() {
    if ($0331271bace68e97$var$zb) {
        var a = $0331271bace68e97$var$zb, b = $0331271bace68e97$var$Ab;
        $0331271bace68e97$var$Ab = $0331271bace68e97$var$zb = null;
        $0331271bace68e97$var$Bb(a);
        if (b) for(a = 0; a < b.length; a++)$0331271bace68e97$var$Bb(b[a]);
    }
}
function $0331271bace68e97$var$Gb(a, b) {
    return a(b);
}
function $0331271bace68e97$var$Hb() {}
var $0331271bace68e97$var$Ib = !1;
function $0331271bace68e97$var$Jb(a, b, c) {
    if ($0331271bace68e97$var$Ib) return a(b, c);
    $0331271bace68e97$var$Ib = !0;
    try {
        return $0331271bace68e97$var$Gb(a, b, c);
    } finally{
        if ($0331271bace68e97$var$Ib = !1, null !== $0331271bace68e97$var$zb || null !== $0331271bace68e97$var$Ab) $0331271bace68e97$var$Hb(), $0331271bace68e97$var$Fb();
    }
}
function $0331271bace68e97$var$Kb(a, b) {
    var c = a.stateNode;
    if (null === c) return null;
    var d = $0331271bace68e97$var$Db(c);
    if (null === d) return null;
    c = d[b];
    a: switch(b){
        case "onClick":
        case "onClickCapture":
        case "onDoubleClick":
        case "onDoubleClickCapture":
        case "onMouseDown":
        case "onMouseDownCapture":
        case "onMouseMove":
        case "onMouseMoveCapture":
        case "onMouseUp":
        case "onMouseUpCapture":
        case "onMouseEnter":
            (d = !d.disabled) || (a = a.type, d = !("button" === a || "input" === a || "select" === a || "textarea" === a));
            a = !d;
            break a;
        default:
            a = !1;
    }
    if (a) return null;
    if (c && "function" !== typeof c) throw Error($0331271bace68e97$var$p(231, b, typeof c === "undefined" ? "undefined" : (0, $bJtXW._)(c)));
    return c;
}
var $0331271bace68e97$var$Lb = !1;
if ($0331271bace68e97$var$ia) try {
    var $0331271bace68e97$var$Mb = {};
    Object.defineProperty($0331271bace68e97$var$Mb, "passive", {
        get: function get() {
            $0331271bace68e97$var$Lb = !0;
        }
    });
    window.addEventListener("test", $0331271bace68e97$var$Mb, $0331271bace68e97$var$Mb);
    window.removeEventListener("test", $0331271bace68e97$var$Mb, $0331271bace68e97$var$Mb);
} catch (a) {
    $0331271bace68e97$var$Lb = !1;
}
function $0331271bace68e97$var$Nb(a, b, c, d, e, f, g, h, k) {
    var l = Array.prototype.slice.call(arguments, 3);
    try {
        b.apply(c, l);
    } catch (m) {
        this.onError(m);
    }
}
var $0331271bace68e97$var$Ob = !1, $0331271bace68e97$var$Pb = null, $0331271bace68e97$var$Qb = !1, $0331271bace68e97$var$Rb = null, $0331271bace68e97$var$Sb = {
    onError: function onError(a) {
        $0331271bace68e97$var$Ob = !0;
        $0331271bace68e97$var$Pb = a;
    }
};
function $0331271bace68e97$var$Tb(a, b, c, d, e, f, g, h, k) {
    $0331271bace68e97$var$Ob = !1;
    $0331271bace68e97$var$Pb = null;
    $0331271bace68e97$var$Nb.apply($0331271bace68e97$var$Sb, arguments);
}
function $0331271bace68e97$var$Ub(a, b, c, d, e, f, g, h, k) {
    $0331271bace68e97$var$Tb.apply(this, arguments);
    if ($0331271bace68e97$var$Ob) {
        if ($0331271bace68e97$var$Ob) {
            var l = $0331271bace68e97$var$Pb;
            $0331271bace68e97$var$Ob = !1;
            $0331271bace68e97$var$Pb = null;
        } else throw Error($0331271bace68e97$var$p(198));
        $0331271bace68e97$var$Qb || ($0331271bace68e97$var$Qb = !0, $0331271bace68e97$var$Rb = l);
    }
}
function $0331271bace68e97$var$Vb(a) {
    var b = a, c = a;
    if (a.alternate) for(; b.return;)b = b.return;
    else {
        a = b;
        do b = a, 0 !== (b.flags & 4098) && (c = b.return), a = b.return;
        while (a);
    }
    return 3 === b.tag ? c : null;
}
function $0331271bace68e97$var$Wb(a) {
    if (13 === a.tag) {
        var b = a.memoizedState;
        null === b && (a = a.alternate, null !== a && (b = a.memoizedState));
        if (null !== b) return b.dehydrated;
    }
    return null;
}
function $0331271bace68e97$var$Xb(a) {
    if ($0331271bace68e97$var$Vb(a) !== a) throw Error($0331271bace68e97$var$p(188));
}
function $0331271bace68e97$var$Yb(a) {
    var b = a.alternate;
    if (!b) {
        b = $0331271bace68e97$var$Vb(a);
        if (null === b) throw Error($0331271bace68e97$var$p(188));
        return b !== a ? null : a;
    }
    for(var c = a, d = b;;){
        var e = c.return;
        if (null === e) break;
        var f = e.alternate;
        if (null === f) {
            d = e.return;
            if (null !== d) {
                c = d;
                continue;
            }
            break;
        }
        if (e.child === f.child) {
            for(f = e.child; f;){
                if (f === c) return $0331271bace68e97$var$Xb(e), a;
                if (f === d) return $0331271bace68e97$var$Xb(e), b;
                f = f.sibling;
            }
            throw Error($0331271bace68e97$var$p(188));
        }
        if (c.return !== d.return) c = e, d = f;
        else {
            for(var g = !1, h = e.child; h;){
                if (h === c) {
                    g = !0;
                    c = e;
                    d = f;
                    break;
                }
                if (h === d) {
                    g = !0;
                    d = e;
                    c = f;
                    break;
                }
                h = h.sibling;
            }
            if (!g) {
                for(h = f.child; h;){
                    if (h === c) {
                        g = !0;
                        c = f;
                        d = e;
                        break;
                    }
                    if (h === d) {
                        g = !0;
                        d = f;
                        c = e;
                        break;
                    }
                    h = h.sibling;
                }
                if (!g) throw Error($0331271bace68e97$var$p(189));
            }
        }
        if (c.alternate !== d) throw Error($0331271bace68e97$var$p(190));
    }
    if (3 !== c.tag) throw Error($0331271bace68e97$var$p(188));
    return c.stateNode.current === c ? a : b;
}
function $0331271bace68e97$var$Zb(a) {
    a = $0331271bace68e97$var$Yb(a);
    return null !== a ? $0331271bace68e97$var$$b(a) : null;
}
function $0331271bace68e97$var$$b(a) {
    if (5 === a.tag || 6 === a.tag) return a;
    for(a = a.child; null !== a;){
        var b = $0331271bace68e97$var$$b(a);
        if (null !== b) return b;
        a = a.sibling;
    }
    return null;
}
var $0331271bace68e97$var$ac = $1iyD5.unstable_scheduleCallback, $0331271bace68e97$var$bc = $1iyD5.unstable_cancelCallback, $0331271bace68e97$var$cc = $1iyD5.unstable_shouldYield, $0331271bace68e97$var$dc = $1iyD5.unstable_requestPaint, $0331271bace68e97$var$B = $1iyD5.unstable_now, $0331271bace68e97$var$ec = $1iyD5.unstable_getCurrentPriorityLevel, $0331271bace68e97$var$fc = $1iyD5.unstable_ImmediatePriority, $0331271bace68e97$var$gc = $1iyD5.unstable_UserBlockingPriority, $0331271bace68e97$var$hc = $1iyD5.unstable_NormalPriority, $0331271bace68e97$var$ic = $1iyD5.unstable_LowPriority, $0331271bace68e97$var$jc = $1iyD5.unstable_IdlePriority, $0331271bace68e97$var$kc = null, $0331271bace68e97$var$lc = null;
function $0331271bace68e97$var$mc(a) {
    if ($0331271bace68e97$var$lc && "function" === typeof $0331271bace68e97$var$lc.onCommitFiberRoot) try {
        $0331271bace68e97$var$lc.onCommitFiberRoot($0331271bace68e97$var$kc, a, void 0, 128 === (a.current.flags & 128));
    } catch (b) {}
}
var $0331271bace68e97$var$oc = Math.clz32 ? Math.clz32 : $0331271bace68e97$var$nc, $0331271bace68e97$var$pc = Math.log, $0331271bace68e97$var$qc = Math.LN2;
function $0331271bace68e97$var$nc(a) {
    a >>>= 0;
    return 0 === a ? 32 : 31 - ($0331271bace68e97$var$pc(a) / $0331271bace68e97$var$qc | 0) | 0;
}
var $0331271bace68e97$var$rc = 64, $0331271bace68e97$var$sc = 4194304;
function $0331271bace68e97$var$tc(a) {
    switch(a & -a){
        case 1:
            return 1;
        case 2:
            return 2;
        case 4:
            return 4;
        case 8:
            return 8;
        case 16:
            return 16;
        case 32:
            return 32;
        case 64:
        case 128:
        case 256:
        case 512:
        case 1024:
        case 2048:
        case 4096:
        case 8192:
        case 16384:
        case 32768:
        case 65536:
        case 131072:
        case 262144:
        case 524288:
        case 1048576:
        case 2097152:
            return a & 4194240;
        case 4194304:
        case 8388608:
        case 16777216:
        case 33554432:
        case 67108864:
            return a & 130023424;
        case 134217728:
            return 134217728;
        case 268435456:
            return 268435456;
        case 536870912:
            return 536870912;
        case 1073741824:
            return 1073741824;
        default:
            return a;
    }
}
function $0331271bace68e97$var$uc(a, b) {
    var c = a.pendingLanes;
    if (0 === c) return 0;
    var d = 0, e = a.suspendedLanes, f = a.pingedLanes, g = c & 268435455;
    if (0 !== g) {
        var h = g & ~e;
        0 !== h ? d = $0331271bace68e97$var$tc(h) : (f &= g, 0 !== f && (d = $0331271bace68e97$var$tc(f)));
    } else g = c & ~e, 0 !== g ? d = $0331271bace68e97$var$tc(g) : 0 !== f && (d = $0331271bace68e97$var$tc(f));
    if (0 === d) return 0;
    if (0 !== b && b !== d && 0 === (b & e) && (e = d & -d, f = b & -b, e >= f || 16 === e && 0 !== (f & 4194240))) return b;
    0 !== (d & 4) && (d |= c & 16);
    b = a.entangledLanes;
    if (0 !== b) for(a = a.entanglements, b &= d; 0 < b;)c = 31 - $0331271bace68e97$var$oc(b), e = 1 << c, d |= a[c], b &= ~e;
    return d;
}
function $0331271bace68e97$var$vc(a, b) {
    switch(a){
        case 1:
        case 2:
        case 4:
            return b + 250;
        case 8:
        case 16:
        case 32:
        case 64:
        case 128:
        case 256:
        case 512:
        case 1024:
        case 2048:
        case 4096:
        case 8192:
        case 16384:
        case 32768:
        case 65536:
        case 131072:
        case 262144:
        case 524288:
        case 1048576:
        case 2097152:
            return b + 5E3;
        case 4194304:
        case 8388608:
        case 16777216:
        case 33554432:
        case 67108864:
            return -1;
        case 134217728:
        case 268435456:
        case 536870912:
        case 1073741824:
            return -1;
        default:
            return -1;
    }
}
function $0331271bace68e97$var$wc(a, b) {
    for(var c = a.suspendedLanes, d = a.pingedLanes, e = a.expirationTimes, f = a.pendingLanes; 0 < f;){
        var g = 31 - $0331271bace68e97$var$oc(f), h = 1 << g, k = e[g];
        if (-1 === k) {
            if (0 === (h & c) || 0 !== (h & d)) e[g] = $0331271bace68e97$var$vc(h, b);
        } else k <= b && (a.expiredLanes |= h);
        f &= ~h;
    }
}
function $0331271bace68e97$var$xc(a) {
    a = a.pendingLanes & -1073741825;
    return 0 !== a ? a : a & 1073741824 ? 1073741824 : 0;
}
function $0331271bace68e97$var$yc() {
    var a = $0331271bace68e97$var$rc;
    $0331271bace68e97$var$rc <<= 1;
    0 === ($0331271bace68e97$var$rc & 4194240) && ($0331271bace68e97$var$rc = 64);
    return a;
}
function $0331271bace68e97$var$zc(a) {
    for(var b = [], c = 0; 31 > c; c++)b.push(a);
    return b;
}
function $0331271bace68e97$var$Ac(a, b, c) {
    a.pendingLanes |= b;
    536870912 !== b && (a.suspendedLanes = 0, a.pingedLanes = 0);
    a = a.eventTimes;
    b = 31 - $0331271bace68e97$var$oc(b);
    a[b] = c;
}
function $0331271bace68e97$var$Bc(a, b) {
    var c = a.pendingLanes & ~b;
    a.pendingLanes = b;
    a.suspendedLanes = 0;
    a.pingedLanes = 0;
    a.expiredLanes &= b;
    a.mutableReadLanes &= b;
    a.entangledLanes &= b;
    b = a.entanglements;
    var d = a.eventTimes;
    for(a = a.expirationTimes; 0 < c;){
        var e = 31 - $0331271bace68e97$var$oc(c), f = 1 << e;
        b[e] = 0;
        d[e] = -1;
        a[e] = -1;
        c &= ~f;
    }
}
function $0331271bace68e97$var$Cc(a, b) {
    var c = a.entangledLanes |= b;
    for(a = a.entanglements; c;){
        var d = 31 - $0331271bace68e97$var$oc(c), e = 1 << d;
        e & b | a[d] & b && (a[d] |= b);
        c &= ~e;
    }
}
var $0331271bace68e97$var$C = 0;
function $0331271bace68e97$var$Dc(a) {
    a &= -a;
    return 1 < a ? 4 < a ? 0 !== (a & 268435455) ? 16 : 536870912 : 4 : 1;
}
var $0331271bace68e97$var$Ec, $0331271bace68e97$var$Fc, $0331271bace68e97$var$Gc, $0331271bace68e97$var$Hc, $0331271bace68e97$var$Ic, $0331271bace68e97$var$Jc = !1, $0331271bace68e97$var$Kc = [], $0331271bace68e97$var$Lc = null, $0331271bace68e97$var$Mc = null, $0331271bace68e97$var$Nc = null, $0331271bace68e97$var$Oc = new Map, $0331271bace68e97$var$Pc = new Map, $0331271bace68e97$var$Qc = [], $0331271bace68e97$var$Rc = "mousedown mouseup touchcancel touchend touchstart auxclick dblclick pointercancel pointerdown pointerup dragend dragstart drop compositionend compositionstart keydown keypress keyup input textInput copy cut paste click change contextmenu reset submit".split(" ");
function $0331271bace68e97$var$Sc(a, b) {
    switch(a){
        case "focusin":
        case "focusout":
            $0331271bace68e97$var$Lc = null;
            break;
        case "dragenter":
        case "dragleave":
            $0331271bace68e97$var$Mc = null;
            break;
        case "mouseover":
        case "mouseout":
            $0331271bace68e97$var$Nc = null;
            break;
        case "pointerover":
        case "pointerout":
            $0331271bace68e97$var$Oc.delete(b.pointerId);
            break;
        case "gotpointercapture":
        case "lostpointercapture":
            $0331271bace68e97$var$Pc.delete(b.pointerId);
    }
}
function $0331271bace68e97$var$Tc(a, b, c, d, e, f) {
    if (null === a || a.nativeEvent !== f) return a = {
        blockedOn: b,
        domEventName: c,
        eventSystemFlags: d,
        nativeEvent: f,
        targetContainers: [
            e
        ]
    }, null !== b && (b = $0331271bace68e97$var$Cb(b), null !== b && $0331271bace68e97$var$Fc(b)), a;
    a.eventSystemFlags |= d;
    b = a.targetContainers;
    null !== e && -1 === b.indexOf(e) && b.push(e);
    return a;
}
function $0331271bace68e97$var$Uc(a, b, c, d, e) {
    switch(b){
        case "focusin":
            return $0331271bace68e97$var$Lc = $0331271bace68e97$var$Tc($0331271bace68e97$var$Lc, a, b, c, d, e), !0;
        case "dragenter":
            return $0331271bace68e97$var$Mc = $0331271bace68e97$var$Tc($0331271bace68e97$var$Mc, a, b, c, d, e), !0;
        case "mouseover":
            return $0331271bace68e97$var$Nc = $0331271bace68e97$var$Tc($0331271bace68e97$var$Nc, a, b, c, d, e), !0;
        case "pointerover":
            var f = e.pointerId;
            $0331271bace68e97$var$Oc.set(f, $0331271bace68e97$var$Tc($0331271bace68e97$var$Oc.get(f) || null, a, b, c, d, e));
            return !0;
        case "gotpointercapture":
            return f = e.pointerId, $0331271bace68e97$var$Pc.set(f, $0331271bace68e97$var$Tc($0331271bace68e97$var$Pc.get(f) || null, a, b, c, d, e)), !0;
    }
    return !1;
}
function $0331271bace68e97$var$Vc(a) {
    var b = $0331271bace68e97$var$Wc(a.target);
    if (null !== b) {
        var c = $0331271bace68e97$var$Vb(b);
        if (null !== c) {
            if (b = c.tag, 13 === b) {
                if (b = $0331271bace68e97$var$Wb(c), null !== b) {
                    a.blockedOn = b;
                    $0331271bace68e97$var$Ic(a.priority, function() {
                        $0331271bace68e97$var$Gc(c);
                    });
                    return;
                }
            } else if (3 === b && c.stateNode.current.memoizedState.isDehydrated) {
                a.blockedOn = 3 === c.tag ? c.stateNode.containerInfo : null;
                return;
            }
        }
    }
    a.blockedOn = null;
}
function $0331271bace68e97$var$Xc(a) {
    if (null !== a.blockedOn) return !1;
    for(var b = a.targetContainers; 0 < b.length;){
        var c = $0331271bace68e97$var$Yc(a.domEventName, a.eventSystemFlags, b[0], a.nativeEvent);
        if (null === c) {
            c = a.nativeEvent;
            var d = new c.constructor(c.type, c);
            $0331271bace68e97$var$wb = d;
            c.target.dispatchEvent(d);
            $0331271bace68e97$var$wb = null;
        } else return b = $0331271bace68e97$var$Cb(c), null !== b && $0331271bace68e97$var$Fc(b), a.blockedOn = c, !1;
        b.shift();
    }
    return !0;
}
function $0331271bace68e97$var$Zc(a, b, c) {
    $0331271bace68e97$var$Xc(a) && c.delete(b);
}
function $0331271bace68e97$var$$c() {
    $0331271bace68e97$var$Jc = !1;
    null !== $0331271bace68e97$var$Lc && $0331271bace68e97$var$Xc($0331271bace68e97$var$Lc) && ($0331271bace68e97$var$Lc = null);
    null !== $0331271bace68e97$var$Mc && $0331271bace68e97$var$Xc($0331271bace68e97$var$Mc) && ($0331271bace68e97$var$Mc = null);
    null !== $0331271bace68e97$var$Nc && $0331271bace68e97$var$Xc($0331271bace68e97$var$Nc) && ($0331271bace68e97$var$Nc = null);
    $0331271bace68e97$var$Oc.forEach($0331271bace68e97$var$Zc);
    $0331271bace68e97$var$Pc.forEach($0331271bace68e97$var$Zc);
}
function $0331271bace68e97$var$ad(a, b) {
    a.blockedOn === b && (a.blockedOn = null, $0331271bace68e97$var$Jc || ($0331271bace68e97$var$Jc = !0, $1iyD5.unstable_scheduleCallback($1iyD5.unstable_NormalPriority, $0331271bace68e97$var$$c)));
}
function $0331271bace68e97$var$bd(a) {
    function b(b) {
        return $0331271bace68e97$var$ad(b, a);
    }
    if (0 < $0331271bace68e97$var$Kc.length) {
        $0331271bace68e97$var$ad($0331271bace68e97$var$Kc[0], a);
        for(var c = 1; c < $0331271bace68e97$var$Kc.length; c++){
            var d = $0331271bace68e97$var$Kc[c];
            d.blockedOn === a && (d.blockedOn = null);
        }
    }
    null !== $0331271bace68e97$var$Lc && $0331271bace68e97$var$ad($0331271bace68e97$var$Lc, a);
    null !== $0331271bace68e97$var$Mc && $0331271bace68e97$var$ad($0331271bace68e97$var$Mc, a);
    null !== $0331271bace68e97$var$Nc && $0331271bace68e97$var$ad($0331271bace68e97$var$Nc, a);
    $0331271bace68e97$var$Oc.forEach(b);
    $0331271bace68e97$var$Pc.forEach(b);
    for(c = 0; c < $0331271bace68e97$var$Qc.length; c++)d = $0331271bace68e97$var$Qc[c], d.blockedOn === a && (d.blockedOn = null);
    for(; 0 < $0331271bace68e97$var$Qc.length && (c = $0331271bace68e97$var$Qc[0], null === c.blockedOn);)$0331271bace68e97$var$Vc(c), null === c.blockedOn && $0331271bace68e97$var$Qc.shift();
}
var $0331271bace68e97$var$cd = $0331271bace68e97$var$ua.ReactCurrentBatchConfig, $0331271bace68e97$var$dd = !0;
function $0331271bace68e97$var$ed(a, b, c, d) {
    var e = $0331271bace68e97$var$C, f = $0331271bace68e97$var$cd.transition;
    $0331271bace68e97$var$cd.transition = null;
    try {
        $0331271bace68e97$var$C = 1, $0331271bace68e97$var$fd(a, b, c, d);
    } finally{
        $0331271bace68e97$var$C = e, $0331271bace68e97$var$cd.transition = f;
    }
}
function $0331271bace68e97$var$gd(a, b, c, d) {
    var e = $0331271bace68e97$var$C, f = $0331271bace68e97$var$cd.transition;
    $0331271bace68e97$var$cd.transition = null;
    try {
        $0331271bace68e97$var$C = 4, $0331271bace68e97$var$fd(a, b, c, d);
    } finally{
        $0331271bace68e97$var$C = e, $0331271bace68e97$var$cd.transition = f;
    }
}
function $0331271bace68e97$var$fd(a, b, c, d) {
    if ($0331271bace68e97$var$dd) {
        var e = $0331271bace68e97$var$Yc(a, b, c, d);
        if (null === e) $0331271bace68e97$var$hd(a, b, d, $0331271bace68e97$var$id, c), $0331271bace68e97$var$Sc(a, d);
        else if ($0331271bace68e97$var$Uc(e, a, b, c, d)) d.stopPropagation();
        else if ($0331271bace68e97$var$Sc(a, d), b & 4 && -1 < $0331271bace68e97$var$Rc.indexOf(a)) {
            for(; null !== e;){
                var f = $0331271bace68e97$var$Cb(e);
                null !== f && $0331271bace68e97$var$Ec(f);
                f = $0331271bace68e97$var$Yc(a, b, c, d);
                null === f && $0331271bace68e97$var$hd(a, b, d, $0331271bace68e97$var$id, c);
                if (f === e) break;
                e = f;
            }
            null !== e && d.stopPropagation();
        } else $0331271bace68e97$var$hd(a, b, d, null, c);
    }
}
var $0331271bace68e97$var$id = null;
function $0331271bace68e97$var$Yc(a, b, c, d) {
    $0331271bace68e97$var$id = null;
    a = $0331271bace68e97$var$xb(d);
    a = $0331271bace68e97$var$Wc(a);
    if (null !== a) {
        if (b = $0331271bace68e97$var$Vb(a), null === b) a = null;
        else if (c = b.tag, 13 === c) {
            a = $0331271bace68e97$var$Wb(b);
            if (null !== a) return a;
            a = null;
        } else if (3 === c) {
            if (b.stateNode.current.memoizedState.isDehydrated) return 3 === b.tag ? b.stateNode.containerInfo : null;
            a = null;
        } else b !== a && (a = null);
    }
    $0331271bace68e97$var$id = a;
    return null;
}
function $0331271bace68e97$var$jd(a) {
    switch(a){
        case "cancel":
        case "click":
        case "close":
        case "contextmenu":
        case "copy":
        case "cut":
        case "auxclick":
        case "dblclick":
        case "dragend":
        case "dragstart":
        case "drop":
        case "focusin":
        case "focusout":
        case "input":
        case "invalid":
        case "keydown":
        case "keypress":
        case "keyup":
        case "mousedown":
        case "mouseup":
        case "paste":
        case "pause":
        case "play":
        case "pointercancel":
        case "pointerdown":
        case "pointerup":
        case "ratechange":
        case "reset":
        case "resize":
        case "seeked":
        case "submit":
        case "touchcancel":
        case "touchend":
        case "touchstart":
        case "volumechange":
        case "change":
        case "selectionchange":
        case "textInput":
        case "compositionstart":
        case "compositionend":
        case "compositionupdate":
        case "beforeblur":
        case "afterblur":
        case "beforeinput":
        case "blur":
        case "fullscreenchange":
        case "focus":
        case "hashchange":
        case "popstate":
        case "select":
        case "selectstart":
            return 1;
        case "drag":
        case "dragenter":
        case "dragexit":
        case "dragleave":
        case "dragover":
        case "mousemove":
        case "mouseout":
        case "mouseover":
        case "pointermove":
        case "pointerout":
        case "pointerover":
        case "scroll":
        case "toggle":
        case "touchmove":
        case "wheel":
        case "mouseenter":
        case "mouseleave":
        case "pointerenter":
        case "pointerleave":
            return 4;
        case "message":
            switch($0331271bace68e97$var$ec()){
                case $0331271bace68e97$var$fc:
                    return 1;
                case $0331271bace68e97$var$gc:
                    return 4;
                case $0331271bace68e97$var$hc:
                case $0331271bace68e97$var$ic:
                    return 16;
                case $0331271bace68e97$var$jc:
                    return 536870912;
                default:
                    return 16;
            }
        default:
            return 16;
    }
}
var $0331271bace68e97$var$kd = null, $0331271bace68e97$var$ld = null, $0331271bace68e97$var$md = null;
function $0331271bace68e97$var$nd() {
    if ($0331271bace68e97$var$md) return $0331271bace68e97$var$md;
    var a, b = $0331271bace68e97$var$ld, c = b.length, d, e = "value" in $0331271bace68e97$var$kd ? $0331271bace68e97$var$kd.value : $0331271bace68e97$var$kd.textContent, f = e.length;
    for(a = 0; a < c && b[a] === e[a]; a++);
    var g = c - a;
    for(d = 1; d <= g && b[c - d] === e[f - d]; d++);
    return $0331271bace68e97$var$md = e.slice(a, 1 < d ? 1 - d : void 0);
}
function $0331271bace68e97$var$od(a) {
    var b = a.keyCode;
    "charCode" in a ? (a = a.charCode, 0 === a && 13 === b && (a = 13)) : a = b;
    10 === a && (a = 13);
    return 32 <= a || 13 === a ? a : 0;
}
function $0331271bace68e97$var$pd() {
    return !0;
}
function $0331271bace68e97$var$qd() {
    return !1;
}
function $0331271bace68e97$var$rd(a) {
    function b(b, d, e, f, g) {
        this._reactName = b;
        this._targetInst = e;
        this.type = d;
        this.nativeEvent = f;
        this.target = g;
        this.currentTarget = null;
        for(var c in a)a.hasOwnProperty(c) && (b = a[c], this[c] = b ? b(f) : f[c]);
        this.isDefaultPrevented = (null != f.defaultPrevented ? f.defaultPrevented : !1 === f.returnValue) ? $0331271bace68e97$var$pd : $0331271bace68e97$var$qd;
        this.isPropagationStopped = $0331271bace68e97$var$qd;
        return this;
    }
    $0331271bace68e97$var$A(b.prototype, {
        preventDefault: function preventDefault() {
            this.defaultPrevented = !0;
            var a = this.nativeEvent;
            a && (a.preventDefault ? a.preventDefault() : "unknown" !== (0, $bJtXW._)(a.returnValue) && (a.returnValue = !1), this.isDefaultPrevented = $0331271bace68e97$var$pd);
        },
        stopPropagation: function stopPropagation() {
            var a = this.nativeEvent;
            a && (a.stopPropagation ? a.stopPropagation() : "unknown" !== (0, $bJtXW._)(a.cancelBubble) && (a.cancelBubble = !0), this.isPropagationStopped = $0331271bace68e97$var$pd);
        },
        persist: function persist() {},
        isPersistent: $0331271bace68e97$var$pd
    });
    return b;
}
var $0331271bace68e97$var$sd = {
    eventPhase: 0,
    bubbles: 0,
    cancelable: 0,
    timeStamp: function timeStamp(a) {
        return a.timeStamp || Date.now();
    },
    defaultPrevented: 0,
    isTrusted: 0
}, $0331271bace68e97$var$td = $0331271bace68e97$var$rd($0331271bace68e97$var$sd), $0331271bace68e97$var$ud = $0331271bace68e97$var$A({}, $0331271bace68e97$var$sd, {
    view: 0,
    detail: 0
}), $0331271bace68e97$var$vd = $0331271bace68e97$var$rd($0331271bace68e97$var$ud), $0331271bace68e97$var$wd, $0331271bace68e97$var$xd, $0331271bace68e97$var$yd, $0331271bace68e97$var$Ad = $0331271bace68e97$var$A({}, $0331271bace68e97$var$ud, {
    screenX: 0,
    screenY: 0,
    clientX: 0,
    clientY: 0,
    pageX: 0,
    pageY: 0,
    ctrlKey: 0,
    shiftKey: 0,
    altKey: 0,
    metaKey: 0,
    getModifierState: $0331271bace68e97$var$zd,
    button: 0,
    buttons: 0,
    relatedTarget: function relatedTarget(a) {
        return void 0 === a.relatedTarget ? a.fromElement === a.srcElement ? a.toElement : a.fromElement : a.relatedTarget;
    },
    movementX: function movementX(a) {
        if ("movementX" in a) return a.movementX;
        a !== $0331271bace68e97$var$yd && ($0331271bace68e97$var$yd && "mousemove" === a.type ? ($0331271bace68e97$var$wd = a.screenX - $0331271bace68e97$var$yd.screenX, $0331271bace68e97$var$xd = a.screenY - $0331271bace68e97$var$yd.screenY) : $0331271bace68e97$var$xd = $0331271bace68e97$var$wd = 0, $0331271bace68e97$var$yd = a);
        return $0331271bace68e97$var$wd;
    },
    movementY: function movementY(a) {
        return "movementY" in a ? a.movementY : $0331271bace68e97$var$xd;
    }
}), $0331271bace68e97$var$Bd = $0331271bace68e97$var$rd($0331271bace68e97$var$Ad), $0331271bace68e97$var$Cd = $0331271bace68e97$var$A({}, $0331271bace68e97$var$Ad, {
    dataTransfer: 0
}), $0331271bace68e97$var$Dd = $0331271bace68e97$var$rd($0331271bace68e97$var$Cd), $0331271bace68e97$var$Ed = $0331271bace68e97$var$A({}, $0331271bace68e97$var$ud, {
    relatedTarget: 0
}), $0331271bace68e97$var$Fd = $0331271bace68e97$var$rd($0331271bace68e97$var$Ed), $0331271bace68e97$var$Gd = $0331271bace68e97$var$A({}, $0331271bace68e97$var$sd, {
    animationName: 0,
    elapsedTime: 0,
    pseudoElement: 0
}), $0331271bace68e97$var$Hd = $0331271bace68e97$var$rd($0331271bace68e97$var$Gd), $0331271bace68e97$var$Id = $0331271bace68e97$var$A({}, $0331271bace68e97$var$sd, {
    clipboardData: function clipboardData(a) {
        return "clipboardData" in a ? a.clipboardData : window.clipboardData;
    }
}), $0331271bace68e97$var$Jd = $0331271bace68e97$var$rd($0331271bace68e97$var$Id), $0331271bace68e97$var$Kd = $0331271bace68e97$var$A({}, $0331271bace68e97$var$sd, {
    data: 0
}), $0331271bace68e97$var$Ld = $0331271bace68e97$var$rd($0331271bace68e97$var$Kd), $0331271bace68e97$var$Md = {
    Esc: "Escape",
    Spacebar: " ",
    Left: "ArrowLeft",
    Up: "ArrowUp",
    Right: "ArrowRight",
    Down: "ArrowDown",
    Del: "Delete",
    Win: "OS",
    Menu: "ContextMenu",
    Apps: "ContextMenu",
    Scroll: "ScrollLock",
    MozPrintableKey: "Unidentified"
}, $0331271bace68e97$var$Nd = {
    8: "Backspace",
    9: "Tab",
    12: "Clear",
    13: "Enter",
    16: "Shift",
    17: "Control",
    18: "Alt",
    19: "Pause",
    20: "CapsLock",
    27: "Escape",
    32: " ",
    33: "PageUp",
    34: "PageDown",
    35: "End",
    36: "Home",
    37: "ArrowLeft",
    38: "ArrowUp",
    39: "ArrowRight",
    40: "ArrowDown",
    45: "Insert",
    46: "Delete",
    112: "F1",
    113: "F2",
    114: "F3",
    115: "F4",
    116: "F5",
    117: "F6",
    118: "F7",
    119: "F8",
    120: "F9",
    121: "F10",
    122: "F11",
    123: "F12",
    144: "NumLock",
    145: "ScrollLock",
    224: "Meta"
}, $0331271bace68e97$var$Od = {
    Alt: "altKey",
    Control: "ctrlKey",
    Meta: "metaKey",
    Shift: "shiftKey"
};
function $0331271bace68e97$var$Pd(a) {
    var b = this.nativeEvent;
    return b.getModifierState ? b.getModifierState(a) : (a = $0331271bace68e97$var$Od[a]) ? !!b[a] : !1;
}
function $0331271bace68e97$var$zd() {
    return $0331271bace68e97$var$Pd;
}
var $0331271bace68e97$var$Qd = $0331271bace68e97$var$A({}, $0331271bace68e97$var$ud, {
    key: function key(a) {
        if (a.key) {
            var b = $0331271bace68e97$var$Md[a.key] || a.key;
            if ("Unidentified" !== b) return b;
        }
        return "keypress" === a.type ? (a = $0331271bace68e97$var$od(a), 13 === a ? "Enter" : String.fromCharCode(a)) : "keydown" === a.type || "keyup" === a.type ? $0331271bace68e97$var$Nd[a.keyCode] || "Unidentified" : "";
    },
    code: 0,
    location: 0,
    ctrlKey: 0,
    shiftKey: 0,
    altKey: 0,
    metaKey: 0,
    repeat: 0,
    locale: 0,
    getModifierState: $0331271bace68e97$var$zd,
    charCode: function charCode(a) {
        return "keypress" === a.type ? $0331271bace68e97$var$od(a) : 0;
    },
    keyCode: function keyCode(a) {
        return "keydown" === a.type || "keyup" === a.type ? a.keyCode : 0;
    },
    which: function which(a) {
        return "keypress" === a.type ? $0331271bace68e97$var$od(a) : "keydown" === a.type || "keyup" === a.type ? a.keyCode : 0;
    }
}), $0331271bace68e97$var$Rd = $0331271bace68e97$var$rd($0331271bace68e97$var$Qd), $0331271bace68e97$var$Sd = $0331271bace68e97$var$A({}, $0331271bace68e97$var$Ad, {
    pointerId: 0,
    width: 0,
    height: 0,
    pressure: 0,
    tangentialPressure: 0,
    tiltX: 0,
    tiltY: 0,
    twist: 0,
    pointerType: 0,
    isPrimary: 0
}), $0331271bace68e97$var$Td = $0331271bace68e97$var$rd($0331271bace68e97$var$Sd), $0331271bace68e97$var$Ud = $0331271bace68e97$var$A({}, $0331271bace68e97$var$ud, {
    touches: 0,
    targetTouches: 0,
    changedTouches: 0,
    altKey: 0,
    metaKey: 0,
    ctrlKey: 0,
    shiftKey: 0,
    getModifierState: $0331271bace68e97$var$zd
}), $0331271bace68e97$var$Vd = $0331271bace68e97$var$rd($0331271bace68e97$var$Ud), $0331271bace68e97$var$Wd = $0331271bace68e97$var$A({}, $0331271bace68e97$var$sd, {
    propertyName: 0,
    elapsedTime: 0,
    pseudoElement: 0
}), $0331271bace68e97$var$Xd = $0331271bace68e97$var$rd($0331271bace68e97$var$Wd), $0331271bace68e97$var$Yd = $0331271bace68e97$var$A({}, $0331271bace68e97$var$Ad, {
    deltaX: function deltaX(a) {
        return "deltaX" in a ? a.deltaX : "wheelDeltaX" in a ? -a.wheelDeltaX : 0;
    },
    deltaY: function deltaY(a) {
        return "deltaY" in a ? a.deltaY : "wheelDeltaY" in a ? -a.wheelDeltaY : "wheelDelta" in a ? -a.wheelDelta : 0;
    },
    deltaZ: 0,
    deltaMode: 0
}), $0331271bace68e97$var$Zd = $0331271bace68e97$var$rd($0331271bace68e97$var$Yd), $0331271bace68e97$var$$d = [
    9,
    13,
    27,
    32
], $0331271bace68e97$var$ae = $0331271bace68e97$var$ia && "CompositionEvent" in window, $0331271bace68e97$var$be = null;
$0331271bace68e97$var$ia && "documentMode" in document && ($0331271bace68e97$var$be = document.documentMode);
var $0331271bace68e97$var$ce = $0331271bace68e97$var$ia && "TextEvent" in window && !$0331271bace68e97$var$be, $0331271bace68e97$var$de = $0331271bace68e97$var$ia && (!$0331271bace68e97$var$ae || $0331271bace68e97$var$be && 8 < $0331271bace68e97$var$be && 11 >= $0331271bace68e97$var$be), $0331271bace68e97$var$ee = String.fromCharCode(32), $0331271bace68e97$var$fe = !1;
function $0331271bace68e97$var$ge(a, b) {
    switch(a){
        case "keyup":
            return -1 !== $0331271bace68e97$var$$d.indexOf(b.keyCode);
        case "keydown":
            return 229 !== b.keyCode;
        case "keypress":
        case "mousedown":
        case "focusout":
            return !0;
        default:
            return !1;
    }
}
function $0331271bace68e97$var$he(a) {
    a = a.detail;
    return "object" === (typeof a === "undefined" ? "undefined" : (0, $bJtXW._)(a)) && "data" in a ? a.data : null;
}
var $0331271bace68e97$var$ie = !1;
function $0331271bace68e97$var$je(a, b) {
    switch(a){
        case "compositionend":
            return $0331271bace68e97$var$he(b);
        case "keypress":
            if (32 !== b.which) return null;
            $0331271bace68e97$var$fe = !0;
            return $0331271bace68e97$var$ee;
        case "textInput":
            return a = b.data, a === $0331271bace68e97$var$ee && $0331271bace68e97$var$fe ? null : a;
        default:
            return null;
    }
}
function $0331271bace68e97$var$ke(a, b) {
    if ($0331271bace68e97$var$ie) return "compositionend" === a || !$0331271bace68e97$var$ae && $0331271bace68e97$var$ge(a, b) ? (a = $0331271bace68e97$var$nd(), $0331271bace68e97$var$md = $0331271bace68e97$var$ld = $0331271bace68e97$var$kd = null, $0331271bace68e97$var$ie = !1, a) : null;
    switch(a){
        case "paste":
            return null;
        case "keypress":
            if (!(b.ctrlKey || b.altKey || b.metaKey) || b.ctrlKey && b.altKey) {
                if (b.char && 1 < b.char.length) return b.char;
                if (b.which) return String.fromCharCode(b.which);
            }
            return null;
        case "compositionend":
            return $0331271bace68e97$var$de && "ko" !== b.locale ? null : b.data;
        default:
            return null;
    }
}
var $0331271bace68e97$var$le = {
    color: !0,
    date: !0,
    datetime: !0,
    "datetime-local": !0,
    email: !0,
    month: !0,
    number: !0,
    password: !0,
    range: !0,
    search: !0,
    tel: !0,
    text: !0,
    time: !0,
    url: !0,
    week: !0
};
function $0331271bace68e97$var$me(a) {
    var b = a && a.nodeName && a.nodeName.toLowerCase();
    return "input" === b ? !!$0331271bace68e97$var$le[a.type] : "textarea" === b ? !0 : !1;
}
function $0331271bace68e97$var$ne(a, b, c, d) {
    $0331271bace68e97$var$Eb(d);
    b = $0331271bace68e97$var$oe(b, "onChange");
    0 < b.length && (c = new $0331271bace68e97$var$td("onChange", "change", null, c, d), a.push({
        event: c,
        listeners: b
    }));
}
var $0331271bace68e97$var$pe = null, $0331271bace68e97$var$qe = null;
function $0331271bace68e97$var$re(a) {
    $0331271bace68e97$var$se(a, 0);
}
function $0331271bace68e97$var$te(a) {
    var b = $0331271bace68e97$var$ue(a);
    if ($0331271bace68e97$var$Wa(b)) return a;
}
function $0331271bace68e97$var$ve(a, b) {
    if ("change" === a) return b;
}
var $0331271bace68e97$var$we = !1;
if ($0331271bace68e97$var$ia) {
    var $0331271bace68e97$var$xe;
    if ($0331271bace68e97$var$ia) {
        var $0331271bace68e97$var$ye = "oninput" in document;
        if (!$0331271bace68e97$var$ye) {
            var $0331271bace68e97$var$ze = document.createElement("div");
            $0331271bace68e97$var$ze.setAttribute("oninput", "return;");
            $0331271bace68e97$var$ye = "function" === typeof $0331271bace68e97$var$ze.oninput;
        }
        $0331271bace68e97$var$xe = $0331271bace68e97$var$ye;
    } else $0331271bace68e97$var$xe = !1;
    $0331271bace68e97$var$we = $0331271bace68e97$var$xe && (!document.documentMode || 9 < document.documentMode);
}
function $0331271bace68e97$var$Ae() {
    $0331271bace68e97$var$pe && ($0331271bace68e97$var$pe.detachEvent("onpropertychange", $0331271bace68e97$var$Be), $0331271bace68e97$var$qe = $0331271bace68e97$var$pe = null);
}
function $0331271bace68e97$var$Be(a) {
    if ("value" === a.propertyName && $0331271bace68e97$var$te($0331271bace68e97$var$qe)) {
        var b = [];
        $0331271bace68e97$var$ne(b, $0331271bace68e97$var$qe, a, $0331271bace68e97$var$xb(a));
        $0331271bace68e97$var$Jb($0331271bace68e97$var$re, b);
    }
}
function $0331271bace68e97$var$Ce(a, b, c) {
    "focusin" === a ? ($0331271bace68e97$var$Ae(), $0331271bace68e97$var$pe = b, $0331271bace68e97$var$qe = c, $0331271bace68e97$var$pe.attachEvent("onpropertychange", $0331271bace68e97$var$Be)) : "focusout" === a && $0331271bace68e97$var$Ae();
}
function $0331271bace68e97$var$De(a) {
    if ("selectionchange" === a || "keyup" === a || "keydown" === a) return $0331271bace68e97$var$te($0331271bace68e97$var$qe);
}
function $0331271bace68e97$var$Ee(a, b) {
    if ("click" === a) return $0331271bace68e97$var$te(b);
}
function $0331271bace68e97$var$Fe(a, b) {
    if ("input" === a || "change" === a) return $0331271bace68e97$var$te(b);
}
function $0331271bace68e97$var$Ge(a, b) {
    return a === b && (0 !== a || 1 / a === 1 / b) || a !== a && b !== b;
}
var $0331271bace68e97$var$He = "function" === typeof Object.is ? Object.is : $0331271bace68e97$var$Ge;
function $0331271bace68e97$var$Ie(a, b) {
    if ($0331271bace68e97$var$He(a, b)) return !0;
    if ("object" !== (typeof a === "undefined" ? "undefined" : (0, $bJtXW._)(a)) || null === a || "object" !== (typeof b === "undefined" ? "undefined" : (0, $bJtXW._)(b)) || null === b) return !1;
    var c = Object.keys(a), d = Object.keys(b);
    if (c.length !== d.length) return !1;
    for(d = 0; d < c.length; d++){
        var e = c[d];
        if (!$0331271bace68e97$var$ja.call(b, e) || !$0331271bace68e97$var$He(a[e], b[e])) return !1;
    }
    return !0;
}
function $0331271bace68e97$var$Je(a) {
    for(; a && a.firstChild;)a = a.firstChild;
    return a;
}
function $0331271bace68e97$var$Ke(a, b) {
    var c = $0331271bace68e97$var$Je(a);
    a = 0;
    for(var d; c;){
        if (3 === c.nodeType) {
            d = a + c.textContent.length;
            if (a <= b && d >= b) return {
                node: c,
                offset: b - a
            };
            a = d;
        }
        a: {
            for(; c;){
                if (c.nextSibling) {
                    c = c.nextSibling;
                    break a;
                }
                c = c.parentNode;
            }
            c = void 0;
        }
        c = $0331271bace68e97$var$Je(c);
    }
}
function $0331271bace68e97$var$Le(a, b) {
    return a && b ? a === b ? !0 : a && 3 === a.nodeType ? !1 : b && 3 === b.nodeType ? $0331271bace68e97$var$Le(a, b.parentNode) : "contains" in a ? a.contains(b) : a.compareDocumentPosition ? !!(a.compareDocumentPosition(b) & 16) : !1 : !1;
}
function $0331271bace68e97$var$Me() {
    for(var a = window, b = $0331271bace68e97$var$Xa(); b instanceof a.HTMLIFrameElement;){
        try {
            var c = "string" === typeof b.contentWindow.location.href;
        } catch (d) {
            c = !1;
        }
        if (c) a = b.contentWindow;
        else break;
        b = $0331271bace68e97$var$Xa(a.document);
    }
    return b;
}
function $0331271bace68e97$var$Ne(a) {
    var b = a && a.nodeName && a.nodeName.toLowerCase();
    return b && ("input" === b && ("text" === a.type || "search" === a.type || "tel" === a.type || "url" === a.type || "password" === a.type) || "textarea" === b || "true" === a.contentEditable);
}
function $0331271bace68e97$var$Oe(a) {
    var b = $0331271bace68e97$var$Me(), c = a.focusedElem, d = a.selectionRange;
    if (b !== c && c && c.ownerDocument && $0331271bace68e97$var$Le(c.ownerDocument.documentElement, c)) {
        if (null !== d && $0331271bace68e97$var$Ne(c)) {
            if (b = d.start, a = d.end, void 0 === a && (a = b), "selectionStart" in c) c.selectionStart = b, c.selectionEnd = Math.min(a, c.value.length);
            else if (a = (b = c.ownerDocument || document) && b.defaultView || window, a.getSelection) {
                a = a.getSelection();
                var e = c.textContent.length, f = Math.min(d.start, e);
                d = void 0 === d.end ? f : Math.min(d.end, e);
                !a.extend && f > d && (e = d, d = f, f = e);
                e = $0331271bace68e97$var$Ke(c, f);
                var g = $0331271bace68e97$var$Ke(c, d);
                e && g && (1 !== a.rangeCount || a.anchorNode !== e.node || a.anchorOffset !== e.offset || a.focusNode !== g.node || a.focusOffset !== g.offset) && (b = b.createRange(), b.setStart(e.node, e.offset), a.removeAllRanges(), f > d ? (a.addRange(b), a.extend(g.node, g.offset)) : (b.setEnd(g.node, g.offset), a.addRange(b)));
            }
        }
        b = [];
        for(a = c; a = a.parentNode;)1 === a.nodeType && b.push({
            element: a,
            left: a.scrollLeft,
            top: a.scrollTop
        });
        "function" === typeof c.focus && c.focus();
        for(c = 0; c < b.length; c++)a = b[c], a.element.scrollLeft = a.left, a.element.scrollTop = a.top;
    }
}
var $0331271bace68e97$var$Pe = $0331271bace68e97$var$ia && "documentMode" in document && 11 >= document.documentMode, $0331271bace68e97$var$Qe = null, $0331271bace68e97$var$Re = null, $0331271bace68e97$var$Se = null, $0331271bace68e97$var$Te = !1;
function $0331271bace68e97$var$Ue(a, b, c) {
    var d = c.window === c ? c.document : 9 === c.nodeType ? c : c.ownerDocument;
    $0331271bace68e97$var$Te || null == $0331271bace68e97$var$Qe || $0331271bace68e97$var$Qe !== $0331271bace68e97$var$Xa(d) || (d = $0331271bace68e97$var$Qe, "selectionStart" in d && $0331271bace68e97$var$Ne(d) ? d = {
        start: d.selectionStart,
        end: d.selectionEnd
    } : (d = (d.ownerDocument && d.ownerDocument.defaultView || window).getSelection(), d = {
        anchorNode: d.anchorNode,
        anchorOffset: d.anchorOffset,
        focusNode: d.focusNode,
        focusOffset: d.focusOffset
    }), $0331271bace68e97$var$Se && $0331271bace68e97$var$Ie($0331271bace68e97$var$Se, d) || ($0331271bace68e97$var$Se = d, d = $0331271bace68e97$var$oe($0331271bace68e97$var$Re, "onSelect"), 0 < d.length && (b = new $0331271bace68e97$var$td("onSelect", "select", null, b, c), a.push({
        event: b,
        listeners: d
    }), b.target = $0331271bace68e97$var$Qe)));
}
function $0331271bace68e97$var$Ve(a, b) {
    var c = {};
    c[a.toLowerCase()] = b.toLowerCase();
    c["Webkit" + a] = "webkit" + b;
    c["Moz" + a] = "moz" + b;
    return c;
}
var $0331271bace68e97$var$We = {
    animationend: $0331271bace68e97$var$Ve("Animation", "AnimationEnd"),
    animationiteration: $0331271bace68e97$var$Ve("Animation", "AnimationIteration"),
    animationstart: $0331271bace68e97$var$Ve("Animation", "AnimationStart"),
    transitionend: $0331271bace68e97$var$Ve("Transition", "TransitionEnd")
}, $0331271bace68e97$var$Xe = {}, $0331271bace68e97$var$Ye = {};
$0331271bace68e97$var$ia && ($0331271bace68e97$var$Ye = document.createElement("div").style, "AnimationEvent" in window || (delete $0331271bace68e97$var$We.animationend.animation, delete $0331271bace68e97$var$We.animationiteration.animation, delete $0331271bace68e97$var$We.animationstart.animation), "TransitionEvent" in window || delete $0331271bace68e97$var$We.transitionend.transition);
function $0331271bace68e97$var$Ze(a) {
    if ($0331271bace68e97$var$Xe[a]) return $0331271bace68e97$var$Xe[a];
    if (!$0331271bace68e97$var$We[a]) return a;
    var b = $0331271bace68e97$var$We[a], c;
    for(c in b)if (b.hasOwnProperty(c) && c in $0331271bace68e97$var$Ye) return $0331271bace68e97$var$Xe[a] = b[c];
    return a;
}
var $0331271bace68e97$var$$e = $0331271bace68e97$var$Ze("animationend"), $0331271bace68e97$var$af = $0331271bace68e97$var$Ze("animationiteration"), $0331271bace68e97$var$bf = $0331271bace68e97$var$Ze("animationstart"), $0331271bace68e97$var$cf = $0331271bace68e97$var$Ze("transitionend"), $0331271bace68e97$var$df = new Map, $0331271bace68e97$var$ef = "abort auxClick cancel canPlay canPlayThrough click close contextMenu copy cut drag dragEnd dragEnter dragExit dragLeave dragOver dragStart drop durationChange emptied encrypted ended error gotPointerCapture input invalid keyDown keyPress keyUp load loadedData loadedMetadata loadStart lostPointerCapture mouseDown mouseMove mouseOut mouseOver mouseUp paste pause play playing pointerCancel pointerDown pointerMove pointerOut pointerOver pointerUp progress rateChange reset resize seeked seeking stalled submit suspend timeUpdate touchCancel touchEnd touchStart volumeChange scroll toggle touchMove waiting wheel".split(" ");
function $0331271bace68e97$var$ff(a, b) {
    $0331271bace68e97$var$df.set(a, b);
    $0331271bace68e97$var$fa(b, [
        a
    ]);
}
for(var $0331271bace68e97$var$gf = 0; $0331271bace68e97$var$gf < $0331271bace68e97$var$ef.length; $0331271bace68e97$var$gf++){
    var $0331271bace68e97$var$hf = $0331271bace68e97$var$ef[$0331271bace68e97$var$gf], $0331271bace68e97$var$jf = $0331271bace68e97$var$hf.toLowerCase(), $0331271bace68e97$var$kf = $0331271bace68e97$var$hf[0].toUpperCase() + $0331271bace68e97$var$hf.slice(1);
    $0331271bace68e97$var$ff($0331271bace68e97$var$jf, "on" + $0331271bace68e97$var$kf);
}
$0331271bace68e97$var$ff($0331271bace68e97$var$$e, "onAnimationEnd");
$0331271bace68e97$var$ff($0331271bace68e97$var$af, "onAnimationIteration");
$0331271bace68e97$var$ff($0331271bace68e97$var$bf, "onAnimationStart");
$0331271bace68e97$var$ff("dblclick", "onDoubleClick");
$0331271bace68e97$var$ff("focusin", "onFocus");
$0331271bace68e97$var$ff("focusout", "onBlur");
$0331271bace68e97$var$ff($0331271bace68e97$var$cf, "onTransitionEnd");
$0331271bace68e97$var$ha("onMouseEnter", [
    "mouseout",
    "mouseover"
]);
$0331271bace68e97$var$ha("onMouseLeave", [
    "mouseout",
    "mouseover"
]);
$0331271bace68e97$var$ha("onPointerEnter", [
    "pointerout",
    "pointerover"
]);
$0331271bace68e97$var$ha("onPointerLeave", [
    "pointerout",
    "pointerover"
]);
$0331271bace68e97$var$fa("onChange", "change click focusin focusout input keydown keyup selectionchange".split(" "));
$0331271bace68e97$var$fa("onSelect", "focusout contextmenu dragend focusin keydown keyup mousedown mouseup selectionchange".split(" "));
$0331271bace68e97$var$fa("onBeforeInput", [
    "compositionend",
    "keypress",
    "textInput",
    "paste"
]);
$0331271bace68e97$var$fa("onCompositionEnd", "compositionend focusout keydown keypress keyup mousedown".split(" "));
$0331271bace68e97$var$fa("onCompositionStart", "compositionstart focusout keydown keypress keyup mousedown".split(" "));
$0331271bace68e97$var$fa("onCompositionUpdate", "compositionupdate focusout keydown keypress keyup mousedown".split(" "));
var $0331271bace68e97$var$lf = "abort canplay canplaythrough durationchange emptied encrypted ended error loadeddata loadedmetadata loadstart pause play playing progress ratechange resize seeked seeking stalled suspend timeupdate volumechange waiting".split(" "), $0331271bace68e97$var$mf = new Set("cancel close invalid load scroll toggle".split(" ").concat($0331271bace68e97$var$lf));
function $0331271bace68e97$var$nf(a, b, c) {
    var d = a.type || "unknown-event";
    a.currentTarget = c;
    $0331271bace68e97$var$Ub(d, b, void 0, a);
    a.currentTarget = null;
}
function $0331271bace68e97$var$se(a, b) {
    b = 0 !== (b & 4);
    for(var c = 0; c < a.length; c++){
        var d = a[c], e = d.event;
        d = d.listeners;
        a: {
            var f = void 0;
            if (b) for(var g = d.length - 1; 0 <= g; g--){
                var h = d[g], k = h.instance, l = h.currentTarget;
                h = h.listener;
                if (k !== f && e.isPropagationStopped()) break a;
                $0331271bace68e97$var$nf(e, h, l);
                f = k;
            }
            else for(g = 0; g < d.length; g++){
                h = d[g];
                k = h.instance;
                l = h.currentTarget;
                h = h.listener;
                if (k !== f && e.isPropagationStopped()) break a;
                $0331271bace68e97$var$nf(e, h, l);
                f = k;
            }
        }
    }
    if ($0331271bace68e97$var$Qb) throw a = $0331271bace68e97$var$Rb, $0331271bace68e97$var$Qb = !1, $0331271bace68e97$var$Rb = null, a;
}
function $0331271bace68e97$var$D(a, b) {
    var c = b[$0331271bace68e97$var$of];
    void 0 === c && (c = b[$0331271bace68e97$var$of] = new Set);
    var d = a + "__bubble";
    c.has(d) || ($0331271bace68e97$var$pf(b, a, 2, !1), c.add(d));
}
function $0331271bace68e97$var$qf(a, b, c) {
    var d = 0;
    b && (d |= 4);
    $0331271bace68e97$var$pf(c, a, d, b);
}
var $0331271bace68e97$var$rf = "_reactListening" + Math.random().toString(36).slice(2);
function $0331271bace68e97$var$sf(a) {
    if (!a[$0331271bace68e97$var$rf]) {
        a[$0331271bace68e97$var$rf] = !0;
        $0331271bace68e97$var$da.forEach(function(b) {
            "selectionchange" !== b && ($0331271bace68e97$var$mf.has(b) || $0331271bace68e97$var$qf(b, !1, a), $0331271bace68e97$var$qf(b, !0, a));
        });
        var b = 9 === a.nodeType ? a : a.ownerDocument;
        null === b || b[$0331271bace68e97$var$rf] || (b[$0331271bace68e97$var$rf] = !0, $0331271bace68e97$var$qf("selectionchange", !1, b));
    }
}
function $0331271bace68e97$var$pf(a, b, c, d) {
    switch($0331271bace68e97$var$jd(b)){
        case 1:
            var e = $0331271bace68e97$var$ed;
            break;
        case 4:
            e = $0331271bace68e97$var$gd;
            break;
        default:
            e = $0331271bace68e97$var$fd;
    }
    c = e.bind(null, b, c, a);
    e = void 0;
    !$0331271bace68e97$var$Lb || "touchstart" !== b && "touchmove" !== b && "wheel" !== b || (e = !0);
    d ? void 0 !== e ? a.addEventListener(b, c, {
        capture: !0,
        passive: e
    }) : a.addEventListener(b, c, !0) : void 0 !== e ? a.addEventListener(b, c, {
        passive: e
    }) : a.addEventListener(b, c, !1);
}
function $0331271bace68e97$var$hd(a, b, c, d, e) {
    var f = d;
    if (0 === (b & 1) && 0 === (b & 2) && null !== d) a: for(;;){
        if (null === d) return;
        var g = d.tag;
        if (3 === g || 4 === g) {
            var h = d.stateNode.containerInfo;
            if (h === e || 8 === h.nodeType && h.parentNode === e) break;
            if (4 === g) for(g = d.return; null !== g;){
                var k = g.tag;
                if (3 === k || 4 === k) {
                    if (k = g.stateNode.containerInfo, k === e || 8 === k.nodeType && k.parentNode === e) return;
                }
                g = g.return;
            }
            for(; null !== h;){
                g = $0331271bace68e97$var$Wc(h);
                if (null === g) return;
                k = g.tag;
                if (5 === k || 6 === k) {
                    d = f = g;
                    continue a;
                }
                h = h.parentNode;
            }
        }
        d = d.return;
    }
    $0331271bace68e97$var$Jb(function() {
        var _$d = f, _$e = $0331271bace68e97$var$xb(c), g = [];
        a: {
            var h = $0331271bace68e97$var$df.get(a);
            if (void 0 !== h) {
                var k = $0331271bace68e97$var$td, n = a;
                switch(a){
                    case "keypress":
                        if (0 === $0331271bace68e97$var$od(c)) break a;
                    case "keydown":
                    case "keyup":
                        k = $0331271bace68e97$var$Rd;
                        break;
                    case "focusin":
                        n = "focus";
                        k = $0331271bace68e97$var$Fd;
                        break;
                    case "focusout":
                        n = "blur";
                        k = $0331271bace68e97$var$Fd;
                        break;
                    case "beforeblur":
                    case "afterblur":
                        k = $0331271bace68e97$var$Fd;
                        break;
                    case "click":
                        if (2 === c.button) break a;
                    case "auxclick":
                    case "dblclick":
                    case "mousedown":
                    case "mousemove":
                    case "mouseup":
                    case "mouseout":
                    case "mouseover":
                    case "contextmenu":
                        k = $0331271bace68e97$var$Bd;
                        break;
                    case "drag":
                    case "dragend":
                    case "dragenter":
                    case "dragexit":
                    case "dragleave":
                    case "dragover":
                    case "dragstart":
                    case "drop":
                        k = $0331271bace68e97$var$Dd;
                        break;
                    case "touchcancel":
                    case "touchend":
                    case "touchmove":
                    case "touchstart":
                        k = $0331271bace68e97$var$Vd;
                        break;
                    case $0331271bace68e97$var$$e:
                    case $0331271bace68e97$var$af:
                    case $0331271bace68e97$var$bf:
                        k = $0331271bace68e97$var$Hd;
                        break;
                    case $0331271bace68e97$var$cf:
                        k = $0331271bace68e97$var$Xd;
                        break;
                    case "scroll":
                        k = $0331271bace68e97$var$vd;
                        break;
                    case "wheel":
                        k = $0331271bace68e97$var$Zd;
                        break;
                    case "copy":
                    case "cut":
                    case "paste":
                        k = $0331271bace68e97$var$Jd;
                        break;
                    case "gotpointercapture":
                    case "lostpointercapture":
                    case "pointercancel":
                    case "pointerdown":
                    case "pointermove":
                    case "pointerout":
                    case "pointerover":
                    case "pointerup":
                        k = $0331271bace68e97$var$Td;
                }
                var t = 0 !== (b & 4), J = !t && "scroll" === a, x = t ? null !== h ? h + "Capture" : null : h;
                t = [];
                for(var w = _$d, u; null !== w;){
                    u = w;
                    var F = u.stateNode;
                    5 === u.tag && null !== F && (u = F, null !== x && (F = $0331271bace68e97$var$Kb(w, x), null != F && t.push($0331271bace68e97$var$tf(w, F, u))));
                    if (J) break;
                    w = w.return;
                }
                0 < t.length && (h = new k(h, n, null, c, _$e), g.push({
                    event: h,
                    listeners: t
                }));
            }
        }
        if (0 === (b & 7)) {
            a: {
                h = "mouseover" === a || "pointerover" === a;
                k = "mouseout" === a || "pointerout" === a;
                if (h && c !== $0331271bace68e97$var$wb && (n = c.relatedTarget || c.fromElement) && ($0331271bace68e97$var$Wc(n) || n[$0331271bace68e97$var$uf])) break a;
                if (k || h) {
                    h = _$e.window === _$e ? _$e : (h = _$e.ownerDocument) ? h.defaultView || h.parentWindow : window;
                    if (k) {
                        if (n = c.relatedTarget || c.toElement, k = _$d, n = n ? $0331271bace68e97$var$Wc(n) : null, null !== n && (J = $0331271bace68e97$var$Vb(n), n !== J || 5 !== n.tag && 6 !== n.tag)) n = null;
                    } else k = null, n = _$d;
                    if (k !== n) {
                        t = $0331271bace68e97$var$Bd;
                        F = "onMouseLeave";
                        x = "onMouseEnter";
                        w = "mouse";
                        if ("pointerout" === a || "pointerover" === a) t = $0331271bace68e97$var$Td, F = "onPointerLeave", x = "onPointerEnter", w = "pointer";
                        J = null == k ? h : $0331271bace68e97$var$ue(k);
                        u = null == n ? h : $0331271bace68e97$var$ue(n);
                        h = new t(F, w + "leave", k, c, _$e);
                        h.target = J;
                        h.relatedTarget = u;
                        F = null;
                        $0331271bace68e97$var$Wc(_$e) === _$d && (t = new t(x, w + "enter", n, c, _$e), t.target = u, t.relatedTarget = J, F = t);
                        J = F;
                        if (k && n) b: {
                            t = k;
                            x = n;
                            w = 0;
                            for(u = t; u; u = $0331271bace68e97$var$vf(u))w++;
                            u = 0;
                            for(F = x; F; F = $0331271bace68e97$var$vf(F))u++;
                            for(; 0 < w - u;)t = $0331271bace68e97$var$vf(t), w--;
                            for(; 0 < u - w;)x = $0331271bace68e97$var$vf(x), u--;
                            for(; w--;){
                                if (t === x || null !== x && t === x.alternate) break b;
                                t = $0331271bace68e97$var$vf(t);
                                x = $0331271bace68e97$var$vf(x);
                            }
                            t = null;
                        }
                        else t = null;
                        null !== k && $0331271bace68e97$var$wf(g, h, k, t, !1);
                        null !== n && null !== J && $0331271bace68e97$var$wf(g, J, n, t, !0);
                    }
                }
            }
            a: {
                h = _$d ? $0331271bace68e97$var$ue(_$d) : window;
                k = h.nodeName && h.nodeName.toLowerCase();
                if ("select" === k || "input" === k && "file" === h.type) var na = $0331271bace68e97$var$ve;
                else if ($0331271bace68e97$var$me(h)) {
                    if ($0331271bace68e97$var$we) na = $0331271bace68e97$var$Fe;
                    else {
                        na = $0331271bace68e97$var$De;
                        var xa = $0331271bace68e97$var$Ce;
                    }
                } else (k = h.nodeName) && "input" === k.toLowerCase() && ("checkbox" === h.type || "radio" === h.type) && (na = $0331271bace68e97$var$Ee);
                if (na && (na = na(a, _$d))) {
                    $0331271bace68e97$var$ne(g, na, c, _$e);
                    break a;
                }
                xa && xa(a, h, _$d);
                "focusout" === a && (xa = h._wrapperState) && xa.controlled && "number" === h.type && $0331271bace68e97$var$cb(h, "number", h.value);
            }
            xa = _$d ? $0331271bace68e97$var$ue(_$d) : window;
            switch(a){
                case "focusin":
                    if ($0331271bace68e97$var$me(xa) || "true" === xa.contentEditable) $0331271bace68e97$var$Qe = xa, $0331271bace68e97$var$Re = _$d, $0331271bace68e97$var$Se = null;
                    break;
                case "focusout":
                    $0331271bace68e97$var$Se = $0331271bace68e97$var$Re = $0331271bace68e97$var$Qe = null;
                    break;
                case "mousedown":
                    $0331271bace68e97$var$Te = !0;
                    break;
                case "contextmenu":
                case "mouseup":
                case "dragend":
                    $0331271bace68e97$var$Te = !1;
                    $0331271bace68e97$var$Ue(g, c, _$e);
                    break;
                case "selectionchange":
                    if ($0331271bace68e97$var$Pe) break;
                case "keydown":
                case "keyup":
                    $0331271bace68e97$var$Ue(g, c, _$e);
            }
            var $a;
            if ($0331271bace68e97$var$ae) b: {
                switch(a){
                    case "compositionstart":
                        var ba = "onCompositionStart";
                        break b;
                    case "compositionend":
                        ba = "onCompositionEnd";
                        break b;
                    case "compositionupdate":
                        ba = "onCompositionUpdate";
                        break b;
                }
                ba = void 0;
            }
            else $0331271bace68e97$var$ie ? $0331271bace68e97$var$ge(a, c) && (ba = "onCompositionEnd") : "keydown" === a && 229 === c.keyCode && (ba = "onCompositionStart");
            ba && ($0331271bace68e97$var$de && "ko" !== c.locale && ($0331271bace68e97$var$ie || "onCompositionStart" !== ba ? "onCompositionEnd" === ba && $0331271bace68e97$var$ie && ($a = $0331271bace68e97$var$nd()) : ($0331271bace68e97$var$kd = _$e, $0331271bace68e97$var$ld = "value" in $0331271bace68e97$var$kd ? $0331271bace68e97$var$kd.value : $0331271bace68e97$var$kd.textContent, $0331271bace68e97$var$ie = !0)), xa = $0331271bace68e97$var$oe(_$d, ba), 0 < xa.length && (ba = new $0331271bace68e97$var$Ld(ba, a, null, c, _$e), g.push({
                event: ba,
                listeners: xa
            }), $a ? ba.data = $a : ($a = $0331271bace68e97$var$he(c), null !== $a && (ba.data = $a))));
            if ($a = $0331271bace68e97$var$ce ? $0331271bace68e97$var$je(a, c) : $0331271bace68e97$var$ke(a, c)) _$d = $0331271bace68e97$var$oe(_$d, "onBeforeInput"), 0 < _$d.length && (_$e = new $0331271bace68e97$var$Ld("onBeforeInput", "beforeinput", null, c, _$e), g.push({
                event: _$e,
                listeners: _$d
            }), _$e.data = $a);
        }
        $0331271bace68e97$var$se(g, b);
    });
}
function $0331271bace68e97$var$tf(a, b, c) {
    return {
        instance: a,
        listener: b,
        currentTarget: c
    };
}
function $0331271bace68e97$var$oe(a, b) {
    for(var c = b + "Capture", d = []; null !== a;){
        var e = a, f = e.stateNode;
        5 === e.tag && null !== f && (e = f, f = $0331271bace68e97$var$Kb(a, c), null != f && d.unshift($0331271bace68e97$var$tf(a, f, e)), f = $0331271bace68e97$var$Kb(a, b), null != f && d.push($0331271bace68e97$var$tf(a, f, e)));
        a = a.return;
    }
    return d;
}
function $0331271bace68e97$var$vf(a) {
    if (null === a) return null;
    do a = a.return;
    while (a && 5 !== a.tag);
    return a ? a : null;
}
function $0331271bace68e97$var$wf(a, b, c, d, e) {
    for(var f = b._reactName, g = []; null !== c && c !== d;){
        var h = c, k = h.alternate, l = h.stateNode;
        if (null !== k && k === d) break;
        5 === h.tag && null !== l && (h = l, e ? (k = $0331271bace68e97$var$Kb(c, f), null != k && g.unshift($0331271bace68e97$var$tf(c, k, h))) : e || (k = $0331271bace68e97$var$Kb(c, f), null != k && g.push($0331271bace68e97$var$tf(c, k, h))));
        c = c.return;
    }
    0 !== g.length && a.push({
        event: b,
        listeners: g
    });
}
var $0331271bace68e97$var$xf = /\r\n?/g, $0331271bace68e97$var$yf = /\u0000|\uFFFD/g;
function $0331271bace68e97$var$zf(a) {
    return ("string" === typeof a ? a : "" + a).replace($0331271bace68e97$var$xf, "\n").replace($0331271bace68e97$var$yf, "");
}
function $0331271bace68e97$var$Af(a, b, c) {
    b = $0331271bace68e97$var$zf(b);
    if ($0331271bace68e97$var$zf(a) !== b && c) throw Error($0331271bace68e97$var$p(425));
}
function $0331271bace68e97$var$Bf() {}
var $0331271bace68e97$var$Cf = null, $0331271bace68e97$var$Df = null;
function $0331271bace68e97$var$Ef(a, b) {
    return "textarea" === a || "noscript" === a || "string" === typeof b.children || "number" === typeof b.children || "object" === (0, $bJtXW._)(b.dangerouslySetInnerHTML) && null !== b.dangerouslySetInnerHTML && null != b.dangerouslySetInnerHTML.__html;
}
var $0331271bace68e97$var$Ff = "function" === typeof setTimeout ? setTimeout : void 0, $0331271bace68e97$var$Gf = "function" === typeof clearTimeout ? clearTimeout : void 0, $0331271bace68e97$var$Hf = "function" === typeof Promise ? Promise : void 0, $0331271bace68e97$var$Jf = "function" === typeof queueMicrotask ? queueMicrotask : "undefined" !== typeof $0331271bace68e97$var$Hf ? function Jf(a) {
    return $0331271bace68e97$var$Hf.resolve(null).then(a).catch($0331271bace68e97$var$If);
} : $0331271bace68e97$var$Ff;
function $0331271bace68e97$var$If(a) {
    setTimeout(function() {
        throw a;
    });
}
function $0331271bace68e97$var$Kf(a, b) {
    var c = b, d = 0;
    do {
        var e = c.nextSibling;
        a.removeChild(c);
        if (e && 8 === e.nodeType) {
            if (c = e.data, "/$" === c) {
                if (0 === d) {
                    a.removeChild(e);
                    $0331271bace68e97$var$bd(b);
                    return;
                }
                d--;
            } else "$" !== c && "$?" !== c && "$!" !== c || d++;
        }
        c = e;
    }while (c);
    $0331271bace68e97$var$bd(b);
}
function $0331271bace68e97$var$Lf(a) {
    for(; null != a; a = a.nextSibling){
        var b = a.nodeType;
        if (1 === b || 3 === b) break;
        if (8 === b) {
            b = a.data;
            if ("$" === b || "$!" === b || "$?" === b) break;
            if ("/$" === b) return null;
        }
    }
    return a;
}
function $0331271bace68e97$var$Mf(a) {
    a = a.previousSibling;
    for(var b = 0; a;){
        if (8 === a.nodeType) {
            var c = a.data;
            if ("$" === c || "$!" === c || "$?" === c) {
                if (0 === b) return a;
                b--;
            } else "/$" === c && b++;
        }
        a = a.previousSibling;
    }
    return null;
}
var $0331271bace68e97$var$Nf = Math.random().toString(36).slice(2), $0331271bace68e97$var$Of = "__reactFiber$" + $0331271bace68e97$var$Nf, $0331271bace68e97$var$Pf = "__reactProps$" + $0331271bace68e97$var$Nf, $0331271bace68e97$var$uf = "__reactContainer$" + $0331271bace68e97$var$Nf, $0331271bace68e97$var$of = "__reactEvents$" + $0331271bace68e97$var$Nf, $0331271bace68e97$var$Qf = "__reactListeners$" + $0331271bace68e97$var$Nf, $0331271bace68e97$var$Rf = "__reactHandles$" + $0331271bace68e97$var$Nf;
function $0331271bace68e97$var$Wc(a) {
    var b = a[$0331271bace68e97$var$Of];
    if (b) return b;
    for(var c = a.parentNode; c;){
        if (b = c[$0331271bace68e97$var$uf] || c[$0331271bace68e97$var$Of]) {
            c = b.alternate;
            if (null !== b.child || null !== c && null !== c.child) for(a = $0331271bace68e97$var$Mf(a); null !== a;){
                if (c = a[$0331271bace68e97$var$Of]) return c;
                a = $0331271bace68e97$var$Mf(a);
            }
            return b;
        }
        a = c;
        c = a.parentNode;
    }
    return null;
}
function $0331271bace68e97$var$Cb(a) {
    a = a[$0331271bace68e97$var$Of] || a[$0331271bace68e97$var$uf];
    return !a || 5 !== a.tag && 6 !== a.tag && 13 !== a.tag && 3 !== a.tag ? null : a;
}
function $0331271bace68e97$var$ue(a) {
    if (5 === a.tag || 6 === a.tag) return a.stateNode;
    throw Error($0331271bace68e97$var$p(33));
}
function $0331271bace68e97$var$Db(a) {
    return a[$0331271bace68e97$var$Pf] || null;
}
var $0331271bace68e97$var$Sf = [], $0331271bace68e97$var$Tf = -1;
function $0331271bace68e97$var$Uf(a) {
    return {
        current: a
    };
}
function $0331271bace68e97$var$E(a) {
    0 > $0331271bace68e97$var$Tf || (a.current = $0331271bace68e97$var$Sf[$0331271bace68e97$var$Tf], $0331271bace68e97$var$Sf[$0331271bace68e97$var$Tf] = null, $0331271bace68e97$var$Tf--);
}
function $0331271bace68e97$var$G(a, b) {
    $0331271bace68e97$var$Tf++;
    $0331271bace68e97$var$Sf[$0331271bace68e97$var$Tf] = a.current;
    a.current = b;
}
var $0331271bace68e97$var$Vf = {}, $0331271bace68e97$var$H = $0331271bace68e97$var$Uf($0331271bace68e97$var$Vf), $0331271bace68e97$var$Wf = $0331271bace68e97$var$Uf(!1), $0331271bace68e97$var$Xf = $0331271bace68e97$var$Vf;
function $0331271bace68e97$var$Yf(a, b) {
    var c = a.type.contextTypes;
    if (!c) return $0331271bace68e97$var$Vf;
    var d = a.stateNode;
    if (d && d.__reactInternalMemoizedUnmaskedChildContext === b) return d.__reactInternalMemoizedMaskedChildContext;
    var e = {}, f;
    for(f in c)e[f] = b[f];
    d && (a = a.stateNode, a.__reactInternalMemoizedUnmaskedChildContext = b, a.__reactInternalMemoizedMaskedChildContext = e);
    return e;
}
function $0331271bace68e97$var$Zf(a) {
    a = a.childContextTypes;
    return null !== a && void 0 !== a;
}
function $0331271bace68e97$var$$f() {
    $0331271bace68e97$var$E($0331271bace68e97$var$Wf);
    $0331271bace68e97$var$E($0331271bace68e97$var$H);
}
function $0331271bace68e97$var$ag(a, b, c) {
    if ($0331271bace68e97$var$H.current !== $0331271bace68e97$var$Vf) throw Error($0331271bace68e97$var$p(168));
    $0331271bace68e97$var$G($0331271bace68e97$var$H, b);
    $0331271bace68e97$var$G($0331271bace68e97$var$Wf, c);
}
function $0331271bace68e97$var$bg(a, b, c) {
    var d = a.stateNode;
    b = b.childContextTypes;
    if ("function" !== typeof d.getChildContext) return c;
    d = d.getChildContext();
    for(var e in d)if (!(e in b)) throw Error($0331271bace68e97$var$p(108, $0331271bace68e97$var$Ra(a) || "Unknown", e));
    return $0331271bace68e97$var$A({}, c, d);
}
function $0331271bace68e97$var$cg(a) {
    a = (a = a.stateNode) && a.__reactInternalMemoizedMergedChildContext || $0331271bace68e97$var$Vf;
    $0331271bace68e97$var$Xf = $0331271bace68e97$var$H.current;
    $0331271bace68e97$var$G($0331271bace68e97$var$H, a);
    $0331271bace68e97$var$G($0331271bace68e97$var$Wf, $0331271bace68e97$var$Wf.current);
    return !0;
}
function $0331271bace68e97$var$dg(a, b, c) {
    var d = a.stateNode;
    if (!d) throw Error($0331271bace68e97$var$p(169));
    c ? (a = $0331271bace68e97$var$bg(a, b, $0331271bace68e97$var$Xf), d.__reactInternalMemoizedMergedChildContext = a, $0331271bace68e97$var$E($0331271bace68e97$var$Wf), $0331271bace68e97$var$E($0331271bace68e97$var$H), $0331271bace68e97$var$G($0331271bace68e97$var$H, a)) : $0331271bace68e97$var$E($0331271bace68e97$var$Wf);
    $0331271bace68e97$var$G($0331271bace68e97$var$Wf, c);
}
var $0331271bace68e97$var$eg = null, $0331271bace68e97$var$fg = !1, $0331271bace68e97$var$gg = !1;
function $0331271bace68e97$var$hg(a) {
    null === $0331271bace68e97$var$eg ? $0331271bace68e97$var$eg = [
        a
    ] : $0331271bace68e97$var$eg.push(a);
}
function $0331271bace68e97$var$ig(a) {
    $0331271bace68e97$var$fg = !0;
    $0331271bace68e97$var$hg(a);
}
function $0331271bace68e97$var$jg() {
    if (!$0331271bace68e97$var$gg && null !== $0331271bace68e97$var$eg) {
        $0331271bace68e97$var$gg = !0;
        var a = 0, b = $0331271bace68e97$var$C;
        try {
            var c = $0331271bace68e97$var$eg;
            for($0331271bace68e97$var$C = 1; a < c.length; a++){
                var d = c[a];
                do d = d(!0);
                while (null !== d);
            }
            $0331271bace68e97$var$eg = null;
            $0331271bace68e97$var$fg = !1;
        } catch (e) {
            throw null !== $0331271bace68e97$var$eg && ($0331271bace68e97$var$eg = $0331271bace68e97$var$eg.slice(a + 1)), $0331271bace68e97$var$ac($0331271bace68e97$var$fc, $0331271bace68e97$var$jg), e;
        } finally{
            $0331271bace68e97$var$C = b, $0331271bace68e97$var$gg = !1;
        }
    }
    return null;
}
var $0331271bace68e97$var$kg = [], $0331271bace68e97$var$lg = 0, $0331271bace68e97$var$mg = null, $0331271bace68e97$var$ng = 0, $0331271bace68e97$var$og = [], $0331271bace68e97$var$pg = 0, $0331271bace68e97$var$qg = null, $0331271bace68e97$var$rg = 1, $0331271bace68e97$var$sg = "";
function $0331271bace68e97$var$tg(a, b) {
    $0331271bace68e97$var$kg[$0331271bace68e97$var$lg++] = $0331271bace68e97$var$ng;
    $0331271bace68e97$var$kg[$0331271bace68e97$var$lg++] = $0331271bace68e97$var$mg;
    $0331271bace68e97$var$mg = a;
    $0331271bace68e97$var$ng = b;
}
function $0331271bace68e97$var$ug(a, b, c) {
    $0331271bace68e97$var$og[$0331271bace68e97$var$pg++] = $0331271bace68e97$var$rg;
    $0331271bace68e97$var$og[$0331271bace68e97$var$pg++] = $0331271bace68e97$var$sg;
    $0331271bace68e97$var$og[$0331271bace68e97$var$pg++] = $0331271bace68e97$var$qg;
    $0331271bace68e97$var$qg = a;
    var d = $0331271bace68e97$var$rg;
    a = $0331271bace68e97$var$sg;
    var e = 32 - $0331271bace68e97$var$oc(d) - 1;
    d &= ~(1 << e);
    c += 1;
    var f = 32 - $0331271bace68e97$var$oc(b) + e;
    if (30 < f) {
        var g = e - e % 5;
        f = (d & (1 << g) - 1).toString(32);
        d >>= g;
        e -= g;
        $0331271bace68e97$var$rg = 1 << 32 - $0331271bace68e97$var$oc(b) + e | c << e | d;
        $0331271bace68e97$var$sg = f + a;
    } else $0331271bace68e97$var$rg = 1 << f | c << e | d, $0331271bace68e97$var$sg = a;
}
function $0331271bace68e97$var$vg(a) {
    null !== a.return && ($0331271bace68e97$var$tg(a, 1), $0331271bace68e97$var$ug(a, 1, 0));
}
function $0331271bace68e97$var$wg(a) {
    for(; a === $0331271bace68e97$var$mg;)$0331271bace68e97$var$mg = $0331271bace68e97$var$kg[--$0331271bace68e97$var$lg], $0331271bace68e97$var$kg[$0331271bace68e97$var$lg] = null, $0331271bace68e97$var$ng = $0331271bace68e97$var$kg[--$0331271bace68e97$var$lg], $0331271bace68e97$var$kg[$0331271bace68e97$var$lg] = null;
    for(; a === $0331271bace68e97$var$qg;)$0331271bace68e97$var$qg = $0331271bace68e97$var$og[--$0331271bace68e97$var$pg], $0331271bace68e97$var$og[$0331271bace68e97$var$pg] = null, $0331271bace68e97$var$sg = $0331271bace68e97$var$og[--$0331271bace68e97$var$pg], $0331271bace68e97$var$og[$0331271bace68e97$var$pg] = null, $0331271bace68e97$var$rg = $0331271bace68e97$var$og[--$0331271bace68e97$var$pg], $0331271bace68e97$var$og[$0331271bace68e97$var$pg] = null;
}
var $0331271bace68e97$var$xg = null, $0331271bace68e97$var$yg = null, $0331271bace68e97$var$I = !1, $0331271bace68e97$var$zg = null;
function $0331271bace68e97$var$Ag(a, b) {
    var c = $0331271bace68e97$var$Bg(5, null, null, 0);
    c.elementType = "DELETED";
    c.stateNode = b;
    c.return = a;
    b = a.deletions;
    null === b ? (a.deletions = [
        c
    ], a.flags |= 16) : b.push(c);
}
function $0331271bace68e97$var$Cg(a, b) {
    switch(a.tag){
        case 5:
            var c = a.type;
            b = 1 !== b.nodeType || c.toLowerCase() !== b.nodeName.toLowerCase() ? null : b;
            return null !== b ? (a.stateNode = b, $0331271bace68e97$var$xg = a, $0331271bace68e97$var$yg = $0331271bace68e97$var$Lf(b.firstChild), !0) : !1;
        case 6:
            return b = "" === a.pendingProps || 3 !== b.nodeType ? null : b, null !== b ? (a.stateNode = b, $0331271bace68e97$var$xg = a, $0331271bace68e97$var$yg = null, !0) : !1;
        case 13:
            return b = 8 !== b.nodeType ? null : b, null !== b ? (c = null !== $0331271bace68e97$var$qg ? {
                id: $0331271bace68e97$var$rg,
                overflow: $0331271bace68e97$var$sg
            } : null, a.memoizedState = {
                dehydrated: b,
                treeContext: c,
                retryLane: 1073741824
            }, c = $0331271bace68e97$var$Bg(18, null, null, 0), c.stateNode = b, c.return = a, a.child = c, $0331271bace68e97$var$xg = a, $0331271bace68e97$var$yg = null, !0) : !1;
        default:
            return !1;
    }
}
function $0331271bace68e97$var$Dg(a) {
    return 0 !== (a.mode & 1) && 0 === (a.flags & 128);
}
function $0331271bace68e97$var$Eg(a) {
    if ($0331271bace68e97$var$I) {
        var b = $0331271bace68e97$var$yg;
        if (b) {
            var c = b;
            if (!$0331271bace68e97$var$Cg(a, b)) {
                if ($0331271bace68e97$var$Dg(a)) throw Error($0331271bace68e97$var$p(418));
                b = $0331271bace68e97$var$Lf(c.nextSibling);
                var d = $0331271bace68e97$var$xg;
                b && $0331271bace68e97$var$Cg(a, b) ? $0331271bace68e97$var$Ag(d, c) : (a.flags = a.flags & -4097 | 2, $0331271bace68e97$var$I = !1, $0331271bace68e97$var$xg = a);
            }
        } else {
            if ($0331271bace68e97$var$Dg(a)) throw Error($0331271bace68e97$var$p(418));
            a.flags = a.flags & -4097 | 2;
            $0331271bace68e97$var$I = !1;
            $0331271bace68e97$var$xg = a;
        }
    }
}
function $0331271bace68e97$var$Fg(a) {
    for(a = a.return; null !== a && 5 !== a.tag && 3 !== a.tag && 13 !== a.tag;)a = a.return;
    $0331271bace68e97$var$xg = a;
}
function $0331271bace68e97$var$Gg(a) {
    if (a !== $0331271bace68e97$var$xg) return !1;
    if (!$0331271bace68e97$var$I) return $0331271bace68e97$var$Fg(a), $0331271bace68e97$var$I = !0, !1;
    var b;
    (b = 3 !== a.tag) && !(b = 5 !== a.tag) && (b = a.type, b = "head" !== b && "body" !== b && !$0331271bace68e97$var$Ef(a.type, a.memoizedProps));
    if (b && (b = $0331271bace68e97$var$yg)) {
        if ($0331271bace68e97$var$Dg(a)) throw $0331271bace68e97$var$Hg(), Error($0331271bace68e97$var$p(418));
        for(; b;)$0331271bace68e97$var$Ag(a, b), b = $0331271bace68e97$var$Lf(b.nextSibling);
    }
    $0331271bace68e97$var$Fg(a);
    if (13 === a.tag) {
        a = a.memoizedState;
        a = null !== a ? a.dehydrated : null;
        if (!a) throw Error($0331271bace68e97$var$p(317));
        a: {
            a = a.nextSibling;
            for(b = 0; a;){
                if (8 === a.nodeType) {
                    var c = a.data;
                    if ("/$" === c) {
                        if (0 === b) {
                            $0331271bace68e97$var$yg = $0331271bace68e97$var$Lf(a.nextSibling);
                            break a;
                        }
                        b--;
                    } else "$" !== c && "$!" !== c && "$?" !== c || b++;
                }
                a = a.nextSibling;
            }
            $0331271bace68e97$var$yg = null;
        }
    } else $0331271bace68e97$var$yg = $0331271bace68e97$var$xg ? $0331271bace68e97$var$Lf(a.stateNode.nextSibling) : null;
    return !0;
}
function $0331271bace68e97$var$Hg() {
    for(var a = $0331271bace68e97$var$yg; a;)a = $0331271bace68e97$var$Lf(a.nextSibling);
}
function $0331271bace68e97$var$Ig() {
    $0331271bace68e97$var$yg = $0331271bace68e97$var$xg = null;
    $0331271bace68e97$var$I = !1;
}
function $0331271bace68e97$var$Jg(a) {
    null === $0331271bace68e97$var$zg ? $0331271bace68e97$var$zg = [
        a
    ] : $0331271bace68e97$var$zg.push(a);
}
var $0331271bace68e97$var$Kg = $0331271bace68e97$var$ua.ReactCurrentBatchConfig;
function $0331271bace68e97$var$Lg(a, b, c) {
    a = c.ref;
    if (null !== a && "function" !== typeof a && "object" !== (typeof a === "undefined" ? "undefined" : (0, $bJtXW._)(a))) {
        if (c._owner) {
            c = c._owner;
            if (c) {
                if (1 !== c.tag) throw Error($0331271bace68e97$var$p(309));
                var d = c.stateNode;
            }
            if (!d) throw Error($0331271bace68e97$var$p(147, a));
            var e = d, f = "" + a;
            if (null !== b && null !== b.ref && "function" === typeof b.ref && b.ref._stringRef === f) return b.ref;
            b = function b(a) {
                var _$b = e.refs;
                null === a ? delete _$b[f] : _$b[f] = a;
            };
            b._stringRef = f;
            return b;
        }
        if ("string" !== typeof a) throw Error($0331271bace68e97$var$p(284));
        if (!c._owner) throw Error($0331271bace68e97$var$p(290, a));
    }
    return a;
}
function $0331271bace68e97$var$Mg(a, b) {
    a = Object.prototype.toString.call(b);
    throw Error($0331271bace68e97$var$p(31, "[object Object]" === a ? "object with keys {" + Object.keys(b).join(", ") + "}" : a));
}
function $0331271bace68e97$var$Ng(a) {
    var b = a._init;
    return b(a._payload);
}
function $0331271bace68e97$var$Og(a) {
    function b(b, c) {
        if (a) {
            var d = b.deletions;
            null === d ? (b.deletions = [
                c
            ], b.flags |= 16) : d.push(c);
        }
    }
    function c(c, d) {
        if (!a) return null;
        for(; null !== d;)b(c, d), d = d.sibling;
        return null;
    }
    function d(a, b) {
        for(a = new Map; null !== b;)null !== b.key ? a.set(b.key, b) : a.set(b.index, b), b = b.sibling;
        return a;
    }
    function e(a, b) {
        a = $0331271bace68e97$var$Pg(a, b);
        a.index = 0;
        a.sibling = null;
        return a;
    }
    function f(b, c, d) {
        b.index = d;
        if (!a) return b.flags |= 1048576, c;
        d = b.alternate;
        if (null !== d) return d = d.index, d < c ? (b.flags |= 2, c) : d;
        b.flags |= 2;
        return c;
    }
    function g(b) {
        a && null === b.alternate && (b.flags |= 2);
        return b;
    }
    function h(a, b, c, d) {
        if (null === b || 6 !== b.tag) return b = $0331271bace68e97$var$Qg(c, a.mode, d), b.return = a, b;
        b = e(b, c);
        b.return = a;
        return b;
    }
    function k(a, b, c, d) {
        var f = c.type;
        if (f === $0331271bace68e97$var$ya) return m(a, b, c.props.children, d, c.key);
        if (null !== b && (b.elementType === f || "object" === (typeof f === "undefined" ? "undefined" : (0, $bJtXW._)(f)) && null !== f && f.$$typeof === $0331271bace68e97$var$Ha && $0331271bace68e97$var$Ng(f) === b.type)) return d = e(b, c.props), d.ref = $0331271bace68e97$var$Lg(a, b, c), d.return = a, d;
        d = $0331271bace68e97$var$Rg(c.type, c.key, c.props, null, a.mode, d);
        d.ref = $0331271bace68e97$var$Lg(a, b, c);
        d.return = a;
        return d;
    }
    function l(a, b, c, d) {
        if (null === b || 4 !== b.tag || b.stateNode.containerInfo !== c.containerInfo || b.stateNode.implementation !== c.implementation) return b = $0331271bace68e97$var$Sg(c, a.mode, d), b.return = a, b;
        b = e(b, c.children || []);
        b.return = a;
        return b;
    }
    function m(a, b, c, d, f) {
        if (null === b || 7 !== b.tag) return b = $0331271bace68e97$var$Tg(c, a.mode, d, f), b.return = a, b;
        b = e(b, c);
        b.return = a;
        return b;
    }
    function q(a, b, c) {
        if ("string" === typeof b && "" !== b || "number" === typeof b) return b = $0331271bace68e97$var$Qg("" + b, a.mode, c), b.return = a, b;
        if ("object" === (typeof b === "undefined" ? "undefined" : (0, $bJtXW._)(b)) && null !== b) {
            switch(b.$$typeof){
                case $0331271bace68e97$var$va:
                    return c = $0331271bace68e97$var$Rg(b.type, b.key, b.props, null, a.mode, c), c.ref = $0331271bace68e97$var$Lg(a, null, b), c.return = a, c;
                case $0331271bace68e97$var$wa:
                    return b = $0331271bace68e97$var$Sg(b, a.mode, c), b.return = a, b;
                case $0331271bace68e97$var$Ha:
                    var d = b._init;
                    return q(a, d(b._payload), c);
            }
            if ($0331271bace68e97$var$eb(b) || $0331271bace68e97$var$Ka(b)) return b = $0331271bace68e97$var$Tg(b, a.mode, c, null), b.return = a, b;
            $0331271bace68e97$var$Mg(a, b);
        }
        return null;
    }
    function r(a, b, c, d) {
        var e = null !== b ? b.key : null;
        if ("string" === typeof c && "" !== c || "number" === typeof c) return null !== e ? null : h(a, b, "" + c, d);
        if ("object" === (typeof c === "undefined" ? "undefined" : (0, $bJtXW._)(c)) && null !== c) {
            switch(c.$$typeof){
                case $0331271bace68e97$var$va:
                    return c.key === e ? k(a, b, c, d) : null;
                case $0331271bace68e97$var$wa:
                    return c.key === e ? l(a, b, c, d) : null;
                case $0331271bace68e97$var$Ha:
                    return e = c._init, r(a, b, e(c._payload), d);
            }
            if ($0331271bace68e97$var$eb(c) || $0331271bace68e97$var$Ka(c)) return null !== e ? null : m(a, b, c, d, null);
            $0331271bace68e97$var$Mg(a, c);
        }
        return null;
    }
    function y(a, b, c, d, e) {
        if ("string" === typeof d && "" !== d || "number" === typeof d) return a = a.get(c) || null, h(b, a, "" + d, e);
        if ("object" === (typeof d === "undefined" ? "undefined" : (0, $bJtXW._)(d)) && null !== d) {
            switch(d.$$typeof){
                case $0331271bace68e97$var$va:
                    return a = a.get(null === d.key ? c : d.key) || null, k(b, a, d, e);
                case $0331271bace68e97$var$wa:
                    return a = a.get(null === d.key ? c : d.key) || null, l(b, a, d, e);
                case $0331271bace68e97$var$Ha:
                    var f = d._init;
                    return y(a, b, c, f(d._payload), e);
            }
            if ($0331271bace68e97$var$eb(d) || $0331271bace68e97$var$Ka(d)) return a = a.get(c) || null, m(b, a, d, e, null);
            $0331271bace68e97$var$Mg(b, d);
        }
        return null;
    }
    function n(e, g, h, k) {
        for(var l = null, m = null, u = g, w = g = 0, x = null; null !== u && w < h.length; w++){
            u.index > w ? (x = u, u = null) : x = u.sibling;
            var n = r(e, u, h[w], k);
            if (null === n) {
                null === u && (u = x);
                break;
            }
            a && u && null === n.alternate && b(e, u);
            g = f(n, g, w);
            null === m ? l = n : m.sibling = n;
            m = n;
            u = x;
        }
        if (w === h.length) return c(e, u), $0331271bace68e97$var$I && $0331271bace68e97$var$tg(e, w), l;
        if (null === u) {
            for(; w < h.length; w++)u = q(e, h[w], k), null !== u && (g = f(u, g, w), null === m ? l = u : m.sibling = u, m = u);
            $0331271bace68e97$var$I && $0331271bace68e97$var$tg(e, w);
            return l;
        }
        for(u = d(e, u); w < h.length; w++)x = y(u, e, w, h[w], k), null !== x && (a && null !== x.alternate && u.delete(null === x.key ? w : x.key), g = f(x, g, w), null === m ? l = x : m.sibling = x, m = x);
        a && u.forEach(function(a) {
            return b(e, a);
        });
        $0331271bace68e97$var$I && $0331271bace68e97$var$tg(e, w);
        return l;
    }
    function t(e, g, h, k) {
        var l = $0331271bace68e97$var$Ka(h);
        if ("function" !== typeof l) throw Error($0331271bace68e97$var$p(150));
        h = l.call(h);
        if (null == h) throw Error($0331271bace68e97$var$p(151));
        for(var u = l = null, m = g, w = g = 0, x = null, n = h.next(); null !== m && !n.done; w++, n = h.next()){
            m.index > w ? (x = m, m = null) : x = m.sibling;
            var t = r(e, m, n.value, k);
            if (null === t) {
                null === m && (m = x);
                break;
            }
            a && m && null === t.alternate && b(e, m);
            g = f(t, g, w);
            null === u ? l = t : u.sibling = t;
            u = t;
            m = x;
        }
        if (n.done) return c(e, m), $0331271bace68e97$var$I && $0331271bace68e97$var$tg(e, w), l;
        if (null === m) {
            for(; !n.done; w++, n = h.next())n = q(e, n.value, k), null !== n && (g = f(n, g, w), null === u ? l = n : u.sibling = n, u = n);
            $0331271bace68e97$var$I && $0331271bace68e97$var$tg(e, w);
            return l;
        }
        for(m = d(e, m); !n.done; w++, n = h.next())n = y(m, e, w, n.value, k), null !== n && (a && null !== n.alternate && m.delete(null === n.key ? w : n.key), g = f(n, g, w), null === u ? l = n : u.sibling = n, u = n);
        a && m.forEach(function(a) {
            return b(e, a);
        });
        $0331271bace68e97$var$I && $0331271bace68e97$var$tg(e, w);
        return l;
    }
    function J(a, d, f, h) {
        "object" === (typeof f === "undefined" ? "undefined" : (0, $bJtXW._)(f)) && null !== f && f.type === $0331271bace68e97$var$ya && null === f.key && (f = f.props.children);
        if ("object" === (typeof f === "undefined" ? "undefined" : (0, $bJtXW._)(f)) && null !== f) {
            switch(f.$$typeof){
                case $0331271bace68e97$var$va:
                    a: {
                        for(var k = f.key, l = d; null !== l;){
                            if (l.key === k) {
                                k = f.type;
                                if (k === $0331271bace68e97$var$ya) {
                                    if (7 === l.tag) {
                                        c(a, l.sibling);
                                        d = e(l, f.props.children);
                                        d.return = a;
                                        a = d;
                                        break a;
                                    }
                                } else if (l.elementType === k || "object" === (typeof k === "undefined" ? "undefined" : (0, $bJtXW._)(k)) && null !== k && k.$$typeof === $0331271bace68e97$var$Ha && $0331271bace68e97$var$Ng(k) === l.type) {
                                    c(a, l.sibling);
                                    d = e(l, f.props);
                                    d.ref = $0331271bace68e97$var$Lg(a, l, f);
                                    d.return = a;
                                    a = d;
                                    break a;
                                }
                                c(a, l);
                                break;
                            } else b(a, l);
                            l = l.sibling;
                        }
                        f.type === $0331271bace68e97$var$ya ? (d = $0331271bace68e97$var$Tg(f.props.children, a.mode, h, f.key), d.return = a, a = d) : (h = $0331271bace68e97$var$Rg(f.type, f.key, f.props, null, a.mode, h), h.ref = $0331271bace68e97$var$Lg(a, d, f), h.return = a, a = h);
                    }
                    return g(a);
                case $0331271bace68e97$var$wa:
                    a: {
                        for(l = f.key; null !== d;){
                            if (d.key === l) {
                                if (4 === d.tag && d.stateNode.containerInfo === f.containerInfo && d.stateNode.implementation === f.implementation) {
                                    c(a, d.sibling);
                                    d = e(d, f.children || []);
                                    d.return = a;
                                    a = d;
                                    break a;
                                } else {
                                    c(a, d);
                                    break;
                                }
                            } else b(a, d);
                            d = d.sibling;
                        }
                        d = $0331271bace68e97$var$Sg(f, a.mode, h);
                        d.return = a;
                        a = d;
                    }
                    return g(a);
                case $0331271bace68e97$var$Ha:
                    return l = f._init, J(a, d, l(f._payload), h);
            }
            if ($0331271bace68e97$var$eb(f)) return n(a, d, f, h);
            if ($0331271bace68e97$var$Ka(f)) return t(a, d, f, h);
            $0331271bace68e97$var$Mg(a, f);
        }
        return "string" === typeof f && "" !== f || "number" === typeof f ? (f = "" + f, null !== d && 6 === d.tag ? (c(a, d.sibling), d = e(d, f), d.return = a, a = d) : (c(a, d), d = $0331271bace68e97$var$Qg(f, a.mode, h), d.return = a, a = d), g(a)) : c(a, d);
    }
    return J;
}
var $0331271bace68e97$var$Ug = $0331271bace68e97$var$Og(!0), $0331271bace68e97$var$Vg = $0331271bace68e97$var$Og(!1), $0331271bace68e97$var$Wg = $0331271bace68e97$var$Uf(null), $0331271bace68e97$var$Xg = null, $0331271bace68e97$var$Yg = null, $0331271bace68e97$var$Zg = null;
function $0331271bace68e97$var$$g() {
    $0331271bace68e97$var$Zg = $0331271bace68e97$var$Yg = $0331271bace68e97$var$Xg = null;
}
function $0331271bace68e97$var$ah(a) {
    var b = $0331271bace68e97$var$Wg.current;
    $0331271bace68e97$var$E($0331271bace68e97$var$Wg);
    a._currentValue = b;
}
function $0331271bace68e97$var$bh(a, b, c) {
    for(; null !== a;){
        var d = a.alternate;
        (a.childLanes & b) !== b ? (a.childLanes |= b, null !== d && (d.childLanes |= b)) : null !== d && (d.childLanes & b) !== b && (d.childLanes |= b);
        if (a === c) break;
        a = a.return;
    }
}
function $0331271bace68e97$var$ch(a, b) {
    $0331271bace68e97$var$Xg = a;
    $0331271bace68e97$var$Zg = $0331271bace68e97$var$Yg = null;
    a = a.dependencies;
    null !== a && null !== a.firstContext && (0 !== (a.lanes & b) && ($0331271bace68e97$var$dh = !0), a.firstContext = null);
}
function $0331271bace68e97$var$eh(a) {
    var b = a._currentValue;
    if ($0331271bace68e97$var$Zg !== a) {
        if (a = {
            context: a,
            memoizedValue: b,
            next: null
        }, null === $0331271bace68e97$var$Yg) {
            if (null === $0331271bace68e97$var$Xg) throw Error($0331271bace68e97$var$p(308));
            $0331271bace68e97$var$Yg = a;
            $0331271bace68e97$var$Xg.dependencies = {
                lanes: 0,
                firstContext: a
            };
        } else $0331271bace68e97$var$Yg = $0331271bace68e97$var$Yg.next = a;
    }
    return b;
}
var $0331271bace68e97$var$fh = null;
function $0331271bace68e97$var$gh(a) {
    null === $0331271bace68e97$var$fh ? $0331271bace68e97$var$fh = [
        a
    ] : $0331271bace68e97$var$fh.push(a);
}
function $0331271bace68e97$var$hh(a, b, c, d) {
    var e = b.interleaved;
    null === e ? (c.next = c, $0331271bace68e97$var$gh(b)) : (c.next = e.next, e.next = c);
    b.interleaved = c;
    return $0331271bace68e97$var$ih(a, d);
}
function $0331271bace68e97$var$ih(a, b) {
    a.lanes |= b;
    var c = a.alternate;
    null !== c && (c.lanes |= b);
    c = a;
    for(a = a.return; null !== a;)a.childLanes |= b, c = a.alternate, null !== c && (c.childLanes |= b), c = a, a = a.return;
    return 3 === c.tag ? c.stateNode : null;
}
var $0331271bace68e97$var$jh = !1;
function $0331271bace68e97$var$kh(a) {
    a.updateQueue = {
        baseState: a.memoizedState,
        firstBaseUpdate: null,
        lastBaseUpdate: null,
        shared: {
            pending: null,
            interleaved: null,
            lanes: 0
        },
        effects: null
    };
}
function $0331271bace68e97$var$lh(a, b) {
    a = a.updateQueue;
    b.updateQueue === a && (b.updateQueue = {
        baseState: a.baseState,
        firstBaseUpdate: a.firstBaseUpdate,
        lastBaseUpdate: a.lastBaseUpdate,
        shared: a.shared,
        effects: a.effects
    });
}
function $0331271bace68e97$var$mh(a, b) {
    return {
        eventTime: a,
        lane: b,
        tag: 0,
        payload: null,
        callback: null,
        next: null
    };
}
function $0331271bace68e97$var$nh(a, b, c) {
    var d = a.updateQueue;
    if (null === d) return null;
    d = d.shared;
    if (0 !== ($0331271bace68e97$var$K & 2)) {
        var e = d.pending;
        null === e ? b.next = b : (b.next = e.next, e.next = b);
        d.pending = b;
        return $0331271bace68e97$var$ih(a, c);
    }
    e = d.interleaved;
    null === e ? (b.next = b, $0331271bace68e97$var$gh(d)) : (b.next = e.next, e.next = b);
    d.interleaved = b;
    return $0331271bace68e97$var$ih(a, c);
}
function $0331271bace68e97$var$oh(a, b, c) {
    b = b.updateQueue;
    if (null !== b && (b = b.shared, 0 !== (c & 4194240))) {
        var d = b.lanes;
        d &= a.pendingLanes;
        c |= d;
        b.lanes = c;
        $0331271bace68e97$var$Cc(a, c);
    }
}
function $0331271bace68e97$var$ph(a, b) {
    var c = a.updateQueue, d = a.alternate;
    if (null !== d && (d = d.updateQueue, c === d)) {
        var e = null, f = null;
        c = c.firstBaseUpdate;
        if (null !== c) {
            do {
                var g = {
                    eventTime: c.eventTime,
                    lane: c.lane,
                    tag: c.tag,
                    payload: c.payload,
                    callback: c.callback,
                    next: null
                };
                null === f ? e = f = g : f = f.next = g;
                c = c.next;
            }while (null !== c);
            null === f ? e = f = b : f = f.next = b;
        } else e = f = b;
        c = {
            baseState: d.baseState,
            firstBaseUpdate: e,
            lastBaseUpdate: f,
            shared: d.shared,
            effects: d.effects
        };
        a.updateQueue = c;
        return;
    }
    a = c.lastBaseUpdate;
    null === a ? c.firstBaseUpdate = b : a.next = b;
    c.lastBaseUpdate = b;
}
function $0331271bace68e97$var$qh(a, b, c, d) {
    var e = a.updateQueue;
    $0331271bace68e97$var$jh = !1;
    var f = e.firstBaseUpdate, g = e.lastBaseUpdate, h = e.shared.pending;
    if (null !== h) {
        e.shared.pending = null;
        var k = h, l = k.next;
        k.next = null;
        null === g ? f = l : g.next = l;
        g = k;
        var m = a.alternate;
        null !== m && (m = m.updateQueue, h = m.lastBaseUpdate, h !== g && (null === h ? m.firstBaseUpdate = l : h.next = l, m.lastBaseUpdate = k));
    }
    if (null !== f) {
        var q = e.baseState;
        g = 0;
        m = l = k = null;
        h = f;
        do {
            var r = h.lane, y = h.eventTime;
            if ((d & r) === r) {
                null !== m && (m = m.next = {
                    eventTime: y,
                    lane: 0,
                    tag: h.tag,
                    payload: h.payload,
                    callback: h.callback,
                    next: null
                });
                a: {
                    var n = a, t = h;
                    r = b;
                    y = c;
                    switch(t.tag){
                        case 1:
                            n = t.payload;
                            if ("function" === typeof n) {
                                q = n.call(y, q, r);
                                break a;
                            }
                            q = n;
                            break a;
                        case 3:
                            n.flags = n.flags & -65537 | 128;
                        case 0:
                            n = t.payload;
                            r = "function" === typeof n ? n.call(y, q, r) : n;
                            if (null === r || void 0 === r) break a;
                            q = $0331271bace68e97$var$A({}, q, r);
                            break a;
                        case 2:
                            $0331271bace68e97$var$jh = !0;
                    }
                }
                null !== h.callback && 0 !== h.lane && (a.flags |= 64, r = e.effects, null === r ? e.effects = [
                    h
                ] : r.push(h));
            } else y = {
                eventTime: y,
                lane: r,
                tag: h.tag,
                payload: h.payload,
                callback: h.callback,
                next: null
            }, null === m ? (l = m = y, k = q) : m = m.next = y, g |= r;
            h = h.next;
            if (null === h) {
                if (h = e.shared.pending, null === h) break;
                else r = h, h = r.next, r.next = null, e.lastBaseUpdate = r, e.shared.pending = null;
            }
        }while (1);
        null === m && (k = q);
        e.baseState = k;
        e.firstBaseUpdate = l;
        e.lastBaseUpdate = m;
        b = e.shared.interleaved;
        if (null !== b) {
            e = b;
            do g |= e.lane, e = e.next;
            while (e !== b);
        } else null === f && (e.shared.lanes = 0);
        $0331271bace68e97$var$rh |= g;
        a.lanes = g;
        a.memoizedState = q;
    }
}
function $0331271bace68e97$var$sh(a, b, c) {
    a = b.effects;
    b.effects = null;
    if (null !== a) for(b = 0; b < a.length; b++){
        var d = a[b], e = d.callback;
        if (null !== e) {
            d.callback = null;
            d = c;
            if ("function" !== typeof e) throw Error($0331271bace68e97$var$p(191, e));
            e.call(d);
        }
    }
}
var $0331271bace68e97$var$th = {}, $0331271bace68e97$var$uh = $0331271bace68e97$var$Uf($0331271bace68e97$var$th), $0331271bace68e97$var$vh = $0331271bace68e97$var$Uf($0331271bace68e97$var$th), $0331271bace68e97$var$wh = $0331271bace68e97$var$Uf($0331271bace68e97$var$th);
function $0331271bace68e97$var$xh(a) {
    if (a === $0331271bace68e97$var$th) throw Error($0331271bace68e97$var$p(174));
    return a;
}
function $0331271bace68e97$var$yh(a, b) {
    $0331271bace68e97$var$G($0331271bace68e97$var$wh, b);
    $0331271bace68e97$var$G($0331271bace68e97$var$vh, a);
    $0331271bace68e97$var$G($0331271bace68e97$var$uh, $0331271bace68e97$var$th);
    a = b.nodeType;
    switch(a){
        case 9:
        case 11:
            b = (b = b.documentElement) ? b.namespaceURI : $0331271bace68e97$var$lb(null, "");
            break;
        default:
            a = 8 === a ? b.parentNode : b, b = a.namespaceURI || null, a = a.tagName, b = $0331271bace68e97$var$lb(b, a);
    }
    $0331271bace68e97$var$E($0331271bace68e97$var$uh);
    $0331271bace68e97$var$G($0331271bace68e97$var$uh, b);
}
function $0331271bace68e97$var$zh() {
    $0331271bace68e97$var$E($0331271bace68e97$var$uh);
    $0331271bace68e97$var$E($0331271bace68e97$var$vh);
    $0331271bace68e97$var$E($0331271bace68e97$var$wh);
}
function $0331271bace68e97$var$Ah(a) {
    $0331271bace68e97$var$xh($0331271bace68e97$var$wh.current);
    var b = $0331271bace68e97$var$xh($0331271bace68e97$var$uh.current);
    var c = $0331271bace68e97$var$lb(b, a.type);
    b !== c && ($0331271bace68e97$var$G($0331271bace68e97$var$vh, a), $0331271bace68e97$var$G($0331271bace68e97$var$uh, c));
}
function $0331271bace68e97$var$Bh(a) {
    $0331271bace68e97$var$vh.current === a && ($0331271bace68e97$var$E($0331271bace68e97$var$uh), $0331271bace68e97$var$E($0331271bace68e97$var$vh));
}
var $0331271bace68e97$var$L = $0331271bace68e97$var$Uf(0);
function $0331271bace68e97$var$Ch(a) {
    for(var b = a; null !== b;){
        if (13 === b.tag) {
            var c = b.memoizedState;
            if (null !== c && (c = c.dehydrated, null === c || "$?" === c.data || "$!" === c.data)) return b;
        } else if (19 === b.tag && void 0 !== b.memoizedProps.revealOrder) {
            if (0 !== (b.flags & 128)) return b;
        } else if (null !== b.child) {
            b.child.return = b;
            b = b.child;
            continue;
        }
        if (b === a) break;
        for(; null === b.sibling;){
            if (null === b.return || b.return === a) return null;
            b = b.return;
        }
        b.sibling.return = b.return;
        b = b.sibling;
    }
    return null;
}
var $0331271bace68e97$var$Dh = [];
function $0331271bace68e97$var$Eh() {
    for(var a = 0; a < $0331271bace68e97$var$Dh.length; a++)$0331271bace68e97$var$Dh[a]._workInProgressVersionPrimary = null;
    $0331271bace68e97$var$Dh.length = 0;
}
var $0331271bace68e97$var$Fh = $0331271bace68e97$var$ua.ReactCurrentDispatcher, $0331271bace68e97$var$Gh = $0331271bace68e97$var$ua.ReactCurrentBatchConfig, $0331271bace68e97$var$Hh = 0, $0331271bace68e97$var$M = null, $0331271bace68e97$var$N = null, $0331271bace68e97$var$O = null, $0331271bace68e97$var$Ih = !1, $0331271bace68e97$var$Jh = !1, $0331271bace68e97$var$Kh = 0, $0331271bace68e97$var$Lh = 0;
function $0331271bace68e97$var$P() {
    throw Error($0331271bace68e97$var$p(321));
}
function $0331271bace68e97$var$Mh(a, b) {
    if (null === b) return !1;
    for(var c = 0; c < b.length && c < a.length; c++)if (!$0331271bace68e97$var$He(a[c], b[c])) return !1;
    return !0;
}
function $0331271bace68e97$var$Nh(a, b, c, d, e, f) {
    $0331271bace68e97$var$Hh = f;
    $0331271bace68e97$var$M = b;
    b.memoizedState = null;
    b.updateQueue = null;
    b.lanes = 0;
    $0331271bace68e97$var$Fh.current = null === a || null === a.memoizedState ? $0331271bace68e97$var$Oh : $0331271bace68e97$var$Ph;
    a = c(d, e);
    if ($0331271bace68e97$var$Jh) {
        f = 0;
        do {
            $0331271bace68e97$var$Jh = !1;
            $0331271bace68e97$var$Kh = 0;
            if (25 <= f) throw Error($0331271bace68e97$var$p(301));
            f += 1;
            $0331271bace68e97$var$O = $0331271bace68e97$var$N = null;
            b.updateQueue = null;
            $0331271bace68e97$var$Fh.current = $0331271bace68e97$var$Qh;
            a = c(d, e);
        }while ($0331271bace68e97$var$Jh);
    }
    $0331271bace68e97$var$Fh.current = $0331271bace68e97$var$Rh;
    b = null !== $0331271bace68e97$var$N && null !== $0331271bace68e97$var$N.next;
    $0331271bace68e97$var$Hh = 0;
    $0331271bace68e97$var$O = $0331271bace68e97$var$N = $0331271bace68e97$var$M = null;
    $0331271bace68e97$var$Ih = !1;
    if (b) throw Error($0331271bace68e97$var$p(300));
    return a;
}
function $0331271bace68e97$var$Sh() {
    var a = 0 !== $0331271bace68e97$var$Kh;
    $0331271bace68e97$var$Kh = 0;
    return a;
}
function $0331271bace68e97$var$Th() {
    var a = {
        memoizedState: null,
        baseState: null,
        baseQueue: null,
        queue: null,
        next: null
    };
    null === $0331271bace68e97$var$O ? $0331271bace68e97$var$M.memoizedState = $0331271bace68e97$var$O = a : $0331271bace68e97$var$O = $0331271bace68e97$var$O.next = a;
    return $0331271bace68e97$var$O;
}
function $0331271bace68e97$var$Uh() {
    if (null === $0331271bace68e97$var$N) {
        var a = $0331271bace68e97$var$M.alternate;
        a = null !== a ? a.memoizedState : null;
    } else a = $0331271bace68e97$var$N.next;
    var b = null === $0331271bace68e97$var$O ? $0331271bace68e97$var$M.memoizedState : $0331271bace68e97$var$O.next;
    if (null !== b) $0331271bace68e97$var$O = b, $0331271bace68e97$var$N = a;
    else {
        if (null === a) throw Error($0331271bace68e97$var$p(310));
        $0331271bace68e97$var$N = a;
        a = {
            memoizedState: $0331271bace68e97$var$N.memoizedState,
            baseState: $0331271bace68e97$var$N.baseState,
            baseQueue: $0331271bace68e97$var$N.baseQueue,
            queue: $0331271bace68e97$var$N.queue,
            next: null
        };
        null === $0331271bace68e97$var$O ? $0331271bace68e97$var$M.memoizedState = $0331271bace68e97$var$O = a : $0331271bace68e97$var$O = $0331271bace68e97$var$O.next = a;
    }
    return $0331271bace68e97$var$O;
}
function $0331271bace68e97$var$Vh(a, b) {
    return "function" === typeof b ? b(a) : b;
}
function $0331271bace68e97$var$Wh(a) {
    var b = $0331271bace68e97$var$Uh(), c = b.queue;
    if (null === c) throw Error($0331271bace68e97$var$p(311));
    c.lastRenderedReducer = a;
    var d = $0331271bace68e97$var$N, e = d.baseQueue, f = c.pending;
    if (null !== f) {
        if (null !== e) {
            var g = e.next;
            e.next = f.next;
            f.next = g;
        }
        d.baseQueue = e = f;
        c.pending = null;
    }
    if (null !== e) {
        f = e.next;
        d = d.baseState;
        var h = g = null, k = null, l = f;
        do {
            var m = l.lane;
            if (($0331271bace68e97$var$Hh & m) === m) null !== k && (k = k.next = {
                lane: 0,
                action: l.action,
                hasEagerState: l.hasEagerState,
                eagerState: l.eagerState,
                next: null
            }), d = l.hasEagerState ? l.eagerState : a(d, l.action);
            else {
                var q = {
                    lane: m,
                    action: l.action,
                    hasEagerState: l.hasEagerState,
                    eagerState: l.eagerState,
                    next: null
                };
                null === k ? (h = k = q, g = d) : k = k.next = q;
                $0331271bace68e97$var$M.lanes |= m;
                $0331271bace68e97$var$rh |= m;
            }
            l = l.next;
        }while (null !== l && l !== f);
        null === k ? g = d : k.next = h;
        $0331271bace68e97$var$He(d, b.memoizedState) || ($0331271bace68e97$var$dh = !0);
        b.memoizedState = d;
        b.baseState = g;
        b.baseQueue = k;
        c.lastRenderedState = d;
    }
    a = c.interleaved;
    if (null !== a) {
        e = a;
        do f = e.lane, $0331271bace68e97$var$M.lanes |= f, $0331271bace68e97$var$rh |= f, e = e.next;
        while (e !== a);
    } else null === e && (c.lanes = 0);
    return [
        b.memoizedState,
        c.dispatch
    ];
}
function $0331271bace68e97$var$Xh(a) {
    var b = $0331271bace68e97$var$Uh(), c = b.queue;
    if (null === c) throw Error($0331271bace68e97$var$p(311));
    c.lastRenderedReducer = a;
    var d = c.dispatch, e = c.pending, f = b.memoizedState;
    if (null !== e) {
        c.pending = null;
        var g = e = e.next;
        do f = a(f, g.action), g = g.next;
        while (g !== e);
        $0331271bace68e97$var$He(f, b.memoizedState) || ($0331271bace68e97$var$dh = !0);
        b.memoizedState = f;
        null === b.baseQueue && (b.baseState = f);
        c.lastRenderedState = f;
    }
    return [
        f,
        d
    ];
}
function $0331271bace68e97$var$Yh() {}
function $0331271bace68e97$var$Zh(a, b) {
    var c = $0331271bace68e97$var$M, d = $0331271bace68e97$var$Uh(), e = b(), f = !$0331271bace68e97$var$He(d.memoizedState, e);
    f && (d.memoizedState = e, $0331271bace68e97$var$dh = !0);
    d = d.queue;
    $0331271bace68e97$var$$h($0331271bace68e97$var$ai.bind(null, c, d, a), [
        a
    ]);
    if (d.getSnapshot !== b || f || null !== $0331271bace68e97$var$O && $0331271bace68e97$var$O.memoizedState.tag & 1) {
        c.flags |= 2048;
        $0331271bace68e97$var$bi(9, $0331271bace68e97$var$ci.bind(null, c, d, e, b), void 0, null);
        if (null === $0331271bace68e97$var$Q) throw Error($0331271bace68e97$var$p(349));
        0 !== ($0331271bace68e97$var$Hh & 30) || $0331271bace68e97$var$di(c, b, e);
    }
    return e;
}
function $0331271bace68e97$var$di(a, b, c) {
    a.flags |= 16384;
    a = {
        getSnapshot: b,
        value: c
    };
    b = $0331271bace68e97$var$M.updateQueue;
    null === b ? (b = {
        lastEffect: null,
        stores: null
    }, $0331271bace68e97$var$M.updateQueue = b, b.stores = [
        a
    ]) : (c = b.stores, null === c ? b.stores = [
        a
    ] : c.push(a));
}
function $0331271bace68e97$var$ci(a, b, c, d) {
    b.value = c;
    b.getSnapshot = d;
    $0331271bace68e97$var$ei(b) && $0331271bace68e97$var$fi(a);
}
function $0331271bace68e97$var$ai(a, b, c) {
    return c(function() {
        $0331271bace68e97$var$ei(b) && $0331271bace68e97$var$fi(a);
    });
}
function $0331271bace68e97$var$ei(a) {
    var b = a.getSnapshot;
    a = a.value;
    try {
        var c = b();
        return !$0331271bace68e97$var$He(a, c);
    } catch (d) {
        return !0;
    }
}
function $0331271bace68e97$var$fi(a) {
    var b = $0331271bace68e97$var$ih(a, 1);
    null !== b && $0331271bace68e97$var$gi(b, a, 1, -1);
}
function $0331271bace68e97$var$hi(a) {
    var b = $0331271bace68e97$var$Th();
    "function" === typeof a && (a = a());
    b.memoizedState = b.baseState = a;
    a = {
        pending: null,
        interleaved: null,
        lanes: 0,
        dispatch: null,
        lastRenderedReducer: $0331271bace68e97$var$Vh,
        lastRenderedState: a
    };
    b.queue = a;
    a = a.dispatch = $0331271bace68e97$var$ii.bind(null, $0331271bace68e97$var$M, a);
    return [
        b.memoizedState,
        a
    ];
}
function $0331271bace68e97$var$bi(a, b, c, d) {
    a = {
        tag: a,
        create: b,
        destroy: c,
        deps: d,
        next: null
    };
    b = $0331271bace68e97$var$M.updateQueue;
    null === b ? (b = {
        lastEffect: null,
        stores: null
    }, $0331271bace68e97$var$M.updateQueue = b, b.lastEffect = a.next = a) : (c = b.lastEffect, null === c ? b.lastEffect = a.next = a : (d = c.next, c.next = a, a.next = d, b.lastEffect = a));
    return a;
}
function $0331271bace68e97$var$ji() {
    return $0331271bace68e97$var$Uh().memoizedState;
}
function $0331271bace68e97$var$ki(a, b, c, d) {
    var e = $0331271bace68e97$var$Th();
    $0331271bace68e97$var$M.flags |= a;
    e.memoizedState = $0331271bace68e97$var$bi(1 | b, c, void 0, void 0 === d ? null : d);
}
function $0331271bace68e97$var$li(a, b, c, d) {
    var e = $0331271bace68e97$var$Uh();
    d = void 0 === d ? null : d;
    var f = void 0;
    if (null !== $0331271bace68e97$var$N) {
        var g = $0331271bace68e97$var$N.memoizedState;
        f = g.destroy;
        if (null !== d && $0331271bace68e97$var$Mh(d, g.deps)) {
            e.memoizedState = $0331271bace68e97$var$bi(b, c, f, d);
            return;
        }
    }
    $0331271bace68e97$var$M.flags |= a;
    e.memoizedState = $0331271bace68e97$var$bi(1 | b, c, f, d);
}
function $0331271bace68e97$var$mi(a, b) {
    return $0331271bace68e97$var$ki(8390656, 8, a, b);
}
function $0331271bace68e97$var$$h(a, b) {
    return $0331271bace68e97$var$li(2048, 8, a, b);
}
function $0331271bace68e97$var$ni(a, b) {
    return $0331271bace68e97$var$li(4, 2, a, b);
}
function $0331271bace68e97$var$oi(a, b) {
    return $0331271bace68e97$var$li(4, 4, a, b);
}
function $0331271bace68e97$var$pi(a, b) {
    if ("function" === typeof b) return a = a(), b(a), function() {
        b(null);
    };
    if (null !== b && void 0 !== b) return a = a(), b.current = a, function() {
        b.current = null;
    };
}
function $0331271bace68e97$var$qi(a, b, c) {
    c = null !== c && void 0 !== c ? c.concat([
        a
    ]) : null;
    return $0331271bace68e97$var$li(4, 4, $0331271bace68e97$var$pi.bind(null, b, a), c);
}
function $0331271bace68e97$var$ri() {}
function $0331271bace68e97$var$si(a, b) {
    var c = $0331271bace68e97$var$Uh();
    b = void 0 === b ? null : b;
    var d = c.memoizedState;
    if (null !== d && null !== b && $0331271bace68e97$var$Mh(b, d[1])) return d[0];
    c.memoizedState = [
        a,
        b
    ];
    return a;
}
function $0331271bace68e97$var$ti(a, b) {
    var c = $0331271bace68e97$var$Uh();
    b = void 0 === b ? null : b;
    var d = c.memoizedState;
    if (null !== d && null !== b && $0331271bace68e97$var$Mh(b, d[1])) return d[0];
    a = a();
    c.memoizedState = [
        a,
        b
    ];
    return a;
}
function $0331271bace68e97$var$ui(a, b, c) {
    if (0 === ($0331271bace68e97$var$Hh & 21)) return a.baseState && (a.baseState = !1, $0331271bace68e97$var$dh = !0), a.memoizedState = c;
    $0331271bace68e97$var$He(c, b) || (c = $0331271bace68e97$var$yc(), $0331271bace68e97$var$M.lanes |= c, $0331271bace68e97$var$rh |= c, a.baseState = !0);
    return b;
}
function $0331271bace68e97$var$vi(a, b) {
    var c = $0331271bace68e97$var$C;
    $0331271bace68e97$var$C = 0 !== c && 4 > c ? c : 4;
    a(!0);
    var d = $0331271bace68e97$var$Gh.transition;
    $0331271bace68e97$var$Gh.transition = {};
    try {
        a(!1), b();
    } finally{
        $0331271bace68e97$var$C = c, $0331271bace68e97$var$Gh.transition = d;
    }
}
function $0331271bace68e97$var$wi() {
    return $0331271bace68e97$var$Uh().memoizedState;
}
function $0331271bace68e97$var$xi(a, b, c) {
    var d = $0331271bace68e97$var$yi(a);
    c = {
        lane: d,
        action: c,
        hasEagerState: !1,
        eagerState: null,
        next: null
    };
    if ($0331271bace68e97$var$zi(a)) $0331271bace68e97$var$Ai(b, c);
    else if (c = $0331271bace68e97$var$hh(a, b, c, d), null !== c) {
        var e = $0331271bace68e97$var$R();
        $0331271bace68e97$var$gi(c, a, d, e);
        $0331271bace68e97$var$Bi(c, b, d);
    }
}
function $0331271bace68e97$var$ii(a, b, c) {
    var d = $0331271bace68e97$var$yi(a), e = {
        lane: d,
        action: c,
        hasEagerState: !1,
        eagerState: null,
        next: null
    };
    if ($0331271bace68e97$var$zi(a)) $0331271bace68e97$var$Ai(b, e);
    else {
        var f = a.alternate;
        if (0 === a.lanes && (null === f || 0 === f.lanes) && (f = b.lastRenderedReducer, null !== f)) try {
            var g = b.lastRenderedState, h = f(g, c);
            e.hasEagerState = !0;
            e.eagerState = h;
            if ($0331271bace68e97$var$He(h, g)) {
                var k = b.interleaved;
                null === k ? (e.next = e, $0331271bace68e97$var$gh(b)) : (e.next = k.next, k.next = e);
                b.interleaved = e;
                return;
            }
        } catch (l) {} finally{}
        c = $0331271bace68e97$var$hh(a, b, e, d);
        null !== c && (e = $0331271bace68e97$var$R(), $0331271bace68e97$var$gi(c, a, d, e), $0331271bace68e97$var$Bi(c, b, d));
    }
}
function $0331271bace68e97$var$zi(a) {
    var b = a.alternate;
    return a === $0331271bace68e97$var$M || null !== b && b === $0331271bace68e97$var$M;
}
function $0331271bace68e97$var$Ai(a, b) {
    $0331271bace68e97$var$Jh = $0331271bace68e97$var$Ih = !0;
    var c = a.pending;
    null === c ? b.next = b : (b.next = c.next, c.next = b);
    a.pending = b;
}
function $0331271bace68e97$var$Bi(a, b, c) {
    if (0 !== (c & 4194240)) {
        var d = b.lanes;
        d &= a.pendingLanes;
        c |= d;
        b.lanes = c;
        $0331271bace68e97$var$Cc(a, c);
    }
}
var $0331271bace68e97$var$Rh = {
    readContext: $0331271bace68e97$var$eh,
    useCallback: $0331271bace68e97$var$P,
    useContext: $0331271bace68e97$var$P,
    useEffect: $0331271bace68e97$var$P,
    useImperativeHandle: $0331271bace68e97$var$P,
    useInsertionEffect: $0331271bace68e97$var$P,
    useLayoutEffect: $0331271bace68e97$var$P,
    useMemo: $0331271bace68e97$var$P,
    useReducer: $0331271bace68e97$var$P,
    useRef: $0331271bace68e97$var$P,
    useState: $0331271bace68e97$var$P,
    useDebugValue: $0331271bace68e97$var$P,
    useDeferredValue: $0331271bace68e97$var$P,
    useTransition: $0331271bace68e97$var$P,
    useMutableSource: $0331271bace68e97$var$P,
    useSyncExternalStore: $0331271bace68e97$var$P,
    useId: $0331271bace68e97$var$P,
    unstable_isNewReconciler: !1
}, $0331271bace68e97$var$Oh = {
    readContext: $0331271bace68e97$var$eh,
    useCallback: function useCallback(a, b) {
        $0331271bace68e97$var$Th().memoizedState = [
            a,
            void 0 === b ? null : b
        ];
        return a;
    },
    useContext: $0331271bace68e97$var$eh,
    useEffect: $0331271bace68e97$var$mi,
    useImperativeHandle: function useImperativeHandle(a, b, c) {
        c = null !== c && void 0 !== c ? c.concat([
            a
        ]) : null;
        return $0331271bace68e97$var$ki(4194308, 4, $0331271bace68e97$var$pi.bind(null, b, a), c);
    },
    useLayoutEffect: function useLayoutEffect(a, b) {
        return $0331271bace68e97$var$ki(4194308, 4, a, b);
    },
    useInsertionEffect: function useInsertionEffect(a, b) {
        return $0331271bace68e97$var$ki(4, 2, a, b);
    },
    useMemo: function useMemo(a, b) {
        var c = $0331271bace68e97$var$Th();
        b = void 0 === b ? null : b;
        a = a();
        c.memoizedState = [
            a,
            b
        ];
        return a;
    },
    useReducer: function useReducer(a, b, c) {
        var d = $0331271bace68e97$var$Th();
        b = void 0 !== c ? c(b) : b;
        d.memoizedState = d.baseState = b;
        a = {
            pending: null,
            interleaved: null,
            lanes: 0,
            dispatch: null,
            lastRenderedReducer: a,
            lastRenderedState: b
        };
        d.queue = a;
        a = a.dispatch = $0331271bace68e97$var$xi.bind(null, $0331271bace68e97$var$M, a);
        return [
            d.memoizedState,
            a
        ];
    },
    useRef: function useRef(a) {
        var b = $0331271bace68e97$var$Th();
        a = {
            current: a
        };
        return b.memoizedState = a;
    },
    useState: $0331271bace68e97$var$hi,
    useDebugValue: $0331271bace68e97$var$ri,
    useDeferredValue: function useDeferredValue(a) {
        return $0331271bace68e97$var$Th().memoizedState = a;
    },
    useTransition: function useTransition() {
        var a = $0331271bace68e97$var$hi(!1), b = a[0];
        a = $0331271bace68e97$var$vi.bind(null, a[1]);
        $0331271bace68e97$var$Th().memoizedState = a;
        return [
            b,
            a
        ];
    },
    useMutableSource: function useMutableSource() {},
    useSyncExternalStore: function useSyncExternalStore(a, b, c) {
        var d = $0331271bace68e97$var$M, e = $0331271bace68e97$var$Th();
        if ($0331271bace68e97$var$I) {
            if (void 0 === c) throw Error($0331271bace68e97$var$p(407));
            c = c();
        } else {
            c = b();
            if (null === $0331271bace68e97$var$Q) throw Error($0331271bace68e97$var$p(349));
            0 !== ($0331271bace68e97$var$Hh & 30) || $0331271bace68e97$var$di(d, b, c);
        }
        e.memoizedState = c;
        var f = {
            value: c,
            getSnapshot: b
        };
        e.queue = f;
        $0331271bace68e97$var$mi($0331271bace68e97$var$ai.bind(null, d, f, a), [
            a
        ]);
        d.flags |= 2048;
        $0331271bace68e97$var$bi(9, $0331271bace68e97$var$ci.bind(null, d, f, c, b), void 0, null);
        return c;
    },
    useId: function useId() {
        var a = $0331271bace68e97$var$Th(), b = $0331271bace68e97$var$Q.identifierPrefix;
        if ($0331271bace68e97$var$I) {
            var c = $0331271bace68e97$var$sg;
            var d = $0331271bace68e97$var$rg;
            c = (d & ~(1 << 32 - $0331271bace68e97$var$oc(d) - 1)).toString(32) + c;
            b = ":" + b + "R" + c;
            c = $0331271bace68e97$var$Kh++;
            0 < c && (b += "H" + c.toString(32));
            b += ":";
        } else c = $0331271bace68e97$var$Lh++, b = ":" + b + "r" + c.toString(32) + ":";
        return a.memoizedState = b;
    },
    unstable_isNewReconciler: !1
}, $0331271bace68e97$var$Ph = {
    readContext: $0331271bace68e97$var$eh,
    useCallback: $0331271bace68e97$var$si,
    useContext: $0331271bace68e97$var$eh,
    useEffect: $0331271bace68e97$var$$h,
    useImperativeHandle: $0331271bace68e97$var$qi,
    useInsertionEffect: $0331271bace68e97$var$ni,
    useLayoutEffect: $0331271bace68e97$var$oi,
    useMemo: $0331271bace68e97$var$ti,
    useReducer: $0331271bace68e97$var$Wh,
    useRef: $0331271bace68e97$var$ji,
    useState: function useState() {
        return $0331271bace68e97$var$Wh($0331271bace68e97$var$Vh);
    },
    useDebugValue: $0331271bace68e97$var$ri,
    useDeferredValue: function useDeferredValue(a) {
        var b = $0331271bace68e97$var$Uh();
        return $0331271bace68e97$var$ui(b, $0331271bace68e97$var$N.memoizedState, a);
    },
    useTransition: function useTransition() {
        var a = $0331271bace68e97$var$Wh($0331271bace68e97$var$Vh)[0], b = $0331271bace68e97$var$Uh().memoizedState;
        return [
            a,
            b
        ];
    },
    useMutableSource: $0331271bace68e97$var$Yh,
    useSyncExternalStore: $0331271bace68e97$var$Zh,
    useId: $0331271bace68e97$var$wi,
    unstable_isNewReconciler: !1
}, $0331271bace68e97$var$Qh = {
    readContext: $0331271bace68e97$var$eh,
    useCallback: $0331271bace68e97$var$si,
    useContext: $0331271bace68e97$var$eh,
    useEffect: $0331271bace68e97$var$$h,
    useImperativeHandle: $0331271bace68e97$var$qi,
    useInsertionEffect: $0331271bace68e97$var$ni,
    useLayoutEffect: $0331271bace68e97$var$oi,
    useMemo: $0331271bace68e97$var$ti,
    useReducer: $0331271bace68e97$var$Xh,
    useRef: $0331271bace68e97$var$ji,
    useState: function useState() {
        return $0331271bace68e97$var$Xh($0331271bace68e97$var$Vh);
    },
    useDebugValue: $0331271bace68e97$var$ri,
    useDeferredValue: function useDeferredValue(a) {
        var b = $0331271bace68e97$var$Uh();
        return null === $0331271bace68e97$var$N ? b.memoizedState = a : $0331271bace68e97$var$ui(b, $0331271bace68e97$var$N.memoizedState, a);
    },
    useTransition: function useTransition() {
        var a = $0331271bace68e97$var$Xh($0331271bace68e97$var$Vh)[0], b = $0331271bace68e97$var$Uh().memoizedState;
        return [
            a,
            b
        ];
    },
    useMutableSource: $0331271bace68e97$var$Yh,
    useSyncExternalStore: $0331271bace68e97$var$Zh,
    useId: $0331271bace68e97$var$wi,
    unstable_isNewReconciler: !1
};
function $0331271bace68e97$var$Ci(a, b) {
    if (a && a.defaultProps) {
        b = $0331271bace68e97$var$A({}, b);
        a = a.defaultProps;
        for(var c in a)void 0 === b[c] && (b[c] = a[c]);
        return b;
    }
    return b;
}
function $0331271bace68e97$var$Di(a, b, c, d) {
    b = a.memoizedState;
    c = c(d, b);
    c = null === c || void 0 === c ? b : $0331271bace68e97$var$A({}, b, c);
    a.memoizedState = c;
    0 === a.lanes && (a.updateQueue.baseState = c);
}
var $0331271bace68e97$var$Ei = {
    isMounted: function isMounted(a) {
        return (a = a._reactInternals) ? $0331271bace68e97$var$Vb(a) === a : !1;
    },
    enqueueSetState: function enqueueSetState(a, b, c) {
        a = a._reactInternals;
        var d = $0331271bace68e97$var$R(), e = $0331271bace68e97$var$yi(a), f = $0331271bace68e97$var$mh(d, e);
        f.payload = b;
        void 0 !== c && null !== c && (f.callback = c);
        b = $0331271bace68e97$var$nh(a, f, e);
        null !== b && ($0331271bace68e97$var$gi(b, a, e, d), $0331271bace68e97$var$oh(b, a, e));
    },
    enqueueReplaceState: function enqueueReplaceState(a, b, c) {
        a = a._reactInternals;
        var d = $0331271bace68e97$var$R(), e = $0331271bace68e97$var$yi(a), f = $0331271bace68e97$var$mh(d, e);
        f.tag = 1;
        f.payload = b;
        void 0 !== c && null !== c && (f.callback = c);
        b = $0331271bace68e97$var$nh(a, f, e);
        null !== b && ($0331271bace68e97$var$gi(b, a, e, d), $0331271bace68e97$var$oh(b, a, e));
    },
    enqueueForceUpdate: function enqueueForceUpdate(a, b) {
        a = a._reactInternals;
        var c = $0331271bace68e97$var$R(), d = $0331271bace68e97$var$yi(a), e = $0331271bace68e97$var$mh(c, d);
        e.tag = 2;
        void 0 !== b && null !== b && (e.callback = b);
        b = $0331271bace68e97$var$nh(a, e, d);
        null !== b && ($0331271bace68e97$var$gi(b, a, d, c), $0331271bace68e97$var$oh(b, a, d));
    }
};
function $0331271bace68e97$var$Fi(a, b, c, d, e, f, g) {
    a = a.stateNode;
    return "function" === typeof a.shouldComponentUpdate ? a.shouldComponentUpdate(d, f, g) : b.prototype && b.prototype.isPureReactComponent ? !$0331271bace68e97$var$Ie(c, d) || !$0331271bace68e97$var$Ie(e, f) : !0;
}
function $0331271bace68e97$var$Gi(a, b, c) {
    var d = !1, e = $0331271bace68e97$var$Vf;
    var f = b.contextType;
    "object" === (typeof f === "undefined" ? "undefined" : (0, $bJtXW._)(f)) && null !== f ? f = $0331271bace68e97$var$eh(f) : (e = $0331271bace68e97$var$Zf(b) ? $0331271bace68e97$var$Xf : $0331271bace68e97$var$H.current, d = b.contextTypes, f = (d = null !== d && void 0 !== d) ? $0331271bace68e97$var$Yf(a, e) : $0331271bace68e97$var$Vf);
    b = new b(c, f);
    a.memoizedState = null !== b.state && void 0 !== b.state ? b.state : null;
    b.updater = $0331271bace68e97$var$Ei;
    a.stateNode = b;
    b._reactInternals = a;
    d && (a = a.stateNode, a.__reactInternalMemoizedUnmaskedChildContext = e, a.__reactInternalMemoizedMaskedChildContext = f);
    return b;
}
function $0331271bace68e97$var$Hi(a, b, c, d) {
    a = b.state;
    "function" === typeof b.componentWillReceiveProps && b.componentWillReceiveProps(c, d);
    "function" === typeof b.UNSAFE_componentWillReceiveProps && b.UNSAFE_componentWillReceiveProps(c, d);
    b.state !== a && $0331271bace68e97$var$Ei.enqueueReplaceState(b, b.state, null);
}
function $0331271bace68e97$var$Ii(a, b, c, d) {
    var e = a.stateNode;
    e.props = c;
    e.state = a.memoizedState;
    e.refs = {};
    $0331271bace68e97$var$kh(a);
    var f = b.contextType;
    "object" === (typeof f === "undefined" ? "undefined" : (0, $bJtXW._)(f)) && null !== f ? e.context = $0331271bace68e97$var$eh(f) : (f = $0331271bace68e97$var$Zf(b) ? $0331271bace68e97$var$Xf : $0331271bace68e97$var$H.current, e.context = $0331271bace68e97$var$Yf(a, f));
    e.state = a.memoizedState;
    f = b.getDerivedStateFromProps;
    "function" === typeof f && ($0331271bace68e97$var$Di(a, b, f, c), e.state = a.memoizedState);
    "function" === typeof b.getDerivedStateFromProps || "function" === typeof e.getSnapshotBeforeUpdate || "function" !== typeof e.UNSAFE_componentWillMount && "function" !== typeof e.componentWillMount || (b = e.state, "function" === typeof e.componentWillMount && e.componentWillMount(), "function" === typeof e.UNSAFE_componentWillMount && e.UNSAFE_componentWillMount(), b !== e.state && $0331271bace68e97$var$Ei.enqueueReplaceState(e, e.state, null), $0331271bace68e97$var$qh(a, c, e, d), e.state = a.memoizedState);
    "function" === typeof e.componentDidMount && (a.flags |= 4194308);
}
function $0331271bace68e97$var$Ji(a, b) {
    try {
        var c = "", d = b;
        do c += $0331271bace68e97$var$Pa(d), d = d.return;
        while (d);
        var e = c;
    } catch (f) {
        e = "\nError generating stack: " + f.message + "\n" + f.stack;
    }
    return {
        value: a,
        source: b,
        stack: e,
        digest: null
    };
}
function $0331271bace68e97$var$Ki(a, b, c) {
    return {
        value: a,
        source: null,
        stack: null != c ? c : null,
        digest: null != b ? b : null
    };
}
function $0331271bace68e97$var$Li(a, b) {
    try {
        console.error(b.value);
    } catch (c) {
        setTimeout(function() {
            throw c;
        });
    }
}
var $0331271bace68e97$var$Mi = "function" === typeof WeakMap ? WeakMap : Map;
function $0331271bace68e97$var$Ni(a, b, c) {
    c = $0331271bace68e97$var$mh(-1, c);
    c.tag = 3;
    c.payload = {
        element: null
    };
    var d = b.value;
    c.callback = function() {
        $0331271bace68e97$var$Oi || ($0331271bace68e97$var$Oi = !0, $0331271bace68e97$var$Pi = d);
        $0331271bace68e97$var$Li(a, b);
    };
    return c;
}
function $0331271bace68e97$var$Qi(a, b, c) {
    c = $0331271bace68e97$var$mh(-1, c);
    c.tag = 3;
    var d = a.type.getDerivedStateFromError;
    if ("function" === typeof d) {
        var e = b.value;
        c.payload = function() {
            return d(e);
        };
        c.callback = function() {
            $0331271bace68e97$var$Li(a, b);
        };
    }
    var f = a.stateNode;
    null !== f && "function" === typeof f.componentDidCatch && (c.callback = function() {
        $0331271bace68e97$var$Li(a, b);
        "function" !== typeof d && (null === $0331271bace68e97$var$Ri ? $0331271bace68e97$var$Ri = new Set([
            this
        ]) : $0331271bace68e97$var$Ri.add(this));
        var _$c = b.stack;
        this.componentDidCatch(b.value, {
            componentStack: null !== _$c ? _$c : ""
        });
    });
    return c;
}
function $0331271bace68e97$var$Si(a, b, c) {
    var d = a.pingCache;
    if (null === d) {
        d = a.pingCache = new $0331271bace68e97$var$Mi;
        var e = new Set;
        d.set(b, e);
    } else e = d.get(b), void 0 === e && (e = new Set, d.set(b, e));
    e.has(c) || (e.add(c), a = $0331271bace68e97$var$Ti.bind(null, a, b, c), b.then(a, a));
}
function $0331271bace68e97$var$Ui(a) {
    do {
        var b;
        if (b = 13 === a.tag) b = a.memoizedState, b = null !== b ? null !== b.dehydrated ? !0 : !1 : !0;
        if (b) return a;
        a = a.return;
    }while (null !== a);
    return null;
}
function $0331271bace68e97$var$Vi(a, b, c, d, e) {
    if (0 === (a.mode & 1)) return a === b ? a.flags |= 65536 : (a.flags |= 128, c.flags |= 131072, c.flags &= -52805, 1 === c.tag && (null === c.alternate ? c.tag = 17 : (b = $0331271bace68e97$var$mh(-1, 1), b.tag = 2, $0331271bace68e97$var$nh(c, b, 1))), c.lanes |= 1), a;
    a.flags |= 65536;
    a.lanes = e;
    return a;
}
var $0331271bace68e97$var$Wi = $0331271bace68e97$var$ua.ReactCurrentOwner, $0331271bace68e97$var$dh = !1;
function $0331271bace68e97$var$Xi(a, b, c, d) {
    b.child = null === a ? $0331271bace68e97$var$Vg(b, null, c, d) : $0331271bace68e97$var$Ug(b, a.child, c, d);
}
function $0331271bace68e97$var$Yi(a, b, c, d, e) {
    c = c.render;
    var f = b.ref;
    $0331271bace68e97$var$ch(b, e);
    d = $0331271bace68e97$var$Nh(a, b, c, d, f, e);
    c = $0331271bace68e97$var$Sh();
    if (null !== a && !$0331271bace68e97$var$dh) return b.updateQueue = a.updateQueue, b.flags &= -2053, a.lanes &= ~e, $0331271bace68e97$var$Zi(a, b, e);
    $0331271bace68e97$var$I && c && $0331271bace68e97$var$vg(b);
    b.flags |= 1;
    $0331271bace68e97$var$Xi(a, b, d, e);
    return b.child;
}
function $0331271bace68e97$var$$i(a, b, c, d, e) {
    if (null === a) {
        var f = c.type;
        if ("function" === typeof f && !$0331271bace68e97$var$aj(f) && void 0 === f.defaultProps && null === c.compare && void 0 === c.defaultProps) return b.tag = 15, b.type = f, $0331271bace68e97$var$bj(a, b, f, d, e);
        a = $0331271bace68e97$var$Rg(c.type, null, d, b, b.mode, e);
        a.ref = b.ref;
        a.return = b;
        return b.child = a;
    }
    f = a.child;
    if (0 === (a.lanes & e)) {
        var g = f.memoizedProps;
        c = c.compare;
        c = null !== c ? c : $0331271bace68e97$var$Ie;
        if (c(g, d) && a.ref === b.ref) return $0331271bace68e97$var$Zi(a, b, e);
    }
    b.flags |= 1;
    a = $0331271bace68e97$var$Pg(f, d);
    a.ref = b.ref;
    a.return = b;
    return b.child = a;
}
function $0331271bace68e97$var$bj(a, b, c, d, e) {
    if (null !== a) {
        var f = a.memoizedProps;
        if ($0331271bace68e97$var$Ie(f, d) && a.ref === b.ref) {
            if ($0331271bace68e97$var$dh = !1, b.pendingProps = d = f, 0 !== (a.lanes & e)) 0 !== (a.flags & 131072) && ($0331271bace68e97$var$dh = !0);
            else return b.lanes = a.lanes, $0331271bace68e97$var$Zi(a, b, e);
        }
    }
    return $0331271bace68e97$var$cj(a, b, c, d, e);
}
function $0331271bace68e97$var$dj(a, b, c) {
    var d = b.pendingProps, e = d.children, f = null !== a ? a.memoizedState : null;
    if ("hidden" === d.mode) {
        if (0 === (b.mode & 1)) b.memoizedState = {
            baseLanes: 0,
            cachePool: null,
            transitions: null
        }, $0331271bace68e97$var$G($0331271bace68e97$var$ej, $0331271bace68e97$var$fj), $0331271bace68e97$var$fj |= c;
        else {
            if (0 === (c & 1073741824)) return a = null !== f ? f.baseLanes | c : c, b.lanes = b.childLanes = 1073741824, b.memoizedState = {
                baseLanes: a,
                cachePool: null,
                transitions: null
            }, b.updateQueue = null, $0331271bace68e97$var$G($0331271bace68e97$var$ej, $0331271bace68e97$var$fj), $0331271bace68e97$var$fj |= a, null;
            b.memoizedState = {
                baseLanes: 0,
                cachePool: null,
                transitions: null
            };
            d = null !== f ? f.baseLanes : c;
            $0331271bace68e97$var$G($0331271bace68e97$var$ej, $0331271bace68e97$var$fj);
            $0331271bace68e97$var$fj |= d;
        }
    } else null !== f ? (d = f.baseLanes | c, b.memoizedState = null) : d = c, $0331271bace68e97$var$G($0331271bace68e97$var$ej, $0331271bace68e97$var$fj), $0331271bace68e97$var$fj |= d;
    $0331271bace68e97$var$Xi(a, b, e, c);
    return b.child;
}
function $0331271bace68e97$var$gj(a, b) {
    var c = b.ref;
    if (null === a && null !== c || null !== a && a.ref !== c) b.flags |= 512, b.flags |= 2097152;
}
function $0331271bace68e97$var$cj(a, b, c, d, e) {
    var f = $0331271bace68e97$var$Zf(c) ? $0331271bace68e97$var$Xf : $0331271bace68e97$var$H.current;
    f = $0331271bace68e97$var$Yf(b, f);
    $0331271bace68e97$var$ch(b, e);
    c = $0331271bace68e97$var$Nh(a, b, c, d, f, e);
    d = $0331271bace68e97$var$Sh();
    if (null !== a && !$0331271bace68e97$var$dh) return b.updateQueue = a.updateQueue, b.flags &= -2053, a.lanes &= ~e, $0331271bace68e97$var$Zi(a, b, e);
    $0331271bace68e97$var$I && d && $0331271bace68e97$var$vg(b);
    b.flags |= 1;
    $0331271bace68e97$var$Xi(a, b, c, e);
    return b.child;
}
function $0331271bace68e97$var$hj(a, b, c, d, e) {
    if ($0331271bace68e97$var$Zf(c)) {
        var f = !0;
        $0331271bace68e97$var$cg(b);
    } else f = !1;
    $0331271bace68e97$var$ch(b, e);
    if (null === b.stateNode) $0331271bace68e97$var$ij(a, b), $0331271bace68e97$var$Gi(b, c, d), $0331271bace68e97$var$Ii(b, c, d, e), d = !0;
    else if (null === a) {
        var g = b.stateNode, h = b.memoizedProps;
        g.props = h;
        var k = g.context, l = c.contextType;
        "object" === (typeof l === "undefined" ? "undefined" : (0, $bJtXW._)(l)) && null !== l ? l = $0331271bace68e97$var$eh(l) : (l = $0331271bace68e97$var$Zf(c) ? $0331271bace68e97$var$Xf : $0331271bace68e97$var$H.current, l = $0331271bace68e97$var$Yf(b, l));
        var m = c.getDerivedStateFromProps, q = "function" === typeof m || "function" === typeof g.getSnapshotBeforeUpdate;
        q || "function" !== typeof g.UNSAFE_componentWillReceiveProps && "function" !== typeof g.componentWillReceiveProps || (h !== d || k !== l) && $0331271bace68e97$var$Hi(b, g, d, l);
        $0331271bace68e97$var$jh = !1;
        var r = b.memoizedState;
        g.state = r;
        $0331271bace68e97$var$qh(b, d, g, e);
        k = b.memoizedState;
        h !== d || r !== k || $0331271bace68e97$var$Wf.current || $0331271bace68e97$var$jh ? ("function" === typeof m && ($0331271bace68e97$var$Di(b, c, m, d), k = b.memoizedState), (h = $0331271bace68e97$var$jh || $0331271bace68e97$var$Fi(b, c, h, d, r, k, l)) ? (q || "function" !== typeof g.UNSAFE_componentWillMount && "function" !== typeof g.componentWillMount || ("function" === typeof g.componentWillMount && g.componentWillMount(), "function" === typeof g.UNSAFE_componentWillMount && g.UNSAFE_componentWillMount()), "function" === typeof g.componentDidMount && (b.flags |= 4194308)) : ("function" === typeof g.componentDidMount && (b.flags |= 4194308), b.memoizedProps = d, b.memoizedState = k), g.props = d, g.state = k, g.context = l, d = h) : ("function" === typeof g.componentDidMount && (b.flags |= 4194308), d = !1);
    } else {
        g = b.stateNode;
        $0331271bace68e97$var$lh(a, b);
        h = b.memoizedProps;
        l = b.type === b.elementType ? h : $0331271bace68e97$var$Ci(b.type, h);
        g.props = l;
        q = b.pendingProps;
        r = g.context;
        k = c.contextType;
        "object" === (typeof k === "undefined" ? "undefined" : (0, $bJtXW._)(k)) && null !== k ? k = $0331271bace68e97$var$eh(k) : (k = $0331271bace68e97$var$Zf(c) ? $0331271bace68e97$var$Xf : $0331271bace68e97$var$H.current, k = $0331271bace68e97$var$Yf(b, k));
        var y = c.getDerivedStateFromProps;
        (m = "function" === typeof y || "function" === typeof g.getSnapshotBeforeUpdate) || "function" !== typeof g.UNSAFE_componentWillReceiveProps && "function" !== typeof g.componentWillReceiveProps || (h !== q || r !== k) && $0331271bace68e97$var$Hi(b, g, d, k);
        $0331271bace68e97$var$jh = !1;
        r = b.memoizedState;
        g.state = r;
        $0331271bace68e97$var$qh(b, d, g, e);
        var n = b.memoizedState;
        h !== q || r !== n || $0331271bace68e97$var$Wf.current || $0331271bace68e97$var$jh ? ("function" === typeof y && ($0331271bace68e97$var$Di(b, c, y, d), n = b.memoizedState), (l = $0331271bace68e97$var$jh || $0331271bace68e97$var$Fi(b, c, l, d, r, n, k) || !1) ? (m || "function" !== typeof g.UNSAFE_componentWillUpdate && "function" !== typeof g.componentWillUpdate || ("function" === typeof g.componentWillUpdate && g.componentWillUpdate(d, n, k), "function" === typeof g.UNSAFE_componentWillUpdate && g.UNSAFE_componentWillUpdate(d, n, k)), "function" === typeof g.componentDidUpdate && (b.flags |= 4), "function" === typeof g.getSnapshotBeforeUpdate && (b.flags |= 1024)) : ("function" !== typeof g.componentDidUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 4), "function" !== typeof g.getSnapshotBeforeUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 1024), b.memoizedProps = d, b.memoizedState = n), g.props = d, g.state = n, g.context = k, d = l) : ("function" !== typeof g.componentDidUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 4), "function" !== typeof g.getSnapshotBeforeUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 1024), d = !1);
    }
    return $0331271bace68e97$var$jj(a, b, c, d, f, e);
}
function $0331271bace68e97$var$jj(a, b, c, d, e, f) {
    $0331271bace68e97$var$gj(a, b);
    var g = 0 !== (b.flags & 128);
    if (!d && !g) return e && $0331271bace68e97$var$dg(b, c, !1), $0331271bace68e97$var$Zi(a, b, f);
    d = b.stateNode;
    $0331271bace68e97$var$Wi.current = b;
    var h = g && "function" !== typeof c.getDerivedStateFromError ? null : d.render();
    b.flags |= 1;
    null !== a && g ? (b.child = $0331271bace68e97$var$Ug(b, a.child, null, f), b.child = $0331271bace68e97$var$Ug(b, null, h, f)) : $0331271bace68e97$var$Xi(a, b, h, f);
    b.memoizedState = d.state;
    e && $0331271bace68e97$var$dg(b, c, !0);
    return b.child;
}
function $0331271bace68e97$var$kj(a) {
    var b = a.stateNode;
    b.pendingContext ? $0331271bace68e97$var$ag(a, b.pendingContext, b.pendingContext !== b.context) : b.context && $0331271bace68e97$var$ag(a, b.context, !1);
    $0331271bace68e97$var$yh(a, b.containerInfo);
}
function $0331271bace68e97$var$lj(a, b, c, d, e) {
    $0331271bace68e97$var$Ig();
    $0331271bace68e97$var$Jg(e);
    b.flags |= 256;
    $0331271bace68e97$var$Xi(a, b, c, d);
    return b.child;
}
var $0331271bace68e97$var$mj = {
    dehydrated: null,
    treeContext: null,
    retryLane: 0
};
function $0331271bace68e97$var$nj(a) {
    return {
        baseLanes: a,
        cachePool: null,
        transitions: null
    };
}
function $0331271bace68e97$var$oj(a, b, c) {
    var d = b.pendingProps, e = $0331271bace68e97$var$L.current, f = !1, g = 0 !== (b.flags & 128), h;
    (h = g) || (h = null !== a && null === a.memoizedState ? !1 : 0 !== (e & 2));
    if (h) f = !0, b.flags &= -129;
    else if (null === a || null !== a.memoizedState) e |= 1;
    $0331271bace68e97$var$G($0331271bace68e97$var$L, e & 1);
    if (null === a) {
        $0331271bace68e97$var$Eg(b);
        a = b.memoizedState;
        if (null !== a && (a = a.dehydrated, null !== a)) return 0 === (b.mode & 1) ? b.lanes = 1 : "$!" === a.data ? b.lanes = 8 : b.lanes = 1073741824, null;
        g = d.children;
        a = d.fallback;
        return f ? (d = b.mode, f = b.child, g = {
            mode: "hidden",
            children: g
        }, 0 === (d & 1) && null !== f ? (f.childLanes = 0, f.pendingProps = g) : f = $0331271bace68e97$var$pj(g, d, 0, null), a = $0331271bace68e97$var$Tg(a, d, c, null), f.return = b, a.return = b, f.sibling = a, b.child = f, b.child.memoizedState = $0331271bace68e97$var$nj(c), b.memoizedState = $0331271bace68e97$var$mj, a) : $0331271bace68e97$var$qj(b, g);
    }
    e = a.memoizedState;
    if (null !== e && (h = e.dehydrated, null !== h)) return $0331271bace68e97$var$rj(a, b, g, d, h, e, c);
    if (f) {
        f = d.fallback;
        g = b.mode;
        e = a.child;
        h = e.sibling;
        var k = {
            mode: "hidden",
            children: d.children
        };
        0 === (g & 1) && b.child !== e ? (d = b.child, d.childLanes = 0, d.pendingProps = k, b.deletions = null) : (d = $0331271bace68e97$var$Pg(e, k), d.subtreeFlags = e.subtreeFlags & 14680064);
        null !== h ? f = $0331271bace68e97$var$Pg(h, f) : (f = $0331271bace68e97$var$Tg(f, g, c, null), f.flags |= 2);
        f.return = b;
        d.return = b;
        d.sibling = f;
        b.child = d;
        d = f;
        f = b.child;
        g = a.child.memoizedState;
        g = null === g ? $0331271bace68e97$var$nj(c) : {
            baseLanes: g.baseLanes | c,
            cachePool: null,
            transitions: g.transitions
        };
        f.memoizedState = g;
        f.childLanes = a.childLanes & ~c;
        b.memoizedState = $0331271bace68e97$var$mj;
        return d;
    }
    f = a.child;
    a = f.sibling;
    d = $0331271bace68e97$var$Pg(f, {
        mode: "visible",
        children: d.children
    });
    0 === (b.mode & 1) && (d.lanes = c);
    d.return = b;
    d.sibling = null;
    null !== a && (c = b.deletions, null === c ? (b.deletions = [
        a
    ], b.flags |= 16) : c.push(a));
    b.child = d;
    b.memoizedState = null;
    return d;
}
function $0331271bace68e97$var$qj(a, b) {
    b = $0331271bace68e97$var$pj({
        mode: "visible",
        children: b
    }, a.mode, 0, null);
    b.return = a;
    return a.child = b;
}
function $0331271bace68e97$var$sj(a, b, c, d) {
    null !== d && $0331271bace68e97$var$Jg(d);
    $0331271bace68e97$var$Ug(b, a.child, null, c);
    a = $0331271bace68e97$var$qj(b, b.pendingProps.children);
    a.flags |= 2;
    b.memoizedState = null;
    return a;
}
function $0331271bace68e97$var$rj(a, b, c, d, e, f, g) {
    if (c) {
        if (b.flags & 256) return b.flags &= -257, d = $0331271bace68e97$var$Ki(Error($0331271bace68e97$var$p(422))), $0331271bace68e97$var$sj(a, b, g, d);
        if (null !== b.memoizedState) return b.child = a.child, b.flags |= 128, null;
        f = d.fallback;
        e = b.mode;
        d = $0331271bace68e97$var$pj({
            mode: "visible",
            children: d.children
        }, e, 0, null);
        f = $0331271bace68e97$var$Tg(f, e, g, null);
        f.flags |= 2;
        d.return = b;
        f.return = b;
        d.sibling = f;
        b.child = d;
        0 !== (b.mode & 1) && $0331271bace68e97$var$Ug(b, a.child, null, g);
        b.child.memoizedState = $0331271bace68e97$var$nj(g);
        b.memoizedState = $0331271bace68e97$var$mj;
        return f;
    }
    if (0 === (b.mode & 1)) return $0331271bace68e97$var$sj(a, b, g, null);
    if ("$!" === e.data) {
        d = e.nextSibling && e.nextSibling.dataset;
        if (d) var h = d.dgst;
        d = h;
        f = Error($0331271bace68e97$var$p(419));
        d = $0331271bace68e97$var$Ki(f, d, void 0);
        return $0331271bace68e97$var$sj(a, b, g, d);
    }
    h = 0 !== (g & a.childLanes);
    if ($0331271bace68e97$var$dh || h) {
        d = $0331271bace68e97$var$Q;
        if (null !== d) {
            switch(g & -g){
                case 4:
                    e = 2;
                    break;
                case 16:
                    e = 8;
                    break;
                case 64:
                case 128:
                case 256:
                case 512:
                case 1024:
                case 2048:
                case 4096:
                case 8192:
                case 16384:
                case 32768:
                case 65536:
                case 131072:
                case 262144:
                case 524288:
                case 1048576:
                case 2097152:
                case 4194304:
                case 8388608:
                case 16777216:
                case 33554432:
                case 67108864:
                    e = 32;
                    break;
                case 536870912:
                    e = 268435456;
                    break;
                default:
                    e = 0;
            }
            e = 0 !== (e & (d.suspendedLanes | g)) ? 0 : e;
            0 !== e && e !== f.retryLane && (f.retryLane = e, $0331271bace68e97$var$ih(a, e), $0331271bace68e97$var$gi(d, a, e, -1));
        }
        $0331271bace68e97$var$tj();
        d = $0331271bace68e97$var$Ki(Error($0331271bace68e97$var$p(421)));
        return $0331271bace68e97$var$sj(a, b, g, d);
    }
    if ("$?" === e.data) return b.flags |= 128, b.child = a.child, b = $0331271bace68e97$var$uj.bind(null, a), e._reactRetry = b, null;
    a = f.treeContext;
    $0331271bace68e97$var$yg = $0331271bace68e97$var$Lf(e.nextSibling);
    $0331271bace68e97$var$xg = b;
    $0331271bace68e97$var$I = !0;
    $0331271bace68e97$var$zg = null;
    null !== a && ($0331271bace68e97$var$og[$0331271bace68e97$var$pg++] = $0331271bace68e97$var$rg, $0331271bace68e97$var$og[$0331271bace68e97$var$pg++] = $0331271bace68e97$var$sg, $0331271bace68e97$var$og[$0331271bace68e97$var$pg++] = $0331271bace68e97$var$qg, $0331271bace68e97$var$rg = a.id, $0331271bace68e97$var$sg = a.overflow, $0331271bace68e97$var$qg = b);
    b = $0331271bace68e97$var$qj(b, d.children);
    b.flags |= 4096;
    return b;
}
function $0331271bace68e97$var$vj(a, b, c) {
    a.lanes |= b;
    var d = a.alternate;
    null !== d && (d.lanes |= b);
    $0331271bace68e97$var$bh(a.return, b, c);
}
function $0331271bace68e97$var$wj(a, b, c, d, e) {
    var f = a.memoizedState;
    null === f ? a.memoizedState = {
        isBackwards: b,
        rendering: null,
        renderingStartTime: 0,
        last: d,
        tail: c,
        tailMode: e
    } : (f.isBackwards = b, f.rendering = null, f.renderingStartTime = 0, f.last = d, f.tail = c, f.tailMode = e);
}
function $0331271bace68e97$var$xj(a, b, c) {
    var d = b.pendingProps, e = d.revealOrder, f = d.tail;
    $0331271bace68e97$var$Xi(a, b, d.children, c);
    d = $0331271bace68e97$var$L.current;
    if (0 !== (d & 2)) d = d & 1 | 2, b.flags |= 128;
    else {
        if (null !== a && 0 !== (a.flags & 128)) a: for(a = b.child; null !== a;){
            if (13 === a.tag) null !== a.memoizedState && $0331271bace68e97$var$vj(a, c, b);
            else if (19 === a.tag) $0331271bace68e97$var$vj(a, c, b);
            else if (null !== a.child) {
                a.child.return = a;
                a = a.child;
                continue;
            }
            if (a === b) break a;
            for(; null === a.sibling;){
                if (null === a.return || a.return === b) break a;
                a = a.return;
            }
            a.sibling.return = a.return;
            a = a.sibling;
        }
        d &= 1;
    }
    $0331271bace68e97$var$G($0331271bace68e97$var$L, d);
    if (0 === (b.mode & 1)) b.memoizedState = null;
    else switch(e){
        case "forwards":
            c = b.child;
            for(e = null; null !== c;)a = c.alternate, null !== a && null === $0331271bace68e97$var$Ch(a) && (e = c), c = c.sibling;
            c = e;
            null === c ? (e = b.child, b.child = null) : (e = c.sibling, c.sibling = null);
            $0331271bace68e97$var$wj(b, !1, e, c, f);
            break;
        case "backwards":
            c = null;
            e = b.child;
            for(b.child = null; null !== e;){
                a = e.alternate;
                if (null !== a && null === $0331271bace68e97$var$Ch(a)) {
                    b.child = e;
                    break;
                }
                a = e.sibling;
                e.sibling = c;
                c = e;
                e = a;
            }
            $0331271bace68e97$var$wj(b, !0, c, null, f);
            break;
        case "together":
            $0331271bace68e97$var$wj(b, !1, null, null, void 0);
            break;
        default:
            b.memoizedState = null;
    }
    return b.child;
}
function $0331271bace68e97$var$ij(a, b) {
    0 === (b.mode & 1) && null !== a && (a.alternate = null, b.alternate = null, b.flags |= 2);
}
function $0331271bace68e97$var$Zi(a, b, c) {
    null !== a && (b.dependencies = a.dependencies);
    $0331271bace68e97$var$rh |= b.lanes;
    if (0 === (c & b.childLanes)) return null;
    if (null !== a && b.child !== a.child) throw Error($0331271bace68e97$var$p(153));
    if (null !== b.child) {
        a = b.child;
        c = $0331271bace68e97$var$Pg(a, a.pendingProps);
        b.child = c;
        for(c.return = b; null !== a.sibling;)a = a.sibling, c = c.sibling = $0331271bace68e97$var$Pg(a, a.pendingProps), c.return = b;
        c.sibling = null;
    }
    return b.child;
}
function $0331271bace68e97$var$yj(a, b, c) {
    switch(b.tag){
        case 3:
            $0331271bace68e97$var$kj(b);
            $0331271bace68e97$var$Ig();
            break;
        case 5:
            $0331271bace68e97$var$Ah(b);
            break;
        case 1:
            $0331271bace68e97$var$Zf(b.type) && $0331271bace68e97$var$cg(b);
            break;
        case 4:
            $0331271bace68e97$var$yh(b, b.stateNode.containerInfo);
            break;
        case 10:
            var d = b.type._context, e = b.memoizedProps.value;
            $0331271bace68e97$var$G($0331271bace68e97$var$Wg, d._currentValue);
            d._currentValue = e;
            break;
        case 13:
            d = b.memoizedState;
            if (null !== d) {
                if (null !== d.dehydrated) return $0331271bace68e97$var$G($0331271bace68e97$var$L, $0331271bace68e97$var$L.current & 1), b.flags |= 128, null;
                if (0 !== (c & b.child.childLanes)) return $0331271bace68e97$var$oj(a, b, c);
                $0331271bace68e97$var$G($0331271bace68e97$var$L, $0331271bace68e97$var$L.current & 1);
                a = $0331271bace68e97$var$Zi(a, b, c);
                return null !== a ? a.sibling : null;
            }
            $0331271bace68e97$var$G($0331271bace68e97$var$L, $0331271bace68e97$var$L.current & 1);
            break;
        case 19:
            d = 0 !== (c & b.childLanes);
            if (0 !== (a.flags & 128)) {
                if (d) return $0331271bace68e97$var$xj(a, b, c);
                b.flags |= 128;
            }
            e = b.memoizedState;
            null !== e && (e.rendering = null, e.tail = null, e.lastEffect = null);
            $0331271bace68e97$var$G($0331271bace68e97$var$L, $0331271bace68e97$var$L.current);
            if (d) break;
            else return null;
        case 22:
        case 23:
            return b.lanes = 0, $0331271bace68e97$var$dj(a, b, c);
    }
    return $0331271bace68e97$var$Zi(a, b, c);
}
var $0331271bace68e97$var$zj, $0331271bace68e97$var$Aj, $0331271bace68e97$var$Bj, $0331271bace68e97$var$Cj;
$0331271bace68e97$var$zj = function zj(a, b) {
    for(var c = b.child; null !== c;){
        if (5 === c.tag || 6 === c.tag) a.appendChild(c.stateNode);
        else if (4 !== c.tag && null !== c.child) {
            c.child.return = c;
            c = c.child;
            continue;
        }
        if (c === b) break;
        for(; null === c.sibling;){
            if (null === c.return || c.return === b) return;
            c = c.return;
        }
        c.sibling.return = c.return;
        c = c.sibling;
    }
};
$0331271bace68e97$var$Aj = function Aj() {};
$0331271bace68e97$var$Bj = function Bj(a, b, c, d) {
    var e = a.memoizedProps;
    if (e !== d) {
        a = b.stateNode;
        $0331271bace68e97$var$xh($0331271bace68e97$var$uh.current);
        var f = null;
        switch(c){
            case "input":
                e = $0331271bace68e97$var$Ya(a, e);
                d = $0331271bace68e97$var$Ya(a, d);
                f = [];
                break;
            case "select":
                e = $0331271bace68e97$var$A({}, e, {
                    value: void 0
                });
                d = $0331271bace68e97$var$A({}, d, {
                    value: void 0
                });
                f = [];
                break;
            case "textarea":
                e = $0331271bace68e97$var$gb(a, e);
                d = $0331271bace68e97$var$gb(a, d);
                f = [];
                break;
            default:
                "function" !== typeof e.onClick && "function" === typeof d.onClick && (a.onclick = $0331271bace68e97$var$Bf);
        }
        $0331271bace68e97$var$ub(c, d);
        var g;
        c = null;
        for(l in e)if (!d.hasOwnProperty(l) && e.hasOwnProperty(l) && null != e[l]) {
            if ("style" === l) {
                var h = e[l];
                for(g in h)h.hasOwnProperty(g) && (c || (c = {}), c[g] = "");
            } else "dangerouslySetInnerHTML" !== l && "children" !== l && "suppressContentEditableWarning" !== l && "suppressHydrationWarning" !== l && "autoFocus" !== l && ($0331271bace68e97$var$ea.hasOwnProperty(l) ? f || (f = []) : (f = f || []).push(l, null));
        }
        for(l in d){
            var k = d[l];
            h = null != e ? e[l] : void 0;
            if (d.hasOwnProperty(l) && k !== h && (null != k || null != h)) {
                if ("style" === l) {
                    if (h) {
                        for(g in h)!h.hasOwnProperty(g) || k && k.hasOwnProperty(g) || (c || (c = {}), c[g] = "");
                        for(g in k)k.hasOwnProperty(g) && h[g] !== k[g] && (c || (c = {}), c[g] = k[g]);
                    } else c || (f || (f = []), f.push(l, c)), c = k;
                } else "dangerouslySetInnerHTML" === l ? (k = k ? k.__html : void 0, h = h ? h.__html : void 0, null != k && h !== k && (f = f || []).push(l, k)) : "children" === l ? "string" !== typeof k && "number" !== typeof k || (f = f || []).push(l, "" + k) : "suppressContentEditableWarning" !== l && "suppressHydrationWarning" !== l && ($0331271bace68e97$var$ea.hasOwnProperty(l) ? (null != k && "onScroll" === l && $0331271bace68e97$var$D("scroll", a), f || h === k || (f = [])) : (f = f || []).push(l, k));
            }
        }
        c && (f = f || []).push("style", c);
        var l = f;
        if (b.updateQueue = l) b.flags |= 4;
    }
};
$0331271bace68e97$var$Cj = function Cj(a, b, c, d) {
    c !== d && (b.flags |= 4);
};
function $0331271bace68e97$var$Dj(a, b) {
    if (!$0331271bace68e97$var$I) switch(a.tailMode){
        case "hidden":
            b = a.tail;
            for(var c = null; null !== b;)null !== b.alternate && (c = b), b = b.sibling;
            null === c ? a.tail = null : c.sibling = null;
            break;
        case "collapsed":
            c = a.tail;
            for(var d = null; null !== c;)null !== c.alternate && (d = c), c = c.sibling;
            null === d ? b || null === a.tail ? a.tail = null : a.tail.sibling = null : d.sibling = null;
    }
}
function $0331271bace68e97$var$S(a) {
    var b = null !== a.alternate && a.alternate.child === a.child, c = 0, d = 0;
    if (b) for(var e = a.child; null !== e;)c |= e.lanes | e.childLanes, d |= e.subtreeFlags & 14680064, d |= e.flags & 14680064, e.return = a, e = e.sibling;
    else for(e = a.child; null !== e;)c |= e.lanes | e.childLanes, d |= e.subtreeFlags, d |= e.flags, e.return = a, e = e.sibling;
    a.subtreeFlags |= d;
    a.childLanes = c;
    return b;
}
function $0331271bace68e97$var$Ej(a, b, c) {
    var d = b.pendingProps;
    $0331271bace68e97$var$wg(b);
    switch(b.tag){
        case 2:
        case 16:
        case 15:
        case 0:
        case 11:
        case 7:
        case 8:
        case 12:
        case 9:
        case 14:
            return $0331271bace68e97$var$S(b), null;
        case 1:
            return $0331271bace68e97$var$Zf(b.type) && $0331271bace68e97$var$$f(), $0331271bace68e97$var$S(b), null;
        case 3:
            d = b.stateNode;
            $0331271bace68e97$var$zh();
            $0331271bace68e97$var$E($0331271bace68e97$var$Wf);
            $0331271bace68e97$var$E($0331271bace68e97$var$H);
            $0331271bace68e97$var$Eh();
            d.pendingContext && (d.context = d.pendingContext, d.pendingContext = null);
            if (null === a || null === a.child) $0331271bace68e97$var$Gg(b) ? b.flags |= 4 : null === a || a.memoizedState.isDehydrated && 0 === (b.flags & 256) || (b.flags |= 1024, null !== $0331271bace68e97$var$zg && ($0331271bace68e97$var$Fj($0331271bace68e97$var$zg), $0331271bace68e97$var$zg = null));
            $0331271bace68e97$var$Aj(a, b);
            $0331271bace68e97$var$S(b);
            return null;
        case 5:
            $0331271bace68e97$var$Bh(b);
            var e = $0331271bace68e97$var$xh($0331271bace68e97$var$wh.current);
            c = b.type;
            if (null !== a && null != b.stateNode) $0331271bace68e97$var$Bj(a, b, c, d, e), a.ref !== b.ref && (b.flags |= 512, b.flags |= 2097152);
            else {
                if (!d) {
                    if (null === b.stateNode) throw Error($0331271bace68e97$var$p(166));
                    $0331271bace68e97$var$S(b);
                    return null;
                }
                a = $0331271bace68e97$var$xh($0331271bace68e97$var$uh.current);
                if ($0331271bace68e97$var$Gg(b)) {
                    d = b.stateNode;
                    c = b.type;
                    var f = b.memoizedProps;
                    d[$0331271bace68e97$var$Of] = b;
                    d[$0331271bace68e97$var$Pf] = f;
                    a = 0 !== (b.mode & 1);
                    switch(c){
                        case "dialog":
                            $0331271bace68e97$var$D("cancel", d);
                            $0331271bace68e97$var$D("close", d);
                            break;
                        case "iframe":
                        case "object":
                        case "embed":
                            $0331271bace68e97$var$D("load", d);
                            break;
                        case "video":
                        case "audio":
                            for(e = 0; e < $0331271bace68e97$var$lf.length; e++)$0331271bace68e97$var$D($0331271bace68e97$var$lf[e], d);
                            break;
                        case "source":
                            $0331271bace68e97$var$D("error", d);
                            break;
                        case "img":
                        case "image":
                        case "link":
                            $0331271bace68e97$var$D("error", d);
                            $0331271bace68e97$var$D("load", d);
                            break;
                        case "details":
                            $0331271bace68e97$var$D("toggle", d);
                            break;
                        case "input":
                            $0331271bace68e97$var$Za(d, f);
                            $0331271bace68e97$var$D("invalid", d);
                            break;
                        case "select":
                            d._wrapperState = {
                                wasMultiple: !!f.multiple
                            };
                            $0331271bace68e97$var$D("invalid", d);
                            break;
                        case "textarea":
                            $0331271bace68e97$var$hb(d, f), $0331271bace68e97$var$D("invalid", d);
                    }
                    $0331271bace68e97$var$ub(c, f);
                    e = null;
                    for(var g in f)if (f.hasOwnProperty(g)) {
                        var h = f[g];
                        "children" === g ? "string" === typeof h ? d.textContent !== h && (!0 !== f.suppressHydrationWarning && $0331271bace68e97$var$Af(d.textContent, h, a), e = [
                            "children",
                            h
                        ]) : "number" === typeof h && d.textContent !== "" + h && (!0 !== f.suppressHydrationWarning && $0331271bace68e97$var$Af(d.textContent, h, a), e = [
                            "children",
                            "" + h
                        ]) : $0331271bace68e97$var$ea.hasOwnProperty(g) && null != h && "onScroll" === g && $0331271bace68e97$var$D("scroll", d);
                    }
                    switch(c){
                        case "input":
                            $0331271bace68e97$var$Va(d);
                            $0331271bace68e97$var$db(d, f, !0);
                            break;
                        case "textarea":
                            $0331271bace68e97$var$Va(d);
                            $0331271bace68e97$var$jb(d);
                            break;
                        case "select":
                        case "option":
                            break;
                        default:
                            "function" === typeof f.onClick && (d.onclick = $0331271bace68e97$var$Bf);
                    }
                    d = e;
                    b.updateQueue = d;
                    null !== d && (b.flags |= 4);
                } else {
                    g = 9 === e.nodeType ? e : e.ownerDocument;
                    "http://www.w3.org/1999/xhtml" === a && (a = $0331271bace68e97$var$kb(c));
                    "http://www.w3.org/1999/xhtml" === a ? "script" === c ? (a = g.createElement("div"), a.innerHTML = "<script>\x3c/script>", a = a.removeChild(a.firstChild)) : "string" === typeof d.is ? a = g.createElement(c, {
                        is: d.is
                    }) : (a = g.createElement(c), "select" === c && (g = a, d.multiple ? g.multiple = !0 : d.size && (g.size = d.size))) : a = g.createElementNS(a, c);
                    a[$0331271bace68e97$var$Of] = b;
                    a[$0331271bace68e97$var$Pf] = d;
                    $0331271bace68e97$var$zj(a, b, !1, !1);
                    b.stateNode = a;
                    a: {
                        g = $0331271bace68e97$var$vb(c, d);
                        switch(c){
                            case "dialog":
                                $0331271bace68e97$var$D("cancel", a);
                                $0331271bace68e97$var$D("close", a);
                                e = d;
                                break;
                            case "iframe":
                            case "object":
                            case "embed":
                                $0331271bace68e97$var$D("load", a);
                                e = d;
                                break;
                            case "video":
                            case "audio":
                                for(e = 0; e < $0331271bace68e97$var$lf.length; e++)$0331271bace68e97$var$D($0331271bace68e97$var$lf[e], a);
                                e = d;
                                break;
                            case "source":
                                $0331271bace68e97$var$D("error", a);
                                e = d;
                                break;
                            case "img":
                            case "image":
                            case "link":
                                $0331271bace68e97$var$D("error", a);
                                $0331271bace68e97$var$D("load", a);
                                e = d;
                                break;
                            case "details":
                                $0331271bace68e97$var$D("toggle", a);
                                e = d;
                                break;
                            case "input":
                                $0331271bace68e97$var$Za(a, d);
                                e = $0331271bace68e97$var$Ya(a, d);
                                $0331271bace68e97$var$D("invalid", a);
                                break;
                            case "option":
                                e = d;
                                break;
                            case "select":
                                a._wrapperState = {
                                    wasMultiple: !!d.multiple
                                };
                                e = $0331271bace68e97$var$A({}, d, {
                                    value: void 0
                                });
                                $0331271bace68e97$var$D("invalid", a);
                                break;
                            case "textarea":
                                $0331271bace68e97$var$hb(a, d);
                                e = $0331271bace68e97$var$gb(a, d);
                                $0331271bace68e97$var$D("invalid", a);
                                break;
                            default:
                                e = d;
                        }
                        $0331271bace68e97$var$ub(c, e);
                        h = e;
                        for(f in h)if (h.hasOwnProperty(f)) {
                            var k = h[f];
                            "style" === f ? $0331271bace68e97$var$sb(a, k) : "dangerouslySetInnerHTML" === f ? (k = k ? k.__html : void 0, null != k && $0331271bace68e97$var$nb(a, k)) : "children" === f ? "string" === typeof k ? ("textarea" !== c || "" !== k) && $0331271bace68e97$var$ob(a, k) : "number" === typeof k && $0331271bace68e97$var$ob(a, "" + k) : "suppressContentEditableWarning" !== f && "suppressHydrationWarning" !== f && "autoFocus" !== f && ($0331271bace68e97$var$ea.hasOwnProperty(f) ? null != k && "onScroll" === f && $0331271bace68e97$var$D("scroll", a) : null != k && $0331271bace68e97$var$ta(a, f, k, g));
                        }
                        switch(c){
                            case "input":
                                $0331271bace68e97$var$Va(a);
                                $0331271bace68e97$var$db(a, d, !1);
                                break;
                            case "textarea":
                                $0331271bace68e97$var$Va(a);
                                $0331271bace68e97$var$jb(a);
                                break;
                            case "option":
                                null != d.value && a.setAttribute("value", "" + $0331271bace68e97$var$Sa(d.value));
                                break;
                            case "select":
                                a.multiple = !!d.multiple;
                                f = d.value;
                                null != f ? $0331271bace68e97$var$fb(a, !!d.multiple, f, !1) : null != d.defaultValue && $0331271bace68e97$var$fb(a, !!d.multiple, d.defaultValue, !0);
                                break;
                            default:
                                "function" === typeof e.onClick && (a.onclick = $0331271bace68e97$var$Bf);
                        }
                        switch(c){
                            case "button":
                            case "input":
                            case "select":
                            case "textarea":
                                d = !!d.autoFocus;
                                break a;
                            case "img":
                                d = !0;
                                break a;
                            default:
                                d = !1;
                        }
                    }
                    d && (b.flags |= 4);
                }
                null !== b.ref && (b.flags |= 512, b.flags |= 2097152);
            }
            $0331271bace68e97$var$S(b);
            return null;
        case 6:
            if (a && null != b.stateNode) $0331271bace68e97$var$Cj(a, b, a.memoizedProps, d);
            else {
                if ("string" !== typeof d && null === b.stateNode) throw Error($0331271bace68e97$var$p(166));
                c = $0331271bace68e97$var$xh($0331271bace68e97$var$wh.current);
                $0331271bace68e97$var$xh($0331271bace68e97$var$uh.current);
                if ($0331271bace68e97$var$Gg(b)) {
                    d = b.stateNode;
                    c = b.memoizedProps;
                    d[$0331271bace68e97$var$Of] = b;
                    if (f = d.nodeValue !== c) {
                        if (a = $0331271bace68e97$var$xg, null !== a) switch(a.tag){
                            case 3:
                                $0331271bace68e97$var$Af(d.nodeValue, c, 0 !== (a.mode & 1));
                                break;
                            case 5:
                                !0 !== a.memoizedProps.suppressHydrationWarning && $0331271bace68e97$var$Af(d.nodeValue, c, 0 !== (a.mode & 1));
                        }
                    }
                    f && (b.flags |= 4);
                } else d = (9 === c.nodeType ? c : c.ownerDocument).createTextNode(d), d[$0331271bace68e97$var$Of] = b, b.stateNode = d;
            }
            $0331271bace68e97$var$S(b);
            return null;
        case 13:
            $0331271bace68e97$var$E($0331271bace68e97$var$L);
            d = b.memoizedState;
            if (null === a || null !== a.memoizedState && null !== a.memoizedState.dehydrated) {
                if ($0331271bace68e97$var$I && null !== $0331271bace68e97$var$yg && 0 !== (b.mode & 1) && 0 === (b.flags & 128)) $0331271bace68e97$var$Hg(), $0331271bace68e97$var$Ig(), b.flags |= 98560, f = !1;
                else if (f = $0331271bace68e97$var$Gg(b), null !== d && null !== d.dehydrated) {
                    if (null === a) {
                        if (!f) throw Error($0331271bace68e97$var$p(318));
                        f = b.memoizedState;
                        f = null !== f ? f.dehydrated : null;
                        if (!f) throw Error($0331271bace68e97$var$p(317));
                        f[$0331271bace68e97$var$Of] = b;
                    } else $0331271bace68e97$var$Ig(), 0 === (b.flags & 128) && (b.memoizedState = null), b.flags |= 4;
                    $0331271bace68e97$var$S(b);
                    f = !1;
                } else null !== $0331271bace68e97$var$zg && ($0331271bace68e97$var$Fj($0331271bace68e97$var$zg), $0331271bace68e97$var$zg = null), f = !0;
                if (!f) return b.flags & 65536 ? b : null;
            }
            if (0 !== (b.flags & 128)) return b.lanes = c, b;
            d = null !== d;
            d !== (null !== a && null !== a.memoizedState) && d && (b.child.flags |= 8192, 0 !== (b.mode & 1) && (null === a || 0 !== ($0331271bace68e97$var$L.current & 1) ? 0 === $0331271bace68e97$var$T && ($0331271bace68e97$var$T = 3) : $0331271bace68e97$var$tj()));
            null !== b.updateQueue && (b.flags |= 4);
            $0331271bace68e97$var$S(b);
            return null;
        case 4:
            return $0331271bace68e97$var$zh(), $0331271bace68e97$var$Aj(a, b), null === a && $0331271bace68e97$var$sf(b.stateNode.containerInfo), $0331271bace68e97$var$S(b), null;
        case 10:
            return $0331271bace68e97$var$ah(b.type._context), $0331271bace68e97$var$S(b), null;
        case 17:
            return $0331271bace68e97$var$Zf(b.type) && $0331271bace68e97$var$$f(), $0331271bace68e97$var$S(b), null;
        case 19:
            $0331271bace68e97$var$E($0331271bace68e97$var$L);
            f = b.memoizedState;
            if (null === f) return $0331271bace68e97$var$S(b), null;
            d = 0 !== (b.flags & 128);
            g = f.rendering;
            if (null === g) {
                if (d) $0331271bace68e97$var$Dj(f, !1);
                else {
                    if (0 !== $0331271bace68e97$var$T || null !== a && 0 !== (a.flags & 128)) for(a = b.child; null !== a;){
                        g = $0331271bace68e97$var$Ch(a);
                        if (null !== g) {
                            b.flags |= 128;
                            $0331271bace68e97$var$Dj(f, !1);
                            d = g.updateQueue;
                            null !== d && (b.updateQueue = d, b.flags |= 4);
                            b.subtreeFlags = 0;
                            d = c;
                            for(c = b.child; null !== c;)f = c, a = d, f.flags &= 14680066, g = f.alternate, null === g ? (f.childLanes = 0, f.lanes = a, f.child = null, f.subtreeFlags = 0, f.memoizedProps = null, f.memoizedState = null, f.updateQueue = null, f.dependencies = null, f.stateNode = null) : (f.childLanes = g.childLanes, f.lanes = g.lanes, f.child = g.child, f.subtreeFlags = 0, f.deletions = null, f.memoizedProps = g.memoizedProps, f.memoizedState = g.memoizedState, f.updateQueue = g.updateQueue, f.type = g.type, a = g.dependencies, f.dependencies = null === a ? null : {
                                lanes: a.lanes,
                                firstContext: a.firstContext
                            }), c = c.sibling;
                            $0331271bace68e97$var$G($0331271bace68e97$var$L, $0331271bace68e97$var$L.current & 1 | 2);
                            return b.child;
                        }
                        a = a.sibling;
                    }
                    null !== f.tail && $0331271bace68e97$var$B() > $0331271bace68e97$var$Gj && (b.flags |= 128, d = !0, $0331271bace68e97$var$Dj(f, !1), b.lanes = 4194304);
                }
            } else {
                if (!d) {
                    if (a = $0331271bace68e97$var$Ch(g), null !== a) {
                        if (b.flags |= 128, d = !0, c = a.updateQueue, null !== c && (b.updateQueue = c, b.flags |= 4), $0331271bace68e97$var$Dj(f, !0), null === f.tail && "hidden" === f.tailMode && !g.alternate && !$0331271bace68e97$var$I) return $0331271bace68e97$var$S(b), null;
                    } else 2 * $0331271bace68e97$var$B() - f.renderingStartTime > $0331271bace68e97$var$Gj && 1073741824 !== c && (b.flags |= 128, d = !0, $0331271bace68e97$var$Dj(f, !1), b.lanes = 4194304);
                }
                f.isBackwards ? (g.sibling = b.child, b.child = g) : (c = f.last, null !== c ? c.sibling = g : b.child = g, f.last = g);
            }
            if (null !== f.tail) return b = f.tail, f.rendering = b, f.tail = b.sibling, f.renderingStartTime = $0331271bace68e97$var$B(), b.sibling = null, c = $0331271bace68e97$var$L.current, $0331271bace68e97$var$G($0331271bace68e97$var$L, d ? c & 1 | 2 : c & 1), b;
            $0331271bace68e97$var$S(b);
            return null;
        case 22:
        case 23:
            return $0331271bace68e97$var$Hj(), d = null !== b.memoizedState, null !== a && null !== a.memoizedState !== d && (b.flags |= 8192), d && 0 !== (b.mode & 1) ? 0 !== ($0331271bace68e97$var$fj & 1073741824) && ($0331271bace68e97$var$S(b), b.subtreeFlags & 6 && (b.flags |= 8192)) : $0331271bace68e97$var$S(b), null;
        case 24:
            return null;
        case 25:
            return null;
    }
    throw Error($0331271bace68e97$var$p(156, b.tag));
}
function $0331271bace68e97$var$Ij(a, b) {
    $0331271bace68e97$var$wg(b);
    switch(b.tag){
        case 1:
            return $0331271bace68e97$var$Zf(b.type) && $0331271bace68e97$var$$f(), a = b.flags, a & 65536 ? (b.flags = a & -65537 | 128, b) : null;
        case 3:
            return $0331271bace68e97$var$zh(), $0331271bace68e97$var$E($0331271bace68e97$var$Wf), $0331271bace68e97$var$E($0331271bace68e97$var$H), $0331271bace68e97$var$Eh(), a = b.flags, 0 !== (a & 65536) && 0 === (a & 128) ? (b.flags = a & -65537 | 128, b) : null;
        case 5:
            return $0331271bace68e97$var$Bh(b), null;
        case 13:
            $0331271bace68e97$var$E($0331271bace68e97$var$L);
            a = b.memoizedState;
            if (null !== a && null !== a.dehydrated) {
                if (null === b.alternate) throw Error($0331271bace68e97$var$p(340));
                $0331271bace68e97$var$Ig();
            }
            a = b.flags;
            return a & 65536 ? (b.flags = a & -65537 | 128, b) : null;
        case 19:
            return $0331271bace68e97$var$E($0331271bace68e97$var$L), null;
        case 4:
            return $0331271bace68e97$var$zh(), null;
        case 10:
            return $0331271bace68e97$var$ah(b.type._context), null;
        case 22:
        case 23:
            return $0331271bace68e97$var$Hj(), null;
        case 24:
            return null;
        default:
            return null;
    }
}
var $0331271bace68e97$var$Jj = !1, $0331271bace68e97$var$U = !1, $0331271bace68e97$var$Kj = "function" === typeof WeakSet ? WeakSet : Set, $0331271bace68e97$var$V = null;
function $0331271bace68e97$var$Lj(a, b) {
    var c = a.ref;
    if (null !== c) {
        if ("function" === typeof c) try {
            c(null);
        } catch (d) {
            $0331271bace68e97$var$W(a, b, d);
        }
        else c.current = null;
    }
}
function $0331271bace68e97$var$Mj(a, b, c) {
    try {
        c();
    } catch (d) {
        $0331271bace68e97$var$W(a, b, d);
    }
}
var $0331271bace68e97$var$Nj = !1;
function $0331271bace68e97$var$Oj(a, b) {
    $0331271bace68e97$var$Cf = $0331271bace68e97$var$dd;
    a = $0331271bace68e97$var$Me();
    if ($0331271bace68e97$var$Ne(a)) {
        if ("selectionStart" in a) var c = {
            start: a.selectionStart,
            end: a.selectionEnd
        };
        else a: {
            c = (c = a.ownerDocument) && c.defaultView || window;
            var d = c.getSelection && c.getSelection();
            if (d && 0 !== d.rangeCount) {
                c = d.anchorNode;
                var e = d.anchorOffset, f = d.focusNode;
                d = d.focusOffset;
                try {
                    c.nodeType, f.nodeType;
                } catch (F) {
                    c = null;
                    break a;
                }
                var g = 0, h = -1, k = -1, l = 0, m = 0, q = a, r = null;
                b: for(;;){
                    for(var y;;){
                        q !== c || 0 !== e && 3 !== q.nodeType || (h = g + e);
                        q !== f || 0 !== d && 3 !== q.nodeType || (k = g + d);
                        3 === q.nodeType && (g += q.nodeValue.length);
                        if (null === (y = q.firstChild)) break;
                        r = q;
                        q = y;
                    }
                    for(;;){
                        if (q === a) break b;
                        r === c && ++l === e && (h = g);
                        r === f && ++m === d && (k = g);
                        if (null !== (y = q.nextSibling)) break;
                        q = r;
                        r = q.parentNode;
                    }
                    q = y;
                }
                c = -1 === h || -1 === k ? null : {
                    start: h,
                    end: k
                };
            } else c = null;
        }
        c = c || {
            start: 0,
            end: 0
        };
    } else c = null;
    $0331271bace68e97$var$Df = {
        focusedElem: a,
        selectionRange: c
    };
    $0331271bace68e97$var$dd = !1;
    for($0331271bace68e97$var$V = b; null !== $0331271bace68e97$var$V;)if (b = $0331271bace68e97$var$V, a = b.child, 0 !== (b.subtreeFlags & 1028) && null !== a) a.return = b, $0331271bace68e97$var$V = a;
    else for(; null !== $0331271bace68e97$var$V;){
        b = $0331271bace68e97$var$V;
        try {
            var n = b.alternate;
            if (0 !== (b.flags & 1024)) switch(b.tag){
                case 0:
                case 11:
                case 15:
                    break;
                case 1:
                    if (null !== n) {
                        var t = n.memoizedProps, J = n.memoizedState, x = b.stateNode, w = x.getSnapshotBeforeUpdate(b.elementType === b.type ? t : $0331271bace68e97$var$Ci(b.type, t), J);
                        x.__reactInternalSnapshotBeforeUpdate = w;
                    }
                    break;
                case 3:
                    var u = b.stateNode.containerInfo;
                    1 === u.nodeType ? u.textContent = "" : 9 === u.nodeType && u.documentElement && u.removeChild(u.documentElement);
                    break;
                case 5:
                case 6:
                case 4:
                case 17:
                    break;
                default:
                    throw Error($0331271bace68e97$var$p(163));
            }
        } catch (F) {
            $0331271bace68e97$var$W(b, b.return, F);
        }
        a = b.sibling;
        if (null !== a) {
            a.return = b.return;
            $0331271bace68e97$var$V = a;
            break;
        }
        $0331271bace68e97$var$V = b.return;
    }
    n = $0331271bace68e97$var$Nj;
    $0331271bace68e97$var$Nj = !1;
    return n;
}
function $0331271bace68e97$var$Pj(a, b, c) {
    var d = b.updateQueue;
    d = null !== d ? d.lastEffect : null;
    if (null !== d) {
        var e = d = d.next;
        do {
            if ((e.tag & a) === a) {
                var f = e.destroy;
                e.destroy = void 0;
                void 0 !== f && $0331271bace68e97$var$Mj(b, c, f);
            }
            e = e.next;
        }while (e !== d);
    }
}
function $0331271bace68e97$var$Qj(a, b) {
    b = b.updateQueue;
    b = null !== b ? b.lastEffect : null;
    if (null !== b) {
        var c = b = b.next;
        do {
            if ((c.tag & a) === a) {
                var d = c.create;
                c.destroy = d();
            }
            c = c.next;
        }while (c !== b);
    }
}
function $0331271bace68e97$var$Rj(a) {
    var b = a.ref;
    if (null !== b) {
        var c = a.stateNode;
        switch(a.tag){
            case 5:
                a = c;
                break;
            default:
                a = c;
        }
        "function" === typeof b ? b(a) : b.current = a;
    }
}
function $0331271bace68e97$var$Sj(a) {
    var b = a.alternate;
    null !== b && (a.alternate = null, $0331271bace68e97$var$Sj(b));
    a.child = null;
    a.deletions = null;
    a.sibling = null;
    5 === a.tag && (b = a.stateNode, null !== b && (delete b[$0331271bace68e97$var$Of], delete b[$0331271bace68e97$var$Pf], delete b[$0331271bace68e97$var$of], delete b[$0331271bace68e97$var$Qf], delete b[$0331271bace68e97$var$Rf]));
    a.stateNode = null;
    a.return = null;
    a.dependencies = null;
    a.memoizedProps = null;
    a.memoizedState = null;
    a.pendingProps = null;
    a.stateNode = null;
    a.updateQueue = null;
}
function $0331271bace68e97$var$Tj(a) {
    return 5 === a.tag || 3 === a.tag || 4 === a.tag;
}
function $0331271bace68e97$var$Uj(a) {
    a: for(;;){
        for(; null === a.sibling;){
            if (null === a.return || $0331271bace68e97$var$Tj(a.return)) return null;
            a = a.return;
        }
        a.sibling.return = a.return;
        for(a = a.sibling; 5 !== a.tag && 6 !== a.tag && 18 !== a.tag;){
            if (a.flags & 2) continue a;
            if (null === a.child || 4 === a.tag) continue a;
            else a.child.return = a, a = a.child;
        }
        if (!(a.flags & 2)) return a.stateNode;
    }
}
function $0331271bace68e97$var$Vj(a, b, c) {
    var d = a.tag;
    if (5 === d || 6 === d) a = a.stateNode, b ? 8 === c.nodeType ? c.parentNode.insertBefore(a, b) : c.insertBefore(a, b) : (8 === c.nodeType ? (b = c.parentNode, b.insertBefore(a, c)) : (b = c, b.appendChild(a)), c = c._reactRootContainer, null !== c && void 0 !== c || null !== b.onclick || (b.onclick = $0331271bace68e97$var$Bf));
    else if (4 !== d && (a = a.child, null !== a)) for($0331271bace68e97$var$Vj(a, b, c), a = a.sibling; null !== a;)$0331271bace68e97$var$Vj(a, b, c), a = a.sibling;
}
function $0331271bace68e97$var$Wj(a, b, c) {
    var d = a.tag;
    if (5 === d || 6 === d) a = a.stateNode, b ? c.insertBefore(a, b) : c.appendChild(a);
    else if (4 !== d && (a = a.child, null !== a)) for($0331271bace68e97$var$Wj(a, b, c), a = a.sibling; null !== a;)$0331271bace68e97$var$Wj(a, b, c), a = a.sibling;
}
var $0331271bace68e97$var$X = null, $0331271bace68e97$var$Xj = !1;
function $0331271bace68e97$var$Yj(a, b, c) {
    for(c = c.child; null !== c;)$0331271bace68e97$var$Zj(a, b, c), c = c.sibling;
}
function $0331271bace68e97$var$Zj(a, b, c) {
    if ($0331271bace68e97$var$lc && "function" === typeof $0331271bace68e97$var$lc.onCommitFiberUnmount) try {
        $0331271bace68e97$var$lc.onCommitFiberUnmount($0331271bace68e97$var$kc, c);
    } catch (h) {}
    switch(c.tag){
        case 5:
            $0331271bace68e97$var$U || $0331271bace68e97$var$Lj(c, b);
        case 6:
            var d = $0331271bace68e97$var$X, e = $0331271bace68e97$var$Xj;
            $0331271bace68e97$var$X = null;
            $0331271bace68e97$var$Yj(a, b, c);
            $0331271bace68e97$var$X = d;
            $0331271bace68e97$var$Xj = e;
            null !== $0331271bace68e97$var$X && ($0331271bace68e97$var$Xj ? (a = $0331271bace68e97$var$X, c = c.stateNode, 8 === a.nodeType ? a.parentNode.removeChild(c) : a.removeChild(c)) : $0331271bace68e97$var$X.removeChild(c.stateNode));
            break;
        case 18:
            null !== $0331271bace68e97$var$X && ($0331271bace68e97$var$Xj ? (a = $0331271bace68e97$var$X, c = c.stateNode, 8 === a.nodeType ? $0331271bace68e97$var$Kf(a.parentNode, c) : 1 === a.nodeType && $0331271bace68e97$var$Kf(a, c), $0331271bace68e97$var$bd(a)) : $0331271bace68e97$var$Kf($0331271bace68e97$var$X, c.stateNode));
            break;
        case 4:
            d = $0331271bace68e97$var$X;
            e = $0331271bace68e97$var$Xj;
            $0331271bace68e97$var$X = c.stateNode.containerInfo;
            $0331271bace68e97$var$Xj = !0;
            $0331271bace68e97$var$Yj(a, b, c);
            $0331271bace68e97$var$X = d;
            $0331271bace68e97$var$Xj = e;
            break;
        case 0:
        case 11:
        case 14:
        case 15:
            if (!$0331271bace68e97$var$U && (d = c.updateQueue, null !== d && (d = d.lastEffect, null !== d))) {
                e = d = d.next;
                do {
                    var f = e, g = f.destroy;
                    f = f.tag;
                    void 0 !== g && (0 !== (f & 2) ? $0331271bace68e97$var$Mj(c, b, g) : 0 !== (f & 4) && $0331271bace68e97$var$Mj(c, b, g));
                    e = e.next;
                }while (e !== d);
            }
            $0331271bace68e97$var$Yj(a, b, c);
            break;
        case 1:
            if (!$0331271bace68e97$var$U && ($0331271bace68e97$var$Lj(c, b), d = c.stateNode, "function" === typeof d.componentWillUnmount)) try {
                d.props = c.memoizedProps, d.state = c.memoizedState, d.componentWillUnmount();
            } catch (h) {
                $0331271bace68e97$var$W(c, b, h);
            }
            $0331271bace68e97$var$Yj(a, b, c);
            break;
        case 21:
            $0331271bace68e97$var$Yj(a, b, c);
            break;
        case 22:
            c.mode & 1 ? ($0331271bace68e97$var$U = (d = $0331271bace68e97$var$U) || null !== c.memoizedState, $0331271bace68e97$var$Yj(a, b, c), $0331271bace68e97$var$U = d) : $0331271bace68e97$var$Yj(a, b, c);
            break;
        default:
            $0331271bace68e97$var$Yj(a, b, c);
    }
}
function $0331271bace68e97$var$ak(a) {
    var b = a.updateQueue;
    if (null !== b) {
        a.updateQueue = null;
        var c = a.stateNode;
        null === c && (c = a.stateNode = new $0331271bace68e97$var$Kj);
        b.forEach(function(b) {
            var d = $0331271bace68e97$var$bk.bind(null, a, b);
            c.has(b) || (c.add(b), b.then(d, d));
        });
    }
}
function $0331271bace68e97$var$ck(a, b) {
    var c = b.deletions;
    if (null !== c) for(var d = 0; d < c.length; d++){
        var e = c[d];
        try {
            var f = a, g = b, h = g;
            a: for(; null !== h;){
                switch(h.tag){
                    case 5:
                        $0331271bace68e97$var$X = h.stateNode;
                        $0331271bace68e97$var$Xj = !1;
                        break a;
                    case 3:
                        $0331271bace68e97$var$X = h.stateNode.containerInfo;
                        $0331271bace68e97$var$Xj = !0;
                        break a;
                    case 4:
                        $0331271bace68e97$var$X = h.stateNode.containerInfo;
                        $0331271bace68e97$var$Xj = !0;
                        break a;
                }
                h = h.return;
            }
            if (null === $0331271bace68e97$var$X) throw Error($0331271bace68e97$var$p(160));
            $0331271bace68e97$var$Zj(f, g, e);
            $0331271bace68e97$var$X = null;
            $0331271bace68e97$var$Xj = !1;
            var k = e.alternate;
            null !== k && (k.return = null);
            e.return = null;
        } catch (l) {
            $0331271bace68e97$var$W(e, b, l);
        }
    }
    if (b.subtreeFlags & 12854) for(b = b.child; null !== b;)$0331271bace68e97$var$dk(b, a), b = b.sibling;
}
function $0331271bace68e97$var$dk(a, b) {
    var c = a.alternate, d = a.flags;
    switch(a.tag){
        case 0:
        case 11:
        case 14:
        case 15:
            $0331271bace68e97$var$ck(b, a);
            $0331271bace68e97$var$ek(a);
            if (d & 4) {
                try {
                    $0331271bace68e97$var$Pj(3, a, a.return), $0331271bace68e97$var$Qj(3, a);
                } catch (t) {
                    $0331271bace68e97$var$W(a, a.return, t);
                }
                try {
                    $0331271bace68e97$var$Pj(5, a, a.return);
                } catch (t) {
                    $0331271bace68e97$var$W(a, a.return, t);
                }
            }
            break;
        case 1:
            $0331271bace68e97$var$ck(b, a);
            $0331271bace68e97$var$ek(a);
            d & 512 && null !== c && $0331271bace68e97$var$Lj(c, c.return);
            break;
        case 5:
            $0331271bace68e97$var$ck(b, a);
            $0331271bace68e97$var$ek(a);
            d & 512 && null !== c && $0331271bace68e97$var$Lj(c, c.return);
            if (a.flags & 32) {
                var e = a.stateNode;
                try {
                    $0331271bace68e97$var$ob(e, "");
                } catch (t) {
                    $0331271bace68e97$var$W(a, a.return, t);
                }
            }
            if (d & 4 && (e = a.stateNode, null != e)) {
                var f = a.memoizedProps, g = null !== c ? c.memoizedProps : f, h = a.type, k = a.updateQueue;
                a.updateQueue = null;
                if (null !== k) try {
                    "input" === h && "radio" === f.type && null != f.name && $0331271bace68e97$var$ab(e, f);
                    $0331271bace68e97$var$vb(h, g);
                    var l = $0331271bace68e97$var$vb(h, f);
                    for(g = 0; g < k.length; g += 2){
                        var m = k[g], q = k[g + 1];
                        "style" === m ? $0331271bace68e97$var$sb(e, q) : "dangerouslySetInnerHTML" === m ? $0331271bace68e97$var$nb(e, q) : "children" === m ? $0331271bace68e97$var$ob(e, q) : $0331271bace68e97$var$ta(e, m, q, l);
                    }
                    switch(h){
                        case "input":
                            $0331271bace68e97$var$bb(e, f);
                            break;
                        case "textarea":
                            $0331271bace68e97$var$ib(e, f);
                            break;
                        case "select":
                            var r = e._wrapperState.wasMultiple;
                            e._wrapperState.wasMultiple = !!f.multiple;
                            var y = f.value;
                            null != y ? $0331271bace68e97$var$fb(e, !!f.multiple, y, !1) : r !== !!f.multiple && (null != f.defaultValue ? $0331271bace68e97$var$fb(e, !!f.multiple, f.defaultValue, !0) : $0331271bace68e97$var$fb(e, !!f.multiple, f.multiple ? [] : "", !1));
                    }
                    e[$0331271bace68e97$var$Pf] = f;
                } catch (t) {
                    $0331271bace68e97$var$W(a, a.return, t);
                }
            }
            break;
        case 6:
            $0331271bace68e97$var$ck(b, a);
            $0331271bace68e97$var$ek(a);
            if (d & 4) {
                if (null === a.stateNode) throw Error($0331271bace68e97$var$p(162));
                e = a.stateNode;
                f = a.memoizedProps;
                try {
                    e.nodeValue = f;
                } catch (t) {
                    $0331271bace68e97$var$W(a, a.return, t);
                }
            }
            break;
        case 3:
            $0331271bace68e97$var$ck(b, a);
            $0331271bace68e97$var$ek(a);
            if (d & 4 && null !== c && c.memoizedState.isDehydrated) try {
                $0331271bace68e97$var$bd(b.containerInfo);
            } catch (t) {
                $0331271bace68e97$var$W(a, a.return, t);
            }
            break;
        case 4:
            $0331271bace68e97$var$ck(b, a);
            $0331271bace68e97$var$ek(a);
            break;
        case 13:
            $0331271bace68e97$var$ck(b, a);
            $0331271bace68e97$var$ek(a);
            e = a.child;
            e.flags & 8192 && (f = null !== e.memoizedState, e.stateNode.isHidden = f, !f || null !== e.alternate && null !== e.alternate.memoizedState || ($0331271bace68e97$var$fk = $0331271bace68e97$var$B()));
            d & 4 && $0331271bace68e97$var$ak(a);
            break;
        case 22:
            m = null !== c && null !== c.memoizedState;
            a.mode & 1 ? ($0331271bace68e97$var$U = (l = $0331271bace68e97$var$U) || m, $0331271bace68e97$var$ck(b, a), $0331271bace68e97$var$U = l) : $0331271bace68e97$var$ck(b, a);
            $0331271bace68e97$var$ek(a);
            if (d & 8192) {
                l = null !== a.memoizedState;
                if ((a.stateNode.isHidden = l) && !m && 0 !== (a.mode & 1)) for($0331271bace68e97$var$V = a, m = a.child; null !== m;){
                    for(q = $0331271bace68e97$var$V = m; null !== $0331271bace68e97$var$V;){
                        r = $0331271bace68e97$var$V;
                        y = r.child;
                        switch(r.tag){
                            case 0:
                            case 11:
                            case 14:
                            case 15:
                                $0331271bace68e97$var$Pj(4, r, r.return);
                                break;
                            case 1:
                                $0331271bace68e97$var$Lj(r, r.return);
                                var n = r.stateNode;
                                if ("function" === typeof n.componentWillUnmount) {
                                    d = r;
                                    c = r.return;
                                    try {
                                        b = d, n.props = b.memoizedProps, n.state = b.memoizedState, n.componentWillUnmount();
                                    } catch (t) {
                                        $0331271bace68e97$var$W(d, c, t);
                                    }
                                }
                                break;
                            case 5:
                                $0331271bace68e97$var$Lj(r, r.return);
                                break;
                            case 22:
                                if (null !== r.memoizedState) {
                                    $0331271bace68e97$var$gk(q);
                                    continue;
                                }
                        }
                        null !== y ? (y.return = r, $0331271bace68e97$var$V = y) : $0331271bace68e97$var$gk(q);
                    }
                    m = m.sibling;
                }
                a: for(m = null, q = a;;){
                    if (5 === q.tag) {
                        if (null === m) {
                            m = q;
                            try {
                                e = q.stateNode, l ? (f = e.style, "function" === typeof f.setProperty ? f.setProperty("display", "none", "important") : f.display = "none") : (h = q.stateNode, k = q.memoizedProps.style, g = void 0 !== k && null !== k && k.hasOwnProperty("display") ? k.display : null, h.style.display = $0331271bace68e97$var$rb("display", g));
                            } catch (t) {
                                $0331271bace68e97$var$W(a, a.return, t);
                            }
                        }
                    } else if (6 === q.tag) {
                        if (null === m) try {
                            q.stateNode.nodeValue = l ? "" : q.memoizedProps;
                        } catch (t) {
                            $0331271bace68e97$var$W(a, a.return, t);
                        }
                    } else if ((22 !== q.tag && 23 !== q.tag || null === q.memoizedState || q === a) && null !== q.child) {
                        q.child.return = q;
                        q = q.child;
                        continue;
                    }
                    if (q === a) break a;
                    for(; null === q.sibling;){
                        if (null === q.return || q.return === a) break a;
                        m === q && (m = null);
                        q = q.return;
                    }
                    m === q && (m = null);
                    q.sibling.return = q.return;
                    q = q.sibling;
                }
            }
            break;
        case 19:
            $0331271bace68e97$var$ck(b, a);
            $0331271bace68e97$var$ek(a);
            d & 4 && $0331271bace68e97$var$ak(a);
            break;
        case 21:
            break;
        default:
            $0331271bace68e97$var$ck(b, a), $0331271bace68e97$var$ek(a);
    }
}
function $0331271bace68e97$var$ek(a) {
    var b = a.flags;
    if (b & 2) {
        try {
            a: {
                for(var c = a.return; null !== c;){
                    if ($0331271bace68e97$var$Tj(c)) {
                        var d = c;
                        break a;
                    }
                    c = c.return;
                }
                throw Error($0331271bace68e97$var$p(160));
            }
            switch(d.tag){
                case 5:
                    var e = d.stateNode;
                    d.flags & 32 && ($0331271bace68e97$var$ob(e, ""), d.flags &= -33);
                    var f = $0331271bace68e97$var$Uj(a);
                    $0331271bace68e97$var$Wj(a, f, e);
                    break;
                case 3:
                case 4:
                    var g = d.stateNode.containerInfo, h = $0331271bace68e97$var$Uj(a);
                    $0331271bace68e97$var$Vj(a, h, g);
                    break;
                default:
                    throw Error($0331271bace68e97$var$p(161));
            }
        } catch (k) {
            $0331271bace68e97$var$W(a, a.return, k);
        }
        a.flags &= -3;
    }
    b & 4096 && (a.flags &= -4097);
}
function $0331271bace68e97$var$hk(a, b, c) {
    $0331271bace68e97$var$V = a;
    $0331271bace68e97$var$ik(a, b, c);
}
function $0331271bace68e97$var$ik(a, b, c) {
    for(var d = 0 !== (a.mode & 1); null !== $0331271bace68e97$var$V;){
        var e = $0331271bace68e97$var$V, f = e.child;
        if (22 === e.tag && d) {
            var g = null !== e.memoizedState || $0331271bace68e97$var$Jj;
            if (!g) {
                var h = e.alternate, k = null !== h && null !== h.memoizedState || $0331271bace68e97$var$U;
                h = $0331271bace68e97$var$Jj;
                var l = $0331271bace68e97$var$U;
                $0331271bace68e97$var$Jj = g;
                if (($0331271bace68e97$var$U = k) && !l) for($0331271bace68e97$var$V = e; null !== $0331271bace68e97$var$V;)g = $0331271bace68e97$var$V, k = g.child, 22 === g.tag && null !== g.memoizedState ? $0331271bace68e97$var$jk(e) : null !== k ? (k.return = g, $0331271bace68e97$var$V = k) : $0331271bace68e97$var$jk(e);
                for(; null !== f;)$0331271bace68e97$var$V = f, $0331271bace68e97$var$ik(f, b, c), f = f.sibling;
                $0331271bace68e97$var$V = e;
                $0331271bace68e97$var$Jj = h;
                $0331271bace68e97$var$U = l;
            }
            $0331271bace68e97$var$kk(a, b, c);
        } else 0 !== (e.subtreeFlags & 8772) && null !== f ? (f.return = e, $0331271bace68e97$var$V = f) : $0331271bace68e97$var$kk(a, b, c);
    }
}
function $0331271bace68e97$var$kk(a) {
    for(; null !== $0331271bace68e97$var$V;){
        var b = $0331271bace68e97$var$V;
        if (0 !== (b.flags & 8772)) {
            var c = b.alternate;
            try {
                if (0 !== (b.flags & 8772)) switch(b.tag){
                    case 0:
                    case 11:
                    case 15:
                        $0331271bace68e97$var$U || $0331271bace68e97$var$Qj(5, b);
                        break;
                    case 1:
                        var d = b.stateNode;
                        if (b.flags & 4 && !$0331271bace68e97$var$U) {
                            if (null === c) d.componentDidMount();
                            else {
                                var e = b.elementType === b.type ? c.memoizedProps : $0331271bace68e97$var$Ci(b.type, c.memoizedProps);
                                d.componentDidUpdate(e, c.memoizedState, d.__reactInternalSnapshotBeforeUpdate);
                            }
                        }
                        var f = b.updateQueue;
                        null !== f && $0331271bace68e97$var$sh(b, f, d);
                        break;
                    case 3:
                        var g = b.updateQueue;
                        if (null !== g) {
                            c = null;
                            if (null !== b.child) switch(b.child.tag){
                                case 5:
                                    c = b.child.stateNode;
                                    break;
                                case 1:
                                    c = b.child.stateNode;
                            }
                            $0331271bace68e97$var$sh(b, g, c);
                        }
                        break;
                    case 5:
                        var h = b.stateNode;
                        if (null === c && b.flags & 4) {
                            c = h;
                            var k = b.memoizedProps;
                            switch(b.type){
                                case "button":
                                case "input":
                                case "select":
                                case "textarea":
                                    k.autoFocus && c.focus();
                                    break;
                                case "img":
                                    k.src && (c.src = k.src);
                            }
                        }
                        break;
                    case 6:
                        break;
                    case 4:
                        break;
                    case 12:
                        break;
                    case 13:
                        if (null === b.memoizedState) {
                            var l = b.alternate;
                            if (null !== l) {
                                var m = l.memoizedState;
                                if (null !== m) {
                                    var q = m.dehydrated;
                                    null !== q && $0331271bace68e97$var$bd(q);
                                }
                            }
                        }
                        break;
                    case 19:
                    case 17:
                    case 21:
                    case 22:
                    case 23:
                    case 25:
                        break;
                    default:
                        throw Error($0331271bace68e97$var$p(163));
                }
                $0331271bace68e97$var$U || b.flags & 512 && $0331271bace68e97$var$Rj(b);
            } catch (r) {
                $0331271bace68e97$var$W(b, b.return, r);
            }
        }
        if (b === a) {
            $0331271bace68e97$var$V = null;
            break;
        }
        c = b.sibling;
        if (null !== c) {
            c.return = b.return;
            $0331271bace68e97$var$V = c;
            break;
        }
        $0331271bace68e97$var$V = b.return;
    }
}
function $0331271bace68e97$var$gk(a) {
    for(; null !== $0331271bace68e97$var$V;){
        var b = $0331271bace68e97$var$V;
        if (b === a) {
            $0331271bace68e97$var$V = null;
            break;
        }
        var c = b.sibling;
        if (null !== c) {
            c.return = b.return;
            $0331271bace68e97$var$V = c;
            break;
        }
        $0331271bace68e97$var$V = b.return;
    }
}
function $0331271bace68e97$var$jk(a) {
    for(; null !== $0331271bace68e97$var$V;){
        var b = $0331271bace68e97$var$V;
        try {
            switch(b.tag){
                case 0:
                case 11:
                case 15:
                    var c = b.return;
                    try {
                        $0331271bace68e97$var$Qj(4, b);
                    } catch (k) {
                        $0331271bace68e97$var$W(b, c, k);
                    }
                    break;
                case 1:
                    var d = b.stateNode;
                    if ("function" === typeof d.componentDidMount) {
                        var e = b.return;
                        try {
                            d.componentDidMount();
                        } catch (k) {
                            $0331271bace68e97$var$W(b, e, k);
                        }
                    }
                    var f = b.return;
                    try {
                        $0331271bace68e97$var$Rj(b);
                    } catch (k) {
                        $0331271bace68e97$var$W(b, f, k);
                    }
                    break;
                case 5:
                    var g = b.return;
                    try {
                        $0331271bace68e97$var$Rj(b);
                    } catch (k) {
                        $0331271bace68e97$var$W(b, g, k);
                    }
            }
        } catch (k) {
            $0331271bace68e97$var$W(b, b.return, k);
        }
        if (b === a) {
            $0331271bace68e97$var$V = null;
            break;
        }
        var h = b.sibling;
        if (null !== h) {
            h.return = b.return;
            $0331271bace68e97$var$V = h;
            break;
        }
        $0331271bace68e97$var$V = b.return;
    }
}
var $0331271bace68e97$var$lk = Math.ceil, $0331271bace68e97$var$mk = $0331271bace68e97$var$ua.ReactCurrentDispatcher, $0331271bace68e97$var$nk = $0331271bace68e97$var$ua.ReactCurrentOwner, $0331271bace68e97$var$ok = $0331271bace68e97$var$ua.ReactCurrentBatchConfig, $0331271bace68e97$var$K = 0, $0331271bace68e97$var$Q = null, $0331271bace68e97$var$Y = null, $0331271bace68e97$var$Z = 0, $0331271bace68e97$var$fj = 0, $0331271bace68e97$var$ej = $0331271bace68e97$var$Uf(0), $0331271bace68e97$var$T = 0, $0331271bace68e97$var$pk = null, $0331271bace68e97$var$rh = 0, $0331271bace68e97$var$qk = 0, $0331271bace68e97$var$rk = 0, $0331271bace68e97$var$sk = null, $0331271bace68e97$var$tk = null, $0331271bace68e97$var$fk = 0, $0331271bace68e97$var$Gj = Infinity, $0331271bace68e97$var$uk = null, $0331271bace68e97$var$Oi = !1, $0331271bace68e97$var$Pi = null, $0331271bace68e97$var$Ri = null, $0331271bace68e97$var$vk = !1, $0331271bace68e97$var$wk = null, $0331271bace68e97$var$xk = 0, $0331271bace68e97$var$yk = 0, $0331271bace68e97$var$zk = null, $0331271bace68e97$var$Ak = -1, $0331271bace68e97$var$Bk = 0;
function $0331271bace68e97$var$R() {
    return 0 !== ($0331271bace68e97$var$K & 6) ? $0331271bace68e97$var$B() : -1 !== $0331271bace68e97$var$Ak ? $0331271bace68e97$var$Ak : $0331271bace68e97$var$Ak = $0331271bace68e97$var$B();
}
function $0331271bace68e97$var$yi(a) {
    if (0 === (a.mode & 1)) return 1;
    if (0 !== ($0331271bace68e97$var$K & 2) && 0 !== $0331271bace68e97$var$Z) return $0331271bace68e97$var$Z & -$0331271bace68e97$var$Z;
    if (null !== $0331271bace68e97$var$Kg.transition) return 0 === $0331271bace68e97$var$Bk && ($0331271bace68e97$var$Bk = $0331271bace68e97$var$yc()), $0331271bace68e97$var$Bk;
    a = $0331271bace68e97$var$C;
    if (0 !== a) return a;
    a = window.event;
    a = void 0 === a ? 16 : $0331271bace68e97$var$jd(a.type);
    return a;
}
function $0331271bace68e97$var$gi(a, b, c, d) {
    if (50 < $0331271bace68e97$var$yk) throw $0331271bace68e97$var$yk = 0, $0331271bace68e97$var$zk = null, Error($0331271bace68e97$var$p(185));
    $0331271bace68e97$var$Ac(a, c, d);
    if (0 === ($0331271bace68e97$var$K & 2) || a !== $0331271bace68e97$var$Q) a === $0331271bace68e97$var$Q && (0 === ($0331271bace68e97$var$K & 2) && ($0331271bace68e97$var$qk |= c), 4 === $0331271bace68e97$var$T && $0331271bace68e97$var$Ck(a, $0331271bace68e97$var$Z)), $0331271bace68e97$var$Dk(a, d), 1 === c && 0 === $0331271bace68e97$var$K && 0 === (b.mode & 1) && ($0331271bace68e97$var$Gj = $0331271bace68e97$var$B() + 500, $0331271bace68e97$var$fg && $0331271bace68e97$var$jg());
}
function $0331271bace68e97$var$Dk(a, b) {
    var c = a.callbackNode;
    $0331271bace68e97$var$wc(a, b);
    var d = $0331271bace68e97$var$uc(a, a === $0331271bace68e97$var$Q ? $0331271bace68e97$var$Z : 0);
    if (0 === d) null !== c && $0331271bace68e97$var$bc(c), a.callbackNode = null, a.callbackPriority = 0;
    else if (b = d & -d, a.callbackPriority !== b) {
        null != c && $0331271bace68e97$var$bc(c);
        if (1 === b) 0 === a.tag ? $0331271bace68e97$var$ig($0331271bace68e97$var$Ek.bind(null, a)) : $0331271bace68e97$var$hg($0331271bace68e97$var$Ek.bind(null, a)), $0331271bace68e97$var$Jf(function() {
            0 === ($0331271bace68e97$var$K & 6) && $0331271bace68e97$var$jg();
        }), c = null;
        else {
            switch($0331271bace68e97$var$Dc(d)){
                case 1:
                    c = $0331271bace68e97$var$fc;
                    break;
                case 4:
                    c = $0331271bace68e97$var$gc;
                    break;
                case 16:
                    c = $0331271bace68e97$var$hc;
                    break;
                case 536870912:
                    c = $0331271bace68e97$var$jc;
                    break;
                default:
                    c = $0331271bace68e97$var$hc;
            }
            c = $0331271bace68e97$var$Fk(c, $0331271bace68e97$var$Gk.bind(null, a));
        }
        a.callbackPriority = b;
        a.callbackNode = c;
    }
}
function $0331271bace68e97$var$Gk(a, b) {
    $0331271bace68e97$var$Ak = -1;
    $0331271bace68e97$var$Bk = 0;
    if (0 !== ($0331271bace68e97$var$K & 6)) throw Error($0331271bace68e97$var$p(327));
    var c = a.callbackNode;
    if ($0331271bace68e97$var$Hk() && a.callbackNode !== c) return null;
    var d = $0331271bace68e97$var$uc(a, a === $0331271bace68e97$var$Q ? $0331271bace68e97$var$Z : 0);
    if (0 === d) return null;
    if (0 !== (d & 30) || 0 !== (d & a.expiredLanes) || b) b = $0331271bace68e97$var$Ik(a, d);
    else {
        b = d;
        var e = $0331271bace68e97$var$K;
        $0331271bace68e97$var$K |= 2;
        var f = $0331271bace68e97$var$Jk();
        if ($0331271bace68e97$var$Q !== a || $0331271bace68e97$var$Z !== b) $0331271bace68e97$var$uk = null, $0331271bace68e97$var$Gj = $0331271bace68e97$var$B() + 500, $0331271bace68e97$var$Kk(a, b);
        for(;;)try {
            $0331271bace68e97$var$Lk();
            break;
        } catch (h) {
            $0331271bace68e97$var$Mk(a, h);
        }
        $0331271bace68e97$var$$g();
        $0331271bace68e97$var$mk.current = f;
        $0331271bace68e97$var$K = e;
        null !== $0331271bace68e97$var$Y ? b = 0 : ($0331271bace68e97$var$Q = null, $0331271bace68e97$var$Z = 0, b = $0331271bace68e97$var$T);
    }
    if (0 !== b) {
        2 === b && (e = $0331271bace68e97$var$xc(a), 0 !== e && (d = e, b = $0331271bace68e97$var$Nk(a, e)));
        if (1 === b) throw c = $0331271bace68e97$var$pk, $0331271bace68e97$var$Kk(a, 0), $0331271bace68e97$var$Ck(a, d), $0331271bace68e97$var$Dk(a, $0331271bace68e97$var$B()), c;
        if (6 === b) $0331271bace68e97$var$Ck(a, d);
        else {
            e = a.current.alternate;
            if (0 === (d & 30) && !$0331271bace68e97$var$Ok(e) && (b = $0331271bace68e97$var$Ik(a, d), 2 === b && (f = $0331271bace68e97$var$xc(a), 0 !== f && (d = f, b = $0331271bace68e97$var$Nk(a, f))), 1 === b)) throw c = $0331271bace68e97$var$pk, $0331271bace68e97$var$Kk(a, 0), $0331271bace68e97$var$Ck(a, d), $0331271bace68e97$var$Dk(a, $0331271bace68e97$var$B()), c;
            a.finishedWork = e;
            a.finishedLanes = d;
            switch(b){
                case 0:
                case 1:
                    throw Error($0331271bace68e97$var$p(345));
                case 2:
                    $0331271bace68e97$var$Pk(a, $0331271bace68e97$var$tk, $0331271bace68e97$var$uk);
                    break;
                case 3:
                    $0331271bace68e97$var$Ck(a, d);
                    if ((d & 130023424) === d && (b = $0331271bace68e97$var$fk + 500 - $0331271bace68e97$var$B(), 10 < b)) {
                        if (0 !== $0331271bace68e97$var$uc(a, 0)) break;
                        e = a.suspendedLanes;
                        if ((e & d) !== d) {
                            $0331271bace68e97$var$R();
                            a.pingedLanes |= a.suspendedLanes & e;
                            break;
                        }
                        a.timeoutHandle = $0331271bace68e97$var$Ff($0331271bace68e97$var$Pk.bind(null, a, $0331271bace68e97$var$tk, $0331271bace68e97$var$uk), b);
                        break;
                    }
                    $0331271bace68e97$var$Pk(a, $0331271bace68e97$var$tk, $0331271bace68e97$var$uk);
                    break;
                case 4:
                    $0331271bace68e97$var$Ck(a, d);
                    if ((d & 4194240) === d) break;
                    b = a.eventTimes;
                    for(e = -1; 0 < d;){
                        var g = 31 - $0331271bace68e97$var$oc(d);
                        f = 1 << g;
                        g = b[g];
                        g > e && (e = g);
                        d &= ~f;
                    }
                    d = e;
                    d = $0331271bace68e97$var$B() - d;
                    d = (120 > d ? 120 : 480 > d ? 480 : 1080 > d ? 1080 : 1920 > d ? 1920 : 3E3 > d ? 3E3 : 4320 > d ? 4320 : 1960 * $0331271bace68e97$var$lk(d / 1960)) - d;
                    if (10 < d) {
                        a.timeoutHandle = $0331271bace68e97$var$Ff($0331271bace68e97$var$Pk.bind(null, a, $0331271bace68e97$var$tk, $0331271bace68e97$var$uk), d);
                        break;
                    }
                    $0331271bace68e97$var$Pk(a, $0331271bace68e97$var$tk, $0331271bace68e97$var$uk);
                    break;
                case 5:
                    $0331271bace68e97$var$Pk(a, $0331271bace68e97$var$tk, $0331271bace68e97$var$uk);
                    break;
                default:
                    throw Error($0331271bace68e97$var$p(329));
            }
        }
    }
    $0331271bace68e97$var$Dk(a, $0331271bace68e97$var$B());
    return a.callbackNode === c ? $0331271bace68e97$var$Gk.bind(null, a) : null;
}
function $0331271bace68e97$var$Nk(a, b) {
    var c = $0331271bace68e97$var$sk;
    a.current.memoizedState.isDehydrated && ($0331271bace68e97$var$Kk(a, b).flags |= 256);
    a = $0331271bace68e97$var$Ik(a, b);
    2 !== a && (b = $0331271bace68e97$var$tk, $0331271bace68e97$var$tk = c, null !== b && $0331271bace68e97$var$Fj(b));
    return a;
}
function $0331271bace68e97$var$Fj(a) {
    null === $0331271bace68e97$var$tk ? $0331271bace68e97$var$tk = a : $0331271bace68e97$var$tk.push.apply($0331271bace68e97$var$tk, a);
}
function $0331271bace68e97$var$Ok(a) {
    for(var b = a;;){
        if (b.flags & 16384) {
            var c = b.updateQueue;
            if (null !== c && (c = c.stores, null !== c)) for(var d = 0; d < c.length; d++){
                var e = c[d], f = e.getSnapshot;
                e = e.value;
                try {
                    if (!$0331271bace68e97$var$He(f(), e)) return !1;
                } catch (g) {
                    return !1;
                }
            }
        }
        c = b.child;
        if (b.subtreeFlags & 16384 && null !== c) c.return = b, b = c;
        else {
            if (b === a) break;
            for(; null === b.sibling;){
                if (null === b.return || b.return === a) return !0;
                b = b.return;
            }
            b.sibling.return = b.return;
            b = b.sibling;
        }
    }
    return !0;
}
function $0331271bace68e97$var$Ck(a, b) {
    b &= ~$0331271bace68e97$var$rk;
    b &= ~$0331271bace68e97$var$qk;
    a.suspendedLanes |= b;
    a.pingedLanes &= ~b;
    for(a = a.expirationTimes; 0 < b;){
        var c = 31 - $0331271bace68e97$var$oc(b), d = 1 << c;
        a[c] = -1;
        b &= ~d;
    }
}
function $0331271bace68e97$var$Ek(a) {
    if (0 !== ($0331271bace68e97$var$K & 6)) throw Error($0331271bace68e97$var$p(327));
    $0331271bace68e97$var$Hk();
    var b = $0331271bace68e97$var$uc(a, 0);
    if (0 === (b & 1)) return $0331271bace68e97$var$Dk(a, $0331271bace68e97$var$B()), null;
    var c = $0331271bace68e97$var$Ik(a, b);
    if (0 !== a.tag && 2 === c) {
        var d = $0331271bace68e97$var$xc(a);
        0 !== d && (b = d, c = $0331271bace68e97$var$Nk(a, d));
    }
    if (1 === c) throw c = $0331271bace68e97$var$pk, $0331271bace68e97$var$Kk(a, 0), $0331271bace68e97$var$Ck(a, b), $0331271bace68e97$var$Dk(a, $0331271bace68e97$var$B()), c;
    if (6 === c) throw Error($0331271bace68e97$var$p(345));
    a.finishedWork = a.current.alternate;
    a.finishedLanes = b;
    $0331271bace68e97$var$Pk(a, $0331271bace68e97$var$tk, $0331271bace68e97$var$uk);
    $0331271bace68e97$var$Dk(a, $0331271bace68e97$var$B());
    return null;
}
function $0331271bace68e97$var$Qk(a, b) {
    var c = $0331271bace68e97$var$K;
    $0331271bace68e97$var$K |= 1;
    try {
        return a(b);
    } finally{
        $0331271bace68e97$var$K = c, 0 === $0331271bace68e97$var$K && ($0331271bace68e97$var$Gj = $0331271bace68e97$var$B() + 500, $0331271bace68e97$var$fg && $0331271bace68e97$var$jg());
    }
}
function $0331271bace68e97$var$Rk(a) {
    null !== $0331271bace68e97$var$wk && 0 === $0331271bace68e97$var$wk.tag && 0 === ($0331271bace68e97$var$K & 6) && $0331271bace68e97$var$Hk();
    var b = $0331271bace68e97$var$K;
    $0331271bace68e97$var$K |= 1;
    var c = $0331271bace68e97$var$ok.transition, d = $0331271bace68e97$var$C;
    try {
        if ($0331271bace68e97$var$ok.transition = null, $0331271bace68e97$var$C = 1, a) return a();
    } finally{
        $0331271bace68e97$var$C = d, $0331271bace68e97$var$ok.transition = c, $0331271bace68e97$var$K = b, 0 === ($0331271bace68e97$var$K & 6) && $0331271bace68e97$var$jg();
    }
}
function $0331271bace68e97$var$Hj() {
    $0331271bace68e97$var$fj = $0331271bace68e97$var$ej.current;
    $0331271bace68e97$var$E($0331271bace68e97$var$ej);
}
function $0331271bace68e97$var$Kk(a, b) {
    a.finishedWork = null;
    a.finishedLanes = 0;
    var c = a.timeoutHandle;
    -1 !== c && (a.timeoutHandle = -1, $0331271bace68e97$var$Gf(c));
    if (null !== $0331271bace68e97$var$Y) for(c = $0331271bace68e97$var$Y.return; null !== c;){
        var d = c;
        $0331271bace68e97$var$wg(d);
        switch(d.tag){
            case 1:
                d = d.type.childContextTypes;
                null !== d && void 0 !== d && $0331271bace68e97$var$$f();
                break;
            case 3:
                $0331271bace68e97$var$zh();
                $0331271bace68e97$var$E($0331271bace68e97$var$Wf);
                $0331271bace68e97$var$E($0331271bace68e97$var$H);
                $0331271bace68e97$var$Eh();
                break;
            case 5:
                $0331271bace68e97$var$Bh(d);
                break;
            case 4:
                $0331271bace68e97$var$zh();
                break;
            case 13:
                $0331271bace68e97$var$E($0331271bace68e97$var$L);
                break;
            case 19:
                $0331271bace68e97$var$E($0331271bace68e97$var$L);
                break;
            case 10:
                $0331271bace68e97$var$ah(d.type._context);
                break;
            case 22:
            case 23:
                $0331271bace68e97$var$Hj();
        }
        c = c.return;
    }
    $0331271bace68e97$var$Q = a;
    $0331271bace68e97$var$Y = a = $0331271bace68e97$var$Pg(a.current, null);
    $0331271bace68e97$var$Z = $0331271bace68e97$var$fj = b;
    $0331271bace68e97$var$T = 0;
    $0331271bace68e97$var$pk = null;
    $0331271bace68e97$var$rk = $0331271bace68e97$var$qk = $0331271bace68e97$var$rh = 0;
    $0331271bace68e97$var$tk = $0331271bace68e97$var$sk = null;
    if (null !== $0331271bace68e97$var$fh) {
        for(b = 0; b < $0331271bace68e97$var$fh.length; b++)if (c = $0331271bace68e97$var$fh[b], d = c.interleaved, null !== d) {
            c.interleaved = null;
            var e = d.next, f = c.pending;
            if (null !== f) {
                var g = f.next;
                f.next = e;
                d.next = g;
            }
            c.pending = d;
        }
        $0331271bace68e97$var$fh = null;
    }
    return a;
}
function $0331271bace68e97$var$Mk(a, b) {
    do {
        var c = $0331271bace68e97$var$Y;
        try {
            $0331271bace68e97$var$$g();
            $0331271bace68e97$var$Fh.current = $0331271bace68e97$var$Rh;
            if ($0331271bace68e97$var$Ih) {
                for(var d = $0331271bace68e97$var$M.memoizedState; null !== d;){
                    var e = d.queue;
                    null !== e && (e.pending = null);
                    d = d.next;
                }
                $0331271bace68e97$var$Ih = !1;
            }
            $0331271bace68e97$var$Hh = 0;
            $0331271bace68e97$var$O = $0331271bace68e97$var$N = $0331271bace68e97$var$M = null;
            $0331271bace68e97$var$Jh = !1;
            $0331271bace68e97$var$Kh = 0;
            $0331271bace68e97$var$nk.current = null;
            if (null === c || null === c.return) {
                $0331271bace68e97$var$T = 1;
                $0331271bace68e97$var$pk = b;
                $0331271bace68e97$var$Y = null;
                break;
            }
            a: {
                var f = a, g = c.return, h = c, k = b;
                b = $0331271bace68e97$var$Z;
                h.flags |= 32768;
                if (null !== k && "object" === (typeof k === "undefined" ? "undefined" : (0, $bJtXW._)(k)) && "function" === typeof k.then) {
                    var l = k, m = h, q = m.tag;
                    if (0 === (m.mode & 1) && (0 === q || 11 === q || 15 === q)) {
                        var r = m.alternate;
                        r ? (m.updateQueue = r.updateQueue, m.memoizedState = r.memoizedState, m.lanes = r.lanes) : (m.updateQueue = null, m.memoizedState = null);
                    }
                    var y = $0331271bace68e97$var$Ui(g);
                    if (null !== y) {
                        y.flags &= -257;
                        $0331271bace68e97$var$Vi(y, g, h, f, b);
                        y.mode & 1 && $0331271bace68e97$var$Si(f, l, b);
                        b = y;
                        k = l;
                        var n = b.updateQueue;
                        if (null === n) {
                            var t = new Set;
                            t.add(k);
                            b.updateQueue = t;
                        } else n.add(k);
                        break a;
                    } else {
                        if (0 === (b & 1)) {
                            $0331271bace68e97$var$Si(f, l, b);
                            $0331271bace68e97$var$tj();
                            break a;
                        }
                        k = Error($0331271bace68e97$var$p(426));
                    }
                } else if ($0331271bace68e97$var$I && h.mode & 1) {
                    var J = $0331271bace68e97$var$Ui(g);
                    if (null !== J) {
                        0 === (J.flags & 65536) && (J.flags |= 256);
                        $0331271bace68e97$var$Vi(J, g, h, f, b);
                        $0331271bace68e97$var$Jg($0331271bace68e97$var$Ji(k, h));
                        break a;
                    }
                }
                f = k = $0331271bace68e97$var$Ji(k, h);
                4 !== $0331271bace68e97$var$T && ($0331271bace68e97$var$T = 2);
                null === $0331271bace68e97$var$sk ? $0331271bace68e97$var$sk = [
                    f
                ] : $0331271bace68e97$var$sk.push(f);
                f = g;
                do {
                    switch(f.tag){
                        case 3:
                            f.flags |= 65536;
                            b &= -b;
                            f.lanes |= b;
                            var x = $0331271bace68e97$var$Ni(f, k, b);
                            $0331271bace68e97$var$ph(f, x);
                            break a;
                        case 1:
                            h = k;
                            var w = f.type, u = f.stateNode;
                            if (0 === (f.flags & 128) && ("function" === typeof w.getDerivedStateFromError || null !== u && "function" === typeof u.componentDidCatch && (null === $0331271bace68e97$var$Ri || !$0331271bace68e97$var$Ri.has(u)))) {
                                f.flags |= 65536;
                                b &= -b;
                                f.lanes |= b;
                                var F = $0331271bace68e97$var$Qi(f, h, b);
                                $0331271bace68e97$var$ph(f, F);
                                break a;
                            }
                    }
                    f = f.return;
                }while (null !== f);
            }
            $0331271bace68e97$var$Sk(c);
        } catch (na) {
            b = na;
            $0331271bace68e97$var$Y === c && null !== c && ($0331271bace68e97$var$Y = c = c.return);
            continue;
        }
        break;
    }while (1);
}
function $0331271bace68e97$var$Jk() {
    var a = $0331271bace68e97$var$mk.current;
    $0331271bace68e97$var$mk.current = $0331271bace68e97$var$Rh;
    return null === a ? $0331271bace68e97$var$Rh : a;
}
function $0331271bace68e97$var$tj() {
    if (0 === $0331271bace68e97$var$T || 3 === $0331271bace68e97$var$T || 2 === $0331271bace68e97$var$T) $0331271bace68e97$var$T = 4;
    null === $0331271bace68e97$var$Q || 0 === ($0331271bace68e97$var$rh & 268435455) && 0 === ($0331271bace68e97$var$qk & 268435455) || $0331271bace68e97$var$Ck($0331271bace68e97$var$Q, $0331271bace68e97$var$Z);
}
function $0331271bace68e97$var$Ik(a, b) {
    var c = $0331271bace68e97$var$K;
    $0331271bace68e97$var$K |= 2;
    var d = $0331271bace68e97$var$Jk();
    if ($0331271bace68e97$var$Q !== a || $0331271bace68e97$var$Z !== b) $0331271bace68e97$var$uk = null, $0331271bace68e97$var$Kk(a, b);
    for(;;)try {
        $0331271bace68e97$var$Tk();
        break;
    } catch (e) {
        $0331271bace68e97$var$Mk(a, e);
    }
    $0331271bace68e97$var$$g();
    $0331271bace68e97$var$K = c;
    $0331271bace68e97$var$mk.current = d;
    if (null !== $0331271bace68e97$var$Y) throw Error($0331271bace68e97$var$p(261));
    $0331271bace68e97$var$Q = null;
    $0331271bace68e97$var$Z = 0;
    return $0331271bace68e97$var$T;
}
function $0331271bace68e97$var$Tk() {
    for(; null !== $0331271bace68e97$var$Y;)$0331271bace68e97$var$Uk($0331271bace68e97$var$Y);
}
function $0331271bace68e97$var$Lk() {
    for(; null !== $0331271bace68e97$var$Y && !$0331271bace68e97$var$cc();)$0331271bace68e97$var$Uk($0331271bace68e97$var$Y);
}
function $0331271bace68e97$var$Uk(a) {
    var b = $0331271bace68e97$var$Vk(a.alternate, a, $0331271bace68e97$var$fj);
    a.memoizedProps = a.pendingProps;
    null === b ? $0331271bace68e97$var$Sk(a) : $0331271bace68e97$var$Y = b;
    $0331271bace68e97$var$nk.current = null;
}
function $0331271bace68e97$var$Sk(a) {
    var b = a;
    do {
        var c = b.alternate;
        a = b.return;
        if (0 === (b.flags & 32768)) {
            if (c = $0331271bace68e97$var$Ej(c, b, $0331271bace68e97$var$fj), null !== c) {
                $0331271bace68e97$var$Y = c;
                return;
            }
        } else {
            c = $0331271bace68e97$var$Ij(c, b);
            if (null !== c) {
                c.flags &= 32767;
                $0331271bace68e97$var$Y = c;
                return;
            }
            if (null !== a) a.flags |= 32768, a.subtreeFlags = 0, a.deletions = null;
            else {
                $0331271bace68e97$var$T = 6;
                $0331271bace68e97$var$Y = null;
                return;
            }
        }
        b = b.sibling;
        if (null !== b) {
            $0331271bace68e97$var$Y = b;
            return;
        }
        $0331271bace68e97$var$Y = b = a;
    }while (null !== b);
    0 === $0331271bace68e97$var$T && ($0331271bace68e97$var$T = 5);
}
function $0331271bace68e97$var$Pk(a, b, c) {
    var d = $0331271bace68e97$var$C, e = $0331271bace68e97$var$ok.transition;
    try {
        $0331271bace68e97$var$ok.transition = null, $0331271bace68e97$var$C = 1, $0331271bace68e97$var$Wk(a, b, c, d);
    } finally{
        $0331271bace68e97$var$ok.transition = e, $0331271bace68e97$var$C = d;
    }
    return null;
}
function $0331271bace68e97$var$Wk(a, b, c, d) {
    do $0331271bace68e97$var$Hk();
    while (null !== $0331271bace68e97$var$wk);
    if (0 !== ($0331271bace68e97$var$K & 6)) throw Error($0331271bace68e97$var$p(327));
    c = a.finishedWork;
    var e = a.finishedLanes;
    if (null === c) return null;
    a.finishedWork = null;
    a.finishedLanes = 0;
    if (c === a.current) throw Error($0331271bace68e97$var$p(177));
    a.callbackNode = null;
    a.callbackPriority = 0;
    var f = c.lanes | c.childLanes;
    $0331271bace68e97$var$Bc(a, f);
    a === $0331271bace68e97$var$Q && ($0331271bace68e97$var$Y = $0331271bace68e97$var$Q = null, $0331271bace68e97$var$Z = 0);
    0 === (c.subtreeFlags & 2064) && 0 === (c.flags & 2064) || $0331271bace68e97$var$vk || ($0331271bace68e97$var$vk = !0, $0331271bace68e97$var$Fk($0331271bace68e97$var$hc, function() {
        $0331271bace68e97$var$Hk();
        return null;
    }));
    f = 0 !== (c.flags & 15990);
    if (0 !== (c.subtreeFlags & 15990) || f) {
        f = $0331271bace68e97$var$ok.transition;
        $0331271bace68e97$var$ok.transition = null;
        var g = $0331271bace68e97$var$C;
        $0331271bace68e97$var$C = 1;
        var h = $0331271bace68e97$var$K;
        $0331271bace68e97$var$K |= 4;
        $0331271bace68e97$var$nk.current = null;
        $0331271bace68e97$var$Oj(a, c);
        $0331271bace68e97$var$dk(c, a);
        $0331271bace68e97$var$Oe($0331271bace68e97$var$Df);
        $0331271bace68e97$var$dd = !!$0331271bace68e97$var$Cf;
        $0331271bace68e97$var$Df = $0331271bace68e97$var$Cf = null;
        a.current = c;
        $0331271bace68e97$var$hk(c, a, e);
        $0331271bace68e97$var$dc();
        $0331271bace68e97$var$K = h;
        $0331271bace68e97$var$C = g;
        $0331271bace68e97$var$ok.transition = f;
    } else a.current = c;
    $0331271bace68e97$var$vk && ($0331271bace68e97$var$vk = !1, $0331271bace68e97$var$wk = a, $0331271bace68e97$var$xk = e);
    f = a.pendingLanes;
    0 === f && ($0331271bace68e97$var$Ri = null);
    $0331271bace68e97$var$mc(c.stateNode, d);
    $0331271bace68e97$var$Dk(a, $0331271bace68e97$var$B());
    if (null !== b) for(d = a.onRecoverableError, c = 0; c < b.length; c++)e = b[c], d(e.value, {
        componentStack: e.stack,
        digest: e.digest
    });
    if ($0331271bace68e97$var$Oi) throw $0331271bace68e97$var$Oi = !1, a = $0331271bace68e97$var$Pi, $0331271bace68e97$var$Pi = null, a;
    0 !== ($0331271bace68e97$var$xk & 1) && 0 !== a.tag && $0331271bace68e97$var$Hk();
    f = a.pendingLanes;
    0 !== (f & 1) ? a === $0331271bace68e97$var$zk ? $0331271bace68e97$var$yk++ : ($0331271bace68e97$var$yk = 0, $0331271bace68e97$var$zk = a) : $0331271bace68e97$var$yk = 0;
    $0331271bace68e97$var$jg();
    return null;
}
function $0331271bace68e97$var$Hk() {
    if (null !== $0331271bace68e97$var$wk) {
        var a = $0331271bace68e97$var$Dc($0331271bace68e97$var$xk), b = $0331271bace68e97$var$ok.transition, c = $0331271bace68e97$var$C;
        try {
            $0331271bace68e97$var$ok.transition = null;
            $0331271bace68e97$var$C = 16 > a ? 16 : a;
            if (null === $0331271bace68e97$var$wk) var d = !1;
            else {
                a = $0331271bace68e97$var$wk;
                $0331271bace68e97$var$wk = null;
                $0331271bace68e97$var$xk = 0;
                if (0 !== ($0331271bace68e97$var$K & 6)) throw Error($0331271bace68e97$var$p(331));
                var e = $0331271bace68e97$var$K;
                $0331271bace68e97$var$K |= 4;
                for($0331271bace68e97$var$V = a.current; null !== $0331271bace68e97$var$V;){
                    var f = $0331271bace68e97$var$V, g = f.child;
                    if (0 !== ($0331271bace68e97$var$V.flags & 16)) {
                        var h = f.deletions;
                        if (null !== h) {
                            for(var k = 0; k < h.length; k++){
                                var l = h[k];
                                for($0331271bace68e97$var$V = l; null !== $0331271bace68e97$var$V;){
                                    var m = $0331271bace68e97$var$V;
                                    switch(m.tag){
                                        case 0:
                                        case 11:
                                        case 15:
                                            $0331271bace68e97$var$Pj(8, m, f);
                                    }
                                    var q = m.child;
                                    if (null !== q) q.return = m, $0331271bace68e97$var$V = q;
                                    else for(; null !== $0331271bace68e97$var$V;){
                                        m = $0331271bace68e97$var$V;
                                        var r = m.sibling, y = m.return;
                                        $0331271bace68e97$var$Sj(m);
                                        if (m === l) {
                                            $0331271bace68e97$var$V = null;
                                            break;
                                        }
                                        if (null !== r) {
                                            r.return = y;
                                            $0331271bace68e97$var$V = r;
                                            break;
                                        }
                                        $0331271bace68e97$var$V = y;
                                    }
                                }
                            }
                            var n = f.alternate;
                            if (null !== n) {
                                var t = n.child;
                                if (null !== t) {
                                    n.child = null;
                                    do {
                                        var J = t.sibling;
                                        t.sibling = null;
                                        t = J;
                                    }while (null !== t);
                                }
                            }
                            $0331271bace68e97$var$V = f;
                        }
                    }
                    if (0 !== (f.subtreeFlags & 2064) && null !== g) g.return = f, $0331271bace68e97$var$V = g;
                    else b: for(; null !== $0331271bace68e97$var$V;){
                        f = $0331271bace68e97$var$V;
                        if (0 !== (f.flags & 2048)) switch(f.tag){
                            case 0:
                            case 11:
                            case 15:
                                $0331271bace68e97$var$Pj(9, f, f.return);
                        }
                        var x = f.sibling;
                        if (null !== x) {
                            x.return = f.return;
                            $0331271bace68e97$var$V = x;
                            break b;
                        }
                        $0331271bace68e97$var$V = f.return;
                    }
                }
                var w = a.current;
                for($0331271bace68e97$var$V = w; null !== $0331271bace68e97$var$V;){
                    g = $0331271bace68e97$var$V;
                    var u = g.child;
                    if (0 !== (g.subtreeFlags & 2064) && null !== u) u.return = g, $0331271bace68e97$var$V = u;
                    else b: for(g = w; null !== $0331271bace68e97$var$V;){
                        h = $0331271bace68e97$var$V;
                        if (0 !== (h.flags & 2048)) try {
                            switch(h.tag){
                                case 0:
                                case 11:
                                case 15:
                                    $0331271bace68e97$var$Qj(9, h);
                            }
                        } catch (na) {
                            $0331271bace68e97$var$W(h, h.return, na);
                        }
                        if (h === g) {
                            $0331271bace68e97$var$V = null;
                            break b;
                        }
                        var F = h.sibling;
                        if (null !== F) {
                            F.return = h.return;
                            $0331271bace68e97$var$V = F;
                            break b;
                        }
                        $0331271bace68e97$var$V = h.return;
                    }
                }
                $0331271bace68e97$var$K = e;
                $0331271bace68e97$var$jg();
                if ($0331271bace68e97$var$lc && "function" === typeof $0331271bace68e97$var$lc.onPostCommitFiberRoot) try {
                    $0331271bace68e97$var$lc.onPostCommitFiberRoot($0331271bace68e97$var$kc, a);
                } catch (na) {}
                d = !0;
            }
            return d;
        } finally{
            $0331271bace68e97$var$C = c, $0331271bace68e97$var$ok.transition = b;
        }
    }
    return !1;
}
function $0331271bace68e97$var$Xk(a, b, c) {
    b = $0331271bace68e97$var$Ji(c, b);
    b = $0331271bace68e97$var$Ni(a, b, 1);
    a = $0331271bace68e97$var$nh(a, b, 1);
    b = $0331271bace68e97$var$R();
    null !== a && ($0331271bace68e97$var$Ac(a, 1, b), $0331271bace68e97$var$Dk(a, b));
}
function $0331271bace68e97$var$W(a, b, c) {
    if (3 === a.tag) $0331271bace68e97$var$Xk(a, a, c);
    else for(; null !== b;){
        if (3 === b.tag) {
            $0331271bace68e97$var$Xk(b, a, c);
            break;
        } else if (1 === b.tag) {
            var d = b.stateNode;
            if ("function" === typeof b.type.getDerivedStateFromError || "function" === typeof d.componentDidCatch && (null === $0331271bace68e97$var$Ri || !$0331271bace68e97$var$Ri.has(d))) {
                a = $0331271bace68e97$var$Ji(c, a);
                a = $0331271bace68e97$var$Qi(b, a, 1);
                b = $0331271bace68e97$var$nh(b, a, 1);
                a = $0331271bace68e97$var$R();
                null !== b && ($0331271bace68e97$var$Ac(b, 1, a), $0331271bace68e97$var$Dk(b, a));
                break;
            }
        }
        b = b.return;
    }
}
function $0331271bace68e97$var$Ti(a, b, c) {
    var d = a.pingCache;
    null !== d && d.delete(b);
    b = $0331271bace68e97$var$R();
    a.pingedLanes |= a.suspendedLanes & c;
    $0331271bace68e97$var$Q === a && ($0331271bace68e97$var$Z & c) === c && (4 === $0331271bace68e97$var$T || 3 === $0331271bace68e97$var$T && ($0331271bace68e97$var$Z & 130023424) === $0331271bace68e97$var$Z && 500 > $0331271bace68e97$var$B() - $0331271bace68e97$var$fk ? $0331271bace68e97$var$Kk(a, 0) : $0331271bace68e97$var$rk |= c);
    $0331271bace68e97$var$Dk(a, b);
}
function $0331271bace68e97$var$Yk(a, b) {
    0 === b && (0 === (a.mode & 1) ? b = 1 : (b = $0331271bace68e97$var$sc, $0331271bace68e97$var$sc <<= 1, 0 === ($0331271bace68e97$var$sc & 130023424) && ($0331271bace68e97$var$sc = 4194304)));
    var c = $0331271bace68e97$var$R();
    a = $0331271bace68e97$var$ih(a, b);
    null !== a && ($0331271bace68e97$var$Ac(a, b, c), $0331271bace68e97$var$Dk(a, c));
}
function $0331271bace68e97$var$uj(a) {
    var b = a.memoizedState, c = 0;
    null !== b && (c = b.retryLane);
    $0331271bace68e97$var$Yk(a, c);
}
function $0331271bace68e97$var$bk(a, b) {
    var c = 0;
    switch(a.tag){
        case 13:
            var d = a.stateNode;
            var e = a.memoizedState;
            null !== e && (c = e.retryLane);
            break;
        case 19:
            d = a.stateNode;
            break;
        default:
            throw Error($0331271bace68e97$var$p(314));
    }
    null !== d && d.delete(b);
    $0331271bace68e97$var$Yk(a, c);
}
var $0331271bace68e97$var$Vk;
$0331271bace68e97$var$Vk = function Vk(a, b, c) {
    if (null !== a) {
        if (a.memoizedProps !== b.pendingProps || $0331271bace68e97$var$Wf.current) $0331271bace68e97$var$dh = !0;
        else {
            if (0 === (a.lanes & c) && 0 === (b.flags & 128)) return $0331271bace68e97$var$dh = !1, $0331271bace68e97$var$yj(a, b, c);
            $0331271bace68e97$var$dh = 0 !== (a.flags & 131072) ? !0 : !1;
        }
    } else $0331271bace68e97$var$dh = !1, $0331271bace68e97$var$I && 0 !== (b.flags & 1048576) && $0331271bace68e97$var$ug(b, $0331271bace68e97$var$ng, b.index);
    b.lanes = 0;
    switch(b.tag){
        case 2:
            var d = b.type;
            $0331271bace68e97$var$ij(a, b);
            a = b.pendingProps;
            var e = $0331271bace68e97$var$Yf(b, $0331271bace68e97$var$H.current);
            $0331271bace68e97$var$ch(b, c);
            e = $0331271bace68e97$var$Nh(null, b, d, a, e, c);
            var f = $0331271bace68e97$var$Sh();
            b.flags |= 1;
            "object" === (typeof e === "undefined" ? "undefined" : (0, $bJtXW._)(e)) && null !== e && "function" === typeof e.render && void 0 === e.$$typeof ? (b.tag = 1, b.memoizedState = null, b.updateQueue = null, $0331271bace68e97$var$Zf(d) ? (f = !0, $0331271bace68e97$var$cg(b)) : f = !1, b.memoizedState = null !== e.state && void 0 !== e.state ? e.state : null, $0331271bace68e97$var$kh(b), e.updater = $0331271bace68e97$var$Ei, b.stateNode = e, e._reactInternals = b, $0331271bace68e97$var$Ii(b, d, a, c), b = $0331271bace68e97$var$jj(null, b, d, !0, f, c)) : (b.tag = 0, $0331271bace68e97$var$I && f && $0331271bace68e97$var$vg(b), $0331271bace68e97$var$Xi(null, b, e, c), b = b.child);
            return b;
        case 16:
            d = b.elementType;
            a: {
                $0331271bace68e97$var$ij(a, b);
                a = b.pendingProps;
                e = d._init;
                d = e(d._payload);
                b.type = d;
                e = b.tag = $0331271bace68e97$var$Zk(d);
                a = $0331271bace68e97$var$Ci(d, a);
                switch(e){
                    case 0:
                        b = $0331271bace68e97$var$cj(null, b, d, a, c);
                        break a;
                    case 1:
                        b = $0331271bace68e97$var$hj(null, b, d, a, c);
                        break a;
                    case 11:
                        b = $0331271bace68e97$var$Yi(null, b, d, a, c);
                        break a;
                    case 14:
                        b = $0331271bace68e97$var$$i(null, b, d, $0331271bace68e97$var$Ci(d.type, a), c);
                        break a;
                }
                throw Error($0331271bace68e97$var$p(306, d, ""));
            }
            return b;
        case 0:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $0331271bace68e97$var$Ci(d, e), $0331271bace68e97$var$cj(a, b, d, e, c);
        case 1:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $0331271bace68e97$var$Ci(d, e), $0331271bace68e97$var$hj(a, b, d, e, c);
        case 3:
            a: {
                $0331271bace68e97$var$kj(b);
                if (null === a) throw Error($0331271bace68e97$var$p(387));
                d = b.pendingProps;
                f = b.memoizedState;
                e = f.element;
                $0331271bace68e97$var$lh(a, b);
                $0331271bace68e97$var$qh(b, d, null, c);
                var g = b.memoizedState;
                d = g.element;
                if (f.isDehydrated) {
                    if (f = {
                        element: d,
                        isDehydrated: !1,
                        cache: g.cache,
                        pendingSuspenseBoundaries: g.pendingSuspenseBoundaries,
                        transitions: g.transitions
                    }, b.updateQueue.baseState = f, b.memoizedState = f, b.flags & 256) {
                        e = $0331271bace68e97$var$Ji(Error($0331271bace68e97$var$p(423)), b);
                        b = $0331271bace68e97$var$lj(a, b, d, c, e);
                        break a;
                    } else if (d !== e) {
                        e = $0331271bace68e97$var$Ji(Error($0331271bace68e97$var$p(424)), b);
                        b = $0331271bace68e97$var$lj(a, b, d, c, e);
                        break a;
                    } else for($0331271bace68e97$var$yg = $0331271bace68e97$var$Lf(b.stateNode.containerInfo.firstChild), $0331271bace68e97$var$xg = b, $0331271bace68e97$var$I = !0, $0331271bace68e97$var$zg = null, c = $0331271bace68e97$var$Vg(b, null, d, c), b.child = c; c;)c.flags = c.flags & -3 | 4096, c = c.sibling;
                } else {
                    $0331271bace68e97$var$Ig();
                    if (d === e) {
                        b = $0331271bace68e97$var$Zi(a, b, c);
                        break a;
                    }
                    $0331271bace68e97$var$Xi(a, b, d, c);
                }
                b = b.child;
            }
            return b;
        case 5:
            return $0331271bace68e97$var$Ah(b), null === a && $0331271bace68e97$var$Eg(b), d = b.type, e = b.pendingProps, f = null !== a ? a.memoizedProps : null, g = e.children, $0331271bace68e97$var$Ef(d, e) ? g = null : null !== f && $0331271bace68e97$var$Ef(d, f) && (b.flags |= 32), $0331271bace68e97$var$gj(a, b), $0331271bace68e97$var$Xi(a, b, g, c), b.child;
        case 6:
            return null === a && $0331271bace68e97$var$Eg(b), null;
        case 13:
            return $0331271bace68e97$var$oj(a, b, c);
        case 4:
            return $0331271bace68e97$var$yh(b, b.stateNode.containerInfo), d = b.pendingProps, null === a ? b.child = $0331271bace68e97$var$Ug(b, null, d, c) : $0331271bace68e97$var$Xi(a, b, d, c), b.child;
        case 11:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $0331271bace68e97$var$Ci(d, e), $0331271bace68e97$var$Yi(a, b, d, e, c);
        case 7:
            return $0331271bace68e97$var$Xi(a, b, b.pendingProps, c), b.child;
        case 8:
            return $0331271bace68e97$var$Xi(a, b, b.pendingProps.children, c), b.child;
        case 12:
            return $0331271bace68e97$var$Xi(a, b, b.pendingProps.children, c), b.child;
        case 10:
            a: {
                d = b.type._context;
                e = b.pendingProps;
                f = b.memoizedProps;
                g = e.value;
                $0331271bace68e97$var$G($0331271bace68e97$var$Wg, d._currentValue);
                d._currentValue = g;
                if (null !== f) {
                    if ($0331271bace68e97$var$He(f.value, g)) {
                        if (f.children === e.children && !$0331271bace68e97$var$Wf.current) {
                            b = $0331271bace68e97$var$Zi(a, b, c);
                            break a;
                        }
                    } else for(f = b.child, null !== f && (f.return = b); null !== f;){
                        var h = f.dependencies;
                        if (null !== h) {
                            g = f.child;
                            for(var k = h.firstContext; null !== k;){
                                if (k.context === d) {
                                    if (1 === f.tag) {
                                        k = $0331271bace68e97$var$mh(-1, c & -c);
                                        k.tag = 2;
                                        var l = f.updateQueue;
                                        if (null !== l) {
                                            l = l.shared;
                                            var m = l.pending;
                                            null === m ? k.next = k : (k.next = m.next, m.next = k);
                                            l.pending = k;
                                        }
                                    }
                                    f.lanes |= c;
                                    k = f.alternate;
                                    null !== k && (k.lanes |= c);
                                    $0331271bace68e97$var$bh(f.return, c, b);
                                    h.lanes |= c;
                                    break;
                                }
                                k = k.next;
                            }
                        } else if (10 === f.tag) g = f.type === b.type ? null : f.child;
                        else if (18 === f.tag) {
                            g = f.return;
                            if (null === g) throw Error($0331271bace68e97$var$p(341));
                            g.lanes |= c;
                            h = g.alternate;
                            null !== h && (h.lanes |= c);
                            $0331271bace68e97$var$bh(g, c, b);
                            g = f.sibling;
                        } else g = f.child;
                        if (null !== g) g.return = f;
                        else for(g = f; null !== g;){
                            if (g === b) {
                                g = null;
                                break;
                            }
                            f = g.sibling;
                            if (null !== f) {
                                f.return = g.return;
                                g = f;
                                break;
                            }
                            g = g.return;
                        }
                        f = g;
                    }
                }
                $0331271bace68e97$var$Xi(a, b, e.children, c);
                b = b.child;
            }
            return b;
        case 9:
            return e = b.type, d = b.pendingProps.children, $0331271bace68e97$var$ch(b, c), e = $0331271bace68e97$var$eh(e), d = d(e), b.flags |= 1, $0331271bace68e97$var$Xi(a, b, d, c), b.child;
        case 14:
            return d = b.type, e = $0331271bace68e97$var$Ci(d, b.pendingProps), e = $0331271bace68e97$var$Ci(d.type, e), $0331271bace68e97$var$$i(a, b, d, e, c);
        case 15:
            return $0331271bace68e97$var$bj(a, b, b.type, b.pendingProps, c);
        case 17:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $0331271bace68e97$var$Ci(d, e), $0331271bace68e97$var$ij(a, b), b.tag = 1, $0331271bace68e97$var$Zf(d) ? (a = !0, $0331271bace68e97$var$cg(b)) : a = !1, $0331271bace68e97$var$ch(b, c), $0331271bace68e97$var$Gi(b, d, e), $0331271bace68e97$var$Ii(b, d, e, c), $0331271bace68e97$var$jj(null, b, d, !0, a, c);
        case 19:
            return $0331271bace68e97$var$xj(a, b, c);
        case 22:
            return $0331271bace68e97$var$dj(a, b, c);
    }
    throw Error($0331271bace68e97$var$p(156, b.tag));
};
function $0331271bace68e97$var$Fk(a, b) {
    return $0331271bace68e97$var$ac(a, b);
}
function $0331271bace68e97$var$$k(a, b, c, d) {
    this.tag = a;
    this.key = c;
    this.sibling = this.child = this.return = this.stateNode = this.type = this.elementType = null;
    this.index = 0;
    this.ref = null;
    this.pendingProps = b;
    this.dependencies = this.memoizedState = this.updateQueue = this.memoizedProps = null;
    this.mode = d;
    this.subtreeFlags = this.flags = 0;
    this.deletions = null;
    this.childLanes = this.lanes = 0;
    this.alternate = null;
}
function $0331271bace68e97$var$Bg(a, b, c, d) {
    return new $0331271bace68e97$var$$k(a, b, c, d);
}
function $0331271bace68e97$var$aj(a) {
    a = a.prototype;
    return !(!a || !a.isReactComponent);
}
function $0331271bace68e97$var$Zk(a) {
    if ("function" === typeof a) return $0331271bace68e97$var$aj(a) ? 1 : 0;
    if (void 0 !== a && null !== a) {
        a = a.$$typeof;
        if (a === $0331271bace68e97$var$Da) return 11;
        if (a === $0331271bace68e97$var$Ga) return 14;
    }
    return 2;
}
function $0331271bace68e97$var$Pg(a, b) {
    var c = a.alternate;
    null === c ? (c = $0331271bace68e97$var$Bg(a.tag, b, a.key, a.mode), c.elementType = a.elementType, c.type = a.type, c.stateNode = a.stateNode, c.alternate = a, a.alternate = c) : (c.pendingProps = b, c.type = a.type, c.flags = 0, c.subtreeFlags = 0, c.deletions = null);
    c.flags = a.flags & 14680064;
    c.childLanes = a.childLanes;
    c.lanes = a.lanes;
    c.child = a.child;
    c.memoizedProps = a.memoizedProps;
    c.memoizedState = a.memoizedState;
    c.updateQueue = a.updateQueue;
    b = a.dependencies;
    c.dependencies = null === b ? null : {
        lanes: b.lanes,
        firstContext: b.firstContext
    };
    c.sibling = a.sibling;
    c.index = a.index;
    c.ref = a.ref;
    return c;
}
function $0331271bace68e97$var$Rg(a, b, c, d, e, f) {
    var g = 2;
    d = a;
    if ("function" === typeof a) $0331271bace68e97$var$aj(a) && (g = 1);
    else if ("string" === typeof a) g = 5;
    else a: switch(a){
        case $0331271bace68e97$var$ya:
            return $0331271bace68e97$var$Tg(c.children, e, f, b);
        case $0331271bace68e97$var$za:
            g = 8;
            e |= 8;
            break;
        case $0331271bace68e97$var$Aa:
            return a = $0331271bace68e97$var$Bg(12, c, b, e | 2), a.elementType = $0331271bace68e97$var$Aa, a.lanes = f, a;
        case $0331271bace68e97$var$Ea:
            return a = $0331271bace68e97$var$Bg(13, c, b, e), a.elementType = $0331271bace68e97$var$Ea, a.lanes = f, a;
        case $0331271bace68e97$var$Fa:
            return a = $0331271bace68e97$var$Bg(19, c, b, e), a.elementType = $0331271bace68e97$var$Fa, a.lanes = f, a;
        case $0331271bace68e97$var$Ia:
            return $0331271bace68e97$var$pj(c, e, f, b);
        default:
            if ("object" === (typeof a === "undefined" ? "undefined" : (0, $bJtXW._)(a)) && null !== a) switch(a.$$typeof){
                case $0331271bace68e97$var$Ba:
                    g = 10;
                    break a;
                case $0331271bace68e97$var$Ca:
                    g = 9;
                    break a;
                case $0331271bace68e97$var$Da:
                    g = 11;
                    break a;
                case $0331271bace68e97$var$Ga:
                    g = 14;
                    break a;
                case $0331271bace68e97$var$Ha:
                    g = 16;
                    d = null;
                    break a;
            }
            throw Error($0331271bace68e97$var$p(130, null == a ? a : typeof a === "undefined" ? "undefined" : (0, $bJtXW._)(a), ""));
    }
    b = $0331271bace68e97$var$Bg(g, c, b, e);
    b.elementType = a;
    b.type = d;
    b.lanes = f;
    return b;
}
function $0331271bace68e97$var$Tg(a, b, c, d) {
    a = $0331271bace68e97$var$Bg(7, a, d, b);
    a.lanes = c;
    return a;
}
function $0331271bace68e97$var$pj(a, b, c, d) {
    a = $0331271bace68e97$var$Bg(22, a, d, b);
    a.elementType = $0331271bace68e97$var$Ia;
    a.lanes = c;
    a.stateNode = {
        isHidden: !1
    };
    return a;
}
function $0331271bace68e97$var$Qg(a, b, c) {
    a = $0331271bace68e97$var$Bg(6, a, null, b);
    a.lanes = c;
    return a;
}
function $0331271bace68e97$var$Sg(a, b, c) {
    b = $0331271bace68e97$var$Bg(4, null !== a.children ? a.children : [], a.key, b);
    b.lanes = c;
    b.stateNode = {
        containerInfo: a.containerInfo,
        pendingChildren: null,
        implementation: a.implementation
    };
    return b;
}
function $0331271bace68e97$var$al(a, b, c, d, e) {
    this.tag = b;
    this.containerInfo = a;
    this.finishedWork = this.pingCache = this.current = this.pendingChildren = null;
    this.timeoutHandle = -1;
    this.callbackNode = this.pendingContext = this.context = null;
    this.callbackPriority = 0;
    this.eventTimes = $0331271bace68e97$var$zc(0);
    this.expirationTimes = $0331271bace68e97$var$zc(-1);
    this.entangledLanes = this.finishedLanes = this.mutableReadLanes = this.expiredLanes = this.pingedLanes = this.suspendedLanes = this.pendingLanes = 0;
    this.entanglements = $0331271bace68e97$var$zc(0);
    this.identifierPrefix = d;
    this.onRecoverableError = e;
    this.mutableSourceEagerHydrationData = null;
}
function $0331271bace68e97$var$bl(a, b, c, d, e, f, g, h, k) {
    a = new $0331271bace68e97$var$al(a, b, c, h, k);
    1 === b ? (b = 1, !0 === f && (b |= 8)) : b = 0;
    f = $0331271bace68e97$var$Bg(3, null, null, b);
    a.current = f;
    f.stateNode = a;
    f.memoizedState = {
        element: d,
        isDehydrated: c,
        cache: null,
        transitions: null,
        pendingSuspenseBoundaries: null
    };
    $0331271bace68e97$var$kh(f);
    return a;
}
function $0331271bace68e97$var$cl(a, b, c) {
    var d = 3 < arguments.length && void 0 !== arguments[3] ? arguments[3] : null;
    return {
        $$typeof: $0331271bace68e97$var$wa,
        key: null == d ? null : "" + d,
        children: a,
        containerInfo: b,
        implementation: c
    };
}
function $0331271bace68e97$var$dl(a) {
    if (!a) return $0331271bace68e97$var$Vf;
    a = a._reactInternals;
    a: {
        if ($0331271bace68e97$var$Vb(a) !== a || 1 !== a.tag) throw Error($0331271bace68e97$var$p(170));
        var b = a;
        do {
            switch(b.tag){
                case 3:
                    b = b.stateNode.context;
                    break a;
                case 1:
                    if ($0331271bace68e97$var$Zf(b.type)) {
                        b = b.stateNode.__reactInternalMemoizedMergedChildContext;
                        break a;
                    }
            }
            b = b.return;
        }while (null !== b);
        throw Error($0331271bace68e97$var$p(171));
    }
    if (1 === a.tag) {
        var c = a.type;
        if ($0331271bace68e97$var$Zf(c)) return $0331271bace68e97$var$bg(a, c, b);
    }
    return b;
}
function $0331271bace68e97$var$el(a, b, c, d, e, f, g, h, k) {
    a = $0331271bace68e97$var$bl(c, d, !0, a, e, f, g, h, k);
    a.context = $0331271bace68e97$var$dl(null);
    c = a.current;
    d = $0331271bace68e97$var$R();
    e = $0331271bace68e97$var$yi(c);
    f = $0331271bace68e97$var$mh(d, e);
    f.callback = void 0 !== b && null !== b ? b : null;
    $0331271bace68e97$var$nh(c, f, e);
    a.current.lanes = e;
    $0331271bace68e97$var$Ac(a, e, d);
    $0331271bace68e97$var$Dk(a, d);
    return a;
}
function $0331271bace68e97$var$fl(a, b, c, d) {
    var e = b.current, f = $0331271bace68e97$var$R(), g = $0331271bace68e97$var$yi(e);
    c = $0331271bace68e97$var$dl(c);
    null === b.context ? b.context = c : b.pendingContext = c;
    b = $0331271bace68e97$var$mh(f, g);
    b.payload = {
        element: a
    };
    d = void 0 === d ? null : d;
    null !== d && (b.callback = d);
    a = $0331271bace68e97$var$nh(e, b, g);
    null !== a && ($0331271bace68e97$var$gi(a, e, g, f), $0331271bace68e97$var$oh(a, e, g));
    return g;
}
function $0331271bace68e97$var$gl(a) {
    a = a.current;
    if (!a.child) return null;
    switch(a.child.tag){
        case 5:
            return a.child.stateNode;
        default:
            return a.child.stateNode;
    }
}
function $0331271bace68e97$var$hl(a, b) {
    a = a.memoizedState;
    if (null !== a && null !== a.dehydrated) {
        var c = a.retryLane;
        a.retryLane = 0 !== c && c < b ? c : b;
    }
}
function $0331271bace68e97$var$il(a, b) {
    $0331271bace68e97$var$hl(a, b);
    (a = a.alternate) && $0331271bace68e97$var$hl(a, b);
}
function $0331271bace68e97$var$jl() {
    return null;
}
var $0331271bace68e97$var$kl = "function" === typeof reportError ? reportError : function kl(a) {
    console.error(a);
};
function $0331271bace68e97$var$ll(a) {
    this._internalRoot = a;
}
$0331271bace68e97$var$ml.prototype.render = $0331271bace68e97$var$ll.prototype.render = function(a) {
    var b = this._internalRoot;
    if (null === b) throw Error($0331271bace68e97$var$p(409));
    $0331271bace68e97$var$fl(a, b, null, null);
};
$0331271bace68e97$var$ml.prototype.unmount = $0331271bace68e97$var$ll.prototype.unmount = function() {
    var a = this._internalRoot;
    if (null !== a) {
        this._internalRoot = null;
        var b = a.containerInfo;
        $0331271bace68e97$var$Rk(function() {
            $0331271bace68e97$var$fl(null, a, null, null);
        });
        b[$0331271bace68e97$var$uf] = null;
    }
};
function $0331271bace68e97$var$ml(a) {
    this._internalRoot = a;
}
$0331271bace68e97$var$ml.prototype.unstable_scheduleHydration = function(a) {
    if (a) {
        var b = $0331271bace68e97$var$Hc();
        a = {
            blockedOn: null,
            target: a,
            priority: b
        };
        for(var c = 0; c < $0331271bace68e97$var$Qc.length && 0 !== b && b < $0331271bace68e97$var$Qc[c].priority; c++);
        $0331271bace68e97$var$Qc.splice(c, 0, a);
        0 === c && $0331271bace68e97$var$Vc(a);
    }
};
function $0331271bace68e97$var$nl(a) {
    return !(!a || 1 !== a.nodeType && 9 !== a.nodeType && 11 !== a.nodeType);
}
function $0331271bace68e97$var$ol(a) {
    return !(!a || 1 !== a.nodeType && 9 !== a.nodeType && 11 !== a.nodeType && (8 !== a.nodeType || " react-mount-point-unstable " !== a.nodeValue));
}
function $0331271bace68e97$var$pl() {}
function $0331271bace68e97$var$ql(a, b, c, d, e) {
    if (e) {
        if ("function" === typeof d) {
            var f = d;
            d = function d() {
                var _$a = $0331271bace68e97$var$gl(g);
                f.call(_$a);
            };
        }
        var g = $0331271bace68e97$var$el(b, d, a, 0, null, !1, !1, "", $0331271bace68e97$var$pl);
        a._reactRootContainer = g;
        a[$0331271bace68e97$var$uf] = g.current;
        $0331271bace68e97$var$sf(8 === a.nodeType ? a.parentNode : a);
        $0331271bace68e97$var$Rk();
        return g;
    }
    for(; e = a.lastChild;)a.removeChild(e);
    if ("function" === typeof d) {
        var h = d;
        d = function d() {
            var _$a = $0331271bace68e97$var$gl(k);
            h.call(_$a);
        };
    }
    var k = $0331271bace68e97$var$bl(a, 0, !1, null, null, !1, !1, "", $0331271bace68e97$var$pl);
    a._reactRootContainer = k;
    a[$0331271bace68e97$var$uf] = k.current;
    $0331271bace68e97$var$sf(8 === a.nodeType ? a.parentNode : a);
    $0331271bace68e97$var$Rk(function() {
        $0331271bace68e97$var$fl(b, k, c, d);
    });
    return k;
}
function $0331271bace68e97$var$rl(a, b, c, d, e) {
    var f = c._reactRootContainer;
    if (f) {
        var g = f;
        if ("function" === typeof e) {
            var h = e;
            e = function e() {
                var _$a = $0331271bace68e97$var$gl(g);
                h.call(_$a);
            };
        }
        $0331271bace68e97$var$fl(b, g, a, e);
    } else g = $0331271bace68e97$var$ql(c, b, a, e, d);
    return $0331271bace68e97$var$gl(g);
}
$0331271bace68e97$var$Ec = function Ec(a) {
    switch(a.tag){
        case 3:
            var b = a.stateNode;
            if (b.current.memoizedState.isDehydrated) {
                var c = $0331271bace68e97$var$tc(b.pendingLanes);
                0 !== c && ($0331271bace68e97$var$Cc(b, c | 1), $0331271bace68e97$var$Dk(b, $0331271bace68e97$var$B()), 0 === ($0331271bace68e97$var$K & 6) && ($0331271bace68e97$var$Gj = $0331271bace68e97$var$B() + 500, $0331271bace68e97$var$jg()));
            }
            break;
        case 13:
            $0331271bace68e97$var$Rk(function() {
                var b = $0331271bace68e97$var$ih(a, 1);
                if (null !== b) {
                    var c = $0331271bace68e97$var$R();
                    $0331271bace68e97$var$gi(b, a, 1, c);
                }
            }), $0331271bace68e97$var$il(a, 1);
    }
};
$0331271bace68e97$var$Fc = function Fc(a) {
    if (13 === a.tag) {
        var b = $0331271bace68e97$var$ih(a, 134217728);
        if (null !== b) {
            var c = $0331271bace68e97$var$R();
            $0331271bace68e97$var$gi(b, a, 134217728, c);
        }
        $0331271bace68e97$var$il(a, 134217728);
    }
};
$0331271bace68e97$var$Gc = function Gc(a) {
    if (13 === a.tag) {
        var b = $0331271bace68e97$var$yi(a), c = $0331271bace68e97$var$ih(a, b);
        if (null !== c) {
            var d = $0331271bace68e97$var$R();
            $0331271bace68e97$var$gi(c, a, b, d);
        }
        $0331271bace68e97$var$il(a, b);
    }
};
$0331271bace68e97$var$Hc = function Hc() {
    return $0331271bace68e97$var$C;
};
$0331271bace68e97$var$Ic = function Ic(a, b) {
    var c = $0331271bace68e97$var$C;
    try {
        return $0331271bace68e97$var$C = a, b();
    } finally{
        $0331271bace68e97$var$C = c;
    }
};
$0331271bace68e97$var$yb = function yb(a, b, c) {
    switch(b){
        case "input":
            $0331271bace68e97$var$bb(a, c);
            b = c.name;
            if ("radio" === c.type && null != b) {
                for(c = a; c.parentNode;)c = c.parentNode;
                c = c.querySelectorAll("input[name=" + JSON.stringify("" + b) + '][type="radio"]');
                for(b = 0; b < c.length; b++){
                    var d = c[b];
                    if (d !== a && d.form === a.form) {
                        var e = $0331271bace68e97$var$Db(d);
                        if (!e) throw Error($0331271bace68e97$var$p(90));
                        $0331271bace68e97$var$Wa(d);
                        $0331271bace68e97$var$bb(d, e);
                    }
                }
            }
            break;
        case "textarea":
            $0331271bace68e97$var$ib(a, c);
            break;
        case "select":
            b = c.value, null != b && $0331271bace68e97$var$fb(a, !!c.multiple, b, !1);
    }
};
$0331271bace68e97$var$Gb = $0331271bace68e97$var$Qk;
$0331271bace68e97$var$Hb = $0331271bace68e97$var$Rk;
var $0331271bace68e97$var$sl = {
    usingClientEntryPoint: !1,
    Events: [
        $0331271bace68e97$var$Cb,
        $0331271bace68e97$var$ue,
        $0331271bace68e97$var$Db,
        $0331271bace68e97$var$Eb,
        $0331271bace68e97$var$Fb,
        $0331271bace68e97$var$Qk
    ]
}, $0331271bace68e97$var$tl = {
    findFiberByHostInstance: $0331271bace68e97$var$Wc,
    bundleType: 0,
    version: "18.3.1",
    rendererPackageName: "react-dom"
};
var $0331271bace68e97$var$ul = {
    bundleType: $0331271bace68e97$var$tl.bundleType,
    version: $0331271bace68e97$var$tl.version,
    rendererPackageName: $0331271bace68e97$var$tl.rendererPackageName,
    rendererConfig: $0331271bace68e97$var$tl.rendererConfig,
    overrideHookState: null,
    overrideHookStateDeletePath: null,
    overrideHookStateRenamePath: null,
    overrideProps: null,
    overridePropsDeletePath: null,
    overridePropsRenamePath: null,
    setErrorHandler: null,
    setSuspenseHandler: null,
    scheduleUpdate: null,
    currentDispatcherRef: $0331271bace68e97$var$ua.ReactCurrentDispatcher,
    findHostInstanceByFiber: function findHostInstanceByFiber(a) {
        a = $0331271bace68e97$var$Zb(a);
        return null === a ? null : a.stateNode;
    },
    findFiberByHostInstance: $0331271bace68e97$var$tl.findFiberByHostInstance || $0331271bace68e97$var$jl,
    findHostInstancesForRefresh: null,
    scheduleRefresh: null,
    scheduleRoot: null,
    setRefreshHandler: null,
    getCurrentFiber: null,
    reconcilerVersion: "18.3.1-next-f1338f8080-20240426"
};
if ("undefined" !== typeof __REACT_DEVTOOLS_GLOBAL_HOOK__) {
    var $0331271bace68e97$var$vl = __REACT_DEVTOOLS_GLOBAL_HOOK__;
    if (!$0331271bace68e97$var$vl.isDisabled && $0331271bace68e97$var$vl.supportsFiber) try {
        $0331271bace68e97$var$kc = $0331271bace68e97$var$vl.inject($0331271bace68e97$var$ul), $0331271bace68e97$var$lc = $0331271bace68e97$var$vl;
    } catch (a) {}
}
$0331271bace68e97$export$ae55be85d98224ed = $0331271bace68e97$var$sl;
$0331271bace68e97$export$d39a5bbd09211389 = function(a, b) {
    var c = 2 < arguments.length && void 0 !== arguments[2] ? arguments[2] : null;
    if (!$0331271bace68e97$var$nl(b)) throw Error($0331271bace68e97$var$p(200));
    return $0331271bace68e97$var$cl(a, b, null, c);
};
$0331271bace68e97$export$882461b6382ed46c = function(a, b) {
    if (!$0331271bace68e97$var$nl(a)) throw Error($0331271bace68e97$var$p(299));
    var c = !1, d = "", e = $0331271bace68e97$var$kl;
    null !== b && void 0 !== b && (!0 === b.unstable_strictMode && (c = !0), void 0 !== b.identifierPrefix && (d = b.identifierPrefix), void 0 !== b.onRecoverableError && (e = b.onRecoverableError));
    b = $0331271bace68e97$var$bl(a, 1, !1, null, null, c, !1, d, e);
    a[$0331271bace68e97$var$uf] = b.current;
    $0331271bace68e97$var$sf(8 === a.nodeType ? a.parentNode : a);
    return new $0331271bace68e97$var$ll(b);
};
$0331271bace68e97$export$466bfc07425424d5 = function(a) {
    if (null == a) return null;
    if (1 === a.nodeType) return a;
    var b = a._reactInternals;
    if (void 0 === b) {
        if ("function" === typeof a.render) throw Error($0331271bace68e97$var$p(188));
        a = Object.keys(a).join(",");
        throw Error($0331271bace68e97$var$p(268, a));
    }
    a = $0331271bace68e97$var$Zb(b);
    a = null === a ? null : a.stateNode;
    return a;
};
$0331271bace68e97$export$cd75ccfd720a3cd4 = function(a) {
    return $0331271bace68e97$var$Rk(a);
};
$0331271bace68e97$export$fa8d919ba61d84db = function(a, b, c) {
    if (!$0331271bace68e97$var$ol(b)) throw Error($0331271bace68e97$var$p(200));
    return $0331271bace68e97$var$rl(null, a, b, !0, c);
};
$0331271bace68e97$export$757ceba2d55c277e = function(a, b, c) {
    if (!$0331271bace68e97$var$nl(a)) throw Error($0331271bace68e97$var$p(405));
    var d = null != c && c.hydratedSources || null, e = !1, f = "", g = $0331271bace68e97$var$kl;
    null !== c && void 0 !== c && (!0 === c.unstable_strictMode && (e = !0), void 0 !== c.identifierPrefix && (f = c.identifierPrefix), void 0 !== c.onRecoverableError && (g = c.onRecoverableError));
    b = $0331271bace68e97$var$el(b, null, a, 1, null != c ? c : null, e, !1, f, g);
    a[$0331271bace68e97$var$uf] = b.current;
    $0331271bace68e97$var$sf(a);
    if (d) for(a = 0; a < d.length; a++)c = d[a], e = c._getVersion, e = e(c._source), null == b.mutableSourceEagerHydrationData ? b.mutableSourceEagerHydrationData = [
        c,
        e
    ] : b.mutableSourceEagerHydrationData.push(c, e);
    return new $0331271bace68e97$var$ml(b);
};
$0331271bace68e97$export$b3890eb0ae9dca99 = function(a, b, c) {
    if (!$0331271bace68e97$var$ol(b)) throw Error($0331271bace68e97$var$p(200));
    return $0331271bace68e97$var$rl(null, a, b, !1, c);
};
$0331271bace68e97$export$502457920280e6be = function(a) {
    if (!$0331271bace68e97$var$ol(a)) throw Error($0331271bace68e97$var$p(40));
    return a._reactRootContainer ? ($0331271bace68e97$var$Rk(function() {
        $0331271bace68e97$var$rl(null, null, a, !1, function() {
            a._reactRootContainer = null;
            a[$0331271bace68e97$var$uf] = null;
        });
    }), !0) : !1;
};
$0331271bace68e97$export$c78a37762a8d58e1 = $0331271bace68e97$var$Qk;
$0331271bace68e97$export$dc54d992c10e8a18 = function(a, b, c, d) {
    if (!$0331271bace68e97$var$ol(c)) throw Error($0331271bace68e97$var$p(200));
    if (null == a || void 0 === a._reactInternals) throw Error($0331271bace68e97$var$p(38));
    return $0331271bace68e97$var$rl(a, b, c, !1, d);
};
$0331271bace68e97$export$83d89fbfd8236492 = "18.3.1-next-f1338f8080-20240426";

});
parcelRegister("1iyD5", function(module, exports) {
'use strict';

module.exports = (parcelRequire("2nkgC"));

});
parcelRegister("2nkgC", function(module, exports) {

$parcel$export(module.exports, "unstable_now", function () { return $1bad735fa80bcaf4$export$c4744153514ff05d; }, function (v) { return $1bad735fa80bcaf4$export$c4744153514ff05d = v; });
$parcel$export(module.exports, "unstable_IdlePriority", function () { return $1bad735fa80bcaf4$export$3e506c1ccc9cc1a7; }, function (v) { return $1bad735fa80bcaf4$export$3e506c1ccc9cc1a7 = v; });
$parcel$export(module.exports, "unstable_ImmediatePriority", function () { return $1bad735fa80bcaf4$export$e26fe2ed2fa76875; }, function (v) { return $1bad735fa80bcaf4$export$e26fe2ed2fa76875 = v; });
$parcel$export(module.exports, "unstable_LowPriority", function () { return $1bad735fa80bcaf4$export$502329bbf4b505b1; }, function (v) { return $1bad735fa80bcaf4$export$502329bbf4b505b1 = v; });
$parcel$export(module.exports, "unstable_NormalPriority", function () { return $1bad735fa80bcaf4$export$6e3807111c4874c4; }, function (v) { return $1bad735fa80bcaf4$export$6e3807111c4874c4 = v; });
$parcel$export(module.exports, "unstable_Profiling", function () { return $1bad735fa80bcaf4$export$c27134553091fb3a; }, function (v) { return $1bad735fa80bcaf4$export$c27134553091fb3a = v; });
$parcel$export(module.exports, "unstable_UserBlockingPriority", function () { return $1bad735fa80bcaf4$export$33ee1acdc04fd2a2; }, function (v) { return $1bad735fa80bcaf4$export$33ee1acdc04fd2a2 = v; });
$parcel$export(module.exports, "unstable_cancelCallback", function () { return $1bad735fa80bcaf4$export$b00a404bbd5edef2; }, function (v) { return $1bad735fa80bcaf4$export$b00a404bbd5edef2 = v; });
$parcel$export(module.exports, "unstable_continueExecution", function () { return $1bad735fa80bcaf4$export$8352ce38b91d0c62; }, function (v) { return $1bad735fa80bcaf4$export$8352ce38b91d0c62 = v; });
$parcel$export(module.exports, "unstable_forceFrameRate", function () { return $1bad735fa80bcaf4$export$d66a1c1c77bd778b; }, function (v) { return $1bad735fa80bcaf4$export$d66a1c1c77bd778b = v; });
$parcel$export(module.exports, "unstable_getCurrentPriorityLevel", function () { return $1bad735fa80bcaf4$export$d3dfb8e4810cb555; }, function (v) { return $1bad735fa80bcaf4$export$d3dfb8e4810cb555 = v; });
$parcel$export(module.exports, "unstable_getFirstCallbackNode", function () { return $1bad735fa80bcaf4$export$839f9183b0465a69; }, function (v) { return $1bad735fa80bcaf4$export$839f9183b0465a69 = v; });
$parcel$export(module.exports, "unstable_next", function () { return $1bad735fa80bcaf4$export$72fdf0e06517287b; }, function (v) { return $1bad735fa80bcaf4$export$72fdf0e06517287b = v; });
$parcel$export(module.exports, "unstable_pauseExecution", function () { return $1bad735fa80bcaf4$export$4b844e58a3e414b4; }, function (v) { return $1bad735fa80bcaf4$export$4b844e58a3e414b4 = v; });
$parcel$export(module.exports, "unstable_requestPaint", function () { return $1bad735fa80bcaf4$export$816d2913ae6b83b1; }, function (v) { return $1bad735fa80bcaf4$export$816d2913ae6b83b1 = v; });
$parcel$export(module.exports, "unstable_runWithPriority", function () { return $1bad735fa80bcaf4$export$61bcfe829111a1d0; }, function (v) { return $1bad735fa80bcaf4$export$61bcfe829111a1d0 = v; });
$parcel$export(module.exports, "unstable_scheduleCallback", function () { return $1bad735fa80bcaf4$export$7ee8c9beb337bc3f; }, function (v) { return $1bad735fa80bcaf4$export$7ee8c9beb337bc3f = v; });
$parcel$export(module.exports, "unstable_shouldYield", function () { return $1bad735fa80bcaf4$export$b5836b71941fa3ed; }, function (v) { return $1bad735fa80bcaf4$export$b5836b71941fa3ed = v; });
$parcel$export(module.exports, "unstable_wrapCallback", function () { return $1bad735fa80bcaf4$export$cf845f2c119da08a; }, function (v) { return $1bad735fa80bcaf4$export$cf845f2c119da08a = v; });
/**
 * @license React
 * scheduler.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ 
var $bJtXW = parcelRequire("bJtXW");
var $1bad735fa80bcaf4$export$c4744153514ff05d;
var $1bad735fa80bcaf4$export$3e506c1ccc9cc1a7;
var $1bad735fa80bcaf4$export$e26fe2ed2fa76875;
var $1bad735fa80bcaf4$export$502329bbf4b505b1;
var $1bad735fa80bcaf4$export$6e3807111c4874c4;
var $1bad735fa80bcaf4$export$c27134553091fb3a;
var $1bad735fa80bcaf4$export$33ee1acdc04fd2a2;
var $1bad735fa80bcaf4$export$b00a404bbd5edef2;
var $1bad735fa80bcaf4$export$8352ce38b91d0c62;
var $1bad735fa80bcaf4$export$d66a1c1c77bd778b;
var $1bad735fa80bcaf4$export$d3dfb8e4810cb555;
var $1bad735fa80bcaf4$export$839f9183b0465a69;
var $1bad735fa80bcaf4$export$72fdf0e06517287b;
var $1bad735fa80bcaf4$export$4b844e58a3e414b4;
var $1bad735fa80bcaf4$export$816d2913ae6b83b1;
var $1bad735fa80bcaf4$export$61bcfe829111a1d0;
var $1bad735fa80bcaf4$export$7ee8c9beb337bc3f;
var $1bad735fa80bcaf4$export$b5836b71941fa3ed;
var $1bad735fa80bcaf4$export$cf845f2c119da08a;
'use strict';
function $1bad735fa80bcaf4$var$f(a, b) {
    var c = a.length;
    a.push(b);
    a: for(; 0 < c;){
        var d = c - 1 >>> 1, e = a[d];
        if (0 < $1bad735fa80bcaf4$var$g(e, b)) a[d] = b, a[c] = e, c = d;
        else break a;
    }
}
function $1bad735fa80bcaf4$var$h(a) {
    return 0 === a.length ? null : a[0];
}
function $1bad735fa80bcaf4$var$k(a) {
    if (0 === a.length) return null;
    var b = a[0], c = a.pop();
    if (c !== b) {
        a[0] = c;
        a: for(var d = 0, e = a.length, w = e >>> 1; d < w;){
            var m = 2 * (d + 1) - 1, C = a[m], n = m + 1, x = a[n];
            if (0 > $1bad735fa80bcaf4$var$g(C, c)) n < e && 0 > $1bad735fa80bcaf4$var$g(x, C) ? (a[d] = x, a[n] = c, d = n) : (a[d] = C, a[m] = c, d = m);
            else if (n < e && 0 > $1bad735fa80bcaf4$var$g(x, c)) a[d] = x, a[n] = c, d = n;
            else break a;
        }
    }
    return b;
}
function $1bad735fa80bcaf4$var$g(a, b) {
    var c = a.sortIndex - b.sortIndex;
    return 0 !== c ? c : a.id - b.id;
}
if ("object" === (typeof performance === "undefined" ? "undefined" : (0, $bJtXW._)(performance)) && "function" === typeof performance.now) {
    var $1bad735fa80bcaf4$var$l = performance;
    $1bad735fa80bcaf4$export$c4744153514ff05d = function() {
        return $1bad735fa80bcaf4$var$l.now();
    };
} else {
    var $1bad735fa80bcaf4$var$p = Date, $1bad735fa80bcaf4$var$q = $1bad735fa80bcaf4$var$p.now();
    $1bad735fa80bcaf4$export$c4744153514ff05d = function() {
        return $1bad735fa80bcaf4$var$p.now() - $1bad735fa80bcaf4$var$q;
    };
}
var $1bad735fa80bcaf4$var$r = [], $1bad735fa80bcaf4$var$t = [], $1bad735fa80bcaf4$var$u = 1, $1bad735fa80bcaf4$var$v = null, $1bad735fa80bcaf4$var$y = 3, $1bad735fa80bcaf4$var$z = !1, $1bad735fa80bcaf4$var$A = !1, $1bad735fa80bcaf4$var$B = !1, $1bad735fa80bcaf4$var$D = "function" === typeof setTimeout ? setTimeout : null, $1bad735fa80bcaf4$var$E = "function" === typeof clearTimeout ? clearTimeout : null, $1bad735fa80bcaf4$var$F = "undefined" !== typeof setImmediate ? setImmediate : null;
"undefined" !== typeof navigator && void 0 !== navigator.scheduling && void 0 !== navigator.scheduling.isInputPending && navigator.scheduling.isInputPending.bind(navigator.scheduling);
function $1bad735fa80bcaf4$var$G(a) {
    for(var b = $1bad735fa80bcaf4$var$h($1bad735fa80bcaf4$var$t); null !== b;){
        if (null === b.callback) $1bad735fa80bcaf4$var$k($1bad735fa80bcaf4$var$t);
        else if (b.startTime <= a) $1bad735fa80bcaf4$var$k($1bad735fa80bcaf4$var$t), b.sortIndex = b.expirationTime, $1bad735fa80bcaf4$var$f($1bad735fa80bcaf4$var$r, b);
        else break;
        b = $1bad735fa80bcaf4$var$h($1bad735fa80bcaf4$var$t);
    }
}
function $1bad735fa80bcaf4$var$H(a) {
    $1bad735fa80bcaf4$var$B = !1;
    $1bad735fa80bcaf4$var$G(a);
    if (!$1bad735fa80bcaf4$var$A) {
        if (null !== $1bad735fa80bcaf4$var$h($1bad735fa80bcaf4$var$r)) $1bad735fa80bcaf4$var$A = !0, $1bad735fa80bcaf4$var$I($1bad735fa80bcaf4$var$J);
        else {
            var b = $1bad735fa80bcaf4$var$h($1bad735fa80bcaf4$var$t);
            null !== b && $1bad735fa80bcaf4$var$K($1bad735fa80bcaf4$var$H, b.startTime - a);
        }
    }
}
function $1bad735fa80bcaf4$var$J(a, b) {
    $1bad735fa80bcaf4$var$A = !1;
    $1bad735fa80bcaf4$var$B && ($1bad735fa80bcaf4$var$B = !1, $1bad735fa80bcaf4$var$E($1bad735fa80bcaf4$var$L), $1bad735fa80bcaf4$var$L = -1);
    $1bad735fa80bcaf4$var$z = !0;
    var c = $1bad735fa80bcaf4$var$y;
    try {
        $1bad735fa80bcaf4$var$G(b);
        for($1bad735fa80bcaf4$var$v = $1bad735fa80bcaf4$var$h($1bad735fa80bcaf4$var$r); null !== $1bad735fa80bcaf4$var$v && (!($1bad735fa80bcaf4$var$v.expirationTime > b) || a && !$1bad735fa80bcaf4$var$M());){
            var d = $1bad735fa80bcaf4$var$v.callback;
            if ("function" === typeof d) {
                $1bad735fa80bcaf4$var$v.callback = null;
                $1bad735fa80bcaf4$var$y = $1bad735fa80bcaf4$var$v.priorityLevel;
                var e = d($1bad735fa80bcaf4$var$v.expirationTime <= b);
                b = $1bad735fa80bcaf4$export$c4744153514ff05d();
                "function" === typeof e ? $1bad735fa80bcaf4$var$v.callback = e : $1bad735fa80bcaf4$var$v === $1bad735fa80bcaf4$var$h($1bad735fa80bcaf4$var$r) && $1bad735fa80bcaf4$var$k($1bad735fa80bcaf4$var$r);
                $1bad735fa80bcaf4$var$G(b);
            } else $1bad735fa80bcaf4$var$k($1bad735fa80bcaf4$var$r);
            $1bad735fa80bcaf4$var$v = $1bad735fa80bcaf4$var$h($1bad735fa80bcaf4$var$r);
        }
        if (null !== $1bad735fa80bcaf4$var$v) var w = !0;
        else {
            var m = $1bad735fa80bcaf4$var$h($1bad735fa80bcaf4$var$t);
            null !== m && $1bad735fa80bcaf4$var$K($1bad735fa80bcaf4$var$H, m.startTime - b);
            w = !1;
        }
        return w;
    } finally{
        $1bad735fa80bcaf4$var$v = null, $1bad735fa80bcaf4$var$y = c, $1bad735fa80bcaf4$var$z = !1;
    }
}
var $1bad735fa80bcaf4$var$N = !1, $1bad735fa80bcaf4$var$O = null, $1bad735fa80bcaf4$var$L = -1, $1bad735fa80bcaf4$var$P = 5, $1bad735fa80bcaf4$var$Q = -1;
function $1bad735fa80bcaf4$var$M() {
    return $1bad735fa80bcaf4$export$c4744153514ff05d() - $1bad735fa80bcaf4$var$Q < $1bad735fa80bcaf4$var$P ? !1 : !0;
}
function $1bad735fa80bcaf4$var$R() {
    if (null !== $1bad735fa80bcaf4$var$O) {
        var a = $1bad735fa80bcaf4$export$c4744153514ff05d();
        $1bad735fa80bcaf4$var$Q = a;
        var b = !0;
        try {
            b = $1bad735fa80bcaf4$var$O(!0, a);
        } finally{
            b ? $1bad735fa80bcaf4$var$S() : ($1bad735fa80bcaf4$var$N = !1, $1bad735fa80bcaf4$var$O = null);
        }
    } else $1bad735fa80bcaf4$var$N = !1;
}
var $1bad735fa80bcaf4$var$S;
if ("function" === typeof $1bad735fa80bcaf4$var$F) $1bad735fa80bcaf4$var$S = function S() {
    $1bad735fa80bcaf4$var$F($1bad735fa80bcaf4$var$R);
};
else if ("undefined" !== typeof MessageChannel) {
    var $1bad735fa80bcaf4$var$T = new MessageChannel, $1bad735fa80bcaf4$var$U = $1bad735fa80bcaf4$var$T.port2;
    $1bad735fa80bcaf4$var$T.port1.onmessage = $1bad735fa80bcaf4$var$R;
    $1bad735fa80bcaf4$var$S = function S() {
        $1bad735fa80bcaf4$var$U.postMessage(null);
    };
} else $1bad735fa80bcaf4$var$S = function S() {
    $1bad735fa80bcaf4$var$D($1bad735fa80bcaf4$var$R, 0);
};
function $1bad735fa80bcaf4$var$I(a) {
    $1bad735fa80bcaf4$var$O = a;
    $1bad735fa80bcaf4$var$N || ($1bad735fa80bcaf4$var$N = !0, $1bad735fa80bcaf4$var$S());
}
function $1bad735fa80bcaf4$var$K(a, b) {
    $1bad735fa80bcaf4$var$L = $1bad735fa80bcaf4$var$D(function() {
        a($1bad735fa80bcaf4$export$c4744153514ff05d());
    }, b);
}
$1bad735fa80bcaf4$export$3e506c1ccc9cc1a7 = 5;
$1bad735fa80bcaf4$export$e26fe2ed2fa76875 = 1;
$1bad735fa80bcaf4$export$502329bbf4b505b1 = 4;
$1bad735fa80bcaf4$export$6e3807111c4874c4 = 3;
$1bad735fa80bcaf4$export$c27134553091fb3a = null;
$1bad735fa80bcaf4$export$33ee1acdc04fd2a2 = 2;
$1bad735fa80bcaf4$export$b00a404bbd5edef2 = function(a) {
    a.callback = null;
};
$1bad735fa80bcaf4$export$8352ce38b91d0c62 = function() {
    $1bad735fa80bcaf4$var$A || $1bad735fa80bcaf4$var$z || ($1bad735fa80bcaf4$var$A = !0, $1bad735fa80bcaf4$var$I($1bad735fa80bcaf4$var$J));
};
$1bad735fa80bcaf4$export$d66a1c1c77bd778b = function(a) {
    0 > a || 125 < a ? console.error("forceFrameRate takes a positive int between 0 and 125, forcing frame rates higher than 125 fps is not supported") : $1bad735fa80bcaf4$var$P = 0 < a ? Math.floor(1E3 / a) : 5;
};
$1bad735fa80bcaf4$export$d3dfb8e4810cb555 = function() {
    return $1bad735fa80bcaf4$var$y;
};
$1bad735fa80bcaf4$export$839f9183b0465a69 = function() {
    return $1bad735fa80bcaf4$var$h($1bad735fa80bcaf4$var$r);
};
$1bad735fa80bcaf4$export$72fdf0e06517287b = function(a) {
    switch($1bad735fa80bcaf4$var$y){
        case 1:
        case 2:
        case 3:
            var b = 3;
            break;
        default:
            b = $1bad735fa80bcaf4$var$y;
    }
    var c = $1bad735fa80bcaf4$var$y;
    $1bad735fa80bcaf4$var$y = b;
    try {
        return a();
    } finally{
        $1bad735fa80bcaf4$var$y = c;
    }
};
$1bad735fa80bcaf4$export$4b844e58a3e414b4 = function() {};
$1bad735fa80bcaf4$export$816d2913ae6b83b1 = function() {};
$1bad735fa80bcaf4$export$61bcfe829111a1d0 = function(a, b) {
    switch(a){
        case 1:
        case 2:
        case 3:
        case 4:
        case 5:
            break;
        default:
            a = 3;
    }
    var c = $1bad735fa80bcaf4$var$y;
    $1bad735fa80bcaf4$var$y = a;
    try {
        return b();
    } finally{
        $1bad735fa80bcaf4$var$y = c;
    }
};
$1bad735fa80bcaf4$export$7ee8c9beb337bc3f = function(a, b, c) {
    var d = $1bad735fa80bcaf4$export$c4744153514ff05d();
    "object" === (typeof c === "undefined" ? "undefined" : (0, $bJtXW._)(c)) && null !== c ? (c = c.delay, c = "number" === typeof c && 0 < c ? d + c : d) : c = d;
    switch(a){
        case 1:
            var e = -1;
            break;
        case 2:
            e = 250;
            break;
        case 5:
            e = 1073741823;
            break;
        case 4:
            e = 1E4;
            break;
        default:
            e = 5E3;
    }
    e = c + e;
    a = {
        id: $1bad735fa80bcaf4$var$u++,
        callback: b,
        priorityLevel: a,
        startTime: c,
        expirationTime: e,
        sortIndex: -1
    };
    c > d ? (a.sortIndex = c, $1bad735fa80bcaf4$var$f($1bad735fa80bcaf4$var$t, a), null === $1bad735fa80bcaf4$var$h($1bad735fa80bcaf4$var$r) && a === $1bad735fa80bcaf4$var$h($1bad735fa80bcaf4$var$t) && ($1bad735fa80bcaf4$var$B ? ($1bad735fa80bcaf4$var$E($1bad735fa80bcaf4$var$L), $1bad735fa80bcaf4$var$L = -1) : $1bad735fa80bcaf4$var$B = !0, $1bad735fa80bcaf4$var$K($1bad735fa80bcaf4$var$H, c - d))) : (a.sortIndex = e, $1bad735fa80bcaf4$var$f($1bad735fa80bcaf4$var$r, a), $1bad735fa80bcaf4$var$A || $1bad735fa80bcaf4$var$z || ($1bad735fa80bcaf4$var$A = !0, $1bad735fa80bcaf4$var$I($1bad735fa80bcaf4$var$J)));
    return a;
};
$1bad735fa80bcaf4$export$b5836b71941fa3ed = $1bad735fa80bcaf4$var$M;
$1bad735fa80bcaf4$export$cf845f2c119da08a = function(a) {
    var b = $1bad735fa80bcaf4$var$y;
    return function() {
        var c = $1bad735fa80bcaf4$var$y;
        $1bad735fa80bcaf4$var$y = b;
        try {
            return a.apply(this, arguments);
        } finally{
            $1bad735fa80bcaf4$var$y = c;
        }
    };
};

});



parcelRegister("gl7zH", function(module, exports) {

$parcel$export(module.exports, "Action", function () { return Action; });
$parcel$export(module.exports, "createMemoryHistory", function () { return createMemoryHistory; });
$parcel$export(module.exports, "createPath", function () { return createPath; });
$parcel$export(module.exports, "parsePath", function () { return parsePath; });
$parcel$export(module.exports, "createBrowserHistory", function () { return createBrowserHistory; });
$parcel$export(module.exports, "createHashHistory", function () { return createHashHistory; });
$parcel$export(module.exports, "UNSAFE_invariant", function () { return invariant; });
$parcel$export(module.exports, "matchRoutes", function () { return matchRoutes; });
$parcel$export(module.exports, "stripBasename", function () { return stripBasename; });
$parcel$export(module.exports, "UNSAFE_decodePath", function () { return decodePath; });
$parcel$export(module.exports, "UNSAFE_convertRouteMatchToUiMatch", function () { return convertRouteMatchToUiMatch; });
$parcel$export(module.exports, "joinPaths", function () { return joinPaths; });
$parcel$export(module.exports, "matchPath", function () { return matchPath; });
$parcel$export(module.exports, "UNSAFE_getResolveToMatches", function () { return getResolveToMatches; });
$parcel$export(module.exports, "resolveTo", function () { return resolveTo; });
$parcel$export(module.exports, "AbortedDeferredError", function () { return AbortedDeferredError; });
$parcel$export(module.exports, "UNSAFE_ErrorResponseImpl", function () { return ErrorResponseImpl; });
$parcel$export(module.exports, "isRouteErrorResponse", function () { return isRouteErrorResponse; });
$parcel$export(module.exports, "IDLE_FETCHER", function () { return IDLE_FETCHER; });
$parcel$export(module.exports, "IDLE_BLOCKER", function () { return IDLE_BLOCKER; });
$parcel$export(module.exports, "createRouter", function () { return createRouter; });
/**
 * @remix-run/router v1.23.1
 *
 * Copyright (c) Remix Software Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * @license MIT
 */ 
var $g3gsR = parcelRequire("g3gsR");

var $f3Okx = parcelRequire("f3Okx");

var $grujF = parcelRequire("grujF");

var $dhMkv = parcelRequire("dhMkv");

var $72osQ = parcelRequire("72osQ");

var $j6Mzi = parcelRequire("j6Mzi");

var $2nwvT = parcelRequire("2nwvT");

var $l8eKX = parcelRequire("l8eKX");

var $2us1u = parcelRequire("2us1u");

var $bJtXW = parcelRequire("bJtXW");

var $1EZOw = parcelRequire("1EZOw");

var $fRv9I = parcelRequire("fRv9I");

var $fRv9I = parcelRequire("fRv9I");
function _extends() {
    _extends = Object.assign ? Object.assign.bind() : function _extends(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
////////////////////////////////////////////////////////////////////////////////
//#region Types and Constants
////////////////////////////////////////////////////////////////////////////////
/**
 * Actions represent the type of change to a location value.
 */ var Action;
(function(Action) {
    /**
   * A POP indicates a change to an arbitrary index in the history stack, such
   * as a back or forward navigation. It does not describe the direction of the
   * navigation, only that the current index changed.
   *
   * Note: This is the default action for newly created history objects.
   */ Action["Pop"] = "POP";
    /**
   * A PUSH indicates a new entry being added to the history stack, such as when
   * a link is clicked and a new page loads. When this happens, all subsequent
   * entries in the stack are lost.
   */ Action["Push"] = "PUSH";
    /**
   * A REPLACE indicates the entry at the current index in the history stack
   * being replaced by a new one.
   */ Action["Replace"] = "REPLACE";
})(Action || (Action = {}));
var PopStateEventType = "popstate";
/**
 * Memory history stores the current location in memory. It is designed for use
 * in stateful non-browser environments like tests and React Native.
 */ function createMemoryHistory(options) {
    if (options === void 0) options = {};
    var _options_initialEntries = options.initialEntries, initialEntries = _options_initialEntries === void 0 ? [
        "/"
    ] : _options_initialEntries, initialIndex = options.initialIndex, _options_v5Compat = options.v5Compat, v5Compat = _options_v5Compat === void 0 ? false : _options_v5Compat;
    var entries; // Declare so we can access from createMemoryLocation
    entries = initialEntries.map(function(entry, index) {
        return createMemoryLocation(entry, typeof entry === "string" ? null : entry.state, index === 0 ? "default" : undefined);
    });
    var index = clampIndex(initialIndex == null ? entries.length - 1 : initialIndex);
    var action = Action.Pop;
    var listener = null;
    function clampIndex(n) {
        return Math.min(Math.max(n, 0), entries.length - 1);
    }
    function getCurrentLocation() {
        return entries[index];
    }
    function createMemoryLocation(to, state, key) {
        if (state === void 0) state = null;
        var location = createLocation(entries ? getCurrentLocation().pathname : "/", to, state, key);
        warning(location.pathname.charAt(0) === "/", "relative pathnames are not supported in memory history: " + JSON.stringify(to));
        return location;
    }
    function createHref(to) {
        return typeof to === "string" ? to : createPath(to);
    }
    var history = {
        get index () {
            return index;
        },
        get action () {
            return action;
        },
        get location () {
            return getCurrentLocation();
        },
        createHref: createHref,
        createURL: function(to) {
            return new URL(createHref(to), "http://localhost");
        },
        encodeLocation: function(to) {
            var path = typeof to === "string" ? parsePath(to) : to;
            return {
                pathname: path.pathname || "",
                search: path.search || "",
                hash: path.hash || ""
            };
        },
        push: function(to, state) {
            action = Action.Push;
            var nextLocation = createMemoryLocation(to, state);
            index += 1;
            entries.splice(index, entries.length, nextLocation);
            if (v5Compat && listener) listener({
                action: action,
                location: nextLocation,
                delta: 1
            });
        },
        replace: function(to, state) {
            action = Action.Replace;
            var nextLocation = createMemoryLocation(to, state);
            entries[index] = nextLocation;
            if (v5Compat && listener) listener({
                action: action,
                location: nextLocation,
                delta: 0
            });
        },
        go: function(delta) {
            action = Action.Pop;
            var nextIndex = clampIndex(index + delta);
            var nextLocation = entries[nextIndex];
            index = nextIndex;
            if (listener) listener({
                action: action,
                location: nextLocation,
                delta: delta
            });
        },
        listen: function(fn) {
            listener = fn;
            return function() {
                listener = null;
            };
        }
    };
    return history;
}
/**
 * Browser history stores the location in regular URLs. This is the standard for
 * most web apps, but it requires some configuration on the server to ensure you
 * serve the same app at multiple URLs.
 *
 * @see https://github.com/remix-run/history/tree/main/docs/api-reference.md#createbrowserhistory
 */ function createBrowserHistory(options) {
    if (options === void 0) options = {};
    function createBrowserLocation(window1, globalHistory) {
        var _window_location = window1.location, pathname = _window_location.pathname, search = _window_location.search, hash = _window_location.hash;
        return createLocation("", {
            pathname: pathname,
            search: search,
            hash: hash
        }, // state defaults to `null` because `window.history.state` does
        globalHistory.state && globalHistory.state.usr || null, globalHistory.state && globalHistory.state.key || "default");
    }
    function createBrowserHref(window1, to) {
        return typeof to === "string" ? to : createPath(to);
    }
    return getUrlBasedHistory(createBrowserLocation, createBrowserHref, null, options);
}
/**
 * Hash history stores the location in window.location.hash. This makes it ideal
 * for situations where you don't want to send the location to the server for
 * some reason, either because you do cannot configure it or the URL space is
 * reserved for something else.
 *
 * @see https://github.com/remix-run/history/tree/main/docs/api-reference.md#createhashhistory
 */ function createHashHistory(options) {
    if (options === void 0) options = {};
    function createHashLocation(window1, globalHistory) {
        var _parsePath = parsePath(window1.location.hash.substr(1)), _parsePath_pathname = _parsePath.pathname, pathname = _parsePath_pathname === void 0 ? "/" : _parsePath_pathname, _parsePath_search = _parsePath.search, search = _parsePath_search === void 0 ? "" : _parsePath_search, _parsePath_hash = _parsePath.hash, hash = _parsePath_hash === void 0 ? "" : _parsePath_hash;
        // Hash URL should always have a leading / just like window.location.pathname
        // does, so if an app ends up at a route like /#something then we add a
        // leading slash so all of our path-matching behaves the same as if it would
        // in a browser router.  This is particularly important when there exists a
        // root splat route (<Route path="*">) since that matches internally against
        // "/*" and we'd expect /#something to 404 in a hash router app.
        if (!pathname.startsWith("/") && !pathname.startsWith(".")) pathname = "/" + pathname;
        return createLocation("", {
            pathname: pathname,
            search: search,
            hash: hash
        }, // state defaults to `null` because `window.history.state` does
        globalHistory.state && globalHistory.state.usr || null, globalHistory.state && globalHistory.state.key || "default");
    }
    function createHashHref(window1, to) {
        var base = window1.document.querySelector("base");
        var href = "";
        if (base && base.getAttribute("href")) {
            var url = window1.location.href;
            var hashIndex = url.indexOf("#");
            href = hashIndex === -1 ? url : url.slice(0, hashIndex);
        }
        return href + "#" + (typeof to === "string" ? to : createPath(to));
    }
    function validateHashLocation(location, to) {
        warning(location.pathname.charAt(0) === "/", "relative pathnames are not supported in hash history.push(" + JSON.stringify(to) + ")");
    }
    return getUrlBasedHistory(createHashLocation, createHashHref, validateHashLocation, options);
}
function invariant(value, message) {
    if (value === false || value === null || typeof value === "undefined") throw new Error(message);
}
function warning(cond, message) {
    if (!cond) {
        // eslint-disable-next-line no-console
        if (typeof console !== "undefined") console.warn(message);
        try {
            // Welcome to debugging history!
            //
            // This error is thrown as a convenience, so you can more easily
            // find the source for a warning that appears in the console by
            // enabling "pause on exceptions" in your JavaScript debugger.
            throw new Error(message);
        // eslint-disable-next-line no-empty
        } catch (e) {}
    }
}
function createKey() {
    return Math.random().toString(36).substr(2, 8);
}
/**
 * For browser-based histories, we combine the state and key into an object
 */ function getHistoryState(location, index) {
    return {
        usr: location.state,
        key: location.key,
        idx: index
    };
}
/**
 * Creates a Location object with a unique key from the given Path
 */ function createLocation(current, to, state, key) {
    if (state === void 0) state = null;
    var location = _extends({
        pathname: typeof current === "string" ? current : current.pathname,
        search: "",
        hash: ""
    }, typeof to === "string" ? parsePath(to) : to, {
        state: state,
        // TODO: This could be cleaned up.  push/replace should probably just take
        // full Locations now and avoid the need to run through this flow at all
        // But that's a pretty big refactor to the current test suite so going to
        // keep as is for the time being and just let any incoming keys take precedence
        key: to && to.key || key || createKey()
    });
    return location;
}
/**
 * Creates a string URL path from the given pathname, search, and hash components.
 */ function createPath(_ref) {
    var _ref_pathname = _ref.pathname, pathname = _ref_pathname === void 0 ? "/" : _ref_pathname, _ref_search = _ref.search, search = _ref_search === void 0 ? "" : _ref_search, _ref_hash = _ref.hash, hash = _ref_hash === void 0 ? "" : _ref_hash;
    if (search && search !== "?") pathname += search.charAt(0) === "?" ? search : "?" + search;
    if (hash && hash !== "#") pathname += hash.charAt(0) === "#" ? hash : "#" + hash;
    return pathname;
}
/**
 * Parses a string URL path into its separate pathname, search, and hash components.
 */ function parsePath(path) {
    var parsedPath = {};
    if (path) {
        var hashIndex = path.indexOf("#");
        if (hashIndex >= 0) {
            parsedPath.hash = path.substr(hashIndex);
            path = path.substr(0, hashIndex);
        }
        var searchIndex = path.indexOf("?");
        if (searchIndex >= 0) {
            parsedPath.search = path.substr(searchIndex);
            path = path.substr(0, searchIndex);
        }
        if (path) parsedPath.pathname = path;
    }
    return parsedPath;
}
function getUrlBasedHistory(getLocation, createHref, validateLocation, options) {
    if (options === void 0) options = {};
    var _options_window = options.window, window1 = _options_window === void 0 ? document.defaultView : _options_window, _options_v5Compat = options.v5Compat, v5Compat = _options_v5Compat === void 0 ? false : _options_v5Compat;
    var globalHistory = window1.history;
    var action = Action.Pop;
    var listener = null;
    var index = getIndex();
    // Index should only be null when we initialize. If not, it's because the
    // user called history.pushState or history.replaceState directly, in which
    // case we should log a warning as it will result in bugs.
    if (index == null) {
        index = 0;
        globalHistory.replaceState(_extends({}, globalHistory.state, {
            idx: index
        }), "");
    }
    function getIndex() {
        var state = globalHistory.state || {
            idx: null
        };
        return state.idx;
    }
    function handlePop() {
        action = Action.Pop;
        var nextIndex = getIndex();
        var delta = nextIndex == null ? null : nextIndex - index;
        index = nextIndex;
        if (listener) listener({
            action: action,
            location: history.location,
            delta: delta
        });
    }
    function push(to, state) {
        action = Action.Push;
        var location = createLocation(history.location, to, state);
        if (validateLocation) validateLocation(location, to);
        index = getIndex() + 1;
        var historyState = getHistoryState(location, index);
        var url = history.createHref(location);
        // try...catch because iOS limits us to 100 pushState calls :/
        try {
            globalHistory.pushState(historyState, "", url);
        } catch (error) {
            // If the exception is because `state` can't be serialized, let that throw
            // outwards just like a replace call would so the dev knows the cause
            // https://html.spec.whatwg.org/multipage/nav-history-apis.html#shared-history-push/replace-state-steps
            // https://html.spec.whatwg.org/multipage/structured-data.html#structuredserializeinternal
            if (error instanceof DOMException && error.name === "DataCloneError") throw error;
            // They are going to lose state here, but there is no real
            // way to warn them about it since the page will refresh...
            window1.location.assign(url);
        }
        if (v5Compat && listener) listener({
            action: action,
            location: history.location,
            delta: 1
        });
    }
    function replace(to, state) {
        action = Action.Replace;
        var location = createLocation(history.location, to, state);
        if (validateLocation) validateLocation(location, to);
        index = getIndex();
        var historyState = getHistoryState(location, index);
        var url = history.createHref(location);
        globalHistory.replaceState(historyState, "", url);
        if (v5Compat && listener) listener({
            action: action,
            location: history.location,
            delta: 0
        });
    }
    function createURL(to) {
        // window.location.origin is "null" (the literal string value) in Firefox
        // under certain conditions, notably when serving from a local HTML file
        // See https://bugzilla.mozilla.org/show_bug.cgi?id=878297
        var base = window1.location.origin !== "null" ? window1.location.origin : window1.location.href;
        var href = typeof to === "string" ? to : createPath(to);
        // Treating this as a full URL will strip any trailing spaces so we need to
        // pre-encode them since they might be part of a matching splat param from
        // an ancestor route
        href = href.replace(/ $/, "%20");
        invariant(base, "No window.location.(origin|href) available to create URL for href: " + href);
        return new URL(href, base);
    }
    var history = {
        get action () {
            return action;
        },
        get location () {
            return getLocation(window1, globalHistory);
        },
        listen: function(fn) {
            if (listener) throw new Error("A history only accepts one active listener");
            window1.addEventListener(PopStateEventType, handlePop);
            listener = fn;
            return function() {
                window1.removeEventListener(PopStateEventType, handlePop);
                listener = null;
            };
        },
        createHref: function(to) {
            return createHref(window1, to);
        },
        createURL: createURL,
        encodeLocation: function(to) {
            // Encode a Location the same way window.location would
            var url = createURL(to);
            return {
                pathname: url.pathname,
                search: url.search,
                hash: url.hash
            };
        },
        push: push,
        replace: replace,
        go: function(n) {
            return globalHistory.go(n);
        }
    };
    return history;
}
//#endregion
var ResultType;
(function(ResultType) {
    ResultType["data"] = "data";
    ResultType["deferred"] = "deferred";
    ResultType["redirect"] = "redirect";
    ResultType["error"] = "error";
})(ResultType || (ResultType = {}));
var immutableRouteKeys = new Set([
    "lazy",
    "caseSensitive",
    "path",
    "id",
    "index",
    "children"
]);
function isIndexRoute(route) {
    return route.index === true;
}
// Walk the route tree generating unique IDs where necessary, so we are working
// solely with AgnosticDataRouteObject's within the Router
function convertRoutesToDataRoutes(routes, mapRouteProperties, parentPath, manifest) {
    if (parentPath === void 0) parentPath = [];
    if (manifest === void 0) manifest = {};
    return routes.map(function(route, index) {
        var treePath = (0, $2us1u._)(parentPath).concat([
            String(index)
        ]);
        var id = typeof route.id === "string" ? route.id : treePath.join("-");
        invariant(route.index !== true || !route.children, "Cannot specify children on an index route");
        invariant(!manifest[id], "Found a route id collision on id \"" + id + "\".  Route " + "id's must be globally unique within Data Router usages");
        if (isIndexRoute(route)) {
            var indexRoute = _extends({}, route, mapRouteProperties(route), {
                id: id
            });
            manifest[id] = indexRoute;
            return indexRoute;
        } else {
            var pathOrLayoutRoute = _extends({}, route, mapRouteProperties(route), {
                id: id,
                children: undefined
            });
            manifest[id] = pathOrLayoutRoute;
            if (route.children) pathOrLayoutRoute.children = convertRoutesToDataRoutes(route.children, mapRouteProperties, treePath, manifest);
            return pathOrLayoutRoute;
        }
    });
}
/**
 * Matches the given routes to a location and returns the match data.
 *
 * @see https://reactrouter.com/v6/utils/match-routes
 */ function matchRoutes(routes, locationArg, basename) {
    if (basename === void 0) basename = "/";
    return matchRoutesImpl(routes, locationArg, basename, false);
}
function matchRoutesImpl(routes, locationArg, basename, allowPartial) {
    var location = typeof locationArg === "string" ? parsePath(locationArg) : locationArg;
    var pathname = stripBasename(location.pathname || "/", basename);
    if (pathname == null) return null;
    var branches = flattenRoutes(routes);
    rankRouteBranches(branches);
    var matches = null;
    for(var i = 0; matches == null && i < branches.length; ++i){
        // Incoming pathnames are generally encoded from either window.location
        // or from router.navigate, but we want to match against the unencoded
        // paths in the route definitions.  Memory router locations won't be
        // encoded here but there also shouldn't be anything to decode so this
        // should be a safe operation.  This avoids needing matchRoutes to be
        // history-aware.
        var decoded = decodePath(pathname);
        matches = matchRouteBranch(branches[i], decoded, allowPartial);
    }
    return matches;
}
function convertRouteMatchToUiMatch(match, loaderData) {
    var route = match.route, pathname = match.pathname, params = match.params;
    return {
        id: route.id,
        pathname: pathname,
        params: params,
        data: loaderData[route.id],
        handle: route.handle
    };
}
function flattenRoutes(routes, branches, parentsMeta, parentPath) {
    if (branches === void 0) branches = [];
    if (parentsMeta === void 0) parentsMeta = [];
    if (parentPath === void 0) parentPath = "";
    var flattenRoute = function(route, index, relativePath) {
        var meta = {
            relativePath: relativePath === undefined ? route.path || "" : relativePath,
            caseSensitive: route.caseSensitive === true,
            childrenIndex: index,
            route: route
        };
        if (meta.relativePath.startsWith("/")) {
            invariant(meta.relativePath.startsWith(parentPath), "Absolute route path \"" + meta.relativePath + "\" nested under path " + ("\"" + parentPath + "\" is not valid. An absolute child route path ") + "must start with the combined path of all its parent routes.");
            meta.relativePath = meta.relativePath.slice(parentPath.length);
        }
        var path = joinPaths([
            parentPath,
            meta.relativePath
        ]);
        var routesMeta = parentsMeta.concat(meta);
        // Add the children before adding this route to the array, so we traverse the
        // route tree depth-first and child routes appear before their parents in
        // the "flattened" version.
        if (route.children && route.children.length > 0) {
            invariant(// Our types know better, but runtime JS may not!
            // @ts-expect-error
            route.index !== true, "Index routes must not have child routes. Please remove " + ("all child routes from route path \"" + path + "\"."));
            flattenRoutes(route.children, branches, routesMeta, path);
        }
        // Routes without a path shouldn't ever match by themselves unless they are
        // index routes, so don't add them to the list of possible branches.
        if (route.path == null && !route.index) return;
        branches.push({
            path: path,
            score: computeScore(path, route.index),
            routesMeta: routesMeta
        });
    };
    routes.forEach(function(route, index) {
        var _route$path;
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        // coarse-grain check for optional params
        if (route.path === "" || !((_route$path = route.path) != null && _route$path.includes("?"))) flattenRoute(route, index);
        else try {
            for(var _iterator = explodeOptionalSegments(route.path)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var exploded = _step.value;
                flattenRoute(route, index, exploded);
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
    });
    return branches;
}
/**
 * Computes all combinations of optional path segments for a given path,
 * excluding combinations that are ambiguous and of lower priority.
 *
 * For example, `/one/:two?/three/:four?/:five?` explodes to:
 * - `/one/three`
 * - `/one/:two/three`
 * - `/one/three/:four`
 * - `/one/three/:five`
 * - `/one/:two/three/:four`
 * - `/one/:two/three/:five`
 * - `/one/three/:four/:five`
 * - `/one/:two/three/:four/:five`
 */ function explodeOptionalSegments(path) {
    var // All child paths with the prefix.  Do this for all children before the
    // optional version for all children, so we get consistent ordering where the
    // parent optional aspect is preferred as required.  Otherwise, we can get
    // child sections interspersed where deeper optional segments are higher than
    // parent optional segments, where for example, /:two would explode _earlier_
    // then /:one.  By always including the parent as required _for all children_
    // first, we avoid this issue
    _result, _result1;
    var segments = path.split("/");
    if (segments.length === 0) return [];
    var _segments = (0, $l8eKX._)(segments), first = _segments[0], rest = _segments.slice(1);
    // Optional path segments are denoted by a trailing `?`
    var isOptional = first.endsWith("?");
    // Compute the corresponding required segment: `foo?` -> `foo`
    var required = first.replace(/\?$/, "");
    if (rest.length === 0) // Intepret empty string as omitting an optional segment
    // `["one", "", "three"]` corresponds to omitting `:two` from `/one/:two?/three` -> `/one/three`
    return isOptional ? [
        required,
        ""
    ] : [
        required
    ];
    var restExploded = explodeOptionalSegments(rest.join("/"));
    var result = [];
    (_result = result).push.apply(_result, (0, $2us1u._)(restExploded.map(function(subpath) {
        return subpath === "" ? required : [
            required,
            subpath
        ].join("/");
    })));
    // Then, if this is an optional value, add all child versions without
    if (isOptional) (_result1 = result).push.apply(_result1, (0, $2us1u._)(restExploded));
    // for absolute paths, ensure `/` instead of empty segment
    return result.map(function(exploded) {
        return path.startsWith("/") && exploded === "" ? "/" : exploded;
    });
}
function rankRouteBranches(branches) {
    branches.sort(function(a, b) {
        return a.score !== b.score ? b.score - a.score // Higher score first
         : compareIndexes(a.routesMeta.map(function(meta) {
            return meta.childrenIndex;
        }), b.routesMeta.map(function(meta) {
            return meta.childrenIndex;
        }));
    });
}
var paramRe = /^:[\w-]+$/;
var dynamicSegmentValue = 3;
var indexRouteValue = 2;
var emptySegmentValue = 1;
var staticSegmentValue = 10;
var splatPenalty = -2;
var isSplat = function(s) {
    return s === "*";
};
function computeScore(path, index) {
    var segments = path.split("/");
    var initialScore = segments.length;
    if (segments.some(isSplat)) initialScore += splatPenalty;
    if (index) initialScore += indexRouteValue;
    return segments.filter(function(s) {
        return !isSplat(s);
    }).reduce(function(score, segment) {
        return score + (paramRe.test(segment) ? dynamicSegmentValue : segment === "" ? emptySegmentValue : staticSegmentValue);
    }, initialScore);
}
function compareIndexes(a, b) {
    var siblings = a.length === b.length && a.slice(0, -1).every(function(n, i) {
        return n === b[i];
    });
    return siblings ? // If two routes are siblings, we should try to match the earlier sibling
    // first. This allows people to have fine-grained control over the matching
    // behavior by simply putting routes with identical paths in the order they
    // want them tried.
    a[a.length - 1] - b[b.length - 1] : // Otherwise, it doesn't really make sense to rank non-siblings by index,
    // so they sort equally.
    0;
}
function matchRouteBranch(branch, pathname, allowPartial) {
    if (allowPartial === void 0) allowPartial = false;
    var routesMeta = branch.routesMeta;
    var matchedParams = {};
    var matchedPathname = "/";
    var matches = [];
    for(var i = 0; i < routesMeta.length; ++i){
        var meta = routesMeta[i];
        var end = i === routesMeta.length - 1;
        var remainingPathname = matchedPathname === "/" ? pathname : pathname.slice(matchedPathname.length) || "/";
        var match = matchPath({
            path: meta.relativePath,
            caseSensitive: meta.caseSensitive,
            end: end
        }, remainingPathname);
        var route = meta.route;
        if (!match && end && allowPartial && !routesMeta[routesMeta.length - 1].route.index) match = matchPath({
            path: meta.relativePath,
            caseSensitive: meta.caseSensitive,
            end: false
        }, remainingPathname);
        if (!match) return null;
        Object.assign(matchedParams, match.params);
        matches.push({
            // TODO: Can this as be avoided?
            params: matchedParams,
            pathname: joinPaths([
                matchedPathname,
                match.pathname
            ]),
            pathnameBase: normalizePathname(joinPaths([
                matchedPathname,
                match.pathnameBase
            ])),
            route: route
        });
        if (match.pathnameBase !== "/") matchedPathname = joinPaths([
            matchedPathname,
            match.pathnameBase
        ]);
    }
    return matches;
}
/**
 * Returns a path with params interpolated.
 *
 * @see https://reactrouter.com/v6/utils/generate-path
 */ function generatePath(originalPath, params) {
    if (params === void 0) params = {};
    var path = originalPath;
    if (path.endsWith("*") && path !== "*" && !path.endsWith("/*")) {
        warning(false, "Route path \"" + path + "\" will be treated as if it were " + ("\"" + path.replace(/\*$/, "/*") + "\" because the `*` character must ") + "always follow a `/` in the pattern. To get rid of this warning, " + ("please change the route path to \"" + path.replace(/\*$/, "/*") + "\"."));
        path = path.replace(/\*$/, "/*");
    }
    // ensure `/` is added at the beginning if the path is absolute
    var prefix = path.startsWith("/") ? "/" : "";
    var stringify = function(p) {
        return p == null ? "" : typeof p === "string" ? p : String(p);
    };
    var segments = path.split(/\/+/).map(function(segment, index, array) {
        var isLastSegment = index === array.length - 1;
        // only apply the splat if it's the last segment
        if (isLastSegment && segment === "*") {
            var star = "*";
            // Apply the splat
            return stringify(params[star]);
        }
        var keyMatch = segment.match(/^:([\w-]+)(\??)$/);
        if (keyMatch) {
            var _keyMatch = (0, $2nwvT._)(keyMatch, 3), key = _keyMatch[1], optional = _keyMatch[2];
            var param = params[key];
            invariant(optional === "?" || param != null, "Missing \":" + key + "\" param");
            return stringify(param);
        }
        // Remove any optional markers from optional static segments
        return segment.replace(/\?$/g, "");
    })// Remove empty segments
    .filter(function(segment) {
        return !!segment;
    });
    return prefix + segments.join("/");
}
/**
 * Performs pattern matching on a URL pathname and returns information about
 * the match.
 *
 * @see https://reactrouter.com/v6/utils/match-path
 */ function matchPath(pattern, pathname) {
    if (typeof pattern === "string") pattern = {
        path: pattern,
        caseSensitive: false,
        end: true
    };
    var _compilePath = (0, $2nwvT._)(compilePath(pattern.path, pattern.caseSensitive, pattern.end), 2), matcher = _compilePath[0], compiledParams = _compilePath[1];
    var match = pathname.match(matcher);
    if (!match) return null;
    var matchedPathname = match[0];
    var pathnameBase = matchedPathname.replace(/(.)\/+$/, "$1");
    var captureGroups = match.slice(1);
    var params = compiledParams.reduce(function(memo, _ref, index) {
        var paramName = _ref.paramName, isOptional = _ref.isOptional;
        // We need to compute the pathnameBase here using the raw splat value
        // instead of using params["*"] later because it will be decoded then
        if (paramName === "*") {
            var splatValue = captureGroups[index] || "";
            pathnameBase = matchedPathname.slice(0, matchedPathname.length - splatValue.length).replace(/(.)\/+$/, "$1");
        }
        var value = captureGroups[index];
        if (isOptional && !value) memo[paramName] = undefined;
        else memo[paramName] = (value || "").replace(/%2F/g, "/");
        return memo;
    }, {});
    return {
        params: params,
        pathname: matchedPathname,
        pathnameBase: pathnameBase,
        pattern: pattern
    };
}
function compilePath(path, caseSensitive, end) {
    if (caseSensitive === void 0) caseSensitive = false;
    if (end === void 0) end = true;
    warning(path === "*" || !path.endsWith("*") || path.endsWith("/*"), "Route path \"" + path + "\" will be treated as if it were " + ("\"" + path.replace(/\*$/, "/*") + "\" because the `*` character must ") + "always follow a `/` in the pattern. To get rid of this warning, " + ("please change the route path to \"" + path.replace(/\*$/, "/*") + "\"."));
    var params = [];
    var regexpSource = "^" + path.replace(/\/*\*?$/, "") // Ignore trailing / and /*, we'll handle it below
    .replace(/^\/*/, "/") // Make sure it has a leading /
    .replace(/[\\.*+^${}|()[\]]/g, "\\$&") // Escape special regex chars
    .replace(/\/:([\w-]+)(\?)?/g, function(_, paramName, isOptional) {
        params.push({
            paramName: paramName,
            isOptional: isOptional != null
        });
        return isOptional ? "/?([^\\/]+)?" : "/([^\\/]+)";
    });
    if (path.endsWith("*")) {
        params.push({
            paramName: "*"
        });
        regexpSource += path === "*" || path === "/*" ? "(.*)$" // Already matched the initial /, just match the rest
         : "(?:\\/(.+)|\\/*)$"; // Don't include the / in params["*"]
    } else if (end) // When matching to the end, ignore trailing slashes
    regexpSource += "\\/*$";
    else if (path !== "" && path !== "/") // If our path is non-empty and contains anything beyond an initial slash,
    // then we have _some_ form of path in our regex, so we should expect to
    // match only if we find the end of this path segment.  Look for an optional
    // non-captured trailing slash (to match a portion of the URL) or the end
    // of the path (if we've matched to the end).  We used to do this with a
    // word boundary but that gives false positives on routes like
    // /user-preferences since `-` counts as a word boundary.
    regexpSource += "(?:(?=\\/|$))";
    var matcher = new RegExp(regexpSource, caseSensitive ? undefined : "i");
    return [
        matcher,
        params
    ];
}
function decodePath(value) {
    try {
        return value.split("/").map(function(v) {
            return decodeURIComponent(v).replace(/\//g, "%2F");
        }).join("/");
    } catch (error) {
        warning(false, "The URL path \"" + value + "\" could not be decoded because it is is a " + "malformed URL segment. This is probably due to a bad percent " + ("encoding (" + error + ")."));
        return value;
    }
}
/**
 * @private
 */ function stripBasename(pathname, basename) {
    if (basename === "/") return pathname;
    if (!pathname.toLowerCase().startsWith(basename.toLowerCase())) return null;
    // We want to leave trailing slash behavior in the user's control, so if they
    // specify a basename with a trailing slash, we should support it
    var startIndex = basename.endsWith("/") ? basename.length - 1 : basename.length;
    var nextChar = pathname.charAt(startIndex);
    if (nextChar && nextChar !== "/") // pathname does not start with basename/
    return null;
    return pathname.slice(startIndex) || "/";
}
var ABSOLUTE_URL_REGEX$1 = /^(?:[a-z][a-z0-9+.-]*:|\/\/)/i;
var isAbsoluteUrl = function(url) {
    return ABSOLUTE_URL_REGEX$1.test(url);
};
/**
 * Returns a resolved path object relative to the given pathname.
 *
 * @see https://reactrouter.com/v6/utils/resolve-path
 */ function resolvePath(to, fromPathname) {
    if (fromPathname === void 0) fromPathname = "/";
    var _ref = typeof to === "string" ? parsePath(to) : to, toPathname = _ref.pathname, _ref_search = _ref.search, search = _ref_search === void 0 ? "" : _ref_search, _ref_hash = _ref.hash, hash = _ref_hash === void 0 ? "" : _ref_hash;
    var pathname;
    if (toPathname) {
        if (isAbsoluteUrl(toPathname)) pathname = toPathname;
        else {
            if (toPathname.includes("//")) {
                var oldPathname = toPathname;
                toPathname = toPathname.replace(/\/\/+/g, "/");
                warning(false, "Pathnames cannot have embedded double slashes - normalizing " + (oldPathname + " -> " + toPathname));
            }
            if (toPathname.startsWith("/")) pathname = resolvePathname(toPathname.substring(1), "/");
            else pathname = resolvePathname(toPathname, fromPathname);
        }
    } else pathname = fromPathname;
    return {
        pathname: pathname,
        search: normalizeSearch(search),
        hash: normalizeHash(hash)
    };
}
function resolvePathname(relativePath, fromPathname) {
    var segments = fromPathname.replace(/\/+$/, "").split("/");
    var relativeSegments = relativePath.split("/");
    relativeSegments.forEach(function(segment) {
        if (segment === "..") // Keep the root "" segment so the pathname starts at /
        {
            if (segments.length > 1) segments.pop();
        } else if (segment !== ".") segments.push(segment);
    });
    return segments.length > 1 ? segments.join("/") : "/";
}
function getInvalidPathError(char, field, dest, path) {
    return "Cannot include a '" + char + "' character in a manually specified " + ("`to." + field + "` field [" + JSON.stringify(path) + "].  Please separate it out to the ") + ("`to." + dest + "` field. Alternatively you may provide the full path as ") + "a string in <Link to=\"...\"> and the router will parse it for you.";
}
/**
 * @private
 *
 * When processing relative navigation we want to ignore ancestor routes that
 * do not contribute to the path, such that index/pathless layout routes don't
 * interfere.
 *
 * For example, when moving a route element into an index route and/or a
 * pathless layout route, relative link behavior contained within should stay
 * the same.  Both of the following examples should link back to the root:
 *
 *   <Route path="/">
 *     <Route path="accounts" element={<Link to=".."}>
 *   </Route>
 *
 *   <Route path="/">
 *     <Route path="accounts">
 *       <Route element={<AccountsLayout />}>       // <-- Does not contribute
 *         <Route index element={<Link to=".."} />  // <-- Does not contribute
 *       </Route
 *     </Route>
 *   </Route>
 */ function getPathContributingMatches(matches) {
    return matches.filter(function(match, index) {
        return index === 0 || match.route.path && match.route.path.length > 0;
    });
}
// Return the array of pathnames for the current route matches - used to
// generate the routePathnames input for resolveTo()
function getResolveToMatches(matches, v7_relativeSplatPath) {
    var pathMatches = getPathContributingMatches(matches);
    // When v7_relativeSplatPath is enabled, use the full pathname for the leaf
    // match so we include splat values for "." links.  See:
    // https://github.com/remix-run/react-router/issues/11052#issuecomment-1836589329
    if (v7_relativeSplatPath) return pathMatches.map(function(match, idx) {
        return idx === pathMatches.length - 1 ? match.pathname : match.pathnameBase;
    });
    return pathMatches.map(function(match) {
        return match.pathnameBase;
    });
}
/**
 * @private
 */ function resolveTo(toArg, routePathnames, locationPathname, isPathRelative) {
    if (isPathRelative === void 0) isPathRelative = false;
    var to;
    if (typeof toArg === "string") to = parsePath(toArg);
    else {
        to = _extends({}, toArg);
        invariant(!to.pathname || !to.pathname.includes("?"), getInvalidPathError("?", "pathname", "search", to));
        invariant(!to.pathname || !to.pathname.includes("#"), getInvalidPathError("#", "pathname", "hash", to));
        invariant(!to.search || !to.search.includes("#"), getInvalidPathError("#", "search", "hash", to));
    }
    var isEmptyPath = toArg === "" || to.pathname === "";
    var toPathname = isEmptyPath ? "/" : to.pathname;
    var from;
    // Routing is relative to the current pathname if explicitly requested.
    //
    // If a pathname is explicitly provided in `to`, it should be relative to the
    // route context. This is explained in `Note on `<Link to>` values` in our
    // migration guide from v5 as a means of disambiguation between `to` values
    // that begin with `/` and those that do not. However, this is problematic for
    // `to` values that do not provide a pathname. `to` can simply be a search or
    // hash string, in which case we should assume that the navigation is relative
    // to the current location's pathname and *not* the route pathname.
    if (toPathname == null) from = locationPathname;
    else {
        var routePathnameIndex = routePathnames.length - 1;
        // With relative="route" (the default), each leading .. segment means
        // "go up one route" instead of "go up one URL segment".  This is a key
        // difference from how <a href> works and a major reason we call this a
        // "to" value instead of a "href".
        if (!isPathRelative && toPathname.startsWith("..")) {
            var toSegments = toPathname.split("/");
            while(toSegments[0] === ".."){
                toSegments.shift();
                routePathnameIndex -= 1;
            }
            to.pathname = toSegments.join("/");
        }
        from = routePathnameIndex >= 0 ? routePathnames[routePathnameIndex] : "/";
    }
    var path = resolvePath(to, from);
    // Ensure the pathname has a trailing slash if the original "to" had one
    var hasExplicitTrailingSlash = toPathname && toPathname !== "/" && toPathname.endsWith("/");
    // Or if this was a link to the current path which has a trailing slash
    var hasCurrentTrailingSlash = (isEmptyPath || toPathname === ".") && locationPathname.endsWith("/");
    if (!path.pathname.endsWith("/") && (hasExplicitTrailingSlash || hasCurrentTrailingSlash)) path.pathname += "/";
    return path;
}
/**
 * @private
 */ function getToPathname(to) {
    // Empty strings should be treated the same as / paths
    return to === "" || to.pathname === "" ? "/" : typeof to === "string" ? parsePath(to).pathname : to.pathname;
}
/**
 * @private
 */ var joinPaths = function(paths) {
    return paths.join("/").replace(/\/\/+/g, "/");
};
/**
 * @private
 */ var normalizePathname = function(pathname) {
    return pathname.replace(/\/+$/, "").replace(/^\/*/, "/");
};
/**
 * @private
 */ var normalizeSearch = function(search) {
    return !search || search === "?" ? "" : search.startsWith("?") ? search : "?" + search;
};
/**
 * @private
 */ var normalizeHash = function(hash) {
    return !hash || hash === "#" ? "" : hash.startsWith("#") ? hash : "#" + hash;
};
/**
 * This is a shortcut for creating `application/json` responses. Converts `data`
 * to JSON and sets the `Content-Type` header.
 *
 * @deprecated The `json` method is deprecated in favor of returning raw objects.
 * This method will be removed in v7.
 */ var json = function json(data, init) {
    if (init === void 0) init = {};
    var responseInit = typeof init === "number" ? {
        status: init
    } : init;
    var headers = new Headers(responseInit.headers);
    if (!headers.has("Content-Type")) headers.set("Content-Type", "application/json; charset=utf-8");
    return new Response(JSON.stringify(data), _extends({}, responseInit, {
        headers: headers
    }));
};
var DataWithResponseInit = function DataWithResponseInit(data, init) {
    "use strict";
    (0, $grujF._)(this, DataWithResponseInit);
    this.type = "DataWithResponseInit";
    this.data = data;
    this.init = init || null;
};
/**
 * Create "responses" that contain `status`/`headers` without forcing
 * serialization into an actual `Response` - used by Remix single fetch
 */ function data(data, init) {
    return new DataWithResponseInit(data, typeof init === "number" ? {
        status: init
    } : init);
}
var AbortedDeferredError = /*#__PURE__*/ function(Error1) {
    "use strict";
    (0, $j6Mzi._)(AbortedDeferredError, Error1);
    function AbortedDeferredError() {
        (0, $grujF._)(this, AbortedDeferredError);
        return (0, $f3Okx._)(this, AbortedDeferredError, arguments);
    }
    return AbortedDeferredError;
}((0, $1EZOw._)(Error));
var DeferredData = /*#__PURE__*/ function() {
    "use strict";
    function DeferredData(data, responseInit) {
        var _this = this;
        (0, $grujF._)(this, DeferredData);
        this.pendingKeysSet = new Set();
        this.subscribers = new Set();
        this.deferredKeys = [];
        invariant(data && (typeof data === "undefined" ? "undefined" : (0, $bJtXW._)(data)) === "object" && !Array.isArray(data), "defer() only accepts plain objects");
        // Set up an AbortController + Promise we can race against to exit early
        // cancellation
        var reject;
        this.abortPromise = new Promise(function(_, r) {
            return reject = r;
        });
        this.controller = new AbortController();
        var onAbort = function() {
            return reject(new AbortedDeferredError("Deferred data aborted"));
        };
        this.unlistenAbortSignal = function() {
            return _this.controller.signal.removeEventListener("abort", onAbort);
        };
        this.controller.signal.addEventListener("abort", onAbort);
        this.data = Object.entries(data).reduce(function(acc, _ref2) {
            var _$_ref2 = (0, $2nwvT._)(_ref2, 2), key = _$_ref2[0], value = _$_ref2[1];
            return Object.assign(acc, (0, $72osQ._)({}, key, _this.trackPromise(key, value)));
        }, {});
        if (this.done) // All incoming values were resolved
        this.unlistenAbortSignal();
        this.init = responseInit;
    }
    (0, $dhMkv._)(DeferredData, [
        {
            key: "trackPromise",
            value: function trackPromise(key, value) {
                var _this = this;
                if (!(value instanceof Promise)) return value;
                this.deferredKeys.push(key);
                this.pendingKeysSet.add(key);
                // We store a little wrapper promise that will be extended with
                // _data/_error props upon resolve/reject
                var promise = Promise.race([
                    value,
                    this.abortPromise
                ]).then(function(data) {
                    return _this.onSettle(promise, key, undefined, data);
                }, function(error) {
                    return _this.onSettle(promise, key, error);
                });
                // Register rejection listeners to avoid uncaught promise rejections on
                // errors or aborted deferred values
                promise.catch(function() {});
                Object.defineProperty(promise, "_tracked", {
                    get: function() {
                        return true;
                    }
                });
                return promise;
            }
        },
        {
            key: "onSettle",
            value: function onSettle(promise, key, error, data) {
                if (this.controller.signal.aborted && error instanceof AbortedDeferredError) {
                    this.unlistenAbortSignal();
                    Object.defineProperty(promise, "_error", {
                        get: function() {
                            return error;
                        }
                    });
                    return Promise.reject(error);
                }
                this.pendingKeysSet.delete(key);
                if (this.done) // Nothing left to abort!
                this.unlistenAbortSignal();
                // If the promise was resolved/rejected with undefined, we'll throw an error as you
                // should always resolve with a value or null
                if (error === undefined && data === undefined) {
                    var undefinedError = new Error("Deferred data for key \"" + key + "\" resolved/rejected with `undefined`, " + "you must resolve/reject with a value or `null`.");
                    Object.defineProperty(promise, "_error", {
                        get: function() {
                            return undefinedError;
                        }
                    });
                    this.emit(false, key);
                    return Promise.reject(undefinedError);
                }
                if (data === undefined) {
                    Object.defineProperty(promise, "_error", {
                        get: function() {
                            return error;
                        }
                    });
                    this.emit(false, key);
                    return Promise.reject(error);
                }
                Object.defineProperty(promise, "_data", {
                    get: function() {
                        return data;
                    }
                });
                this.emit(false, key);
                return data;
            }
        },
        {
            key: "emit",
            value: function emit(aborted, settledKey) {
                this.subscribers.forEach(function(subscriber) {
                    return subscriber(aborted, settledKey);
                });
            }
        },
        {
            key: "subscribe",
            value: function subscribe(fn) {
                var _this = this;
                this.subscribers.add(fn);
                return function() {
                    return _this.subscribers.delete(fn);
                };
            }
        },
        {
            key: "cancel",
            value: function cancel() {
                var _this = this;
                this.controller.abort();
                this.pendingKeysSet.forEach(function(v, k) {
                    return _this.pendingKeysSet.delete(k);
                });
                this.emit(true);
            }
        },
        {
            key: "resolveData",
            value: function resolveData(signal) {
                return (/*#__PURE__*/ 0, /*#__PURE__*/ $g3gsR._)(function() {
                    var _this, aborted, onAbort;
                    return (0, $fRv9I.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                _this = this;
                                aborted = false;
                                if (!!this.done) return [
                                    3,
                                    2
                                ];
                                onAbort = function() {
                                    return _this.cancel();
                                };
                                signal.addEventListener("abort", onAbort);
                                return [
                                    4,
                                    new Promise(function(resolve) {
                                        _this.subscribe(function(aborted) {
                                            signal.removeEventListener("abort", onAbort);
                                            if (aborted || _this.done) resolve(aborted);
                                        });
                                    })
                                ];
                            case 1:
                                aborted = _state.sent();
                                _state.label = 2;
                            case 2:
                                return [
                                    2,
                                    aborted
                                ];
                        }
                    });
                }).call(this);
            }
        },
        {
            key: "done",
            get: function get() {
                return this.pendingKeysSet.size === 0;
            }
        },
        {
            key: "unwrappedData",
            get: function get() {
                invariant(this.data !== null && this.done, "Can only unwrap data on initialized and settled deferreds");
                return Object.entries(this.data).reduce(function(acc, _ref3) {
                    var _$_ref3 = (0, $2nwvT._)(_ref3, 2), key = _$_ref3[0], value = _$_ref3[1];
                    return Object.assign(acc, (0, $72osQ._)({}, key, unwrapTrackedPromise(value)));
                }, {});
            }
        },
        {
            key: "pendingKeys",
            get: function get() {
                return Array.from(this.pendingKeysSet);
            }
        }
    ]);
    return DeferredData;
}();
function isTrackedPromise(value) {
    return value instanceof Promise && value._tracked === true;
}
function unwrapTrackedPromise(value) {
    if (!isTrackedPromise(value)) return value;
    if (value._error) throw value._error;
    return value._data;
}
/**
 * @deprecated The `defer` method is deprecated in favor of returning raw
 * objects. This method will be removed in v7.
 */ var defer = function defer(data, init) {
    if (init === void 0) init = {};
    var responseInit = typeof init === "number" ? {
        status: init
    } : init;
    return new DeferredData(data, responseInit);
};
/**
 * A redirect response. Sets the status code and the `Location` header.
 * Defaults to "302 Found".
 */ var redirect = function redirect(url, init) {
    if (init === void 0) init = 302;
    var responseInit = init;
    if (typeof responseInit === "number") responseInit = {
        status: responseInit
    };
    else if (typeof responseInit.status === "undefined") responseInit.status = 302;
    var headers = new Headers(responseInit.headers);
    headers.set("Location", url);
    return new Response(null, _extends({}, responseInit, {
        headers: headers
    }));
};
/**
 * A redirect response that will force a document reload to the new location.
 * Sets the status code and the `Location` header.
 * Defaults to "302 Found".
 */ var redirectDocument = function(url, init) {
    var response = redirect(url, init);
    response.headers.set("X-Remix-Reload-Document", "true");
    return response;
};
/**
 * A redirect response that will perform a `history.replaceState` instead of a
 * `history.pushState` for client-side navigation redirects.
 * Sets the status code and the `Location` header.
 * Defaults to "302 Found".
 */ var replace = function(url, init) {
    var response = redirect(url, init);
    response.headers.set("X-Remix-Replace", "true");
    return response;
};
/**
 * @private
 * Utility class we use to hold auto-unwrapped 4xx/5xx Response bodies
 *
 * We don't export the class for public use since it's an implementation
 * detail, but we export the interface above so folks can build their own
 * abstractions around instances via isRouteErrorResponse()
 */ var ErrorResponseImpl = function ErrorResponseImpl(status, statusText, data, internal) {
    "use strict";
    (0, $grujF._)(this, ErrorResponseImpl);
    if (internal === void 0) internal = false;
    this.status = status;
    this.statusText = statusText || "";
    this.internal = internal;
    if (data instanceof Error) {
        this.data = data.toString();
        this.error = data;
    } else this.data = data;
};
/**
 * Check if the given error is an ErrorResponse generated from a 4xx/5xx
 * Response thrown from an action/loader
 */ function isRouteErrorResponse(error) {
    return error != null && typeof error.status === "number" && typeof error.statusText === "string" && typeof error.internal === "boolean" && "data" in error;
}
var validMutationMethodsArr = [
    "post",
    "put",
    "patch",
    "delete"
];
var validMutationMethods = new Set(validMutationMethodsArr);
var validRequestMethodsArr = [
    "get"
].concat((0, $2us1u._)(validMutationMethodsArr));
var validRequestMethods = new Set(validRequestMethodsArr);
var redirectStatusCodes = new Set([
    301,
    302,
    303,
    307,
    308
]);
var redirectPreserveMethodStatusCodes = new Set([
    307,
    308
]);
var IDLE_NAVIGATION = {
    state: "idle",
    location: undefined,
    formMethod: undefined,
    formAction: undefined,
    formEncType: undefined,
    formData: undefined,
    json: undefined,
    text: undefined
};
var IDLE_FETCHER = {
    state: "idle",
    data: undefined,
    formMethod: undefined,
    formAction: undefined,
    formEncType: undefined,
    formData: undefined,
    json: undefined,
    text: undefined
};
var IDLE_BLOCKER = {
    state: "unblocked",
    proceed: undefined,
    reset: undefined,
    location: undefined
};
var ABSOLUTE_URL_REGEX = /^(?:[a-z][a-z0-9+.-]*:|\/\/)/i;
var defaultMapRouteProperties = function(route) {
    return {
        hasErrorBoundary: Boolean(route.hasErrorBoundary)
    };
};
var TRANSITIONS_STORAGE_KEY = "remix-router-transitions";
//#endregion
////////////////////////////////////////////////////////////////////////////////
//#region createRouter
////////////////////////////////////////////////////////////////////////////////
/**
 * Create a router and listen to history POP navigations
 */ function createRouter(init) {
    var routerWindow = init.window ? init.window : typeof window !== "undefined" ? window : undefined;
    var isBrowser = typeof routerWindow !== "undefined" && typeof routerWindow.document !== "undefined" && typeof routerWindow.document.createElement !== "undefined";
    var isServer = !isBrowser;
    invariant(init.routes.length > 0, "You must provide a non-empty routes array to createRouter");
    var mapRouteProperties;
    if (init.mapRouteProperties) mapRouteProperties = init.mapRouteProperties;
    else if (init.detectErrorBoundary) {
        // If they are still using the deprecated version, wrap it with the new API
        var detectErrorBoundary = init.detectErrorBoundary;
        mapRouteProperties = function(route) {
            return {
                hasErrorBoundary: detectErrorBoundary(route)
            };
        };
    } else mapRouteProperties = defaultMapRouteProperties;
    // Routes keyed by ID
    var manifest = {};
    // Routes in tree format for matching
    var dataRoutes = convertRoutesToDataRoutes(init.routes, mapRouteProperties, undefined, manifest);
    var inFlightDataRoutes;
    var basename = init.basename || "/";
    var dataStrategyImpl = init.dataStrategy || defaultDataStrategy;
    var patchRoutesOnNavigationImpl = init.patchRoutesOnNavigation;
    // Config driven behavior flags
    var future = _extends({
        v7_fetcherPersist: false,
        v7_normalizeFormMethod: false,
        v7_partialHydration: false,
        v7_prependBasename: false,
        v7_relativeSplatPath: false,
        v7_skipActionErrorRevalidation: false
    }, init.future);
    // Cleanup function for history
    var unlistenHistory = null;
    // Externally-provided functions to call on all state changes
    var subscribers = new Set();
    // Externally-provided object to hold scroll restoration locations during routing
    var savedScrollPositions = null;
    // Externally-provided function to get scroll restoration keys
    var getScrollRestorationKey = null;
    // Externally-provided function to get current scroll position
    var getScrollPosition = null;
    // One-time flag to control the initial hydration scroll restoration.  Because
    // we don't get the saved positions from <ScrollRestoration /> until _after_
    // the initial render, we need to manually trigger a separate updateState to
    // send along the restoreScrollPosition
    // Set to true if we have `hydrationData` since we assume we were SSR'd and that
    // SSR did the initial scroll restoration.
    var initialScrollRestored = init.hydrationData != null;
    var initialMatches = matchRoutes(dataRoutes, init.history.location, basename);
    var initialMatchesIsFOW = false;
    var initialErrors = null;
    if (initialMatches == null && !patchRoutesOnNavigationImpl) {
        // If we do not match a user-provided-route, fall back to the root
        // to allow the error boundary to take over
        var error = getInternalRouterError(404, {
            pathname: init.history.location.pathname
        });
        var _getShortCircuitMatches = getShortCircuitMatches(dataRoutes), matches = _getShortCircuitMatches.matches, route = _getShortCircuitMatches.route;
        initialMatches = matches;
        initialErrors = (0, $72osQ._)({}, route.id, error);
    }
    // In SPA apps, if the user provided a patchRoutesOnNavigation implementation and
    // our initial match is a splat route, clear them out so we run through lazy
    // discovery on hydration in case there's a more accurate lazy route match.
    // In SSR apps (with `hydrationData`), we expect that the server will send
    // up the proper matched routes so we don't want to run lazy discovery on
    // initial hydration and want to hydrate into the splat route.
    if (initialMatches && !init.hydrationData) {
        var fogOfWar = checkFogOfWar(initialMatches, dataRoutes, init.history.location.pathname);
        if (fogOfWar.active) initialMatches = null;
    }
    var initialized;
    if (!initialMatches) {
        initialized = false;
        initialMatches = [];
        // If partial hydration and fog of war is enabled, we will be running
        // `patchRoutesOnNavigation` during hydration so include any partial matches as
        // the initial matches so we can properly render `HydrateFallback`'s
        if (future.v7_partialHydration) {
            var fogOfWar1 = checkFogOfWar(null, dataRoutes, init.history.location.pathname);
            if (fogOfWar1.active && fogOfWar1.matches) {
                initialMatchesIsFOW = true;
                initialMatches = fogOfWar1.matches;
            }
        }
    } else if (initialMatches.some(function(m) {
        return m.route.lazy;
    })) // All initialMatches need to be loaded before we're ready.  If we have lazy
    // functions around still then we'll need to run them in initialize()
    initialized = false;
    else if (!initialMatches.some(function(m) {
        return m.route.loader;
    })) // If we've got no loaders to run, then we're good to go
    initialized = true;
    else if (future.v7_partialHydration) {
        // If partial hydration is enabled, we're initialized so long as we were
        // provided with hydrationData for every route with a loader, and no loaders
        // were marked for explicit hydration
        var loaderData = init.hydrationData ? init.hydrationData.loaderData : null;
        var errors = init.hydrationData ? init.hydrationData.errors : null;
        // If errors exist, don't consider routes below the boundary
        if (errors) {
            var idx = initialMatches.findIndex(function(m) {
                return errors[m.route.id] !== undefined;
            });
            initialized = initialMatches.slice(0, idx + 1).every(function(m) {
                return !shouldLoadRouteOnHydration(m.route, loaderData, errors);
            });
        } else initialized = initialMatches.every(function(m) {
            return !shouldLoadRouteOnHydration(m.route, loaderData, errors);
        });
    } else // Without partial hydration - we're initialized if we were provided any
    // hydrationData - which is expected to be complete
    initialized = init.hydrationData != null;
    var router;
    var state = {
        historyAction: init.history.action,
        location: init.history.location,
        matches: initialMatches,
        initialized: initialized,
        navigation: IDLE_NAVIGATION,
        // Don't restore on initial updateState() if we were SSR'd
        restoreScrollPosition: init.hydrationData != null ? false : null,
        preventScrollReset: false,
        revalidation: "idle",
        loaderData: init.hydrationData && init.hydrationData.loaderData || {},
        actionData: init.hydrationData && init.hydrationData.actionData || null,
        errors: init.hydrationData && init.hydrationData.errors || initialErrors,
        fetchers: new Map(),
        blockers: new Map()
    };
    // -- Stateful internal variables to manage navigations --
    // Current navigation in progress (to be committed in completeNavigation)
    var pendingAction = Action.Pop;
    // Should the current navigation prevent the scroll reset if scroll cannot
    // be restored?
    var pendingPreventScrollReset = false;
    // AbortController for the active navigation
    var pendingNavigationController;
    // Should the current navigation enable document.startViewTransition?
    var pendingViewTransitionEnabled = false;
    // Store applied view transitions so we can apply them on POP
    var appliedViewTransitions = new Map();
    // Cleanup function for persisting applied transitions to sessionStorage
    var removePageHideEventListener = null;
    // We use this to avoid touching history in completeNavigation if a
    // revalidation is entirely uninterrupted
    var isUninterruptedRevalidation = false;
    // Use this internal flag to force revalidation of all loaders:
    //  - submissions (completed or interrupted)
    //  - useRevalidator()
    //  - X-Remix-Revalidate (from redirect)
    var isRevalidationRequired = false;
    // Use this internal array to capture routes that require revalidation due
    // to a cancelled deferred on action submission
    var cancelledDeferredRoutes = [];
    // Use this internal array to capture fetcher loads that were cancelled by an
    // action navigation and require revalidation
    var cancelledFetcherLoads = new Set();
    // AbortControllers for any in-flight fetchers
    var fetchControllers = new Map();
    // Track loads based on the order in which they started
    var incrementingLoadId = 0;
    // Track the outstanding pending navigation data load to be compared against
    // the globally incrementing load when a fetcher load lands after a completed
    // navigation
    var pendingNavigationLoadId = -1;
    // Fetchers that triggered data reloads as a result of their actions
    var fetchReloadIds = new Map();
    // Fetchers that triggered redirect navigations
    var fetchRedirectIds = new Set();
    // Most recent href/match for fetcher.load calls for fetchers
    var fetchLoadMatches = new Map();
    // Ref-count mounted fetchers so we know when it's ok to clean them up
    var activeFetchers = new Map();
    // Fetchers that have requested a delete when using v7_fetcherPersist,
    // they'll be officially removed after they return to idle
    var deletedFetchers = new Set();
    // Store DeferredData instances for active route matches.  When a
    // route loader returns defer() we stick one in here.  Then, when a nested
    // promise resolves we update loaderData.  If a new navigation starts we
    // cancel active deferreds for eliminated routes.
    var activeDeferreds = new Map();
    // Store blocker functions in a separate Map outside of router state since
    // we don't need to update UI state if they change
    var blockerFunctions = new Map();
    // Flag to ignore the next history update, so we can revert the URL change on
    // a POP navigation that was blocked by the user without touching router state
    var unblockBlockerHistoryUpdate = undefined;
    // Initialize the router, all side effects should be kicked off from here.
    // Implemented as a Fluent API for ease of:
    //   let router = createRouter(init).initialize();
    function initialize() {
        // If history informs us of a POP navigation, start the navigation but do not update
        // state.  We'll update our own state once the navigation completes
        unlistenHistory = init.history.listen(function(_ref) {
            var historyAction = _ref.action, location = _ref.location, delta = _ref.delta;
            // Ignore this event if it was just us resetting the URL from a
            // blocked POP navigation
            if (unblockBlockerHistoryUpdate) {
                unblockBlockerHistoryUpdate();
                unblockBlockerHistoryUpdate = undefined;
                return;
            }
            warning(blockerFunctions.size === 0 || delta != null, "You are trying to use a blocker on a POP navigation to a location that was not created by @remix-run/router. This will fail silently in production. This can happen if you are navigating outside the router via `window.history.pushState`/`window.location.hash` instead of using router navigation APIs.  This can also happen if you are using createHashRouter and the user manually changes the URL.");
            var blockerKey = shouldBlockNavigation({
                currentLocation: state.location,
                nextLocation: location,
                historyAction: historyAction
            });
            if (blockerKey && delta != null) {
                // Restore the URL to match the current UI, but don't update router state
                var nextHistoryUpdatePromise = new Promise(function(resolve) {
                    unblockBlockerHistoryUpdate = resolve;
                });
                init.history.go(delta * -1);
                // Put the blocker into a blocked state
                updateBlocker(blockerKey, {
                    state: "blocked",
                    location: location,
                    proceed: function() {
                        updateBlocker(blockerKey, {
                            state: "proceeding",
                            proceed: undefined,
                            reset: undefined,
                            location: location
                        });
                        // Re-do the same POP navigation we just blocked, after the url
                        // restoration is also complete.  See:
                        // https://github.com/remix-run/react-router/issues/11613
                        nextHistoryUpdatePromise.then(function() {
                            return init.history.go(delta);
                        });
                    },
                    reset: function() {
                        var blockers = new Map(state.blockers);
                        blockers.set(blockerKey, IDLE_BLOCKER);
                        updateState({
                            blockers: blockers
                        });
                    }
                });
                return;
            }
            return startNavigation(historyAction, location);
        });
        if (isBrowser) {
            // FIXME: This feels gross.  How can we cleanup the lines between
            // scrollRestoration/appliedTransitions persistance?
            restoreAppliedTransitions(routerWindow, appliedViewTransitions);
            var _saveAppliedTransitions = function() {
                return persistAppliedTransitions(routerWindow, appliedViewTransitions);
            };
            routerWindow.addEventListener("pagehide", _saveAppliedTransitions);
            removePageHideEventListener = function() {
                return routerWindow.removeEventListener("pagehide", _saveAppliedTransitions);
            };
        }
        // Kick off initial data load if needed.  Use Pop to avoid modifying history
        // Note we don't do any handling of lazy here.  For SPA's it'll get handled
        // in the normal navigation flow.  For SSR it's expected that lazy modules are
        // resolved prior to router creation since we can't go into a fallbackElement
        // UI for SSR'd apps
        if (!state.initialized) startNavigation(Action.Pop, state.location, {
            initialHydration: true
        });
        return router;
    }
    // Clean up a router and it's side effects
    function dispose() {
        if (unlistenHistory) unlistenHistory();
        if (removePageHideEventListener) removePageHideEventListener();
        subscribers.clear();
        pendingNavigationController && pendingNavigationController.abort();
        state.fetchers.forEach(function(_, key) {
            return deleteFetcher(key);
        });
        state.blockers.forEach(function(_, key) {
            return deleteBlocker(key);
        });
    }
    // Subscribe to state updates for the router
    function subscribe(fn) {
        subscribers.add(fn);
        return function() {
            return subscribers.delete(fn);
        };
    }
    // Update our state and notify the calling context of the change
    function updateState(newState, opts) {
        if (opts === void 0) opts = {};
        state = _extends({}, state, newState);
        // Prep fetcher cleanup so we can tell the UI which fetcher data entries
        // can be removed
        var completedFetchers = [];
        var deletedFetchersKeys = [];
        if (future.v7_fetcherPersist) state.fetchers.forEach(function(fetcher, key) {
            if (fetcher.state === "idle") {
                if (deletedFetchers.has(key)) // Unmounted from the UI and can be totally removed
                deletedFetchersKeys.push(key);
                else // Returned to idle but still mounted in the UI, so semi-remains for
                // revalidations and such
                completedFetchers.push(key);
            }
        });
        // Remove any lingering deleted fetchers that have already been removed
        // from state.fetchers
        deletedFetchers.forEach(function(key) {
            if (!state.fetchers.has(key) && !fetchControllers.has(key)) deletedFetchersKeys.push(key);
        });
        // Iterate over a local copy so that if flushSync is used and we end up
        // removing and adding a new subscriber due to the useCallback dependencies,
        // we don't get ourselves into a loop calling the new subscriber immediately
        (0, $2us1u._)(subscribers).forEach(function(subscriber) {
            return subscriber(state, {
                deletedFetchers: deletedFetchersKeys,
                viewTransitionOpts: opts.viewTransitionOpts,
                flushSync: opts.flushSync === true
            });
        });
        // Remove idle fetchers from state since we only care about in-flight fetchers.
        if (future.v7_fetcherPersist) {
            completedFetchers.forEach(function(key) {
                return state.fetchers.delete(key);
            });
            deletedFetchersKeys.forEach(function(key) {
                return deleteFetcher(key);
            });
        } else // We already called deleteFetcher() on these, can remove them from this
        // Set now that we've handed the keys off to the data layer
        deletedFetchersKeys.forEach(function(key) {
            return deletedFetchers.delete(key);
        });
    }
    // Complete a navigation returning the state.navigation back to the IDLE_NAVIGATION
    // and setting state.[historyAction/location/matches] to the new route.
    // - Location is a required param
    // - Navigation will always be set to IDLE_NAVIGATION
    // - Can pass any other state in newState
    function completeNavigation(location, newState, _temp) {
        var _location$state, _location$state2;
        var flushSync = (_temp === void 0 ? {} : _temp).flushSync;
        // Deduce if we're in a loading/actionReload state:
        // - We have committed actionData in the store
        // - The current navigation was a mutation submission
        // - We're past the submitting state and into the loading state
        // - The location being loaded is not the result of a redirect
        var isActionReload = state.actionData != null && state.navigation.formMethod != null && isMutationMethod(state.navigation.formMethod) && state.navigation.state === "loading" && ((_location$state = location.state) == null ? void 0 : _location$state._isRedirect) !== true;
        var actionData;
        if (newState.actionData) {
            if (Object.keys(newState.actionData).length > 0) actionData = newState.actionData;
            else // Empty actionData -> clear prior actionData due to an action error
            actionData = null;
        } else if (isActionReload) // Keep the current data if we're wrapping up the action reload
        actionData = state.actionData;
        else // Clear actionData on any other completed navigations
        actionData = null;
        // Always preserve any existing loaderData from re-used routes
        var loaderData = newState.loaderData ? mergeLoaderData(state.loaderData, newState.loaderData, newState.matches || [], newState.errors) : state.loaderData;
        // On a successful navigation we can assume we got through all blockers
        // so we can start fresh
        var blockers = state.blockers;
        if (blockers.size > 0) {
            blockers = new Map(blockers);
            blockers.forEach(function(_, k) {
                return blockers.set(k, IDLE_BLOCKER);
            });
        }
        // Always respect the user flag.  Otherwise don't reset on mutation
        // submission navigations unless they redirect
        var preventScrollReset = pendingPreventScrollReset === true || state.navigation.formMethod != null && isMutationMethod(state.navigation.formMethod) && ((_location$state2 = location.state) == null ? void 0 : _location$state2._isRedirect) !== true;
        // Commit any in-flight routes at the end of the HMR revalidation "navigation"
        if (inFlightDataRoutes) {
            dataRoutes = inFlightDataRoutes;
            inFlightDataRoutes = undefined;
        }
        if (isUninterruptedRevalidation) ;
        else if (pendingAction === Action.Pop) ;
        else if (pendingAction === Action.Push) init.history.push(location, location.state);
        else if (pendingAction === Action.Replace) init.history.replace(location, location.state);
        var viewTransitionOpts;
        // On POP, enable transitions if they were enabled on the original navigation
        if (pendingAction === Action.Pop) {
            // Forward takes precedence so they behave like the original navigation
            var priorPaths = appliedViewTransitions.get(state.location.pathname);
            if (priorPaths && priorPaths.has(location.pathname)) viewTransitionOpts = {
                currentLocation: state.location,
                nextLocation: location
            };
            else if (appliedViewTransitions.has(location.pathname)) // If we don't have a previous forward nav, assume we're popping back to
            // the new location and enable if that location previously enabled
            viewTransitionOpts = {
                currentLocation: location,
                nextLocation: state.location
            };
        } else if (pendingViewTransitionEnabled) {
            // Store the applied transition on PUSH/REPLACE
            var toPaths = appliedViewTransitions.get(state.location.pathname);
            if (toPaths) toPaths.add(location.pathname);
            else {
                toPaths = new Set([
                    location.pathname
                ]);
                appliedViewTransitions.set(state.location.pathname, toPaths);
            }
            viewTransitionOpts = {
                currentLocation: state.location,
                nextLocation: location
            };
        }
        updateState(_extends({}, newState, {
            actionData: actionData,
            loaderData: loaderData,
            historyAction: pendingAction,
            location: location,
            initialized: true,
            navigation: IDLE_NAVIGATION,
            revalidation: "idle",
            restoreScrollPosition: getSavedScrollPosition(location, newState.matches || state.matches),
            preventScrollReset: preventScrollReset,
            blockers: blockers
        }), {
            viewTransitionOpts: viewTransitionOpts,
            flushSync: flushSync === true
        });
        // Reset stateful navigation vars
        pendingAction = Action.Pop;
        pendingPreventScrollReset = false;
        pendingViewTransitionEnabled = false;
        isUninterruptedRevalidation = false;
        isRevalidationRequired = false;
        cancelledDeferredRoutes = [];
    }
    // Trigger a navigation event, which can either be a numerical POP or a PUSH
    // replace with an optional submission
    function navigate(to, opts) {
        return (/*#__PURE__*/ 0, /*#__PURE__*/ $g3gsR._)(function() {
            var normalizedPath, _normalizeNavigateOptions, path, submission, error, currentLocation, nextLocation, userReplace, historyAction, preventScrollReset, flushSync, blockerKey;
            return (0, $fRv9I.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        if (typeof to === "number") {
                            init.history.go(to);
                            return [
                                2
                            ];
                        }
                        normalizedPath = normalizeTo(state.location, state.matches, basename, future.v7_prependBasename, to, future.v7_relativeSplatPath, opts == null ? void 0 : opts.fromRouteId, opts == null ? void 0 : opts.relative);
                        _normalizeNavigateOptions = normalizeNavigateOptions(future.v7_normalizeFormMethod, false, normalizedPath, opts), path = _normalizeNavigateOptions.path, submission = _normalizeNavigateOptions.submission, error = _normalizeNavigateOptions.error;
                        currentLocation = state.location;
                        nextLocation = createLocation(state.location, path, opts && opts.state);
                        // When using navigate as a PUSH/REPLACE we aren't reading an already-encoded
                        // URL from window.location, so we need to encode it here so the behavior
                        // remains the same as POP and non-data-router usages.  new URL() does all
                        // the same encoding we'd get from a history.pushState/window.location read
                        // without having to touch history
                        nextLocation = _extends({}, nextLocation, init.history.encodeLocation(nextLocation));
                        userReplace = opts && opts.replace != null ? opts.replace : undefined;
                        historyAction = Action.Push;
                        if (userReplace === true) historyAction = Action.Replace;
                        else if (userReplace === false) ;
                        else if (submission != null && isMutationMethod(submission.formMethod) && submission.formAction === state.location.pathname + state.location.search) // By default on submissions to the current location we REPLACE so that
                        // users don't have to double-click the back button to get to the prior
                        // location.  If the user redirects to a different location from the
                        // action/loader this will be ignored and the redirect will be a PUSH
                        historyAction = Action.Replace;
                        preventScrollReset = opts && "preventScrollReset" in opts ? opts.preventScrollReset === true : undefined;
                        flushSync = (opts && opts.flushSync) === true;
                        blockerKey = shouldBlockNavigation({
                            currentLocation: currentLocation,
                            nextLocation: nextLocation,
                            historyAction: historyAction
                        });
                        if (blockerKey) {
                            // Put the blocker into a blocked state
                            updateBlocker(blockerKey, {
                                state: "blocked",
                                location: nextLocation,
                                proceed: function() {
                                    updateBlocker(blockerKey, {
                                        state: "proceeding",
                                        proceed: undefined,
                                        reset: undefined,
                                        location: nextLocation
                                    });
                                    // Send the same navigation through
                                    navigate(to, opts);
                                },
                                reset: function() {
                                    var blockers = new Map(state.blockers);
                                    blockers.set(blockerKey, IDLE_BLOCKER);
                                    updateState({
                                        blockers: blockers
                                    });
                                }
                            });
                            return [
                                2
                            ];
                        }
                        return [
                            4,
                            startNavigation(historyAction, nextLocation, {
                                submission: submission,
                                // Send through the formData serialization error if we have one so we can
                                // render at the right error boundary after we match routes
                                pendingError: error,
                                preventScrollReset: preventScrollReset,
                                replace: opts && opts.replace,
                                enableViewTransition: opts && opts.viewTransition,
                                flushSync: flushSync
                            })
                        ];
                    case 1:
                        return [
                            2,
                            _state.sent()
                        ];
                }
            });
        })();
    }
    // Revalidate all current loaders.  If a navigation is in progress or if this
    // is interrupted by a navigation, allow this to "succeed" by calling all
    // loaders during the next loader round
    function revalidate() {
        interruptActiveLoads();
        updateState({
            revalidation: "loading"
        });
        // If we're currently submitting an action, we don't need to start a new
        // navigation, we'll just let the follow up loader execution call all loaders
        if (state.navigation.state === "submitting") return;
        // If we're currently in an idle state, start a new navigation for the current
        // action/location and mark it as uninterrupted, which will skip the history
        // update in completeNavigation
        if (state.navigation.state === "idle") {
            startNavigation(state.historyAction, state.location, {
                startUninterruptedRevalidation: true
            });
            return;
        }
        // Otherwise, if we're currently in a loading state, just start a new
        // navigation to the navigation.location but do not trigger an uninterrupted
        // revalidation so that history correctly updates once the navigation completes
        startNavigation(pendingAction || state.historyAction, state.navigation.location, {
            overrideNavigation: state.navigation,
            // Proxy through any rending view transition
            enableViewTransition: pendingViewTransitionEnabled === true
        });
    }
    // Start a navigation to the given action/location.  Can optionally provide a
    // overrideNavigation which will override the normalLoad in the case of a redirect
    // navigation
    function startNavigation(historyAction, location, opts) {
        return (/*#__PURE__*/ 0, /*#__PURE__*/ $g3gsR._)(function() {
            var routesToUse, loadingNavigation, matches, flushSync, fogOfWar, _handleNavigational404, error, notFoundMatches, route, request, pendingActionResult, actionResult, _actionResult_pendingActionResult, routeId, result, _ref, shortCircuited, updatedMatches, loaderData, errors;
            return (0, $fRv9I.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        // Abort any in-progress navigations and start a new one. Unset any ongoing
                        // uninterrupted revalidations unless told otherwise, since we want this
                        // new navigation to update history normally
                        pendingNavigationController && pendingNavigationController.abort();
                        pendingNavigationController = null;
                        pendingAction = historyAction;
                        isUninterruptedRevalidation = (opts && opts.startUninterruptedRevalidation) === true;
                        // Save the current scroll position every time we start a new navigation,
                        // and track whether we should reset scroll on completion
                        saveScrollPosition(state.location, state.matches);
                        pendingPreventScrollReset = (opts && opts.preventScrollReset) === true;
                        pendingViewTransitionEnabled = (opts && opts.enableViewTransition) === true;
                        routesToUse = inFlightDataRoutes || dataRoutes;
                        loadingNavigation = opts && opts.overrideNavigation;
                        matches = opts != null && opts.initialHydration && state.matches && state.matches.length > 0 && !initialMatchesIsFOW ? // `matchRoutes()` has already been called if we're in here via `router.initialize()`
                        state.matches : matchRoutes(routesToUse, location, basename);
                        flushSync = (opts && opts.flushSync) === true;
                        // Short circuit if it's only a hash change and not a revalidation or
                        // mutation submission.
                        //
                        // Ignore on initial page loads because since the initial hydration will always
                        // be "same hash".  For example, on /page#hash and submit a <Form method="post">
                        // which will default to a navigation to /page
                        if (matches && state.initialized && !isRevalidationRequired && isHashChangeOnly(state.location, location) && !(opts && opts.submission && isMutationMethod(opts.submission.formMethod))) {
                            completeNavigation(location, {
                                matches: matches
                            }, {
                                flushSync: flushSync
                            });
                            return [
                                2
                            ];
                        }
                        fogOfWar = checkFogOfWar(matches, routesToUse, location.pathname);
                        if (fogOfWar.active && fogOfWar.matches) matches = fogOfWar.matches;
                        // Short circuit with a 404 on the root error boundary if we match nothing
                        if (!matches) {
                            _handleNavigational404 = handleNavigational404(location.pathname), error = _handleNavigational404.error, notFoundMatches = _handleNavigational404.notFoundMatches, route = _handleNavigational404.route;
                            completeNavigation(location, {
                                matches: notFoundMatches,
                                loaderData: {},
                                errors: (0, $72osQ._)({}, route.id, error)
                            }, {
                                flushSync: flushSync
                            });
                            return [
                                2
                            ];
                        }
                        // Create a controller/Request for this navigation
                        pendingNavigationController = new AbortController();
                        request = createClientSideRequest(init.history, location, pendingNavigationController.signal, opts && opts.submission);
                        if (!(opts && opts.pendingError)) return [
                            3,
                            1
                        ];
                        // If we have a pendingError, it means the user attempted a GET submission
                        // with binary FormData so assign here and skip to handleLoaders.  That
                        // way we handle calling loaders above the boundary etc.  It's not really
                        // different from an actionError in that sense.
                        pendingActionResult = [
                            findNearestBoundary(matches).route.id,
                            {
                                type: ResultType.error,
                                error: opts.pendingError
                            }
                        ];
                        return [
                            3,
                            3
                        ];
                    case 1:
                        if (!(opts && opts.submission && isMutationMethod(opts.submission.formMethod))) return [
                            3,
                            3
                        ];
                        return [
                            4,
                            handleAction(request, location, opts.submission, matches, fogOfWar.active, {
                                replace: opts.replace,
                                flushSync: flushSync
                            })
                        ];
                    case 2:
                        actionResult = _state.sent();
                        if (actionResult.shortCircuited) return [
                            2
                        ];
                        // If we received a 404 from handleAction, it's because we couldn't lazily
                        // discover the destination route so we don't want to call loaders
                        if (actionResult.pendingActionResult) {
                            _actionResult_pendingActionResult = (0, $2nwvT._)(actionResult.pendingActionResult, 2), routeId = _actionResult_pendingActionResult[0], result = _actionResult_pendingActionResult[1];
                            if (isErrorResult(result) && isRouteErrorResponse(result.error) && result.error.status === 404) {
                                pendingNavigationController = null;
                                completeNavigation(location, {
                                    matches: actionResult.matches,
                                    loaderData: {},
                                    errors: (0, $72osQ._)({}, routeId, result.error)
                                });
                                return [
                                    2
                                ];
                            }
                        }
                        matches = actionResult.matches || matches;
                        pendingActionResult = actionResult.pendingActionResult;
                        loadingNavigation = getLoadingNavigation(location, opts.submission);
                        flushSync = false;
                        // No need to do fog of war matching again on loader execution
                        fogOfWar.active = false;
                        // Create a GET request for the loaders
                        request = createClientSideRequest(init.history, request.url, request.signal);
                        _state.label = 3;
                    case 3:
                        return [
                            4,
                            handleLoaders(request, location, matches, fogOfWar.active, loadingNavigation, opts && opts.submission, opts && opts.fetcherSubmission, opts && opts.replace, opts && opts.initialHydration === true, flushSync, pendingActionResult)
                        ];
                    case 4:
                        _ref = _state.sent(), shortCircuited = _ref.shortCircuited, updatedMatches = _ref.matches, loaderData = _ref.loaderData, errors = _ref.errors;
                        if (shortCircuited) return [
                            2
                        ];
                        // Clean up now that the action/loaders have completed.  Don't clean up if
                        // we short circuited because pendingNavigationController will have already
                        // been assigned to a new controller for the next navigation
                        pendingNavigationController = null;
                        completeNavigation(location, _extends({
                            matches: updatedMatches || matches
                        }, getActionDataForCommit(pendingActionResult), {
                            loaderData: loaderData,
                            errors: errors
                        }));
                        return [
                            2
                        ];
                }
            });
        })();
    }
    // Call the action matched by the leaf route for this navigation and handle
    // redirects/errors
    function handleAction(request, location, submission, matches, isFogOfWar, opts) {
        return (/*#__PURE__*/ 0, /*#__PURE__*/ $g3gsR._)(function() {
            var navigation, discoverResult, boundaryId, _handleNavigational404, notFoundMatches, error, route, result, actionMatch, results, replace, _$location, boundaryMatch;
            return (0, $fRv9I.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        if (opts === void 0) opts = {};
                        interruptActiveLoads();
                        // Put us in a submitting state
                        navigation = getSubmittingNavigation(location, submission);
                        updateState({
                            navigation: navigation
                        }, {
                            flushSync: opts.flushSync === true
                        });
                        if (!isFogOfWar) return [
                            3,
                            2
                        ];
                        return [
                            4,
                            discoverRoutes(matches, location.pathname, request.signal)
                        ];
                    case 1:
                        discoverResult = _state.sent();
                        if (discoverResult.type === "aborted") return [
                            2,
                            {
                                shortCircuited: true
                            }
                        ];
                        else if (discoverResult.type === "error") {
                            boundaryId = findNearestBoundary(discoverResult.partialMatches).route.id;
                            return [
                                2,
                                {
                                    matches: discoverResult.partialMatches,
                                    pendingActionResult: [
                                        boundaryId,
                                        {
                                            type: ResultType.error,
                                            error: discoverResult.error
                                        }
                                    ]
                                }
                            ];
                        } else if (!discoverResult.matches) {
                            _handleNavigational404 = handleNavigational404(location.pathname), notFoundMatches = _handleNavigational404.notFoundMatches, error = _handleNavigational404.error, route = _handleNavigational404.route;
                            return [
                                2,
                                {
                                    matches: notFoundMatches,
                                    pendingActionResult: [
                                        route.id,
                                        {
                                            type: ResultType.error,
                                            error: error
                                        }
                                    ]
                                }
                            ];
                        } else matches = discoverResult.matches;
                        _state.label = 2;
                    case 2:
                        actionMatch = getTargetMatch(matches, location);
                        if (!(!actionMatch.route.action && !actionMatch.route.lazy)) return [
                            3,
                            3
                        ];
                        result = {
                            type: ResultType.error,
                            error: getInternalRouterError(405, {
                                method: request.method,
                                pathname: location.pathname,
                                routeId: actionMatch.route.id
                            })
                        };
                        return [
                            3,
                            5
                        ];
                    case 3:
                        return [
                            4,
                            callDataStrategy("action", state, request, [
                                actionMatch
                            ], matches, null)
                        ];
                    case 4:
                        results = _state.sent();
                        result = results[actionMatch.route.id];
                        if (request.signal.aborted) return [
                            2,
                            {
                                shortCircuited: true
                            }
                        ];
                        _state.label = 5;
                    case 5:
                        if (!isRedirectResult(result)) return [
                            3,
                            7
                        ];
                        if (opts && opts.replace != null) replace = opts.replace;
                        else {
                            // If the user didn't explicity indicate replace behavior, replace if
                            // we redirected to the exact same location we're currently at to avoid
                            // double back-buttons
                            _$location = normalizeRedirectLocation(result.response.headers.get("Location"), new URL(request.url), basename);
                            replace = _$location === state.location.pathname + state.location.search;
                        }
                        return [
                            4,
                            startRedirectNavigation(request, result, true, {
                                submission: submission,
                                replace: replace
                            })
                        ];
                    case 6:
                        _state.sent();
                        return [
                            2,
                            {
                                shortCircuited: true
                            }
                        ];
                    case 7:
                        if (isDeferredResult(result)) throw getInternalRouterError(400, {
                            type: "defer-action"
                        });
                        if (isErrorResult(result)) {
                            // Store off the pending error - we use it to determine which loaders
                            // to call and will commit it when we complete the navigation
                            boundaryMatch = findNearestBoundary(matches, actionMatch.route.id);
                            // By default, all submissions to the current location are REPLACE
                            // navigations, but if the action threw an error that'll be rendered in
                            // an errorElement, we fall back to PUSH so that the user can use the
                            // back button to get back to the pre-submission form location to try
                            // again
                            if ((opts && opts.replace) !== true) pendingAction = Action.Push;
                            return [
                                2,
                                {
                                    matches: matches,
                                    pendingActionResult: [
                                        boundaryMatch.route.id,
                                        result
                                    ]
                                }
                            ];
                        }
                        return [
                            2,
                            {
                                matches: matches,
                                pendingActionResult: [
                                    actionMatch.route.id,
                                    result
                                ]
                            }
                        ];
                }
            });
        })();
    }
    // Call all applicable loaders for the given matches, handling redirects,
    // errors, etc.
    function handleLoaders(request, location, matches, isFogOfWar, overrideNavigation, submission, fetcherSubmission, replace, initialHydration, flushSync, pendingActionResult) {
        return (/*#__PURE__*/ 0, /*#__PURE__*/ $g3gsR._)(function() {
            var loadingNavigation, activeSubmission, shouldUpdateNavigationState, actionData, discoverResult, boundaryId, _handleNavigational404, error, notFoundMatches, route, routesToUse, _getMatchesToLoad, matchesToLoad, revalidatingFetchers, updatedFetchers, updates, actionData1, abortPendingFetchRevalidations, _ref, loaderResults, fetcherResults, redirect, _processLoaderData, loaderData, errors, updatedFetchers1, didAbortFetchLoads, shouldUpdateFetchers;
            return (0, $fRv9I.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        // Figure out the right navigation we want to use for data loading
                        loadingNavigation = overrideNavigation || getLoadingNavigation(location, submission);
                        // If this was a redirect from an action we don't have a "submission" but
                        // we have it on the loading navigation so use that if available
                        activeSubmission = submission || fetcherSubmission || getSubmissionFromNavigation(loadingNavigation);
                        // If this is an uninterrupted revalidation, we remain in our current idle
                        // state.  If not, we need to switch to our loading state and load data,
                        // preserving any new action data or existing action data (in the case of
                        // a revalidation interrupting an actionReload)
                        // If we have partialHydration enabled, then don't update the state for the
                        // initial data load since it's not a "navigation"
                        shouldUpdateNavigationState = !isUninterruptedRevalidation && (!future.v7_partialHydration || !initialHydration);
                        if (!isFogOfWar) return [
                            3,
                            2
                        ];
                        if (shouldUpdateNavigationState) {
                            actionData = getUpdatedActionData(pendingActionResult);
                            updateState(_extends({
                                navigation: loadingNavigation
                            }, actionData !== undefined ? {
                                actionData: actionData
                            } : {}), {
                                flushSync: flushSync
                            });
                        }
                        return [
                            4,
                            discoverRoutes(matches, location.pathname, request.signal)
                        ];
                    case 1:
                        discoverResult = _state.sent();
                        if (discoverResult.type === "aborted") return [
                            2,
                            {
                                shortCircuited: true
                            }
                        ];
                        else if (discoverResult.type === "error") {
                            boundaryId = findNearestBoundary(discoverResult.partialMatches).route.id;
                            return [
                                2,
                                {
                                    matches: discoverResult.partialMatches,
                                    loaderData: {},
                                    errors: (0, $72osQ._)({}, boundaryId, discoverResult.error)
                                }
                            ];
                        } else if (!discoverResult.matches) {
                            _handleNavigational404 = handleNavigational404(location.pathname), error = _handleNavigational404.error, notFoundMatches = _handleNavigational404.notFoundMatches, route = _handleNavigational404.route;
                            return [
                                2,
                                {
                                    matches: notFoundMatches,
                                    loaderData: {},
                                    errors: (0, $72osQ._)({}, route.id, error)
                                }
                            ];
                        } else matches = discoverResult.matches;
                        _state.label = 2;
                    case 2:
                        routesToUse = inFlightDataRoutes || dataRoutes;
                        _getMatchesToLoad = (0, $2nwvT._)(getMatchesToLoad(init.history, state, matches, activeSubmission, location, future.v7_partialHydration && initialHydration === true, future.v7_skipActionErrorRevalidation, isRevalidationRequired, cancelledDeferredRoutes, cancelledFetcherLoads, deletedFetchers, fetchLoadMatches, fetchRedirectIds, routesToUse, basename, pendingActionResult), 2), matchesToLoad = _getMatchesToLoad[0], revalidatingFetchers = _getMatchesToLoad[1];
                        // Cancel pending deferreds for no-longer-matched routes or routes we're
                        // about to reload.  Note that if this is an action reload we would have
                        // already cancelled all pending deferreds so this would be a no-op
                        cancelActiveDeferreds(function(routeId) {
                            return !(matches && matches.some(function(m) {
                                return m.route.id === routeId;
                            })) || matchesToLoad && matchesToLoad.some(function(m) {
                                return m.route.id === routeId;
                            });
                        });
                        pendingNavigationLoadId = ++incrementingLoadId;
                        // Short circuit if we have no loaders to run
                        if (matchesToLoad.length === 0 && revalidatingFetchers.length === 0) {
                            updatedFetchers = markFetchRedirectsDone();
                            completeNavigation(location, _extends({
                                matches: matches,
                                loaderData: {},
                                // Commit pending error if we're short circuiting
                                errors: pendingActionResult && isErrorResult(pendingActionResult[1]) ? (0, $72osQ._)({}, pendingActionResult[0], pendingActionResult[1].error) : null
                            }, getActionDataForCommit(pendingActionResult), updatedFetchers ? {
                                fetchers: new Map(state.fetchers)
                            } : {}), {
                                flushSync: flushSync
                            });
                            return [
                                2,
                                {
                                    shortCircuited: true
                                }
                            ];
                        }
                        if (shouldUpdateNavigationState) {
                            updates = {};
                            if (!isFogOfWar) {
                                // Only update navigation/actionNData if we didn't already do it above
                                updates.navigation = loadingNavigation;
                                actionData1 = getUpdatedActionData(pendingActionResult);
                                if (actionData1 !== undefined) updates.actionData = actionData1;
                            }
                            if (revalidatingFetchers.length > 0) updates.fetchers = getUpdatedRevalidatingFetchers(revalidatingFetchers);
                            updateState(updates, {
                                flushSync: flushSync
                            });
                        }
                        revalidatingFetchers.forEach(function(rf) {
                            abortFetcher(rf.key);
                            if (rf.controller) // Fetchers use an independent AbortController so that aborting a fetcher
                            // (via deleteFetcher) does not abort the triggering navigation that
                            // triggered the revalidation
                            fetchControllers.set(rf.key, rf.controller);
                        });
                        // Proxy navigation abort through to revalidation fetchers
                        abortPendingFetchRevalidations = function() {
                            return revalidatingFetchers.forEach(function(f) {
                                return abortFetcher(f.key);
                            });
                        };
                        if (pendingNavigationController) pendingNavigationController.signal.addEventListener("abort", abortPendingFetchRevalidations);
                        return [
                            4,
                            callLoadersAndMaybeResolveData(state, matches, matchesToLoad, revalidatingFetchers, request)
                        ];
                    case 3:
                        _ref = _state.sent(), loaderResults = _ref.loaderResults, fetcherResults = _ref.fetcherResults;
                        if (request.signal.aborted) return [
                            2,
                            {
                                shortCircuited: true
                            }
                        ];
                        // Clean up _after_ loaders have completed.  Don't clean up if we short
                        // circuited because fetchControllers would have been aborted and
                        // reassigned to new controllers for the next navigation
                        if (pendingNavigationController) pendingNavigationController.signal.removeEventListener("abort", abortPendingFetchRevalidations);
                        revalidatingFetchers.forEach(function(rf) {
                            return fetchControllers.delete(rf.key);
                        });
                        // If any loaders returned a redirect Response, start a new REPLACE navigation
                        redirect = findRedirect(loaderResults);
                        if (!redirect) return [
                            3,
                            5
                        ];
                        return [
                            4,
                            startRedirectNavigation(request, redirect.result, true, {
                                replace: replace
                            })
                        ];
                    case 4:
                        _state.sent();
                        return [
                            2,
                            {
                                shortCircuited: true
                            }
                        ];
                    case 5:
                        redirect = findRedirect(fetcherResults);
                        if (!redirect) return [
                            3,
                            7
                        ];
                        // If this redirect came from a fetcher make sure we mark it in
                        // fetchRedirectIds so it doesn't get revalidated on the next set of
                        // loader executions
                        fetchRedirectIds.add(redirect.key);
                        return [
                            4,
                            startRedirectNavigation(request, redirect.result, true, {
                                replace: replace
                            })
                        ];
                    case 6:
                        _state.sent();
                        return [
                            2,
                            {
                                shortCircuited: true
                            }
                        ];
                    case 7:
                        // Process and commit output from loaders
                        _processLoaderData = processLoaderData(state, matches, loaderResults, pendingActionResult, revalidatingFetchers, fetcherResults, activeDeferreds), loaderData = _processLoaderData.loaderData, errors = _processLoaderData.errors;
                        // Wire up subscribers to update loaderData as promises settle
                        activeDeferreds.forEach(function(deferredData, routeId) {
                            deferredData.subscribe(function(aborted) {
                                // Note: No need to updateState here since the TrackedPromise on
                                // loaderData is stable across resolve/reject
                                // Remove this instance if we were aborted or if promises have settled
                                if (aborted || deferredData.done) activeDeferreds.delete(routeId);
                            });
                        });
                        // Preserve SSR errors during partial hydration
                        if (future.v7_partialHydration && initialHydration && state.errors) errors = _extends({}, state.errors, errors);
                        updatedFetchers1 = markFetchRedirectsDone();
                        didAbortFetchLoads = abortStaleFetchLoads(pendingNavigationLoadId);
                        shouldUpdateFetchers = updatedFetchers1 || didAbortFetchLoads || revalidatingFetchers.length > 0;
                        return [
                            2,
                            _extends({
                                matches: matches,
                                loaderData: loaderData,
                                errors: errors
                            }, shouldUpdateFetchers ? {
                                fetchers: new Map(state.fetchers)
                            } : {})
                        ];
                }
            });
        })();
    }
    function getUpdatedActionData(pendingActionResult) {
        if (pendingActionResult && !isErrorResult(pendingActionResult[1])) // This is cast to `any` currently because `RouteData`uses any and it
        // would be a breaking change to use any.
        // TODO: v7 - change `RouteData` to use `unknown` instead of `any`
        return (0, $72osQ._)({}, pendingActionResult[0], pendingActionResult[1].data);
        else if (state.actionData) {
            if (Object.keys(state.actionData).length === 0) return null;
            else return state.actionData;
        }
    }
    function getUpdatedRevalidatingFetchers(revalidatingFetchers) {
        revalidatingFetchers.forEach(function(rf) {
            var fetcher = state.fetchers.get(rf.key);
            var revalidatingFetcher = getLoadingFetcher(undefined, fetcher ? fetcher.data : undefined);
            state.fetchers.set(rf.key, revalidatingFetcher);
        });
        return new Map(state.fetchers);
    }
    // Trigger a fetcher load/submit for the given fetcher key
    function fetch(key, routeId, href, opts) {
        if (isServer) throw new Error("router.fetch() was called during the server render, but it shouldn't be. You are likely calling a useFetcher() method in the body of your component. Try moving it to a useEffect or a callback.");
        abortFetcher(key);
        var flushSync = (opts && opts.flushSync) === true;
        var routesToUse = inFlightDataRoutes || dataRoutes;
        var normalizedPath = normalizeTo(state.location, state.matches, basename, future.v7_prependBasename, href, future.v7_relativeSplatPath, routeId, opts == null ? void 0 : opts.relative);
        var matches = matchRoutes(routesToUse, normalizedPath, basename);
        var fogOfWar = checkFogOfWar(matches, routesToUse, normalizedPath);
        if (fogOfWar.active && fogOfWar.matches) matches = fogOfWar.matches;
        if (!matches) {
            setFetcherError(key, routeId, getInternalRouterError(404, {
                pathname: normalizedPath
            }), {
                flushSync: flushSync
            });
            return;
        }
        var _normalizeNavigateOptions = normalizeNavigateOptions(future.v7_normalizeFormMethod, true, normalizedPath, opts), path = _normalizeNavigateOptions.path, submission = _normalizeNavigateOptions.submission, error = _normalizeNavigateOptions.error;
        if (error) {
            setFetcherError(key, routeId, error, {
                flushSync: flushSync
            });
            return;
        }
        var match = getTargetMatch(matches, path);
        var preventScrollReset = (opts && opts.preventScrollReset) === true;
        if (submission && isMutationMethod(submission.formMethod)) {
            handleFetcherAction(key, routeId, path, match, matches, fogOfWar.active, flushSync, preventScrollReset, submission);
            return;
        }
        // Store off the match so we can call it's shouldRevalidate on subsequent
        // revalidations
        fetchLoadMatches.set(key, {
            routeId: routeId,
            path: path
        });
        handleFetcherLoader(key, routeId, path, match, matches, fogOfWar.active, flushSync, preventScrollReset, submission);
    }
    // Call the action for the matched fetcher.submit(), and then handle redirects,
    // errors, and revalidation
    function handleFetcherAction(key, routeId, path, match, requestMatches, isFogOfWar, flushSync, preventScrollReset, submission) {
        return (/*#__PURE__*/ 0, /*#__PURE__*/ $g3gsR._)(function() {
            var existingFetcher, abortController, fetchRequest, discoverResult, originatingLoadId, actionResults, actionResult, nextLocation, revalidationRequest, routesToUse, matches, loadId, loadFetcher, _getMatchesToLoad, matchesToLoad, revalidatingFetchers, abortPendingFetchRevalidations, _ref, loaderResults, fetcherResults, redirect, _processLoaderData, loaderData, errors, doneFetcher;
            function detectAndHandle405Error(m) {
                if (!m.route.action && !m.route.lazy) {
                    var error = getInternalRouterError(405, {
                        method: submission.formMethod,
                        pathname: path,
                        routeId: routeId
                    });
                    setFetcherError(key, routeId, error, {
                        flushSync: flushSync
                    });
                    return true;
                }
                return false;
            }
            return (0, $fRv9I.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        interruptActiveLoads();
                        fetchLoadMatches.delete(key);
                        if (!isFogOfWar && detectAndHandle405Error(match)) return [
                            2
                        ];
                        // Put this fetcher into it's submitting state
                        existingFetcher = state.fetchers.get(key);
                        updateFetcherState(key, getSubmittingFetcher(submission, existingFetcher), {
                            flushSync: flushSync
                        });
                        abortController = new AbortController();
                        fetchRequest = createClientSideRequest(init.history, path, abortController.signal, submission);
                        if (!isFogOfWar) return [
                            3,
                            2
                        ];
                        return [
                            4,
                            discoverRoutes(requestMatches, new URL(fetchRequest.url).pathname, fetchRequest.signal, key)
                        ];
                    case 1:
                        discoverResult = _state.sent();
                        if (discoverResult.type === "aborted") return [
                            2
                        ];
                        else if (discoverResult.type === "error") {
                            setFetcherError(key, routeId, discoverResult.error, {
                                flushSync: flushSync
                            });
                            return [
                                2
                            ];
                        } else if (!discoverResult.matches) {
                            setFetcherError(key, routeId, getInternalRouterError(404, {
                                pathname: path
                            }), {
                                flushSync: flushSync
                            });
                            return [
                                2
                            ];
                        } else {
                            requestMatches = discoverResult.matches;
                            match = getTargetMatch(requestMatches, path);
                            if (detectAndHandle405Error(match)) return [
                                2
                            ];
                        }
                        _state.label = 2;
                    case 2:
                        // Call the action for the fetcher
                        fetchControllers.set(key, abortController);
                        originatingLoadId = incrementingLoadId;
                        return [
                            4,
                            callDataStrategy("action", state, fetchRequest, [
                                match
                            ], requestMatches, key)
                        ];
                    case 3:
                        actionResults = _state.sent();
                        actionResult = actionResults[match.route.id];
                        if (fetchRequest.signal.aborted) {
                            // We can delete this so long as we weren't aborted by our own fetcher
                            // re-submit which would have put _new_ controller is in fetchControllers
                            if (fetchControllers.get(key) === abortController) fetchControllers.delete(key);
                            return [
                                2
                            ];
                        }
                        // When using v7_fetcherPersist, we don't want errors bubbling up to the UI
                        // or redirects processed for unmounted fetchers so we just revert them to
                        // idle
                        if (future.v7_fetcherPersist && deletedFetchers.has(key)) {
                            if (isRedirectResult(actionResult) || isErrorResult(actionResult)) {
                                updateFetcherState(key, getDoneFetcher(undefined));
                                return [
                                    2
                                ];
                            }
                        } else {
                            if (isRedirectResult(actionResult)) {
                                fetchControllers.delete(key);
                                if (pendingNavigationLoadId > originatingLoadId) {
                                    // A new navigation was kicked off after our action started, so that
                                    // should take precedence over this redirect navigation.  We already
                                    // set isRevalidationRequired so all loaders for the new route should
                                    // fire unless opted out via shouldRevalidate
                                    updateFetcherState(key, getDoneFetcher(undefined));
                                    return [
                                        2
                                    ];
                                } else {
                                    fetchRedirectIds.add(key);
                                    updateFetcherState(key, getLoadingFetcher(submission));
                                    return [
                                        2,
                                        startRedirectNavigation(fetchRequest, actionResult, false, {
                                            fetcherSubmission: submission,
                                            preventScrollReset: preventScrollReset
                                        })
                                    ];
                                }
                            }
                            // Process any non-redirect errors thrown
                            if (isErrorResult(actionResult)) {
                                setFetcherError(key, routeId, actionResult.error);
                                return [
                                    2
                                ];
                            }
                        }
                        if (isDeferredResult(actionResult)) throw getInternalRouterError(400, {
                            type: "defer-action"
                        });
                        // Start the data load for current matches, or the next location if we're
                        // in the middle of a navigation
                        nextLocation = state.navigation.location || state.location;
                        revalidationRequest = createClientSideRequest(init.history, nextLocation, abortController.signal);
                        routesToUse = inFlightDataRoutes || dataRoutes;
                        matches = state.navigation.state !== "idle" ? matchRoutes(routesToUse, state.navigation.location, basename) : state.matches;
                        invariant(matches, "Didn't find any matches after fetcher action");
                        loadId = ++incrementingLoadId;
                        fetchReloadIds.set(key, loadId);
                        loadFetcher = getLoadingFetcher(submission, actionResult.data);
                        state.fetchers.set(key, loadFetcher);
                        _getMatchesToLoad = (0, $2nwvT._)(getMatchesToLoad(init.history, state, matches, submission, nextLocation, false, future.v7_skipActionErrorRevalidation, isRevalidationRequired, cancelledDeferredRoutes, cancelledFetcherLoads, deletedFetchers, fetchLoadMatches, fetchRedirectIds, routesToUse, basename, [
                            match.route.id,
                            actionResult
                        ]), 2), matchesToLoad = _getMatchesToLoad[0], revalidatingFetchers = _getMatchesToLoad[1];
                        // Put all revalidating fetchers into the loading state, except for the
                        // current fetcher which we want to keep in it's current loading state which
                        // contains it's action submission info + action data
                        revalidatingFetchers.filter(function(rf) {
                            return rf.key !== key;
                        }).forEach(function(rf) {
                            var staleKey = rf.key;
                            var existingFetcher = state.fetchers.get(staleKey);
                            var revalidatingFetcher = getLoadingFetcher(undefined, existingFetcher ? existingFetcher.data : undefined);
                            state.fetchers.set(staleKey, revalidatingFetcher);
                            abortFetcher(staleKey);
                            if (rf.controller) fetchControllers.set(staleKey, rf.controller);
                        });
                        updateState({
                            fetchers: new Map(state.fetchers)
                        });
                        abortPendingFetchRevalidations = function() {
                            return revalidatingFetchers.forEach(function(rf) {
                                return abortFetcher(rf.key);
                            });
                        };
                        abortController.signal.addEventListener("abort", abortPendingFetchRevalidations);
                        return [
                            4,
                            callLoadersAndMaybeResolveData(state, matches, matchesToLoad, revalidatingFetchers, revalidationRequest)
                        ];
                    case 4:
                        _ref = _state.sent(), loaderResults = _ref.loaderResults, fetcherResults = _ref.fetcherResults;
                        if (abortController.signal.aborted) return [
                            2
                        ];
                        abortController.signal.removeEventListener("abort", abortPendingFetchRevalidations);
                        fetchReloadIds.delete(key);
                        fetchControllers.delete(key);
                        revalidatingFetchers.forEach(function(r) {
                            return fetchControllers.delete(r.key);
                        });
                        redirect = findRedirect(loaderResults);
                        if (redirect) return [
                            2,
                            startRedirectNavigation(revalidationRequest, redirect.result, false, {
                                preventScrollReset: preventScrollReset
                            })
                        ];
                        redirect = findRedirect(fetcherResults);
                        if (redirect) {
                            // If this redirect came from a fetcher make sure we mark it in
                            // fetchRedirectIds so it doesn't get revalidated on the next set of
                            // loader executions
                            fetchRedirectIds.add(redirect.key);
                            return [
                                2,
                                startRedirectNavigation(revalidationRequest, redirect.result, false, {
                                    preventScrollReset: preventScrollReset
                                })
                            ];
                        }
                        // Process and commit output from loaders
                        _processLoaderData = processLoaderData(state, matches, loaderResults, undefined, revalidatingFetchers, fetcherResults, activeDeferreds), loaderData = _processLoaderData.loaderData, errors = _processLoaderData.errors;
                        // Since we let revalidations complete even if the submitting fetcher was
                        // deleted, only put it back to idle if it hasn't been deleted
                        if (state.fetchers.has(key)) {
                            doneFetcher = getDoneFetcher(actionResult.data);
                            state.fetchers.set(key, doneFetcher);
                        }
                        abortStaleFetchLoads(loadId);
                        // If we are currently in a navigation loading state and this fetcher is
                        // more recent than the navigation, we want the newer data so abort the
                        // navigation and complete it with the fetcher data
                        if (state.navigation.state === "loading" && loadId > pendingNavigationLoadId) {
                            invariant(pendingAction, "Expected pending action");
                            pendingNavigationController && pendingNavigationController.abort();
                            completeNavigation(state.navigation.location, {
                                matches: matches,
                                loaderData: loaderData,
                                errors: errors,
                                fetchers: new Map(state.fetchers)
                            });
                        } else {
                            // otherwise just update with the fetcher data, preserving any existing
                            // loaderData for loaders that did not need to reload.  We have to
                            // manually merge here since we aren't going through completeNavigation
                            updateState({
                                errors: errors,
                                loaderData: mergeLoaderData(state.loaderData, loaderData, matches, errors),
                                fetchers: new Map(state.fetchers)
                            });
                            isRevalidationRequired = false;
                        }
                        return [
                            2
                        ];
                }
            });
        })();
    }
    // Call the matched loader for fetcher.load(), handling redirects, errors, etc.
    function handleFetcherLoader(key, routeId, path, match, matches, isFogOfWar, flushSync, preventScrollReset, submission) {
        return (/*#__PURE__*/ 0, /*#__PURE__*/ $g3gsR._)(function() {
            var existingFetcher, abortController, fetchRequest, discoverResult, originatingLoadId, results, result;
            return (0, $fRv9I.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        existingFetcher = state.fetchers.get(key);
                        updateFetcherState(key, getLoadingFetcher(submission, existingFetcher ? existingFetcher.data : undefined), {
                            flushSync: flushSync
                        });
                        abortController = new AbortController();
                        fetchRequest = createClientSideRequest(init.history, path, abortController.signal);
                        if (!isFogOfWar) return [
                            3,
                            2
                        ];
                        return [
                            4,
                            discoverRoutes(matches, new URL(fetchRequest.url).pathname, fetchRequest.signal, key)
                        ];
                    case 1:
                        discoverResult = _state.sent();
                        if (discoverResult.type === "aborted") return [
                            2
                        ];
                        else if (discoverResult.type === "error") {
                            setFetcherError(key, routeId, discoverResult.error, {
                                flushSync: flushSync
                            });
                            return [
                                2
                            ];
                        } else if (!discoverResult.matches) {
                            setFetcherError(key, routeId, getInternalRouterError(404, {
                                pathname: path
                            }), {
                                flushSync: flushSync
                            });
                            return [
                                2
                            ];
                        } else {
                            matches = discoverResult.matches;
                            match = getTargetMatch(matches, path);
                        }
                        _state.label = 2;
                    case 2:
                        // Call the loader for this fetcher route match
                        fetchControllers.set(key, abortController);
                        originatingLoadId = incrementingLoadId;
                        return [
                            4,
                            callDataStrategy("loader", state, fetchRequest, [
                                match
                            ], matches, key)
                        ];
                    case 3:
                        results = _state.sent();
                        result = results[match.route.id];
                        if (!isDeferredResult(result)) return [
                            3,
                            5
                        ];
                        return [
                            4,
                            resolveDeferredData(result, fetchRequest.signal, true)
                        ];
                    case 4:
                        result = _state.sent() || result;
                        _state.label = 5;
                    case 5:
                        // We can delete this so long as we weren't aborted by our our own fetcher
                        // re-load which would have put _new_ controller is in fetchControllers
                        if (fetchControllers.get(key) === abortController) fetchControllers.delete(key);
                        if (fetchRequest.signal.aborted) return [
                            2
                        ];
                        // We don't want errors bubbling up or redirects followed for unmounted
                        // fetchers, so short circuit here if it was removed from the UI
                        if (deletedFetchers.has(key)) {
                            updateFetcherState(key, getDoneFetcher(undefined));
                            return [
                                2
                            ];
                        }
                        if (!isRedirectResult(result)) return [
                            3,
                            8
                        ];
                        if (!(pendingNavigationLoadId > originatingLoadId)) return [
                            3,
                            6
                        ];
                        // A new navigation was kicked off after our loader started, so that
                        // should take precedence over this redirect navigation
                        updateFetcherState(key, getDoneFetcher(undefined));
                        return [
                            2
                        ];
                    case 6:
                        fetchRedirectIds.add(key);
                        return [
                            4,
                            startRedirectNavigation(fetchRequest, result, false, {
                                preventScrollReset: preventScrollReset
                            })
                        ];
                    case 7:
                        _state.sent();
                        return [
                            2
                        ];
                    case 8:
                        // Process any non-redirect errors thrown
                        if (isErrorResult(result)) {
                            setFetcherError(key, routeId, result.error);
                            return [
                                2
                            ];
                        }
                        invariant(!isDeferredResult(result), "Unhandled fetcher deferred data");
                        // Put the fetcher back into an idle state
                        updateFetcherState(key, getDoneFetcher(result.data));
                        return [
                            2
                        ];
                }
            });
        })();
    }
    /**
   * Utility function to handle redirects returned from an action or loader.
   * Normally, a redirect "replaces" the navigation that triggered it.  So, for
   * example:
   *
   *  - user is on /a
   *  - user clicks a link to /b
   *  - loader for /b redirects to /c
   *
   * In a non-JS app the browser would track the in-flight navigation to /b and
   * then replace it with /c when it encountered the redirect response.  In
   * the end it would only ever update the URL bar with /c.
   *
   * In client-side routing using pushState/replaceState, we aim to emulate
   * this behavior and we also do not update history until the end of the
   * navigation (including processed redirects).  This means that we never
   * actually touch history until we've processed redirects, so we just use
   * the history action from the original navigation (PUSH or REPLACE).
   */ function startRedirectNavigation(request, redirect, isNavigation, _temp2) {
        return (/*#__PURE__*/ 0, /*#__PURE__*/ $g3gsR._)(function() {
            var _ref, submission, fetcherSubmission, preventScrollReset, replace, location, redirectLocation, isDocumentReload, url, redirectHistoryAction, _state_navigation, formMethod, formAction, formEncType, activeSubmission, overrideNavigation;
            return (0, $fRv9I.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        _ref = _temp2 === void 0 ? {} : _temp2, submission = _ref.submission, fetcherSubmission = _ref.fetcherSubmission, preventScrollReset = _ref.preventScrollReset, replace = _ref.replace;
                        if (redirect.response.headers.has("X-Remix-Revalidate")) isRevalidationRequired = true;
                        location = redirect.response.headers.get("Location");
                        invariant(location, "Expected a Location header on the redirect Response");
                        location = normalizeRedirectLocation(location, new URL(request.url), basename);
                        redirectLocation = createLocation(state.location, location, {
                            _isRedirect: true
                        });
                        if (isBrowser) {
                            isDocumentReload = false;
                            if (redirect.response.headers.has("X-Remix-Reload-Document")) // Hard reload if the response contained X-Remix-Reload-Document
                            isDocumentReload = true;
                            else if (ABSOLUTE_URL_REGEX.test(location)) {
                                url = init.history.createURL(location);
                                isDocumentReload = // Hard reload if it's an absolute URL to a new origin
                                url.origin !== routerWindow.location.origin || // Hard reload if it's an absolute URL that does not match our basename
                                stripBasename(url.pathname, basename) == null;
                            }
                            if (isDocumentReload) {
                                if (replace) routerWindow.location.replace(location);
                                else routerWindow.location.assign(location);
                                return [
                                    2
                                ];
                            }
                        }
                        // There's no need to abort on redirects, since we don't detect the
                        // redirect until the action/loaders have settled
                        pendingNavigationController = null;
                        redirectHistoryAction = replace === true || redirect.response.headers.has("X-Remix-Replace") ? Action.Replace : Action.Push;
                        // Use the incoming submission if provided, fallback on the active one in
                        // state.navigation
                        _state_navigation = state.navigation, formMethod = _state_navigation.formMethod, formAction = _state_navigation.formAction, formEncType = _state_navigation.formEncType;
                        if (!submission && !fetcherSubmission && formMethod && formAction && formEncType) submission = getSubmissionFromNavigation(state.navigation);
                        // If this was a 307/308 submission we want to preserve the HTTP method and
                        // re-submit the GET/POST/PUT/PATCH/DELETE as a submission navigation to the
                        // redirected location
                        activeSubmission = submission || fetcherSubmission;
                        if (!(redirectPreserveMethodStatusCodes.has(redirect.response.status) && activeSubmission && isMutationMethod(activeSubmission.formMethod))) return [
                            3,
                            2
                        ];
                        return [
                            4,
                            startNavigation(redirectHistoryAction, redirectLocation, {
                                submission: _extends({}, activeSubmission, {
                                    formAction: location
                                }),
                                // Preserve these flags across redirects
                                preventScrollReset: preventScrollReset || pendingPreventScrollReset,
                                enableViewTransition: isNavigation ? pendingViewTransitionEnabled : undefined
                            })
                        ];
                    case 1:
                        _state.sent();
                        return [
                            3,
                            4
                        ];
                    case 2:
                        // If we have a navigation submission, we will preserve it through the
                        // redirect navigation
                        overrideNavigation = getLoadingNavigation(redirectLocation, submission);
                        return [
                            4,
                            startNavigation(redirectHistoryAction, redirectLocation, {
                                overrideNavigation: overrideNavigation,
                                // Send fetcher submissions through for shouldRevalidate
                                fetcherSubmission: fetcherSubmission,
                                // Preserve these flags across redirects
                                preventScrollReset: preventScrollReset || pendingPreventScrollReset,
                                enableViewTransition: isNavigation ? pendingViewTransitionEnabled : undefined
                            })
                        ];
                    case 3:
                        _state.sent();
                        _state.label = 4;
                    case 4:
                        return [
                            2
                        ];
                }
            });
        })();
    }
    // Utility wrapper for calling dataStrategy client-side without having to
    // pass around the manifest, mapRouteProperties, etc.
    function callDataStrategy(type, state, request, matchesToLoad, matches, fetcherKey) {
        return (/*#__PURE__*/ 0, /*#__PURE__*/ $g3gsR._)(function() {
            var results, dataResults, e, _iteratorNormalCompletion, _didIteratorError, _iteratorError, _iterator, _step, _step_value, routeId, result, response, err;
            return (0, $fRv9I.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        dataResults = {};
                        _state.label = 1;
                    case 1:
                        _state.trys.push([
                            1,
                            3,
                            ,
                            4
                        ]);
                        return [
                            4,
                            callDataStrategyImpl(dataStrategyImpl, type, state, request, matchesToLoad, matches, fetcherKey, manifest, mapRouteProperties)
                        ];
                    case 2:
                        results = _state.sent();
                        return [
                            3,
                            4
                        ];
                    case 3:
                        e = _state.sent();
                        // If the outer dataStrategy method throws, just return the error for all
                        // matches - and it'll naturally bubble to the root
                        matchesToLoad.forEach(function(m) {
                            dataResults[m.route.id] = {
                                type: ResultType.error,
                                error: e
                            };
                        });
                        return [
                            2,
                            dataResults
                        ];
                    case 4:
                        _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                        _state.label = 5;
                    case 5:
                        _state.trys.push([
                            5,
                            11,
                            12,
                            13
                        ]);
                        _iterator = Object.entries(results)[Symbol.iterator]();
                        _state.label = 6;
                    case 6:
                        if (!!(_iteratorNormalCompletion = (_step = _iterator.next()).done)) return [
                            3,
                            10
                        ];
                        _step_value = (0, $2nwvT._)(_step.value, 2), routeId = _step_value[0], result = _step_value[1];
                        if (!isRedirectDataStrategyResultResult(result)) return [
                            3,
                            7
                        ];
                        response = result.result;
                        dataResults[routeId] = {
                            type: ResultType.redirect,
                            response: normalizeRelativeRoutingRedirectResponse(response, request, routeId, matches, basename, future.v7_relativeSplatPath)
                        };
                        return [
                            3,
                            9
                        ];
                    case 7:
                        return [
                            4,
                            convertDataStrategyResultToDataResult(result)
                        ];
                    case 8:
                        dataResults[routeId] = _state.sent();
                        _state.label = 9;
                    case 9:
                        _iteratorNormalCompletion = true;
                        return [
                            3,
                            6
                        ];
                    case 10:
                        return [
                            3,
                            13
                        ];
                    case 11:
                        err = _state.sent();
                        _didIteratorError = true;
                        _iteratorError = err;
                        return [
                            3,
                            13
                        ];
                    case 12:
                        try {
                            if (!_iteratorNormalCompletion && _iterator.return != null) {
                                _iterator.return();
                            }
                        } finally{
                            if (_didIteratorError) {
                                throw _iteratorError;
                            }
                        }
                        return [
                            7
                        ];
                    case 13:
                        return [
                            2,
                            dataResults
                        ];
                }
            });
        })();
    }
    function callLoadersAndMaybeResolveData(state, matches, matchesToLoad, fetchersToLoad, request) {
        return (/*#__PURE__*/ 0, /*#__PURE__*/ $g3gsR._)(function() {
            var currentMatches, loaderResultsPromise, fetcherResultsPromise, loaderResults, fetcherResults;
            return (0, $fRv9I.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        currentMatches = state.matches;
                        // Kick off loaders and fetchers in parallel
                        loaderResultsPromise = callDataStrategy("loader", state, request, matchesToLoad, matches, null);
                        fetcherResultsPromise = Promise.all(fetchersToLoad.map(function(f) {
                            return (/*#__PURE__*/ 0, /*#__PURE__*/ $g3gsR._)(function() {
                                var results, result;
                                return (0, $fRv9I.__generator)(this, function(_state) {
                                    switch(_state.label){
                                        case 0:
                                            if (!(f.matches && f.match && f.controller)) return [
                                                3,
                                                2
                                            ];
                                            return [
                                                4,
                                                callDataStrategy("loader", state, createClientSideRequest(init.history, f.path, f.controller.signal), [
                                                    f.match
                                                ], f.matches, f.key)
                                            ];
                                        case 1:
                                            results = _state.sent();
                                            result = results[f.match.route.id];
                                            // Fetcher results are keyed by fetcher key from here on out, not routeId
                                            return [
                                                2,
                                                (0, $72osQ._)({}, f.key, result)
                                            ];
                                        case 2:
                                            return [
                                                2,
                                                Promise.resolve((0, $72osQ._)({}, f.key, {
                                                    type: ResultType.error,
                                                    error: getInternalRouterError(404, {
                                                        pathname: f.path
                                                    })
                                                }))
                                            ];
                                        case 3:
                                            return [
                                                2
                                            ];
                                    }
                                });
                            })();
                        }));
                        return [
                            4,
                            loaderResultsPromise
                        ];
                    case 1:
                        loaderResults = _state.sent();
                        return [
                            4,
                            fetcherResultsPromise
                        ];
                    case 2:
                        fetcherResults = _state.sent().reduce(function(acc, r) {
                            return Object.assign(acc, r);
                        }, {});
                        return [
                            4,
                            Promise.all([
                                resolveNavigationDeferredResults(matches, loaderResults, request.signal, currentMatches, state.loaderData),
                                resolveFetcherDeferredResults(matches, fetcherResults, fetchersToLoad)
                            ])
                        ];
                    case 3:
                        _state.sent();
                        return [
                            2,
                            {
                                loaderResults: loaderResults,
                                fetcherResults: fetcherResults
                            }
                        ];
                }
            });
        })();
    }
    function interruptActiveLoads() {
        var // Cancel pending route-level deferreds and mark cancelled routes for
        // revalidation
        _cancelledDeferredRoutes;
        // Every interruption triggers a revalidation
        isRevalidationRequired = true;
        (_cancelledDeferredRoutes = cancelledDeferredRoutes).push.apply(_cancelledDeferredRoutes, (0, $2us1u._)(cancelActiveDeferreds()));
        // Abort in-flight fetcher loads
        fetchLoadMatches.forEach(function(_, key) {
            if (fetchControllers.has(key)) cancelledFetcherLoads.add(key);
            abortFetcher(key);
        });
    }
    function updateFetcherState(key, fetcher, opts) {
        if (opts === void 0) opts = {};
        state.fetchers.set(key, fetcher);
        updateState({
            fetchers: new Map(state.fetchers)
        }, {
            flushSync: (opts && opts.flushSync) === true
        });
    }
    function setFetcherError(key, routeId, error, opts) {
        if (opts === void 0) opts = {};
        var boundaryMatch = findNearestBoundary(state.matches, routeId);
        deleteFetcher(key);
        updateState({
            errors: (0, $72osQ._)({}, boundaryMatch.route.id, error),
            fetchers: new Map(state.fetchers)
        }, {
            flushSync: (opts && opts.flushSync) === true
        });
    }
    function getFetcher(key) {
        activeFetchers.set(key, (activeFetchers.get(key) || 0) + 1);
        // If this fetcher was previously marked for deletion, unmark it since we
        // have a new instance
        if (deletedFetchers.has(key)) deletedFetchers.delete(key);
        return state.fetchers.get(key) || IDLE_FETCHER;
    }
    function deleteFetcher(key) {
        var fetcher = state.fetchers.get(key);
        // Don't abort the controller if this is a deletion of a fetcher.submit()
        // in it's loading phase since - we don't want to abort the corresponding
        // revalidation and want them to complete and land
        if (fetchControllers.has(key) && !(fetcher && fetcher.state === "loading" && fetchReloadIds.has(key))) abortFetcher(key);
        fetchLoadMatches.delete(key);
        fetchReloadIds.delete(key);
        fetchRedirectIds.delete(key);
        // If we opted into the flag we can clear this now since we're calling
        // deleteFetcher() at the end of updateState() and we've already handed the
        // deleted fetcher keys off to the data layer.
        // If not, we're eagerly calling deleteFetcher() and we need to keep this
        // Set populated until the next updateState call, and we'll clear
        // `deletedFetchers` then
        if (future.v7_fetcherPersist) deletedFetchers.delete(key);
        cancelledFetcherLoads.delete(key);
        state.fetchers.delete(key);
    }
    function deleteFetcherAndUpdateState(key) {
        var count = (activeFetchers.get(key) || 0) - 1;
        if (count <= 0) {
            activeFetchers.delete(key);
            deletedFetchers.add(key);
            if (!future.v7_fetcherPersist) deleteFetcher(key);
        } else activeFetchers.set(key, count);
        updateState({
            fetchers: new Map(state.fetchers)
        });
    }
    function abortFetcher(key) {
        var controller = fetchControllers.get(key);
        if (controller) {
            controller.abort();
            fetchControllers.delete(key);
        }
    }
    function markFetchersDone(keys) {
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            for(var _iterator = keys[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var key = _step.value;
                var fetcher = getFetcher(key);
                var doneFetcher = getDoneFetcher(fetcher.data);
                state.fetchers.set(key, doneFetcher);
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
    }
    function markFetchRedirectsDone() {
        var doneKeys = [];
        var updatedFetchers = false;
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            for(var _iterator = fetchRedirectIds[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var key = _step.value;
                var fetcher = state.fetchers.get(key);
                invariant(fetcher, "Expected fetcher: " + key);
                if (fetcher.state === "loading") {
                    fetchRedirectIds.delete(key);
                    doneKeys.push(key);
                    updatedFetchers = true;
                }
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
        markFetchersDone(doneKeys);
        return updatedFetchers;
    }
    function abortStaleFetchLoads(landedId) {
        var yeetedKeys = [];
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            for(var _iterator = fetchReloadIds[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var _step_value = (0, $2nwvT._)(_step.value, 2), key = _step_value[0], id = _step_value[1];
                if (id < landedId) {
                    var fetcher = state.fetchers.get(key);
                    invariant(fetcher, "Expected fetcher: " + key);
                    if (fetcher.state === "loading") {
                        abortFetcher(key);
                        fetchReloadIds.delete(key);
                        yeetedKeys.push(key);
                    }
                }
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
        markFetchersDone(yeetedKeys);
        return yeetedKeys.length > 0;
    }
    function getBlocker(key, fn) {
        var blocker = state.blockers.get(key) || IDLE_BLOCKER;
        if (blockerFunctions.get(key) !== fn) blockerFunctions.set(key, fn);
        return blocker;
    }
    function deleteBlocker(key) {
        state.blockers.delete(key);
        blockerFunctions.delete(key);
    }
    // Utility function to update blockers, ensuring valid state transitions
    function updateBlocker(key, newBlocker) {
        var blocker = state.blockers.get(key) || IDLE_BLOCKER;
        // Poor mans state machine :)
        // https://mermaid.live/edit#pako:eNqVkc9OwzAMxl8l8nnjAYrEtDIOHEBIgwvKJTReGy3_lDpIqO27k6awMG0XcrLlnz87nwdonESogKXXBuE79rq75XZO3-yHds0RJVuv70YrPlUrCEe2HfrORS3rubqZfuhtpg5C9wk5tZ4VKcRUq88q9Z8RS0-48cE1iHJkL0ugbHuFLus9L6spZy8nX9MP2CNdomVaposqu3fGayT8T8-jJQwhepo_UtpgBQaDEUom04dZhAN1aJBDlUKJBxE1ceB2Smj0Mln-IBW5AFU2dwUiktt_2Qaq2dBfaKdEup85UV7Yd-dKjlnkabl2Pvr0DTkTreM
        invariant(blocker.state === "unblocked" && newBlocker.state === "blocked" || blocker.state === "blocked" && newBlocker.state === "blocked" || blocker.state === "blocked" && newBlocker.state === "proceeding" || blocker.state === "blocked" && newBlocker.state === "unblocked" || blocker.state === "proceeding" && newBlocker.state === "unblocked", "Invalid blocker state transition: " + blocker.state + " -> " + newBlocker.state);
        var blockers = new Map(state.blockers);
        blockers.set(key, newBlocker);
        updateState({
            blockers: blockers
        });
    }
    function shouldBlockNavigation(_ref2) {
        var currentLocation = _ref2.currentLocation, nextLocation = _ref2.nextLocation, historyAction = _ref2.historyAction;
        if (blockerFunctions.size === 0) return;
        // We ony support a single active blocker at the moment since we don't have
        // any compelling use cases for multi-blocker yet
        if (blockerFunctions.size > 1) warning(false, "A router only supports one blocker at a time");
        var entries = Array.from(blockerFunctions.entries());
        var _entries_ = (0, $2nwvT._)(entries[entries.length - 1], 2), blockerKey = _entries_[0], blockerFunction = _entries_[1];
        var blocker = state.blockers.get(blockerKey);
        if (blocker && blocker.state === "proceeding") // If the blocker is currently proceeding, we don't need to re-check
        // it and can let this navigation continue
        return;
        // At this point, we know we're unblocked/blocked so we need to check the
        // user-provided blocker function
        if (blockerFunction({
            currentLocation: currentLocation,
            nextLocation: nextLocation,
            historyAction: historyAction
        })) return blockerKey;
    }
    function handleNavigational404(pathname) {
        var error = getInternalRouterError(404, {
            pathname: pathname
        });
        var routesToUse = inFlightDataRoutes || dataRoutes;
        var _getShortCircuitMatches = getShortCircuitMatches(routesToUse), matches = _getShortCircuitMatches.matches, route = _getShortCircuitMatches.route;
        // Cancel all pending deferred on 404s since we don't keep any routes
        cancelActiveDeferreds();
        return {
            notFoundMatches: matches,
            route: route,
            error: error
        };
    }
    function cancelActiveDeferreds(predicate) {
        var cancelledRouteIds = [];
        activeDeferreds.forEach(function(dfd, routeId) {
            if (!predicate || predicate(routeId)) {
                // Cancel the deferred - but do not remove from activeDeferreds here -
                // we rely on the subscribers to do that so our tests can assert proper
                // cleanup via _internalActiveDeferreds
                dfd.cancel();
                cancelledRouteIds.push(routeId);
                activeDeferreds.delete(routeId);
            }
        });
        return cancelledRouteIds;
    }
    // Opt in to capturing and reporting scroll positions during navigations,
    // used by the <ScrollRestoration> component
    function enableScrollRestoration(positions, getPosition, getKey) {
        savedScrollPositions = positions;
        getScrollPosition = getPosition;
        getScrollRestorationKey = getKey || null;
        // Perform initial hydration scroll restoration, since we miss the boat on
        // the initial updateState() because we've not yet rendered <ScrollRestoration/>
        // and therefore have no savedScrollPositions available
        if (!initialScrollRestored && state.navigation === IDLE_NAVIGATION) {
            initialScrollRestored = true;
            var y = getSavedScrollPosition(state.location, state.matches);
            if (y != null) updateState({
                restoreScrollPosition: y
            });
        }
        return function() {
            savedScrollPositions = null;
            getScrollPosition = null;
            getScrollRestorationKey = null;
        };
    }
    function getScrollKey(location, matches) {
        if (getScrollRestorationKey) {
            var key = getScrollRestorationKey(location, matches.map(function(m) {
                return convertRouteMatchToUiMatch(m, state.loaderData);
            }));
            return key || location.key;
        }
        return location.key;
    }
    function saveScrollPosition(location, matches) {
        if (savedScrollPositions && getScrollPosition) {
            var key = getScrollKey(location, matches);
            savedScrollPositions[key] = getScrollPosition();
        }
    }
    function getSavedScrollPosition(location, matches) {
        if (savedScrollPositions) {
            var key = getScrollKey(location, matches);
            var y = savedScrollPositions[key];
            if (typeof y === "number") return y;
        }
        return null;
    }
    function checkFogOfWar(matches, routesToUse, pathname) {
        if (patchRoutesOnNavigationImpl) {
            if (!matches) {
                var fogMatches = matchRoutesImpl(routesToUse, pathname, basename, true);
                return {
                    active: true,
                    matches: fogMatches || []
                };
            } else if (Object.keys(matches[0].params).length > 0) {
                // If we matched a dynamic param or a splat, it might only be because
                // we haven't yet discovered other routes that would match with a
                // higher score.  Call patchRoutesOnNavigation just to be sure
                var partialMatches = matchRoutesImpl(routesToUse, pathname, basename, true);
                return {
                    active: true,
                    matches: partialMatches
                };
            }
        }
        return {
            active: false,
            matches: null
        };
    }
    function discoverRoutes(matches, pathname, signal, fetcherKey) {
        return (/*#__PURE__*/ 0, /*#__PURE__*/ $g3gsR._)(function() {
            var _loop, partialMatches, _ret;
            return (0, $fRv9I.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        _loop = function() {
                            var isNonHMR, routesToUse, localManifest, e, newMatches, newPartialMatches;
                            return (0, $fRv9I.__generator)(this, function(_state) {
                                switch(_state.label){
                                    case 0:
                                        isNonHMR = inFlightDataRoutes == null;
                                        routesToUse = inFlightDataRoutes || dataRoutes;
                                        localManifest = manifest;
                                        _state.label = 1;
                                    case 1:
                                        _state.trys.push([
                                            1,
                                            3,
                                            4,
                                            5
                                        ]);
                                        return [
                                            4,
                                            patchRoutesOnNavigationImpl({
                                                signal: signal,
                                                path: pathname,
                                                matches: partialMatches,
                                                fetcherKey: fetcherKey,
                                                patch: function(routeId, children) {
                                                    if (signal.aborted) return;
                                                    patchRoutesImpl(routeId, children, routesToUse, localManifest, mapRouteProperties);
                                                }
                                            })
                                        ];
                                    case 2:
                                        _state.sent();
                                        return [
                                            3,
                                            5
                                        ];
                                    case 3:
                                        e = _state.sent();
                                        return [
                                            2,
                                            {
                                                v: {
                                                    type: "error",
                                                    error: e,
                                                    partialMatches: partialMatches
                                                }
                                            }
                                        ];
                                    case 4:
                                        // If we are not in the middle of an HMR revalidation and we changed the
                                        // routes, provide a new identity so when we `updateState` at the end of
                                        // this navigation/fetch `router.routes` will be a new identity and
                                        // trigger a re-run of memoized `router.routes` dependencies.
                                        // HMR will already update the identity and reflow when it lands
                                        // `inFlightDataRoutes` in `completeNavigation`
                                        if (isNonHMR && !signal.aborted) dataRoutes = (0, $2us1u._)(dataRoutes);
                                        return [
                                            7
                                        ];
                                    case 5:
                                        if (signal.aborted) return [
                                            2,
                                            {
                                                v: {
                                                    type: "aborted"
                                                }
                                            }
                                        ];
                                        newMatches = matchRoutes(routesToUse, pathname, basename);
                                        if (newMatches) return [
                                            2,
                                            {
                                                v: {
                                                    type: "success",
                                                    matches: newMatches
                                                }
                                            }
                                        ];
                                        newPartialMatches = matchRoutesImpl(routesToUse, pathname, basename, true);
                                        // Avoid loops if the second pass results in the same partial matches
                                        if (!newPartialMatches || partialMatches.length === newPartialMatches.length && partialMatches.every(function(m, i) {
                                            return m.route.id === newPartialMatches[i].route.id;
                                        })) return [
                                            2,
                                            {
                                                v: {
                                                    type: "success",
                                                    matches: null
                                                }
                                            }
                                        ];
                                        partialMatches = newPartialMatches;
                                        return [
                                            2
                                        ];
                                }
                            });
                        };
                        if (!patchRoutesOnNavigationImpl) return [
                            2,
                            {
                                type: "success",
                                matches: matches
                            }
                        ];
                        partialMatches = matches;
                        _state.label = 1;
                    case 1:
                        if (!true) return [
                            3,
                            3
                        ];
                        return [
                            5,
                            (0, $fRv9I.__values)(_loop())
                        ];
                    case 2:
                        _ret = _state.sent();
                        if ((0, $bJtXW._)(_ret) === "object") return [
                            2,
                            _ret.v
                        ];
                        return [
                            3,
                            1
                        ];
                    case 3:
                        return [
                            2
                        ];
                }
            });
        })();
    }
    function _internalSetRoutes(newRoutes) {
        manifest = {};
        inFlightDataRoutes = convertRoutesToDataRoutes(newRoutes, mapRouteProperties, undefined, manifest);
    }
    function patchRoutes(routeId, children) {
        var isNonHMR = inFlightDataRoutes == null;
        var routesToUse = inFlightDataRoutes || dataRoutes;
        patchRoutesImpl(routeId, children, routesToUse, manifest, mapRouteProperties);
        // If we are not in the middle of an HMR revalidation and we changed the
        // routes, provide a new identity and trigger a reflow via `updateState`
        // to re-run memoized `router.routes` dependencies.
        // HMR will already update the identity and reflow when it lands
        // `inFlightDataRoutes` in `completeNavigation`
        if (isNonHMR) {
            dataRoutes = (0, $2us1u._)(dataRoutes);
            updateState({});
        }
    }
    router = {
        get basename () {
            return basename;
        },
        get future () {
            return future;
        },
        get state () {
            return state;
        },
        get routes () {
            return dataRoutes;
        },
        get window () {
            return routerWindow;
        },
        initialize: initialize,
        subscribe: subscribe,
        enableScrollRestoration: enableScrollRestoration,
        navigate: navigate,
        fetch: fetch,
        revalidate: revalidate,
        // Passthrough to history-aware createHref used by useHref so we get proper
        // hash-aware URLs in DOM paths
        createHref: function(to) {
            return init.history.createHref(to);
        },
        encodeLocation: function(to) {
            return init.history.encodeLocation(to);
        },
        getFetcher: getFetcher,
        deleteFetcher: deleteFetcherAndUpdateState,
        dispose: dispose,
        getBlocker: getBlocker,
        deleteBlocker: deleteBlocker,
        patchRoutes: patchRoutes,
        _internalFetchControllers: fetchControllers,
        _internalActiveDeferreds: activeDeferreds,
        // TODO: Remove setRoutes, it's temporary to avoid dealing with
        // updating the tree while validating the update algorithm.
        _internalSetRoutes: _internalSetRoutes
    };
    return router;
}
//#endregion
////////////////////////////////////////////////////////////////////////////////
//#region createStaticHandler
////////////////////////////////////////////////////////////////////////////////
var UNSAFE_DEFERRED_SYMBOL = Symbol("deferred");
function createStaticHandler(routes, opts) {
    invariant(routes.length > 0, "You must provide a non-empty routes array to createStaticHandler");
    var manifest = {};
    var basename = (opts ? opts.basename : null) || "/";
    var mapRouteProperties;
    if (opts != null && opts.mapRouteProperties) mapRouteProperties = opts.mapRouteProperties;
    else if (opts != null && opts.detectErrorBoundary) {
        // If they are still using the deprecated version, wrap it with the new API
        var detectErrorBoundary = opts.detectErrorBoundary;
        mapRouteProperties = function(route) {
            return {
                hasErrorBoundary: detectErrorBoundary(route)
            };
        };
    } else mapRouteProperties = defaultMapRouteProperties;
    // Config driven behavior flags
    var future = _extends({
        v7_relativeSplatPath: false,
        v7_throwAbortReason: false
    }, opts ? opts.future : null);
    var dataRoutes = convertRoutesToDataRoutes(routes, mapRouteProperties, undefined, manifest);
    /**
   * The query() method is intended for document requests, in which we want to
   * call an optional action and potentially multiple loaders for all nested
   * routes.  It returns a StaticHandlerContext object, which is very similar
   * to the router state (location, loaderData, actionData, errors, etc.) and
   * also adds SSR-specific information such as the statusCode and headers
   * from action/loaders Responses.
   *
   * It _should_ never throw and should report all errors through the
   * returned context.errors object, properly associating errors to their error
   * boundary.  Additionally, it tracks _deepestRenderedBoundaryId which can be
   * used to emulate React error boundaries during SSr by performing a second
   * pass only down to the boundaryId.
   *
   * The one exception where we do not return a StaticHandlerContext is when a
   * redirect response is returned or thrown from any action/loader.  We
   * propagate that out and return the raw Response so the HTTP server can
   * return it directly.
   *
   * - `opts.requestContext` is an optional server context that will be passed
   *   to actions/loaders in the `context` parameter
   * - `opts.skipLoaderErrorBubbling` is an optional parameter that will prevent
   *   the bubbling of errors which allows single-fetch-type implementations
   *   where the client will handle the bubbling and we may need to return data
   *   for the handling route
   */ function query(request, _temp3) {
        return (/*#__PURE__*/ 0, /*#__PURE__*/ $g3gsR._)(function() {
            var _ref, requestContext, skipLoaderErrorBubbling, dataStrategy, url, method, location, matches, error, _getShortCircuitMatches, methodNotAllowedMatches, route, error1, _getShortCircuitMatches1, notFoundMatches, route1, result;
            return (0, $fRv9I.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        _ref = _temp3 === void 0 ? {} : _temp3, requestContext = _ref.requestContext, skipLoaderErrorBubbling = _ref.skipLoaderErrorBubbling, dataStrategy = _ref.dataStrategy;
                        url = new URL(request.url);
                        method = request.method;
                        location = createLocation("", createPath(url), null, "default");
                        matches = matchRoutes(dataRoutes, location, basename);
                        // SSR supports HEAD requests while SPA doesn't
                        if (!isValidMethod(method) && method !== "HEAD") {
                            error = getInternalRouterError(405, {
                                method: method
                            });
                            _getShortCircuitMatches = getShortCircuitMatches(dataRoutes), methodNotAllowedMatches = _getShortCircuitMatches.matches, route = _getShortCircuitMatches.route;
                            return [
                                2,
                                {
                                    basename: basename,
                                    location: location,
                                    matches: methodNotAllowedMatches,
                                    loaderData: {},
                                    actionData: null,
                                    errors: (0, $72osQ._)({}, route.id, error),
                                    statusCode: error.status,
                                    loaderHeaders: {},
                                    actionHeaders: {},
                                    activeDeferreds: null
                                }
                            ];
                        } else if (!matches) {
                            error1 = getInternalRouterError(404, {
                                pathname: location.pathname
                            });
                            _getShortCircuitMatches1 = getShortCircuitMatches(dataRoutes), notFoundMatches = _getShortCircuitMatches1.matches, route1 = _getShortCircuitMatches1.route;
                            return [
                                2,
                                {
                                    basename: basename,
                                    location: location,
                                    matches: notFoundMatches,
                                    loaderData: {},
                                    actionData: null,
                                    errors: (0, $72osQ._)({}, route1.id, error1),
                                    statusCode: error1.status,
                                    loaderHeaders: {},
                                    actionHeaders: {},
                                    activeDeferreds: null
                                }
                            ];
                        }
                        return [
                            4,
                            queryImpl(request, location, matches, requestContext, dataStrategy || null, skipLoaderErrorBubbling === true, null)
                        ];
                    case 1:
                        result = _state.sent();
                        if (isResponse(result)) return [
                            2,
                            result
                        ];
                        // When returning StaticHandlerContext, we patch back in the location here
                        // since we need it for React Context.  But this helps keep our submit and
                        // loadRouteData operating on a Request instead of a Location
                        return [
                            2,
                            _extends({
                                location: location,
                                basename: basename
                            }, result)
                        ];
                }
            });
        })();
    }
    /**
   * The queryRoute() method is intended for targeted route requests, either
   * for fetch ?_data requests or resource route requests.  In this case, we
   * are only ever calling a single action or loader, and we are returning the
   * returned value directly.  In most cases, this will be a Response returned
   * from the action/loader, but it may be a primitive or other value as well -
   * and in such cases the calling context should handle that accordingly.
   *
   * We do respect the throw/return differentiation, so if an action/loader
   * throws, then this method will throw the value.  This is important so we
   * can do proper boundary identification in Remix where a thrown Response
   * must go to the Catch Boundary but a returned Response is happy-path.
   *
   * One thing to note is that any Router-initiated Errors that make sense
   * to associate with a status code will be thrown as an ErrorResponse
   * instance which include the raw Error, such that the calling context can
   * serialize the error as they see fit while including the proper response
   * code.  Examples here are 404 and 405 errors that occur prior to reaching
   * any user-defined loaders.
   *
   * - `opts.routeId` allows you to specify the specific route handler to call.
   *   If not provided the handler will determine the proper route by matching
   *   against `request.url`
   * - `opts.requestContext` is an optional server context that will be passed
   *    to actions/loaders in the `context` parameter
   */ function queryRoute(request, _temp4) {
        return (/*#__PURE__*/ 0, /*#__PURE__*/ $g3gsR._)(function() {
            var _ref, routeId, requestContext, dataStrategy, url, method, location, matches, match, result, error, _result$activeDeferre, data;
            return (0, $fRv9I.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        _ref = _temp4 === void 0 ? {} : _temp4, routeId = _ref.routeId, requestContext = _ref.requestContext, dataStrategy = _ref.dataStrategy;
                        url = new URL(request.url);
                        method = request.method;
                        location = createLocation("", createPath(url), null, "default");
                        matches = matchRoutes(dataRoutes, location, basename);
                        // SSR supports HEAD requests while SPA doesn't
                        if (!isValidMethod(method) && method !== "HEAD" && method !== "OPTIONS") throw getInternalRouterError(405, {
                            method: method
                        });
                        else if (!matches) throw getInternalRouterError(404, {
                            pathname: location.pathname
                        });
                        match = routeId ? matches.find(function(m) {
                            return m.route.id === routeId;
                        }) : getTargetMatch(matches, location);
                        if (routeId && !match) throw getInternalRouterError(403, {
                            pathname: location.pathname,
                            routeId: routeId
                        });
                        else if (!match) // This should never hit I don't think?
                        throw getInternalRouterError(404, {
                            pathname: location.pathname
                        });
                        return [
                            4,
                            queryImpl(request, location, matches, requestContext, dataStrategy || null, false, match)
                        ];
                    case 1:
                        result = _state.sent();
                        if (isResponse(result)) return [
                            2,
                            result
                        ];
                        error = result.errors ? Object.values(result.errors)[0] : undefined;
                        if (error !== undefined) // If we got back result.errors, that means the loader/action threw
                        // _something_ that wasn't a Response, but it's not guaranteed/required
                        // to be an `instanceof Error` either, so we have to use throw here to
                        // preserve the "error" state outside of queryImpl.
                        throw error;
                        // Pick off the right state value to return
                        if (result.actionData) return [
                            2,
                            Object.values(result.actionData)[0]
                        ];
                        if (result.loaderData) {
                            ;
                            data = Object.values(result.loaderData)[0];
                            if ((_result$activeDeferre = result.activeDeferreds) != null && _result$activeDeferre[match.route.id]) data[UNSAFE_DEFERRED_SYMBOL] = result.activeDeferreds[match.route.id];
                            return [
                                2,
                                data
                            ];
                        }
                        return [
                            2,
                            undefined
                        ];
                }
            });
        })();
    }
    function queryImpl(request, location, matches, requestContext, dataStrategy, skipLoaderErrorBubbling, routeMatch) {
        return (/*#__PURE__*/ 0, /*#__PURE__*/ $g3gsR._)(function() {
            var result, result1, e;
            return (0, $fRv9I.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        invariant(request.signal, "query()/queryRoute() requests must contain an AbortController signal");
                        _state.label = 1;
                    case 1:
                        _state.trys.push([
                            1,
                            5,
                            ,
                            6
                        ]);
                        if (!isMutationMethod(request.method.toLowerCase())) return [
                            3,
                            3
                        ];
                        return [
                            4,
                            submit(request, matches, routeMatch || getTargetMatch(matches, location), requestContext, dataStrategy, skipLoaderErrorBubbling, routeMatch != null)
                        ];
                    case 2:
                        result = _state.sent();
                        return [
                            2,
                            result
                        ];
                    case 3:
                        return [
                            4,
                            loadRouteData(request, matches, requestContext, dataStrategy, skipLoaderErrorBubbling, routeMatch)
                        ];
                    case 4:
                        result1 = _state.sent();
                        return [
                            2,
                            isResponse(result1) ? result1 : _extends({}, result1, {
                                actionData: null,
                                actionHeaders: {}
                            })
                        ];
                    case 5:
                        e = _state.sent();
                        // If the user threw/returned a Response in callLoaderOrAction for a
                        // `queryRoute` call, we throw the `DataStrategyResult` to bail out early
                        // and then return or throw the raw Response here accordingly
                        if (isDataStrategyResult(e) && isResponse(e.result)) {
                            if (e.type === ResultType.error) throw e.result;
                            return [
                                2,
                                e.result
                            ];
                        }
                        // Redirects are always returned since they don't propagate to catch
                        // boundaries
                        if (isRedirectResponse(e)) return [
                            2,
                            e
                        ];
                        throw e;
                    case 6:
                        return [
                            2
                        ];
                }
            });
        })();
    }
    function submit(request, matches, actionMatch, requestContext, dataStrategy, skipLoaderErrorBubbling, isRouteRequest) {
        return (/*#__PURE__*/ 0, /*#__PURE__*/ $g3gsR._)(function() {
            var result, error, results, error1, loaderRequest, boundaryMatch, context, context1;
            return (0, $fRv9I.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        if (!(!actionMatch.route.action && !actionMatch.route.lazy)) return [
                            3,
                            1
                        ];
                        error = getInternalRouterError(405, {
                            method: request.method,
                            pathname: new URL(request.url).pathname,
                            routeId: actionMatch.route.id
                        });
                        if (isRouteRequest) throw error;
                        result = {
                            type: ResultType.error,
                            error: error
                        };
                        return [
                            3,
                            3
                        ];
                    case 1:
                        return [
                            4,
                            callDataStrategy("action", request, [
                                actionMatch
                            ], matches, isRouteRequest, requestContext, dataStrategy)
                        ];
                    case 2:
                        results = _state.sent();
                        result = results[actionMatch.route.id];
                        if (request.signal.aborted) throwStaticHandlerAbortedError(request, isRouteRequest, future);
                        _state.label = 3;
                    case 3:
                        if (isRedirectResult(result)) // Uhhhh - this should never happen, we should always throw these from
                        // callLoaderOrAction, but the type narrowing here keeps TS happy and we
                        // can get back on the "throw all redirect responses" train here should
                        // this ever happen :/
                        throw new Response(null, {
                            status: result.response.status,
                            headers: {
                                Location: result.response.headers.get("Location")
                            }
                        });
                        if (isDeferredResult(result)) {
                            error1 = getInternalRouterError(400, {
                                type: "defer-action"
                            });
                            if (isRouteRequest) throw error1;
                            result = {
                                type: ResultType.error,
                                error: error1
                            };
                        }
                        if (isRouteRequest) {
                            // Note: This should only be non-Response values if we get here, since
                            // isRouteRequest should throw any Response received in callLoaderOrAction
                            if (isErrorResult(result)) throw result.error;
                            return [
                                2,
                                {
                                    matches: [
                                        actionMatch
                                    ],
                                    loaderData: {},
                                    actionData: (0, $72osQ._)({}, actionMatch.route.id, result.data),
                                    errors: null,
                                    // Note: statusCode + headers are unused here since queryRoute will
                                    // return the raw Response or value
                                    statusCode: 200,
                                    loaderHeaders: {},
                                    actionHeaders: {},
                                    activeDeferreds: null
                                }
                            ];
                        }
                        // Create a GET request for the loaders
                        loaderRequest = new Request(request.url, {
                            headers: request.headers,
                            redirect: request.redirect,
                            signal: request.signal
                        });
                        if (!isErrorResult(result)) return [
                            3,
                            5
                        ];
                        // Store off the pending error - we use it to determine which loaders
                        // to call and will commit it when we complete the navigation
                        boundaryMatch = skipLoaderErrorBubbling ? actionMatch : findNearestBoundary(matches, actionMatch.route.id);
                        return [
                            4,
                            loadRouteData(loaderRequest, matches, requestContext, dataStrategy, skipLoaderErrorBubbling, null, [
                                boundaryMatch.route.id,
                                result
                            ])
                        ];
                    case 4:
                        context = _state.sent();
                        // action status codes take precedence over loader status codes
                        return [
                            2,
                            _extends({}, context, {
                                statusCode: isRouteErrorResponse(result.error) ? result.error.status : result.statusCode != null ? result.statusCode : 500,
                                actionData: null,
                                actionHeaders: _extends({}, result.headers ? (0, $72osQ._)({}, actionMatch.route.id, result.headers) : {})
                            })
                        ];
                    case 5:
                        return [
                            4,
                            loadRouteData(loaderRequest, matches, requestContext, dataStrategy, skipLoaderErrorBubbling, null)
                        ];
                    case 6:
                        context1 = _state.sent();
                        return [
                            2,
                            _extends({}, context1, {
                                actionData: (0, $72osQ._)({}, actionMatch.route.id, result.data)
                            }, result.statusCode ? {
                                statusCode: result.statusCode
                            } : {}, {
                                actionHeaders: result.headers ? (0, $72osQ._)({}, actionMatch.route.id, result.headers) : {}
                            })
                        ];
                }
            });
        })();
    }
    function loadRouteData(request, matches, requestContext, dataStrategy, skipLoaderErrorBubbling, routeMatch, pendingActionResult) {
        return (/*#__PURE__*/ 0, /*#__PURE__*/ $g3gsR._)(function() {
            var isRouteRequest, requestMatches, matchesToLoad, results, activeDeferreds, context, executedLoaders;
            return (0, $fRv9I.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        isRouteRequest = routeMatch != null;
                        // Short circuit if we have no loaders to run (queryRoute())
                        if (isRouteRequest && !(routeMatch != null && routeMatch.route.loader) && !(routeMatch != null && routeMatch.route.lazy)) throw getInternalRouterError(400, {
                            method: request.method,
                            pathname: new URL(request.url).pathname,
                            routeId: routeMatch == null ? void 0 : routeMatch.route.id
                        });
                        requestMatches = routeMatch ? [
                            routeMatch
                        ] : pendingActionResult && isErrorResult(pendingActionResult[1]) ? getLoaderMatchesUntilBoundary(matches, pendingActionResult[0]) : matches;
                        matchesToLoad = requestMatches.filter(function(m) {
                            return m.route.loader || m.route.lazy;
                        });
                        // Short circuit if we have no loaders to run (query())
                        if (matchesToLoad.length === 0) return [
                            2,
                            {
                                matches: matches,
                                // Add a null for all matched routes for proper revalidation on the client
                                loaderData: matches.reduce(function(acc, m) {
                                    return Object.assign(acc, (0, $72osQ._)({}, m.route.id, null));
                                }, {}),
                                errors: pendingActionResult && isErrorResult(pendingActionResult[1]) ? (0, $72osQ._)({}, pendingActionResult[0], pendingActionResult[1].error) : null,
                                statusCode: 200,
                                loaderHeaders: {},
                                activeDeferreds: null
                            }
                        ];
                        return [
                            4,
                            callDataStrategy("loader", request, matchesToLoad, matches, isRouteRequest, requestContext, dataStrategy)
                        ];
                    case 1:
                        results = _state.sent();
                        if (request.signal.aborted) throwStaticHandlerAbortedError(request, isRouteRequest, future);
                        // Process and commit output from loaders
                        activeDeferreds = new Map();
                        context = processRouteLoaderData(matches, results, pendingActionResult, activeDeferreds, skipLoaderErrorBubbling);
                        // Add a null for any non-loader matches for proper revalidation on the client
                        executedLoaders = new Set(matchesToLoad.map(function(match) {
                            return match.route.id;
                        }));
                        matches.forEach(function(match) {
                            if (!executedLoaders.has(match.route.id)) context.loaderData[match.route.id] = null;
                        });
                        return [
                            2,
                            _extends({}, context, {
                                matches: matches,
                                activeDeferreds: activeDeferreds.size > 0 ? Object.fromEntries(activeDeferreds.entries()) : null
                            })
                        ];
                }
            });
        })();
    }
    // Utility wrapper for calling dataStrategy server-side without having to
    // pass around the manifest, mapRouteProperties, etc.
    function callDataStrategy(type, request, matchesToLoad, matches, isRouteRequest, requestContext, dataStrategy) {
        return (/*#__PURE__*/ 0, /*#__PURE__*/ $g3gsR._)(function() {
            var results, dataResults;
            return (0, $fRv9I.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        return [
                            4,
                            callDataStrategyImpl(dataStrategy || defaultDataStrategy, type, null, request, matchesToLoad, matches, null, manifest, mapRouteProperties, requestContext)
                        ];
                    case 1:
                        results = _state.sent();
                        dataResults = {};
                        return [
                            4,
                            Promise.all(matches.map(function(match) {
                                return (/*#__PURE__*/ 0, /*#__PURE__*/ $g3gsR._)(function() {
                                    var result, response, _;
                                    return (0, $fRv9I.__generator)(this, function(_state) {
                                        switch(_state.label){
                                            case 0:
                                                if (!(match.route.id in results)) return [
                                                    2
                                                ];
                                                result = results[match.route.id];
                                                if (isRedirectDataStrategyResultResult(result)) {
                                                    response = result.result;
                                                    // Throw redirects and let the server handle them with an HTTP redirect
                                                    throw normalizeRelativeRoutingRedirectResponse(response, request, match.route.id, matches, basename, future.v7_relativeSplatPath);
                                                }
                                                if (isResponse(result.result) && isRouteRequest) // For SSR single-route requests, we want to hand Responses back
                                                // directly without unwrapping
                                                throw result;
                                                _ = match.route.id;
                                                return [
                                                    4,
                                                    convertDataStrategyResultToDataResult(result)
                                                ];
                                            case 1:
                                                dataResults[_] = _state.sent();
                                                return [
                                                    2
                                                ];
                                        }
                                    });
                                })();
                            }))
                        ];
                    case 2:
                        _state.sent();
                        return [
                            2,
                            dataResults
                        ];
                }
            });
        })();
    }
    return {
        dataRoutes: dataRoutes,
        query: query,
        queryRoute: queryRoute
    };
}
//#endregion
////////////////////////////////////////////////////////////////////////////////
//#region Helpers
////////////////////////////////////////////////////////////////////////////////
/**
 * Given an existing StaticHandlerContext and an error thrown at render time,
 * provide an updated StaticHandlerContext suitable for a second SSR render
 */ function getStaticContextFromError(routes, context, error) {
    var newContext = _extends({}, context, {
        statusCode: isRouteErrorResponse(error) ? error.status : 500,
        errors: (0, $72osQ._)({}, context._deepestRenderedBoundaryId || routes[0].id, error)
    });
    return newContext;
}
function throwStaticHandlerAbortedError(request, isRouteRequest, future) {
    if (future.v7_throwAbortReason && request.signal.reason !== undefined) throw request.signal.reason;
    var method = isRouteRequest ? "queryRoute" : "query";
    throw new Error(method + "() call aborted: " + request.method + " " + request.url);
}
function isSubmissionNavigation(opts) {
    return opts != null && ("formData" in opts && opts.formData != null || "body" in opts && opts.body !== undefined);
}
function normalizeTo(location, matches, basename, prependBasename, to, v7_relativeSplatPath, fromRouteId, relative) {
    var contextualMatches;
    var activeRouteMatch;
    if (fromRouteId) {
        // Grab matches up to the calling route so our route-relative logic is
        // relative to the correct source route
        contextualMatches = [];
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            for(var _iterator = matches[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var match = _step.value;
                contextualMatches.push(match);
                if (match.route.id === fromRouteId) {
                    activeRouteMatch = match;
                    break;
                }
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
    } else {
        contextualMatches = matches;
        activeRouteMatch = matches[matches.length - 1];
    }
    // Resolve the relative path
    var path = resolveTo(to ? to : ".", getResolveToMatches(contextualMatches, v7_relativeSplatPath), stripBasename(location.pathname, basename) || location.pathname, relative === "path");
    // When `to` is not specified we inherit search/hash from the current
    // location, unlike when to="." and we just inherit the path.
    // See https://github.com/remix-run/remix/issues/927
    if (to == null) {
        path.search = location.search;
        path.hash = location.hash;
    }
    // Account for `?index` params when routing to the current location
    if ((to == null || to === "" || to === ".") && activeRouteMatch) {
        var nakedIndex = hasNakedIndexQuery(path.search);
        if (activeRouteMatch.route.index && !nakedIndex) // Add one when we're targeting an index route
        path.search = path.search ? path.search.replace(/^\?/, "?index&") : "?index";
        else if (!activeRouteMatch.route.index && nakedIndex) {
            // Remove existing ones when we're not
            var params = new URLSearchParams(path.search);
            var indexValues = params.getAll("index");
            params.delete("index");
            indexValues.filter(function(v) {
                return v;
            }).forEach(function(v) {
                return params.append("index", v);
            });
            var qs = params.toString();
            path.search = qs ? "?" + qs : "";
        }
    }
    // If we're operating within a basename, prepend it to the pathname.  If
    // this is a root navigation, then just use the raw basename which allows
    // the basename to have full control over the presence of a trailing slash
    // on root actions
    if (prependBasename && basename !== "/") path.pathname = path.pathname === "/" ? basename : joinPaths([
        basename,
        path.pathname
    ]);
    return createPath(path);
}
// Normalize navigation options by converting formMethod=GET formData objects to
// URLSearchParams so they behave identically to links with query params
function normalizeNavigateOptions(normalizeFormMethod, isFetcher, path, opts) {
    // Return location verbatim on non-submission navigations
    if (!opts || !isSubmissionNavigation(opts)) return {
        path: path
    };
    if (opts.formMethod && !isValidMethod(opts.formMethod)) return {
        path: path,
        error: getInternalRouterError(405, {
            method: opts.formMethod
        })
    };
    var getInvalidBodyError = function() {
        return {
            path: path,
            error: getInternalRouterError(400, {
                type: "invalid-body"
            })
        };
    };
    // Create a Submission on non-GET navigations
    var rawFormMethod = opts.formMethod || "get";
    var formMethod = normalizeFormMethod ? rawFormMethod.toUpperCase() : rawFormMethod.toLowerCase();
    var formAction = stripHashFromPath(path);
    if (opts.body !== undefined) {
        if (opts.formEncType === "text/plain") {
            // text only support POST/PUT/PATCH/DELETE submissions
            if (!isMutationMethod(formMethod)) return getInvalidBodyError();
            var text = typeof opts.body === "string" ? opts.body : opts.body instanceof FormData || opts.body instanceof URLSearchParams ? // https://html.spec.whatwg.org/multipage/form-control-infrastructure.html#plain-text-form-data
            Array.from(opts.body.entries()).reduce(function(acc, _ref3) {
                var _$_ref3 = (0, $2nwvT._)(_ref3, 2), name = _$_ref3[0], value = _$_ref3[1];
                return "" + acc + name + "=" + value + "\n";
            }, "") : String(opts.body);
            return {
                path: path,
                submission: {
                    formMethod: formMethod,
                    formAction: formAction,
                    formEncType: opts.formEncType,
                    formData: undefined,
                    json: undefined,
                    text: text
                }
            };
        } else if (opts.formEncType === "application/json") {
            // json only supports POST/PUT/PATCH/DELETE submissions
            if (!isMutationMethod(formMethod)) return getInvalidBodyError();
            try {
                var json = typeof opts.body === "string" ? JSON.parse(opts.body) : opts.body;
                return {
                    path: path,
                    submission: {
                        formMethod: formMethod,
                        formAction: formAction,
                        formEncType: opts.formEncType,
                        formData: undefined,
                        json: json,
                        text: undefined
                    }
                };
            } catch (e) {
                return getInvalidBodyError();
            }
        }
    }
    invariant(typeof FormData === "function", "FormData is not available in this environment");
    var searchParams;
    var formData;
    if (opts.formData) {
        searchParams = convertFormDataToSearchParams(opts.formData);
        formData = opts.formData;
    } else if (opts.body instanceof FormData) {
        searchParams = convertFormDataToSearchParams(opts.body);
        formData = opts.body;
    } else if (opts.body instanceof URLSearchParams) {
        searchParams = opts.body;
        formData = convertSearchParamsToFormData(searchParams);
    } else if (opts.body == null) {
        searchParams = new URLSearchParams();
        formData = new FormData();
    } else try {
        searchParams = new URLSearchParams(opts.body);
        formData = convertSearchParamsToFormData(searchParams);
    } catch (e) {
        return getInvalidBodyError();
    }
    var submission = {
        formMethod: formMethod,
        formAction: formAction,
        formEncType: opts && opts.formEncType || "application/x-www-form-urlencoded",
        formData: formData,
        json: undefined,
        text: undefined
    };
    if (isMutationMethod(submission.formMethod)) return {
        path: path,
        submission: submission
    };
    // Flatten submission onto URLSearchParams for GET submissions
    var parsedPath = parsePath(path);
    // On GET navigation submissions we can drop the ?index param from the
    // resulting location since all loaders will run.  But fetcher GET submissions
    // only run a single loader so we need to preserve any incoming ?index params
    if (isFetcher && parsedPath.search && hasNakedIndexQuery(parsedPath.search)) searchParams.append("index", "");
    parsedPath.search = "?" + searchParams;
    return {
        path: createPath(parsedPath),
        submission: submission
    };
}
// Filter out all routes at/below any caught error as they aren't going to
// render so we don't need to load them
function getLoaderMatchesUntilBoundary(matches, boundaryId, includeBoundary) {
    if (includeBoundary === void 0) includeBoundary = false;
    var index = matches.findIndex(function(m) {
        return m.route.id === boundaryId;
    });
    if (index >= 0) return matches.slice(0, includeBoundary ? index + 1 : index);
    return matches;
}
function getMatchesToLoad(history, state, matches, submission, location, initialHydration, skipActionErrorRevalidation, isRevalidationRequired, cancelledDeferredRoutes, cancelledFetcherLoads, deletedFetchers, fetchLoadMatches, fetchRedirectIds, routesToUse, basename, pendingActionResult) {
    var actionResult = pendingActionResult ? isErrorResult(pendingActionResult[1]) ? pendingActionResult[1].error : pendingActionResult[1].data : undefined;
    var currentUrl = history.createURL(state.location);
    var nextUrl = history.createURL(location);
    // Pick navigation matches that are net-new or qualify for revalidation
    var boundaryMatches = matches;
    if (initialHydration && state.errors) // On initial hydration, only consider matches up to _and including_ the boundary.
    // This is inclusive to handle cases where a server loader ran successfully,
    // a child server loader bubbled up to this route, but this route has
    // `clientLoader.hydrate` so we want to still run the `clientLoader` so that
    // we have a complete version of `loaderData`
    boundaryMatches = getLoaderMatchesUntilBoundary(matches, Object.keys(state.errors)[0], true);
    else if (pendingActionResult && isErrorResult(pendingActionResult[1])) // If an action threw an error, we call loaders up to, but not including the
    // boundary
    boundaryMatches = getLoaderMatchesUntilBoundary(matches, pendingActionResult[0]);
    // Don't revalidate loaders by default after action 4xx/5xx responses
    // when the flag is enabled.  They can still opt-into revalidation via
    // `shouldRevalidate` via `actionResult`
    var actionStatus = pendingActionResult ? pendingActionResult[1].statusCode : undefined;
    var shouldSkipRevalidation = skipActionErrorRevalidation && actionStatus && actionStatus >= 400;
    var navigationMatches = boundaryMatches.filter(function(match, index) {
        var route = match.route;
        if (route.lazy) // We haven't loaded this route yet so we don't know if it's got a loader!
        return true;
        if (route.loader == null) return false;
        if (initialHydration) return shouldLoadRouteOnHydration(route, state.loaderData, state.errors);
        // Always call the loader on new route instances and pending defer cancellations
        if (isNewLoader(state.loaderData, state.matches[index], match) || cancelledDeferredRoutes.some(function(id) {
            return id === match.route.id;
        })) return true;
        // This is the default implementation for when we revalidate.  If the route
        // provides it's own implementation, then we give them full control but
        // provide this value so they can leverage it if needed after they check
        // their own specific use cases
        var currentRouteMatch = state.matches[index];
        var nextRouteMatch = match;
        return shouldRevalidateLoader(match, _extends({
            currentUrl: currentUrl,
            currentParams: currentRouteMatch.params,
            nextUrl: nextUrl,
            nextParams: nextRouteMatch.params
        }, submission, {
            actionResult: actionResult,
            actionStatus: actionStatus,
            defaultShouldRevalidate: shouldSkipRevalidation ? false : // Forced revalidation due to submission, useRevalidator, or X-Remix-Revalidate
            isRevalidationRequired || currentUrl.pathname + currentUrl.search === nextUrl.pathname + nextUrl.search || // Search params affect all loaders
            currentUrl.search !== nextUrl.search || isNewRouteInstance(currentRouteMatch, nextRouteMatch)
        }));
    });
    // Pick fetcher.loads that need to be revalidated
    var revalidatingFetchers = [];
    fetchLoadMatches.forEach(function(f, key) {
        // Don't revalidate:
        //  - on initial hydration (shouldn't be any fetchers then anyway)
        //  - if fetcher won't be present in the subsequent render
        //    - no longer matches the URL (v7_fetcherPersist=false)
        //    - was unmounted but persisted due to v7_fetcherPersist=true
        if (initialHydration || !matches.some(function(m) {
            return m.route.id === f.routeId;
        }) || deletedFetchers.has(key)) return;
        var fetcherMatches = matchRoutes(routesToUse, f.path, basename);
        // If the fetcher path no longer matches, push it in with null matches so
        // we can trigger a 404 in callLoadersAndMaybeResolveData.  Note this is
        // currently only a use-case for Remix HMR where the route tree can change
        // at runtime and remove a route previously loaded via a fetcher
        if (!fetcherMatches) {
            revalidatingFetchers.push({
                key: key,
                routeId: f.routeId,
                path: f.path,
                matches: null,
                match: null,
                controller: null
            });
            return;
        }
        // Revalidating fetchers are decoupled from the route matches since they
        // load from a static href.  They revalidate based on explicit revalidation
        // (submission, useRevalidator, or X-Remix-Revalidate)
        var fetcher = state.fetchers.get(key);
        var fetcherMatch = getTargetMatch(fetcherMatches, f.path);
        var shouldRevalidate = false;
        if (fetchRedirectIds.has(key)) // Never trigger a revalidation of an actively redirecting fetcher
        shouldRevalidate = false;
        else if (cancelledFetcherLoads.has(key)) {
            // Always mark for revalidation if the fetcher was cancelled
            cancelledFetcherLoads.delete(key);
            shouldRevalidate = true;
        } else if (fetcher && fetcher.state !== "idle" && fetcher.data === undefined) // If the fetcher hasn't ever completed loading yet, then this isn't a
        // revalidation, it would just be a brand new load if an explicit
        // revalidation is required
        shouldRevalidate = isRevalidationRequired;
        else // Otherwise fall back on any user-defined shouldRevalidate, defaulting
        // to explicit revalidations only
        shouldRevalidate = shouldRevalidateLoader(fetcherMatch, _extends({
            currentUrl: currentUrl,
            currentParams: state.matches[state.matches.length - 1].params,
            nextUrl: nextUrl,
            nextParams: matches[matches.length - 1].params
        }, submission, {
            actionResult: actionResult,
            actionStatus: actionStatus,
            defaultShouldRevalidate: shouldSkipRevalidation ? false : isRevalidationRequired
        }));
        if (shouldRevalidate) revalidatingFetchers.push({
            key: key,
            routeId: f.routeId,
            path: f.path,
            matches: fetcherMatches,
            match: fetcherMatch,
            controller: new AbortController()
        });
    });
    return [
        navigationMatches,
        revalidatingFetchers
    ];
}
function shouldLoadRouteOnHydration(route, loaderData, errors) {
    // We dunno if we have a loader - gotta find out!
    if (route.lazy) return true;
    // No loader, nothing to initialize
    if (!route.loader) return false;
    var hasData = loaderData != null && loaderData[route.id] !== undefined;
    var hasError = errors != null && errors[route.id] !== undefined;
    // Don't run if we error'd during SSR
    if (!hasData && hasError) return false;
    // Explicitly opting-in to running on hydration
    if (typeof route.loader === "function" && route.loader.hydrate === true) return true;
    // Otherwise, run if we're not yet initialized with anything
    return !hasData && !hasError;
}
function isNewLoader(currentLoaderData, currentMatch, match) {
    var isNew = // [a] -> [a, b]
    !currentMatch || // [a, b] -> [a, c]
    match.route.id !== currentMatch.route.id;
    // Handle the case that we don't have data for a re-used route, potentially
    // from a prior error or from a cancelled pending deferred
    var isMissingData = currentLoaderData[match.route.id] === undefined;
    // Always load if this is a net-new route or we don't yet have data
    return isNew || isMissingData;
}
function isNewRouteInstance(currentMatch, match) {
    var currentPath = currentMatch.route.path;
    return(// param change for this match, /users/123 -> /users/456
    currentMatch.pathname !== match.pathname || // splat param changed, which is not present in match.path
    // e.g. /files/images/avatar.jpg -> files/finances.xls
    currentPath != null && currentPath.endsWith("*") && currentMatch.params["*"] !== match.params["*"]);
}
function shouldRevalidateLoader(loaderMatch, arg) {
    if (loaderMatch.route.shouldRevalidate) {
        var routeChoice = loaderMatch.route.shouldRevalidate(arg);
        if (typeof routeChoice === "boolean") return routeChoice;
    }
    return arg.defaultShouldRevalidate;
}
function patchRoutesImpl(routeId, children, routesToUse, manifest, mapRouteProperties) {
    var _childrenToPatch;
    var _childrenToPatch1;
    var childrenToPatch;
    if (routeId) {
        var route = manifest[routeId];
        invariant(route, "No route found to patch children into: routeId = " + routeId);
        if (!route.children) route.children = [];
        childrenToPatch = route.children;
    } else childrenToPatch = routesToUse;
    // Don't patch in routes we already know about so that `patch` is idempotent
    // to simplify user-land code. This is useful because we re-call the
    // `patchRoutesOnNavigation` function for matched routes with params.
    var uniqueChildren = children.filter(function(newRoute) {
        return !childrenToPatch.some(function(existingRoute) {
            return isSameRoute(newRoute, existingRoute);
        });
    });
    var newRoutes = convertRoutesToDataRoutes(uniqueChildren, mapRouteProperties, [
        routeId || "_",
        "patch",
        String(((_childrenToPatch1 = childrenToPatch) == null ? void 0 : _childrenToPatch1.length) || "0")
    ], manifest);
    (_childrenToPatch = childrenToPatch).push.apply(_childrenToPatch, (0, $2us1u._)(newRoutes));
}
function isSameRoute(newRoute, existingRoute) {
    // Most optimal check is by id
    if ("id" in newRoute && "id" in existingRoute && newRoute.id === existingRoute.id) return true;
    // Second is by pathing differences
    if (!(newRoute.index === existingRoute.index && newRoute.path === existingRoute.path && newRoute.caseSensitive === existingRoute.caseSensitive)) return false;
    // Pathless layout routes are trickier since we need to check children.
    // If they have no children then they're the same as far as we can tell
    if ((!newRoute.children || newRoute.children.length === 0) && (!existingRoute.children || existingRoute.children.length === 0)) return true;
    // Otherwise, we look to see if every child in the new route is already
    // represented in the existing route's children
    return newRoute.children.every(function(aChild, i) {
        var _existingRoute$childr;
        return (_existingRoute$childr = existingRoute.children) == null ? void 0 : _existingRoute$childr.some(function(bChild) {
            return isSameRoute(aChild, bChild);
        });
    });
}
/**
 * Execute route.lazy() methods to lazily load route modules (loader, action,
 * shouldRevalidate) and update the routeManifest in place which shares objects
 * with dataRoutes so those get updated as well.
 */ function loadLazyRouteModule(route, mapRouteProperties, manifest) {
    return (/*#__PURE__*/ 0, /*#__PURE__*/ $g3gsR._)(function() {
        var lazyRoute, routeToUpdate, routeUpdates, lazyRouteProperty, staticRouteValue, isPropertyStaticallyDefined;
        return (0, $fRv9I.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    if (!route.lazy) return [
                        2
                    ];
                    return [
                        4,
                        route.lazy()
                    ];
                case 1:
                    lazyRoute = _state.sent();
                    // If the lazy route function was executed and removed by another parallel
                    // call then we can return - first lazy() to finish wins because the return
                    // value of lazy is expected to be static
                    if (!route.lazy) return [
                        2
                    ];
                    routeToUpdate = manifest[route.id];
                    invariant(routeToUpdate, "No route found in manifest");
                    // Update the route in place.  This should be safe because there's no way
                    // we could yet be sitting on this route as we can't get there without
                    // resolving lazy() first.
                    //
                    // This is different than the HMR "update" use-case where we may actively be
                    // on the route being updated.  The main concern boils down to "does this
                    // mutation affect any ongoing navigations or any current state.matches
                    // values?".  If not, it should be safe to update in place.
                    routeUpdates = {};
                    for(var lazyRouteProperty in lazyRoute){
                        staticRouteValue = routeToUpdate[lazyRouteProperty];
                        isPropertyStaticallyDefined = staticRouteValue !== undefined && // This property isn't static since it should always be updated based
                        // on the route updates
                        lazyRouteProperty !== "hasErrorBoundary";
                        warning(!isPropertyStaticallyDefined, "Route \"" + routeToUpdate.id + "\" has a static property \"" + lazyRouteProperty + "\" " + "defined but its lazy function is also returning a value for this property. " + ("The lazy route property \"" + lazyRouteProperty + "\" will be ignored."));
                        if (!isPropertyStaticallyDefined && !immutableRouteKeys.has(lazyRouteProperty)) routeUpdates[lazyRouteProperty] = lazyRoute[lazyRouteProperty];
                    }
                    // Mutate the route with the provided updates.  Do this first so we pass
                    // the updated version to mapRouteProperties
                    Object.assign(routeToUpdate, routeUpdates);
                    // Mutate the `hasErrorBoundary` property on the route based on the route
                    // updates and remove the `lazy` function so we don't resolve the lazy
                    // route again.
                    Object.assign(routeToUpdate, _extends({}, mapRouteProperties(routeToUpdate), {
                        lazy: undefined
                    }));
                    return [
                        2
                    ];
            }
        });
    })();
}
// Default implementation of `dataStrategy` which fetches all loaders in parallel
function defaultDataStrategy(_ref4) {
    return (/*#__PURE__*/ 0, /*#__PURE__*/ $g3gsR._)(function() {
        var matches, matchesToLoad, results;
        return (0, $fRv9I.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    matches = _ref4.matches;
                    matchesToLoad = matches.filter(function(m) {
                        return m.shouldLoad;
                    });
                    return [
                        4,
                        Promise.all(matchesToLoad.map(function(m) {
                            return m.resolve();
                        }))
                    ];
                case 1:
                    results = _state.sent();
                    return [
                        2,
                        results.reduce(function(acc, result, i) {
                            return Object.assign(acc, (0, $72osQ._)({}, matchesToLoad[i].route.id, result));
                        }, {})
                    ];
            }
        });
    })();
}
function callDataStrategyImpl(dataStrategyImpl, type, state, request, matchesToLoad, matches, fetcherKey, manifest, mapRouteProperties, requestContext) {
    return (/*#__PURE__*/ 0, /*#__PURE__*/ $g3gsR._)(function() {
        var loadRouteDefinitionsPromises, dsMatches, results, e;
        return (0, $fRv9I.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    loadRouteDefinitionsPromises = matches.map(function(m) {
                        return m.route.lazy ? loadLazyRouteModule(m.route, mapRouteProperties, manifest) : undefined;
                    });
                    dsMatches = matches.map(function(match, i) {
                        var loadRoutePromise = loadRouteDefinitionsPromises[i];
                        var shouldLoad = matchesToLoad.some(function(m) {
                            return m.route.id === match.route.id;
                        });
                        // `resolve` encapsulates route.lazy(), executing the loader/action,
                        // and mapping return values/thrown errors to a `DataStrategyResult`.  Users
                        // can pass a callback to take fine-grained control over the execution
                        // of the loader/action
                        var resolve = function(handlerOverride) {
                            return (/*#__PURE__*/ 0, /*#__PURE__*/ $g3gsR._)(function() {
                                return (0, $fRv9I.__generator)(this, function(_state) {
                                    if (handlerOverride && request.method === "GET" && (match.route.lazy || match.route.loader)) shouldLoad = true;
                                    return [
                                        2,
                                        shouldLoad ? callLoaderOrAction(type, request, match, loadRoutePromise, handlerOverride, requestContext) : Promise.resolve({
                                            type: ResultType.data,
                                            result: undefined
                                        })
                                    ];
                                });
                            })();
                        };
                        return _extends({}, match, {
                            shouldLoad: shouldLoad,
                            resolve: resolve
                        });
                    });
                    return [
                        4,
                        dataStrategyImpl({
                            matches: dsMatches,
                            request: request,
                            params: matches[0].params,
                            fetcherKey: fetcherKey,
                            context: requestContext
                        })
                    ];
                case 1:
                    results = _state.sent();
                    _state.label = 2;
                case 2:
                    _state.trys.push([
                        2,
                        4,
                        ,
                        5
                    ]);
                    return [
                        4,
                        Promise.all(loadRouteDefinitionsPromises)
                    ];
                case 3:
                    _state.sent();
                    return [
                        3,
                        5
                    ];
                case 4:
                    e = _state.sent();
                    return [
                        3,
                        5
                    ];
                case 5:
                    return [
                        2,
                        results
                    ];
            }
        });
    })();
}
// Default logic for calling a loader/action is the user has no specified a dataStrategy
function callLoaderOrAction(type, request, match, loadRoutePromise, handlerOverride, staticContext) {
    return (/*#__PURE__*/ 0, /*#__PURE__*/ $g3gsR._)(function() {
        var result, onReject, runHandler, handler, handlerError, _ref, value, url, pathname, url1, pathname1, e;
        return (0, $fRv9I.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    runHandler = function(handler) {
                        // Setup a promise we can race against so that abort signals short circuit
                        var reject;
                        // This will never resolve so safe to type it as Promise<DataStrategyResult> to
                        // satisfy the function return value
                        var abortPromise = new Promise(function(_, r) {
                            return reject = r;
                        });
                        onReject = function() {
                            return reject();
                        };
                        request.signal.addEventListener("abort", onReject);
                        var actualHandler = function(ctx) {
                            if (typeof handler !== "function") return Promise.reject(new Error("You cannot call the handler for a route which defines a boolean " + ("\"" + type + "\" [routeId: " + match.route.id + "]")));
                            return handler.apply(void 0, [
                                {
                                    request: request,
                                    params: match.params,
                                    context: staticContext
                                }
                            ].concat((0, $2us1u._)(ctx !== undefined ? [
                                ctx
                            ] : [])));
                        };
                        var handlerPromise = function() {
                            return (/*#__PURE__*/ 0, /*#__PURE__*/ $g3gsR._)(function() {
                                var val, e;
                                return (0, $fRv9I.__generator)(this, function(_state) {
                                    switch(_state.label){
                                        case 0:
                                            _state.trys.push([
                                                0,
                                                2,
                                                ,
                                                3
                                            ]);
                                            return [
                                                4,
                                                handlerOverride ? handlerOverride(function(ctx) {
                                                    return actualHandler(ctx);
                                                }) : actualHandler()
                                            ];
                                        case 1:
                                            val = _state.sent();
                                            return [
                                                2,
                                                {
                                                    type: "data",
                                                    result: val
                                                }
                                            ];
                                        case 2:
                                            e = _state.sent();
                                            return [
                                                2,
                                                {
                                                    type: "error",
                                                    result: e
                                                }
                                            ];
                                        case 3:
                                            return [
                                                2
                                            ];
                                    }
                                });
                            })();
                        }();
                        return Promise.race([
                            handlerPromise,
                            abortPromise
                        ]);
                    };
                    _state.label = 1;
                case 1:
                    _state.trys.push([
                        1,
                        12,
                        13,
                        14
                    ]);
                    handler = match.route[type];
                    if (!loadRoutePromise) return [
                        3,
                        8
                    ];
                    if (!handler) return [
                        3,
                        3
                    ];
                    return [
                        4,
                        Promise.all([
                            // If the handler throws, don't let it immediately bubble out,
                            // since we need to let the lazy() execution finish so we know if this
                            // route has a boundary that can handle the error
                            runHandler(handler).catch(function(e) {
                                handlerError = e;
                            }),
                            loadRoutePromise
                        ])
                    ];
                case 2:
                    _ref = (0, $2nwvT._).apply(void 0, [
                        _state.sent(),
                        1
                    ]), value = _ref[0];
                    if (handlerError !== undefined) throw handlerError;
                    result = value;
                    return [
                        3,
                        7
                    ];
                case 3:
                    // Load lazy route module, then run any returned handler
                    return [
                        4,
                        loadRoutePromise
                    ];
                case 4:
                    _state.sent();
                    handler = match.route[type];
                    if (!handler) return [
                        3,
                        6
                    ];
                    return [
                        4,
                        runHandler(handler)
                    ];
                case 5:
                    // Handler still runs even if we got interrupted to maintain consistency
                    // with un-abortable behavior of handler execution on non-lazy or
                    // previously-lazy-loaded routes
                    result = _state.sent();
                    return [
                        3,
                        7
                    ];
                case 6:
                    if (type === "action") {
                        url = new URL(request.url);
                        pathname = url.pathname + url.search;
                        throw getInternalRouterError(405, {
                            method: request.method,
                            pathname: pathname,
                            routeId: match.route.id
                        });
                    } else // lazy() route has no loader to run.  Short circuit here so we don't
                    // hit the invariant below that errors on returning undefined.
                    return [
                        2,
                        {
                            type: ResultType.data,
                            result: undefined
                        }
                    ];
                    _state.label = 7;
                case 7:
                    return [
                        3,
                        11
                    ];
                case 8:
                    if (!!handler) return [
                        3,
                        9
                    ];
                    url1 = new URL(request.url);
                    pathname1 = url1.pathname + url1.search;
                    throw getInternalRouterError(404, {
                        pathname: pathname1
                    });
                case 9:
                    return [
                        4,
                        runHandler(handler)
                    ];
                case 10:
                    result = _state.sent();
                    _state.label = 11;
                case 11:
                    invariant(result.result !== undefined, "You defined " + (type === "action" ? "an action" : "a loader") + " for route " + ("\"" + match.route.id + "\" but didn't return anything from your `" + type + "` ") + "function. Please return a value or `null`.");
                    return [
                        3,
                        14
                    ];
                case 12:
                    e = _state.sent();
                    // We should already be catching and converting normal handler executions to
                    // DataStrategyResults and returning them, so anything that throws here is an
                    // unexpected error we still need to wrap
                    return [
                        2,
                        {
                            type: ResultType.error,
                            result: e
                        }
                    ];
                case 13:
                    if (onReject) request.signal.removeEventListener("abort", onReject);
                    return [
                        7
                    ];
                case 14:
                    return [
                        2,
                        result
                    ];
            }
        });
    })();
}
function convertDataStrategyResultToDataResult(dataStrategyResult) {
    return (/*#__PURE__*/ 0, /*#__PURE__*/ $g3gsR._)(function() {
        var result, type, data, contentType, e, _result$init3, _result$init4, _result$init, _result$init2, _result$init5, _result$init6, _result$init7, _result$init8;
        return (0, $fRv9I.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    result = dataStrategyResult.result, type = dataStrategyResult.type;
                    if (!isResponse(result)) return [
                        3,
                        10
                    ];
                    _state.label = 1;
                case 1:
                    _state.trys.push([
                        1,
                        8,
                        ,
                        9
                    ]);
                    contentType = result.headers.get("Content-Type");
                    if (!(contentType && /\bapplication\/json\b/.test(contentType))) return [
                        3,
                        5
                    ];
                    if (!(result.body == null)) return [
                        3,
                        2
                    ];
                    data = null;
                    return [
                        3,
                        4
                    ];
                case 2:
                    return [
                        4,
                        result.json()
                    ];
                case 3:
                    data = _state.sent();
                    _state.label = 4;
                case 4:
                    return [
                        3,
                        7
                    ];
                case 5:
                    return [
                        4,
                        result.text()
                    ];
                case 6:
                    data = _state.sent();
                    _state.label = 7;
                case 7:
                    return [
                        3,
                        9
                    ];
                case 8:
                    e = _state.sent();
                    return [
                        2,
                        {
                            type: ResultType.error,
                            error: e
                        }
                    ];
                case 9:
                    if (type === ResultType.error) return [
                        2,
                        {
                            type: ResultType.error,
                            error: new ErrorResponseImpl(result.status, result.statusText, data),
                            statusCode: result.status,
                            headers: result.headers
                        }
                    ];
                    return [
                        2,
                        {
                            type: ResultType.data,
                            data: data,
                            statusCode: result.status,
                            headers: result.headers
                        }
                    ];
                case 10:
                    if (type === ResultType.error) {
                        if (isDataWithResponseInit(result)) {
                            ;
                            if (result.data instanceof Error) {
                                ;
                                return [
                                    2,
                                    {
                                        type: ResultType.error,
                                        error: result.data,
                                        statusCode: (_result$init = result.init) == null ? void 0 : _result$init.status,
                                        headers: (_result$init2 = result.init) != null && _result$init2.headers ? new Headers(result.init.headers) : undefined
                                    }
                                ];
                            }
                            // Convert thrown data() to ErrorResponse instances
                            return [
                                2,
                                {
                                    type: ResultType.error,
                                    error: new ErrorResponseImpl(((_result$init3 = result.init) == null ? void 0 : _result$init3.status) || 500, undefined, result.data),
                                    statusCode: isRouteErrorResponse(result) ? result.status : undefined,
                                    headers: (_result$init4 = result.init) != null && _result$init4.headers ? new Headers(result.init.headers) : undefined
                                }
                            ];
                        }
                        return [
                            2,
                            {
                                type: ResultType.error,
                                error: result,
                                statusCode: isRouteErrorResponse(result) ? result.status : undefined
                            }
                        ];
                    }
                    if (isDeferredData(result)) {
                        ;
                        return [
                            2,
                            {
                                type: ResultType.deferred,
                                deferredData: result,
                                statusCode: (_result$init5 = result.init) == null ? void 0 : _result$init5.status,
                                headers: ((_result$init6 = result.init) == null ? void 0 : _result$init6.headers) && new Headers(result.init.headers)
                            }
                        ];
                    }
                    if (isDataWithResponseInit(result)) {
                        ;
                        return [
                            2,
                            {
                                type: ResultType.data,
                                data: result.data,
                                statusCode: (_result$init7 = result.init) == null ? void 0 : _result$init7.status,
                                headers: (_result$init8 = result.init) != null && _result$init8.headers ? new Headers(result.init.headers) : undefined
                            }
                        ];
                    }
                    return [
                        2,
                        {
                            type: ResultType.data,
                            data: result
                        }
                    ];
            }
        });
    })();
}
// Support relative routing in internal redirects
function normalizeRelativeRoutingRedirectResponse(response, request, routeId, matches, basename, v7_relativeSplatPath) {
    var location = response.headers.get("Location");
    invariant(location, "Redirects returned/thrown from loaders/actions must have a Location header");
    if (!ABSOLUTE_URL_REGEX.test(location)) {
        var trimmedMatches = matches.slice(0, matches.findIndex(function(m) {
            return m.route.id === routeId;
        }) + 1);
        location = normalizeTo(new URL(request.url), trimmedMatches, basename, true, location, v7_relativeSplatPath);
        response.headers.set("Location", location);
    }
    return response;
}
function normalizeRedirectLocation(location, currentUrl, basename) {
    if (ABSOLUTE_URL_REGEX.test(location)) {
        // Strip off the protocol+origin for same-origin + same-basename absolute redirects
        var normalizedLocation = location;
        var url = normalizedLocation.startsWith("//") ? new URL(currentUrl.protocol + normalizedLocation) : new URL(normalizedLocation);
        var isSameBasename = stripBasename(url.pathname, basename) != null;
        if (url.origin === currentUrl.origin && isSameBasename) return url.pathname + url.search + url.hash;
    }
    return location;
}
// Utility method for creating the Request instances for loaders/actions during
// client-side navigations and fetches.  During SSR we will always have a
// Request instance from the static handler (query/queryRoute)
function createClientSideRequest(history, location, signal, submission) {
    var url = history.createURL(stripHashFromPath(location)).toString();
    var init = {
        signal: signal
    };
    if (submission && isMutationMethod(submission.formMethod)) {
        var formMethod = submission.formMethod, formEncType = submission.formEncType;
        // Didn't think we needed this but it turns out unlike other methods, patch
        // won't be properly normalized to uppercase and results in a 405 error.
        // See: https://fetch.spec.whatwg.org/#concept-method
        init.method = formMethod.toUpperCase();
        if (formEncType === "application/json") {
            init.headers = new Headers({
                "Content-Type": formEncType
            });
            init.body = JSON.stringify(submission.json);
        } else if (formEncType === "text/plain") // Content-Type is inferred (https://fetch.spec.whatwg.org/#dom-request)
        init.body = submission.text;
        else if (formEncType === "application/x-www-form-urlencoded" && submission.formData) // Content-Type is inferred (https://fetch.spec.whatwg.org/#dom-request)
        init.body = convertFormDataToSearchParams(submission.formData);
        else // Content-Type is inferred (https://fetch.spec.whatwg.org/#dom-request)
        init.body = submission.formData;
    }
    return new Request(url, init);
}
function convertFormDataToSearchParams(formData) {
    var searchParams = new URLSearchParams();
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = formData.entries()[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var _step_value = (0, $2nwvT._)(_step.value, 2), key = _step_value[0], value = _step_value[1];
            // https://html.spec.whatwg.org/multipage/form-control-infrastructure.html#converting-an-entry-list-to-a-list-of-name-value-pairs
            searchParams.append(key, typeof value === "string" ? value : value.name);
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    return searchParams;
}
function convertSearchParamsToFormData(searchParams) {
    var formData = new FormData();
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = searchParams.entries()[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var _step_value = (0, $2nwvT._)(_step.value, 2), key = _step_value[0], value = _step_value[1];
            formData.append(key, value);
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    return formData;
}
function processRouteLoaderData(matches, results, pendingActionResult, activeDeferreds, skipLoaderErrorBubbling) {
    // Fill in loaderData/errors from our loaders
    var loaderData = {};
    var errors = null;
    var statusCode;
    var foundError = false;
    var loaderHeaders = {};
    var pendingError = pendingActionResult && isErrorResult(pendingActionResult[1]) ? pendingActionResult[1].error : undefined;
    // Process loader results into state.loaderData/state.errors
    matches.forEach(function(match) {
        if (!(match.route.id in results)) return;
        var id = match.route.id;
        var result = results[id];
        invariant(!isRedirectResult(result), "Cannot handle redirect results in processLoaderData");
        if (isErrorResult(result)) {
            var error = result.error;
            // If we have a pending action error, we report it at the highest-route
            // that throws a loader error, and then clear it out to indicate that
            // it was consumed
            if (pendingError !== undefined) {
                error = pendingError;
                pendingError = undefined;
            }
            errors = errors || {};
            if (skipLoaderErrorBubbling) errors[id] = error;
            else {
                // Look upwards from the matched route for the closest ancestor error
                // boundary, defaulting to the root match.  Prefer higher error values
                // if lower errors bubble to the same boundary
                var boundaryMatch = findNearestBoundary(matches, id);
                if (errors[boundaryMatch.route.id] == null) errors[boundaryMatch.route.id] = error;
            }
            // Clear our any prior loaderData for the throwing route
            loaderData[id] = undefined;
            // Once we find our first (highest) error, we set the status code and
            // prevent deeper status codes from overriding
            if (!foundError) {
                foundError = true;
                statusCode = isRouteErrorResponse(result.error) ? result.error.status : 500;
            }
            if (result.headers) loaderHeaders[id] = result.headers;
        } else if (isDeferredResult(result)) {
            activeDeferreds.set(id, result.deferredData);
            loaderData[id] = result.deferredData.data;
            // Error status codes always override success status codes, but if all
            // loaders are successful we take the deepest status code.
            if (result.statusCode != null && result.statusCode !== 200 && !foundError) statusCode = result.statusCode;
            if (result.headers) loaderHeaders[id] = result.headers;
        } else {
            loaderData[id] = result.data;
            // Error status codes always override success status codes, but if all
            // loaders are successful we take the deepest status code.
            if (result.statusCode && result.statusCode !== 200 && !foundError) statusCode = result.statusCode;
            if (result.headers) loaderHeaders[id] = result.headers;
        }
    });
    // If we didn't consume the pending action error (i.e., all loaders
    // resolved), then consume it here.  Also clear out any loaderData for the
    // throwing route
    if (pendingError !== undefined && pendingActionResult) {
        errors = (0, $72osQ._)({}, pendingActionResult[0], pendingError);
        loaderData[pendingActionResult[0]] = undefined;
    }
    return {
        loaderData: loaderData,
        errors: errors,
        statusCode: statusCode || 200,
        loaderHeaders: loaderHeaders
    };
}
function processLoaderData(state, matches, results, pendingActionResult, revalidatingFetchers, fetcherResults, activeDeferreds) {
    var _processRouteLoaderData = processRouteLoaderData(matches, results, pendingActionResult, activeDeferreds, false // This method is only called client side so we always want to bubble
    ), loaderData = _processRouteLoaderData.loaderData, errors = _processRouteLoaderData.errors;
    // Process results from our revalidating fetchers
    revalidatingFetchers.forEach(function(rf) {
        var key = rf.key, match = rf.match, controller = rf.controller;
        var result = fetcherResults[key];
        invariant(result, "Did not find corresponding fetcher result");
        // Process fetcher non-redirect errors
        if (controller && controller.signal.aborted) // Nothing to do for aborted fetchers
        return;
        else if (isErrorResult(result)) {
            var boundaryMatch = findNearestBoundary(state.matches, match == null ? void 0 : match.route.id);
            if (!(errors && errors[boundaryMatch.route.id])) errors = _extends({}, errors, (0, $72osQ._)({}, boundaryMatch.route.id, result.error));
            state.fetchers.delete(key);
        } else if (isRedirectResult(result)) // Should never get here, redirects should get processed above, but we
        // keep this to type narrow to a success result in the else
        invariant(false, "Unhandled fetcher revalidation redirect");
        else if (isDeferredResult(result)) // Should never get here, deferred data should be awaited for fetchers
        // in resolveDeferredResults
        invariant(false, "Unhandled fetcher deferred data");
        else {
            var doneFetcher = getDoneFetcher(result.data);
            state.fetchers.set(key, doneFetcher);
        }
    });
    return {
        loaderData: loaderData,
        errors: errors
    };
}
function mergeLoaderData(loaderData, newLoaderData, matches, errors) {
    var mergedLoaderData = _extends({}, newLoaderData);
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = matches[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var match = _step.value;
            var id = match.route.id;
            if (newLoaderData.hasOwnProperty(id)) {
                if (newLoaderData[id] !== undefined) mergedLoaderData[id] = newLoaderData[id];
            } else if (loaderData[id] !== undefined && match.route.loader) // Preserve existing keys not included in newLoaderData and where a loader
            // wasn't removed by HMR
            mergedLoaderData[id] = loaderData[id];
            if (errors && errors.hasOwnProperty(id)) break;
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    return mergedLoaderData;
}
function getActionDataForCommit(pendingActionResult) {
    if (!pendingActionResult) return {};
    return isErrorResult(pendingActionResult[1]) ? {
        // Clear out prior actionData on errors
        actionData: {}
    } : {
        actionData: (0, $72osQ._)({}, pendingActionResult[0], pendingActionResult[1].data)
    };
}
// Find the nearest error boundary, looking upwards from the leaf route (or the
// route specified by routeId) for the closest ancestor error boundary,
// defaulting to the root match
function findNearestBoundary(matches, routeId) {
    var eligibleMatches = routeId ? matches.slice(0, matches.findIndex(function(m) {
        return m.route.id === routeId;
    }) + 1) : (0, $2us1u._)(matches);
    return eligibleMatches.reverse().find(function(m) {
        return m.route.hasErrorBoundary === true;
    }) || matches[0];
}
function getShortCircuitMatches(routes) {
    // Prefer a root layout route if present, otherwise shim in a route object
    var route = routes.length === 1 ? routes[0] : routes.find(function(r) {
        return r.index || !r.path || r.path === "/";
    }) || {
        id: "__shim-error-route__"
    };
    return {
        matches: [
            {
                params: {},
                pathname: "",
                pathnameBase: "",
                route: route
            }
        ],
        route: route
    };
}
function getInternalRouterError(status, _temp5) {
    var _ref = _temp5 === void 0 ? {} : _temp5, pathname = _ref.pathname, routeId = _ref.routeId, method = _ref.method, type = _ref.type, message = _ref.message;
    var statusText = "Unknown Server Error";
    var errorMessage = "Unknown @remix-run/router error";
    if (status === 400) {
        statusText = "Bad Request";
        if (method && pathname && routeId) errorMessage = "You made a " + method + " request to \"" + pathname + "\" but " + ("did not provide a `loader` for route \"" + routeId + "\", ") + "so there is no way to handle the request.";
        else if (type === "defer-action") errorMessage = "defer() is not supported in actions";
        else if (type === "invalid-body") errorMessage = "Unable to encode submission body";
    } else if (status === 403) {
        statusText = "Forbidden";
        errorMessage = "Route \"" + routeId + "\" does not match URL \"" + pathname + "\"";
    } else if (status === 404) {
        statusText = "Not Found";
        errorMessage = "No route matches URL \"" + pathname + "\"";
    } else if (status === 405) {
        statusText = "Method Not Allowed";
        if (method && pathname && routeId) errorMessage = "You made a " + method.toUpperCase() + " request to \"" + pathname + "\" but " + ("did not provide an `action` for route \"" + routeId + "\", ") + "so there is no way to handle the request.";
        else if (method) errorMessage = "Invalid request method \"" + method.toUpperCase() + "\"";
    }
    return new ErrorResponseImpl(status || 500, statusText, new Error(errorMessage), true);
}
// Find any returned redirect errors, starting from the lowest match
function findRedirect(results) {
    var entries = Object.entries(results);
    for(var i = entries.length - 1; i >= 0; i--){
        var _entries_i = (0, $2nwvT._)(entries[i], 2), key = _entries_i[0], result = _entries_i[1];
        if (isRedirectResult(result)) return {
            key: key,
            result: result
        };
    }
}
function stripHashFromPath(path) {
    var parsedPath = typeof path === "string" ? parsePath(path) : path;
    return createPath(_extends({}, parsedPath, {
        hash: ""
    }));
}
function isHashChangeOnly(a, b) {
    if (a.pathname !== b.pathname || a.search !== b.search) return false;
    if (a.hash === "") // /page -> /page#hash
    return b.hash !== "";
    else if (a.hash === b.hash) // /page#hash -> /page#hash
    return true;
    else if (b.hash !== "") // /page#hash -> /page#other
    return true;
    // If the hash is removed the browser will re-perform a request to the server
    // /page#hash -> /page
    return false;
}
function isDataStrategyResult(result) {
    return result != null && (typeof result === "undefined" ? "undefined" : (0, $bJtXW._)(result)) === "object" && "type" in result && "result" in result && (result.type === ResultType.data || result.type === ResultType.error);
}
function isRedirectDataStrategyResultResult(result) {
    return isResponse(result.result) && redirectStatusCodes.has(result.result.status);
}
function isDeferredResult(result) {
    return result.type === ResultType.deferred;
}
function isErrorResult(result) {
    return result.type === ResultType.error;
}
function isRedirectResult(result) {
    return (result && result.type) === ResultType.redirect;
}
function isDataWithResponseInit(value) {
    return (typeof value === "undefined" ? "undefined" : (0, $bJtXW._)(value)) === "object" && value != null && "type" in value && "data" in value && "init" in value && value.type === "DataWithResponseInit";
}
function isDeferredData(value) {
    var deferred = value;
    return deferred && (typeof deferred === "undefined" ? "undefined" : (0, $bJtXW._)(deferred)) === "object" && (0, $bJtXW._)(deferred.data) === "object" && typeof deferred.subscribe === "function" && typeof deferred.cancel === "function" && typeof deferred.resolveData === "function";
}
function isResponse(value) {
    return value != null && typeof value.status === "number" && typeof value.statusText === "string" && (0, $bJtXW._)(value.headers) === "object" && typeof value.body !== "undefined";
}
function isRedirectResponse(result) {
    if (!isResponse(result)) return false;
    var status = result.status;
    var location = result.headers.get("Location");
    return status >= 300 && status <= 399 && location != null;
}
function isValidMethod(method) {
    return validRequestMethods.has(method.toLowerCase());
}
function isMutationMethod(method) {
    return validMutationMethods.has(method.toLowerCase());
}
function resolveNavigationDeferredResults(matches, results, signal, currentMatches, currentLoaderData) {
    return (/*#__PURE__*/ 0, /*#__PURE__*/ $g3gsR._)(function() {
        var _loop, entries, index;
        return (0, $fRv9I.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    _loop = function(index) {
                        var _entries_index, routeId, result, match, currentMatch, isRevalidatingLoader;
                        return (0, $fRv9I.__generator)(this, function(_state) {
                            switch(_state.label){
                                case 0:
                                    _entries_index = (0, $2nwvT._)(entries[index], 2), routeId = _entries_index[0], result = _entries_index[1];
                                    match = matches.find(function(m) {
                                        return (m == null ? void 0 : m.route.id) === routeId;
                                    });
                                    // If we don't have a match, then we can have a deferred result to do
                                    // anything with.  This is for revalidating fetchers where the route was
                                    // removed during HMR
                                    if (!match) return [
                                        2,
                                        "continue"
                                    ];
                                    currentMatch = currentMatches.find(function(m) {
                                        return m.route.id === match.route.id;
                                    });
                                    isRevalidatingLoader = currentMatch != null && !isNewRouteInstance(currentMatch, match) && (currentLoaderData && currentLoaderData[match.route.id]) !== undefined;
                                    if (!(isDeferredResult(result) && isRevalidatingLoader)) return [
                                        3,
                                        2
                                    ];
                                    // Note: we do not have to touch activeDeferreds here since we race them
                                    // against the signal in resolveDeferredData and they'll get aborted
                                    // there if needed
                                    return [
                                        4,
                                        resolveDeferredData(result, signal, false).then(function(result) {
                                            if (result) results[routeId] = result;
                                        })
                                    ];
                                case 1:
                                    _state.sent();
                                    _state.label = 2;
                                case 2:
                                    return [
                                        2
                                    ];
                            }
                        });
                    };
                    entries = Object.entries(results);
                    index = 0;
                    _state.label = 1;
                case 1:
                    if (!(index < entries.length)) return [
                        3,
                        4
                    ];
                    return [
                        5,
                        (0, $fRv9I.__values)(_loop(index))
                    ];
                case 2:
                    _state.sent();
                    _state.label = 3;
                case 3:
                    index++;
                    return [
                        3,
                        1
                    ];
                case 4:
                    return [
                        2
                    ];
            }
        });
    })();
}
function resolveFetcherDeferredResults(matches, results, revalidatingFetchers) {
    return (/*#__PURE__*/ 0, /*#__PURE__*/ $g3gsR._)(function() {
        var _loop, index;
        return (0, $fRv9I.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    _loop = function(index) {
                        var _revalidatingFetchers_index, key, routeId, controller, result, match;
                        return (0, $fRv9I.__generator)(this, function(_state) {
                            switch(_state.label){
                                case 0:
                                    _revalidatingFetchers_index = revalidatingFetchers[index], key = _revalidatingFetchers_index.key, routeId = _revalidatingFetchers_index.routeId, controller = _revalidatingFetchers_index.controller;
                                    result = results[key];
                                    match = matches.find(function(m) {
                                        return (m == null ? void 0 : m.route.id) === routeId;
                                    });
                                    // If we don't have a match, then we can have a deferred result to do
                                    // anything with.  This is for revalidating fetchers where the route was
                                    // removed during HMR
                                    if (!match) return [
                                        2,
                                        "continue"
                                    ];
                                    if (!isDeferredResult(result)) return [
                                        3,
                                        2
                                    ];
                                    // Note: we do not have to touch activeDeferreds here since we race them
                                    // against the signal in resolveDeferredData and they'll get aborted
                                    // there if needed
                                    invariant(controller, "Expected an AbortController for revalidating fetcher deferred result");
                                    return [
                                        4,
                                        resolveDeferredData(result, controller.signal, true).then(function(result) {
                                            if (result) results[key] = result;
                                        })
                                    ];
                                case 1:
                                    _state.sent();
                                    _state.label = 2;
                                case 2:
                                    return [
                                        2
                                    ];
                            }
                        });
                    };
                    index = 0;
                    _state.label = 1;
                case 1:
                    if (!(index < revalidatingFetchers.length)) return [
                        3,
                        4
                    ];
                    return [
                        5,
                        (0, $fRv9I.__values)(_loop(index))
                    ];
                case 2:
                    _state.sent();
                    _state.label = 3;
                case 3:
                    index++;
                    return [
                        3,
                        1
                    ];
                case 4:
                    return [
                        2
                    ];
            }
        });
    })();
}
function resolveDeferredData(result, signal, unwrap) {
    return (/*#__PURE__*/ 0, /*#__PURE__*/ $g3gsR._)(function() {
        var aborted;
        return (0, $fRv9I.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    if (unwrap === void 0) unwrap = false;
                    return [
                        4,
                        result.deferredData.resolveData(signal)
                    ];
                case 1:
                    aborted = _state.sent();
                    if (aborted) return [
                        2
                    ];
                    if (unwrap) try {
                        return [
                            2,
                            {
                                type: ResultType.data,
                                data: result.deferredData.unwrappedData
                            }
                        ];
                    } catch (e) {
                        // Handle any TrackedPromise._error values encountered while unwrapping
                        return [
                            2,
                            {
                                type: ResultType.error,
                                error: e
                            }
                        ];
                    }
                    return [
                        2,
                        {
                            type: ResultType.data,
                            data: result.deferredData.data
                        }
                    ];
            }
        });
    })();
}
function hasNakedIndexQuery(search) {
    return new URLSearchParams(search).getAll("index").some(function(v) {
        return v === "";
    });
}
function getTargetMatch(matches, location) {
    var search = typeof location === "string" ? parsePath(location).search : location.search;
    if (matches[matches.length - 1].route.index && hasNakedIndexQuery(search || "")) // Return the leaf index route when index is present
    return matches[matches.length - 1];
    // Otherwise grab the deepest "path contributing" match (ignoring index and
    // pathless layout routes)
    var pathMatches = getPathContributingMatches(matches);
    return pathMatches[pathMatches.length - 1];
}
function getSubmissionFromNavigation(navigation) {
    var formMethod = navigation.formMethod, formAction = navigation.formAction, formEncType = navigation.formEncType, text = navigation.text, formData = navigation.formData, json = navigation.json;
    if (!formMethod || !formAction || !formEncType) return;
    if (text != null) return {
        formMethod: formMethod,
        formAction: formAction,
        formEncType: formEncType,
        formData: undefined,
        json: undefined,
        text: text
    };
    else if (formData != null) return {
        formMethod: formMethod,
        formAction: formAction,
        formEncType: formEncType,
        formData: formData,
        json: undefined,
        text: undefined
    };
    else if (json !== undefined) return {
        formMethod: formMethod,
        formAction: formAction,
        formEncType: formEncType,
        formData: undefined,
        json: json,
        text: undefined
    };
}
function getLoadingNavigation(location, submission) {
    if (submission) {
        var navigation = {
            state: "loading",
            location: location,
            formMethod: submission.formMethod,
            formAction: submission.formAction,
            formEncType: submission.formEncType,
            formData: submission.formData,
            json: submission.json,
            text: submission.text
        };
        return navigation;
    } else {
        var navigation1 = {
            state: "loading",
            location: location,
            formMethod: undefined,
            formAction: undefined,
            formEncType: undefined,
            formData: undefined,
            json: undefined,
            text: undefined
        };
        return navigation1;
    }
}
function getSubmittingNavigation(location, submission) {
    var navigation = {
        state: "submitting",
        location: location,
        formMethod: submission.formMethod,
        formAction: submission.formAction,
        formEncType: submission.formEncType,
        formData: submission.formData,
        json: submission.json,
        text: submission.text
    };
    return navigation;
}
function getLoadingFetcher(submission, data) {
    if (submission) {
        var fetcher = {
            state: "loading",
            formMethod: submission.formMethod,
            formAction: submission.formAction,
            formEncType: submission.formEncType,
            formData: submission.formData,
            json: submission.json,
            text: submission.text,
            data: data
        };
        return fetcher;
    } else {
        var fetcher1 = {
            state: "loading",
            formMethod: undefined,
            formAction: undefined,
            formEncType: undefined,
            formData: undefined,
            json: undefined,
            text: undefined,
            data: data
        };
        return fetcher1;
    }
}
function getSubmittingFetcher(submission, existingFetcher) {
    var fetcher = {
        state: "submitting",
        formMethod: submission.formMethod,
        formAction: submission.formAction,
        formEncType: submission.formEncType,
        formData: submission.formData,
        json: submission.json,
        text: submission.text,
        data: existingFetcher ? existingFetcher.data : undefined
    };
    return fetcher;
}
function getDoneFetcher(data) {
    var fetcher = {
        state: "idle",
        formMethod: undefined,
        formAction: undefined,
        formEncType: undefined,
        formData: undefined,
        json: undefined,
        text: undefined,
        data: data
    };
    return fetcher;
}
function restoreAppliedTransitions(_window, transitions) {
    try {
        var sessionPositions = _window.sessionStorage.getItem(TRANSITIONS_STORAGE_KEY);
        if (sessionPositions) {
            var json = JSON.parse(sessionPositions);
            var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
            try {
                for(var _iterator = Object.entries(json || {})[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                    var _step_value = (0, $2nwvT._)(_step.value, 2), k = _step_value[0], v = _step_value[1];
                    if (v && Array.isArray(v)) transitions.set(k, new Set(v || []));
                }
            } catch (err) {
                _didIteratorError = true;
                _iteratorError = err;
            } finally{
                try {
                    if (!_iteratorNormalCompletion && _iterator.return != null) {
                        _iterator.return();
                    }
                } finally{
                    if (_didIteratorError) {
                        throw _iteratorError;
                    }
                }
            }
        }
    } catch (e) {
    // no-op, use default empty object
    }
}
function persistAppliedTransitions(_window, transitions) {
    if (transitions.size > 0) {
        var json = {};
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            for(var _iterator = transitions[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var _step_value = (0, $2nwvT._)(_step.value, 2), k = _step_value[0], v = _step_value[1];
                json[k] = (0, $2us1u._)(v);
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
        try {
            _window.sessionStorage.setItem(TRANSITIONS_STORAGE_KEY, JSON.stringify(json));
        } catch (error) {
            warning(false, "Failed to save applied view transitions in sessionStorage (" + error + ").");
        }
    }
}

});
parcelRegister("g3gsR", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $baf9b2a64fedef68$export$71511d61b312f219; });
function $baf9b2a64fedef68$var$asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) resolve(value);
    else Promise.resolve(value).then(_next, _throw);
}
function $baf9b2a64fedef68$export$71511d61b312f219(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                $baf9b2a64fedef68$var$asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                $baf9b2a64fedef68$var$asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}

});

parcelRegister("f3Okx", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $af6e2d59c2ac092d$export$71511d61b312f219; });

var $gyGuQ = parcelRequire("gyGuQ");

var $ftVlM = parcelRequire("ftVlM");

var $gvVNz = parcelRequire("gvVNz");
function $af6e2d59c2ac092d$export$71511d61b312f219(_this, derived, args) {
    // Super
    derived = (0, $gyGuQ._)(derived);
    return (0, $gvVNz._)(_this, (0, $ftVlM._)() ? Reflect.construct(derived, args || [], (0, $gyGuQ._)(_this).constructor) : derived.apply(_this, args));
}

});
parcelRegister("gyGuQ", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $c0e0c9403f4e59d3$export$71511d61b312f219; });
function $c0e0c9403f4e59d3$export$71511d61b312f219(o) {
    $c0e0c9403f4e59d3$export$71511d61b312f219 = Object.setPrototypeOf ? Object.getPrototypeOf : function getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return $c0e0c9403f4e59d3$export$71511d61b312f219(o);
}

});

parcelRegister("ftVlM", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $b4560d09ed0b6bd9$export$71511d61b312f219; });
function $b4560d09ed0b6bd9$export$71511d61b312f219() {
    // Since Reflect.construct can't be properly polyfilled, some
    // implementations (e.g. core-js@2) don't set the correct internal slots.
    // Those polyfills don't allow us to subclass built-ins, so we need to
    // use our fallback implementation.
    try {
        // If the internal slots aren't set, this throws an error similar to
        //   TypeError: this is not a Boolean object.
        var result = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (_) {}
    return ($b4560d09ed0b6bd9$export$71511d61b312f219 = function() {
        return !!result;
    })();
}

});

parcelRegister("gvVNz", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $031a439d9bd8f8b3$export$71511d61b312f219; });

var $dcJGd = parcelRequire("dcJGd");

var $bJtXW = parcelRequire("bJtXW");
function $031a439d9bd8f8b3$export$71511d61b312f219(self, call) {
    if (call && ((0, $bJtXW._)(call) === "object" || typeof call === "function")) return call;
    return (0, $dcJGd._)(self);
}

});
parcelRegister("dcJGd", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $99cfd4696d3ae8ed$export$71511d61b312f219; });
function $99cfd4696d3ae8ed$export$71511d61b312f219(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}

});



parcelRegister("grujF", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $bf86af1e5034cb56$export$71511d61b312f219; });
function $bf86af1e5034cb56$export$71511d61b312f219(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}

});

parcelRegister("dhMkv", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $9ac25a306229a9ff$export$71511d61b312f219; });
function $9ac25a306229a9ff$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function $9ac25a306229a9ff$export$71511d61b312f219(Constructor, protoProps, staticProps) {
    if (protoProps) $9ac25a306229a9ff$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $9ac25a306229a9ff$var$_defineProperties(Constructor, staticProps);
    return Constructor;
}

});

parcelRegister("72osQ", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $51fbb26672273063$export$71511d61b312f219; });
function $51fbb26672273063$export$71511d61b312f219(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}

});

parcelRegister("j6Mzi", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $de944088b801fe33$export$71511d61b312f219; });

var $fMryZ = parcelRequire("fMryZ");
function $de944088b801fe33$export$71511d61b312f219(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) (0, $fMryZ._)(subClass, superClass);
}

});
parcelRegister("fMryZ", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $b7d0b832e35ee57e$export$71511d61b312f219; });
function $b7d0b832e35ee57e$export$71511d61b312f219(o, p) {
    $b7d0b832e35ee57e$export$71511d61b312f219 = Object.setPrototypeOf || function setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return $b7d0b832e35ee57e$export$71511d61b312f219(o, p);
}

});


parcelRegister("2nwvT", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $1bb6f341c8f857d6$export$71511d61b312f219; });

var $1g4fM = parcelRequire("1g4fM");

var $aPFUy = parcelRequire("aPFUy");

var $9kJqn = parcelRequire("9kJqn");

var $2DD2t = parcelRequire("2DD2t");
function $1bb6f341c8f857d6$export$71511d61b312f219(arr, i) {
    return (0, $1g4fM._)(arr) || (0, $aPFUy._)(arr, i) || (0, $2DD2t._)(arr, i) || (0, $9kJqn._)();
}

});
parcelRegister("1g4fM", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $0eaa95b9f3cb7234$export$71511d61b312f219; });
function $0eaa95b9f3cb7234$export$71511d61b312f219(arr) {
    if (Array.isArray(arr)) return arr;
}

});

parcelRegister("aPFUy", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $7e2f2d8338cd036c$export$71511d61b312f219; });
function $7e2f2d8338cd036c$export$71511d61b312f219(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}

});

parcelRegister("9kJqn", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $6cb937a794637792$export$71511d61b312f219; });
function $6cb937a794637792$export$71511d61b312f219() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

});

parcelRegister("2DD2t", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $1ebd819a91fcf92e$export$71511d61b312f219; });

var $6exmR = parcelRequire("6exmR");
function $1ebd819a91fcf92e$export$71511d61b312f219(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return (0, $6exmR._)(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return (0, $6exmR._)(o, minLen);
}

});
parcelRegister("6exmR", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $489def0a77882a2a$export$71511d61b312f219; });
function $489def0a77882a2a$export$71511d61b312f219(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}

});



parcelRegister("l8eKX", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $f625ca9f0dc92caa$export$71511d61b312f219; });

var $1g4fM = parcelRequire("1g4fM");

var $eaxdf = parcelRequire("eaxdf");

var $9kJqn = parcelRequire("9kJqn");

var $2DD2t = parcelRequire("2DD2t");
function $f625ca9f0dc92caa$export$71511d61b312f219(arr) {
    return (0, $1g4fM._)(arr) || (0, $eaxdf._)(arr) || (0, $2DD2t._)(arr) || (0, $9kJqn._)();
}

});
parcelRegister("eaxdf", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $a50bc32ea5ddcbbf$export$71511d61b312f219; });
function $a50bc32ea5ddcbbf$export$71511d61b312f219(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}

});


parcelRegister("2us1u", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $1d041ee89e51af1b$export$71511d61b312f219; });

var $eYsRh = parcelRequire("eYsRh");

var $eaxdf = parcelRequire("eaxdf");

var $46sYX = parcelRequire("46sYX");

var $2DD2t = parcelRequire("2DD2t");
function $1d041ee89e51af1b$export$71511d61b312f219(arr) {
    return (0, $eYsRh._)(arr) || (0, $eaxdf._)(arr) || (0, $2DD2t._)(arr) || (0, $46sYX._)();
}

});
parcelRegister("eYsRh", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $ae6d0dee9f5eb3eb$export$71511d61b312f219; });

var $6exmR = parcelRequire("6exmR");
function $ae6d0dee9f5eb3eb$export$71511d61b312f219(arr) {
    if (Array.isArray(arr)) return (0, $6exmR._)(arr);
}

});

parcelRegister("46sYX", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $2fce3437f4cf1874$export$71511d61b312f219; });
function $2fce3437f4cf1874$export$71511d61b312f219() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

});


parcelRegister("1EZOw", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $135979cf6d0dc133$export$71511d61b312f219; });

var $8wAe0 = parcelRequire("8wAe0");

var $gyGuQ = parcelRequire("gyGuQ");

var $aFtfV = parcelRequire("aFtfV");

var $fMryZ = parcelRequire("fMryZ");
function $135979cf6d0dc133$export$71511d61b312f219(Class) {
    var _cache = typeof Map === "function" ? new Map() : undefined;
    $135979cf6d0dc133$export$71511d61b312f219 = function(Class) {
        if (Class === null || !(0, $aFtfV._)(Class)) return Class;
        if (typeof Class !== "function") throw new TypeError("Super expression must either be null or a function");
        if (typeof _cache !== "undefined") {
            if (_cache.has(Class)) return _cache.get(Class);
            _cache.set(Class, Wrapper);
        }
        function Wrapper() {
            return (0, $8wAe0._)(Class, arguments, (0, $gyGuQ._)(this).constructor);
        }
        Wrapper.prototype = Object.create(Class.prototype, {
            constructor: {
                value: Wrapper,
                enumerable: false,
                writable: true,
                configurable: true
            }
        });
        return (0, $fMryZ._)(Wrapper, Class);
    };
    return $135979cf6d0dc133$export$71511d61b312f219(Class);
}

});
parcelRegister("8wAe0", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $634d6964686a1afa$export$71511d61b312f219; });

var $ftVlM = parcelRequire("ftVlM");

var $fMryZ = parcelRequire("fMryZ");
function $634d6964686a1afa$export$71511d61b312f219(Parent, args, Class) {
    if ((0, $ftVlM._)()) $634d6964686a1afa$export$71511d61b312f219 = Reflect.construct;
    else $634d6964686a1afa$export$71511d61b312f219 = function construct(Parent, args, Class) {
        var a = [
            null
        ];
        a.push.apply(a, args);
        var Constructor = Function.bind.apply(Parent, a);
        var instance = new Constructor();
        if (Class) (0, $fMryZ._)(instance, Class.prototype);
        return instance;
    };
    return $634d6964686a1afa$export$71511d61b312f219.apply(null, arguments);
}

});

parcelRegister("aFtfV", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $7c446d547ed0cd60$export$71511d61b312f219; });
function $7c446d547ed0cd60$export$71511d61b312f219(fn) {
    return Function.toString.call(fn).indexOf("[native code]") !== -1;
}

});


parcelRegister("fRv9I", function(module, exports) {

$parcel$export(module.exports, "__generator", function () { return $b8c3f91e5973f862$export$67ebef60e6f28a6; });
$parcel$export(module.exports, "__values", function () { return $b8c3f91e5973f862$export$19a8beecd37a4c45; });
/******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */ /* global Reflect, Promise, SuppressedError, Symbol, Iterator */ 
var $bJtXW = parcelRequire("bJtXW");
var $b8c3f91e5973f862$var$extendStatics = function extendStatics1(d, b) {
    $b8c3f91e5973f862$var$extendStatics = Object.setPrototypeOf || ({
        __proto__: []
    }) instanceof Array && function(d, b) {
        d.__proto__ = b;
    } || function(d, b) {
        for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
    };
    return $b8c3f91e5973f862$var$extendStatics(d, b);
};
function $b8c3f91e5973f862$export$a8ba968b8961cb8a(d, b) {
    if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
    $b8c3f91e5973f862$var$extendStatics(d, b);
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}
var $b8c3f91e5973f862$export$18ce0697a983be9b = function __assign1() {
    $b8c3f91e5973f862$export$18ce0697a983be9b = Object.assign || function __assign(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $b8c3f91e5973f862$export$18ce0697a983be9b.apply(this, arguments);
};
function $b8c3f91e5973f862$export$3c9a16f847548506(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
}
function $b8c3f91e5973f862$export$29e00dfd3077644b(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if ((typeof Reflect === "undefined" ? "undefined" : (0, $bJtXW._)(Reflect)) === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}
function $b8c3f91e5973f862$export$d5ad3fd78186038f(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
}
function $b8c3f91e5973f862$export$3a84e1ae4e97e9b0(ctor, descriptorIn, decorators, contextIn, initializers, extraInitializers) {
    function accept(f) {
        if (f !== void 0 && typeof f !== "function") throw new TypeError("Function expected");
        return f;
    }
    var kind = contextIn.kind, key = kind === "getter" ? "get" : kind === "setter" ? "set" : "value";
    var target = !descriptorIn && ctor ? contextIn["static"] ? ctor : ctor.prototype : null;
    var descriptor = descriptorIn || (target ? Object.getOwnPropertyDescriptor(target, contextIn.name) : {});
    var _, done = false;
    for(var i = decorators.length - 1; i >= 0; i--){
        var context = {};
        for(var p in contextIn)context[p] = p === "access" ? {} : contextIn[p];
        for(var p in contextIn.access)context.access[p] = contextIn.access[p];
        context.addInitializer = function(f) {
            if (done) throw new TypeError("Cannot add initializers after decoration has completed");
            extraInitializers.push(accept(f || null));
        };
        var result = (0, decorators[i])(kind === "accessor" ? {
            get: descriptor.get,
            set: descriptor.set
        } : descriptor[key], context);
        if (kind === "accessor") {
            if (result === void 0) continue;
            if (result === null || (typeof result === "undefined" ? "undefined" : (0, $bJtXW._)(result)) !== "object") throw new TypeError("Object expected");
            if (_ = accept(result.get)) descriptor.get = _;
            if (_ = accept(result.set)) descriptor.set = _;
            if (_ = accept(result.init)) initializers.unshift(_);
        } else if (_ = accept(result)) {
            if (kind === "field") initializers.unshift(_);
            else descriptor[key] = _;
        }
    }
    if (target) Object.defineProperty(target, contextIn.name, descriptor);
    done = true;
}
function $b8c3f91e5973f862$export$d831c04e792af3d(thisArg, initializers, value) {
    var useValue = arguments.length > 2;
    for(var i = 0; i < initializers.length; i++)value = useValue ? initializers[i].call(thisArg, value) : initializers[i].call(thisArg);
    return useValue ? value : void 0;
}
function $b8c3f91e5973f862$export$6a2a36740a146cb8(x) {
    return (typeof x === "undefined" ? "undefined" : (0, $bJtXW._)(x)) === "symbol" ? x : "".concat(x);
}
function $b8c3f91e5973f862$export$d1a06452d3489bc7(f, name, prefix) {
    if ((typeof name === "undefined" ? "undefined" : (0, $bJtXW._)(name)) === "symbol") name = name.description ? "[".concat(name.description, "]") : "";
    return Object.defineProperty(f, "name", {
        configurable: true,
        value: prefix ? "".concat(prefix, " ", name) : name
    });
}
function $b8c3f91e5973f862$export$f1db080c865becb9(metadataKey, metadataValue) {
    if ((typeof Reflect === "undefined" ? "undefined" : (0, $bJtXW._)(Reflect)) === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(metadataKey, metadataValue);
}
function $b8c3f91e5973f862$export$1050f835b63b671e(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}
function $b8c3f91e5973f862$export$67ebef60e6f28a6(thisArg, body) {
    var _ = {
        label: 0,
        sent: function sent() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(g && (g = 0, op[0] && (_ = 0)), _)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
var $b8c3f91e5973f862$export$45d3717a4c69092e = Object.create ? function __createBinding(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function get() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
};
function $b8c3f91e5973f862$export$f33643c0debef087(m, o) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(o, p)) $b8c3f91e5973f862$export$45d3717a4c69092e(o, m, p);
}
function $b8c3f91e5973f862$export$19a8beecd37a4c45(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function next() {
            if (o && i >= o.length) o = void 0;
            return {
                value: o && o[i++],
                done: !o
            };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
}
function $b8c3f91e5973f862$export$8d051b38c9118094(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
}
function $b8c3f91e5973f862$export$afc72e2116322959() {
    for(var ar = [], i = 0; i < arguments.length; i++)ar = ar.concat($b8c3f91e5973f862$export$8d051b38c9118094(arguments[i]));
    return ar;
}
function $b8c3f91e5973f862$export$6388937ca91ccae8() {
    for(var s = 0, i = 0, il = arguments.length; i < il; i++)s += arguments[i].length;
    for(var r = Array(s), k = 0, i = 0; i < il; i++)for(var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)r[k] = a[j];
    return r;
}
function $b8c3f91e5973f862$export$1216008129fb82ed(to, from, pack) {
    if (pack || arguments.length === 2) {
        for(var i = 0, l = from.length, ar; i < l; i++)if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
}
function $b8c3f91e5973f862$export$10c90e4f7922046c(v) {
    return this instanceof $b8c3f91e5973f862$export$10c90e4f7922046c ? (this.v = v, this) : new $b8c3f91e5973f862$export$10c90e4f7922046c(v);
}
function $b8c3f91e5973f862$export$e427f37a30a4de9b(thisArg, _arguments, generator) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var g = generator.apply(thisArg, _arguments || []), i, q = [];
    return i = Object.create((typeof AsyncIterator === "function" ? AsyncIterator : Object).prototype), verb("next"), verb("throw"), verb("return", awaitReturn), i[Symbol.asyncIterator] = function() {
        return this;
    }, i;
    function awaitReturn(f) {
        return function(v) {
            return Promise.resolve(v).then(f, reject);
        };
    }
    function verb(n, f) {
        if (g[n]) {
            i[n] = function(v) {
                return new Promise(function(a, b) {
                    q.push([
                        n,
                        v,
                        a,
                        b
                    ]) > 1 || resume(n, v);
                });
            };
            if (f) i[n] = f(i[n]);
        }
    }
    function resume(n, v) {
        try {
            step(g[n](v));
        } catch (e) {
            settle(q[0][3], e);
        }
    }
    function step(r) {
        r.value instanceof $b8c3f91e5973f862$export$10c90e4f7922046c ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r);
    }
    function fulfill(value) {
        resume("next", value);
    }
    function reject(value) {
        resume("throw", value);
    }
    function settle(f, v) {
        if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]);
    }
}
function $b8c3f91e5973f862$export$bbd80228419bb833(o) {
    var i, p;
    return i = {}, verb("next"), verb("throw", function(e) {
        throw e;
    }), verb("return"), i[Symbol.iterator] = function() {
        return this;
    }, i;
    function verb(n, f) {
        i[n] = o[n] ? function(v) {
            return (p = !p) ? {
                value: $b8c3f91e5973f862$export$10c90e4f7922046c(o[n](v)),
                done: false
            } : f ? f(v) : v;
        } : f;
    }
}
function $b8c3f91e5973f862$export$e3b29a3d6162315f(o) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var m = o[Symbol.asyncIterator], i;
    return m ? m.call(o) : (o = typeof $b8c3f91e5973f862$export$19a8beecd37a4c45 === "function" ? $b8c3f91e5973f862$export$19a8beecd37a4c45(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i);
    function verb(n) {
        i[n] = o[n] && function(v) {
            return new Promise(function(resolve, reject) {
                v = o[n](v), settle(resolve, reject, v.done, v.value);
            });
        };
    }
    function settle(resolve, reject, d, v) {
        Promise.resolve(v).then(function(v) {
            resolve({
                value: v,
                done: d
            });
        }, reject);
    }
}
function $b8c3f91e5973f862$export$4fb47efe1390b86f(cooked, raw) {
    if (Object.defineProperty) Object.defineProperty(cooked, "raw", {
        value: raw
    });
    else cooked.raw = raw;
    return cooked;
}
var $b8c3f91e5973f862$var$__setModuleDefault = Object.create ? function __setModuleDefault(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
};
var $b8c3f91e5973f862$var$ownKeys = function ownKeys1(o) {
    $b8c3f91e5973f862$var$ownKeys = Object.getOwnPropertyNames || function(o) {
        var ar = [];
        for(var k in o)if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
        return ar;
    };
    return $b8c3f91e5973f862$var$ownKeys(o);
};
function $b8c3f91e5973f862$export$c21735bcef00d192(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k = $b8c3f91e5973f862$var$ownKeys(mod), i = 0; i < k.length; i++)if (k[i] !== "default") $b8c3f91e5973f862$export$45d3717a4c69092e(result, mod, k[i]);
    }
    $b8c3f91e5973f862$var$__setModuleDefault(result, mod);
    return result;
}
function $b8c3f91e5973f862$export$da59b14a69baef04(mod) {
    return mod && mod.__esModule ? mod : {
        default: mod
    };
}
function $b8c3f91e5973f862$export$d5dcaf168c640c35(receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
}
function $b8c3f91e5973f862$export$d40a35129aaff81f(receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value), value;
}
function $b8c3f91e5973f862$export$81fdc39f203e4e04(state, receiver) {
    if (receiver === null || (typeof receiver === "undefined" ? "undefined" : (0, $bJtXW._)(receiver)) !== "object" && typeof receiver !== "function") throw new TypeError("Cannot use 'in' operator on non-object");
    return typeof state === "function" ? receiver === state : state.has(receiver);
}
function $b8c3f91e5973f862$export$88ac25d8e944e405(env, value, async) {
    if (value !== null && value !== void 0) {
        if ((typeof value === "undefined" ? "undefined" : (0, $bJtXW._)(value)) !== "object" && typeof value !== "function") throw new TypeError("Object expected.");
        var dispose, inner;
        if (async) {
            if (!Symbol.asyncDispose) throw new TypeError("Symbol.asyncDispose is not defined.");
            dispose = value[Symbol.asyncDispose];
        }
        if (dispose === void 0) {
            if (!Symbol.dispose) throw new TypeError("Symbol.dispose is not defined.");
            dispose = value[Symbol.dispose];
            if (async) inner = dispose;
        }
        if (typeof dispose !== "function") throw new TypeError("Object not disposable.");
        if (inner) dispose = function dispose() {
            try {
                inner.call(this);
            } catch (e) {
                return Promise.reject(e);
            }
        };
        env.stack.push({
            value: value,
            dispose: dispose,
            async: async
        });
    } else if (async) env.stack.push({
        async: true
    });
    return value;
}
var $b8c3f91e5973f862$var$_SuppressedError = typeof SuppressedError === "function" ? SuppressedError : function _SuppressedError(error, suppressed, message) {
    var e = new Error(message);
    return e.name = "SuppressedError", e.error = error, e.suppressed = suppressed, e;
};
function $b8c3f91e5973f862$export$8f076105dc360e92(env) {
    function fail(e) {
        env.error = env.hasError ? new $b8c3f91e5973f862$var$_SuppressedError(e, env.error, "An error was suppressed during disposal.") : e;
        env.hasError = true;
    }
    var r, s = 0;
    function next() {
        while(r = env.stack.pop())try {
            if (!r.async && s === 1) return s = 0, env.stack.push(r), Promise.resolve().then(next);
            if (r.dispose) {
                var result = r.dispose.call(r.value);
                if (r.async) return s |= 2, Promise.resolve(result).then(next, function(e) {
                    fail(e);
                    return next();
                });
            } else s |= 1;
        } catch (e) {
            fail(e);
        }
        if (s === 1) return env.hasError ? Promise.reject(env.error) : Promise.resolve();
        if (env.hasError) throw env.error;
    }
    return next();
}
function $b8c3f91e5973f862$export$889dfb5d17574b0b(path, preserveJsx) {
    if (typeof path === "string" && /^\.\.?\//.test(path)) return path.replace(/\.(tsx)$|((?:\.d)?)((?:\.[^./]+?)?)\.([cm]?)ts$/i, function(m, tsx, d, ext, cm) {
        return tsx ? preserveJsx ? ".jsx" : ".js" : d && (!ext || !cm) ? m : d + ext + "." + cm.toLowerCase() + "js";
    });
    return path;
}
var $b8c3f91e5973f862$export$2e2bcd8739ae039 = {
    __extends: $b8c3f91e5973f862$export$a8ba968b8961cb8a,
    __assign: $b8c3f91e5973f862$export$18ce0697a983be9b,
    __rest: $b8c3f91e5973f862$export$3c9a16f847548506,
    __decorate: $b8c3f91e5973f862$export$29e00dfd3077644b,
    __param: $b8c3f91e5973f862$export$d5ad3fd78186038f,
    __esDecorate: $b8c3f91e5973f862$export$3a84e1ae4e97e9b0,
    __runInitializers: $b8c3f91e5973f862$export$d831c04e792af3d,
    __propKey: $b8c3f91e5973f862$export$6a2a36740a146cb8,
    __setFunctionName: $b8c3f91e5973f862$export$d1a06452d3489bc7,
    __metadata: $b8c3f91e5973f862$export$f1db080c865becb9,
    __awaiter: $b8c3f91e5973f862$export$1050f835b63b671e,
    __generator: $b8c3f91e5973f862$export$67ebef60e6f28a6,
    __createBinding: $b8c3f91e5973f862$export$45d3717a4c69092e,
    __exportStar: $b8c3f91e5973f862$export$f33643c0debef087,
    __values: $b8c3f91e5973f862$export$19a8beecd37a4c45,
    __read: $b8c3f91e5973f862$export$8d051b38c9118094,
    __spread: $b8c3f91e5973f862$export$afc72e2116322959,
    __spreadArrays: $b8c3f91e5973f862$export$6388937ca91ccae8,
    __spreadArray: $b8c3f91e5973f862$export$1216008129fb82ed,
    __await: $b8c3f91e5973f862$export$10c90e4f7922046c,
    __asyncGenerator: $b8c3f91e5973f862$export$e427f37a30a4de9b,
    __asyncDelegator: $b8c3f91e5973f862$export$bbd80228419bb833,
    __asyncValues: $b8c3f91e5973f862$export$e3b29a3d6162315f,
    __makeTemplateObject: $b8c3f91e5973f862$export$4fb47efe1390b86f,
    __importStar: $b8c3f91e5973f862$export$c21735bcef00d192,
    __importDefault: $b8c3f91e5973f862$export$da59b14a69baef04,
    __classPrivateFieldGet: $b8c3f91e5973f862$export$d5dcaf168c640c35,
    __classPrivateFieldSet: $b8c3f91e5973f862$export$d40a35129aaff81f,
    __classPrivateFieldIn: $b8c3f91e5973f862$export$81fdc39f203e4e04,
    __addDisposableResource: $b8c3f91e5973f862$export$88ac25d8e944e405,
    __disposeResources: $b8c3f91e5973f862$export$8f076105dc360e92,
    __rewriteRelativeImportExtension: $b8c3f91e5973f862$export$889dfb5d17574b0b
};

});


parcelRegister("imka8", function(module, exports) {

$parcel$export(module.exports, "useSyncExternalStoreWithSelector", function () { return $d5d9ebee7c4f223e$export$bf730a2d8bf68b42; }, function (v) { return $d5d9ebee7c4f223e$export$bf730a2d8bf68b42 = v; });
/**
 * @license React
 * use-sync-external-store-with-selector.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $d5d9ebee7c4f223e$export$bf730a2d8bf68b42;
"use strict";

var $dQFEZ = parcelRequire("dQFEZ");
function $d5d9ebee7c4f223e$var$is(x, y) {
    return x === y && (0 !== x || 1 / x === 1 / y) || x !== x && y !== y;
}
var $d5d9ebee7c4f223e$var$objectIs = "function" === typeof Object.is ? Object.is : $d5d9ebee7c4f223e$var$is, $d5d9ebee7c4f223e$var$useSyncExternalStore = $dQFEZ.useSyncExternalStore, $d5d9ebee7c4f223e$var$useRef = $dQFEZ.useRef, $d5d9ebee7c4f223e$var$useEffect = $dQFEZ.useEffect, $d5d9ebee7c4f223e$var$useMemo = $dQFEZ.useMemo, $d5d9ebee7c4f223e$var$useDebugValue = $dQFEZ.useDebugValue;
$d5d9ebee7c4f223e$export$bf730a2d8bf68b42 = function(subscribe, getSnapshot, getServerSnapshot, selector, isEqual) {
    var instRef = $d5d9ebee7c4f223e$var$useRef(null);
    if (null === instRef.current) {
        var inst = {
            hasValue: !1,
            value: null
        };
        instRef.current = inst;
    } else inst = instRef.current;
    instRef = $d5d9ebee7c4f223e$var$useMemo(function() {
        function memoizedSelector(nextSnapshot) {
            if (!hasMemo) {
                hasMemo = !0;
                memoizedSnapshot = nextSnapshot;
                nextSnapshot = selector(nextSnapshot);
                if (void 0 !== isEqual && inst.hasValue) {
                    var currentSelection = inst.value;
                    if (isEqual(currentSelection, nextSnapshot)) return memoizedSelection = currentSelection;
                }
                return memoizedSelection = nextSnapshot;
            }
            currentSelection = memoizedSelection;
            if ($d5d9ebee7c4f223e$var$objectIs(memoizedSnapshot, nextSnapshot)) return currentSelection;
            var nextSelection = selector(nextSnapshot);
            if (void 0 !== isEqual && isEqual(currentSelection, nextSelection)) return memoizedSnapshot = nextSnapshot, currentSelection;
            memoizedSnapshot = nextSnapshot;
            return memoizedSelection = nextSelection;
        }
        var hasMemo = !1, memoizedSnapshot, memoizedSelection, maybeGetServerSnapshot = void 0 === getServerSnapshot ? null : getServerSnapshot;
        return [
            function() {
                return memoizedSelector(getSnapshot());
            },
            null === maybeGetServerSnapshot ? void 0 : function() {
                return memoizedSelector(maybeGetServerSnapshot());
            }
        ];
    }, [
        getSnapshot,
        getServerSnapshot,
        selector,
        isEqual
    ]);
    var value = $d5d9ebee7c4f223e$var$useSyncExternalStore(subscribe, instRef[0], instRef[1]);
    $d5d9ebee7c4f223e$var$useEffect(function() {
        inst.hasValue = !0;
        inst.value = value;
    }, [
        value
    ]);
    $d5d9ebee7c4f223e$var$useDebugValue(value);
    return value;
};

});

parcelRegister("4UEIL", function(module, exports) {

$parcel$export(module.exports, "motion", function () { return $2e5cd59fdcb487ef$export$e25e478948902b8b; });

var $j5oTN = parcelRequire("j5oTN");

var $a0J91 = parcelRequire("a0J91");

var $1cjWu = parcelRequire("1cjWu");
var $2e5cd59fdcb487ef$export$e25e478948902b8b = /*@__PURE__*/ (0, $a0J91.createMotionProxy)((0, $1cjWu.featureBundle), (0, $j5oTN.createDomVisualElement));

});
parcelRegister("j5oTN", function(module, exports) {

$parcel$export(module.exports, "createDomVisualElement", function () { return $48d7af1c7071e507$export$56ba0183203348f5; });

var $dQFEZ = parcelRequire("dQFEZ");

var $lSopA = parcelRequire("lSopA");

var $3KXBC = parcelRequire("3KXBC");

var $jhf4j = parcelRequire("jhf4j");
var $48d7af1c7071e507$export$56ba0183203348f5 = function(Component, options) {
    return (0, $jhf4j.isSVGComponent)(Component) ? new (0, $3KXBC.SVGVisualElement)(options) : new (0, $lSopA.HTMLVisualElement)(options, {
        allowProjection: Component !== (0, $dQFEZ.Fragment)
    });
};

});
parcelRegister("lSopA", function(module, exports) {

$parcel$export(module.exports, "HTMLVisualElement", function () { return $db240cc0f9efa76a$export$23fea75b03ac16b3; });

var $f3Okx = parcelRequire("f3Okx");

var $grujF = parcelRequire("grujF");

var $dhMkv = parcelRequire("dhMkv");

var $j6Mzi = parcelRequire("j6Mzi");

var $6YsSd = parcelRequire("6YsSd");
var $5nvLr = parcelRequire("5nvLr");
var $e6FP6 = parcelRequire("e6FP6");

var $2947o = parcelRequire("2947o");

var $i3ue5 = parcelRequire("i3ue5");

var $bfKTA = parcelRequire("bfKTA");

var $aZcpS = parcelRequire("aZcpS");

var $367jF = parcelRequire("367jF");
function $db240cc0f9efa76a$export$3735103072e4a80(element) {
    return window.getComputedStyle(element);
}
var $db240cc0f9efa76a$export$23fea75b03ac16b3 = /*#__PURE__*/ function(DOMVisualElement) {
    "use strict";
    (0, $j6Mzi._)(HTMLVisualElement, DOMVisualElement);
    function HTMLVisualElement() {
        (0, $grujF._)(this, HTMLVisualElement);
        var _this;
        _this = (0, $f3Okx._)(this, HTMLVisualElement, arguments);
        _this.type = "html";
        _this.renderInstance = (0, $aZcpS.renderHTML);
        return _this;
    }
    (0, $dhMkv._)(HTMLVisualElement, [
        {
            key: "readValueFromInstance",
            value: function readValueFromInstance(instance, key) {
                var _this_projection;
                if ((0, $e6FP6.transformProps).has(key)) return ((_this_projection = this.projection) === null || _this_projection === void 0 ? void 0 : _this_projection.isProjecting) ? (0, $6YsSd.defaultTransformValue)(key) : (0, $6YsSd.readTransformValue)(instance, key);
                else {
                    var computedStyle = $db240cc0f9efa76a$export$3735103072e4a80(instance);
                    var value = ((0, $5nvLr.isCSSVariableName)(key) ? computedStyle.getPropertyValue(key) : computedStyle[key]) || 0;
                    return typeof value === "string" ? value.trim() : value;
                }
            }
        },
        {
            key: "measureInstanceViewportBox",
            value: function measureInstanceViewportBox(instance, param) {
                var transformPagePoint = param.transformPagePoint;
                return (0, $2947o.measureViewportBox)(instance, transformPagePoint);
            }
        },
        {
            key: "build",
            value: function build(renderState, latestValues, props) {
                (0, $bfKTA.buildHTMLStyles)(renderState, latestValues, props.transformTemplate);
            }
        },
        {
            key: "scrapeMotionValuesFromProps",
            value: function scrapeMotionValuesFromProps1(props, prevProps, visualElement) {
                return (0, $367jF.scrapeMotionValuesFromProps)(props, prevProps, visualElement);
            }
        }
    ]);
    return HTMLVisualElement;
}((0, $i3ue5.DOMVisualElement));

});
parcelRegister("6YsSd", function(module, exports) {

$parcel$export(module.exports, "defaultTransformValue", function () { return $59cb47f5dff6ffb6$export$1f10c01143b9f089; });
$parcel$export(module.exports, "parseValueFromTransform", function () { return $59cb47f5dff6ffb6$export$f9111f9e16b73a26; });
$parcel$export(module.exports, "readTransformValue", function () { return $59cb47f5dff6ffb6$export$bcd97e0e03ba17f6; });
var $59cb47f5dff6ffb6$var$radToDeg = function(rad) {
    return rad * 180 / Math.PI;
};
var $59cb47f5dff6ffb6$var$rotate = function(v) {
    var angle = $59cb47f5dff6ffb6$var$radToDeg(Math.atan2(v[1], v[0]));
    return $59cb47f5dff6ffb6$var$rebaseAngle(angle);
};
var $59cb47f5dff6ffb6$var$matrix2dParsers = {
    x: 4,
    y: 5,
    translateX: 4,
    translateY: 5,
    scaleX: 0,
    scaleY: 3,
    scale: function(v) {
        return (Math.abs(v[0]) + Math.abs(v[3])) / 2;
    },
    rotate: $59cb47f5dff6ffb6$var$rotate,
    rotateZ: $59cb47f5dff6ffb6$var$rotate,
    skewX: function(v) {
        return $59cb47f5dff6ffb6$var$radToDeg(Math.atan(v[1]));
    },
    skewY: function(v) {
        return $59cb47f5dff6ffb6$var$radToDeg(Math.atan(v[2]));
    },
    skew: function(v) {
        return (Math.abs(v[1]) + Math.abs(v[2])) / 2;
    }
};
var $59cb47f5dff6ffb6$var$rebaseAngle = function(angle) {
    angle = angle % 360;
    if (angle < 0) angle += 360;
    return angle;
};
var $59cb47f5dff6ffb6$var$rotateZ = $59cb47f5dff6ffb6$var$rotate;
var $59cb47f5dff6ffb6$var$scaleX = function(v) {
    return Math.sqrt(v[0] * v[0] + v[1] * v[1]);
};
var $59cb47f5dff6ffb6$var$scaleY = function(v) {
    return Math.sqrt(v[4] * v[4] + v[5] * v[5]);
};
var $59cb47f5dff6ffb6$var$matrix3dParsers = {
    x: 12,
    y: 13,
    z: 14,
    translateX: 12,
    translateY: 13,
    translateZ: 14,
    scaleX: $59cb47f5dff6ffb6$var$scaleX,
    scaleY: $59cb47f5dff6ffb6$var$scaleY,
    scale: function(v) {
        return ($59cb47f5dff6ffb6$var$scaleX(v) + $59cb47f5dff6ffb6$var$scaleY(v)) / 2;
    },
    rotateX: function(v) {
        return $59cb47f5dff6ffb6$var$rebaseAngle($59cb47f5dff6ffb6$var$radToDeg(Math.atan2(v[6], v[5])));
    },
    rotateY: function(v) {
        return $59cb47f5dff6ffb6$var$rebaseAngle($59cb47f5dff6ffb6$var$radToDeg(Math.atan2(-v[2], v[0])));
    },
    rotateZ: $59cb47f5dff6ffb6$var$rotateZ,
    rotate: $59cb47f5dff6ffb6$var$rotateZ,
    skewX: function(v) {
        return $59cb47f5dff6ffb6$var$radToDeg(Math.atan(v[4]));
    },
    skewY: function(v) {
        return $59cb47f5dff6ffb6$var$radToDeg(Math.atan(v[1]));
    },
    skew: function(v) {
        return (Math.abs(v[1]) + Math.abs(v[4])) / 2;
    }
};
function $59cb47f5dff6ffb6$export$1f10c01143b9f089(name) {
    return name.includes("scale") ? 1 : 0;
}
function $59cb47f5dff6ffb6$export$f9111f9e16b73a26(transform, name) {
    if (!transform || transform === "none") return $59cb47f5dff6ffb6$export$1f10c01143b9f089(name);
    var matrix3dMatch = transform.match(RegExp("^matrix3d\\(([-\\d.e\\s,]+)\\)$", "u"));
    var parsers;
    var match;
    if (matrix3dMatch) {
        parsers = $59cb47f5dff6ffb6$var$matrix3dParsers;
        match = matrix3dMatch;
    } else {
        var matrix2dMatch = transform.match(RegExp("^matrix\\(([-\\d.e\\s,]+)\\)$", "u"));
        parsers = $59cb47f5dff6ffb6$var$matrix2dParsers;
        match = matrix2dMatch;
    }
    if (!match) return $59cb47f5dff6ffb6$export$1f10c01143b9f089(name);
    var valueParser = parsers[name];
    var values = match[1].split(",").map($59cb47f5dff6ffb6$var$convertTransformToNumber);
    return typeof valueParser === "function" ? valueParser(values) : values[valueParser];
}
var $59cb47f5dff6ffb6$export$bcd97e0e03ba17f6 = function(instance, name) {
    var _getComputedStyle = getComputedStyle(instance), _getComputedStyle_transform = _getComputedStyle.transform, transform = _getComputedStyle_transform === void 0 ? "none" : _getComputedStyle_transform;
    return $59cb47f5dff6ffb6$export$f9111f9e16b73a26(transform, name);
};
function $59cb47f5dff6ffb6$var$convertTransformToNumber(value) {
    return parseFloat(value.trim());
}

});

parcelRegister("5nvLr", function(module, exports) {

$parcel$export(module.exports, "isCSSVariableName", function () { return $48f157fb8b1b69f2$export$9de1236619d9e756; });
$parcel$export(module.exports, "isCSSVariableToken", function () { return $48f157fb8b1b69f2$export$31f9caa2600b5723; });
var $48f157fb8b1b69f2$var$checkStringStartsWith = function(token) {
    return function(key) {
        return typeof key === "string" && key.startsWith(token);
    };
};
var $48f157fb8b1b69f2$export$9de1236619d9e756 = /*@__PURE__*/ $48f157fb8b1b69f2$var$checkStringStartsWith("--");
var $48f157fb8b1b69f2$var$startsAsVariableToken = /*@__PURE__*/ $48f157fb8b1b69f2$var$checkStringStartsWith("var(--");
var $48f157fb8b1b69f2$export$31f9caa2600b5723 = function(value) {
    var startsWithToken = $48f157fb8b1b69f2$var$startsAsVariableToken(value);
    if (!startsWithToken) return false;
    // Ensure any comments are stripped from the value as this can harm performance of the regex.
    return $48f157fb8b1b69f2$var$singleCssVariableRegex.test(value.split("/*")[0].trim());
};
var $48f157fb8b1b69f2$var$singleCssVariableRegex = RegExp("var\\(--(?:[\\w-]+\\s*|[\\w-]+\\s*,(?:\\s*[^)(\\s]|\\s*\\((?:[^)(]|\\([^)(]*\\))*\\))+\\s*)\\)$", "iu");

});

parcelRegister("e6FP6", function(module, exports) {

$parcel$export(module.exports, "transformPropOrder", function () { return $f8d6b09dcb8dd143$export$280dc01950909d86; });
$parcel$export(module.exports, "transformProps", function () { return $f8d6b09dcb8dd143$export$7b42a0094fb00b6e; });
/**
 * Generate a list of every possible transform key.
 */ var $f8d6b09dcb8dd143$export$280dc01950909d86 = [
    "transformPerspective",
    "x",
    "y",
    "z",
    "translateX",
    "translateY",
    "translateZ",
    "scale",
    "scaleX",
    "scaleY",
    "rotate",
    "rotateX",
    "rotateY",
    "rotateZ",
    "skew",
    "skewX",
    "skewY"
];
/**
 * A quick lookup for transform props.
 */ var $f8d6b09dcb8dd143$export$7b42a0094fb00b6e = /*@__PURE__*/ function() {
    return new Set($f8d6b09dcb8dd143$export$280dc01950909d86);
}();

});

parcelRegister("2947o", function(module, exports) {

$parcel$export(module.exports, "measureViewportBox", function () { return $f497d115c831d12d$export$d8718b6a7e5c624e; });
$parcel$export(module.exports, "measurePageBox", function () { return $f497d115c831d12d$export$6a597be7a7940a96; });

var $3QSeu = parcelRequire("3QSeu");

var $1gKyY = parcelRequire("1gKyY");
function $f497d115c831d12d$export$d8718b6a7e5c624e(instance, transformPoint) {
    return (0, $3QSeu.convertBoundingBoxToBox)((0, $3QSeu.transformBoxPoints)(instance.getBoundingClientRect(), transformPoint));
}
function $f497d115c831d12d$export$6a597be7a7940a96(element, rootProjectionNode, transformPagePoint) {
    var viewportBox = $f497d115c831d12d$export$d8718b6a7e5c624e(element, transformPagePoint);
    var scroll = rootProjectionNode.scroll;
    if (scroll) {
        (0, $1gKyY.translateAxis)(viewportBox.x, scroll.offset.x);
        (0, $1gKyY.translateAxis)(viewportBox.y, scroll.offset.y);
    }
    return viewportBox;
}

});
parcelRegister("3QSeu", function(module, exports) {

$parcel$export(module.exports, "convertBoundingBoxToBox", function () { return $1c15c7a4cd4e1645$export$d3955c6a8f65a36b; });
$parcel$export(module.exports, "convertBoxToBoundingBox", function () { return $1c15c7a4cd4e1645$export$b6b9cd4198191a47; });
$parcel$export(module.exports, "transformBoxPoints", function () { return $1c15c7a4cd4e1645$export$21543fb75483a50; });
/**
 * Bounding boxes tend to be defined as top, left, right, bottom. For various operations
 * it's easier to consider each axis individually. This function returns a bounding box
 * as a map of single-axis min/max values.
 */ function $1c15c7a4cd4e1645$export$d3955c6a8f65a36b(param) {
    var top = param.top, left = param.left, right = param.right, bottom = param.bottom;
    return {
        x: {
            min: left,
            max: right
        },
        y: {
            min: top,
            max: bottom
        }
    };
}
function $1c15c7a4cd4e1645$export$b6b9cd4198191a47(param) {
    var x = param.x, y = param.y;
    return {
        top: y.min,
        right: x.max,
        bottom: y.max,
        left: x.min
    };
}
/**
 * Applies a TransformPoint function to a bounding box. TransformPoint is usually a function
 * provided by Framer to allow measured points to be corrected for device scaling. This is used
 * when measuring DOM elements and DOM event points.
 */ function $1c15c7a4cd4e1645$export$21543fb75483a50(point, transformPoint) {
    if (!transformPoint) return point;
    var topLeft = transformPoint({
        x: point.left,
        y: point.top
    });
    var bottomRight = transformPoint({
        x: point.right,
        y: point.bottom
    });
    return {
        top: topLeft.y,
        left: topLeft.x,
        bottom: bottomRight.y,
        right: bottomRight.x
    };
}

});

parcelRegister("1gKyY", function(module, exports) {

$parcel$export(module.exports, "scalePoint", function () { return $a3660d4bbd841766$export$2290ec7febe36dd6; });
$parcel$export(module.exports, "applyBoxDelta", function () { return $a3660d4bbd841766$export$d80074982803af5c; });
$parcel$export(module.exports, "applyTreeDeltas", function () { return $a3660d4bbd841766$export$e2a980535c55eabb; });
$parcel$export(module.exports, "transformBox", function () { return $a3660d4bbd841766$export$58b16271041fbfb; });
$parcel$export(module.exports, "translateAxis", function () { return $a3660d4bbd841766$export$a807a5ce5ebb3895; });

var $83rca = parcelRequire("83rca");

var $62S2y = parcelRequire("62S2y");
/**
 * Scales a point based on a factor and an originPoint
 */ function $a3660d4bbd841766$export$2290ec7febe36dd6(point, scale, originPoint) {
    var distanceFromOrigin = point - originPoint;
    var scaled = scale * distanceFromOrigin;
    return originPoint + scaled;
}
/**
 * Applies a translate/scale delta to a point
 */ function $a3660d4bbd841766$export$4e122ddcc0c61a2e(point, translate, scale, originPoint, boxScale) {
    if (boxScale !== undefined) point = $a3660d4bbd841766$export$2290ec7febe36dd6(point, boxScale, originPoint);
    return $a3660d4bbd841766$export$2290ec7febe36dd6(point, scale, originPoint) + translate;
}
/**
 * Applies a translate/scale delta to an axis
 */ function $a3660d4bbd841766$export$e8e3a712e9ebf422(axis) {
    var translate = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0, scale = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : 1, originPoint = arguments.length > 3 ? arguments[3] : void 0, boxScale = arguments.length > 4 ? arguments[4] : void 0;
    axis.min = $a3660d4bbd841766$export$4e122ddcc0c61a2e(axis.min, translate, scale, originPoint, boxScale);
    axis.max = $a3660d4bbd841766$export$4e122ddcc0c61a2e(axis.max, translate, scale, originPoint, boxScale);
}
/**
 * Applies a translate/scale delta to a box
 */ function $a3660d4bbd841766$export$d80074982803af5c(box, param) {
    var x = param.x, y = param.y;
    $a3660d4bbd841766$export$e8e3a712e9ebf422(box.x, x.translate, x.scale, x.originPoint);
    $a3660d4bbd841766$export$e8e3a712e9ebf422(box.y, y.translate, y.scale, y.originPoint);
}
var $a3660d4bbd841766$var$TREE_SCALE_SNAP_MIN = 0.999999999999;
var $a3660d4bbd841766$var$TREE_SCALE_SNAP_MAX = 1.0000000000001;
/**
 * Apply a tree of deltas to a box. We do this to calculate the effect of all the transforms
 * in a tree upon our box before then calculating how to project it into our desired viewport-relative box
 *
 * This is the final nested loop within updateLayoutDelta for future refactoring
 */ function $a3660d4bbd841766$export$e2a980535c55eabb(box, treeScale, treePath) {
    var isSharedTransition = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : false;
    var treeLength = treePath.length;
    if (!treeLength) return;
    // Reset the treeScale
    treeScale.x = treeScale.y = 1;
    var node;
    var delta;
    for(var i = 0; i < treeLength; i++){
        node = treePath[i];
        delta = node.projectionDelta;
        /**
         * TODO: Prefer to remove this, but currently we have motion components with
         * display: contents in Framer.
         */ var visualElement = node.options.visualElement;
        if (visualElement && visualElement.props.style && visualElement.props.style.display === "contents") continue;
        if (isSharedTransition && node.options.layoutScroll && node.scroll && node !== node.root) $a3660d4bbd841766$export$58b16271041fbfb(box, {
            x: -node.scroll.offset.x,
            y: -node.scroll.offset.y
        });
        if (delta) {
            // Incoporate each ancestor's scale into a culmulative treeScale for this component
            treeScale.x *= delta.x.scale;
            treeScale.y *= delta.y.scale;
            // Apply each ancestor's calculated delta into this component's recorded layout box
            $a3660d4bbd841766$export$d80074982803af5c(box, delta);
        }
        if (isSharedTransition && (0, $62S2y.hasTransform)(node.latestValues)) $a3660d4bbd841766$export$58b16271041fbfb(box, node.latestValues);
    }
    /**
     * Snap tree scale back to 1 if it's within a non-perceivable threshold.
     * This will help reduce useless scales getting rendered.
     */ if (treeScale.x < $a3660d4bbd841766$var$TREE_SCALE_SNAP_MAX && treeScale.x > $a3660d4bbd841766$var$TREE_SCALE_SNAP_MIN) treeScale.x = 1.0;
    if (treeScale.y < $a3660d4bbd841766$var$TREE_SCALE_SNAP_MAX && treeScale.y > $a3660d4bbd841766$var$TREE_SCALE_SNAP_MIN) treeScale.y = 1.0;
}
function $a3660d4bbd841766$export$a807a5ce5ebb3895(axis, distance) {
    axis.min = axis.min + distance;
    axis.max = axis.max + distance;
}
/**
 * Apply a transform to an axis from the latest resolved motion values.
 * This function basically acts as a bridge between a flat motion value map
 * and applyAxisDelta
 */ function $a3660d4bbd841766$export$625f1dd140a2f5e7(axis, axisTranslate, axisScale, boxScale) {
    var axisOrigin = arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : 0.5;
    var originPoint = (0, $83rca.mixNumber)(axis.min, axis.max, axisOrigin);
    // Apply the axis delta to the final axis
    $a3660d4bbd841766$export$e8e3a712e9ebf422(axis, axisTranslate, axisScale, originPoint, boxScale);
}
/**
 * Apply a transform to a box from the latest resolved motion values.
 */ function $a3660d4bbd841766$export$58b16271041fbfb(box, transform) {
    $a3660d4bbd841766$export$625f1dd140a2f5e7(box.x, transform.x, transform.scaleX, transform.scale, transform.originX);
    $a3660d4bbd841766$export$625f1dd140a2f5e7(box.y, transform.y, transform.scaleY, transform.scale, transform.originY);
}

});
parcelRegister("83rca", function(module, exports) {

$parcel$export(module.exports, "mixNumber", function () { return $d9cd979762fee96e$export$3bb0b4ff1037b8dd; });
/*
  Value in range from progress

  Given a lower limit and an upper limit, we return the value within
  that range as expressed by progress (usually a number from 0 to 1)

  So progress = 0.5 would change

  from -------- to

  to

  from ---- to

  E.g. from = 10, to = 20, progress = 0.5 => 15

  @param [number]: Lower limit of range
  @param [number]: Upper limit of range
  @param [number]: The progress between lower and upper limits expressed 0-1
  @return [number]: Value as calculated from progress within range (not limited within range)
*/ var $d9cd979762fee96e$export$3bb0b4ff1037b8dd = function(from, to, progress) {
    return from + (to - from) * progress;
};

});

parcelRegister("62S2y", function(module, exports) {

$parcel$export(module.exports, "hasScale", function () { return $9b4f6a65c1609be2$export$bdf30dca883ea463; });
$parcel$export(module.exports, "hasTransform", function () { return $9b4f6a65c1609be2$export$a545127cf1fbb600; });
$parcel$export(module.exports, "has2DTranslate", function () { return $9b4f6a65c1609be2$export$bf80f5f8f4dc327f; });
function $9b4f6a65c1609be2$var$isIdentityScale(scale) {
    return scale === undefined || scale === 1;
}
function $9b4f6a65c1609be2$export$bdf30dca883ea463(param) {
    var scale = param.scale, scaleX = param.scaleX, scaleY = param.scaleY;
    return !$9b4f6a65c1609be2$var$isIdentityScale(scale) || !$9b4f6a65c1609be2$var$isIdentityScale(scaleX) || !$9b4f6a65c1609be2$var$isIdentityScale(scaleY);
}
function $9b4f6a65c1609be2$export$a545127cf1fbb600(values) {
    return $9b4f6a65c1609be2$export$bdf30dca883ea463(values) || $9b4f6a65c1609be2$export$bf80f5f8f4dc327f(values) || values.z || values.rotate || values.rotateX || values.rotateY || values.skewX || values.skewY;
}
function $9b4f6a65c1609be2$export$bf80f5f8f4dc327f(values) {
    return $9b4f6a65c1609be2$var$is2DTranslate(values.x) || $9b4f6a65c1609be2$var$is2DTranslate(values.y);
}
function $9b4f6a65c1609be2$var$is2DTranslate(value) {
    return value && value !== "0%";
}

});



parcelRegister("i3ue5", function(module, exports) {

$parcel$export(module.exports, "DOMVisualElement", function () { return $65587fadb6626131$export$e49735c2a366bdc7; });

var $f3Okx = parcelRequire("f3Okx");

var $grujF = parcelRequire("grujF");

var $dhMkv = parcelRequire("dhMkv");

var $j6Mzi = parcelRequire("j6Mzi");

var $3hsFr = parcelRequire("3hsFr");
var $4drXU = parcelRequire("4drXU");

var $fMD7u = parcelRequire("fMD7u");
var $65587fadb6626131$export$e49735c2a366bdc7 = /*#__PURE__*/ function(VisualElement) {
    "use strict";
    (0, $j6Mzi._)(DOMVisualElement, VisualElement);
    function DOMVisualElement() {
        (0, $grujF._)(this, DOMVisualElement);
        var _this;
        _this = (0, $f3Okx._)(this, DOMVisualElement, arguments);
        _this.KeyframeResolver = (0, $3hsFr.DOMKeyframesResolver);
        return _this;
    }
    (0, $dhMkv._)(DOMVisualElement, [
        {
            key: "sortInstanceNodePosition",
            value: function sortInstanceNodePosition(a, b) {
                /**
         * compareDocumentPosition returns a bitmask, by using the bitwise &
         * we're returning true if 2 in that bitmask is set to true. 2 is set
         * to true if b preceeds a.
         */ return a.compareDocumentPosition(b) & 2 ? 1 : -1;
            }
        },
        {
            key: "getBaseTargetFromProps",
            value: function getBaseTargetFromProps(props, key) {
                return props.style ? props.style[key] : undefined;
            }
        },
        {
            key: "removeValueFromRenderState",
            value: function removeValueFromRenderState(key, param) {
                var vars = param.vars, style = param.style;
                delete vars[key];
                delete style[key];
            }
        },
        {
            key: "handleChildMotionValue",
            value: function handleChildMotionValue() {
                var _this = this;
                if (this.childSubscription) {
                    this.childSubscription();
                    delete this.childSubscription;
                }
                var children = this.props.children;
                if ((0, $4drXU.isMotionValue)(children)) this.childSubscription = children.on("change", function(latest) {
                    if (_this.current) _this.current.textContent = "".concat(latest);
                });
            }
        }
    ]);
    return DOMVisualElement;
}((0, $fMD7u.VisualElement));

});
parcelRegister("3hsFr", function(module, exports) {

$parcel$export(module.exports, "DOMKeyframesResolver", function () { return $351810b69befc016$export$4983792d11b61017; });

var $f3Okx = parcelRequire("f3Okx");

var $grujF = parcelRequire("grujF");

var $dhMkv = parcelRequire("dhMkv");

var $bxomo = parcelRequire("bxomo");

var $gyGuQ = parcelRequire("gyGuQ");

var $j6Mzi = parcelRequire("j6Mzi");

var $2nwvT = parcelRequire("2nwvT");

var $enWtX = parcelRequire("enWtX");

var $7CP94 = parcelRequire("7CP94");

var $eINrM = parcelRequire("eINrM");

var $5nvLr = parcelRequire("5nvLr");

var $lCMx1 = parcelRequire("lCMx1");

var $avMJM = parcelRequire("avMJM");

var $3UpzJ = parcelRequire("3UpzJ");

var $brg6R = parcelRequire("brg6R");
var $351810b69befc016$export$4983792d11b61017 = /*#__PURE__*/ function(KeyframeResolver) {
    "use strict";
    (0, $j6Mzi._)(DOMKeyframesResolver, KeyframeResolver);
    function DOMKeyframesResolver(unresolvedKeyframes, onComplete, name, motionValue, element) {
        (0, $grujF._)(this, DOMKeyframesResolver);
        return (0, $f3Okx._)(this, DOMKeyframesResolver, [
            unresolvedKeyframes,
            onComplete,
            name,
            motionValue,
            element,
            true
        ]);
    }
    (0, $dhMkv._)(DOMKeyframesResolver, [
        {
            key: "readKeyframes",
            value: function readKeyframes() {
                var _this = this, unresolvedKeyframes = _this.unresolvedKeyframes, element = _this.element, name = _this.name;
                if (!element || !element.current) return;
                (0, $bxomo._)((0, $gyGuQ._)(DOMKeyframesResolver.prototype), "readKeyframes", this).call(this);
                /**
         * If any keyframe is a CSS variable, we need to find its value by sampling the element
         */ for(var i = 0; i < unresolvedKeyframes.length; i++){
                    var keyframe = unresolvedKeyframes[i];
                    if (typeof keyframe === "string") {
                        keyframe = keyframe.trim();
                        if ((0, $5nvLr.isCSSVariableToken)(keyframe)) {
                            var resolved = (0, $eINrM.getVariableValue)(keyframe, element.current);
                            if (resolved !== undefined) unresolvedKeyframes[i] = resolved;
                            if (i === unresolvedKeyframes.length - 1) this.finalKeyframe = keyframe;
                        }
                    }
                }
                /**
         * Resolve "none" values. We do this potentially twice - once before and once after measuring keyframes.
         * This could be seen as inefficient but it's a trade-off to avoid measurements in more situations, which
         * have a far bigger performance impact.
         */ this.resolveNoneKeyframes();
                /**
         * Check to see if unit type has changed. If so schedule jobs that will
         * temporarily set styles to the destination keyframes.
         * Skip if we have more than two keyframes or this isn't a positional value.
         * TODO: We can throw if there are multiple keyframes and the value type changes.
         */ if (!(0, $enWtX.positionalKeys).has(name) || unresolvedKeyframes.length !== 2) return;
                var _unresolvedKeyframes = (0, $2nwvT._)(unresolvedKeyframes, 2), origin = _unresolvedKeyframes[0], target = _unresolvedKeyframes[1];
                var originType = (0, $7CP94.findDimensionValueType)(origin);
                var targetType = (0, $7CP94.findDimensionValueType)(target);
                /**
         * Either we don't recognise these value types or we can animate between them.
         */ if (originType === targetType) return;
                /**
         * If both values are numbers or pixels, we can animate between them by
         * converting them to numbers.
         */ if ((0, $brg6R.isNumOrPxType)(originType) && (0, $brg6R.isNumOrPxType)(targetType)) for(var i1 = 0; i1 < unresolvedKeyframes.length; i1++){
                    var value = unresolvedKeyframes[i1];
                    if (typeof value === "string") unresolvedKeyframes[i1] = parseFloat(value);
                }
                else if ((0, $brg6R.positionalValues)[name]) /**
             * Else, the only way to resolve this is by measuring the element.
             */ this.needsMeasurement = true;
            }
        },
        {
            key: "resolveNoneKeyframes",
            value: function resolveNoneKeyframes() {
                var _this = this, unresolvedKeyframes = _this.unresolvedKeyframes, name = _this.name;
                var noneKeyframeIndexes = [];
                for(var i = 0; i < unresolvedKeyframes.length; i++)if (unresolvedKeyframes[i] === null || (0, $avMJM.isNone)(unresolvedKeyframes[i])) noneKeyframeIndexes.push(i);
                if (noneKeyframeIndexes.length) (0, $3UpzJ.makeNoneKeyframesAnimatable)(unresolvedKeyframes, noneKeyframeIndexes, name);
            }
        },
        {
            key: "measureInitialState",
            value: function measureInitialState() {
                var _this = this, element = _this.element, unresolvedKeyframes = _this.unresolvedKeyframes, name = _this.name;
                if (!element || !element.current) return;
                if (name === "height") this.suspendedScrollY = window.pageYOffset;
                this.measuredOrigin = (0, $brg6R.positionalValues)[name](element.measureViewportBox(), window.getComputedStyle(element.current));
                unresolvedKeyframes[0] = this.measuredOrigin;
                // Set final key frame to measure after next render
                var measureKeyframe = unresolvedKeyframes[unresolvedKeyframes.length - 1];
                if (measureKeyframe !== undefined) element.getValue(name, measureKeyframe).jump(measureKeyframe, false);
            }
        },
        {
            key: "measureEndState",
            value: function measureEndState() {
                var _this_removedTransforms;
                var _this = this, element = _this.element, name = _this.name, unresolvedKeyframes = _this.unresolvedKeyframes;
                if (!element || !element.current) return;
                var value = element.getValue(name);
                value && value.jump(this.measuredOrigin, false);
                var finalKeyframeIndex = unresolvedKeyframes.length - 1;
                var finalKeyframe = unresolvedKeyframes[finalKeyframeIndex];
                unresolvedKeyframes[finalKeyframeIndex] = (0, $brg6R.positionalValues)[name](element.measureViewportBox(), window.getComputedStyle(element.current));
                if (finalKeyframe !== null && this.finalKeyframe === undefined) this.finalKeyframe = finalKeyframe;
                // If we removed transform values, reapply them before the next render
                if ((_this_removedTransforms = this.removedTransforms) === null || _this_removedTransforms === void 0 ? void 0 : _this_removedTransforms.length) this.removedTransforms.forEach(function(param) {
                    var _param = (0, $2nwvT._)(param, 2), unsetTransformName = _param[0], unsetTransformValue = _param[1];
                    element.getValue(unsetTransformName).set(unsetTransformValue);
                });
                this.resolveNoneKeyframes();
            }
        }
    ]);
    return DOMKeyframesResolver;
}((0, $lCMx1.KeyframeResolver));

});
parcelRegister("bxomo", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $8665ac34acf389ad$export$71511d61b312f219; });

var $hTHbr = parcelRequire("hTHbr");
function $8665ac34acf389ad$export$71511d61b312f219(target, property, receiver) {
    if (typeof Reflect !== "undefined" && Reflect.get) $8665ac34acf389ad$export$71511d61b312f219 = Reflect.get;
    else $8665ac34acf389ad$export$71511d61b312f219 = function get(target, property, receiver) {
        var base = (0, $hTHbr._)(target, property);
        if (!base) return;
        var desc = Object.getOwnPropertyDescriptor(base, property);
        if (desc.get) return desc.get.call(receiver || target);
        return desc.value;
    };
    return $8665ac34acf389ad$export$71511d61b312f219(target, property, receiver || target);
}

});
parcelRegister("hTHbr", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $d079121360b168c5$export$71511d61b312f219; });

var $gyGuQ = parcelRequire("gyGuQ");
function $d079121360b168c5$export$71511d61b312f219(object, property) {
    while(!Object.prototype.hasOwnProperty.call(object, property)){
        object = (0, $gyGuQ._)(object);
        if (object === null) break;
    }
    return object;
}

});


parcelRegister("enWtX", function(module, exports) {

$parcel$export(module.exports, "positionalKeys", function () { return $a955cbb9de6ea15d$export$c66c0d5db2a205d; });

var $2us1u = parcelRequire("2us1u");

var $e6FP6 = parcelRequire("e6FP6");
var $a955cbb9de6ea15d$export$c66c0d5db2a205d = new Set([
    "width",
    "height",
    "top",
    "left",
    "right",
    "bottom"
].concat((0, $2us1u._)((0, $e6FP6.transformPropOrder))));

});

parcelRegister("7CP94", function(module, exports) {

$parcel$export(module.exports, "dimensionValueTypes", function () { return $4760230f7f08e2a1$export$d176691c1998a1f5; });
$parcel$export(module.exports, "findDimensionValueType", function () { return $4760230f7f08e2a1$export$eefdd52e3ccae428; });

var $6qUks = parcelRequire("6qUks");

var $2KoB8 = parcelRequire("2KoB8");

var $aUTIu = parcelRequire("aUTIu");

var $7HiS5 = parcelRequire("7HiS5");
/**
 * A list of value types commonly used for dimensions
 */ var $4760230f7f08e2a1$export$d176691c1998a1f5 = [
    (0, $2KoB8.number),
    (0, $aUTIu.px),
    (0, $aUTIu.percent),
    (0, $aUTIu.degrees),
    (0, $aUTIu.vw),
    (0, $aUTIu.vh),
    (0, $6qUks.auto)
];
/**
 * Tests a dimensional value against the list of dimension ValueTypes
 */ var $4760230f7f08e2a1$export$eefdd52e3ccae428 = function(v) {
    return $4760230f7f08e2a1$export$d176691c1998a1f5.find((0, $7HiS5.testValueType)(v));
};

});
parcelRegister("6qUks", function(module, exports) {

$parcel$export(module.exports, "auto", function () { return $fab0f60a7d164ef5$export$dfb5619354ba860; });
/**
 * ValueType for "auto"
 */ var $fab0f60a7d164ef5$export$dfb5619354ba860 = {
    test: function(v) {
        return v === "auto";
    },
    parse: function(v) {
        return v;
    }
};

});

parcelRegister("2KoB8", function(module, exports) {

$parcel$export(module.exports, "number", function () { return $a850566c6371ad57$export$98e628dec113755e; });
$parcel$export(module.exports, "alpha", function () { return $a850566c6371ad57$export$58f0f39f63f3cf42; });
$parcel$export(module.exports, "scale", function () { return $a850566c6371ad57$export$dcdf75081b88279d; });

var $joFW3 = parcelRequire("joFW3");

var $90FDw = parcelRequire("90FDw");

var $3BJvs = parcelRequire("3BJvs");
var $a850566c6371ad57$export$98e628dec113755e = {
    test: function(v) {
        return typeof v === "number";
    },
    parse: parseFloat,
    transform: function(v) {
        return v;
    }
};
var $a850566c6371ad57$export$58f0f39f63f3cf42 = (0, $90FDw._)((0, $joFW3._)({}, $a850566c6371ad57$export$98e628dec113755e), {
    transform: function(v) {
        return (0, $3BJvs.clamp)(0, 1, v);
    }
});
var $a850566c6371ad57$export$dcdf75081b88279d = (0, $90FDw._)((0, $joFW3._)({}, $a850566c6371ad57$export$98e628dec113755e), {
    default: 1
});

});
parcelRegister("joFW3", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $e1f0c9b9d3f0410c$export$71511d61b312f219; });

var $72osQ = parcelRequire("72osQ");
function $e1f0c9b9d3f0410c$export$71511d61b312f219(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
            return Object.getOwnPropertyDescriptor(source, sym).enumerable;
        }));
        ownKeys.forEach(function(key) {
            (0, $72osQ._)(target, key, source[key]);
        });
    }
    return target;
}

});

parcelRegister("90FDw", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $68f469483b2832ee$export$71511d61b312f219; });
function $68f469483b2832ee$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        });
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function $68f469483b2832ee$export$71511d61b312f219(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    else $68f469483b2832ee$var$ownKeys(Object(source)).forEach(function(key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
    return target;
}

});

parcelRegister("3BJvs", function(module, exports) {

$parcel$export(module.exports, "clamp", function () { return $bb72dd0d2250682e$export$7d15b64cf5a3a4c4; });
var $bb72dd0d2250682e$export$7d15b64cf5a3a4c4 = function(min, max, v) {
    if (v > max) return max;
    if (v < min) return min;
    return v;
};

});


parcelRegister("aUTIu", function(module, exports) {

$parcel$export(module.exports, "degrees", function () { return $3def5ef4397e7f54$export$41fc368e1a942b97; });
$parcel$export(module.exports, "percent", function () { return $3def5ef4397e7f54$export$626336c2cd4b14de; });
$parcel$export(module.exports, "px", function () { return $3def5ef4397e7f54$export$91c0eda1d06bf008; });
$parcel$export(module.exports, "vh", function () { return $3def5ef4397e7f54$export$f91e8c45a95a32f2; });
$parcel$export(module.exports, "vw", function () { return $3def5ef4397e7f54$export$aed3d7b7d206c196; });
$parcel$export(module.exports, "progressPercentage", function () { return $3def5ef4397e7f54$export$44e2e1705876d7ed; });
/*#__NO_SIDE_EFFECTS__*/ 
var $joFW3 = parcelRequire("joFW3");

var $90FDw = parcelRequire("90FDw");
var $3def5ef4397e7f54$var$createUnitType = function(unit) {
    return {
        test: function(v) {
            return typeof v === "string" && v.endsWith(unit) && v.split(" ").length === 1;
        },
        parse: parseFloat,
        transform: function(v) {
            return "".concat(v).concat(unit);
        }
    };
};
var $3def5ef4397e7f54$export$41fc368e1a942b97 = /*@__PURE__*/ $3def5ef4397e7f54$var$createUnitType("deg");
var $3def5ef4397e7f54$export$626336c2cd4b14de = /*@__PURE__*/ $3def5ef4397e7f54$var$createUnitType("%");
var $3def5ef4397e7f54$export$91c0eda1d06bf008 = /*@__PURE__*/ $3def5ef4397e7f54$var$createUnitType("px");
var $3def5ef4397e7f54$export$f91e8c45a95a32f2 = /*@__PURE__*/ $3def5ef4397e7f54$var$createUnitType("vh");
var $3def5ef4397e7f54$export$aed3d7b7d206c196 = /*@__PURE__*/ $3def5ef4397e7f54$var$createUnitType("vw");
var $3def5ef4397e7f54$export$44e2e1705876d7ed = /*@__PURE__*/ function() {
    return (0, $90FDw._)((0, $joFW3._)({}, $3def5ef4397e7f54$export$626336c2cd4b14de), {
        parse: function(v) {
            return $3def5ef4397e7f54$export$626336c2cd4b14de.parse(v) / 100;
        },
        transform: function(v) {
            return $3def5ef4397e7f54$export$626336c2cd4b14de.transform(v * 100);
        }
    });
}();

});

parcelRegister("7HiS5", function(module, exports) {

$parcel$export(module.exports, "testValueType", function () { return $8b1e2962cdb901f5$export$6eae4d0a6a7ca7cd; });
/**
 * Tests a provided value against a ValueType
 */ var $8b1e2962cdb901f5$export$6eae4d0a6a7ca7cd = function(v) {
    return function(type) {
        return type.test(v);
    };
};

});


parcelRegister("eINrM", function(module, exports) {

$parcel$export(module.exports, "getVariableValue", function () { return $274bbf72a9d41c95$export$289398774300c991; });

var $2nwvT = parcelRequire("2nwvT");

var $FCK0G = parcelRequire("FCK0G");
var $9WSNG = parcelRequire("9WSNG");

var $5nvLr = parcelRequire("5nvLr");
/**
 * Parse Framer's special CSS variable format into a CSS token and a fallback.
 *
 * ```
 * `var(--foo, #fff)` => [`--foo`, '#fff']
 * ```
 *
 * @param current
 */ var $274bbf72a9d41c95$var$splitCSSVariableRegex = // eslint-disable-next-line redos-detector/no-unsafe-regex -- false positive, as it can match a lot of words
RegExp("^var\\(--(?:([\\w-]+)|([\\w-]+), ?([a-zA-Z\\d ()%#.,-]+))\\)", "u");
function $274bbf72a9d41c95$export$b9f0c1f373aee2b0(current) {
    var match = $274bbf72a9d41c95$var$splitCSSVariableRegex.exec(current);
    if (!match) return [
        , 
    ];
    var _match = (0, $2nwvT._)(match, 4), token1 = _match[1], token2 = _match[2], fallback = _match[3];
    return [
        "--".concat(token1 !== null && token1 !== void 0 ? token1 : token2),
        fallback
    ];
}
var $274bbf72a9d41c95$var$maxDepth = 4;
function $274bbf72a9d41c95$export$289398774300c991(current, element) {
    var depth = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : 1;
    (0, $FCK0G.invariant)(depth <= $274bbf72a9d41c95$var$maxDepth, 'Max CSS variable fallback depth detected in property "'.concat(current, '". This may indicate a circular fallback dependency.'), "max-css-var-depth");
    var _parseCSSVariable = (0, $2nwvT._)($274bbf72a9d41c95$export$b9f0c1f373aee2b0(current), 2), token = _parseCSSVariable[0], fallback = _parseCSSVariable[1];
    // No CSS variable detected
    if (!token) return;
    // Attempt to read this CSS variable off the element
    var resolved = window.getComputedStyle(element).getPropertyValue(token);
    if (resolved) {
        var trimmed = resolved.trim();
        return (0, $9WSNG.isNumericalString)(trimmed) ? parseFloat(trimmed) : trimmed;
    }
    return (0, $5nvLr.isCSSVariableToken)(fallback) ? $274bbf72a9d41c95$export$289398774300c991(fallback, element, depth + 1) : fallback;
}

});
parcelRegister("FCK0G", function(module, exports) {

$parcel$export(module.exports, "warning", function () { return $1430d78121ac4c7d$export$491112666e282270; });
$parcel$export(module.exports, "invariant", function () { return $1430d78121ac4c7d$export$f5708dca728d7177; });

var $1430d78121ac4c7d$export$491112666e282270 = function() {};
var $1430d78121ac4c7d$export$f5708dca728d7177 = function() {};
var $1430d78121ac4c7d$var$check, $1430d78121ac4c7d$var$message, $1430d78121ac4c7d$var$errorCode, $1430d78121ac4c7d$var$check1, $1430d78121ac4c7d$var$message1, $1430d78121ac4c7d$var$errorCode1;

});

parcelRegister("9WSNG", function(module, exports) {

$parcel$export(module.exports, "isNumericalString", function () { return $72a381c523d85d67$export$65583ed5a868f2d9; });
/**
 * Check if value is a numerical string, ie a string that is purely a number eg "100" or "-100.1"
 */ var $72a381c523d85d67$export$65583ed5a868f2d9 = function(v) {
    return RegExp("^-?(?:\\d+(?:\\.\\d+)?|\\.\\d+)$", "u").test(v);
};

});


parcelRegister("lCMx1", function(module, exports) {

$parcel$export(module.exports, "flushKeyframeResolvers", function () { return $125785281a53f53d$export$78b96d2a12593b05; });
$parcel$export(module.exports, "KeyframeResolver", function () { return $125785281a53f53d$export$74d34ca3182f1750; });

var $grujF = parcelRequire("grujF");

var $dhMkv = parcelRequire("dhMkv");

var $2nwvT = parcelRequire("2nwvT");

var $2us1u = parcelRequire("2us1u");

var $bDdn0 = parcelRequire("bDdn0");

var $brg6R = parcelRequire("brg6R");

var $8oVcc = parcelRequire("8oVcc");
var $125785281a53f53d$var$toResolve = new Set();
var $125785281a53f53d$var$isScheduled = false;
var $125785281a53f53d$var$anyNeedsMeasurement = false;
var $125785281a53f53d$var$isForced = false;
function $125785281a53f53d$var$measureAllKeyframes() {
    if ($125785281a53f53d$var$anyNeedsMeasurement) {
        var resolversToMeasure = Array.from($125785281a53f53d$var$toResolve).filter(function(resolver) {
            return resolver.needsMeasurement;
        });
        var elementsToMeasure = new Set(resolversToMeasure.map(function(resolver) {
            return resolver.element;
        }));
        var transformsToRestore = new Map();
        /**
         * Write pass
         * If we're measuring elements we want to remove bounding box-changing transforms.
         */ elementsToMeasure.forEach(function(element) {
            var removedTransforms = (0, $brg6R.removeNonTranslationalTransform)(element);
            if (!removedTransforms.length) return;
            transformsToRestore.set(element, removedTransforms);
            element.render();
        });
        // Read
        resolversToMeasure.forEach(function(resolver) {
            return resolver.measureInitialState();
        });
        // Write
        elementsToMeasure.forEach(function(element) {
            element.render();
            var restore = transformsToRestore.get(element);
            if (restore) restore.forEach(function(param) {
                var _param = (0, $2nwvT._)(param, 2), key = _param[0], value = _param[1];
                var _element_getValue;
                (_element_getValue = element.getValue(key)) === null || _element_getValue === void 0 ? void 0 : _element_getValue.set(value);
            });
        });
        // Read
        resolversToMeasure.forEach(function(resolver) {
            return resolver.measureEndState();
        });
        // Write
        resolversToMeasure.forEach(function(resolver) {
            if (resolver.suspendedScrollY !== undefined) window.scrollTo(0, resolver.suspendedScrollY);
        });
    }
    $125785281a53f53d$var$anyNeedsMeasurement = false;
    $125785281a53f53d$var$isScheduled = false;
    $125785281a53f53d$var$toResolve.forEach(function(resolver) {
        return resolver.complete($125785281a53f53d$var$isForced);
    });
    $125785281a53f53d$var$toResolve.clear();
}
function $125785281a53f53d$var$readAllKeyframes() {
    $125785281a53f53d$var$toResolve.forEach(function(resolver) {
        resolver.readKeyframes();
        if (resolver.needsMeasurement) $125785281a53f53d$var$anyNeedsMeasurement = true;
    });
}
function $125785281a53f53d$export$78b96d2a12593b05() {
    $125785281a53f53d$var$isForced = true;
    $125785281a53f53d$var$readAllKeyframes();
    $125785281a53f53d$var$measureAllKeyframes();
    $125785281a53f53d$var$isForced = false;
}
var $125785281a53f53d$export$74d34ca3182f1750 = /*#__PURE__*/ function() {
    "use strict";
    function KeyframeResolver(unresolvedKeyframes, onComplete, name, motionValue, element) {
        var isAsync = arguments.length > 5 && arguments[5] !== void 0 ? arguments[5] : false;
        (0, $grujF._)(this, KeyframeResolver);
        this.state = "pending";
        /**
         * Track whether this resolver is async. If it is, it'll be added to the
         * resolver queue and flushed in the next frame. Resolvers that aren't going
         * to trigger read/write thrashing don't need to be async.
         */ this.isAsync = false;
        /**
         * Track whether this resolver needs to perform a measurement
         * to resolve its keyframes.
         */ this.needsMeasurement = false;
        this.unresolvedKeyframes = (0, $2us1u._)(unresolvedKeyframes);
        this.onComplete = onComplete;
        this.name = name;
        this.motionValue = motionValue;
        this.element = element;
        this.isAsync = isAsync;
    }
    (0, $dhMkv._)(KeyframeResolver, [
        {
            key: "scheduleResolve",
            value: function scheduleResolve() {
                this.state = "scheduled";
                if (this.isAsync) {
                    $125785281a53f53d$var$toResolve.add(this);
                    if (!$125785281a53f53d$var$isScheduled) {
                        $125785281a53f53d$var$isScheduled = true;
                        (0, $8oVcc.frame).read($125785281a53f53d$var$readAllKeyframes);
                        (0, $8oVcc.frame).resolveKeyframes($125785281a53f53d$var$measureAllKeyframes);
                    }
                } else {
                    this.readKeyframes();
                    this.complete();
                }
            }
        },
        {
            key: "readKeyframes",
            value: function readKeyframes() {
                var _this = this, unresolvedKeyframes = _this.unresolvedKeyframes, name = _this.name, element = _this.element, motionValue = _this.motionValue;
                // If initial keyframe is null we need to read it from the DOM
                if (unresolvedKeyframes[0] === null) {
                    var currentValue = motionValue === null || motionValue === void 0 ? void 0 : motionValue.get();
                    // TODO: This doesn't work if the final keyframe is a wildcard
                    var finalKeyframe = unresolvedKeyframes[unresolvedKeyframes.length - 1];
                    if (currentValue !== undefined) unresolvedKeyframes[0] = currentValue;
                    else if (element && name) {
                        var valueAsRead = element.readValue(name, finalKeyframe);
                        if (valueAsRead !== undefined && valueAsRead !== null) unresolvedKeyframes[0] = valueAsRead;
                    }
                    if (unresolvedKeyframes[0] === undefined) unresolvedKeyframes[0] = finalKeyframe;
                    if (motionValue && currentValue === undefined) motionValue.set(unresolvedKeyframes[0]);
                }
                (0, $bDdn0.fillWildcards)(unresolvedKeyframes);
            }
        },
        {
            key: "setFinalKeyframe",
            value: function setFinalKeyframe() {}
        },
        {
            key: "measureInitialState",
            value: function measureInitialState() {}
        },
        {
            key: "renderEndStyles",
            value: function renderEndStyles() {}
        },
        {
            key: "measureEndState",
            value: function measureEndState() {}
        },
        {
            key: "complete",
            value: function complete() {
                var isForcedComplete = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : false;
                this.state = "complete";
                this.onComplete(this.unresolvedKeyframes, this.finalKeyframe, isForcedComplete);
                $125785281a53f53d$var$toResolve.delete(this);
            }
        },
        {
            key: "cancel",
            value: function cancel() {
                if (this.state === "scheduled") {
                    $125785281a53f53d$var$toResolve.delete(this);
                    this.state = "pending";
                }
            }
        },
        {
            key: "resume",
            value: function resume() {
                if (this.state === "pending") this.scheduleResolve();
            }
        }
    ]);
    return KeyframeResolver;
}();

});
parcelRegister("bDdn0", function(module, exports) {

$parcel$export(module.exports, "fillWildcards", function () { return $df3691806523a8b7$export$5a98a90409277f5a; });
function $df3691806523a8b7$export$5a98a90409277f5a(keyframes) {
    var _keyframes_i;
    for(var i = 1; i < keyframes.length; i++)(_keyframes_i = keyframes[i]) !== null && _keyframes_i !== void 0 ? _keyframes_i : keyframes[i] = keyframes[i - 1];
}

});

parcelRegister("brg6R", function(module, exports) {

$parcel$export(module.exports, "isNumOrPxType", function () { return $33b2a3bfe312c7cc$export$8e5250d1aa9bf370; });
$parcel$export(module.exports, "removeNonTranslationalTransform", function () { return $33b2a3bfe312c7cc$export$39d4bc9655f3f632; });
$parcel$export(module.exports, "positionalValues", function () { return $33b2a3bfe312c7cc$export$781d46a8aa670d52; });

var $6YsSd = parcelRequire("6YsSd");

var $e6FP6 = parcelRequire("e6FP6");

var $2KoB8 = parcelRequire("2KoB8");

var $aUTIu = parcelRequire("aUTIu");
var $33b2a3bfe312c7cc$export$8e5250d1aa9bf370 = function(v) {
    return v === (0, $2KoB8.number) || v === (0, $aUTIu.px);
};
var $33b2a3bfe312c7cc$var$transformKeys = new Set([
    "x",
    "y",
    "z"
]);
var $33b2a3bfe312c7cc$var$nonTranslationalTransformKeys = (0, $e6FP6.transformPropOrder).filter(function(key) {
    return !$33b2a3bfe312c7cc$var$transformKeys.has(key);
});
function $33b2a3bfe312c7cc$export$39d4bc9655f3f632(visualElement) {
    var removedTransforms = [];
    $33b2a3bfe312c7cc$var$nonTranslationalTransformKeys.forEach(function(key) {
        var value = visualElement.getValue(key);
        if (value !== undefined) {
            removedTransforms.push([
                key,
                value.get()
            ]);
            value.set(key.startsWith("scale") ? 1 : 0);
        }
    });
    return removedTransforms;
}
var $33b2a3bfe312c7cc$export$781d46a8aa670d52 = {
    // Dimensions
    width: function(param, param1) {
        var x = param.x, _param_paddingLeft = param1.paddingLeft, paddingLeft = _param_paddingLeft === void 0 ? "0" : _param_paddingLeft, _param_paddingRight = param1.paddingRight, paddingRight = _param_paddingRight === void 0 ? "0" : _param_paddingRight;
        return x.max - x.min - parseFloat(paddingLeft) - parseFloat(paddingRight);
    },
    height: function(param, param1) {
        var y = param.y, _param_paddingTop = param1.paddingTop, paddingTop = _param_paddingTop === void 0 ? "0" : _param_paddingTop, _param_paddingBottom = param1.paddingBottom, paddingBottom = _param_paddingBottom === void 0 ? "0" : _param_paddingBottom;
        return y.max - y.min - parseFloat(paddingTop) - parseFloat(paddingBottom);
    },
    top: function(_bbox, param) {
        var top = param.top;
        return parseFloat(top);
    },
    left: function(_bbox, param) {
        var left = param.left;
        return parseFloat(left);
    },
    bottom: function(param, param1) {
        var y = param.y, top = param1.top;
        return parseFloat(top) + (y.max - y.min);
    },
    right: function(param, param1) {
        var x = param.x, left = param1.left;
        return parseFloat(left) + (x.max - x.min);
    },
    // Transform
    x: function(_bbox, param) {
        var transform = param.transform;
        return (0, $6YsSd.parseValueFromTransform)(transform, "x");
    },
    y: function(_bbox, param) {
        var transform = param.transform;
        return (0, $6YsSd.parseValueFromTransform)(transform, "y");
    }
};
// Alias translate longform names
$33b2a3bfe312c7cc$export$781d46a8aa670d52.translateX = $33b2a3bfe312c7cc$export$781d46a8aa670d52.x;
$33b2a3bfe312c7cc$export$781d46a8aa670d52.translateY = $33b2a3bfe312c7cc$export$781d46a8aa670d52.y;

});

parcelRegister("8oVcc", function(module, exports) {

$parcel$export(module.exports, "frame", function () { return $83430cc8cf177db0$export$2cef06c20297c17d; });
$parcel$export(module.exports, "cancelFrame", function () { return $83430cc8cf177db0$export$ec99c0ef4978dccb; });
$parcel$export(module.exports, "frameData", function () { return $83430cc8cf177db0$export$fff89137e9e818ce; });
$parcel$export(module.exports, "frameSteps", function () { return $83430cc8cf177db0$export$1811c3a7e3af92f0; });

var $eQ5Xp = parcelRequire("eQ5Xp");

var $dYVrz = parcelRequire("dYVrz");
var /* @__PURE__ */ $83430cc8cf177db0$var$_createRenderBatcher = (0, $dYVrz.createRenderBatcher)(typeof requestAnimationFrame !== "undefined" ? requestAnimationFrame : (0, $eQ5Xp.noop), true), $83430cc8cf177db0$export$2cef06c20297c17d = $83430cc8cf177db0$var$_createRenderBatcher.schedule, $83430cc8cf177db0$export$ec99c0ef4978dccb = $83430cc8cf177db0$var$_createRenderBatcher.cancel, $83430cc8cf177db0$export$fff89137e9e818ce = $83430cc8cf177db0$var$_createRenderBatcher.state, $83430cc8cf177db0$export$1811c3a7e3af92f0 = $83430cc8cf177db0$var$_createRenderBatcher.steps;

});
parcelRegister("eQ5Xp", function(module, exports) {

$parcel$export(module.exports, "noop", function () { return $531ba1f5979e69bd$export$8793edee2d425525; });
/*#__NO_SIDE_EFFECTS__*/ var $531ba1f5979e69bd$export$8793edee2d425525 = function(any) {
    return any;
};

});

parcelRegister("dYVrz", function(module, exports) {

$parcel$export(module.exports, "createRenderBatcher", function () { return $4f30921cda56b63d$export$510b0596a933801a; });

var $7mUth = parcelRequire("7mUth");

var $dnmQI = parcelRequire("dnmQI");

var $iqUuO = parcelRequire("iqUuO");
var $4f30921cda56b63d$var$maxElapsed = 40;
function $4f30921cda56b63d$export$510b0596a933801a(scheduleNextBatch, allowKeepAlive) {
    var runNextFrame = false;
    var useDefaultElapsed = true;
    var state = {
        delta: 0.0,
        timestamp: 0.0,
        isProcessing: false
    };
    var flagRunNextFrame = function() {
        return runNextFrame = true;
    };
    var steps = (0, $dnmQI.stepsOrder).reduce(function(acc, key) {
        acc[key] = (0, $iqUuO.createRenderStep)(flagRunNextFrame, allowKeepAlive ? key : undefined);
        return acc;
    }, {});
    var setup = steps.setup, read = steps.read, resolveKeyframes = steps.resolveKeyframes, preUpdate = steps.preUpdate, update = steps.update, preRender = steps.preRender, render = steps.render, postRender = steps.postRender;
    var processBatch = function() {
        var timestamp = (0, $7mUth.MotionGlobalConfig).useManualTiming ? state.timestamp : performance.now();
        runNextFrame = false;
        if (!(0, $7mUth.MotionGlobalConfig).useManualTiming) state.delta = useDefaultElapsed ? 1000 / 60 : Math.max(Math.min(timestamp - state.timestamp, $4f30921cda56b63d$var$maxElapsed), 1);
        state.timestamp = timestamp;
        state.isProcessing = true;
        // Unrolled render loop for better per-frame performance
        setup.process(state);
        read.process(state);
        resolveKeyframes.process(state);
        preUpdate.process(state);
        update.process(state);
        preRender.process(state);
        render.process(state);
        postRender.process(state);
        state.isProcessing = false;
        if (runNextFrame && allowKeepAlive) {
            useDefaultElapsed = false;
            scheduleNextBatch(processBatch);
        }
    };
    var wake = function() {
        runNextFrame = true;
        useDefaultElapsed = true;
        if (!state.isProcessing) scheduleNextBatch(processBatch);
    };
    var schedule = (0, $dnmQI.stepsOrder).reduce(function(acc, key) {
        var step = steps[key];
        acc[key] = function(process) {
            var keepAlive = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false, immediate = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : false;
            if (!runNextFrame) wake();
            return step.schedule(process, keepAlive, immediate);
        };
        return acc;
    }, {});
    var cancel = function(process) {
        for(var i = 0; i < (0, $dnmQI.stepsOrder).length; i++)steps[(0, $dnmQI.stepsOrder)[i]].cancel(process);
    };
    return {
        schedule: schedule,
        cancel: cancel,
        state: state,
        steps: steps
    };
}

});
parcelRegister("7mUth", function(module, exports) {

$parcel$export(module.exports, "MotionGlobalConfig", function () { return $cf14201284c18b4b$export$dd826089e3c5e502; });
var $cf14201284c18b4b$export$dd826089e3c5e502 = {};

});

parcelRegister("dnmQI", function(module, exports) {

$parcel$export(module.exports, "stepsOrder", function () { return $500badfa8e425bc5$export$71ecace0a033b35a; });
var $500badfa8e425bc5$export$71ecace0a033b35a = [
    "setup",
    "read",
    "resolveKeyframes",
    "preUpdate",
    "update",
    "preRender",
    "render",
    "postRender"
];

});

parcelRegister("iqUuO", function(module, exports) {

$parcel$export(module.exports, "createRenderStep", function () { return $d1b0c349e54cbc7c$export$b995e5e85f5c8289; });

var $2GhiD = parcelRequire("2GhiD");
function $d1b0c349e54cbc7c$export$b995e5e85f5c8289(runNextFrame, stepName) {
    /**
     * We create and reuse two queues, one to queue jobs for the current frame
     * and one for the next. We reuse to avoid triggering GC after x frames.
     */ var thisFrame = new Set();
    var nextFrame = new Set();
    /**
     * Track whether we're currently processing jobs in this step. This way
     * we can decide whether to schedule new jobs for this frame or next.
     */ var isProcessing = false;
    var flushNextFrame = false;
    /**
     * A set of processes which were marked keepAlive when scheduled.
     */ var toKeepAlive = new WeakSet();
    var latestFrameData = {
        delta: 0.0,
        timestamp: 0.0,
        isProcessing: false
    };
    var numCalls = 0;
    function triggerCallback(callback) {
        if (toKeepAlive.has(callback)) {
            step.schedule(callback);
            runNextFrame();
        }
        numCalls++;
        callback(latestFrameData);
    }
    var step = {
        /**
         * Schedule a process to run on the next frame.
         */ schedule: function(callback) {
            var keepAlive = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false, immediate = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : false;
            var addToCurrentFrame = immediate && isProcessing;
            var queue = addToCurrentFrame ? thisFrame : nextFrame;
            if (keepAlive) toKeepAlive.add(callback);
            if (!queue.has(callback)) queue.add(callback);
            return callback;
        },
        /**
         * Cancel the provided callback from running on the next frame.
         */ cancel: function(callback) {
            nextFrame.delete(callback);
            toKeepAlive.delete(callback);
        },
        /**
         * Execute all schedule callbacks.
         */ process: function(frameData) {
            latestFrameData = frameData;
            /**
             * If we're already processing we've probably been triggered by a flushSync
             * inside an existing process. Instead of executing, mark flushNextFrame
             * as true and ensure we flush the following frame at the end of this one.
             */ if (isProcessing) {
                flushNextFrame = true;
                return;
            }
            isProcessing = true;
            var ref;
            ref = [
                nextFrame,
                thisFrame
            ], thisFrame = ref[0], nextFrame = ref[1], ref;
            // Execute this frame
            thisFrame.forEach(triggerCallback);
            /**
             * If we're recording stats then
             */ if (stepName && (0, $2GhiD.statsBuffer).value) (0, $2GhiD.statsBuffer).value.frameloop[stepName].push(numCalls);
            numCalls = 0;
            // Clear the frame so no callbacks remain. This is to avoid
            // memory leaks should this render step not run for a while.
            thisFrame.clear();
            isProcessing = false;
            if (flushNextFrame) {
                flushNextFrame = false;
                step.process(frameData);
            }
        }
    };
    return step;
}

});
parcelRegister("2GhiD", function(module, exports) {

$parcel$export(module.exports, "statsBuffer", function () { return $37c40d95e90d81cf$export$84ce9a476f53d110; });
var $37c40d95e90d81cf$export$84ce9a476f53d110 = {
    value: null,
    addProjectionMetrics: null
};

});





parcelRegister("avMJM", function(module, exports) {

$parcel$export(module.exports, "isNone", function () { return $bae3ad67ddbbc680$export$e56af863d5645d5f; });

var $akpVE = parcelRequire("akpVE");
function $bae3ad67ddbbc680$export$e56af863d5645d5f(value) {
    if (typeof value === "number") return value === 0;
    else if (value !== null) return value === "none" || value === "0" || (0, $akpVE.isZeroValueString)(value);
    else return true;
}

});
parcelRegister("akpVE", function(module, exports) {

$parcel$export(module.exports, "isZeroValueString", function () { return $bd0e7291620bbed0$export$ade84c85e44a6cb1; });
/**
 * Check if the value is a zero value string like "0px" or "0%"
 */ var $bd0e7291620bbed0$export$ade84c85e44a6cb1 = function(v) {
    return RegExp("^0[^.\\s]+$", "u").test(v);
};

});


parcelRegister("3UpzJ", function(module, exports) {

$parcel$export(module.exports, "makeNoneKeyframesAnimatable", function () { return $d68201895ec728fa$export$8cc4958f8e540f37; });

var $8S0wI = parcelRequire("8S0wI");

var $84dY4 = parcelRequire("84dY4");
/**
 * If we encounter keyframes like "none" or "0" and we also have keyframes like
 * "#fff" or "200px 200px" we want to find a keyframe to serve as a template for
 * the "none" keyframes. In this case "#fff" or "200px 200px" - then these get turned into
 * zero equivalents, i.e. "#fff0" or "0px 0px".
 */ var $d68201895ec728fa$var$invalidTemplates = new Set([
    "auto",
    "none",
    "0"
]);
function $d68201895ec728fa$export$8cc4958f8e540f37(unresolvedKeyframes, noneKeyframeIndexes, name) {
    var i = 0;
    var animatableTemplate = undefined;
    while(i < unresolvedKeyframes.length && !animatableTemplate){
        var keyframe = unresolvedKeyframes[i];
        if (typeof keyframe === "string" && !$d68201895ec728fa$var$invalidTemplates.has(keyframe) && (0, $8S0wI.analyseComplexValue)(keyframe).values.length) animatableTemplate = unresolvedKeyframes[i];
        i++;
    }
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    if (animatableTemplate && name) try {
        for(var _iterator = noneKeyframeIndexes[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var noneIndex = _step.value;
            unresolvedKeyframes[noneIndex] = (0, $84dY4.getAnimatableNone)(name, animatableTemplate);
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
}

});
parcelRegister("8S0wI", function(module, exports) {

$parcel$export(module.exports, "analyseComplexValue", function () { return $97275ef59162952c$export$b61fc7c44bf646d5; });
$parcel$export(module.exports, "complex", function () { return $97275ef59162952c$export$83a0e34f1302825b; });

var $1WGCc = parcelRequire("1WGCc");

var $gGClp = parcelRequire("gGClp");

var $k4xhi = parcelRequire("k4xhi");

var $dB31d = parcelRequire("dB31d");
function $97275ef59162952c$var$test(v) {
    var _v_match, _v_match1;
    return isNaN(v) && typeof v === "string" && (((_v_match = v.match((0, $k4xhi.floatRegex))) === null || _v_match === void 0 ? void 0 : _v_match.length) || 0) + (((_v_match1 = v.match((0, $gGClp.colorRegex))) === null || _v_match1 === void 0 ? void 0 : _v_match1.length) || 0) > 0;
}
var $97275ef59162952c$var$NUMBER_TOKEN = "number";
var $97275ef59162952c$var$COLOR_TOKEN = "color";
var $97275ef59162952c$var$VAR_TOKEN = "var";
var $97275ef59162952c$var$VAR_FUNCTION_TOKEN = "var(";
var $97275ef59162952c$var$SPLIT_TOKEN = "${}";
// this regex consists of the `singleCssVariableRegex|rgbHSLValueRegex|digitRegex`
var $97275ef59162952c$var$complexRegex = RegExp("var\\s*\\(\\s*--(?:[\\w-]+\\s*|[\\w-]+\\s*,(?:\\s*[^)(\\s]|\\s*\\((?:[^)(]|\\([^)(]*\\))*\\))+\\s*)\\)|#[\\da-f]{3,8}|(?:rgb|hsl)a?\\((?:-?[\\d.]+%?[,\\s]+){2}-?[\\d.]+%?\\s*(?:[,/]\\s*)?(?:\\b\\d+(?:\\.\\d+)?|\\.\\d+)?%?\\)|-?(?:\\d+(?:\\.\\d+)?|\\.\\d+)", "giu");
function $97275ef59162952c$export$b61fc7c44bf646d5(value) {
    var originalValue = value.toString();
    var values = [];
    var indexes = {
        color: [],
        number: [],
        var: []
    };
    var types = [];
    var i = 0;
    var tokenised = originalValue.replace($97275ef59162952c$var$complexRegex, function(parsedValue) {
        if ((0, $1WGCc.color).test(parsedValue)) {
            indexes.color.push(i);
            types.push($97275ef59162952c$var$COLOR_TOKEN);
            values.push((0, $1WGCc.color).parse(parsedValue));
        } else if (parsedValue.startsWith($97275ef59162952c$var$VAR_FUNCTION_TOKEN)) {
            indexes.var.push(i);
            types.push($97275ef59162952c$var$VAR_TOKEN);
            values.push(parsedValue);
        } else {
            indexes.number.push(i);
            types.push($97275ef59162952c$var$NUMBER_TOKEN);
            values.push(parseFloat(parsedValue));
        }
        ++i;
        return $97275ef59162952c$var$SPLIT_TOKEN;
    });
    var split = tokenised.split($97275ef59162952c$var$SPLIT_TOKEN);
    return {
        values: values,
        split: split,
        indexes: indexes,
        types: types
    };
}
function $97275ef59162952c$var$parseComplexValue(v) {
    return $97275ef59162952c$export$b61fc7c44bf646d5(v).values;
}
function $97275ef59162952c$var$createTransformer(source) {
    var _analyseComplexValue = $97275ef59162952c$export$b61fc7c44bf646d5(source), split = _analyseComplexValue.split, types = _analyseComplexValue.types;
    var numSections = split.length;
    return function(v) {
        var output = "";
        for(var i = 0; i < numSections; i++){
            output += split[i];
            if (v[i] !== undefined) {
                var type = types[i];
                if (type === $97275ef59162952c$var$NUMBER_TOKEN) output += (0, $dB31d.sanitize)(v[i]);
                else if (type === $97275ef59162952c$var$COLOR_TOKEN) output += (0, $1WGCc.color).transform(v[i]);
                else output += v[i];
            }
        }
        return output;
    };
}
var $97275ef59162952c$var$convertNumbersToZero = function(v) {
    return typeof v === "number" ? 0 : (0, $1WGCc.color).test(v) ? (0, $1WGCc.color).getAnimatableNone(v) : v;
};
function $97275ef59162952c$var$getAnimatableNone(v) {
    var parsed = $97275ef59162952c$var$parseComplexValue(v);
    var transformer = $97275ef59162952c$var$createTransformer(v);
    return transformer(parsed.map($97275ef59162952c$var$convertNumbersToZero));
}
var $97275ef59162952c$export$83a0e34f1302825b = {
    test: $97275ef59162952c$var$test,
    parse: $97275ef59162952c$var$parseComplexValue,
    createTransformer: $97275ef59162952c$var$createTransformer,
    getAnimatableNone: $97275ef59162952c$var$getAnimatableNone
};

});
parcelRegister("1WGCc", function(module, exports) {

$parcel$export(module.exports, "color", function () { return $7d9ab91e22e702d6$export$35e9368ef982300f; });

var $911y6 = parcelRequire("911y6");

var $dKdh0 = parcelRequire("dKdh0");

var $48zq7 = parcelRequire("48zq7");
var $7d9ab91e22e702d6$export$35e9368ef982300f = {
    test: function(v) {
        return (0, $48zq7.rgba).test(v) || (0, $911y6.hex).test(v) || (0, $dKdh0.hsla).test(v);
    },
    parse: function(v) {
        if ((0, $48zq7.rgba).test(v)) return (0, $48zq7.rgba).parse(v);
        else if ((0, $dKdh0.hsla).test(v)) return (0, $dKdh0.hsla).parse(v);
        else return (0, $911y6.hex).parse(v);
    },
    transform: function(v) {
        return typeof v === "string" ? v : v.hasOwnProperty("red") ? (0, $48zq7.rgba).transform(v) : (0, $dKdh0.hsla).transform(v);
    },
    getAnimatableNone: function(v) {
        var parsed = $7d9ab91e22e702d6$export$35e9368ef982300f.parse(v);
        parsed.alpha = 0;
        return $7d9ab91e22e702d6$export$35e9368ef982300f.transform(parsed);
    }
};

});
parcelRegister("911y6", function(module, exports) {

$parcel$export(module.exports, "hex", function () { return $046d61b2d30e04cc$export$834dfc94dde4b3d8; });

var $48zq7 = parcelRequire("48zq7");

var $2896D = parcelRequire("2896D");
function $046d61b2d30e04cc$var$parseHex(v) {
    var r = "";
    var g = "";
    var b = "";
    var a = "";
    // If we have 6 characters, ie #FF0000
    if (v.length > 5) {
        r = v.substring(1, 3);
        g = v.substring(3, 5);
        b = v.substring(5, 7);
        a = v.substring(7, 9);
    // Or we have 3 characters, ie #F00
    } else {
        r = v.substring(1, 2);
        g = v.substring(2, 3);
        b = v.substring(3, 4);
        a = v.substring(4, 5);
        r += r;
        g += g;
        b += b;
        a += a;
    }
    return {
        red: parseInt(r, 16),
        green: parseInt(g, 16),
        blue: parseInt(b, 16),
        alpha: a ? parseInt(a, 16) / 255 : 1
    };
}
var $046d61b2d30e04cc$export$834dfc94dde4b3d8 = {
    test: /*@__PURE__*/ (0, $2896D.isColorString)("#"),
    parse: $046d61b2d30e04cc$var$parseHex,
    transform: (0, $48zq7.rgba).transform
};

});
parcelRegister("48zq7", function(module, exports) {

$parcel$export(module.exports, "rgba", function () { return $ad7c771706022406$export$4e46ac54fc82cf3b; });

var $joFW3 = parcelRequire("joFW3");

var $90FDw = parcelRequire("90FDw");

var $3BJvs = parcelRequire("3BJvs");

var $2KoB8 = parcelRequire("2KoB8");

var $dB31d = parcelRequire("dB31d");

var $2896D = parcelRequire("2896D");
var $ad7c771706022406$var$clampRgbUnit = function(v) {
    return (0, $3BJvs.clamp)(0, 255, v);
};
var $ad7c771706022406$export$7a99c86b5b1f4c9e = (0, $90FDw._)((0, $joFW3._)({}, (0, $2KoB8.number)), {
    transform: function(v) {
        return Math.round($ad7c771706022406$var$clampRgbUnit(v));
    }
});
var $ad7c771706022406$export$4e46ac54fc82cf3b = {
    test: /*@__PURE__*/ (0, $2896D.isColorString)("rgb", "red"),
    parse: /*@__PURE__*/ (0, $2896D.splitColor)("red", "green", "blue"),
    transform: function(param) {
        var red = param.red, green = param.green, blue = param.blue, tmp = param.alpha, alpha$1 = tmp === void 0 ? 1 : tmp;
        return "rgba(" + $ad7c771706022406$export$7a99c86b5b1f4c9e.transform(red) + ", " + $ad7c771706022406$export$7a99c86b5b1f4c9e.transform(green) + ", " + $ad7c771706022406$export$7a99c86b5b1f4c9e.transform(blue) + ", " + (0, $dB31d.sanitize)((0, $2KoB8.alpha).transform(alpha$1)) + ")";
    }
};

});
parcelRegister("dB31d", function(module, exports) {

$parcel$export(module.exports, "sanitize", function () { return $ee2de5aeee8fb11d$export$83d2e9e3e4ee39ed; });
// If this number is a decimal, make it just five decimal places
// to avoid exponents
var $ee2de5aeee8fb11d$export$83d2e9e3e4ee39ed = function(v) {
    return Math.round(v * 100000) / 100000;
};

});

parcelRegister("2896D", function(module, exports) {

$parcel$export(module.exports, "isColorString", function () { return $83c953ac901bb9c5$export$2c8400d58aca05e; });
$parcel$export(module.exports, "splitColor", function () { return $83c953ac901bb9c5$export$73d6f35be992df24; });

var $72osQ = parcelRequire("72osQ");

var $2nwvT = parcelRequire("2nwvT");

var $k4xhi = parcelRequire("k4xhi");

var $kenmb = parcelRequire("kenmb");

var $23RUF = parcelRequire("23RUF");
/**
 * Returns true if the provided string is a color, ie rgba(0,0,0,0) or #000,
 * but false if a number or multiple colors
 */ var $83c953ac901bb9c5$export$2c8400d58aca05e = function(type, testProp) {
    return function(v) {
        return Boolean(typeof v === "string" && (0, $23RUF.singleColorRegex).test(v) && v.startsWith(type) || testProp && !(0, $kenmb.isNullish)(v) && Object.prototype.hasOwnProperty.call(v, testProp));
    };
};
var $83c953ac901bb9c5$export$73d6f35be992df24 = function(aName, bName, cName) {
    return function(v) {
        if (typeof v !== "string") return v;
        var _v_match = (0, $2nwvT._)(v.match((0, $k4xhi.floatRegex)), 4), a = _v_match[0], b = _v_match[1], c = _v_match[2], alpha = _v_match[3];
        var _obj;
        return _obj = {}, (0, $72osQ._)(_obj, aName, parseFloat(a)), (0, $72osQ._)(_obj, bName, parseFloat(b)), (0, $72osQ._)(_obj, cName, parseFloat(c)), (0, $72osQ._)(_obj, "alpha", alpha !== undefined ? parseFloat(alpha) : 1), _obj;
    };
};

});
parcelRegister("k4xhi", function(module, exports) {

$parcel$export(module.exports, "floatRegex", function () { return $1fc2b625e64a12ca$export$2444ca58c08448e4; });
var $1fc2b625e64a12ca$export$2444ca58c08448e4 = RegExp("-?(?:\\d+(?:\\.\\d+)?|\\.\\d+)", "gu");

});

parcelRegister("kenmb", function(module, exports) {

$parcel$export(module.exports, "isNullish", function () { return $7088ae50a1b0e576$export$b931b78cbb3caf86; });
function $7088ae50a1b0e576$export$b931b78cbb3caf86(v) {
    return v == null;
}

});

parcelRegister("23RUF", function(module, exports) {

$parcel$export(module.exports, "singleColorRegex", function () { return $bb92f80d6337e815$export$ed808ff6ecd39e8d; });
var $bb92f80d6337e815$export$ed808ff6ecd39e8d = RegExp("^(?:#[\\da-f]{3,8}|(?:rgb|hsl)a?\\((?:-?[\\d.]+%?[,\\s]+){2}-?[\\d.]+%?\\s*(?:[,/]\\s*)?(?:\\b\\d+(?:\\.\\d+)?|\\.\\d+)?%?\\))$", "iu");

});




parcelRegister("dKdh0", function(module, exports) {

$parcel$export(module.exports, "hsla", function () { return $ae964bdb67d703fe$export$810b04175080204c; });

var $2KoB8 = parcelRequire("2KoB8");

var $aUTIu = parcelRequire("aUTIu");

var $dB31d = parcelRequire("dB31d");

var $2896D = parcelRequire("2896D");
var $ae964bdb67d703fe$export$810b04175080204c = {
    test: /*@__PURE__*/ (0, $2896D.isColorString)("hsl", "hue"),
    parse: /*@__PURE__*/ (0, $2896D.splitColor)("hue", "saturation", "lightness"),
    transform: function(param) {
        var hue = param.hue, saturation = param.saturation, lightness = param.lightness, tmp = param.alpha, alpha$1 = tmp === void 0 ? 1 : tmp;
        return "hsla(" + Math.round(hue) + ", " + (0, $aUTIu.percent).transform((0, $dB31d.sanitize)(saturation)) + ", " + (0, $aUTIu.percent).transform((0, $dB31d.sanitize)(lightness)) + ", " + (0, $dB31d.sanitize)((0, $2KoB8.alpha).transform(alpha$1)) + ")";
    }
};

});


parcelRegister("gGClp", function(module, exports) {

$parcel$export(module.exports, "colorRegex", function () { return $fcd5791ffece630b$export$740b69c5fad25dba; });
var $fcd5791ffece630b$export$740b69c5fad25dba = RegExp("(?:#[\\da-f]{3,8}|(?:rgb|hsl)a?\\((?:-?[\\d.]+%?[,\\s]+){2}-?[\\d.]+%?\\s*(?:[,/]\\s*)?(?:\\b\\d+(?:\\.\\d+)?|\\.\\d+)?%?\\))", "giu");

});


parcelRegister("84dY4", function(module, exports) {

$parcel$export(module.exports, "getAnimatableNone", function () { return $d1c49f8afe3e6175$export$cea0cedcb94873b5; });

var $8S0wI = parcelRequire("8S0wI");

var $5sDkb = parcelRequire("5sDkb");

var $eUWWD = parcelRequire("eUWWD");
function $d1c49f8afe3e6175$export$cea0cedcb94873b5(key, value) {
    var defaultValueType = (0, $eUWWD.getDefaultValueType)(key);
    if (defaultValueType !== (0, $5sDkb.filter)) defaultValueType = (0, $8S0wI.complex);
    // If value is not recognised as animatable, ie "none", create an animatable version origin based on the target
    return defaultValueType.getAnimatableNone ? defaultValueType.getAnimatableNone(value) : undefined;
}

});
parcelRegister("5sDkb", function(module, exports) {

$parcel$export(module.exports, "filter", function () { return $355e42a9590c731e$export$3dea766d36a8935f; });

var $joFW3 = parcelRequire("joFW3");

var $90FDw = parcelRequire("90FDw");

var $2nwvT = parcelRequire("2nwvT");

var $8S0wI = parcelRequire("8S0wI");

var $k4xhi = parcelRequire("k4xhi");
/**
 * Properties that should default to 1 or 100%
 */ var $355e42a9590c731e$var$maxDefaults = new Set([
    "brightness",
    "contrast",
    "saturate",
    "opacity"
]);
function $355e42a9590c731e$var$applyDefaultFilter(v) {
    var _v_slice_split = (0, $2nwvT._)(v.slice(0, -1).split("("), 2), name = _v_slice_split[0], value = _v_slice_split[1];
    if (name === "drop-shadow") return v;
    var _ref = (0, $2nwvT._)(value.match((0, $k4xhi.floatRegex)) || [], 1), number = _ref[0];
    if (!number) return v;
    var unit = value.replace(number, "");
    var defaultValue = $355e42a9590c731e$var$maxDefaults.has(name) ? 1 : 0;
    if (number !== value) defaultValue *= 100;
    return name + "(" + defaultValue + unit + ")";
}
var $355e42a9590c731e$var$functionRegex = RegExp("\\b([a-z-]*)\\(.*?\\)", "gu");
var $355e42a9590c731e$export$3dea766d36a8935f = (0, $90FDw._)((0, $joFW3._)({}, (0, $8S0wI.complex)), {
    getAnimatableNone: function(v) {
        var functions = v.match($355e42a9590c731e$var$functionRegex);
        return functions ? functions.map($355e42a9590c731e$var$applyDefaultFilter).join(" ") : v;
    }
});

});

parcelRegister("eUWWD", function(module, exports) {

$parcel$export(module.exports, "getDefaultValueType", function () { return $11c48f313f259094$export$67d1babe0338d23b; });

var $joFW3 = parcelRequire("joFW3");

var $90FDw = parcelRequire("90FDw");

var $1WGCc = parcelRequire("1WGCc");

var $5sDkb = parcelRequire("5sDkb");

var $BNtOZ = parcelRequire("BNtOZ");
/**
 * A map of default value types for common values
 */ var $11c48f313f259094$export$98cd7c72c5a731fb = (0, $90FDw._)((0, $joFW3._)({}, (0, $BNtOZ.numberValueTypes)), {
    // Color props
    color: (0, $1WGCc.color),
    backgroundColor: (0, $1WGCc.color),
    outlineColor: (0, $1WGCc.color),
    fill: (0, $1WGCc.color),
    stroke: (0, $1WGCc.color),
    // Border props
    borderColor: (0, $1WGCc.color),
    borderTopColor: (0, $1WGCc.color),
    borderRightColor: (0, $1WGCc.color),
    borderBottomColor: (0, $1WGCc.color),
    borderLeftColor: (0, $1WGCc.color),
    filter: (0, $5sDkb.filter),
    WebkitFilter: (0, $5sDkb.filter)
});
/**
 * Gets the default ValueType for the provided value key
 */ var $11c48f313f259094$export$67d1babe0338d23b = function(key) {
    return $11c48f313f259094$export$98cd7c72c5a731fb[key];
};

});
parcelRegister("BNtOZ", function(module, exports) {

$parcel$export(module.exports, "numberValueTypes", function () { return $f6dbc5e7fc04c228$export$eec14432cd1cb67b; });

var $joFW3 = parcelRequire("joFW3");

var $90FDw = parcelRequire("90FDw");

var $6ZeOa = parcelRequire("6ZeOa");

var $2KoB8 = parcelRequire("2KoB8");

var $aUTIu = parcelRequire("aUTIu");

var $b1GaK = parcelRequire("b1GaK");
var $f6dbc5e7fc04c228$export$eec14432cd1cb67b = (0, $90FDw._)((0, $joFW3._)({
    // Border props
    borderWidth: (0, $aUTIu.px),
    borderTopWidth: (0, $aUTIu.px),
    borderRightWidth: (0, $aUTIu.px),
    borderBottomWidth: (0, $aUTIu.px),
    borderLeftWidth: (0, $aUTIu.px),
    borderRadius: (0, $aUTIu.px),
    radius: (0, $aUTIu.px),
    borderTopLeftRadius: (0, $aUTIu.px),
    borderTopRightRadius: (0, $aUTIu.px),
    borderBottomRightRadius: (0, $aUTIu.px),
    borderBottomLeftRadius: (0, $aUTIu.px),
    // Positioning props
    width: (0, $aUTIu.px),
    maxWidth: (0, $aUTIu.px),
    height: (0, $aUTIu.px),
    maxHeight: (0, $aUTIu.px),
    top: (0, $aUTIu.px),
    right: (0, $aUTIu.px),
    bottom: (0, $aUTIu.px),
    left: (0, $aUTIu.px),
    // Spacing props
    padding: (0, $aUTIu.px),
    paddingTop: (0, $aUTIu.px),
    paddingRight: (0, $aUTIu.px),
    paddingBottom: (0, $aUTIu.px),
    paddingLeft: (0, $aUTIu.px),
    margin: (0, $aUTIu.px),
    marginTop: (0, $aUTIu.px),
    marginRight: (0, $aUTIu.px),
    marginBottom: (0, $aUTIu.px),
    marginLeft: (0, $aUTIu.px),
    // Misc
    backgroundPositionX: (0, $aUTIu.px),
    backgroundPositionY: (0, $aUTIu.px)
}, (0, $b1GaK.transformValueTypes)), {
    zIndex: (0, $6ZeOa.int),
    // SVG
    fillOpacity: (0, $2KoB8.alpha),
    strokeOpacity: (0, $2KoB8.alpha),
    numOctaves: (0, $6ZeOa.int)
});

});
parcelRegister("6ZeOa", function(module, exports) {

$parcel$export(module.exports, "int", function () { return $f44ea70df486e170$export$7d260a2a5f8bc19e; });

var $joFW3 = parcelRequire("joFW3");

var $90FDw = parcelRequire("90FDw");

var $2KoB8 = parcelRequire("2KoB8");
var $f44ea70df486e170$export$7d260a2a5f8bc19e = (0, $90FDw._)((0, $joFW3._)({}, (0, $2KoB8.number)), {
    transform: Math.round
});

});

parcelRegister("b1GaK", function(module, exports) {

$parcel$export(module.exports, "transformValueTypes", function () { return $5a0f6b4bcf6db32d$export$f2e4285fee37e26; });

var $2KoB8 = parcelRequire("2KoB8");

var $aUTIu = parcelRequire("aUTIu");
var $5a0f6b4bcf6db32d$export$f2e4285fee37e26 = {
    rotate: (0, $aUTIu.degrees),
    rotateX: (0, $aUTIu.degrees),
    rotateY: (0, $aUTIu.degrees),
    rotateZ: (0, $aUTIu.degrees),
    scale: (0, $2KoB8.scale),
    scaleX: (0, $2KoB8.scale),
    scaleY: (0, $2KoB8.scale),
    scaleZ: (0, $2KoB8.scale),
    skew: (0, $aUTIu.degrees),
    skewX: (0, $aUTIu.degrees),
    skewY: (0, $aUTIu.degrees),
    distance: (0, $aUTIu.px),
    translateX: (0, $aUTIu.px),
    translateY: (0, $aUTIu.px),
    translateZ: (0, $aUTIu.px),
    x: (0, $aUTIu.px),
    y: (0, $aUTIu.px),
    z: (0, $aUTIu.px),
    perspective: (0, $aUTIu.px),
    transformPerspective: (0, $aUTIu.px),
    opacity: (0, $2KoB8.alpha),
    originX: (0, $aUTIu.progressPercentage),
    originY: (0, $aUTIu.progressPercentage),
    originZ: (0, $aUTIu.px)
};

});






parcelRegister("4drXU", function(module, exports) {

$parcel$export(module.exports, "isMotionValue", function () { return $7517db90f044a07d$export$605d60a2578142d3; });
var $7517db90f044a07d$export$605d60a2578142d3 = function(value) {
    return Boolean(value && value.getVelocity);
};

});

parcelRegister("fMD7u", function(module, exports) {

$parcel$export(module.exports, "VisualElement", function () { return $fdabed03578d55f2$export$fa8b653c0f3714e5; });

var $grujF = parcelRequire("grujF");

var $dhMkv = parcelRequire("dhMkv");

var $joFW3 = parcelRequire("joFW3");

var $buaX5 = parcelRequire("buaX5");

var $2us1u = parcelRequire("2us1u");

var $bJtXW = parcelRequire("bJtXW");

var $8oVcc = parcelRequire("8oVcc");
var $8S0wI = parcelRequire("8S0wI");
var $tvEFe = parcelRequire("tvEFe");
var $84dY4 = parcelRequire("84dY4");
var $4drXU = parcelRequire("4drXU");
var $lCMx1 = parcelRequire("lCMx1");
var $43f3w = parcelRequire("43f3w");
var $4SyWW = parcelRequire("4SyWW");
var $j716H = parcelRequire("j716H");
var $e6FP6 = parcelRequire("e6FP6");

var $9WSNG = parcelRequire("9WSNG");
var $akpVE = parcelRequire("akpVE");
var $iTDss = parcelRequire("iTDss");

var $iXrcD = parcelRequire("iXrcD");

var $60wa2 = parcelRequire("60wa2");

var $gihmc = parcelRequire("gihmc");

var $dnFPB = parcelRequire("dnFPB");

var $aFm76 = parcelRequire("aFm76");

var $bXOiK = parcelRequire("bXOiK");

var $lCxEz = parcelRequire("lCxEz");

var $44IJv = parcelRequire("44IJv");
var $fdabed03578d55f2$var$propEventHandlers = [
    "AnimationStart",
    "AnimationComplete",
    "Update",
    "BeforeLayoutMeasure",
    "LayoutMeasure",
    "LayoutAnimationStart",
    "LayoutAnimationComplete"
];
/**
 * A VisualElement is an imperative abstraction around UI elements such as
 * HTMLElement, SVGElement, Three.Object3D etc.
 */ var $fdabed03578d55f2$export$fa8b653c0f3714e5 = /*#__PURE__*/ function() {
    "use strict";
    function VisualElement(param) {
        var _this = this;
        var parent = param.parent, props = param.props, presenceContext = param.presenceContext, reducedMotionConfig = param.reducedMotionConfig, blockInitialAnimation = param.blockInitialAnimation, visualState = param.visualState, options = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
        (0, $grujF._)(this, VisualElement);
        /**
         * A reference to the current underlying Instance, e.g. a HTMLElement
         * or Three.Mesh etc.
         */ this.current = null;
        /**
         * A set containing references to this VisualElement's children.
         */ this.children = new Set();
        /**
         * Determine what role this visual element should take in the variant tree.
         */ this.isVariantNode = false;
        this.isControllingVariants = false;
        /**
         * Decides whether this VisualElement should animate in reduced motion
         * mode.
         *
         * TODO: This is currently set on every individual VisualElement but feels
         * like it could be set globally.
         */ this.shouldReduceMotion = null;
        /**
         * A map of all motion values attached to this visual element. Motion
         * values are source of truth for any given animated value. A motion
         * value might be provided externally by the component via props.
         */ this.values = new Map();
        this.KeyframeResolver = (0, $lCMx1.KeyframeResolver);
        /**
         * Cleanup functions for active features (hover/tap/exit etc)
         */ this.features = {};
        /**
         * A map of every subscription that binds the provided or generated
         * motion values onChange listeners to this visual element.
         */ this.valueSubscriptions = new Map();
        /**
         * A reference to the previously-provided motion values as returned
         * from scrapeMotionValuesFromProps. We use the keys in here to determine
         * if any motion values need to be removed after props are updated.
         */ this.prevMotionValues = {};
        /**
         * An object containing a SubscriptionManager for each active event.
         */ this.events = {};
        /**
         * An object containing an unsubscribe function for each prop event subscription.
         * For example, every "Update" event can have multiple subscribers via
         * VisualElement.on(), but only one of those can be defined via the onUpdate prop.
         */ this.propEventSubscriptions = {};
        this.notifyUpdate = function() {
            return _this.notify("Update", _this.latestValues);
        };
        this.render = function() {
            if (!_this.current) return;
            _this.triggerBuild();
            _this.renderInstance(_this.current, _this.renderState, _this.props.style, _this.projection);
        };
        this.renderScheduledAt = 0.0;
        this.scheduleRender = function() {
            var now = (0, $j716H.time).now();
            if (_this.renderScheduledAt < now) {
                _this.renderScheduledAt = now;
                (0, $8oVcc.frame).render(_this.render, false, true);
            }
        };
        var latestValues = visualState.latestValues, renderState = visualState.renderState;
        this.latestValues = latestValues;
        this.baseTarget = (0, $joFW3._)({}, latestValues);
        this.initialValues = props.initial ? (0, $joFW3._)({}, latestValues) : {};
        this.renderState = renderState;
        this.parent = parent;
        this.props = props;
        this.presenceContext = presenceContext;
        this.depth = parent ? parent.depth + 1 : 0;
        this.reducedMotionConfig = reducedMotionConfig;
        this.options = options;
        this.blockInitialAnimation = Boolean(blockInitialAnimation);
        this.isControllingVariants = (0, $bXOiK.isControllingVariants)(props);
        this.isVariantNode = (0, $bXOiK.isVariantNode)(props);
        if (this.isVariantNode) this.variantChildren = new Set();
        this.manuallyAnimateOnMount = Boolean(parent && parent.current);
        /**
         * Any motion values that are provided to the element when created
         * aren't yet bound to the element, as this would technically be impure.
         * However, we iterate through the motion values and set them to the
         * initial values for this component.
         *
         * TODO: This is impure and we should look at changing this to run on mount.
         * Doing so will break some tests but this isn't necessarily a breaking change,
         * more a reflection of the test.
         */ var _this_scrapeMotionValuesFromProps = this.scrapeMotionValuesFromProps(props, {}, this), willChange = _this_scrapeMotionValuesFromProps.willChange, initialMotionValues = (0, $buaX5._)(_this_scrapeMotionValuesFromProps, [
            "willChange"
        ]);
        for(var key in initialMotionValues){
            var value = initialMotionValues[key];
            if (latestValues[key] !== undefined && (0, $4drXU.isMotionValue)(value)) value.set(latestValues[key]);
        }
    }
    (0, $dhMkv._)(VisualElement, [
        {
            /**
     * This method takes React props and returns found MotionValues. For example, HTML
     * MotionValues will be found within the style prop, whereas for Three.js within attribute arrays.
     *
     * This isn't an abstract method as it needs calling in the constructor, but it is
     * intended to be one.
     */ key: "scrapeMotionValuesFromProps",
            value: function scrapeMotionValuesFromProps(_props, _prevProps, _visualElement) {
                return {};
            }
        },
        {
            key: "mount",
            value: function mount(instance) {
                var _this = this;
                var _this_parent;
                this.current = instance;
                (0, $aFm76.visualElementStore).set(instance, this);
                if (this.projection && !this.projection.instance) this.projection.mount(instance);
                if (this.parent && this.isVariantNode && !this.isControllingVariants) this.removeFromVariantTree = this.parent.addVariantChild(this);
                this.values.forEach(function(value, key) {
                    return _this.bindToMotionValue(key, value);
                });
                if (!(0, $dnFPB.hasReducedMotionListener).current) (0, $gihmc.initPrefersReducedMotion)();
                this.shouldReduceMotion = this.reducedMotionConfig === "never" ? false : this.reducedMotionConfig === "always" ? true : (0, $dnFPB.prefersReducedMotion).current;
                (_this_parent = this.parent) === null || _this_parent === void 0 ? void 0 : _this_parent.addChild(this);
                this.update(this.props, this.presenceContext);
            }
        },
        {
            key: "unmount",
            value: function unmount() {
                var _this_parent;
                this.projection && this.projection.unmount();
                (0, $8oVcc.cancelFrame)(this.notifyUpdate);
                (0, $8oVcc.cancelFrame)(this.render);
                this.valueSubscriptions.forEach(function(remove) {
                    return remove();
                });
                this.valueSubscriptions.clear();
                this.removeFromVariantTree && this.removeFromVariantTree();
                (_this_parent = this.parent) === null || _this_parent === void 0 ? void 0 : _this_parent.removeChild(this);
                for(var key in this.events)this.events[key].clear();
                for(var key1 in this.features){
                    var feature = this.features[key1];
                    if (feature) {
                        feature.unmount();
                        feature.isMounted = false;
                    }
                }
                this.current = null;
            }
        },
        {
            key: "addChild",
            value: function addChild(child) {
                this.children.add(child);
                var _this_enteringChildren;
                (_this_enteringChildren = this.enteringChildren) !== null && _this_enteringChildren !== void 0 ? _this_enteringChildren : this.enteringChildren = new Set();
                this.enteringChildren.add(child);
            }
        },
        {
            key: "removeChild",
            value: function removeChild(child) {
                this.children.delete(child);
                this.enteringChildren && this.enteringChildren.delete(child);
            }
        },
        {
            key: "bindToMotionValue",
            value: function bindToMotionValue(key, value) {
                var _this = this;
                if (this.valueSubscriptions.has(key)) this.valueSubscriptions.get(key)();
                var valueIsTransform = (0, $e6FP6.transformProps).has(key);
                if (valueIsTransform && this.onBindTransform) this.onBindTransform();
                var removeOnChange = value.on("change", function(latestValue) {
                    _this.latestValues[key] = latestValue;
                    _this.props.onUpdate && (0, $8oVcc.frame).preRender(_this.notifyUpdate);
                    if (valueIsTransform && _this.projection) _this.projection.isTransformDirty = true;
                    _this.scheduleRender();
                });
                var removeSyncCheck;
                if (window.MotionCheckAppearSync) removeSyncCheck = window.MotionCheckAppearSync(this, key, value);
                this.valueSubscriptions.set(key, function() {
                    removeOnChange();
                    if (removeSyncCheck) removeSyncCheck();
                    if (value.owner) value.stop();
                });
            }
        },
        {
            key: "sortNodePosition",
            value: function sortNodePosition(other) {
                /**
         * If these nodes aren't even of the same type we can't compare their depth.
         */ if (!this.current || !this.sortInstanceNodePosition || this.type !== other.type) return 0;
                return this.sortInstanceNodePosition(this.current, other.current);
            }
        },
        {
            key: "updateFeatures",
            value: function updateFeatures() {
                var key = "animation";
                for(key in 0, $iXrcD.featureDefinitions){
                    var featureDefinition = (0, $iXrcD.featureDefinitions)[key];
                    if (!featureDefinition) continue;
                    var isEnabled = featureDefinition.isEnabled, FeatureConstructor = featureDefinition.Feature;
                    /**
             * If this feature is enabled but not active, make a new instance.
             */ if (!this.features[key] && FeatureConstructor && isEnabled(this.props)) this.features[key] = new FeatureConstructor(this);
                    /**
             * If we have a feature, mount or update it.
             */ if (this.features[key]) {
                        var feature = this.features[key];
                        if (feature.isMounted) feature.update();
                        else {
                            feature.mount();
                            feature.isMounted = true;
                        }
                    }
                }
            }
        },
        {
            key: "triggerBuild",
            value: function triggerBuild() {
                this.build(this.renderState, this.latestValues, this.props);
            }
        },
        {
            /**
     * Measure the current viewport box with or without transforms.
     * Only measures axis-aligned boxes, rotate and skew must be manually
     * removed with a re-render to work.
     */ key: "measureViewportBox",
            value: function measureViewportBox() {
                return this.current ? this.measureInstanceViewportBox(this.current, this.props) : (0, $60wa2.createBox)();
            }
        },
        {
            key: "getStaticValue",
            value: function getStaticValue(key) {
                return this.latestValues[key];
            }
        },
        {
            key: "setStaticValue",
            value: function setStaticValue(key, value) {
                this.latestValues[key] = value;
            }
        },
        {
            /**
     * Update the provided props. Ensure any newly-added motion values are
     * added to our map, old ones removed, and listeners updated.
     */ key: "update",
            value: function update(props, presenceContext) {
                if (props.transformTemplate || this.props.transformTemplate) this.scheduleRender();
                this.prevProps = this.props;
                this.props = props;
                this.prevPresenceContext = this.presenceContext;
                this.presenceContext = presenceContext;
                /**
         * Update prop event handlers ie onAnimationStart, onAnimationComplete
         */ for(var i = 0; i < $fdabed03578d55f2$var$propEventHandlers.length; i++){
                    var key = $fdabed03578d55f2$var$propEventHandlers[i];
                    if (this.propEventSubscriptions[key]) {
                        this.propEventSubscriptions[key]();
                        delete this.propEventSubscriptions[key];
                    }
                    var listenerName = "on" + key;
                    var listener = props[listenerName];
                    if (listener) this.propEventSubscriptions[key] = this.on(key, listener);
                }
                this.prevMotionValues = (0, $lCxEz.updateMotionValuesFromProps)(this, this.scrapeMotionValuesFromProps(props, this.prevProps, this), this.prevMotionValues);
                if (this.handleChildMotionValue) this.handleChildMotionValue();
            }
        },
        {
            key: "getProps",
            value: function getProps() {
                return this.props;
            }
        },
        {
            /**
     * Returns the variant definition with a given name.
     */ key: "getVariant",
            value: function getVariant(name) {
                return this.props.variants ? this.props.variants[name] : undefined;
            }
        },
        {
            /**
     * Returns the defined default transition on this component.
     */ key: "getDefaultTransition",
            value: function getDefaultTransition() {
                return this.props.transition;
            }
        },
        {
            key: "getTransformPagePoint",
            value: function getTransformPagePoint() {
                return this.props.transformPagePoint;
            }
        },
        {
            key: "getClosestVariantNode",
            value: function getClosestVariantNode() {
                return this.isVariantNode ? this : this.parent ? this.parent.getClosestVariantNode() : undefined;
            }
        },
        {
            /**
     * Add a child visual element to our set of children.
     */ key: "addVariantChild",
            value: function addVariantChild(child) {
                var closestVariantNode = this.getClosestVariantNode();
                if (closestVariantNode) {
                    closestVariantNode.variantChildren && closestVariantNode.variantChildren.add(child);
                    return function() {
                        return closestVariantNode.variantChildren.delete(child);
                    };
                }
            }
        },
        {
            /**
     * Add a motion value and bind it to this visual element.
     */ key: "addValue",
            value: function addValue(key, value) {
                // Remove existing value if it exists
                var existingValue = this.values.get(key);
                if (value !== existingValue) {
                    if (existingValue) this.removeValue(key);
                    this.bindToMotionValue(key, value);
                    this.values.set(key, value);
                    this.latestValues[key] = value.get();
                }
            }
        },
        {
            /**
     * Remove a motion value and unbind any active subscriptions.
     */ key: "removeValue",
            value: function removeValue(key) {
                this.values.delete(key);
                var unsubscribe = this.valueSubscriptions.get(key);
                if (unsubscribe) {
                    unsubscribe();
                    this.valueSubscriptions.delete(key);
                }
                delete this.latestValues[key];
                this.removeValueFromRenderState(key, this.renderState);
            }
        },
        {
            /**
     * Check whether we have a motion value for this key
     */ key: "hasValue",
            value: function hasValue(key) {
                return this.values.has(key);
            }
        },
        {
            key: "getValue",
            value: function getValue(key, defaultValue) {
                if (this.props.values && this.props.values[key]) return this.props.values[key];
                var value = this.values.get(key);
                if (value === undefined && defaultValue !== undefined) {
                    value = (0, $4SyWW.motionValue)(defaultValue === null ? undefined : defaultValue, {
                        owner: this
                    });
                    this.addValue(key, value);
                }
                return value;
            }
        },
        {
            /**
     * If we're trying to animate to a previously unencountered value,
     * we need to check for it in our state and as a last resort read it
     * directly from the instance (which might have performance implications).
     */ key: "readValue",
            value: function readValue(key, target) {
                var _this_getBaseTargetFromProps;
                var value = this.latestValues[key] !== undefined || !this.current ? this.latestValues[key] : (_this_getBaseTargetFromProps = this.getBaseTargetFromProps(this.props, key)) !== null && _this_getBaseTargetFromProps !== void 0 ? _this_getBaseTargetFromProps : this.readValueFromInstance(this.current, key, this.options);
                if (value !== undefined && value !== null) {
                    if (typeof value === "string" && ((0, $9WSNG.isNumericalString)(value) || (0, $akpVE.isZeroValueString)(value))) // If this is a number read as a string, ie "0" or "200", convert it to a number
                    value = parseFloat(value);
                    else if (!(0, $tvEFe.findValueType)(value) && (0, $8S0wI.complex).test(target)) value = (0, $84dY4.getAnimatableNone)(key, target);
                    this.setBaseTarget(key, (0, $4drXU.isMotionValue)(value) ? value.get() : value);
                }
                return (0, $4drXU.isMotionValue)(value) ? value.get() : value;
            }
        },
        {
            /**
     * Set the base target to later animate back to. This is currently
     * only hydrated on creation and when we first read a value.
     */ key: "setBaseTarget",
            value: function setBaseTarget(key, value) {
                this.baseTarget[key] = value;
            }
        },
        {
            /**
     * Find the base target for a value thats been removed from all animation
     * props.
     */ key: "getBaseTarget",
            value: function getBaseTarget(key) {
                var initial = this.props.initial;
                var valueFromInitial;
                if (typeof initial === "string" || (typeof initial === "undefined" ? "undefined" : (0, $bJtXW._)(initial)) === "object") {
                    var _this_presenceContext;
                    var variant = (0, $44IJv.resolveVariantFromProps)(this.props, initial, (_this_presenceContext = this.presenceContext) === null || _this_presenceContext === void 0 ? void 0 : _this_presenceContext.custom);
                    if (variant) valueFromInitial = variant[key];
                }
                /**
         * If this value still exists in the current initial variant, read that.
         */ if (initial && valueFromInitial !== undefined) return valueFromInitial;
                /**
         * Alternatively, if this VisualElement config has defined a getBaseTarget
         * so we can read the value from an alternative source, try that.
         */ var target = this.getBaseTargetFromProps(this.props, key);
                if (target !== undefined && !(0, $4drXU.isMotionValue)(target)) return target;
                /**
         * If the value was initially defined on initial, but it doesn't any more,
         * return undefined. Otherwise return the value as initially read from the DOM.
         */ return this.initialValues[key] !== undefined && valueFromInitial === undefined ? undefined : this.baseTarget[key];
            }
        },
        {
            key: "on",
            value: function on(eventName, callback) {
                if (!this.events[eventName]) this.events[eventName] = new (0, $iTDss.SubscriptionManager)();
                return this.events[eventName].add(callback);
            }
        },
        {
            key: "notify",
            value: function notify(eventName) {
                for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++){
                    args[_key - 1] = arguments[_key];
                }
                var _this_events_eventName;
                if (this.events[eventName]) (_this_events_eventName = this.events[eventName]).notify.apply(_this_events_eventName, (0, $2us1u._)(args));
            }
        },
        {
            key: "scheduleRenderMicrotask",
            value: function scheduleRenderMicrotask() {
                (0, $43f3w.microtask).render(this.render);
            }
        }
    ]);
    return VisualElement;
}();

});
parcelRegister("buaX5", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $85cafde4a2dd4f41$export$71511d61b312f219; });

var $hcoZ2 = parcelRequire("hcoZ2");
function $85cafde4a2dd4f41$export$71511d61b312f219(source, excluded) {
    if (source == null) return {};
    var target = (0, $hcoZ2._)(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}

});
parcelRegister("hcoZ2", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $c856efe13547de99$export$71511d61b312f219; });
function $c856efe13547de99$export$71511d61b312f219(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}

});


parcelRegister("tvEFe", function(module, exports) {

$parcel$export(module.exports, "findValueType", function () { return $2420b14e7f555027$export$950e7e59ea1ffed7; });

var $2us1u = parcelRequire("2us1u");

var $1WGCc = parcelRequire("1WGCc");

var $8S0wI = parcelRequire("8S0wI");

var $7CP94 = parcelRequire("7CP94");

var $7HiS5 = parcelRequire("7HiS5");
/**
 * A list of all ValueTypes
 */ var $2420b14e7f555027$var$valueTypes = (0, $2us1u._)((0, $7CP94.dimensionValueTypes)).concat([
    (0, $1WGCc.color),
    (0, $8S0wI.complex)
]);
/**
 * Tests a value against the list of ValueTypes
 */ var $2420b14e7f555027$export$950e7e59ea1ffed7 = function(v) {
    return $2420b14e7f555027$var$valueTypes.find((0, $7HiS5.testValueType)(v));
};

});

parcelRegister("43f3w", function(module, exports) {

$parcel$export(module.exports, "microtask", function () { return $90c2f199bae3d780$export$bb76eed83315504c; });

var $dYVrz = parcelRequire("dYVrz");
var /* @__PURE__ */ $90c2f199bae3d780$var$_createRenderBatcher = (0, $dYVrz.createRenderBatcher)(queueMicrotask, false), $90c2f199bae3d780$export$bb76eed83315504c = $90c2f199bae3d780$var$_createRenderBatcher.schedule, $90c2f199bae3d780$export$3252729004b8456e = $90c2f199bae3d780$var$_createRenderBatcher.cancel;

});

parcelRegister("4SyWW", function(module, exports) {

$parcel$export(module.exports, "motionValue", function () { return $baa2663873be2699$export$ce8bdc721e76545f; });

var $grujF = parcelRequire("grujF");

var $dhMkv = parcelRequire("dhMkv");

var $iTDss = parcelRequire("iTDss");
var $cYmCu = parcelRequire("cYmCu");

var $j716H = parcelRequire("j716H");

var $8oVcc = parcelRequire("8oVcc");
/**
 * Maximum time between the value of two frames, beyond which we
 * assume the velocity has since been 0.
 */ var $baa2663873be2699$var$MAX_VELOCITY_DELTA = 30;
var $baa2663873be2699$var$isFloat = function(value) {
    return !isNaN(parseFloat(value));
};
var $baa2663873be2699$export$67fcd818a264039d = {
    current: undefined
};
/**
 * `MotionValue` is used to track the state and velocity of motion values.
 *
 * @public
 */ var $baa2663873be2699$export$8cea36d14ee64562 = /*#__PURE__*/ function() {
    "use strict";
    function MotionValue(init) {
        var _this = this;
        var options = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
        (0, $grujF._)(this, MotionValue);
        /**
         * Tracks whether this value can output a velocity. Currently this is only true
         * if the value is numerical, but we might be able to widen the scope here and support
         * other value types.
         *
         * @internal
         */ this.canTrackVelocity = null;
        /**
         * An object containing a SubscriptionManager for each active event.
         */ this.events = {};
        this.updateAndNotify = function(v) {
            var currentTime = (0, $j716H.time).now();
            /**
             * If we're updating the value during another frame or eventloop
             * than the previous frame, then the we set the previous frame value
             * to current.
             */ if (_this.updatedAt !== currentTime) _this.setPrevFrameValue();
            _this.prev = _this.current;
            _this.setCurrent(v);
            // Update update subscribers
            if (_this.current !== _this.prev) {
                var _this_events_change;
                (_this_events_change = _this.events.change) === null || _this_events_change === void 0 ? void 0 : _this_events_change.notify(_this.current);
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                if (_this.dependents) try {
                    for(var _iterator = _this.dependents[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                        var dependent = _step.value;
                        dependent.dirty();
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                            _iterator.return();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
            }
        };
        this.hasAnimated = false;
        this.setCurrent(init);
        this.owner = options.owner;
    }
    (0, $dhMkv._)(MotionValue, [
        {
            key: "setCurrent",
            value: function setCurrent(current) {
                this.current = current;
                this.updatedAt = (0, $j716H.time).now();
                if (this.canTrackVelocity === null && current !== undefined) this.canTrackVelocity = $baa2663873be2699$var$isFloat(this.current);
            }
        },
        {
            key: "setPrevFrameValue",
            value: function setPrevFrameValue() {
                var prevFrameValue = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : this.current;
                this.prevFrameValue = prevFrameValue;
                this.prevUpdatedAt = this.updatedAt;
            }
        },
        {
            /**
     * Adds a function that will be notified when the `MotionValue` is updated.
     *
     * It returns a function that, when called, will cancel the subscription.
     *
     * When calling `onChange` inside a React component, it should be wrapped with the
     * `useEffect` hook. As it returns an unsubscribe function, this should be returned
     * from the `useEffect` function to ensure you don't add duplicate subscribers..
     *
     * ```jsx
     * export const MyComponent = () => {
     *   const x = useMotionValue(0)
     *   const y = useMotionValue(0)
     *   const opacity = useMotionValue(1)
     *
     *   useEffect(() => {
     *     function updateOpacity() {
     *       const maxXY = Math.max(x.get(), y.get())
     *       const newOpacity = transform(maxXY, [0, 100], [1, 0])
     *       opacity.set(newOpacity)
     *     }
     *
     *     const unsubscribeX = x.on("change", updateOpacity)
     *     const unsubscribeY = y.on("change", updateOpacity)
     *
     *     return () => {
     *       unsubscribeX()
     *       unsubscribeY()
     *     }
     *   }, [])
     *
     *   return <motion.div style={{ x }} />
     * }
     * ```
     *
     * @param subscriber - A function that receives the latest value.
     * @returns A function that, when called, will cancel this subscription.
     *
     * @deprecated
     */ key: "onChange",
            value: function onChange(subscription) {
                return this.on("change", subscription);
            }
        },
        {
            key: "on",
            value: function on(eventName, callback) {
                var _this = this;
                if (!this.events[eventName]) this.events[eventName] = new (0, $iTDss.SubscriptionManager)();
                var unsubscribe = this.events[eventName].add(callback);
                if (eventName === "change") return function() {
                    unsubscribe();
                    /**
                 * If we have no more change listeners by the start
                 * of the next frame, stop active animations.
                 */ (0, $8oVcc.frame).read(function() {
                        if (!_this.events.change.getSize()) _this.stop();
                    });
                };
                return unsubscribe;
            }
        },
        {
            key: "clearListeners",
            value: function clearListeners() {
                for(var eventManagers in this.events)this.events[eventManagers].clear();
            }
        },
        {
            /**
     * Attaches a passive effect to the `MotionValue`.
     */ key: "attach",
            value: function attach(passiveEffect, stopPassiveEffect) {
                this.passiveEffect = passiveEffect;
                this.stopPassiveEffect = stopPassiveEffect;
            }
        },
        {
            /**
     * Sets the state of the `MotionValue`.
     *
     * @remarks
     *
     * ```jsx
     * const x = useMotionValue(0)
     * x.set(10)
     * ```
     *
     * @param latest - Latest value to set.
     * @param render - Whether to notify render subscribers. Defaults to `true`
     *
     * @public
     */ key: "set",
            value: function set(v) {
                if (!this.passiveEffect) this.updateAndNotify(v);
                else this.passiveEffect(v, this.updateAndNotify);
            }
        },
        {
            key: "setWithVelocity",
            value: function setWithVelocity(prev, current, delta) {
                this.set(current);
                this.prev = undefined;
                this.prevFrameValue = prev;
                this.prevUpdatedAt = this.updatedAt - delta;
            }
        },
        {
            /**
     * Set the state of the `MotionValue`, stopping any active animations,
     * effects, and resets velocity to `0`.
     */ key: "jump",
            value: function jump(v) {
                var endAnimation = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : true;
                this.updateAndNotify(v);
                this.prev = v;
                this.prevUpdatedAt = this.prevFrameValue = undefined;
                endAnimation && this.stop();
                if (this.stopPassiveEffect) this.stopPassiveEffect();
            }
        },
        {
            key: "dirty",
            value: function dirty() {
                var _this_events_change;
                (_this_events_change = this.events.change) === null || _this_events_change === void 0 ? void 0 : _this_events_change.notify(this.current);
            }
        },
        {
            key: "addDependent",
            value: function addDependent(dependent) {
                if (!this.dependents) this.dependents = new Set();
                this.dependents.add(dependent);
            }
        },
        {
            key: "removeDependent",
            value: function removeDependent(dependent) {
                if (this.dependents) this.dependents.delete(dependent);
            }
        },
        {
            /**
     * Returns the latest state of `MotionValue`
     *
     * @returns - The latest state of `MotionValue`
     *
     * @public
     */ key: "get",
            value: function get() {
                if ($baa2663873be2699$export$67fcd818a264039d.current) $baa2663873be2699$export$67fcd818a264039d.current.push(this);
                return this.current;
            }
        },
        {
            /**
     * @public
     */ key: "getPrevious",
            value: function getPrevious() {
                return this.prev;
            }
        },
        {
            /**
     * Returns the latest velocity of `MotionValue`
     *
     * @returns - The latest velocity of `MotionValue`. Returns `0` if the state is non-numerical.
     *
     * @public
     */ key: "getVelocity",
            value: function getVelocity() {
                var currentTime = (0, $j716H.time).now();
                if (!this.canTrackVelocity || this.prevFrameValue === undefined || currentTime - this.updatedAt > $baa2663873be2699$var$MAX_VELOCITY_DELTA) return 0;
                var delta = Math.min(this.updatedAt - this.prevUpdatedAt, $baa2663873be2699$var$MAX_VELOCITY_DELTA);
                // Casts because of parseFloat's poor typing
                return (0, $cYmCu.velocityPerSecond)(parseFloat(this.current) - parseFloat(this.prevFrameValue), delta);
            }
        },
        {
            /**
     * Registers a new animation to control this `MotionValue`. Only one
     * animation can drive a `MotionValue` at one time.
     *
     * ```jsx
     * value.start()
     * ```
     *
     * @param animation - A function that starts the provided animation
     */ key: "start",
            value: function start(startAnimation) {
                var _this = this;
                this.stop();
                return new Promise(function(resolve) {
                    _this.hasAnimated = true;
                    _this.animation = startAnimation(resolve);
                    if (_this.events.animationStart) _this.events.animationStart.notify();
                }).then(function() {
                    if (_this.events.animationComplete) _this.events.animationComplete.notify();
                    _this.clearAnimation();
                });
            }
        },
        {
            /**
     * Stop the currently active animation.
     *
     * @public
     */ key: "stop",
            value: function stop() {
                if (this.animation) {
                    this.animation.stop();
                    if (this.events.animationCancel) this.events.animationCancel.notify();
                }
                this.clearAnimation();
            }
        },
        {
            /**
     * Returns `true` if this value is currently animating.
     *
     * @public
     */ key: "isAnimating",
            value: function isAnimating() {
                return !!this.animation;
            }
        },
        {
            key: "clearAnimation",
            value: function clearAnimation() {
                delete this.animation;
            }
        },
        {
            /**
     * Destroy and clean up subscribers to this `MotionValue`.
     *
     * The `MotionValue` hooks like `useMotionValue` and `useTransform` automatically
     * handle the lifecycle of the returned `MotionValue`, so this method is only necessary if you've manually
     * created a `MotionValue` via the `motionValue` function.
     *
     * @public
     */ key: "destroy",
            value: function destroy() {
                var _this_dependents, _this_events_destroy;
                (_this_dependents = this.dependents) === null || _this_dependents === void 0 ? void 0 : _this_dependents.clear();
                (_this_events_destroy = this.events.destroy) === null || _this_events_destroy === void 0 ? void 0 : _this_events_destroy.notify();
                this.clearListeners();
                this.stop();
                if (this.stopPassiveEffect) this.stopPassiveEffect();
            }
        }
    ]);
    return MotionValue;
}();
function $baa2663873be2699$export$ce8bdc721e76545f(init, options) {
    return new $baa2663873be2699$export$8cea36d14ee64562(init, options);
}

});
parcelRegister("iTDss", function(module, exports) {

$parcel$export(module.exports, "SubscriptionManager", function () { return $db6578df4c1ea95a$export$e7dff9482a5fd23c; });

var $grujF = parcelRequire("grujF");

var $dhMkv = parcelRequire("dhMkv");

var $28QzH = parcelRequire("28QzH");
var $db6578df4c1ea95a$export$e7dff9482a5fd23c = /*#__PURE__*/ function() {
    "use strict";
    function SubscriptionManager() {
        (0, $grujF._)(this, SubscriptionManager);
        this.subscriptions = [];
    }
    (0, $dhMkv._)(SubscriptionManager, [
        {
            key: "add",
            value: function add(handler) {
                var _this = this;
                (0, $28QzH.addUniqueItem)(this.subscriptions, handler);
                return function() {
                    return (0, $28QzH.removeItem)(_this.subscriptions, handler);
                };
            }
        },
        {
            key: "notify",
            value: function notify(a, b, c) {
                var numSubscriptions = this.subscriptions.length;
                if (!numSubscriptions) return;
                if (numSubscriptions === 1) /**
             * If there's only a single handler we can just call it without invoking a loop.
             */ this.subscriptions[0](a, b, c);
                else for(var i = 0; i < numSubscriptions; i++){
                    /**
                 * Check whether the handler exists before firing as it's possible
                 * the subscriptions were modified during this loop running.
                 */ var handler = this.subscriptions[i];
                    handler && handler(a, b, c);
                }
            }
        },
        {
            key: "getSize",
            value: function getSize() {
                return this.subscriptions.length;
            }
        },
        {
            key: "clear",
            value: function clear() {
                this.subscriptions.length = 0;
            }
        }
    ]);
    return SubscriptionManager;
}();

});
parcelRegister("28QzH", function(module, exports) {

$parcel$export(module.exports, "addUniqueItem", function () { return $cb71288206c1e755$export$20e507e47fae79fd; });
$parcel$export(module.exports, "removeItem", function () { return $cb71288206c1e755$export$fe2d9b4e03920b4c; });

var $2nwvT = parcelRequire("2nwvT");

var $l8eKX = parcelRequire("l8eKX");
function $cb71288206c1e755$export$20e507e47fae79fd(arr, item) {
    if (arr.indexOf(item) === -1) arr.push(item);
}
function $cb71288206c1e755$export$fe2d9b4e03920b4c(arr, item) {
    var index = arr.indexOf(item);
    if (index > -1) arr.splice(index, 1);
}
// Adapted from array-move
function $cb71288206c1e755$export$ec937e64de6c1257(param, fromIndex, toIndex) {
    var _param = (0, $l8eKX._)(param), arr = _param.slice(0);
    var startIndex = fromIndex < 0 ? arr.length + fromIndex : fromIndex;
    if (startIndex >= 0 && startIndex < arr.length) {
        var endIndex = toIndex < 0 ? arr.length + toIndex : toIndex;
        var _arr_splice = (0, $2nwvT._)(arr.splice(fromIndex, 1), 1), item = _arr_splice[0];
        arr.splice(endIndex, 0, item);
    }
    return arr;
}

});


parcelRegister("cYmCu", function(module, exports) {

$parcel$export(module.exports, "velocityPerSecond", function () { return $6ef563b996b1332d$export$eab0632f7ad4f9d7; });
/*
  Convert velocity into velocity per second

  @param [number]: Unit per frame
  @param [number]: Frame duration in ms
*/ function $6ef563b996b1332d$export$eab0632f7ad4f9d7(velocity, frameDuration) {
    return frameDuration ? velocity * (1000 / frameDuration) : 0;
}

});

parcelRegister("j716H", function(module, exports) {

$parcel$export(module.exports, "time", function () { return $00e8af4f7685339c$export$2da9be4cfdb689b1; });

var $7mUth = parcelRequire("7mUth");

var $8oVcc = parcelRequire("8oVcc");
var $00e8af4f7685339c$var$now;
function $00e8af4f7685339c$var$clearTime() {
    $00e8af4f7685339c$var$now = undefined;
}
/**
 * An eventloop-synchronous alternative to performance.now().
 *
 * Ensures that time measurements remain consistent within a synchronous context.
 * Usually calling performance.now() twice within the same synchronous context
 * will return different values which isn't useful for animations when we're usually
 * trying to sync animations to the same frame.
 */ var $00e8af4f7685339c$export$2da9be4cfdb689b1 = {
    now: function() {
        if ($00e8af4f7685339c$var$now === undefined) $00e8af4f7685339c$export$2da9be4cfdb689b1.set((0, $8oVcc.frameData).isProcessing || (0, $7mUth.MotionGlobalConfig).useManualTiming ? (0, $8oVcc.frameData).timestamp : performance.now());
        return $00e8af4f7685339c$var$now;
    },
    set: function(newTime) {
        $00e8af4f7685339c$var$now = newTime;
        queueMicrotask($00e8af4f7685339c$var$clearTime);
    }
};

});


parcelRegister("iXrcD", function(module, exports) {

$parcel$export(module.exports, "featureDefinitions", function () { return $62bab7f5fc850b6e$export$65570e08d843624d; });
var $62bab7f5fc850b6e$var$_loop = function(key) {
    $62bab7f5fc850b6e$export$65570e08d843624d[key] = {
        isEnabled: function(props) {
            return $62bab7f5fc850b6e$var$featureProps[key].some(function(name) {
                return !!props[name];
            });
        }
    };
};
var $62bab7f5fc850b6e$var$featureProps = {
    animation: [
        "animate",
        "variants",
        "whileHover",
        "whileTap",
        "exit",
        "whileInView",
        "whileFocus",
        "whileDrag"
    ],
    exit: [
        "exit"
    ],
    drag: [
        "drag",
        "dragControls"
    ],
    focus: [
        "whileFocus"
    ],
    hover: [
        "whileHover",
        "onHoverStart",
        "onHoverEnd"
    ],
    tap: [
        "whileTap",
        "onTap",
        "onTapStart",
        "onTapCancel"
    ],
    pan: [
        "onPan",
        "onPanStart",
        "onPanSessionStart",
        "onPanEnd"
    ],
    inView: [
        "whileInView",
        "onViewportEnter",
        "onViewportLeave"
    ],
    layout: [
        "layout",
        "layoutId"
    ]
};
var $62bab7f5fc850b6e$export$65570e08d843624d = {};
for(var $62bab7f5fc850b6e$var$key in $62bab7f5fc850b6e$var$featureProps)$62bab7f5fc850b6e$var$_loop($62bab7f5fc850b6e$var$key);

});

parcelRegister("60wa2", function(module, exports) {

$parcel$export(module.exports, "createDelta", function () { return $663055bf986a28b3$export$3d227df54007d73a; });
$parcel$export(module.exports, "createBox", function () { return $663055bf986a28b3$export$6459fc9e86be362e; });
var $663055bf986a28b3$export$ff25708b37f72782 = function() {
    return {
        translate: 0,
        scale: 1,
        origin: 0,
        originPoint: 0
    };
};
var $663055bf986a28b3$export$3d227df54007d73a = function() {
    return {
        x: $663055bf986a28b3$export$ff25708b37f72782(),
        y: $663055bf986a28b3$export$ff25708b37f72782()
    };
};
var $663055bf986a28b3$export$6db76765312617ac = function() {
    return {
        min: 0,
        max: 0
    };
};
var $663055bf986a28b3$export$6459fc9e86be362e = function() {
    return {
        x: $663055bf986a28b3$export$6db76765312617ac(),
        y: $663055bf986a28b3$export$6db76765312617ac()
    };
};

});

parcelRegister("gihmc", function(module, exports) {

$parcel$export(module.exports, "initPrefersReducedMotion", function () { return $3a596c09e0fdcb12$export$ca9f41fb23dded3d; });

var $01Br7 = parcelRequire("01Br7");

var $dnFPB = parcelRequire("dnFPB");
function $3a596c09e0fdcb12$export$ca9f41fb23dded3d() {
    (0, $dnFPB.hasReducedMotionListener).current = true;
    if (!(0, $01Br7.isBrowser)) return;
    if (window.matchMedia) {
        var motionMediaQuery = window.matchMedia("(prefers-reduced-motion)");
        var setReducedMotionPreferences = function() {
            return (0, $dnFPB.prefersReducedMotion).current = motionMediaQuery.matches;
        };
        motionMediaQuery.addEventListener("change", setReducedMotionPreferences);
        setReducedMotionPreferences();
    } else (0, $dnFPB.prefersReducedMotion).current = false;
}

});
parcelRegister("01Br7", function(module, exports) {

$parcel$export(module.exports, "isBrowser", function () { return $d40be6a98a50f608$export$4e09c449d6c407f7; });
var $d40be6a98a50f608$export$4e09c449d6c407f7 = typeof window !== "undefined";

});

parcelRegister("dnFPB", function(module, exports) {

$parcel$export(module.exports, "prefersReducedMotion", function () { return $2e86db59cd05f2ca$export$ff7706047246b98b; });
$parcel$export(module.exports, "hasReducedMotionListener", function () { return $2e86db59cd05f2ca$export$6476d16e2fd2d0db; });
// Does this device prefer reduced motion? Returns `null` server-side.
var $2e86db59cd05f2ca$export$ff7706047246b98b = {
    current: null
};
var $2e86db59cd05f2ca$export$6476d16e2fd2d0db = {
    current: false
};

});


parcelRegister("aFm76", function(module, exports) {

$parcel$export(module.exports, "visualElementStore", function () { return $4f7e1a63f43516e5$export$bc2a978a17abfdde; });
var $4f7e1a63f43516e5$export$bc2a978a17abfdde = new WeakMap();

});

parcelRegister("bXOiK", function(module, exports) {

$parcel$export(module.exports, "isControllingVariants", function () { return $0b7e066ec777c86a$export$4b3c3bd8d910d78d; });
$parcel$export(module.exports, "isVariantNode", function () { return $0b7e066ec777c86a$export$ce46fa4165cdec40; });

var $45xPy = parcelRequire("45xPy");

var $6WBVt = parcelRequire("6WBVt");

var $4hPGR = parcelRequire("4hPGR");
function $0b7e066ec777c86a$export$4b3c3bd8d910d78d(props) {
    return (0, $45xPy.isAnimationControls)(props.animate) || (0, $4hPGR.variantProps).some(function(name) {
        return (0, $6WBVt.isVariantLabel)(props[name]);
    });
}
function $0b7e066ec777c86a$export$ce46fa4165cdec40(props) {
    return Boolean($0b7e066ec777c86a$export$4b3c3bd8d910d78d(props) || props.variants);
}

});
parcelRegister("45xPy", function(module, exports) {

$parcel$export(module.exports, "isAnimationControls", function () { return $4ee7515c1ffdc148$export$aa71198ceeaf53ce; });

var $bJtXW = parcelRequire("bJtXW");
function $4ee7515c1ffdc148$export$aa71198ceeaf53ce(v) {
    return v !== null && (typeof v === "undefined" ? "undefined" : (0, $bJtXW._)(v)) === "object" && typeof v.start === "function";
}

});

parcelRegister("6WBVt", function(module, exports) {

$parcel$export(module.exports, "isVariantLabel", function () { return $e0f40a620bc45744$export$720b90e312cea233; });
/**
 * Decides if the supplied variable is variant label
 */ function $e0f40a620bc45744$export$720b90e312cea233(v) {
    return typeof v === "string" || Array.isArray(v);
}

});

parcelRegister("4hPGR", function(module, exports) {

$parcel$export(module.exports, "variantPriorityOrder", function () { return $1500c6a0728839ac$export$16e45afcc206d3a8; });
$parcel$export(module.exports, "variantProps", function () { return $1500c6a0728839ac$export$1405a65085f40b9; });

var $2us1u = parcelRequire("2us1u");
var $1500c6a0728839ac$export$16e45afcc206d3a8 = [
    "animate",
    "whileInView",
    "whileFocus",
    "whileHover",
    "whileTap",
    "whileDrag",
    "exit"
];
var $1500c6a0728839ac$export$1405a65085f40b9 = [
    "initial"
].concat((0, $2us1u._)($1500c6a0728839ac$export$16e45afcc206d3a8));

});


parcelRegister("lCxEz", function(module, exports) {

$parcel$export(module.exports, "updateMotionValuesFromProps", function () { return $d0b6ac0904d794c4$export$9a552858d5197f6e; });

var $4drXU = parcelRequire("4drXU");
var $4SyWW = parcelRequire("4SyWW");
function $d0b6ac0904d794c4$export$9a552858d5197f6e(element, next, prev) {
    for(var key in next){
        var nextValue = next[key];
        var prevValue = prev[key];
        if ((0, $4drXU.isMotionValue)(nextValue)) /**
             * If this is a motion value found in props or style, we want to add it
             * to our visual element's motion value map.
             */ element.addValue(key, nextValue);
        else if ((0, $4drXU.isMotionValue)(prevValue)) /**
             * If we're swapping from a motion value to a static value,
             * create a new motion value from that
             */ element.addValue(key, (0, $4SyWW.motionValue)(nextValue, {
            owner: element
        }));
        else if (prevValue !== nextValue) {
            /**
             * If this is a flat value that has changed, update the motion value
             * or create one if it doesn't exist. We only want to do this if we're
             * not handling the value with our animation state.
             */ if (element.hasValue(key)) {
                var existingValue = element.getValue(key);
                if (existingValue.liveStyle === true) existingValue.jump(nextValue);
                else if (!existingValue.hasAnimated) existingValue.set(nextValue);
            } else {
                var latestValue = element.getStaticValue(key);
                element.addValue(key, (0, $4SyWW.motionValue)(latestValue !== undefined ? latestValue : nextValue, {
                    owner: element
                }));
            }
        }
    }
    // Handle removed values
    for(var key1 in prev)if (next[key1] === undefined) element.removeValue(key1);
    return next;
}

});

parcelRegister("44IJv", function(module, exports) {

$parcel$export(module.exports, "resolveVariantFromProps", function () { return $f00bc84c0df1779b$export$d68f140c4d9b48bc; });

var $2nwvT = parcelRequire("2nwvT");
function $f00bc84c0df1779b$var$getValueState(visualElement) {
    var state = [
        {},
        {}
    ];
    visualElement === null || visualElement === void 0 ? void 0 : visualElement.values.forEach(function(value, key) {
        state[0][key] = value.get();
        state[1][key] = value.getVelocity();
    });
    return state;
}
function $f00bc84c0df1779b$export$d68f140c4d9b48bc(props, definition, custom, visualElement) {
    /**
     * If the variant definition is a function, resolve.
     */ if (typeof definition === "function") {
        var _getValueState = (0, $2nwvT._)($f00bc84c0df1779b$var$getValueState(visualElement), 2), current = _getValueState[0], velocity = _getValueState[1];
        definition = definition(custom !== undefined ? custom : props.custom, current, velocity);
    }
    /**
     * If the variant definition is a variant label, or
     * the function returned a variant label, resolve.
     */ if (typeof definition === "string") definition = props.variants && props.variants[definition];
    /**
     * At this point we've resolved both functions and variant labels,
     * but the resolved variant label might itself have been a function.
     * If so, resolve. This can only have returned a valid target object.
     */ if (typeof definition === "function") {
        var _getValueState1 = (0, $2nwvT._)($f00bc84c0df1779b$var$getValueState(visualElement), 2), current1 = _getValueState1[0], velocity1 = _getValueState1[1];
        definition = definition(custom !== undefined ? custom : props.custom, current1, velocity1);
    }
    return definition;
}

});



parcelRegister("bfKTA", function(module, exports) {

$parcel$export(module.exports, "buildHTMLStyles", function () { return $13cbff5e14cbcd80$export$bb517f8b40f8e99d; });

var $buWS5 = parcelRequire("buWS5");
var $5nvLr = parcelRequire("5nvLr");
var $BNtOZ = parcelRequire("BNtOZ");
var $e6FP6 = parcelRequire("e6FP6");

var $2KKIC = parcelRequire("2KKIC");
function $13cbff5e14cbcd80$export$bb517f8b40f8e99d(state, latestValues, transformTemplate) {
    var style = state.style, vars = state.vars, transformOrigin = state.transformOrigin;
    // Track whether we encounter any transform or transformOrigin values.
    var hasTransform = false;
    var hasTransformOrigin = false;
    /**
     * Loop over all our latest animated values and decide whether to handle them
     * as a style or CSS variable.
     *
     * Transforms and transform origins are kept separately for further processing.
     */ for(var key in latestValues){
        var value = latestValues[key];
        if ((0, $e6FP6.transformProps).has(key)) {
            // If this is a transform, flag to enable further transform processing
            hasTransform = true;
            continue;
        } else if ((0, $5nvLr.isCSSVariableName)(key)) {
            vars[key] = value;
            continue;
        } else {
            // Convert the value to its default value type, ie 0 -> "0px"
            var valueAsType = (0, $buWS5.getValueAsType)(value, (0, $BNtOZ.numberValueTypes)[key]);
            if (key.startsWith("origin")) {
                // If this is a transform origin, flag and enable further transform-origin processing
                hasTransformOrigin = true;
                transformOrigin[key] = valueAsType;
            } else style[key] = valueAsType;
        }
    }
    if (!latestValues.transform) {
        if (hasTransform || transformTemplate) style.transform = (0, $2KKIC.buildTransform)(latestValues, state.transform, transformTemplate);
        else if (style.transform) /**
             * If we have previously created a transform but currently don't have any,
             * reset transform style to none.
             */ style.transform = "none";
    }
    /**
     * Build a transformOrigin style. Uses the same defaults as the browser for
     * undefined origins.
     */ if (hasTransformOrigin) {
        var _transformOrigin_originX = transformOrigin.originX, originX = _transformOrigin_originX === void 0 ? "50%" : _transformOrigin_originX, _transformOrigin_originY = transformOrigin.originY, originY = _transformOrigin_originY === void 0 ? "50%" : _transformOrigin_originY, _transformOrigin_originZ = transformOrigin.originZ, originZ = _transformOrigin_originZ === void 0 ? 0 : _transformOrigin_originZ;
        style.transformOrigin = "".concat(originX, " ").concat(originY, " ").concat(originZ);
    }
}

});
parcelRegister("buWS5", function(module, exports) {

$parcel$export(module.exports, "getValueAsType", function () { return $ba4abe5e39cb8ce0$export$453ef540a9a1bd6b; });
/**
 * Provided a value and a ValueType, returns the value as that value type.
 */ var $ba4abe5e39cb8ce0$export$453ef540a9a1bd6b = function(value, type) {
    return type && typeof value === "number" ? type.transform(value) : value;
};

});

parcelRegister("2KKIC", function(module, exports) {

$parcel$export(module.exports, "buildTransform", function () { return $81f9be88174867c9$export$bdc96e0d5c8f914; });

var $buWS5 = parcelRequire("buWS5");
var $BNtOZ = parcelRequire("BNtOZ");
var $e6FP6 = parcelRequire("e6FP6");
var $81f9be88174867c9$var$translateAlias = {
    x: "translateX",
    y: "translateY",
    z: "translateZ",
    transformPerspective: "perspective"
};
var $81f9be88174867c9$var$numTransforms = (0, $e6FP6.transformPropOrder).length;
/**
 * Build a CSS transform style from individual x/y/scale etc properties.
 *
 * This outputs with a default order of transforms/scales/rotations, this can be customised by
 * providing a transformTemplate function.
 */ function $81f9be88174867c9$export$bdc96e0d5c8f914(latestValues, transform, transformTemplate) {
    // The transform string we're going to build into.
    var transformString = "";
    var transformIsDefault = true;
    /**
     * Loop over all possible transforms in order, adding the ones that
     * are present to the transform string.
     */ for(var i = 0; i < $81f9be88174867c9$var$numTransforms; i++){
        var key = (0, $e6FP6.transformPropOrder)[i];
        var value = latestValues[key];
        if (value === undefined) continue;
        var valueIsDefault = true;
        if (typeof value === "number") valueIsDefault = value === (key.startsWith("scale") ? 1 : 0);
        else valueIsDefault = parseFloat(value) === 0;
        if (!valueIsDefault || transformTemplate) {
            var valueAsType = (0, $buWS5.getValueAsType)(value, (0, $BNtOZ.numberValueTypes)[key]);
            if (!valueIsDefault) {
                transformIsDefault = false;
                var transformName = $81f9be88174867c9$var$translateAlias[key] || key;
                transformString += "".concat(transformName, "(").concat(valueAsType, ") ");
            }
            if (transformTemplate) transform[key] = valueAsType;
        }
    }
    transformString = transformString.trim();
    // If we have a custom `transform` template, pass our transform values and
    // generated transformString to that before returning
    if (transformTemplate) transformString = transformTemplate(transform, transformIsDefault ? "" : transformString);
    else if (transformIsDefault) transformString = "none";
    return transformString;
}

});


parcelRegister("aZcpS", function(module, exports) {

$parcel$export(module.exports, "renderHTML", function () { return $0ec3e01a84905c76$export$1a32bf6229c258c0; });
function $0ec3e01a84905c76$export$1a32bf6229c258c0(element, param, styleProp, projection) {
    var style = param.style, vars = param.vars;
    var elementStyle = element.style;
    var key;
    for(key in style)// CSSStyleDeclaration has [index: number]: string; in the types, so we use that as key type.
    elementStyle[key] = style[key];
    // Write projection styles directly to element style
    projection === null || projection === void 0 ? void 0 : projection.applyProjectionStyles(elementStyle, styleProp);
    for(key in vars)// Loop over any CSS variables and assign those.
    // They can only be assigned using `setProperty`.
    elementStyle.setProperty(key, vars[key]);
}

});

parcelRegister("367jF", function(module, exports) {

$parcel$export(module.exports, "scrapeMotionValuesFromProps", function () { return $4ba2c6b29cfaba58$export$16da615486abaa45; });

var $4drXU = parcelRequire("4drXU");

var $94pNX = parcelRequire("94pNX");
function $4ba2c6b29cfaba58$export$16da615486abaa45(props, prevProps, visualElement) {
    var _visualElement_getValue;
    var style = props.style;
    var newValues = {};
    for(var key in style)if ((0, $4drXU.isMotionValue)(style[key]) || prevProps.style && (0, $4drXU.isMotionValue)(prevProps.style[key]) || (0, $94pNX.isForcedMotionValue)(key, props) || (visualElement === null || visualElement === void 0 ? void 0 : (_visualElement_getValue = visualElement.getValue(key)) === null || _visualElement_getValue === void 0 ? void 0 : _visualElement_getValue.liveStyle) !== undefined) newValues[key] = style[key];
    return newValues;
}

});
parcelRegister("94pNX", function(module, exports) {

$parcel$export(module.exports, "isForcedMotionValue", function () { return $3f8ee39b82ceb57a$export$6d27ce8e3de1c3cf; });

var $e6FP6 = parcelRequire("e6FP6");

var $dssUL = parcelRequire("dssUL");
function $3f8ee39b82ceb57a$export$6d27ce8e3de1c3cf(key, param) {
    var layout = param.layout, layoutId = param.layoutId;
    return (0, $e6FP6.transformProps).has(key) || key.startsWith("origin") || (layout || layoutId !== undefined) && (!!(0, $dssUL.scaleCorrectors)[key] || key === "opacity");
}

});
parcelRegister("dssUL", function(module, exports) {

$parcel$export(module.exports, "scaleCorrectors", function () { return $ae2875b24a733eed$export$91ddd985b97788d1; });

var $joFW3 = parcelRequire("joFW3");

var $90FDw = parcelRequire("90FDw");

var $5nvLr = parcelRequire("5nvLr");

var $h5F62 = parcelRequire("h5F62");

var $04biR = parcelRequire("04biR");
var $ae2875b24a733eed$export$91ddd985b97788d1 = {
    borderRadius: (0, $90FDw._)((0, $joFW3._)({}, (0, $h5F62.correctBorderRadius)), {
        applyTo: [
            "borderTopLeftRadius",
            "borderTopRightRadius",
            "borderBottomLeftRadius",
            "borderBottomRightRadius"
        ]
    }),
    borderTopLeftRadius: (0, $h5F62.correctBorderRadius),
    borderTopRightRadius: (0, $h5F62.correctBorderRadius),
    borderBottomLeftRadius: (0, $h5F62.correctBorderRadius),
    borderBottomRightRadius: (0, $h5F62.correctBorderRadius),
    boxShadow: (0, $04biR.correctBoxShadow)
};
function $ae2875b24a733eed$export$de9e7791c71225fd(correctors) {
    for(var key in correctors){
        $ae2875b24a733eed$export$91ddd985b97788d1[key] = correctors[key];
        if ((0, $5nvLr.isCSSVariableName)(key)) $ae2875b24a733eed$export$91ddd985b97788d1[key].isCSSVariable = true;
    }
}

});
parcelRegister("h5F62", function(module, exports) {

$parcel$export(module.exports, "correctBorderRadius", function () { return $a976d9639d6fe080$export$5eafb6257a5844c; });

var $aUTIu = parcelRequire("aUTIu");
function $a976d9639d6fe080$export$fafff692be55225d(pixels, axis) {
    if (axis.max === axis.min) return 0;
    return pixels / (axis.max - axis.min) * 100;
}
/**
 * We always correct borderRadius as a percentage rather than pixels to reduce paints.
 * For example, if you are projecting a box that is 100px wide with a 10px borderRadius
 * into a box that is 200px wide with a 20px borderRadius, that is actually a 10%
 * borderRadius in both states. If we animate between the two in pixels that will trigger
 * a paint each time. If we animate between the two in percentage we'll avoid a paint.
 */ var $a976d9639d6fe080$export$5eafb6257a5844c = {
    correct: function(latest, node) {
        if (!node.target) return latest;
        /**
         * If latest is a string, if it's a percentage we can return immediately as it's
         * going to be stretched appropriately. Otherwise, if it's a pixel, convert it to a number.
         */ if (typeof latest === "string") {
            if ((0, $aUTIu.px).test(latest)) latest = parseFloat(latest);
            else return latest;
        }
        /**
         * If latest is a number, it's a pixel value. We use the current viewportBox to calculate that
         * pixel value as a percentage of each axis
         */ var x = $a976d9639d6fe080$export$fafff692be55225d(latest, node.target.x);
        var y = $a976d9639d6fe080$export$fafff692be55225d(latest, node.target.y);
        return "".concat(x, "% ").concat(y, "%");
    }
};

});

parcelRegister("04biR", function(module, exports) {

$parcel$export(module.exports, "correctBoxShadow", function () { return $84c3c53ff0b05577$export$eb0bc629e74dcf8; });

var $8S0wI = parcelRequire("8S0wI");
var $83rca = parcelRequire("83rca");
var $84c3c53ff0b05577$export$eb0bc629e74dcf8 = {
    correct: function(latest, param) {
        var treeScale = param.treeScale, projectionDelta = param.projectionDelta;
        var original = latest;
        var shadow = (0, $8S0wI.complex).parse(latest);
        // TODO: Doesn't support multiple shadows
        if (shadow.length > 5) return original;
        var template = (0, $8S0wI.complex).createTransformer(latest);
        var offset = typeof shadow[0] !== "number" ? 1 : 0;
        // Calculate the overall context scale
        var xScale = projectionDelta.x.scale * treeScale.x;
        var yScale = projectionDelta.y.scale * treeScale.y;
        shadow[0 + offset] /= xScale;
        shadow[1 + offset] /= yScale;
        /**
         * Ideally we'd correct x and y scales individually, but because blur and
         * spread apply to both we have to take a scale average and apply that instead.
         * We could potentially improve the outcome of this by incorporating the ratio between
         * the two scales.
         */ var averageScale = (0, $83rca.mixNumber)(xScale, yScale, 0.5);
        // Blur
        if (typeof shadow[2 + offset] === "number") shadow[2 + offset] /= averageScale;
        // Spread
        if (typeof shadow[3 + offset] === "number") shadow[3 + offset] /= averageScale;
        return template(shadow);
    }
};

});





parcelRegister("3KXBC", function(module, exports) {

$parcel$export(module.exports, "SVGVisualElement", function () { return $538966105ebede37$export$86bcdffbaf733d84; });

var $f3Okx = parcelRequire("f3Okx");

var $grujF = parcelRequire("grujF");

var $dhMkv = parcelRequire("dhMkv");

var $bxomo = parcelRequire("bxomo");

var $gyGuQ = parcelRequire("gyGuQ");

var $j6Mzi = parcelRequire("j6Mzi");

var $eUWWD = parcelRequire("eUWWD");
var $e6FP6 = parcelRequire("e6FP6");

var $60wa2 = parcelRequire("60wa2");

var $i3ue5 = parcelRequire("i3ue5");

var $aUgjR = parcelRequire("aUgjR");

var $2JRsN = parcelRequire("2JRsN");

var $a80tk = parcelRequire("a80tk");

var $4FZiX = parcelRequire("4FZiX");

var $I1uhy = parcelRequire("I1uhy");

var $e0WAH = parcelRequire("e0WAH");
var $538966105ebede37$export$86bcdffbaf733d84 = /*#__PURE__*/ function(DOMVisualElement) {
    "use strict";
    (0, $j6Mzi._)(SVGVisualElement, DOMVisualElement);
    function SVGVisualElement() {
        (0, $grujF._)(this, SVGVisualElement);
        var _this;
        _this = (0, $f3Okx._)(this, SVGVisualElement, arguments);
        _this.type = "svg";
        _this.isSVGTag = false;
        _this.measureInstanceViewportBox = (0, $60wa2.createBox);
        return _this;
    }
    (0, $dhMkv._)(SVGVisualElement, [
        {
            key: "getBaseTargetFromProps",
            value: function getBaseTargetFromProps(props, key) {
                return props[key];
            }
        },
        {
            key: "readValueFromInstance",
            value: function readValueFromInstance(instance, key) {
                if ((0, $e6FP6.transformProps).has(key)) {
                    var defaultType = (0, $eUWWD.getDefaultValueType)(key);
                    return defaultType ? defaultType.default || 0 : 0;
                }
                key = !(0, $a80tk.camelCaseAttributes).has(key) ? (0, $aUgjR.camelToDash)(key) : key;
                return instance.getAttribute(key);
            }
        },
        {
            key: "scrapeMotionValuesFromProps",
            value: function scrapeMotionValuesFromProps1(props, prevProps, visualElement) {
                return (0, $e0WAH.scrapeMotionValuesFromProps)(props, prevProps, visualElement);
            }
        },
        {
            key: "build",
            value: function build(renderState, latestValues, props) {
                (0, $2JRsN.buildSVGAttrs)(renderState, latestValues, this.isSVGTag, props.transformTemplate, props.style);
            }
        },
        {
            key: "renderInstance",
            value: function renderInstance(instance, renderState, styleProp, projection) {
                (0, $I1uhy.renderSVG)(instance, renderState, styleProp, projection);
            }
        },
        {
            key: "mount",
            value: function mount(instance) {
                this.isSVGTag = (0, $4FZiX.isSVGTag)(instance.tagName);
                (0, $bxomo._)((0, $gyGuQ._)(SVGVisualElement.prototype), "mount", this).call(this, instance);
            }
        }
    ]);
    return SVGVisualElement;
}((0, $i3ue5.DOMVisualElement));

});
parcelRegister("aUgjR", function(module, exports) {

$parcel$export(module.exports, "camelToDash", function () { return $954f6dcdfd539927$export$9fd24a634729c672; });
/**
 * Convert camelCase to dash-case properties.
 */ var $954f6dcdfd539927$export$9fd24a634729c672 = function(str) {
    return str.replace(RegExp("([a-z])([A-Z])", "gu"), "$1-$2").toLowerCase();
};

});

parcelRegister("2JRsN", function(module, exports) {

$parcel$export(module.exports, "buildSVGAttrs", function () { return $91df2c47b15ea8f0$export$5475d24f125d7053; });

var $buaX5 = parcelRequire("buaX5");

var $bfKTA = parcelRequire("bfKTA");

var $7xSDT = parcelRequire("7xSDT");
/**
 * Build SVG visual attributes, like cx and style.transform
 */ function $91df2c47b15ea8f0$export$5475d24f125d7053(state, _param, isSVGTag, transformTemplate, styleProp) {
    var attrX = _param.attrX, attrY = _param.attrY, attrScale = _param.attrScale, pathLength = _param.pathLength, _param_pathSpacing = _param.pathSpacing, pathSpacing = _param_pathSpacing === void 0 ? 1 : _param_pathSpacing, _param_pathOffset = _param.pathOffset, pathOffset = _param_pathOffset === void 0 ? 0 : _param_pathOffset, latest = (0, $buaX5._)(_param, [
        "attrX",
        "attrY",
        "attrScale",
        "pathLength",
        "pathSpacing",
        "pathOffset"
    ]);
    (0, $bfKTA.buildHTMLStyles)(state, latest, transformTemplate);
    /**
     * For svg tags we just want to make sure viewBox is animatable and treat all the styles
     * as normal HTML tags.
     */ if (isSVGTag) {
        if (state.style.viewBox) state.attrs.viewBox = state.style.viewBox;
        return;
    }
    state.attrs = state.style;
    state.style = {};
    var attrs = state.attrs, style = state.style;
    /**
     * However, we apply transforms as CSS transforms.
     * So if we detect a transform, transformOrigin we take it from attrs and copy it into style.
     */ if (attrs.transform) {
        style.transform = attrs.transform;
        delete attrs.transform;
    }
    if (style.transform || attrs.transformOrigin) {
        var _attrs_transformOrigin;
        style.transformOrigin = (_attrs_transformOrigin = attrs.transformOrigin) !== null && _attrs_transformOrigin !== void 0 ? _attrs_transformOrigin : "50% 50%";
        delete attrs.transformOrigin;
    }
    if (style.transform) {
        var _styleProp_transformBox;
        /**
         * SVG's element transform-origin uses its own median as a reference.
         * Therefore, transformBox becomes a fill-box
         */ style.transformBox = (_styleProp_transformBox = styleProp === null || styleProp === void 0 ? void 0 : styleProp.transformBox) !== null && _styleProp_transformBox !== void 0 ? _styleProp_transformBox : "fill-box";
        delete attrs.transformBox;
    }
    // Render attrX/attrY/attrScale as attributes
    if (attrX !== undefined) attrs.x = attrX;
    if (attrY !== undefined) attrs.y = attrY;
    if (attrScale !== undefined) attrs.scale = attrScale;
    // Build SVG path if one has been defined
    if (pathLength !== undefined) (0, $7xSDT.buildSVGPath)(attrs, pathLength, pathSpacing, pathOffset, false);
}

});
parcelRegister("7xSDT", function(module, exports) {

$parcel$export(module.exports, "buildSVGPath", function () { return $2b9fe70632b6840d$export$311b43f666da1d82; });

var $aUTIu = parcelRequire("aUTIu");
var $2b9fe70632b6840d$var$dashKeys = {
    offset: "stroke-dashoffset",
    array: "stroke-dasharray"
};
var $2b9fe70632b6840d$var$camelKeys = {
    offset: "strokeDashoffset",
    array: "strokeDasharray"
};
/**
 * Build SVG path properties. Uses the path's measured length to convert
 * our custom pathLength, pathSpacing and pathOffset into stroke-dashoffset
 * and stroke-dasharray attributes.
 *
 * This function is mutative to reduce per-frame GC.
 */ function $2b9fe70632b6840d$export$311b43f666da1d82(attrs, length) {
    var spacing = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : 1, offset = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : 0, useDashCase = arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : true;
    // Normalise path length by setting SVG attribute pathLength to 1
    attrs.pathLength = 1;
    // We use dash case when setting attributes directly to the DOM node and camel case
    // when defining props on a React component.
    var keys = useDashCase ? $2b9fe70632b6840d$var$dashKeys : $2b9fe70632b6840d$var$camelKeys;
    // Build the dash offset
    attrs[keys.offset] = (0, $aUTIu.px).transform(-offset);
    // Build the dash array
    var pathLength = (0, $aUTIu.px).transform(length);
    var pathSpacing = (0, $aUTIu.px).transform(spacing);
    attrs[keys.array] = "".concat(pathLength, " ").concat(pathSpacing);
}

});


parcelRegister("a80tk", function(module, exports) {

$parcel$export(module.exports, "camelCaseAttributes", function () { return $944d9d7404e87d24$export$28931db5d57958e5; });
/**
 * A set of attribute names that are always read/written as camel case.
 */ var $944d9d7404e87d24$export$28931db5d57958e5 = new Set([
    "baseFrequency",
    "diffuseConstant",
    "kernelMatrix",
    "kernelUnitLength",
    "keySplines",
    "keyTimes",
    "limitingConeAngle",
    "markerHeight",
    "markerWidth",
    "numOctaves",
    "targetX",
    "targetY",
    "surfaceScale",
    "specularConstant",
    "specularExponent",
    "stdDeviation",
    "tableValues",
    "viewBox",
    "gradientTransform",
    "pathLength",
    "startOffset",
    "textLength",
    "lengthAdjust"
]);

});

parcelRegister("4FZiX", function(module, exports) {

$parcel$export(module.exports, "isSVGTag", function () { return $baea5e7697904cc6$export$6328ce7565ea1049; });
var $baea5e7697904cc6$export$6328ce7565ea1049 = function(tag) {
    return typeof tag === "string" && tag.toLowerCase() === "svg";
};

});

parcelRegister("I1uhy", function(module, exports) {

$parcel$export(module.exports, "renderSVG", function () { return $b00285c0951e7b7f$export$c5f8399d19a7394b; });

var $aUgjR = parcelRequire("aUgjR");

var $aZcpS = parcelRequire("aZcpS");

var $a80tk = parcelRequire("a80tk");
function $b00285c0951e7b7f$export$c5f8399d19a7394b(element, renderState, _styleProp, projection) {
    (0, $aZcpS.renderHTML)(element, renderState, undefined, projection);
    for(var key in renderState.attrs)element.setAttribute(!(0, $a80tk.camelCaseAttributes).has(key) ? (0, $aUgjR.camelToDash)(key) : key, renderState.attrs[key]);
}

});

parcelRegister("e0WAH", function(module, exports) {

$parcel$export(module.exports, "scrapeMotionValuesFromProps", function () { return $a6468c62becd11cf$export$16da615486abaa45; });

var $4drXU = parcelRequire("4drXU");
var $e6FP6 = parcelRequire("e6FP6");

var $367jF = parcelRequire("367jF");
function $a6468c62becd11cf$export$16da615486abaa45(props, prevProps, visualElement) {
    var newValues = (0, $367jF.scrapeMotionValuesFromProps)(props, prevProps, visualElement);
    for(var key in props)if ((0, $4drXU.isMotionValue)(props[key]) || (0, $4drXU.isMotionValue)(prevProps[key])) {
        var targetKey = (0, $e6FP6.transformPropOrder).indexOf(key) !== -1 ? "attr" + key.charAt(0).toUpperCase() + key.substring(1) : key;
        newValues[targetKey] = props[key];
    }
    return newValues;
}

});


parcelRegister("jhf4j", function(module, exports) {

$parcel$export(module.exports, "isSVGComponent", function () { return $d3214709b7c7176a$export$88f3fc2fd3766989; });

var $bBeao = parcelRequire("bBeao");
function $d3214709b7c7176a$export$88f3fc2fd3766989(Component) {
    if (/**
     * If it's not a string, it's a custom React component. Currently we only support
     * HTML custom React components.
     */ typeof Component !== "string" || /**
         * If it contains a dash, the element is a custom HTML webcomponent.
         */ Component.includes("-")) return false;
    else if (/**
     * If it's in our list of lowercase SVG tags, it's an SVG component
     */ (0, $bBeao.lowercaseSVGElements).indexOf(Component) > -1 || /**
         * If it contains a capital letter, it's an SVG component
         */ RegExp("[A-Z]", "u").test(Component)) return true;
    return false;
}

});
parcelRegister("bBeao", function(module, exports) {

$parcel$export(module.exports, "lowercaseSVGElements", function () { return $78477f61f0d85119$export$40209c4c512158e6; });
/**
 * We keep these listed separately as we use the lowercase tag names as part
 * of the runtime bundle to detect SVG components
 */ var $78477f61f0d85119$export$40209c4c512158e6 = [
    "animate",
    "circle",
    "defs",
    "desc",
    "ellipse",
    "g",
    "image",
    "line",
    "filter",
    "marker",
    "mask",
    "metadata",
    "path",
    "pattern",
    "polygon",
    "polyline",
    "rect",
    "stop",
    "switch",
    "symbol",
    "svg",
    "text",
    "tspan",
    "use",
    "view"
];

});



parcelRegister("a0J91", function(module, exports) {

$parcel$export(module.exports, "createMotionProxy", function () { return $6f291ce41df76c58$export$a28d6df673050e18; });


var $kvKma = parcelRequire("kvKma");
function $6f291ce41df76c58$export$a28d6df673050e18(preloadedFeatures, createVisualElement) {
    if (typeof Proxy === "undefined") return 0, $kvKma.createMotionComponent;
    /**
     * A cache of generated `motion` components, e.g `motion.div`, `motion.input` etc.
     * Rather than generating them anew every render.
     */ var componentCache = new Map();
    var factory = function(Component, options) {
        return (0, $kvKma.createMotionComponent)(Component, options, preloadedFeatures, createVisualElement);
    };
    /**
     * Support for deprecated`motion(Component)` pattern
     */ var deprecatedFactoryFunction = function(Component, options) {
        return factory(Component, options);
    };
    return new Proxy(deprecatedFactoryFunction, {
        /**
         * Called when `motion` is referenced with a prop: `motion.div`, `motion.input` etc.
         * The prop name is passed through as `key` and we can use that to generate a `motion`
         * DOM component with that name.
         */ get: function(_target, key) {
            if (key === "create") return factory;
            /**
             * If this element doesn't exist in the component cache, create it and cache.
             */ if (!componentCache.has(key)) componentCache.set(key, (0, $kvKma.createMotionComponent)(key, undefined, preloadedFeatures, createVisualElement));
            return componentCache.get(key);
        }
    });
}

});
parcelRegister("kvKma", function(module, exports) {

$parcel$export(module.exports, "createMotionComponent", function () { return $b8cf0c54888a2417$export$46b7e4b9dc6110c3; });

var $joFW3 = parcelRequire("joFW3");

var $90FDw = parcelRequire("90FDw");

var $iD4WH = parcelRequire("iD4WH");


var $dQFEZ = parcelRequire("dQFEZ");

var $6dUNv = parcelRequire("6dUNv");

var $92Vel = parcelRequire("92Vel");

var $2SJr1 = parcelRequire("2SJr1");

var $6Xk7W = parcelRequire("6Xk7W");

var $ec36N = parcelRequire("ec36N");

var $bxvB0 = parcelRequire("bxvB0");

var $jhf4j = parcelRequire("jhf4j");

var $8IK5f = parcelRequire("8IK5f");

var $c5Rjl = parcelRequire("c5Rjl");

var $01Br7 = parcelRequire("01Br7");

var $iXrcD = parcelRequire("iXrcD");

var $c37MO = parcelRequire("c37MO");

var $gLA0e = parcelRequire("gLA0e");

var $XURUJ = parcelRequire("XURUJ");

var $i9Alr = parcelRequire("i9Alr");
"use client";
/**
 * Create a `motion` component.
 *
 * This function accepts a Component argument, which can be either a string (ie "div"
 * for `motion.div`), or an actual React component.
 *
 * Alongside this is a config option which provides a way of rendering the provided
 * component "offline", or outside the React render cycle.
 */ function $b8cf0c54888a2417$export$46b7e4b9dc6110c3(Component) {
    var _ref = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, _ref_forwardMotionProps = _ref.forwardMotionProps, forwardMotionProps = _ref_forwardMotionProps === void 0 ? false : _ref_forwardMotionProps, preloadedFeatures = arguments.length > 2 ? arguments[2] : void 0, createVisualElement = arguments.length > 3 ? arguments[3] : void 0;
    preloadedFeatures && (0, $c37MO.loadFeatures)(preloadedFeatures);
    var useVisualState = (0, $jhf4j.isSVGComponent)(Component) ? (0, $c5Rjl.useSVGVisualState) : (0, $8IK5f.useHTMLVisualState);
    function MotionDOMComponent(props, externalRef) {
        /**
         * If we need to measure the element we load this functionality in a
         * separate class component in order to gain access to getSnapshotBeforeUpdate.
         */ var MeasureLayout;
        var configAndProps = (0, $90FDw._)((0, $joFW3._)({}, (0, $dQFEZ.useContext)((0, $2SJr1.MotionConfigContext)), props), {
            layoutId: $b8cf0c54888a2417$var$useLayoutId(props)
        });
        var isStatic = configAndProps.isStatic;
        var context = (0, $ec36N.useCreateMotionContext)(props);
        var visualState = useVisualState(props, isStatic);
        if (!isStatic && (0, $01Br7.isBrowser)) {
            $b8cf0c54888a2417$var$useStrictMode(configAndProps, preloadedFeatures);
            var layoutProjection = $b8cf0c54888a2417$var$getProjectionFunctionality(configAndProps);
            MeasureLayout = layoutProjection.MeasureLayout;
            /**
             * Create a VisualElement for this component. A VisualElement provides a common
             * interface to renderer-specific APIs (ie DOM/Three.js etc) as well as
             * providing a way of rendering to these APIs outside of the React render loop
             * for more performant animations and interactions
             */ context.visualElement = (0, $i9Alr.useVisualElement)(Component, visualState, configAndProps, createVisualElement, layoutProjection.ProjectionNode);
        }
        /**
         * The mount order and hierarchy is specific to ensure our element ref
         * is hydrated by the time features fire their effects.
         */ return (0, $iD4WH.jsxs)((0, $6Xk7W.MotionContext).Provider, {
            value: context,
            children: [
                MeasureLayout && context.visualElement ? (0, $iD4WH.jsx)(MeasureLayout, (0, $joFW3._)({
                    visualElement: context.visualElement
                }, configAndProps)) : null,
                (0, $bxvB0.useRender)(Component, props, (0, $XURUJ.useMotionRef)(visualState, context.visualElement, externalRef), visualState, isStatic, forwardMotionProps)
            ]
        });
    }
    var _Component_displayName, _ref1;
    MotionDOMComponent.displayName = "motion.".concat(typeof Component === "string" ? Component : "create(".concat((_ref1 = (_Component_displayName = Component.displayName) !== null && _Component_displayName !== void 0 ? _Component_displayName : Component.name) !== null && _ref1 !== void 0 ? _ref1 : "", ")"));
    var ForwardRefMotionComponent = (0, $dQFEZ.forwardRef)(MotionDOMComponent);
    ForwardRefMotionComponent[0, $gLA0e.motionComponentSymbol] = Component;
    return ForwardRefMotionComponent;
}
function $b8cf0c54888a2417$var$useLayoutId(param) {
    var layoutId = param.layoutId;
    var layoutGroupId = (0, $dQFEZ.useContext)((0, $6dUNv.LayoutGroupContext)).id;
    return layoutGroupId && layoutId !== undefined ? layoutGroupId + "-" + layoutId : layoutId;
}
function $b8cf0c54888a2417$var$useStrictMode(configAndProps, preloadedFeatures) {
    var isStrict = (0, $dQFEZ.useContext)((0, $92Vel.LazyContext)).strict;
}
function $b8cf0c54888a2417$var$getProjectionFunctionality(props) {
    var drag = (0, $iXrcD.featureDefinitions).drag, layout = (0, $iXrcD.featureDefinitions).layout;
    if (!drag && !layout) return {};
    var combined = (0, $joFW3._)({}, drag, layout);
    return {
        MeasureLayout: (drag === null || drag === void 0 ? void 0 : drag.isEnabled(props)) || (layout === null || layout === void 0 ? void 0 : layout.isEnabled(props)) ? combined.MeasureLayout : undefined,
        ProjectionNode: combined.ProjectionNode
    };
}

});
parcelRegister("6dUNv", function(module, exports) {

$parcel$export(module.exports, "LayoutGroupContext", function () { return $c9258bc28bb8df33$export$a3579ca508007a95; });

var $dQFEZ = parcelRequire("dQFEZ");
"use client";
var $c9258bc28bb8df33$export$a3579ca508007a95 = (0, $dQFEZ.createContext)({});

});

parcelRegister("92Vel", function(module, exports) {

$parcel$export(module.exports, "LazyContext", function () { return $f87d791d047a722d$export$40f10139ecf1f171; });

var $dQFEZ = parcelRequire("dQFEZ");
"use client";
var $f87d791d047a722d$export$40f10139ecf1f171 = (0, $dQFEZ.createContext)({
    strict: false
});

});

parcelRegister("2SJr1", function(module, exports) {

$parcel$export(module.exports, "MotionConfigContext", function () { return $0acdd268e97afa5a$export$22a697fb29aac98d; });

var $dQFEZ = parcelRequire("dQFEZ");
"use client";
/**
 * @public
 */ var $0acdd268e97afa5a$export$22a697fb29aac98d = (0, $dQFEZ.createContext)({
    transformPagePoint: function(p) {
        return p;
    },
    isStatic: false,
    reducedMotion: "never"
});

});

parcelRegister("6Xk7W", function(module, exports) {

$parcel$export(module.exports, "MotionContext", function () { return $ae8dea0de7d1e112$export$2285bbca2c666415; });

var $dQFEZ = parcelRequire("dQFEZ");
"use client";
var $ae8dea0de7d1e112$export$2285bbca2c666415 = /* @__PURE__ */ (0, $dQFEZ.createContext)({});

});

parcelRegister("ec36N", function(module, exports) {

$parcel$export(module.exports, "useCreateMotionContext", function () { return $b75fcb8f43a04c75$export$c5638d843b37a176; });

var $dQFEZ = parcelRequire("dQFEZ");

var $6Xk7W = parcelRequire("6Xk7W");

var $bimmx = parcelRequire("bimmx");
"use client";
function $b75fcb8f43a04c75$export$c5638d843b37a176(props) {
    var _getCurrentTreeVariants = (0, $bimmx.getCurrentTreeVariants)(props, (0, $dQFEZ.useContext)((0, $6Xk7W.MotionContext))), initial = _getCurrentTreeVariants.initial, animate = _getCurrentTreeVariants.animate;
    return (0, $dQFEZ.useMemo)(function() {
        return {
            initial: initial,
            animate: animate
        };
    }, [
        $b75fcb8f43a04c75$var$variantLabelsAsDependency(initial),
        $b75fcb8f43a04c75$var$variantLabelsAsDependency(animate)
    ]);
}
function $b75fcb8f43a04c75$var$variantLabelsAsDependency(prop) {
    return Array.isArray(prop) ? prop.join(" ") : prop;
}

});
parcelRegister("bimmx", function(module, exports) {

$parcel$export(module.exports, "getCurrentTreeVariants", function () { return $d614193aeee51e7f$export$12fc32fc096a04a3; });

var $bXOiK = parcelRequire("bXOiK");

var $6WBVt = parcelRequire("6WBVt");
function $d614193aeee51e7f$export$12fc32fc096a04a3(props, context) {
    if ((0, $bXOiK.isControllingVariants)(props)) {
        var initial = props.initial, animate = props.animate;
        return {
            initial: initial === false || (0, $6WBVt.isVariantLabel)(initial) ? initial : undefined,
            animate: (0, $6WBVt.isVariantLabel)(animate) ? animate : undefined
        };
    }
    return props.inherit !== false ? context : {};
}

});


parcelRegister("bxvB0", function(module, exports) {

$parcel$export(module.exports, "useRender", function () { return $ee48b3870114cda2$export$e25bb1e5b53cbdff; });

var $joFW3 = parcelRequire("joFW3");

var $90FDw = parcelRequire("90FDw");

var $4drXU = parcelRequire("4drXU");

var $dQFEZ = parcelRequire("dQFEZ");

var $dY0NX = parcelRequire("dY0NX");

var $7bgbA = parcelRequire("7bgbA");

var $Q2Drm = parcelRequire("Q2Drm");

var $jhf4j = parcelRequire("jhf4j");
"use client";
function $ee48b3870114cda2$export$e25bb1e5b53cbdff(Component, props, ref, param, isStatic) {
    var latestValues = param.latestValues, forwardMotionProps = arguments.length > 5 && arguments[5] !== void 0 ? arguments[5] : false;
    var useVisualProps = (0, $jhf4j.isSVGComponent)(Component) ? (0, $7bgbA.useSVGProps) : (0, $dY0NX.useHTMLProps);
    var visualProps = useVisualProps(props, latestValues, isStatic, Component);
    var filteredProps = (0, $Q2Drm.filterProps)(props, typeof Component === "string", forwardMotionProps);
    var elementProps = Component !== (0, $dQFEZ.Fragment) ? (0, $90FDw._)((0, $joFW3._)({}, filteredProps, visualProps), {
        ref: ref
    }) : {};
    /**
     * If component has been handed a motion value as its child,
     * memoise its initial value and render that. Subsequent updates
     * will be handled by the onChange handler
     */ var children = props.children;
    var renderedChildren = (0, $dQFEZ.useMemo)(function() {
        return (0, $4drXU.isMotionValue)(children) ? children.get() : children;
    }, [
        children
    ]);
    return (0, $dQFEZ.createElement)(Component, (0, $90FDw._)((0, $joFW3._)({}, elementProps), {
        children: renderedChildren
    }));
}

});
parcelRegister("dY0NX", function(module, exports) {

$parcel$export(module.exports, "copyRawValuesOnly", function () { return $5e1c873133858513$export$40dafdb8630c956b; });
$parcel$export(module.exports, "useHTMLProps", function () { return $5e1c873133858513$export$57be0a314572d87d; });

var $4drXU = parcelRequire("4drXU");

var $dQFEZ = parcelRequire("dQFEZ");

var $94pNX = parcelRequire("94pNX");

var $bfKTA = parcelRequire("bfKTA");

var $7kIoa = parcelRequire("7kIoa");
"use client";
function $5e1c873133858513$export$40dafdb8630c956b(target, source, props) {
    for(var key in source)if (!(0, $4drXU.isMotionValue)(source[key]) && !(0, $94pNX.isForcedMotionValue)(key, props)) target[key] = source[key];
}
function $5e1c873133858513$var$useInitialMotionValues(param, visualState) {
    var transformTemplate = param.transformTemplate;
    return (0, $dQFEZ.useMemo)(function() {
        var state = (0, $7kIoa.createHtmlRenderState)();
        (0, $bfKTA.buildHTMLStyles)(state, visualState, transformTemplate);
        return Object.assign({}, state.vars, state.style);
    }, [
        visualState
    ]);
}
function $5e1c873133858513$var$useStyle(props, visualState) {
    var styleProp = props.style || {};
    var style = {};
    /**
     * Copy non-Motion Values straight into style
     */ $5e1c873133858513$export$40dafdb8630c956b(style, styleProp, props);
    Object.assign(style, $5e1c873133858513$var$useInitialMotionValues(props, visualState));
    return style;
}
function $5e1c873133858513$export$57be0a314572d87d(props, visualState) {
    // The `any` isn't ideal but it is the type of createElement props argument
    var htmlProps = {};
    var style = $5e1c873133858513$var$useStyle(props, visualState);
    if (props.drag && props.dragListener !== false) {
        // Disable the ghost element when a user drags
        htmlProps.draggable = false;
        // Disable text selection
        style.userSelect = style.WebkitUserSelect = style.WebkitTouchCallout = "none";
        // Disable scrolling on the draggable direction
        style.touchAction = props.drag === true ? "none" : "pan-".concat(props.drag === "x" ? "y" : "x");
    }
    if (props.tabIndex === undefined && (props.onTap || props.onTapStart || props.whileTap)) htmlProps.tabIndex = 0;
    htmlProps.style = style;
    return htmlProps;
}

});
parcelRegister("7kIoa", function(module, exports) {

$parcel$export(module.exports, "createHtmlRenderState", function () { return $4d93f86e3a69bef4$export$8940b483cf52eeda; });
var $4d93f86e3a69bef4$export$8940b483cf52eeda = function() {
    return {
        style: {},
        transform: {},
        transformOrigin: {},
        vars: {}
    };
};

});


parcelRegister("7bgbA", function(module, exports) {

$parcel$export(module.exports, "useSVGProps", function () { return $024aac31e5e6c43d$export$84309c4f53cb1bd5; });

var $joFW3 = parcelRequire("joFW3");

var $90FDw = parcelRequire("90FDw");

var $dQFEZ = parcelRequire("dQFEZ");

var $dY0NX = parcelRequire("dY0NX");

var $2JRsN = parcelRequire("2JRsN");

var $fNMd6 = parcelRequire("fNMd6");

var $4FZiX = parcelRequire("4FZiX");
"use client";
function $024aac31e5e6c43d$export$84309c4f53cb1bd5(props, visualState, _isStatic, Component) {
    var visualProps = (0, $dQFEZ.useMemo)(function() {
        var state = (0, $fNMd6.createSvgRenderState)();
        (0, $2JRsN.buildSVGAttrs)(state, visualState, (0, $4FZiX.isSVGTag)(Component), props.transformTemplate, props.style);
        return (0, $90FDw._)((0, $joFW3._)({}, state.attrs), {
            style: (0, $joFW3._)({}, state.style)
        });
    }, [
        visualState
    ]);
    if (props.style) {
        var rawStyles = {};
        (0, $dY0NX.copyRawValuesOnly)(rawStyles, props.style, props);
        visualProps.style = (0, $joFW3._)({}, rawStyles, visualProps.style);
    }
    return visualProps;
}

});
parcelRegister("fNMd6", function(module, exports) {

$parcel$export(module.exports, "createSvgRenderState", function () { return $5f955f31c57591ad$export$41be8b43e1c4d4f9; });

var $joFW3 = parcelRequire("joFW3");

var $90FDw = parcelRequire("90FDw");

var $7kIoa = parcelRequire("7kIoa");
var $5f955f31c57591ad$export$41be8b43e1c4d4f9 = function() {
    return (0, $90FDw._)((0, $joFW3._)({}, (0, $7kIoa.createHtmlRenderState)()), {
        attrs: {}
    });
};

});


parcelRegister("Q2Drm", function(module, exports) {

$parcel$export(module.exports, "filterProps", function () { return $530313d1f042095d$export$d697c39a2985a4c; });

var $bJtXW = parcelRequire("bJtXW");

var $2JBa0 = parcelRequire("2JBa0");
var $530313d1f042095d$var$shouldForward = function(key) {
    return !(0, $2JBa0.isValidMotionProp)(key);
};
function $530313d1f042095d$export$59d6962c470509a5(isValidProp) {
    if (typeof isValidProp !== "function") return;
    // Explicitly filter our events
    $530313d1f042095d$var$shouldForward = function(key) {
        return key.startsWith("on") ? !(0, $2JBa0.isValidMotionProp)(key) : isValidProp(key);
    };
}

/**
 * Emotion and Styled Components both allow users to pass through arbitrary props to their components
 * to dynamically generate CSS. They both use the `@emotion/is-prop-valid` package to determine which
 * of these should be passed to the underlying DOM node.
 *
 * However, when styling a Motion component `styled(motion.div)`, both packages pass through *all* props
 * as it's seen as an arbitrary component rather than a DOM node. Motion only allows arbitrary props
 * passed through the `custom` prop so it doesn't *need* the payload or computational overhead of
 * `@emotion/is-prop-valid`, however to fix this problem we need to use it.
 *
 * By making it an optionalDependency we can offer this functionality only in the situations where it's
 * actually required.
 */ try {
    /**
     * We attempt to import this package but require won't be defined in esm environments, in that case
     * isPropValid will have to be provided via `MotionContext`. In a 6.0.0 this should probably be removed
     * in favour of explicit injection.
     */ $530313d1f042095d$export$59d6962c470509a5($530313d1f042095d$import$c6bce8c37c642938$2e2bcd8739ae039);
} catch (e) {
// We don't need to actually do anything here - the fallback is the existing `isPropValid`.
}
function $530313d1f042095d$export$d697c39a2985a4c(props, isDom, forwardMotionProps) {
    var filteredProps = {};
    for(var key in props){
        /**
         * values is considered a valid prop by Emotion, so if it's present
         * this will be rendered out to the DOM unless explicitly filtered.
         *
         * We check the type as it could be used with the `feColorMatrix`
         * element, which we support.
         */ if (key === "values" && (0, $bJtXW._)(props.values) === "object") continue;
        if ($530313d1f042095d$var$shouldForward(key) || forwardMotionProps === true && (0, $2JBa0.isValidMotionProp)(key) || !isDom && !(0, $2JBa0.isValidMotionProp)(key) || // If trying to use native HTML drag events, forward drag listeners
        props["draggable"] && key.startsWith("onDrag")) filteredProps[key] = props[key];
    }
    return filteredProps;
}

});
parcelRegister("2JBa0", function(module, exports) {

$parcel$export(module.exports, "isValidMotionProp", function () { return $e2747a960589a80f$export$2f9c46555243bf04; });
/**
 * A list of all valid MotionProps.
 *
 * @privateRemarks
 * This doesn't throw if a `MotionProp` name is missing - it should.
 */ var $e2747a960589a80f$var$validMotionProps = new Set([
    "animate",
    "exit",
    "variants",
    "initial",
    "style",
    "values",
    "variants",
    "transition",
    "transformTemplate",
    "custom",
    "inherit",
    "onBeforeLayoutMeasure",
    "onAnimationStart",
    "onAnimationComplete",
    "onUpdate",
    "onDragStart",
    "onDrag",
    "onDragEnd",
    "onMeasureDragConstraints",
    "onDirectionLock",
    "onDragTransitionEnd",
    "_dragX",
    "_dragY",
    "onHoverStart",
    "onHoverEnd",
    "onViewportEnter",
    "onViewportLeave",
    "globalTapTarget",
    "ignoreStrict",
    "viewport"
]);
/**
 * Check whether a prop name is a valid `MotionProp` key.
 *
 * @param key - Name of the property to check
 * @returns `true` is key is a valid `MotionProp`.
 *
 * @public
 */ function $e2747a960589a80f$export$2f9c46555243bf04(key) {
    return key.startsWith("while") || key.startsWith("drag") && key !== "draggable" || key.startsWith("layout") || key.startsWith("onTap") || key.startsWith("onPan") || key.startsWith("onLayout") || $e2747a960589a80f$var$validMotionProps.has(key);
}

});



parcelRegister("8IK5f", function(module, exports) {

$parcel$export(module.exports, "useHTMLVisualState", function () { return $0d69426261e6ed65$export$851cf1f78cb3feac; });

var $7xLne = parcelRequire("7xLne");

var $7kIoa = parcelRequire("7kIoa");

var $367jF = parcelRequire("367jF");
"use client";
var $0d69426261e6ed65$export$851cf1f78cb3feac = /*@__PURE__*/ (0, $7xLne.makeUseVisualState)({
    scrapeMotionValuesFromProps: (0, $367jF.scrapeMotionValuesFromProps),
    createRenderState: (0, $7kIoa.createHtmlRenderState)
});

});
parcelRegister("7xLne", function(module, exports) {

$parcel$export(module.exports, "makeUseVisualState", function () { return $8a348e04716008a3$export$e91e107bc6d03a8e; });

var $buaX5 = parcelRequire("buaX5");

var $dQFEZ = parcelRequire("dQFEZ");

var $45xPy = parcelRequire("45xPy");

var $6Xk7W = parcelRequire("6Xk7W");

var $6QE4x = parcelRequire("6QE4x");

var $bXOiK = parcelRequire("bXOiK");

var $44IJv = parcelRequire("44IJv");

var $1mefA = parcelRequire("1mefA");

var $lbw40 = parcelRequire("lbw40");
"use client";
function $8a348e04716008a3$var$makeState(param, props, context, presenceContext) {
    var scrapeMotionValuesFromProps = param.scrapeMotionValuesFromProps, createRenderState = param.createRenderState;
    var state = {
        latestValues: $8a348e04716008a3$var$makeLatestValues(props, context, presenceContext, scrapeMotionValuesFromProps),
        renderState: createRenderState()
    };
    return state;
}
function $8a348e04716008a3$var$makeLatestValues(props, context, presenceContext, scrapeMotionValues) {
    var values = {};
    var motionValues = scrapeMotionValues(props, {});
    for(var key in motionValues)values[key] = (0, $lbw40.resolveMotionValue)(motionValues[key]);
    var initial = props.initial, animate = props.animate;
    var isControllingVariants$1 = (0, $bXOiK.isControllingVariants)(props);
    var isVariantNode$1 = (0, $bXOiK.isVariantNode)(props);
    if (context && isVariantNode$1 && !isControllingVariants$1 && props.inherit !== false) {
        if (initial === undefined) initial = context.initial;
        if (animate === undefined) animate = context.animate;
    }
    var isInitialAnimationBlocked = presenceContext ? presenceContext.initial === false : false;
    isInitialAnimationBlocked = isInitialAnimationBlocked || initial === false;
    var variantToSet = isInitialAnimationBlocked ? animate : initial;
    if (variantToSet && typeof variantToSet !== "boolean" && !(0, $45xPy.isAnimationControls)(variantToSet)) {
        var list = Array.isArray(variantToSet) ? variantToSet : [
            variantToSet
        ];
        for(var i = 0; i < list.length; i++){
            var resolved = (0, $44IJv.resolveVariantFromProps)(props, list[i]);
            if (resolved) {
                var transitionEnd = resolved.transitionEnd, transition = resolved.transition, target = (0, $buaX5._)(resolved, [
                    "transitionEnd",
                    "transition"
                ]);
                for(var key1 in target){
                    var valueTarget = target[key1];
                    if (Array.isArray(valueTarget)) {
                        /**
                         * Take final keyframe if the initial animation is blocked because
                         * we want to initialise at the end of that blocked animation.
                         */ var index = isInitialAnimationBlocked ? valueTarget.length - 1 : 0;
                        valueTarget = valueTarget[index];
                    }
                    if (valueTarget !== null) values[key1] = valueTarget;
                }
                for(var key2 in transitionEnd)values[key2] = transitionEnd[key2];
            }
        }
    }
    return values;
}
var $8a348e04716008a3$export$e91e107bc6d03a8e = function(config) {
    return function(props, isStatic) {
        var context = (0, $dQFEZ.useContext)((0, $6Xk7W.MotionContext));
        var presenceContext = (0, $dQFEZ.useContext)((0, $6QE4x.PresenceContext));
        var make = function() {
            return $8a348e04716008a3$var$makeState(config, props, context, presenceContext);
        };
        return isStatic ? make() : (0, $1mefA.useConstant)(make);
    };
};

});
parcelRegister("6QE4x", function(module, exports) {

$parcel$export(module.exports, "PresenceContext", function () { return $4fa6635067f6f474$export$f224e4635b6f8ce2; });

var $dQFEZ = parcelRequire("dQFEZ");
"use client";
/**
 * @public
 */ var $4fa6635067f6f474$export$f224e4635b6f8ce2 = /* @__PURE__ */ (0, $dQFEZ.createContext)(null);

});

parcelRegister("1mefA", function(module, exports) {

$parcel$export(module.exports, "useConstant", function () { return $aa070268e56bbe37$export$fe4300aa8eebea86; });

var $dQFEZ = parcelRequire("dQFEZ");
"use client";
/**
 * Creates a constant value over the lifecycle of a component.
 *
 * Even if `useMemo` is provided an empty array as its final argument, it doesn't offer
 * a guarantee that it won't re-run for performance reasons later on. By using `useConstant`
 * you can ensure that initialisers don't execute twice or more.
 */ function $aa070268e56bbe37$export$fe4300aa8eebea86(init) {
    var ref = (0, $dQFEZ.useRef)(null);
    if (ref.current === null) ref.current = init();
    return ref.current;
}

});

parcelRegister("lbw40", function(module, exports) {

$parcel$export(module.exports, "resolveMotionValue", function () { return $ed000a70011c0ae0$export$fcc2206ecb6d74b; });

var $4drXU = parcelRequire("4drXU");
/**
 * If the provided value is a MotionValue, this returns the actual value, otherwise just the value itself
 *
 * TODO: Remove and move to library
 */ function $ed000a70011c0ae0$export$fcc2206ecb6d74b(value) {
    return (0, $4drXU.isMotionValue)(value) ? value.get() : value;
}

});



parcelRegister("c5Rjl", function(module, exports) {

$parcel$export(module.exports, "useSVGVisualState", function () { return $c0300b8c1a2fca4c$export$9922240e40b88c48; });

var $7xLne = parcelRequire("7xLne");

var $fNMd6 = parcelRequire("fNMd6");

var $e0WAH = parcelRequire("e0WAH");
"use client";
var $c0300b8c1a2fca4c$export$9922240e40b88c48 = /*@__PURE__*/ (0, $7xLne.makeUseVisualState)({
    scrapeMotionValuesFromProps: (0, $e0WAH.scrapeMotionValuesFromProps),
    createRenderState: (0, $fNMd6.createSvgRenderState)
});

});

parcelRegister("c37MO", function(module, exports) {

$parcel$export(module.exports, "loadFeatures", function () { return $44185beb94054e7b$export$449561ec5703cdc8; });

var $joFW3 = parcelRequire("joFW3");

var $iXrcD = parcelRequire("iXrcD");
function $44185beb94054e7b$export$449561ec5703cdc8(features) {
    for(var key in features)(0, $iXrcD.featureDefinitions)[key] = (0, $joFW3._)({}, (0, $iXrcD.featureDefinitions)[key], features[key]);
}

});

parcelRegister("gLA0e", function(module, exports) {

$parcel$export(module.exports, "motionComponentSymbol", function () { return $d94b3b1d6ffd8254$export$28e2e4cce424ae23; });
var $d94b3b1d6ffd8254$export$28e2e4cce424ae23 = Symbol.for("motionComponentSymbol");

});

parcelRegister("XURUJ", function(module, exports) {

$parcel$export(module.exports, "useMotionRef", function () { return $0bef4a991924a127$export$c684914703d321fd; });

var $dQFEZ = parcelRequire("dQFEZ");

var $g0sR1 = parcelRequire("g0sR1");
"use client";
/**
 * Creates a ref function that, when called, hydrates the provided
 * external ref and VisualElement.
 */ function $0bef4a991924a127$export$c684914703d321fd(visualState, visualElement, externalRef) {
    return (0, $dQFEZ.useCallback)(function(instance) {
        if (instance) visualState.onMount && visualState.onMount(instance);
        if (visualElement) {
            if (instance) visualElement.mount(instance);
            else visualElement.unmount();
        }
        if (externalRef) {
            if (typeof externalRef === "function") externalRef(instance);
            else if ((0, $g0sR1.isRefObject)(externalRef)) externalRef.current = instance;
        }
    }, /**
     * Include externalRef in dependencies to ensure the callback updates
     * when the ref changes, allowing proper ref forwarding.
     */ [
        visualElement
    ]);
}

});
parcelRegister("g0sR1", function(module, exports) {

$parcel$export(module.exports, "isRefObject", function () { return $e9c25423de102281$export$dedd81df7bc1307; });

var $bJtXW = parcelRequire("bJtXW");
function $e9c25423de102281$export$dedd81df7bc1307(ref) {
    return ref && (typeof ref === "undefined" ? "undefined" : (0, $bJtXW._)(ref)) === "object" && Object.prototype.hasOwnProperty.call(ref, "current");
}

});


parcelRegister("i9Alr", function(module, exports) {

$parcel$export(module.exports, "useVisualElement", function () { return $1056e15c612ff777$export$dc0335d73ab0b115; });

var $dQFEZ = parcelRequire("dQFEZ");

var $1CiSy = parcelRequire("1CiSy");

var $92Vel = parcelRequire("92Vel");

var $2SJr1 = parcelRequire("2SJr1");

var $6Xk7W = parcelRequire("6Xk7W");

var $6QE4x = parcelRequire("6QE4x");

var $67KHr = parcelRequire("67KHr");

var $g0sR1 = parcelRequire("g0sR1");

var $9ismc = parcelRequire("9ismc");
"use client";
function $1056e15c612ff777$export$dc0335d73ab0b115(Component, visualState, props, createVisualElement, ProjectionNodeConstructor) {
    var _window_MotionHandoffIsComplete, _window, _window_MotionHasOptimisedAnimation, _window1;
    var _useContext = (0, $dQFEZ.useContext)((0, $6Xk7W.MotionContext)), parent = _useContext.visualElement;
    var lazyContext = (0, $dQFEZ.useContext)((0, $92Vel.LazyContext));
    var presenceContext = (0, $dQFEZ.useContext)((0, $6QE4x.PresenceContext));
    var reducedMotionConfig = (0, $dQFEZ.useContext)((0, $2SJr1.MotionConfigContext)).reducedMotion;
    var visualElementRef = (0, $dQFEZ.useRef)(null);
    /**
     * If we haven't preloaded a renderer, check to see if we have one lazy-loaded
     */ createVisualElement = createVisualElement || lazyContext.renderer;
    if (!visualElementRef.current && createVisualElement) visualElementRef.current = createVisualElement(Component, {
        visualState: visualState,
        parent: parent,
        props: props,
        presenceContext: presenceContext,
        blockInitialAnimation: presenceContext ? presenceContext.initial === false : false,
        reducedMotionConfig: reducedMotionConfig
    });
    var visualElement = visualElementRef.current;
    /**
     * Load Motion gesture and animation features. These are rendered as renderless
     * components so each feature can optionally make use of React lifecycle methods.
     */ var initialLayoutGroupConfig = (0, $dQFEZ.useContext)((0, $67KHr.SwitchLayoutGroupContext));
    if (visualElement && !visualElement.projection && ProjectionNodeConstructor && (visualElement.type === "html" || visualElement.type === "svg")) $1056e15c612ff777$var$createProjectionNode(visualElementRef.current, props, ProjectionNodeConstructor, initialLayoutGroupConfig);
    var isMounted = (0, $dQFEZ.useRef)(false);
    (0, $dQFEZ.useInsertionEffect)(function() {
        /**
         * Check the component has already mounted before calling
         * `update` unnecessarily. This ensures we skip the initial update.
         */ if (visualElement && isMounted.current) visualElement.update(props, presenceContext);
    });
    /**
     * Cache this value as we want to know whether HandoffAppearAnimations
     * was present on initial render - it will be deleted after this.
     */ var optimisedAppearId = props[0, $1CiSy.optimizedAppearDataAttribute];
    var wantsHandoff = (0, $dQFEZ.useRef)(Boolean(optimisedAppearId) && !((_window_MotionHandoffIsComplete = (_window = window).MotionHandoffIsComplete) === null || _window_MotionHandoffIsComplete === void 0 ? void 0 : _window_MotionHandoffIsComplete.call(_window, optimisedAppearId)) && ((_window_MotionHasOptimisedAnimation = (_window1 = window).MotionHasOptimisedAnimation) === null || _window_MotionHasOptimisedAnimation === void 0 ? void 0 : _window_MotionHasOptimisedAnimation.call(_window1, optimisedAppearId)));
    (0, $9ismc.useIsomorphicLayoutEffect)(function() {
        if (!visualElement) return;
        isMounted.current = true;
        window.MotionIsMounted = true;
        visualElement.updateFeatures();
        visualElement.scheduleRenderMicrotask();
        /**
         * Ideally this function would always run in a useEffect.
         *
         * However, if we have optimised appear animations to handoff from,
         * it needs to happen synchronously to ensure there's no flash of
         * incorrect styles in the event of a hydration error.
         *
         * So if we detect a situtation where optimised appear animations
         * are running, we use useLayoutEffect to trigger animations.
         */ if (wantsHandoff.current && visualElement.animationState) visualElement.animationState.animateChanges();
    });
    (0, $dQFEZ.useEffect)(function() {
        if (!visualElement) return;
        if (!wantsHandoff.current && visualElement.animationState) visualElement.animationState.animateChanges();
        if (wantsHandoff.current) {
            // This ensures all future calls to animateChanges() in this component will run in useEffect
            queueMicrotask(function() {
                var _window_MotionHandoffMarkAsComplete, _window;
                (_window_MotionHandoffMarkAsComplete = (_window = window).MotionHandoffMarkAsComplete) === null || _window_MotionHandoffMarkAsComplete === void 0 ? void 0 : _window_MotionHandoffMarkAsComplete.call(_window, optimisedAppearId);
            });
            wantsHandoff.current = false;
        }
        /**
         * Now we've finished triggering animations for this element we
         * can wipe the enteringChildren set for the next render.
         */ visualElement.enteringChildren = undefined;
    });
    return visualElement;
}
function $1056e15c612ff777$var$createProjectionNode(visualElement, props, ProjectionNodeConstructor, initialPromotionConfig) {
    var layoutId = props.layoutId, layout = props.layout, drag = props.drag, dragConstraints = props.dragConstraints, layoutScroll = props.layoutScroll, layoutRoot = props.layoutRoot, layoutCrossfade = props.layoutCrossfade;
    visualElement.projection = new ProjectionNodeConstructor(visualElement.latestValues, props["data-framer-portal-id"] ? undefined : $1056e15c612ff777$var$getClosestProjectingNode(visualElement.parent));
    visualElement.projection.setOptions({
        layoutId: layoutId,
        layout: layout,
        alwaysMeasureLayout: Boolean(drag) || dragConstraints && (0, $g0sR1.isRefObject)(dragConstraints),
        visualElement: visualElement,
        /**
         * TODO: Update options in an effect. This could be tricky as it'll be too late
         * to update by the time layout animations run.
         * We also need to fix this safeToRemove by linking it up to the one returned by usePresence,
         * ensuring it gets called if there's no potential layout animations.
         *
         */ animationType: typeof layout === "string" ? layout : "both",
        initialPromotionConfig: initialPromotionConfig,
        crossfade: layoutCrossfade,
        layoutScroll: layoutScroll,
        layoutRoot: layoutRoot
    });
}
function $1056e15c612ff777$var$getClosestProjectingNode(visualElement) {
    if (!visualElement) return undefined;
    return visualElement.options.allowProjection !== false ? visualElement.projection : $1056e15c612ff777$var$getClosestProjectingNode(visualElement.parent);
}

});
parcelRegister("1CiSy", function(module, exports) {

$parcel$export(module.exports, "optimizedAppearDataAttribute", function () { return $de72616665b27730$export$8592e1c077c890a6; });

var $aUgjR = parcelRequire("aUgjR");
var $de72616665b27730$export$ed7b8fa9dbf0105d = "framerAppearId";
var $de72616665b27730$export$8592e1c077c890a6 = "data-" + (0, $aUgjR.camelToDash)($de72616665b27730$export$ed7b8fa9dbf0105d);

});

parcelRegister("67KHr", function(module, exports) {

$parcel$export(module.exports, "SwitchLayoutGroupContext", function () { return $fff1757b250efb2b$export$da5f7b802957459a; });

var $dQFEZ = parcelRequire("dQFEZ");
"use client";
/**
 * Internal, exported only for usage in Framer
 */ var $fff1757b250efb2b$export$da5f7b802957459a = (0, $dQFEZ.createContext)({});

});

parcelRegister("9ismc", function(module, exports) {

$parcel$export(module.exports, "useIsomorphicLayoutEffect", function () { return $4887edf070f19529$export$700979bc83e7db82; });

var $dQFEZ = parcelRequire("dQFEZ");

var $01Br7 = parcelRequire("01Br7");
"use client";
var $4887edf070f19529$export$700979bc83e7db82 = (0, $01Br7.isBrowser) ? (0, $dQFEZ.useLayoutEffect) : (0, $dQFEZ.useEffect);

});




parcelRegister("1cjWu", function(module, exports) {

$parcel$export(module.exports, "featureBundle", function () { return $8c505fdcc211c7fb$export$d596cd8841d25433; });

var $joFW3 = parcelRequire("joFW3");

var $h87uo = parcelRequire("h87uo");

var $btWuV = parcelRequire("btWuV");

var $iuwO5 = parcelRequire("iuwO5");

var $jYIKh = parcelRequire("jYIKh");
var $8c505fdcc211c7fb$export$d596cd8841d25433 = (0, $joFW3._)({}, (0, $h87uo.animations), (0, $iuwO5.gestureAnimations), (0, $btWuV.drag), (0, $jYIKh.layout));

});
parcelRegister("h87uo", function(module, exports) {

$parcel$export(module.exports, "animations", function () { return $be27ed77b2e5a032$export$7f9953c70dacfd7f; });

var $52DfJ = parcelRequire("52DfJ");

var $9DyrS = parcelRequire("9DyrS");
var $be27ed77b2e5a032$export$7f9953c70dacfd7f = {
    animation: {
        Feature: (0, $52DfJ.AnimationFeature)
    },
    exit: {
        Feature: (0, $9DyrS.ExitAnimationFeature)
    }
};

});
parcelRegister("52DfJ", function(module, exports) {

$parcel$export(module.exports, "AnimationFeature", function () { return $c3d76a5dbb926afc$export$b45b3fe5caabdca; });

var $f3Okx = parcelRequire("f3Okx");

var $grujF = parcelRequire("grujF");

var $dhMkv = parcelRequire("dhMkv");

var $j6Mzi = parcelRequire("j6Mzi");

var $45xPy = parcelRequire("45xPy");

var $1X3ht = parcelRequire("1X3ht");

var $hVeVW = parcelRequire("hVeVW");
var $c3d76a5dbb926afc$export$b45b3fe5caabdca = /*#__PURE__*/ function(Feature) {
    "use strict";
    (0, $j6Mzi._)(AnimationFeature, Feature);
    function AnimationFeature(node) {
        (0, $grujF._)(this, AnimationFeature);
        var _this;
        _this = (0, $f3Okx._)(this, AnimationFeature, [
            node
        ]);
        node.animationState || (node.animationState = (0, $1X3ht.createAnimationState)(node));
        return _this;
    }
    (0, $dhMkv._)(AnimationFeature, [
        {
            key: "updateAnimationControlsSubscription",
            value: function updateAnimationControlsSubscription() {
                var animate = this.node.getProps().animate;
                if ((0, $45xPy.isAnimationControls)(animate)) this.unmountControls = animate.subscribe(this.node);
            }
        },
        {
            /**
     * Subscribe any provided AnimationControls to the component's VisualElement
     */ key: "mount",
            value: function mount() {
                this.updateAnimationControlsSubscription();
            }
        },
        {
            key: "update",
            value: function update() {
                var animate = this.node.getProps().animate;
                var _ref = this.node.prevProps || {}, prevAnimate = _ref.animate;
                if (animate !== prevAnimate) this.updateAnimationControlsSubscription();
            }
        },
        {
            key: "unmount",
            value: function unmount() {
                var _this_unmountControls, _this;
                this.node.animationState.reset();
                (_this_unmountControls = (_this = this).unmountControls) === null || _this_unmountControls === void 0 ? void 0 : _this_unmountControls.call(_this);
            }
        }
    ]);
    return AnimationFeature;
}((0, $hVeVW.Feature));

});
parcelRegister("1X3ht", function(module, exports) {

$parcel$export(module.exports, "createAnimationState", function () { return $a510560c83c41c68$export$bb53502b7a672aa8; });

var $joFW3 = parcelRequire("joFW3");

var $buaX5 = parcelRequire("buaX5");

var $2us1u = parcelRequire("2us1u");

var $2t8ZB = parcelRequire("2t8ZB");

var $dcOWD = parcelRequire("dcOWD");

var $45xPy = parcelRequire("45xPy");

var $eHYmI = parcelRequire("eHYmI");

var $jwaC9 = parcelRequire("jwaC9");

var $gXnT6 = parcelRequire("gXnT6");

var $6WBVt = parcelRequire("6WBVt");

var $D0HzR = parcelRequire("D0HzR");

var $4hPGR = parcelRequire("4hPGR");
var $a510560c83c41c68$var$reversePriorityOrder = (0, $2us1u._)((0, $4hPGR.variantPriorityOrder)).reverse();
var $a510560c83c41c68$var$numAnimationTypes = (0, $4hPGR.variantPriorityOrder).length;
function $a510560c83c41c68$var$animateList(visualElement) {
    return function(animations) {
        return Promise.all(animations.map(function(param) {
            var animation = param.animation, options = param.options;
            return (0, $2t8ZB.animateVisualElement)(visualElement, animation, options);
        }));
    };
}
function $a510560c83c41c68$export$bb53502b7a672aa8(visualElement) {
    var animate = $a510560c83c41c68$var$animateList(visualElement);
    var state = $a510560c83c41c68$var$createState();
    var isInitialRender = true;
    /**
     * This function will be used to reduce the animation definitions for
     * each active animation type into an object of resolved values for it.
     */ var buildResolvedTypeValues = function(type) {
        return function(acc, definition) {
            var _visualElement_presenceContext;
            var resolved = (0, $D0HzR.resolveVariant)(visualElement, definition, type === "exit" ? (_visualElement_presenceContext = visualElement.presenceContext) === null || _visualElement_presenceContext === void 0 ? void 0 : _visualElement_presenceContext.custom : undefined);
            if (resolved) {
                var transition = resolved.transition, transitionEnd = resolved.transitionEnd, target = (0, $buaX5._)(resolved, [
                    "transition",
                    "transitionEnd"
                ]);
                acc = (0, $joFW3._)({}, acc, target, transitionEnd);
            }
            return acc;
        };
    };
    /**
     * This just allows us to inject mocked animation functions
     * @internal
     */ function setAnimateFunction(makeAnimator) {
        animate = makeAnimator(visualElement);
    }
    /**
     * When we receive new props, we need to:
     * 1. Create a list of protected keys for each type. This is a directory of
     *    value keys that are currently being "handled" by types of a higher priority
     *    so that whenever an animation is played of a given type, these values are
     *    protected from being animated.
     * 2. Determine if an animation type needs animating.
     * 3. Determine if any values have been removed from a type and figure out
     *    what to animate those to.
     */ function animateChanges(changedActiveType) {
        var _loop = function(i) {
            var _animations;
            var type = $a510560c83c41c68$var$reversePriorityOrder[i];
            var typeState = state[type];
            var prop = props[type] !== undefined ? props[type] : context[type];
            var propIsVariant = (0, $6WBVt.isVariantLabel)(prop);
            /**
             * If this type has *just* changed isActive status, set activeDelta
             * to that status. Otherwise set to null.
             */ var activeDelta = type === changedActiveType ? typeState.isActive : null;
            if (activeDelta === false) removedVariantIndex = i;
            /**
             * If this prop is an inherited variant, rather than been set directly on the
             * component itself, we want to make sure we allow the parent to trigger animations.
             *
             * TODO: Can probably change this to a !isControllingVariants check
             */ var isInherited = prop === context[type] && prop !== props[type] && propIsVariant;
            if (isInherited && isInitialRender && visualElement.manuallyAnimateOnMount) isInherited = false;
            /**
             * Set all encountered keys so far as the protected keys for this type. This will
             * be any key that has been animated or otherwise handled by active, higher-priortiy types.
             */ typeState.protectedKeys = (0, $joFW3._)({}, encounteredKeys);
            // Check if we can skip analysing this prop early
            if (// If it isn't active and hasn't *just* been set as inactive
            !typeState.isActive && activeDelta === null || // If we didn't and don't have any defined prop for this animation type
            !prop && !typeState.prevProp || // Or if the prop doesn't define an animation
            (0, $45xPy.isAnimationControls)(prop) || typeof prop === "boolean") return "continue";
            /**
             * As we go look through the values defined on this type, if we detect
             * a changed value or a value that was removed in a higher priority, we set
             * this to true and add this prop to the animation list.
             */ var variantDidChange = $a510560c83c41c68$export$68651800594fd43c(typeState.prevProp, prop);
            var shouldAnimateType = variantDidChange || // If we're making this variant active, we want to always make it active
            type === changedActiveType && typeState.isActive && !isInherited && propIsVariant || // If we removed a higher-priority variant (i is in reverse order)
            i > removedVariantIndex && propIsVariant;
            var handledRemovedValues = false;
            /**
             * As animations can be set as variant lists, variants or target objects, we
             * coerce everything to an array if it isn't one already
             */ var definitionList = Array.isArray(prop) ? prop : [
                prop
            ];
            /**
             * Build an object of all the resolved values. We'll use this in the subsequent
             * animateChanges calls to determine whether a value has changed.
             */ var resolvedValues = definitionList.reduce(buildResolvedTypeValues(type), {});
            if (activeDelta === false) resolvedValues = {};
            /**
             * Now we need to loop through all the keys in the prev prop and this prop,
             * and decide:
             * 1. If the value has changed, and needs animating
             * 2. If it has been removed, and needs adding to the removedKeys set
             * 3. If it has been removed in a higher priority type and needs animating
             * 4. If it hasn't been removed in a higher priority but hasn't changed, and
             *    needs adding to the type's protectedKeys list.
             */ var _typeState_prevResolvedValues = typeState.prevResolvedValues, prevResolvedValues = _typeState_prevResolvedValues === void 0 ? {} : _typeState_prevResolvedValues;
            var allKeys = (0, $joFW3._)({}, prevResolvedValues, resolvedValues);
            var markToAnimate = function(key) {
                shouldAnimateType = true;
                if (removedKeys.has(key)) {
                    handledRemovedValues = true;
                    removedKeys.delete(key);
                }
                typeState.needsAnimating[key] = true;
                var motionValue = visualElement.getValue(key);
                if (motionValue) motionValue.liveStyle = false;
            };
            for(var key in allKeys){
                var next = resolvedValues[key];
                var prev = prevResolvedValues[key];
                // If we've already handled this we can just skip ahead
                if (encounteredKeys.hasOwnProperty(key)) continue;
                /**
                 * If the value has changed, we probably want to animate it.
                 */ var valueHasChanged = false;
                if ((0, $eHYmI.isKeyframesTarget)(next) && (0, $eHYmI.isKeyframesTarget)(prev)) valueHasChanged = !(0, $jwaC9.shallowCompare)(next, prev);
                else valueHasChanged = next !== prev;
                if (valueHasChanged) {
                    if (next !== undefined && next !== null) // If next is defined and doesn't equal prev, it needs animating
                    markToAnimate(key);
                    else // If it's undefined, it's been removed.
                    removedKeys.add(key);
                } else if (next !== undefined && removedKeys.has(key)) /**
                     * If next hasn't changed and it isn't undefined, we want to check if it's
                     * been removed by a higher priority
                     */ markToAnimate(key);
                else /**
                     * If it hasn't changed, we add it to the list of protected values
                     * to ensure it doesn't get animated.
                     */ typeState.protectedKeys[key] = true;
            }
            /**
             * Update the typeState so next time animateChanges is called we can compare the
             * latest prop and resolvedValues to these.
             */ typeState.prevProp = prop;
            typeState.prevResolvedValues = resolvedValues;
            if (typeState.isActive) encounteredKeys = (0, $joFW3._)({}, encounteredKeys, resolvedValues);
            if (isInitialRender && visualElement.blockInitialAnimation) shouldAnimateType = false;
            /**
             * If this is an inherited prop we want to skip this animation
             * unless the inherited variants haven't changed on this render.
             */ var willAnimateViaParent = isInherited && variantDidChange;
            var needsAnimating = !willAnimateViaParent || handledRemovedValues;
            if (shouldAnimateType && needsAnimating) (_animations = animations).push.apply(_animations, (0, $2us1u._)(definitionList.map(function(animation) {
                var options = {
                    type: type
                };
                /**
                     * If we're performing the initial animation, but we're not
                     * rendering at the same time as the variant-controlling parent,
                     * we want to use the parent's transition to calculate the stagger.
                     */ if (typeof animation === "string" && isInitialRender && !willAnimateViaParent && visualElement.manuallyAnimateOnMount && visualElement.parent) {
                    var parent = visualElement.parent;
                    var parentVariant = (0, $D0HzR.resolveVariant)(parent, animation);
                    if (parent.enteringChildren && parentVariant) {
                        var delayChildren = (parentVariant.transition || {}).delayChildren;
                        options.delay = (0, $dcOWD.calcChildStagger)(parent.enteringChildren, visualElement, delayChildren);
                    }
                }
                return {
                    animation: animation,
                    options: options
                };
            })));
        };
        var props = visualElement.props;
        var context = (0, $gXnT6.getVariantContext)(visualElement.parent) || {};
        /**
         * A list of animations that we'll build into as we iterate through the animation
         * types. This will get executed at the end of the function.
         */ var animations = [];
        /**
         * Keep track of which values have been removed. Then, as we hit lower priority
         * animation types, we can check if they contain removed values and animate to that.
         */ var removedKeys = new Set();
        /**
         * A dictionary of all encountered keys. This is an object to let us build into and
         * copy it without iteration. Each time we hit an animation type we set its protected
         * keys - the keys its not allowed to animate - to the latest version of this object.
         */ var encounteredKeys = {};
        /**
         * If a variant has been removed at a given index, and this component is controlling
         * variant animations, we want to ensure lower-priority variants are forced to animate.
         */ var removedVariantIndex = Infinity;
        /**
         * Iterate through all animation types in reverse priority order. For each, we want to
         * detect which values it's handling and whether or not they've changed (and therefore
         * need to be animated). If any values have been removed, we want to detect those in
         * lower priority props and flag for animation.
         */ for(var i = 0; i < $a510560c83c41c68$var$numAnimationTypes; i++)_loop(i);
        /**
         * If there are some removed value that haven't been dealt with,
         * we need to create a new animation that falls back either to the value
         * defined in the style prop, or the last read value.
         */ if (removedKeys.size) {
            var fallbackAnimation = {};
            /**
             * If the initial prop contains a transition we can use that, otherwise
             * allow the animation function to use the visual element's default.
             */ if (typeof props.initial !== "boolean") {
                var initialTransition = (0, $D0HzR.resolveVariant)(visualElement, Array.isArray(props.initial) ? props.initial[0] : props.initial);
                if (initialTransition && initialTransition.transition) fallbackAnimation.transition = initialTransition.transition;
            }
            removedKeys.forEach(function(key) {
                var fallbackTarget = visualElement.getBaseTarget(key);
                var motionValue = visualElement.getValue(key);
                if (motionValue) motionValue.liveStyle = true;
                // @ts-expect-error - @mattgperry to figure if we should do something here
                fallbackAnimation[key] = fallbackTarget !== null && fallbackTarget !== void 0 ? fallbackTarget : null;
            });
            animations.push({
                animation: fallbackAnimation
            });
        }
        var shouldAnimate = Boolean(animations.length);
        if (isInitialRender && (props.initial === false || props.initial === props.animate) && !visualElement.manuallyAnimateOnMount) shouldAnimate = false;
        isInitialRender = false;
        return shouldAnimate ? animate(animations) : Promise.resolve();
    }
    /**
     * Change whether a certain animation type is active.
     */ function setActive(type, isActive) {
        var // Propagate active change to children
        _visualElement_variantChildren;
        // If the active state hasn't changed, we can safely do nothing here
        if (state[type].isActive === isActive) return Promise.resolve();
        (_visualElement_variantChildren = visualElement.variantChildren) === null || _visualElement_variantChildren === void 0 ? void 0 : _visualElement_variantChildren.forEach(function(child) {
            var _child_animationState;
            return (_child_animationState = child.animationState) === null || _child_animationState === void 0 ? void 0 : _child_animationState.setActive(type, isActive);
        });
        state[type].isActive = isActive;
        var animations = animateChanges(type);
        for(var key in state)state[key].protectedKeys = {};
        return animations;
    }
    return {
        animateChanges: animateChanges,
        setActive: setActive,
        setAnimateFunction: setAnimateFunction,
        getState: function() {
            return state;
        },
        reset: function() {
            state = $a510560c83c41c68$var$createState();
        /**
             * Temporarily disabling resetting this flag as it prevents components
             * with initial={false} from animating after being remounted, for instance
             * as the child of an Activity component.
             */ // isInitialRender = true
        }
    };
}
function $a510560c83c41c68$export$68651800594fd43c(prev, next) {
    if (typeof next === "string") return next !== prev;
    else if (Array.isArray(next)) return !(0, $jwaC9.shallowCompare)(next, prev);
    return false;
}
function $a510560c83c41c68$var$createTypeState() {
    var isActive = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : false;
    return {
        isActive: isActive,
        protectedKeys: {},
        needsAnimating: {},
        prevResolvedValues: {}
    };
}
function $a510560c83c41c68$var$createState() {
    return {
        animate: $a510560c83c41c68$var$createTypeState(true),
        whileInView: $a510560c83c41c68$var$createTypeState(),
        whileHover: $a510560c83c41c68$var$createTypeState(),
        whileTap: $a510560c83c41c68$var$createTypeState(),
        whileDrag: $a510560c83c41c68$var$createTypeState(),
        whileFocus: $a510560c83c41c68$var$createTypeState(),
        exit: $a510560c83c41c68$var$createTypeState()
    };
}

});
parcelRegister("2t8ZB", function(module, exports) {

$parcel$export(module.exports, "animateVisualElement", function () { return $fa895be873988539$export$ff62cf473653f109; });

var $D0HzR = parcelRequire("D0HzR");

var $b9KoW = parcelRequire("b9KoW");

var $kdPZo = parcelRequire("kdPZo");
function $fa895be873988539$export$ff62cf473653f109(visualElement, definition) {
    var options = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
    visualElement.notify("AnimationStart", definition);
    var animation;
    if (Array.isArray(definition)) {
        var animations = definition.map(function(variant) {
            return (0, $kdPZo.animateVariant)(visualElement, variant, options);
        });
        animation = Promise.all(animations);
    } else if (typeof definition === "string") animation = (0, $kdPZo.animateVariant)(visualElement, definition, options);
    else {
        var resolvedDefinition = typeof definition === "function" ? (0, $D0HzR.resolveVariant)(visualElement, definition, options.custom) : definition;
        animation = Promise.all((0, $b9KoW.animateTarget)(visualElement, resolvedDefinition, options));
    }
    return animation.then(function() {
        visualElement.notify("AnimationComplete", definition);
    });
}

});
parcelRegister("D0HzR", function(module, exports) {

$parcel$export(module.exports, "resolveVariant", function () { return $73f2f95224ec0d43$export$7b1b1c981f4f0558; });

var $44IJv = parcelRequire("44IJv");
function $73f2f95224ec0d43$export$7b1b1c981f4f0558(visualElement, definition, custom) {
    var props = visualElement.getProps();
    return (0, $44IJv.resolveVariantFromProps)(props, definition, custom !== undefined ? custom : props.custom, visualElement);
}

});

parcelRegister("b9KoW", function(module, exports) {

$parcel$export(module.exports, "animateTarget", function () { return $e84464b742e0ec31$export$68cacfeee78d98d2; });

var $joFW3 = parcelRequire("joFW3");

var $buaX5 = parcelRequire("buaX5");

var $8oVcc = parcelRequire("8oVcc");
var $Oeytg = parcelRequire("Oeytg");
var $enWtX = parcelRequire("enWtX");

var $4HtTX = parcelRequire("4HtTX");

var $gjAeU = parcelRequire("gjAeU");

var $cWeYk = parcelRequire("cWeYk");

var $cUBhh = parcelRequire("cUBhh");
/**
 * Decide whether we should block this animation. Previously, we achieved this
 * just by checking whether the key was listed in protectedKeys, but this
 * posed problems if an animation was triggered by afterChildren and protectedKeys
 * had been set to true in the meantime.
 */ function $e84464b742e0ec31$var$shouldBlockAnimation(param, key) {
    var protectedKeys = param.protectedKeys, needsAnimating = param.needsAnimating;
    var shouldBlock = protectedKeys.hasOwnProperty(key) && needsAnimating[key] !== true;
    needsAnimating[key] = false;
    return shouldBlock;
}
function $e84464b742e0ec31$export$68cacfeee78d98d2(visualElement, targetAndTransition) {
    var _ref = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {}, _ref_delay = _ref.delay, delay = _ref_delay === void 0 ? 0 : _ref_delay, transitionOverride = _ref.transitionOverride, type = _ref.type;
    var _targetAndTransition_transition = targetAndTransition.transition, transition = _targetAndTransition_transition === void 0 ? visualElement.getDefaultTransition() : _targetAndTransition_transition, transitionEnd = targetAndTransition.transitionEnd, target = (0, $buaX5._)(targetAndTransition, [
        "transition",
        "transitionEnd"
    ]);
    if (transitionOverride) transition = transitionOverride;
    var animations = [];
    var animationTypeState = type && visualElement.animationState && visualElement.animationState.getState()[type];
    for(var key in target){
        var _visualElement_latestValues_key;
        var value = visualElement.getValue(key, (_visualElement_latestValues_key = visualElement.latestValues[key]) !== null && _visualElement_latestValues_key !== void 0 ? _visualElement_latestValues_key : null);
        var valueTarget = target[key];
        if (valueTarget === undefined || animationTypeState && $e84464b742e0ec31$var$shouldBlockAnimation(animationTypeState, key)) continue;
        var valueTransition = (0, $joFW3._)({
            delay: delay
        }, (0, $Oeytg.getValueTransition)(transition || {}, key));
        /**
         * If the value is already at the defined target, skip the animation.
         */ var currentValue = value.get();
        if (currentValue !== undefined && !value.isAnimating && !Array.isArray(valueTarget) && valueTarget === currentValue && !valueTransition.velocity) continue;
        /**
         * If this is the first time a value is being animated, check
         * to see if we're handling off from an existing animation.
         */ var isHandoff = false;
        if (window.MotionHandoffAnimation) {
            var appearId = (0, $cWeYk.getOptimisedAppearId)(visualElement);
            if (appearId) {
                var startTime = window.MotionHandoffAnimation(appearId, key, (0, $8oVcc.frame));
                if (startTime !== null) {
                    valueTransition.startTime = startTime;
                    isHandoff = true;
                }
            }
        }
        (0, $gjAeU.addValueToWillChange)(visualElement, key);
        value.start((0, $cUBhh.animateMotionValue)(key, value, valueTarget, visualElement.shouldReduceMotion && (0, $enWtX.positionalKeys).has(key) ? {
            type: false
        } : valueTransition, visualElement, isHandoff));
        var animation = value.animation;
        if (animation) animations.push(animation);
    }
    if (transitionEnd) Promise.all(animations).then(function() {
        (0, $8oVcc.frame).update(function() {
            transitionEnd && (0, $4HtTX.setTarget)(visualElement, transitionEnd);
        });
    });
    return animations;
}

});
parcelRegister("Oeytg", function(module, exports) {

$parcel$export(module.exports, "getValueTransition", function () { return $5181a26cd8f3096f$export$7c1391340308742e; });
function $5181a26cd8f3096f$export$7c1391340308742e(transition, key) {
    var _transition_key, _ref;
    return (_ref = (_transition_key = transition === null || transition === void 0 ? void 0 : transition[key]) !== null && _transition_key !== void 0 ? _transition_key : transition === null || transition === void 0 ? void 0 : transition["default"]) !== null && _ref !== void 0 ? _ref : transition;
}

});

parcelRegister("4HtTX", function(module, exports) {

$parcel$export(module.exports, "setTarget", function () { return $debc911be3c26118$export$1f61c53461aff4a5; });

var $joFW3 = parcelRequire("joFW3");

var $buaX5 = parcelRequire("buaX5");

var $4SyWW = parcelRequire("4SyWW");

var $eHYmI = parcelRequire("eHYmI");

var $D0HzR = parcelRequire("D0HzR");
/**
 * Set VisualElement's MotionValue, creating a new MotionValue for it if
 * it doesn't exist.
 */ function $debc911be3c26118$var$setMotionValue(visualElement, key, value) {
    if (visualElement.hasValue(key)) visualElement.getValue(key).set(value);
    else visualElement.addValue(key, (0, $4SyWW.motionValue)(value));
}
function $debc911be3c26118$var$resolveFinalValueInKeyframes(v) {
    // TODO maybe throw if v.length - 1 is placeholder token?
    return (0, $eHYmI.isKeyframesTarget)(v) ? v[v.length - 1] || 0 : v;
}
function $debc911be3c26118$export$1f61c53461aff4a5(visualElement, definition) {
    var resolved = (0, $D0HzR.resolveVariant)(visualElement, definition);
    var _ref = resolved || {}, _ref_transitionEnd = _ref.transitionEnd, transitionEnd = _ref_transitionEnd === void 0 ? {} : _ref_transitionEnd, _ref_transition = _ref.transition, transition = _ref_transition === void 0 ? {} : _ref_transition, target = (0, $buaX5._)(_ref, [
        "transitionEnd",
        "transition"
    ]);
    target = (0, $joFW3._)({}, target, transitionEnd);
    for(var key in target){
        var value = $debc911be3c26118$var$resolveFinalValueInKeyframes(target[key]);
        $debc911be3c26118$var$setMotionValue(visualElement, key, value);
    }
}

});
parcelRegister("eHYmI", function(module, exports) {

$parcel$export(module.exports, "isKeyframesTarget", function () { return $0fad434c33d9e872$export$9153ad4c4999f4a0; });
var $0fad434c33d9e872$export$9153ad4c4999f4a0 = function(v) {
    return Array.isArray(v);
};

});


parcelRegister("gjAeU", function(module, exports) {

$parcel$export(module.exports, "addValueToWillChange", function () { return $26200d9f5f242395$export$3ac5aed310be0bee; });

var $7mUth = parcelRequire("7mUth");

var $4AV2C = parcelRequire("4AV2C");
function $26200d9f5f242395$export$3ac5aed310be0bee(visualElement, key) {
    var willChange = visualElement.getValue("willChange");
    /**
     * It could be that a user has set willChange to a regular MotionValue,
     * in which case we can't add the value to it.
     */ if ((0, $4AV2C.isWillChangeMotionValue)(willChange)) return willChange.add(key);
    else if (!willChange && (0, $7mUth.MotionGlobalConfig).WillChange) {
        var newWillChange = new (0, $7mUth.MotionGlobalConfig).WillChange("auto");
        visualElement.addValue("willChange", newWillChange);
        newWillChange.add(key);
    }
}

});
parcelRegister("4AV2C", function(module, exports) {

$parcel$export(module.exports, "isWillChangeMotionValue", function () { return $851bd87414310d5a$export$98397f3adbf6259f; });

var $4drXU = parcelRequire("4drXU");
function $851bd87414310d5a$export$98397f3adbf6259f(value) {
    return Boolean((0, $4drXU.isMotionValue)(value) && value.add);
}

});


parcelRegister("cWeYk", function(module, exports) {

$parcel$export(module.exports, "getOptimisedAppearId", function () { return $6334040f84a80be4$export$5f8d21e84d1d84fc; });

var $1CiSy = parcelRequire("1CiSy");
function $6334040f84a80be4$export$5f8d21e84d1d84fc(visualElement) {
    return visualElement.props[0, $1CiSy.optimizedAppearDataAttribute];
}

});

parcelRegister("cUBhh", function(module, exports) {

$parcel$export(module.exports, "animateMotionValue", function () { return $e9a361abb303d2a2$export$90b3dfc33ff3548; });

var $joFW3 = parcelRequire("joFW3");

var $90FDw = parcelRequire("90FDw");

var $hTWo1 = parcelRequire("hTWo1");
var $8oVcc = parcelRequire("8oVcc");
var $Oeytg = parcelRequire("Oeytg");
var $aTzRr = parcelRequire("aTzRr");
var $iLBLt = parcelRequire("iLBLt");

var $7mUth = parcelRequire("7mUth");
var $04dOm = parcelRequire("04dOm");

var $hLYzX = parcelRequire("hLYzX");

var $3eyIR = parcelRequire("3eyIR");

var $bKS2F = parcelRequire("bKS2F");
var $e9a361abb303d2a2$export$90b3dfc33ff3548 = function(name, value, target) {
    var transition = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : {}, element = arguments.length > 4 ? arguments[4] : void 0, isHandoff = arguments.length > 5 ? arguments[5] : void 0;
    return function(onComplete) {
        var valueTransition = (0, $Oeytg.getValueTransition)(transition, name) || {};
        /**
     * Most transition values are currently completely overwritten by value-specific
     * transitions. In the future it'd be nicer to blend these transitions. But for now
     * delay actually does inherit from the root transition if not value-specific.
     */ var delay = valueTransition.delay || transition.delay || 0;
        /**
     * Elapsed isn't a public transition option but can be passed through from
     * optimized appear effects in milliseconds.
     */ var _transition_elapsed = transition.elapsed, elapsed = _transition_elapsed === void 0 ? 0 : _transition_elapsed;
        elapsed = elapsed - (0, $04dOm.secondsToMilliseconds)(delay);
        var options = (0, $90FDw._)((0, $joFW3._)({
            keyframes: Array.isArray(target) ? target : [
                null,
                target
            ],
            ease: "easeOut",
            velocity: value.getVelocity()
        }, valueTransition), {
            delay: -elapsed,
            onUpdate: function(v) {
                value.set(v);
                valueTransition.onUpdate && valueTransition.onUpdate(v);
            },
            onComplete: function() {
                onComplete();
                valueTransition.onComplete && valueTransition.onComplete();
            },
            name: name,
            motionValue: value,
            element: isHandoff ? undefined : element
        });
        /**
     * If there's no transition defined for this value, we can generate
     * unique transition settings for this value.
     */ if (!(0, $bKS2F.isTransitionDefined)(valueTransition)) Object.assign(options, (0, $3eyIR.getDefaultTransition)(name, options));
        /**
     * Both WAAPI and our internal animation functions use durations
     * as defined by milliseconds, while our external API defines them
     * as seconds.
     */ options.duration && (options.duration = (0, $04dOm.secondsToMilliseconds)(options.duration));
        options.repeatDelay && (options.repeatDelay = (0, $04dOm.secondsToMilliseconds)(options.repeatDelay));
        /**
     * Support deprecated way to set initial value. Prefer keyframe syntax.
     */ if (options.from !== undefined) options.keyframes[0] = options.from;
        var shouldSkip = false;
        if (options.type === false || options.duration === 0 && !options.repeatDelay) {
            (0, $iLBLt.makeAnimationInstant)(options);
            if (options.delay === 0) shouldSkip = true;
        }
        if ((0, $7mUth.MotionGlobalConfig).instantAnimations || (0, $7mUth.MotionGlobalConfig).skipAnimations) {
            shouldSkip = true;
            (0, $iLBLt.makeAnimationInstant)(options);
            options.delay = 0;
        }
        /**
     * If the transition type or easing has been explicitly set by the user
     * then we don't want to allow flattening the animation.
     */ options.allowFlatten = !valueTransition.type && !valueTransition.ease;
        /**
     * If we can or must skip creating the animation, and apply only
     * the final keyframe, do so. We also check once keyframes are resolved but
     * this early check prevents the need to create an animation at all.
     */ if (shouldSkip && !isHandoff && value.get() !== undefined) {
            var finalKeyframe = (0, $hLYzX.getFinalKeyframe)(options.keyframes, valueTransition);
            if (finalKeyframe !== undefined) {
                (0, $8oVcc.frame).update(function() {
                    options.onUpdate(finalKeyframe);
                    options.onComplete();
                });
                return;
            }
        }
        return valueTransition.isSync ? new (0, $aTzRr.JSAnimation)(options) : new (0, $hTWo1.AsyncMotionValueAnimation)(options);
    };
};

});
parcelRegister("hTWo1", function(module, exports) {

$parcel$export(module.exports, "AsyncMotionValueAnimation", function () { return $b8e26ce38b5a3366$export$b9855e2a7dee3dd2; });

var $f3Okx = parcelRequire("f3Okx");

var $grujF = parcelRequire("grujF");

var $dhMkv = parcelRequire("dhMkv");

var $j6Mzi = parcelRequire("j6Mzi");

var $joFW3 = parcelRequire("joFW3");

var $90FDw = parcelRequire("90FDw");

var $buaX5 = parcelRequire("buaX5");

var $7mUth = parcelRequire("7mUth");
var $eQ5Xp = parcelRequire("eQ5Xp");

var $j716H = parcelRequire("j716H");

var $aTzRr = parcelRequire("aTzRr");

var $dsmSc = parcelRequire("dsmSc");

var $lCMx1 = parcelRequire("lCMx1");

var $kbsuG = parcelRequire("kbsuG");

var $fsb2l = parcelRequire("fsb2l");

var $iLBLt = parcelRequire("iLBLt");

var $iqh7q = parcelRequire("iqh7q");

var $geiGS = parcelRequire("geiGS");
/**
 * Maximum time allowed between an animation being created and it being
 * resolved for us to use the latter as the start time.
 *
 * This is to ensure that while we prefer to "start" an animation as soon
 * as it's triggered, we also want to avoid a visual jump if there's a big delay
 * between these two moments.
 */ var $b8e26ce38b5a3366$var$MAX_RESOLVE_DELAY = 40;
var $b8e26ce38b5a3366$export$b9855e2a7dee3dd2 = /*#__PURE__*/ function(WithPromise) {
    "use strict";
    (0, $j6Mzi._)(AsyncMotionValueAnimation, WithPromise);
    function AsyncMotionValueAnimation(_param) {
        (0, $grujF._)(this, AsyncMotionValueAnimation);
        var _this;
        var _param_autoplay = _param.autoplay, autoplay = _param_autoplay === void 0 ? true : _param_autoplay, _param_delay = _param.delay, delay = _param_delay === void 0 ? 0 : _param_delay, _param_type = _param.type, type = _param_type === void 0 ? "keyframes" : _param_type, _param_repeat = _param.repeat, repeat = _param_repeat === void 0 ? 0 : _param_repeat, _param_repeatDelay = _param.repeatDelay, repeatDelay = _param_repeatDelay === void 0 ? 0 : _param_repeatDelay, _param_repeatType = _param.repeatType, repeatType = _param_repeatType === void 0 ? "loop" : _param_repeatType, keyframes = _param.keyframes, name = _param.name, motionValue = _param.motionValue, element = _param.element, options = (0, $buaX5._)(_param, [
            "autoplay",
            "delay",
            "type",
            "repeat",
            "repeatDelay",
            "repeatType",
            "keyframes",
            "name",
            "motionValue",
            "element"
        ]);
        var _this_keyframeResolver;
        _this = (0, $f3Okx._)(this, AsyncMotionValueAnimation);
        /**
         * Bound to support return animation.stop pattern
         */ _this.stop = function() {
            var _this_keyframeResolver;
            if (_this._animation) {
                var _this_stopTimeline, _this1;
                _this._animation.stop();
                (_this_stopTimeline = (_this1 = _this).stopTimeline) === null || _this_stopTimeline === void 0 ? void 0 : _this_stopTimeline.call(_this1);
            }
            (_this_keyframeResolver = _this.keyframeResolver) === null || _this_keyframeResolver === void 0 ? void 0 : _this_keyframeResolver.cancel();
        };
        _this.createdAt = (0, $j716H.time).now();
        var optionsWithDefaults = (0, $joFW3._)({
            autoplay: autoplay,
            delay: delay,
            type: type,
            repeat: repeat,
            repeatDelay: repeatDelay,
            repeatType: repeatType,
            name: name,
            motionValue: motionValue,
            element: element
        }, options);
        var KeyframeResolver$1 = (element === null || element === void 0 ? void 0 : element.KeyframeResolver) || (0, $lCMx1.KeyframeResolver);
        _this.keyframeResolver = new KeyframeResolver$1(keyframes, function(resolvedKeyframes, finalKeyframe, forced) {
            return _this.onKeyframesResolved(resolvedKeyframes, finalKeyframe, optionsWithDefaults, !forced);
        }, name, motionValue, element);
        (_this_keyframeResolver = _this.keyframeResolver) === null || _this_keyframeResolver === void 0 ? void 0 : _this_keyframeResolver.scheduleResolve();
        return _this;
    }
    (0, $dhMkv._)(AsyncMotionValueAnimation, [
        {
            key: "onKeyframesResolved",
            value: function onKeyframesResolved(keyframes, finalKeyframe, options, sync) {
                var _this = this;
                this.keyframeResolver = undefined;
                var name = options.name, type = options.type, velocity = options.velocity, delay = options.delay, isHandoff = options.isHandoff, onUpdate = options.onUpdate;
                this.resolvedAt = (0, $j716H.time).now();
                /**
         * If we can't animate this value with the resolved keyframes
         * then we should complete it immediately.
         */ if (!(0, $fsb2l.canAnimate)(keyframes, name, type, velocity)) {
                    if ((0, $7mUth.MotionGlobalConfig).instantAnimations || !delay) onUpdate === null || onUpdate === void 0 ? void 0 : onUpdate((0, $dsmSc.getFinalKeyframe)(keyframes, options, finalKeyframe));
                    keyframes[0] = keyframes[keyframes.length - 1];
                    (0, $iLBLt.makeAnimationInstant)(options);
                    options.repeat = 0;
                }
                /**
         * Resolve startTime for the animation.
         *
         * This method uses the createdAt and resolvedAt to calculate the
         * animation startTime. *Ideally*, we would use the createdAt time as t=0
         * as the following frame would then be the first frame of the animation in
         * progress, which would feel snappier.
         *
         * However, if there's a delay (main thread work) between the creation of
         * the animation and the first commited frame, we prefer to use resolvedAt
         * to avoid a sudden jump into the animation.
         */ var startTime = sync ? !this.resolvedAt ? this.createdAt : this.resolvedAt - this.createdAt > $b8e26ce38b5a3366$var$MAX_RESOLVE_DELAY ? this.resolvedAt : this.createdAt : undefined;
                var resolvedOptions = (0, $90FDw._)((0, $joFW3._)({
                    startTime: startTime,
                    finalKeyframe: finalKeyframe
                }, options), {
                    keyframes: keyframes
                });
                /**
         * Animate via WAAPI if possible. If this is a handoff animation, the optimised animation will be running via
         * WAAPI. Therefore, this animation must be JS to ensure it runs "under" the
         * optimised animation.
         */ var animation = !isHandoff && (0, $geiGS.supportsBrowserAnimation)(resolvedOptions) ? new (0, $kbsuG.NativeAnimationExtended)((0, $90FDw._)((0, $joFW3._)({}, resolvedOptions), {
                    element: resolvedOptions.motionValue.owner.current
                })) : new (0, $aTzRr.JSAnimation)(resolvedOptions);
                animation.finished.then(function() {
                    return _this.notifyFinished();
                }).catch((0, $eQ5Xp.noop));
                if (this.pendingTimeline) {
                    this.stopTimeline = animation.attachTimeline(this.pendingTimeline);
                    this.pendingTimeline = undefined;
                }
                this._animation = animation;
            }
        },
        {
            key: "finished",
            get: function get() {
                if (!this._animation) return this._finished;
                else return this.animation.finished;
            }
        },
        {
            key: "then",
            value: function then(onResolve, _onReject) {
                return this.finished.finally(onResolve).then(function() {});
            }
        },
        {
            key: "animation",
            get: function get() {
                if (!this._animation) {
                    var _this_keyframeResolver;
                    (_this_keyframeResolver = this.keyframeResolver) === null || _this_keyframeResolver === void 0 ? void 0 : _this_keyframeResolver.resume();
                    (0, $lCMx1.flushKeyframeResolvers)();
                }
                return this._animation;
            }
        },
        {
            key: "duration",
            get: function get() {
                return this.animation.duration;
            }
        },
        {
            key: "iterationDuration",
            get: function get() {
                return this.animation.iterationDuration;
            }
        },
        {
            key: "time",
            get: function get() {
                return this.animation.time;
            },
            set: function set(newTime) {
                this.animation.time = newTime;
            }
        },
        {
            key: "speed",
            get: function get() {
                return this.animation.speed;
            },
            set: function set(newSpeed) {
                this.animation.speed = newSpeed;
            }
        },
        {
            key: "state",
            get: function get() {
                return this.animation.state;
            }
        },
        {
            key: "startTime",
            get: function get() {
                return this.animation.startTime;
            }
        },
        {
            key: "attachTimeline",
            value: function attachTimeline(timeline) {
                var _this = this;
                if (this._animation) this.stopTimeline = this.animation.attachTimeline(timeline);
                else this.pendingTimeline = timeline;
                return function() {
                    return _this.stop();
                };
            }
        },
        {
            key: "play",
            value: function play() {
                this.animation.play();
            }
        },
        {
            key: "pause",
            value: function pause() {
                this.animation.pause();
            }
        },
        {
            key: "complete",
            value: function complete() {
                this.animation.complete();
            }
        },
        {
            key: "cancel",
            value: function cancel() {
                var _this_keyframeResolver;
                if (this._animation) this.animation.cancel();
                (_this_keyframeResolver = this.keyframeResolver) === null || _this_keyframeResolver === void 0 ? void 0 : _this_keyframeResolver.cancel();
            }
        }
    ]);
    return AsyncMotionValueAnimation;
}((0, $iqh7q.WithPromise));

});
parcelRegister("aTzRr", function(module, exports) {

$parcel$export(module.exports, "JSAnimation", function () { return $f010deb53288dc15$export$3394f837405475c7; });

var $f3Okx = parcelRequire("f3Okx");

var $grujF = parcelRequire("grujF");

var $dhMkv = parcelRequire("dhMkv");

var $j6Mzi = parcelRequire("j6Mzi");

var $joFW3 = parcelRequire("joFW3");

var $90FDw = parcelRequire("90FDw");

var $2us1u = parcelRequire("2us1u");

var $3BJvs = parcelRequire("3BJvs");
var $04dOm = parcelRequire("04dOm");
var $1Te65 = parcelRequire("1Te65");

var $j716H = parcelRequire("j716H");

var $2gN7O = parcelRequire("2gN7O");

var $bbEF1 = parcelRequire("bbEF1");

var $lMd1J = parcelRequire("lMd1J");

var $815XJ = parcelRequire("815XJ");

var $fndcd = parcelRequire("fndcd");

var $lvPjb = parcelRequire("lvPjb");

var $dsmSc = parcelRequire("dsmSc");

var $kzQqU = parcelRequire("kzQqU");

var $iqh7q = parcelRequire("iqh7q");
var $f010deb53288dc15$var$percentToProgress = function(percent) {
    return percent / 100;
};
var $f010deb53288dc15$export$3394f837405475c7 = /*#__PURE__*/ function(WithPromise) {
    "use strict";
    (0, $j6Mzi._)(JSAnimation, WithPromise);
    function JSAnimation(options) {
        (0, $grujF._)(this, JSAnimation);
        var _this;
        _this = (0, $f3Okx._)(this, JSAnimation);
        _this.state = "idle";
        _this.startTime = null;
        _this.isStopped = false;
        /**
         * The current time of the animation.
         */ _this.currentTime = 0;
        /**
         * The time at which the animation was paused.
         */ _this.holdTime = null;
        /**
         * Playback speed as a factor. 0 would be stopped, -1 reverse and 2 double speed.
         */ _this.playbackSpeed = 1;
        /**
         * This method is bound to the instance to fix a pattern where
         * animation.stop is returned as a reference from a useEffect.
         */ _this.stop = function() {
            var _this_options_onStop, _this_options;
            var motionValue = _this.options.motionValue;
            if (motionValue && motionValue.updatedAt !== (0, $j716H.time).now()) _this.tick((0, $j716H.time).now());
            _this.isStopped = true;
            if (_this.state === "idle") return;
            _this.teardown();
            (_this_options_onStop = (_this_options = _this.options).onStop) === null || _this_options_onStop === void 0 ? void 0 : _this_options_onStop.call(_this_options);
        };
        (0, $2gN7O.activeAnimations).mainThread++;
        _this.options = options;
        _this.initAnimation();
        _this.play();
        if (options.autoplay === false) _this.pause();
        return _this;
    }
    (0, $dhMkv._)(JSAnimation, [
        {
            key: "initAnimation",
            value: function initAnimation() {
                var options = this.options;
                (0, $kzQqU.replaceTransitionType)(options);
                var _options_type = options.type, type = _options_type === void 0 ? (0, $fndcd.keyframes) : _options_type, _options_repeat = options.repeat, repeat = _options_repeat === void 0 ? 0 : _options_repeat, _options_repeatDelay = options.repeatDelay, repeatDelay = _options_repeatDelay === void 0 ? 0 : _options_repeatDelay, repeatType = options.repeatType, _options_velocity = options.velocity, velocity = _options_velocity === void 0 ? 0 : _options_velocity;
                var keyframes$1 = options.keyframes;
                var generatorFactory = type || (0, $fndcd.keyframes);
                if (generatorFactory !== (0, $fndcd.keyframes) && typeof keyframes$1[0] !== "number") {
                    this.mixKeyframes = (0, $1Te65.pipe)($f010deb53288dc15$var$percentToProgress, (0, $bbEF1.mix)(keyframes$1[0], keyframes$1[1]));
                    keyframes$1 = [
                        0,
                        100
                    ];
                }
                var generator = generatorFactory((0, $90FDw._)((0, $joFW3._)({}, options), {
                    keyframes: keyframes$1
                }));
                /**
         * If we have a mirror repeat type we need to create a second generator that outputs the
         * mirrored (not reversed) animation and later ping pong between the two generators.
         */ if (repeatType === "mirror") this.mirroredGenerator = generatorFactory((0, $90FDw._)((0, $joFW3._)({}, options), {
                    keyframes: (0, $2us1u._)(keyframes$1).reverse(),
                    velocity: -velocity
                }));
                /**
         * If duration is undefined and we have repeat options,
         * we need to calculate a duration from the generator.
         *
         * We set it to the generator itself to cache the duration.
         * Any timeline resolver will need to have already precalculated
         * the duration by this step.
         */ if (generator.calculatedDuration === null) generator.calculatedDuration = (0, $lvPjb.calcGeneratorDuration)(generator);
                var calculatedDuration = generator.calculatedDuration;
                this.calculatedDuration = calculatedDuration;
                this.resolvedDuration = calculatedDuration + repeatDelay;
                this.totalDuration = this.resolvedDuration * (repeat + 1) - repeatDelay;
                this.generator = generator;
            }
        },
        {
            key: "updateTime",
            value: function updateTime(timestamp) {
                var animationTime = Math.round(timestamp - this.startTime) * this.playbackSpeed;
                // Update currentTime
                if (this.holdTime !== null) this.currentTime = this.holdTime;
                else // Rounding the time because floating point arithmetic is not always accurate, e.g. 3000.367 - 1000.367 =
                // 2000.0000000000002. This is a problem when we are comparing the currentTime with the duration, for
                // example.
                this.currentTime = animationTime;
            }
        },
        {
            key: "tick",
            value: function tick(timestamp) {
                var sample = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false;
                var _this = this, generator = _this.generator, totalDuration = _this.totalDuration, mixKeyframes = _this.mixKeyframes, mirroredGenerator = _this.mirroredGenerator, resolvedDuration = _this.resolvedDuration, calculatedDuration = _this.calculatedDuration;
                if (this.startTime === null) return generator.next(0);
                var _this_options = this.options, _this_options_delay = _this_options.delay, delay = _this_options_delay === void 0 ? 0 : _this_options_delay, keyframes = _this_options.keyframes, repeat = _this_options.repeat, repeatType = _this_options.repeatType, repeatDelay = _this_options.repeatDelay, type = _this_options.type, onUpdate = _this_options.onUpdate, finalKeyframe = _this_options.finalKeyframe;
                /**
         * requestAnimationFrame timestamps can come through as lower than
         * the startTime as set by performance.now(). Here we prevent this,
         * though in the future it could be possible to make setting startTime
         * a pending operation that gets resolved here.
         */ if (this.speed > 0) this.startTime = Math.min(this.startTime, timestamp);
                else if (this.speed < 0) this.startTime = Math.min(timestamp - totalDuration / this.speed, this.startTime);
                if (sample) this.currentTime = timestamp;
                else this.updateTime(timestamp);
                // Rebase on delay
                var timeWithoutDelay = this.currentTime - delay * (this.playbackSpeed >= 0 ? 1 : -1);
                var isInDelayPhase = this.playbackSpeed >= 0 ? timeWithoutDelay < 0 : timeWithoutDelay > totalDuration;
                this.currentTime = Math.max(timeWithoutDelay, 0);
                // If this animation has finished, set the current time  to the total duration.
                if (this.state === "finished" && this.holdTime === null) this.currentTime = totalDuration;
                var elapsed = this.currentTime;
                var frameGenerator = generator;
                if (repeat) {
                    /**
             * Get the current progress (0-1) of the animation. If t is >
             * than duration we'll get values like 2.5 (midway through the
             * third iteration)
             */ var progress = Math.min(this.currentTime, totalDuration) / resolvedDuration;
                    /**
             * Get the current iteration (0 indexed). For instance the floor of
             * 2.5 is 2.
             */ var currentIteration = Math.floor(progress);
                    /**
             * Get the current progress of the iteration by taking the remainder
             * so 2.5 is 0.5 through iteration 2
             */ var iterationProgress = progress % 1.0;
                    /**
             * If iteration progress is 1 we count that as the end
             * of the previous iteration.
             */ if (!iterationProgress && progress >= 1) iterationProgress = 1;
                    iterationProgress === 1 && currentIteration--;
                    currentIteration = Math.min(currentIteration, repeat + 1);
                    /**
             * Reverse progress if we're not running in "normal" direction
             */ var isOddIteration = Boolean(currentIteration % 2);
                    if (isOddIteration) {
                        if (repeatType === "reverse") {
                            iterationProgress = 1 - iterationProgress;
                            if (repeatDelay) iterationProgress -= repeatDelay / resolvedDuration;
                        } else if (repeatType === "mirror") frameGenerator = mirroredGenerator;
                    }
                    elapsed = (0, $3BJvs.clamp)(0, 1, iterationProgress) * resolvedDuration;
                }
                /**
         * If we're in negative time, set state as the initial keyframe.
         * This prevents delay: x, duration: 0 animations from finishing
         * instantly.
         */ var state = isInDelayPhase ? {
                    done: false,
                    value: keyframes[0]
                } : frameGenerator.next(elapsed);
                if (mixKeyframes) state.value = mixKeyframes(state.value);
                var done = state.done;
                if (!isInDelayPhase && calculatedDuration !== null) done = this.playbackSpeed >= 0 ? this.currentTime >= totalDuration : this.currentTime <= 0;
                var isAnimationFinished = this.holdTime === null && (this.state === "finished" || this.state === "running" && done);
                // TODO: The exception for inertia could be cleaner here
                if (isAnimationFinished && type !== (0, $815XJ.inertia)) state.value = (0, $dsmSc.getFinalKeyframe)(keyframes, this.options, finalKeyframe, this.speed);
                if (onUpdate) onUpdate(state.value);
                if (isAnimationFinished) this.finish();
                return state;
            }
        },
        {
            /**
     * Allows the returned animation to be awaited or promise-chained. Currently
     * resolves when the animation finishes at all but in a future update could/should
     * reject if its cancels.
     */ key: "then",
            value: function then(resolve, reject) {
                return this.finished.then(resolve, reject);
            }
        },
        {
            key: "duration",
            get: function get() {
                return (0, $04dOm.millisecondsToSeconds)(this.calculatedDuration);
            }
        },
        {
            key: "iterationDuration",
            get: function get() {
                var _ref = this.options || {}, _ref_delay = _ref.delay, delay = _ref_delay === void 0 ? 0 : _ref_delay;
                return this.duration + (0, $04dOm.millisecondsToSeconds)(delay);
            }
        },
        {
            key: "time",
            get: function get() {
                return (0, $04dOm.millisecondsToSeconds)(this.currentTime);
            },
            set: function set(newTime) {
                var _this_driver;
                newTime = (0, $04dOm.secondsToMilliseconds)(newTime);
                this.currentTime = newTime;
                if (this.startTime === null || this.holdTime !== null || this.playbackSpeed === 0) this.holdTime = newTime;
                else if (this.driver) this.startTime = this.driver.now() - newTime / this.playbackSpeed;
                (_this_driver = this.driver) === null || _this_driver === void 0 ? void 0 : _this_driver.start(false);
            }
        },
        {
            key: "speed",
            get: function get() {
                return this.playbackSpeed;
            },
            set: function set(newSpeed) {
                this.updateTime((0, $j716H.time).now());
                var hasChanged = this.playbackSpeed !== newSpeed;
                this.playbackSpeed = newSpeed;
                if (hasChanged) this.time = (0, $04dOm.millisecondsToSeconds)(this.currentTime);
            }
        },
        {
            key: "play",
            value: function play() {
                var _this = this;
                var _this_options_onPlay, _this_options;
                if (this.isStopped) return;
                var _this_options1 = this.options, _this_options_driver = _this_options1.driver, driver = _this_options_driver === void 0 ? (0, $lMd1J.frameloopDriver) : _this_options_driver, startTime = _this_options1.startTime;
                if (!this.driver) this.driver = driver(function(timestamp) {
                    return _this.tick(timestamp);
                });
                (_this_options_onPlay = (_this_options = this.options).onPlay) === null || _this_options_onPlay === void 0 ? void 0 : _this_options_onPlay.call(_this_options);
                var now = this.driver.now();
                if (this.state === "finished") {
                    this.updateFinished();
                    this.startTime = now;
                } else if (this.holdTime !== null) this.startTime = now - this.holdTime;
                else if (!this.startTime) this.startTime = startTime !== null && startTime !== void 0 ? startTime : now;
                if (this.state === "finished" && this.speed < 0) this.startTime += this.calculatedDuration;
                this.holdTime = null;
                /**
         * Set playState to running only after we've used it in
         * the previous logic.
         */ this.state = "running";
                this.driver.start();
            }
        },
        {
            key: "pause",
            value: function pause() {
                this.state = "paused";
                this.updateTime((0, $j716H.time).now());
                this.holdTime = this.currentTime;
            }
        },
        {
            key: "complete",
            value: function complete() {
                if (this.state !== "running") this.play();
                this.state = "finished";
                this.holdTime = null;
            }
        },
        {
            key: "finish",
            value: function finish() {
                var _this_options_onComplete, _this_options;
                this.notifyFinished();
                this.teardown();
                this.state = "finished";
                (_this_options_onComplete = (_this_options = this.options).onComplete) === null || _this_options_onComplete === void 0 ? void 0 : _this_options_onComplete.call(_this_options);
            }
        },
        {
            key: "cancel",
            value: function cancel() {
                var _this_options_onCancel, _this_options;
                this.holdTime = null;
                this.startTime = 0;
                this.tick(0);
                this.teardown();
                (_this_options_onCancel = (_this_options = this.options).onCancel) === null || _this_options_onCancel === void 0 ? void 0 : _this_options_onCancel.call(_this_options);
            }
        },
        {
            key: "teardown",
            value: function teardown() {
                this.state = "idle";
                this.stopDriver();
                this.startTime = this.holdTime = null;
                (0, $2gN7O.activeAnimations).mainThread--;
            }
        },
        {
            key: "stopDriver",
            value: function stopDriver() {
                if (!this.driver) return;
                this.driver.stop();
                this.driver = undefined;
            }
        },
        {
            key: "sample",
            value: function sample(sampleTime) {
                this.startTime = 0;
                return this.tick(sampleTime, true);
            }
        },
        {
            key: "attachTimeline",
            value: function attachTimeline(timeline) {
                var _this_driver;
                if (this.options.allowFlatten) {
                    this.options.type = "keyframes";
                    this.options.ease = "linear";
                    this.initAnimation();
                }
                (_this_driver = this.driver) === null || _this_driver === void 0 ? void 0 : _this_driver.stop();
                return timeline.observe(this);
            }
        }
    ]);
    return JSAnimation;
}((0, $iqh7q.WithPromise));
// Legacy function support
function $f010deb53288dc15$export$ee9b76de7353d815(options) {
    return new $f010deb53288dc15$export$3394f837405475c7(options);
}

});
parcelRegister("04dOm", function(module, exports) {

$parcel$export(module.exports, "secondsToMilliseconds", function () { return $bd3547e405d3818c$export$fc3e7e8557f8c8c7; });
$parcel$export(module.exports, "millisecondsToSeconds", function () { return $bd3547e405d3818c$export$f64c3bfbc58eec0f; });
/**
 * Converts seconds to milliseconds
 *
 * @param seconds - Time in seconds.
 * @return milliseconds - Converted time in milliseconds.
 */ /*#__NO_SIDE_EFFECTS__*/ var $bd3547e405d3818c$export$fc3e7e8557f8c8c7 = function(seconds) {
    return seconds * 1000;
};
/*#__NO_SIDE_EFFECTS__*/ var $bd3547e405d3818c$export$f64c3bfbc58eec0f = function(milliseconds) {
    return milliseconds / 1000;
};

});

parcelRegister("1Te65", function(module, exports) {

$parcel$export(module.exports, "pipe", function () { return $68e9070eda7c19a0$export$a4627e546088548d; });
/**
 * Pipe
 * Compose other transformers to run linearily
 * pipe(min(20), max(40))
 * @param  {...functions} transformers
 * @return {function}
 */ var $68e9070eda7c19a0$var$combineFunctions = function(a, b) {
    return function(v) {
        return b(a(v));
    };
};
var $68e9070eda7c19a0$export$a4627e546088548d = function() {
    for(var _len = arguments.length, transformers = new Array(_len), _key = 0; _key < _len; _key++){
        transformers[_key] = arguments[_key];
    }
    return transformers.reduce($68e9070eda7c19a0$var$combineFunctions);
};

});

parcelRegister("2gN7O", function(module, exports) {

$parcel$export(module.exports, "activeAnimations", function () { return $ae38305072f05d88$export$d921fb2475e2900c; });
var $ae38305072f05d88$export$d921fb2475e2900c = {
    layout: 0,
    mainThread: 0,
    waapi: 0
};

});

parcelRegister("bbEF1", function(module, exports) {

$parcel$export(module.exports, "mix", function () { return $aea48e835f85b8da$export$2c9e8a9632a706b2; });

var $b4ajx = parcelRequire("b4ajx");

var $83rca = parcelRequire("83rca");
function $aea48e835f85b8da$export$2c9e8a9632a706b2(from, to, p) {
    if (typeof from === "number" && typeof to === "number" && typeof p === "number") return (0, $83rca.mixNumber)(from, to, p);
    var mixer = (0, $b4ajx.getMixer)(from);
    return mixer(from, to);
}

});
parcelRegister("b4ajx", function(module, exports) {

$parcel$export(module.exports, "getMixer", function () { return $a04c78958da31b69$export$36ec24672cd098e0; });

var $joFW3 = parcelRequire("joFW3");

var $2us1u = parcelRequire("2us1u");

var $bJtXW = parcelRequire("bJtXW");

var $1Te65 = parcelRequire("1Te65");
var $FCK0G = parcelRequire("FCK0G");

var $5nvLr = parcelRequire("5nvLr");

var $1WGCc = parcelRequire("1WGCc");

var $8S0wI = parcelRequire("8S0wI");

var $2lxkk = parcelRequire("2lxkk");

var $5Cl4m = parcelRequire("5Cl4m");

var $83rca = parcelRequire("83rca");

var $kiPNf = parcelRequire("kiPNf");
function $a04c78958da31b69$var$mixNumber(a, b) {
    return function(p) {
        return (0, $83rca.mixNumber)(a, b, p);
    };
}
function $a04c78958da31b69$export$36ec24672cd098e0(a) {
    if (typeof a === "number") return $a04c78958da31b69$var$mixNumber;
    else if (typeof a === "string") return (0, $5nvLr.isCSSVariableToken)(a) ? (0, $5Cl4m.mixImmediate) : (0, $1WGCc.color).test(a) ? (0, $2lxkk.mixColor) : $a04c78958da31b69$export$65516310a87d8205;
    else if (Array.isArray(a)) return $a04c78958da31b69$export$3bbefa2f402845c4;
    else if ((typeof a === "undefined" ? "undefined" : (0, $bJtXW._)(a)) === "object") return (0, $1WGCc.color).test(a) ? (0, $2lxkk.mixColor) : $a04c78958da31b69$export$ebc23b6840c51ba1;
    return 0, $5Cl4m.mixImmediate;
}
function $a04c78958da31b69$export$3bbefa2f402845c4(a, b) {
    var output = (0, $2us1u._)(a);
    var numValues = output.length;
    var blendValue = a.map(function(v, i) {
        return $a04c78958da31b69$export$36ec24672cd098e0(v)(v, b[i]);
    });
    return function(p) {
        for(var i = 0; i < numValues; i++)output[i] = blendValue[i](p);
        return output;
    };
}
function $a04c78958da31b69$export$ebc23b6840c51ba1(a, b) {
    var output = (0, $joFW3._)({}, a, b);
    var blendValue = {};
    for(var key in output)if (a[key] !== undefined && b[key] !== undefined) blendValue[key] = $a04c78958da31b69$export$36ec24672cd098e0(a[key])(a[key], b[key]);
    return function(v) {
        for(var key in blendValue)output[key] = blendValue[key](v);
        return output;
    };
}
function $a04c78958da31b69$var$matchOrder(origin, target) {
    var orderedOrigin = [];
    var pointers = {
        color: 0,
        var: 0,
        number: 0
    };
    for(var i = 0; i < target.values.length; i++){
        var type = target.types[i];
        var originIndex = origin.indexes[type][pointers[type]];
        var _origin_values_originIndex;
        var originValue = (_origin_values_originIndex = origin.values[originIndex]) !== null && _origin_values_originIndex !== void 0 ? _origin_values_originIndex : 0;
        orderedOrigin[i] = originValue;
        pointers[type]++;
    }
    return orderedOrigin;
}
var $a04c78958da31b69$export$65516310a87d8205 = function(origin, target) {
    var template = (0, $8S0wI.complex).createTransformer(target);
    var originStats = (0, $8S0wI.analyseComplexValue)(origin);
    var targetStats = (0, $8S0wI.analyseComplexValue)(target);
    var canInterpolate = originStats.indexes.var.length === targetStats.indexes.var.length && originStats.indexes.color.length === targetStats.indexes.color.length && originStats.indexes.number.length >= targetStats.indexes.number.length;
    if (canInterpolate) {
        if ((0, $kiPNf.invisibleValues).has(origin) && !targetStats.values.length || (0, $kiPNf.invisibleValues).has(target) && !originStats.values.length) return (0, $kiPNf.mixVisibility)(origin, target);
        return (0, $1Te65.pipe)($a04c78958da31b69$export$3bbefa2f402845c4($a04c78958da31b69$var$matchOrder(originStats, targetStats), targetStats.values), template);
    } else {
        (0, $FCK0G.warning)(true, "Complex values '".concat(origin, "' and '").concat(target, "' too different to mix. Ensure all colors are of the same type, and that each contains the same quantity of number and color values. Falling back to instant transition."), "complex-values-different");
        return (0, $5Cl4m.mixImmediate)(origin, target);
    }
};

});
parcelRegister("2lxkk", function(module, exports) {

$parcel$export(module.exports, "mixColor", function () { return $01135436030f36c7$export$51e568cf5c039bac; });

var $joFW3 = parcelRequire("joFW3");

var $FCK0G = parcelRequire("FCK0G");

var $911y6 = parcelRequire("911y6");

var $dKdh0 = parcelRequire("dKdh0");

var $6M9jb = parcelRequire("6M9jb");

var $48zq7 = parcelRequire("48zq7");

var $5Cl4m = parcelRequire("5Cl4m");

var $83rca = parcelRequire("83rca");
// Linear color space blending
// Explained https://www.youtube.com/watch?v=LKnqECcg6Gw
// Demonstrated http://codepen.io/osublake/pen/xGVVaN
var $01135436030f36c7$export$d4ecea248cce73c = function(from, to, v) {
    var fromExpo = from * from;
    var expo = v * (to * to - fromExpo) + fromExpo;
    return expo < 0 ? 0 : Math.sqrt(expo);
};
var $01135436030f36c7$var$colorTypes = [
    (0, $911y6.hex),
    (0, $48zq7.rgba),
    (0, $dKdh0.hsla)
];
var $01135436030f36c7$var$getColorType = function(v) {
    return $01135436030f36c7$var$colorTypes.find(function(type) {
        return type.test(v);
    });
};
function $01135436030f36c7$var$asRGBA(color) {
    var type = $01135436030f36c7$var$getColorType(color);
    (0, $FCK0G.warning)(Boolean(type), "'".concat(color, "' is not an animatable color. Use the equivalent color code instead."), "color-not-animatable");
    if (!Boolean(type)) return false;
    var model = type.parse(color);
    if (type === (0, $dKdh0.hsla)) // TODO Remove this cast - needed since Motion's stricter typing
    model = (0, $6M9jb.hslaToRgba)(model);
    return model;
}
var $01135436030f36c7$export$51e568cf5c039bac = function(from, to) {
    var fromRGBA = $01135436030f36c7$var$asRGBA(from);
    var toRGBA = $01135436030f36c7$var$asRGBA(to);
    if (!fromRGBA || !toRGBA) return (0, $5Cl4m.mixImmediate)(from, to);
    var blended = (0, $joFW3._)({}, fromRGBA);
    return function(v) {
        blended.red = $01135436030f36c7$export$d4ecea248cce73c(fromRGBA.red, toRGBA.red, v);
        blended.green = $01135436030f36c7$export$d4ecea248cce73c(fromRGBA.green, toRGBA.green, v);
        blended.blue = $01135436030f36c7$export$d4ecea248cce73c(fromRGBA.blue, toRGBA.blue, v);
        blended.alpha = (0, $83rca.mixNumber)(fromRGBA.alpha, toRGBA.alpha, v);
        return (0, $48zq7.rgba).transform(blended);
    };
};

});
parcelRegister("6M9jb", function(module, exports) {

$parcel$export(module.exports, "hslaToRgba", function () { return $b667b5a137a8a3a3$export$6ae64dbcd6bfc33e; });
// Adapted from https://gist.github.com/mjackson/5311256
function $b667b5a137a8a3a3$var$hueToRgb(p, q, t) {
    if (t < 0) t += 1;
    if (t > 1) t -= 1;
    if (t < 1 / 6) return p + (q - p) * 6 * t;
    if (t < 0.5) return q;
    if (t < 2 / 3) return p + (q - p) * (2 / 3 - t) * 6;
    return p;
}
function $b667b5a137a8a3a3$export$6ae64dbcd6bfc33e(param) {
    var hue = param.hue, saturation = param.saturation, lightness = param.lightness, alpha = param.alpha;
    hue /= 360;
    saturation /= 100;
    lightness /= 100;
    var red = 0;
    var green = 0;
    var blue = 0;
    if (!saturation) red = green = blue = lightness;
    else {
        var q = lightness < 0.5 ? lightness * (1 + saturation) : lightness + saturation - lightness * saturation;
        var p = 2 * lightness - q;
        red = $b667b5a137a8a3a3$var$hueToRgb(p, q, hue + 1 / 3);
        green = $b667b5a137a8a3a3$var$hueToRgb(p, q, hue);
        blue = $b667b5a137a8a3a3$var$hueToRgb(p, q, hue - 1 / 3);
    }
    return {
        red: Math.round(red * 255),
        green: Math.round(green * 255),
        blue: Math.round(blue * 255),
        alpha: alpha
    };
}

});

parcelRegister("5Cl4m", function(module, exports) {

$parcel$export(module.exports, "mixImmediate", function () { return $a6403ffdecbe80d0$export$a6f92d4bae65c0f1; });
function $a6403ffdecbe80d0$export$a6f92d4bae65c0f1(a, b) {
    return function(p) {
        return p > 0 ? b : a;
    };
}

});


parcelRegister("kiPNf", function(module, exports) {

$parcel$export(module.exports, "invisibleValues", function () { return $0b925af28154e13e$export$e5a55ae567dd4ac7; });
$parcel$export(module.exports, "mixVisibility", function () { return $0b925af28154e13e$export$fed62ccc3fb1a568; });
var $0b925af28154e13e$export$e5a55ae567dd4ac7 = new Set([
    "none",
    "hidden"
]);
/**
 * Returns a function that, when provided a progress value between 0 and 1,
 * will return the "none" or "hidden" string only when the progress is that of
 * the origin or target.
 */ function $0b925af28154e13e$export$fed62ccc3fb1a568(origin, target) {
    if ($0b925af28154e13e$export$e5a55ae567dd4ac7.has(origin)) return function(p) {
        return p <= 0 ? origin : target;
    };
    else return function(p) {
        return p >= 1 ? target : origin;
    };
}

});



parcelRegister("lMd1J", function(module, exports) {

$parcel$export(module.exports, "frameloopDriver", function () { return $b3a1a27a82e31e9b$export$c1033964b5ad7fef; });

var $j716H = parcelRequire("j716H");

var $8oVcc = parcelRequire("8oVcc");
var $b3a1a27a82e31e9b$export$c1033964b5ad7fef = function(update) {
    var passTimestamp = function(param) {
        var timestamp = param.timestamp;
        return update(timestamp);
    };
    return {
        start: function() {
            var keepAlive = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : true;
            return (0, $8oVcc.frame).update(passTimestamp, keepAlive);
        },
        stop: function() {
            return (0, $8oVcc.cancelFrame)(passTimestamp);
        },
        /**
         * If we're processing this frame we can use the
         * framelocked timestamp to keep things in sync.
         */ now: function() {
            return (0, $8oVcc.frameData).isProcessing ? (0, $8oVcc.frameData).timestamp : (0, $j716H.time).now();
        }
    };
};

});

parcelRegister("815XJ", function(module, exports) {

$parcel$export(module.exports, "inertia", function () { return $0a533f16da2ff2e9$export$ee3ff3a17106998; });

var $jDzBZ = parcelRequire("jDzBZ");

var $eV6JV = parcelRequire("eV6JV");
function $0a533f16da2ff2e9$export$ee3ff3a17106998(param) {
    var keyframes = param.keyframes, _param_velocity = param.velocity, velocity = _param_velocity === void 0 ? 0.0 : _param_velocity, _param_power = param.power, power = _param_power === void 0 ? 0.8 : _param_power, _param_timeConstant = param.timeConstant, timeConstant = _param_timeConstant === void 0 ? 325 : _param_timeConstant, _param_bounceDamping = param.bounceDamping, bounceDamping = _param_bounceDamping === void 0 ? 10 : _param_bounceDamping, _param_bounceStiffness = param.bounceStiffness, bounceStiffness = _param_bounceStiffness === void 0 ? 500 : _param_bounceStiffness, modifyTarget = param.modifyTarget, min = param.min, max = param.max, _param_restDelta = param.restDelta, restDelta = _param_restDelta === void 0 ? 0.5 : _param_restDelta, restSpeed = param.restSpeed;
    var origin = keyframes[0];
    var state = {
        done: false,
        value: origin
    };
    var isOutOfBounds = function(v) {
        return min !== undefined && v < min || max !== undefined && v > max;
    };
    var nearestBoundary = function(v) {
        if (min === undefined) return max;
        if (max === undefined) return min;
        return Math.abs(min - v) < Math.abs(max - v) ? min : max;
    };
    var amplitude = power * velocity;
    var ideal = origin + amplitude;
    var target = modifyTarget === undefined ? ideal : modifyTarget(ideal);
    /**
     * If the target has changed we need to re-calculate the amplitude, otherwise
     * the animation will start from the wrong position.
     */ if (target !== ideal) amplitude = target - origin;
    var calcDelta = function(t) {
        return -amplitude * Math.exp(-t / timeConstant);
    };
    var calcLatest = function(t) {
        return target + calcDelta(t);
    };
    var applyFriction = function(t) {
        var delta = calcDelta(t);
        var latest = calcLatest(t);
        state.done = Math.abs(delta) <= restDelta;
        state.value = state.done ? target : latest;
    };
    /**
     * Ideally this would resolve for t in a stateless way, we could
     * do that by always precalculating the animation but as we know
     * this will be done anyway we can assume that spring will
     * be discovered during that.
     */ var timeReachedBoundary;
    var spring$1;
    var checkCatchBoundary = function(t) {
        if (!isOutOfBounds(state.value)) return;
        timeReachedBoundary = t;
        spring$1 = (0, $jDzBZ.spring)({
            keyframes: [
                state.value,
                nearestBoundary(state.value)
            ],
            velocity: (0, $eV6JV.calcGeneratorVelocity)(calcLatest, t, state.value),
            damping: bounceDamping,
            stiffness: bounceStiffness,
            restDelta: restDelta,
            restSpeed: restSpeed
        });
    };
    checkCatchBoundary(0);
    return {
        calculatedDuration: null,
        next: function(t) {
            /**
             * We need to resolve the friction to figure out if we need a
             * spring but we don't want to do this twice per frame. So here
             * we flag if we updated for this frame and later if we did
             * we can skip doing it again.
             */ var hasUpdatedFrame = false;
            if (!spring$1 && timeReachedBoundary === undefined) {
                hasUpdatedFrame = true;
                applyFriction(t);
                checkCatchBoundary(t);
            }
            /**
             * If we have a spring and the provided t is beyond the moment the friction
             * animation crossed the min/max boundary, use the spring.
             */ if (timeReachedBoundary !== undefined && t >= timeReachedBoundary) return spring$1.next(t - timeReachedBoundary);
            else {
                !hasUpdatedFrame && applyFriction(t);
                return state;
            }
        }
    };
}

});
parcelRegister("jDzBZ", function(module, exports) {

$parcel$export(module.exports, "spring", function () { return $3d1a59dc829b9d46$export$b36281d89752ae66; });

var $joFW3 = parcelRequire("joFW3");

var $90FDw = parcelRequire("90FDw");

var $bJtXW = parcelRequire("bJtXW");

var $3BJvs = parcelRequire("3BJvs");
var $04dOm = parcelRequire("04dOm");

var $jhu9a = parcelRequire("jhu9a");

var $lvPjb = parcelRequire("lvPjb");

var $9RQlP = parcelRequire("9RQlP");

var $eV6JV = parcelRequire("eV6JV");

var $lcgIK = parcelRequire("lcgIK");

var $6ERXh = parcelRequire("6ERXh");
var $3d1a59dc829b9d46$var$durationKeys = [
    "duration",
    "bounce"
];
var $3d1a59dc829b9d46$var$physicsKeys = [
    "stiffness",
    "damping",
    "mass"
];
function $3d1a59dc829b9d46$var$isSpringType(options, keys) {
    return keys.some(function(key) {
        return options[key] !== undefined;
    });
}
function $3d1a59dc829b9d46$var$getSpringOptions(options) {
    var springOptions = (0, $joFW3._)({
        velocity: (0, $lcgIK.springDefaults).velocity,
        stiffness: (0, $lcgIK.springDefaults).stiffness,
        damping: (0, $lcgIK.springDefaults).damping,
        mass: (0, $lcgIK.springDefaults).mass,
        isResolvedFromDuration: false
    }, options);
    // stiffness/damping/mass overrides duration/bounce
    if (!$3d1a59dc829b9d46$var$isSpringType(options, $3d1a59dc829b9d46$var$physicsKeys) && $3d1a59dc829b9d46$var$isSpringType(options, $3d1a59dc829b9d46$var$durationKeys)) {
        if (options.visualDuration) {
            var visualDuration = options.visualDuration;
            var root = 2 * Math.PI / (visualDuration * 1.2);
            var stiffness = root * root;
            var damping = 2 * (0, $3BJvs.clamp)(0.05, 1, 1 - (options.bounce || 0)) * Math.sqrt(stiffness);
            springOptions = (0, $90FDw._)((0, $joFW3._)({}, springOptions), {
                mass: (0, $lcgIK.springDefaults).mass,
                stiffness: stiffness,
                damping: damping
            });
        } else {
            var derived = (0, $6ERXh.findSpring)(options);
            springOptions = (0, $90FDw._)((0, $joFW3._)({}, springOptions, derived), {
                mass: (0, $lcgIK.springDefaults).mass
            });
            springOptions.isResolvedFromDuration = true;
        }
    }
    return springOptions;
}
function $3d1a59dc829b9d46$export$b36281d89752ae66() {
    var optionsOrVisualDuration = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : (0, $lcgIK.springDefaults).visualDuration, bounce = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : (0, $lcgIK.springDefaults).bounce;
    var options = (typeof optionsOrVisualDuration === "undefined" ? "undefined" : (0, $bJtXW._)(optionsOrVisualDuration)) !== "object" ? {
        visualDuration: optionsOrVisualDuration,
        keyframes: [
            0,
            1
        ],
        bounce: bounce
    } : optionsOrVisualDuration;
    var restSpeed = options.restSpeed, restDelta = options.restDelta;
    var origin = options.keyframes[0];
    var target = options.keyframes[options.keyframes.length - 1];
    /**
     * This is the Iterator-spec return value. We ensure it's mutable rather than using a generator
     * to reduce GC during animation.
     */ var state = {
        done: false,
        value: origin
    };
    var _getSpringOptions = $3d1a59dc829b9d46$var$getSpringOptions((0, $90FDw._)((0, $joFW3._)({}, options), {
        velocity: -(0, $04dOm.millisecondsToSeconds)(options.velocity || 0)
    })), stiffness = _getSpringOptions.stiffness, damping = _getSpringOptions.damping, mass = _getSpringOptions.mass, duration = _getSpringOptions.duration, velocity = _getSpringOptions.velocity, isResolvedFromDuration = _getSpringOptions.isResolvedFromDuration;
    var initialVelocity = velocity || 0.0;
    var dampingRatio = damping / (2 * Math.sqrt(stiffness * mass));
    var initialDelta = target - origin;
    var undampedAngularFreq = (0, $04dOm.millisecondsToSeconds)(Math.sqrt(stiffness / mass));
    /**
     * If we're working on a granular scale, use smaller defaults for determining
     * when the spring is finished.
     *
     * These defaults have been selected emprically based on what strikes a good
     * ratio between feeling good and finishing as soon as changes are imperceptible.
     */ var isGranularScale = Math.abs(initialDelta) < 5;
    restSpeed || (restSpeed = isGranularScale ? (0, $lcgIK.springDefaults).restSpeed.granular : (0, $lcgIK.springDefaults).restSpeed.default);
    restDelta || (restDelta = isGranularScale ? (0, $lcgIK.springDefaults).restDelta.granular : (0, $lcgIK.springDefaults).restDelta.default);
    var resolveSpring;
    if (dampingRatio < 1) {
        var angularFreq = (0, $6ERXh.calcAngularFreq)(undampedAngularFreq, dampingRatio);
        // Underdamped spring
        resolveSpring = function(t) {
            var envelope = Math.exp(-dampingRatio * undampedAngularFreq * t);
            return target - envelope * ((initialVelocity + dampingRatio * undampedAngularFreq * initialDelta) / angularFreq * Math.sin(angularFreq * t) + initialDelta * Math.cos(angularFreq * t));
        };
    } else if (dampingRatio === 1) // Critically damped spring
    resolveSpring = function(t) {
        return target - Math.exp(-undampedAngularFreq * t) * (initialDelta + (initialVelocity + undampedAngularFreq * initialDelta) * t);
    };
    else {
        // Overdamped spring
        var dampedAngularFreq = undampedAngularFreq * Math.sqrt(dampingRatio * dampingRatio - 1);
        resolveSpring = function(t) {
            var envelope = Math.exp(-dampingRatio * undampedAngularFreq * t);
            // When performing sinh or cosh values can hit Infinity so we cap them here
            var freqForT = Math.min(dampedAngularFreq * t, 300);
            return target - envelope * ((initialVelocity + dampingRatio * undampedAngularFreq * initialDelta) * Math.sinh(freqForT) + dampedAngularFreq * initialDelta * Math.cosh(freqForT)) / dampedAngularFreq;
        };
    }
    var generator = {
        calculatedDuration: isResolvedFromDuration ? duration || null : null,
        next: function(t) {
            var current = resolveSpring(t);
            if (!isResolvedFromDuration) {
                var currentVelocity = t === 0 ? initialVelocity : 0.0;
                /**
                 * We only need to calculate velocity for under-damped springs
                 * as over- and critically-damped springs can't overshoot, so
                 * checking only for displacement is enough.
                 */ if (dampingRatio < 1) currentVelocity = t === 0 ? (0, $04dOm.secondsToMilliseconds)(initialVelocity) : (0, $eV6JV.calcGeneratorVelocity)(resolveSpring, t, current);
                var isBelowVelocityThreshold = Math.abs(currentVelocity) <= restSpeed;
                var isBelowDisplacementThreshold = Math.abs(target - current) <= restDelta;
                state.done = isBelowVelocityThreshold && isBelowDisplacementThreshold;
            } else state.done = t >= duration;
            state.value = state.done ? target : current;
            return state;
        },
        toString: function() {
            var calculatedDuration = Math.min((0, $lvPjb.calcGeneratorDuration)(generator), (0, $lvPjb.maxGeneratorDuration));
            var easing = (0, $jhu9a.generateLinearEasing)(function(progress) {
                return generator.next(calculatedDuration * progress).value;
            }, calculatedDuration, 30);
            return calculatedDuration + "ms " + easing;
        },
        toTransition: function() {}
    };
    return generator;
}
$3d1a59dc829b9d46$export$b36281d89752ae66.applyToOptions = function(options) {
    var generatorOptions = (0, $9RQlP.createGeneratorEasing)(options, 100, $3d1a59dc829b9d46$export$b36281d89752ae66);
    options.ease = generatorOptions.ease;
    options.duration = (0, $04dOm.secondsToMilliseconds)(generatorOptions.duration);
    options.type = "keyframes";
    return options;
};

});
parcelRegister("jhu9a", function(module, exports) {

$parcel$export(module.exports, "generateLinearEasing", function () { return $e9ed81c36f8b410f$export$66d3851e2b1ec912; });
var $e9ed81c36f8b410f$export$66d3851e2b1ec912 = function(easing, duration) {
    var resolution = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : 10 // as milliseconds
    ;
    var points = "";
    var numPoints = Math.max(Math.round(duration / resolution), 2);
    for(var i = 0; i < numPoints; i++)points += Math.round(easing(i / (numPoints - 1)) * 10000) / 10000 + ", ";
    return "linear(".concat(points.substring(0, points.length - 2), ")");
};

});

parcelRegister("lvPjb", function(module, exports) {

$parcel$export(module.exports, "maxGeneratorDuration", function () { return $c66704a25355671b$export$f4ff70a5b4808fd8; });
$parcel$export(module.exports, "calcGeneratorDuration", function () { return $c66704a25355671b$export$cbdd6b3d40ea54e2; });
/**
 * Implement a practical max duration for keyframe generation
 * to prevent infinite loops
 */ var $c66704a25355671b$export$f4ff70a5b4808fd8 = 20000;
function $c66704a25355671b$export$cbdd6b3d40ea54e2(generator) {
    var duration = 0;
    var timeStep = 50;
    var state = generator.next(duration);
    while(!state.done && duration < $c66704a25355671b$export$f4ff70a5b4808fd8){
        duration += timeStep;
        state = generator.next(duration);
    }
    return duration >= $c66704a25355671b$export$f4ff70a5b4808fd8 ? Infinity : duration;
}

});

parcelRegister("9RQlP", function(module, exports) {

$parcel$export(module.exports, "createGeneratorEasing", function () { return $4dbe752157a2d4db$export$7f1511d09ee75a99; });

var $joFW3 = parcelRequire("joFW3");

var $90FDw = parcelRequire("90FDw");

var $04dOm = parcelRequire("04dOm");

var $lvPjb = parcelRequire("lvPjb");
/**
 * Create a progress => progress easing function from a generator.
 */ function $4dbe752157a2d4db$export$7f1511d09ee75a99(options) {
    var scale = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 100, createGenerator = arguments.length > 2 ? arguments[2] : void 0;
    var generator = createGenerator((0, $90FDw._)((0, $joFW3._)({}, options), {
        keyframes: [
            0,
            scale
        ]
    }));
    var duration = Math.min((0, $lvPjb.calcGeneratorDuration)(generator), (0, $lvPjb.maxGeneratorDuration));
    return {
        type: "keyframes",
        ease: function(progress) {
            return generator.next(duration * progress).value / scale;
        },
        duration: (0, $04dOm.millisecondsToSeconds)(duration)
    };
}

});

parcelRegister("eV6JV", function(module, exports) {

$parcel$export(module.exports, "calcGeneratorVelocity", function () { return $16d1e82c1b5006df$export$854187271d233eb5; });

var $cYmCu = parcelRequire("cYmCu");
var $16d1e82c1b5006df$var$velocitySampleDuration = 5; // ms
function $16d1e82c1b5006df$export$854187271d233eb5(resolveValue, t, current) {
    var prevT = Math.max(t - $16d1e82c1b5006df$var$velocitySampleDuration, 0);
    return (0, $cYmCu.velocityPerSecond)(current - resolveValue(prevT), t - prevT);
}

});

parcelRegister("lcgIK", function(module, exports) {

$parcel$export(module.exports, "springDefaults", function () { return $5469d7db7ae31814$export$86436497e7b05d16; });
var $5469d7db7ae31814$export$86436497e7b05d16 = {
    // Default spring physics
    stiffness: 100,
    damping: 10,
    mass: 1.0,
    velocity: 0.0,
    // Default duration/bounce-based options
    duration: 800,
    bounce: 0.3,
    visualDuration: 0.3,
    // Rest thresholds
    restSpeed: {
        granular: 0.01,
        default: 2
    },
    restDelta: {
        granular: 0.005,
        default: 0.5
    },
    // Limits
    minDuration: 0.01,
    maxDuration: 10.0,
    minDamping: 0.05,
    maxDamping: 1
};

});

parcelRegister("6ERXh", function(module, exports) {

$parcel$export(module.exports, "findSpring", function () { return $5ce2fa901efe6228$export$b15f158dc6d6f458; });
$parcel$export(module.exports, "calcAngularFreq", function () { return $5ce2fa901efe6228$export$5f679887c3a78b15; });

var $3BJvs = parcelRequire("3BJvs");
var $04dOm = parcelRequire("04dOm");
var $FCK0G = parcelRequire("FCK0G");

var $lcgIK = parcelRequire("lcgIK");
var $5ce2fa901efe6228$var$safeMin = 0.001;
function $5ce2fa901efe6228$export$b15f158dc6d6f458(param) {
    var _param_duration = param.duration, duration = _param_duration === void 0 ? (0, $lcgIK.springDefaults).duration : _param_duration, _param_bounce = param.bounce, bounce = _param_bounce === void 0 ? (0, $lcgIK.springDefaults).bounce : _param_bounce, _param_velocity = param.velocity, velocity = _param_velocity === void 0 ? (0, $lcgIK.springDefaults).velocity : _param_velocity, _param_mass = param.mass, mass = _param_mass === void 0 ? (0, $lcgIK.springDefaults).mass : _param_mass;
    var envelope;
    var derivative;
    (0, $FCK0G.warning)(duration <= (0, $04dOm.secondsToMilliseconds)((0, $lcgIK.springDefaults).maxDuration), "Spring duration must be 10 seconds or less", "spring-duration-limit");
    var dampingRatio = 1 - bounce;
    /**
     * Restrict dampingRatio and duration to within acceptable ranges.
     */ dampingRatio = (0, $3BJvs.clamp)((0, $lcgIK.springDefaults).minDamping, (0, $lcgIK.springDefaults).maxDamping, dampingRatio);
    duration = (0, $3BJvs.clamp)((0, $lcgIK.springDefaults).minDuration, (0, $lcgIK.springDefaults).maxDuration, (0, $04dOm.millisecondsToSeconds)(duration));
    if (dampingRatio < 1) {
        /**
         * Underdamped spring
         */ envelope = function(undampedFreq) {
            var exponentialDecay = undampedFreq * dampingRatio;
            var delta = exponentialDecay * duration;
            var a = exponentialDecay - velocity;
            var b = $5ce2fa901efe6228$export$5f679887c3a78b15(undampedFreq, dampingRatio);
            var c = Math.exp(-delta);
            return $5ce2fa901efe6228$var$safeMin - a / b * c;
        };
        derivative = function(undampedFreq) {
            var exponentialDecay = undampedFreq * dampingRatio;
            var delta = exponentialDecay * duration;
            var d = delta * velocity + velocity;
            var e = Math.pow(dampingRatio, 2) * Math.pow(undampedFreq, 2) * duration;
            var f = Math.exp(-delta);
            var g = $5ce2fa901efe6228$export$5f679887c3a78b15(Math.pow(undampedFreq, 2), dampingRatio);
            var factor = -envelope(undampedFreq) + $5ce2fa901efe6228$var$safeMin > 0 ? -1 : 1;
            return factor * ((d - e) * f) / g;
        };
    } else {
        /**
         * Critically-damped spring
         */ envelope = function(undampedFreq) {
            var a = Math.exp(-undampedFreq * duration);
            var b = (undampedFreq - velocity) * duration + 1;
            return -$5ce2fa901efe6228$var$safeMin + a * b;
        };
        derivative = function(undampedFreq) {
            var a = Math.exp(-undampedFreq * duration);
            var b = (velocity - undampedFreq) * (duration * duration);
            return a * b;
        };
    }
    var initialGuess = 5 / duration;
    var undampedFreq = $5ce2fa901efe6228$var$approximateRoot(envelope, derivative, initialGuess);
    duration = (0, $04dOm.secondsToMilliseconds)(duration);
    if (isNaN(undampedFreq)) return {
        stiffness: (0, $lcgIK.springDefaults).stiffness,
        damping: (0, $lcgIK.springDefaults).damping,
        duration: duration
    };
    else {
        var stiffness = Math.pow(undampedFreq, 2) * mass;
        return {
            stiffness: stiffness,
            damping: dampingRatio * 2 * Math.sqrt(mass * stiffness),
            duration: duration
        };
    }
}
var $5ce2fa901efe6228$var$rootIterations = 12;
function $5ce2fa901efe6228$var$approximateRoot(envelope, derivative, initialGuess) {
    var result = initialGuess;
    for(var i = 1; i < $5ce2fa901efe6228$var$rootIterations; i++)result = result - envelope(result) / derivative(result);
    return result;
}
function $5ce2fa901efe6228$export$5f679887c3a78b15(undampedFreq, dampingRatio) {
    return undampedFreq * Math.sqrt(1 - dampingRatio * dampingRatio);
}

});



parcelRegister("fndcd", function(module, exports) {

$parcel$export(module.exports, "keyframes", function () { return $c8655e70795b2b30$export$d25ddfdf17c3ad3e; });

var $kSwd9 = parcelRequire("kSwd9");
var $9eHeZ = parcelRequire("9eHeZ");
var $12SSg = parcelRequire("12SSg");

var $ekQM5 = parcelRequire("ekQM5");

var $fttLR = parcelRequire("fttLR");

var $hpJrU = parcelRequire("hpJrU");
function $c8655e70795b2b30$export$6b60b58e4ea7d715(values, easing) {
    return values.map(function() {
        return easing || (0, $kSwd9.easeInOut);
    }).splice(0, values.length - 1);
}
function $c8655e70795b2b30$export$d25ddfdf17c3ad3e(param) {
    var _param_duration = param.duration, duration = _param_duration === void 0 ? 300 : _param_duration, keyframeValues = param.keyframes, times = param.times, _param_ease = param.ease, ease = _param_ease === void 0 ? "easeInOut" : _param_ease;
    /**
     * Easing functions can be externally defined as strings. Here we convert them
     * into actual functions.
     */ var easingFunctions = (0, $12SSg.isEasingArray)(ease) ? ease.map((0, $9eHeZ.easingDefinitionToFunction)) : (0, $9eHeZ.easingDefinitionToFunction)(ease);
    /**
     * This is the Iterator-spec return value. We ensure it's mutable rather than using a generator
     * to reduce GC during animation.
     */ var state = {
        done: false,
        value: keyframeValues[0]
    };
    /**
     * Create a times array based on the provided 0-1 offsets
     */ var absoluteTimes = (0, $hpJrU.convertOffsetToTimes)(// Only use the provided offsets if they're the correct length
    // TODO Maybe we should warn here if there's a length mismatch
    times && times.length === keyframeValues.length ? times : (0, $fttLR.defaultOffset)(keyframeValues), duration);
    var mapTimeToKeyframe = (0, $ekQM5.interpolate)(absoluteTimes, keyframeValues, {
        ease: Array.isArray(easingFunctions) ? easingFunctions : $c8655e70795b2b30$export$6b60b58e4ea7d715(keyframeValues, easingFunctions)
    });
    return {
        calculatedDuration: duration,
        next: function(t) {
            state.value = mapTimeToKeyframe(t);
            state.done = t >= duration;
            return state;
        }
    };
}

});
parcelRegister("kSwd9", function(module, exports) {

$parcel$export(module.exports, "easeIn", function () { return $eb292bac1ef4a6d7$export$929e5a82286172a6; });
$parcel$export(module.exports, "easeOut", function () { return $eb292bac1ef4a6d7$export$57636bb43b1ccbb0; });
$parcel$export(module.exports, "easeInOut", function () { return $eb292bac1ef4a6d7$export$c07234257a03d5e9; });

var $32riN = parcelRequire("32riN");
var $eb292bac1ef4a6d7$export$929e5a82286172a6 = /*@__PURE__*/ (0, $32riN.cubicBezier)(0.42, 0, 1, 1);
var $eb292bac1ef4a6d7$export$57636bb43b1ccbb0 = /*@__PURE__*/ (0, $32riN.cubicBezier)(0, 0, 0.58, 1);
var $eb292bac1ef4a6d7$export$c07234257a03d5e9 = /*@__PURE__*/ (0, $32riN.cubicBezier)(0.42, 0, 0.58, 1);

});
parcelRegister("32riN", function(module, exports) {

$parcel$export(module.exports, "cubicBezier", function () { return $f5c360d38329607e$export$2c575fa1d20488bd; });

var $eQ5Xp = parcelRequire("eQ5Xp");
/*
  Bezier function generator
  This has been modified from Gaëtan Renaudeau's BezierEasing
  https://github.com/gre/bezier-easing/blob/master/src/index.js
  https://github.com/gre/bezier-easing/blob/master/LICENSE
  
  I've removed the newtonRaphsonIterate algo because in benchmarking it
  wasn't noticeably faster than binarySubdivision, indeed removing it
  usually improved times, depending on the curve.
  I also removed the lookup table, as for the added bundle size and loop we're
  only cutting ~4 or so subdivision iterations. I bumped the max iterations up
  to 12 to compensate and this still tended to be faster for no perceivable
  loss in accuracy.
  Usage
    const easeOut = cubicBezier(.17,.67,.83,.67);
    const x = easeOut(0.5); // returns 0.627...
*/ // Returns x(t) given t, x1, and x2, or y(t) given t, y1, and y2.
var $f5c360d38329607e$var$calcBezier = function(t, a1, a2) {
    return (((1.0 - 3.0 * a2 + 3.0 * a1) * t + (3.0 * a2 - 6.0 * a1)) * t + 3.0 * a1) * t;
};
var $f5c360d38329607e$var$subdivisionPrecision = 0.0000001;
var $f5c360d38329607e$var$subdivisionMaxIterations = 12;
function $f5c360d38329607e$var$binarySubdivide(x, lowerBound, upperBound, mX1, mX2) {
    var currentX;
    var currentT;
    var i = 0;
    do {
        currentT = lowerBound + (upperBound - lowerBound) / 2.0;
        currentX = $f5c360d38329607e$var$calcBezier(currentT, mX1, mX2) - x;
        if (currentX > 0.0) upperBound = currentT;
        else lowerBound = currentT;
    }while (Math.abs(currentX) > $f5c360d38329607e$var$subdivisionPrecision && ++i < $f5c360d38329607e$var$subdivisionMaxIterations);
    return currentT;
}
function $f5c360d38329607e$export$2c575fa1d20488bd(mX1, mY1, mX2, mY2) {
    // If this is a linear gradient, return linear easing
    if (mX1 === mY1 && mX2 === mY2) return 0, $eQ5Xp.noop;
    var getTForX = function(aX) {
        return $f5c360d38329607e$var$binarySubdivide(aX, 0, 1, mX1, mX2);
    };
    // If animation is at start/end, return t without easing
    return function(t) {
        return t === 0 || t === 1 ? t : $f5c360d38329607e$var$calcBezier(getTForX(t), mY1, mY2);
    };
}

});


parcelRegister("9eHeZ", function(module, exports) {

$parcel$export(module.exports, "easingDefinitionToFunction", function () { return $b5a2e12436b27ff7$export$ef97fe084f156ca4; });

var $2nwvT = parcelRequire("2nwvT");

var $FCK0G = parcelRequire("FCK0G");

var $eQ5Xp = parcelRequire("eQ5Xp");

var $jcXJu = parcelRequire("jcXJu");

var $84x0f = parcelRequire("84x0f");

var $iRVOe = parcelRequire("iRVOe");

var $32riN = parcelRequire("32riN");

var $kSwd9 = parcelRequire("kSwd9");

var $fq8uE = parcelRequire("fq8uE");
var $b5a2e12436b27ff7$var$easingLookup = {
    linear: (0, $eQ5Xp.noop),
    easeIn: (0, $kSwd9.easeIn),
    easeInOut: (0, $kSwd9.easeInOut),
    easeOut: (0, $kSwd9.easeOut),
    circIn: (0, $iRVOe.circIn),
    circInOut: (0, $iRVOe.circInOut),
    circOut: (0, $iRVOe.circOut),
    backIn: (0, $84x0f.backIn),
    backInOut: (0, $84x0f.backInOut),
    backOut: (0, $84x0f.backOut),
    anticipate: (0, $jcXJu.anticipate)
};
var $b5a2e12436b27ff7$var$isValidEasing = function(easing) {
    return typeof easing === "string";
};
var $b5a2e12436b27ff7$export$ef97fe084f156ca4 = function(definition) {
    if ((0, $fq8uE.isBezierDefinition)(definition)) {
        // If cubic bezier definition, create bezier curve
        (0, $FCK0G.invariant)(definition.length === 4, "Cubic bezier arrays must contain four numerical values.", "cubic-bezier-length");
        var _definition = (0, $2nwvT._)(definition, 4), x1 = _definition[0], y1 = _definition[1], x2 = _definition[2], y2 = _definition[3];
        return (0, $32riN.cubicBezier)(x1, y1, x2, y2);
    } else if ($b5a2e12436b27ff7$var$isValidEasing(definition)) {
        // Else lookup from table
        (0, $FCK0G.invariant)($b5a2e12436b27ff7$var$easingLookup[definition] !== undefined, "Invalid easing type '".concat(definition, "'"), "invalid-easing-type");
        return $b5a2e12436b27ff7$var$easingLookup[definition];
    }
    return definition;
};

});
parcelRegister("jcXJu", function(module, exports) {

$parcel$export(module.exports, "anticipate", function () { return $c1114ba97d1aa7e1$export$6b0af63b873d419e; });

var $84x0f = parcelRequire("84x0f");
var $c1114ba97d1aa7e1$export$6b0af63b873d419e = function(p) {
    return (p *= 2) < 1 ? 0.5 * (0, $84x0f.backIn)(p) : 0.5 * (2 - Math.pow(2, -10 * (p - 1)));
};

});
parcelRegister("84x0f", function(module, exports) {

$parcel$export(module.exports, "backOut", function () { return $a94cab4588efd61c$export$77edfce482316a60; });
$parcel$export(module.exports, "backIn", function () { return $a94cab4588efd61c$export$b01116c84cdfe1a2; });
$parcel$export(module.exports, "backInOut", function () { return $a94cab4588efd61c$export$ddc5fd596f6c71b2; });

var $32riN = parcelRequire("32riN");

var $1eBln = parcelRequire("1eBln");

var $i9bgu = parcelRequire("i9bgu");
var $a94cab4588efd61c$export$77edfce482316a60 = /*@__PURE__*/ (0, $32riN.cubicBezier)(0.33, 1.53, 0.69, 0.99);
var $a94cab4588efd61c$export$b01116c84cdfe1a2 = /*@__PURE__*/ (0, $i9bgu.reverseEasing)($a94cab4588efd61c$export$77edfce482316a60);
var $a94cab4588efd61c$export$ddc5fd596f6c71b2 = /*@__PURE__*/ (0, $1eBln.mirrorEasing)($a94cab4588efd61c$export$b01116c84cdfe1a2);

});
parcelRegister("1eBln", function(module, exports) {

$parcel$export(module.exports, "mirrorEasing", function () { return $4e106f82518cbbfc$export$f946554fb8aeaf0d; });
// Accepts an easing function and returns a new one that outputs mirrored values for
// the second half of the animation. Turns easeIn into easeInOut.
var $4e106f82518cbbfc$export$f946554fb8aeaf0d = function(easing) {
    return function(p) {
        return p <= 0.5 ? easing(2 * p) / 2 : (2 - easing(2 * (1 - p))) / 2;
    };
};

});

parcelRegister("i9bgu", function(module, exports) {

$parcel$export(module.exports, "reverseEasing", function () { return $4e89a2a3f1aec398$export$2c07eeff45156d4d; });
// Accepts an easing function and returns a new one that outputs reversed values.
// Turns easeIn into easeOut.
var $4e89a2a3f1aec398$export$2c07eeff45156d4d = function(easing) {
    return function(p) {
        return 1 - easing(1 - p);
    };
};

});



parcelRegister("iRVOe", function(module, exports) {

$parcel$export(module.exports, "circIn", function () { return $c8467f744072c29e$export$e444123e42d03385; });
$parcel$export(module.exports, "circOut", function () { return $c8467f744072c29e$export$c8d67a19199d1a50; });
$parcel$export(module.exports, "circInOut", function () { return $c8467f744072c29e$export$30d3455eee55bed5; });

var $1eBln = parcelRequire("1eBln");

var $i9bgu = parcelRequire("i9bgu");
var $c8467f744072c29e$export$e444123e42d03385 = function(p) {
    return 1 - Math.sin(Math.acos(p));
};
var $c8467f744072c29e$export$c8d67a19199d1a50 = (0, $i9bgu.reverseEasing)($c8467f744072c29e$export$e444123e42d03385);
var $c8467f744072c29e$export$30d3455eee55bed5 = (0, $1eBln.mirrorEasing)($c8467f744072c29e$export$e444123e42d03385);

});

parcelRegister("fq8uE", function(module, exports) {

$parcel$export(module.exports, "isBezierDefinition", function () { return $6a2606d5ca5e077e$export$ff43f99925d7366b; });
var $6a2606d5ca5e077e$export$ff43f99925d7366b = function(easing) {
    return Array.isArray(easing) && typeof easing[0] === "number";
};

});


parcelRegister("12SSg", function(module, exports) {

$parcel$export(module.exports, "isEasingArray", function () { return $d4fcb8d8a2cd786d$export$216948827bbdc797; });
var $d4fcb8d8a2cd786d$export$216948827bbdc797 = function(ease) {
    return Array.isArray(ease) && typeof ease[0] !== "number";
};

});

parcelRegister("ekQM5", function(module, exports) {

$parcel$export(module.exports, "interpolate", function () { return $1a5d1658c8542292$export$89e29e4ab65e70a9; });

var $2us1u = parcelRequire("2us1u");

var $3BJvs = parcelRequire("3BJvs");
var $FCK0G = parcelRequire("FCK0G");
var $7mUth = parcelRequire("7mUth");
var $eQ5Xp = parcelRequire("eQ5Xp");
var $1Te65 = parcelRequire("1Te65");
var $4nrxA = parcelRequire("4nrxA");

var $bbEF1 = parcelRequire("bbEF1");
function $1a5d1658c8542292$var$createMixers(output, ease, customMixer) {
    var mixers = [];
    var mixerFactory = customMixer || (0, $7mUth.MotionGlobalConfig).mix || (0, $bbEF1.mix);
    var numMixers = output.length - 1;
    for(var i = 0; i < numMixers; i++){
        var mixer = mixerFactory(output[i], output[i + 1]);
        if (ease) {
            var easingFunction = Array.isArray(ease) ? ease[i] || (0, $eQ5Xp.noop) : ease;
            mixer = (0, $1Te65.pipe)(easingFunction, mixer);
        }
        mixers.push(mixer);
    }
    return mixers;
}
/**
 * Create a function that maps from a numerical input array to a generic output array.
 *
 * Accepts:
 *   - Numbers
 *   - Colors (hex, hsl, hsla, rgb, rgba)
 *   - Complex (combinations of one or more numbers or strings)
 *
 * ```jsx
 * const mixColor = interpolate([0, 1], ['#fff', '#000'])
 *
 * mixColor(0.5) // 'rgba(128, 128, 128, 1)'
 * ```
 *
 * TODO Revisit this approach once we've moved to data models for values,
 * probably not needed to pregenerate mixer functions.
 *
 * @public
 */ function $1a5d1658c8542292$export$89e29e4ab65e70a9(input, output) {
    var _ref = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {}, tmp = _ref.clamp, isClamp = tmp === void 0 ? true : tmp, ease = _ref.ease, mixer = _ref.mixer;
    var inputLength = input.length;
    (0, $FCK0G.invariant)(inputLength === output.length, "Both input and output ranges must be the same length", "range-length");
    /**
     * If we're only provided a single input, we can just make a function
     * that returns the output.
     */ if (inputLength === 1) return function() {
        return output[0];
    };
    if (inputLength === 2 && output[0] === output[1]) return function() {
        return output[1];
    };
    var isZeroDeltaRange = input[0] === input[1];
    // If input runs highest -> lowest, reverse both arrays
    if (input[0] > input[inputLength - 1]) {
        input = (0, $2us1u._)(input).reverse();
        output = (0, $2us1u._)(output).reverse();
    }
    var mixers = $1a5d1658c8542292$var$createMixers(output, ease, mixer);
    var numMixers = mixers.length;
    var interpolator = function(v) {
        if (isZeroDeltaRange && v < input[0]) return output[0];
        var i = 0;
        if (numMixers > 1) for(; i < input.length - 2; i++){
            if (v < input[i + 1]) break;
        }
        var progressInRange = (0, $4nrxA.progress)(input[i], input[i + 1], v);
        return mixers[i](progressInRange);
    };
    return isClamp ? function(v) {
        return interpolator((0, $3BJvs.clamp)(input[0], input[inputLength - 1], v));
    } : interpolator;
}

});
parcelRegister("4nrxA", function(module, exports) {

$parcel$export(module.exports, "progress", function () { return $97e7409b3cca2443$export$504d7abb21fa8c9; });
/*
  Progress within given range

  Given a lower limit and an upper limit, we return the progress
  (expressed as a number 0-1) represented by the given value, and
  limit that progress to within 0-1.

  @param [number]: Lower limit
  @param [number]: Upper limit
  @param [number]: Value to find progress within given range
  @return [number]: Progress of value within range as expressed 0-1
*/ /*#__NO_SIDE_EFFECTS__*/ var $97e7409b3cca2443$export$504d7abb21fa8c9 = function(from, to, value) {
    var toFromDifference = to - from;
    return toFromDifference === 0 ? 1 : (value - from) / toFromDifference;
};

});


parcelRegister("fttLR", function(module, exports) {

$parcel$export(module.exports, "defaultOffset", function () { return $1ed123c9cb161adf$export$24dbcec0b26e6d9d; });

var $8ZFf9 = parcelRequire("8ZFf9");
function $1ed123c9cb161adf$export$24dbcec0b26e6d9d(arr) {
    var offset = [
        0
    ];
    (0, $8ZFf9.fillOffset)(offset, arr.length - 1);
    return offset;
}

});
parcelRegister("8ZFf9", function(module, exports) {

$parcel$export(module.exports, "fillOffset", function () { return $e24e07066d3c33d4$export$dafee61230cf05c6; });

var $4nrxA = parcelRequire("4nrxA");

var $83rca = parcelRequire("83rca");
function $e24e07066d3c33d4$export$dafee61230cf05c6(offset, remaining) {
    var min = offset[offset.length - 1];
    for(var i = 1; i <= remaining; i++){
        var offsetProgress = (0, $4nrxA.progress)(0, remaining, i);
        offset.push((0, $83rca.mixNumber)(min, 1, offsetProgress));
    }
}

});


parcelRegister("hpJrU", function(module, exports) {

$parcel$export(module.exports, "convertOffsetToTimes", function () { return $65d0e5b84078731d$export$2a91b4e3a4539316; });
function $65d0e5b84078731d$export$2a91b4e3a4539316(offset, duration) {
    return offset.map(function(o) {
        return o * duration;
    });
}

});


parcelRegister("dsmSc", function(module, exports) {

$parcel$export(module.exports, "getFinalKeyframe", function () { return $fb48450792641fca$export$14de59408fad90b; });
var $fb48450792641fca$var$isNotNull = function(value) {
    return value !== null;
};
function $fb48450792641fca$export$14de59408fad90b(keyframes, param, finalKeyframe) {
    var repeat = param.repeat, _param_repeatType = param.repeatType, repeatType = _param_repeatType === void 0 ? "loop" : _param_repeatType, speed = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : 1;
    var resolvedKeyframes = keyframes.filter($fb48450792641fca$var$isNotNull);
    var useFirstKeyframe = speed < 0 || repeat && repeatType !== "loop" && repeat % 2 === 1;
    var index = useFirstKeyframe ? 0 : resolvedKeyframes.length - 1;
    return !index || finalKeyframe === undefined ? resolvedKeyframes[index] : finalKeyframe;
}

});

parcelRegister("kzQqU", function(module, exports) {

$parcel$export(module.exports, "replaceTransitionType", function () { return $0dd59ff7781f1684$export$98db6ef1242dfa2; });

var $815XJ = parcelRequire("815XJ");

var $fndcd = parcelRequire("fndcd");

var $jDzBZ = parcelRequire("jDzBZ");
var $0dd59ff7781f1684$var$transitionTypeMap = {
    decay: (0, $815XJ.inertia),
    inertia: (0, $815XJ.inertia),
    tween: (0, $fndcd.keyframes),
    keyframes: (0, $fndcd.keyframes),
    spring: (0, $jDzBZ.spring)
};
function $0dd59ff7781f1684$export$98db6ef1242dfa2(transition) {
    if (typeof transition.type === "string") transition.type = $0dd59ff7781f1684$var$transitionTypeMap[transition.type];
}

});

parcelRegister("iqh7q", function(module, exports) {

$parcel$export(module.exports, "WithPromise", function () { return $552eec322a4ce1dd$export$655db786091c33e0; });

var $grujF = parcelRequire("grujF");

var $dhMkv = parcelRequire("dhMkv");
var $552eec322a4ce1dd$export$655db786091c33e0 = /*#__PURE__*/ function() {
    "use strict";
    function WithPromise() {
        (0, $grujF._)(this, WithPromise);
        this.updateFinished();
    }
    (0, $dhMkv._)(WithPromise, [
        {
            key: "finished",
            get: function get() {
                return this._finished;
            }
        },
        {
            key: "updateFinished",
            value: function updateFinished() {
                var _this = this;
                this._finished = new Promise(function(resolve) {
                    _this.resolve = resolve;
                });
            }
        },
        {
            key: "notifyFinished",
            value: function notifyFinished() {
                this.resolve();
            }
        },
        {
            /**
     * Allows the animation to be awaited.
     *
     * @deprecated Use `finished` instead.
     */ key: "then",
            value: function then(onResolve, onReject) {
                return this.finished.then(onResolve, onReject);
            }
        }
    ]);
    return WithPromise;
}();

});


parcelRegister("kbsuG", function(module, exports) {

$parcel$export(module.exports, "NativeAnimationExtended", function () { return $e7c78a794c503337$export$bd2cd6a048093d96; });

var $f3Okx = parcelRequire("f3Okx");

var $grujF = parcelRequire("grujF");

var $dhMkv = parcelRequire("dhMkv");

var $j6Mzi = parcelRequire("j6Mzi");

var $joFW3 = parcelRequire("joFW3");

var $90FDw = parcelRequire("90FDw");

var $buaX5 = parcelRequire("buaX5");

var $04dOm = parcelRequire("04dOm");

var $aTzRr = parcelRequire("aTzRr");

var $kdVfh = parcelRequire("kdVfh");

var $kzQqU = parcelRequire("kzQqU");

var $d7Kr9 = parcelRequire("d7Kr9");
/**
 * 10ms is chosen here as it strikes a balance between smooth
 * results (more than one keyframe per frame at 60fps) and
 * keyframe quantity.
 */ var $e7c78a794c503337$var$sampleDelta = 10; //ms
var $e7c78a794c503337$export$bd2cd6a048093d96 = /*#__PURE__*/ function(NativeAnimation) {
    "use strict";
    (0, $j6Mzi._)(NativeAnimationExtended, NativeAnimation);
    function NativeAnimationExtended(options) {
        (0, $grujF._)(this, NativeAnimationExtended);
        var _this;
        /**
         * The base NativeAnimation function only supports a subset
         * of Motion easings, and WAAPI also only supports some
         * easing functions via string/cubic-bezier definitions.
         *
         * This function replaces those unsupported easing functions
         * with a JS easing function. This will later get compiled
         * to a linear() easing function.
         */ (0, $d7Kr9.replaceStringEasing)(options);
        /**
         * Ensure we replace the transition type with a generator function
         * before passing to WAAPI.
         *
         * TODO: Does this have a better home? It could be shared with
         * JSAnimation.
         */ (0, $kzQqU.replaceTransitionType)(options);
        _this = (0, $f3Okx._)(this, NativeAnimationExtended, [
            options
        ]);
        if (options.startTime) _this.startTime = options.startTime;
        _this.options = options;
        return _this;
    }
    (0, $dhMkv._)(NativeAnimationExtended, [
        {
            /**
     * WAAPI doesn't natively have any interruption capabilities.
     *
     * Rather than read commited styles back out of the DOM, we can
     * create a renderless JS animation and sample it twice to calculate
     * its current value, "previous" value, and therefore allow
     * Motion to calculate velocity for any subsequent animation.
     */ key: "updateMotionValue",
            value: function updateMotionValue(value) {
                var _this_options = this.options, motionValue = _this_options.motionValue, onUpdate = _this_options.onUpdate, onComplete = _this_options.onComplete, element = _this_options.element, options = (0, $buaX5._)(_this_options, [
                    "motionValue",
                    "onUpdate",
                    "onComplete",
                    "element"
                ]);
                if (!motionValue) return;
                if (value !== undefined) {
                    motionValue.set(value);
                    return;
                }
                var sampleAnimation = new (0, $aTzRr.JSAnimation)((0, $90FDw._)((0, $joFW3._)({}, options), {
                    autoplay: false
                }));
                var _this_finishedTime;
                var sampleTime = (0, $04dOm.secondsToMilliseconds)((_this_finishedTime = this.finishedTime) !== null && _this_finishedTime !== void 0 ? _this_finishedTime : this.time);
                motionValue.setWithVelocity(sampleAnimation.sample(sampleTime - $e7c78a794c503337$var$sampleDelta).value, sampleAnimation.sample(sampleTime).value, $e7c78a794c503337$var$sampleDelta);
                sampleAnimation.stop();
            }
        }
    ]);
    return NativeAnimationExtended;
}((0, $kdVfh.NativeAnimation));

});
parcelRegister("kdVfh", function(module, exports) {

$parcel$export(module.exports, "NativeAnimation", function () { return $da30e772b70b3e40$export$6c0f9803d8aa7219; });

var $f3Okx = parcelRequire("f3Okx");

var $grujF = parcelRequire("grujF");

var $dhMkv = parcelRequire("dhMkv");

var $j6Mzi = parcelRequire("j6Mzi");

var $gvVNz = parcelRequire("gvVNz");

var $FCK0G = parcelRequire("FCK0G");
var $04dOm = parcelRequire("04dOm");
var $eQ5Xp = parcelRequire("eQ5Xp");

var $fu4PA = parcelRequire("fu4PA");

var $7Zpon = parcelRequire("7Zpon");

var $dsmSc = parcelRequire("dsmSc");

var $iqh7q = parcelRequire("iqh7q");

var $9Nbpj = parcelRequire("9Nbpj");

var $81wxg = parcelRequire("81wxg");
/**
 * NativeAnimation implements AnimationPlaybackControls for the browser's Web Animations API.
 */ var $da30e772b70b3e40$export$6c0f9803d8aa7219 = /*#__PURE__*/ function(WithPromise) {
    "use strict";
    (0, $j6Mzi._)(NativeAnimation, WithPromise);
    function NativeAnimation(options) {
        (0, $grujF._)(this, NativeAnimation);
        var _this;
        _this = (0, $f3Okx._)(this, NativeAnimation);
        _this.finishedTime = null;
        _this.isStopped = false;
        if (!options) return (0, $gvVNz._)(_this);
        var element = options.element, name = options.name, keyframes = options.keyframes, pseudoElement = options.pseudoElement, _options_allowFlatten = options.allowFlatten, allowFlatten = _options_allowFlatten === void 0 ? false : _options_allowFlatten, finalKeyframe = options.finalKeyframe, onComplete = options.onComplete;
        _this.isPseudoElement = Boolean(pseudoElement);
        _this.allowFlatten = allowFlatten;
        _this.options = options;
        (0, $FCK0G.invariant)(typeof options.type !== "string", 'Mini animate() doesn\'t support "type" as a string.', "mini-spring");
        var transition = (0, $81wxg.applyGeneratorOptions)(options);
        _this.animation = (0, $9Nbpj.startWaapiAnimation)(element, name, keyframes, transition, pseudoElement);
        if (transition.autoplay === false) _this.animation.pause();
        _this.animation.onfinish = function() {
            _this.finishedTime = _this.time;
            if (!pseudoElement) {
                var keyframe = (0, $dsmSc.getFinalKeyframe)(keyframes, _this.options, finalKeyframe, _this.speed);
                if (_this.updateMotionValue) _this.updateMotionValue(keyframe);
                else /**
                     * If we can, we want to commit the final style as set by the user,
                     * rather than the computed keyframe value supplied by the animation.
                     */ (0, $fu4PA.setStyle)(element, name, keyframe);
                _this.animation.cancel();
            }
            onComplete === null || onComplete === void 0 ? void 0 : onComplete();
            _this.notifyFinished();
        };
        return _this;
    }
    (0, $dhMkv._)(NativeAnimation, [
        {
            key: "play",
            value: function play() {
                if (this.isStopped) return;
                this.animation.play();
                if (this.state === "finished") this.updateFinished();
            }
        },
        {
            key: "pause",
            value: function pause() {
                this.animation.pause();
            }
        },
        {
            key: "complete",
            value: function complete() {
                var _this_animation_finish, _this_animation;
                (_this_animation_finish = (_this_animation = this.animation).finish) === null || _this_animation_finish === void 0 ? void 0 : _this_animation_finish.call(_this_animation);
            }
        },
        {
            key: "cancel",
            value: function cancel() {
                try {
                    this.animation.cancel();
                } catch (e) {}
            }
        },
        {
            key: "stop",
            value: function stop() {
                if (this.isStopped) return;
                this.isStopped = true;
                var state = this.state;
                if (state === "idle" || state === "finished") return;
                if (this.updateMotionValue) this.updateMotionValue();
                else this.commitStyles();
                if (!this.isPseudoElement) this.cancel();
            }
        },
        {
            /**
     * WAAPI doesn't natively have any interruption capabilities.
     *
     * In this method, we commit styles back to the DOM before cancelling
     * the animation.
     *
     * This is designed to be overridden by NativeAnimationExtended, which
     * will create a renderless JS animation and sample it twice to calculate
     * its current value, "previous" value, and therefore allow
     * Motion to also correctly calculate velocity for any subsequent animation
     * while deferring the commit until the next animation frame.
     */ key: "commitStyles",
            value: function commitStyles() {
                var _this_animation_commitStyles, _this_animation;
                if (!this.isPseudoElement) (_this_animation_commitStyles = (_this_animation = this.animation).commitStyles) === null || _this_animation_commitStyles === void 0 ? void 0 : _this_animation_commitStyles.call(_this_animation);
            }
        },
        {
            key: "duration",
            get: function get() {
                var _this_animation_effect_getComputedTiming, _this_animation_effect;
                var duration = ((_this_animation_effect = this.animation.effect) === null || _this_animation_effect === void 0 ? void 0 : (_this_animation_effect_getComputedTiming = _this_animation_effect.getComputedTiming) === null || _this_animation_effect_getComputedTiming === void 0 ? void 0 : _this_animation_effect_getComputedTiming.call(_this_animation_effect).duration) || 0;
                return (0, $04dOm.millisecondsToSeconds)(Number(duration));
            }
        },
        {
            key: "iterationDuration",
            get: function get() {
                var _ref = this.options || {}, _ref_delay = _ref.delay, delay = _ref_delay === void 0 ? 0 : _ref_delay;
                return this.duration + (0, $04dOm.millisecondsToSeconds)(delay);
            }
        },
        {
            key: "time",
            get: function get() {
                return (0, $04dOm.millisecondsToSeconds)(Number(this.animation.currentTime) || 0);
            },
            set: function set(newTime) {
                this.finishedTime = null;
                this.animation.currentTime = (0, $04dOm.secondsToMilliseconds)(newTime);
            }
        },
        {
            key: "speed",
            get: /**
     * The playback speed of the animation.
     * 1 = normal speed, 2 = double speed, 0.5 = half speed.
     */ function get() {
                return this.animation.playbackRate;
            },
            set: function set(newSpeed) {
                // Allow backwards playback after finishing
                if (newSpeed < 0) this.finishedTime = null;
                this.animation.playbackRate = newSpeed;
            }
        },
        {
            key: "state",
            get: function get() {
                return this.finishedTime !== null ? "finished" : this.animation.playState;
            }
        },
        {
            key: "startTime",
            get: function get() {
                return Number(this.animation.startTime);
            },
            set: function set(newStartTime) {
                this.animation.startTime = newStartTime;
            }
        },
        {
            /**
     * Attaches a timeline to the animation, for instance the `ScrollTimeline`.
     */ key: "attachTimeline",
            value: function attachTimeline(param) {
                var timeline = param.timeline, observe = param.observe;
                var _this_animation_effect;
                if (this.allowFlatten) (_this_animation_effect = this.animation.effect) === null || _this_animation_effect === void 0 ? void 0 : _this_animation_effect.updateTiming({
                    easing: "linear"
                });
                this.animation.onfinish = null;
                if (timeline && (0, $7Zpon.supportsScrollTimeline)()) {
                    this.animation.timeline = timeline;
                    return 0, $eQ5Xp.noop;
                } else return observe(this);
            }
        }
    ]);
    return NativeAnimation;
}((0, $iqh7q.WithPromise));

});
parcelRegister("fu4PA", function(module, exports) {

$parcel$export(module.exports, "setStyle", function () { return $28dd183987330986$export$37a5fde709c1db82; });

var $1rHW2 = parcelRequire("1rHW2");
function $28dd183987330986$export$37a5fde709c1db82(element, name, value) {
    (0, $1rHW2.isCSSVar)(name) ? element.style.setProperty(name, value) : element.style[name] = value;
}

});
parcelRegister("1rHW2", function(module, exports) {

$parcel$export(module.exports, "isCSSVar", function () { return $620a721641fb43af$export$c9f584638d388483; });
var $620a721641fb43af$export$c9f584638d388483 = function(name) {
    return name.startsWith("--");
};

});


parcelRegister("7Zpon", function(module, exports) {

$parcel$export(module.exports, "supportsScrollTimeline", function () { return $302116dbf0b45254$export$20d68f04f30763a5; });

var $8HBdf = parcelRequire("8HBdf");
var $302116dbf0b45254$export$20d68f04f30763a5 = /* @__PURE__ */ (0, $8HBdf.memo)(function() {
    return window.ScrollTimeline !== undefined;
});

});
parcelRegister("8HBdf", function(module, exports) {

$parcel$export(module.exports, "memo", function () { return $7ec412fc599da105$export$7c73462e0d25e514; });
/*#__NO_SIDE_EFFECTS__*/ function $7ec412fc599da105$export$7c73462e0d25e514(callback) {
    var result;
    return function() {
        if (result === undefined) result = callback();
        return result;
    };
}

});


parcelRegister("9Nbpj", function(module, exports) {

$parcel$export(module.exports, "startWaapiAnimation", function () { return $47c1bc72d70c179b$export$d896de52f97cb615; });

var $72osQ = parcelRequire("72osQ");

var $2gN7O = parcelRequire("2gN7O");

var $2GhiD = parcelRequire("2GhiD");

var $Mjyaa = parcelRequire("Mjyaa");
function $47c1bc72d70c179b$export$d896de52f97cb615(element, valueName, keyframes) {
    var _ref = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : {}, _ref_delay = _ref.delay, delay = _ref_delay === void 0 ? 0 : _ref_delay, _ref_duration = _ref.duration, duration = _ref_duration === void 0 ? 300 : _ref_duration, _ref_repeat = _ref.repeat, repeat = _ref_repeat === void 0 ? 0 : _ref_repeat, _ref_repeatType = _ref.repeatType, repeatType = _ref_repeatType === void 0 ? "loop" : _ref_repeatType, _ref_ease = _ref.ease, ease = _ref_ease === void 0 ? "easeOut" : _ref_ease, times = _ref.times, pseudoElement = arguments.length > 4 ? arguments[4] : void 0;
    var keyframeOptions = (0, $72osQ._)({}, valueName, keyframes);
    if (times) keyframeOptions.offset = times;
    var easing = (0, $Mjyaa.mapEasingToNativeEasing)(ease, duration);
    /**
     * If this is an easing array, apply to keyframes, not animation as a whole
     */ if (Array.isArray(easing)) keyframeOptions.easing = easing;
    if ((0, $2GhiD.statsBuffer).value) (0, $2gN7O.activeAnimations).waapi++;
    var options = {
        delay: delay,
        duration: duration,
        easing: !Array.isArray(easing) ? easing : "linear",
        fill: "both",
        iterations: repeat + 1,
        direction: repeatType === "reverse" ? "alternate" : "normal"
    };
    if (pseudoElement) options.pseudoElement = pseudoElement;
    var animation = element.animate(keyframeOptions, options);
    if ((0, $2GhiD.statsBuffer).value) animation.finished.finally(function() {
        (0, $2gN7O.activeAnimations).waapi--;
    });
    return animation;
}

});
parcelRegister("Mjyaa", function(module, exports) {

$parcel$export(module.exports, "mapEasingToNativeEasing", function () { return $7deb930c78f46f69$export$916ea73bcd3a6030; });

var $fq8uE = parcelRequire("fq8uE");

var $jiZGz = parcelRequire("jiZGz");

var $jhu9a = parcelRequire("jhu9a");

var $6KiHh = parcelRequire("6KiHh");

var $4q1oa = parcelRequire("4q1oa");
function $7deb930c78f46f69$export$916ea73bcd3a6030(easing, duration) {
    if (!easing) return undefined;
    else if (typeof easing === "function") return (0, $jiZGz.supportsLinearEasing)() ? (0, $jhu9a.generateLinearEasing)(easing, duration) : "ease-out";
    else if ((0, $fq8uE.isBezierDefinition)(easing)) return (0, $6KiHh.cubicBezierAsString)(easing);
    else if (Array.isArray(easing)) return easing.map(function(segmentEasing) {
        return $7deb930c78f46f69$export$916ea73bcd3a6030(segmentEasing, duration) || (0, $4q1oa.supportedWaapiEasing).easeOut;
    });
    else return (0, $4q1oa.supportedWaapiEasing)[easing];
}

});
parcelRegister("jiZGz", function(module, exports) {

$parcel$export(module.exports, "supportsLinearEasing", function () { return $75579a67fd925e6a$export$866c1d07a1ac2ab; });

var $9Dl94 = parcelRequire("9Dl94");
var $75579a67fd925e6a$export$866c1d07a1ac2ab = /*@__PURE__*/ (0, $9Dl94.memoSupports)(function() {
    try {
        document.createElement("div").animate({
            opacity: 0
        }, {
            easing: "linear(0, 1)"
        });
    } catch (e) {
        return false;
    }
    return true;
}, "linearEasing");

});
parcelRegister("9Dl94", function(module, exports) {

$parcel$export(module.exports, "memoSupports", function () { return $a31b9de8bcbf930b$export$1964673d5ec13c3a; });

var $8HBdf = parcelRequire("8HBdf");

var $8ifJj = parcelRequire("8ifJj");
function $a31b9de8bcbf930b$export$1964673d5ec13c3a(callback, supportsFlag) {
    var memoized = (0, $8HBdf.memo)(callback);
    return function() {
        var _supportsFlags_supportsFlag;
        return (_supportsFlags_supportsFlag = (0, $8ifJj.supportsFlags)[supportsFlag]) !== null && _supportsFlags_supportsFlag !== void 0 ? _supportsFlags_supportsFlag : memoized();
    };
}

});
parcelRegister("8ifJj", function(module, exports) {

$parcel$export(module.exports, "supportsFlags", function () { return $bea9597aedc977b3$export$e3ad02c335474dee; });
/**
 * Add the ability for test suites to manually set support flags
 * to better test more environments.
 */ var $bea9597aedc977b3$export$e3ad02c335474dee = {};

});



parcelRegister("6KiHh", function(module, exports) {

$parcel$export(module.exports, "cubicBezierAsString", function () { return $e6d40b483684adaa$export$2523b8f0bd8f44cb; });

var $2nwvT = parcelRequire("2nwvT");
var $e6d40b483684adaa$export$2523b8f0bd8f44cb = function(param) {
    var _param = (0, $2nwvT._)(param, 4), a = _param[0], b = _param[1], c = _param[2], d = _param[3];
    return "cubic-bezier(".concat(a, ", ").concat(b, ", ").concat(c, ", ").concat(d, ")");
};

});

parcelRegister("4q1oa", function(module, exports) {

$parcel$export(module.exports, "supportedWaapiEasing", function () { return $538faa756078367c$export$2cf569f5e2221176; });

var $6KiHh = parcelRequire("6KiHh");
var $538faa756078367c$export$2cf569f5e2221176 = {
    linear: "linear",
    ease: "ease",
    easeIn: "ease-in",
    easeOut: "ease-out",
    easeInOut: "ease-in-out",
    circIn: /*@__PURE__*/ (0, $6KiHh.cubicBezierAsString)([
        0,
        0.65,
        0.55,
        1
    ]),
    circOut: /*@__PURE__*/ (0, $6KiHh.cubicBezierAsString)([
        0.55,
        0,
        1,
        0.45
    ]),
    backIn: /*@__PURE__*/ (0, $6KiHh.cubicBezierAsString)([
        0.31,
        0.01,
        0.66,
        -0.59
    ]),
    backOut: /*@__PURE__*/ (0, $6KiHh.cubicBezierAsString)([
        0.33,
        1.53,
        0.69,
        0.99
    ])
};

});



parcelRegister("81wxg", function(module, exports) {

$parcel$export(module.exports, "applyGeneratorOptions", function () { return $ccd1c1be7bc95318$export$a31269144d66b4a; });

var $buaX5 = parcelRequire("buaX5");

var $jiZGz = parcelRequire("jiZGz");

var $7hxuZ = parcelRequire("7hxuZ");
function $ccd1c1be7bc95318$export$a31269144d66b4a(_param) {
    var type = _param.type, options = (0, $buaX5._)(_param, [
        "type"
    ]);
    if ((0, $7hxuZ.isGenerator)(type) && (0, $jiZGz.supportsLinearEasing)()) return type.applyToOptions(options);
    else {
        var _options_duration;
        (_options_duration = options.duration) !== null && _options_duration !== void 0 ? _options_duration : options.duration = 300;
        var _options_ease;
        (_options_ease = options.ease) !== null && _options_ease !== void 0 ? _options_ease : options.ease = "easeOut";
    }
    return options;
}

});
parcelRegister("7hxuZ", function(module, exports) {

$parcel$export(module.exports, "isGenerator", function () { return $51cf503cefd47cf4$export$6ab7812f1bac68be; });
function $51cf503cefd47cf4$export$6ab7812f1bac68be(type) {
    return typeof type === "function" && "applyToOptions" in type;
}

});



parcelRegister("d7Kr9", function(module, exports) {

$parcel$export(module.exports, "replaceStringEasing", function () { return $5bede2309bd10c0a$export$5195f232c29d1f82; });

var $jcXJu = parcelRequire("jcXJu");
var $84x0f = parcelRequire("84x0f");
var $iRVOe = parcelRequire("iRVOe");
var $5bede2309bd10c0a$var$unsupportedEasingFunctions = {
    anticipate: (0, $jcXJu.anticipate),
    backInOut: (0, $84x0f.backInOut),
    circInOut: (0, $iRVOe.circInOut)
};
function $5bede2309bd10c0a$var$isUnsupportedEase(key) {
    return key in $5bede2309bd10c0a$var$unsupportedEasingFunctions;
}
function $5bede2309bd10c0a$export$5195f232c29d1f82(transition) {
    if (typeof transition.ease === "string" && $5bede2309bd10c0a$var$isUnsupportedEase(transition.ease)) transition.ease = $5bede2309bd10c0a$var$unsupportedEasingFunctions[transition.ease];
}

});


parcelRegister("fsb2l", function(module, exports) {

$parcel$export(module.exports, "canAnimate", function () { return $82861b78cd75bbdf$export$1b109e6c9968df4f; });

var $FCK0G = parcelRequire("FCK0G");

var $7hxuZ = parcelRequire("7hxuZ");

var $aACQm = parcelRequire("aACQm");
function $82861b78cd75bbdf$var$hasKeyframesChanged(keyframes) {
    var current = keyframes[0];
    if (keyframes.length === 1) return true;
    for(var i = 0; i < keyframes.length; i++){
        if (keyframes[i] !== current) return true;
    }
}
function $82861b78cd75bbdf$export$1b109e6c9968df4f(keyframes, name, type, velocity) {
    /**
     * Check if we're able to animate between the start and end keyframes,
     * and throw a warning if we're attempting to animate between one that's
     * animatable and another that isn't.
     */ var originKeyframe = keyframes[0];
    if (originKeyframe === null) return false;
    /**
     * These aren't traditionally animatable but we do support them.
     * In future we could look into making this more generic or replacing
     * this function with mix() === mixImmediate
     */ if (name === "display" || name === "visibility") return true;
    var targetKeyframe = keyframes[keyframes.length - 1];
    var isOriginAnimatable = (0, $aACQm.isAnimatable)(originKeyframe, name);
    var isTargetAnimatable = (0, $aACQm.isAnimatable)(targetKeyframe, name);
    (0, $FCK0G.warning)(isOriginAnimatable === isTargetAnimatable, "You are trying to animate ".concat(name, ' from "').concat(originKeyframe, '" to "').concat(targetKeyframe, '". "').concat(isOriginAnimatable ? targetKeyframe : originKeyframe, '" is not an animatable value.'), "value-not-animatable");
    // Always skip if any of these are true
    if (!isOriginAnimatable || !isTargetAnimatable) return false;
    return $82861b78cd75bbdf$var$hasKeyframesChanged(keyframes) || (type === "spring" || (0, $7hxuZ.isGenerator)(type)) && velocity;
}

});
parcelRegister("aACQm", function(module, exports) {

$parcel$export(module.exports, "isAnimatable", function () { return $8dd4870ac2970adf$export$65676b58b122bc38; });

var $8S0wI = parcelRequire("8S0wI");
/**
 * Check if a value is animatable. Examples:
 *
 * ✅: 100, "100px", "#fff"
 * ❌: "block", "url(2.jpg)"
 * @param value
 *
 * @internal
 */ var $8dd4870ac2970adf$export$65676b58b122bc38 = function(value, name) {
    // If the list of keys that might be non-animatable grows, replace with Set
    if (name === "zIndex") return false;
    // If it's a number or a keyframes array, we can animate it. We might at some point
    // need to do a deep isAnimatable check of keyframes, or let Popmotion handle this,
    // but for now lets leave it like this for performance reasons
    if (typeof value === "number" || Array.isArray(value)) return true;
    if (typeof value === "string" && // It's animatable if we have a string
    ((0, $8S0wI.complex).test(value) || value === "0") && // And it contains numbers and/or colors
    !value.startsWith("url(") // Unless it starts with "url("
    ) return true;
    return false;
};

});


parcelRegister("iLBLt", function(module, exports) {

$parcel$export(module.exports, "makeAnimationInstant", function () { return $5502118e8747fc3e$export$b2585dd3c345da47; });
function $5502118e8747fc3e$export$b2585dd3c345da47(options) {
    options.duration = 0;
    options.type = "keyframes";
}

});

parcelRegister("geiGS", function(module, exports) {

$parcel$export(module.exports, "supportsBrowserAnimation", function () { return $3fcbd7be31ee79cf$export$ea92bde116fda821; });

var $8HBdf = parcelRequire("8HBdf");
/**
 * A list of values that can be hardware-accelerated.
 */ var $3fcbd7be31ee79cf$var$acceleratedValues = new Set([
    "opacity",
    "clipPath",
    "filter",
    "transform"
]);
var $3fcbd7be31ee79cf$var$supportsWaapi = /*@__PURE__*/ (0, $8HBdf.memo)(function() {
    return Object.hasOwnProperty.call(Element.prototype, "animate");
});
function $3fcbd7be31ee79cf$export$ea92bde116fda821(options) {
    var _motionValue_owner;
    var motionValue = options.motionValue, name = options.name, repeatDelay = options.repeatDelay, repeatType = options.repeatType, damping = options.damping, type = options.type;
    var subject = motionValue === null || motionValue === void 0 ? void 0 : (_motionValue_owner = motionValue.owner) === null || _motionValue_owner === void 0 ? void 0 : _motionValue_owner.current;
    /**
     * We use this check instead of isHTMLElement() because we explicitly
     * **don't** want elements in different timing contexts (i.e. popups)
     * to be accelerated, as it's not possible to sync these animations
     * properly with those driven from the main window frameloop.
     */ if (!(subject instanceof HTMLElement)) return false;
    var _motionValue_owner_getProps = motionValue.owner.getProps(), onUpdate = _motionValue_owner_getProps.onUpdate, transformTemplate = _motionValue_owner_getProps.transformTemplate;
    return $3fcbd7be31ee79cf$var$supportsWaapi() && name && $3fcbd7be31ee79cf$var$acceleratedValues.has(name) && (name !== "transform" || !transformTemplate) && /**
         * If we're outputting values to onUpdate then we can't use WAAPI as there's
         * no way to read the value from WAAPI every frame.
         */ !onUpdate && !repeatDelay && repeatType !== "mirror" && damping !== 0 && type !== "inertia";
}

});


parcelRegister("hLYzX", function(module, exports) {

$parcel$export(module.exports, "getFinalKeyframe", function () { return $0a3f2bb43fc99f38$export$14de59408fad90b; });
var $0a3f2bb43fc99f38$var$isNotNull = function(value) {
    return value !== null;
};
function $0a3f2bb43fc99f38$export$14de59408fad90b(keyframes, param, finalKeyframe) {
    var repeat = param.repeat, _param_repeatType = param.repeatType, repeatType = _param_repeatType === void 0 ? "loop" : _param_repeatType;
    var resolvedKeyframes = keyframes.filter($0a3f2bb43fc99f38$var$isNotNull);
    var index = repeat && repeatType !== "loop" && repeat % 2 === 1 ? 0 : resolvedKeyframes.length - 1;
    return !index || finalKeyframe === undefined ? resolvedKeyframes[index] : finalKeyframe;
}

});

parcelRegister("3eyIR", function(module, exports) {

$parcel$export(module.exports, "getDefaultTransition", function () { return $30dad1ee1f8213dc$export$262124b154b9f1c0; });

var $e6FP6 = parcelRequire("e6FP6");
var $30dad1ee1f8213dc$var$underDampedSpring = {
    type: "spring",
    stiffness: 500,
    damping: 25,
    restSpeed: 10
};
var $30dad1ee1f8213dc$var$criticallyDampedSpring = function(target) {
    return {
        type: "spring",
        stiffness: 550,
        damping: target === 0 ? 2 * Math.sqrt(550) : 30,
        restSpeed: 10
    };
};
var $30dad1ee1f8213dc$var$keyframesTransition = {
    type: "keyframes",
    duration: 0.8
};
/**
 * Default easing curve is a slightly shallower version of
 * the default browser easing curve.
 */ var $30dad1ee1f8213dc$var$ease = {
    type: "keyframes",
    ease: [
        0.25,
        0.1,
        0.35,
        1
    ],
    duration: 0.3
};
var $30dad1ee1f8213dc$export$262124b154b9f1c0 = function(valueKey, param) {
    var keyframes = param.keyframes;
    if (keyframes.length > 2) return $30dad1ee1f8213dc$var$keyframesTransition;
    else if ((0, $e6FP6.transformProps).has(valueKey)) return valueKey.startsWith("scale") ? $30dad1ee1f8213dc$var$criticallyDampedSpring(keyframes[1]) : $30dad1ee1f8213dc$var$underDampedSpring;
    return $30dad1ee1f8213dc$var$ease;
};

});

parcelRegister("bKS2F", function(module, exports) {

$parcel$export(module.exports, "isTransitionDefined", function () { return $af0924459c76fadf$export$ca8e47dc8ed5a9d7; });
/**
 * Decide whether a transition is defined on a given Transition.
 * This filters out orchestration options and returns true
 * if any options are left.
 */ 
var $buaX5 = parcelRequire("buaX5");
function $af0924459c76fadf$export$ca8e47dc8ed5a9d7(_param) {
    var when = _param.when, _delay = _param.delay, delayChildren = _param.delayChildren, staggerChildren = _param.staggerChildren, staggerDirection = _param.staggerDirection, repeat = _param.repeat, repeatType = _param.repeatType, repeatDelay = _param.repeatDelay, from = _param.from, elapsed = _param.elapsed, transition = (0, $buaX5._)(_param, [
        "when",
        "delay",
        "delayChildren",
        "staggerChildren",
        "staggerDirection",
        "repeat",
        "repeatType",
        "repeatDelay",
        "from",
        "elapsed"
    ]);
    return !!Object.keys(transition).length;
}

});



parcelRegister("kdPZo", function(module, exports) {

$parcel$export(module.exports, "animateVariant", function () { return $5a8955c615d28bfc$export$4709dc300705b2af; });

var $joFW3 = parcelRequire("joFW3");

var $90FDw = parcelRequire("90FDw");

var $2nwvT = parcelRequire("2nwvT");

var $D0HzR = parcelRequire("D0HzR");

var $dcOWD = parcelRequire("dcOWD");

var $b9KoW = parcelRequire("b9KoW");
function $5a8955c615d28bfc$export$4709dc300705b2af(visualElement, variant) {
    var options = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
    var _visualElement_presenceContext;
    var resolved = (0, $D0HzR.resolveVariant)(visualElement, variant, options.type === "exit" ? (_visualElement_presenceContext = visualElement.presenceContext) === null || _visualElement_presenceContext === void 0 ? void 0 : _visualElement_presenceContext.custom : undefined);
    var _ref = resolved || {}, _ref_transition = _ref.transition, transition = _ref_transition === void 0 ? visualElement.getDefaultTransition() || {} : _ref_transition;
    if (options.transitionOverride) transition = options.transitionOverride;
    /**
     * If we have a variant, create a callback that runs it as an animation.
     * Otherwise, we resolve a Promise immediately for a composable no-op.
     */ var getAnimation = resolved ? function() {
        return Promise.all((0, $b9KoW.animateTarget)(visualElement, resolved, options));
    } : function() {
        return Promise.resolve();
    };
    /**
     * If we have children, create a callback that runs all their animations.
     * Otherwise, we resolve a Promise immediately for a composable no-op.
     */ var getChildAnimations = visualElement.variantChildren && visualElement.variantChildren.size ? function() {
        var forwardDelay = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : 0;
        var _transition_delayChildren = transition.delayChildren, delayChildren = _transition_delayChildren === void 0 ? 0 : _transition_delayChildren, staggerChildren = transition.staggerChildren, staggerDirection = transition.staggerDirection;
        return $5a8955c615d28bfc$var$animateChildren(visualElement, variant, forwardDelay, delayChildren, staggerChildren, staggerDirection, options);
    } : function() {
        return Promise.resolve();
    };
    /**
     * If the transition explicitly defines a "when" option, we need to resolve either
     * this animation or all children animations before playing the other.
     */ var when = transition.when;
    if (when) {
        var _ref1 = (0, $2nwvT._)(when === "beforeChildren" ? [
            getAnimation,
            getChildAnimations
        ] : [
            getChildAnimations,
            getAnimation
        ], 2), first = _ref1[0], last = _ref1[1];
        return first().then(function() {
            return last();
        });
    } else return Promise.all([
        getAnimation(),
        getChildAnimations(options.delay)
    ]);
}
function $5a8955c615d28bfc$var$animateChildren(visualElement, variant) {
    var delay = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : 0, delayChildren = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : 0, staggerChildren = arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : 0, staggerDirection = arguments.length > 5 && arguments[5] !== void 0 ? arguments[5] : 1, options = arguments.length > 6 ? arguments[6] : void 0;
    var animations = [];
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        var _loop = function() {
            var child = _step.value;
            child.notify("AnimationStart", variant);
            animations.push($5a8955c615d28bfc$export$4709dc300705b2af(child, variant, (0, $90FDw._)((0, $joFW3._)({}, options), {
                delay: delay + (typeof delayChildren === "function" ? 0 : delayChildren) + (0, $dcOWD.calcChildStagger)(visualElement.variantChildren, child, delayChildren, staggerChildren, staggerDirection)
            })).then(function() {
                return child.notify("AnimationComplete", variant);
            }));
        };
        for(var _iterator = visualElement.variantChildren[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true)_loop();
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    return Promise.all(animations);
}

});
parcelRegister("dcOWD", function(module, exports) {

$parcel$export(module.exports, "calcChildStagger", function () { return $27b772e89538f6f3$export$6e01cb2cb232d79b; });
function $27b772e89538f6f3$export$6e01cb2cb232d79b(children, child, delayChildren) {
    var staggerChildren = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : 0, staggerDirection = arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : 1;
    var index = Array.from(children).sort(function(a, b) {
        return a.sortNodePosition(b);
    }).indexOf(child);
    var numChildren = children.size;
    var maxStaggerDuration = (numChildren - 1) * staggerChildren;
    var delayIsFunction = typeof delayChildren === "function";
    return delayIsFunction ? delayChildren(index, numChildren) : staggerDirection === 1 ? index * staggerChildren : maxStaggerDuration - index * staggerChildren;
}

});



parcelRegister("jwaC9", function(module, exports) {

$parcel$export(module.exports, "shallowCompare", function () { return $7471e449acc6dd77$export$90e866afbd6b9f1a; });
function $7471e449acc6dd77$export$90e866afbd6b9f1a(next, prev) {
    if (!Array.isArray(prev)) return false;
    var prevLength = prev.length;
    if (prevLength !== next.length) return false;
    for(var i = 0; i < prevLength; i++){
        if (prev[i] !== next[i]) return false;
    }
    return true;
}

});

parcelRegister("gXnT6", function(module, exports) {

$parcel$export(module.exports, "getVariantContext", function () { return $53fe4e15f29d0229$export$6669f52f7ffa343b; });

var $6WBVt = parcelRequire("6WBVt");

var $4hPGR = parcelRequire("4hPGR");
var $53fe4e15f29d0229$var$numVariantProps = (0, $4hPGR.variantProps).length;
function $53fe4e15f29d0229$export$6669f52f7ffa343b(visualElement) {
    if (!visualElement) return undefined;
    if (!visualElement.isControllingVariants) {
        var context = visualElement.parent ? $53fe4e15f29d0229$export$6669f52f7ffa343b(visualElement.parent) || {} : {};
        if (visualElement.props.initial !== undefined) context.initial = visualElement.props.initial;
        return context;
    }
    var context1 = {};
    for(var i = 0; i < $53fe4e15f29d0229$var$numVariantProps; i++){
        var name = (0, $4hPGR.variantProps)[i];
        var prop = visualElement.props[name];
        if ((0, $6WBVt.isVariantLabel)(prop) || prop === false) context1[name] = prop;
    }
    return context1;
}

});


parcelRegister("hVeVW", function(module, exports) {

$parcel$export(module.exports, "Feature", function () { return $d9394131c38c23bf$export$6e91cf7616333d5; });

var $grujF = parcelRequire("grujF");

var $dhMkv = parcelRequire("dhMkv");
var $d9394131c38c23bf$export$6e91cf7616333d5 = /*#__PURE__*/ function() {
    "use strict";
    function Feature(node) {
        (0, $grujF._)(this, Feature);
        this.isMounted = false;
        this.node = node;
    }
    (0, $dhMkv._)(Feature, [
        {
            key: "update",
            value: function update() {}
        }
    ]);
    return Feature;
}();

});


parcelRegister("9DyrS", function(module, exports) {

$parcel$export(module.exports, "ExitAnimationFeature", function () { return $cb76ef4145f3ff30$export$4989d1eb6104cc6c; });

var $f3Okx = parcelRequire("f3Okx");

var $grujF = parcelRequire("grujF");

var $dhMkv = parcelRequire("dhMkv");

var $j6Mzi = parcelRequire("j6Mzi");

var $hVeVW = parcelRequire("hVeVW");
var $cb76ef4145f3ff30$var$id = 0;
var $cb76ef4145f3ff30$export$4989d1eb6104cc6c = /*#__PURE__*/ function(Feature) {
    "use strict";
    (0, $j6Mzi._)(ExitAnimationFeature, Feature);
    function ExitAnimationFeature() {
        (0, $grujF._)(this, ExitAnimationFeature);
        var _this;
        _this = (0, $f3Okx._)(this, ExitAnimationFeature, arguments);
        _this.id = $cb76ef4145f3ff30$var$id++;
        return _this;
    }
    (0, $dhMkv._)(ExitAnimationFeature, [
        {
            key: "update",
            value: function update() {
                var _this = this;
                if (!this.node.presenceContext) return;
                var _this_node_presenceContext = this.node.presenceContext, isPresent = _this_node_presenceContext.isPresent, onExitComplete = _this_node_presenceContext.onExitComplete;
                var _ref = this.node.prevPresenceContext || {}, prevIsPresent = _ref.isPresent;
                if (!this.node.animationState || isPresent === prevIsPresent) return;
                var exitAnimation = this.node.animationState.setActive("exit", !isPresent);
                if (onExitComplete && !isPresent) exitAnimation.then(function() {
                    onExitComplete(_this.id);
                });
            }
        },
        {
            key: "mount",
            value: function mount() {
                var _ref = this.node.presenceContext || {}, register = _ref.register, onExitComplete = _ref.onExitComplete;
                if (onExitComplete) onExitComplete(this.id);
                if (register) this.unmount = register(this.id);
            }
        },
        {
            key: "unmount",
            value: function unmount() {}
        }
    ]);
    return ExitAnimationFeature;
}((0, $hVeVW.Feature));

});


parcelRegister("btWuV", function(module, exports) {

$parcel$export(module.exports, "drag", function () { return $50f17eda5c58cf90$export$d7d5d435647ed5a0; });

var $eOlEE = parcelRequire("eOlEE");

var $be9aY = parcelRequire("be9aY");

var $kXN1g = parcelRequire("kXN1g");

var $hj2UJ = parcelRequire("hj2UJ");
var $50f17eda5c58cf90$export$d7d5d435647ed5a0 = {
    pan: {
        Feature: (0, $be9aY.PanGesture)
    },
    drag: {
        Feature: (0, $eOlEE.DragGesture),
        ProjectionNode: (0, $hj2UJ.HTMLProjectionNode),
        MeasureLayout: (0, $kXN1g.MeasureLayout)
    }
};

});
parcelRegister("eOlEE", function(module, exports) {

$parcel$export(module.exports, "DragGesture", function () { return $154ee79a98f34d03$export$5d97dc2872682820; });

var $f3Okx = parcelRequire("f3Okx");

var $grujF = parcelRequire("grujF");

var $dhMkv = parcelRequire("dhMkv");

var $j6Mzi = parcelRequire("j6Mzi");

var $hVeVW = parcelRequire("hVeVW");

var $eQ5Xp = parcelRequire("eQ5Xp");

var $i0WVt = parcelRequire("i0WVt");
var $154ee79a98f34d03$export$5d97dc2872682820 = /*#__PURE__*/ function(Feature) {
    "use strict";
    (0, $j6Mzi._)(DragGesture, Feature);
    function DragGesture(node) {
        (0, $grujF._)(this, DragGesture);
        var _this;
        _this = (0, $f3Okx._)(this, DragGesture, [
            node
        ]);
        _this.removeGroupControls = (0, $eQ5Xp.noop);
        _this.removeListeners = (0, $eQ5Xp.noop);
        _this.controls = new (0, $i0WVt.VisualElementDragControls)(node);
        return _this;
    }
    (0, $dhMkv._)(DragGesture, [
        {
            key: "mount",
            value: function mount() {
                // If we've been provided a DragControls for manual control over the drag gesture,
                // subscribe this component to it on mount.
                var dragControls = this.node.getProps().dragControls;
                if (dragControls) this.removeGroupControls = dragControls.subscribe(this.controls);
                this.removeListeners = this.controls.addListeners() || (0, $eQ5Xp.noop);
            }
        },
        {
            key: "unmount",
            value: function unmount() {
                this.removeGroupControls();
                this.removeListeners();
            }
        }
    ]);
    return DragGesture;
}((0, $hVeVW.Feature));

});
parcelRegister("i0WVt", function(module, exports) {

$parcel$export(module.exports, "VisualElementDragControls", function () { return $8317a11ef33664a9$export$86bff71f18910307; });

var $grujF = parcelRequire("grujF");

var $dhMkv = parcelRequire("dhMkv");

var $joFW3 = parcelRequire("joFW3");

var $90FDw = parcelRequire("90FDw");

var $8oVcc = parcelRequire("8oVcc");
var $83rca = parcelRequire("83rca");
var $aUTIu = parcelRequire("aUTIu");
var $i7mFQ = parcelRequire("i7mFQ");

var $FCK0G = parcelRequire("FCK0G");

var $cUBhh = parcelRequire("cUBhh");

var $j9DZq = parcelRequire("j9DZq");

var $7qJEU = parcelRequire("7qJEU");

var $kKOaz = parcelRequire("kKOaz");

var $3QSeu = parcelRequire("3QSeu");

var $kqrPq = parcelRequire("kqrPq");

var $60wa2 = parcelRequire("60wa2");

var $8vGlw = parcelRequire("8vGlw");

var $2947o = parcelRequire("2947o");

var $8ugSN = parcelRequire("8ugSN");

var $g0sR1 = parcelRequire("g0sR1");

var $gjAeU = parcelRequire("gjAeU");

var $lV3fJ = parcelRequire("lV3fJ");

var $iO0HF = parcelRequire("iO0HF");
var $8317a11ef33664a9$export$f0a15892c27dc07c = new WeakMap();
var $8317a11ef33664a9$export$86bff71f18910307 = /*#__PURE__*/ function() {
    "use strict";
    function VisualElementDragControls(visualElement) {
        (0, $grujF._)(this, VisualElementDragControls);
        this.openDragLock = null;
        this.isDragging = false;
        this.currentDirection = null;
        this.originPoint = {
            x: 0,
            y: 0
        };
        /**
         * The permitted boundaries of travel, in pixels.
         */ this.constraints = false;
        this.hasMutatedConstraints = false;
        /**
         * The per-axis resolved elastic values.
         */ this.elastic = (0, $60wa2.createBox)();
        /**
         * The latest pointer event. Used as fallback when the `cancel` and `stop` functions are called without arguments.
         */ this.latestPointerEvent = null;
        /**
         * The latest pan info. Used as fallback when the `cancel` and `stop` functions are called without arguments.
         */ this.latestPanInfo = null;
        this.visualElement = visualElement;
    }
    (0, $dhMkv._)(VisualElementDragControls, [
        {
            key: "start",
            value: function start(originEvent) {
                var _this = this;
                var _ref = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, _ref_snapToCursor = _ref.snapToCursor, snapToCursor = _ref_snapToCursor === void 0 ? false : _ref_snapToCursor, distanceThreshold = _ref.distanceThreshold;
                /**
         * Don't start dragging if this component is exiting
         */ var presenceContext = this.visualElement.presenceContext;
                if (presenceContext && presenceContext.isPresent === false) return;
                var onSessionStart = function(event) {
                    var dragSnapToOrigin = _this.getProps().dragSnapToOrigin;
                    // Stop or pause any animations on both axis values immediately. This allows the user to throw and catch
                    // the component.
                    dragSnapToOrigin ? _this.pauseAnimation() : _this.stopAnimation();
                    if (snapToCursor) _this.snapToCursor((0, $kKOaz.extractEventInfo)(event).point);
                };
                var onStart = function(event, info) {
                    // Attempt to grab the global drag gesture lock - maybe make this part of PanSession
                    var _this_getProps = _this.getProps(), drag = _this_getProps.drag, dragPropagation = _this_getProps.dragPropagation, onDragStart = _this_getProps.onDragStart;
                    if (drag && !dragPropagation) {
                        if (_this.openDragLock) _this.openDragLock();
                        _this.openDragLock = (0, $i7mFQ.setDragLock)(drag);
                        // If we don 't have the lock, don't start dragging
                        if (!_this.openDragLock) return;
                    }
                    _this.latestPointerEvent = event;
                    _this.latestPanInfo = info;
                    _this.isDragging = true;
                    _this.currentDirection = null;
                    _this.resolveConstraints();
                    if (_this.visualElement.projection) {
                        _this.visualElement.projection.isAnimationBlocked = true;
                        _this.visualElement.projection.target = undefined;
                    }
                    /**
             * Record gesture origin
             */ (0, $8vGlw.eachAxis)(function(axis) {
                        var current = _this.getAxisMotionValue(axis).get() || 0;
                        /**
                 * If the MotionValue is a percentage value convert to px
                 */ if ((0, $aUTIu.percent).test(current)) {
                            var projection = _this.visualElement.projection;
                            if (projection && projection.layout) {
                                var measuredAxis = projection.layout.layoutBox[axis];
                                if (measuredAxis) {
                                    var length = (0, $kqrPq.calcLength)(measuredAxis);
                                    current = length * (parseFloat(current) / 100);
                                }
                            }
                        }
                        _this.originPoint[axis] = current;
                    });
                    // Fire onDragStart event
                    if (onDragStart) (0, $8oVcc.frame).postRender(function() {
                        return onDragStart(event, info);
                    });
                    (0, $gjAeU.addValueToWillChange)(_this.visualElement, "transform");
                    var animationState = _this.visualElement.animationState;
                    animationState && animationState.setActive("whileDrag", true);
                };
                var onMove = function(event, info) {
                    _this.latestPointerEvent = event;
                    _this.latestPanInfo = info;
                    var _this_getProps = _this.getProps(), dragPropagation = _this_getProps.dragPropagation, dragDirectionLock = _this_getProps.dragDirectionLock, onDirectionLock = _this_getProps.onDirectionLock, onDrag = _this_getProps.onDrag;
                    // If we didn't successfully receive the gesture lock, early return.
                    if (!dragPropagation && !_this.openDragLock) return;
                    var offset = info.offset;
                    // Attempt to detect drag direction if directionLock is true
                    if (dragDirectionLock && _this.currentDirection === null) {
                        _this.currentDirection = $8317a11ef33664a9$var$getCurrentDirection(offset);
                        // If we've successfully set a direction, notify listener
                        if (_this.currentDirection !== null) onDirectionLock && onDirectionLock(_this.currentDirection);
                        return;
                    }
                    // Update each point with the latest position
                    _this.updateAxis("x", info.point, offset);
                    _this.updateAxis("y", info.point, offset);
                    /**
             * Ideally we would leave the renderer to fire naturally at the end of
             * this frame but if the element is about to change layout as the result
             * of a re-render we want to ensure the browser can read the latest
             * bounding box to ensure the pointer and element don't fall out of sync.
             */ _this.visualElement.render();
                    /**
             * This must fire after the render call as it might trigger a state
             * change which itself might trigger a layout update.
             */ onDrag && onDrag(event, info);
                };
                var onSessionEnd = function(event, info) {
                    _this.latestPointerEvent = event;
                    _this.latestPanInfo = info;
                    _this.stop(event, info);
                    _this.latestPointerEvent = null;
                    _this.latestPanInfo = null;
                };
                var resumeAnimation = function() {
                    return (0, $8vGlw.eachAxis)(function(axis) {
                        var _this_getAxisMotionValue_animation;
                        return _this.getAnimationState(axis) === "paused" && ((_this_getAxisMotionValue_animation = _this.getAxisMotionValue(axis).animation) === null || _this_getAxisMotionValue_animation === void 0 ? void 0 : _this_getAxisMotionValue_animation.play());
                    });
                };
                var dragSnapToOrigin = this.getProps().dragSnapToOrigin;
                this.panSession = new (0, $lV3fJ.PanSession)(originEvent, {
                    onSessionStart: onSessionStart,
                    onStart: onStart,
                    onMove: onMove,
                    onSessionEnd: onSessionEnd,
                    resumeAnimation: resumeAnimation
                }, {
                    transformPagePoint: this.visualElement.getTransformPagePoint(),
                    dragSnapToOrigin: dragSnapToOrigin,
                    distanceThreshold: distanceThreshold,
                    contextWindow: (0, $8ugSN.getContextWindow)(this.visualElement)
                });
            }
        },
        {
            /**
     * @internal
     */ key: "stop",
            value: function stop(event, panInfo) {
                var finalEvent = event || this.latestPointerEvent;
                var finalPanInfo = panInfo || this.latestPanInfo;
                var isDragging = this.isDragging;
                this.cancel();
                if (!isDragging || !finalPanInfo || !finalEvent) return;
                var velocity = finalPanInfo.velocity;
                this.startAnimation(velocity);
                var onDragEnd = this.getProps().onDragEnd;
                if (onDragEnd) (0, $8oVcc.frame).postRender(function() {
                    return onDragEnd(finalEvent, finalPanInfo);
                });
            }
        },
        {
            /**
     * @internal
     */ key: "cancel",
            value: function cancel() {
                this.isDragging = false;
                var _this_visualElement = this.visualElement, projection = _this_visualElement.projection, animationState = _this_visualElement.animationState;
                if (projection) projection.isAnimationBlocked = false;
                this.panSession && this.panSession.end();
                this.panSession = undefined;
                var dragPropagation = this.getProps().dragPropagation;
                if (!dragPropagation && this.openDragLock) {
                    this.openDragLock();
                    this.openDragLock = null;
                }
                animationState && animationState.setActive("whileDrag", false);
            }
        },
        {
            key: "updateAxis",
            value: function updateAxis(axis, _point, offset) {
                var drag = this.getProps().drag;
                // If we're not dragging this axis, do an early return.
                if (!offset || !$8317a11ef33664a9$var$shouldDrag(axis, drag, this.currentDirection)) return;
                var axisValue = this.getAxisMotionValue(axis);
                var next = this.originPoint[axis] + offset[axis];
                // Apply constraints
                if (this.constraints && this.constraints[axis]) next = (0, $iO0HF.applyConstraints)(next, this.constraints[axis], this.elastic[axis]);
                axisValue.set(next);
            }
        },
        {
            key: "resolveConstraints",
            value: function resolveConstraints() {
                var _this = this;
                var _this_visualElement_projection;
                var _this_getProps = this.getProps(), dragConstraints = _this_getProps.dragConstraints, dragElastic = _this_getProps.dragElastic;
                var layout = this.visualElement.projection && !this.visualElement.projection.layout ? this.visualElement.projection.measure(false) : (_this_visualElement_projection = this.visualElement.projection) === null || _this_visualElement_projection === void 0 ? void 0 : _this_visualElement_projection.layout;
                var prevConstraints = this.constraints;
                if (dragConstraints && (0, $g0sR1.isRefObject)(dragConstraints)) {
                    if (!this.constraints) this.constraints = this.resolveRefConstraints();
                } else if (dragConstraints && layout) this.constraints = (0, $iO0HF.calcRelativeConstraints)(layout.layoutBox, dragConstraints);
                else this.constraints = false;
                this.elastic = (0, $iO0HF.resolveDragElastic)(dragElastic);
                /**
         * If we're outputting to external MotionValues, we want to rebase the measured constraints
         * from viewport-relative to component-relative.
         */ if (prevConstraints !== this.constraints && layout && this.constraints && !this.hasMutatedConstraints) (0, $8vGlw.eachAxis)(function(axis) {
                    if (_this.constraints !== false && _this.getAxisMotionValue(axis)) _this.constraints[axis] = (0, $iO0HF.rebaseAxisConstraints)(layout.layoutBox[axis], _this.constraints[axis]);
                });
            }
        },
        {
            key: "resolveRefConstraints",
            value: function resolveRefConstraints() {
                var _this_getProps = this.getProps(), constraints = _this_getProps.dragConstraints, onMeasureDragConstraints = _this_getProps.onMeasureDragConstraints;
                if (!constraints || !(0, $g0sR1.isRefObject)(constraints)) return false;
                var constraintsElement = constraints.current;
                (0, $FCK0G.invariant)(constraintsElement !== null, "If `dragConstraints` is set as a React ref, that ref must be passed to another component's `ref` prop.", "drag-constraints-ref");
                var projection = this.visualElement.projection;
                // TODO
                if (!projection || !projection.layout) return false;
                var constraintsBox = (0, $2947o.measurePageBox)(constraintsElement, projection.root, this.visualElement.getTransformPagePoint());
                var measuredConstraints = (0, $iO0HF.calcViewportConstraints)(projection.layout.layoutBox, constraintsBox);
                /**
         * If there's an onMeasureDragConstraints listener we call it and
         * if different constraints are returned, set constraints to that
         */ if (onMeasureDragConstraints) {
                    var userConstraints = onMeasureDragConstraints((0, $3QSeu.convertBoxToBoundingBox)(measuredConstraints));
                    this.hasMutatedConstraints = !!userConstraints;
                    if (userConstraints) measuredConstraints = (0, $3QSeu.convertBoundingBoxToBox)(userConstraints);
                }
                return measuredConstraints;
            }
        },
        {
            key: "startAnimation",
            value: function startAnimation(velocity) {
                var _this = this;
                var _this_getProps = this.getProps(), drag = _this_getProps.drag, dragMomentum = _this_getProps.dragMomentum, dragElastic = _this_getProps.dragElastic, dragTransition = _this_getProps.dragTransition, dragSnapToOrigin = _this_getProps.dragSnapToOrigin, onDragTransitionEnd = _this_getProps.onDragTransitionEnd;
                var constraints = this.constraints || {};
                var momentumAnimations = (0, $8vGlw.eachAxis)(function(axis) {
                    if (!$8317a11ef33664a9$var$shouldDrag(axis, drag, _this.currentDirection)) return;
                    var transition = constraints && constraints[axis] || {};
                    if (dragSnapToOrigin) transition = {
                        min: 0,
                        max: 0
                    };
                    /**
             * Overdamp the boundary spring if `dragElastic` is disabled. There's still a frame
             * of spring animations so we should look into adding a disable spring option to `inertia`.
             * We could do something here where we affect the `bounceStiffness` and `bounceDamping`
             * using the value of `dragElastic`.
             */ var bounceStiffness = dragElastic ? 200 : 1000000;
                    var bounceDamping = dragElastic ? 40 : 10000000;
                    var inertia = (0, $joFW3._)({
                        type: "inertia",
                        velocity: dragMomentum ? velocity[axis] : 0,
                        bounceStiffness: bounceStiffness,
                        bounceDamping: bounceDamping,
                        timeConstant: 750,
                        restDelta: 1,
                        restSpeed: 10
                    }, dragTransition, transition);
                    // If we're not animating on an externally-provided `MotionValue` we can use the
                    // component's animation controls which will handle interactions with whileHover (etc),
                    // otherwise we just have to animate the `MotionValue` itself.
                    return _this.startAxisValueAnimation(axis, inertia);
                });
                // Run all animations and then resolve the new drag constraints.
                return Promise.all(momentumAnimations).then(onDragTransitionEnd);
            }
        },
        {
            key: "startAxisValueAnimation",
            value: function startAxisValueAnimation(axis, transition) {
                var axisValue = this.getAxisMotionValue(axis);
                (0, $gjAeU.addValueToWillChange)(this.visualElement, axis);
                return axisValue.start((0, $cUBhh.animateMotionValue)(axis, axisValue, 0, transition, this.visualElement, false));
            }
        },
        {
            key: "stopAnimation",
            value: function stopAnimation() {
                var _this = this;
                (0, $8vGlw.eachAxis)(function(axis) {
                    return _this.getAxisMotionValue(axis).stop();
                });
            }
        },
        {
            key: "pauseAnimation",
            value: function pauseAnimation() {
                var _this = this;
                (0, $8vGlw.eachAxis)(function(axis) {
                    var _this_getAxisMotionValue_animation;
                    return (_this_getAxisMotionValue_animation = _this.getAxisMotionValue(axis).animation) === null || _this_getAxisMotionValue_animation === void 0 ? void 0 : _this_getAxisMotionValue_animation.pause();
                });
            }
        },
        {
            key: "getAnimationState",
            value: function getAnimationState(axis) {
                var _this_getAxisMotionValue_animation;
                return (_this_getAxisMotionValue_animation = this.getAxisMotionValue(axis).animation) === null || _this_getAxisMotionValue_animation === void 0 ? void 0 : _this_getAxisMotionValue_animation.state;
            }
        },
        {
            /**
     * Drag works differently depending on which props are provided.
     *
     * - If _dragX and _dragY are provided, we output the gesture delta directly to those motion values.
     * - Otherwise, we apply the delta to the x/y motion values.
     */ key: "getAxisMotionValue",
            value: function getAxisMotionValue(axis) {
                var dragKey = "_drag".concat(axis.toUpperCase());
                var props = this.visualElement.getProps();
                var externalMotionValue = props[dragKey];
                return externalMotionValue ? externalMotionValue : this.visualElement.getValue(axis, (props.initial ? props.initial[axis] : undefined) || 0);
            }
        },
        {
            key: "snapToCursor",
            value: function snapToCursor(point) {
                var _this = this;
                (0, $8vGlw.eachAxis)(function(axis) {
                    var drag = _this.getProps().drag;
                    // If we're not dragging this axis, do an early return.
                    if (!$8317a11ef33664a9$var$shouldDrag(axis, drag, _this.currentDirection)) return;
                    var projection = _this.visualElement.projection;
                    var axisValue = _this.getAxisMotionValue(axis);
                    if (projection && projection.layout) {
                        var _projection_layout_layoutBox_axis = projection.layout.layoutBox[axis], min = _projection_layout_layoutBox_axis.min, max = _projection_layout_layoutBox_axis.max;
                        axisValue.set(point[axis] - (0, $83rca.mixNumber)(min, max, 0.5));
                    }
                });
            }
        },
        {
            /**
     * When the viewport resizes we want to check if the measured constraints
     * have changed and, if so, reposition the element within those new constraints
     * relative to where it was before the resize.
     */ key: "scalePositionWithinConstraints",
            value: function scalePositionWithinConstraints() {
                var _this = this;
                if (!this.visualElement.current) return;
                var _this_getProps = this.getProps(), drag = _this_getProps.drag, dragConstraints = _this_getProps.dragConstraints;
                var projection = this.visualElement.projection;
                if (!(0, $g0sR1.isRefObject)(dragConstraints) || !projection || !this.constraints) return;
                /**
         * Stop current animations as there can be visual glitching if we try to do
         * this mid-animation
         */ this.stopAnimation();
                /**
         * Record the relative position of the dragged element relative to the
         * constraints box and save as a progress value.
         */ var boxProgress = {
                    x: 0,
                    y: 0
                };
                (0, $8vGlw.eachAxis)(function(axis) {
                    var axisValue = _this.getAxisMotionValue(axis);
                    if (axisValue && _this.constraints !== false) {
                        var latest = axisValue.get();
                        boxProgress[axis] = (0, $iO0HF.calcOrigin)({
                            min: latest,
                            max: latest
                        }, _this.constraints[axis]);
                    }
                });
                /**
         * Update the layout of this element and resolve the latest drag constraints
         */ var transformTemplate = this.visualElement.getProps().transformTemplate;
                this.visualElement.current.style.transform = transformTemplate ? transformTemplate({}, "") : "none";
                projection.root && projection.root.updateScroll();
                projection.updateLayout();
                this.resolveConstraints();
                /**
         * For each axis, calculate the current progress of the layout axis
         * within the new constraints.
         */ (0, $8vGlw.eachAxis)(function(axis) {
                    if (!$8317a11ef33664a9$var$shouldDrag(axis, drag, null)) return;
                    /**
             * Calculate a new transform based on the previous box progress
             */ var axisValue = _this.getAxisMotionValue(axis);
                    var _this_constraints_axis = _this.constraints[axis], min = _this_constraints_axis.min, max = _this_constraints_axis.max;
                    axisValue.set((0, $83rca.mixNumber)(min, max, boxProgress[axis]));
                });
            }
        },
        {
            key: "addListeners",
            value: function addListeners() {
                var _this = this;
                if (!this.visualElement.current) return;
                $8317a11ef33664a9$export$f0a15892c27dc07c.set(this.visualElement, this);
                var element = this.visualElement.current;
                /**
         * Attach a pointerdown event listener on this DOM element to initiate drag tracking.
         */ var stopPointerListener = (0, $7qJEU.addPointerEvent)(element, "pointerdown", function(event) {
                    var _this_getProps = _this.getProps(), drag = _this_getProps.drag, _this_getProps_dragListener = _this_getProps.dragListener, dragListener = _this_getProps_dragListener === void 0 ? true : _this_getProps_dragListener;
                    drag && dragListener && _this.start(event);
                });
                var measureDragConstraints = function() {
                    var dragConstraints = _this.getProps().dragConstraints;
                    if ((0, $g0sR1.isRefObject)(dragConstraints) && dragConstraints.current) _this.constraints = _this.resolveRefConstraints();
                };
                var projection = this.visualElement.projection;
                var stopMeasureLayoutListener = projection.addEventListener("measure", measureDragConstraints);
                if (projection && !projection.layout) {
                    projection.root && projection.root.updateScroll();
                    projection.updateLayout();
                }
                (0, $8oVcc.frame).read(measureDragConstraints);
                /**
         * Attach a window resize listener to scale the draggable target within its defined
         * constraints as the window resizes.
         */ var stopResizeListener = (0, $j9DZq.addDomEvent)(window, "resize", function() {
                    return _this.scalePositionWithinConstraints();
                });
                /**
         * If the element's layout changes, calculate the delta and apply that to
         * the drag gesture's origin point.
         */ var stopLayoutUpdateListener = projection.addEventListener("didUpdate", function(param) {
                    var delta = param.delta, hasLayoutChanged = param.hasLayoutChanged;
                    if (_this.isDragging && hasLayoutChanged) {
                        (0, $8vGlw.eachAxis)(function(axis) {
                            var motionValue = _this.getAxisMotionValue(axis);
                            if (!motionValue) return;
                            _this.originPoint[axis] += delta[axis].translate;
                            motionValue.set(motionValue.get() + delta[axis].translate);
                        });
                        _this.visualElement.render();
                    }
                });
                return function() {
                    stopResizeListener();
                    stopPointerListener();
                    stopMeasureLayoutListener();
                    stopLayoutUpdateListener && stopLayoutUpdateListener();
                };
            }
        },
        {
            key: "getProps",
            value: function getProps() {
                var props = this.visualElement.getProps();
                var _props_drag = props.drag, drag = _props_drag === void 0 ? false : _props_drag, _props_dragDirectionLock = props.dragDirectionLock, dragDirectionLock = _props_dragDirectionLock === void 0 ? false : _props_dragDirectionLock, _props_dragPropagation = props.dragPropagation, dragPropagation = _props_dragPropagation === void 0 ? false : _props_dragPropagation, _props_dragConstraints = props.dragConstraints, dragConstraints = _props_dragConstraints === void 0 ? false : _props_dragConstraints, _props_dragElastic = props.dragElastic, dragElastic = _props_dragElastic === void 0 ? (0, $iO0HF.defaultElastic) : _props_dragElastic, _props_dragMomentum = props.dragMomentum, dragMomentum = _props_dragMomentum === void 0 ? true : _props_dragMomentum;
                return (0, $90FDw._)((0, $joFW3._)({}, props), {
                    drag: drag,
                    dragDirectionLock: dragDirectionLock,
                    dragPropagation: dragPropagation,
                    dragConstraints: dragConstraints,
                    dragElastic: dragElastic,
                    dragMomentum: dragMomentum
                });
            }
        }
    ]);
    return VisualElementDragControls;
}();
function $8317a11ef33664a9$var$shouldDrag(direction, drag, currentDirection) {
    return (drag === true || drag === direction) && (currentDirection === null || currentDirection === direction);
}
/**
 * Based on an x/y offset determine the current drag direction. If both axis' offsets are lower
 * than the provided threshold, return `null`.
 *
 * @param offset - The x/y offset from origin.
 * @param lockThreshold - (Optional) - the minimum absolute offset before we can determine a drag direction.
 */ function $8317a11ef33664a9$var$getCurrentDirection(offset) {
    var lockThreshold = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 10;
    var direction = null;
    if (Math.abs(offset.y) > lockThreshold) direction = "y";
    else if (Math.abs(offset.x) > lockThreshold) direction = "x";
    return direction;
}

});
parcelRegister("i7mFQ", function(module, exports) {

$parcel$export(module.exports, "setDragLock", function () { return $dfc4ef75bfda86a5$export$64d8a3fd7eb621d5; });

var $1B8HX = parcelRequire("1B8HX");
function $dfc4ef75bfda86a5$export$64d8a3fd7eb621d5(axis) {
    if (axis === "x" || axis === "y") {
        if ((0, $1B8HX.isDragging)[axis]) return null;
        else {
            (0, $1B8HX.isDragging)[axis] = true;
            return function() {
                (0, $1B8HX.isDragging)[axis] = false;
            };
        }
    } else {
        if ((0, $1B8HX.isDragging).x || (0, $1B8HX.isDragging).y) return null;
        else {
            (0, $1B8HX.isDragging).x = (0, $1B8HX.isDragging).y = true;
            return function() {
                (0, $1B8HX.isDragging).x = (0, $1B8HX.isDragging).y = false;
            };
        }
    }
}

});
parcelRegister("1B8HX", function(module, exports) {

$parcel$export(module.exports, "isDragging", function () { return $905a9d5e0d7b39ea$export$9e9bc3c487fccc00; });
$parcel$export(module.exports, "isDragActive", function () { return $905a9d5e0d7b39ea$export$1b3dd616664938e4; });
var $905a9d5e0d7b39ea$export$9e9bc3c487fccc00 = {
    x: false,
    y: false
};
function $905a9d5e0d7b39ea$export$1b3dd616664938e4() {
    return $905a9d5e0d7b39ea$export$9e9bc3c487fccc00.x || $905a9d5e0d7b39ea$export$9e9bc3c487fccc00.y;
}

});


parcelRegister("j9DZq", function(module, exports) {

$parcel$export(module.exports, "addDomEvent", function () { return $63bd599df9fc420d$export$b1d829ddf82884aa; });
function $63bd599df9fc420d$export$b1d829ddf82884aa(target, eventName, handler) {
    var options = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : {
        passive: true
    };
    target.addEventListener(eventName, handler, options);
    return function() {
        return target.removeEventListener(eventName, handler);
    };
}

});

parcelRegister("7qJEU", function(module, exports) {

$parcel$export(module.exports, "addPointerEvent", function () { return $db69ad6144494a98$export$fcff2e64e6676b81; });

var $j9DZq = parcelRequire("j9DZq");

var $kKOaz = parcelRequire("kKOaz");
function $db69ad6144494a98$export$fcff2e64e6676b81(target, eventName, handler, options) {
    return (0, $j9DZq.addDomEvent)(target, eventName, (0, $kKOaz.addPointerInfo)(handler), options);
}

});
parcelRegister("kKOaz", function(module, exports) {

$parcel$export(module.exports, "extractEventInfo", function () { return $3bcd6d32796288e9$export$12f84bb882d06e1a; });
$parcel$export(module.exports, "addPointerInfo", function () { return $3bcd6d32796288e9$export$c404e80f92c98d29; });

var $5nfcx = parcelRequire("5nfcx");
function $3bcd6d32796288e9$export$12f84bb882d06e1a(event) {
    return {
        point: {
            x: event.pageX,
            y: event.pageY
        }
    };
}
var $3bcd6d32796288e9$export$c404e80f92c98d29 = function(handler) {
    return function(event) {
        return (0, $5nfcx.isPrimaryPointer)(event) && handler(event, $3bcd6d32796288e9$export$12f84bb882d06e1a(event));
    };
};

});
parcelRegister("5nfcx", function(module, exports) {

$parcel$export(module.exports, "isPrimaryPointer", function () { return $68f26569604c2fff$export$a4cf9c8a4b063a6e; });
var $68f26569604c2fff$export$a4cf9c8a4b063a6e = function(event) {
    if (event.pointerType === "mouse") return typeof event.button !== "number" || event.button <= 0;
    else /**
         * isPrimary is true for all mice buttons, whereas every touch point
         * is regarded as its own input. So subsequent concurrent touch points
         * will be false.
         *
         * Specifically match against false here as incomplete versions of
         * PointerEvents in very old browser might have it set as undefined.
         */ return event.isPrimary !== false;
};

});



parcelRegister("kqrPq", function(module, exports) {

$parcel$export(module.exports, "calcLength", function () { return $3fdd03eb18d7c56c$export$c1c127004b72a37; });
$parcel$export(module.exports, "isNear", function () { return $3fdd03eb18d7c56c$export$28d0384c4b79bde2; });
$parcel$export(module.exports, "calcBoxDelta", function () { return $3fdd03eb18d7c56c$export$c0d25e96fc67d310; });
$parcel$export(module.exports, "calcRelativeBox", function () { return $3fdd03eb18d7c56c$export$426154f9d100f99; });
$parcel$export(module.exports, "calcRelativePosition", function () { return $3fdd03eb18d7c56c$export$2785bfcc929c5650; });

var $83rca = parcelRequire("83rca");
var $3fdd03eb18d7c56c$var$SCALE_PRECISION = 0.0001;
var $3fdd03eb18d7c56c$var$SCALE_MIN = 1 - $3fdd03eb18d7c56c$var$SCALE_PRECISION;
var $3fdd03eb18d7c56c$var$SCALE_MAX = 1 + $3fdd03eb18d7c56c$var$SCALE_PRECISION;
var $3fdd03eb18d7c56c$var$TRANSLATE_PRECISION = 0.01;
var $3fdd03eb18d7c56c$var$TRANSLATE_MIN = 0 - $3fdd03eb18d7c56c$var$TRANSLATE_PRECISION;
var $3fdd03eb18d7c56c$var$TRANSLATE_MAX = 0 + $3fdd03eb18d7c56c$var$TRANSLATE_PRECISION;
function $3fdd03eb18d7c56c$export$c1c127004b72a37(axis) {
    return axis.max - axis.min;
}
function $3fdd03eb18d7c56c$export$28d0384c4b79bde2(value, target, maxDistance) {
    return Math.abs(value - target) <= maxDistance;
}
function $3fdd03eb18d7c56c$export$e90fc1ae5e3e48ed(delta, source, target) {
    var origin = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : 0.5;
    delta.origin = origin;
    delta.originPoint = (0, $83rca.mixNumber)(source.min, source.max, delta.origin);
    delta.scale = $3fdd03eb18d7c56c$export$c1c127004b72a37(target) / $3fdd03eb18d7c56c$export$c1c127004b72a37(source);
    delta.translate = (0, $83rca.mixNumber)(target.min, target.max, delta.origin) - delta.originPoint;
    if (delta.scale >= $3fdd03eb18d7c56c$var$SCALE_MIN && delta.scale <= $3fdd03eb18d7c56c$var$SCALE_MAX || isNaN(delta.scale)) delta.scale = 1.0;
    if (delta.translate >= $3fdd03eb18d7c56c$var$TRANSLATE_MIN && delta.translate <= $3fdd03eb18d7c56c$var$TRANSLATE_MAX || isNaN(delta.translate)) delta.translate = 0.0;
}
function $3fdd03eb18d7c56c$export$c0d25e96fc67d310(delta, source, target, origin) {
    $3fdd03eb18d7c56c$export$e90fc1ae5e3e48ed(delta.x, source.x, target.x, origin ? origin.originX : undefined);
    $3fdd03eb18d7c56c$export$e90fc1ae5e3e48ed(delta.y, source.y, target.y, origin ? origin.originY : undefined);
}
function $3fdd03eb18d7c56c$export$cabef5b392704b41(target, relative, parent) {
    target.min = parent.min + relative.min;
    target.max = target.min + $3fdd03eb18d7c56c$export$c1c127004b72a37(relative);
}
function $3fdd03eb18d7c56c$export$426154f9d100f99(target, relative, parent) {
    $3fdd03eb18d7c56c$export$cabef5b392704b41(target.x, relative.x, parent.x);
    $3fdd03eb18d7c56c$export$cabef5b392704b41(target.y, relative.y, parent.y);
}
function $3fdd03eb18d7c56c$export$ecd3d3bef81102c3(target, layout, parent) {
    target.min = layout.min - parent.min;
    target.max = target.min + $3fdd03eb18d7c56c$export$c1c127004b72a37(layout);
}
function $3fdd03eb18d7c56c$export$2785bfcc929c5650(target, layout, parent) {
    $3fdd03eb18d7c56c$export$ecd3d3bef81102c3(target.x, layout.x, parent.x);
    $3fdd03eb18d7c56c$export$ecd3d3bef81102c3(target.y, layout.y, parent.y);
}

});

parcelRegister("8vGlw", function(module, exports) {

$parcel$export(module.exports, "eachAxis", function () { return $61436e0004160986$export$b789de563eb43b1; });
function $61436e0004160986$export$b789de563eb43b1(callback) {
    return [
        callback("x"),
        callback("y")
    ];
}

});

parcelRegister("8ugSN", function(module, exports) {

$parcel$export(module.exports, "getContextWindow", function () { return $c58f370c5e3b42e6$export$d533d84f9871c879; });
// Fixes https://github.com/motiondivision/motion/issues/2270
var $c58f370c5e3b42e6$export$d533d84f9871c879 = function(param) {
    var current = param.current;
    return current ? current.ownerDocument.defaultView : null;
};

});

parcelRegister("lV3fJ", function(module, exports) {

$parcel$export(module.exports, "PanSession", function () { return $9b6dc319aac82545$export$d9c66232c9c4689c; });

var $grujF = parcelRequire("grujF");

var $dhMkv = parcelRequire("dhMkv");

var $joFW3 = parcelRequire("joFW3");

var $90FDw = parcelRequire("90FDw");

var $8oVcc = parcelRequire("8oVcc");
var $5nfcx = parcelRequire("5nfcx");

var $04dOm = parcelRequire("04dOm");
var $1Te65 = parcelRequire("1Te65");

var $7qJEU = parcelRequire("7qJEU");

var $kKOaz = parcelRequire("kKOaz");

var $8dswN = parcelRequire("8dswN");
/**
 * @internal
 */ var $9b6dc319aac82545$export$d9c66232c9c4689c = /*#__PURE__*/ function() {
    "use strict";
    function PanSession(event, handlers) {
        var _this = this;
        var _ref = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {}, transformPagePoint = _ref.transformPagePoint, _ref_contextWindow = _ref.contextWindow, contextWindow = _ref_contextWindow === void 0 ? window : _ref_contextWindow, _ref_dragSnapToOrigin = _ref.dragSnapToOrigin, dragSnapToOrigin = _ref_dragSnapToOrigin === void 0 ? false : _ref_dragSnapToOrigin, _ref_distanceThreshold = _ref.distanceThreshold, distanceThreshold = _ref_distanceThreshold === void 0 ? 3 : _ref_distanceThreshold;
        (0, $grujF._)(this, PanSession);
        /**
         * @internal
         */ this.startEvent = null;
        /**
         * @internal
         */ this.lastMoveEvent = null;
        /**
         * @internal
         */ this.lastMoveEventInfo = null;
        /**
         * @internal
         */ this.handlers = {};
        /**
         * @internal
         */ this.contextWindow = window;
        this.updatePoint = function() {
            if (!(_this.lastMoveEvent && _this.lastMoveEventInfo)) return;
            var info = $9b6dc319aac82545$var$getPanInfo(_this.lastMoveEventInfo, _this.history);
            var isPanStarted = _this.startEvent !== null;
            // Only start panning if the offset is larger than 3 pixels. If we make it
            // any larger than this we'll want to reset the pointer history
            // on the first update to avoid visual snapping to the cursor.
            var isDistancePastThreshold = (0, $8dswN.distance2D)(info.offset, {
                x: 0,
                y: 0
            }) >= _this.distanceThreshold;
            if (!isPanStarted && !isDistancePastThreshold) return;
            var point = info.point;
            var timestamp = (0, $8oVcc.frameData).timestamp;
            _this.history.push((0, $90FDw._)((0, $joFW3._)({}, point), {
                timestamp: timestamp
            }));
            var _this_handlers = _this.handlers, onStart = _this_handlers.onStart, onMove = _this_handlers.onMove;
            if (!isPanStarted) {
                onStart && onStart(_this.lastMoveEvent, info);
                _this.startEvent = _this.lastMoveEvent;
            }
            onMove && onMove(_this.lastMoveEvent, info);
        };
        this.handlePointerMove = function(event, info) {
            _this.lastMoveEvent = event;
            _this.lastMoveEventInfo = $9b6dc319aac82545$var$transformPoint(info, _this.transformPagePoint);
            // Throttle mouse move event to once per frame
            (0, $8oVcc.frame).update(_this.updatePoint, true);
        };
        this.handlePointerUp = function(event, info) {
            _this.end();
            var _this_handlers = _this.handlers, onEnd = _this_handlers.onEnd, onSessionEnd = _this_handlers.onSessionEnd, resumeAnimation = _this_handlers.resumeAnimation;
            if (_this.dragSnapToOrigin) resumeAnimation && resumeAnimation();
            if (!(_this.lastMoveEvent && _this.lastMoveEventInfo)) return;
            var panInfo = $9b6dc319aac82545$var$getPanInfo(event.type === "pointercancel" ? _this.lastMoveEventInfo : $9b6dc319aac82545$var$transformPoint(info, _this.transformPagePoint), _this.history);
            if (_this.startEvent && onEnd) onEnd(event, panInfo);
            onSessionEnd && onSessionEnd(event, panInfo);
        };
        // If we have more than one touch, don't start detecting this gesture
        if (!(0, $5nfcx.isPrimaryPointer)(event)) return;
        this.dragSnapToOrigin = dragSnapToOrigin;
        this.handlers = handlers;
        this.transformPagePoint = transformPagePoint;
        this.distanceThreshold = distanceThreshold;
        this.contextWindow = contextWindow || window;
        var info = (0, $kKOaz.extractEventInfo)(event);
        var initialInfo = $9b6dc319aac82545$var$transformPoint(info, this.transformPagePoint);
        var point = initialInfo.point;
        var timestamp = (0, $8oVcc.frameData).timestamp;
        this.history = [
            (0, $90FDw._)((0, $joFW3._)({}, point), {
                timestamp: timestamp
            })
        ];
        var onSessionStart = handlers.onSessionStart;
        onSessionStart && onSessionStart(event, $9b6dc319aac82545$var$getPanInfo(initialInfo, this.history));
        this.removeListeners = (0, $1Te65.pipe)((0, $7qJEU.addPointerEvent)(this.contextWindow, "pointermove", this.handlePointerMove), (0, $7qJEU.addPointerEvent)(this.contextWindow, "pointerup", this.handlePointerUp), (0, $7qJEU.addPointerEvent)(this.contextWindow, "pointercancel", this.handlePointerUp));
    }
    (0, $dhMkv._)(PanSession, [
        {
            key: "updateHandlers",
            value: function updateHandlers(handlers) {
                this.handlers = handlers;
            }
        },
        {
            key: "end",
            value: function end() {
                this.removeListeners && this.removeListeners();
                (0, $8oVcc.cancelFrame)(this.updatePoint);
            }
        }
    ]);
    return PanSession;
}();
function $9b6dc319aac82545$var$transformPoint(info, transformPagePoint) {
    return transformPagePoint ? {
        point: transformPagePoint(info.point)
    } : info;
}
function $9b6dc319aac82545$var$subtractPoint(a, b) {
    return {
        x: a.x - b.x,
        y: a.y - b.y
    };
}
function $9b6dc319aac82545$var$getPanInfo(param, history) {
    var point = param.point;
    return {
        point: point,
        delta: $9b6dc319aac82545$var$subtractPoint(point, $9b6dc319aac82545$var$lastDevicePoint(history)),
        offset: $9b6dc319aac82545$var$subtractPoint(point, $9b6dc319aac82545$var$startDevicePoint(history)),
        velocity: $9b6dc319aac82545$var$getVelocity(history, 0.1)
    };
}
function $9b6dc319aac82545$var$startDevicePoint(history) {
    return history[0];
}
function $9b6dc319aac82545$var$lastDevicePoint(history) {
    return history[history.length - 1];
}
function $9b6dc319aac82545$var$getVelocity(history, timeDelta) {
    if (history.length < 2) return {
        x: 0,
        y: 0
    };
    var i = history.length - 1;
    var timestampedPoint = null;
    var lastPoint = $9b6dc319aac82545$var$lastDevicePoint(history);
    while(i >= 0){
        timestampedPoint = history[i];
        if (lastPoint.timestamp - timestampedPoint.timestamp > (0, $04dOm.secondsToMilliseconds)(timeDelta)) break;
        i--;
    }
    if (!timestampedPoint) return {
        x: 0,
        y: 0
    };
    var time = (0, $04dOm.millisecondsToSeconds)(lastPoint.timestamp - timestampedPoint.timestamp);
    if (time === 0) return {
        x: 0,
        y: 0
    };
    var currentVelocity = {
        x: (lastPoint.x - timestampedPoint.x) / time,
        y: (lastPoint.y - timestampedPoint.y) / time
    };
    if (currentVelocity.x === Infinity) currentVelocity.x = 0;
    if (currentVelocity.y === Infinity) currentVelocity.y = 0;
    return currentVelocity;
}

});
parcelRegister("8dswN", function(module, exports) {

$parcel$export(module.exports, "distance2D", function () { return $6a348c772548332b$export$503a1d513f12e38b; });
var $6a348c772548332b$export$9f17032d917177de = function(a, b) {
    return Math.abs(a - b);
};
function $6a348c772548332b$export$503a1d513f12e38b(a, b) {
    // Multi-dimensional
    var xDelta = $6a348c772548332b$export$9f17032d917177de(a.x, b.x);
    var yDelta = $6a348c772548332b$export$9f17032d917177de(a.y, b.y);
    return Math.sqrt(Math.pow(xDelta, 2) + Math.pow(yDelta, 2));
}

});


parcelRegister("iO0HF", function(module, exports) {

$parcel$export(module.exports, "applyConstraints", function () { return $85e4cd4bd9da141a$export$b3c764d3fca3ffe3; });
$parcel$export(module.exports, "calcRelativeConstraints", function () { return $85e4cd4bd9da141a$export$4e9195bf7793bc78; });
$parcel$export(module.exports, "calcViewportConstraints", function () { return $85e4cd4bd9da141a$export$4228500f19d4cdf7; });
$parcel$export(module.exports, "calcOrigin", function () { return $85e4cd4bd9da141a$export$13abbfca044ca46d; });
$parcel$export(module.exports, "rebaseAxisConstraints", function () { return $85e4cd4bd9da141a$export$e9672cc4c36a8b87; });
$parcel$export(module.exports, "defaultElastic", function () { return $85e4cd4bd9da141a$export$a3366d3bac43a742; });
$parcel$export(module.exports, "resolveDragElastic", function () { return $85e4cd4bd9da141a$export$7c5eaef8f4723d22; });

var $83rca = parcelRequire("83rca");

var $3BJvs = parcelRequire("3BJvs");
var $4nrxA = parcelRequire("4nrxA");

var $kqrPq = parcelRequire("kqrPq");
/**
 * Apply constraints to a point. These constraints are both physical along an
 * axis, and an elastic factor that determines how much to constrain the point
 * by if it does lie outside the defined parameters.
 */ function $85e4cd4bd9da141a$export$b3c764d3fca3ffe3(point, param, elastic) {
    var min = param.min, max = param.max;
    if (min !== undefined && point < min) // If we have a min point defined, and this is outside of that, constrain
    point = elastic ? (0, $83rca.mixNumber)(min, point, elastic.min) : Math.max(point, min);
    else if (max !== undefined && point > max) // If we have a max point defined, and this is outside of that, constrain
    point = elastic ? (0, $83rca.mixNumber)(max, point, elastic.max) : Math.min(point, max);
    return point;
}
/**
 * Calculate constraints in terms of the viewport when defined relatively to the
 * measured axis. This is measured from the nearest edge, so a max constraint of 200
 * on an axis with a max value of 300 would return a constraint of 500 - axis length
 */ function $85e4cd4bd9da141a$export$690c180aa5775042(axis, min, max) {
    return {
        min: min !== undefined ? axis.min + min : undefined,
        max: max !== undefined ? axis.max + max - (axis.max - axis.min) : undefined
    };
}
/**
 * Calculate constraints in terms of the viewport when
 * defined relatively to the measured bounding box.
 */ function $85e4cd4bd9da141a$export$4e9195bf7793bc78(layoutBox, param) {
    var top = param.top, left = param.left, bottom = param.bottom, right = param.right;
    return {
        x: $85e4cd4bd9da141a$export$690c180aa5775042(layoutBox.x, left, right),
        y: $85e4cd4bd9da141a$export$690c180aa5775042(layoutBox.y, top, bottom)
    };
}
/**
 * Calculate viewport constraints when defined as another viewport-relative axis
 */ function $85e4cd4bd9da141a$export$87abc398c3c7ce27(layoutAxis, constraintsAxis) {
    var min = constraintsAxis.min - layoutAxis.min;
    var max = constraintsAxis.max - layoutAxis.max;
    var ref;
    // If the constraints axis is actually smaller than the layout axis then we can
    // flip the constraints
    if (constraintsAxis.max - constraintsAxis.min < layoutAxis.max - layoutAxis.min) ref = [
        max,
        min
    ], min = ref[0], max = ref[1], ref;
    return {
        min: min,
        max: max
    };
}
/**
 * Calculate viewport constraints when defined as another viewport-relative box
 */ function $85e4cd4bd9da141a$export$4228500f19d4cdf7(layoutBox, constraintsBox) {
    return {
        x: $85e4cd4bd9da141a$export$87abc398c3c7ce27(layoutBox.x, constraintsBox.x),
        y: $85e4cd4bd9da141a$export$87abc398c3c7ce27(layoutBox.y, constraintsBox.y)
    };
}
/**
 * Calculate a transform origin relative to the source axis, between 0-1, that results
 * in an asthetically pleasing scale/transform needed to project from source to target.
 */ function $85e4cd4bd9da141a$export$13abbfca044ca46d(source, target) {
    var origin = 0.5;
    var sourceLength = (0, $kqrPq.calcLength)(source);
    var targetLength = (0, $kqrPq.calcLength)(target);
    if (targetLength > sourceLength) origin = (0, $4nrxA.progress)(target.min, target.max - sourceLength, source.min);
    else if (sourceLength > targetLength) origin = (0, $4nrxA.progress)(source.min, source.max - targetLength, target.min);
    return (0, $3BJvs.clamp)(0, 1, origin);
}
/**
 * Rebase the calculated viewport constraints relative to the layout.min point.
 */ function $85e4cd4bd9da141a$export$e9672cc4c36a8b87(layout, constraints) {
    var relativeConstraints = {};
    if (constraints.min !== undefined) relativeConstraints.min = constraints.min - layout.min;
    if (constraints.max !== undefined) relativeConstraints.max = constraints.max - layout.min;
    return relativeConstraints;
}
var $85e4cd4bd9da141a$export$a3366d3bac43a742 = 0.35;
/**
 * Accepts a dragElastic prop and returns resolved elastic values for each axis.
 */ function $85e4cd4bd9da141a$export$7c5eaef8f4723d22() {
    var dragElastic = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : $85e4cd4bd9da141a$export$a3366d3bac43a742;
    if (dragElastic === false) dragElastic = 0;
    else if (dragElastic === true) dragElastic = $85e4cd4bd9da141a$export$a3366d3bac43a742;
    return {
        x: $85e4cd4bd9da141a$export$589076940abb04b5(dragElastic, "left", "right"),
        y: $85e4cd4bd9da141a$export$589076940abb04b5(dragElastic, "top", "bottom")
    };
}
function $85e4cd4bd9da141a$export$589076940abb04b5(dragElastic, minLabel, maxLabel) {
    return {
        min: $85e4cd4bd9da141a$export$bbbc10b82e6c0afb(dragElastic, minLabel),
        max: $85e4cd4bd9da141a$export$bbbc10b82e6c0afb(dragElastic, maxLabel)
    };
}
function $85e4cd4bd9da141a$export$bbbc10b82e6c0afb(dragElastic, label) {
    return typeof dragElastic === "number" ? dragElastic : dragElastic[label] || 0;
}

});



parcelRegister("be9aY", function(module, exports) {

$parcel$export(module.exports, "PanGesture", function () { return $1556b743982d1d5a$export$b4f8f1ee75ce5859; });

var $f3Okx = parcelRequire("f3Okx");

var $grujF = parcelRequire("grujF");

var $dhMkv = parcelRequire("dhMkv");

var $j6Mzi = parcelRequire("j6Mzi");

var $8oVcc = parcelRequire("8oVcc");

var $eQ5Xp = parcelRequire("eQ5Xp");

var $7qJEU = parcelRequire("7qJEU");

var $hVeVW = parcelRequire("hVeVW");

var $8ugSN = parcelRequire("8ugSN");

var $lV3fJ = parcelRequire("lV3fJ");
var $1556b743982d1d5a$var$asyncHandler = function(handler) {
    return function(event, info) {
        if (handler) (0, $8oVcc.frame).postRender(function() {
            return handler(event, info);
        });
    };
};
var $1556b743982d1d5a$export$b4f8f1ee75ce5859 = /*#__PURE__*/ function(Feature) {
    "use strict";
    (0, $j6Mzi._)(PanGesture, Feature);
    function PanGesture() {
        (0, $grujF._)(this, PanGesture);
        var _this;
        _this = (0, $f3Okx._)(this, PanGesture, arguments);
        _this.removePointerDownListener = (0, $eQ5Xp.noop);
        return _this;
    }
    (0, $dhMkv._)(PanGesture, [
        {
            key: "onPointerDown",
            value: function onPointerDown(pointerDownEvent) {
                this.session = new (0, $lV3fJ.PanSession)(pointerDownEvent, this.createPanHandlers(), {
                    transformPagePoint: this.node.getTransformPagePoint(),
                    contextWindow: (0, $8ugSN.getContextWindow)(this.node)
                });
            }
        },
        {
            key: "createPanHandlers",
            value: function createPanHandlers() {
                var _this = this;
                var _this_node_getProps = this.node.getProps(), onPanSessionStart = _this_node_getProps.onPanSessionStart, onPanStart = _this_node_getProps.onPanStart, onPan = _this_node_getProps.onPan, onPanEnd = _this_node_getProps.onPanEnd;
                return {
                    onSessionStart: $1556b743982d1d5a$var$asyncHandler(onPanSessionStart),
                    onStart: $1556b743982d1d5a$var$asyncHandler(onPanStart),
                    onMove: onPan,
                    onEnd: function(event, info) {
                        delete _this.session;
                        if (onPanEnd) (0, $8oVcc.frame).postRender(function() {
                            return onPanEnd(event, info);
                        });
                    }
                };
            }
        },
        {
            key: "mount",
            value: function mount() {
                var _this = this;
                this.removePointerDownListener = (0, $7qJEU.addPointerEvent)(this.node.current, "pointerdown", function(event) {
                    return _this.onPointerDown(event);
                });
            }
        },
        {
            key: "update",
            value: function update() {
                this.session && this.session.updateHandlers(this.createPanHandlers());
            }
        },
        {
            key: "unmount",
            value: function unmount() {
                this.removePointerDownListener();
                this.session && this.session.end();
            }
        }
    ]);
    return PanGesture;
}((0, $hVeVW.Feature));

});

parcelRegister("kXN1g", function(module, exports) {

$parcel$export(module.exports, "MeasureLayout", function () { return $31d7336c9fb9e92d$export$779f5fb01ad751cd; });

var $f3Okx = parcelRequire("f3Okx");

var $grujF = parcelRequire("grujF");

var $dhMkv = parcelRequire("dhMkv");

var $j6Mzi = parcelRequire("j6Mzi");

var $joFW3 = parcelRequire("joFW3");

var $90FDw = parcelRequire("90FDw");

var $2nwvT = parcelRequire("2nwvT");

var $iD4WH = parcelRequire("iD4WH");

var $8oVcc = parcelRequire("8oVcc");
var $43f3w = parcelRequire("43f3w");

var $dQFEZ = parcelRequire("dQFEZ");

var $kXnKc = parcelRequire("kXnKc");

var $6dUNv = parcelRequire("6dUNv");

var $67KHr = parcelRequire("67KHr");

var $7hofA = parcelRequire("7hofA");
"use client";
/**
 * Track whether we've taken any snapshots yet. If not,
 * we can safely skip notification of didUpdate.
 *
 * Difficult to capture in a test but to prevent flickering
 * we must set this to true either on update or unmount.
 * Running `next-env/layout-id` in Safari will show this behaviour if broken.
 */ var $31d7336c9fb9e92d$var$hasTakenAnySnapshot = false;
var $31d7336c9fb9e92d$var$MeasureLayoutWithContext = /*#__PURE__*/ function(Component) {
    "use strict";
    (0, $j6Mzi._)(MeasureLayoutWithContext, Component);
    function MeasureLayoutWithContext() {
        (0, $grujF._)(this, MeasureLayoutWithContext);
        return (0, $f3Okx._)(this, MeasureLayoutWithContext, arguments);
    }
    (0, $dhMkv._)(MeasureLayoutWithContext, [
        {
            /**
     * This only mounts projection nodes for components that
     * need measuring, we might want to do it for all components
     * in order to incorporate transforms
     */ key: "componentDidMount",
            value: function componentDidMount() {
                var _this = this;
                var _this_props = this.props, visualElement = _this_props.visualElement, layoutGroup = _this_props.layoutGroup, switchLayoutGroup = _this_props.switchLayoutGroup, layoutId = _this_props.layoutId;
                var projection = visualElement.projection;
                if (projection) {
                    if (layoutGroup.group) layoutGroup.group.add(projection);
                    if (switchLayoutGroup && switchLayoutGroup.register && layoutId) switchLayoutGroup.register(projection);
                    if ($31d7336c9fb9e92d$var$hasTakenAnySnapshot) projection.root.didUpdate();
                    projection.addEventListener("animationComplete", function() {
                        _this.safeToRemove();
                    });
                    projection.setOptions((0, $90FDw._)((0, $joFW3._)({}, projection.options), {
                        onExitComplete: function() {
                            return _this.safeToRemove();
                        }
                    }));
                }
                (0, $7hofA.globalProjectionState).hasEverUpdated = true;
            }
        },
        {
            key: "getSnapshotBeforeUpdate",
            value: function getSnapshotBeforeUpdate(prevProps) {
                var _this = this;
                var _this_props = this.props, layoutDependency = _this_props.layoutDependency, visualElement = _this_props.visualElement, drag = _this_props.drag, isPresent = _this_props.isPresent;
                var projection = visualElement.projection;
                if (!projection) return null;
                /**
         * TODO: We use this data in relegate to determine whether to
         * promote a previous element. There's no guarantee its presence data
         * will have updated by this point - if a bug like this arises it will
         * have to be that we markForRelegation and then find a new lead some other way,
         * perhaps in didUpdate
         */ projection.isPresent = isPresent;
                $31d7336c9fb9e92d$var$hasTakenAnySnapshot = true;
                if (drag || prevProps.layoutDependency !== layoutDependency || layoutDependency === undefined || prevProps.isPresent !== isPresent) projection.willUpdate();
                else this.safeToRemove();
                if (prevProps.isPresent !== isPresent) {
                    if (isPresent) projection.promote();
                    else if (!projection.relegate()) /**
                 * If there's another stack member taking over from this one,
                 * it's in charge of the exit animation and therefore should
                 * be in charge of the safe to remove. Otherwise we call it here.
                 */ (0, $8oVcc.frame).postRender(function() {
                        var stack = projection.getStack();
                        if (!stack || !stack.members.length) _this.safeToRemove();
                    });
                }
                return null;
            }
        },
        {
            key: "componentDidUpdate",
            value: function componentDidUpdate() {
                var _this = this;
                var projection = this.props.visualElement.projection;
                if (projection) {
                    projection.root.didUpdate();
                    (0, $43f3w.microtask).postRender(function() {
                        if (!projection.currentAnimation && projection.isLead()) _this.safeToRemove();
                    });
                }
            }
        },
        {
            key: "componentWillUnmount",
            value: function componentWillUnmount() {
                var _this_props = this.props, visualElement = _this_props.visualElement, layoutGroup = _this_props.layoutGroup, promoteContext = _this_props.switchLayoutGroup;
                var projection = visualElement.projection;
                $31d7336c9fb9e92d$var$hasTakenAnySnapshot = true;
                if (projection) {
                    projection.scheduleCheckAfterUnmount();
                    if (layoutGroup && layoutGroup.group) layoutGroup.group.remove(projection);
                    if (promoteContext && promoteContext.deregister) promoteContext.deregister(projection);
                }
            }
        },
        {
            key: "safeToRemove",
            value: function safeToRemove() {
                var safeToRemove = this.props.safeToRemove;
                safeToRemove && safeToRemove();
            }
        },
        {
            key: "render",
            value: function render() {
                return null;
            }
        }
    ]);
    return MeasureLayoutWithContext;
}((0, $dQFEZ.Component));
function $31d7336c9fb9e92d$export$779f5fb01ad751cd(props) {
    var _usePresence = (0, $2nwvT._)((0, $kXnKc.usePresence)(), 2), isPresent = _usePresence[0], safeToRemove = _usePresence[1];
    var layoutGroup = (0, $dQFEZ.useContext)((0, $6dUNv.LayoutGroupContext));
    return (0, $iD4WH.jsx)($31d7336c9fb9e92d$var$MeasureLayoutWithContext, (0, $90FDw._)((0, $joFW3._)({}, props), {
        layoutGroup: layoutGroup,
        switchLayoutGroup: (0, $dQFEZ.useContext)((0, $67KHr.SwitchLayoutGroupContext)),
        isPresent: isPresent,
        safeToRemove: safeToRemove
    }));
}

});
parcelRegister("kXnKc", function(module, exports) {

$parcel$export(module.exports, "usePresence", function () { return $f8101c460941971a$export$2a8c16d82a0a0e26; });

var $dQFEZ = parcelRequire("dQFEZ");

var $6QE4x = parcelRequire("6QE4x");
"use client";
/**
 * When a component is the child of `AnimatePresence`, it can use `usePresence`
 * to access information about whether it's still present in the React tree.
 *
 * ```jsx
 * import { usePresence } from "framer-motion"
 *
 * export const Component = () => {
 *   const [isPresent, safeToRemove] = usePresence()
 *
 *   useEffect(() => {
 *     !isPresent && setTimeout(safeToRemove, 1000)
 *   }, [isPresent])
 *
 *   return <div />
 * }
 * ```
 *
 * If `isPresent` is `false`, it means that a component has been removed the tree, but
 * `AnimatePresence` won't really remove it until `safeToRemove` has been called.
 *
 * @public
 */ function $f8101c460941971a$export$2a8c16d82a0a0e26() {
    var subscribe = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : true;
    var context = (0, $dQFEZ.useContext)((0, $6QE4x.PresenceContext));
    if (context === null) return [
        true,
        null
    ];
    var isPresent = context.isPresent, onExitComplete = context.onExitComplete, register = context.register;
    // It's safe to call the following hooks conditionally (after an early return) because the context will always
    // either be null or non-null for the lifespan of the component.
    var id = (0, $dQFEZ.useId)();
    (0, $dQFEZ.useEffect)(function() {
        if (subscribe) return register(id);
    }, [
        subscribe
    ]);
    var safeToRemove = (0, $dQFEZ.useCallback)(function() {
        return subscribe && onExitComplete && onExitComplete(id);
    }, [
        id,
        onExitComplete,
        subscribe
    ]);
    return !isPresent && onExitComplete ? [
        false,
        safeToRemove
    ] : [
        true
    ];
}
/**
 * Similar to `usePresence`, except `useIsPresent` simply returns whether or not the component is present.
 * There is no `safeToRemove` function.
 *
 * ```jsx
 * import { useIsPresent } from "framer-motion"
 *
 * export const Component = () => {
 *   const isPresent = useIsPresent()
 *
 *   useEffect(() => {
 *     !isPresent && console.log("I've been removed!")
 *   }, [isPresent])
 *
 *   return <div />
 * }
 * ```
 *
 * @public
 */ function $f8101c460941971a$export$8249053f690ea39a() {
    return $f8101c460941971a$export$ee27c052bca048fb((0, $dQFEZ.useContext)((0, $6QE4x.PresenceContext)));
}
function $f8101c460941971a$export$ee27c052bca048fb(context) {
    return context === null ? true : context.isPresent;
}

});

parcelRegister("7hofA", function(module, exports) {

$parcel$export(module.exports, "globalProjectionState", function () { return $13965e5337addde9$export$97db156a3ed1593b; });
/**
 * This should only ever be modified on the client otherwise it'll
 * persist through server requests. If we need instanced states we
 * could lazy-init via root.
 */ var $13965e5337addde9$export$97db156a3ed1593b = {
    /**
     * Global flag as to whether the tree has animated since the last time
     * we resized the window
     */ hasAnimatedSinceResize: true,
    /**
     * We set this to true once, on the first update. Any nodes added to the tree beyond that
     * update will be given a `data-projection-id` attribute.
     */ hasEverUpdated: false
};

});


parcelRegister("hj2UJ", function(module, exports) {

$parcel$export(module.exports, "HTMLProjectionNode", function () { return $6d52979c0e32fd4d$export$b61a9eb3dbde8858; });

var $kqWGD = parcelRequire("kqWGD");

var $6HVnR = parcelRequire("6HVnR");
var $6d52979c0e32fd4d$export$b91509fcf893b648 = {
    current: undefined
};
var $6d52979c0e32fd4d$export$b61a9eb3dbde8858 = (0, $kqWGD.createProjectionNode)({
    measureScroll: function(instance) {
        return {
            x: instance.scrollLeft,
            y: instance.scrollTop
        };
    },
    defaultParent: function() {
        if (!$6d52979c0e32fd4d$export$b91509fcf893b648.current) {
            var documentNode = new (0, $6HVnR.DocumentProjectionNode)({});
            documentNode.mount(window);
            documentNode.setOptions({
                layoutScroll: true
            });
            $6d52979c0e32fd4d$export$b91509fcf893b648.current = documentNode;
        }
        return $6d52979c0e32fd4d$export$b91509fcf893b648.current;
    },
    resetTransform: function(instance, value) {
        instance.style.transform = value !== undefined ? value : "none";
    },
    checkIsScrollRoot: function(instance) {
        return Boolean(window.getComputedStyle(instance).position === "fixed");
    }
});

});
parcelRegister("kqWGD", function(module, exports) {

$parcel$export(module.exports, "createProjectionNode", function () { return $a4fa0da8ce0f2603$export$a84b61f69daa9da0; });

var $grujF = parcelRequire("grujF");

var $dhMkv = parcelRequire("dhMkv");

var $joFW3 = parcelRequire("joFW3");

var $90FDw = parcelRequire("90FDw");

var $2us1u = parcelRequire("2us1u");

var $2gN7O = parcelRequire("2gN7O");
var $8oVcc = parcelRequire("8oVcc");
var $Oeytg = parcelRequire("Oeytg");
var $cHHhA = parcelRequire("cHHhA");
var $5vP3Z = parcelRequire("5vP3Z");
var $43f3w = parcelRequire("43f3w");
var $83rca = parcelRequire("83rca");
var $4SyWW = parcelRequire("4SyWW");
var $2GhiD = parcelRequire("2GhiD");
var $j716H = parcelRequire("j716H");

var $3BJvs = parcelRequire("3BJvs");
var $eQ5Xp = parcelRequire("eQ5Xp");
var $iTDss = parcelRequire("iTDss");

var $l3DiY = parcelRequire("l3DiY");

var $cWeYk = parcelRequire("cWeYk");

var $2ioij = parcelRequire("2ioij");

var $1ggeo = parcelRequire("1ggeo");

var $lbw40 = parcelRequire("lbw40");

var $4ZPkc = parcelRequire("4ZPkc");

var $flTx0 = parcelRequire("flTx0");

var $1gKyY = parcelRequire("1gKyY");

var $kqrPq = parcelRequire("kqrPq");

var $caRLN = parcelRequire("caRLN");

var $60wa2 = parcelRequire("60wa2");

var $cMIhe = parcelRequire("cMIhe");

var $811dd = parcelRequire("811dd");

var $dssUL = parcelRequire("dssUL");

var $l4Vjc = parcelRequire("l4Vjc");

var $8vGlw = parcelRequire("8vGlw");

var $62S2y = parcelRequire("62S2y");

var $7hofA = parcelRequire("7hofA");
var $a4fa0da8ce0f2603$var$metrics = {
    nodes: 0,
    calculatedTargetDeltas: 0,
    calculatedProjections: 0
};
var $a4fa0da8ce0f2603$var$transformAxes = [
    "",
    "X",
    "Y",
    "Z"
];
/**
 * We use 1000 as the animation target as 0-1000 maps better to pixels than 0-1
 * which has a noticeable difference in spring animations
 */ var $a4fa0da8ce0f2603$var$animationTarget = 1000;
var $a4fa0da8ce0f2603$var$id = 0;
function $a4fa0da8ce0f2603$var$resetDistortingTransform(key, visualElement, values, sharedAnimationValues) {
    var latestValues = visualElement.latestValues;
    // Record the distorting transform and then temporarily set it to 0
    if (latestValues[key]) {
        values[key] = latestValues[key];
        visualElement.setStaticValue(key, 0);
        if (sharedAnimationValues) sharedAnimationValues[key] = 0;
    }
}
function $a4fa0da8ce0f2603$var$cancelTreeOptimisedTransformAnimations(projectionNode) {
    projectionNode.hasCheckedOptimisedAppear = true;
    if (projectionNode.root === projectionNode) return;
    var visualElement = projectionNode.options.visualElement;
    if (!visualElement) return;
    var appearId = (0, $cWeYk.getOptimisedAppearId)(visualElement);
    if (window.MotionHasOptimisedAnimation(appearId, "transform")) {
        var _projectionNode_options = projectionNode.options, layout = _projectionNode_options.layout, layoutId = _projectionNode_options.layoutId;
        window.MotionCancelOptimisedAnimation(appearId, "transform", (0, $8oVcc.frame), !(layout || layoutId));
    }
    var parent = projectionNode.parent;
    if (parent && !parent.hasCheckedOptimisedAppear) $a4fa0da8ce0f2603$var$cancelTreeOptimisedTransformAnimations(parent);
}
function $a4fa0da8ce0f2603$export$a84b61f69daa9da0(param) {
    var attachResizeListener = param.attachResizeListener, defaultParent = param.defaultParent, measureScroll = param.measureScroll, checkIsScrollRoot = param.checkIsScrollRoot, resetTransform = param.resetTransform;
    return /*#__PURE__*/ function() {
        "use strict";
        function ProjectionNode() {
            var _this = this;
            var latestValues = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, parent = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : defaultParent === null || defaultParent === void 0 ? void 0 : defaultParent();
            (0, $grujF._)(this, ProjectionNode);
            /**
             * A unique ID generated for every projection node.
             */ this.id = $a4fa0da8ce0f2603$var$id++;
            /**
             * An id that represents a unique session instigated by startUpdate.
             */ this.animationId = 0;
            this.animationCommitId = 0;
            /**
             * A Set containing all this component's children. This is used to iterate
             * through the children.
             *
             * TODO: This could be faster to iterate as a flat array stored on the root node.
             */ this.children = new Set();
            /**
             * Options for the node. We use this to configure what kind of layout animations
             * we should perform (if any).
             */ this.options = {};
            /**
             * We use this to detect when its safe to shut down part of a projection tree.
             * We have to keep projecting children for scale correction and relative projection
             * until all their parents stop performing layout animations.
             */ this.isTreeAnimating = false;
            this.isAnimationBlocked = false;
            /**
             * Flag to true if we think this layout has been changed. We can't always know this,
             * currently we set it to true every time a component renders, or if it has a layoutDependency
             * if that has changed between renders. Additionally, components can be grouped by LayoutGroup
             * and if one node is dirtied, they all are.
             */ this.isLayoutDirty = false;
            /**
             * Flag to true if we think the projection calculations for this node needs
             * recalculating as a result of an updated transform or layout animation.
             */ this.isProjectionDirty = false;
            /**
             * Flag to true if the layout *or* transform has changed. This then gets propagated
             * throughout the projection tree, forcing any element below to recalculate on the next frame.
             */ this.isSharedProjectionDirty = false;
            /**
             * Flag transform dirty. This gets propagated throughout the whole tree but is only
             * respected by shared nodes.
             */ this.isTransformDirty = false;
            /**
             * Block layout updates for instant layout transitions throughout the tree.
             */ this.updateManuallyBlocked = false;
            this.updateBlockedByResize = false;
            /**
             * Set to true between the start of the first `willUpdate` call and the end of the `didUpdate`
             * call.
             */ this.isUpdating = false;
            /**
             * If this is an SVG element we currently disable projection transforms
             */ this.isSVG = false;
            /**
             * Flag to true (during promotion) if a node doing an instant layout transition needs to reset
             * its projection styles.
             */ this.needsReset = false;
            /**
             * Flags whether this node should have its transform reset prior to measuring.
             */ this.shouldResetTransform = false;
            /**
             * Store whether this node has been checked for optimised appear animations. As
             * effects fire bottom-up, and we want to look up the tree for appear animations,
             * this makes sure we only check each path once, stopping at nodes that
             * have already been checked.
             */ this.hasCheckedOptimisedAppear = false;
            /**
             * An object representing the calculated contextual/accumulated/tree scale.
             * This will be used to scale calculcated projection transforms, as these are
             * calculated in screen-space but need to be scaled for elements to layoutly
             * make it to their calculated destinations.
             *
             * TODO: Lazy-init
             */ this.treeScale = {
                x: 1,
                y: 1
            };
            /**
             *
             */ this.eventHandlers = new Map();
            this.hasTreeAnimated = false;
            this.layoutVersion = 0;
            // Note: Currently only running on root node
            this.updateScheduled = false;
            this.scheduleUpdate = function() {
                return _this.update();
            };
            this.projectionUpdateScheduled = false;
            this.checkUpdateFailed = function() {
                if (_this.isUpdating) {
                    _this.isUpdating = false;
                    _this.clearAllSnapshots();
                }
            };
            /**
             * This is a multi-step process as shared nodes might be of different depths. Nodes
             * are sorted by depth order, so we need to resolve the entire tree before moving to
             * the next step.
             */ this.updateProjection = function() {
                _this.projectionUpdateScheduled = false;
                /**
                 * Reset debug counts. Manually resetting rather than creating a new
                 * object each frame.
                 */ if ((0, $2GhiD.statsBuffer).value) $a4fa0da8ce0f2603$var$metrics.nodes = $a4fa0da8ce0f2603$var$metrics.calculatedTargetDeltas = $a4fa0da8ce0f2603$var$metrics.calculatedProjections = 0;
                _this.nodes.forEach($a4fa0da8ce0f2603$export$131f2f0cc5fe9609);
                _this.nodes.forEach($a4fa0da8ce0f2603$var$resolveTargetDelta);
                _this.nodes.forEach($a4fa0da8ce0f2603$var$calcProjection);
                _this.nodes.forEach($a4fa0da8ce0f2603$export$c2664f37bc951031);
                if ((0, $2GhiD.statsBuffer).addProjectionMetrics) (0, $2GhiD.statsBuffer).addProjectionMetrics($a4fa0da8ce0f2603$var$metrics);
            };
            /**
             * Frame calculations
             */ this.resolvedRelativeTargetAt = 0.0;
            this.linkedParentVersion = 0;
            this.hasProjected = false;
            this.isVisible = true;
            this.animationProgress = 0;
            /**
             * Shared layout
             */ // TODO Only running on root node
            this.sharedNodes = new Map();
            this.latestValues = latestValues;
            this.root = parent ? parent.root || parent : this;
            this.path = parent ? (0, $2us1u._)(parent.path).concat([
                parent
            ]) : [];
            this.parent = parent;
            this.depth = parent ? parent.depth + 1 : 0;
            for(var i = 0; i < this.path.length; i++)this.path[i].shouldResetTransform = true;
            if (this.root === this) this.nodes = new (0, $2ioij.FlatTree)();
        }
        (0, $dhMkv._)(ProjectionNode, [
            {
                key: "addEventListener",
                value: function addEventListener(name, handler) {
                    if (!this.eventHandlers.has(name)) this.eventHandlers.set(name, new (0, $iTDss.SubscriptionManager)());
                    return this.eventHandlers.get(name).add(handler);
                }
            },
            {
                key: "notifyListeners",
                value: function notifyListeners(name) {
                    for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++){
                        args[_key - 1] = arguments[_key];
                    }
                    var _subscriptionManager;
                    var subscriptionManager = this.eventHandlers.get(name);
                    subscriptionManager && (_subscriptionManager = subscriptionManager).notify.apply(_subscriptionManager, (0, $2us1u._)(args));
                }
            },
            {
                key: "hasListeners",
                value: function hasListeners(name) {
                    return this.eventHandlers.has(name);
                }
            },
            {
                /**
         * Lifecycles
         */ key: "mount",
                value: function mount(instance) {
                    var _this = this;
                    if (this.instance) return;
                    this.isSVG = (0, $cHHhA.isSVGElement)(instance) && !(0, $5vP3Z.isSVGSVGElement)(instance);
                    this.instance = instance;
                    var _this_options = this.options, layoutId = _this_options.layoutId, layout = _this_options.layout, visualElement = _this_options.visualElement;
                    if (visualElement && !visualElement.current) visualElement.mount(instance);
                    this.root.nodes.add(this);
                    this.parent && this.parent.children.add(this);
                    if (this.root.hasTreeAnimated && (layout || layoutId)) this.isLayoutDirty = true;
                    if (attachResizeListener) {
                        var cancelDelay;
                        var innerWidth = 0;
                        var resizeUnblockUpdate = function() {
                            return _this.root.updateBlockedByResize = false;
                        };
                        // Set initial innerWidth in a frame.read callback to batch the read
                        (0, $8oVcc.frame).read(function() {
                            innerWidth = window.innerWidth;
                        });
                        attachResizeListener(instance, function() {
                            var newInnerWidth = window.innerWidth;
                            if (newInnerWidth === innerWidth) return;
                            innerWidth = newInnerWidth;
                            _this.root.updateBlockedByResize = true;
                            cancelDelay && cancelDelay();
                            cancelDelay = (0, $1ggeo.delay)(resizeUnblockUpdate, 250);
                            if ((0, $7hofA.globalProjectionState).hasAnimatedSinceResize) {
                                (0, $7hofA.globalProjectionState).hasAnimatedSinceResize = false;
                                _this.nodes.forEach($a4fa0da8ce0f2603$var$finishAnimation);
                            }
                        });
                    }
                    if (layoutId) this.root.registerSharedNode(layoutId, this);
                    // Only register the handler if it requires layout animation
                    if (this.options.animate !== false && visualElement && (layoutId || layout)) this.addEventListener("didUpdate", function(param) {
                        var delta = param.delta, hasLayoutChanged = param.hasLayoutChanged, hasRelativeLayoutChanged = param.hasRelativeLayoutChanged, newLayout = param.layout;
                        if (_this.isTreeAnimationBlocked()) {
                            _this.target = undefined;
                            _this.relativeTarget = undefined;
                            return;
                        }
                        // TODO: Check here if an animation exists
                        var layoutTransition = _this.options.transition || visualElement.getDefaultTransition() || $a4fa0da8ce0f2603$var$defaultLayoutTransition;
                        var _visualElement_getProps = visualElement.getProps(), onLayoutAnimationStart = _visualElement_getProps.onLayoutAnimationStart, onLayoutAnimationComplete = _visualElement_getProps.onLayoutAnimationComplete;
                        /**
                     * The target layout of the element might stay the same,
                     * but its position relative to its parent has changed.
                     */ var hasTargetChanged = !_this.targetLayout || !(0, $cMIhe.boxEqualsRounded)(_this.targetLayout, newLayout);
                        /*
                     * Note: Disabled to fix relative animations always triggering new
                     * layout animations. If this causes further issues, we can try
                     * a different approach to detecting relative target changes.
                     */ // || hasRelativeLayoutChanged
                        /**
                     * If the layout hasn't seemed to have changed, it might be that the
                     * element is visually in the same place in the document but its position
                     * relative to its parent has indeed changed. So here we check for that.
                     */ var hasOnlyRelativeTargetChanged = !hasLayoutChanged && hasRelativeLayoutChanged;
                        if (_this.options.layoutRoot || _this.resumeFrom || hasOnlyRelativeTargetChanged || hasLayoutChanged && (hasTargetChanged || !_this.currentAnimation)) {
                            if (_this.resumeFrom) {
                                _this.resumingFrom = _this.resumeFrom;
                                _this.resumingFrom.resumingFrom = undefined;
                            }
                            var animationOptions = (0, $90FDw._)((0, $joFW3._)({}, (0, $Oeytg.getValueTransition)(layoutTransition, "layout")), {
                                onPlay: onLayoutAnimationStart,
                                onComplete: onLayoutAnimationComplete
                            });
                            if (visualElement.shouldReduceMotion || _this.options.layoutRoot) {
                                animationOptions.delay = 0;
                                animationOptions.type = false;
                            }
                            _this.startAnimation(animationOptions);
                            /**
                         * Set animation origin after starting animation to avoid layout jump
                         * caused by stopping previous layout animation
                         */ _this.setAnimationOrigin(delta, hasOnlyRelativeTargetChanged);
                        } else {
                            /**
                         * If the layout hasn't changed and we have an animation that hasn't started yet,
                         * finish it immediately. Otherwise it will be animating from a location
                         * that was probably never commited to screen and look like a jumpy box.
                         */ if (!hasLayoutChanged) $a4fa0da8ce0f2603$var$finishAnimation(_this);
                            if (_this.isLead() && _this.options.onExitComplete) _this.options.onExitComplete();
                        }
                        _this.targetLayout = newLayout;
                    });
                }
            },
            {
                key: "unmount",
                value: function unmount() {
                    this.options.layoutId && this.willUpdate();
                    this.root.nodes.remove(this);
                    var stack = this.getStack();
                    stack && stack.remove(this);
                    this.parent && this.parent.children.delete(this);
                    this.instance = undefined;
                    this.eventHandlers.clear();
                    (0, $8oVcc.cancelFrame)(this.updateProjection);
                }
            },
            {
                // only on the root
                key: "blockUpdate",
                value: function blockUpdate() {
                    this.updateManuallyBlocked = true;
                }
            },
            {
                key: "unblockUpdate",
                value: function unblockUpdate() {
                    this.updateManuallyBlocked = false;
                }
            },
            {
                key: "isUpdateBlocked",
                value: function isUpdateBlocked() {
                    return this.updateManuallyBlocked || this.updateBlockedByResize;
                }
            },
            {
                key: "isTreeAnimationBlocked",
                value: function isTreeAnimationBlocked() {
                    return this.isAnimationBlocked || this.parent && this.parent.isTreeAnimationBlocked() || false;
                }
            },
            {
                // Note: currently only running on root node
                key: "startUpdate",
                value: function startUpdate() {
                    if (this.isUpdateBlocked()) return;
                    this.isUpdating = true;
                    this.nodes && this.nodes.forEach($a4fa0da8ce0f2603$var$resetSkewAndRotation);
                    this.animationId++;
                }
            },
            {
                key: "getTransformTemplate",
                value: function getTransformTemplate() {
                    var visualElement = this.options.visualElement;
                    return visualElement && visualElement.getProps().transformTemplate;
                }
            },
            {
                key: "willUpdate",
                value: function willUpdate() {
                    var shouldNotifyListeners = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : true;
                    this.root.hasTreeAnimated = true;
                    if (this.root.isUpdateBlocked()) {
                        this.options.onExitComplete && this.options.onExitComplete();
                        return;
                    }
                    /**
             * If we're running optimised appear animations then these must be
             * cancelled before measuring the DOM. This is so we can measure
             * the true layout of the element rather than the WAAPI animation
             * which will be unaffected by the resetSkewAndRotate step.
             *
             * Note: This is a DOM write. Worst case scenario is this is sandwiched
             * between other snapshot reads which will cause unnecessary style recalculations.
             * This has to happen here though, as we don't yet know which nodes will need
             * snapshots in startUpdate(), but we only want to cancel optimised animations
             * if a layout animation measurement is actually going to be affected by them.
             */ if (window.MotionCancelOptimisedAnimation && !this.hasCheckedOptimisedAppear) $a4fa0da8ce0f2603$var$cancelTreeOptimisedTransformAnimations(this);
                    !this.root.isUpdating && this.root.startUpdate();
                    if (this.isLayoutDirty) return;
                    this.isLayoutDirty = true;
                    for(var i = 0; i < this.path.length; i++){
                        var node = this.path[i];
                        node.shouldResetTransform = true;
                        node.updateScroll("snapshot");
                        if (node.options.layoutRoot) node.willUpdate(false);
                    }
                    var _this_options = this.options, layoutId = _this_options.layoutId, layout = _this_options.layout;
                    if (layoutId === undefined && !layout) return;
                    var transformTemplate = this.getTransformTemplate();
                    this.prevTransformTemplateValue = transformTemplate ? transformTemplate(this.latestValues, "") : undefined;
                    this.updateSnapshot();
                    shouldNotifyListeners && this.notifyListeners("willUpdate");
                }
            },
            {
                key: "update",
                value: function update() {
                    this.updateScheduled = false;
                    var updateWasBlocked = this.isUpdateBlocked();
                    // When doing an instant transition, we skip the layout update,
                    // but should still clean up the measurements so that the next
                    // snapshot could be taken correctly.
                    if (updateWasBlocked) {
                        this.unblockUpdate();
                        this.clearAllSnapshots();
                        this.nodes.forEach($a4fa0da8ce0f2603$var$clearMeasurements);
                        return;
                    }
                    /**
             * If this is a repeat of didUpdate then ignore the animation.
             */ if (this.animationId <= this.animationCommitId) {
                        this.nodes.forEach($a4fa0da8ce0f2603$var$clearIsLayoutDirty);
                        return;
                    }
                    this.animationCommitId = this.animationId;
                    if (!this.isUpdating) this.nodes.forEach($a4fa0da8ce0f2603$var$clearIsLayoutDirty);
                    else {
                        this.isUpdating = false;
                        /**
                 * Write
                 */ this.nodes.forEach($a4fa0da8ce0f2603$var$resetTransformStyle);
                        /**
                 * Read ==================
                 */ // Update layout measurements of updated children
                        this.nodes.forEach($a4fa0da8ce0f2603$var$updateLayout);
                        /**
                 * Write
                 */ // Notify listeners that the layout is updated
                        this.nodes.forEach($a4fa0da8ce0f2603$var$notifyLayoutUpdate);
                    }
                    this.clearAllSnapshots();
                    /**
             * Manually flush any pending updates. Ideally
             * we could leave this to the following requestAnimationFrame but this seems
             * to leave a flash of incorrectly styled content.
             */ var now = (0, $j716H.time).now();
                    (0, $8oVcc.frameData).delta = (0, $3BJvs.clamp)(0, 1000 / 60, now - (0, $8oVcc.frameData).timestamp);
                    (0, $8oVcc.frameData).timestamp = now;
                    (0, $8oVcc.frameData).isProcessing = true;
                    (0, $8oVcc.frameSteps).update.process((0, $8oVcc.frameData));
                    (0, $8oVcc.frameSteps).preRender.process((0, $8oVcc.frameData));
                    (0, $8oVcc.frameSteps).render.process((0, $8oVcc.frameData));
                    (0, $8oVcc.frameData).isProcessing = false;
                }
            },
            {
                key: "didUpdate",
                value: function didUpdate() {
                    if (!this.updateScheduled) {
                        this.updateScheduled = true;
                        (0, $43f3w.microtask).read(this.scheduleUpdate);
                    }
                }
            },
            {
                key: "clearAllSnapshots",
                value: function clearAllSnapshots() {
                    this.nodes.forEach($a4fa0da8ce0f2603$var$clearSnapshot);
                    this.sharedNodes.forEach($a4fa0da8ce0f2603$var$removeLeadSnapshots);
                }
            },
            {
                key: "scheduleUpdateProjection",
                value: function scheduleUpdateProjection() {
                    if (!this.projectionUpdateScheduled) {
                        this.projectionUpdateScheduled = true;
                        (0, $8oVcc.frame).preRender(this.updateProjection, false, true);
                    }
                }
            },
            {
                key: "scheduleCheckAfterUnmount",
                value: function scheduleCheckAfterUnmount() {
                    var _this = this;
                    /**
             * If the unmounting node is in a layoutGroup and did trigger a willUpdate,
             * we manually call didUpdate to give a chance to the siblings to animate.
             * Otherwise, cleanup all snapshots to prevents future nodes from reusing them.
             */ (0, $8oVcc.frame).postRender(function() {
                        if (_this.isLayoutDirty) _this.root.didUpdate();
                        else _this.root.checkUpdateFailed();
                    });
                }
            },
            {
                /**
         * Update measurements
         */ key: "updateSnapshot",
                value: function updateSnapshot() {
                    if (this.snapshot || !this.instance) return;
                    this.snapshot = this.measure();
                    if (this.snapshot && !(0, $kqrPq.calcLength)(this.snapshot.measuredBox.x) && !(0, $kqrPq.calcLength)(this.snapshot.measuredBox.y)) this.snapshot = undefined;
                }
            },
            {
                key: "updateLayout",
                value: function updateLayout() {
                    if (!this.instance) return;
                    this.updateScroll();
                    if (!(this.options.alwaysMeasureLayout && this.isLead()) && !this.isLayoutDirty) return;
                    /**
             * When a node is mounted, it simply resumes from the prevLead's
             * snapshot instead of taking a new one, but the ancestors scroll
             * might have updated while the prevLead is unmounted. We need to
             * update the scroll again to make sure the layout we measure is
             * up to date.
             */ if (this.resumeFrom && !this.resumeFrom.instance) for(var i = 0; i < this.path.length; i++){
                        var node = this.path[i];
                        node.updateScroll();
                    }
                    var prevLayout = this.layout;
                    this.layout = this.measure(false);
                    this.layoutVersion++;
                    this.layoutCorrected = (0, $60wa2.createBox)();
                    this.isLayoutDirty = false;
                    this.projectionDelta = undefined;
                    this.notifyListeners("measure", this.layout.layoutBox);
                    var visualElement = this.options.visualElement;
                    visualElement && visualElement.notify("LayoutMeasure", this.layout.layoutBox, prevLayout ? prevLayout.layoutBox : undefined);
                }
            },
            {
                key: "updateScroll",
                value: function updateScroll() {
                    var phase = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "measure";
                    var needsMeasurement = Boolean(this.options.layoutScroll && this.instance);
                    if (this.scroll && this.scroll.animationId === this.root.animationId && this.scroll.phase === phase) needsMeasurement = false;
                    if (needsMeasurement && this.instance) {
                        var isRoot = checkIsScrollRoot(this.instance);
                        this.scroll = {
                            animationId: this.root.animationId,
                            phase: phase,
                            isRoot: isRoot,
                            offset: measureScroll(this.instance),
                            wasRoot: this.scroll ? this.scroll.isRoot : isRoot
                        };
                    }
                }
            },
            {
                key: "resetTransform",
                value: function resetTransform1() {
                    if (!resetTransform) return;
                    var isResetRequested = this.isLayoutDirty || this.shouldResetTransform || this.options.alwaysMeasureLayout;
                    var hasProjection = this.projectionDelta && !(0, $cMIhe.isDeltaZero)(this.projectionDelta);
                    var transformTemplate = this.getTransformTemplate();
                    var transformTemplateValue = transformTemplate ? transformTemplate(this.latestValues, "") : undefined;
                    var transformTemplateHasChanged = transformTemplateValue !== this.prevTransformTemplateValue;
                    if (isResetRequested && this.instance && (hasProjection || (0, $62S2y.hasTransform)(this.latestValues) || transformTemplateHasChanged)) {
                        resetTransform(this.instance, transformTemplateValue);
                        this.shouldResetTransform = false;
                        this.scheduleRender();
                    }
                }
            },
            {
                key: "measure",
                value: function measure() {
                    var removeTransform = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : true;
                    var pageBox = this.measurePageBox();
                    var layoutBox = this.removeElementScroll(pageBox);
                    /**
             * Measurements taken during the pre-render stage
             * still have transforms applied so we remove them
             * via calculation.
             */ if (removeTransform) layoutBox = this.removeTransform(layoutBox);
                    $a4fa0da8ce0f2603$var$roundBox(layoutBox);
                    return {
                        animationId: this.root.animationId,
                        measuredBox: pageBox,
                        layoutBox: layoutBox,
                        latestValues: {},
                        source: this.id
                    };
                }
            },
            {
                key: "measurePageBox",
                value: function measurePageBox() {
                    var _this_scroll;
                    var visualElement = this.options.visualElement;
                    if (!visualElement) return (0, $60wa2.createBox)();
                    var box = visualElement.measureViewportBox();
                    var wasInScrollRoot = ((_this_scroll = this.scroll) === null || _this_scroll === void 0 ? void 0 : _this_scroll.wasRoot) || this.path.some($a4fa0da8ce0f2603$var$checkNodeWasScrollRoot);
                    if (!wasInScrollRoot) {
                        // Remove viewport scroll to give page-relative coordinates
                        var scroll = this.root.scroll;
                        if (scroll) {
                            (0, $1gKyY.translateAxis)(box.x, scroll.offset.x);
                            (0, $1gKyY.translateAxis)(box.y, scroll.offset.y);
                        }
                    }
                    return box;
                }
            },
            {
                key: "removeElementScroll",
                value: function removeElementScroll(box) {
                    var _this_scroll;
                    var boxWithoutScroll = (0, $60wa2.createBox)();
                    (0, $flTx0.copyBoxInto)(boxWithoutScroll, box);
                    if ((_this_scroll = this.scroll) === null || _this_scroll === void 0 ? void 0 : _this_scroll.wasRoot) return boxWithoutScroll;
                    /**
             * Performance TODO: Keep a cumulative scroll offset down the tree
             * rather than loop back up the path.
             */ for(var i = 0; i < this.path.length; i++){
                        var node = this.path[i];
                        var scroll = node.scroll, options = node.options;
                        if (node !== this.root && scroll && options.layoutScroll) {
                            /**
                     * If this is a new scroll root, we want to remove all previous scrolls
                     * from the viewport box.
                     */ if (scroll.wasRoot) (0, $flTx0.copyBoxInto)(boxWithoutScroll, box);
                            (0, $1gKyY.translateAxis)(boxWithoutScroll.x, scroll.offset.x);
                            (0, $1gKyY.translateAxis)(boxWithoutScroll.y, scroll.offset.y);
                        }
                    }
                    return boxWithoutScroll;
                }
            },
            {
                key: "applyTransform",
                value: function applyTransform(box) {
                    var transformOnly = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false;
                    var withTransforms = (0, $60wa2.createBox)();
                    (0, $flTx0.copyBoxInto)(withTransforms, box);
                    for(var i = 0; i < this.path.length; i++){
                        var node = this.path[i];
                        if (!transformOnly && node.options.layoutScroll && node.scroll && node !== node.root) (0, $1gKyY.transformBox)(withTransforms, {
                            x: -node.scroll.offset.x,
                            y: -node.scroll.offset.y
                        });
                        if (!(0, $62S2y.hasTransform)(node.latestValues)) continue;
                        (0, $1gKyY.transformBox)(withTransforms, node.latestValues);
                    }
                    if ((0, $62S2y.hasTransform)(this.latestValues)) (0, $1gKyY.transformBox)(withTransforms, this.latestValues);
                    return withTransforms;
                }
            },
            {
                key: "removeTransform",
                value: function removeTransform(box) {
                    var boxWithoutTransform = (0, $60wa2.createBox)();
                    (0, $flTx0.copyBoxInto)(boxWithoutTransform, box);
                    for(var i = 0; i < this.path.length; i++){
                        var node = this.path[i];
                        if (!node.instance) continue;
                        if (!(0, $62S2y.hasTransform)(node.latestValues)) continue;
                        (0, $62S2y.hasScale)(node.latestValues) && node.updateSnapshot();
                        var sourceBox = (0, $60wa2.createBox)();
                        var nodeBox = node.measurePageBox();
                        (0, $flTx0.copyBoxInto)(sourceBox, nodeBox);
                        (0, $caRLN.removeBoxTransforms)(boxWithoutTransform, node.latestValues, node.snapshot ? node.snapshot.layoutBox : undefined, sourceBox);
                    }
                    if ((0, $62S2y.hasTransform)(this.latestValues)) (0, $caRLN.removeBoxTransforms)(boxWithoutTransform, this.latestValues);
                    return boxWithoutTransform;
                }
            },
            {
                key: "setTargetDelta",
                value: function setTargetDelta(delta) {
                    this.targetDelta = delta;
                    this.root.scheduleUpdateProjection();
                    this.isProjectionDirty = true;
                }
            },
            {
                key: "setOptions",
                value: function setOptions(options) {
                    this.options = (0, $90FDw._)((0, $joFW3._)({}, this.options, options), {
                        crossfade: options.crossfade !== undefined ? options.crossfade : true
                    });
                }
            },
            {
                key: "clearMeasurements",
                value: function clearMeasurements() {
                    this.scroll = undefined;
                    this.layout = undefined;
                    this.snapshot = undefined;
                    this.prevTransformTemplateValue = undefined;
                    this.targetDelta = undefined;
                    this.target = undefined;
                    this.isLayoutDirty = false;
                }
            },
            {
                key: "forceRelativeParentToResolveTarget",
                value: function forceRelativeParentToResolveTarget() {
                    if (!this.relativeParent) return;
                    /**
             * If the parent target isn't up-to-date, force it to update.
             * This is an unfortunate de-optimisation as it means any updating relative
             * projection will cause all the relative parents to recalculate back
             * up the tree.
             */ if (this.relativeParent.resolvedRelativeTargetAt !== (0, $8oVcc.frameData).timestamp) this.relativeParent.resolveTargetDelta(true);
                }
            },
            {
                key: "resolveTargetDelta",
                value: function resolveTargetDelta() {
                    var forceRecalculation = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : false;
                    var _this_parent;
                    /**
             * Once the dirty status of nodes has been spread through the tree, we also
             * need to check if we have a shared node of a different depth that has itself
             * been dirtied.
             */ var lead = this.getLead();
                    this.isProjectionDirty || (this.isProjectionDirty = lead.isProjectionDirty);
                    this.isTransformDirty || (this.isTransformDirty = lead.isTransformDirty);
                    this.isSharedProjectionDirty || (this.isSharedProjectionDirty = lead.isSharedProjectionDirty);
                    var isShared = Boolean(this.resumingFrom) || this !== lead;
                    /**
             * We don't use transform for this step of processing so we don't
             * need to check whether any nodes have changed transform.
             */ var canSkip = !(forceRecalculation || isShared && this.isSharedProjectionDirty || this.isProjectionDirty || ((_this_parent = this.parent) === null || _this_parent === void 0 ? void 0 : _this_parent.isProjectionDirty) || this.attemptToResolveRelativeTarget || this.root.updateBlockedByResize);
                    if (canSkip) return;
                    var _this_options = this.options, layout = _this_options.layout, layoutId = _this_options.layoutId;
                    /**
             * If we have no layout, we can't perform projection, so early return
             */ if (!this.layout || !(layout || layoutId)) return;
                    this.resolvedRelativeTargetAt = (0, $8oVcc.frameData).timestamp;
                    var relativeParent = this.getClosestProjectingParent();
                    if (relativeParent && this.linkedParentVersion !== relativeParent.layoutVersion && !relativeParent.options.layoutRoot) this.removeRelativeTarget();
                    /**
             * If we don't have a targetDelta but do have a layout, we can attempt to resolve
             * a relativeParent. This will allow a component to perform scale correction
             * even if no animation has started.
             */ if (!this.targetDelta && !this.relativeTarget) {
                        if (relativeParent && relativeParent.layout) this.createRelativeTarget(relativeParent, this.layout.layoutBox, relativeParent.layout.layoutBox);
                        else this.removeRelativeTarget();
                    }
                    /**
             * If we have no relative target or no target delta our target isn't valid
             * for this frame.
             */ if (!this.relativeTarget && !this.targetDelta) return;
                    /**
             * Lazy-init target data structure
             */ if (!this.target) {
                        this.target = (0, $60wa2.createBox)();
                        this.targetWithTransforms = (0, $60wa2.createBox)();
                    }
                    /**
             * If we've got a relative box for this component, resolve it into a target relative to the parent.
             */ if (this.relativeTarget && this.relativeTargetOrigin && this.relativeParent && this.relativeParent.target) {
                        this.forceRelativeParentToResolveTarget();
                        (0, $kqrPq.calcRelativeBox)(this.target, this.relativeTarget, this.relativeParent.target);
                    /**
                 * If we've only got a targetDelta, resolve it into a target
                 */ } else if (this.targetDelta) {
                        if (Boolean(this.resumingFrom)) // TODO: This is creating a new object every frame
                        this.target = this.applyTransform(this.layout.layoutBox);
                        else (0, $flTx0.copyBoxInto)(this.target, this.layout.layoutBox);
                        (0, $1gKyY.applyBoxDelta)(this.target, this.targetDelta);
                    } else /**
                 * If no target, use own layout as target
                 */ (0, $flTx0.copyBoxInto)(this.target, this.layout.layoutBox);
                    /**
             * If we've been told to attempt to resolve a relative target, do so.
             */ if (this.attemptToResolveRelativeTarget) {
                        this.attemptToResolveRelativeTarget = false;
                        if (relativeParent && Boolean(relativeParent.resumingFrom) === Boolean(this.resumingFrom) && !relativeParent.options.layoutScroll && relativeParent.target && this.animationProgress !== 1) this.createRelativeTarget(relativeParent, this.target, relativeParent.target);
                        else this.relativeParent = this.relativeTarget = undefined;
                    }
                    /**
             * Increase debug counter for resolved target deltas
             */ if ((0, $2GhiD.statsBuffer).value) $a4fa0da8ce0f2603$var$metrics.calculatedTargetDeltas++;
                }
            },
            {
                key: "getClosestProjectingParent",
                value: function getClosestProjectingParent() {
                    if (!this.parent || (0, $62S2y.hasScale)(this.parent.latestValues) || (0, $62S2y.has2DTranslate)(this.parent.latestValues)) return undefined;
                    if (this.parent.isProjecting()) return this.parent;
                    else return this.parent.getClosestProjectingParent();
                }
            },
            {
                key: "isProjecting",
                value: function isProjecting() {
                    return Boolean((this.relativeTarget || this.targetDelta || this.options.layoutRoot) && this.layout);
                }
            },
            {
                key: "createRelativeTarget",
                value: function createRelativeTarget(relativeParent, layout, parentLayout) {
                    this.relativeParent = relativeParent;
                    this.linkedParentVersion = relativeParent.layoutVersion;
                    this.forceRelativeParentToResolveTarget();
                    this.relativeTarget = (0, $60wa2.createBox)();
                    this.relativeTargetOrigin = (0, $60wa2.createBox)();
                    (0, $kqrPq.calcRelativePosition)(this.relativeTargetOrigin, layout, parentLayout);
                    (0, $flTx0.copyBoxInto)(this.relativeTarget, this.relativeTargetOrigin);
                }
            },
            {
                key: "removeRelativeTarget",
                value: function removeRelativeTarget() {
                    this.relativeParent = this.relativeTarget = undefined;
                }
            },
            {
                key: "calcProjection",
                value: function calcProjection() {
                    var _this_parent;
                    var lead = this.getLead();
                    var isShared = Boolean(this.resumingFrom) || this !== lead;
                    var canSkip = true;
                    /**
             * If this is a normal layout animation and neither this node nor its nearest projecting
             * is dirty then we can't skip.
             */ if (this.isProjectionDirty || ((_this_parent = this.parent) === null || _this_parent === void 0 ? void 0 : _this_parent.isProjectionDirty)) canSkip = false;
                    /**
             * If this is a shared layout animation and this node's shared projection is dirty then
             * we can't skip.
             */ if (isShared && (this.isSharedProjectionDirty || this.isTransformDirty)) canSkip = false;
                    /**
             * If we have resolved the target this frame we must recalculate the
             * projection to ensure it visually represents the internal calculations.
             */ if (this.resolvedRelativeTargetAt === (0, $8oVcc.frameData).timestamp) canSkip = false;
                    if (canSkip) return;
                    var _this_options = this.options, layout = _this_options.layout, layoutId = _this_options.layoutId;
                    /**
             * If this section of the tree isn't animating we can
             * delete our target sources for the following frame.
             */ this.isTreeAnimating = Boolean(this.parent && this.parent.isTreeAnimating || this.currentAnimation || this.pendingAnimation);
                    if (!this.isTreeAnimating) this.targetDelta = this.relativeTarget = undefined;
                    if (!this.layout || !(layout || layoutId)) return;
                    /**
             * Reset the corrected box with the latest values from box, as we're then going
             * to perform mutative operations on it.
             */ (0, $flTx0.copyBoxInto)(this.layoutCorrected, this.layout.layoutBox);
                    /**
             * Record previous tree scales before updating.
             */ var prevTreeScaleX = this.treeScale.x;
                    var prevTreeScaleY = this.treeScale.y;
                    /**
             * Apply all the parent deltas to this box to produce the corrected box. This
             * is the layout box, as it will appear on screen as a result of the transforms of its parents.
             */ (0, $1gKyY.applyTreeDeltas)(this.layoutCorrected, this.treeScale, this.path, isShared);
                    /**
             * If this layer needs to perform scale correction but doesn't have a target,
             * use the layout as the target.
             */ if (lead.layout && !lead.target && (this.treeScale.x !== 1 || this.treeScale.y !== 1)) {
                        lead.target = lead.layout.layoutBox;
                        lead.targetWithTransforms = (0, $60wa2.createBox)();
                    }
                    var target = lead.target;
                    if (!target) {
                        /**
                 * If we don't have a target to project into, but we were previously
                 * projecting, we want to remove the stored transform and schedule
                 * a render to ensure the elements reflect the removed transform.
                 */ if (this.prevProjectionDelta) {
                            this.createProjectionDeltas();
                            this.scheduleRender();
                        }
                        return;
                    }
                    if (!this.projectionDelta || !this.prevProjectionDelta) this.createProjectionDeltas();
                    else {
                        (0, $flTx0.copyAxisDeltaInto)(this.prevProjectionDelta.x, this.projectionDelta.x);
                        (0, $flTx0.copyAxisDeltaInto)(this.prevProjectionDelta.y, this.projectionDelta.y);
                    }
                    /**
             * Update the delta between the corrected box and the target box before user-set transforms were applied.
             * This will allow us to calculate the corrected borderRadius and boxShadow to compensate
             * for our layout reprojection, but still allow them to be scaled correctly by the user.
             * It might be that to simplify this we may want to accept that user-set scale is also corrected
             * and we wouldn't have to keep and calc both deltas, OR we could support a user setting
             * to allow people to choose whether these styles are corrected based on just the
             * layout reprojection or the final bounding box.
             */ (0, $kqrPq.calcBoxDelta)(this.projectionDelta, this.layoutCorrected, target, this.latestValues);
                    if (this.treeScale.x !== prevTreeScaleX || this.treeScale.y !== prevTreeScaleY || !(0, $cMIhe.axisDeltaEquals)(this.projectionDelta.x, this.prevProjectionDelta.x) || !(0, $cMIhe.axisDeltaEquals)(this.projectionDelta.y, this.prevProjectionDelta.y)) {
                        this.hasProjected = true;
                        this.scheduleRender();
                        this.notifyListeners("projectionUpdate", target);
                    }
                    /**
             * Increase debug counter for recalculated projections
             */ if ((0, $2GhiD.statsBuffer).value) $a4fa0da8ce0f2603$var$metrics.calculatedProjections++;
                }
            },
            {
                key: "hide",
                value: function hide() {
                    this.isVisible = false;
                // TODO: Schedule render
                }
            },
            {
                key: "show",
                value: function show() {
                    this.isVisible = true;
                // TODO: Schedule render
                }
            },
            {
                key: "scheduleRender",
                value: function scheduleRender() {
                    var notifyAll = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : true;
                    var _this_options_visualElement;
                    (_this_options_visualElement = this.options.visualElement) === null || _this_options_visualElement === void 0 ? void 0 : _this_options_visualElement.scheduleRender();
                    if (notifyAll) {
                        var stack = this.getStack();
                        stack && stack.scheduleRender();
                    }
                    if (this.resumingFrom && !this.resumingFrom.instance) this.resumingFrom = undefined;
                }
            },
            {
                key: "createProjectionDeltas",
                value: function createProjectionDeltas() {
                    this.prevProjectionDelta = (0, $60wa2.createDelta)();
                    this.projectionDelta = (0, $60wa2.createDelta)();
                    this.projectionDeltaWithTransform = (0, $60wa2.createDelta)();
                }
            },
            {
                key: "setAnimationOrigin",
                value: function setAnimationOrigin(delta) {
                    var _this = this;
                    var hasOnlyRelativeTargetChanged = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false;
                    var snapshot = this.snapshot;
                    var snapshotLatestValues = snapshot ? snapshot.latestValues : {};
                    var mixedValues = (0, $joFW3._)({}, this.latestValues);
                    var targetDelta = (0, $60wa2.createDelta)();
                    if (!this.relativeParent || !this.relativeParent.options.layoutRoot) this.relativeTarget = this.relativeTargetOrigin = undefined;
                    this.attemptToResolveRelativeTarget = !hasOnlyRelativeTargetChanged;
                    var relativeLayout = (0, $60wa2.createBox)();
                    var snapshotSource = snapshot ? snapshot.source : undefined;
                    var layoutSource = this.layout ? this.layout.source : undefined;
                    var isSharedLayoutAnimation = snapshotSource !== layoutSource;
                    var stack = this.getStack();
                    var isOnlyMember = !stack || stack.members.length <= 1;
                    var shouldCrossfadeOpacity = Boolean(isSharedLayoutAnimation && !isOnlyMember && this.options.crossfade === true && !this.path.some($a4fa0da8ce0f2603$var$hasOpacityCrossfade));
                    this.animationProgress = 0;
                    var prevRelativeTarget;
                    this.mixTargetDelta = function(latest) {
                        var progress = latest / 1000;
                        $a4fa0da8ce0f2603$export$91dbf443e1bf1de1(targetDelta.x, delta.x, progress);
                        $a4fa0da8ce0f2603$export$91dbf443e1bf1de1(targetDelta.y, delta.y, progress);
                        _this.setTargetDelta(targetDelta);
                        if (_this.relativeTarget && _this.relativeTargetOrigin && _this.layout && _this.relativeParent && _this.relativeParent.layout) {
                            (0, $kqrPq.calcRelativePosition)(relativeLayout, _this.layout.layoutBox, _this.relativeParent.layout.layoutBox);
                            $a4fa0da8ce0f2603$export$6ffd3e6ae339a132(_this.relativeTarget, _this.relativeTargetOrigin, relativeLayout, progress);
                            /**
                     * If this is an unchanged relative target we can consider the
                     * projection not dirty.
                     */ if (prevRelativeTarget && (0, $cMIhe.boxEquals)(_this.relativeTarget, prevRelativeTarget)) _this.isProjectionDirty = false;
                            if (!prevRelativeTarget) prevRelativeTarget = (0, $60wa2.createBox)();
                            (0, $flTx0.copyBoxInto)(prevRelativeTarget, _this.relativeTarget);
                        }
                        if (isSharedLayoutAnimation) {
                            _this.animationValues = mixedValues;
                            (0, $4ZPkc.mixValues)(mixedValues, snapshotLatestValues, _this.latestValues, progress, shouldCrossfadeOpacity, isOnlyMember);
                        }
                        _this.root.scheduleUpdateProjection();
                        _this.scheduleRender();
                        _this.animationProgress = progress;
                    };
                    this.mixTargetDelta(this.options.layoutRoot ? 1000 : 0);
                }
            },
            {
                key: "startAnimation",
                value: function startAnimation(options) {
                    var _this = this;
                    var _this_currentAnimation, _this_resumingFrom_currentAnimation, _this_resumingFrom;
                    this.notifyListeners("animationStart");
                    (_this_currentAnimation = this.currentAnimation) === null || _this_currentAnimation === void 0 ? void 0 : _this_currentAnimation.stop();
                    (_this_resumingFrom = this.resumingFrom) === null || _this_resumingFrom === void 0 ? void 0 : (_this_resumingFrom_currentAnimation = _this_resumingFrom.currentAnimation) === null || _this_resumingFrom_currentAnimation === void 0 ? void 0 : _this_resumingFrom_currentAnimation.stop();
                    if (this.pendingAnimation) {
                        (0, $8oVcc.cancelFrame)(this.pendingAnimation);
                        this.pendingAnimation = undefined;
                    }
                    /**
             * Start the animation in the next frame to have a frame with progress 0,
             * where the target is the same as when the animation started, so we can
             * calculate the relative positions correctly for instant transitions.
             */ this.pendingAnimation = (0, $8oVcc.frame).update(function() {
                        (0, $7hofA.globalProjectionState).hasAnimatedSinceResize = true;
                        (0, $2gN7O.activeAnimations).layout++;
                        _this.motionValue || (_this.motionValue = (0, $4SyWW.motionValue)(0));
                        _this.currentAnimation = (0, $l3DiY.animateSingleValue)(_this.motionValue, [
                            0,
                            1000
                        ], (0, $90FDw._)((0, $joFW3._)({}, options), {
                            velocity: 0,
                            isSync: true,
                            onUpdate: function(latest) {
                                _this.mixTargetDelta(latest);
                                options.onUpdate && options.onUpdate(latest);
                            },
                            onStop: function() {
                                (0, $2gN7O.activeAnimations).layout--;
                            },
                            onComplete: function() {
                                (0, $2gN7O.activeAnimations).layout--;
                                options.onComplete && options.onComplete();
                                _this.completeAnimation();
                            }
                        }));
                        if (_this.resumingFrom) _this.resumingFrom.currentAnimation = _this.currentAnimation;
                        _this.pendingAnimation = undefined;
                    });
                }
            },
            {
                key: "completeAnimation",
                value: function completeAnimation() {
                    if (this.resumingFrom) {
                        this.resumingFrom.currentAnimation = undefined;
                        this.resumingFrom.preserveOpacity = undefined;
                    }
                    var stack = this.getStack();
                    stack && stack.exitAnimationComplete();
                    this.resumingFrom = this.currentAnimation = this.animationValues = undefined;
                    this.notifyListeners("animationComplete");
                }
            },
            {
                key: "finishAnimation",
                value: function finishAnimation() {
                    if (this.currentAnimation) {
                        this.mixTargetDelta && this.mixTargetDelta($a4fa0da8ce0f2603$var$animationTarget);
                        this.currentAnimation.stop();
                    }
                    this.completeAnimation();
                }
            },
            {
                key: "applyTransformsToTarget",
                value: function applyTransformsToTarget() {
                    var lead = this.getLead();
                    var targetWithTransforms = lead.targetWithTransforms, target = lead.target, layout = lead.layout, latestValues = lead.latestValues;
                    if (!targetWithTransforms || !target || !layout) return;
                    /**
             * If we're only animating position, and this element isn't the lead element,
             * then instead of projecting into the lead box we instead want to calculate
             * a new target that aligns the two boxes but maintains the layout shape.
             */ if (this !== lead && this.layout && layout && $a4fa0da8ce0f2603$var$shouldAnimatePositionOnly(this.options.animationType, this.layout.layoutBox, layout.layoutBox)) {
                        target = this.target || (0, $60wa2.createBox)();
                        var xLength = (0, $kqrPq.calcLength)(this.layout.layoutBox.x);
                        target.x.min = lead.target.x.min;
                        target.x.max = target.x.min + xLength;
                        var yLength = (0, $kqrPq.calcLength)(this.layout.layoutBox.y);
                        target.y.min = lead.target.y.min;
                        target.y.max = target.y.min + yLength;
                    }
                    (0, $flTx0.copyBoxInto)(targetWithTransforms, target);
                    /**
             * Apply the latest user-set transforms to the targetBox to produce the targetBoxFinal.
             * This is the final box that we will then project into by calculating a transform delta and
             * applying it to the corrected box.
             */ (0, $1gKyY.transformBox)(targetWithTransforms, latestValues);
                    /**
             * Update the delta between the corrected box and the final target box, after
             * user-set transforms are applied to it. This will be used by the renderer to
             * create a transform style that will reproject the element from its layout layout
             * into the desired bounding box.
             */ (0, $kqrPq.calcBoxDelta)(this.projectionDeltaWithTransform, this.layoutCorrected, targetWithTransforms, latestValues);
                }
            },
            {
                key: "registerSharedNode",
                value: function registerSharedNode(layoutId, node) {
                    if (!this.sharedNodes.has(layoutId)) this.sharedNodes.set(layoutId, new (0, $811dd.NodeStack)());
                    var stack = this.sharedNodes.get(layoutId);
                    stack.add(node);
                    var config = node.options.initialPromotionConfig;
                    node.promote({
                        transition: config ? config.transition : undefined,
                        preserveFollowOpacity: config && config.shouldPreserveFollowOpacity ? config.shouldPreserveFollowOpacity(node) : undefined
                    });
                }
            },
            {
                key: "isLead",
                value: function isLead() {
                    var stack = this.getStack();
                    return stack ? stack.lead === this : true;
                }
            },
            {
                key: "getLead",
                value: function getLead() {
                    var _this_getStack;
                    var layoutId = this.options.layoutId;
                    return layoutId ? ((_this_getStack = this.getStack()) === null || _this_getStack === void 0 ? void 0 : _this_getStack.lead) || this : this;
                }
            },
            {
                key: "getPrevLead",
                value: function getPrevLead() {
                    var _this_getStack;
                    var layoutId = this.options.layoutId;
                    return layoutId ? (_this_getStack = this.getStack()) === null || _this_getStack === void 0 ? void 0 : _this_getStack.prevLead : undefined;
                }
            },
            {
                key: "getStack",
                value: function getStack() {
                    var layoutId = this.options.layoutId;
                    if (layoutId) return this.root.sharedNodes.get(layoutId);
                }
            },
            {
                key: "promote",
                value: function promote() {
                    var _ref = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, needsReset = _ref.needsReset, transition = _ref.transition, preserveFollowOpacity = _ref.preserveFollowOpacity;
                    var stack = this.getStack();
                    if (stack) stack.promote(this, preserveFollowOpacity);
                    if (needsReset) {
                        this.projectionDelta = undefined;
                        this.needsReset = true;
                    }
                    if (transition) this.setOptions({
                        transition: transition
                    });
                }
            },
            {
                key: "relegate",
                value: function relegate() {
                    var stack = this.getStack();
                    if (stack) return stack.relegate(this);
                    else return false;
                }
            },
            {
                key: "resetSkewAndRotation",
                value: function resetSkewAndRotation() {
                    var visualElement = this.options.visualElement;
                    if (!visualElement) return;
                    // If there's no detected skew or rotation values, we can early return without a forced render.
                    var hasDistortingTransform = false;
                    /**
             * An unrolled check for rotation values. Most elements don't have any rotation and
             * skipping the nested loop and new object creation is 50% faster.
             */ var latestValues = visualElement.latestValues;
                    if (latestValues.z || latestValues.rotate || latestValues.rotateX || latestValues.rotateY || latestValues.rotateZ || latestValues.skewX || latestValues.skewY) hasDistortingTransform = true;
                    // If there's no distorting values, we don't need to do any more.
                    if (!hasDistortingTransform) return;
                    var resetValues = {};
                    if (latestValues.z) $a4fa0da8ce0f2603$var$resetDistortingTransform("z", visualElement, resetValues, this.animationValues);
                    // Check the skew and rotate value of all axes and reset to 0
                    for(var i = 0; i < $a4fa0da8ce0f2603$var$transformAxes.length; i++){
                        $a4fa0da8ce0f2603$var$resetDistortingTransform("rotate".concat($a4fa0da8ce0f2603$var$transformAxes[i]), visualElement, resetValues, this.animationValues);
                        $a4fa0da8ce0f2603$var$resetDistortingTransform("skew".concat($a4fa0da8ce0f2603$var$transformAxes[i]), visualElement, resetValues, this.animationValues);
                    }
                    // Force a render of this element to apply the transform with all skews and rotations
                    // set to 0.
                    visualElement.render();
                    // Put back all the values we reset
                    for(var key in resetValues){
                        visualElement.setStaticValue(key, resetValues[key]);
                        if (this.animationValues) this.animationValues[key] = resetValues[key];
                    }
                    // Schedule a render for the next frame. This ensures we won't visually
                    // see the element with the reset rotate value applied.
                    visualElement.scheduleRender();
                }
            },
            {
                key: "applyProjectionStyles",
                value: function applyProjectionStyles(targetStyle, styleProp) {
                    if (!this.instance || this.isSVG) return;
                    if (!this.isVisible) {
                        targetStyle.visibility = "hidden";
                        return;
                    }
                    var transformTemplate = this.getTransformTemplate();
                    if (this.needsReset) {
                        this.needsReset = false;
                        targetStyle.visibility = "";
                        targetStyle.opacity = "";
                        targetStyle.pointerEvents = (0, $lbw40.resolveMotionValue)(styleProp === null || styleProp === void 0 ? void 0 : styleProp.pointerEvents) || "";
                        targetStyle.transform = transformTemplate ? transformTemplate(this.latestValues, "") : "none";
                        return;
                    }
                    var lead = this.getLead();
                    if (!this.projectionDelta || !this.layout || !lead.target) {
                        if (this.options.layoutId) {
                            targetStyle.opacity = this.latestValues.opacity !== undefined ? this.latestValues.opacity : 1;
                            targetStyle.pointerEvents = (0, $lbw40.resolveMotionValue)(styleProp === null || styleProp === void 0 ? void 0 : styleProp.pointerEvents) || "";
                        }
                        if (this.hasProjected && !(0, $62S2y.hasTransform)(this.latestValues)) {
                            targetStyle.transform = transformTemplate ? transformTemplate({}, "") : "none";
                            this.hasProjected = false;
                        }
                        return;
                    }
                    targetStyle.visibility = "";
                    var valuesToRender = lead.animationValues || lead.latestValues;
                    this.applyTransformsToTarget();
                    var transform = (0, $l4Vjc.buildProjectionTransform)(this.projectionDeltaWithTransform, this.treeScale, valuesToRender);
                    if (transformTemplate) transform = transformTemplate(valuesToRender, transform);
                    targetStyle.transform = transform;
                    var _this_projectionDelta = this.projectionDelta, x = _this_projectionDelta.x, y = _this_projectionDelta.y;
                    targetStyle.transformOrigin = "".concat(x.origin * 100, "% ").concat(y.origin * 100, "% 0");
                    var _valuesToRender_opacity, _ref;
                    if (lead.animationValues) /**
                 * If the lead component is animating, assign this either the entering/leaving
                 * opacity
                 */ targetStyle.opacity = lead === this ? (_ref = (_valuesToRender_opacity = valuesToRender.opacity) !== null && _valuesToRender_opacity !== void 0 ? _valuesToRender_opacity : this.latestValues.opacity) !== null && _ref !== void 0 ? _ref : 1 : this.preserveOpacity ? this.latestValues.opacity : valuesToRender.opacityExit;
                    else /**
                 * Or we're not animating at all, set the lead component to its layout
                 * opacity and other components to hidden.
                 */ targetStyle.opacity = lead === this ? valuesToRender.opacity !== undefined ? valuesToRender.opacity : "" : valuesToRender.opacityExit !== undefined ? valuesToRender.opacityExit : 0;
                    /**
             * Apply scale correction
             */ for(var key in 0, $dssUL.scaleCorrectors){
                        if (valuesToRender[key] === undefined) continue;
                        var _scaleCorrectors_key = (0, $dssUL.scaleCorrectors)[key], correct = _scaleCorrectors_key.correct, applyTo = _scaleCorrectors_key.applyTo, isCSSVariable = _scaleCorrectors_key.isCSSVariable;
                        /**
                 * Only apply scale correction to the value if we have an
                 * active projection transform. Otherwise these values become
                 * vulnerable to distortion if the element changes size without
                 * a corresponding layout animation.
                 */ var corrected = transform === "none" ? valuesToRender[key] : correct(valuesToRender[key], lead);
                        if (applyTo) {
                            var num = applyTo.length;
                            for(var i = 0; i < num; i++)targetStyle[applyTo[i]] = corrected;
                        } else // If this is a CSS variable, set it directly on the instance.
                        // Replacing this function from creating styles to setting them
                        // would be a good place to remove per frame object creation
                        if (isCSSVariable) this.options.visualElement.renderState.vars[key] = corrected;
                        else targetStyle[key] = corrected;
                    }
                    /**
             * Disable pointer events on follow components. This is to ensure
             * that if a follow component covers a lead component it doesn't block
             * pointer events on the lead.
             */ if (this.options.layoutId) targetStyle.pointerEvents = lead === this ? (0, $lbw40.resolveMotionValue)(styleProp === null || styleProp === void 0 ? void 0 : styleProp.pointerEvents) || "" : "none";
                }
            },
            {
                key: "clearSnapshot",
                value: function clearSnapshot() {
                    this.resumeFrom = this.snapshot = undefined;
                }
            },
            {
                // Only run on root
                key: "resetTree",
                value: function resetTree() {
                    this.root.nodes.forEach(function(node) {
                        var _node_currentAnimation;
                        return (_node_currentAnimation = node.currentAnimation) === null || _node_currentAnimation === void 0 ? void 0 : _node_currentAnimation.stop();
                    });
                    this.root.nodes.forEach($a4fa0da8ce0f2603$var$clearMeasurements);
                    this.root.sharedNodes.clear();
                }
            }
        ]);
        return ProjectionNode;
    }();
}
function $a4fa0da8ce0f2603$var$updateLayout(node) {
    node.updateLayout();
}
function $a4fa0da8ce0f2603$var$notifyLayoutUpdate(node) {
    var _node_resumeFrom;
    var snapshot = ((_node_resumeFrom = node.resumeFrom) === null || _node_resumeFrom === void 0 ? void 0 : _node_resumeFrom.snapshot) || node.snapshot;
    if (node.isLead() && node.layout && snapshot && node.hasListeners("didUpdate")) {
        var _node_layout = node.layout, layout = _node_layout.layoutBox, measuredLayout = _node_layout.measuredBox;
        var animationType = node.options.animationType;
        var isShared = snapshot.source !== node.layout.source;
        // TODO Maybe we want to also resize the layout snapshot so we don't trigger
        // animations for instance if layout="size" and an element has only changed position
        if (animationType === "size") (0, $8vGlw.eachAxis)(function(axis) {
            var axisSnapshot = isShared ? snapshot.measuredBox[axis] : snapshot.layoutBox[axis];
            var length = (0, $kqrPq.calcLength)(axisSnapshot);
            axisSnapshot.min = layout[axis].min;
            axisSnapshot.max = axisSnapshot.min + length;
        });
        else if ($a4fa0da8ce0f2603$var$shouldAnimatePositionOnly(animationType, snapshot.layoutBox, layout)) (0, $8vGlw.eachAxis)(function(axis) {
            var axisSnapshot = isShared ? snapshot.measuredBox[axis] : snapshot.layoutBox[axis];
            var length = (0, $kqrPq.calcLength)(layout[axis]);
            axisSnapshot.max = axisSnapshot.min + length;
            /**
                 * Ensure relative target gets resized and rerendererd
                 */ if (node.relativeTarget && !node.currentAnimation) {
                node.isProjectionDirty = true;
                node.relativeTarget[axis].max = node.relativeTarget[axis].min + length;
            }
        });
        var layoutDelta = (0, $60wa2.createDelta)();
        (0, $kqrPq.calcBoxDelta)(layoutDelta, layout, snapshot.layoutBox);
        var visualDelta = (0, $60wa2.createDelta)();
        if (isShared) (0, $kqrPq.calcBoxDelta)(visualDelta, node.applyTransform(measuredLayout, true), snapshot.measuredBox);
        else (0, $kqrPq.calcBoxDelta)(visualDelta, layout, snapshot.layoutBox);
        var hasLayoutChanged = !(0, $cMIhe.isDeltaZero)(layoutDelta);
        var hasRelativeLayoutChanged = false;
        if (!node.resumeFrom) {
            var relativeParent = node.getClosestProjectingParent();
            /**
             * If the relativeParent is itself resuming from a different element then
             * the relative snapshot is not relavent
             */ if (relativeParent && !relativeParent.resumeFrom) {
                var parentSnapshot = relativeParent.snapshot, parentLayout = relativeParent.layout;
                if (parentSnapshot && parentLayout) {
                    var relativeSnapshot = (0, $60wa2.createBox)();
                    (0, $kqrPq.calcRelativePosition)(relativeSnapshot, snapshot.layoutBox, parentSnapshot.layoutBox);
                    var relativeLayout = (0, $60wa2.createBox)();
                    (0, $kqrPq.calcRelativePosition)(relativeLayout, layout, parentLayout.layoutBox);
                    if (!(0, $cMIhe.boxEqualsRounded)(relativeSnapshot, relativeLayout)) hasRelativeLayoutChanged = true;
                    if (relativeParent.options.layoutRoot) {
                        node.relativeTarget = relativeLayout;
                        node.relativeTargetOrigin = relativeSnapshot;
                        node.relativeParent = relativeParent;
                    }
                }
            }
        }
        node.notifyListeners("didUpdate", {
            layout: layout,
            snapshot: snapshot,
            delta: visualDelta,
            layoutDelta: layoutDelta,
            hasLayoutChanged: hasLayoutChanged,
            hasRelativeLayoutChanged: hasRelativeLayoutChanged
        });
    } else if (node.isLead()) {
        var onExitComplete = node.options.onExitComplete;
        onExitComplete && onExitComplete();
    }
    /**
     * Clearing transition
     * TODO: Investigate why this transition is being passed in as {type: false } from Framer
     * and why we need it at all
     */ node.options.transition = undefined;
}
function $a4fa0da8ce0f2603$export$131f2f0cc5fe9609(node) {
    /**
     * Increase debug counter for nodes encountered this frame
     */ if ((0, $2GhiD.statsBuffer).value) $a4fa0da8ce0f2603$var$metrics.nodes++;
    if (!node.parent) return;
    /**
     * If this node isn't projecting, propagate isProjectionDirty. It will have
     * no performance impact but it will allow the next child that *is* projecting
     * but *isn't* dirty to just check its parent to see if *any* ancestor needs
     * correcting.
     */ if (!node.isProjecting()) node.isProjectionDirty = node.parent.isProjectionDirty;
    /**
     * Propagate isSharedProjectionDirty and isTransformDirty
     * throughout the whole tree. A future revision can take another look at
     * this but for safety we still recalcualte shared nodes.
     */ node.isSharedProjectionDirty || (node.isSharedProjectionDirty = Boolean(node.isProjectionDirty || node.parent.isProjectionDirty || node.parent.isSharedProjectionDirty));
    node.isTransformDirty || (node.isTransformDirty = node.parent.isTransformDirty);
}
function $a4fa0da8ce0f2603$export$c2664f37bc951031(node) {
    node.isProjectionDirty = node.isSharedProjectionDirty = node.isTransformDirty = false;
}
function $a4fa0da8ce0f2603$var$clearSnapshot(node) {
    node.clearSnapshot();
}
function $a4fa0da8ce0f2603$var$clearMeasurements(node) {
    node.clearMeasurements();
}
function $a4fa0da8ce0f2603$var$clearIsLayoutDirty(node) {
    node.isLayoutDirty = false;
}
function $a4fa0da8ce0f2603$var$resetTransformStyle(node) {
    var visualElement = node.options.visualElement;
    if (visualElement && visualElement.getProps().onBeforeLayoutMeasure) visualElement.notify("BeforeLayoutMeasure");
    node.resetTransform();
}
function $a4fa0da8ce0f2603$var$finishAnimation(node) {
    node.finishAnimation();
    node.targetDelta = node.relativeTarget = node.target = undefined;
    node.isProjectionDirty = true;
}
function $a4fa0da8ce0f2603$var$resolveTargetDelta(node) {
    node.resolveTargetDelta();
}
function $a4fa0da8ce0f2603$var$calcProjection(node) {
    node.calcProjection();
}
function $a4fa0da8ce0f2603$var$resetSkewAndRotation(node) {
    node.resetSkewAndRotation();
}
function $a4fa0da8ce0f2603$var$removeLeadSnapshots(stack) {
    stack.removeLeadSnapshot();
}
function $a4fa0da8ce0f2603$export$91dbf443e1bf1de1(output, delta, p) {
    output.translate = (0, $83rca.mixNumber)(delta.translate, 0, p);
    output.scale = (0, $83rca.mixNumber)(delta.scale, 1, p);
    output.origin = delta.origin;
    output.originPoint = delta.originPoint;
}
function $a4fa0da8ce0f2603$export$8f9f6b0c76c773c7(output, from, to, p) {
    output.min = (0, $83rca.mixNumber)(from.min, to.min, p);
    output.max = (0, $83rca.mixNumber)(from.max, to.max, p);
}
function $a4fa0da8ce0f2603$export$6ffd3e6ae339a132(output, from, to, p) {
    $a4fa0da8ce0f2603$export$8f9f6b0c76c773c7(output.x, from.x, to.x, p);
    $a4fa0da8ce0f2603$export$8f9f6b0c76c773c7(output.y, from.y, to.y, p);
}
function $a4fa0da8ce0f2603$var$hasOpacityCrossfade(node) {
    return node.animationValues && node.animationValues.opacityExit !== undefined;
}
var $a4fa0da8ce0f2603$var$defaultLayoutTransition = {
    duration: 0.45,
    ease: [
        0.4,
        0,
        0.1,
        1
    ]
};
var $a4fa0da8ce0f2603$var$userAgentContains = function(string) {
    return typeof navigator !== "undefined" && navigator.userAgent && navigator.userAgent.toLowerCase().includes(string);
};
/**
 * Measured bounding boxes must be rounded in Safari and
 * left untouched in Chrome, otherwise non-integer layouts within scaled-up elements
 * can appear to jump.
 */ var $a4fa0da8ce0f2603$var$roundPoint = $a4fa0da8ce0f2603$var$userAgentContains("applewebkit/") && !$a4fa0da8ce0f2603$var$userAgentContains("chrome/") ? Math.round : (0, $eQ5Xp.noop);
function $a4fa0da8ce0f2603$var$roundAxis(axis) {
    // Round to the nearest .5 pixels to support subpixel layouts
    axis.min = $a4fa0da8ce0f2603$var$roundPoint(axis.min);
    axis.max = $a4fa0da8ce0f2603$var$roundPoint(axis.max);
}
function $a4fa0da8ce0f2603$var$roundBox(box) {
    $a4fa0da8ce0f2603$var$roundAxis(box.x);
    $a4fa0da8ce0f2603$var$roundAxis(box.y);
}
function $a4fa0da8ce0f2603$var$shouldAnimatePositionOnly(animationType, snapshot, layout) {
    return animationType === "position" || animationType === "preserve-aspect" && !(0, $kqrPq.isNear)((0, $cMIhe.aspectRatio)(snapshot), (0, $cMIhe.aspectRatio)(layout), 0.2);
}
function $a4fa0da8ce0f2603$var$checkNodeWasScrollRoot(node) {
    var _node_scroll;
    return node !== node.root && ((_node_scroll = node.scroll) === null || _node_scroll === void 0 ? void 0 : _node_scroll.wasRoot);
}

});
parcelRegister("cHHhA", function(module, exports) {

$parcel$export(module.exports, "isSVGElement", function () { return $1cc7e2a783d26210$export$17eda790a720ec57; });

var $fIyKB = parcelRequire("fIyKB");
/**
 * Checks if an element is an SVG element in a way
 * that works across iframes
 */ function $1cc7e2a783d26210$export$17eda790a720ec57(element) {
    return (0, $fIyKB.isObject)(element) && "ownerSVGElement" in element;
}

});
parcelRegister("fIyKB", function(module, exports) {

$parcel$export(module.exports, "isObject", function () { return $3eb4d0c9e6d07a0b$export$a6cdc56e425d0d0a; });

var $bJtXW = parcelRequire("bJtXW");
function $3eb4d0c9e6d07a0b$export$a6cdc56e425d0d0a(value) {
    return (typeof value === "undefined" ? "undefined" : (0, $bJtXW._)(value)) === "object" && value !== null;
}

});


parcelRegister("5vP3Z", function(module, exports) {

$parcel$export(module.exports, "isSVGSVGElement", function () { return $ba5a0468ac6a4f34$export$66957ea77182581d; });

var $cHHhA = parcelRequire("cHHhA");
/**
 * Checks if an element is specifically an SVGSVGElement (the root SVG element)
 * in a way that works across iframes
 */ function $ba5a0468ac6a4f34$export$66957ea77182581d(element) {
    return (0, $cHHhA.isSVGElement)(element) && element.tagName === "svg";
}

});

parcelRegister("l3DiY", function(module, exports) {

$parcel$export(module.exports, "animateSingleValue", function () { return $8f956ea6ab1cba99$export$335a17c977067b99; });

var $4drXU = parcelRequire("4drXU");
var $4SyWW = parcelRequire("4SyWW");

var $cUBhh = parcelRequire("cUBhh");
function $8f956ea6ab1cba99$export$335a17c977067b99(value, keyframes, options) {
    var motionValue$1 = (0, $4drXU.isMotionValue)(value) ? value : (0, $4SyWW.motionValue)(value);
    motionValue$1.start((0, $cUBhh.animateMotionValue)("", motionValue$1, keyframes, options));
    return motionValue$1.animation;
}

});

parcelRegister("2ioij", function(module, exports) {

$parcel$export(module.exports, "FlatTree", function () { return $37d0c662741611c9$export$1465d17e3de78a96; });

var $grujF = parcelRequire("grujF");

var $dhMkv = parcelRequire("dhMkv");

var $28QzH = parcelRequire("28QzH");

var $78VJi = parcelRequire("78VJi");
var $37d0c662741611c9$export$1465d17e3de78a96 = /*#__PURE__*/ function() {
    "use strict";
    function FlatTree() {
        (0, $grujF._)(this, FlatTree);
        this.children = [];
        this.isDirty = false;
    }
    (0, $dhMkv._)(FlatTree, [
        {
            key: "add",
            value: function add(child) {
                (0, $28QzH.addUniqueItem)(this.children, child);
                this.isDirty = true;
            }
        },
        {
            key: "remove",
            value: function remove(child) {
                (0, $28QzH.removeItem)(this.children, child);
                this.isDirty = true;
            }
        },
        {
            key: "forEach",
            value: function forEach(callback) {
                this.isDirty && this.children.sort((0, $78VJi.compareByDepth));
                this.isDirty = false;
                this.children.forEach(callback);
            }
        }
    ]);
    return FlatTree;
}();

});
parcelRegister("78VJi", function(module, exports) {

$parcel$export(module.exports, "compareByDepth", function () { return $9fa2818e80e920fe$export$d689d9dec5ad338; });
var $9fa2818e80e920fe$export$d689d9dec5ad338 = function(a, b) {
    return a.depth - b.depth;
};

});


parcelRegister("1ggeo", function(module, exports) {

$parcel$export(module.exports, "delay", function () { return $4d94f3593b4e7494$export$1391212d75b2ee65; });

var $8oVcc = parcelRequire("8oVcc");
var $j716H = parcelRequire("j716H");

var $04dOm = parcelRequire("04dOm");
/**
 * Timeout defined in ms
 */ function $4d94f3593b4e7494$export$1391212d75b2ee65(callback, timeout) {
    var start = (0, $j716H.time).now();
    var checkElapsed = function(param) {
        var timestamp = param.timestamp;
        var elapsed = timestamp - start;
        if (elapsed >= timeout) {
            (0, $8oVcc.cancelFrame)(checkElapsed);
            callback(elapsed - timeout);
        }
    };
    (0, $8oVcc.frame).setup(checkElapsed, true);
    return function() {
        return (0, $8oVcc.cancelFrame)(checkElapsed);
    };
}
function $4d94f3593b4e7494$export$fcd451ca460f8a2a(callback, timeout) {
    return $4d94f3593b4e7494$export$1391212d75b2ee65(callback, (0, $04dOm.secondsToMilliseconds)(timeout));
}

});

parcelRegister("4ZPkc", function(module, exports) {

$parcel$export(module.exports, "mixValues", function () { return $f9e781f51bc03c71$export$739e279c17d51c3d; });

var $83rca = parcelRequire("83rca");
var $aUTIu = parcelRequire("aUTIu");

var $iRVOe = parcelRequire("iRVOe");
var $eQ5Xp = parcelRequire("eQ5Xp");
var $4nrxA = parcelRequire("4nrxA");
var $f9e781f51bc03c71$var$borders = [
    "TopLeft",
    "TopRight",
    "BottomLeft",
    "BottomRight"
];
var $f9e781f51bc03c71$var$numBorders = $f9e781f51bc03c71$var$borders.length;
var $f9e781f51bc03c71$var$asNumber = function(value) {
    return typeof value === "string" ? parseFloat(value) : value;
};
var $f9e781f51bc03c71$var$isPx = function(value) {
    return typeof value === "number" || (0, $aUTIu.px).test(value);
};
function $f9e781f51bc03c71$export$739e279c17d51c3d(target, follow, lead, progress, shouldCrossfadeOpacity, isOnlyMember) {
    var _follow_opacity, _lead_opacity;
    if (shouldCrossfadeOpacity) {
        var _lead_opacity1;
        target.opacity = (0, $83rca.mixNumber)(0, (_lead_opacity1 = lead.opacity) !== null && _lead_opacity1 !== void 0 ? _lead_opacity1 : 1, $f9e781f51bc03c71$var$easeCrossfadeIn(progress));
        var _follow_opacity1;
        target.opacityExit = (0, $83rca.mixNumber)((_follow_opacity1 = follow.opacity) !== null && _follow_opacity1 !== void 0 ? _follow_opacity1 : 1, 0, $f9e781f51bc03c71$var$easeCrossfadeOut(progress));
    } else if (isOnlyMember) target.opacity = (0, $83rca.mixNumber)((_follow_opacity = follow.opacity) !== null && _follow_opacity !== void 0 ? _follow_opacity : 1, (_lead_opacity = lead.opacity) !== null && _lead_opacity !== void 0 ? _lead_opacity : 1, progress);
    /**
     * Mix border radius
     */ for(var i = 0; i < $f9e781f51bc03c71$var$numBorders; i++){
        var borderLabel = "border".concat($f9e781f51bc03c71$var$borders[i], "Radius");
        var followRadius = $f9e781f51bc03c71$var$getRadius(follow, borderLabel);
        var leadRadius = $f9e781f51bc03c71$var$getRadius(lead, borderLabel);
        if (followRadius === undefined && leadRadius === undefined) continue;
        followRadius || (followRadius = 0);
        leadRadius || (leadRadius = 0);
        var canMix = followRadius === 0 || leadRadius === 0 || $f9e781f51bc03c71$var$isPx(followRadius) === $f9e781f51bc03c71$var$isPx(leadRadius);
        if (canMix) {
            target[borderLabel] = Math.max((0, $83rca.mixNumber)($f9e781f51bc03c71$var$asNumber(followRadius), $f9e781f51bc03c71$var$asNumber(leadRadius), progress), 0);
            if ((0, $aUTIu.percent).test(leadRadius) || (0, $aUTIu.percent).test(followRadius)) target[borderLabel] += "%";
        } else target[borderLabel] = leadRadius;
    }
    /**
     * Mix rotation
     */ if (follow.rotate || lead.rotate) target.rotate = (0, $83rca.mixNumber)(follow.rotate || 0, lead.rotate || 0, progress);
}
function $f9e781f51bc03c71$var$getRadius(values, radiusName) {
    return values[radiusName] !== undefined ? values[radiusName] : values.borderRadius;
}
// /**
//  * We only want to mix the background color if there's a follow element
//  * that we're not crossfading opacity between. For instance with switch
//  * AnimateSharedLayout animations, this helps the illusion of a continuous
//  * element being animated but also cuts down on the number of paints triggered
//  * for elements where opacity is doing that work for us.
//  */
// if (
//     !hasFollowElement &&
//     latestLeadValues.backgroundColor &&
//     latestFollowValues.backgroundColor
// ) {
//     /**
//      * This isn't ideal performance-wise as mixColor is creating a new function every frame.
//      * We could probably create a mixer that runs at the start of the animation but
//      * the idea behind the crossfader is that it runs dynamically between two potentially
//      * changing targets (ie opacity or borderRadius may be animating independently via variants)
//      */
//     leadState.backgroundColor = followState.backgroundColor = mixColor(
//         latestFollowValues.backgroundColor as string,
//         latestLeadValues.backgroundColor as string
//     )(p)
// }
var $f9e781f51bc03c71$var$easeCrossfadeIn = /*@__PURE__*/ $f9e781f51bc03c71$var$compress(0, 0.5, (0, $iRVOe.circOut));
var $f9e781f51bc03c71$var$easeCrossfadeOut = /*@__PURE__*/ $f9e781f51bc03c71$var$compress(0.5, 0.95, (0, $eQ5Xp.noop));
function $f9e781f51bc03c71$var$compress(min, max, easing) {
    return function(p) {
        // Could replace ifs with clamp
        if (p < min) return 0;
        if (p > max) return 1;
        return easing((0, $4nrxA.progress)(min, max, p));
    };
}

});

parcelRegister("flTx0", function(module, exports) {

$parcel$export(module.exports, "copyBoxInto", function () { return $a723b2b360843335$export$c53fd88f45d77e4b; });
$parcel$export(module.exports, "copyAxisDeltaInto", function () { return $a723b2b360843335$export$8ead6a7d6b225ef; });
/**
 * Reset an axis to the provided origin box.
 *
 * This is a mutative operation.
 */ function $a723b2b360843335$export$a0230ae482601ae8(axis, originAxis) {
    axis.min = originAxis.min;
    axis.max = originAxis.max;
}
/**
 * Reset a box to the provided origin box.
 *
 * This is a mutative operation.
 */ function $a723b2b360843335$export$c53fd88f45d77e4b(box, originBox) {
    $a723b2b360843335$export$a0230ae482601ae8(box.x, originBox.x);
    $a723b2b360843335$export$a0230ae482601ae8(box.y, originBox.y);
}
/**
 * Reset a delta to the provided origin box.
 *
 * This is a mutative operation.
 */ function $a723b2b360843335$export$8ead6a7d6b225ef(delta, originDelta) {
    delta.translate = originDelta.translate;
    delta.scale = originDelta.scale;
    delta.originPoint = originDelta.originPoint;
    delta.origin = originDelta.origin;
}

});

parcelRegister("caRLN", function(module, exports) {

$parcel$export(module.exports, "removeBoxTransforms", function () { return $5cdc90a77563ad73$export$73e1ad0a9694e25c; });

var $2nwvT = parcelRequire("2nwvT");

var $83rca = parcelRequire("83rca");
var $aUTIu = parcelRequire("aUTIu");

var $1gKyY = parcelRequire("1gKyY");
/**
 * Remove a delta from a point. This is essentially the steps of applyPointDelta in reverse
 */ function $5cdc90a77563ad73$export$691f07066b3be7c5(point, translate, scale, originPoint, boxScale) {
    point -= translate;
    point = (0, $1gKyY.scalePoint)(point, 1 / scale, originPoint);
    if (boxScale !== undefined) point = (0, $1gKyY.scalePoint)(point, 1 / boxScale, originPoint);
    return point;
}
/**
 * Remove a delta from an axis. This is essentially the steps of applyAxisDelta in reverse
 */ function $5cdc90a77563ad73$export$cc12a0672fae5b4a(axis) {
    var translate = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0, scale = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : 1, origin = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : 0.5, boxScale = arguments.length > 4 ? arguments[4] : void 0, originAxis = arguments.length > 5 && arguments[5] !== void 0 ? arguments[5] : axis, sourceAxis = arguments.length > 6 && arguments[6] !== void 0 ? arguments[6] : axis;
    if ((0, $aUTIu.percent).test(translate)) {
        translate = parseFloat(translate);
        var relativeProgress = (0, $83rca.mixNumber)(sourceAxis.min, sourceAxis.max, translate / 100);
        translate = relativeProgress - sourceAxis.min;
    }
    if (typeof translate !== "number") return;
    var originPoint = (0, $83rca.mixNumber)(originAxis.min, originAxis.max, origin);
    if (axis === originAxis) originPoint -= translate;
    axis.min = $5cdc90a77563ad73$export$691f07066b3be7c5(axis.min, translate, scale, originPoint, boxScale);
    axis.max = $5cdc90a77563ad73$export$691f07066b3be7c5(axis.max, translate, scale, originPoint, boxScale);
}
/**
 * Remove a transforms from an axis. This is essentially the steps of applyAxisTransforms in reverse
 * and acts as a bridge between motion values and removeAxisDelta
 */ function $5cdc90a77563ad73$export$42b76f1d0d16d5b(axis, transforms, param, origin, sourceAxis) {
    var _param = (0, $2nwvT._)(param, 3), key = _param[0], scaleKey = _param[1], originKey = _param[2];
    $5cdc90a77563ad73$export$cc12a0672fae5b4a(axis, transforms[key], transforms[scaleKey], transforms[originKey], transforms.scale, origin, sourceAxis);
}
/**
 * The names of the motion values we want to apply as translation, scale and origin.
 */ var $5cdc90a77563ad73$var$xKeys = [
    "x",
    "scaleX",
    "originX"
];
var $5cdc90a77563ad73$var$yKeys = [
    "y",
    "scaleY",
    "originY"
];
/**
 * Remove a transforms from an box. This is essentially the steps of applyAxisBox in reverse
 * and acts as a bridge between motion values and removeAxisDelta
 */ function $5cdc90a77563ad73$export$73e1ad0a9694e25c(box, transforms, originBox, sourceBox) {
    $5cdc90a77563ad73$export$42b76f1d0d16d5b(box.x, transforms, $5cdc90a77563ad73$var$xKeys, originBox ? originBox.x : undefined, sourceBox ? sourceBox.x : undefined);
    $5cdc90a77563ad73$export$42b76f1d0d16d5b(box.y, transforms, $5cdc90a77563ad73$var$yKeys, originBox ? originBox.y : undefined, sourceBox ? sourceBox.y : undefined);
}

});

parcelRegister("cMIhe", function(module, exports) {

$parcel$export(module.exports, "isDeltaZero", function () { return $4690f6bd1285a864$export$a7ec7642fe550fb6; });
$parcel$export(module.exports, "boxEquals", function () { return $4690f6bd1285a864$export$8d5cf76bb7daff09; });
$parcel$export(module.exports, "boxEqualsRounded", function () { return $4690f6bd1285a864$export$ef641b782d85522; });
$parcel$export(module.exports, "aspectRatio", function () { return $4690f6bd1285a864$export$c5706146bc63213; });
$parcel$export(module.exports, "axisDeltaEquals", function () { return $4690f6bd1285a864$export$444620505e28fe92; });

var $kqrPq = parcelRequire("kqrPq");
function $4690f6bd1285a864$var$isAxisDeltaZero(delta) {
    return delta.translate === 0 && delta.scale === 1;
}
function $4690f6bd1285a864$export$a7ec7642fe550fb6(delta) {
    return $4690f6bd1285a864$var$isAxisDeltaZero(delta.x) && $4690f6bd1285a864$var$isAxisDeltaZero(delta.y);
}
function $4690f6bd1285a864$export$7a9a6f114ddd0fdb(a, b) {
    return a.min === b.min && a.max === b.max;
}
function $4690f6bd1285a864$export$8d5cf76bb7daff09(a, b) {
    return $4690f6bd1285a864$export$7a9a6f114ddd0fdb(a.x, b.x) && $4690f6bd1285a864$export$7a9a6f114ddd0fdb(a.y, b.y);
}
function $4690f6bd1285a864$export$22adf28bfca1c186(a, b) {
    return Math.round(a.min) === Math.round(b.min) && Math.round(a.max) === Math.round(b.max);
}
function $4690f6bd1285a864$export$ef641b782d85522(a, b) {
    return $4690f6bd1285a864$export$22adf28bfca1c186(a.x, b.x) && $4690f6bd1285a864$export$22adf28bfca1c186(a.y, b.y);
}
function $4690f6bd1285a864$export$c5706146bc63213(box) {
    return (0, $kqrPq.calcLength)(box.x) / (0, $kqrPq.calcLength)(box.y);
}
function $4690f6bd1285a864$export$444620505e28fe92(a, b) {
    return a.translate === b.translate && a.scale === b.scale && a.originPoint === b.originPoint;
}

});

parcelRegister("811dd", function(module, exports) {

$parcel$export(module.exports, "NodeStack", function () { return $f12c4077ced3b8ac$export$39be5b2d82fc9dc7; });

var $grujF = parcelRequire("grujF");

var $dhMkv = parcelRequire("dhMkv");

var $28QzH = parcelRequire("28QzH");
var $f12c4077ced3b8ac$export$39be5b2d82fc9dc7 = /*#__PURE__*/ function() {
    "use strict";
    function NodeStack() {
        (0, $grujF._)(this, NodeStack);
        this.members = [];
    }
    (0, $dhMkv._)(NodeStack, [
        {
            key: "add",
            value: function add(node) {
                (0, $28QzH.addUniqueItem)(this.members, node);
                node.scheduleRender();
            }
        },
        {
            key: "remove",
            value: function remove(node) {
                (0, $28QzH.removeItem)(this.members, node);
                if (node === this.prevLead) this.prevLead = undefined;
                if (node === this.lead) {
                    var prevLead = this.members[this.members.length - 1];
                    if (prevLead) this.promote(prevLead);
                }
            }
        },
        {
            key: "relegate",
            value: function relegate(node) {
                var indexOfNode = this.members.findIndex(function(member) {
                    return node === member;
                });
                if (indexOfNode === 0) return false;
                /**
         * Find the next projection node that is present
         */ var prevLead;
                for(var i = indexOfNode; i >= 0; i--){
                    var member = this.members[i];
                    if (member.isPresent !== false) {
                        prevLead = member;
                        break;
                    }
                }
                if (prevLead) {
                    this.promote(prevLead);
                    return true;
                } else return false;
            }
        },
        {
            key: "promote",
            value: function promote(node, preserveFollowOpacity) {
                var prevLead = this.lead;
                if (node === prevLead) return;
                this.prevLead = prevLead;
                this.lead = node;
                node.show();
                if (prevLead) {
                    prevLead.instance && prevLead.scheduleRender();
                    node.scheduleRender();
                    node.resumeFrom = prevLead;
                    if (preserveFollowOpacity) node.resumeFrom.preserveOpacity = true;
                    if (prevLead.snapshot) {
                        node.snapshot = prevLead.snapshot;
                        node.snapshot.latestValues = prevLead.animationValues || prevLead.latestValues;
                    }
                    if (node.root && node.root.isUpdating) node.isLayoutDirty = true;
                    var crossfade = node.options.crossfade;
                    if (crossfade === false) prevLead.hide();
                /**
             * TODO:
             *   - Test border radius when previous node was deleted
             *   - boxShadow mixing
             *   - Shared between element A in scrolled container and element B (scroll stays the same or changes)
             *   - Shared between element A in transformed container and element B (transform stays the same or changes)
             *   - Shared between element A in scrolled page and element B (scroll stays the same or changes)
             * ---
             *   - Crossfade opacity of root nodes
             *   - layoutId changes after animation
             *   - layoutId changes mid animation
             */ }
            }
        },
        {
            key: "exitAnimationComplete",
            value: function exitAnimationComplete() {
                this.members.forEach(function(node) {
                    var options = node.options, resumingFrom = node.resumingFrom;
                    options.onExitComplete && options.onExitComplete();
                    if (resumingFrom) resumingFrom.options.onExitComplete && resumingFrom.options.onExitComplete();
                });
            }
        },
        {
            key: "scheduleRender",
            value: function scheduleRender() {
                this.members.forEach(function(node) {
                    node.instance && node.scheduleRender(false);
                });
            }
        },
        {
            /**
     * Clear any leads that have been removed this render to prevent them from being
     * used in future animations and to prevent memory leaks
     */ key: "removeLeadSnapshot",
            value: function removeLeadSnapshot() {
                if (this.lead && this.lead.snapshot) this.lead.snapshot = undefined;
            }
        }
    ]);
    return NodeStack;
}();

});

parcelRegister("l4Vjc", function(module, exports) {

$parcel$export(module.exports, "buildProjectionTransform", function () { return $1d516ac34e3f30b2$export$d33653b270fe725c; });
function $1d516ac34e3f30b2$export$d33653b270fe725c(delta, treeScale, latestTransform) {
    var transform = "";
    /**
     * The translations we use to calculate are always relative to the viewport coordinate space.
     * But when we apply scales, we also scale the coordinate space of an element and its children.
     * For instance if we have a treeScale (the culmination of all parent scales) of 0.5 and we need
     * to move an element 100 pixels, we actually need to move it 200 in within that scaled space.
     */ var xTranslate = delta.x.translate / treeScale.x;
    var yTranslate = delta.y.translate / treeScale.y;
    var zTranslate = (latestTransform === null || latestTransform === void 0 ? void 0 : latestTransform.z) || 0;
    if (xTranslate || yTranslate || zTranslate) transform = "translate3d(".concat(xTranslate, "px, ").concat(yTranslate, "px, ").concat(zTranslate, "px) ");
    /**
     * Apply scale correction for the tree transform.
     * This will apply scale to the screen-orientated axes.
     */ if (treeScale.x !== 1 || treeScale.y !== 1) transform += "scale(".concat(1 / treeScale.x, ", ").concat(1 / treeScale.y, ") ");
    if (latestTransform) {
        var transformPerspective = latestTransform.transformPerspective, rotate = latestTransform.rotate, rotateX = latestTransform.rotateX, rotateY = latestTransform.rotateY, skewX = latestTransform.skewX, skewY = latestTransform.skewY;
        if (transformPerspective) transform = "perspective(".concat(transformPerspective, "px) ").concat(transform);
        if (rotate) transform += "rotate(".concat(rotate, "deg) ");
        if (rotateX) transform += "rotateX(".concat(rotateX, "deg) ");
        if (rotateY) transform += "rotateY(".concat(rotateY, "deg) ");
        if (skewX) transform += "skewX(".concat(skewX, "deg) ");
        if (skewY) transform += "skewY(".concat(skewY, "deg) ");
    }
    /**
     * Apply scale to match the size of the element to the size we want it.
     * This will apply scale to the element-orientated axes.
     */ var elementScaleX = delta.x.scale * treeScale.x;
    var elementScaleY = delta.y.scale * treeScale.y;
    if (elementScaleX !== 1 || elementScaleY !== 1) transform += "scale(".concat(elementScaleX, ", ").concat(elementScaleY, ")");
    return transform || "none";
}

});


parcelRegister("6HVnR", function(module, exports) {

$parcel$export(module.exports, "DocumentProjectionNode", function () { return $4d4656ea29856bc8$export$2d029a49a09b6177; });

var $j9DZq = parcelRequire("j9DZq");

var $kqWGD = parcelRequire("kqWGD");
var $4d4656ea29856bc8$export$2d029a49a09b6177 = (0, $kqWGD.createProjectionNode)({
    attachResizeListener: function(ref, notify) {
        return (0, $j9DZq.addDomEvent)(ref, "resize", notify);
    },
    measureScroll: function() {
        return {
            x: document.documentElement.scrollLeft || document.body.scrollLeft,
            y: document.documentElement.scrollTop || document.body.scrollTop
        };
    },
    checkIsScrollRoot: function() {
        return true;
    }
});

});



parcelRegister("iuwO5", function(module, exports) {

$parcel$export(module.exports, "gestureAnimations", function () { return $0051659ccbbb73a2$export$e5b72898e5a201f1; });

var $alFeR = parcelRequire("alFeR");

var $ldCfF = parcelRequire("ldCfF");

var $5JTf0 = parcelRequire("5JTf0");

var $4afxb = parcelRequire("4afxb");
var $0051659ccbbb73a2$export$e5b72898e5a201f1 = {
    inView: {
        Feature: (0, $4afxb.InViewFeature)
    },
    tap: {
        Feature: (0, $5JTf0.PressGesture)
    },
    focus: {
        Feature: (0, $ldCfF.FocusGesture)
    },
    hover: {
        Feature: (0, $alFeR.HoverGesture)
    }
};

});
parcelRegister("alFeR", function(module, exports) {

$parcel$export(module.exports, "HoverGesture", function () { return $173eaa6b522a528e$export$93a81ea037eac456; });

var $f3Okx = parcelRequire("f3Okx");

var $grujF = parcelRequire("grujF");

var $dhMkv = parcelRequire("dhMkv");

var $j6Mzi = parcelRequire("j6Mzi");

var $8oVcc = parcelRequire("8oVcc");
var $cchFG = parcelRequire("cchFG");

var $kKOaz = parcelRequire("kKOaz");

var $hVeVW = parcelRequire("hVeVW");
function $173eaa6b522a528e$var$handleHoverEvent(node, event, lifecycle) {
    var props = node.props;
    if (node.animationState && props.whileHover) node.animationState.setActive("whileHover", lifecycle === "Start");
    var eventName = "onHover" + lifecycle;
    var callback = props[eventName];
    if (callback) (0, $8oVcc.frame).postRender(function() {
        return callback(event, (0, $kKOaz.extractEventInfo)(event));
    });
}
var $173eaa6b522a528e$export$93a81ea037eac456 = /*#__PURE__*/ function(Feature) {
    "use strict";
    (0, $j6Mzi._)(HoverGesture, Feature);
    function HoverGesture() {
        (0, $grujF._)(this, HoverGesture);
        return (0, $f3Okx._)(this, HoverGesture, arguments);
    }
    (0, $dhMkv._)(HoverGesture, [
        {
            key: "mount",
            value: function mount() {
                var _this = this;
                var current = this.node.current;
                if (!current) return;
                this.unmount = (0, $cchFG.hover)(current, function(_element, startEvent) {
                    $173eaa6b522a528e$var$handleHoverEvent(_this.node, startEvent, "Start");
                    return function(endEvent) {
                        return $173eaa6b522a528e$var$handleHoverEvent(_this.node, endEvent, "End");
                    };
                });
            }
        },
        {
            key: "unmount",
            value: function unmount() {}
        }
    ]);
    return HoverGesture;
}((0, $hVeVW.Feature));

});
parcelRegister("cchFG", function(module, exports) {

$parcel$export(module.exports, "hover", function () { return $452b97928399455f$export$3f60957f5dbf3876; });

var $2nwvT = parcelRequire("2nwvT");

var $1B8HX = parcelRequire("1B8HX");

var $7btXr = parcelRequire("7btXr");
function $452b97928399455f$var$isValidHover(event) {
    return !(event.pointerType === "touch" || (0, $1B8HX.isDragActive)());
}
/**
 * Create a hover gesture. hover() is different to .addEventListener("pointerenter")
 * in that it has an easier syntax, filters out polyfilled touch events, interoperates
 * with drag gestures, and automatically removes the "pointerennd" event listener when the hover ends.
 *
 * @public
 */ function $452b97928399455f$export$3f60957f5dbf3876(elementOrSelector, onHoverStart) {
    var options = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
    var _setupGesture = (0, $2nwvT._)((0, $7btXr.setupGesture)(elementOrSelector, options), 3), elements = _setupGesture[0], eventOptions = _setupGesture[1], cancel = _setupGesture[2];
    var onPointerEnter = function(enterEvent) {
        if (!$452b97928399455f$var$isValidHover(enterEvent)) return;
        var target = enterEvent.target;
        var onHoverEnd = onHoverStart(target, enterEvent);
        if (typeof onHoverEnd !== "function" || !target) return;
        var onPointerLeave = function(leaveEvent) {
            if (!$452b97928399455f$var$isValidHover(leaveEvent)) return;
            onHoverEnd(leaveEvent);
            target.removeEventListener("pointerleave", onPointerLeave);
        };
        target.addEventListener("pointerleave", onPointerLeave, eventOptions);
    };
    elements.forEach(function(element) {
        element.addEventListener("pointerenter", onPointerEnter, eventOptions);
    });
    return cancel;
}

});
parcelRegister("7btXr", function(module, exports) {

$parcel$export(module.exports, "setupGesture", function () { return $2dbbbe59f79df008$export$edc0ace9d5e7e842; });

var $joFW3 = parcelRequire("joFW3");

var $90FDw = parcelRequire("90FDw");

var $f6V81 = parcelRequire("f6V81");
function $2dbbbe59f79df008$export$edc0ace9d5e7e842(elementOrSelector, options) {
    var elements = (0, $f6V81.resolveElements)(elementOrSelector);
    var gestureAbortController = new AbortController();
    var eventOptions = (0, $90FDw._)((0, $joFW3._)({
        passive: true
    }, options), {
        signal: gestureAbortController.signal
    });
    var cancel = function() {
        return gestureAbortController.abort();
    };
    return [
        elements,
        eventOptions,
        cancel
    ];
}

});
parcelRegister("f6V81", function(module, exports) {

$parcel$export(module.exports, "resolveElements", function () { return $32651bf030d3ab1c$export$90ceba2564a894f8; });
function $32651bf030d3ab1c$export$90ceba2564a894f8(elementOrSelector, scope, selectorCache) {
    if (elementOrSelector instanceof EventTarget) return [
        elementOrSelector
    ];
    else if (typeof elementOrSelector === "string") {
        var root = document;
        if (scope) root = scope.current;
        var _selectorCache_elementOrSelector;
        var elements = (_selectorCache_elementOrSelector = selectorCache === null || selectorCache === void 0 ? void 0 : selectorCache[elementOrSelector]) !== null && _selectorCache_elementOrSelector !== void 0 ? _selectorCache_elementOrSelector : root.querySelectorAll(elementOrSelector);
        return elements ? Array.from(elements) : [];
    }
    return Array.from(elementOrSelector);
}

});




parcelRegister("ldCfF", function(module, exports) {

$parcel$export(module.exports, "FocusGesture", function () { return $52139f42dca6e904$export$d4826db40d47595b; });

var $f3Okx = parcelRequire("f3Okx");

var $grujF = parcelRequire("grujF");

var $dhMkv = parcelRequire("dhMkv");

var $j6Mzi = parcelRequire("j6Mzi");

var $1Te65 = parcelRequire("1Te65");

var $j9DZq = parcelRequire("j9DZq");

var $hVeVW = parcelRequire("hVeVW");
var $52139f42dca6e904$export$d4826db40d47595b = /*#__PURE__*/ function(Feature) {
    "use strict";
    (0, $j6Mzi._)(FocusGesture, Feature);
    function FocusGesture() {
        (0, $grujF._)(this, FocusGesture);
        var _this;
        _this = (0, $f3Okx._)(this, FocusGesture, arguments);
        _this.isActive = false;
        return _this;
    }
    (0, $dhMkv._)(FocusGesture, [
        {
            key: "onFocus",
            value: function onFocus() {
                var isFocusVisible = false;
                /**
         * If this element doesn't match focus-visible then don't
         * apply whileHover. But, if matches throws that focus-visible
         * is not a valid selector then in that browser outline styles will be applied
         * to the element by default and we want to match that behaviour with whileFocus.
         */ try {
                    isFocusVisible = this.node.current.matches(":focus-visible");
                } catch (e) {
                    isFocusVisible = true;
                }
                if (!isFocusVisible || !this.node.animationState) return;
                this.node.animationState.setActive("whileFocus", true);
                this.isActive = true;
            }
        },
        {
            key: "onBlur",
            value: function onBlur() {
                if (!this.isActive || !this.node.animationState) return;
                this.node.animationState.setActive("whileFocus", false);
                this.isActive = false;
            }
        },
        {
            key: "mount",
            value: function mount() {
                var _this = this;
                this.unmount = (0, $1Te65.pipe)((0, $j9DZq.addDomEvent)(this.node.current, "focus", function() {
                    return _this.onFocus();
                }), (0, $j9DZq.addDomEvent)(this.node.current, "blur", function() {
                    return _this.onBlur();
                }));
            }
        },
        {
            key: "unmount",
            value: function unmount() {}
        }
    ]);
    return FocusGesture;
}((0, $hVeVW.Feature));

});

parcelRegister("5JTf0", function(module, exports) {

$parcel$export(module.exports, "PressGesture", function () { return $a4eb5b67bff52a9c$export$f026abdbba7f0c9e; });

var $f3Okx = parcelRequire("f3Okx");

var $grujF = parcelRequire("grujF");

var $dhMkv = parcelRequire("dhMkv");

var $j6Mzi = parcelRequire("j6Mzi");

var $8oVcc = parcelRequire("8oVcc");
var $fog13 = parcelRequire("fog13");

var $kKOaz = parcelRequire("kKOaz");

var $hVeVW = parcelRequire("hVeVW");
function $a4eb5b67bff52a9c$var$handlePressEvent(node, event, lifecycle) {
    var props = node.props;
    if (node.current instanceof HTMLButtonElement && node.current.disabled) return;
    if (node.animationState && props.whileTap) node.animationState.setActive("whileTap", lifecycle === "Start");
    var eventName = "onTap" + (lifecycle === "End" ? "" : lifecycle);
    var callback = props[eventName];
    if (callback) (0, $8oVcc.frame).postRender(function() {
        return callback(event, (0, $kKOaz.extractEventInfo)(event));
    });
}
var $a4eb5b67bff52a9c$export$f026abdbba7f0c9e = /*#__PURE__*/ function(Feature) {
    "use strict";
    (0, $j6Mzi._)(PressGesture, Feature);
    function PressGesture() {
        (0, $grujF._)(this, PressGesture);
        return (0, $f3Okx._)(this, PressGesture, arguments);
    }
    (0, $dhMkv._)(PressGesture, [
        {
            key: "mount",
            value: function mount() {
                var _this = this;
                var current = this.node.current;
                if (!current) return;
                this.unmount = (0, $fog13.press)(current, function(_element, startEvent) {
                    $a4eb5b67bff52a9c$var$handlePressEvent(_this.node, startEvent, "Start");
                    return function(endEvent, param) {
                        var success = param.success;
                        return $a4eb5b67bff52a9c$var$handlePressEvent(_this.node, endEvent, success ? "End" : "Cancel");
                    };
                }, {
                    useGlobalTarget: this.node.props.globalTapTarget
                });
            }
        },
        {
            key: "unmount",
            value: function unmount() {}
        }
    ]);
    return PressGesture;
}((0, $hVeVW.Feature));

});
parcelRegister("fog13", function(module, exports) {

$parcel$export(module.exports, "press", function () { return $272e42db6cc2cbb4$export$dbe9198142dace0c; });

var $2nwvT = parcelRequire("2nwvT");

var $36BcT = parcelRequire("36BcT");

var $1B8HX = parcelRequire("1B8HX");

var $ea0F7 = parcelRequire("ea0F7");

var $5nfcx = parcelRequire("5nfcx");

var $7btXr = parcelRequire("7btXr");

var $kUUDr = parcelRequire("kUUDr");

var $erTip = parcelRequire("erTip");

var $eiw1w = parcelRequire("eiw1w");
/**
 * Filter out events that are not primary pointer events, or are triggering
 * while a Motion gesture is active.
 */ function $272e42db6cc2cbb4$var$isValidPressEvent(event) {
    return (0, $5nfcx.isPrimaryPointer)(event) && !(0, $1B8HX.isDragActive)();
}
/**
 * Create a press gesture.
 *
 * Press is different to `"pointerdown"`, `"pointerup"` in that it
 * automatically filters out secondary pointer events like right
 * click and multitouch.
 *
 * It also adds accessibility support for keyboards, where
 * an element with a press gesture will receive focus and
 *  trigger on Enter `"keydown"` and `"keyup"` events.
 *
 * This is different to a browser's `"click"` event, which does
 * respond to keyboards but only for the `"click"` itself, rather
 * than the press start and end/cancel. The element also needs
 * to be focusable for this to work, whereas a press gesture will
 * make an element focusable by default.
 *
 * @public
 */ function $272e42db6cc2cbb4$export$dbe9198142dace0c(targetOrSelector, onPressStart) {
    var options = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
    var _setupGesture = (0, $2nwvT._)((0, $7btXr.setupGesture)(targetOrSelector, options), 3), targets = _setupGesture[0], eventOptions = _setupGesture[1], cancelEvents = _setupGesture[2];
    var startPress = function(startEvent) {
        var target = startEvent.currentTarget;
        if (!$272e42db6cc2cbb4$var$isValidPressEvent(startEvent)) return;
        (0, $eiw1w.isPressing).add(target);
        var onPressEnd = onPressStart(target, startEvent);
        var onPointerEnd = function(endEvent, success) {
            window.removeEventListener("pointerup", onPointerUp);
            window.removeEventListener("pointercancel", onPointerCancel);
            if ((0, $eiw1w.isPressing).has(target)) (0, $eiw1w.isPressing).delete(target);
            if (!$272e42db6cc2cbb4$var$isValidPressEvent(endEvent)) return;
            if (typeof onPressEnd === "function") onPressEnd(endEvent, {
                success: success
            });
        };
        var onPointerUp = function(upEvent) {
            onPointerEnd(upEvent, target === window || target === document || options.useGlobalTarget || (0, $ea0F7.isNodeOrChild)(target, upEvent.target));
        };
        var onPointerCancel = function(cancelEvent) {
            onPointerEnd(cancelEvent, false);
        };
        window.addEventListener("pointerup", onPointerUp, eventOptions);
        window.addEventListener("pointercancel", onPointerCancel, eventOptions);
    };
    targets.forEach(function(target) {
        var pointerDownTarget = options.useGlobalTarget ? window : target;
        pointerDownTarget.addEventListener("pointerdown", startPress, eventOptions);
        if ((0, $36BcT.isHTMLElement)(target)) {
            target.addEventListener("focus", function(event) {
                return (0, $erTip.enableKeyboardPress)(event, eventOptions);
            });
            if (!(0, $kUUDr.isElementKeyboardAccessible)(target) && !target.hasAttribute("tabindex")) target.tabIndex = 0;
        }
    });
    return cancelEvents;
}

});
parcelRegister("36BcT", function(module, exports) {

$parcel$export(module.exports, "isHTMLElement", function () { return $f69c620d00d439b0$export$1b3bfaa9684536aa; });

var $fIyKB = parcelRequire("fIyKB");
/**
 * Checks if an element is an HTML element in a way
 * that works across iframes
 */ function $f69c620d00d439b0$export$1b3bfaa9684536aa(element) {
    return (0, $fIyKB.isObject)(element) && "offsetHeight" in element;
}

});

parcelRegister("ea0F7", function(module, exports) {

$parcel$export(module.exports, "isNodeOrChild", function () { return $aa74dd048fc40a15$export$e841ada32ff745b; });
/**
 * Recursively traverse up the tree to check whether the provided child node
 * is the parent or a descendant of it.
 *
 * @param parent - Element to find
 * @param child - Element to test against parent
 */ var $aa74dd048fc40a15$export$e841ada32ff745b = function(parent, child) {
    if (!child) return false;
    else if (parent === child) return true;
    else return $aa74dd048fc40a15$export$e841ada32ff745b(parent, child.parentElement);
};

});

parcelRegister("kUUDr", function(module, exports) {

$parcel$export(module.exports, "isElementKeyboardAccessible", function () { return $d796244b9d4aaa19$export$5f6976e2f961e8b7; });
var $d796244b9d4aaa19$var$focusableElements = new Set([
    "BUTTON",
    "INPUT",
    "SELECT",
    "TEXTAREA",
    "A"
]);
function $d796244b9d4aaa19$export$5f6976e2f961e8b7(element) {
    return $d796244b9d4aaa19$var$focusableElements.has(element.tagName) || element.tabIndex !== -1;
}

});

parcelRegister("erTip", function(module, exports) {

$parcel$export(module.exports, "enableKeyboardPress", function () { return $b880ab7cc1bd9e53$export$4b5790288fe12a79; });

var $eiw1w = parcelRequire("eiw1w");
/**
 * Filter out events that are not "Enter" keys.
 */ function $b880ab7cc1bd9e53$var$filterEvents(callback) {
    return function(event) {
        if (event.key !== "Enter") return;
        callback(event);
    };
}
function $b880ab7cc1bd9e53$var$firePointerEvent(target, type) {
    target.dispatchEvent(new PointerEvent("pointer" + type, {
        isPrimary: true,
        bubbles: true
    }));
}
var $b880ab7cc1bd9e53$export$4b5790288fe12a79 = function(focusEvent, eventOptions) {
    var element = focusEvent.currentTarget;
    if (!element) return;
    var handleKeydown = $b880ab7cc1bd9e53$var$filterEvents(function() {
        if ((0, $eiw1w.isPressing).has(element)) return;
        $b880ab7cc1bd9e53$var$firePointerEvent(element, "down");
        var handleKeyup = $b880ab7cc1bd9e53$var$filterEvents(function() {
            $b880ab7cc1bd9e53$var$firePointerEvent(element, "up");
        });
        var handleBlur = function() {
            return $b880ab7cc1bd9e53$var$firePointerEvent(element, "cancel");
        };
        element.addEventListener("keyup", handleKeyup, eventOptions);
        element.addEventListener("blur", handleBlur, eventOptions);
    });
    element.addEventListener("keydown", handleKeydown, eventOptions);
    /**
     * Add an event listener that fires on blur to remove the keydown events.
     */ element.addEventListener("blur", function() {
        return element.removeEventListener("keydown", handleKeydown);
    }, eventOptions);
};

});
parcelRegister("eiw1w", function(module, exports) {

$parcel$export(module.exports, "isPressing", function () { return $55167614512c33a5$export$7987404a4e35b84b; });
var $55167614512c33a5$export$7987404a4e35b84b = new WeakSet();

});




parcelRegister("4afxb", function(module, exports) {

$parcel$export(module.exports, "InViewFeature", function () { return $fa7b6f1b1c96e2d9$export$150851c8cc2f0c72; });

var $f3Okx = parcelRequire("f3Okx");

var $grujF = parcelRequire("grujF");

var $dhMkv = parcelRequire("dhMkv");

var $j6Mzi = parcelRequire("j6Mzi");

var $hVeVW = parcelRequire("hVeVW");

var $jFBAj = parcelRequire("jFBAj");
var $fa7b6f1b1c96e2d9$var$thresholdNames = {
    some: 0,
    all: 1
};
var $fa7b6f1b1c96e2d9$export$150851c8cc2f0c72 = /*#__PURE__*/ function(Feature) {
    "use strict";
    (0, $j6Mzi._)(InViewFeature, Feature);
    function InViewFeature() {
        (0, $grujF._)(this, InViewFeature);
        var _this;
        _this = (0, $f3Okx._)(this, InViewFeature, arguments);
        _this.hasEnteredView = false;
        _this.isInView = false;
        return _this;
    }
    (0, $dhMkv._)(InViewFeature, [
        {
            key: "startObserver",
            value: function startObserver() {
                var _this = this;
                this.unmount();
                var _this_node_getProps = this.node.getProps(), _this_node_getProps_viewport = _this_node_getProps.viewport, viewport = _this_node_getProps_viewport === void 0 ? {} : _this_node_getProps_viewport;
                var root = viewport.root, rootMargin = viewport.margin, _viewport_amount = viewport.amount, amount = _viewport_amount === void 0 ? "some" : _viewport_amount, once = viewport.once;
                var options = {
                    root: root ? root.current : undefined,
                    rootMargin: rootMargin,
                    threshold: typeof amount === "number" ? amount : $fa7b6f1b1c96e2d9$var$thresholdNames[amount]
                };
                var onIntersectionUpdate = function(entry) {
                    var isIntersecting = entry.isIntersecting;
                    /**
             * If there's been no change in the viewport state, early return.
             */ if (_this.isInView === isIntersecting) return;
                    _this.isInView = isIntersecting;
                    /**
             * Handle hasEnteredView. If this is only meant to run once, and
             * element isn't visible, early return. Otherwise set hasEnteredView to true.
             */ if (once && !isIntersecting && _this.hasEnteredView) return;
                    else if (isIntersecting) _this.hasEnteredView = true;
                    if (_this.node.animationState) _this.node.animationState.setActive("whileInView", isIntersecting);
                    /**
             * Use the latest committed props rather than the ones in scope
             * when this observer is created
             */ var _this_node_getProps = _this.node.getProps(), onViewportEnter = _this_node_getProps.onViewportEnter, onViewportLeave = _this_node_getProps.onViewportLeave;
                    var callback = isIntersecting ? onViewportEnter : onViewportLeave;
                    callback && callback(entry);
                };
                return (0, $jFBAj.observeIntersection)(this.node.current, options, onIntersectionUpdate);
            }
        },
        {
            key: "mount",
            value: function mount() {
                this.startObserver();
            }
        },
        {
            key: "update",
            value: function update() {
                if (typeof IntersectionObserver === "undefined") return;
                var _this_node = this.node, props = _this_node.props, prevProps = _this_node.prevProps;
                var hasOptionsChanged = [
                    "amount",
                    "margin",
                    "root"
                ].some($fa7b6f1b1c96e2d9$var$hasViewportOptionChanged(props, prevProps));
                if (hasOptionsChanged) this.startObserver();
            }
        },
        {
            key: "unmount",
            value: function unmount() {}
        }
    ]);
    return InViewFeature;
}((0, $hVeVW.Feature));
function $fa7b6f1b1c96e2d9$var$hasViewportOptionChanged(param) {
    var _param_viewport = param.viewport, viewport = _param_viewport === void 0 ? {} : _param_viewport, _ref = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, tmp = _ref.viewport, prevViewport = tmp === void 0 ? {} : tmp;
    return function(name) {
        return viewport[name] !== prevViewport[name];
    };
}

});
parcelRegister("jFBAj", function(module, exports) {

$parcel$export(module.exports, "observeIntersection", function () { return $e3edcdbf610c9c12$export$b2bcd62fb7925aa5; });
/**
 * Map an IntersectionHandler callback to an element. We only ever make one handler for one
 * element, so even though these handlers might all be triggered by different
 * observers, we can keep them in the same map.
 */ 
var $joFW3 = parcelRequire("joFW3");

var $buaX5 = parcelRequire("buaX5");
var $e3edcdbf610c9c12$var$observerCallbacks = new WeakMap();
/**
 * Multiple observers can be created for multiple element/document roots. Each with
 * different settings. So here we store dictionaries of observers to each root,
 * using serialised settings (threshold/margin) as lookup keys.
 */ var $e3edcdbf610c9c12$var$observers = new WeakMap();
var $e3edcdbf610c9c12$var$fireObserverCallback = function(entry) {
    var callback = $e3edcdbf610c9c12$var$observerCallbacks.get(entry.target);
    callback && callback(entry);
};
var $e3edcdbf610c9c12$var$fireAllObserverCallbacks = function(entries) {
    entries.forEach($e3edcdbf610c9c12$var$fireObserverCallback);
};
function $e3edcdbf610c9c12$var$initIntersectionObserver(_param) {
    var root = _param.root, options = (0, $buaX5._)(_param, [
        "root"
    ]);
    var lookupRoot = root || document;
    /**
     * If we don't have an observer lookup map for this root, create one.
     */ if (!$e3edcdbf610c9c12$var$observers.has(lookupRoot)) $e3edcdbf610c9c12$var$observers.set(lookupRoot, {});
    var rootObservers = $e3edcdbf610c9c12$var$observers.get(lookupRoot);
    var key = JSON.stringify(options);
    /**
     * If we don't have an observer for this combination of root and settings,
     * create one.
     */ if (!rootObservers[key]) rootObservers[key] = new IntersectionObserver($e3edcdbf610c9c12$var$fireAllObserverCallbacks, (0, $joFW3._)({
        root: root
    }, options));
    return rootObservers[key];
}
function $e3edcdbf610c9c12$export$b2bcd62fb7925aa5(element, options, callback) {
    var rootInteresectionObserver = $e3edcdbf610c9c12$var$initIntersectionObserver(options);
    $e3edcdbf610c9c12$var$observerCallbacks.set(element, callback);
    rootInteresectionObserver.observe(element);
    return function() {
        $e3edcdbf610c9c12$var$observerCallbacks.delete(element);
        rootInteresectionObserver.unobserve(element);
    };
}

});



parcelRegister("jYIKh", function(module, exports) {

$parcel$export(module.exports, "layout", function () { return $b80faf2c7d6ef320$export$b3219800bda33a1f; });

var $hj2UJ = parcelRequire("hj2UJ");

var $kXN1g = parcelRequire("kXN1g");
var $b80faf2c7d6ef320$export$b3219800bda33a1f = {
    layout: {
        ProjectionNode: (0, $hj2UJ.HTMLProjectionNode),
        MeasureLayout: (0, $kXN1g.MeasureLayout)
    }
};

});



parcelRegister("kK8g8", function(module, exports) {

$parcel$export(module.exports, "isDraft", function () { return isDraft; });
$parcel$export(module.exports, "isDraftable", function () { return isDraftable; });
$parcel$export(module.exports, "current", function () { return current; });
$parcel$export(module.exports, "produce", function () { return produce; });

var $f3Okx = parcelRequire("f3Okx");

var $grujF = parcelRequire("grujF");

var $dhMkv = parcelRequire("dhMkv");

var $72osQ = parcelRequire("72osQ");

var $j6Mzi = parcelRequire("j6Mzi");

var $2nwvT = parcelRequire("2nwvT");

var $2us1u = parcelRequire("2us1u");

var $bJtXW = parcelRequire("bJtXW");

var $1EZOw = parcelRequire("1EZOw");
var __defProp = Object.defineProperty;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = function(obj, key, value) {
    return key in obj ? __defProp(obj, key, {
        enumerable: true,
        configurable: true,
        writable: true,
        value: value
    }) : obj[key] = value;
};
var __spreadValues = function(a, b) {
    for(var prop in b || (b = {}))if (__hasOwnProp.call(b, prop)) __defNormalProp(a, prop, b[prop]);
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    if (__getOwnPropSymbols) try {
        for(var _iterator = __getOwnPropSymbols(b)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var prop = _step.value;
            if (__propIsEnum.call(b, prop)) __defNormalProp(a, prop, b[prop]);
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    return a;
};
// src/utils/env.ts
var NOTHING = Symbol.for("immer-nothing");
var DRAFTABLE = Symbol.for("immer-draftable");
var DRAFT_STATE = Symbol.for("immer-state");
// src/utils/errors.ts
var errors = [];
function die(error) {
    for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++){
        args[_key - 1] = arguments[_key];
    }
    throw new Error("[Immer] minified error nr: ".concat(error, ". Full error at: https://bit.ly/3cXEKWf"));
}
// src/utils/common.ts
var O = Object;
var getPrototypeOf = O.getPrototypeOf;
var CONSTRUCTOR = "constructor";
var PROTOTYPE = "prototype";
var CONFIGURABLE = "configurable";
var ENUMERABLE = "enumerable";
var WRITABLE = "writable";
var VALUE = "value";
var isDraft = function(value) {
    return !!value && !!value[DRAFT_STATE];
};
function isDraftable(value) {
    var _a;
    if (!value) return false;
    return isPlainObject(value) || isArray(value) || !!value[DRAFTABLE] || !!((_a = value[CONSTRUCTOR]) == null ? void 0 : _a[DRAFTABLE]) || isMap(value) || isSet(value);
}
var objectCtorString = O[PROTOTYPE][CONSTRUCTOR].toString();
var cachedCtorStrings = /* @__PURE__ */ new WeakMap();
function isPlainObject(value) {
    if (!value || !isObjectish(value)) return false;
    var proto = getPrototypeOf(value);
    if (proto === null || proto === O[PROTOTYPE]) return true;
    var Ctor = O.hasOwnProperty.call(proto, CONSTRUCTOR) && proto[CONSTRUCTOR];
    if (Ctor === Object) return true;
    if (!isFunction(Ctor)) return false;
    var ctorString = cachedCtorStrings.get(Ctor);
    if (ctorString === void 0) {
        ctorString = Function.toString.call(Ctor);
        cachedCtorStrings.set(Ctor, ctorString);
    }
    return ctorString === objectCtorString;
}
function original(value) {
    if (!isDraft(value)) die(15, value);
    return value[DRAFT_STATE].base_;
}
function each(obj, iter) {
    var strict = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : true;
    if (getArchtype(obj) === 0 /* Object */ ) {
        var keys = strict ? Reflect.ownKeys(obj) : O.keys(obj);
        keys.forEach(function(key) {
            iter(key, obj[key], obj);
        });
    } else obj.forEach(function(entry, index) {
        return iter(index, entry, obj);
    });
}
function getArchtype(thing) {
    var state = thing[DRAFT_STATE];
    return state ? state.type_ : isArray(thing) ? 1 /* Array */  : isMap(thing) ? 2 /* Map */  : isSet(thing) ? 3 /* Set */  : 0 /* Object */ ;
}
var has = function(thing, prop) {
    var type = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : getArchtype(thing);
    return type === 2 /* Map */  ? thing.has(prop) : O[PROTOTYPE].hasOwnProperty.call(thing, prop);
};
var get = function(thing, prop) {
    var type = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : getArchtype(thing);
    return(// @ts-ignore
    type === 2 /* Map */  ? thing.get(prop) : thing[prop]);
};
var set = function(thing, propOrOldValue, value) {
    var type = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : getArchtype(thing);
    if (type === 2 /* Map */ ) thing.set(propOrOldValue, value);
    else if (type === 3 /* Set */ ) thing.add(value);
    else thing[propOrOldValue] = value;
};
function is(x, y) {
    if (x === y) return x !== 0 || 1 / x === 1 / y;
    else return x !== x && y !== y;
}
var isArray = Array.isArray;
var isMap = function(target) {
    return target instanceof Map;
};
var isSet = function(target) {
    return target instanceof Set;
};
var isObjectish = function(target) {
    return (typeof target === "undefined" ? "undefined" : (0, $bJtXW._)(target)) === "object";
};
var isFunction = function(target) {
    return typeof target === "function";
};
var isBoolean = function(target) {
    return typeof target === "boolean";
};
function isArrayIndex(value) {
    var n = +value;
    return Number.isInteger(n) && String(n) === value;
}
var getProxyDraft = function(value) {
    if (!isObjectish(value)) return null;
    return value == null ? void 0 : value[DRAFT_STATE];
};
var latest = function(state) {
    return state.copy_ || state.base_;
};
var getValue = function(value) {
    var _a;
    var proxyDraft = getProxyDraft(value);
    return proxyDraft ? (_a = proxyDraft.copy_) != null ? _a : proxyDraft.base_ : value;
};
var getFinalValue = function(state) {
    return state.modified_ ? state.copy_ : state.base_;
};
function shallowCopy(base, strict) {
    if (isMap(base)) return new Map(base);
    if (isSet(base)) return new Set(base);
    if (isArray(base)) return Array[PROTOTYPE].slice.call(base);
    var isPlain = isPlainObject(base);
    if (strict === true || strict === "class_only" && !isPlain) {
        var descriptors = O.getOwnPropertyDescriptors(base);
        delete descriptors[DRAFT_STATE];
        var keys = Reflect.ownKeys(descriptors);
        for(var i = 0; i < keys.length; i++){
            var key = keys[i];
            var desc = descriptors[key];
            if (desc[WRITABLE] === false) {
                desc[WRITABLE] = true;
                desc[CONFIGURABLE] = true;
            }
            var _obj;
            if (desc.get || desc.set) descriptors[key] = (_obj = {}, (0, $72osQ._)(_obj, CONFIGURABLE, true), (0, $72osQ._)(_obj, WRITABLE, true), // could live with !!desc.set as well here...
            (0, $72osQ._)(_obj, ENUMERABLE, desc[ENUMERABLE]), (0, $72osQ._)(_obj, VALUE, base[key]), _obj);
        }
        return O.create(getPrototypeOf(base), descriptors);
    } else {
        var proto = getPrototypeOf(base);
        if (proto !== null && isPlain) return __spreadValues({}, base);
        var obj = O.create(proto);
        return O.assign(obj, base);
    }
}
function freeze(obj) {
    var deep = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false;
    if (isFrozen(obj) || isDraft(obj) || !isDraftable(obj)) return obj;
    if (getArchtype(obj) > 1) O.defineProperties(obj, {
        set: dontMutateMethodOverride,
        add: dontMutateMethodOverride,
        clear: dontMutateMethodOverride,
        delete: dontMutateMethodOverride
    });
    O.freeze(obj);
    if (deep) each(obj, function(_key, value) {
        freeze(value, true);
    }, false);
    return obj;
}
function dontMutateFrozenCollections() {
    die(2);
}
var dontMutateMethodOverride = (0, $72osQ._)({}, VALUE, dontMutateFrozenCollections);
function isFrozen(obj) {
    if (obj === null || !isObjectish(obj)) return true;
    return O.isFrozen(obj);
}
// src/utils/plugins.ts
var PluginMapSet = "MapSet";
var PluginPatches = "Patches";
var PluginArrayMethods = "ArrayMethods";
var plugins = {};
function getPlugin(pluginKey) {
    var plugin = plugins[pluginKey];
    if (!plugin) die(0, pluginKey);
    return plugin;
}
var isPluginLoaded = function(pluginKey) {
    return !!plugins[pluginKey];
};
function loadPlugin(pluginKey, implementation) {
    if (!plugins[pluginKey]) plugins[pluginKey] = implementation;
}
// src/core/scope.ts
var currentScope;
var getCurrentScope = function() {
    return currentScope;
};
var createScope = function(parent_, immer_) {
    return {
        drafts_: [],
        parent_: parent_,
        immer_: immer_,
        // Whenever the modified draft contains a draft from another scope, we
        // need to prevent auto-freezing so the unowned draft can be finalized.
        canAutoFreeze_: true,
        unfinalizedDrafts_: 0,
        handledSet_: /* @__PURE__ */ new Set(),
        processedForPatches_: /* @__PURE__ */ new Set(),
        mapSetPlugin_: isPluginLoaded(PluginMapSet) ? getPlugin(PluginMapSet) : void 0,
        arrayMethodsPlugin_: isPluginLoaded(PluginArrayMethods) ? getPlugin(PluginArrayMethods) : void 0
    };
};
function usePatchesInScope(scope, patchListener) {
    if (patchListener) {
        scope.patchPlugin_ = getPlugin(PluginPatches);
        scope.patches_ = [];
        scope.inversePatches_ = [];
        scope.patchListener_ = patchListener;
    }
}
function revokeScope(scope) {
    leaveScope(scope);
    scope.drafts_.forEach(revokeDraft);
    scope.drafts_ = null;
}
function leaveScope(scope) {
    if (scope === currentScope) currentScope = scope.parent_;
}
var enterScope = function(immer2) {
    return currentScope = createScope(currentScope, immer2);
};
function revokeDraft(draft) {
    var state = draft[DRAFT_STATE];
    if (state.type_ === 0 /* Object */  || state.type_ === 1 /* Array */ ) state.revoke_();
    else state.revoked_ = true;
}
// src/core/finalize.ts
function processResult(result, scope) {
    scope.unfinalizedDrafts_ = scope.drafts_.length;
    var baseDraft = scope.drafts_[0];
    var isReplaced = result !== void 0 && result !== baseDraft;
    if (isReplaced) {
        if (baseDraft[DRAFT_STATE].modified_) {
            revokeScope(scope);
            die(4);
        }
        if (isDraftable(result)) result = finalize(scope, result);
        var patchPlugin_ = scope.patchPlugin_;
        if (patchPlugin_) patchPlugin_.generateReplacementPatches_(baseDraft[DRAFT_STATE].base_, result, scope);
    } else result = finalize(scope, baseDraft);
    maybeFreeze(scope, result, true);
    revokeScope(scope);
    if (scope.patches_) scope.patchListener_(scope.patches_, scope.inversePatches_);
    return result !== NOTHING ? result : void 0;
}
function finalize(rootScope, value) {
    if (isFrozen(value)) return value;
    var state = value[DRAFT_STATE];
    if (!state) {
        var finalValue = handleValue(value, rootScope.handledSet_, rootScope);
        return finalValue;
    }
    if (!isSameScope(state, rootScope)) return value;
    if (!state.modified_) return state.base_;
    if (!state.finalized_) {
        var callbacks_ = state.callbacks_;
        if (callbacks_) while(callbacks_.length > 0){
            var callback = callbacks_.pop();
            callback(rootScope);
        }
        generatePatchesAndFinalize(state, rootScope);
    }
    return state.copy_;
}
function maybeFreeze(scope, value) {
    var deep = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : false;
    if (!scope.parent_ && scope.immer_.autoFreeze_ && scope.canAutoFreeze_) freeze(value, deep);
}
function markStateFinalized(state) {
    state.finalized_ = true;
    state.scope_.unfinalizedDrafts_--;
}
var isSameScope = function(state, rootScope) {
    return state.scope_ === rootScope;
};
var EMPTY_LOCATIONS_RESULT = [];
function updateDraftInParent(parent, draftValue, finalizedValue, originalKey) {
    var _a;
    var parentCopy = latest(parent);
    var parentType = parent.type_;
    if (originalKey !== void 0) {
        var currentValue = get(parentCopy, originalKey, parentType);
        if (currentValue === draftValue) {
            set(parentCopy, originalKey, finalizedValue, parentType);
            return;
        }
    }
    if (!parent.draftLocations_) {
        var draftLocations = parent.draftLocations_ = /* @__PURE__ */ new Map();
        each(parentCopy, function(key, value) {
            if (isDraft(value)) {
                var keys = draftLocations.get(value) || [];
                keys.push(key);
                draftLocations.set(value, keys);
            }
        });
    }
    var locations = (_a = parent.draftLocations_.get(draftValue)) != null ? _a : EMPTY_LOCATIONS_RESULT;
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = locations[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var location = _step.value;
            set(parentCopy, location, finalizedValue, parentType);
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
}
function registerChildFinalizationCallback(parent, child, key) {
    parent.callbacks_.push(function childCleanup(rootScope) {
        var _a, _b;
        var state = child;
        if (!state || !isSameScope(state, rootScope)) return;
        (_a = rootScope.mapSetPlugin_) == null || _a.fixSetContents(state);
        var finalizedValue = getFinalValue(state);
        updateDraftInParent(parent, (_b = state.draft_) != null ? _b : state, finalizedValue, key);
        generatePatchesAndFinalize(state, rootScope);
    });
}
function generatePatchesAndFinalize(state, rootScope) {
    var _a, _b;
    var shouldFinalize = state.modified_ && !state.finalized_ && (state.type_ === 3 /* Set */  || state.type_ === 1 /* Array */  && state.allIndicesReassigned_ || ((_b = (_a = state.assigned_) == null ? void 0 : _a.size) != null ? _b : 0) > 0);
    if (shouldFinalize) {
        var patchPlugin_ = rootScope.patchPlugin_;
        if (patchPlugin_) {
            var basePath = patchPlugin_.getPath(state);
            if (basePath) patchPlugin_.generatePatches_(state, basePath, rootScope);
        }
        markStateFinalized(state);
    }
}
function handleCrossReference(target, key, value) {
    var scope_ = target.scope_;
    if (isDraft(value)) {
        var state = value[DRAFT_STATE];
        if (isSameScope(state, scope_)) state.callbacks_.push(function crossReferenceCleanup() {
            prepareCopy(target);
            var finalizedValue = getFinalValue(state);
            updateDraftInParent(target, value, finalizedValue, key);
        });
    } else if (isDraftable(value)) target.callbacks_.push(function nestedDraftCleanup() {
        var _a;
        var targetCopy = latest(target);
        if (get(targetCopy, key, target.type_) === value) {
            if (scope_.drafts_.length > 1 && ((_a = target.assigned_.get(key)) != null ? _a : false) === true && target.copy_) handleValue(get(target.copy_, key, target.type_), scope_.handledSet_, scope_);
        }
    });
}
function handleValue(target, handledSet, rootScope) {
    if (!rootScope.immer_.autoFreeze_ && rootScope.unfinalizedDrafts_ < 1) return target;
    if (isDraft(target) || handledSet.has(target) || !isDraftable(target) || isFrozen(target)) return target;
    handledSet.add(target);
    each(target, function(key, value) {
        if (isDraft(value)) {
            var state = value[DRAFT_STATE];
            if (isSameScope(state, rootScope)) {
                var updatedValue = getFinalValue(state);
                set(target, key, updatedValue, target.type_);
                markStateFinalized(state);
            }
        } else if (isDraftable(value)) handleValue(value, handledSet, rootScope);
    });
    return target;
}
// src/core/proxy.ts
function createProxyProxy(base, parent) {
    var baseIsArray = isArray(base);
    var state = {
        type_: baseIsArray ? 1 /* Array */  : 0 /* Object */ ,
        // Track which produce call this is associated with.
        scope_: parent ? parent.scope_ : getCurrentScope(),
        // True for both shallow and deep changes.
        modified_: false,
        // Used during finalization.
        finalized_: false,
        // Track which properties have been assigned (true) or deleted (false).
        // actually instantiated in `prepareCopy()`
        assigned_: void 0,
        // The parent draft state.
        parent_: parent,
        // The base state.
        base_: base,
        // The base proxy.
        draft_: null,
        // set below
        // The base copy with any updated values.
        copy_: null,
        // Called by the `produce` function.
        revoke_: null,
        isManual_: false,
        // `callbacks` actually gets assigned in `createProxy`
        callbacks_: void 0
    };
    var target = state;
    var traps = objectTraps;
    if (baseIsArray) {
        target = [
            state
        ];
        traps = arrayTraps;
    }
    var _Proxy_revocable = Proxy.revocable(target, traps), revoke = _Proxy_revocable.revoke, proxy = _Proxy_revocable.proxy;
    state.draft_ = proxy;
    state.revoke_ = revoke;
    return [
        proxy,
        state
    ];
}
var objectTraps = {
    get: function(state, prop) {
        if (prop === DRAFT_STATE) return state;
        var arrayPlugin = state.scope_.arrayMethodsPlugin_;
        var isArrayWithStringProp = state.type_ === 1 /* Array */  && typeof prop === "string";
        if (isArrayWithStringProp) {
            if (arrayPlugin == null ? void 0 : arrayPlugin.isArrayOperationMethod(prop)) return arrayPlugin.createMethodInterceptor(state, prop);
        }
        var source = latest(state);
        if (!has(source, prop, state.type_)) return readPropFromProto(state, source, prop);
        var value = source[prop];
        if (state.finalized_ || !isDraftable(value)) return value;
        if (isArrayWithStringProp && state.operationMethod && (arrayPlugin == null ? void 0 : arrayPlugin.isMutatingArrayMethod(state.operationMethod)) && isArrayIndex(prop)) return value;
        if (value === peek(state.base_, prop)) {
            prepareCopy(state);
            var childKey = state.type_ === 1 /* Array */  ? +prop : prop;
            var childDraft = createProxy(state.scope_, value, state, childKey);
            return state.copy_[childKey] = childDraft;
        }
        return value;
    },
    has: function(state, prop) {
        return prop in latest(state);
    },
    ownKeys: function(state) {
        return Reflect.ownKeys(latest(state));
    },
    set: function(state, prop, value) {
        var desc = getDescriptorFromProto(latest(state), prop);
        if (desc == null ? void 0 : desc.set) {
            desc.set.call(state.draft_, value);
            return true;
        }
        if (!state.modified_) {
            var current2 = peek(latest(state), prop);
            var currentState = current2 == null ? void 0 : current2[DRAFT_STATE];
            if (currentState && currentState.base_ === value) {
                state.copy_[prop] = value;
                state.assigned_.set(prop, false);
                return true;
            }
            if (is(value, current2) && (value !== void 0 || has(state.base_, prop, state.type_))) return true;
            prepareCopy(state);
            markChanged(state);
        }
        if (state.copy_[prop] === value && // special case: handle new props with value 'undefined'
        (value !== void 0 || prop in state.copy_) || // special case: NaN
        Number.isNaN(value) && Number.isNaN(state.copy_[prop])) return true;
        state.copy_[prop] = value;
        state.assigned_.set(prop, true);
        handleCrossReference(state, prop, value);
        return true;
    },
    deleteProperty: function(state, prop) {
        prepareCopy(state);
        if (peek(state.base_, prop) !== void 0 || prop in state.base_) {
            state.assigned_.set(prop, false);
            markChanged(state);
        } else state.assigned_.delete(prop);
        if (state.copy_) delete state.copy_[prop];
        return true;
    },
    // Note: We never coerce `desc.value` into an Immer draft, because we can't make
    // the same guarantee in ES5 mode.
    getOwnPropertyDescriptor: function(state, prop) {
        var owner = latest(state);
        var desc = Reflect.getOwnPropertyDescriptor(owner, prop);
        if (!desc) return desc;
        var _obj;
        return _obj = {}, (0, $72osQ._)(_obj, WRITABLE, true), (0, $72osQ._)(_obj, CONFIGURABLE, state.type_ !== 1 /* Array */  || prop !== "length"), (0, $72osQ._)(_obj, ENUMERABLE, desc[ENUMERABLE]), (0, $72osQ._)(_obj, VALUE, owner[prop]), _obj;
    },
    defineProperty: function() {
        die(11);
    },
    getPrototypeOf: function(state) {
        return getPrototypeOf(state.base_);
    },
    setPrototypeOf: function() {
        die(12);
    }
};
var arrayTraps = {};
each(objectTraps, function(key, fn) {
    arrayTraps[key] = function() {
        var args = arguments;
        args[0] = args[0][0];
        return fn.apply(this, args);
    };
});
arrayTraps.deleteProperty = function(state, prop) {
    return arrayTraps.set.call(this, state, prop, void 0);
};
arrayTraps.set = function(state, prop, value) {
    return objectTraps.set.call(this, state[0], prop, value, state[0]);
};
function peek(draft, prop) {
    var state = draft[DRAFT_STATE];
    var source = state ? latest(state) : draft;
    return source[prop];
}
function readPropFromProto(state, source, prop) {
    var _a;
    var desc = getDescriptorFromProto(source, prop);
    return desc ? VALUE in desc ? desc[VALUE] : // This is a very special case, if the prop is a getter defined by the
    // prototype, we should invoke it with the draft as context!
    (_a = desc.get) == null ? void 0 : _a.call(state.draft_) : void 0;
}
function getDescriptorFromProto(source, prop) {
    if (!(prop in source)) return void 0;
    var proto = getPrototypeOf(source);
    while(proto){
        var desc = Object.getOwnPropertyDescriptor(proto, prop);
        if (desc) return desc;
        proto = getPrototypeOf(proto);
    }
    return void 0;
}
function markChanged(state) {
    if (!state.modified_) {
        state.modified_ = true;
        if (state.parent_) markChanged(state.parent_);
    }
}
function prepareCopy(state) {
    if (!state.copy_) {
        state.assigned_ = /* @__PURE__ */ new Map();
        state.copy_ = shallowCopy(state.base_, state.scope_.immer_.useStrictShallowCopy_);
    }
}
// src/core/immerClass.ts
var Immer2 = /*#__PURE__*/ function() {
    "use strict";
    function Immer2(config) {
        var _this = this;
        (0, $grujF._)(this, Immer2);
        this.autoFreeze_ = true;
        this.useStrictShallowCopy_ = false;
        this.useStrictIteration_ = false;
        /**
     * The `produce` function takes a value and a "recipe function" (whose
     * return value often depends on the base state). The recipe function is
     * free to mutate its first argument however it wants. All mutations are
     * only ever applied to a __copy__ of the base state.
     *
     * Pass only a function to create a "curried producer" which relieves you
     * from passing the recipe function every time.
     *
     * Only plain objects and arrays are made mutable. All other objects are
     * considered uncopyable.
     *
     * Note: This function is __bound__ to its `Immer` instance.
     *
     * @param {any} base - the initial state
     * @param {Function} recipe - function that receives a proxy of the base state as first argument and which can be freely modified
     * @param {Function} patchListener - optional function that will be called with all the patches produced here
     * @returns {any} a new state, or the initial state if nothing was modified
     */ this.produce = function(base, recipe, patchListener) {
            if (isFunction(base) && !isFunction(recipe)) {
                var defaultBase = recipe;
                recipe = base;
                var self = _this;
                return function curriedProduce() {
                    var _this = this;
                    var base2 = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : defaultBase;
                    for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++){
                        args[_key - 1] = arguments[_key];
                    }
                    var _recipe;
                    return self.produce(base2, function(draft) {
                        return (_recipe = recipe).call.apply(_recipe, [
                            _this,
                            draft
                        ].concat((0, $2us1u._)(args)));
                    });
                };
            }
            if (!isFunction(recipe)) die(6);
            if (patchListener !== void 0 && !isFunction(patchListener)) die(7);
            var result;
            if (isDraftable(base)) {
                var scope = enterScope(_this);
                var proxy = createProxy(scope, base, void 0);
                var hasError = true;
                try {
                    result = recipe(proxy);
                    hasError = false;
                } finally{
                    if (hasError) revokeScope(scope);
                    else leaveScope(scope);
                }
                usePatchesInScope(scope, patchListener);
                return processResult(result, scope);
            } else if (!base || !isObjectish(base)) {
                result = recipe(base);
                if (result === void 0) result = base;
                if (result === NOTHING) result = void 0;
                if (_this.autoFreeze_) freeze(result, true);
                if (patchListener) {
                    var p = [];
                    var ip = [];
                    getPlugin(PluginPatches).generateReplacementPatches_(base, result, {
                        patches_: p,
                        inversePatches_: ip
                    });
                    patchListener(p, ip);
                }
                return result;
            } else die(1, base);
        };
        this.produceWithPatches = function(base, recipe) {
            var _this1 = _this;
            if (isFunction(base)) return function(state) {
                for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++){
                    args[_key - 1] = arguments[_key];
                }
                return _this1.produceWithPatches(state, function(draft) {
                    return base.apply(void 0, [
                        draft
                    ].concat((0, $2us1u._)(args)));
                });
            };
            var patches, inversePatches;
            var result = _this.produce(base, recipe, function(p, ip) {
                patches = p;
                inversePatches = ip;
            });
            return [
                result,
                patches,
                inversePatches
            ];
        };
        if (isBoolean(config == null ? void 0 : config.autoFreeze)) this.setAutoFreeze(config.autoFreeze);
        if (isBoolean(config == null ? void 0 : config.useStrictShallowCopy)) this.setUseStrictShallowCopy(config.useStrictShallowCopy);
        if (isBoolean(config == null ? void 0 : config.useStrictIteration)) this.setUseStrictIteration(config.useStrictIteration);
    }
    (0, $dhMkv._)(Immer2, [
        {
            key: "createDraft",
            value: function createDraft(base) {
                if (!isDraftable(base)) die(8);
                if (isDraft(base)) base = current(base);
                var scope = enterScope(this);
                var proxy = createProxy(scope, base, void 0);
                proxy[DRAFT_STATE].isManual_ = true;
                leaveScope(scope);
                return proxy;
            }
        },
        {
            key: "finishDraft",
            value: function finishDraft(draft, patchListener) {
                var state = draft && draft[DRAFT_STATE];
                if (!state || !state.isManual_) die(9);
                var scope = state.scope_;
                usePatchesInScope(scope, patchListener);
                return processResult(void 0, scope);
            }
        },
        {
            /**
   * Pass true to automatically freeze all copies created by Immer.
   *
   * By default, auto-freezing is enabled.
   */ key: "setAutoFreeze",
            value: function setAutoFreeze(value) {
                this.autoFreeze_ = value;
            }
        },
        {
            /**
   * Pass true to enable strict shallow copy.
   *
   * By default, immer does not copy the object descriptors such as getter, setter and non-enumrable properties.
   */ key: "setUseStrictShallowCopy",
            value: function setUseStrictShallowCopy(value) {
                this.useStrictShallowCopy_ = value;
            }
        },
        {
            /**
   * Pass false to use faster iteration that skips non-enumerable properties
   * but still handles symbols for compatibility.
   *
   * By default, strict iteration is enabled (includes all own properties).
   */ key: "setUseStrictIteration",
            value: function setUseStrictIteration(value) {
                this.useStrictIteration_ = value;
            }
        },
        {
            key: "shouldUseStrictIteration",
            value: function shouldUseStrictIteration() {
                return this.useStrictIteration_;
            }
        },
        {
            key: "applyPatches",
            value: function applyPatches(base, patches) {
                var i;
                for(i = patches.length - 1; i >= 0; i--){
                    var patch = patches[i];
                    if (patch.path.length === 0 && patch.op === "replace") {
                        base = patch.value;
                        break;
                    }
                }
                if (i > -1) patches = patches.slice(i + 1);
                var applyPatchesImpl = getPlugin(PluginPatches).applyPatches_;
                if (isDraft(base)) return applyPatchesImpl(base, patches);
                return this.produce(base, function(draft) {
                    return applyPatchesImpl(draft, patches);
                });
            }
        }
    ]);
    return Immer2;
}();
function createProxy(rootScope, value, parent, key) {
    var _a, _b;
    var _ref = (0, $2nwvT._)(isMap(value) ? getPlugin(PluginMapSet).proxyMap_(value, parent) : isSet(value) ? getPlugin(PluginMapSet).proxySet_(value, parent) : createProxyProxy(value, parent), 2), draft = _ref[0], state = _ref[1];
    var scope = (_a = parent == null ? void 0 : parent.scope_) != null ? _a : getCurrentScope();
    scope.drafts_.push(draft);
    state.callbacks_ = (_b = parent == null ? void 0 : parent.callbacks_) != null ? _b : [];
    state.key_ = key;
    if (parent && key !== void 0) registerChildFinalizationCallback(parent, state, key);
    else state.callbacks_.push(function rootDraftCleanup(rootScope2) {
        var _a2;
        (_a2 = rootScope2.mapSetPlugin_) == null || _a2.fixSetContents(state);
        var patchPlugin_ = rootScope2.patchPlugin_;
        if (state.modified_ && patchPlugin_) patchPlugin_.generatePatches_(state, [], rootScope2);
    });
    return draft;
}
// src/core/current.ts
function current(value) {
    if (!isDraft(value)) die(10, value);
    return currentImpl(value);
}
function currentImpl(value) {
    if (!isDraftable(value) || isFrozen(value)) return value;
    var state = value[DRAFT_STATE];
    var copy;
    var strict = true;
    if (state) {
        if (!state.modified_) return state.base_;
        state.finalized_ = true;
        copy = shallowCopy(value, state.scope_.immer_.useStrictShallowCopy_);
        strict = state.scope_.immer_.shouldUseStrictIteration();
    } else copy = shallowCopy(value, true);
    each(copy, function(key, childValue) {
        set(copy, key, currentImpl(childValue));
    }, strict);
    if (state) state.finalized_ = false;
    return copy;
}
// src/plugins/patches.ts
function enablePatches() {
    var errorOffset = 16;
    function getPath(state) {
        var path = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : [];
        var _a;
        if ("key_" in state && state.key_ !== void 0) {
            var parentCopy = (_a = state.parent_.copy_) != null ? _a : state.parent_.base_;
            var proxyDraft = getProxyDraft(get(parentCopy, state.key_));
            var valueAtKey = get(parentCopy, state.key_);
            if (valueAtKey === void 0) return null;
            if (valueAtKey !== state.draft_ && valueAtKey !== state.base_ && valueAtKey !== state.copy_) return null;
            if (proxyDraft != null && proxyDraft.base_ !== state.base_) return null;
            var isSet2 = state.parent_.type_ === 3 /* Set */ ;
            var key;
            if (isSet2) {
                var setParent = state.parent_;
                key = Array.from(setParent.drafts_.keys()).indexOf(state.key_);
            } else key = state.key_;
            if (!(isSet2 && parentCopy.size > key || has(parentCopy, key))) return null;
            path.push(key);
        }
        if (state.parent_) return getPath(state.parent_, path);
        path.reverse();
        try {
            resolvePath(state.copy_, path);
        } catch (e) {
            return null;
        }
        return path;
    }
    function resolvePath(base, path) {
        var current2 = base;
        for(var i = 0; i < path.length - 1; i++){
            var key = path[i];
            current2 = get(current2, key);
            if (!isObjectish(current2) || current2 === null) throw new Error("Cannot resolve path at '".concat(path.join("/"), "'"));
        }
        return current2;
    }
    var REPLACE = "replace";
    var ADD = "add";
    var REMOVE = "remove";
    function generatePatches_(state, basePath, scope) {
        if (state.scope_.processedForPatches_.has(state)) return;
        state.scope_.processedForPatches_.add(state);
        var patches_ = scope.patches_, inversePatches_ = scope.inversePatches_;
        switch(state.type_){
            case 0 /* Object */ :
            case 2 /* Map */ :
                return generatePatchesFromAssigned(state, basePath, patches_, inversePatches_);
            case 1 /* Array */ :
                return generateArrayPatches(state, basePath, patches_, inversePatches_);
            case 3 /* Set */ :
                return generateSetPatches(state, basePath, patches_, inversePatches_);
        }
    }
    function generateArrayPatches(state, basePath, patches, inversePatches) {
        var base_ = state.base_, assigned_ = state.assigned_;
        var copy_ = state.copy_;
        if (copy_.length < base_.length) {
            var ref;
            ref = [
                copy_,
                base_
            ], base_ = ref[0], copy_ = ref[1], ref;
            var ref1;
            ref1 = [
                inversePatches,
                patches
            ], patches = ref1[0], inversePatches = ref1[1], ref1;
        }
        var allReassigned = state.allIndicesReassigned_ === true;
        for(var i = 0; i < base_.length; i++){
            var copiedItem = copy_[i];
            var baseItem = base_[i];
            var isAssigned = allReassigned || (assigned_ == null ? void 0 : assigned_.get(i.toString()));
            if (isAssigned && copiedItem !== baseItem) {
                var childState = copiedItem == null ? void 0 : copiedItem[DRAFT_STATE];
                if (childState && childState.modified_) continue;
                var path = basePath.concat([
                    i
                ]);
                patches.push({
                    op: REPLACE,
                    path: path,
                    // Need to maybe clone it, as it can in fact be the original value
                    // due to the base/copy inversion at the start of this function
                    value: clonePatchValueIfNeeded(copiedItem)
                });
                inversePatches.push({
                    op: REPLACE,
                    path: path,
                    value: clonePatchValueIfNeeded(baseItem)
                });
            }
        }
        for(var i1 = base_.length; i1 < copy_.length; i1++){
            var path1 = basePath.concat([
                i1
            ]);
            patches.push({
                op: ADD,
                path: path1,
                // Need to maybe clone it, as it can in fact be the original value
                // due to the base/copy inversion at the start of this function
                value: clonePatchValueIfNeeded(copy_[i1])
            });
        }
        for(var i2 = copy_.length - 1; base_.length <= i2; --i2){
            var path2 = basePath.concat([
                i2
            ]);
            inversePatches.push({
                op: REMOVE,
                path: path2
            });
        }
    }
    function generatePatchesFromAssigned(state, basePath, patches, inversePatches) {
        var base_ = state.base_, copy_ = state.copy_, type_ = state.type_;
        each(state.assigned_, function(key, assignedValue) {
            var origValue = get(base_, key, type_);
            var value = get(copy_, key, type_);
            var op = !assignedValue ? REMOVE : has(base_, key) ? REPLACE : ADD;
            if (origValue === value && op === REPLACE) return;
            var path = basePath.concat(key);
            patches.push(op === REMOVE ? {
                op: op,
                path: path
            } : {
                op: op,
                path: path,
                value: clonePatchValueIfNeeded(value)
            });
            inversePatches.push(op === ADD ? {
                op: REMOVE,
                path: path
            } : op === REMOVE ? {
                op: ADD,
                path: path,
                value: clonePatchValueIfNeeded(origValue)
            } : {
                op: REPLACE,
                path: path,
                value: clonePatchValueIfNeeded(origValue)
            });
        });
    }
    function generateSetPatches(state, basePath, patches, inversePatches) {
        var base_ = state.base_, copy_ = state.copy_;
        var i = 0;
        base_.forEach(function(value) {
            if (!copy_.has(value)) {
                var path = basePath.concat([
                    i
                ]);
                patches.push({
                    op: REMOVE,
                    path: path,
                    value: value
                });
                inversePatches.unshift({
                    op: ADD,
                    path: path,
                    value: value
                });
            }
            i++;
        });
        i = 0;
        copy_.forEach(function(value) {
            if (!base_.has(value)) {
                var path = basePath.concat([
                    i
                ]);
                patches.push({
                    op: ADD,
                    path: path,
                    value: value
                });
                inversePatches.unshift({
                    op: REMOVE,
                    path: path,
                    value: value
                });
            }
            i++;
        });
    }
    function generateReplacementPatches_(baseValue, replacement, scope) {
        var patches_ = scope.patches_, inversePatches_ = scope.inversePatches_;
        patches_.push({
            op: REPLACE,
            path: [],
            value: replacement === NOTHING ? void 0 : replacement
        });
        inversePatches_.push({
            op: REPLACE,
            path: [],
            value: baseValue
        });
    }
    function applyPatches_(draft, patches) {
        patches.forEach(function(patch) {
            var path = patch.path, op = patch.op;
            var base = draft;
            for(var i = 0; i < path.length - 1; i++){
                var parentType = getArchtype(base);
                var p = path[i];
                if (typeof p !== "string" && typeof p !== "number") p = "" + p;
                if ((parentType === 0 /* Object */  || parentType === 1 /* Array */ ) && (p === "__proto__" || p === CONSTRUCTOR)) die(errorOffset + 3);
                if (isFunction(base) && p === PROTOTYPE) die(errorOffset + 3);
                base = get(base, p);
                if (!isObjectish(base)) die(errorOffset + 2, path.join("/"));
            }
            var type = getArchtype(base);
            var value = deepClonePatchValue(patch.value);
            var key = path[path.length - 1];
            switch(op){
                case REPLACE:
                    switch(type){
                        case 2 /* Map */ :
                            return base.set(key, value);
                        case 3 /* Set */ :
                            die(errorOffset);
                        default:
                            return base[key] = value;
                    }
                case ADD:
                    switch(type){
                        case 1 /* Array */ :
                            return key === "-" ? base.push(value) : base.splice(key, 0, value);
                        case 2 /* Map */ :
                            return base.set(key, value);
                        case 3 /* Set */ :
                            return base.add(value);
                        default:
                            return base[key] = value;
                    }
                case REMOVE:
                    switch(type){
                        case 1 /* Array */ :
                            return base.splice(key, 1);
                        case 2 /* Map */ :
                            return base.delete(key);
                        case 3 /* Set */ :
                            return base.delete(patch.value);
                        default:
                            return delete base[key];
                    }
                default:
                    die(errorOffset + 1, op);
            }
        });
        return draft;
    }
    function deepClonePatchValue(obj) {
        if (!isDraftable(obj)) return obj;
        if (isArray(obj)) return obj.map(deepClonePatchValue);
        if (isMap(obj)) return new Map(Array.from(obj.entries()).map(function(param) {
            var _param = (0, $2nwvT._)(param, 2), k = _param[0], v = _param[1];
            return [
                k,
                deepClonePatchValue(v)
            ];
        }));
        if (isSet(obj)) return new Set(Array.from(obj).map(deepClonePatchValue));
        var cloned = Object.create(getPrototypeOf(obj));
        for(var key in obj)cloned[key] = deepClonePatchValue(obj[key]);
        if (has(obj, DRAFTABLE)) cloned[DRAFTABLE] = obj[DRAFTABLE];
        return cloned;
    }
    function clonePatchValueIfNeeded(obj) {
        if (isDraft(obj)) return deepClonePatchValue(obj);
        else return obj;
    }
    loadPlugin(PluginPatches, {
        applyPatches_: applyPatches_,
        generatePatches_: generatePatches_,
        generateReplacementPatches_: generateReplacementPatches_,
        getPath: getPath
    });
}
// src/plugins/mapset.ts
function enableMapSet() {
    var DraftMap = /*#__PURE__*/ function(Map1) {
        "use strict";
        (0, $j6Mzi._)(DraftMap, Map1);
        function DraftMap(target, parent) {
            (0, $grujF._)(this, DraftMap);
            var _this;
            _this = (0, $f3Okx._)(this, DraftMap);
            _this[DRAFT_STATE] = {
                type_: 2 /* Map */ ,
                parent_: parent,
                scope_: parent ? parent.scope_ : getCurrentScope(),
                modified_: false,
                finalized_: false,
                copy_: void 0,
                assigned_: void 0,
                base_: target,
                draft_: _this,
                isManual_: false,
                revoked_: false,
                callbacks_: []
            };
            return _this;
        }
        (0, $dhMkv._)(DraftMap, [
            {
                key: "size",
                get: function get() {
                    return latest(this[DRAFT_STATE]).size;
                }
            },
            {
                key: "has",
                value: function has(key) {
                    return latest(this[DRAFT_STATE]).has(key);
                }
            },
            {
                key: "set",
                value: function set(key, value) {
                    var state = this[DRAFT_STATE];
                    assertUnrevoked(state);
                    if (!latest(state).has(key) || latest(state).get(key) !== value) {
                        prepareMapCopy(state);
                        markChanged(state);
                        state.assigned_.set(key, true);
                        state.copy_.set(key, value);
                        state.assigned_.set(key, true);
                    }
                    return this;
                }
            },
            {
                key: "delete",
                value: function _delete(key) {
                    if (!this.has(key)) return false;
                    var state = this[DRAFT_STATE];
                    assertUnrevoked(state);
                    prepareMapCopy(state);
                    markChanged(state);
                    if (state.base_.has(key)) state.assigned_.set(key, false);
                    else state.assigned_.delete(key);
                    state.copy_.delete(key);
                    return true;
                }
            },
            {
                key: "clear",
                value: function clear() {
                    var state = this[DRAFT_STATE];
                    assertUnrevoked(state);
                    if (latest(state).size) {
                        prepareMapCopy(state);
                        markChanged(state);
                        state.assigned_ = /* @__PURE__ */ new Map();
                        each(state.base_, function(key) {
                            state.assigned_.set(key, false);
                        });
                        state.copy_.clear();
                    }
                }
            },
            {
                key: "forEach",
                value: function forEach(cb, thisArg) {
                    var _this = this;
                    var state = this[DRAFT_STATE];
                    latest(state).forEach(function(_value, key, _map) {
                        cb.call(thisArg, _this.get(key), key, _this);
                    });
                }
            },
            {
                key: "get",
                value: function get(key) {
                    var state = this[DRAFT_STATE];
                    assertUnrevoked(state);
                    var value = latest(state).get(key);
                    if (state.finalized_ || !isDraftable(value)) return value;
                    if (value !== state.base_.get(key)) return value;
                    var draft = createProxy(state.scope_, value, state, key);
                    prepareMapCopy(state);
                    state.copy_.set(key, draft);
                    return draft;
                }
            },
            {
                key: "keys",
                value: function keys() {
                    return latest(this[DRAFT_STATE]).keys();
                }
            },
            {
                key: "values",
                value: function values() {
                    var _this = this;
                    var iterator = this.keys();
                    var _obj;
                    return _obj = {}, (0, $72osQ._)(_obj, Symbol.iterator, function() {
                        return _this.values();
                    }), (0, $72osQ._)(_obj, "next", function() {
                        var r = iterator.next();
                        if (r.done) return r;
                        var value = _this.get(r.value);
                        return {
                            done: false,
                            value: value
                        };
                    }), _obj;
                }
            },
            {
                key: "entries",
                value: function entries() {
                    var _this = this;
                    var iterator = this.keys();
                    var _obj;
                    return _obj = {}, (0, $72osQ._)(_obj, Symbol.iterator, function() {
                        return _this.entries();
                    }), (0, $72osQ._)(_obj, "next", function() {
                        var r = iterator.next();
                        if (r.done) return r;
                        var value = _this.get(r.value);
                        return {
                            done: false,
                            value: [
                                r.value,
                                value
                            ]
                        };
                    }), _obj;
                }
            },
            {
                key: (DRAFT_STATE, Symbol.iterator),
                value: function value() {
                    return this.entries();
                }
            }
        ]);
        return DraftMap;
    }((0, $1EZOw._)(Map));
    function proxyMap_(target, parent) {
        var map = new DraftMap(target, parent);
        return [
            map,
            map[DRAFT_STATE]
        ];
    }
    function prepareMapCopy(state) {
        if (!state.copy_) {
            state.assigned_ = /* @__PURE__ */ new Map();
            state.copy_ = new Map(state.base_);
        }
    }
    var DraftSet = /*#__PURE__*/ function(Set1) {
        "use strict";
        (0, $j6Mzi._)(DraftSet, Set1);
        function DraftSet(target, parent) {
            (0, $grujF._)(this, DraftSet);
            var _this;
            _this = (0, $f3Okx._)(this, DraftSet);
            _this[DRAFT_STATE] = {
                type_: 3 /* Set */ ,
                parent_: parent,
                scope_: parent ? parent.scope_ : getCurrentScope(),
                modified_: false,
                finalized_: false,
                copy_: void 0,
                base_: target,
                draft_: _this,
                drafts_: /* @__PURE__ */ new Map(),
                revoked_: false,
                isManual_: false,
                assigned_: void 0,
                callbacks_: []
            };
            return _this;
        }
        (0, $dhMkv._)(DraftSet, [
            {
                key: "size",
                get: function get() {
                    return latest(this[DRAFT_STATE]).size;
                }
            },
            {
                key: "has",
                value: function has(value) {
                    var state = this[DRAFT_STATE];
                    assertUnrevoked(state);
                    if (!state.copy_) return state.base_.has(value);
                    if (state.copy_.has(value)) return true;
                    if (state.drafts_.has(value) && state.copy_.has(state.drafts_.get(value))) return true;
                    return false;
                }
            },
            {
                key: "add",
                value: function add(value) {
                    var state = this[DRAFT_STATE];
                    assertUnrevoked(state);
                    if (!this.has(value)) {
                        prepareSetCopy(state);
                        markChanged(state);
                        state.copy_.add(value);
                    }
                    return this;
                }
            },
            {
                key: "delete",
                value: function _delete(value) {
                    if (!this.has(value)) return false;
                    var state = this[DRAFT_STATE];
                    assertUnrevoked(state);
                    prepareSetCopy(state);
                    markChanged(state);
                    return state.copy_.delete(value) || (state.drafts_.has(value) ? state.copy_.delete(state.drafts_.get(value)) : /* istanbul ignore next */ false);
                }
            },
            {
                key: "clear",
                value: function clear() {
                    var state = this[DRAFT_STATE];
                    assertUnrevoked(state);
                    if (latest(state).size) {
                        prepareSetCopy(state);
                        markChanged(state);
                        state.copy_.clear();
                    }
                }
            },
            {
                key: "values",
                value: function values() {
                    var state = this[DRAFT_STATE];
                    assertUnrevoked(state);
                    prepareSetCopy(state);
                    return state.copy_.values();
                }
            },
            {
                key: "entries",
                value: function entries() {
                    var state = this[DRAFT_STATE];
                    assertUnrevoked(state);
                    prepareSetCopy(state);
                    return state.copy_.entries();
                }
            },
            {
                key: "keys",
                value: function keys() {
                    return this.values();
                }
            },
            {
                key: (DRAFT_STATE, Symbol.iterator),
                value: function value() {
                    return this.values();
                }
            },
            {
                key: "forEach",
                value: function forEach(cb, thisArg) {
                    var iterator = this.values();
                    var result = iterator.next();
                    while(!result.done){
                        cb.call(thisArg, result.value, result.value, this);
                        result = iterator.next();
                    }
                }
            }
        ]);
        return DraftSet;
    }((0, $1EZOw._)(Set));
    function proxySet_(target, parent) {
        var set2 = new DraftSet(target, parent);
        return [
            set2,
            set2[DRAFT_STATE]
        ];
    }
    function prepareSetCopy(state) {
        if (!state.copy_) {
            state.copy_ = /* @__PURE__ */ new Set();
            state.base_.forEach(function(value) {
                if (isDraftable(value)) {
                    var draft = createProxy(state.scope_, value, state, value);
                    state.drafts_.set(value, draft);
                    state.copy_.add(draft);
                } else state.copy_.add(value);
            });
        }
    }
    function assertUnrevoked(state) {
        if (state.revoked_) die(3, JSON.stringify(latest(state)));
    }
    function fixSetContents(target) {
        if (target.type_ === 3 /* Set */  && target.copy_) {
            var copy = new Set(target.copy_);
            target.copy_.clear();
            copy.forEach(function(value) {
                target.copy_.add(getValue(value));
            });
        }
    }
    loadPlugin(PluginMapSet, {
        proxyMap_: proxyMap_,
        proxySet_: proxySet_,
        fixSetContents: fixSetContents
    });
}
// src/plugins/arrayMethods.ts
function enableArrayMethods() {
    var SHIFTING_METHODS = /* @__PURE__ */ new Set([
        "shift",
        "unshift"
    ]);
    var QUEUE_METHODS = /* @__PURE__ */ new Set([
        "push",
        "pop"
    ]);
    var RESULT_RETURNING_METHODS = /* @__PURE__ */ new Set((0, $2us1u._)(QUEUE_METHODS).concat((0, $2us1u._)(SHIFTING_METHODS)));
    var REORDERING_METHODS = /* @__PURE__ */ new Set([
        "reverse",
        "sort"
    ]);
    var MUTATING_METHODS = /* @__PURE__ */ new Set((0, $2us1u._)(RESULT_RETURNING_METHODS).concat((0, $2us1u._)(REORDERING_METHODS), [
        "splice"
    ]));
    var FIND_METHODS = /* @__PURE__ */ new Set([
        "find",
        "findLast"
    ]);
    var NON_MUTATING_METHODS = /* @__PURE__ */ new Set([
        "filter",
        "slice",
        "concat",
        "flat"
    ].concat((0, $2us1u._)(FIND_METHODS), [
        "findIndex",
        "findLastIndex",
        "some",
        "every",
        "indexOf",
        "lastIndexOf",
        "includes",
        "join",
        "toString",
        "toLocaleString"
    ]));
    function isMutatingArrayMethod(method) {
        return MUTATING_METHODS.has(method);
    }
    function isNonMutatingArrayMethod(method) {
        return NON_MUTATING_METHODS.has(method);
    }
    function isArrayOperationMethod(method) {
        return isMutatingArrayMethod(method) || isNonMutatingArrayMethod(method);
    }
    function enterOperation(state, method) {
        state.operationMethod = method;
    }
    function exitOperation(state) {
        state.operationMethod = void 0;
    }
    function executeArrayMethod(state, operation) {
        var markLength = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : true;
        prepareCopy(state);
        var result = operation();
        markChanged(state);
        if (markLength) state.assigned_.set("length", true);
        return result;
    }
    function markAllIndicesReassigned(state) {
        state.allIndicesReassigned_ = true;
    }
    function normalizeSliceIndex(index, length) {
        if (index < 0) return Math.max(length + index, 0);
        return Math.min(index, length);
    }
    function handleSimpleOperation(state, method, args) {
        return executeArrayMethod(state, function() {
            var _state_copy_;
            var result = (_state_copy_ = state.copy_)[method].apply(_state_copy_, (0, $2us1u._)(args));
            if (SHIFTING_METHODS.has(method)) markAllIndicesReassigned(state);
            return RESULT_RETURNING_METHODS.has(method) ? result : state.draft_;
        });
    }
    function handleReorderingOperation(state, method, args) {
        return executeArrayMethod(state, function() {
            var _state_copy_;
            (_state_copy_ = state.copy_)[method].apply(_state_copy_, (0, $2us1u._)(args));
            markAllIndicesReassigned(state);
            return state.draft_;
        }, false);
    }
    function createMethodInterceptor(state, originalMethod) {
        return function interceptedMethod() {
            for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
                args[_key] = arguments[_key];
            }
            var method = originalMethod;
            enterOperation(state, method);
            try {
                if (isMutatingArrayMethod(method)) {
                    if (RESULT_RETURNING_METHODS.has(method)) return handleSimpleOperation(state, method, args);
                    if (REORDERING_METHODS.has(method)) return handleReorderingOperation(state, method, args);
                    if (method === "splice") {
                        var _state_copy_;
                        var res = executeArrayMethod(state, function() {
                            return (_state_copy_ = state.copy_).splice.apply(_state_copy_, (0, $2us1u._)(args));
                        });
                        markAllIndicesReassigned(state);
                        return res;
                    }
                } else return handleNonMutatingOperation(state, method, args);
            } finally{
                exitOperation(state);
            }
        };
    }
    function handleNonMutatingOperation(state, method, args) {
        var _source;
        var _a, _b;
        var source = latest(state);
        if (method === "filter") {
            var predicate = args[0];
            var result = [];
            for(var i = 0; i < source.length; i++)if (predicate(source[i], i, source)) result.push(state.draft_[i]);
            return result;
        }
        if (FIND_METHODS.has(method)) {
            var predicate1 = args[0];
            var isForward = method === "find";
            var step = isForward ? 1 : -1;
            var start = isForward ? 0 : source.length - 1;
            for(var i1 = start; i1 >= 0 && i1 < source.length; i1 += step){
                if (predicate1(source[i1], i1, source)) return state.draft_[i1];
            }
            return void 0;
        }
        if (method === "slice") {
            var rawStart = (_a = args[0]) != null ? _a : 0;
            var rawEnd = (_b = args[1]) != null ? _b : source.length;
            var start1 = normalizeSliceIndex(rawStart, source.length);
            var end = normalizeSliceIndex(rawEnd, source.length);
            var result1 = [];
            for(var i2 = start1; i2 < end; i2++)result1.push(state.draft_[i2]);
            return result1;
        }
        return (_source = source)[method].apply(_source, (0, $2us1u._)(args));
    }
    loadPlugin(PluginArrayMethods, {
        createMethodInterceptor: createMethodInterceptor,
        isArrayOperationMethod: isArrayOperationMethod,
        isMutatingArrayMethod: isMutatingArrayMethod
    });
}
// src/immer.ts
var immer = new Immer2();
var produce = immer.produce;
var produceWithPatches = /* @__PURE__ */ immer.produceWithPatches.bind(immer);
var setAutoFreeze = /* @__PURE__ */ immer.setAutoFreeze.bind(immer);
var setUseStrictShallowCopy = /* @__PURE__ */ immer.setUseStrictShallowCopy.bind(immer);
var setUseStrictIteration = /* @__PURE__ */ immer.setUseStrictIteration.bind(immer);
var applyPatches = /* @__PURE__ */ immer.applyPatches.bind(immer);
var createDraft = /* @__PURE__ */ immer.createDraft.bind(immer);
var finishDraft = /* @__PURE__ */ immer.finishDraft.bind(immer);
var castDraft = function(value) {
    return value;
};
var castImmutable = function(value) {
    return value;
};

});

parcelRegister("4EGqz", function(module, exports) {

module.exports = (parcelRequire("dxJzZ"))($parcel$resolve("35cQq")).then(function() {
    return parcelRequire('82X7V');
});

});
parcelRegister("dxJzZ", function(module, exports) {
"use strict";

var $dzhUQ = parcelRequire("dzhUQ");
module.exports = $dzhUQ(function(bundle) {
    return new Promise(function(resolve, reject) {
        // Don't insert the same script twice (e.g. if it was already in the HTML)
        var existingScripts = document.getElementsByTagName('script');
        if ([].concat(existingScripts).some(function(script) {
            return script.src === bundle;
        })) {
            resolve();
            return;
        }
        var preloadLink = document.createElement('link');
        preloadLink.href = bundle;
        preloadLink.rel = 'preload';
        preloadLink.as = 'script';
        document.head.appendChild(preloadLink);
        var script = document.createElement('script');
        script.async = true;
        script.type = 'text/javascript';
        script.src = bundle;
        script.onerror = function(e) {
            var error = new TypeError("Failed to fetch dynamically imported module: ".concat(bundle, ". Error: ").concat(e.message));
            script.onerror = script.onload = null;
            script.remove();
            reject(error);
        };
        script.onload = function() {
            script.onerror = script.onload = null;
            resolve();
        };
        document.getElementsByTagName('head')[0].appendChild(script);
    });
});

});
parcelRegister("dzhUQ", function(module, exports) {
"use strict";
var $9e0c70f198b0df6a$var$cachedBundles = {};
var $9e0c70f198b0df6a$var$cachedPreloads = {};
var $9e0c70f198b0df6a$var$cachedPrefetches = {};
function $9e0c70f198b0df6a$var$getCache(type) {
    switch(type){
        case 'preload':
            return $9e0c70f198b0df6a$var$cachedPreloads;
        case 'prefetch':
            return $9e0c70f198b0df6a$var$cachedPrefetches;
        default:
            return $9e0c70f198b0df6a$var$cachedBundles;
    }
}
module.exports = function(loader, type) {
    return function(bundle) {
        var cache = $9e0c70f198b0df6a$var$getCache(type);
        if (cache[bundle]) return cache[bundle];
        return cache[bundle] = loader.apply(null, arguments).catch(function(e) {
            delete cache[bundle];
            throw e;
        });
    };
};

});



var $6e800bfff3f0224d$exports = {};
$parcel$extendImportMap({
    "35cQq": "Grocery.d6fa9342.js"
});


var $2nwvT = parcelRequire("2nwvT");

var $iD4WH = parcelRequire("iD4WH");

var $dQFEZ = parcelRequire("dQFEZ");
var $8dbfa3fee6dc40a7$exports = {};

$parcel$export($8dbfa3fee6dc40a7$exports, "createRoot", function () { return $8dbfa3fee6dc40a7$export$882461b6382ed46c; }, function (v) { return $8dbfa3fee6dc40a7$export$882461b6382ed46c = v; });
$parcel$export($8dbfa3fee6dc40a7$exports, "hydrateRoot", function () { return $8dbfa3fee6dc40a7$export$757ceba2d55c277e; }, function (v) { return $8dbfa3fee6dc40a7$export$757ceba2d55c277e = v; });
var $8dbfa3fee6dc40a7$export$882461b6382ed46c;
var $8dbfa3fee6dc40a7$export$757ceba2d55c277e;
'use strict';
var $4288f0eb191085d1$exports = {};
'use strict';
function $4288f0eb191085d1$var$checkDCE() {
    /* global __REACT_DEVTOOLS_GLOBAL_HOOK__ */ if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ === 'undefined' || typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE !== 'function') return;
    try {
        // Verify that the code above has been dead code eliminated (DCE'd).
        __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE($4288f0eb191085d1$var$checkDCE);
    } catch (err) {
        // DevTools shouldn't crash React, no matter what.
        // We should still report in case we break this code.
        console.error(err);
    }
}
// DCE check should happen before ReactDOM bundle executes so that
// DevTools can report bad minification during injection.
$4288f0eb191085d1$var$checkDCE();

$4288f0eb191085d1$exports = (parcelRequire("gZreO"));


var $8dbfa3fee6dc40a7$var$i;
$8dbfa3fee6dc40a7$export$882461b6382ed46c = $4288f0eb191085d1$exports.createRoot;
$8dbfa3fee6dc40a7$export$757ceba2d55c277e = $4288f0eb191085d1$exports.hydrateRoot;


/**
 * React Router DOM v6.30.2
 *
 * Copyright (c) Remix Software Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * @license MIT
 */ 
var $g3gsR = parcelRequire("g3gsR");

var $grujF = parcelRequire("grujF");

var $2nwvT = parcelRequire("2nwvT");

var $fRv9I = parcelRequire("fRv9I");

var $dQFEZ = parcelRequire("dQFEZ");


var $gl7zH = parcelRequire("gl7zH");/**
 * React Router v6.30.2
 *
 * Copyright (c) Remix Software Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * @license MIT
 */ 
var $f3Okx = parcelRequire("f3Okx");

var $grujF = parcelRequire("grujF");

var $dhMkv = parcelRequire("dhMkv");

var $j6Mzi = parcelRequire("j6Mzi");

var $2nwvT = parcelRequire("2nwvT");

var $2us1u = parcelRequire("2us1u");

var $dQFEZ = parcelRequire("dQFEZ");

var $gl7zH = parcelRequire("gl7zH");
function $8c3ad80f8a436e0f$var$_extends() {
    $8c3ad80f8a436e0f$var$_extends = Object.assign ? Object.assign.bind() : function _extends(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $8c3ad80f8a436e0f$var$_extends.apply(this, arguments);
}
// Create react-specific types from the agnostic types in @remix-run/router to
// export from react-router
var $8c3ad80f8a436e0f$export$3add0d5dce533e2e = /*#__PURE__*/ $dQFEZ.createContext(null);
var $8c3ad80f8a436e0f$export$145dfa71566a64dc = /*#__PURE__*/ $dQFEZ.createContext(null);
var $8c3ad80f8a436e0f$var$AwaitContext = /*#__PURE__*/ $dQFEZ.createContext(null);
/**
 * A Navigator is a "location changer"; it's how you get to different locations.
 *
 * Every history instance conforms to the Navigator interface, but the
 * distinction is useful primarily when it comes to the low-level `<Router>` API
 * where both the location and a navigator must be provided separately in order
 * to avoid "tearing" that may occur in a suspense-enabled app if the action
 * and/or location were to be read directly from the history instance.
 */ var $8c3ad80f8a436e0f$export$26749e8557646306 = /*#__PURE__*/ $dQFEZ.createContext(null);
var $8c3ad80f8a436e0f$export$c7914228fb69b0f5 = /*#__PURE__*/ $dQFEZ.createContext(null);
var $8c3ad80f8a436e0f$export$9072aa6dd1f93057 = /*#__PURE__*/ $dQFEZ.createContext({
    outlet: null,
    matches: [],
    isDataRoute: false
});
var $8c3ad80f8a436e0f$var$RouteErrorContext = /*#__PURE__*/ $dQFEZ.createContext(null);
/**
 * Returns the full href for the given "to" value. This is useful for building
 * custom links that are also accessible and preserve right-click behavior.
 *
 * @see https://reactrouter.com/v6/hooks/use-href
 */ function $8c3ad80f8a436e0f$export$b66bb29c5006f12f(to, _temp) {
    var relative = (_temp === void 0 ? {} : _temp).relative;
    !$8c3ad80f8a436e0f$export$9c954a9d03d32f4a() && (0, $gl7zH.UNSAFE_invariant)(false);
    var _React_useContext = $dQFEZ.useContext($8c3ad80f8a436e0f$export$26749e8557646306), basename = _React_useContext.basename, navigator = _React_useContext.navigator;
    var _useResolvedPath = $8c3ad80f8a436e0f$export$e75d2a2d1b3c245b(to, {
        relative: relative
    }), hash = _useResolvedPath.hash, pathname = _useResolvedPath.pathname, search = _useResolvedPath.search;
    var joinedPathname = pathname;
    // If we're operating within a basename, prepend it to the pathname prior
    // to creating the href.  If this is a root navigation, then just use the raw
    // basename which allows the basename to have full control over the presence
    // of a trailing slash on root links
    if (basename !== "/") joinedPathname = pathname === "/" ? basename : (0, $gl7zH.joinPaths)([
        basename,
        pathname
    ]);
    return navigator.createHref({
        pathname: joinedPathname,
        search: search,
        hash: hash
    });
}
/**
 * Returns true if this component is a descendant of a `<Router>`.
 *
 * @see https://reactrouter.com/v6/hooks/use-in-router-context
 */ function $8c3ad80f8a436e0f$export$9c954a9d03d32f4a() {
    return $dQFEZ.useContext($8c3ad80f8a436e0f$export$c7914228fb69b0f5) != null;
}
/**
 * Returns the current location object, which represents the current URL in web
 * browsers.
 *
 * Note: If you're using this it may mean you're doing some of your own
 * "routing" in your app, and we'd like to know what your use case is. We may
 * be able to provide something higher-level to better suit your needs.
 *
 * @see https://reactrouter.com/v6/hooks/use-location
 */ function $8c3ad80f8a436e0f$export$45d76561a5302f2b() {
    !$8c3ad80f8a436e0f$export$9c954a9d03d32f4a() && (0, $gl7zH.UNSAFE_invariant)(false);
    return $dQFEZ.useContext($8c3ad80f8a436e0f$export$c7914228fb69b0f5).location;
}
/**
 * Returns the current navigation action which describes how the router came to
 * the current location, either by a pop, push, or replace on the history stack.
 *
 * @see https://reactrouter.com/v6/hooks/use-navigation-type
 */ function $8c3ad80f8a436e0f$export$1b3f31771c5d07c() {
    return $dQFEZ.useContext($8c3ad80f8a436e0f$export$c7914228fb69b0f5).navigationType;
}
/**
 * Returns a PathMatch object if the given pattern matches the current URL.
 * This is useful for components that need to know "active" state, e.g.
 * `<NavLink>`.
 *
 * @see https://reactrouter.com/v6/hooks/use-match
 */ function $8c3ad80f8a436e0f$export$6c330e8992e8a295(pattern) {
    !$8c3ad80f8a436e0f$export$9c954a9d03d32f4a() && (0, $gl7zH.UNSAFE_invariant)(false);
    var pathname = $8c3ad80f8a436e0f$export$45d76561a5302f2b().pathname;
    return $dQFEZ.useMemo(function() {
        return (0, $gl7zH.matchPath)(pattern, (0, $gl7zH.UNSAFE_decodePath)(pathname));
    }, [
        pathname,
        pattern
    ]);
}
/**
 * The interface for the navigate() function returned from useNavigate().
 */ var $8c3ad80f8a436e0f$var$navigateEffectWarning = "You should call navigate() in a React.useEffect(), not when your component is first rendered.";
// Mute warnings for calls to useNavigate in SSR environments
function $8c3ad80f8a436e0f$var$useIsomorphicLayoutEffect(cb) {
    var isStatic = $dQFEZ.useContext($8c3ad80f8a436e0f$export$26749e8557646306).static;
    if (!isStatic) // We should be able to get rid of this once react 18.3 is released
    // See: https://github.com/facebook/react/pull/26395
    // eslint-disable-next-line react-hooks/rules-of-hooks
    $dQFEZ.useLayoutEffect(cb);
}
/**
 * Returns an imperative method for changing the location. Used by `<Link>`s, but
 * may also be used by other elements to change the location.
 *
 * @see https://reactrouter.com/v6/hooks/use-navigate
 */ function $8c3ad80f8a436e0f$export$9770f232ac06a008() {
    var isDataRoute = $dQFEZ.useContext($8c3ad80f8a436e0f$export$9072aa6dd1f93057).isDataRoute;
    // Conditional usage is OK here because the usage of a data router is static
    // eslint-disable-next-line react-hooks/rules-of-hooks
    return isDataRoute ? $8c3ad80f8a436e0f$var$useNavigateStable() : $8c3ad80f8a436e0f$var$useNavigateUnstable();
}
function $8c3ad80f8a436e0f$var$useNavigateUnstable() {
    !$8c3ad80f8a436e0f$export$9c954a9d03d32f4a() && (0, $gl7zH.UNSAFE_invariant)(false);
    var dataRouterContext = $dQFEZ.useContext($8c3ad80f8a436e0f$export$3add0d5dce533e2e);
    var _React_useContext = $dQFEZ.useContext($8c3ad80f8a436e0f$export$26749e8557646306), basename = _React_useContext.basename, future = _React_useContext.future, navigator = _React_useContext.navigator;
    var matches = $dQFEZ.useContext($8c3ad80f8a436e0f$export$9072aa6dd1f93057).matches;
    var _useLocation = $8c3ad80f8a436e0f$export$45d76561a5302f2b(), locationPathname = _useLocation.pathname;
    var routePathnamesJson = JSON.stringify((0, $gl7zH.UNSAFE_getResolveToMatches)(matches, future.v7_relativeSplatPath));
    var activeRef = $dQFEZ.useRef(false);
    $8c3ad80f8a436e0f$var$useIsomorphicLayoutEffect(function() {
        activeRef.current = true;
    });
    var navigate = $dQFEZ.useCallback(function(to, options) {
        if (options === void 0) options = {};
        // Short circuit here since if this happens on first render the navigate
        // is useless because we haven't wired up our history listener yet
        if (!activeRef.current) return;
        if (typeof to === "number") {
            navigator.go(to);
            return;
        }
        var path = (0, $gl7zH.resolveTo)(to, JSON.parse(routePathnamesJson), locationPathname, options.relative === "path");
        // If we're operating within a basename, prepend it to the pathname prior
        // to handing off to history (but only if we're not in a data router,
        // otherwise it'll prepend the basename inside of the router).
        // If this is a root navigation, then we navigate to the raw basename
        // which allows the basename to have full control over the presence of a
        // trailing slash on root links
        if (dataRouterContext == null && basename !== "/") path.pathname = path.pathname === "/" ? basename : (0, $gl7zH.joinPaths)([
            basename,
            path.pathname
        ]);
        (!!options.replace ? navigator.replace : navigator.push)(path, options.state, options);
    }, [
        basename,
        navigator,
        routePathnamesJson,
        locationPathname,
        dataRouterContext
    ]);
    return navigate;
}
var $8c3ad80f8a436e0f$var$OutletContext = /*#__PURE__*/ $dQFEZ.createContext(null);
/**
 * Returns the context (if provided) for the child route at this level of the route
 * hierarchy.
 * @see https://reactrouter.com/v6/hooks/use-outlet-context
 */ function $8c3ad80f8a436e0f$export$4138103a3ae699cc() {
    return $dQFEZ.useContext($8c3ad80f8a436e0f$var$OutletContext);
}
/**
 * Returns the element for the child route at this level of the route
 * hierarchy. Used internally by `<Outlet>` to render child routes.
 *
 * @see https://reactrouter.com/v6/hooks/use-outlet
 */ function $8c3ad80f8a436e0f$export$a3be3530d8e40d0b(context) {
    var outlet = $dQFEZ.useContext($8c3ad80f8a436e0f$export$9072aa6dd1f93057).outlet;
    if (outlet) return /*#__PURE__*/ $dQFEZ.createElement($8c3ad80f8a436e0f$var$OutletContext.Provider, {
        value: context
    }, outlet);
    return outlet;
}
/**
 * Returns an object of key/value pairs of the dynamic params from the current
 * URL that were matched by the route path.
 *
 * @see https://reactrouter.com/v6/hooks/use-params
 */ function $8c3ad80f8a436e0f$export$99eaa27ddbbb95ef() {
    var matches = $dQFEZ.useContext($8c3ad80f8a436e0f$export$9072aa6dd1f93057).matches;
    var routeMatch = matches[matches.length - 1];
    return routeMatch ? routeMatch.params : {};
}
/**
 * Resolves the pathname of the given `to` value against the current location.
 *
 * @see https://reactrouter.com/v6/hooks/use-resolved-path
 */ function $8c3ad80f8a436e0f$export$e75d2a2d1b3c245b(to, _temp2) {
    var relative = (_temp2 === void 0 ? {} : _temp2).relative;
    var future = $dQFEZ.useContext($8c3ad80f8a436e0f$export$26749e8557646306).future;
    var matches = $dQFEZ.useContext($8c3ad80f8a436e0f$export$9072aa6dd1f93057).matches;
    var _useLocation = $8c3ad80f8a436e0f$export$45d76561a5302f2b(), locationPathname = _useLocation.pathname;
    var routePathnamesJson = JSON.stringify((0, $gl7zH.UNSAFE_getResolveToMatches)(matches, future.v7_relativeSplatPath));
    return $dQFEZ.useMemo(function() {
        return (0, $gl7zH.resolveTo)(to, JSON.parse(routePathnamesJson), locationPathname, relative === "path");
    }, [
        to,
        routePathnamesJson,
        locationPathname,
        relative
    ]);
}
/**
 * Returns the element of the route that matched the current location, prepared
 * with the correct context to render the remainder of the route tree. Route
 * elements in the tree must render an `<Outlet>` to render their child route's
 * element.
 *
 * @see https://reactrouter.com/v6/hooks/use-routes
 */ function $8c3ad80f8a436e0f$export$5d3fca4a98652595(routes, locationArg) {
    return $8c3ad80f8a436e0f$export$5fcee62552a12fbf(routes, locationArg);
}
// Internal implementation with accept optional param for RouterProvider usage
function $8c3ad80f8a436e0f$export$5fcee62552a12fbf(routes, locationArg, dataRouterState, future) {
    !$8c3ad80f8a436e0f$export$9c954a9d03d32f4a() && (0, $gl7zH.UNSAFE_invariant)(false);
    var navigator = $dQFEZ.useContext($8c3ad80f8a436e0f$export$26749e8557646306).navigator;
    var _React_useContext = $dQFEZ.useContext($8c3ad80f8a436e0f$export$9072aa6dd1f93057), parentMatches = _React_useContext.matches;
    var routeMatch = parentMatches[parentMatches.length - 1];
    var parentParams = routeMatch ? routeMatch.params : {};
    var parentPathname = routeMatch ? routeMatch.pathname : "/";
    var parentPathnameBase = routeMatch ? routeMatch.pathnameBase : "/";
    var parentRoute = routeMatch && routeMatch.route;
    var locationFromContext = $8c3ad80f8a436e0f$export$45d76561a5302f2b();
    var location;
    if (locationArg) {
        var _parsedLocationArg$pa;
        var parsedLocationArg = typeof locationArg === "string" ? (0, $gl7zH.parsePath)(locationArg) : locationArg;
        !(parentPathnameBase === "/" || ((_parsedLocationArg$pa = parsedLocationArg.pathname) == null ? void 0 : _parsedLocationArg$pa.startsWith(parentPathnameBase))) && (0, $gl7zH.UNSAFE_invariant)(false);
        location = parsedLocationArg;
    } else location = locationFromContext;
    var pathname = location.pathname || "/";
    var remainingPathname = pathname;
    if (parentPathnameBase !== "/") {
        // Determine the remaining pathname by removing the # of URL segments the
        // parentPathnameBase has, instead of removing based on character count.
        // This is because we can't guarantee that incoming/outgoing encodings/
        // decodings will match exactly.
        // We decode paths before matching on a per-segment basis with
        // decodeURIComponent(), but we re-encode pathnames via `new URL()` so they
        // match what `window.location.pathname` would reflect.  Those don't 100%
        // align when it comes to encoded URI characters such as % and &.
        //
        // So we may end up with:
        //   pathname:           "/descendant/a%25b/match"
        //   parentPathnameBase: "/descendant/a%b"
        //
        // And the direct substring removal approach won't work :/
        var parentSegments = parentPathnameBase.replace(/^\//, "").split("/");
        var segments = pathname.replace(/^\//, "").split("/");
        remainingPathname = "/" + segments.slice(parentSegments.length).join("/");
    }
    var matches = (0, $gl7zH.matchRoutes)(routes, {
        pathname: remainingPathname
    });
    var renderedMatches = $8c3ad80f8a436e0f$var$_renderMatches(matches && matches.map(function(match) {
        return Object.assign({}, match, {
            params: Object.assign({}, parentParams, match.params),
            pathname: (0, $gl7zH.joinPaths)([
                parentPathnameBase,
                // Re-encode pathnames that were decoded inside matchRoutes
                navigator.encodeLocation ? navigator.encodeLocation(match.pathname).pathname : match.pathname
            ]),
            pathnameBase: match.pathnameBase === "/" ? parentPathnameBase : (0, $gl7zH.joinPaths)([
                parentPathnameBase,
                // Re-encode pathnames that were decoded inside matchRoutes
                navigator.encodeLocation ? navigator.encodeLocation(match.pathnameBase).pathname : match.pathnameBase
            ])
        });
    }), parentMatches, dataRouterState, future);
    // When a user passes in a `locationArg`, the associated routes need to
    // be wrapped in a new `LocationContext.Provider` in order for `useLocation`
    // to use the scoped location instead of the global location.
    if (locationArg && renderedMatches) return /*#__PURE__*/ $dQFEZ.createElement($8c3ad80f8a436e0f$export$c7914228fb69b0f5.Provider, {
        value: {
            location: $8c3ad80f8a436e0f$var$_extends({
                pathname: "/",
                search: "",
                hash: "",
                state: null,
                key: "default"
            }, location),
            navigationType: (0, $gl7zH.Action).Pop
        }
    }, renderedMatches);
    return renderedMatches;
}
function $8c3ad80f8a436e0f$var$DefaultErrorComponent() {
    var error = $8c3ad80f8a436e0f$export$ed527bf60f6e05f2();
    var message = (0, $gl7zH.isRouteErrorResponse)(error) ? error.status + " " + error.statusText : error instanceof Error ? error.message : JSON.stringify(error);
    var stack = error instanceof Error ? error.stack : null;
    var lightgrey = "rgba(200,200,200, 0.5)";
    var preStyles = {
        padding: "0.5rem",
        backgroundColor: lightgrey
    };
    var codeStyles = {
        padding: "2px 4px",
        backgroundColor: lightgrey
    };
    var devInfo = null;
    return /*#__PURE__*/ $dQFEZ.createElement($dQFEZ.Fragment, null, /*#__PURE__*/ $dQFEZ.createElement("h2", null, "Unexpected Application Error!"), /*#__PURE__*/ $dQFEZ.createElement("h3", {
        style: {
            fontStyle: "italic"
        }
    }, message), stack ? /*#__PURE__*/ $dQFEZ.createElement("pre", {
        style: preStyles
    }, stack) : null, devInfo);
}
var $8c3ad80f8a436e0f$var$defaultErrorElement = /*#__PURE__*/ $dQFEZ.createElement($8c3ad80f8a436e0f$var$DefaultErrorComponent, null);
var $8c3ad80f8a436e0f$var$RenderErrorBoundary = /*#__PURE__*/ function(_React_Component) {
    "use strict";
    (0, $j6Mzi._)(RenderErrorBoundary, _React_Component);
    function RenderErrorBoundary(props) {
        (0, $grujF._)(this, RenderErrorBoundary);
        var _this;
        _this = (0, $f3Okx._)(this, RenderErrorBoundary, [
            props
        ]);
        _this.state = {
            location: props.location,
            revalidation: props.revalidation,
            error: props.error
        };
        return _this;
    }
    (0, $dhMkv._)(RenderErrorBoundary, [
        {
            key: "componentDidCatch",
            value: function componentDidCatch(error, errorInfo) {
                console.error("React Router caught the following error during render", error, errorInfo);
            }
        },
        {
            key: "render",
            value: function render() {
                return this.state.error !== undefined ? /*#__PURE__*/ $dQFEZ.createElement($8c3ad80f8a436e0f$export$9072aa6dd1f93057.Provider, {
                    value: this.props.routeContext
                }, /*#__PURE__*/ $dQFEZ.createElement($8c3ad80f8a436e0f$var$RouteErrorContext.Provider, {
                    value: this.state.error,
                    children: this.props.component
                })) : this.props.children;
            }
        }
    ], [
        {
            key: "getDerivedStateFromError",
            value: function getDerivedStateFromError(error) {
                return {
                    error: error
                };
            }
        },
        {
            key: "getDerivedStateFromProps",
            value: function getDerivedStateFromProps(props, state) {
                // When we get into an error state, the user will likely click "back" to the
                // previous page that didn't have an error. Because this wraps the entire
                // application, that will have no effect--the error page continues to display.
                // This gives us a mechanism to recover from the error when the location changes.
                //
                // Whether we're in an error state or not, we update the location in state
                // so that when we are in an error state, it gets reset when a new location
                // comes in and the user recovers from the error.
                if (state.location !== props.location || state.revalidation !== "idle" && props.revalidation === "idle") return {
                    error: props.error,
                    location: props.location,
                    revalidation: props.revalidation
                };
                // If we're not changing locations, preserve the location but still surface
                // any new errors that may come through. We retain the existing error, we do
                // this because the error provided from the app state may be cleared without
                // the location changing.
                return {
                    error: props.error !== undefined ? props.error : state.error,
                    location: state.location,
                    revalidation: props.revalidation || state.revalidation
                };
            }
        }
    ]);
    return RenderErrorBoundary;
}($dQFEZ.Component);
function $8c3ad80f8a436e0f$var$RenderedRoute(_ref) {
    var routeContext = _ref.routeContext, match = _ref.match, children = _ref.children;
    var dataRouterContext = $dQFEZ.useContext($8c3ad80f8a436e0f$export$3add0d5dce533e2e);
    // Track how deep we got in our render pass to emulate SSR componentDidCatch
    // in a DataStaticRouter
    if (dataRouterContext && dataRouterContext.static && dataRouterContext.staticContext && (match.route.errorElement || match.route.ErrorBoundary)) dataRouterContext.staticContext._deepestRenderedBoundaryId = match.route.id;
    return /*#__PURE__*/ $dQFEZ.createElement($8c3ad80f8a436e0f$export$9072aa6dd1f93057.Provider, {
        value: routeContext
    }, children);
}
function $8c3ad80f8a436e0f$var$_renderMatches(matches, parentMatches, dataRouterState, future) {
    var _dataRouterState;
    if (parentMatches === void 0) parentMatches = [];
    if (dataRouterState === void 0) dataRouterState = null;
    if (future === void 0) future = null;
    if (matches == null) {
        var _future;
        if (!dataRouterState) return null;
        if (dataRouterState.errors) // Don't bail if we have data router errors so we can render them in the
        // boundary.  Use the pre-matched (or shimmed) matches
        matches = dataRouterState.matches;
        else if ((_future = future) != null && _future.v7_partialHydration && parentMatches.length === 0 && !dataRouterState.initialized && dataRouterState.matches.length > 0) // Don't bail if we're initializing with partial hydration and we have
        // router matches.  That means we're actively running `patchRoutesOnNavigation`
        // so we should render down the partial matches to the appropriate
        // `HydrateFallback`.  We only do this if `parentMatches` is empty so it
        // only impacts the root matches for `RouterProvider` and no descendant
        // `<Routes>`
        matches = dataRouterState.matches;
        else return null;
    }
    var renderedMatches = matches;
    // If we have data errors, trim matches to the highest error boundary
    var errors = (_dataRouterState = dataRouterState) == null ? void 0 : _dataRouterState.errors;
    if (errors != null) {
        var errorIndex = renderedMatches.findIndex(function(m) {
            return m.route.id && (errors == null ? void 0 : errors[m.route.id]) !== undefined;
        });
        !(errorIndex >= 0) && (0, $gl7zH.UNSAFE_invariant)(false);
        renderedMatches = renderedMatches.slice(0, Math.min(renderedMatches.length, errorIndex + 1));
    }
    // If we're in a partial hydration mode, detect if we need to render down to
    // a given HydrateFallback while we load the rest of the hydration data
    var renderFallback = false;
    var fallbackIndex = -1;
    if (dataRouterState && future && future.v7_partialHydration) for(var i = 0; i < renderedMatches.length; i++){
        var match = renderedMatches[i];
        // Track the deepest fallback up until the first route without data
        if (match.route.HydrateFallback || match.route.hydrateFallbackElement) fallbackIndex = i;
        if (match.route.id) {
            var loaderData = dataRouterState.loaderData, errors1 = dataRouterState.errors;
            var needsToRunLoader = match.route.loader && loaderData[match.route.id] === undefined && (!errors1 || errors1[match.route.id] === undefined);
            if (match.route.lazy || needsToRunLoader) {
                // We found the first route that's not ready to render (waiting on
                // lazy, or has a loader that hasn't run yet).  Flag that we need to
                // render a fallback and render up until the appropriate fallback
                renderFallback = true;
                if (fallbackIndex >= 0) renderedMatches = renderedMatches.slice(0, fallbackIndex + 1);
                else renderedMatches = [
                    renderedMatches[0]
                ];
                break;
            }
        }
    }
    return renderedMatches.reduceRight(function(outlet, match, index) {
        // Only data routers handle errors/fallbacks
        var error;
        var shouldRenderHydrateFallback = false;
        var errorElement = null;
        var hydrateFallbackElement = null;
        if (dataRouterState) {
            error = errors && match.route.id ? errors[match.route.id] : undefined;
            errorElement = match.route.errorElement || $8c3ad80f8a436e0f$var$defaultErrorElement;
            if (renderFallback) {
                if (fallbackIndex < 0 && index === 0) {
                    $8c3ad80f8a436e0f$var$warningOnce("route-fallback", false, "No `HydrateFallback` element provided to render during initial hydration");
                    shouldRenderHydrateFallback = true;
                    hydrateFallbackElement = null;
                } else if (fallbackIndex === index) {
                    shouldRenderHydrateFallback = true;
                    hydrateFallbackElement = match.route.hydrateFallbackElement || null;
                }
            }
        }
        var _$matches = parentMatches.concat(renderedMatches.slice(0, index + 1));
        var getChildren = function() {
            var children;
            if (error) children = errorElement;
            else if (shouldRenderHydrateFallback) children = hydrateFallbackElement;
            else if (match.route.Component) // Note: This is a de-optimized path since React won't re-use the
            // ReactElement since it's identity changes with each new
            // React.createElement call.  We keep this so folks can use
            // `<Route Component={...}>` in `<Routes>` but generally `Component`
            // usage is only advised in `RouterProvider` when we can convert it to
            // `element` ahead of time.
            children = /*#__PURE__*/ $dQFEZ.createElement(match.route.Component, null);
            else if (match.route.element) children = match.route.element;
            else children = outlet;
            return /*#__PURE__*/ $dQFEZ.createElement($8c3ad80f8a436e0f$var$RenderedRoute, {
                match: match,
                routeContext: {
                    outlet: outlet,
                    matches: _$matches,
                    isDataRoute: dataRouterState != null
                },
                children: children
            });
        };
        // Only wrap in an error boundary within data router usages when we have an
        // ErrorBoundary/errorElement on this route.  Otherwise let it bubble up to
        // an ancestor ErrorBoundary/errorElement
        return dataRouterState && (match.route.ErrorBoundary || match.route.errorElement || index === 0) ? /*#__PURE__*/ $dQFEZ.createElement($8c3ad80f8a436e0f$var$RenderErrorBoundary, {
            location: dataRouterState.location,
            revalidation: dataRouterState.revalidation,
            component: errorElement,
            error: error,
            children: getChildren(),
            routeContext: {
                outlet: null,
                matches: _$matches,
                isDataRoute: true
            }
        }) : getChildren();
    }, null);
}
var $8c3ad80f8a436e0f$var$DataRouterHook = /*#__PURE__*/ function(DataRouterHook) {
    DataRouterHook["UseBlocker"] = "useBlocker";
    DataRouterHook["UseRevalidator"] = "useRevalidator";
    DataRouterHook["UseNavigateStable"] = "useNavigate";
    return DataRouterHook;
}($8c3ad80f8a436e0f$var$DataRouterHook || {});
var $8c3ad80f8a436e0f$var$DataRouterStateHook = /*#__PURE__*/ function(DataRouterStateHook) {
    DataRouterStateHook["UseBlocker"] = "useBlocker";
    DataRouterStateHook["UseLoaderData"] = "useLoaderData";
    DataRouterStateHook["UseActionData"] = "useActionData";
    DataRouterStateHook["UseRouteError"] = "useRouteError";
    DataRouterStateHook["UseNavigation"] = "useNavigation";
    DataRouterStateHook["UseRouteLoaderData"] = "useRouteLoaderData";
    DataRouterStateHook["UseMatches"] = "useMatches";
    DataRouterStateHook["UseRevalidator"] = "useRevalidator";
    DataRouterStateHook["UseNavigateStable"] = "useNavigate";
    DataRouterStateHook["UseRouteId"] = "useRouteId";
    return DataRouterStateHook;
}($8c3ad80f8a436e0f$var$DataRouterStateHook || {});
function $8c3ad80f8a436e0f$var$getDataRouterConsoleError(hookName) {
    return hookName + " must be used within a data router.  See https://reactrouter.com/v6/routers/picking-a-router.";
}
function $8c3ad80f8a436e0f$var$useDataRouterContext(hookName) {
    var ctx = $dQFEZ.useContext($8c3ad80f8a436e0f$export$3add0d5dce533e2e);
    !ctx && (0, $gl7zH.UNSAFE_invariant)(false);
    return ctx;
}
function $8c3ad80f8a436e0f$var$useDataRouterState(hookName) {
    var state = $dQFEZ.useContext($8c3ad80f8a436e0f$export$145dfa71566a64dc);
    !state && (0, $gl7zH.UNSAFE_invariant)(false);
    return state;
}
function $8c3ad80f8a436e0f$var$useRouteContext(hookName) {
    var route = $dQFEZ.useContext($8c3ad80f8a436e0f$export$9072aa6dd1f93057);
    !route && (0, $gl7zH.UNSAFE_invariant)(false);
    return route;
}
// Internal version with hookName-aware debugging
function $8c3ad80f8a436e0f$var$useCurrentRouteId(hookName) {
    var route = $8c3ad80f8a436e0f$var$useRouteContext(hookName);
    var thisRoute = route.matches[route.matches.length - 1];
    !thisRoute.route.id && (0, $gl7zH.UNSAFE_invariant)(false);
    return thisRoute.route.id;
}
/**
 * Returns the ID for the nearest contextual route
 */ function $8c3ad80f8a436e0f$export$5fc8298006ad9e58() {
    return $8c3ad80f8a436e0f$var$useCurrentRouteId($8c3ad80f8a436e0f$var$DataRouterStateHook.UseRouteId);
}
/**
 * Returns the current navigation, defaulting to an "idle" navigation when
 * no navigation is in progress
 */ function $8c3ad80f8a436e0f$export$d0fd4b7106de2769() {
    var state = $8c3ad80f8a436e0f$var$useDataRouterState($8c3ad80f8a436e0f$var$DataRouterStateHook.UseNavigation);
    return state.navigation;
}
/**
 * Returns a revalidate function for manually triggering revalidation, as well
 * as the current state of any manual revalidations
 */ function $8c3ad80f8a436e0f$export$600dc272ed516c15() {
    var dataRouterContext = $8c3ad80f8a436e0f$var$useDataRouterContext($8c3ad80f8a436e0f$var$DataRouterHook.UseRevalidator);
    var state = $8c3ad80f8a436e0f$var$useDataRouterState($8c3ad80f8a436e0f$var$DataRouterStateHook.UseRevalidator);
    return $dQFEZ.useMemo(function() {
        return {
            revalidate: dataRouterContext.router.revalidate,
            state: state.revalidation
        };
    }, [
        dataRouterContext.router.revalidate,
        state.revalidation
    ]);
}
/**
 * Returns the active route matches, useful for accessing loaderData for
 * parent/child routes or the route "handle" property
 */ function $8c3ad80f8a436e0f$export$2378eb7f5ff86053() {
    var _useDataRouterState = $8c3ad80f8a436e0f$var$useDataRouterState($8c3ad80f8a436e0f$var$DataRouterStateHook.UseMatches), matches = _useDataRouterState.matches, loaderData = _useDataRouterState.loaderData;
    return $dQFEZ.useMemo(function() {
        return matches.map(function(m) {
            return (0, $gl7zH.UNSAFE_convertRouteMatchToUiMatch)(m, loaderData);
        });
    }, [
        matches,
        loaderData
    ]);
}
/**
 * Returns the loader data for the nearest ancestor Route loader
 */ function $8c3ad80f8a436e0f$export$1448a5050d252c4d() {
    var state = $8c3ad80f8a436e0f$var$useDataRouterState($8c3ad80f8a436e0f$var$DataRouterStateHook.UseLoaderData);
    var routeId = $8c3ad80f8a436e0f$var$useCurrentRouteId($8c3ad80f8a436e0f$var$DataRouterStateHook.UseLoaderData);
    if (state.errors && state.errors[routeId] != null) {
        console.error("You cannot `useLoaderData` in an errorElement (routeId: " + routeId + ")");
        return undefined;
    }
    return state.loaderData[routeId];
}
/**
 * Returns the loaderData for the given routeId
 */ function $8c3ad80f8a436e0f$export$fd5d37484eab868d(routeId) {
    var state = $8c3ad80f8a436e0f$var$useDataRouterState($8c3ad80f8a436e0f$var$DataRouterStateHook.UseRouteLoaderData);
    return state.loaderData[routeId];
}
/**
 * Returns the action data for the nearest ancestor Route action
 */ function $8c3ad80f8a436e0f$export$fdc00f3f26066d5e() {
    var state = $8c3ad80f8a436e0f$var$useDataRouterState($8c3ad80f8a436e0f$var$DataRouterStateHook.UseActionData);
    var routeId = $8c3ad80f8a436e0f$var$useCurrentRouteId($8c3ad80f8a436e0f$var$DataRouterStateHook.UseLoaderData);
    return state.actionData ? state.actionData[routeId] : undefined;
}
/**
 * Returns the nearest ancestor Route error, which could be a loader/action
 * error or a render error.  This is intended to be called from your
 * ErrorBoundary/errorElement to display a proper error message.
 */ function $8c3ad80f8a436e0f$export$ed527bf60f6e05f2() {
    var _state$errors;
    var error = $dQFEZ.useContext($8c3ad80f8a436e0f$var$RouteErrorContext);
    var state = $8c3ad80f8a436e0f$var$useDataRouterState($8c3ad80f8a436e0f$var$DataRouterStateHook.UseRouteError);
    var routeId = $8c3ad80f8a436e0f$var$useCurrentRouteId($8c3ad80f8a436e0f$var$DataRouterStateHook.UseRouteError);
    // If this was a render error, we put it in a RouteError context inside
    // of RenderErrorBoundary
    if (error !== undefined) return error;
    // Otherwise look for errors from our data router state
    return (_state$errors = state.errors) == null ? void 0 : _state$errors[routeId];
}
/**
 * Returns the happy-path data from the nearest ancestor `<Await />` value
 */ function $8c3ad80f8a436e0f$export$78a72ddb39bdd145() {
    var value = $dQFEZ.useContext($8c3ad80f8a436e0f$var$AwaitContext);
    return value == null ? void 0 : value._data;
}
/**
 * Returns the error from the nearest ancestor `<Await />` value
 */ function $8c3ad80f8a436e0f$export$17f53340677d5831() {
    var value = $dQFEZ.useContext($8c3ad80f8a436e0f$var$AwaitContext);
    return value == null ? void 0 : value._error;
}
var $8c3ad80f8a436e0f$var$blockerId = 0;
/**
 * Allow the application to block navigations within the SPA and present the
 * user a confirmation dialog to confirm the navigation.  Mostly used to avoid
 * using half-filled form data.  This does not handle hard-reloads or
 * cross-origin navigations.
 */ function $8c3ad80f8a436e0f$export$b273b3273281a049(shouldBlock) {
    var _useDataRouterContext = $8c3ad80f8a436e0f$var$useDataRouterContext($8c3ad80f8a436e0f$var$DataRouterHook.UseBlocker), router = _useDataRouterContext.router, basename = _useDataRouterContext.basename;
    var state = $8c3ad80f8a436e0f$var$useDataRouterState($8c3ad80f8a436e0f$var$DataRouterStateHook.UseBlocker);
    var _React_useState = (0, $2nwvT._)($dQFEZ.useState(""), 2), blockerKey = _React_useState[0], setBlockerKey = _React_useState[1];
    var blockerFunction = $dQFEZ.useCallback(function(arg) {
        if (typeof shouldBlock !== "function") return !!shouldBlock;
        if (basename === "/") return shouldBlock(arg);
        // If they provided us a function and we've got an active basename, strip
        // it from the locations we expose to the user to match the behavior of
        // useLocation
        var currentLocation = arg.currentLocation, nextLocation = arg.nextLocation, historyAction = arg.historyAction;
        return shouldBlock({
            currentLocation: $8c3ad80f8a436e0f$var$_extends({}, currentLocation, {
                pathname: (0, $gl7zH.stripBasename)(currentLocation.pathname, basename) || currentLocation.pathname
            }),
            nextLocation: $8c3ad80f8a436e0f$var$_extends({}, nextLocation, {
                pathname: (0, $gl7zH.stripBasename)(nextLocation.pathname, basename) || nextLocation.pathname
            }),
            historyAction: historyAction
        });
    }, [
        basename,
        shouldBlock
    ]);
    // This effect is in charge of blocker key assignment and deletion (which is
    // tightly coupled to the key)
    $dQFEZ.useEffect(function() {
        var key = String(++$8c3ad80f8a436e0f$var$blockerId);
        setBlockerKey(key);
        return function() {
            return router.deleteBlocker(key);
        };
    }, [
        router
    ]);
    // This effect handles assigning the blockerFunction.  This is to handle
    // unstable blocker function identities, and happens only after the prior
    // effect so we don't get an orphaned blockerFunction in the router with a
    // key of "".  Until then we just have the IDLE_BLOCKER.
    $dQFEZ.useEffect(function() {
        if (blockerKey !== "") router.getBlocker(blockerKey, blockerFunction);
    }, [
        router,
        blockerKey,
        blockerFunction
    ]);
    // Prefer the blocker from `state` not `router.state` since DataRouterContext
    // is memoized so this ensures we update on blocker state updates
    return blockerKey && state.blockers.has(blockerKey) ? state.blockers.get(blockerKey) : (0, $gl7zH.IDLE_BLOCKER);
}
/**
 * Stable version of useNavigate that is used when we are in the context of
 * a RouterProvider.
 */ function $8c3ad80f8a436e0f$var$useNavigateStable() {
    var router = $8c3ad80f8a436e0f$var$useDataRouterContext($8c3ad80f8a436e0f$var$DataRouterHook.UseNavigateStable).router;
    var id = $8c3ad80f8a436e0f$var$useCurrentRouteId($8c3ad80f8a436e0f$var$DataRouterStateHook.UseNavigateStable);
    var activeRef = $dQFEZ.useRef(false);
    $8c3ad80f8a436e0f$var$useIsomorphicLayoutEffect(function() {
        activeRef.current = true;
    });
    var navigate = $dQFEZ.useCallback(function(to, options) {
        if (options === void 0) options = {};
        // Short circuit here since if this happens on first render the navigate
        // is useless because we haven't wired up our router subscriber yet
        if (!activeRef.current) return;
        if (typeof to === "number") router.navigate(to);
        else router.navigate(to, $8c3ad80f8a436e0f$var$_extends({
            fromRouteId: id
        }, options));
    }, [
        router,
        id
    ]);
    return navigate;
}
var $8c3ad80f8a436e0f$var$alreadyWarned$1 = {};
function $8c3ad80f8a436e0f$var$warningOnce(key, cond, message) {
    if (!cond && !$8c3ad80f8a436e0f$var$alreadyWarned$1[key]) $8c3ad80f8a436e0f$var$alreadyWarned$1[key] = true;
}
var $8c3ad80f8a436e0f$var$alreadyWarned = {};
function $8c3ad80f8a436e0f$var$warnOnce(key, message) {}
var $8c3ad80f8a436e0f$var$logDeprecation = function(flag, msg, link) {
    return $8c3ad80f8a436e0f$var$warnOnce(flag, "\u26A0\uFE0F React Router Future Flag Warning: " + msg + ". " + ("You can use the `" + flag + "` future flag to opt-in early. ") + ("For more information, see " + link + "."));
};
function $8c3ad80f8a436e0f$export$db5148ec97d6af7a(renderFuture, routerFuture) {
    if ((renderFuture == null ? void 0 : renderFuture.v7_startTransition) === undefined) $8c3ad80f8a436e0f$var$logDeprecation("v7_startTransition", "React Router will begin wrapping state updates in `React.startTransition` in v7", "https://reactrouter.com/v6/upgrading/future#v7_starttransition");
    if ((renderFuture == null ? void 0 : renderFuture.v7_relativeSplatPath) === undefined && (!routerFuture || routerFuture.v7_relativeSplatPath === undefined)) $8c3ad80f8a436e0f$var$logDeprecation("v7_relativeSplatPath", "Relative route resolution within Splat routes is changing in v7", "https://reactrouter.com/v6/upgrading/future#v7_relativesplatpath");
    if (routerFuture) {
        if (routerFuture.v7_fetcherPersist === undefined) $8c3ad80f8a436e0f$var$logDeprecation("v7_fetcherPersist", "The persistence behavior of fetchers is changing in v7", "https://reactrouter.com/v6/upgrading/future#v7_fetcherpersist");
        if (routerFuture.v7_normalizeFormMethod === undefined) $8c3ad80f8a436e0f$var$logDeprecation("v7_normalizeFormMethod", "Casing of `formMethod` fields is being normalized to uppercase in v7", "https://reactrouter.com/v6/upgrading/future#v7_normalizeformmethod");
        if (routerFuture.v7_partialHydration === undefined) $8c3ad80f8a436e0f$var$logDeprecation("v7_partialHydration", "`RouterProvider` hydration behavior is changing in v7", "https://reactrouter.com/v6/upgrading/future#v7_partialhydration");
        if (routerFuture.v7_skipActionErrorRevalidation === undefined) $8c3ad80f8a436e0f$var$logDeprecation("v7_skipActionErrorRevalidation", "The revalidation behavior after 4xx/5xx `action` responses is changing in v7", "https://reactrouter.com/v6/upgrading/future#v7_skipactionerrorrevalidation");
    }
}
/**
  Webpack + React 17 fails to compile on any of the following because webpack
  complains that `startTransition` doesn't exist in `React`:
  * import { startTransition } from "react"
  * import * as React from from "react";
    "startTransition" in React ? React.startTransition(() => setState()) : setState()
  * import * as React from from "react";
    "startTransition" in React ? React["startTransition"](() => setState()) : setState()

  Moving it to a constant such as the following solves the Webpack/React 17 issue:
  * import * as React from from "react";
    const START_TRANSITION = "startTransition";
    START_TRANSITION in React ? React[START_TRANSITION](() => setState()) : setState()

  However, that introduces webpack/terser minification issues in production builds
  in React 18 where minification/obfuscation ends up removing the call of
  React.startTransition entirely from the first half of the ternary.  Grabbing
  this exported reference once up front resolves that issue.

  See https://github.com/remix-run/react-router/issues/10579
*/ var $8c3ad80f8a436e0f$var$START_TRANSITION = "startTransition";
var $8c3ad80f8a436e0f$var$startTransitionImpl = $dQFEZ[$8c3ad80f8a436e0f$var$START_TRANSITION];
/**
 * Given a Remix Router instance, render the appropriate UI
 */ function $8c3ad80f8a436e0f$export$323e4fc2fa4753fb(_ref) {
    var fallbackElement = _ref.fallbackElement, router = _ref.router, future = _ref.future;
    var _React_useState = (0, $2nwvT._)($dQFEZ.useState(router.state), 2), state = _React_useState[0], setStateImpl = _React_useState[1];
    var v7_startTransition = (future || {}).v7_startTransition;
    var setState = $dQFEZ.useCallback(function(newState) {
        if (v7_startTransition && $8c3ad80f8a436e0f$var$startTransitionImpl) $8c3ad80f8a436e0f$var$startTransitionImpl(function() {
            return setStateImpl(newState);
        });
        else setStateImpl(newState);
    }, [
        setStateImpl,
        v7_startTransition
    ]);
    // Need to use a layout effect here so we are subscribed early enough to
    // pick up on any render-driven redirects/navigations (useEffect/<Navigate>)
    $dQFEZ.useLayoutEffect(function() {
        return router.subscribe(setState);
    }, [
        router,
        setState
    ]);
    $dQFEZ.useEffect(function() {
    // Only log this once on initial mount
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    var navigator = $dQFEZ.useMemo(function() {
        return {
            createHref: router.createHref,
            encodeLocation: router.encodeLocation,
            go: function(n) {
                return router.navigate(n);
            },
            push: function(to, state, opts) {
                return router.navigate(to, {
                    state: state,
                    preventScrollReset: opts == null ? void 0 : opts.preventScrollReset
                });
            },
            replace: function(to, state, opts) {
                return router.navigate(to, {
                    replace: true,
                    state: state,
                    preventScrollReset: opts == null ? void 0 : opts.preventScrollReset
                });
            }
        };
    }, [
        router
    ]);
    var basename = router.basename || "/";
    var dataRouterContext = $dQFEZ.useMemo(function() {
        return {
            router: router,
            navigator: navigator,
            static: false,
            basename: basename
        };
    }, [
        router,
        navigator,
        basename
    ]);
    $dQFEZ.useEffect(function() {
        return $8c3ad80f8a436e0f$export$db5148ec97d6af7a(future, router.future);
    }, [
        router,
        future
    ]);
    // The fragment and {null} here are important!  We need them to keep React 18's
    // useId happy when we are server-rendering since we may have a <script> here
    // containing the hydrated server-side staticContext (from StaticRouterProvider).
    // useId relies on the component tree structure to generate deterministic id's
    // so we need to ensure it remains the same on the client even though
    // we don't need the <script> tag
    return /*#__PURE__*/ $dQFEZ.createElement($dQFEZ.Fragment, null, /*#__PURE__*/ $dQFEZ.createElement($8c3ad80f8a436e0f$export$3add0d5dce533e2e.Provider, {
        value: dataRouterContext
    }, /*#__PURE__*/ $dQFEZ.createElement($8c3ad80f8a436e0f$export$145dfa71566a64dc.Provider, {
        value: state
    }, /*#__PURE__*/ $dQFEZ.createElement($8c3ad80f8a436e0f$export$55185c17a0fcbe46, {
        basename: basename,
        location: state.location,
        navigationType: state.historyAction,
        navigator: navigator,
        future: {
            v7_relativeSplatPath: router.future.v7_relativeSplatPath
        }
    }, state.initialized || router.future.v7_partialHydration ? /*#__PURE__*/ $dQFEZ.createElement($8c3ad80f8a436e0f$var$DataRoutes, {
        routes: router.routes,
        future: router.future,
        state: state
    }) : fallbackElement))), null);
}
function $8c3ad80f8a436e0f$var$DataRoutes(_ref2) {
    var routes = _ref2.routes, future = _ref2.future, state = _ref2.state;
    return $8c3ad80f8a436e0f$export$5fcee62552a12fbf(routes, undefined, state, future);
}
/**
 * A `<Router>` that stores all entries in memory.
 *
 * @see https://reactrouter.com/v6/router-components/memory-router
 */ function $8c3ad80f8a436e0f$export$ae46f04cfaffe093(_ref3) {
    var basename = _ref3.basename, children = _ref3.children, initialEntries = _ref3.initialEntries, initialIndex = _ref3.initialIndex, future = _ref3.future;
    var historyRef = $dQFEZ.useRef();
    if (historyRef.current == null) historyRef.current = (0, $gl7zH.createMemoryHistory)({
        initialEntries: initialEntries,
        initialIndex: initialIndex,
        v5Compat: true
    });
    var history = historyRef.current;
    var _React_useState = (0, $2nwvT._)($dQFEZ.useState({
        action: history.action,
        location: history.location
    }), 2), state = _React_useState[0], setStateImpl = _React_useState[1];
    var v7_startTransition = (future || {}).v7_startTransition;
    var setState = $dQFEZ.useCallback(function(newState) {
        v7_startTransition && $8c3ad80f8a436e0f$var$startTransitionImpl ? $8c3ad80f8a436e0f$var$startTransitionImpl(function() {
            return setStateImpl(newState);
        }) : setStateImpl(newState);
    }, [
        setStateImpl,
        v7_startTransition
    ]);
    $dQFEZ.useLayoutEffect(function() {
        return history.listen(setState);
    }, [
        history,
        setState
    ]);
    $dQFEZ.useEffect(function() {
        return $8c3ad80f8a436e0f$export$db5148ec97d6af7a(future);
    }, [
        future
    ]);
    return /*#__PURE__*/ $dQFEZ.createElement($8c3ad80f8a436e0f$export$55185c17a0fcbe46, {
        basename: basename,
        children: children,
        location: state.location,
        navigationType: state.action,
        navigator: history,
        future: future
    });
}
/**
 * Changes the current location.
 *
 * Note: This API is mostly useful in React.Component subclasses that are not
 * able to use hooks. In functional components, we recommend you use the
 * `useNavigate` hook instead.
 *
 * @see https://reactrouter.com/v6/components/navigate
 */ function $8c3ad80f8a436e0f$export$444b3ab0cb9aec40(_ref4) {
    var to = _ref4.to, replace = _ref4.replace, state = _ref4.state, relative = _ref4.relative;
    !$8c3ad80f8a436e0f$export$9c954a9d03d32f4a() && (0, $gl7zH.UNSAFE_invariant)(false);
    var _React_useContext = $dQFEZ.useContext($8c3ad80f8a436e0f$export$26749e8557646306), future = _React_useContext.future, isStatic = _React_useContext.static;
    var matches = $dQFEZ.useContext($8c3ad80f8a436e0f$export$9072aa6dd1f93057).matches;
    var _useLocation = $8c3ad80f8a436e0f$export$45d76561a5302f2b(), locationPathname = _useLocation.pathname;
    var navigate = $8c3ad80f8a436e0f$export$9770f232ac06a008();
    // Resolve the path outside of the effect so that when effects run twice in
    // StrictMode they navigate to the same place
    var path = (0, $gl7zH.resolveTo)(to, (0, $gl7zH.UNSAFE_getResolveToMatches)(matches, future.v7_relativeSplatPath), locationPathname, relative === "path");
    var jsonPath = JSON.stringify(path);
    $dQFEZ.useEffect(function() {
        return navigate(JSON.parse(jsonPath), {
            replace: replace,
            state: state,
            relative: relative
        });
    }, [
        navigate,
        jsonPath,
        relative,
        replace,
        state
    ]);
    return null;
}
/**
 * Renders the child route's element, if there is one.
 *
 * @see https://reactrouter.com/v6/components/outlet
 */ function $8c3ad80f8a436e0f$export$910ae8079b2c2852(props) {
    return $8c3ad80f8a436e0f$export$a3be3530d8e40d0b(props.context);
}
/**
 * Declares an element that should be rendered at a certain URL path.
 *
 * @see https://reactrouter.com/v6/components/route
 */ function $8c3ad80f8a436e0f$export$e7b0ac011bb776c6(_props) {
    (0, $gl7zH.UNSAFE_invariant)(false);
}
/**
 * Provides location context for the rest of the app.
 *
 * Note: You usually won't render a `<Router>` directly. Instead, you'll render a
 * router that is more specific to your environment such as a `<BrowserRouter>`
 * in web browsers or a `<StaticRouter>` for server rendering.
 *
 * @see https://reactrouter.com/v6/router-components/router
 */ function $8c3ad80f8a436e0f$export$55185c17a0fcbe46(_ref5) {
    var tmp = _ref5.basename, basenameProp = tmp === void 0 ? "/" : tmp, _ref5_children = _ref5.children, children = _ref5_children === void 0 ? null : _ref5_children, locationProp = _ref5.location, _ref5_navigationType = _ref5.navigationType, navigationType = _ref5_navigationType === void 0 ? (0, $gl7zH.Action).Pop : _ref5_navigationType, navigator = _ref5.navigator, tmp1 = _ref5.static, staticProp = tmp1 === void 0 ? false : tmp1, future = _ref5.future;
    !!$8c3ad80f8a436e0f$export$9c954a9d03d32f4a() && (0, $gl7zH.UNSAFE_invariant)(false);
    // Preserve trailing slashes on basename, so we can let the user control
    // the enforcement of trailing slashes throughout the app
    var basename = basenameProp.replace(/^\/*/, "/");
    var navigationContext = $dQFEZ.useMemo(function() {
        return {
            basename: basename,
            navigator: navigator,
            static: staticProp,
            future: $8c3ad80f8a436e0f$var$_extends({
                v7_relativeSplatPath: false
            }, future)
        };
    }, [
        basename,
        future,
        navigator,
        staticProp
    ]);
    if (typeof locationProp === "string") locationProp = (0, $gl7zH.parsePath)(locationProp);
    var _locationProp_pathname = locationProp.pathname, pathname = _locationProp_pathname === void 0 ? "/" : _locationProp_pathname, _locationProp_search = locationProp.search, search = _locationProp_search === void 0 ? "" : _locationProp_search, _locationProp_hash = locationProp.hash, hash = _locationProp_hash === void 0 ? "" : _locationProp_hash, _locationProp_state = locationProp.state, state = _locationProp_state === void 0 ? null : _locationProp_state, _locationProp_key = locationProp.key, key = _locationProp_key === void 0 ? "default" : _locationProp_key;
    var locationContext = $dQFEZ.useMemo(function() {
        var trailingPathname = (0, $gl7zH.stripBasename)(pathname, basename);
        if (trailingPathname == null) return null;
        return {
            location: {
                pathname: trailingPathname,
                search: search,
                hash: hash,
                state: state,
                key: key
            },
            navigationType: navigationType
        };
    }, [
        basename,
        pathname,
        search,
        hash,
        state,
        key,
        navigationType
    ]);
    if (locationContext == null) return null;
    return /*#__PURE__*/ $dQFEZ.createElement($8c3ad80f8a436e0f$export$26749e8557646306.Provider, {
        value: navigationContext
    }, /*#__PURE__*/ $dQFEZ.createElement($8c3ad80f8a436e0f$export$c7914228fb69b0f5.Provider, {
        children: children,
        value: locationContext
    }));
}
/**
 * A container for a nested tree of `<Route>` elements that renders the branch
 * that best matches the current location.
 *
 * @see https://reactrouter.com/v6/components/routes
 */ function $8c3ad80f8a436e0f$export$3565eb3d00ca5a74(_ref6) {
    var children = _ref6.children, location = _ref6.location;
    return $8c3ad80f8a436e0f$export$5d3fca4a98652595($8c3ad80f8a436e0f$export$16da398f5434bdec(children), location);
}
/**
 * Component to use for rendering lazily loaded data from returning defer()
 * in a loader function
 */ function $8c3ad80f8a436e0f$export$6ddabde395c8c576(_ref7) {
    var children = _ref7.children, errorElement = _ref7.errorElement, resolve = _ref7.resolve;
    return /*#__PURE__*/ $dQFEZ.createElement($8c3ad80f8a436e0f$var$AwaitErrorBoundary, {
        resolve: resolve,
        errorElement: errorElement
    }, /*#__PURE__*/ $dQFEZ.createElement($8c3ad80f8a436e0f$var$ResolveAwait, null, children));
}
var $8c3ad80f8a436e0f$var$AwaitRenderStatus = /*#__PURE__*/ function(AwaitRenderStatus) {
    AwaitRenderStatus[AwaitRenderStatus["pending"] = 0] = "pending";
    AwaitRenderStatus[AwaitRenderStatus["success"] = 1] = "success";
    AwaitRenderStatus[AwaitRenderStatus["error"] = 2] = "error";
    return AwaitRenderStatus;
}($8c3ad80f8a436e0f$var$AwaitRenderStatus || {});
var $8c3ad80f8a436e0f$var$neverSettledPromise = new Promise(function() {});
var $8c3ad80f8a436e0f$var$AwaitErrorBoundary = /*#__PURE__*/ function(_React_Component) {
    "use strict";
    (0, $j6Mzi._)(AwaitErrorBoundary, _React_Component);
    function AwaitErrorBoundary(props) {
        (0, $grujF._)(this, AwaitErrorBoundary);
        var _this;
        _this = (0, $f3Okx._)(this, AwaitErrorBoundary, [
            props
        ]);
        _this.state = {
            error: null
        };
        return _this;
    }
    (0, $dhMkv._)(AwaitErrorBoundary, [
        {
            key: "componentDidCatch",
            value: function componentDidCatch(error, errorInfo) {
                console.error("<Await> caught the following error during render", error, errorInfo);
            }
        },
        {
            key: "render",
            value: function render() {
                var _this_props = this.props, children = _this_props.children, errorElement = _this_props.errorElement, resolve = _this_props.resolve;
                var promise = null;
                var status = $8c3ad80f8a436e0f$var$AwaitRenderStatus.pending;
                if (!(resolve instanceof Promise)) {
                    // Didn't get a promise - provide as a resolved promise
                    status = $8c3ad80f8a436e0f$var$AwaitRenderStatus.success;
                    promise = Promise.resolve();
                    Object.defineProperty(promise, "_tracked", {
                        get: function() {
                            return true;
                        }
                    });
                    Object.defineProperty(promise, "_data", {
                        get: function() {
                            return resolve;
                        }
                    });
                } else if (this.state.error) {
                    // Caught a render error, provide it as a rejected promise
                    status = $8c3ad80f8a436e0f$var$AwaitRenderStatus.error;
                    var renderError = this.state.error;
                    promise = Promise.reject().catch(function() {}); // Avoid unhandled rejection warnings
                    Object.defineProperty(promise, "_tracked", {
                        get: function() {
                            return true;
                        }
                    });
                    Object.defineProperty(promise, "_error", {
                        get: function() {
                            return renderError;
                        }
                    });
                } else if (resolve._tracked) {
                    // Already tracked promise - check contents
                    promise = resolve;
                    status = "_error" in promise ? $8c3ad80f8a436e0f$var$AwaitRenderStatus.error : "_data" in promise ? $8c3ad80f8a436e0f$var$AwaitRenderStatus.success : $8c3ad80f8a436e0f$var$AwaitRenderStatus.pending;
                } else {
                    // Raw (untracked) promise - track it
                    status = $8c3ad80f8a436e0f$var$AwaitRenderStatus.pending;
                    Object.defineProperty(resolve, "_tracked", {
                        get: function() {
                            return true;
                        }
                    });
                    promise = resolve.then(function(data) {
                        return Object.defineProperty(resolve, "_data", {
                            get: function() {
                                return data;
                            }
                        });
                    }, function(error) {
                        return Object.defineProperty(resolve, "_error", {
                            get: function() {
                                return error;
                            }
                        });
                    });
                }
                if (status === $8c3ad80f8a436e0f$var$AwaitRenderStatus.error && promise._error instanceof (0, $gl7zH.AbortedDeferredError)) // Freeze the UI by throwing a never resolved promise
                throw $8c3ad80f8a436e0f$var$neverSettledPromise;
                if (status === $8c3ad80f8a436e0f$var$AwaitRenderStatus.error && !errorElement) // No errorElement, throw to the nearest route-level error boundary
                throw promise._error;
                if (status === $8c3ad80f8a436e0f$var$AwaitRenderStatus.error) // Render via our errorElement
                return /*#__PURE__*/ $dQFEZ.createElement($8c3ad80f8a436e0f$var$AwaitContext.Provider, {
                    value: promise,
                    children: errorElement
                });
                if (status === $8c3ad80f8a436e0f$var$AwaitRenderStatus.success) // Render children with resolved value
                return /*#__PURE__*/ $dQFEZ.createElement($8c3ad80f8a436e0f$var$AwaitContext.Provider, {
                    value: promise,
                    children: children
                });
                // Throw to the suspense boundary
                throw promise;
            }
        }
    ], [
        {
            key: "getDerivedStateFromError",
            value: function getDerivedStateFromError(error) {
                return {
                    error: error
                };
            }
        }
    ]);
    return AwaitErrorBoundary;
}($dQFEZ.Component);
/**
 * @private
 * Indirection to leverage useAsyncValue for a render-prop API on `<Await>`
 */ function $8c3ad80f8a436e0f$var$ResolveAwait(_ref8) {
    var children = _ref8.children;
    var data = $8c3ad80f8a436e0f$export$78a72ddb39bdd145();
    var toRender = typeof children === "function" ? children(data) : children;
    return /*#__PURE__*/ $dQFEZ.createElement($dQFEZ.Fragment, null, toRender);
}
///////////////////////////////////////////////////////////////////////////////
// UTILS
///////////////////////////////////////////////////////////////////////////////
/**
 * Creates a route config from a React "children" object, which is usually
 * either a `<Route>` element or an array of them. Used internally by
 * `<Routes>` to create a route config from its children.
 *
 * @see https://reactrouter.com/v6/utils/create-routes-from-children
 */ function $8c3ad80f8a436e0f$export$16da398f5434bdec(children, parentPath) {
    if (parentPath === void 0) parentPath = [];
    var routes = [];
    $dQFEZ.Children.forEach(children, function(element, index) {
        if (!/*#__PURE__*/ $dQFEZ.isValidElement(element)) // Ignore non-elements. This allows people to more easily inline
        // conditionals in their route config.
        return;
        var treePath = (0, $2us1u._)(parentPath).concat([
            index
        ]);
        if (element.type === $dQFEZ.Fragment) {
            // Transparently support React.Fragment and its children.
            routes.push.apply(routes, $8c3ad80f8a436e0f$export$16da398f5434bdec(element.props.children, treePath));
            return;
        }
        !(element.type === $8c3ad80f8a436e0f$export$e7b0ac011bb776c6) && (0, $gl7zH.UNSAFE_invariant)(false);
        !(!element.props.index || !element.props.children) && (0, $gl7zH.UNSAFE_invariant)(false);
        var route = {
            id: element.props.id || treePath.join("-"),
            caseSensitive: element.props.caseSensitive,
            element: element.props.element,
            Component: element.props.Component,
            index: element.props.index,
            path: element.props.path,
            loader: element.props.loader,
            action: element.props.action,
            errorElement: element.props.errorElement,
            ErrorBoundary: element.props.ErrorBoundary,
            hasErrorBoundary: element.props.ErrorBoundary != null || element.props.errorElement != null,
            shouldRevalidate: element.props.shouldRevalidate,
            handle: element.props.handle,
            lazy: element.props.lazy
        };
        if (element.props.children) route.children = $8c3ad80f8a436e0f$export$16da398f5434bdec(element.props.children, treePath);
        routes.push(route);
    });
    return routes;
}
/**
 * Renders the result of `matchRoutes()` into a React element.
 */ function $8c3ad80f8a436e0f$export$daf73786167a7f72(matches) {
    return $8c3ad80f8a436e0f$var$_renderMatches(matches);
}
function $8c3ad80f8a436e0f$export$52b333d321859367(route) {
    var updates = {
        // Note: this check also occurs in createRoutesFromChildren so update
        // there if you change this -- please and thank you!
        hasErrorBoundary: route.ErrorBoundary != null || route.errorElement != null
    };
    if (route.Component) Object.assign(updates, {
        element: /*#__PURE__*/ $dQFEZ.createElement(route.Component),
        Component: undefined
    });
    if (route.HydrateFallback) Object.assign(updates, {
        hydrateFallbackElement: /*#__PURE__*/ $dQFEZ.createElement(route.HydrateFallback),
        HydrateFallback: undefined
    });
    if (route.ErrorBoundary) Object.assign(updates, {
        errorElement: /*#__PURE__*/ $dQFEZ.createElement(route.ErrorBoundary),
        ErrorBoundary: undefined
    });
    return updates;
}
function $8c3ad80f8a436e0f$export$f30f7e456d254e83(routes, opts) {
    return (0, $gl7zH.createRouter)({
        basename: opts == null ? void 0 : opts.basename,
        future: $8c3ad80f8a436e0f$var$_extends({}, opts == null ? void 0 : opts.future, {
            v7_prependBasename: true
        }),
        history: (0, $gl7zH.createMemoryHistory)({
            initialEntries: opts == null ? void 0 : opts.initialEntries,
            initialIndex: opts == null ? void 0 : opts.initialIndex
        }),
        hydrationData: opts == null ? void 0 : opts.hydrationData,
        routes: routes,
        mapRouteProperties: $8c3ad80f8a436e0f$export$52b333d321859367,
        dataStrategy: opts == null ? void 0 : opts.dataStrategy,
        patchRoutesOnNavigation: opts == null ? void 0 : opts.patchRoutesOnNavigation
    }).initialize();
}



var $gl7zH = parcelRequire("gl7zH");
function $fc41d09ddc03e3ec$var$_extends() {
    $fc41d09ddc03e3ec$var$_extends = Object.assign ? Object.assign.bind() : function _extends(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $fc41d09ddc03e3ec$var$_extends.apply(this, arguments);
}
function $fc41d09ddc03e3ec$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
var $fc41d09ddc03e3ec$var$defaultMethod = "get";
var $fc41d09ddc03e3ec$var$defaultEncType = "application/x-www-form-urlencoded";
function $fc41d09ddc03e3ec$var$isHtmlElement(object) {
    return object != null && typeof object.tagName === "string";
}
function $fc41d09ddc03e3ec$var$isButtonElement(object) {
    return $fc41d09ddc03e3ec$var$isHtmlElement(object) && object.tagName.toLowerCase() === "button";
}
function $fc41d09ddc03e3ec$var$isFormElement(object) {
    return $fc41d09ddc03e3ec$var$isHtmlElement(object) && object.tagName.toLowerCase() === "form";
}
function $fc41d09ddc03e3ec$var$isInputElement(object) {
    return $fc41d09ddc03e3ec$var$isHtmlElement(object) && object.tagName.toLowerCase() === "input";
}
function $fc41d09ddc03e3ec$var$isModifiedEvent(event) {
    return !!(event.metaKey || event.altKey || event.ctrlKey || event.shiftKey);
}
function $fc41d09ddc03e3ec$var$shouldProcessLinkClick(event, target) {
    return event.button === 0 && // Ignore everything but left clicks
    (!target || target === "_self") && // Let browser handle "target=_blank" etc.
    !$fc41d09ddc03e3ec$var$isModifiedEvent(event) // Ignore clicks with modifier keys
    ;
}
/**
 * Creates a URLSearchParams object using the given initializer.
 *
 * This is identical to `new URLSearchParams(init)` except it also
 * supports arrays as values in the object form of the initializer
 * instead of just strings. This is convenient when you need multiple
 * values for a given key, but don't want to use an array initializer.
 *
 * For example, instead of:
 *
 *   let searchParams = new URLSearchParams([
 *     ['sort', 'name'],
 *     ['sort', 'price']
 *   ]);
 *
 * you can do:
 *
 *   let searchParams = createSearchParams({
 *     sort: ['name', 'price']
 *   });
 */ function $fc41d09ddc03e3ec$export$a2e4e2dcc7b1f22f(init) {
    if (init === void 0) init = "";
    return new URLSearchParams(typeof init === "string" || Array.isArray(init) || init instanceof URLSearchParams ? init : Object.keys(init).reduce(function(memo, key) {
        var value = init[key];
        return memo.concat(Array.isArray(value) ? value.map(function(v) {
            return [
                key,
                v
            ];
        }) : [
            [
                key,
                value
            ]
        ]);
    }, []));
}
function $fc41d09ddc03e3ec$var$getSearchParamsForLocation(locationSearch, defaultSearchParams) {
    var searchParams = $fc41d09ddc03e3ec$export$a2e4e2dcc7b1f22f(locationSearch);
    if (defaultSearchParams) // Use `defaultSearchParams.forEach(...)` here instead of iterating of
    // `defaultSearchParams.keys()` to work-around a bug in Firefox related to
    // web extensions. Relevant Bugzilla tickets:
    // https://bugzilla.mozilla.org/show_bug.cgi?id=1414602
    // https://bugzilla.mozilla.org/show_bug.cgi?id=1023984
    defaultSearchParams.forEach(function(_, key) {
        if (!searchParams.has(key)) defaultSearchParams.getAll(key).forEach(function(value) {
            searchParams.append(key, value);
        });
    });
    return searchParams;
}
// One-time check for submitter support
var $fc41d09ddc03e3ec$var$_formDataSupportsSubmitter = null;
function $fc41d09ddc03e3ec$var$isFormDataSubmitterSupported() {
    if ($fc41d09ddc03e3ec$var$_formDataSupportsSubmitter === null) try {
        new FormData(document.createElement("form"), // @ts-expect-error if FormData supports the submitter parameter, this will throw
        0);
        $fc41d09ddc03e3ec$var$_formDataSupportsSubmitter = false;
    } catch (e) {
        $fc41d09ddc03e3ec$var$_formDataSupportsSubmitter = true;
    }
    return $fc41d09ddc03e3ec$var$_formDataSupportsSubmitter;
}
var $fc41d09ddc03e3ec$var$supportedFormEncTypes = new Set([
    "application/x-www-form-urlencoded",
    "multipart/form-data",
    "text/plain"
]);
function $fc41d09ddc03e3ec$var$getFormEncType(encType) {
    if (encType != null && !$fc41d09ddc03e3ec$var$supportedFormEncTypes.has(encType)) return null;
    return encType;
}
function $fc41d09ddc03e3ec$var$getFormSubmissionInfo(target, basename) {
    var method;
    var action;
    var encType;
    var formData;
    var body;
    if ($fc41d09ddc03e3ec$var$isFormElement(target)) {
        // When grabbing the action from the element, it will have had the basename
        // prefixed to ensure non-JS scenarios work, so strip it since we'll
        // re-prefix in the router
        var attr = target.getAttribute("action");
        action = attr ? (0, $gl7zH.stripBasename)(attr, basename) : null;
        method = target.getAttribute("method") || $fc41d09ddc03e3ec$var$defaultMethod;
        encType = $fc41d09ddc03e3ec$var$getFormEncType(target.getAttribute("enctype")) || $fc41d09ddc03e3ec$var$defaultEncType;
        formData = new FormData(target);
    } else if ($fc41d09ddc03e3ec$var$isButtonElement(target) || $fc41d09ddc03e3ec$var$isInputElement(target) && (target.type === "submit" || target.type === "image")) {
        var form = target.form;
        if (form == null) throw new Error("Cannot submit a <button> or <input type=\"submit\"> without a <form>");
        // <button>/<input type="submit"> may override attributes of <form>
        // When grabbing the action from the element, it will have had the basename
        // prefixed to ensure non-JS scenarios work, so strip it since we'll
        // re-prefix in the router
        var attr1 = target.getAttribute("formaction") || form.getAttribute("action");
        action = attr1 ? (0, $gl7zH.stripBasename)(attr1, basename) : null;
        method = target.getAttribute("formmethod") || form.getAttribute("method") || $fc41d09ddc03e3ec$var$defaultMethod;
        encType = $fc41d09ddc03e3ec$var$getFormEncType(target.getAttribute("formenctype")) || $fc41d09ddc03e3ec$var$getFormEncType(form.getAttribute("enctype")) || $fc41d09ddc03e3ec$var$defaultEncType;
        // Build a FormData object populated from a form and submitter
        formData = new FormData(form, target);
        // If this browser doesn't support the `FormData(el, submitter)` format,
        // then tack on the submitter value at the end.  This is a lightweight
        // solution that is not 100% spec compliant.  For complete support in older
        // browsers, consider using the `formdata-submitter-polyfill` package
        if (!$fc41d09ddc03e3ec$var$isFormDataSubmitterSupported()) {
            var name = target.name, type = target.type, value = target.value;
            if (type === "image") {
                var prefix = name ? name + "." : "";
                formData.append(prefix + "x", "0");
                formData.append(prefix + "y", "0");
            } else if (name) formData.append(name, value);
        }
    } else if ($fc41d09ddc03e3ec$var$isHtmlElement(target)) throw new Error('Cannot submit element that is not <form>, <button>, or <input type="submit|image">');
    else {
        method = $fc41d09ddc03e3ec$var$defaultMethod;
        action = null;
        encType = $fc41d09ddc03e3ec$var$defaultEncType;
        body = target;
    }
    // Send body for <Form encType="text/plain" so we encode it into text
    if (formData && encType === "text/plain") {
        body = formData;
        formData = undefined;
    }
    return {
        action: action,
        method: method.toLowerCase(),
        encType: encType,
        formData: formData,
        body: body
    };
}
var $fc41d09ddc03e3ec$var$_excluded = [
    "onClick",
    "relative",
    "reloadDocument",
    "replace",
    "state",
    "target",
    "to",
    "preventScrollReset",
    "viewTransition"
], $fc41d09ddc03e3ec$var$_excluded2 = [
    "aria-current",
    "caseSensitive",
    "className",
    "end",
    "style",
    "to",
    "viewTransition",
    "children"
], $fc41d09ddc03e3ec$var$_excluded3 = [
    "fetcherKey",
    "navigate",
    "reloadDocument",
    "replace",
    "state",
    "method",
    "action",
    "onSubmit",
    "relative",
    "preventScrollReset",
    "viewTransition"
];
// HEY YOU! DON'T TOUCH THIS VARIABLE!
//
// It is replaced with the proper version at build time via a babel plugin in
// the rollup config.
//
// Export a global property onto the window for React Router detection by the
// Core Web Vitals Technology Report.  This way they can configure the `wappalyzer`
// to detect and properly classify live websites as being built with React Router:
// https://github.com/HTTPArchive/wappalyzer/blob/main/src/technologies/r.json
var $fc41d09ddc03e3ec$var$REACT_ROUTER_VERSION = "6";
try {
    window.__reactRouterVersion = $fc41d09ddc03e3ec$var$REACT_ROUTER_VERSION;
} catch (e) {
// no-op
}
function $fc41d09ddc03e3ec$export$1f3f55432a00e06d(routes, opts) {
    return (0, $gl7zH.createRouter)({
        basename: opts == null ? void 0 : opts.basename,
        future: $fc41d09ddc03e3ec$var$_extends({}, opts == null ? void 0 : opts.future, {
            v7_prependBasename: true
        }),
        history: (0, $gl7zH.createBrowserHistory)({
            window: opts == null ? void 0 : opts.window
        }),
        hydrationData: (opts == null ? void 0 : opts.hydrationData) || $fc41d09ddc03e3ec$var$parseHydrationData(),
        routes: routes,
        mapRouteProperties: (0, $8c3ad80f8a436e0f$export$52b333d321859367),
        dataStrategy: opts == null ? void 0 : opts.dataStrategy,
        patchRoutesOnNavigation: opts == null ? void 0 : opts.patchRoutesOnNavigation,
        window: opts == null ? void 0 : opts.window
    }).initialize();
}
function $fc41d09ddc03e3ec$export$1ba7ed8a3a7b3765(routes, opts) {
    return (0, $gl7zH.createRouter)({
        basename: opts == null ? void 0 : opts.basename,
        future: $fc41d09ddc03e3ec$var$_extends({}, opts == null ? void 0 : opts.future, {
            v7_prependBasename: true
        }),
        history: (0, $gl7zH.createHashHistory)({
            window: opts == null ? void 0 : opts.window
        }),
        hydrationData: (opts == null ? void 0 : opts.hydrationData) || $fc41d09ddc03e3ec$var$parseHydrationData(),
        routes: routes,
        mapRouteProperties: (0, $8c3ad80f8a436e0f$export$52b333d321859367),
        dataStrategy: opts == null ? void 0 : opts.dataStrategy,
        patchRoutesOnNavigation: opts == null ? void 0 : opts.patchRoutesOnNavigation,
        window: opts == null ? void 0 : opts.window
    }).initialize();
}
function $fc41d09ddc03e3ec$var$parseHydrationData() {
    var _window;
    var state = (_window = window) == null ? void 0 : _window.__staticRouterHydrationData;
    if (state && state.errors) state = $fc41d09ddc03e3ec$var$_extends({}, state, {
        errors: $fc41d09ddc03e3ec$var$deserializeErrors(state.errors)
    });
    return state;
}
function $fc41d09ddc03e3ec$var$deserializeErrors(errors) {
    if (!errors) return null;
    var entries = Object.entries(errors);
    var serialized = {};
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = entries[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var _step_value = (0, $2nwvT._)(_step.value, 2), key = _step_value[0], val = _step_value[1];
            // Hey you!  If you change this, please change the corresponding logic in
            // serializeErrors in react-router-dom/server.tsx :)
            if (val && val.__type === "RouteErrorResponse") serialized[key] = new (0, $gl7zH.UNSAFE_ErrorResponseImpl)(val.status, val.statusText, val.data, val.internal === true);
            else if (val && val.__type === "Error") {
                // Attempt to reconstruct the right type of Error (i.e., ReferenceError)
                if (val.__subType) {
                    var ErrorConstructor = window[val.__subType];
                    if (typeof ErrorConstructor === "function") try {
                        // @ts-expect-error
                        var error = new ErrorConstructor(val.message);
                        // Wipe away the client-side stack trace.  Nothing to fill it in with
                        // because we don't serialize SSR stack traces for security reasons
                        error.stack = "";
                        serialized[key] = error;
                    } catch (e) {
                    // no-op - fall through and create a normal Error
                    }
                }
                if (serialized[key] == null) {
                    var error1 = new Error(val.message);
                    // Wipe away the client-side stack trace.  Nothing to fill it in with
                    // because we don't serialize SSR stack traces for security reasons
                    error1.stack = "";
                    serialized[key] = error1;
                }
            } else serialized[key] = val;
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    return serialized;
}
var $fc41d09ddc03e3ec$export$7ad602f0e94e62d1 = /*#__PURE__*/ $dQFEZ.createContext({
    isTransitioning: false
});
var $fc41d09ddc03e3ec$export$148fd98d095596d4 = /*#__PURE__*/ $dQFEZ.createContext(new Map());
//#endregion
////////////////////////////////////////////////////////////////////////////////
//#region Components
////////////////////////////////////////////////////////////////////////////////
/**
  Webpack + React 17 fails to compile on any of the following because webpack
  complains that `startTransition` doesn't exist in `React`:
  * import { startTransition } from "react"
  * import * as React from from "react";
    "startTransition" in React ? React.startTransition(() => setState()) : setState()
  * import * as React from from "react";
    "startTransition" in React ? React["startTransition"](() => setState()) : setState()

  Moving it to a constant such as the following solves the Webpack/React 17 issue:
  * import * as React from from "react";
    const START_TRANSITION = "startTransition";
    START_TRANSITION in React ? React[START_TRANSITION](() => setState()) : setState()

  However, that introduces webpack/terser minification issues in production builds
  in React 18 where minification/obfuscation ends up removing the call of
  React.startTransition entirely from the first half of the ternary.  Grabbing
  this exported reference once up front resolves that issue.

  See https://github.com/remix-run/react-router/issues/10579
*/ var $fc41d09ddc03e3ec$var$START_TRANSITION = "startTransition";
var $fc41d09ddc03e3ec$var$startTransitionImpl = $dQFEZ[$fc41d09ddc03e3ec$var$START_TRANSITION];
var $fc41d09ddc03e3ec$var$FLUSH_SYNC = "flushSync";
var $fc41d09ddc03e3ec$var$flushSyncImpl = $4288f0eb191085d1$exports[$fc41d09ddc03e3ec$var$FLUSH_SYNC];
var $fc41d09ddc03e3ec$var$USE_ID = "useId";
var $fc41d09ddc03e3ec$var$useIdImpl = $dQFEZ[$fc41d09ddc03e3ec$var$USE_ID];
function $fc41d09ddc03e3ec$var$startTransitionSafe(cb) {
    if ($fc41d09ddc03e3ec$var$startTransitionImpl) $fc41d09ddc03e3ec$var$startTransitionImpl(cb);
    else cb();
}
function $fc41d09ddc03e3ec$var$flushSyncSafe(cb) {
    if ($fc41d09ddc03e3ec$var$flushSyncImpl) $fc41d09ddc03e3ec$var$flushSyncImpl(cb);
    else cb();
}
var $fc41d09ddc03e3ec$var$Deferred = function Deferred() {
    "use strict";
    var _this = this;
    (0, $grujF._)(this, Deferred);
    this.status = "pending";
    this.promise = new Promise(function(resolve, reject) {
        _this.resolve = function(value) {
            if (_this.status === "pending") {
                _this.status = "resolved";
                resolve(value);
            }
        };
        _this.reject = function(reason) {
            if (_this.status === "pending") {
                _this.status = "rejected";
                reject(reason);
            }
        };
    });
};
/**
 * Given a Remix Router instance, render the appropriate UI
 */ function $fc41d09ddc03e3ec$export$323e4fc2fa4753fb(_ref) {
    var fallbackElement = _ref.fallbackElement, router = _ref.router, future = _ref.future;
    var _React_useState = (0, $2nwvT._)($dQFEZ.useState(router.state), 2), state = _React_useState[0], setStateImpl = _React_useState[1];
    var _React_useState1 = (0, $2nwvT._)($dQFEZ.useState(), 2), pendingState = _React_useState1[0], setPendingState = _React_useState1[1];
    var _React_useState2 = (0, $2nwvT._)($dQFEZ.useState({
        isTransitioning: false
    }), 2), vtContext = _React_useState2[0], setVtContext = _React_useState2[1];
    var _React_useState3 = (0, $2nwvT._)($dQFEZ.useState(), 2), renderDfd = _React_useState3[0], setRenderDfd = _React_useState3[1];
    var _React_useState4 = (0, $2nwvT._)($dQFEZ.useState(), 2), transition = _React_useState4[0], setTransition = _React_useState4[1];
    var _React_useState5 = (0, $2nwvT._)($dQFEZ.useState(), 2), interruption = _React_useState5[0], setInterruption = _React_useState5[1];
    var fetcherData = $dQFEZ.useRef(new Map());
    var v7_startTransition = (future || {}).v7_startTransition;
    var optInStartTransition = $dQFEZ.useCallback(function(cb) {
        if (v7_startTransition) $fc41d09ddc03e3ec$var$startTransitionSafe(cb);
        else cb();
    }, [
        v7_startTransition
    ]);
    var setState = $dQFEZ.useCallback(function(newState, _ref2) {
        var deletedFetchers = _ref2.deletedFetchers, flushSync = _ref2.flushSync, viewTransitionOpts = _ref2.viewTransitionOpts;
        newState.fetchers.forEach(function(fetcher, key) {
            if (fetcher.data !== undefined) fetcherData.current.set(key, fetcher.data);
        });
        deletedFetchers.forEach(function(key) {
            return fetcherData.current.delete(key);
        });
        var isViewTransitionUnavailable = router.window == null || router.window.document == null || typeof router.window.document.startViewTransition !== "function";
        // If this isn't a view transition or it's not available in this browser,
        // just update and be done with it
        if (!viewTransitionOpts || isViewTransitionUnavailable) {
            if (flushSync) $fc41d09ddc03e3ec$var$flushSyncSafe(function() {
                return setStateImpl(newState);
            });
            else optInStartTransition(function() {
                return setStateImpl(newState);
            });
            return;
        }
        // flushSync + startViewTransition
        if (flushSync) {
            // Flush through the context to mark DOM elements as transition=ing
            $fc41d09ddc03e3ec$var$flushSyncSafe(function() {
                // Cancel any pending transitions
                if (transition) {
                    renderDfd && renderDfd.resolve();
                    transition.skipTransition();
                }
                setVtContext({
                    isTransitioning: true,
                    flushSync: true,
                    currentLocation: viewTransitionOpts.currentLocation,
                    nextLocation: viewTransitionOpts.nextLocation
                });
            });
            // Update the DOM
            var t = router.window.document.startViewTransition(function() {
                $fc41d09ddc03e3ec$var$flushSyncSafe(function() {
                    return setStateImpl(newState);
                });
            });
            // Clean up after the animation completes
            t.finished.finally(function() {
                $fc41d09ddc03e3ec$var$flushSyncSafe(function() {
                    setRenderDfd(undefined);
                    setTransition(undefined);
                    setPendingState(undefined);
                    setVtContext({
                        isTransitioning: false
                    });
                });
            });
            $fc41d09ddc03e3ec$var$flushSyncSafe(function() {
                return setTransition(t);
            });
            return;
        }
        // startTransition + startViewTransition
        if (transition) {
            // Interrupting an in-progress transition, cancel and let everything flush
            // out, and then kick off a new transition from the interruption state
            renderDfd && renderDfd.resolve();
            transition.skipTransition();
            setInterruption({
                state: newState,
                currentLocation: viewTransitionOpts.currentLocation,
                nextLocation: viewTransitionOpts.nextLocation
            });
        } else {
            // Completed navigation update with opted-in view transitions, let 'er rip
            setPendingState(newState);
            setVtContext({
                isTransitioning: true,
                flushSync: false,
                currentLocation: viewTransitionOpts.currentLocation,
                nextLocation: viewTransitionOpts.nextLocation
            });
        }
    }, [
        router.window,
        transition,
        renderDfd,
        fetcherData,
        optInStartTransition
    ]);
    // Need to use a layout effect here so we are subscribed early enough to
    // pick up on any render-driven redirects/navigations (useEffect/<Navigate>)
    $dQFEZ.useLayoutEffect(function() {
        return router.subscribe(setState);
    }, [
        router,
        setState
    ]);
    // When we start a view transition, create a Deferred we can use for the
    // eventual "completed" render
    $dQFEZ.useEffect(function() {
        if (vtContext.isTransitioning && !vtContext.flushSync) setRenderDfd(new $fc41d09ddc03e3ec$var$Deferred());
    }, [
        vtContext
    ]);
    // Once the deferred is created, kick off startViewTransition() to update the
    // DOM and then wait on the Deferred to resolve (indicating the DOM update has
    // happened)
    $dQFEZ.useEffect(function() {
        if (renderDfd && pendingState && router.window) {
            var newState = pendingState;
            var renderPromise = renderDfd.promise;
            var transition = router.window.document.startViewTransition(function() {
                return (/*#__PURE__*/ 0, /*#__PURE__*/ $g3gsR._)(function() {
                    return (0, $fRv9I.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                optInStartTransition(function() {
                                    return setStateImpl(newState);
                                });
                                return [
                                    4,
                                    renderPromise
                                ];
                            case 1:
                                _state.sent();
                                return [
                                    2
                                ];
                        }
                    });
                })();
            });
            transition.finished.finally(function() {
                setRenderDfd(undefined);
                setTransition(undefined);
                setPendingState(undefined);
                setVtContext({
                    isTransitioning: false
                });
            });
            setTransition(transition);
        }
    }, [
        optInStartTransition,
        pendingState,
        renderDfd,
        router.window
    ]);
    // When the new location finally renders and is committed to the DOM, this
    // effect will run to resolve the transition
    $dQFEZ.useEffect(function() {
        if (renderDfd && pendingState && state.location.key === pendingState.location.key) renderDfd.resolve();
    }, [
        renderDfd,
        transition,
        state.location,
        pendingState
    ]);
    // If we get interrupted with a new navigation during a transition, we skip
    // the active transition, let it cleanup, then kick it off again here
    $dQFEZ.useEffect(function() {
        if (!vtContext.isTransitioning && interruption) {
            setPendingState(interruption.state);
            setVtContext({
                isTransitioning: true,
                flushSync: false,
                currentLocation: interruption.currentLocation,
                nextLocation: interruption.nextLocation
            });
            setInterruption(undefined);
        }
    }, [
        vtContext.isTransitioning,
        interruption
    ]);
    $dQFEZ.useEffect(function() {
    // Only log this once on initial mount
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    var navigator = $dQFEZ.useMemo(function() {
        return {
            createHref: router.createHref,
            encodeLocation: router.encodeLocation,
            go: function(n) {
                return router.navigate(n);
            },
            push: function(to, state, opts) {
                return router.navigate(to, {
                    state: state,
                    preventScrollReset: opts == null ? void 0 : opts.preventScrollReset
                });
            },
            replace: function(to, state, opts) {
                return router.navigate(to, {
                    replace: true,
                    state: state,
                    preventScrollReset: opts == null ? void 0 : opts.preventScrollReset
                });
            }
        };
    }, [
        router
    ]);
    var basename = router.basename || "/";
    var dataRouterContext = $dQFEZ.useMemo(function() {
        return {
            router: router,
            navigator: navigator,
            static: false,
            basename: basename
        };
    }, [
        router,
        navigator,
        basename
    ]);
    var routerFuture = $dQFEZ.useMemo(function() {
        return {
            v7_relativeSplatPath: router.future.v7_relativeSplatPath
        };
    }, [
        router.future.v7_relativeSplatPath
    ]);
    $dQFEZ.useEffect(function() {
        return (0, $8c3ad80f8a436e0f$export$db5148ec97d6af7a)(future, router.future);
    }, [
        future,
        router.future
    ]);
    // The fragment and {null} here are important!  We need them to keep React 18's
    // useId happy when we are server-rendering since we may have a <script> here
    // containing the hydrated server-side staticContext (from StaticRouterProvider).
    // useId relies on the component tree structure to generate deterministic id's
    // so we need to ensure it remains the same on the client even though
    // we don't need the <script> tag
    return /*#__PURE__*/ $dQFEZ.createElement($dQFEZ.Fragment, null, /*#__PURE__*/ $dQFEZ.createElement((0, $8c3ad80f8a436e0f$export$3add0d5dce533e2e).Provider, {
        value: dataRouterContext
    }, /*#__PURE__*/ $dQFEZ.createElement((0, $8c3ad80f8a436e0f$export$145dfa71566a64dc).Provider, {
        value: state
    }, /*#__PURE__*/ $dQFEZ.createElement($fc41d09ddc03e3ec$export$148fd98d095596d4.Provider, {
        value: fetcherData.current
    }, /*#__PURE__*/ $dQFEZ.createElement($fc41d09ddc03e3ec$export$7ad602f0e94e62d1.Provider, {
        value: vtContext
    }, /*#__PURE__*/ $dQFEZ.createElement((0, $8c3ad80f8a436e0f$export$55185c17a0fcbe46), {
        basename: basename,
        location: state.location,
        navigationType: state.historyAction,
        navigator: navigator,
        future: routerFuture
    }, state.initialized || router.future.v7_partialHydration ? /*#__PURE__*/ $dQFEZ.createElement($fc41d09ddc03e3ec$var$MemoizedDataRoutes, {
        routes: router.routes,
        future: router.future,
        state: state
    }) : fallbackElement))))), null);
}
// Memoize to avoid re-renders when updating `ViewTransitionContext`
var $fc41d09ddc03e3ec$var$MemoizedDataRoutes = /*#__PURE__*/ $dQFEZ.memo($fc41d09ddc03e3ec$var$DataRoutes);
function $fc41d09ddc03e3ec$var$DataRoutes(_ref3) {
    var routes = _ref3.routes, future = _ref3.future, state = _ref3.state;
    return (0, $8c3ad80f8a436e0f$export$5fcee62552a12fbf)(routes, undefined, state, future);
}
/**
 * A `<Router>` for use in web browsers. Provides the cleanest URLs.
 */ function $fc41d09ddc03e3ec$export$9ba4e89fdfa1fc54(_ref4) {
    var basename = _ref4.basename, children = _ref4.children, future = _ref4.future, _$window = _ref4.window;
    var historyRef = $dQFEZ.useRef();
    if (historyRef.current == null) historyRef.current = (0, $gl7zH.createBrowserHistory)({
        window: _$window,
        v5Compat: true
    });
    var history = historyRef.current;
    var _React_useState = (0, $2nwvT._)($dQFEZ.useState({
        action: history.action,
        location: history.location
    }), 2), state = _React_useState[0], setStateImpl = _React_useState[1];
    var v7_startTransition = (future || {}).v7_startTransition;
    var setState = $dQFEZ.useCallback(function(newState) {
        v7_startTransition && $fc41d09ddc03e3ec$var$startTransitionImpl ? $fc41d09ddc03e3ec$var$startTransitionImpl(function() {
            return setStateImpl(newState);
        }) : setStateImpl(newState);
    }, [
        setStateImpl,
        v7_startTransition
    ]);
    $dQFEZ.useLayoutEffect(function() {
        return history.listen(setState);
    }, [
        history,
        setState
    ]);
    $dQFEZ.useEffect(function() {
        return (0, $8c3ad80f8a436e0f$export$db5148ec97d6af7a)(future);
    }, [
        future
    ]);
    return /*#__PURE__*/ $dQFEZ.createElement((0, $8c3ad80f8a436e0f$export$55185c17a0fcbe46), {
        basename: basename,
        children: children,
        location: state.location,
        navigationType: state.action,
        navigator: history,
        future: future
    });
}
/**
 * A `<Router>` for use in web browsers. Stores the location in the hash
 * portion of the URL so it is not sent to the server.
 */ function $fc41d09ddc03e3ec$export$7221d69dcfc8e36b(_ref5) {
    var basename = _ref5.basename, children = _ref5.children, future = _ref5.future, _$window = _ref5.window;
    var historyRef = $dQFEZ.useRef();
    if (historyRef.current == null) historyRef.current = (0, $gl7zH.createHashHistory)({
        window: _$window,
        v5Compat: true
    });
    var history = historyRef.current;
    var _React_useState = (0, $2nwvT._)($dQFEZ.useState({
        action: history.action,
        location: history.location
    }), 2), state = _React_useState[0], setStateImpl = _React_useState[1];
    var v7_startTransition = (future || {}).v7_startTransition;
    var setState = $dQFEZ.useCallback(function(newState) {
        v7_startTransition && $fc41d09ddc03e3ec$var$startTransitionImpl ? $fc41d09ddc03e3ec$var$startTransitionImpl(function() {
            return setStateImpl(newState);
        }) : setStateImpl(newState);
    }, [
        setStateImpl,
        v7_startTransition
    ]);
    $dQFEZ.useLayoutEffect(function() {
        return history.listen(setState);
    }, [
        history,
        setState
    ]);
    $dQFEZ.useEffect(function() {
        return (0, $8c3ad80f8a436e0f$export$db5148ec97d6af7a)(future);
    }, [
        future
    ]);
    return /*#__PURE__*/ $dQFEZ.createElement((0, $8c3ad80f8a436e0f$export$55185c17a0fcbe46), {
        basename: basename,
        children: children,
        location: state.location,
        navigationType: state.action,
        navigator: history,
        future: future
    });
}
/**
 * A `<Router>` that accepts a pre-instantiated history object. It's important
 * to note that using your own history object is highly discouraged and may add
 * two versions of the history library to your bundles unless you use the same
 * version of the history library that React Router uses internally.
 */ function $fc41d09ddc03e3ec$export$eefb0c834599897e(_ref6) {
    var basename = _ref6.basename, children = _ref6.children, future = _ref6.future, history = _ref6.history;
    var _React_useState = (0, $2nwvT._)($dQFEZ.useState({
        action: history.action,
        location: history.location
    }), 2), state = _React_useState[0], setStateImpl = _React_useState[1];
    var v7_startTransition = (future || {}).v7_startTransition;
    var setState = $dQFEZ.useCallback(function(newState) {
        v7_startTransition && $fc41d09ddc03e3ec$var$startTransitionImpl ? $fc41d09ddc03e3ec$var$startTransitionImpl(function() {
            return setStateImpl(newState);
        }) : setStateImpl(newState);
    }, [
        setStateImpl,
        v7_startTransition
    ]);
    $dQFEZ.useLayoutEffect(function() {
        return history.listen(setState);
    }, [
        history,
        setState
    ]);
    $dQFEZ.useEffect(function() {
        return (0, $8c3ad80f8a436e0f$export$db5148ec97d6af7a)(future);
    }, [
        future
    ]);
    return /*#__PURE__*/ $dQFEZ.createElement((0, $8c3ad80f8a436e0f$export$55185c17a0fcbe46), {
        basename: basename,
        children: children,
        location: state.location,
        navigationType: state.action,
        navigator: history,
        future: future
    });
}
var $fc41d09ddc03e3ec$var$isBrowser = typeof window !== "undefined" && typeof window.document !== "undefined" && typeof window.document.createElement !== "undefined";
var $fc41d09ddc03e3ec$var$ABSOLUTE_URL_REGEX = /^(?:[a-z][a-z0-9+.-]*:|\/\/)/i;
/**
 * The public API for rendering a history-aware `<a>`.
 */ var $fc41d09ddc03e3ec$export$a6c7ac8248d6e38a = /*#__PURE__*/ $dQFEZ.forwardRef(function LinkWithRef(_ref7, ref) {
    var onClick = _ref7.onClick, relative = _ref7.relative, reloadDocument = _ref7.reloadDocument, replace = _ref7.replace, state = _ref7.state, target = _ref7.target, to = _ref7.to, preventScrollReset = _ref7.preventScrollReset, viewTransition = _ref7.viewTransition, rest = $fc41d09ddc03e3ec$var$_objectWithoutPropertiesLoose(_ref7, $fc41d09ddc03e3ec$var$_excluded);
    var basename = $dQFEZ.useContext((0, $8c3ad80f8a436e0f$export$26749e8557646306)).basename;
    // Rendered into <a href> for absolute URLs
    var absoluteHref;
    var isExternal = false;
    if (typeof to === "string" && $fc41d09ddc03e3ec$var$ABSOLUTE_URL_REGEX.test(to)) {
        // Render the absolute href server- and client-side
        absoluteHref = to;
        // Only check for external origins client-side
        if ($fc41d09ddc03e3ec$var$isBrowser) try {
            var currentUrl = new URL(window.location.href);
            var targetUrl = to.startsWith("//") ? new URL(currentUrl.protocol + to) : new URL(to);
            var path = (0, $gl7zH.stripBasename)(targetUrl.pathname, basename);
            if (targetUrl.origin === currentUrl.origin && path != null) // Strip the protocol/origin/basename for same-origin absolute URLs
            to = path + targetUrl.search + targetUrl.hash;
            else isExternal = true;
        } catch (e) {}
    }
    // Rendered into <a href> for relative URLs
    var href = (0, $8c3ad80f8a436e0f$export$b66bb29c5006f12f)(to, {
        relative: relative
    });
    var internalOnClick = $fc41d09ddc03e3ec$export$67621102c14d847(to, {
        replace: replace,
        state: state,
        target: target,
        preventScrollReset: preventScrollReset,
        relative: relative,
        viewTransition: viewTransition
    });
    function handleClick(event) {
        if (onClick) onClick(event);
        if (!event.defaultPrevented) internalOnClick(event);
    }
    return(/*#__PURE__*/ // eslint-disable-next-line jsx-a11y/anchor-has-content
    $dQFEZ.createElement("a", $fc41d09ddc03e3ec$var$_extends({}, rest, {
        href: absoluteHref || href,
        onClick: isExternal || reloadDocument ? onClick : handleClick,
        ref: ref,
        target: target
    })));
});
/**
 * A `<Link>` wrapper that knows if it's "active" or not.
 */ var $fc41d09ddc03e3ec$export$b0d92dbee9b5b60d = /*#__PURE__*/ $dQFEZ.forwardRef(function NavLinkWithRef(_ref8, ref) {
    var tmp = _ref8["aria-current"], ariaCurrentProp = tmp === void 0 ? "page" : tmp, _ref8_caseSensitive = _ref8.caseSensitive, caseSensitive = _ref8_caseSensitive === void 0 ? false : _ref8_caseSensitive, tmp1 = _ref8.className, classNameProp = tmp1 === void 0 ? "" : tmp1, _ref8_end = _ref8.end, end = _ref8_end === void 0 ? false : _ref8_end, styleProp = _ref8.style, to = _ref8.to, viewTransition = _ref8.viewTransition, children = _ref8.children, rest = $fc41d09ddc03e3ec$var$_objectWithoutPropertiesLoose(_ref8, $fc41d09ddc03e3ec$var$_excluded2);
    var path = (0, $8c3ad80f8a436e0f$export$e75d2a2d1b3c245b)(to, {
        relative: rest.relative
    });
    var location = (0, $8c3ad80f8a436e0f$export$45d76561a5302f2b)();
    var routerState = $dQFEZ.useContext((0, $8c3ad80f8a436e0f$export$145dfa71566a64dc));
    var _React_useContext = $dQFEZ.useContext((0, $8c3ad80f8a436e0f$export$26749e8557646306)), navigator = _React_useContext.navigator, basename = _React_useContext.basename;
    var isTransitioning = routerState != null && // Conditional usage is OK here because the usage of a data router is static
    // eslint-disable-next-line react-hooks/rules-of-hooks
    $fc41d09ddc03e3ec$export$e262bd1977bea848(path) && viewTransition === true;
    var toPathname = navigator.encodeLocation ? navigator.encodeLocation(path).pathname : path.pathname;
    var locationPathname = location.pathname;
    var nextLocationPathname = routerState && routerState.navigation && routerState.navigation.location ? routerState.navigation.location.pathname : null;
    if (!caseSensitive) {
        locationPathname = locationPathname.toLowerCase();
        nextLocationPathname = nextLocationPathname ? nextLocationPathname.toLowerCase() : null;
        toPathname = toPathname.toLowerCase();
    }
    if (nextLocationPathname && basename) nextLocationPathname = (0, $gl7zH.stripBasename)(nextLocationPathname, basename) || nextLocationPathname;
    // If the `to` has a trailing slash, look at that exact spot.  Otherwise,
    // we're looking for a slash _after_ what's in `to`.  For example:
    //
    // <NavLink to="/users"> and <NavLink to="/users/">
    // both want to look for a / at index 6 to match URL `/users/matt`
    var endSlashPosition = toPathname !== "/" && toPathname.endsWith("/") ? toPathname.length - 1 : toPathname.length;
    var isActive = locationPathname === toPathname || !end && locationPathname.startsWith(toPathname) && locationPathname.charAt(endSlashPosition) === "/";
    var isPending = nextLocationPathname != null && (nextLocationPathname === toPathname || !end && nextLocationPathname.startsWith(toPathname) && nextLocationPathname.charAt(toPathname.length) === "/");
    var renderProps = {
        isActive: isActive,
        isPending: isPending,
        isTransitioning: isTransitioning
    };
    var ariaCurrent = isActive ? ariaCurrentProp : undefined;
    var className;
    if (typeof classNameProp === "function") className = classNameProp(renderProps);
    else // If the className prop is not a function, we use a default `active`
    // class for <NavLink />s that are active. In v5 `active` was the default
    // value for `activeClassName`, but we are removing that API and can still
    // use the old default behavior for a cleaner upgrade path and keep the
    // simple styling rules working as they currently do.
    className = [
        classNameProp,
        isActive ? "active" : null,
        isPending ? "pending" : null,
        isTransitioning ? "transitioning" : null
    ].filter(Boolean).join(" ");
    var style = typeof styleProp === "function" ? styleProp(renderProps) : styleProp;
    return /*#__PURE__*/ $dQFEZ.createElement($fc41d09ddc03e3ec$export$a6c7ac8248d6e38a, $fc41d09ddc03e3ec$var$_extends({}, rest, {
        "aria-current": ariaCurrent,
        className: className,
        ref: ref,
        style: style,
        to: to,
        viewTransition: viewTransition
    }), typeof children === "function" ? children(renderProps) : children);
});
/**
 * A `@remix-run/router`-aware `<form>`. It behaves like a normal form except
 * that the interaction with the server is with `fetch` instead of new document
 * requests, allowing components to add nicer UX to the page as the form is
 * submitted and returns with data.
 */ var $fc41d09ddc03e3ec$export$a7fed597f4b8afd8 = /*#__PURE__*/ $dQFEZ.forwardRef(function(_ref9, forwardedRef) {
    var fetcherKey = _ref9.fetcherKey, navigate = _ref9.navigate, reloadDocument = _ref9.reloadDocument, replace = _ref9.replace, state = _ref9.state, _ref9_method = _ref9.method, method = _ref9_method === void 0 ? $fc41d09ddc03e3ec$var$defaultMethod : _ref9_method, action = _ref9.action, onSubmit = _ref9.onSubmit, relative = _ref9.relative, preventScrollReset = _ref9.preventScrollReset, viewTransition = _ref9.viewTransition, props = $fc41d09ddc03e3ec$var$_objectWithoutPropertiesLoose(_ref9, $fc41d09ddc03e3ec$var$_excluded3);
    var submit = $fc41d09ddc03e3ec$export$47c85c6e3a081d3();
    var formAction = $fc41d09ddc03e3ec$export$89a6bd6db0d97c56(action, {
        relative: relative
    });
    var formMethod = method.toLowerCase() === "get" ? "get" : "post";
    var submitHandler = function(event) {
        onSubmit && onSubmit(event);
        if (event.defaultPrevented) return;
        event.preventDefault();
        var submitter = event.nativeEvent.submitter;
        var submitMethod = (submitter == null ? void 0 : submitter.getAttribute("formmethod")) || method;
        submit(submitter || event.currentTarget, {
            fetcherKey: fetcherKey,
            method: submitMethod,
            navigate: navigate,
            replace: replace,
            state: state,
            relative: relative,
            preventScrollReset: preventScrollReset,
            viewTransition: viewTransition
        });
    };
    return /*#__PURE__*/ $dQFEZ.createElement("form", $fc41d09ddc03e3ec$var$_extends({
        ref: forwardedRef,
        method: formMethod,
        action: formAction,
        onSubmit: reloadDocument ? onSubmit : submitHandler
    }, props));
});
/**
 * This component will emulate the browser's scroll restoration on location
 * changes.
 */ function $fc41d09ddc03e3ec$export$11aac1aab828f1fa(_ref10) {
    var getKey = _ref10.getKey, storageKey = _ref10.storageKey;
    $fc41d09ddc03e3ec$export$25057cfe5591e3e9({
        getKey: getKey,
        storageKey: storageKey
    });
    return null;
}
//#endregion
////////////////////////////////////////////////////////////////////////////////
//#region Hooks
////////////////////////////////////////////////////////////////////////////////
var $fc41d09ddc03e3ec$var$DataRouterHook;
(function(DataRouterHook) {
    DataRouterHook["UseScrollRestoration"] = "useScrollRestoration";
    DataRouterHook["UseSubmit"] = "useSubmit";
    DataRouterHook["UseSubmitFetcher"] = "useSubmitFetcher";
    DataRouterHook["UseFetcher"] = "useFetcher";
    DataRouterHook["useViewTransitionState"] = "useViewTransitionState";
})($fc41d09ddc03e3ec$var$DataRouterHook || ($fc41d09ddc03e3ec$var$DataRouterHook = {}));
var $fc41d09ddc03e3ec$var$DataRouterStateHook;
(function(DataRouterStateHook) {
    DataRouterStateHook["UseFetcher"] = "useFetcher";
    DataRouterStateHook["UseFetchers"] = "useFetchers";
    DataRouterStateHook["UseScrollRestoration"] = "useScrollRestoration";
})($fc41d09ddc03e3ec$var$DataRouterStateHook || ($fc41d09ddc03e3ec$var$DataRouterStateHook = {}));
// Internal hooks
function $fc41d09ddc03e3ec$var$getDataRouterConsoleError(hookName) {
    return hookName + " must be used within a data router.  See https://reactrouter.com/v6/routers/picking-a-router.";
}
function $fc41d09ddc03e3ec$var$useDataRouterContext(hookName) {
    var ctx = $dQFEZ.useContext((0, $8c3ad80f8a436e0f$export$3add0d5dce533e2e));
    !ctx && (0, $gl7zH.UNSAFE_invariant)(false);
    return ctx;
}
function $fc41d09ddc03e3ec$var$useDataRouterState(hookName) {
    var state = $dQFEZ.useContext((0, $8c3ad80f8a436e0f$export$145dfa71566a64dc));
    !state && (0, $gl7zH.UNSAFE_invariant)(false);
    return state;
}
// External hooks
/**
 * Handles the click behavior for router `<Link>` components. This is useful if
 * you need to create custom `<Link>` components with the same click behavior we
 * use in our exported `<Link>`.
 */ function $fc41d09ddc03e3ec$export$67621102c14d847(to, _temp) {
    var _ref = _temp === void 0 ? {} : _temp, target = _ref.target, replaceProp = _ref.replace, state = _ref.state, preventScrollReset = _ref.preventScrollReset, relative = _ref.relative, viewTransition = _ref.viewTransition;
    var navigate = (0, $8c3ad80f8a436e0f$export$9770f232ac06a008)();
    var location = (0, $8c3ad80f8a436e0f$export$45d76561a5302f2b)();
    var path = (0, $8c3ad80f8a436e0f$export$e75d2a2d1b3c245b)(to, {
        relative: relative
    });
    return $dQFEZ.useCallback(function(event) {
        if ($fc41d09ddc03e3ec$var$shouldProcessLinkClick(event, target)) {
            event.preventDefault();
            // If the URL hasn't changed, a regular <a> will do a replace instead of
            // a push, so do the same here unless the replace prop is explicitly set
            var replace = replaceProp !== undefined ? replaceProp : (0, $gl7zH.createPath)(location) === (0, $gl7zH.createPath)(path);
            navigate(to, {
                replace: replace,
                state: state,
                preventScrollReset: preventScrollReset,
                relative: relative,
                viewTransition: viewTransition
            });
        }
    }, [
        location,
        navigate,
        path,
        replaceProp,
        state,
        target,
        to,
        preventScrollReset,
        relative,
        viewTransition
    ]);
}
/**
 * A convenient wrapper for reading and writing search parameters via the
 * URLSearchParams interface.
 */ function $fc41d09ddc03e3ec$export$f1a78c17382fe22a(defaultInit) {
    var defaultSearchParamsRef = $dQFEZ.useRef($fc41d09ddc03e3ec$export$a2e4e2dcc7b1f22f(defaultInit));
    var hasSetSearchParamsRef = $dQFEZ.useRef(false);
    var location = (0, $8c3ad80f8a436e0f$export$45d76561a5302f2b)();
    var searchParams = $dQFEZ.useMemo(function() {
        return(// Only merge in the defaults if we haven't yet called setSearchParams.
        // Once we call that we want those to take precedence, otherwise you can't
        // remove a param with setSearchParams({}) if it has an initial value
        $fc41d09ddc03e3ec$var$getSearchParamsForLocation(location.search, hasSetSearchParamsRef.current ? null : defaultSearchParamsRef.current));
    }, [
        location.search
    ]);
    var navigate = (0, $8c3ad80f8a436e0f$export$9770f232ac06a008)();
    var setSearchParams = $dQFEZ.useCallback(function(nextInit, navigateOptions) {
        var newSearchParams = $fc41d09ddc03e3ec$export$a2e4e2dcc7b1f22f(typeof nextInit === "function" ? nextInit(searchParams) : nextInit);
        hasSetSearchParamsRef.current = true;
        navigate("?" + newSearchParams, navigateOptions);
    }, [
        navigate,
        searchParams
    ]);
    return [
        searchParams,
        setSearchParams
    ];
}
function $fc41d09ddc03e3ec$var$validateClientSideSubmission() {
    if (typeof document === "undefined") throw new Error("You are calling submit during the server render. Try calling submit within a `useEffect` or callback instead.");
}
var $fc41d09ddc03e3ec$var$fetcherId = 0;
var $fc41d09ddc03e3ec$var$getUniqueFetcherId = function() {
    return "__" + String(++$fc41d09ddc03e3ec$var$fetcherId) + "__";
};
/**
 * Returns a function that may be used to programmatically submit a form (or
 * some arbitrary data) to the server.
 */ function $fc41d09ddc03e3ec$export$47c85c6e3a081d3() {
    var router = $fc41d09ddc03e3ec$var$useDataRouterContext($fc41d09ddc03e3ec$var$DataRouterHook.UseSubmit).router;
    var basename = $dQFEZ.useContext((0, $8c3ad80f8a436e0f$export$26749e8557646306)).basename;
    var currentRouteId = (0, $8c3ad80f8a436e0f$export$5fc8298006ad9e58)();
    return $dQFEZ.useCallback(function(target, options) {
        if (options === void 0) options = {};
        $fc41d09ddc03e3ec$var$validateClientSideSubmission();
        var _getFormSubmissionInfo = $fc41d09ddc03e3ec$var$getFormSubmissionInfo(target, basename), action = _getFormSubmissionInfo.action, method = _getFormSubmissionInfo.method, encType = _getFormSubmissionInfo.encType, formData = _getFormSubmissionInfo.formData, body = _getFormSubmissionInfo.body;
        if (options.navigate === false) {
            var key = options.fetcherKey || $fc41d09ddc03e3ec$var$getUniqueFetcherId();
            router.fetch(key, currentRouteId, options.action || action, {
                preventScrollReset: options.preventScrollReset,
                formData: formData,
                body: body,
                formMethod: options.method || method,
                formEncType: options.encType || encType,
                flushSync: options.flushSync
            });
        } else router.navigate(options.action || action, {
            preventScrollReset: options.preventScrollReset,
            formData: formData,
            body: body,
            formMethod: options.method || method,
            formEncType: options.encType || encType,
            replace: options.replace,
            state: options.state,
            fromRouteId: currentRouteId,
            flushSync: options.flushSync,
            viewTransition: options.viewTransition
        });
    }, [
        router,
        basename,
        currentRouteId
    ]);
}
// v7: Eventually we should deprecate this entirely in favor of using the
// router method directly?
function $fc41d09ddc03e3ec$export$89a6bd6db0d97c56(action, _temp2) {
    var relative = (_temp2 === void 0 ? {} : _temp2).relative;
    var basename = $dQFEZ.useContext((0, $8c3ad80f8a436e0f$export$26749e8557646306)).basename;
    var routeContext = $dQFEZ.useContext((0, $8c3ad80f8a436e0f$export$9072aa6dd1f93057));
    !routeContext && (0, $gl7zH.UNSAFE_invariant)(false);
    var _routeContext_matches_slice = (0, $2nwvT._)(routeContext.matches.slice(-1), 1), match = _routeContext_matches_slice[0];
    // Shallow clone path so we can modify it below, otherwise we modify the
    // object referenced by useMemo inside useResolvedPath
    var path = $fc41d09ddc03e3ec$var$_extends({}, (0, $8c3ad80f8a436e0f$export$e75d2a2d1b3c245b)(action ? action : ".", {
        relative: relative
    }));
    // If no action was specified, browsers will persist current search params
    // when determining the path, so match that behavior
    // https://github.com/remix-run/remix/issues/927
    var location = (0, $8c3ad80f8a436e0f$export$45d76561a5302f2b)();
    if (action == null) {
        // Safe to write to this directly here since if action was undefined, we
        // would have called useResolvedPath(".") which will never include a search
        path.search = location.search;
        // When grabbing search params from the URL, remove any included ?index param
        // since it might not apply to our contextual route.  We add it back based
        // on match.route.index below
        var params = new URLSearchParams(path.search);
        var indexValues = params.getAll("index");
        var hasNakedIndexParam = indexValues.some(function(v) {
            return v === "";
        });
        if (hasNakedIndexParam) {
            params.delete("index");
            indexValues.filter(function(v) {
                return v;
            }).forEach(function(v) {
                return params.append("index", v);
            });
            var qs = params.toString();
            path.search = qs ? "?" + qs : "";
        }
    }
    if ((!action || action === ".") && match.route.index) path.search = path.search ? path.search.replace(/^\?/, "?index&") : "?index";
    // If we're operating within a basename, prepend it to the pathname prior
    // to creating the form action.  If this is a root navigation, then just use
    // the raw basename which allows the basename to have full control over the
    // presence of a trailing slash on root actions
    if (basename !== "/") path.pathname = path.pathname === "/" ? basename : (0, $gl7zH.joinPaths)([
        basename,
        path.pathname
    ]);
    return (0, $gl7zH.createPath)(path);
}
// TODO: (v7) Change the useFetcher generic default from `any` to `unknown`
/**
 * Interacts with route loaders and actions without causing a navigation. Great
 * for any interaction that stays on the same page.
 */ function $fc41d09ddc03e3ec$export$5b0d2d9a9921565a(_temp3) {
    var _route$matches;
    var key = (_temp3 === void 0 ? {} : _temp3).key;
    var router = $fc41d09ddc03e3ec$var$useDataRouterContext($fc41d09ddc03e3ec$var$DataRouterHook.UseFetcher).router;
    var state = $fc41d09ddc03e3ec$var$useDataRouterState($fc41d09ddc03e3ec$var$DataRouterStateHook.UseFetcher);
    var fetcherData = $dQFEZ.useContext($fc41d09ddc03e3ec$export$148fd98d095596d4);
    var route = $dQFEZ.useContext((0, $8c3ad80f8a436e0f$export$9072aa6dd1f93057));
    var routeId = (_route$matches = route.matches[route.matches.length - 1]) == null ? void 0 : _route$matches.route.id;
    !fetcherData && (0, $gl7zH.UNSAFE_invariant)(false);
    !route && (0, $gl7zH.UNSAFE_invariant)(false);
    !(routeId != null) && (0, $gl7zH.UNSAFE_invariant)(false);
    // Fetcher key handling
    // OK to call conditionally to feature detect `useId`
    // eslint-disable-next-line react-hooks/rules-of-hooks
    var defaultKey = $fc41d09ddc03e3ec$var$useIdImpl ? $fc41d09ddc03e3ec$var$useIdImpl() : "";
    var _React_useState = (0, $2nwvT._)($dQFEZ.useState(key || defaultKey), 2), fetcherKey = _React_useState[0], setFetcherKey = _React_useState[1];
    if (key && key !== fetcherKey) setFetcherKey(key);
    else if (!fetcherKey) // We will only fall through here when `useId` is not available
    setFetcherKey($fc41d09ddc03e3ec$var$getUniqueFetcherId());
    // Registration/cleanup
    $dQFEZ.useEffect(function() {
        router.getFetcher(fetcherKey);
        return function() {
            // Tell the router we've unmounted - if v7_fetcherPersist is enabled this
            // will not delete immediately but instead queue up a delete after the
            // fetcher returns to an `idle` state
            router.deleteFetcher(fetcherKey);
        };
    }, [
        router,
        fetcherKey
    ]);
    // Fetcher additions
    var load = $dQFEZ.useCallback(function(href, opts) {
        !routeId && (0, $gl7zH.UNSAFE_invariant)(false);
        router.fetch(fetcherKey, routeId, href, opts);
    }, [
        fetcherKey,
        routeId,
        router
    ]);
    var submitImpl = $fc41d09ddc03e3ec$export$47c85c6e3a081d3();
    var submit = $dQFEZ.useCallback(function(target, opts) {
        submitImpl(target, $fc41d09ddc03e3ec$var$_extends({}, opts, {
            navigate: false,
            fetcherKey: fetcherKey
        }));
    }, [
        fetcherKey,
        submitImpl
    ]);
    var FetcherForm = $dQFEZ.useMemo(function() {
        var FetcherForm = /*#__PURE__*/ $dQFEZ.forwardRef(function(props, ref) {
            return /*#__PURE__*/ $dQFEZ.createElement($fc41d09ddc03e3ec$export$a7fed597f4b8afd8, $fc41d09ddc03e3ec$var$_extends({}, props, {
                navigate: false,
                fetcherKey: fetcherKey,
                ref: ref
            }));
        });
        return FetcherForm;
    }, [
        fetcherKey
    ]);
    // Exposed FetcherWithComponents
    var fetcher = state.fetchers.get(fetcherKey) || (0, $gl7zH.IDLE_FETCHER);
    var data = fetcherData.get(fetcherKey);
    var fetcherWithComponents = $dQFEZ.useMemo(function() {
        return $fc41d09ddc03e3ec$var$_extends({
            Form: FetcherForm,
            submit: submit,
            load: load
        }, fetcher, {
            data: data
        });
    }, [
        FetcherForm,
        submit,
        load,
        fetcher,
        data
    ]);
    return fetcherWithComponents;
}
/**
 * Provides all fetchers currently on the page. Useful for layouts and parent
 * routes that need to provide pending/optimistic UI regarding the fetch.
 */ function $fc41d09ddc03e3ec$export$fa996778a3a31087() {
    var state = $fc41d09ddc03e3ec$var$useDataRouterState($fc41d09ddc03e3ec$var$DataRouterStateHook.UseFetchers);
    return Array.from(state.fetchers.entries()).map(function(_ref11) {
        var _$_ref11 = (0, $2nwvT._)(_ref11, 2), key = _$_ref11[0], fetcher = _$_ref11[1];
        return $fc41d09ddc03e3ec$var$_extends({}, fetcher, {
            key: key
        });
    });
}
var $fc41d09ddc03e3ec$var$SCROLL_RESTORATION_STORAGE_KEY = "react-router-scroll-positions";
var $fc41d09ddc03e3ec$var$savedScrollPositions = {};
/**
 * When rendered inside a RouterProvider, will restore scroll positions on navigations
 */ function $fc41d09ddc03e3ec$export$25057cfe5591e3e9(_temp4) {
    var _ref = _temp4 === void 0 ? {} : _temp4, getKey = _ref.getKey, storageKey = _ref.storageKey;
    var router = $fc41d09ddc03e3ec$var$useDataRouterContext($fc41d09ddc03e3ec$var$DataRouterHook.UseScrollRestoration).router;
    var _useDataRouterState = $fc41d09ddc03e3ec$var$useDataRouterState($fc41d09ddc03e3ec$var$DataRouterStateHook.UseScrollRestoration), restoreScrollPosition = _useDataRouterState.restoreScrollPosition, preventScrollReset = _useDataRouterState.preventScrollReset;
    var basename = $dQFEZ.useContext((0, $8c3ad80f8a436e0f$export$26749e8557646306)).basename;
    var location = (0, $8c3ad80f8a436e0f$export$45d76561a5302f2b)();
    var matches = (0, $8c3ad80f8a436e0f$export$2378eb7f5ff86053)();
    var navigation = (0, $8c3ad80f8a436e0f$export$d0fd4b7106de2769)();
    // Trigger manual scroll restoration while we're active
    $dQFEZ.useEffect(function() {
        window.history.scrollRestoration = "manual";
        return function() {
            window.history.scrollRestoration = "auto";
        };
    }, []);
    // Save positions on pagehide
    $fc41d09ddc03e3ec$var$usePageHide($dQFEZ.useCallback(function() {
        if (navigation.state === "idle") {
            var key = (getKey ? getKey(location, matches) : null) || location.key;
            $fc41d09ddc03e3ec$var$savedScrollPositions[key] = window.scrollY;
        }
        try {
            sessionStorage.setItem(storageKey || $fc41d09ddc03e3ec$var$SCROLL_RESTORATION_STORAGE_KEY, JSON.stringify($fc41d09ddc03e3ec$var$savedScrollPositions));
        } catch (error) {}
        window.history.scrollRestoration = "auto";
    }, [
        storageKey,
        getKey,
        navigation.state,
        location,
        matches
    ]));
    // Read in any saved scroll locations
    if (typeof document !== "undefined") {
        // eslint-disable-next-line react-hooks/rules-of-hooks
        $dQFEZ.useLayoutEffect(function() {
            try {
                var sessionPositions = sessionStorage.getItem(storageKey || $fc41d09ddc03e3ec$var$SCROLL_RESTORATION_STORAGE_KEY);
                if (sessionPositions) $fc41d09ddc03e3ec$var$savedScrollPositions = JSON.parse(sessionPositions);
            } catch (e) {
            // no-op, use default empty object
            }
        }, [
            storageKey
        ]);
        // Enable scroll restoration in the router
        // eslint-disable-next-line react-hooks/rules-of-hooks
        $dQFEZ.useLayoutEffect(function() {
            var getKeyWithoutBasename = getKey && basename !== "/" ? function(location, matches) {
                return getKey($fc41d09ddc03e3ec$var$_extends({}, location, {
                    pathname: (0, $gl7zH.stripBasename)(location.pathname, basename) || location.pathname
                }), matches);
            } : getKey;
            var disableScrollRestoration = router == null ? void 0 : router.enableScrollRestoration($fc41d09ddc03e3ec$var$savedScrollPositions, function() {
                return window.scrollY;
            }, getKeyWithoutBasename);
            return function() {
                return disableScrollRestoration && disableScrollRestoration();
            };
        }, [
            router,
            basename,
            getKey
        ]);
        // Restore scrolling when state.restoreScrollPosition changes
        // eslint-disable-next-line react-hooks/rules-of-hooks
        $dQFEZ.useLayoutEffect(function() {
            // Explicit false means don't do anything (used for submissions)
            if (restoreScrollPosition === false) return;
            // been here before, scroll to it
            if (typeof restoreScrollPosition === "number") {
                window.scrollTo(0, restoreScrollPosition);
                return;
            }
            // try to scroll to the hash
            if (location.hash) {
                var el = document.getElementById(decodeURIComponent(location.hash.slice(1)));
                if (el) {
                    el.scrollIntoView();
                    return;
                }
            }
            // Don't reset if this navigation opted out
            if (preventScrollReset === true) return;
            // otherwise go to the top on new locations
            window.scrollTo(0, 0);
        }, [
            location,
            restoreScrollPosition,
            preventScrollReset
        ]);
    }
}
/**
 * Setup a callback to be fired on the window's `beforeunload` event. This is
 * useful for saving some data to `window.localStorage` just before the page
 * refreshes.
 *
 * Note: The `callback` argument should be a function created with
 * `React.useCallback()`.
 */ function $fc41d09ddc03e3ec$export$c0a586b329cae57d(callback, options) {
    var capture = (options || {}).capture;
    $dQFEZ.useEffect(function() {
        var opts = capture != null ? {
            capture: capture
        } : undefined;
        window.addEventListener("beforeunload", callback, opts);
        return function() {
            window.removeEventListener("beforeunload", callback, opts);
        };
    }, [
        callback,
        capture
    ]);
}
/**
 * Setup a callback to be fired on the window's `pagehide` event. This is
 * useful for saving some data to `window.localStorage` just before the page
 * refreshes.  This event is better supported than beforeunload across browsers.
 *
 * Note: The `callback` argument should be a function created with
 * `React.useCallback()`.
 */ function $fc41d09ddc03e3ec$var$usePageHide(callback, options) {
    var capture = (options || {}).capture;
    $dQFEZ.useEffect(function() {
        var opts = capture != null ? {
            capture: capture
        } : undefined;
        window.addEventListener("pagehide", callback, opts);
        return function() {
            window.removeEventListener("pagehide", callback, opts);
        };
    }, [
        callback,
        capture
    ]);
}
/**
 * Wrapper around useBlocker to show a window.confirm prompt to users instead
 * of building a custom UI with useBlocker.
 *
 * Warning: This has *a lot of rough edges* and behaves very differently (and
 * very incorrectly in some cases) across browsers if user click addition
 * back/forward navigations while the confirm is open.  Use at your own risk.
 */ function $fc41d09ddc03e3ec$export$39f4eb3dbd812741(_ref12) {
    var when = _ref12.when, message = _ref12.message;
    var blocker = (0, $8c3ad80f8a436e0f$export$b273b3273281a049)(when);
    $dQFEZ.useEffect(function() {
        if (blocker.state === "blocked") {
            var proceed = window.confirm(message);
            if (proceed) // This timeout is needed to avoid a weird "race" on POP navigations
            // between the `window.history` revert navigation and the result of
            // `window.confirm`
            setTimeout(blocker.proceed, 0);
            else blocker.reset();
        }
    }, [
        blocker,
        message
    ]);
    $dQFEZ.useEffect(function() {
        if (blocker.state === "blocked" && !when) blocker.reset();
    }, [
        blocker,
        when
    ]);
}
/**
 * Return a boolean indicating if there is an active view transition to the
 * given href.  You can use this value to render CSS classes or viewTransitionName
 * styles onto your elements
 *
 * @param href The destination href
 * @param [opts.relative] Relative routing type ("route" | "path")
 */ function $fc41d09ddc03e3ec$export$e262bd1977bea848(to, opts) {
    if (opts === void 0) opts = {};
    var vtContext = $dQFEZ.useContext($fc41d09ddc03e3ec$export$7ad602f0e94e62d1);
    !(vtContext != null) && (0, $gl7zH.UNSAFE_invariant)(false);
    var basename = $fc41d09ddc03e3ec$var$useDataRouterContext($fc41d09ddc03e3ec$var$DataRouterHook.useViewTransitionState).basename;
    var path = (0, $8c3ad80f8a436e0f$export$e75d2a2d1b3c245b)(to, {
        relative: opts.relative
    });
    if (!vtContext.isTransitioning) return false;
    var currentPath = (0, $gl7zH.stripBasename)(vtContext.currentLocation.pathname, basename) || vtContext.currentLocation.pathname;
    var nextPath = (0, $gl7zH.stripBasename)(vtContext.nextLocation.pathname, basename) || vtContext.nextLocation.pathname;
    // Transition is active if we're going to or coming from the indicated
    // destination.  This ensures that other PUSH navigations that reverse
    // an indicated transition apply.  I.e., on the list view you have:
    //
    //   <NavLink to="/details/1" viewTransition>
    //
    // If you click the breadcrumb back to the list view:
    //
    //   <NavLink to="/list" viewTransition>
    //
    // We should apply the transition because it's indicated as active going
    // from /list -> /details/1 and therefore should be active on the reverse
    // (even though this isn't strictly a POP reverse)
    return (0, $gl7zH.matchPath)(path.pathname, nextPath) != null || (0, $gl7zH.matchPath)(path.pathname, currentPath) != null;
}



var $2nwvT = parcelRequire("2nwvT");

var $iD4WH = parcelRequire("iD4WH");
// This file contain all hard code data which fetch the data from swiggy website
var $ea4655d05e0a655f$export$31adfacaf07ffe63 = "https://media-assets.swiggy.com/swiggy/image/upload/fl_lossy,f_auto,q_auto,w_660/";
var $ea4655d05e0a655f$export$8878ead86ed0da0b = "https://graphicdesigneye.com/images/rastaurant-logo-design-service.png";



var $dQFEZ = parcelRequire("dQFEZ");


var $2nwvT = parcelRequire("2nwvT");

var $dQFEZ = parcelRequire("dQFEZ");
var $1344a5fd517c0f04$var$useOnlineStatus = function() {
    // check if online
    var _useState = (0, $2nwvT._)((0, $dQFEZ.useState)(true), 2), onlineStatus = _useState[0], setOnlineStatus = _useState[1];
    (0, $dQFEZ.useEffect)(function() {
        window.addEventListener("offline", function() {
            setOnlineStatus(false);
        });
        window.addEventListener("online", function() {
            setOnlineStatus(true);
        });
    }, []);
    // boolean value
    return onlineStatus;
};
var $1344a5fd517c0f04$export$2e2bcd8739ae039 = $1344a5fd517c0f04$var$useOnlineStatus;


// UserContext => Keep the information of loggedIn User

var $dQFEZ = parcelRequire("dQFEZ");
var $bec8559dd543f601$var$UserContext = /*#__PURE__*/ (0, $dQFEZ.createContext)({
    loggedInUser: "Default User"
});
var $bec8559dd543f601$export$2e2bcd8739ae039 = $bec8559dd543f601$var$UserContext;



var $72osQ = parcelRequire("72osQ");

var $2nwvT = parcelRequire("2nwvT");

var $2us1u = parcelRequire("2us1u");

var $bJtXW = parcelRequire("bJtXW");

var $dQFEZ = parcelRequire("dQFEZ");
var $f6758991d88cb14f$exports = {};
'use strict';

$f6758991d88cb14f$exports = (parcelRequire("imka8"));


var $d7d37dc522b09008$var$__defProp = Object.defineProperty;
var $d7d37dc522b09008$var$__defProps = Object.defineProperties;
var $d7d37dc522b09008$var$__getOwnPropDescs = Object.getOwnPropertyDescriptors;
var $d7d37dc522b09008$var$__getOwnPropSymbols = Object.getOwnPropertySymbols;
var $d7d37dc522b09008$var$__hasOwnProp = Object.prototype.hasOwnProperty;
var $d7d37dc522b09008$var$__propIsEnum = Object.prototype.propertyIsEnumerable;
var $d7d37dc522b09008$var$__defNormalProp = function(obj, key, value) {
    return key in obj ? $d7d37dc522b09008$var$__defProp(obj, key, {
        enumerable: true,
        configurable: true,
        writable: true,
        value: value
    }) : obj[key] = value;
};
var $d7d37dc522b09008$var$__spreadValues = function(a, b) {
    for(var prop in b || (b = {}))if ($d7d37dc522b09008$var$__hasOwnProp.call(b, prop)) $d7d37dc522b09008$var$__defNormalProp(a, prop, b[prop]);
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    if ($d7d37dc522b09008$var$__getOwnPropSymbols) try {
        for(var _iterator = $d7d37dc522b09008$var$__getOwnPropSymbols(b)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var prop = _step.value;
            if ($d7d37dc522b09008$var$__propIsEnum.call(b, prop)) $d7d37dc522b09008$var$__defNormalProp(a, prop, b[prop]);
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    return a;
};
var $d7d37dc522b09008$var$__spreadProps = function(a, b) {
    return $d7d37dc522b09008$var$__defProps(a, $d7d37dc522b09008$var$__getOwnPropDescs(b));
};
var $d7d37dc522b09008$var$__objRest = function(source, exclude) {
    var target = {};
    for(var prop in source)if ($d7d37dc522b09008$var$__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0) target[prop] = source[prop];
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    if (source != null && $d7d37dc522b09008$var$__getOwnPropSymbols) try {
        for(var _iterator = $d7d37dc522b09008$var$__getOwnPropSymbols(source)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var prop = _step.value;
            if (exclude.indexOf(prop) < 0 && $d7d37dc522b09008$var$__propIsEnum.call(source, prop)) target[prop] = source[prop];
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    return target;
};
// src/utils/react-is.ts
var $d7d37dc522b09008$var$IS_REACT_19 = /* @__PURE__ */ $dQFEZ.version.startsWith("19");
var $d7d37dc522b09008$var$REACT_ELEMENT_TYPE = /* @__PURE__ */ Symbol.for($d7d37dc522b09008$var$IS_REACT_19 ? "react.transitional.element" : "react.element");
var $d7d37dc522b09008$var$REACT_PORTAL_TYPE = /* @__PURE__ */ Symbol.for("react.portal");
var $d7d37dc522b09008$var$REACT_FRAGMENT_TYPE = /* @__PURE__ */ Symbol.for("react.fragment");
var $d7d37dc522b09008$var$REACT_STRICT_MODE_TYPE = /* @__PURE__ */ Symbol.for("react.strict_mode");
var $d7d37dc522b09008$var$REACT_PROFILER_TYPE = /* @__PURE__ */ Symbol.for("react.profiler");
var $d7d37dc522b09008$var$REACT_CONSUMER_TYPE = /* @__PURE__ */ Symbol.for("react.consumer");
var $d7d37dc522b09008$var$REACT_CONTEXT_TYPE = /* @__PURE__ */ Symbol.for("react.context");
var $d7d37dc522b09008$var$REACT_FORWARD_REF_TYPE = /* @__PURE__ */ Symbol.for("react.forward_ref");
var $d7d37dc522b09008$var$REACT_SUSPENSE_TYPE = /* @__PURE__ */ Symbol.for("react.suspense");
var $d7d37dc522b09008$var$REACT_SUSPENSE_LIST_TYPE = /* @__PURE__ */ Symbol.for("react.suspense_list");
var $d7d37dc522b09008$var$REACT_MEMO_TYPE = /* @__PURE__ */ Symbol.for("react.memo");
var $d7d37dc522b09008$var$REACT_LAZY_TYPE = /* @__PURE__ */ Symbol.for("react.lazy");
var $d7d37dc522b09008$var$REACT_OFFSCREEN_TYPE = /* @__PURE__ */ Symbol.for("react.offscreen");
var $d7d37dc522b09008$var$REACT_CLIENT_REFERENCE = /* @__PURE__ */ Symbol.for("react.client.reference");
var $d7d37dc522b09008$var$ForwardRef = $d7d37dc522b09008$var$REACT_FORWARD_REF_TYPE;
var $d7d37dc522b09008$var$Memo = $d7d37dc522b09008$var$REACT_MEMO_TYPE;
function $d7d37dc522b09008$var$isValidElementType(type) {
    return typeof type === "string" || typeof type === "function" || type === $d7d37dc522b09008$var$REACT_FRAGMENT_TYPE || type === $d7d37dc522b09008$var$REACT_PROFILER_TYPE || type === $d7d37dc522b09008$var$REACT_STRICT_MODE_TYPE || type === $d7d37dc522b09008$var$REACT_SUSPENSE_TYPE || type === $d7d37dc522b09008$var$REACT_SUSPENSE_LIST_TYPE || type === $d7d37dc522b09008$var$REACT_OFFSCREEN_TYPE || (typeof type === "undefined" ? "undefined" : (0, $bJtXW._)(type)) === "object" && type !== null && (type.$$typeof === $d7d37dc522b09008$var$REACT_LAZY_TYPE || type.$$typeof === $d7d37dc522b09008$var$REACT_MEMO_TYPE || type.$$typeof === $d7d37dc522b09008$var$REACT_CONTEXT_TYPE || type.$$typeof === $d7d37dc522b09008$var$REACT_CONSUMER_TYPE || type.$$typeof === $d7d37dc522b09008$var$REACT_FORWARD_REF_TYPE || type.$$typeof === $d7d37dc522b09008$var$REACT_CLIENT_REFERENCE || type.getModuleId !== void 0) ? true : false;
}
function $d7d37dc522b09008$var$typeOf(object) {
    if ((typeof object === "undefined" ? "undefined" : (0, $bJtXW._)(object)) === "object" && object !== null) {
        var $$typeof = object.$$typeof;
        switch($$typeof){
            case $d7d37dc522b09008$var$REACT_ELEMENT_TYPE:
                switch(object = object.type, object){
                    case $d7d37dc522b09008$var$REACT_FRAGMENT_TYPE:
                    case $d7d37dc522b09008$var$REACT_PROFILER_TYPE:
                    case $d7d37dc522b09008$var$REACT_STRICT_MODE_TYPE:
                    case $d7d37dc522b09008$var$REACT_SUSPENSE_TYPE:
                    case $d7d37dc522b09008$var$REACT_SUSPENSE_LIST_TYPE:
                        return object;
                    default:
                        switch(object = object && object.$$typeof, object){
                            case $d7d37dc522b09008$var$REACT_CONTEXT_TYPE:
                            case $d7d37dc522b09008$var$REACT_FORWARD_REF_TYPE:
                            case $d7d37dc522b09008$var$REACT_LAZY_TYPE:
                            case $d7d37dc522b09008$var$REACT_MEMO_TYPE:
                                return object;
                            case $d7d37dc522b09008$var$REACT_CONSUMER_TYPE:
                                return object;
                            default:
                                return $$typeof;
                        }
                }
            case $d7d37dc522b09008$var$REACT_PORTAL_TYPE:
                return $$typeof;
        }
    }
}
function $d7d37dc522b09008$var$isContextConsumer(object) {
    return $d7d37dc522b09008$var$IS_REACT_19 ? $d7d37dc522b09008$var$typeOf(object) === $d7d37dc522b09008$var$REACT_CONSUMER_TYPE : $d7d37dc522b09008$var$typeOf(object) === $d7d37dc522b09008$var$REACT_CONTEXT_TYPE;
}
function $d7d37dc522b09008$var$isMemo(object) {
    return $d7d37dc522b09008$var$typeOf(object) === $d7d37dc522b09008$var$REACT_MEMO_TYPE;
}
// src/utils/warning.ts
function $d7d37dc522b09008$var$warning(message) {
    if (typeof console !== "undefined" && typeof console.error === "function") console.error(message);
    try {
        throw new Error(message);
    } catch (e) {}
}
// src/connect/verifySubselectors.ts
function $d7d37dc522b09008$var$verify(selector, methodName) {
    if (!selector) throw new Error("Unexpected value for ".concat(methodName, " in connect."));
    else if (methodName === "mapStateToProps" || methodName === "mapDispatchToProps") {
        if (!Object.prototype.hasOwnProperty.call(selector, "dependsOnOwnProps")) $d7d37dc522b09008$var$warning("The selector for ".concat(methodName, " of connect did not specify a value for dependsOnOwnProps."));
    }
}
function $d7d37dc522b09008$var$verifySubselectors(mapStateToProps, mapDispatchToProps, mergeProps) {
    $d7d37dc522b09008$var$verify(mapStateToProps, "mapStateToProps");
    $d7d37dc522b09008$var$verify(mapDispatchToProps, "mapDispatchToProps");
    $d7d37dc522b09008$var$verify(mergeProps, "mergeProps");
}
// src/connect/selectorFactory.ts
function $d7d37dc522b09008$var$pureFinalPropsSelectorFactory(mapStateToProps, mapDispatchToProps, mergeProps, dispatch, param) {
    var areStatesEqual = param.areStatesEqual, areOwnPropsEqual = param.areOwnPropsEqual, areStatePropsEqual = param.areStatePropsEqual;
    var hasRunAtLeastOnce = false;
    var state;
    var ownProps;
    var stateProps;
    var dispatchProps;
    var mergedProps;
    function handleFirstCall(firstState, firstOwnProps) {
        state = firstState;
        ownProps = firstOwnProps;
        stateProps = mapStateToProps(state, ownProps);
        dispatchProps = mapDispatchToProps(dispatch, ownProps);
        mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
        hasRunAtLeastOnce = true;
        return mergedProps;
    }
    function handleNewPropsAndNewState() {
        stateProps = mapStateToProps(state, ownProps);
        if (mapDispatchToProps.dependsOnOwnProps) dispatchProps = mapDispatchToProps(dispatch, ownProps);
        mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
        return mergedProps;
    }
    function handleNewProps() {
        if (mapStateToProps.dependsOnOwnProps) stateProps = mapStateToProps(state, ownProps);
        if (mapDispatchToProps.dependsOnOwnProps) dispatchProps = mapDispatchToProps(dispatch, ownProps);
        mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
        return mergedProps;
    }
    function handleNewState() {
        var nextStateProps = mapStateToProps(state, ownProps);
        var statePropsChanged = !areStatePropsEqual(nextStateProps, stateProps);
        stateProps = nextStateProps;
        if (statePropsChanged) mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
        return mergedProps;
    }
    function handleSubsequentCalls(nextState, nextOwnProps) {
        var propsChanged = !areOwnPropsEqual(nextOwnProps, ownProps);
        var stateChanged = !areStatesEqual(nextState, state, nextOwnProps, ownProps);
        state = nextState;
        ownProps = nextOwnProps;
        if (propsChanged && stateChanged) return handleNewPropsAndNewState();
        if (propsChanged) return handleNewProps();
        if (stateChanged) return handleNewState();
        return mergedProps;
    }
    return function pureFinalPropsSelector(nextState, nextOwnProps) {
        return hasRunAtLeastOnce ? handleSubsequentCalls(nextState, nextOwnProps) : handleFirstCall(nextState, nextOwnProps);
    };
}
function $d7d37dc522b09008$var$finalPropsSelectorFactory(dispatch, _a) {
    var _b = _a, initMapStateToProps = _b.initMapStateToProps, initMapDispatchToProps = _b.initMapDispatchToProps, initMergeProps = _b.initMergeProps, options = $d7d37dc522b09008$var$__objRest(_b, [
        "initMapStateToProps",
        "initMapDispatchToProps",
        "initMergeProps"
    ]);
    var mapStateToProps = initMapStateToProps(dispatch, options);
    var mapDispatchToProps = initMapDispatchToProps(dispatch, options);
    var mergeProps = initMergeProps(dispatch, options);
    return $d7d37dc522b09008$var$pureFinalPropsSelectorFactory(mapStateToProps, mapDispatchToProps, mergeProps, dispatch, options);
}
// src/utils/bindActionCreators.ts
function $d7d37dc522b09008$var$bindActionCreators(actionCreators, dispatch) {
    var _loop = function(key) {
        var actionCreator = actionCreators[key];
        if (typeof actionCreator === "function") boundActionCreators[key] = function() {
            for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
                args[_key] = arguments[_key];
            }
            return dispatch(actionCreator.apply(void 0, (0, $2us1u._)(args)));
        };
    };
    var boundActionCreators = {};
    for(var key in actionCreators)_loop(key);
    return boundActionCreators;
}
// src/utils/isPlainObject.ts
function $d7d37dc522b09008$var$isPlainObject(obj) {
    if ((typeof obj === "undefined" ? "undefined" : (0, $bJtXW._)(obj)) !== "object" || obj === null) return false;
    var proto = Object.getPrototypeOf(obj);
    if (proto === null) return true;
    var baseProto = proto;
    while(Object.getPrototypeOf(baseProto) !== null)baseProto = Object.getPrototypeOf(baseProto);
    return proto === baseProto;
}
// src/utils/verifyPlainObject.ts
function $d7d37dc522b09008$var$verifyPlainObject(value, displayName, methodName) {
    if (!$d7d37dc522b09008$var$isPlainObject(value)) $d7d37dc522b09008$var$warning("".concat(methodName, "() in ").concat(displayName, " must return a plain object. Instead received ").concat(value, "."));
}
// src/connect/wrapMapToProps.ts
function $d7d37dc522b09008$var$wrapMapToPropsConstant(getConstant) {
    return function initConstantSelector(dispatch) {
        var constant = getConstant(dispatch);
        function constantSelector() {
            return constant;
        }
        constantSelector.dependsOnOwnProps = false;
        return constantSelector;
    };
}
function $d7d37dc522b09008$var$getDependsOnOwnProps(mapToProps) {
    return mapToProps.dependsOnOwnProps ? Boolean(mapToProps.dependsOnOwnProps) : mapToProps.length !== 1;
}
function $d7d37dc522b09008$var$wrapMapToPropsFunc(mapToProps, methodName) {
    return function initProxySelector(dispatch, param) {
        var displayName = param.displayName;
        var proxy = function mapToPropsProxy(stateOrDispatch, ownProps) {
            return proxy.dependsOnOwnProps ? proxy.mapToProps(stateOrDispatch, ownProps) : proxy.mapToProps(stateOrDispatch, void 0);
        };
        proxy.dependsOnOwnProps = true;
        proxy.mapToProps = function detectFactoryAndVerify(stateOrDispatch, ownProps) {
            proxy.mapToProps = mapToProps;
            proxy.dependsOnOwnProps = $d7d37dc522b09008$var$getDependsOnOwnProps(mapToProps);
            var props = proxy(stateOrDispatch, ownProps);
            if (typeof props === "function") {
                proxy.mapToProps = props;
                proxy.dependsOnOwnProps = $d7d37dc522b09008$var$getDependsOnOwnProps(props);
                props = proxy(stateOrDispatch, ownProps);
            }
            return props;
        };
        return proxy;
    };
}
// src/connect/invalidArgFactory.ts
function $d7d37dc522b09008$var$createInvalidArgFactory(arg, name) {
    return function(dispatch, options) {
        throw new Error("Invalid value of type ".concat(typeof arg === "undefined" ? "undefined" : (0, $bJtXW._)(arg), " for ").concat(name, " argument when connecting component ").concat(options.wrappedComponentName, "."));
    };
}
// src/connect/mapDispatchToProps.ts
function $d7d37dc522b09008$var$mapDispatchToPropsFactory(mapDispatchToProps) {
    return mapDispatchToProps && (typeof mapDispatchToProps === "undefined" ? "undefined" : (0, $bJtXW._)(mapDispatchToProps)) === "object" ? $d7d37dc522b09008$var$wrapMapToPropsConstant(function(dispatch) {
        return(// @ts-ignore
        $d7d37dc522b09008$var$bindActionCreators(mapDispatchToProps, dispatch));
    }) : !mapDispatchToProps ? $d7d37dc522b09008$var$wrapMapToPropsConstant(function(dispatch) {
        return {
            dispatch: dispatch
        };
    }) : typeof mapDispatchToProps === "function" ? // @ts-ignore
    $d7d37dc522b09008$var$wrapMapToPropsFunc(mapDispatchToProps, "mapDispatchToProps") : $d7d37dc522b09008$var$createInvalidArgFactory(mapDispatchToProps, "mapDispatchToProps");
}
// src/connect/mapStateToProps.ts
function $d7d37dc522b09008$var$mapStateToPropsFactory(mapStateToProps) {
    return !mapStateToProps ? $d7d37dc522b09008$var$wrapMapToPropsConstant(function() {
        return {};
    }) : typeof mapStateToProps === "function" ? // @ts-ignore
    $d7d37dc522b09008$var$wrapMapToPropsFunc(mapStateToProps, "mapStateToProps") : $d7d37dc522b09008$var$createInvalidArgFactory(mapStateToProps, "mapStateToProps");
}
// src/connect/mergeProps.ts
function $d7d37dc522b09008$var$defaultMergeProps(stateProps, dispatchProps, ownProps) {
    return $d7d37dc522b09008$var$__spreadValues($d7d37dc522b09008$var$__spreadValues($d7d37dc522b09008$var$__spreadValues({}, ownProps), stateProps), dispatchProps);
}
function $d7d37dc522b09008$var$wrapMergePropsFunc(mergeProps) {
    return function initMergePropsProxy(dispatch, param) {
        var displayName = param.displayName, areMergedPropsEqual = param.areMergedPropsEqual;
        var hasRunOnce = false;
        var mergedProps;
        return function mergePropsProxy(stateProps, dispatchProps, ownProps) {
            var nextMergedProps = mergeProps(stateProps, dispatchProps, ownProps);
            if (hasRunOnce) {
                if (!areMergedPropsEqual(nextMergedProps, mergedProps)) mergedProps = nextMergedProps;
            } else {
                hasRunOnce = true;
                mergedProps = nextMergedProps;
            }
            return mergedProps;
        };
    };
}
function $d7d37dc522b09008$var$mergePropsFactory(mergeProps) {
    return !mergeProps ? function() {
        return $d7d37dc522b09008$var$defaultMergeProps;
    } : typeof mergeProps === "function" ? $d7d37dc522b09008$var$wrapMergePropsFunc(mergeProps) : $d7d37dc522b09008$var$createInvalidArgFactory(mergeProps, "mergeProps");
}
// src/utils/batch.ts
function $d7d37dc522b09008$var$defaultNoopBatch(callback) {
    callback();
}
// src/utils/Subscription.ts
function $d7d37dc522b09008$var$createListenerCollection() {
    var first = null;
    var last = null;
    return {
        clear: function() {
            first = null;
            last = null;
        },
        notify: function() {
            $d7d37dc522b09008$var$defaultNoopBatch(function() {
                var listener = first;
                while(listener){
                    listener.callback();
                    listener = listener.next;
                }
            });
        },
        get: function() {
            var listeners = [];
            var listener = first;
            while(listener){
                listeners.push(listener);
                listener = listener.next;
            }
            return listeners;
        },
        subscribe: function(callback) {
            var isSubscribed = true;
            var listener = last = {
                callback: callback,
                next: null,
                prev: last
            };
            if (listener.prev) listener.prev.next = listener;
            else first = listener;
            return function unsubscribe() {
                if (!isSubscribed || first === null) return;
                isSubscribed = false;
                if (listener.next) listener.next.prev = listener.prev;
                else last = listener.prev;
                if (listener.prev) listener.prev.next = listener.next;
                else first = listener.next;
            };
        }
    };
}
var $d7d37dc522b09008$var$nullListeners = {
    notify: function() {},
    get: function() {
        return [];
    }
};
function $d7d37dc522b09008$var$createSubscription(store, parentSub) {
    var unsubscribe;
    var listeners = $d7d37dc522b09008$var$nullListeners;
    var subscriptionsAmount = 0;
    var selfSubscribed = false;
    function addNestedSub(listener) {
        trySubscribe();
        var cleanupListener = listeners.subscribe(listener);
        var removed = false;
        return function() {
            if (!removed) {
                removed = true;
                cleanupListener();
                tryUnsubscribe();
            }
        };
    }
    function notifyNestedSubs() {
        listeners.notify();
    }
    function handleChangeWrapper() {
        if (subscription.onStateChange) subscription.onStateChange();
    }
    function isSubscribed() {
        return selfSubscribed;
    }
    function trySubscribe() {
        subscriptionsAmount++;
        if (!unsubscribe) {
            unsubscribe = parentSub ? parentSub.addNestedSub(handleChangeWrapper) : store.subscribe(handleChangeWrapper);
            listeners = $d7d37dc522b09008$var$createListenerCollection();
        }
    }
    function tryUnsubscribe() {
        subscriptionsAmount--;
        if (unsubscribe && subscriptionsAmount === 0) {
            unsubscribe();
            unsubscribe = void 0;
            listeners.clear();
            listeners = $d7d37dc522b09008$var$nullListeners;
        }
    }
    function trySubscribeSelf() {
        if (!selfSubscribed) {
            selfSubscribed = true;
            trySubscribe();
        }
    }
    function tryUnsubscribeSelf() {
        if (selfSubscribed) {
            selfSubscribed = false;
            tryUnsubscribe();
        }
    }
    var subscription = {
        addNestedSub: addNestedSub,
        notifyNestedSubs: notifyNestedSubs,
        handleChangeWrapper: handleChangeWrapper,
        isSubscribed: isSubscribed,
        trySubscribe: trySubscribeSelf,
        tryUnsubscribe: tryUnsubscribeSelf,
        getListeners: function() {
            return listeners;
        }
    };
    return subscription;
}
// src/utils/useIsomorphicLayoutEffect.ts
var $d7d37dc522b09008$var$canUseDOM = function() {
    return !!(typeof window !== "undefined" && typeof window.document !== "undefined" && typeof window.document.createElement !== "undefined");
};
var $d7d37dc522b09008$var$isDOM = /* @__PURE__ */ $d7d37dc522b09008$var$canUseDOM();
var $d7d37dc522b09008$var$isRunningInReactNative = function() {
    return typeof navigator !== "undefined" && navigator.product === "ReactNative";
};
var $d7d37dc522b09008$var$isReactNative = /* @__PURE__ */ $d7d37dc522b09008$var$isRunningInReactNative();
var $d7d37dc522b09008$var$getUseIsomorphicLayoutEffect = function() {
    return $d7d37dc522b09008$var$isDOM || $d7d37dc522b09008$var$isReactNative ? $dQFEZ.useLayoutEffect : $dQFEZ.useEffect;
};
var $d7d37dc522b09008$var$useIsomorphicLayoutEffect = /* @__PURE__ */ $d7d37dc522b09008$var$getUseIsomorphicLayoutEffect();
// src/utils/shallowEqual.ts
function $d7d37dc522b09008$var$is(x, y) {
    if (x === y) return x !== 0 || y !== 0 || 1 / x === 1 / y;
    else return x !== x && y !== y;
}
function $d7d37dc522b09008$export$d36bdfa510afb180(objA, objB) {
    if ($d7d37dc522b09008$var$is(objA, objB)) return true;
    if ((typeof objA === "undefined" ? "undefined" : (0, $bJtXW._)(objA)) !== "object" || objA === null || (typeof objB === "undefined" ? "undefined" : (0, $bJtXW._)(objB)) !== "object" || objB === null) return false;
    var keysA = Object.keys(objA);
    var keysB = Object.keys(objB);
    if (keysA.length !== keysB.length) return false;
    for(var i = 0; i < keysA.length; i++){
        if (!Object.prototype.hasOwnProperty.call(objB, keysA[i]) || !$d7d37dc522b09008$var$is(objA[keysA[i]], objB[keysA[i]])) return false;
    }
    return true;
}
// src/utils/hoistStatics.ts
var $d7d37dc522b09008$var$REACT_STATICS = {
    childContextTypes: true,
    contextType: true,
    contextTypes: true,
    defaultProps: true,
    displayName: true,
    getDefaultProps: true,
    getDerivedStateFromError: true,
    getDerivedStateFromProps: true,
    mixins: true,
    propTypes: true,
    type: true
};
var $d7d37dc522b09008$var$KNOWN_STATICS = {
    name: true,
    length: true,
    prototype: true,
    caller: true,
    callee: true,
    arguments: true,
    arity: true
};
var $d7d37dc522b09008$var$FORWARD_REF_STATICS = {
    $$typeof: true,
    render: true,
    defaultProps: true,
    displayName: true,
    propTypes: true
};
var $d7d37dc522b09008$var$MEMO_STATICS = {
    $$typeof: true,
    compare: true,
    defaultProps: true,
    displayName: true,
    propTypes: true,
    type: true
};
var $d7d37dc522b09008$var$_obj;
var $d7d37dc522b09008$var$TYPE_STATICS = ($d7d37dc522b09008$var$_obj = {}, (0, $72osQ._)($d7d37dc522b09008$var$_obj, $d7d37dc522b09008$var$ForwardRef, $d7d37dc522b09008$var$FORWARD_REF_STATICS), (0, $72osQ._)($d7d37dc522b09008$var$_obj, $d7d37dc522b09008$var$Memo, $d7d37dc522b09008$var$MEMO_STATICS), $d7d37dc522b09008$var$_obj);
function $d7d37dc522b09008$var$getStatics(component) {
    if ($d7d37dc522b09008$var$isMemo(component)) return $d7d37dc522b09008$var$MEMO_STATICS;
    return $d7d37dc522b09008$var$TYPE_STATICS[component["$$typeof"]] || $d7d37dc522b09008$var$REACT_STATICS;
}
var $d7d37dc522b09008$var$defineProperty = Object.defineProperty;
var $d7d37dc522b09008$var$getOwnPropertyNames = Object.getOwnPropertyNames;
var $d7d37dc522b09008$var$getOwnPropertySymbols = Object.getOwnPropertySymbols;
var $d7d37dc522b09008$var$getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
var $d7d37dc522b09008$var$getPrototypeOf = Object.getPrototypeOf;
var $d7d37dc522b09008$var$objectPrototype = Object.prototype;
function $d7d37dc522b09008$var$hoistNonReactStatics(targetComponent, sourceComponent) {
    if (typeof sourceComponent !== "string") {
        if ($d7d37dc522b09008$var$objectPrototype) {
            var inheritedComponent = $d7d37dc522b09008$var$getPrototypeOf(sourceComponent);
            if (inheritedComponent && inheritedComponent !== $d7d37dc522b09008$var$objectPrototype) $d7d37dc522b09008$var$hoistNonReactStatics(targetComponent, inheritedComponent);
        }
        var keys = $d7d37dc522b09008$var$getOwnPropertyNames(sourceComponent);
        if ($d7d37dc522b09008$var$getOwnPropertySymbols) keys = keys.concat($d7d37dc522b09008$var$getOwnPropertySymbols(sourceComponent));
        var targetStatics = $d7d37dc522b09008$var$getStatics(targetComponent);
        var sourceStatics = $d7d37dc522b09008$var$getStatics(sourceComponent);
        for(var i = 0; i < keys.length; ++i){
            var key = keys[i];
            if (!$d7d37dc522b09008$var$KNOWN_STATICS[key] && !(sourceStatics && sourceStatics[key]) && !(targetStatics && targetStatics[key])) {
                var descriptor = $d7d37dc522b09008$var$getOwnPropertyDescriptor(sourceComponent, key);
                try {
                    $d7d37dc522b09008$var$defineProperty(targetComponent, key, descriptor);
                } catch (e) {}
            }
        }
    }
    return targetComponent;
}
// src/components/Context.ts
var $d7d37dc522b09008$var$ContextKey = /* @__PURE__ */ Symbol.for("react-redux-context");
var $d7d37dc522b09008$var$gT = typeof globalThis !== "undefined" ? globalThis : /* fall back to a per-module scope (pre-8.1 behaviour) if `globalThis` is not available */ {};
function $d7d37dc522b09008$var$getContext() {
    var _a;
    if (!$dQFEZ.createContext) return {};
    var contextMap = (_a = $d7d37dc522b09008$var$gT[$d7d37dc522b09008$var$ContextKey]) != null ? _a : $d7d37dc522b09008$var$gT[$d7d37dc522b09008$var$ContextKey] = /* @__PURE__ */ new Map();
    var realContext = contextMap.get($dQFEZ.createContext);
    if (!realContext) {
        realContext = $dQFEZ.createContext(null);
        contextMap.set($dQFEZ.createContext, realContext);
    }
    return realContext;
}
var $d7d37dc522b09008$export$cc80c08dc91f1c00 = /* @__PURE__ */ $d7d37dc522b09008$var$getContext();
// src/components/connect.tsx
var $d7d37dc522b09008$var$NO_SUBSCRIPTION_ARRAY = [
    null,
    null
];
var $d7d37dc522b09008$var$stringifyComponent = function(Comp) {
    try {
        return JSON.stringify(Comp);
    } catch (err) {
        return String(Comp);
    }
};
function $d7d37dc522b09008$var$useIsomorphicLayoutEffectWithArgs(effectFunc, effectArgs, dependencies) {
    $d7d37dc522b09008$var$useIsomorphicLayoutEffect(function() {
        return effectFunc.apply(void 0, (0, $2us1u._)(effectArgs));
    }, dependencies);
}
function $d7d37dc522b09008$var$captureWrapperProps(lastWrapperProps, lastChildProps, renderIsScheduled, wrapperProps, childPropsFromStoreUpdate, notifyNestedSubs) {
    lastWrapperProps.current = wrapperProps;
    renderIsScheduled.current = false;
    if (childPropsFromStoreUpdate.current) {
        childPropsFromStoreUpdate.current = null;
        notifyNestedSubs();
    }
}
function $d7d37dc522b09008$var$subscribeUpdates(shouldHandleStateChanges, store, subscription, childPropsSelector, lastWrapperProps, lastChildProps, renderIsScheduled, isMounted, childPropsFromStoreUpdate, notifyNestedSubs, additionalSubscribeListener) {
    if (!shouldHandleStateChanges) return function() {};
    var didUnsubscribe = false;
    var lastThrownError = null;
    var checkForUpdates = function() {
        if (didUnsubscribe || !isMounted.current) return;
        var latestStoreState = store.getState();
        var newChildProps, error;
        try {
            newChildProps = childPropsSelector(latestStoreState, lastWrapperProps.current);
        } catch (e) {
            error = e;
            lastThrownError = e;
        }
        if (!error) lastThrownError = null;
        if (newChildProps === lastChildProps.current) {
            if (!renderIsScheduled.current) notifyNestedSubs();
        } else {
            lastChildProps.current = newChildProps;
            childPropsFromStoreUpdate.current = newChildProps;
            renderIsScheduled.current = true;
            additionalSubscribeListener();
        }
    };
    subscription.onStateChange = checkForUpdates;
    subscription.trySubscribe();
    checkForUpdates();
    var unsubscribeWrapper = function() {
        didUnsubscribe = true;
        subscription.tryUnsubscribe();
        subscription.onStateChange = null;
        if (lastThrownError) throw lastThrownError;
    };
    return unsubscribeWrapper;
}
function $d7d37dc522b09008$var$strictEqual(a, b) {
    return a === b;
}
var $d7d37dc522b09008$var$hasWarnedAboutDeprecatedPureOption = false;
function $d7d37dc522b09008$var$connect(mapStateToProps, mapDispatchToProps, mergeProps) {
    var _ref = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : {}, // The `pure` option has been removed, so TS doesn't like us destructuring this to check its existence.
    // @ts-ignore
    pure = _ref.pure, _ref_areStatesEqual = _ref.areStatesEqual, areStatesEqual = _ref_areStatesEqual === void 0 ? $d7d37dc522b09008$var$strictEqual : _ref_areStatesEqual, _ref_areOwnPropsEqual = _ref.areOwnPropsEqual, areOwnPropsEqual = _ref_areOwnPropsEqual === void 0 ? $d7d37dc522b09008$export$d36bdfa510afb180 : _ref_areOwnPropsEqual, _ref_areStatePropsEqual = _ref.areStatePropsEqual, areStatePropsEqual = _ref_areStatePropsEqual === void 0 ? $d7d37dc522b09008$export$d36bdfa510afb180 : _ref_areStatePropsEqual, _ref_areMergedPropsEqual = _ref.areMergedPropsEqual, areMergedPropsEqual = _ref_areMergedPropsEqual === void 0 ? $d7d37dc522b09008$export$d36bdfa510afb180 : _ref_areMergedPropsEqual, _ref_forwardRef = _ref.// use React's forwardRef to expose a ref of the wrapped component
    forwardRef, forwardRef = _ref_forwardRef === void 0 ? false : _ref_forwardRef, _ref_context = _ref.// the context consumer to use
    context, context = _ref_context === void 0 ? $d7d37dc522b09008$export$cc80c08dc91f1c00 : _ref_context;
    var Context = context;
    var initMapStateToProps = $d7d37dc522b09008$var$mapStateToPropsFactory(mapStateToProps);
    var initMapDispatchToProps = $d7d37dc522b09008$var$mapDispatchToPropsFactory(mapDispatchToProps);
    var initMergeProps = $d7d37dc522b09008$var$mergePropsFactory(mergeProps);
    var shouldHandleStateChanges = Boolean(mapStateToProps);
    var wrapWithConnect = function(WrappedComponent) {
        var ConnectFunction = function ConnectFunction(props) {
            var _React_useMemo = (0, $2nwvT._)($dQFEZ.useMemo(function() {
                var _a = props, reactReduxForwardedRef2 = _a.reactReduxForwardedRef, wrapperProps2 = $d7d37dc522b09008$var$__objRest(_a, [
                    "reactReduxForwardedRef"
                ]);
                return [
                    props.context,
                    reactReduxForwardedRef2,
                    wrapperProps2
                ];
            }, [
                props
            ]), 3), propsContext = _React_useMemo[0], reactReduxForwardedRef = _React_useMemo[1], wrapperProps = _React_useMemo[2];
            var ContextToUse = $dQFEZ.useMemo(function() {
                var ResultContext = Context;
                propsContext == null || propsContext.Consumer;
                return ResultContext;
            }, [
                propsContext,
                Context
            ]);
            var contextValue = $dQFEZ.useContext(ContextToUse);
            var didStoreComeFromProps = Boolean(props.store) && Boolean(props.store.getState) && Boolean(props.store.dispatch);
            var didStoreComeFromContext = Boolean(contextValue) && Boolean(contextValue.store);
            var store = didStoreComeFromProps ? props.store : contextValue.store;
            var getServerState = didStoreComeFromContext ? contextValue.getServerState : store.getState;
            var childPropsSelector = $dQFEZ.useMemo(function() {
                return $d7d37dc522b09008$var$finalPropsSelectorFactory(store.dispatch, selectorFactoryOptions);
            }, [
                store
            ]);
            var _React_useMemo1 = (0, $2nwvT._)($dQFEZ.useMemo(function() {
                if (!shouldHandleStateChanges) return $d7d37dc522b09008$var$NO_SUBSCRIPTION_ARRAY;
                var subscription2 = $d7d37dc522b09008$var$createSubscription(store, didStoreComeFromProps ? void 0 : contextValue.subscription);
                var notifyNestedSubs2 = subscription2.notifyNestedSubs.bind(subscription2);
                return [
                    subscription2,
                    notifyNestedSubs2
                ];
            }, [
                store,
                didStoreComeFromProps,
                contextValue
            ]), 2), subscription = _React_useMemo1[0], notifyNestedSubs = _React_useMemo1[1];
            var overriddenContextValue = $dQFEZ.useMemo(function() {
                if (didStoreComeFromProps) return contextValue;
                return $d7d37dc522b09008$var$__spreadProps($d7d37dc522b09008$var$__spreadValues({}, contextValue), {
                    subscription: subscription
                });
            }, [
                didStoreComeFromProps,
                contextValue,
                subscription
            ]);
            var lastChildProps = $dQFEZ.useRef(void 0);
            var lastWrapperProps = $dQFEZ.useRef(wrapperProps);
            var childPropsFromStoreUpdate = $dQFEZ.useRef(void 0);
            var renderIsScheduled = $dQFEZ.useRef(false);
            var isMounted = $dQFEZ.useRef(false);
            var latestSubscriptionCallbackError = $dQFEZ.useRef(void 0);
            $d7d37dc522b09008$var$useIsomorphicLayoutEffect(function() {
                isMounted.current = true;
                return function() {
                    isMounted.current = false;
                };
            }, []);
            var actualChildPropsSelector = $dQFEZ.useMemo(function() {
                var selector = function() {
                    if (childPropsFromStoreUpdate.current && wrapperProps === lastWrapperProps.current) return childPropsFromStoreUpdate.current;
                    return childPropsSelector(store.getState(), wrapperProps);
                };
                return selector;
            }, [
                store,
                wrapperProps
            ]);
            var subscribeForReact = $dQFEZ.useMemo(function() {
                var subscribe = function(reactListener) {
                    if (!subscription) return function() {};
                    return $d7d37dc522b09008$var$subscribeUpdates(shouldHandleStateChanges, store, subscription, // @ts-ignore
                    childPropsSelector, lastWrapperProps, lastChildProps, renderIsScheduled, isMounted, childPropsFromStoreUpdate, notifyNestedSubs, reactListener);
                };
                return subscribe;
            }, [
                subscription
            ]);
            $d7d37dc522b09008$var$useIsomorphicLayoutEffectWithArgs($d7d37dc522b09008$var$captureWrapperProps, [
                lastWrapperProps,
                lastChildProps,
                renderIsScheduled,
                wrapperProps,
                childPropsFromStoreUpdate,
                notifyNestedSubs
            ]);
            var actualChildProps;
            try {
                actualChildProps = $dQFEZ.useSyncExternalStore(// TODO We're passing through a big wrapper that does a bunch of extra side effects besides subscribing
                subscribeForReact, // TODO This is incredibly hacky. We've already processed the store update and calculated new child props,
                // TODO and we're just passing that through so it triggers a re-render for us rather than relying on `uSES`.
                actualChildPropsSelector, getServerState ? function() {
                    return childPropsSelector(getServerState(), wrapperProps);
                } : actualChildPropsSelector);
            } catch (err) {
                if (latestSubscriptionCallbackError.current) err.message += "\nThe error may be correlated with this previous error:\n".concat(latestSubscriptionCallbackError.current.stack, "\n\n");
                throw err;
            }
            $d7d37dc522b09008$var$useIsomorphicLayoutEffect(function() {
                latestSubscriptionCallbackError.current = void 0;
                childPropsFromStoreUpdate.current = void 0;
                lastChildProps.current = actualChildProps;
            });
            var renderedWrappedComponent = $dQFEZ.useMemo(function() {
                return(// @ts-ignore
                /* @__PURE__ */ $dQFEZ.createElement(WrappedComponent, $d7d37dc522b09008$var$__spreadProps($d7d37dc522b09008$var$__spreadValues({}, actualChildProps), {
                    ref: reactReduxForwardedRef
                })));
            }, [
                reactReduxForwardedRef,
                WrappedComponent,
                actualChildProps
            ]);
            var renderedChild = $dQFEZ.useMemo(function() {
                if (shouldHandleStateChanges) return /* @__PURE__ */ $dQFEZ.createElement(ContextToUse.Provider, {
                    value: overriddenContextValue
                }, renderedWrappedComponent);
                return renderedWrappedComponent;
            }, [
                ContextToUse,
                renderedWrappedComponent,
                overriddenContextValue
            ]);
            return renderedChild;
        };
        var wrappedComponentName = WrappedComponent.displayName || WrappedComponent.name || "Component";
        var displayName = "Connect(".concat(wrappedComponentName, ")");
        var selectorFactoryOptions = {
            shouldHandleStateChanges: shouldHandleStateChanges,
            displayName: displayName,
            wrappedComponentName: wrappedComponentName,
            WrappedComponent: WrappedComponent,
            // @ts-ignore
            initMapStateToProps: initMapStateToProps,
            initMapDispatchToProps: initMapDispatchToProps,
            initMergeProps: initMergeProps,
            areStatesEqual: areStatesEqual,
            areStatePropsEqual: areStatePropsEqual,
            areOwnPropsEqual: areOwnPropsEqual,
            areMergedPropsEqual: areMergedPropsEqual
        };
        var _Connect = $dQFEZ.memo(ConnectFunction);
        var Connect = _Connect;
        Connect.WrappedComponent = WrappedComponent;
        Connect.displayName = ConnectFunction.displayName = displayName;
        if (forwardRef) {
            var _forwarded = $dQFEZ.forwardRef(function forwardConnectRef(props, ref) {
                return /* @__PURE__ */ $dQFEZ.createElement(Connect, $d7d37dc522b09008$var$__spreadProps($d7d37dc522b09008$var$__spreadValues({}, props), {
                    reactReduxForwardedRef: ref
                }));
            });
            var forwarded = _forwarded;
            forwarded.displayName = displayName;
            forwarded.WrappedComponent = WrappedComponent;
            return /* @__PURE__ */ $d7d37dc522b09008$var$hoistNonReactStatics(forwarded, WrappedComponent);
        }
        return /* @__PURE__ */ $d7d37dc522b09008$var$hoistNonReactStatics(Connect, WrappedComponent);
    };
    return wrapWithConnect;
}
var $d7d37dc522b09008$export$64605811ab45167f = $d7d37dc522b09008$var$connect;
// src/components/Provider.tsx
function $d7d37dc522b09008$var$Provider(providerProps) {
    var children = providerProps.children, context = providerProps.context, serverState = providerProps.serverState, store = providerProps.store;
    var contextValue = $dQFEZ.useMemo(function() {
        var subscription = $d7d37dc522b09008$var$createSubscription(store);
        var baseContextValue = {
            store: store,
            subscription: subscription,
            getServerState: serverState ? function() {
                return serverState;
            } : void 0
        };
        return baseContextValue;
    }, [
        store,
        serverState
    ]);
    var previousState = $dQFEZ.useMemo(function() {
        return store.getState();
    }, [
        store
    ]);
    $d7d37dc522b09008$var$useIsomorphicLayoutEffect(function() {
        var subscription = contextValue.subscription;
        subscription.onStateChange = subscription.notifyNestedSubs;
        subscription.trySubscribe();
        if (previousState !== store.getState()) subscription.notifyNestedSubs();
        return function() {
            subscription.tryUnsubscribe();
            subscription.onStateChange = void 0;
        };
    }, [
        contextValue,
        previousState
    ]);
    var Context = context || $d7d37dc522b09008$export$cc80c08dc91f1c00;
    return /* @__PURE__ */ $dQFEZ.createElement(Context.Provider, {
        value: contextValue
    }, children);
}
var $d7d37dc522b09008$export$2881499e37b75b9a = $d7d37dc522b09008$var$Provider;
// src/hooks/useReduxContext.ts
function $d7d37dc522b09008$var$createReduxContextHook() {
    var context = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : $d7d37dc522b09008$export$cc80c08dc91f1c00;
    return function useReduxContext2() {
        var contextValue = $dQFEZ.useContext(context);
        return contextValue;
    };
}
var $d7d37dc522b09008$var$useReduxContext = /* @__PURE__ */ $d7d37dc522b09008$var$createReduxContextHook();
// src/hooks/useStore.ts
function $d7d37dc522b09008$export$671dba69185d0304() {
    var context = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : $d7d37dc522b09008$export$cc80c08dc91f1c00;
    var useReduxContext2 = context === $d7d37dc522b09008$export$cc80c08dc91f1c00 ? $d7d37dc522b09008$var$useReduxContext : // @ts-ignore
    $d7d37dc522b09008$var$createReduxContextHook(context);
    var useStore2 = function() {
        var store = useReduxContext2().store;
        return store;
    };
    Object.assign(useStore2, {
        withTypes: function() {
            return useStore2;
        }
    });
    return useStore2;
}
var $d7d37dc522b09008$export$6ccbb43953eebf8 = /* @__PURE__ */ $d7d37dc522b09008$export$671dba69185d0304();
// src/hooks/useDispatch.ts
function $d7d37dc522b09008$export$bc9b55530897c558() {
    var context = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : $d7d37dc522b09008$export$cc80c08dc91f1c00;
    var useStore2 = context === $d7d37dc522b09008$export$cc80c08dc91f1c00 ? $d7d37dc522b09008$export$6ccbb43953eebf8 : $d7d37dc522b09008$export$671dba69185d0304(context);
    var useDispatch2 = function() {
        var store = useStore2();
        return store.dispatch;
    };
    Object.assign(useDispatch2, {
        withTypes: function() {
            return useDispatch2;
        }
    });
    return useDispatch2;
}
var $d7d37dc522b09008$export$8ad76b76a4c905f8 = /* @__PURE__ */ $d7d37dc522b09008$export$bc9b55530897c558();
var $d7d37dc522b09008$var$refEquality = function(a, b) {
    return a === b;
};
function $d7d37dc522b09008$export$2b53f90d2bd1cbfb() {
    var context = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : $d7d37dc522b09008$export$cc80c08dc91f1c00;
    var useReduxContext2 = context === $d7d37dc522b09008$export$cc80c08dc91f1c00 ? $d7d37dc522b09008$var$useReduxContext : $d7d37dc522b09008$var$createReduxContextHook(context);
    var useSelector2 = function(selector) {
        var equalityFnOrOptions = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
        var _ref = typeof equalityFnOrOptions === "function" ? {
            equalityFn: equalityFnOrOptions
        } : equalityFnOrOptions, _ref_equalityFn = _ref.equalityFn, equalityFn = _ref_equalityFn === void 0 ? $d7d37dc522b09008$var$refEquality : _ref_equalityFn;
        var reduxContext = useReduxContext2();
        var store = reduxContext.store, subscription = reduxContext.subscription, getServerState = reduxContext.getServerState;
        var firstRun = $dQFEZ.useRef(true);
        var wrappedSelector = $dQFEZ.useCallback((0, $72osQ._)({}, selector.name, function(state) {
            var selected = selector(state);
            var e, e1;
            return selected;
        })[selector.name], [
            selector
        ]);
        var selectedState = (0, $f6758991d88cb14f$exports.useSyncExternalStoreWithSelector)(subscription.addNestedSub, store.getState, getServerState || store.getState, wrappedSelector, equalityFn);
        $dQFEZ.useDebugValue(selectedState);
        return selectedState;
    };
    Object.assign(useSelector2, {
        withTypes: function() {
            return useSelector2;
        }
    });
    return useSelector2;
}
var $d7d37dc522b09008$export$2105062e25df4afe = /* @__PURE__ */ $d7d37dc522b09008$export$2b53f90d2bd1cbfb();
// src/exports.ts
var $d7d37dc522b09008$export$712ea50be43a7858 = $d7d37dc522b09008$var$defaultNoopBatch;


var $32ef10a07f569689$var$Header = function() {
    var _useState = (0, $2nwvT._)((0, $dQFEZ.useState)("Login"), 2), btnNameReact = _useState[0], setBtnNameReact = _useState[1];
    var onlineStatus = (0, $1344a5fd517c0f04$export$2e2bcd8739ae039)();
    var loggedInUser = (0, $dQFEZ.useContext)((0, $bec8559dd543f601$export$2e2bcd8739ae039)).loggedInUser;
    // Subscribing to the store using a selector
    var cartItems = (0, $d7d37dc522b09008$export$2105062e25df4afe)(function(store) {
        return store.cart.items;
    });
    return /*#__PURE__*/ (0, $iD4WH.jsxs)("header", {
        className: "flex justify-between items-center px-[50px] py-2 bg-[#f1f1f1] shadow-transparent rounded-[15px]",
        children: [
            /*#__PURE__*/ (0, $iD4WH.jsx)("img", {
                src: (0, $ea4655d05e0a655f$export$8878ead86ed0da0b),
                alt: "Food App Logo",
                className: "w-[180px] h-[90px] sm:w-[220px] sm:h-[110px] md:w-[260px] md:h-[130px] object-contain"
            }),
            /*#__PURE__*/ (0, $iD4WH.jsxs)("ul", {
                className: "flex items-center gap-[35px] text-[18px] list-none p-0 m-0",
                children: [
                    /*#__PURE__*/ (0, $iD4WH.jsxs)("li", {
                        children: [
                            "Online Status: ",
                            onlineStatus ? "\uD83D\uDFE2" : "\uD83D\uDD34"
                        ]
                    }),
                    /*#__PURE__*/ (0, $iD4WH.jsx)("li", {
                        children: /*#__PURE__*/ (0, $iD4WH.jsx)((0, $fc41d09ddc03e3ec$export$a6c7ac8248d6e38a), {
                            to: "/",
                            children: "Home"
                        })
                    }),
                    /*#__PURE__*/ (0, $iD4WH.jsx)("li", {
                        children: /*#__PURE__*/ (0, $iD4WH.jsx)((0, $fc41d09ddc03e3ec$export$a6c7ac8248d6e38a), {
                            to: "/about",
                            children: "About"
                        })
                    }),
                    /*#__PURE__*/ (0, $iD4WH.jsx)("li", {
                        children: /*#__PURE__*/ (0, $iD4WH.jsx)((0, $fc41d09ddc03e3ec$export$a6c7ac8248d6e38a), {
                            to: "/contact",
                            children: "Contact"
                        })
                    }),
                    /*#__PURE__*/ (0, $iD4WH.jsx)("li", {
                        children: /*#__PURE__*/ (0, $iD4WH.jsx)((0, $fc41d09ddc03e3ec$export$a6c7ac8248d6e38a), {
                            to: "/grocery",
                            children: "Grocery"
                        })
                    }),
                    " ",
                    /*#__PURE__*/ (0, $iD4WH.jsx)("li", {
                        children: /*#__PURE__*/ (0, $iD4WH.jsxs)((0, $fc41d09ddc03e3ec$export$a6c7ac8248d6e38a), {
                            to: "/cart",
                            children: [
                                "Cart (",
                                cartItems.length,
                                ")"
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0, $iD4WH.jsx)("button", {
                        onClick: function() {
                            return setBtnNameReact(btnNameReact === "Login" ? "Logout" : "Login");
                        },
                        className: "px-6 py-2 border rounded hover:bg-orange-500 hover:text-white",
                        children: btnNameReact
                    }),
                    /*#__PURE__*/ (0, $iD4WH.jsx)("li", {
                        className: "px-4 font-bold",
                        children: loggedInUser
                    })
                ]
            })
        ]
    });
};
var $32ef10a07f569689$export$2e2bcd8739ae039 = $32ef10a07f569689$var$Header;



var $g3gsR = parcelRequire("g3gsR");

var $2nwvT = parcelRequire("2nwvT");

var $fRv9I = parcelRequire("fRv9I");

var $iD4WH = parcelRequire("iD4WH");

var $dQFEZ = parcelRequire("dQFEZ");
// RestaurantCard.jsx
// Reusable component to display a single restaurant card

var $joFW3 = parcelRequire("joFW3");

var $iD4WH = parcelRequire("iD4WH");
parcelRequire("dQFEZ");

var $127143c37b1e1d63$var$RestaurantCard = function(param) {
    var resData = param.resData;
    var _info_cuisines, _info_sla;
    var info = resData === null || resData === void 0 ? void 0 : resData.info;
    var _info_avgRating;
    return(// OLD: rest-card
    /*#__PURE__*/ (0, $iD4WH.jsxs)("div", {
        "data-testid": "resCard",
        className: " w-[280px] bg-[#ffffff] hover:bg-[#e3e3e3] rounded-[12px] overflow-hidden shadow-md text-center cursor-pointer transition-all duration-300 hover:-translate-y-2 hover:shadow-2xl hover:scale-[1.02] ",
        children: [
            /*#__PURE__*/ (0, $iD4WH.jsx)("img", {
                className: "w-full h-[180px] object-cover",
                alt: "restaurant",
                src: (0, $ea4655d05e0a655f$export$31adfacaf07ffe63) + (info === null || info === void 0 ? void 0 : info.cloudinaryImageId)
            }),
            /*#__PURE__*/ (0, $iD4WH.jsxs)("div", {
                className: "p-4",
                children: [
                    /*#__PURE__*/ (0, $iD4WH.jsx)("h2", {
                        className: "text-[17px] font-semibold text-gray-800 mb-1",
                        children: info === null || info === void 0 ? void 0 : info.name
                    }),
                    /*#__PURE__*/ (0, $iD4WH.jsx)("h4", {
                        className: "text-[14px] text-gray-600 mb-1",
                        children: info === null || info === void 0 ? void 0 : (_info_cuisines = info.cuisines) === null || _info_cuisines === void 0 ? void 0 : _info_cuisines.join(", ")
                    }),
                    /*#__PURE__*/ (0, $iD4WH.jsxs)("span", {
                        className: "inline-block text-[13px] text-gray-800 px-2 py-1 rounded-md mb-1 bg-orange-100",
                        children: [
                            (_info_avgRating = info === null || info === void 0 ? void 0 : info.avgRating) !== null && _info_avgRating !== void 0 ? _info_avgRating : info === null || info === void 0 ? void 0 : info.avgRatingString,
                            " \u2B50"
                        ]
                    }),
                    /*#__PURE__*/ (0, $iD4WH.jsx)("h4", {
                        className: "text-[14px] text-gray-600",
                        children: info === null || info === void 0 ? void 0 : info.costForTwo
                    }),
                    /*#__PURE__*/ (0, $iD4WH.jsxs)("h4", {
                        className: "text-[14px] text-gray-600",
                        children: [
                            info === null || info === void 0 ? void 0 : (_info_sla = info.sla) === null || _info_sla === void 0 ? void 0 : _info_sla.deliveryTime,
                            " minutes"
                        ]
                    })
                ]
            })
        ]
    }));
};
var $127143c37b1e1d63$export$2e2bcd8739ae039 = $127143c37b1e1d63$var$RestaurantCard;
var $127143c37b1e1d63$export$ccb02a230af14023 = function(RestaurantCard) {
    return function(props) {
        return /*#__PURE__*/ (0, $iD4WH.jsxs)("div", {
            className: "relative",
            children: [
                /*#__PURE__*/ (0, $iD4WH.jsx)("label", {
                    className: " absolute top-2 left-2 bg-black text-white text-xs font-semibold px-2 py-1 rounded z-10 ",
                    children: "Promoted"
                }),
                /*#__PURE__*/ (0, $iD4WH.jsx)(RestaurantCard, (0, $joFW3._)({}, props))
            ]
        });
    };
};



var $iD4WH = parcelRequire("iD4WH");
parcelRequire("dQFEZ");
var $45d0d9be49de331f$var$ShimmerCard = function() {
    return /*#__PURE__*/ (0, $iD4WH.jsx)("div", {
        className: "relative w-[280px] h-[360px] rounded-[12px] bg-[#e0e0e0] overflow-hidden",
        children: /*#__PURE__*/ (0, $iD4WH.jsx)("div", {
            className: " absolute inset-0 -translate-x-full bg-[linear-gradient(90deg,#e0e0e0_25%,#f5f5f5_37%,#e0e0e0_63%)] animate-[shimmer_2.4s_infinite] "
        })
    });
};
var $45d0d9be49de331f$var$Shimmer = function() {
    return /*#__PURE__*/ (0, $iD4WH.jsx)("div", {
        className: "flex flex-wrap justify-center gap-[25px] px-[40px] py-[30px] bg-[#f8f8f8]",
        children: Array.from({
            length: 8
        }).map(function(_, i) {
            return /*#__PURE__*/ (0, $iD4WH.jsx)($45d0d9be49de331f$var$ShimmerCard, {}, i);
        })
    });
};
var $45d0d9be49de331f$export$2e2bcd8739ae039 = $45d0d9be49de331f$var$Shimmer;




var $cc0ae36f17da6a6a$var$Body = function() {
    var _useState = (0, $2nwvT._)((0, $dQFEZ.useState)([]), 2), listOfRestaurants = _useState[0], setListOfRestaurants = _useState[1];
    var _useState1 = (0, $2nwvT._)((0, $dQFEZ.useState)([]), 2), filteredRestaurants = _useState1[0], setFilteredRestaurants = _useState1[1];
    var _useState2 = (0, $2nwvT._)((0, $dQFEZ.useState)(""), 2), searchText = _useState2[0], setSearchText = _useState2[1];
    var RestaurantCardPromoted = (0, $127143c37b1e1d63$export$ccb02a230af14023)((0, $127143c37b1e1d63$export$2e2bcd8739ae039));
    var navigate = (0, $8c3ad80f8a436e0f$export$9770f232ac06a008)();
    (0, $dQFEZ.useEffect)(function() {
        fetchData();
    }, []);
    var fetchData = function() {
        return (/*#__PURE__*/ 0, /*#__PURE__*/ $g3gsR._)(function() {
            var _json_data_cards_find_card_card_gridElements_infoWithStyle, _json_data_cards_find_card_card_gridElements, _json_data_cards_find_card_card, _json_data_cards_find_card, _json_data_cards_find, _json_data_cards, _json_data, response, json, restaurantsData, error;
            return (0, $fRv9I.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        _state.trys.push([
                            0,
                            3,
                            ,
                            4
                        ]);
                        return [
                            4,
                            fetch("https://www.swiggy.com/dapi/restaurants/list/v5?lat=22.653564&lng=88.4450847&is-seo-homepage-enabled=true&page_type=DESKTOP_WEB_LISTING")
                        ];
                    case 1:
                        response = _state.sent();
                        return [
                            4,
                            response.json()
                        ];
                    case 2:
                        json = _state.sent();
                        restaurantsData = (json === null || json === void 0 ? void 0 : (_json_data = json.data) === null || _json_data === void 0 ? void 0 : (_json_data_cards = _json_data.cards) === null || _json_data_cards === void 0 ? void 0 : (_json_data_cards_find = _json_data_cards.find(function(item) {
                            var _item_card_card_id, _item_card_card, _item_card;
                            return item === null || item === void 0 ? void 0 : (_item_card = item.card) === null || _item_card === void 0 ? void 0 : (_item_card_card = _item_card.card) === null || _item_card_card === void 0 ? void 0 : (_item_card_card_id = _item_card_card.id) === null || _item_card_card_id === void 0 ? void 0 : _item_card_card_id.includes("restaurant_grid_listing_v2");
                        })) === null || _json_data_cards_find === void 0 ? void 0 : (_json_data_cards_find_card = _json_data_cards_find.card) === null || _json_data_cards_find_card === void 0 ? void 0 : (_json_data_cards_find_card_card = _json_data_cards_find_card.card) === null || _json_data_cards_find_card_card === void 0 ? void 0 : (_json_data_cards_find_card_card_gridElements = _json_data_cards_find_card_card.gridElements) === null || _json_data_cards_find_card_card_gridElements === void 0 ? void 0 : (_json_data_cards_find_card_card_gridElements_infoWithStyle = _json_data_cards_find_card_card_gridElements.infoWithStyle) === null || _json_data_cards_find_card_card_gridElements_infoWithStyle === void 0 ? void 0 : _json_data_cards_find_card_card_gridElements_infoWithStyle.restaurants) || [];
                        setListOfRestaurants(restaurantsData);
                        setFilteredRestaurants(restaurantsData);
                        return [
                            3,
                            4
                        ];
                    case 3:
                        error = _state.sent();
                        console.error("Error fetching data:", error);
                        return [
                            3,
                            4
                        ];
                    case 4:
                        return [
                            2
                        ];
                }
            });
        })();
    };
    var onlineStatus = (0, $1344a5fd517c0f04$export$2e2bcd8739ae039)();
    if (!onlineStatus) return /*#__PURE__*/ (0, $iD4WH.jsx)("h1", {
        className: "text-center text-xl font-semibold mt-10 text-red-500",
        children: "Looks like you're offline!!! Please check your internet connection"
    });
    //  Show shimmer while loading API data
    if (listOfRestaurants.length === 0) return /*#__PURE__*/ (0, $iD4WH.jsx)((0, $45d0d9be49de331f$export$2e2bcd8739ae039), {});
    return /*#__PURE__*/ (0, $iD4WH.jsxs)("div", {
        className: "bg-white min-h-screen",
        children: [
            /*#__PURE__*/ (0, $iD4WH.jsxs)("div", {
                className: "flex justify-center flex-wrap m-[19px] px-[40px] py-[14px] gap-6",
                children: [
                    /*#__PURE__*/ (0, $iD4WH.jsxs)("div", {
                        className: "flex items-center",
                        children: [
                            /*#__PURE__*/ (0, $iD4WH.jsx)("input", {
                                className: "px-[40px] py-[14px] rounded-l-[15px] border border-black outline-none",
                                type: "text",
                                "data-testid": "searchInput",
                                value: searchText,
                                onChange: function(e) {
                                    return setSearchText(e.target.value);
                                },
                                placeholder: "Search restaurants..."
                            }),
                            /*#__PURE__*/ (0, $iD4WH.jsx)("button", {
                                className: "px-[40px] py-[14px] rounded-r-[15px] bg-gray-100 hover:bg-gray-200 transition",
                                onClick: function() {
                                    var filtered = listOfRestaurants.filter(function(res) {
                                        return res.info.name.toLowerCase().includes(searchText.toLowerCase());
                                    });
                                    setFilteredRestaurants(filtered);
                                },
                                children: "Search"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $iD4WH.jsx)("button", {
                        className: "px-[40px] py-[14px] rounded-[15px] bg-gray-100 hover:bg-gray-200 transition",
                        onClick: function() {
                            var filtered = listOfRestaurants.filter(function(res) {
                                return res.info.avgRating > 4.2;
                            });
                            setFilteredRestaurants(filtered);
                        },
                        children: "Top Rated Restaurants"
                    })
                ]
            }),
            /*#__PURE__*/ (0, $iD4WH.jsx)("div", {
                className: "flex flex-wrap justify-center gap-[25px] px-[40px] py-[30px] bg-[#f1f1f1]",
                children: filteredRestaurants.map(function(restaurant) {
                    var _restaurant_info;
                    var id = restaurant.info.id;
                    var CardComponent = (restaurant === null || restaurant === void 0 ? void 0 : (_restaurant_info = restaurant.info) === null || _restaurant_info === void 0 ? void 0 : _restaurant_info.promoted) ? RestaurantCardPromoted : (0, $127143c37b1e1d63$export$2e2bcd8739ae039);
                    return /*#__PURE__*/ (0, $iD4WH.jsx)("div", {
                        onClick: function() {
                            return navigate("/restaurants/".concat(id));
                        },
                        className: "cursor-pointer",
                        children: /*#__PURE__*/ (0, $iD4WH.jsx)(CardComponent, {
                            resData: restaurant
                        })
                    }, id);
                })
            })
        ]
    });
};
var $cc0ae36f17da6a6a$export$2e2bcd8739ae039 = $cc0ae36f17da6a6a$var$Body;



var $iD4WH = parcelRequire("iD4WH");

var $4UEIL = parcelRequire("4UEIL");
var $babf9d9b4d58e8a0$var$features = [
    {
        title: "Precision Delivery",
        desc: "Smart routing and preparation workflows ensure every meal reaches you hot, fresh, and right on time."
    },
    {
        title: "Farm-to-Fork Sourcing",
        desc: "We work directly with trusted local Bokaro growers to source fresh, seasonal, and responsibly grown ingredients."
    },
    {
        title: "Chef-Led Standards",
        desc: "Every recipe is designed, tested, and refined by experienced chefs to meet consistent quality benchmarks."
    },
    {
        title: "Human Support",
        desc: "Real people, real help. Our support team is available 24/7 to assist you without automated bots."
    }
];
var $babf9d9b4d58e8a0$var$About = function() {
    return /*#__PURE__*/ (0, $iD4WH.jsxs)("div", {
        className: "bg-[#F8FAFC] text-slate-900 antialiased font-sans",
        children: [
            /*#__PURE__*/ (0, $iD4WH.jsxs)("section", {
                className: "max-w-[1300px] mx-auto px-6 pt-20 md:pt-28 pb-24 md:pb-32 grid lg:grid-cols-12 gap-16 items-center",
                children: [
                    /*#__PURE__*/ (0, $iD4WH.jsxs)((0, $4UEIL.motion).div, {
                        initial: {
                            opacity: 0,
                            y: 30
                        },
                        animate: {
                            opacity: 1,
                            y: 0
                        },
                        transition: {
                            duration: 0.8
                        },
                        className: "lg:col-span-7 space-y-10",
                        children: [
                            /*#__PURE__*/ (0, $iD4WH.jsxs)("h1", {
                                className: "text-6xl md:text-[5.5rem] font-black leading-[0.9] tracking-tighter",
                                children: [
                                    "ChefMaster: Where Precision Creates Excellence ",
                                    /*#__PURE__*/ (0, $iD4WH.jsx)("br", {}),
                                    /*#__PURE__*/ (0, $iD4WH.jsx)("span", {
                                        className: "text-transparent bg-clip-text bg-linear-to-r from-orange-500 to-red-600",
                                        children: "Delivered with purpose."
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $iD4WH.jsx)("p", {
                                className: "text-xl text-slate-500 max-w-xl leading-relaxed font-medium",
                                children: "ChefMaster is a chef-driven restaurant brand from Bokaro, built on precision, freshness, and respect for food. We combine culinary expertise with operational discipline to deliver restaurant-quality meals consistently at your doorstep."
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $iD4WH.jsxs)((0, $4UEIL.motion).div, {
                        initial: {
                            opacity: 0,
                            scale: 0.95
                        },
                        animate: {
                            opacity: 1,
                            scale: 1
                        },
                        transition: {
                            duration: 0.9
                        },
                        className: "lg:col-span-5 relative",
                        children: [
                            /*#__PURE__*/ (0, $iD4WH.jsx)("div", {
                                className: "absolute -inset-6 bg-orange-100/60 rounded-[4rem] -rotate-3 -z-10"
                            }),
                            /*#__PURE__*/ (0, $iD4WH.jsx)("img", {
                                src: "https://images.unsplash.com/photo-1552566626-52f8b828add9",
                                alt: "ChefMaster Kitchen",
                                className: "w-full h-[420px] md:h-[600px] object-cover rounded-[3.5rem] shadow-[0_40px_80px_-15px_rgba(0,0,0,0.2)]"
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $iD4WH.jsx)("section", {
                className: "max-w-[1300px] mx-auto px-6 py-24",
                children: /*#__PURE__*/ (0, $iD4WH.jsxs)("div", {
                    className: "grid grid-cols-1 md:grid-cols-4 gap-6",
                    children: [
                        /*#__PURE__*/ (0, $iD4WH.jsxs)("div", {
                            className: "md:col-span-2 bg-white rounded-[3rem] p-12 flex flex-col justify-center items-center text-center shadow-[0_20px_60px_rgba(0,0,0,0.12)] hover:shadow-[0_30px_80px_rgba(0,0,0,0.18)] transition-all duration-500 hover:-translate-y-2",
                            children: [
                                /*#__PURE__*/ (0, $iD4WH.jsxs)("h2", {
                                    className: "text-5xl font-black text-slate-900",
                                    children: [
                                        "05",
                                        /*#__PURE__*/ (0, $iD4WH.jsx)("span", {
                                            className: "text-orange-500 text-3xl",
                                            children: "+"
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $iD4WH.jsx)("p", {
                                    className: "text-slate-500 font-bold uppercase tracking-[0.25em] text-[10px] mt-3",
                                    children: "Years of Operational Excellence"
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $iD4WH.jsxs)("div", {
                            className: "bg-white rounded-[3rem] p-12 flex flex-col justify-center items-center text-center shadow-[0_20px_60px_rgba(0,0,0,0.12)] hover:shadow-[0_30px_80px_rgba(0,0,0,0.18)] transition-all duration-500 hover:-translate-y-2",
                            children: [
                                /*#__PURE__*/ (0, $iD4WH.jsxs)("h2", {
                                    className: "text-5xl font-black text-slate-900",
                                    children: [
                                        "50K",
                                        /*#__PURE__*/ (0, $iD4WH.jsx)("span", {
                                            className: "text-orange-500 text-3xl",
                                            children: "+"
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $iD4WH.jsx)("p", {
                                    className: "text-slate-500 font-bold uppercase tracking-[0.25em] text-[10px] mt-3",
                                    children: "Orders Delivered"
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $iD4WH.jsxs)("div", {
                            className: "bg-white rounded-[3rem] p-12 flex flex-col items-center justify-center text-center shadow-[0_20px_60px_rgba(0,0,0,0.12)] hover:shadow-[0_30px_80px_rgba(0,0,0,0.18)] transition-all duration-500 hover:-translate-y-2",
                            children: [
                                /*#__PURE__*/ (0, $iD4WH.jsx)("h2", {
                                    className: "text-5xl font-black text-slate-900",
                                    children: "4.8 \u2B50"
                                }),
                                /*#__PURE__*/ (0, $iD4WH.jsx)("p", {
                                    className: "text-slate-500 font-bold uppercase tracking-[0.25em] text-[10px] mt-3",
                                    children: "App Store Rating"
                                })
                            ]
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, $iD4WH.jsxs)("section", {
                className: "relative max-w-[1300px] mx-auto px-6 py-32",
                children: [
                    /*#__PURE__*/ (0, $iD4WH.jsx)("div", {
                        className: "absolute inset-0 -z-10",
                        children: /*#__PURE__*/ (0, $iD4WH.jsx)("div", {
                            className: "absolute top-40 left-1/2 -translate-x-1/2 w-[600px] h-[600px] bg-orange-400/10 blur-[120px] rounded-full"
                        })
                    }),
                    /*#__PURE__*/ (0, $iD4WH.jsxs)("div", {
                        className: "text-center mb-24",
                        children: [
                            /*#__PURE__*/ (0, $iD4WH.jsxs)("h2", {
                                className: "text-5xl md:text-6xl font-black tracking-tight mb-6",
                                children: [
                                    "The system behind the",
                                    " ",
                                    /*#__PURE__*/ (0, $iD4WH.jsx)("span", {
                                        className: "text-orange-500",
                                        children: "flavor."
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $iD4WH.jsx)("p", {
                                className: "text-xl text-slate-500 max-w-2xl mx-auto",
                                children: "ChefMaster is engineered like a restaurant and operated like a system \u2014 ensuring quality, speed, and consistency at scale."
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $iD4WH.jsx)("div", {
                        className: "grid md:grid-cols-2 lg:grid-cols-4 gap-10",
                        children: $babf9d9b4d58e8a0$var$features.map(function(item, i) {
                            return /*#__PURE__*/ (0, $iD4WH.jsx)((0, $4UEIL.motion).div, {
                                initial: {
                                    opacity: 0,
                                    y: 30
                                },
                                whileInView: {
                                    opacity: 1,
                                    y: 0
                                },
                                viewport: {
                                    once: true
                                },
                                transition: {
                                    duration: 0.6,
                                    delay: i * 0.1
                                },
                                className: " group relative rounded-[2.8rem] p-px bg-linear-to-br from-orange-400/40 via-transparent to-slate-200 hover:scale-[1.03] transition-all duration-500 ",
                                children: /*#__PURE__*/ (0, $iD4WH.jsxs)("div", {
                                    className: " h-full rounded-[2.7rem] p-10 bg-white/80 backdrop-blur-xl shadow-[0_20px_60px_rgba(0,0,0,0.08)] group-hover:shadow-[0_30px_90px_rgba(0,0,0,0.18)] transition-all duration-500 ",
                                    children: [
                                        /*#__PURE__*/ (0, $iD4WH.jsx)("div", {
                                            className: " w-16 h-16 mb-8 rounded-2xl bg-linear-to-br from-orange-400 to-orange-600 text-white text-3xl flex items-center justify-center shadow-lg group-hover:scale-90 transition-transform duration-500 ",
                                            children: item.icon
                                        }),
                                        /*#__PURE__*/ (0, $iD4WH.jsx)("h4", {
                                            className: "text-2xl font-black mb-4 text-slate-900",
                                            children: item.title
                                        }),
                                        /*#__PURE__*/ (0, $iD4WH.jsx)("p", {
                                            className: "text-slate-600 leading-relaxed",
                                            children: item.desc
                                        })
                                    ]
                                })
                            }, i);
                        })
                    })
                ]
            })
        ]
    });
};
var $babf9d9b4d58e8a0$export$2e2bcd8739ae039 = $babf9d9b4d58e8a0$var$About;



var $iD4WH = parcelRequire("iD4WH");
var $7dbfc2620234cc5c$var$Contact = function() {
    return /*#__PURE__*/ (0, $iD4WH.jsx)("div", {
        className: "min-h-screen bg-[#ffffff] py-[40px]",
        children: /*#__PURE__*/ (0, $iD4WH.jsxs)("div", {
            className: "max-w-[1100px] mx-auto px-6",
            children: [
                /*#__PURE__*/ (0, $iD4WH.jsxs)("div", {
                    className: "text-center mb-12",
                    children: [
                        /*#__PURE__*/ (0, $iD4WH.jsx)("h1", {
                            className: "text-[38px] text-[#222] font-semibold",
                            children: "Contact Us"
                        }),
                        /*#__PURE__*/ (0, $iD4WH.jsx)("p", {
                            className: "text-[#666] mt-2",
                            children: "We\u2019d love to hear from you. Get in touch with us!"
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $iD4WH.jsxs)("div", {
                    className: "flex gap-14 bg-[#e6e5e5] rounded-[24px] p-12  shadow-[0_30px_70px_rgba(0,0,0,0.12)] max-[900px]:flex-col",
                    children: [
                        /*#__PURE__*/ (0, $iD4WH.jsxs)("div", {
                            className: "flex-1",
                            children: [
                                /*#__PURE__*/ (0, $iD4WH.jsx)("h2", {
                                    className: "mb-6 text-xl font-semibold",
                                    children: "Get in Touch"
                                }),
                                /*#__PURE__*/ (0, $iD4WH.jsxs)("div", {
                                    className: "flex items-center gap-3 mb-5 text-[16px]",
                                    children: [
                                        /*#__PURE__*/ (0, $iD4WH.jsx)("span", {
                                            className: "text-[20px]",
                                            children: "\uD83D\uDCCD"
                                        }),
                                        /*#__PURE__*/ (0, $iD4WH.jsx)("p", {
                                            children: "Bokaro Steel City, Jharkhand, India"
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $iD4WH.jsxs)("div", {
                                    className: "mt-3 text-sm text-gray-700 space-y-1",
                                    children: [
                                        /*#__PURE__*/ (0, $iD4WH.jsx)("p", {
                                            children: "\u23F0 Mon \u2013 Sat: 9:00 AM \u2013 8:00 PM"
                                        }),
                                        /*#__PURE__*/ (0, $iD4WH.jsx)("p", {
                                            children: "\u26A1 Response within 24 hours"
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $iD4WH.jsxs)("div", {
                                    className: "flex items-center gap-3 mt-4 text-[16px]",
                                    children: [
                                        /*#__PURE__*/ (0, $iD4WH.jsx)("span", {
                                            className: "text-[20px]",
                                            children: "\uD83D\uDCE7"
                                        }),
                                        /*#__PURE__*/ (0, $iD4WH.jsx)("p", {
                                            children: "support@chefmaster.com"
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $iD4WH.jsx)("iframe", {
                                    title: "map",
                                    src: "https://www.google.com/maps?q=Bokaro%20Steel%20City,%20Jharkhand&output=embed",
                                    loading: "lazy",
                                    className: "mt-6 w-full h-[180px] rounded-[14px] shadow-sm border-0"
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $iD4WH.jsxs)("div", {
                            className: "flex-1",
                            children: [
                                /*#__PURE__*/ (0, $iD4WH.jsx)("h2", {
                                    className: "mb-6 text-xl font-semibold",
                                    children: "Send Message"
                                }),
                                /*#__PURE__*/ (0, $iD4WH.jsxs)("form", {
                                    className: "flex flex-col gap-4",
                                    children: [
                                        /*#__PURE__*/ (0, $iD4WH.jsx)("input", {
                                            type: "text",
                                            placeholder: "Your Name",
                                            required: true,
                                            className: "px-[16px] py-[13px] rounded-[12px] border border-[#ddd] text-[15px] outline-none focus:border-black"
                                        }),
                                        /*#__PURE__*/ (0, $iD4WH.jsx)("input", {
                                            type: "email",
                                            placeholder: "Your Email",
                                            required: true,
                                            className: "px-[16px] py-[13px] rounded-[12px] border border-[#ddd] text-[15px] outline-none focus:border-black"
                                        }),
                                        /*#__PURE__*/ (0, $iD4WH.jsx)("textarea", {
                                            rows: "5",
                                            placeholder: "Your Message",
                                            required: true,
                                            className: "px-[16px] py-[13px] rounded-[12px] border border-[#ddd] text-[15px] outline-none focus:border-black resize-none"
                                        }),
                                        /*#__PURE__*/ (0, $iD4WH.jsx)("button", {
                                            type: "submit",
                                            className: "mt-2 bg-linear-to-r from-[#ffffff] to-[#d5d4d4] text-white py-3 rounded-[14px] text-[16px] font-medium transition",
                                            children: "Send Message"
                                        })
                                    ]
                                })
                            ]
                        })
                    ]
                })
            ]
        })
    });
};
var $7dbfc2620234cc5c$export$2e2bcd8739ae039 = $7dbfc2620234cc5c$var$Contact;



var $iD4WH = parcelRequire("iD4WH");

var $6723dc5d2e485afc$var$Error = function() {
    var navigate = (0, $8c3ad80f8a436e0f$export$9770f232ac06a008)();
    return /*#__PURE__*/ (0, $iD4WH.jsxs)("div", {
        className: " min-h-screen flex flex-col justify-center items-center text-center px-4 bg-linear-to-br from-orange-50 to-white dark:from-gray-800 dark:to-gray-900 ",
        children: [
            /*#__PURE__*/ (0, $iD4WH.jsx)("h1", {
                className: "text-4xl sm:text-5xl font-bold text-red-500",
                children: "Oops! Something broke \uD83D\uDE35"
            }),
            /*#__PURE__*/ (0, $iD4WH.jsx)("h2", {
                className: "mt-3 text-xl sm:text-2xl font-semibold text-gray-800 dark:text-gray-200",
                children: "We can\u2019t find the page you\u2019re looking for"
            }),
            /*#__PURE__*/ (0, $iD4WH.jsxs)("div", {
                className: "flex gap-4 flex-wrap justify-center",
                children: [
                    /*#__PURE__*/ (0, $iD4WH.jsx)("button", {
                        onClick: function() {
                            return navigate("/");
                        },
                        className: " px-6 py-3 rounded-full font-medium bg-orange-500 text-white hover:bg-orange-600 transition-transform hover:scale-105  ",
                        children: "Go Home \uD83C\uDFE0"
                    }),
                    /*#__PURE__*/ (0, $iD4WH.jsx)("button", {
                        onClick: function() {
                            return window.location.reload();
                        },
                        className: " px-6 py-3 rounded-full font-medium bg-orange-500 text-white hover:bg-orange-600 transition-transform hover:scale-105  ",
                        children: "Try Again \uD83D\uDD04"
                    })
                ]
            }),
            /*#__PURE__*/ (0, $iD4WH.jsx)("p", {
                className: "mt-6 text-sm text-gray-500 dark:text-gray-400",
                children: "Still stuck? Check your internet connection or try again later."
            })
        ]
    });
};
var $6723dc5d2e485afc$export$2e2bcd8739ae039 = $6723dc5d2e485afc$var$Error;



var $2nwvT = parcelRequire("2nwvT");

var $iD4WH = parcelRequire("iD4WH");


var $dQFEZ = parcelRequire("dQFEZ");


var $iD4WH = parcelRequire("iD4WH");

var $iD4WH = parcelRequire("iD4WH");

// Import createSlice from Redux Toolkit
// createSlice helps us create reducers + actions in a clean way

var $g3gsR = parcelRequire("g3gsR");

var $f3Okx = parcelRequire("f3Okx");

var $grujF = parcelRequire("grujF");

var $8wAe0 = parcelRequire("8wAe0");

var $dhMkv = parcelRequire("dhMkv");

var $72osQ = parcelRequire("72osQ");

var $bxomo = parcelRequire("bxomo");

var $gyGuQ = parcelRequire("gyGuQ");

var $j6Mzi = parcelRequire("j6Mzi");

var $2nwvT = parcelRequire("2nwvT");

var $2us1u = parcelRequire("2us1u");

var $bJtXW = parcelRequire("bJtXW");

var $1EZOw = parcelRequire("1EZOw");

var $fRv9I = parcelRequire("fRv9I");
// src/utils/formatProdErrorMessage.ts

var $72osQ = parcelRequire("72osQ");

var $joFW3 = parcelRequire("joFW3");

var $90FDw = parcelRequire("90FDw");

var $2us1u = parcelRequire("2us1u");

var $bJtXW = parcelRequire("bJtXW");
function $20ec22595b3da151$var$formatProdErrorMessage(code) {
    return "Minified Redux error #".concat(code, "; visit https://redux.js.org/Errors?code=").concat(code, " for the full message or use the non-minified dev environment for full errors. ");
}
// src/utils/symbol-observable.ts
var $20ec22595b3da151$var$$$observable = /* @__PURE__ */ function() {
    return typeof Symbol === "function" && Symbol.observable || "@@observable";
}();
var $20ec22595b3da151$var$symbol_observable_default = $20ec22595b3da151$var$$$observable;
// src/utils/actionTypes.ts
var $20ec22595b3da151$var$randomString = function() {
    return Math.random().toString(36).substring(7).split("").join(".");
};
var $20ec22595b3da151$var$ActionTypes = {
    INIT: "@@redux/INIT".concat($20ec22595b3da151$var$randomString()),
    REPLACE: "@@redux/REPLACE".concat($20ec22595b3da151$var$randomString()),
    PROBE_UNKNOWN_ACTION: function() {
        return "@@redux/PROBE_UNKNOWN_ACTION".concat($20ec22595b3da151$var$randomString());
    }
};
var $20ec22595b3da151$export$4219e499db7ca678 = $20ec22595b3da151$var$ActionTypes;
// src/utils/isPlainObject.ts
function $20ec22595b3da151$export$53b83ca8eaab0383(obj) {
    if ((typeof obj === "undefined" ? "undefined" : (0, $bJtXW._)(obj)) !== "object" || obj === null) return false;
    var proto = obj;
    while(Object.getPrototypeOf(proto) !== null)proto = Object.getPrototypeOf(proto);
    return Object.getPrototypeOf(obj) === proto || Object.getPrototypeOf(obj) === null;
}
// src/utils/kindOf.ts
function $20ec22595b3da151$var$miniKindOf(val) {
    if (val === void 0) return "undefined";
    if (val === null) return "null";
    var type = typeof val === "undefined" ? "undefined" : (0, $bJtXW._)(val);
    switch(type){
        case "boolean":
        case "string":
        case "number":
        case "symbol":
        case "function":
            return type;
    }
    if (Array.isArray(val)) return "array";
    if ($20ec22595b3da151$var$isDate(val)) return "date";
    if ($20ec22595b3da151$var$isError(val)) return "error";
    var constructorName = $20ec22595b3da151$var$ctorName(val);
    switch(constructorName){
        case "Symbol":
        case "Promise":
        case "WeakMap":
        case "WeakSet":
        case "Map":
        case "Set":
            return constructorName;
    }
    return Object.prototype.toString.call(val).slice(8, -1).toLowerCase().replace(/\s/g, "");
}
function $20ec22595b3da151$var$ctorName(val) {
    return typeof val.constructor === "function" ? val.constructor.name : null;
}
function $20ec22595b3da151$var$isError(val) {
    return val instanceof Error || typeof val.message === "string" && val.constructor && typeof val.constructor.stackTraceLimit === "number";
}
function $20ec22595b3da151$var$isDate(val) {
    if (val instanceof Date) return true;
    return typeof val.toDateString === "function" && typeof val.getDate === "function" && typeof val.setDate === "function";
}
function $20ec22595b3da151$var$kindOf(val) {
    var typeOfVal = typeof val === "undefined" ? "undefined" : (0, $bJtXW._)(val);
    return typeOfVal;
}
// src/createStore.ts
function $20ec22595b3da151$export$f51a9068ac82ea43(reducer, preloadedState, enhancer) {
    if (typeof reducer !== "function") throw new Error($20ec22595b3da151$var$formatProdErrorMessage(2));
    if (typeof preloadedState === "function" && typeof enhancer === "function" || typeof enhancer === "function" && typeof arguments[3] === "function") throw new Error($20ec22595b3da151$var$formatProdErrorMessage(0));
    if (typeof preloadedState === "function" && typeof enhancer === "undefined") {
        enhancer = preloadedState;
        preloadedState = void 0;
    }
    if (typeof enhancer !== "undefined") {
        if (typeof enhancer !== "function") throw new Error($20ec22595b3da151$var$formatProdErrorMessage(1));
        return enhancer($20ec22595b3da151$export$f51a9068ac82ea43)(reducer, preloadedState);
    }
    var currentReducer = reducer;
    var currentState = preloadedState;
    var currentListeners = /* @__PURE__ */ new Map();
    var nextListeners = currentListeners;
    var listenerIdCounter = 0;
    var isDispatching = false;
    function ensureCanMutateNextListeners() {
        if (nextListeners === currentListeners) {
            nextListeners = /* @__PURE__ */ new Map();
            currentListeners.forEach(function(listener, key) {
                nextListeners.set(key, listener);
            });
        }
    }
    function getState() {
        if (isDispatching) throw new Error($20ec22595b3da151$var$formatProdErrorMessage(3));
        return currentState;
    }
    function subscribe(listener) {
        if (typeof listener !== "function") throw new Error($20ec22595b3da151$var$formatProdErrorMessage(4));
        if (isDispatching) throw new Error($20ec22595b3da151$var$formatProdErrorMessage(5));
        var isSubscribed = true;
        ensureCanMutateNextListeners();
        var listenerId = listenerIdCounter++;
        nextListeners.set(listenerId, listener);
        return function unsubscribe() {
            if (!isSubscribed) return;
            if (isDispatching) throw new Error($20ec22595b3da151$var$formatProdErrorMessage(6));
            isSubscribed = false;
            ensureCanMutateNextListeners();
            nextListeners.delete(listenerId);
            currentListeners = null;
        };
    }
    function dispatch(action) {
        if (!$20ec22595b3da151$export$53b83ca8eaab0383(action)) throw new Error($20ec22595b3da151$var$formatProdErrorMessage(7));
        if (typeof action.type === "undefined") throw new Error($20ec22595b3da151$var$formatProdErrorMessage(8));
        if (typeof action.type !== "string") throw new Error($20ec22595b3da151$var$formatProdErrorMessage(17));
        if (isDispatching) throw new Error($20ec22595b3da151$var$formatProdErrorMessage(9));
        try {
            isDispatching = true;
            currentState = currentReducer(currentState, action);
        } finally{
            isDispatching = false;
        }
        var listeners = currentListeners = nextListeners;
        listeners.forEach(function(listener) {
            listener();
        });
        return action;
    }
    function replaceReducer(nextReducer) {
        if (typeof nextReducer !== "function") throw new Error($20ec22595b3da151$var$formatProdErrorMessage(10));
        currentReducer = nextReducer;
        dispatch({
            type: $20ec22595b3da151$export$4219e499db7ca678.REPLACE
        });
    }
    function observable() {
        var outerSubscribe = subscribe;
        return (0, $72osQ._)({
            /**
       * The minimal observable subscription method.
       * @param observer Any object that can be used as an observer.
       * The observer object should have a `next` method.
       * @returns An object with an `unsubscribe` method that can
       * be used to unsubscribe the observable from the store, and prevent further
       * emission of values from the observable.
       */ subscribe: function(observer) {
                if ((typeof observer === "undefined" ? "undefined" : (0, $bJtXW._)(observer)) !== "object" || observer === null) throw new Error($20ec22595b3da151$var$formatProdErrorMessage(11));
                function observeState() {
                    var observerAsObserver = observer;
                    if (observerAsObserver.next) observerAsObserver.next(getState());
                }
                observeState();
                var unsubscribe = outerSubscribe(observeState);
                return {
                    unsubscribe: unsubscribe
                };
            }
        }, $20ec22595b3da151$var$symbol_observable_default, function() {
            return this;
        });
    }
    dispatch({
        type: $20ec22595b3da151$export$4219e499db7ca678.INIT
    });
    var store = (0, $72osQ._)({
        dispatch: dispatch,
        subscribe: subscribe,
        getState: getState,
        replaceReducer: replaceReducer
    }, $20ec22595b3da151$var$symbol_observable_default, observable);
    return store;
}
function $20ec22595b3da151$export$8928921ea2d3b126(reducer, preloadedState, enhancer) {
    return $20ec22595b3da151$export$f51a9068ac82ea43(reducer, preloadedState, enhancer);
}
// src/utils/warning.ts
function $20ec22595b3da151$var$warning(message) {
    if (typeof console !== "undefined" && typeof console.error === "function") console.error(message);
    try {
        throw new Error(message);
    } catch (e) {}
}
// src/combineReducers.ts
function $20ec22595b3da151$var$getUnexpectedStateShapeWarningMessage(inputState, reducers, action, unexpectedKeyCache) {
    var reducerKeys = Object.keys(reducers);
    var argumentName = action && action.type === $20ec22595b3da151$export$4219e499db7ca678.INIT ? "preloadedState argument passed to createStore" : "previous state received by the reducer";
    if (reducerKeys.length === 0) return "Store does not have a valid reducer. Make sure the argument passed to combineReducers is an object whose values are reducers.";
    if (!$20ec22595b3da151$export$53b83ca8eaab0383(inputState)) return "The ".concat(argumentName, ' has unexpected type of "').concat($20ec22595b3da151$var$kindOf(inputState), '". Expected argument to be an object with the following keys: "').concat(reducerKeys.join('", "'), '"');
    var unexpectedKeys = Object.keys(inputState).filter(function(key) {
        return !reducers.hasOwnProperty(key) && !unexpectedKeyCache[key];
    });
    unexpectedKeys.forEach(function(key) {
        unexpectedKeyCache[key] = true;
    });
    if (action && action.type === $20ec22595b3da151$export$4219e499db7ca678.REPLACE) return;
    if (unexpectedKeys.length > 0) return "Unexpected ".concat(unexpectedKeys.length > 1 ? "keys" : "key", ' "').concat(unexpectedKeys.join('", "'), '" found in ').concat(argumentName, '. Expected to find one of the known reducer keys instead: "').concat(reducerKeys.join('", "'), '". Unexpected keys will be ignored.');
}
function $20ec22595b3da151$var$assertReducerShape(reducers) {
    Object.keys(reducers).forEach(function(key) {
        var reducer = reducers[key];
        var initialState = reducer(void 0, {
            type: $20ec22595b3da151$export$4219e499db7ca678.INIT
        });
        if (typeof initialState === "undefined") throw new Error($20ec22595b3da151$var$formatProdErrorMessage(12));
        if (typeof reducer(void 0, {
            type: $20ec22595b3da151$export$4219e499db7ca678.PROBE_UNKNOWN_ACTION()
        }) === "undefined") throw new Error($20ec22595b3da151$var$formatProdErrorMessage(13));
    });
}
function $20ec22595b3da151$export$66e4520cdb265d18(reducers) {
    var reducerKeys = Object.keys(reducers);
    var finalReducers = {};
    for(var i = 0; i < reducerKeys.length; i++){
        var key = reducerKeys[i];
        if (typeof reducers[key] === "function") finalReducers[key] = reducers[key];
    }
    var finalReducerKeys = Object.keys(finalReducers);
    var unexpectedKeyCache;
    var shapeAssertionError;
    try {
        $20ec22595b3da151$var$assertReducerShape(finalReducers);
    } catch (e) {
        shapeAssertionError = e;
    }
    return function combination() {
        var state = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, action = arguments.length > 1 ? arguments[1] : void 0;
        if (shapeAssertionError) throw shapeAssertionError;
        var hasChanged = false;
        var nextState = {};
        for(var i = 0; i < finalReducerKeys.length; i++){
            var key = finalReducerKeys[i];
            var reducer = finalReducers[key];
            var previousStateForKey = state[key];
            var nextStateForKey = reducer(previousStateForKey, action);
            if (typeof nextStateForKey === "undefined") {
                var actionType = action && action.type;
                throw new Error($20ec22595b3da151$var$formatProdErrorMessage(14));
            }
            nextState[key] = nextStateForKey;
            hasChanged = hasChanged || nextStateForKey !== previousStateForKey;
        }
        hasChanged = hasChanged || finalReducerKeys.length !== Object.keys(state).length;
        return hasChanged ? nextState : state;
    };
}
// src/bindActionCreators.ts
function $20ec22595b3da151$var$bindActionCreator(actionCreator, dispatch) {
    return function() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
            args[_key] = arguments[_key];
        }
        return dispatch(actionCreator.apply(this, args));
    };
}
function $20ec22595b3da151$export$aea084d96e84da92(actionCreators, dispatch) {
    if (typeof actionCreators === "function") return $20ec22595b3da151$var$bindActionCreator(actionCreators, dispatch);
    if ((typeof actionCreators === "undefined" ? "undefined" : (0, $bJtXW._)(actionCreators)) !== "object" || actionCreators === null) throw new Error($20ec22595b3da151$var$formatProdErrorMessage(16));
    var boundActionCreators = {};
    for(var key in actionCreators){
        var actionCreator = actionCreators[key];
        if (typeof actionCreator === "function") boundActionCreators[key] = $20ec22595b3da151$var$bindActionCreator(actionCreator, dispatch);
    }
    return boundActionCreators;
}
// src/compose.ts
function $20ec22595b3da151$export$f672e0b6f7222cd7() {
    for(var _len = arguments.length, funcs = new Array(_len), _key = 0; _key < _len; _key++){
        funcs[_key] = arguments[_key];
    }
    if (funcs.length === 0) return function(arg) {
        return arg;
    };
    if (funcs.length === 1) return funcs[0];
    return funcs.reduce(function(a, b) {
        return function() {
            for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
                args[_key] = arguments[_key];
            }
            return a(b.apply(void 0, (0, $2us1u._)(args)));
        };
    });
}
// src/applyMiddleware.ts
function $20ec22595b3da151$export$9ff26e0402cc7b7() {
    for(var _len = arguments.length, middlewares = new Array(_len), _key = 0; _key < _len; _key++){
        middlewares[_key] = arguments[_key];
    }
    return function(createStore2) {
        return function(reducer, preloadedState) {
            var store = createStore2(reducer, preloadedState);
            var dispatch = function() {
                throw new Error($20ec22595b3da151$var$formatProdErrorMessage(15));
            };
            var middlewareAPI = {
                getState: store.getState,
                dispatch: function(action) {
                    for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++){
                        args[_key - 1] = arguments[_key];
                    }
                    return dispatch.apply(void 0, [
                        action
                    ].concat((0, $2us1u._)(args)));
                }
            };
            var chain = middlewares.map(function(middleware) {
                return middleware(middlewareAPI);
            });
            dispatch = $20ec22595b3da151$export$f672e0b6f7222cd7.apply(void 0, (0, $2us1u._)(chain))(store.dispatch);
            return (0, $90FDw._)((0, $joFW3._)({}, store), {
                dispatch: dispatch
            });
        };
    };
}
// src/utils/isAction.ts
function $20ec22595b3da151$export$b956e38827fca970(action) {
    return $20ec22595b3da151$export$53b83ca8eaab0383(action) && "type" in action && typeof action.type === "string";
}



var $kK8g8 = parcelRequire("kK8g8");

var $grujF = parcelRequire("grujF");

var $dhMkv = parcelRequire("dhMkv");

var $2nwvT = parcelRequire("2nwvT");

var $2us1u = parcelRequire("2us1u");

var $bJtXW = parcelRequire("bJtXW");
var $b262cabcae0d8be6$var$__defProp = Object.defineProperty;
var $b262cabcae0d8be6$var$__getOwnPropSymbols = Object.getOwnPropertySymbols;
var $b262cabcae0d8be6$var$__hasOwnProp = Object.prototype.hasOwnProperty;
var $b262cabcae0d8be6$var$__propIsEnum = Object.prototype.propertyIsEnumerable;
var $b262cabcae0d8be6$var$__defNormalProp = function(obj, key, value) {
    return key in obj ? $b262cabcae0d8be6$var$__defProp(obj, key, {
        enumerable: true,
        configurable: true,
        writable: true,
        value: value
    }) : obj[key] = value;
};
var $b262cabcae0d8be6$var$__spreadValues = function(a, b) {
    for(var prop in b || (b = {}))if ($b262cabcae0d8be6$var$__hasOwnProp.call(b, prop)) $b262cabcae0d8be6$var$__defNormalProp(a, prop, b[prop]);
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    if ($b262cabcae0d8be6$var$__getOwnPropSymbols) try {
        for(var _iterator = $b262cabcae0d8be6$var$__getOwnPropSymbols(b)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var prop = _step.value;
            if ($b262cabcae0d8be6$var$__propIsEnum.call(b, prop)) $b262cabcae0d8be6$var$__defNormalProp(a, prop, b[prop]);
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    return a;
};
var $b262cabcae0d8be6$var$__publicField = function(obj, key, value) {
    $b262cabcae0d8be6$var$__defNormalProp(obj, (typeof key === "undefined" ? "undefined" : (0, $bJtXW._)(key)) !== "symbol" ? key + "" : key, value);
    return value;
};
// src/devModeChecks/identityFunctionCheck.ts
var $b262cabcae0d8be6$var$runIdentityFunctionCheck = function(resultFunc, inputSelectorsResults, outputSelectorResult) {
    if (inputSelectorsResults.length === 1 && inputSelectorsResults[0] === outputSelectorResult) {
        var isInputSameAsOutput = false;
        try {
            var emptyObject = {};
            if (resultFunc(emptyObject) === emptyObject) isInputSameAsOutput = true;
        } catch (e) {}
        if (isInputSameAsOutput) {
            var stack = void 0;
            try {
                throw new Error();
            } catch (e) {
                stack = e.stack;
            }
            console.warn("The result function returned its own inputs without modification. e.g\n`createSelector([state => state.todos], todos => todos)`\nThis could lead to inefficient memoization and unnecessary re-renders.\nEnsure transformation logic is in the result function, and extraction logic is in the input selectors.", {
                stack: stack
            });
        }
    }
};
// src/devModeChecks/inputStabilityCheck.ts
var $b262cabcae0d8be6$var$runInputStabilityCheck = function(inputSelectorResultsObject, options, inputSelectorArgs) {
    var memoize = options.memoize, memoizeOptions = options.memoizeOptions;
    var inputSelectorResults = inputSelectorResultsObject.inputSelectorResults, inputSelectorResultsCopy = inputSelectorResultsObject.inputSelectorResultsCopy;
    var createAnEmptyObject = memoize.apply(void 0, [
        function() {
            return {};
        }
    ].concat((0, $2us1u._)(memoizeOptions)));
    var areInputSelectorResultsEqual = createAnEmptyObject.apply(null, inputSelectorResults) === createAnEmptyObject.apply(null, inputSelectorResultsCopy);
    if (!areInputSelectorResultsEqual) {
        var stack = void 0;
        try {
            throw new Error();
        } catch (e) {
            stack = e.stack;
        }
        console.warn("An input selector returned a different result when passed same arguments.\nThis means your output selector will likely run more frequently than intended.\nAvoid returning a new reference inside your input selector, e.g.\n`createSelector([state => state.todos.map(todo => todo.id)], todoIds => todoIds.length)`", {
            arguments: inputSelectorArgs,
            firstInputs: inputSelectorResults,
            secondInputs: inputSelectorResultsCopy,
            stack: stack
        });
    }
};
// src/devModeChecks/setGlobalDevModeChecks.ts
var $b262cabcae0d8be6$var$globalDevModeChecks = {
    inputStabilityCheck: "once",
    identityFunctionCheck: "once"
};
var $b262cabcae0d8be6$export$1e290349de99e28c = function(devModeChecks) {
    Object.assign($b262cabcae0d8be6$var$globalDevModeChecks, devModeChecks);
};
// src/utils.ts
var $b262cabcae0d8be6$var$NOT_FOUND = /* @__PURE__ */ Symbol("NOT_FOUND");
function $b262cabcae0d8be6$var$assertIsFunction(func) {
    var errorMessage = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "expected a function, instead received ".concat(typeof func === "undefined" ? "undefined" : (0, $bJtXW._)(func));
    if (typeof func !== "function") throw new TypeError(errorMessage);
}
function $b262cabcae0d8be6$var$assertIsObject(object) {
    var errorMessage = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "expected an object, instead received ".concat(typeof object === "undefined" ? "undefined" : (0, $bJtXW._)(object));
    if ((typeof object === "undefined" ? "undefined" : (0, $bJtXW._)(object)) !== "object") throw new TypeError(errorMessage);
}
function $b262cabcae0d8be6$var$assertIsArrayOfFunctions(array) {
    var errorMessage = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "expected all items to be functions, instead received the following types: ";
    if (!array.every(function(item) {
        return typeof item === "function";
    })) {
        var itemTypes = array.map(function(item) {
            return typeof item === "function" ? "function ".concat(item.name || "unnamed", "()") : typeof item === "undefined" ? "undefined" : (0, $bJtXW._)(item);
        }).join(", ");
        throw new TypeError("".concat(errorMessage, "[").concat(itemTypes, "]"));
    }
}
var $b262cabcae0d8be6$var$ensureIsArray = function(item) {
    return Array.isArray(item) ? item : [
        item
    ];
};
function $b262cabcae0d8be6$var$getDependencies(createSelectorArgs) {
    var dependencies = Array.isArray(createSelectorArgs[0]) ? createSelectorArgs[0] : createSelectorArgs;
    $b262cabcae0d8be6$var$assertIsArrayOfFunctions(dependencies, "createSelector expects all input-selectors to be functions, but received the following types: ");
    return dependencies;
}
function $b262cabcae0d8be6$var$collectInputSelectorResults(dependencies, inputSelectorArgs) {
    var inputSelectorResults = [];
    var length = dependencies.length;
    for(var i = 0; i < length; i++)inputSelectorResults.push(dependencies[i].apply(null, inputSelectorArgs));
    return inputSelectorResults;
}
var $b262cabcae0d8be6$var$getDevModeChecksExecutionInfo = function(firstRun, devModeChecks) {
    var __spreadValues1 = $b262cabcae0d8be6$var$__spreadValues($b262cabcae0d8be6$var$__spreadValues({}, $b262cabcae0d8be6$var$globalDevModeChecks), devModeChecks), identityFunctionCheck = __spreadValues1.identityFunctionCheck, inputStabilityCheck = __spreadValues1.inputStabilityCheck;
    return {
        identityFunctionCheck: {
            shouldRun: identityFunctionCheck === "always" || identityFunctionCheck === "once" && firstRun,
            run: $b262cabcae0d8be6$var$runIdentityFunctionCheck
        },
        inputStabilityCheck: {
            shouldRun: inputStabilityCheck === "always" || inputStabilityCheck === "once" && firstRun,
            run: $b262cabcae0d8be6$var$runInputStabilityCheck
        }
    };
};
// src/autotrackMemoize/autotracking.ts
var $b262cabcae0d8be6$var$$REVISION = 0;
var $b262cabcae0d8be6$var$CURRENT_TRACKER = null;
var $b262cabcae0d8be6$var$Cell = /*#__PURE__*/ function() {
    "use strict";
    function Cell(initialValue) {
        var isEqual = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : $b262cabcae0d8be6$var$tripleEq;
        (0, $grujF._)(this, Cell);
        $b262cabcae0d8be6$var$__publicField(this, "revision", $b262cabcae0d8be6$var$$REVISION);
        $b262cabcae0d8be6$var$__publicField(this, "_value");
        $b262cabcae0d8be6$var$__publicField(this, "_lastValue");
        $b262cabcae0d8be6$var$__publicField(this, "_isEqual", $b262cabcae0d8be6$var$tripleEq);
        this._value = this._lastValue = initialValue;
        this._isEqual = isEqual;
    }
    (0, $dhMkv._)(Cell, [
        {
            key: "value",
            get: // Whenever a storage value is read, it'll add itself to the current tracker if
            // one exists, entangling its state with that cache.
            function get() {
                $b262cabcae0d8be6$var$CURRENT_TRACKER == null || $b262cabcae0d8be6$var$CURRENT_TRACKER.add(this);
                return this._value;
            },
            set: // Whenever a storage value is updated, we bump the global revision clock,
            // assign the revision for this storage to the new value, _and_ we schedule a
            // rerender. This is important, and it's what makes autotracking  _pull_
            // based. We don't actively tell the caches which depend on the storage that
            // anything has happened. Instead, we recompute the caches when needed.
            function set(newValue) {
                if (this.value === newValue) return;
                this._value = newValue;
                this.revision = ++$b262cabcae0d8be6$var$$REVISION;
            }
        }
    ]);
    return Cell;
}();
function $b262cabcae0d8be6$var$tripleEq(a, b) {
    return a === b;
}
var $b262cabcae0d8be6$var$TrackingCache = /*#__PURE__*/ function() {
    "use strict";
    function TrackingCache(fn) {
        (0, $grujF._)(this, TrackingCache);
        $b262cabcae0d8be6$var$__publicField(this, "_cachedValue");
        $b262cabcae0d8be6$var$__publicField(this, "_cachedRevision", -1);
        $b262cabcae0d8be6$var$__publicField(this, "_deps", []);
        $b262cabcae0d8be6$var$__publicField(this, "hits", 0);
        $b262cabcae0d8be6$var$__publicField(this, "fn");
        this.fn = fn;
    }
    (0, $dhMkv._)(TrackingCache, [
        {
            key: "clear",
            value: function clear() {
                this._cachedValue = void 0;
                this._cachedRevision = -1;
                this._deps = [];
                this.hits = 0;
            }
        },
        {
            key: "value",
            get: function get() {
                if (this.revision > this._cachedRevision) {
                    var fn = this.fn;
                    var currentTracker = /* @__PURE__ */ new Set();
                    var prevTracker = $b262cabcae0d8be6$var$CURRENT_TRACKER;
                    $b262cabcae0d8be6$var$CURRENT_TRACKER = currentTracker;
                    this._cachedValue = fn();
                    $b262cabcae0d8be6$var$CURRENT_TRACKER = prevTracker;
                    this.hits++;
                    this._deps = Array.from(currentTracker);
                    this._cachedRevision = this.revision;
                }
                $b262cabcae0d8be6$var$CURRENT_TRACKER == null || $b262cabcae0d8be6$var$CURRENT_TRACKER.add(this);
                return this._cachedValue;
            }
        },
        {
            key: "revision",
            get: function get() {
                var _Math;
                return (_Math = Math).max.apply(_Math, (0, $2us1u._)(this._deps.map(function(d) {
                    return d.revision;
                })).concat([
                    0
                ]));
            }
        }
    ]);
    return TrackingCache;
}();
function $b262cabcae0d8be6$var$getValue(cell) {
    if (!(cell instanceof $b262cabcae0d8be6$var$Cell)) console.warn("Not a valid cell! ", cell);
    return cell.value;
}
function $b262cabcae0d8be6$var$setValue(storage, value) {
    if (!(storage instanceof $b262cabcae0d8be6$var$Cell)) throw new TypeError("setValue must be passed a tracked store created with `createStorage`.");
    storage.value = storage._lastValue = value;
}
function $b262cabcae0d8be6$var$createCell(initialValue) {
    var isEqual = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : $b262cabcae0d8be6$var$tripleEq;
    return new $b262cabcae0d8be6$var$Cell(initialValue, isEqual);
}
function $b262cabcae0d8be6$var$createCache(fn) {
    $b262cabcae0d8be6$var$assertIsFunction(fn, "the first parameter to `createCache` must be a function");
    return new $b262cabcae0d8be6$var$TrackingCache(fn);
}
// src/autotrackMemoize/tracking.ts
var $b262cabcae0d8be6$var$neverEq = function(a, b) {
    return false;
};
function $b262cabcae0d8be6$var$createTag() {
    return $b262cabcae0d8be6$var$createCell(null, $b262cabcae0d8be6$var$neverEq);
}
function $b262cabcae0d8be6$var$dirtyTag(tag, value) {
    $b262cabcae0d8be6$var$setValue(tag, value);
}
var $b262cabcae0d8be6$var$consumeCollection = function(node) {
    var tag = node.collectionTag;
    if (tag === null) tag = node.collectionTag = $b262cabcae0d8be6$var$createTag();
    $b262cabcae0d8be6$var$getValue(tag);
};
var $b262cabcae0d8be6$var$dirtyCollection = function(node) {
    var tag = node.collectionTag;
    if (tag !== null) $b262cabcae0d8be6$var$dirtyTag(tag, null);
};
// src/autotrackMemoize/proxy.ts
var $b262cabcae0d8be6$var$REDUX_PROXY_LABEL = Symbol();
var $b262cabcae0d8be6$var$nextId = 0;
var $b262cabcae0d8be6$var$proto = Object.getPrototypeOf({});
var $b262cabcae0d8be6$var$ObjectTreeNode = function ObjectTreeNode(value) {
    "use strict";
    (0, $grujF._)(this, ObjectTreeNode);
    this.value = value;
    $b262cabcae0d8be6$var$__publicField(this, "proxy", new Proxy(this, $b262cabcae0d8be6$var$objectProxyHandler));
    $b262cabcae0d8be6$var$__publicField(this, "tag", $b262cabcae0d8be6$var$createTag());
    $b262cabcae0d8be6$var$__publicField(this, "tags", {});
    $b262cabcae0d8be6$var$__publicField(this, "children", {});
    $b262cabcae0d8be6$var$__publicField(this, "collectionTag", null);
    $b262cabcae0d8be6$var$__publicField(this, "id", $b262cabcae0d8be6$var$nextId++);
    this.value = value;
    this.tag.value = value;
};
var $b262cabcae0d8be6$var$objectProxyHandler = {
    get: function(node, key) {
        function calculateResult() {
            var value = node.value;
            var childValue = Reflect.get(value, key);
            if ((typeof key === "undefined" ? "undefined" : (0, $bJtXW._)(key)) === "symbol") return childValue;
            if (key in $b262cabcae0d8be6$var$proto) return childValue;
            if ((typeof childValue === "undefined" ? "undefined" : (0, $bJtXW._)(childValue)) === "object" && childValue !== null) {
                var childNode = node.children[key];
                if (childNode === void 0) childNode = node.children[key] = $b262cabcae0d8be6$var$createNode(childValue);
                if (childNode.tag) $b262cabcae0d8be6$var$getValue(childNode.tag);
                return childNode.proxy;
            } else {
                var tag = node.tags[key];
                if (tag === void 0) {
                    tag = node.tags[key] = $b262cabcae0d8be6$var$createTag();
                    tag.value = childValue;
                }
                $b262cabcae0d8be6$var$getValue(tag);
                return childValue;
            }
        }
        var res = calculateResult();
        return res;
    },
    ownKeys: function(node) {
        $b262cabcae0d8be6$var$consumeCollection(node);
        return Reflect.ownKeys(node.value);
    },
    getOwnPropertyDescriptor: function(node, prop) {
        return Reflect.getOwnPropertyDescriptor(node.value, prop);
    },
    has: function(node, prop) {
        return Reflect.has(node.value, prop);
    }
};
var $b262cabcae0d8be6$var$ArrayTreeNode = function ArrayTreeNode(value) {
    "use strict";
    (0, $grujF._)(this, ArrayTreeNode);
    this.value = value;
    $b262cabcae0d8be6$var$__publicField(this, "proxy", new Proxy([
        this
    ], $b262cabcae0d8be6$var$arrayProxyHandler));
    $b262cabcae0d8be6$var$__publicField(this, "tag", $b262cabcae0d8be6$var$createTag());
    $b262cabcae0d8be6$var$__publicField(this, "tags", {});
    $b262cabcae0d8be6$var$__publicField(this, "children", {});
    $b262cabcae0d8be6$var$__publicField(this, "collectionTag", null);
    $b262cabcae0d8be6$var$__publicField(this, "id", $b262cabcae0d8be6$var$nextId++);
    this.value = value;
    this.tag.value = value;
};
var $b262cabcae0d8be6$var$arrayProxyHandler = {
    get: function(param, key) {
        var _param = (0, $2nwvT._)(param, 1), node = _param[0];
        if (key === "length") $b262cabcae0d8be6$var$consumeCollection(node);
        return $b262cabcae0d8be6$var$objectProxyHandler.get(node, key);
    },
    ownKeys: function(param) {
        var _param = (0, $2nwvT._)(param, 1), node = _param[0];
        return $b262cabcae0d8be6$var$objectProxyHandler.ownKeys(node);
    },
    getOwnPropertyDescriptor: function(param, prop) {
        var _param = (0, $2nwvT._)(param, 1), node = _param[0];
        return $b262cabcae0d8be6$var$objectProxyHandler.getOwnPropertyDescriptor(node, prop);
    },
    has: function(param, prop) {
        var _param = (0, $2nwvT._)(param, 1), node = _param[0];
        return $b262cabcae0d8be6$var$objectProxyHandler.has(node, prop);
    }
};
function $b262cabcae0d8be6$var$createNode(value) {
    if (Array.isArray(value)) return new $b262cabcae0d8be6$var$ArrayTreeNode(value);
    return new $b262cabcae0d8be6$var$ObjectTreeNode(value);
}
function $b262cabcae0d8be6$var$updateNode(node, newValue) {
    var value = node.value, tags = node.tags, children = node.children;
    node.value = newValue;
    if (Array.isArray(value) && Array.isArray(newValue) && value.length !== newValue.length) $b262cabcae0d8be6$var$dirtyCollection(node);
    else if (value !== newValue) {
        var oldKeysSize = 0;
        var newKeysSize = 0;
        var anyKeysAdded = false;
        for(var _key in value)oldKeysSize++;
        for(var key in newValue){
            newKeysSize++;
            if (!(key in value)) {
                anyKeysAdded = true;
                break;
            }
        }
        var isDifferent = anyKeysAdded || oldKeysSize !== newKeysSize;
        if (isDifferent) $b262cabcae0d8be6$var$dirtyCollection(node);
    }
    for(var key1 in tags){
        var childValue = value[key1];
        var newChildValue = newValue[key1];
        if (childValue !== newChildValue) {
            $b262cabcae0d8be6$var$dirtyCollection(node);
            $b262cabcae0d8be6$var$dirtyTag(tags[key1], newChildValue);
        }
        if ((typeof newChildValue === "undefined" ? "undefined" : (0, $bJtXW._)(newChildValue)) === "object" && newChildValue !== null) delete tags[key1];
    }
    for(var key2 in children){
        var childNode = children[key2];
        var newChildValue1 = newValue[key2];
        var childValue1 = childNode.value;
        if (childValue1 === newChildValue1) continue;
        else if ((typeof newChildValue1 === "undefined" ? "undefined" : (0, $bJtXW._)(newChildValue1)) === "object" && newChildValue1 !== null) $b262cabcae0d8be6$var$updateNode(childNode, newChildValue1);
        else {
            $b262cabcae0d8be6$var$deleteNode(childNode);
            delete children[key2];
        }
    }
}
function $b262cabcae0d8be6$var$deleteNode(node) {
    if (node.tag) $b262cabcae0d8be6$var$dirtyTag(node.tag, null);
    $b262cabcae0d8be6$var$dirtyCollection(node);
    for(var key in node.tags)$b262cabcae0d8be6$var$dirtyTag(node.tags[key], null);
    for(var key1 in node.children)$b262cabcae0d8be6$var$deleteNode(node.children[key1]);
}
// src/lruMemoize.ts
function $b262cabcae0d8be6$var$createSingletonCache(equals) {
    var entry;
    return {
        get: function(key) {
            if (entry && equals(entry.key, key)) return entry.value;
            return $b262cabcae0d8be6$var$NOT_FOUND;
        },
        put: function(key, value) {
            entry = {
                key: key,
                value: value
            };
        },
        getEntries: function() {
            return entry ? [
                entry
            ] : [];
        },
        clear: function() {
            entry = void 0;
        }
    };
}
function $b262cabcae0d8be6$var$createLruCache(maxSize, equals) {
    var entries = [];
    function get(key) {
        var cacheIndex = entries.findIndex(function(entry) {
            return equals(key, entry.key);
        });
        if (cacheIndex > -1) {
            var entry = entries[cacheIndex];
            if (cacheIndex > 0) {
                entries.splice(cacheIndex, 1);
                entries.unshift(entry);
            }
            return entry.value;
        }
        return $b262cabcae0d8be6$var$NOT_FOUND;
    }
    function put(key, value) {
        if (get(key) === $b262cabcae0d8be6$var$NOT_FOUND) {
            entries.unshift({
                key: key,
                value: value
            });
            if (entries.length > maxSize) entries.pop();
        }
    }
    function getEntries() {
        return entries;
    }
    function clear() {
        entries = [];
    }
    return {
        get: get,
        put: put,
        getEntries: getEntries,
        clear: clear
    };
}
var $b262cabcae0d8be6$export$3f025202a230c6dd = function(a, b) {
    return a === b;
};
function $b262cabcae0d8be6$var$createCacheKeyComparator(equalityCheck) {
    return function areArgumentsShallowlyEqual(prev, next) {
        if (prev === null || next === null || prev.length !== next.length) return false;
        var length = prev.length;
        for(var i = 0; i < length; i++){
            if (!equalityCheck(prev[i], next[i])) return false;
        }
        return true;
    };
}
function $b262cabcae0d8be6$export$d8ead1d92249919b(func, equalityCheckOrOptions) {
    var providedOptions = (typeof equalityCheckOrOptions === "undefined" ? "undefined" : (0, $bJtXW._)(equalityCheckOrOptions)) === "object" ? equalityCheckOrOptions : {
        equalityCheck: equalityCheckOrOptions
    };
    var _providedOptions_equalityCheck = providedOptions.equalityCheck, equalityCheck = _providedOptions_equalityCheck === void 0 ? $b262cabcae0d8be6$export$3f025202a230c6dd : _providedOptions_equalityCheck, _providedOptions_maxSize = providedOptions.maxSize, maxSize = _providedOptions_maxSize === void 0 ? 1 : _providedOptions_maxSize, resultEqualityCheck = providedOptions.resultEqualityCheck;
    var comparator = $b262cabcae0d8be6$var$createCacheKeyComparator(equalityCheck);
    var resultsCount = 0;
    var cache = maxSize <= 1 ? $b262cabcae0d8be6$var$createSingletonCache(comparator) : $b262cabcae0d8be6$var$createLruCache(maxSize, comparator);
    function memoized() {
        var value = cache.get(arguments);
        if (value === $b262cabcae0d8be6$var$NOT_FOUND) {
            value = func.apply(null, arguments);
            resultsCount++;
            if (resultEqualityCheck) {
                var entries = cache.getEntries();
                var matchingEntry = entries.find(function(entry) {
                    return resultEqualityCheck(entry.value, value);
                });
                if (matchingEntry) {
                    value = matchingEntry.value;
                    resultsCount !== 0 && resultsCount--;
                }
            }
            cache.put(arguments, value);
        }
        return value;
    }
    memoized.clearCache = function() {
        cache.clear();
        memoized.resetResultsCount();
    };
    memoized.resultsCount = function() {
        return resultsCount;
    };
    memoized.resetResultsCount = function() {
        resultsCount = 0;
    };
    return memoized;
}
// src/autotrackMemoize/autotrackMemoize.ts
function $b262cabcae0d8be6$export$c8f9cf88d9fdee55(func) {
    var node = $b262cabcae0d8be6$var$createNode([]);
    var lastArgs = null;
    var shallowEqual = $b262cabcae0d8be6$var$createCacheKeyComparator($b262cabcae0d8be6$export$3f025202a230c6dd);
    var cache = $b262cabcae0d8be6$var$createCache(function() {
        var res = func.apply(null, node.proxy);
        return res;
    });
    function memoized() {
        if (!shallowEqual(lastArgs, arguments)) {
            $b262cabcae0d8be6$var$updateNode(node, arguments);
            lastArgs = arguments;
        }
        return cache.value;
    }
    memoized.clearCache = function() {
        return cache.clear();
    };
    return memoized;
}
// src/weakMapMemoize.ts
var $b262cabcae0d8be6$var$StrongRef = /*#__PURE__*/ function() {
    "use strict";
    function StrongRef(value) {
        (0, $grujF._)(this, StrongRef);
        this.value = value;
    }
    (0, $dhMkv._)(StrongRef, [
        {
            key: "deref",
            value: function deref() {
                return this.value;
            }
        }
    ]);
    return StrongRef;
}();
var $b262cabcae0d8be6$var$Ref = typeof WeakRef !== "undefined" ? WeakRef : $b262cabcae0d8be6$var$StrongRef;
var $b262cabcae0d8be6$var$UNTERMINATED = 0;
var $b262cabcae0d8be6$var$TERMINATED = 1;
function $b262cabcae0d8be6$var$createCacheNode() {
    return {
        s: $b262cabcae0d8be6$var$UNTERMINATED,
        v: void 0,
        o: null,
        p: null
    };
}
function $b262cabcae0d8be6$export$8402dc26d96f6902(func) {
    var options = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    var fnNode = $b262cabcae0d8be6$var$createCacheNode();
    var resultEqualityCheck = options.resultEqualityCheck;
    var lastResult;
    var resultsCount = 0;
    function memoized() {
        var _a, _b;
        var cacheNode = fnNode;
        var length = arguments.length;
        for(var i = 0, l = length; i < l; i++){
            var arg = arguments[i];
            if (typeof arg === "function" || (typeof arg === "undefined" ? "undefined" : (0, $bJtXW._)(arg)) === "object" && arg !== null) {
                var objectCache = cacheNode.o;
                if (objectCache === null) cacheNode.o = objectCache = /* @__PURE__ */ new WeakMap();
                var objectNode = objectCache.get(arg);
                if (objectNode === void 0) {
                    cacheNode = $b262cabcae0d8be6$var$createCacheNode();
                    objectCache.set(arg, cacheNode);
                } else cacheNode = objectNode;
            } else {
                var primitiveCache = cacheNode.p;
                if (primitiveCache === null) cacheNode.p = primitiveCache = /* @__PURE__ */ new Map();
                var primitiveNode = primitiveCache.get(arg);
                if (primitiveNode === void 0) {
                    cacheNode = $b262cabcae0d8be6$var$createCacheNode();
                    primitiveCache.set(arg, cacheNode);
                } else cacheNode = primitiveNode;
            }
        }
        var terminatedNode = cacheNode;
        var result;
        if (cacheNode.s === $b262cabcae0d8be6$var$TERMINATED) result = cacheNode.v;
        else {
            result = func.apply(null, arguments);
            resultsCount++;
            if (resultEqualityCheck) {
                var lastResultValue = (_b = (_a = lastResult == null ? void 0 : lastResult.deref) == null ? void 0 : _a.call(lastResult)) != null ? _b : lastResult;
                if (lastResultValue != null && resultEqualityCheck(lastResultValue, result)) {
                    result = lastResultValue;
                    resultsCount !== 0 && resultsCount--;
                }
                var needsWeakRef = (typeof result === "undefined" ? "undefined" : (0, $bJtXW._)(result)) === "object" && result !== null || typeof result === "function";
                lastResult = needsWeakRef ? new $b262cabcae0d8be6$var$Ref(result) : result;
            }
        }
        terminatedNode.s = $b262cabcae0d8be6$var$TERMINATED;
        terminatedNode.v = result;
        return result;
    }
    memoized.clearCache = function() {
        fnNode = $b262cabcae0d8be6$var$createCacheNode();
        memoized.resetResultsCount();
    };
    memoized.resultsCount = function() {
        return resultsCount;
    };
    memoized.resetResultsCount = function() {
        resultsCount = 0;
    };
    return memoized;
}
// src/createSelectorCreator.ts
function $b262cabcae0d8be6$export$5943f4447f6ef248(memoizeOrOptions) {
    for(var _len = arguments.length, memoizeOptionsFromArgs = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++){
        memoizeOptionsFromArgs[_key - 1] = arguments[_key];
    }
    var createSelectorCreatorOptions = typeof memoizeOrOptions === "function" ? {
        memoize: memoizeOrOptions,
        memoizeOptions: memoizeOptionsFromArgs
    } : memoizeOrOptions;
    var createSelector2 = function() {
        for(var _len = arguments.length, createSelectorArgs = new Array(_len), _key = 0; _key < _len; _key++){
            createSelectorArgs[_key] = arguments[_key];
        }
        var recomputations = 0;
        var dependencyRecomputations = 0;
        var lastResult;
        var directlyPassedOptions = {};
        var resultFunc = createSelectorArgs.pop();
        if ((typeof resultFunc === "undefined" ? "undefined" : (0, $bJtXW._)(resultFunc)) === "object") {
            directlyPassedOptions = resultFunc;
            resultFunc = createSelectorArgs.pop();
        }
        $b262cabcae0d8be6$var$assertIsFunction(resultFunc, "createSelector expects an output function after the inputs, but received: [".concat(typeof resultFunc === "undefined" ? "undefined" : (0, $bJtXW._)(resultFunc), "]"));
        var combinedOptions = $b262cabcae0d8be6$var$__spreadValues($b262cabcae0d8be6$var$__spreadValues({}, createSelectorCreatorOptions), directlyPassedOptions);
        var memoize = combinedOptions.memoize, _combinedOptions_memoizeOptions = combinedOptions.memoizeOptions, memoizeOptions = _combinedOptions_memoizeOptions === void 0 ? [] : _combinedOptions_memoizeOptions, _combinedOptions_argsMemoize = combinedOptions.argsMemoize, argsMemoize = _combinedOptions_argsMemoize === void 0 ? $b262cabcae0d8be6$export$8402dc26d96f6902 : _combinedOptions_argsMemoize, _combinedOptions_argsMemoizeOptions = combinedOptions.argsMemoizeOptions, argsMemoizeOptions = _combinedOptions_argsMemoizeOptions === void 0 ? [] : _combinedOptions_argsMemoizeOptions, _combinedOptions_devModeChecks = combinedOptions.devModeChecks, devModeChecks = _combinedOptions_devModeChecks === void 0 ? {} : _combinedOptions_devModeChecks;
        var finalMemoizeOptions = $b262cabcae0d8be6$var$ensureIsArray(memoizeOptions);
        var finalArgsMemoizeOptions = $b262cabcae0d8be6$var$ensureIsArray(argsMemoizeOptions);
        var dependencies = $b262cabcae0d8be6$var$getDependencies(createSelectorArgs);
        var memoizedResultFunc = memoize.apply(void 0, [
            function recomputationWrapper() {
                recomputations++;
                return resultFunc.apply(null, arguments);
            }
        ].concat((0, $2us1u._)(finalMemoizeOptions)));
        var firstRun = true;
        var selector = argsMemoize.apply(void 0, [
            function dependenciesChecker() {
                dependencyRecomputations++;
                var inputSelectorResults = $b262cabcae0d8be6$var$collectInputSelectorResults(dependencies, arguments);
                lastResult = memoizedResultFunc.apply(null, inputSelectorResults);
                return lastResult;
            }
        ].concat((0, $2us1u._)(finalArgsMemoizeOptions)));
        return Object.assign(selector, {
            resultFunc: resultFunc,
            memoizedResultFunc: memoizedResultFunc,
            dependencies: dependencies,
            dependencyRecomputations: function() {
                return dependencyRecomputations;
            },
            resetDependencyRecomputations: function() {
                dependencyRecomputations = 0;
            },
            lastResult: function() {
                return lastResult;
            },
            recomputations: function() {
                return recomputations;
            },
            resetRecomputations: function() {
                recomputations = 0;
            },
            memoize: memoize,
            argsMemoize: argsMemoize
        });
    };
    Object.assign(createSelector2, {
        withTypes: function() {
            return createSelector2;
        }
    });
    return createSelector2;
}
var $b262cabcae0d8be6$export$595d22ed68ca2841 = /* @__PURE__ */ $b262cabcae0d8be6$export$5943f4447f6ef248($b262cabcae0d8be6$export$8402dc26d96f6902);
// src/createStructuredSelector.ts
var $b262cabcae0d8be6$export$75979cfcd91bf38f = Object.assign(function(inputSelectorsObject) {
    var selectorCreator = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : $b262cabcae0d8be6$export$595d22ed68ca2841;
    $b262cabcae0d8be6$var$assertIsObject(inputSelectorsObject, "createStructuredSelector expects first argument to be an object where each property is a selector, instead received a ".concat(typeof inputSelectorsObject === "undefined" ? "undefined" : (0, $bJtXW._)(inputSelectorsObject)));
    var inputSelectorKeys = Object.keys(inputSelectorsObject);
    var dependencies = inputSelectorKeys.map(function(key) {
        return inputSelectorsObject[key];
    });
    var structuredSelector = selectorCreator(dependencies, function() {
        for(var _len = arguments.length, inputSelectorResults = new Array(_len), _key = 0; _key < _len; _key++){
            inputSelectorResults[_key] = arguments[_key];
        }
        return inputSelectorResults.reduce(function(composition, value, index) {
            composition[inputSelectorKeys[index]] = value;
            return composition;
        }, {});
    });
    return structuredSelector;
}, {
    withTypes: function() {
        return $b262cabcae0d8be6$export$75979cfcd91bf38f;
    }
});


// src/index.ts
function $21ccc86701ec53ef$var$createThunkMiddleware(extraArgument) {
    var middleware = function(param) {
        var dispatch = param.dispatch, getState = param.getState;
        return function(next) {
            return function(action) {
                if (typeof action === "function") return action(dispatch, getState, extraArgument);
                return next(action);
            };
        };
    };
    return middleware;
}
var $21ccc86701ec53ef$export$dd164f5517779f15 = $21ccc86701ec53ef$var$createThunkMiddleware();
var $21ccc86701ec53ef$export$16d06542a1949d9e = $21ccc86701ec53ef$var$createThunkMiddleware;


var $ca04af99794d5fdc$var$__defProp = Object.defineProperty;
var $ca04af99794d5fdc$var$__defProps = Object.defineProperties;
var $ca04af99794d5fdc$var$__getOwnPropDescs = Object.getOwnPropertyDescriptors;
var $ca04af99794d5fdc$var$__getOwnPropSymbols = Object.getOwnPropertySymbols;
var $ca04af99794d5fdc$var$__hasOwnProp = Object.prototype.hasOwnProperty;
var $ca04af99794d5fdc$var$__propIsEnum = Object.prototype.propertyIsEnumerable;
var $ca04af99794d5fdc$var$__defNormalProp = function(obj, key, value) {
    return key in obj ? $ca04af99794d5fdc$var$__defProp(obj, key, {
        enumerable: true,
        configurable: true,
        writable: true,
        value: value
    }) : obj[key] = value;
};
var $ca04af99794d5fdc$var$__spreadValues = function(a, b) {
    for(var prop in b || (b = {}))if ($ca04af99794d5fdc$var$__hasOwnProp.call(b, prop)) $ca04af99794d5fdc$var$__defNormalProp(a, prop, b[prop]);
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    if ($ca04af99794d5fdc$var$__getOwnPropSymbols) try {
        for(var _iterator = $ca04af99794d5fdc$var$__getOwnPropSymbols(b)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var prop = _step.value;
            if ($ca04af99794d5fdc$var$__propIsEnum.call(b, prop)) $ca04af99794d5fdc$var$__defNormalProp(a, prop, b[prop]);
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    return a;
};
var $ca04af99794d5fdc$var$__spreadProps = function(a, b) {
    return $ca04af99794d5fdc$var$__defProps(a, $ca04af99794d5fdc$var$__getOwnPropDescs(b));
};
var $ca04af99794d5fdc$var$__objRest = function(source, exclude) {
    var target = {};
    for(var prop in source)if ($ca04af99794d5fdc$var$__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0) target[prop] = source[prop];
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    if (source != null && $ca04af99794d5fdc$var$__getOwnPropSymbols) try {
        for(var _iterator = $ca04af99794d5fdc$var$__getOwnPropSymbols(source)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var prop = _step.value;
            if (exclude.indexOf(prop) < 0 && $ca04af99794d5fdc$var$__propIsEnum.call(source, prop)) target[prop] = source[prop];
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    return target;
};
var $ca04af99794d5fdc$var$__publicField = function(obj, key, value) {
    return $ca04af99794d5fdc$var$__defNormalProp(obj, (typeof key === "undefined" ? "undefined" : (0, $bJtXW._)(key)) !== "symbol" ? key + "" : key, value);
};
// src/createDraftSafeSelector.ts
var $ca04af99794d5fdc$export$aab6de9e3dbb1473 = function() {
    for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
        args[_key] = arguments[_key];
    }
    var createSelector2 = (0, $b262cabcae0d8be6$export$5943f4447f6ef248).apply(void 0, (0, $2us1u._)(args));
    var createDraftSafeSelector2 = Object.assign(function() {
        for(var _len = arguments.length, args2 = new Array(_len), _key = 0; _key < _len; _key++){
            args2[_key] = arguments[_key];
        }
        var selector = createSelector2.apply(void 0, (0, $2us1u._)(args2));
        var wrappedSelector = function(value) {
            for(var _len = arguments.length, rest = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++){
                rest[_key - 1] = arguments[_key];
            }
            return selector.apply(void 0, [
                (0, $kK8g8.isDraft)(value) ? (0, $kK8g8.current)(value) : value
            ].concat((0, $2us1u._)(rest)));
        };
        Object.assign(wrappedSelector, selector);
        return wrappedSelector;
    }, {
        withTypes: function() {
            return createDraftSafeSelector2;
        }
    });
    return createDraftSafeSelector2;
};
var $ca04af99794d5fdc$export$a5d3c27355e35910 = /* @__PURE__ */ $ca04af99794d5fdc$export$aab6de9e3dbb1473((0, $b262cabcae0d8be6$export$8402dc26d96f6902));
// src/devtoolsExtension.ts
var $ca04af99794d5fdc$var$composeWithDevTools = typeof window !== "undefined" && window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ ? window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ : function composeWithDevTools() {
    if (arguments.length === 0) return void 0;
    if ((0, $bJtXW._)(arguments[0]) === "object") return 0, $20ec22595b3da151$export$f672e0b6f7222cd7;
    return (0, $20ec22595b3da151$export$f672e0b6f7222cd7).apply(null, arguments);
};
var $ca04af99794d5fdc$var$devToolsEnhancer = typeof window !== "undefined" && window.__REDUX_DEVTOOLS_EXTENSION__ ? window.__REDUX_DEVTOOLS_EXTENSION__ : function devToolsEnhancer() {
    return function(noop3) {
        return noop3;
    };
};
// src/tsHelpers.ts
var $ca04af99794d5fdc$var$hasMatchFunction = function(v) {
    return v && typeof v.match === "function";
};
// src/createAction.ts
function $ca04af99794d5fdc$export$309c7a02b0b0bc62(type, prepareAction) {
    function actionCreator() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
            args[_key] = arguments[_key];
        }
        if (prepareAction) {
            var prepared = prepareAction.apply(void 0, (0, $2us1u._)(args));
            if (!prepared) throw new Error($ca04af99794d5fdc$export$378fa86b259c0280(0));
            return $ca04af99794d5fdc$var$__spreadValues($ca04af99794d5fdc$var$__spreadValues({
                type: type,
                payload: prepared.payload
            }, "meta" in prepared && {
                meta: prepared.meta
            }), "error" in prepared && {
                error: prepared.error
            });
        }
        return {
            type: type,
            payload: args[0]
        };
    }
    actionCreator.toString = function() {
        return "".concat(type);
    };
    actionCreator.type = type;
    actionCreator.match = function(action) {
        return (0, $20ec22595b3da151$export$b956e38827fca970)(action) && action.type === type;
    };
    return actionCreator;
}
function $ca04af99794d5fdc$export$4e5cad2c7f795b8f(action) {
    return typeof action === "function" && "type" in action && // hasMatchFunction only wants Matchers but I don't see the point in rewriting it
    $ca04af99794d5fdc$var$hasMatchFunction(action);
}
function $ca04af99794d5fdc$export$ebd532f9034651f3(action) {
    return (0, $20ec22595b3da151$export$b956e38827fca970)(action) && Object.keys(action).every($ca04af99794d5fdc$var$isValidKey);
}
function $ca04af99794d5fdc$var$isValidKey(key) {
    return [
        "type",
        "payload",
        "error",
        "meta"
    ].indexOf(key) > -1;
}
// src/actionCreatorInvariantMiddleware.ts
function $ca04af99794d5fdc$var$getMessage(type) {
    var splitType = type ? "".concat(type).split("/") : [];
    var actionName = splitType[splitType.length - 1] || "actionCreator";
    return 'Detected an action creator with type "'.concat(type || "unknown", "\" being dispatched. \nMake sure you're calling the action creator before dispatching, i.e. `dispatch(").concat(actionName, "())` instead of `dispatch(").concat(actionName, ")`. This is necessary even if the action has no payload.");
}
function $ca04af99794d5fdc$export$6a1fcb4ceef578f() {
    var options = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    var next, action;
    return function() {
        return function(next) {
            return function(action) {
                return next(action);
            };
        };
    };
}
// src/utils.ts
function $ca04af99794d5fdc$var$getTimeMeasureUtils(maxDelay, fnName) {
    var elapsed = 0;
    return {
        measureTime: function(fn) {
            var started = Date.now();
            try {
                return fn();
            } finally{
                var finished = Date.now();
                elapsed += finished - started;
            }
        },
        warnIfExceeded: function() {
            if (elapsed > maxDelay) console.warn("".concat(fnName, " took ").concat(elapsed, "ms, which is more than the warning threshold of ").concat(maxDelay, "ms. \nIf your state or actions are very large, you may want to disable the middleware as it might cause too much of a slowdown in development mode. See https://redux-toolkit.js.org/api/getDefaultMiddleware for instructions.\nIt is disabled in production builds, so you don't need to worry about that."));
        }
    };
}
var $ca04af99794d5fdc$export$1908877435b1d5e9 = /*#__PURE__*/ function(Array1) {
    "use strict";
    (0, $j6Mzi._)(_Tuple, Array1);
    function _Tuple() {
        for(var _len = arguments.length, items = new Array(_len), _key = 0; _key < _len; _key++){
            items[_key] = arguments[_key];
        }
        (0, $grujF._)(this, _Tuple);
        var _this;
        _this = (0, $f3Okx._)(this, _Tuple, (0, $2us1u._)(items));
        Object.setPrototypeOf(_this, _Tuple.prototype);
        return _this;
    }
    (0, $dhMkv._)(_Tuple, [
        {
            key: "concat",
            value: function concat() {
                for(var _len = arguments.length, arr = new Array(_len), _key = 0; _key < _len; _key++){
                    arr[_key] = arguments[_key];
                }
                return (0, $bxomo._)((0, $gyGuQ._)(_Tuple.prototype), "concat", this).apply(this, arr);
            }
        },
        {
            key: "prepend",
            value: function prepend() {
                for(var _len = arguments.length, arr = new Array(_len), _key = 0; _key < _len; _key++){
                    arr[_key] = arguments[_key];
                }
                if (arr.length === 1 && Array.isArray(arr[0])) return (0, $8wAe0._)(_Tuple, (0, $2us1u._)(arr[0].concat(this)));
                return (0, $8wAe0._)(_Tuple, (0, $2us1u._)(arr.concat(this)));
            }
        }
    ], [
        {
            key: Symbol.species,
            get: function get() {
                return _Tuple;
            }
        }
    ]);
    return _Tuple;
}((0, $1EZOw._)(Array));
function $ca04af99794d5fdc$var$freezeDraftable(val) {
    return (0, $kK8g8.isDraftable)(val) ? (0, $kK8g8.produce)(val, function() {}) : val;
}
function $ca04af99794d5fdc$var$getOrInsertComputed(map, key, compute) {
    if (map.has(key)) return map.get(key);
    return map.set(key, compute(key)).get(key);
}
// src/immutableStateInvariantMiddleware.ts
function $ca04af99794d5fdc$export$9021b2733a0028a3(value) {
    return (typeof value === "undefined" ? "undefined" : (0, $bJtXW._)(value)) !== "object" || value == null || Object.isFrozen(value);
}
function $ca04af99794d5fdc$var$trackForMutations(isImmutable, ignoredPaths, obj) {
    var trackedProperties = $ca04af99794d5fdc$var$trackProperties(isImmutable, ignoredPaths, obj);
    return {
        detectMutations: function() {
            return $ca04af99794d5fdc$var$detectMutations(isImmutable, ignoredPaths, trackedProperties, obj);
        }
    };
}
function $ca04af99794d5fdc$var$trackProperties(isImmutable) {
    var ignoredPaths = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : [], obj = arguments.length > 2 ? arguments[2] : void 0, path = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : "", checkedObjects = arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : /* @__PURE__ */ new Set();
    var tracked = {
        value: obj
    };
    if (!isImmutable(obj) && !checkedObjects.has(obj)) {
        var _loop = function(key) {
            var nestedPath = path ? path + "." + key : key;
            if (hasIgnoredPaths) {
                var hasMatches = ignoredPaths.some(function(ignored) {
                    if (ignored instanceof RegExp) return ignored.test(nestedPath);
                    return nestedPath === ignored;
                });
                if (hasMatches) return "continue";
            }
            tracked.children[key] = $ca04af99794d5fdc$var$trackProperties(isImmutable, ignoredPaths, obj[key], nestedPath);
        };
        checkedObjects.add(obj);
        tracked.children = {};
        var hasIgnoredPaths = ignoredPaths.length > 0;
        for(var key in obj)_loop(key);
    }
    return tracked;
}
function $ca04af99794d5fdc$var$detectMutations(isImmutable) {
    var _loop = function(key2) {
        var nestedPath = path ? path + "." + key2 : key2;
        if (hasIgnoredPaths) {
            var hasMatches = ignoredPaths.some(function(ignored) {
                if (ignored instanceof RegExp) return ignored.test(nestedPath);
                return nestedPath === ignored;
            });
            if (hasMatches) return "continue";
        }
        var result = $ca04af99794d5fdc$var$detectMutations(isImmutable, ignoredPaths, trackedProperty.children[key2], obj[key2], sameRef, nestedPath);
        if (result.wasMutated) return {
            v: result
        };
    };
    var ignoredPaths = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : [], trackedProperty = arguments.length > 2 ? arguments[2] : void 0, obj = arguments.length > 3 ? arguments[3] : void 0, sameParentRef = arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : false, path = arguments.length > 5 && arguments[5] !== void 0 ? arguments[5] : "";
    var prevObj = trackedProperty ? trackedProperty.value : void 0;
    var sameRef = prevObj === obj;
    if (sameParentRef && !sameRef && !Number.isNaN(obj)) return {
        wasMutated: true,
        path: path
    };
    if (isImmutable(prevObj) || isImmutable(obj)) return {
        wasMutated: false
    };
    var keysToDetect = {};
    for(var key in trackedProperty.children)keysToDetect[key] = true;
    for(var key1 in obj)keysToDetect[key1] = true;
    var hasIgnoredPaths = ignoredPaths.length > 0;
    for(var key2 in keysToDetect){
        var _ret = _loop(key2);
        if ((0, $bJtXW._)(_ret) === "object") return _ret.v;
    }
    return {
        wasMutated: false
    };
}
function $ca04af99794d5fdc$export$9181bb1a5474289() {
    var options = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    var stringify, getSerialize, getState, next, action;
    return function() {
        return function(next) {
            return function(action) {
                return next(action);
            };
        };
    };
}
// src/serializableStateInvariantMiddleware.ts
function $ca04af99794d5fdc$export$77670485918dab4e(val) {
    var type = typeof val === "undefined" ? "undefined" : (0, $bJtXW._)(val);
    return val == null || type === "string" || type === "boolean" || type === "number" || Array.isArray(val) || (0, $20ec22595b3da151$export$53b83ca8eaab0383)(val);
}
function $ca04af99794d5fdc$export$ada5dca0b571bc7(value) {
    var path = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "", isSerializable = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : $ca04af99794d5fdc$export$77670485918dab4e, getEntries = arguments.length > 3 ? arguments[3] : void 0, ignoredPaths = arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : [], cache = arguments.length > 5 ? arguments[5] : void 0;
    var foundNestedSerializable;
    if (!isSerializable(value)) return {
        keyPath: path || "<root>",
        value: value
    };
    if ((typeof value === "undefined" ? "undefined" : (0, $bJtXW._)(value)) !== "object" || value === null) return false;
    if (cache == null ? void 0 : cache.has(value)) return false;
    var entries = getEntries != null ? getEntries(value) : Object.entries(value);
    var hasIgnoredPaths = ignoredPaths.length > 0;
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        var _loop = function() {
            var _step_value = (0, $2nwvT._)(_step.value, 2), key = _step_value[0], nestedValue = _step_value[1];
            var nestedPath = path ? path + "." + key : key;
            if (hasIgnoredPaths) {
                var hasMatches = ignoredPaths.some(function(ignored) {
                    if (ignored instanceof RegExp) return ignored.test(nestedPath);
                    return nestedPath === ignored;
                });
                if (hasMatches) return "continue";
            }
            if (!isSerializable(nestedValue)) return {
                v: {
                    keyPath: nestedPath,
                    value: nestedValue
                }
            };
            if ((typeof nestedValue === "undefined" ? "undefined" : (0, $bJtXW._)(nestedValue)) === "object") {
                foundNestedSerializable = $ca04af99794d5fdc$export$ada5dca0b571bc7(nestedValue, nestedPath, isSerializable, getEntries, ignoredPaths, cache);
                if (foundNestedSerializable) return {
                    v: foundNestedSerializable
                };
            }
        };
        for(var _iterator = entries[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var _ret = _loop();
            if ((0, $bJtXW._)(_ret) === "object") return _ret.v;
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    if (cache && $ca04af99794d5fdc$var$isNestedFrozen(value)) cache.add(value);
    return false;
}
function $ca04af99794d5fdc$var$isNestedFrozen(value) {
    if (!Object.isFrozen(value)) return false;
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = Object.values(value)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var nestedValue = _step.value;
            if ((typeof nestedValue === "undefined" ? "undefined" : (0, $bJtXW._)(nestedValue)) !== "object" || nestedValue === null) continue;
            if (!$ca04af99794d5fdc$var$isNestedFrozen(nestedValue)) return false;
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    return true;
}
function $ca04af99794d5fdc$export$6dea1aad6dac5ac2() {
    var options = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    var storeAPI, next, action;
    return function() {
        return function(next) {
            return function(action) {
                return next(action);
            };
        };
    };
}
// src/getDefaultMiddleware.ts
function $ca04af99794d5fdc$var$isBoolean(x) {
    return typeof x === "boolean";
}
var $ca04af99794d5fdc$var$buildGetDefaultMiddleware = function() {
    return function getDefaultMiddleware(options) {
        var _ref = options != null ? options : {}, _ref_thunk = _ref.thunk, thunk = _ref_thunk === void 0 ? true : _ref_thunk, _ref_immutableCheck = _ref.immutableCheck, immutableCheck = _ref_immutableCheck === void 0 ? true : _ref_immutableCheck, _ref_serializableCheck = _ref.serializableCheck, serializableCheck = _ref_serializableCheck === void 0 ? true : _ref_serializableCheck, _ref_actionCreatorCheck = _ref.actionCreatorCheck, actionCreatorCheck = _ref_actionCreatorCheck === void 0 ? true : _ref_actionCreatorCheck;
        var middlewareArray = new $ca04af99794d5fdc$export$1908877435b1d5e9();
        if (thunk) {
            if ($ca04af99794d5fdc$var$isBoolean(thunk)) middlewareArray.push((0, $21ccc86701ec53ef$export$dd164f5517779f15));
            else middlewareArray.push((0, $21ccc86701ec53ef$export$16d06542a1949d9e)(thunk.extraArgument));
        }
        return middlewareArray;
    };
};
// src/autoBatchEnhancer.ts
var $ca04af99794d5fdc$export$8fb31c0f05df007b = "RTK_autoBatch";
var $ca04af99794d5fdc$export$39fcd5145ec5e4e2 = function() {
    return function(payload) {
        return {
            payload: payload,
            meta: (0, $72osQ._)({}, $ca04af99794d5fdc$export$8fb31c0f05df007b, true)
        };
    };
};
var $ca04af99794d5fdc$var$createQueueWithTimer = function(timeout) {
    return function(notify) {
        setTimeout(notify, timeout);
    };
};
var $ca04af99794d5fdc$export$676277d7dca0f396 = function() {
    var options = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {
        type: "raf"
    };
    return function(next) {
        return function() {
            for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
                args[_key] = arguments[_key];
            }
            var store = next.apply(void 0, (0, $2us1u._)(args));
            var notifying = true;
            var shouldNotifyAtEndOfTick = false;
            var notificationQueued = false;
            var listeners = /* @__PURE__ */ new Set();
            var queueCallback = options.type === "tick" ? queueMicrotask : options.type === "raf" ? // requestAnimationFrame won't exist in SSR environments. Fall back to a vague approximation just to keep from erroring.
            typeof window !== "undefined" && window.requestAnimationFrame ? window.requestAnimationFrame : $ca04af99794d5fdc$var$createQueueWithTimer(10) : options.type === "callback" ? options.queueNotification : $ca04af99794d5fdc$var$createQueueWithTimer(options.timeout);
            var notifyListeners = function() {
                notificationQueued = false;
                if (shouldNotifyAtEndOfTick) {
                    shouldNotifyAtEndOfTick = false;
                    listeners.forEach(function(l) {
                        return l();
                    });
                }
            };
            return Object.assign({}, store, {
                // Override the base `store.subscribe` method to keep original listeners
                // from running if we're delaying notifications
                subscribe: function(listener2) {
                    var wrappedListener = function() {
                        return notifying && listener2();
                    };
                    var unsubscribe = store.subscribe(wrappedListener);
                    listeners.add(listener2);
                    return function() {
                        unsubscribe();
                        listeners.delete(listener2);
                    };
                },
                // Override the base `store.dispatch` method so that we can check actions
                // for the `shouldAutoBatch` flag and determine if batching is active
                dispatch: function(action) {
                    var _a;
                    try {
                        notifying = !((_a = action == null ? void 0 : action.meta) == null ? void 0 : _a[$ca04af99794d5fdc$export$8fb31c0f05df007b]);
                        shouldNotifyAtEndOfTick = !notifying;
                        if (shouldNotifyAtEndOfTick) {
                            if (!notificationQueued) {
                                notificationQueued = true;
                                queueCallback(notifyListeners);
                            }
                        }
                        return store.dispatch(action);
                    } finally{
                        notifying = true;
                    }
                }
            });
        };
    };
};
// src/getDefaultEnhancers.ts
var $ca04af99794d5fdc$var$buildGetDefaultEnhancers = function(middlewareEnhancer) {
    return function getDefaultEnhancers(options) {
        var _ref = options != null ? options : {}, _ref_autoBatch = _ref.autoBatch, autoBatch = _ref_autoBatch === void 0 ? true : _ref_autoBatch;
        var enhancerArray = new $ca04af99794d5fdc$export$1908877435b1d5e9(middlewareEnhancer);
        if (autoBatch) enhancerArray.push($ca04af99794d5fdc$export$676277d7dca0f396((typeof autoBatch === "undefined" ? "undefined" : (0, $bJtXW._)(autoBatch)) === "object" ? autoBatch : void 0));
        return enhancerArray;
    };
};
// src/configureStore.ts
function $ca04af99794d5fdc$export$7d8a5b498da695ac(options) {
    var getDefaultMiddleware = $ca04af99794d5fdc$var$buildGetDefaultMiddleware();
    var _ref = options || {}, reducer = _ref.reducer, middleware = _ref.middleware, _ref_devTools = _ref.devTools, devTools = _ref_devTools === void 0 ? true : _ref_devTools, _ref_duplicateMiddlewareCheck = _ref.duplicateMiddlewareCheck, duplicateMiddlewareCheck = _ref_duplicateMiddlewareCheck === void 0 ? true : _ref_duplicateMiddlewareCheck, preloadedState = _ref.preloadedState, enhancers = _ref.enhancers;
    var rootReducer;
    if (typeof reducer === "function") rootReducer = reducer;
    else if ((0, $20ec22595b3da151$export$53b83ca8eaab0383)(reducer)) rootReducer = (0, $20ec22595b3da151$export$66e4520cdb265d18)(reducer);
    else throw new Error($ca04af99794d5fdc$export$378fa86b259c0280(1));
    var finalMiddleware;
    if (typeof middleware === "function") finalMiddleware = middleware(getDefaultMiddleware);
    else finalMiddleware = getDefaultMiddleware();
    var middleware2;
    var finalCompose = (0, $20ec22595b3da151$export$f672e0b6f7222cd7);
    if (devTools) finalCompose = $ca04af99794d5fdc$var$composeWithDevTools($ca04af99794d5fdc$var$__spreadValues({
        // Enable capture of stack traces for dispatched Redux actions
        trace: false
    }, (typeof devTools === "undefined" ? "undefined" : (0, $bJtXW._)(devTools)) === "object" && devTools));
    var middlewareEnhancer = (0, $20ec22595b3da151$export$9ff26e0402cc7b7).apply(void 0, (0, $2us1u._)(finalMiddleware));
    var getDefaultEnhancers = $ca04af99794d5fdc$var$buildGetDefaultEnhancers(middlewareEnhancer);
    var storeEnhancers = typeof enhancers === "function" ? enhancers(getDefaultEnhancers) : getDefaultEnhancers();
    var composedEnhancer = finalCompose.apply(void 0, (0, $2us1u._)(storeEnhancers));
    return (0, $20ec22595b3da151$export$f51a9068ac82ea43)(rootReducer, preloadedState, composedEnhancer);
}
// src/mapBuilders.ts
function $ca04af99794d5fdc$var$executeReducerBuilderCallback(builderCallback) {
    var actionsMap = {};
    var actionMatchers = [];
    var defaultCaseReducer;
    var builder = {
        addCase: function(typeOrActionCreator, reducer) {
            var type = typeof typeOrActionCreator === "string" ? typeOrActionCreator : typeOrActionCreator.type;
            if (!type) throw new Error($ca04af99794d5fdc$export$378fa86b259c0280(28));
            if (type in actionsMap) throw new Error($ca04af99794d5fdc$export$378fa86b259c0280(29));
            actionsMap[type] = reducer;
            return builder;
        },
        addAsyncThunk: function(asyncThunk, reducers) {
            if (reducers.pending) actionsMap[asyncThunk.pending.type] = reducers.pending;
            if (reducers.rejected) actionsMap[asyncThunk.rejected.type] = reducers.rejected;
            if (reducers.fulfilled) actionsMap[asyncThunk.fulfilled.type] = reducers.fulfilled;
            if (reducers.settled) actionMatchers.push({
                matcher: asyncThunk.settled,
                reducer: reducers.settled
            });
            return builder;
        },
        addMatcher: function(matcher, reducer) {
            actionMatchers.push({
                matcher: matcher,
                reducer: reducer
            });
            return builder;
        },
        addDefaultCase: function(reducer) {
            defaultCaseReducer = reducer;
            return builder;
        }
    };
    builderCallback(builder);
    return [
        actionsMap,
        actionMatchers,
        defaultCaseReducer
    ];
}
// src/createReducer.ts
function $ca04af99794d5fdc$var$isStateFunction(x) {
    return typeof x === "function";
}
function $ca04af99794d5fdc$export$473eb76d322d0290(initialState, mapOrBuilderCallback) {
    var _executeReducerBuilderCallback = (0, $2nwvT._)($ca04af99794d5fdc$var$executeReducerBuilderCallback(mapOrBuilderCallback), 3), actionsMap = _executeReducerBuilderCallback[0], finalActionMatchers = _executeReducerBuilderCallback[1], finalDefaultCaseReducer = _executeReducerBuilderCallback[2];
    var getInitialState;
    if ($ca04af99794d5fdc$var$isStateFunction(initialState)) getInitialState = function() {
        return $ca04af99794d5fdc$var$freezeDraftable(initialState());
    };
    else {
        var frozenInitialState = $ca04af99794d5fdc$var$freezeDraftable(initialState);
        getInitialState = function() {
            return frozenInitialState;
        };
    }
    function reducer() {
        var state = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : getInitialState(), action = arguments.length > 1 ? arguments[1] : void 0;
        var caseReducers = [
            actionsMap[action.type]
        ].concat((0, $2us1u._)(finalActionMatchers.filter(function(param) {
            var matcher = param.matcher;
            return matcher(action);
        }).map(function(param) {
            var reducer2 = param.reducer;
            return reducer2;
        })));
        if (caseReducers.filter(function(cr) {
            return !!cr;
        }).length === 0) caseReducers = [
            finalDefaultCaseReducer
        ];
        return caseReducers.reduce(function(previousState, caseReducer) {
            if (caseReducer) {
                if ((0, $kK8g8.isDraft)(previousState)) {
                    var draft = previousState;
                    var result = caseReducer(draft, action);
                    if (result === void 0) return previousState;
                    return result;
                } else if (!(0, $kK8g8.isDraftable)(previousState)) {
                    var result1 = caseReducer(previousState, action);
                    if (result1 === void 0) {
                        if (previousState === null) return previousState;
                        throw Error("A case reducer on a non-draftable value must not return undefined");
                    }
                    return result1;
                } else return (0, $kK8g8.produce)(previousState, function(draft) {
                    return caseReducer(draft, action);
                });
            }
            return previousState;
        }, state);
    }
    reducer.getInitialState = getInitialState;
    return reducer;
}
// src/matchers.ts
var $ca04af99794d5fdc$var$matches = function(matcher, action) {
    if ($ca04af99794d5fdc$var$hasMatchFunction(matcher)) return matcher.match(action);
    else return matcher(action);
};
function $ca04af99794d5fdc$export$2c3435c7647f7b0d() {
    for(var _len = arguments.length, matchers = new Array(_len), _key = 0; _key < _len; _key++){
        matchers[_key] = arguments[_key];
    }
    return function(action) {
        return matchers.some(function(matcher) {
            return $ca04af99794d5fdc$var$matches(matcher, action);
        });
    };
}
function $ca04af99794d5fdc$export$9dd1fb32974da385() {
    for(var _len = arguments.length, matchers = new Array(_len), _key = 0; _key < _len; _key++){
        matchers[_key] = arguments[_key];
    }
    return function(action) {
        return matchers.every(function(matcher) {
            return $ca04af99794d5fdc$var$matches(matcher, action);
        });
    };
}
function $ca04af99794d5fdc$var$hasExpectedRequestMetadata(action, validStatus) {
    if (!action || !action.meta) return false;
    var hasValidRequestId = typeof action.meta.requestId === "string";
    var hasValidRequestStatus = validStatus.indexOf(action.meta.requestStatus) > -1;
    return hasValidRequestId && hasValidRequestStatus;
}
function $ca04af99794d5fdc$var$isAsyncThunkArray(a) {
    return typeof a[0] === "function" && "pending" in a[0] && "fulfilled" in a[0] && "rejected" in a[0];
}
function $ca04af99794d5fdc$export$872dec21e9a69476() {
    for(var _len = arguments.length, asyncThunks = new Array(_len), _key = 0; _key < _len; _key++){
        asyncThunks[_key] = arguments[_key];
    }
    if (asyncThunks.length === 0) return function(action) {
        return $ca04af99794d5fdc$var$hasExpectedRequestMetadata(action, [
            "pending"
        ]);
    };
    if (!$ca04af99794d5fdc$var$isAsyncThunkArray(asyncThunks)) return $ca04af99794d5fdc$export$872dec21e9a69476()(asyncThunks[0]);
    return $ca04af99794d5fdc$export$2c3435c7647f7b0d.apply(void 0, (0, $2us1u._)(asyncThunks.map(function(asyncThunk) {
        return asyncThunk.pending;
    })));
}
function $ca04af99794d5fdc$export$a5c5d27e3994c5be() {
    for(var _len = arguments.length, asyncThunks = new Array(_len), _key = 0; _key < _len; _key++){
        asyncThunks[_key] = arguments[_key];
    }
    if (asyncThunks.length === 0) return function(action) {
        return $ca04af99794d5fdc$var$hasExpectedRequestMetadata(action, [
            "rejected"
        ]);
    };
    if (!$ca04af99794d5fdc$var$isAsyncThunkArray(asyncThunks)) return $ca04af99794d5fdc$export$a5c5d27e3994c5be()(asyncThunks[0]);
    return $ca04af99794d5fdc$export$2c3435c7647f7b0d.apply(void 0, (0, $2us1u._)(asyncThunks.map(function(asyncThunk) {
        return asyncThunk.rejected;
    })));
}
function $ca04af99794d5fdc$export$fcc3388fb56de601() {
    for(var _len = arguments.length, asyncThunks = new Array(_len), _key = 0; _key < _len; _key++){
        asyncThunks[_key] = arguments[_key];
    }
    var hasFlag = function(action) {
        return action && action.meta && action.meta.rejectedWithValue;
    };
    if (asyncThunks.length === 0) return $ca04af99794d5fdc$export$9dd1fb32974da385($ca04af99794d5fdc$export$a5c5d27e3994c5be.apply(void 0, (0, $2us1u._)(asyncThunks)), hasFlag);
    if (!$ca04af99794d5fdc$var$isAsyncThunkArray(asyncThunks)) return $ca04af99794d5fdc$export$fcc3388fb56de601()(asyncThunks[0]);
    return $ca04af99794d5fdc$export$9dd1fb32974da385($ca04af99794d5fdc$export$a5c5d27e3994c5be.apply(void 0, (0, $2us1u._)(asyncThunks)), hasFlag);
}
function $ca04af99794d5fdc$export$1da80a6ef1307441() {
    for(var _len = arguments.length, asyncThunks = new Array(_len), _key = 0; _key < _len; _key++){
        asyncThunks[_key] = arguments[_key];
    }
    if (asyncThunks.length === 0) return function(action) {
        return $ca04af99794d5fdc$var$hasExpectedRequestMetadata(action, [
            "fulfilled"
        ]);
    };
    if (!$ca04af99794d5fdc$var$isAsyncThunkArray(asyncThunks)) return $ca04af99794d5fdc$export$1da80a6ef1307441()(asyncThunks[0]);
    return $ca04af99794d5fdc$export$2c3435c7647f7b0d.apply(void 0, (0, $2us1u._)(asyncThunks.map(function(asyncThunk) {
        return asyncThunk.fulfilled;
    })));
}
function $ca04af99794d5fdc$export$6aa4142d99c1abce() {
    for(var _len = arguments.length, asyncThunks = new Array(_len), _key = 0; _key < _len; _key++){
        asyncThunks[_key] = arguments[_key];
    }
    if (asyncThunks.length === 0) return function(action) {
        return $ca04af99794d5fdc$var$hasExpectedRequestMetadata(action, [
            "pending",
            "fulfilled",
            "rejected"
        ]);
    };
    if (!$ca04af99794d5fdc$var$isAsyncThunkArray(asyncThunks)) return $ca04af99794d5fdc$export$6aa4142d99c1abce()(asyncThunks[0]);
    return $ca04af99794d5fdc$export$2c3435c7647f7b0d.apply(void 0, (0, $2us1u._)(asyncThunks.flatMap(function(asyncThunk) {
        return [
            asyncThunk.pending,
            asyncThunk.rejected,
            asyncThunk.fulfilled
        ];
    })));
}
// src/nanoid.ts
var $ca04af99794d5fdc$var$urlAlphabet = "ModuleSymbhasOwnPr-0123456789ABCDEFGHNRVfgctiUvz_KqYTJkLxpZXIjQW";
var $ca04af99794d5fdc$export$ac4959f4f1338dfc = function() {
    var size = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : 21;
    var id = "";
    var i = size;
    while(i--)id += $ca04af99794d5fdc$var$urlAlphabet[Math.random() * 64 | 0];
    return id;
};
// src/createAsyncThunk.ts
var $ca04af99794d5fdc$var$commonProperties = [
    "name",
    "message",
    "stack",
    "code"
];
var $ca04af99794d5fdc$var$RejectWithValue = function RejectWithValue(payload, meta) {
    "use strict";
    (0, $grujF._)(this, RejectWithValue);
    this.payload = payload;
    this.meta = meta;
    /*
    type-only property to distinguish between RejectWithValue and FulfillWithMeta
    does not exist at runtime
    */ $ca04af99794d5fdc$var$__publicField(this, "_type");
};
var $ca04af99794d5fdc$var$FulfillWithMeta = function FulfillWithMeta(payload, meta) {
    "use strict";
    (0, $grujF._)(this, FulfillWithMeta);
    this.payload = payload;
    this.meta = meta;
    /*
    type-only property to distinguish between RejectWithValue and FulfillWithMeta
    does not exist at runtime
    */ $ca04af99794d5fdc$var$__publicField(this, "_type");
};
var $ca04af99794d5fdc$export$c97c53d0b2d5d81e = function(value) {
    if ((typeof value === "undefined" ? "undefined" : (0, $bJtXW._)(value)) === "object" && value !== null) {
        var simpleError = {};
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            for(var _iterator = $ca04af99794d5fdc$var$commonProperties[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var property = _step.value;
                if (typeof value[property] === "string") simpleError[property] = value[property];
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
        return simpleError;
    }
    return {
        message: String(value)
    };
};
var $ca04af99794d5fdc$var$externalAbortMessage = "External signal was aborted";
var $ca04af99794d5fdc$export$6abd22dc03e5063f = /* @__PURE__ */ function() {
    var createAsyncThunk2 = function createAsyncThunk2(typePrefix, payloadCreator, options) {
        var fulfilled = $ca04af99794d5fdc$export$309c7a02b0b0bc62(typePrefix + "/fulfilled", function(payload, requestId, arg, meta) {
            return {
                payload: payload,
                meta: $ca04af99794d5fdc$var$__spreadProps($ca04af99794d5fdc$var$__spreadValues({}, meta || {}), {
                    arg: arg,
                    requestId: requestId,
                    requestStatus: "fulfilled"
                })
            };
        });
        var pending = $ca04af99794d5fdc$export$309c7a02b0b0bc62(typePrefix + "/pending", function(requestId, arg, meta) {
            return {
                payload: void 0,
                meta: $ca04af99794d5fdc$var$__spreadProps($ca04af99794d5fdc$var$__spreadValues({}, meta || {}), {
                    arg: arg,
                    requestId: requestId,
                    requestStatus: "pending"
                })
            };
        });
        var rejected = $ca04af99794d5fdc$export$309c7a02b0b0bc62(typePrefix + "/rejected", function(error, requestId, arg, payload, meta) {
            return {
                payload: payload,
                error: (options && options.serializeError || $ca04af99794d5fdc$export$c97c53d0b2d5d81e)(error || "Rejected"),
                meta: $ca04af99794d5fdc$var$__spreadProps($ca04af99794d5fdc$var$__spreadValues({}, meta || {}), {
                    arg: arg,
                    requestId: requestId,
                    rejectedWithValue: !!payload,
                    requestStatus: "rejected",
                    aborted: (error == null ? void 0 : error.name) === "AbortError",
                    condition: (error == null ? void 0 : error.name) === "ConditionError"
                })
            };
        });
        function actionCreator(arg) {
            var signal = (arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}).signal;
            return function(dispatch, getState, extra) {
                var abort = function abort(reason) {
                    abortReason = reason;
                    abortController.abort();
                };
                var requestId = (options == null ? void 0 : options.idGenerator) ? options.idGenerator(arg) : $ca04af99794d5fdc$export$ac4959f4f1338dfc();
                var abortController = new AbortController();
                var abortHandler;
                var abortReason;
                if (signal) {
                    if (signal.aborted) abort($ca04af99794d5fdc$var$externalAbortMessage);
                    else signal.addEventListener("abort", function() {
                        return abort($ca04af99794d5fdc$var$externalAbortMessage);
                    }, {
                        once: true
                    });
                }
                var promise = function() {
                    return (/*#__PURE__*/ 0, /*#__PURE__*/ $g3gsR._)(function() {
                        var _a, _b, finalAction, conditionResult, abortedPromise, err, skipDispatch;
                        return (0, $fRv9I.__generator)(this, function(_state) {
                            switch(_state.label){
                                case 0:
                                    _state.trys.push([
                                        0,
                                        4,
                                        5,
                                        6
                                    ]);
                                    conditionResult = (_a = options == null ? void 0 : options.condition) == null ? void 0 : _a.call(options, arg, {
                                        getState: getState,
                                        extra: extra
                                    });
                                    if (!$ca04af99794d5fdc$var$isThenable(conditionResult)) return [
                                        3,
                                        2
                                    ];
                                    return [
                                        4,
                                        conditionResult
                                    ];
                                case 1:
                                    conditionResult = _state.sent();
                                    _state.label = 2;
                                case 2:
                                    if (conditionResult === false || abortController.signal.aborted) throw {
                                        name: "ConditionError",
                                        message: "Aborted due to condition callback returning false."
                                    };
                                    abortedPromise = new Promise(function(_, reject) {
                                        abortHandler = function() {
                                            reject({
                                                name: "AbortError",
                                                message: abortReason || "Aborted"
                                            });
                                        };
                                        abortController.signal.addEventListener("abort", abortHandler, {
                                            once: true
                                        });
                                    });
                                    dispatch(pending(requestId, arg, (_b = options == null ? void 0 : options.getPendingMeta) == null ? void 0 : _b.call(options, {
                                        requestId: requestId,
                                        arg: arg
                                    }, {
                                        getState: getState,
                                        extra: extra
                                    })));
                                    return [
                                        4,
                                        Promise.race([
                                            abortedPromise,
                                            Promise.resolve(payloadCreator(arg, {
                                                dispatch: dispatch,
                                                getState: getState,
                                                extra: extra,
                                                requestId: requestId,
                                                signal: abortController.signal,
                                                abort: abort,
                                                rejectWithValue: function(value, meta) {
                                                    return new $ca04af99794d5fdc$var$RejectWithValue(value, meta);
                                                },
                                                fulfillWithValue: function(value, meta) {
                                                    return new $ca04af99794d5fdc$var$FulfillWithMeta(value, meta);
                                                }
                                            })).then(function(result) {
                                                if (result instanceof $ca04af99794d5fdc$var$RejectWithValue) throw result;
                                                if (result instanceof $ca04af99794d5fdc$var$FulfillWithMeta) return fulfilled(result.payload, requestId, arg, result.meta);
                                                return fulfilled(result, requestId, arg);
                                            })
                                        ])
                                    ];
                                case 3:
                                    finalAction = _state.sent();
                                    return [
                                        3,
                                        6
                                    ];
                                case 4:
                                    err = _state.sent();
                                    finalAction = err instanceof $ca04af99794d5fdc$var$RejectWithValue ? rejected(null, requestId, arg, err.payload, err.meta) : rejected(err, requestId, arg);
                                    return [
                                        3,
                                        6
                                    ];
                                case 5:
                                    if (abortHandler) abortController.signal.removeEventListener("abort", abortHandler);
                                    return [
                                        7
                                    ];
                                case 6:
                                    skipDispatch = options && !options.dispatchConditionRejection && rejected.match(finalAction) && finalAction.meta.condition;
                                    if (!skipDispatch) dispatch(finalAction);
                                    return [
                                        2,
                                        finalAction
                                    ];
                            }
                        });
                    })();
                }();
                return Object.assign(promise, {
                    abort: abort,
                    requestId: requestId,
                    arg: arg,
                    unwrap: function() {
                        return promise.then($ca04af99794d5fdc$export$5b28227b4c5dc983);
                    }
                });
            };
        }
        return Object.assign(actionCreator, {
            pending: pending,
            rejected: rejected,
            fulfilled: fulfilled,
            settled: $ca04af99794d5fdc$export$2c3435c7647f7b0d(rejected, fulfilled),
            typePrefix: typePrefix
        });
    };
    createAsyncThunk2.withTypes = function() {
        return createAsyncThunk2;
    };
    return createAsyncThunk2;
}();
function $ca04af99794d5fdc$export$5b28227b4c5dc983(action) {
    if (action.meta && action.meta.rejectedWithValue) throw action.payload;
    if (action.error) throw action.error;
    return action.payload;
}
function $ca04af99794d5fdc$var$isThenable(value) {
    return value !== null && (typeof value === "undefined" ? "undefined" : (0, $bJtXW._)(value)) === "object" && typeof value.then === "function";
}
// src/createSlice.ts
var $ca04af99794d5fdc$var$asyncThunkSymbol = /* @__PURE__ */ Symbol.for("rtk-slice-createasyncthunk");
var $ca04af99794d5fdc$export$343355ed40c51c46 = (0, $72osQ._)({}, $ca04af99794d5fdc$var$asyncThunkSymbol, $ca04af99794d5fdc$export$6abd22dc03e5063f);
var $ca04af99794d5fdc$export$23a094319a4b586 = /* @__PURE__ */ function(ReducerType2) {
    ReducerType2["reducer"] = "reducer";
    ReducerType2["reducerWithPrepare"] = "reducerWithPrepare";
    ReducerType2["asyncThunk"] = "asyncThunk";
    return ReducerType2;
}($ca04af99794d5fdc$export$23a094319a4b586 || {});
function $ca04af99794d5fdc$var$getType(slice, actionKey) {
    return "".concat(slice, "/").concat(actionKey);
}
function $ca04af99794d5fdc$export$affdea4146de9cf5() {
    var creators = (arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}).creators;
    var _a;
    var cAT = (_a = creators == null ? void 0 : creators.asyncThunk) == null ? void 0 : _a[$ca04af99794d5fdc$var$asyncThunkSymbol];
    return function createSlice2(options) {
        var name = options.name, _options_reducerPath = options.reducerPath, reducerPath = _options_reducerPath === void 0 ? name : _options_reducerPath;
        if (!name) throw new Error($ca04af99794d5fdc$export$378fa86b259c0280(11));
        var reducers = (typeof options.reducers === "function" ? options.reducers($ca04af99794d5fdc$var$buildReducerCreators()) : options.reducers) || {};
        var reducerNames = Object.keys(reducers);
        var context = {
            sliceCaseReducersByName: {},
            sliceCaseReducersByType: {},
            actionCreators: {},
            sliceMatchers: []
        };
        var contextMethods = {
            addCase: function(typeOrActionCreator, reducer2) {
                var type = typeof typeOrActionCreator === "string" ? typeOrActionCreator : typeOrActionCreator.type;
                if (!type) throw new Error($ca04af99794d5fdc$export$378fa86b259c0280(12));
                if (type in context.sliceCaseReducersByType) throw new Error($ca04af99794d5fdc$export$378fa86b259c0280(13));
                context.sliceCaseReducersByType[type] = reducer2;
                return contextMethods;
            },
            addMatcher: function(matcher, reducer2) {
                context.sliceMatchers.push({
                    matcher: matcher,
                    reducer: reducer2
                });
                return contextMethods;
            },
            exposeAction: function(name2, actionCreator) {
                context.actionCreators[name2] = actionCreator;
                return contextMethods;
            },
            exposeCaseReducer: function(name2, reducer2) {
                context.sliceCaseReducersByName[name2] = reducer2;
                return contextMethods;
            }
        };
        reducerNames.forEach(function(reducerName) {
            var reducerDefinition = reducers[reducerName];
            var reducerDetails = {
                reducerName: reducerName,
                type: $ca04af99794d5fdc$var$getType(name, reducerName),
                createNotation: typeof options.reducers === "function"
            };
            if ($ca04af99794d5fdc$var$isAsyncThunkSliceReducerDefinition(reducerDefinition)) $ca04af99794d5fdc$var$handleThunkCaseReducerDefinition(reducerDetails, reducerDefinition, contextMethods, cAT);
            else $ca04af99794d5fdc$var$handleNormalReducerDefinition(reducerDetails, reducerDefinition, contextMethods);
        });
        function buildReducer() {
            var _ref = (0, $2nwvT._)(typeof options.extraReducers === "function" ? $ca04af99794d5fdc$var$executeReducerBuilderCallback(options.extraReducers) : [
                options.extraReducers
            ], 3), tmp = _ref[0], extraReducers = tmp === void 0 ? {} : tmp, tmp1 = _ref[1], actionMatchers = tmp1 === void 0 ? [] : tmp1, defaultCaseReducer = _ref[2];
            var finalCaseReducers = $ca04af99794d5fdc$var$__spreadValues($ca04af99794d5fdc$var$__spreadValues({}, extraReducers), context.sliceCaseReducersByType);
            return $ca04af99794d5fdc$export$473eb76d322d0290(options.initialState, function(builder) {
                for(var key in finalCaseReducers)builder.addCase(key, finalCaseReducers[key]);
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                try {
                    for(var _iterator = context.sliceMatchers[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                        var sM = _step.value;
                        builder.addMatcher(sM.matcher, sM.reducer);
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                            _iterator.return();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
                var _iteratorNormalCompletion1 = true, _didIteratorError1 = false, _iteratorError1 = undefined;
                try {
                    for(var _iterator1 = actionMatchers[Symbol.iterator](), _step1; !(_iteratorNormalCompletion1 = (_step1 = _iterator1.next()).done); _iteratorNormalCompletion1 = true){
                        var m = _step1.value;
                        builder.addMatcher(m.matcher, m.reducer);
                    }
                } catch (err) {
                    _didIteratorError1 = true;
                    _iteratorError1 = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion1 && _iterator1.return != null) {
                            _iterator1.return();
                        }
                    } finally{
                        if (_didIteratorError1) {
                            throw _iteratorError1;
                        }
                    }
                }
                if (defaultCaseReducer) builder.addDefaultCase(defaultCaseReducer);
            });
        }
        var selectSelf = function(state) {
            return state;
        };
        var injectedSelectorCache = /* @__PURE__ */ new Map();
        var injectedStateCache = /* @__PURE__ */ new WeakMap();
        var _reducer;
        function reducer(state, action) {
            if (!_reducer) _reducer = buildReducer();
            return _reducer(state, action);
        }
        function getInitialState() {
            if (!_reducer) _reducer = buildReducer();
            return _reducer.getInitialState();
        }
        function makeSelectorProps(reducerPath2) {
            var injected = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false;
            function selectSlice(state) {
                var sliceState = state[reducerPath2];
                if (typeof sliceState === "undefined") {
                    if (injected) sliceState = $ca04af99794d5fdc$var$getOrInsertComputed(injectedStateCache, selectSlice, getInitialState);
                }
                return sliceState;
            }
            function getSelectors() {
                var selectState = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : selectSelf;
                var selectorCache = $ca04af99794d5fdc$var$getOrInsertComputed(injectedSelectorCache, injected, function() {
                    return /* @__PURE__ */ new WeakMap();
                });
                return $ca04af99794d5fdc$var$getOrInsertComputed(selectorCache, selectState, function() {
                    var _a2;
                    var map = {};
                    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                    try {
                        for(var _iterator = Object.entries((_a2 = options.selectors) != null ? _a2 : {})[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                            var _step_value = (0, $2nwvT._)(_step.value, 2), name2 = _step_value[0], selector = _step_value[1];
                            map[name2] = $ca04af99794d5fdc$var$wrapSelector(selector, selectState, function() {
                                return $ca04af99794d5fdc$var$getOrInsertComputed(injectedStateCache, selectState, getInitialState);
                            }, injected);
                        }
                    } catch (err) {
                        _didIteratorError = true;
                        _iteratorError = err;
                    } finally{
                        try {
                            if (!_iteratorNormalCompletion && _iterator.return != null) {
                                _iterator.return();
                            }
                        } finally{
                            if (_didIteratorError) {
                                throw _iteratorError;
                            }
                        }
                    }
                    return map;
                });
            }
            return {
                reducerPath: reducerPath2,
                getSelectors: getSelectors,
                get selectors () {
                    return getSelectors(selectSlice);
                },
                selectSlice: selectSlice
            };
        }
        var slice = $ca04af99794d5fdc$var$__spreadProps($ca04af99794d5fdc$var$__spreadValues({
            name: name,
            reducer: reducer,
            actions: context.actionCreators,
            caseReducers: context.sliceCaseReducersByName,
            getInitialState: getInitialState
        }, makeSelectorProps(reducerPath)), {
            injectInto: function(injectable) {
                var _a2 = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
                var _b = _a2, pathOpt = _b.reducerPath, config = $ca04af99794d5fdc$var$__objRest(_b, [
                    "reducerPath"
                ]);
                var newReducerPath = pathOpt != null ? pathOpt : reducerPath;
                injectable.inject({
                    reducerPath: newReducerPath,
                    reducer: reducer
                }, config);
                return $ca04af99794d5fdc$var$__spreadValues($ca04af99794d5fdc$var$__spreadValues({}, slice), makeSelectorProps(newReducerPath, true));
            }
        });
        return slice;
    };
}
function $ca04af99794d5fdc$var$wrapSelector(selector, selectState, getInitialState, injected) {
    function wrapper(rootState) {
        for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++){
            args[_key - 1] = arguments[_key];
        }
        var sliceState = selectState(rootState);
        if (typeof sliceState === "undefined") {
            if (injected) sliceState = getInitialState();
        }
        return selector.apply(void 0, [
            sliceState
        ].concat((0, $2us1u._)(args)));
    }
    wrapper.unwrapped = selector;
    return wrapper;
}
var $ca04af99794d5fdc$export$4d8d9bd83c24ae8b = /* @__PURE__ */ $ca04af99794d5fdc$export$affdea4146de9cf5();
function $ca04af99794d5fdc$var$buildReducerCreators() {
    function asyncThunk(payloadCreator, config) {
        return $ca04af99794d5fdc$var$__spreadValues({
            _reducerDefinitionType: "asyncThunk" /* asyncThunk */ ,
            payloadCreator: payloadCreator
        }, config);
    }
    asyncThunk.withTypes = function() {
        return asyncThunk;
    };
    return {
        reducer: function(caseReducer) {
            return Object.assign(// hack so the wrapping function has the same name as the original
            // we need to create a wrapper so the `reducerDefinitionType` is not assigned to the original
            (0, $72osQ._)({}, caseReducer.name, function() {
                for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
                    args[_key] = arguments[_key];
                }
                return caseReducer.apply(void 0, (0, $2us1u._)(args));
            })[caseReducer.name], {
                _reducerDefinitionType: "reducer" /* reducer */ 
            });
        },
        preparedReducer: function(prepare, reducer) {
            return {
                _reducerDefinitionType: "reducerWithPrepare" /* reducerWithPrepare */ ,
                prepare: prepare,
                reducer: reducer
            };
        },
        asyncThunk: asyncThunk
    };
}
function $ca04af99794d5fdc$var$handleNormalReducerDefinition(param, maybeReducerWithPrepare, context) {
    var type = param.type, reducerName = param.reducerName, createNotation = param.createNotation;
    var caseReducer;
    var prepareCallback;
    if ("reducer" in maybeReducerWithPrepare) {
        if (createNotation && !$ca04af99794d5fdc$var$isCaseReducerWithPrepareDefinition(maybeReducerWithPrepare)) throw new Error($ca04af99794d5fdc$export$378fa86b259c0280(17));
        caseReducer = maybeReducerWithPrepare.reducer;
        prepareCallback = maybeReducerWithPrepare.prepare;
    } else caseReducer = maybeReducerWithPrepare;
    context.addCase(type, caseReducer).exposeCaseReducer(reducerName, caseReducer).exposeAction(reducerName, prepareCallback ? $ca04af99794d5fdc$export$309c7a02b0b0bc62(type, prepareCallback) : $ca04af99794d5fdc$export$309c7a02b0b0bc62(type));
}
function $ca04af99794d5fdc$var$isAsyncThunkSliceReducerDefinition(reducerDefinition) {
    return reducerDefinition._reducerDefinitionType === "asyncThunk" /* asyncThunk */ ;
}
function $ca04af99794d5fdc$var$isCaseReducerWithPrepareDefinition(reducerDefinition) {
    return reducerDefinition._reducerDefinitionType === "reducerWithPrepare" /* reducerWithPrepare */ ;
}
function $ca04af99794d5fdc$var$handleThunkCaseReducerDefinition(param, reducerDefinition, context, cAT) {
    var type = param.type, reducerName = param.reducerName;
    if (!cAT) throw new Error($ca04af99794d5fdc$export$378fa86b259c0280(18));
    var payloadCreator = reducerDefinition.payloadCreator, fulfilled = reducerDefinition.fulfilled, pending = reducerDefinition.pending, rejected = reducerDefinition.rejected, settled = reducerDefinition.settled, options = reducerDefinition.options;
    var thunk = cAT(type, payloadCreator, options);
    context.exposeAction(reducerName, thunk);
    if (fulfilled) context.addCase(thunk.fulfilled, fulfilled);
    if (pending) context.addCase(thunk.pending, pending);
    if (rejected) context.addCase(thunk.rejected, rejected);
    if (settled) context.addMatcher(thunk.settled, settled);
    context.exposeCaseReducer(reducerName, {
        fulfilled: fulfilled || $ca04af99794d5fdc$var$noop,
        pending: pending || $ca04af99794d5fdc$var$noop,
        rejected: rejected || $ca04af99794d5fdc$var$noop,
        settled: settled || $ca04af99794d5fdc$var$noop
    });
}
function $ca04af99794d5fdc$var$noop() {}
// src/entities/entity_state.ts
function $ca04af99794d5fdc$var$getInitialEntityState() {
    return {
        ids: [],
        entities: {}
    };
}
function $ca04af99794d5fdc$var$createInitialStateFactory(stateAdapter) {
    function getInitialState() {
        var additionalState = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, entities = arguments.length > 1 ? arguments[1] : void 0;
        var state = Object.assign($ca04af99794d5fdc$var$getInitialEntityState(), additionalState);
        return entities ? stateAdapter.setAll(state, entities) : state;
    }
    return {
        getInitialState: getInitialState
    };
}
// src/entities/state_selectors.ts
function $ca04af99794d5fdc$var$createSelectorsFactory() {
    function getSelectors(selectState) {
        var options = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
        var tmp = options.createSelector, createSelector2 = tmp === void 0 ? $ca04af99794d5fdc$export$a5d3c27355e35910 : tmp;
        var selectIds = function(state) {
            return state.ids;
        };
        var selectEntities = function(state) {
            return state.entities;
        };
        var selectAll = createSelector2(selectIds, selectEntities, function(ids, entities) {
            return ids.map(function(id) {
                return entities[id];
            });
        });
        var selectId = function(_, id) {
            return id;
        };
        var selectById = function(entities, id) {
            return entities[id];
        };
        var selectTotal = createSelector2(selectIds, function(ids) {
            return ids.length;
        });
        if (!selectState) return {
            selectIds: selectIds,
            selectEntities: selectEntities,
            selectAll: selectAll,
            selectTotal: selectTotal,
            selectById: createSelector2(selectEntities, selectId, selectById)
        };
        var selectGlobalizedEntities = createSelector2(selectState, selectEntities);
        return {
            selectIds: createSelector2(selectState, selectIds),
            selectEntities: selectGlobalizedEntities,
            selectAll: createSelector2(selectState, selectAll),
            selectTotal: createSelector2(selectState, selectTotal),
            selectById: createSelector2(selectGlobalizedEntities, selectId, selectById)
        };
    }
    return {
        getSelectors: getSelectors
    };
}
// src/entities/state_adapter.ts
var $ca04af99794d5fdc$var$isDraftTyped = (0, $kK8g8.isDraft);
function $ca04af99794d5fdc$var$createSingleArgumentStateOperator(mutator) {
    var operator = $ca04af99794d5fdc$var$createStateOperator(function(_, state) {
        return mutator(state);
    });
    return function operation(state) {
        return operator(state, void 0);
    };
}
function $ca04af99794d5fdc$var$createStateOperator(mutator) {
    return function operation(state, arg) {
        function isPayloadActionArgument(arg2) {
            return $ca04af99794d5fdc$export$ebd532f9034651f3(arg2);
        }
        var runMutator = function(draft) {
            if (isPayloadActionArgument(arg)) mutator(arg.payload, draft);
            else mutator(arg, draft);
        };
        if ($ca04af99794d5fdc$var$isDraftTyped(state)) {
            runMutator(state);
            return state;
        }
        return (0, $kK8g8.produce)(state, runMutator);
    };
}
// src/entities/utils.ts
function $ca04af99794d5fdc$var$selectIdValue(entity, selectId) {
    var key = selectId(entity);
    return key;
}
function $ca04af99794d5fdc$var$ensureEntitiesArray(entities) {
    if (!Array.isArray(entities)) entities = Object.values(entities);
    return entities;
}
function $ca04af99794d5fdc$var$getCurrent(value) {
    return (0, $kK8g8.isDraft)(value) ? (0, $kK8g8.current)(value) : value;
}
function $ca04af99794d5fdc$var$splitAddedUpdatedEntities(newEntities, selectId, state) {
    newEntities = $ca04af99794d5fdc$var$ensureEntitiesArray(newEntities);
    var existingIdsArray = $ca04af99794d5fdc$var$getCurrent(state.ids);
    var existingIds = new Set(existingIdsArray);
    var added = [];
    var addedIds = /* @__PURE__ */ new Set([]);
    var updated = [];
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = newEntities[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var entity = _step.value;
            var id = $ca04af99794d5fdc$var$selectIdValue(entity, selectId);
            if (existingIds.has(id) || addedIds.has(id)) updated.push({
                id: id,
                changes: entity
            });
            else {
                addedIds.add(id);
                added.push(entity);
            }
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    return [
        added,
        updated,
        existingIdsArray
    ];
}
// src/entities/unsorted_state_adapter.ts
function $ca04af99794d5fdc$var$createUnsortedStateAdapter(selectId) {
    function addOneMutably(entity, state) {
        var key = $ca04af99794d5fdc$var$selectIdValue(entity, selectId);
        if (key in state.entities) return;
        state.ids.push(key);
        state.entities[key] = entity;
    }
    function addManyMutably(newEntities, state) {
        newEntities = $ca04af99794d5fdc$var$ensureEntitiesArray(newEntities);
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            for(var _iterator = newEntities[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var entity = _step.value;
                addOneMutably(entity, state);
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
    }
    function setOneMutably(entity, state) {
        var key = $ca04af99794d5fdc$var$selectIdValue(entity, selectId);
        if (!(key in state.entities)) state.ids.push(key);
        state.entities[key] = entity;
    }
    function setManyMutably(newEntities, state) {
        newEntities = $ca04af99794d5fdc$var$ensureEntitiesArray(newEntities);
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            for(var _iterator = newEntities[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var entity = _step.value;
                setOneMutably(entity, state);
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
    }
    function setAllMutably(newEntities, state) {
        newEntities = $ca04af99794d5fdc$var$ensureEntitiesArray(newEntities);
        state.ids = [];
        state.entities = {};
        addManyMutably(newEntities, state);
    }
    function removeOneMutably(key, state) {
        return removeManyMutably([
            key
        ], state);
    }
    function removeManyMutably(keys, state) {
        var didMutate = false;
        keys.forEach(function(key) {
            if (key in state.entities) {
                delete state.entities[key];
                didMutate = true;
            }
        });
        if (didMutate) state.ids = state.ids.filter(function(id) {
            return id in state.entities;
        });
    }
    function removeAllMutably(state) {
        Object.assign(state, {
            ids: [],
            entities: {}
        });
    }
    function takeNewKey(keys, update, state) {
        var original3 = state.entities[update.id];
        if (original3 === void 0) return false;
        var updated = Object.assign({}, original3, update.changes);
        var newKey = $ca04af99794d5fdc$var$selectIdValue(updated, selectId);
        var hasNewKey = newKey !== update.id;
        if (hasNewKey) {
            keys[update.id] = newKey;
            delete state.entities[update.id];
        }
        state.entities[newKey] = updated;
        return hasNewKey;
    }
    function updateOneMutably(update, state) {
        return updateManyMutably([
            update
        ], state);
    }
    function updateManyMutably(updates, state) {
        var newKeys = {};
        var updatesPerEntity = {};
        updates.forEach(function(update) {
            var _a;
            if (update.id in state.entities) updatesPerEntity[update.id] = {
                id: update.id,
                // Spreads ignore falsy values, so this works even if there isn't
                // an existing update already at this key
                changes: $ca04af99794d5fdc$var$__spreadValues($ca04af99794d5fdc$var$__spreadValues({}, (_a = updatesPerEntity[update.id]) == null ? void 0 : _a.changes), update.changes)
            };
        });
        updates = Object.values(updatesPerEntity);
        var didMutateEntities = updates.length > 0;
        if (didMutateEntities) {
            var didMutateIds = updates.filter(function(update) {
                return takeNewKey(newKeys, update, state);
            }).length > 0;
            if (didMutateIds) state.ids = Object.values(state.entities).map(function(e) {
                return $ca04af99794d5fdc$var$selectIdValue(e, selectId);
            });
        }
    }
    function upsertOneMutably(entity, state) {
        return upsertManyMutably([
            entity
        ], state);
    }
    function upsertManyMutably(newEntities, state) {
        var _splitAddedUpdatedEntities = (0, $2nwvT._)($ca04af99794d5fdc$var$splitAddedUpdatedEntities(newEntities, selectId, state), 2), added = _splitAddedUpdatedEntities[0], updated = _splitAddedUpdatedEntities[1];
        addManyMutably(added, state);
        updateManyMutably(updated, state);
    }
    return {
        removeAll: $ca04af99794d5fdc$var$createSingleArgumentStateOperator(removeAllMutably),
        addOne: $ca04af99794d5fdc$var$createStateOperator(addOneMutably),
        addMany: $ca04af99794d5fdc$var$createStateOperator(addManyMutably),
        setOne: $ca04af99794d5fdc$var$createStateOperator(setOneMutably),
        setMany: $ca04af99794d5fdc$var$createStateOperator(setManyMutably),
        setAll: $ca04af99794d5fdc$var$createStateOperator(setAllMutably),
        updateOne: $ca04af99794d5fdc$var$createStateOperator(updateOneMutably),
        updateMany: $ca04af99794d5fdc$var$createStateOperator(updateManyMutably),
        upsertOne: $ca04af99794d5fdc$var$createStateOperator(upsertOneMutably),
        upsertMany: $ca04af99794d5fdc$var$createStateOperator(upsertManyMutably),
        removeOne: $ca04af99794d5fdc$var$createStateOperator(removeOneMutably),
        removeMany: $ca04af99794d5fdc$var$createStateOperator(removeManyMutably)
    };
}
// src/entities/sorted_state_adapter.ts
function $ca04af99794d5fdc$var$findInsertIndex(sortedItems, item, comparisonFunction) {
    var lowIndex = 0;
    var highIndex = sortedItems.length;
    while(lowIndex < highIndex){
        var middleIndex = lowIndex + highIndex >>> 1;
        var currentItem = sortedItems[middleIndex];
        var res = comparisonFunction(item, currentItem);
        if (res >= 0) lowIndex = middleIndex + 1;
        else highIndex = middleIndex;
    }
    return lowIndex;
}
function $ca04af99794d5fdc$var$insert(sortedItems, item, comparisonFunction) {
    var insertAtIndex = $ca04af99794d5fdc$var$findInsertIndex(sortedItems, item, comparisonFunction);
    sortedItems.splice(insertAtIndex, 0, item);
    return sortedItems;
}
function $ca04af99794d5fdc$var$createSortedStateAdapter(selectId, comparer) {
    var _createUnsortedStateAdapter = $ca04af99794d5fdc$var$createUnsortedStateAdapter(selectId), removeOne = _createUnsortedStateAdapter.removeOne, removeMany = _createUnsortedStateAdapter.removeMany, removeAll = _createUnsortedStateAdapter.removeAll;
    function addOneMutably(entity, state) {
        return addManyMutably([
            entity
        ], state);
    }
    function addManyMutably(newEntities, state, existingIds) {
        newEntities = $ca04af99794d5fdc$var$ensureEntitiesArray(newEntities);
        var existingKeys = new Set(existingIds != null ? existingIds : $ca04af99794d5fdc$var$getCurrent(state.ids));
        var addedKeys = /* @__PURE__ */ new Set();
        var models = newEntities.filter(function(model) {
            var modelId = $ca04af99794d5fdc$var$selectIdValue(model, selectId);
            var notAdded = !addedKeys.has(modelId);
            if (notAdded) addedKeys.add(modelId);
            return !existingKeys.has(modelId) && notAdded;
        });
        if (models.length !== 0) mergeFunction(state, models);
    }
    function setOneMutably(entity, state) {
        return setManyMutably([
            entity
        ], state);
    }
    function setManyMutably(newEntities, state) {
        var deduplicatedEntities = {};
        newEntities = $ca04af99794d5fdc$var$ensureEntitiesArray(newEntities);
        if (newEntities.length !== 0) {
            var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
            try {
                for(var _iterator = newEntities[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                    var item = _step.value;
                    var entityId = selectId(item);
                    deduplicatedEntities[entityId] = item;
                    delete state.entities[entityId];
                }
            } catch (err) {
                _didIteratorError = true;
                _iteratorError = err;
            } finally{
                try {
                    if (!_iteratorNormalCompletion && _iterator.return != null) {
                        _iterator.return();
                    }
                } finally{
                    if (_didIteratorError) {
                        throw _iteratorError;
                    }
                }
            }
            newEntities = $ca04af99794d5fdc$var$ensureEntitiesArray(deduplicatedEntities);
            mergeFunction(state, newEntities);
        }
    }
    function setAllMutably(newEntities, state) {
        newEntities = $ca04af99794d5fdc$var$ensureEntitiesArray(newEntities);
        state.entities = {};
        state.ids = [];
        addManyMutably(newEntities, state, []);
    }
    function updateOneMutably(update, state) {
        return updateManyMutably([
            update
        ], state);
    }
    function updateManyMutably(updates, state) {
        var appliedUpdates = false;
        var replacedIds = false;
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            for(var _iterator = updates[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var update = _step.value;
                var entity = state.entities[update.id];
                if (!entity) continue;
                appliedUpdates = true;
                Object.assign(entity, update.changes);
                var newId = selectId(entity);
                if (update.id !== newId) {
                    replacedIds = true;
                    delete state.entities[update.id];
                    var oldIndex = state.ids.indexOf(update.id);
                    state.ids[oldIndex] = newId;
                    state.entities[newId] = entity;
                }
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
        if (appliedUpdates) mergeFunction(state, [], appliedUpdates, replacedIds);
    }
    function upsertOneMutably(entity, state) {
        return upsertManyMutably([
            entity
        ], state);
    }
    function upsertManyMutably(newEntities, state) {
        var _splitAddedUpdatedEntities = (0, $2nwvT._)($ca04af99794d5fdc$var$splitAddedUpdatedEntities(newEntities, selectId, state), 3), added = _splitAddedUpdatedEntities[0], updated = _splitAddedUpdatedEntities[1], existingIdsArray = _splitAddedUpdatedEntities[2];
        if (added.length) addManyMutably(added, state, existingIdsArray);
        if (updated.length) updateManyMutably(updated, state);
    }
    function areArraysEqual(a, b) {
        if (a.length !== b.length) return false;
        for(var i = 0; i < a.length; i++){
            if (a[i] === b[i]) continue;
            return false;
        }
        return true;
    }
    var mergeFunction = function(state, addedItems, appliedUpdates, replacedIds) {
        var currentEntities = $ca04af99794d5fdc$var$getCurrent(state.entities);
        var currentIds = $ca04af99794d5fdc$var$getCurrent(state.ids);
        var stateEntities = state.entities;
        var ids = currentIds;
        if (replacedIds) ids = new Set(currentIds);
        var sortedEntities = [];
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            for(var _iterator = ids[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var id = _step.value;
                var entity = currentEntities[id];
                if (entity) sortedEntities.push(entity);
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
        var wasPreviouslyEmpty = sortedEntities.length === 0;
        var _iteratorNormalCompletion1 = true, _didIteratorError1 = false, _iteratorError1 = undefined;
        try {
            for(var _iterator1 = addedItems[Symbol.iterator](), _step1; !(_iteratorNormalCompletion1 = (_step1 = _iterator1.next()).done); _iteratorNormalCompletion1 = true){
                var item = _step1.value;
                stateEntities[selectId(item)] = item;
                if (!wasPreviouslyEmpty) $ca04af99794d5fdc$var$insert(sortedEntities, item, comparer);
            }
        } catch (err) {
            _didIteratorError1 = true;
            _iteratorError1 = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion1 && _iterator1.return != null) {
                    _iterator1.return();
                }
            } finally{
                if (_didIteratorError1) {
                    throw _iteratorError1;
                }
            }
        }
        if (wasPreviouslyEmpty) sortedEntities = addedItems.slice().sort(comparer);
        else if (appliedUpdates) sortedEntities.sort(comparer);
        var newSortedIds = sortedEntities.map(selectId);
        if (!areArraysEqual(currentIds, newSortedIds)) state.ids = newSortedIds;
    };
    return {
        removeOne: removeOne,
        removeMany: removeMany,
        removeAll: removeAll,
        addOne: $ca04af99794d5fdc$var$createStateOperator(addOneMutably),
        updateOne: $ca04af99794d5fdc$var$createStateOperator(updateOneMutably),
        upsertOne: $ca04af99794d5fdc$var$createStateOperator(upsertOneMutably),
        setOne: $ca04af99794d5fdc$var$createStateOperator(setOneMutably),
        setMany: $ca04af99794d5fdc$var$createStateOperator(setManyMutably),
        setAll: $ca04af99794d5fdc$var$createStateOperator(setAllMutably),
        addMany: $ca04af99794d5fdc$var$createStateOperator(addManyMutably),
        updateMany: $ca04af99794d5fdc$var$createStateOperator(updateManyMutably),
        upsertMany: $ca04af99794d5fdc$var$createStateOperator(upsertManyMutably)
    };
}
// src/entities/create_adapter.ts
function $ca04af99794d5fdc$export$abcf4037b41e0df() {
    var options = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    var __spreadValues1 = $ca04af99794d5fdc$var$__spreadValues({
        sortComparer: false,
        selectId: function(instance) {
            return instance.id;
        }
    }, options), selectId = __spreadValues1.selectId, sortComparer = __spreadValues1.sortComparer;
    var stateAdapter = sortComparer ? $ca04af99794d5fdc$var$createSortedStateAdapter(selectId, sortComparer) : $ca04af99794d5fdc$var$createUnsortedStateAdapter(selectId);
    var stateFactory = $ca04af99794d5fdc$var$createInitialStateFactory(stateAdapter);
    var selectorsFactory = $ca04af99794d5fdc$var$createSelectorsFactory();
    return $ca04af99794d5fdc$var$__spreadValues($ca04af99794d5fdc$var$__spreadValues($ca04af99794d5fdc$var$__spreadValues({
        selectId: selectId,
        sortComparer: sortComparer
    }, stateFactory), selectorsFactory), stateAdapter);
}
// src/listenerMiddleware/exceptions.ts
var $ca04af99794d5fdc$var$task = "task";
var $ca04af99794d5fdc$var$listener = "listener";
var $ca04af99794d5fdc$var$completed = "completed";
var $ca04af99794d5fdc$var$cancelled = "cancelled";
var $ca04af99794d5fdc$var$taskCancelled = "task-".concat($ca04af99794d5fdc$var$cancelled);
var $ca04af99794d5fdc$var$taskCompleted = "task-".concat($ca04af99794d5fdc$var$completed);
var $ca04af99794d5fdc$var$listenerCancelled = "".concat($ca04af99794d5fdc$var$listener, "-").concat($ca04af99794d5fdc$var$cancelled);
var $ca04af99794d5fdc$var$listenerCompleted = "".concat($ca04af99794d5fdc$var$listener, "-").concat($ca04af99794d5fdc$var$completed);
var $ca04af99794d5fdc$export$cb1bdac908fed7f = function TaskAbortError(code) {
    "use strict";
    (0, $grujF._)(this, TaskAbortError);
    this.code = code;
    $ca04af99794d5fdc$var$__publicField(this, "name", "TaskAbortError");
    $ca04af99794d5fdc$var$__publicField(this, "message");
    this.message = "".concat($ca04af99794d5fdc$var$task, " ").concat($ca04af99794d5fdc$var$cancelled, " (reason: ").concat(code, ")");
};
// src/listenerMiddleware/utils.ts
var $ca04af99794d5fdc$var$assertFunction = function(func, expected) {
    if (typeof func !== "function") throw new TypeError($ca04af99794d5fdc$export$378fa86b259c0280(32));
};
var $ca04af99794d5fdc$var$noop2 = function() {};
var $ca04af99794d5fdc$var$catchRejection = function(promise) {
    var onError = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : $ca04af99794d5fdc$var$noop2;
    promise.catch(onError);
    return promise;
};
var $ca04af99794d5fdc$var$addAbortSignalListener = function(abortSignal, callback) {
    abortSignal.addEventListener("abort", callback, {
        once: true
    });
    return function() {
        return abortSignal.removeEventListener("abort", callback);
    };
};
// src/listenerMiddleware/task.ts
var $ca04af99794d5fdc$var$validateActive = function(signal) {
    if (signal.aborted) throw new $ca04af99794d5fdc$export$cb1bdac908fed7f(signal.reason);
};
function $ca04af99794d5fdc$var$raceWithSignal(signal, promise) {
    var cleanup = $ca04af99794d5fdc$var$noop2;
    return new Promise(function(resolve, reject) {
        var notifyRejection = function() {
            return reject(new $ca04af99794d5fdc$export$cb1bdac908fed7f(signal.reason));
        };
        if (signal.aborted) {
            notifyRejection();
            return;
        }
        cleanup = $ca04af99794d5fdc$var$addAbortSignalListener(signal, notifyRejection);
        promise.finally(function() {
            return cleanup();
        }).then(resolve, reject);
    }).finally(function() {
        cleanup = $ca04af99794d5fdc$var$noop2;
    });
}
var $ca04af99794d5fdc$var$runTask = function(task2, cleanUp) {
    return (/*#__PURE__*/ 0, /*#__PURE__*/ $g3gsR._)(function() {
        var value, error;
        return (0, $fRv9I.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    _state.trys.push([
                        0,
                        3,
                        4,
                        5
                    ]);
                    return [
                        4,
                        Promise.resolve()
                    ];
                case 1:
                    _state.sent();
                    return [
                        4,
                        task2()
                    ];
                case 2:
                    value = _state.sent();
                    return [
                        2,
                        {
                            status: "ok",
                            value: value
                        }
                    ];
                case 3:
                    error = _state.sent();
                    return [
                        2,
                        {
                            status: error instanceof $ca04af99794d5fdc$export$cb1bdac908fed7f ? "cancelled" : "rejected",
                            error: error
                        }
                    ];
                case 4:
                    cleanUp == null || cleanUp();
                    return [
                        7
                    ];
                case 5:
                    return [
                        2
                    ];
            }
        });
    })();
};
var $ca04af99794d5fdc$var$createPause = function(signal) {
    return function(promise) {
        return $ca04af99794d5fdc$var$catchRejection($ca04af99794d5fdc$var$raceWithSignal(signal, promise).then(function(output) {
            $ca04af99794d5fdc$var$validateActive(signal);
            return output;
        }));
    };
};
var $ca04af99794d5fdc$var$createDelay = function(signal) {
    var pause = $ca04af99794d5fdc$var$createPause(signal);
    return function(timeoutMs) {
        return pause(new Promise(function(resolve) {
            return setTimeout(resolve, timeoutMs);
        }));
    };
};
// src/listenerMiddleware/index.ts
var $ca04af99794d5fdc$var$assign = Object.assign;
var $ca04af99794d5fdc$var$INTERNAL_NIL_TOKEN = {};
var $ca04af99794d5fdc$var$alm = "listenerMiddleware";
var $ca04af99794d5fdc$var$createFork = function(parentAbortSignal, parentBlockingPromises) {
    var linkControllers = function(controller) {
        return $ca04af99794d5fdc$var$addAbortSignalListener(parentAbortSignal, function() {
            return controller.abort(parentAbortSignal.reason);
        });
    };
    return function(taskExecutor, opts) {
        $ca04af99794d5fdc$var$assertFunction(taskExecutor, "taskExecutor");
        var childAbortController = new AbortController();
        linkControllers(childAbortController);
        var result = $ca04af99794d5fdc$var$runTask(function() {
            return (/*#__PURE__*/ 0, /*#__PURE__*/ $g3gsR._)(function() {
                var result2;
                return (0, $fRv9I.__generator)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            $ca04af99794d5fdc$var$validateActive(parentAbortSignal);
                            $ca04af99794d5fdc$var$validateActive(childAbortController.signal);
                            return [
                                4,
                                taskExecutor({
                                    pause: $ca04af99794d5fdc$var$createPause(childAbortController.signal),
                                    delay: $ca04af99794d5fdc$var$createDelay(childAbortController.signal),
                                    signal: childAbortController.signal
                                })
                            ];
                        case 1:
                            result2 = _state.sent();
                            $ca04af99794d5fdc$var$validateActive(childAbortController.signal);
                            return [
                                2,
                                result2
                            ];
                    }
                });
            })();
        }, function() {
            return childAbortController.abort($ca04af99794d5fdc$var$taskCompleted);
        });
        if (opts == null ? void 0 : opts.autoJoin) parentBlockingPromises.push(result.catch($ca04af99794d5fdc$var$noop2));
        return {
            result: $ca04af99794d5fdc$var$createPause(parentAbortSignal)(result),
            cancel: function() {
                childAbortController.abort($ca04af99794d5fdc$var$taskCancelled);
            }
        };
    };
};
var $ca04af99794d5fdc$var$createTakePattern = function(startListening, signal) {
    var take = function(predicate, timeout) {
        return (/*#__PURE__*/ 0, /*#__PURE__*/ $g3gsR._)(function() {
            var unsubscribe, tuplePromise, promises, output;
            return (0, $fRv9I.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        $ca04af99794d5fdc$var$validateActive(signal);
                        unsubscribe = function() {};
                        tuplePromise = new Promise(function(resolve, reject) {
                            var stopListening = startListening({
                                predicate: predicate,
                                effect: function(action, listenerApi) {
                                    listenerApi.unsubscribe();
                                    resolve([
                                        action,
                                        listenerApi.getState(),
                                        listenerApi.getOriginalState()
                                    ]);
                                }
                            });
                            unsubscribe = function() {
                                stopListening();
                                reject();
                            };
                        });
                        promises = [
                            tuplePromise
                        ];
                        if (timeout != null) promises.push(new Promise(function(resolve) {
                            return setTimeout(resolve, timeout, null);
                        }));
                        _state.label = 1;
                    case 1:
                        _state.trys.push([
                            1,
                            ,
                            3,
                            4
                        ]);
                        return [
                            4,
                            $ca04af99794d5fdc$var$raceWithSignal(signal, Promise.race(promises))
                        ];
                    case 2:
                        output = _state.sent();
                        $ca04af99794d5fdc$var$validateActive(signal);
                        return [
                            2,
                            output
                        ];
                    case 3:
                        unsubscribe();
                        return [
                            7
                        ];
                    case 4:
                        return [
                            2
                        ];
                }
            });
        })();
    };
    return function(predicate, timeout) {
        return $ca04af99794d5fdc$var$catchRejection(take(predicate, timeout));
    };
};
var $ca04af99794d5fdc$var$getListenerEntryPropsFrom = function(options) {
    var type = options.type, actionCreator = options.actionCreator, matcher = options.matcher, predicate = options.predicate, effect = options.effect;
    if (type) predicate = $ca04af99794d5fdc$export$309c7a02b0b0bc62(type).match;
    else if (actionCreator) {
        type = actionCreator.type;
        predicate = actionCreator.match;
    } else if (matcher) predicate = matcher;
    else if (predicate) ;
    else throw new Error($ca04af99794d5fdc$export$378fa86b259c0280(21));
    $ca04af99794d5fdc$var$assertFunction(effect, "options.listener");
    return {
        predicate: predicate,
        type: type,
        effect: effect
    };
};
var $ca04af99794d5fdc$var$createListenerEntry = /* @__PURE__ */ $ca04af99794d5fdc$var$assign(function(options) {
    var _getListenerEntryPropsFrom = $ca04af99794d5fdc$var$getListenerEntryPropsFrom(options), type = _getListenerEntryPropsFrom.type, predicate = _getListenerEntryPropsFrom.predicate, effect = _getListenerEntryPropsFrom.effect;
    var entry = {
        id: $ca04af99794d5fdc$export$ac4959f4f1338dfc(),
        effect: effect,
        type: type,
        predicate: predicate,
        pending: /* @__PURE__ */ new Set(),
        unsubscribe: function() {
            throw new Error($ca04af99794d5fdc$export$378fa86b259c0280(22));
        }
    };
    return entry;
}, {
    withTypes: function() {
        return $ca04af99794d5fdc$var$createListenerEntry;
    }
});
var $ca04af99794d5fdc$var$findListenerEntry = function(listenerMap, options) {
    var _getListenerEntryPropsFrom = $ca04af99794d5fdc$var$getListenerEntryPropsFrom(options), type = _getListenerEntryPropsFrom.type, effect = _getListenerEntryPropsFrom.effect, predicate = _getListenerEntryPropsFrom.predicate;
    return Array.from(listenerMap.values()).find(function(entry) {
        var matchPredicateOrType = typeof type === "string" ? entry.type === type : entry.predicate === predicate;
        return matchPredicateOrType && entry.effect === effect;
    });
};
var $ca04af99794d5fdc$var$cancelActiveListeners = function(entry) {
    entry.pending.forEach(function(controller) {
        controller.abort($ca04af99794d5fdc$var$listenerCancelled);
    });
};
var $ca04af99794d5fdc$var$createClearListenerMiddleware = function(listenerMap, executingListeners) {
    return function() {
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            for(var _iterator = executingListeners.keys()[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var listener2 = _step.value;
                $ca04af99794d5fdc$var$cancelActiveListeners(listener2);
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
        listenerMap.clear();
    };
};
var $ca04af99794d5fdc$var$safelyNotifyError = function(errorHandler, errorToNotify, errorInfo) {
    try {
        errorHandler(errorToNotify, errorInfo);
    } catch (errorHandlerError) {
        setTimeout(function() {
            throw errorHandlerError;
        }, 0);
    }
};
var $ca04af99794d5fdc$export$f03a6b845d3fb58b = /* @__PURE__ */ $ca04af99794d5fdc$var$assign(/* @__PURE__ */ $ca04af99794d5fdc$export$309c7a02b0b0bc62("".concat($ca04af99794d5fdc$var$alm, "/add")), {
    withTypes: function() {
        return $ca04af99794d5fdc$export$f03a6b845d3fb58b;
    }
});
var $ca04af99794d5fdc$export$b1b8022855fb2b71 = /* @__PURE__ */ $ca04af99794d5fdc$export$309c7a02b0b0bc62("".concat($ca04af99794d5fdc$var$alm, "/removeAll"));
var $ca04af99794d5fdc$export$b03e9483f936dccb = /* @__PURE__ */ $ca04af99794d5fdc$var$assign(/* @__PURE__ */ $ca04af99794d5fdc$export$309c7a02b0b0bc62("".concat($ca04af99794d5fdc$var$alm, "/remove")), {
    withTypes: function() {
        return $ca04af99794d5fdc$export$b03e9483f936dccb;
    }
});
var $ca04af99794d5fdc$var$defaultErrorHandler = function() {
    for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
        args[_key] = arguments[_key];
    }
    var _console;
    (_console = console).error.apply(_console, [
        "".concat($ca04af99794d5fdc$var$alm, "/error")
    ].concat((0, $2us1u._)(args)));
};
var $ca04af99794d5fdc$export$1228acebbbcb485b = function() {
    var middlewareOptions = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    var listenerMap = /* @__PURE__ */ new Map();
    var executingListeners = /* @__PURE__ */ new Map();
    var trackExecutingListener = function(entry) {
        var _a;
        var count = (_a = executingListeners.get(entry)) != null ? _a : 0;
        executingListeners.set(entry, count + 1);
    };
    var untrackExecutingListener = function(entry) {
        var _a;
        var count = (_a = executingListeners.get(entry)) != null ? _a : 1;
        if (count === 1) executingListeners.delete(entry);
        else executingListeners.set(entry, count - 1);
    };
    var extra = middlewareOptions.extra, _middlewareOptions_onError = middlewareOptions.onError, onError = _middlewareOptions_onError === void 0 ? $ca04af99794d5fdc$var$defaultErrorHandler : _middlewareOptions_onError;
    $ca04af99794d5fdc$var$assertFunction(onError, "onError");
    var insertEntry = function(entry) {
        entry.unsubscribe = function() {
            return listenerMap.delete(entry.id);
        };
        listenerMap.set(entry.id, entry);
        return function(cancelOptions) {
            entry.unsubscribe();
            if (cancelOptions == null ? void 0 : cancelOptions.cancelActive) $ca04af99794d5fdc$var$cancelActiveListeners(entry);
        };
    };
    var startListening = function(options) {
        var _a;
        var entry = (_a = $ca04af99794d5fdc$var$findListenerEntry(listenerMap, options)) != null ? _a : $ca04af99794d5fdc$var$createListenerEntry(options);
        return insertEntry(entry);
    };
    $ca04af99794d5fdc$var$assign(startListening, {
        withTypes: function() {
            return startListening;
        }
    });
    var stopListening = function(options) {
        var entry = $ca04af99794d5fdc$var$findListenerEntry(listenerMap, options);
        if (entry) {
            entry.unsubscribe();
            if (options.cancelActive) $ca04af99794d5fdc$var$cancelActiveListeners(entry);
        }
        return !!entry;
    };
    $ca04af99794d5fdc$var$assign(stopListening, {
        withTypes: function() {
            return stopListening;
        }
    });
    var notifyListener = function(entry, action, api, getOriginalState) {
        return (/*#__PURE__*/ 0, /*#__PURE__*/ $g3gsR._)(function() {
            var internalTaskController, take, autoJoinPromises, listenerError;
            return (0, $fRv9I.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        internalTaskController = new AbortController();
                        take = $ca04af99794d5fdc$var$createTakePattern(startListening, internalTaskController.signal);
                        autoJoinPromises = [];
                        _state.label = 1;
                    case 1:
                        _state.trys.push([
                            1,
                            3,
                            4,
                            6
                        ]);
                        entry.pending.add(internalTaskController);
                        trackExecutingListener(entry);
                        return [
                            4,
                            Promise.resolve(entry.effect(action, // Use assign() rather than ... to avoid extra helper functions added to bundle
                            $ca04af99794d5fdc$var$assign({}, api, {
                                getOriginalState: getOriginalState,
                                condition: function(predicate, timeout) {
                                    return take(predicate, timeout).then(Boolean);
                                },
                                take: take,
                                delay: $ca04af99794d5fdc$var$createDelay(internalTaskController.signal),
                                pause: $ca04af99794d5fdc$var$createPause(internalTaskController.signal),
                                extra: extra,
                                signal: internalTaskController.signal,
                                fork: $ca04af99794d5fdc$var$createFork(internalTaskController.signal, autoJoinPromises),
                                unsubscribe: entry.unsubscribe,
                                subscribe: function() {
                                    listenerMap.set(entry.id, entry);
                                },
                                cancelActiveListeners: function() {
                                    entry.pending.forEach(function(controller, _, set) {
                                        if (controller !== internalTaskController) {
                                            controller.abort($ca04af99794d5fdc$var$listenerCancelled);
                                            set.delete(controller);
                                        }
                                    });
                                },
                                cancel: function() {
                                    internalTaskController.abort($ca04af99794d5fdc$var$listenerCancelled);
                                    entry.pending.delete(internalTaskController);
                                },
                                throwIfCancelled: function() {
                                    $ca04af99794d5fdc$var$validateActive(internalTaskController.signal);
                                }
                            })))
                        ];
                    case 2:
                        _state.sent();
                        return [
                            3,
                            6
                        ];
                    case 3:
                        listenerError = _state.sent();
                        if (!(listenerError instanceof $ca04af99794d5fdc$export$cb1bdac908fed7f)) $ca04af99794d5fdc$var$safelyNotifyError(onError, listenerError, {
                            raisedBy: "effect"
                        });
                        return [
                            3,
                            6
                        ];
                    case 4:
                        return [
                            4,
                            Promise.all(autoJoinPromises)
                        ];
                    case 5:
                        _state.sent();
                        internalTaskController.abort($ca04af99794d5fdc$var$listenerCompleted);
                        untrackExecutingListener(entry);
                        entry.pending.delete(internalTaskController);
                        return [
                            7
                        ];
                    case 6:
                        return [
                            2
                        ];
                }
            });
        })();
    };
    var clearListenerMiddleware = $ca04af99794d5fdc$var$createClearListenerMiddleware(listenerMap, executingListeners);
    var middleware = function(api) {
        return function(next) {
            return function(action) {
                if (!(0, $20ec22595b3da151$export$b956e38827fca970)(action)) return next(action);
                if ($ca04af99794d5fdc$export$f03a6b845d3fb58b.match(action)) return startListening(action.payload);
                if ($ca04af99794d5fdc$export$b1b8022855fb2b71.match(action)) {
                    clearListenerMiddleware();
                    return;
                }
                if ($ca04af99794d5fdc$export$b03e9483f936dccb.match(action)) return stopListening(action.payload);
                var originalState = api.getState();
                var getOriginalState = function() {
                    if (originalState === $ca04af99794d5fdc$var$INTERNAL_NIL_TOKEN) throw new Error($ca04af99794d5fdc$export$378fa86b259c0280(23));
                    return originalState;
                };
                var result;
                try {
                    result = next(action);
                    if (listenerMap.size > 0) {
                        var currentState = api.getState();
                        var listenerEntries = Array.from(listenerMap.values());
                        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                        try {
                            for(var _iterator = listenerEntries[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                                var entry = _step.value;
                                var runListener = false;
                                try {
                                    runListener = entry.predicate(action, currentState, originalState);
                                } catch (predicateError) {
                                    runListener = false;
                                    $ca04af99794d5fdc$var$safelyNotifyError(onError, predicateError, {
                                        raisedBy: "predicate"
                                    });
                                }
                                if (!runListener) continue;
                                notifyListener(entry, action, api, getOriginalState);
                            }
                        } catch (err) {
                            _didIteratorError = true;
                            _iteratorError = err;
                        } finally{
                            try {
                                if (!_iteratorNormalCompletion && _iterator.return != null) {
                                    _iterator.return();
                                }
                            } finally{
                                if (_didIteratorError) {
                                    throw _iteratorError;
                                }
                            }
                        }
                    }
                } finally{
                    originalState = $ca04af99794d5fdc$var$INTERNAL_NIL_TOKEN;
                }
                return result;
            };
        };
    };
    return {
        middleware: middleware,
        startListening: startListening,
        stopListening: stopListening,
        clearListeners: clearListenerMiddleware
    };
};
// src/dynamicMiddleware/index.ts
var $ca04af99794d5fdc$var$createMiddlewareEntry = function(middleware) {
    return {
        middleware: middleware,
        applied: /* @__PURE__ */ new Map()
    };
};
var $ca04af99794d5fdc$var$matchInstance = function(instanceId) {
    return function(action) {
        var _a;
        return ((_a = action == null ? void 0 : action.meta) == null ? void 0 : _a.instanceId) === instanceId;
    };
};
var $ca04af99794d5fdc$export$4bb1606a79445586 = function() {
    var instanceId = $ca04af99794d5fdc$export$ac4959f4f1338dfc();
    var middlewareMap = /* @__PURE__ */ new Map();
    var withMiddleware = Object.assign($ca04af99794d5fdc$export$309c7a02b0b0bc62("dynamicMiddleware/add", function() {
        for(var _len = arguments.length, middlewares = new Array(_len), _key = 0; _key < _len; _key++){
            middlewares[_key] = arguments[_key];
        }
        return {
            payload: middlewares,
            meta: {
                instanceId: instanceId
            }
        };
    }), {
        withTypes: function() {
            return withMiddleware;
        }
    });
    var addMiddleware = Object.assign(function addMiddleware2() {
        for(var _len = arguments.length, middlewares = new Array(_len), _key = 0; _key < _len; _key++){
            middlewares[_key] = arguments[_key];
        }
        middlewares.forEach(function(middleware2) {
            $ca04af99794d5fdc$var$getOrInsertComputed(middlewareMap, middleware2, $ca04af99794d5fdc$var$createMiddlewareEntry);
        });
    }, {
        withTypes: function() {
            return addMiddleware;
        }
    });
    var getFinalMiddleware = function(api) {
        var appliedMiddleware = Array.from(middlewareMap.values()).map(function(entry) {
            return $ca04af99794d5fdc$var$getOrInsertComputed(entry.applied, api, entry.middleware);
        });
        return (0, $20ec22595b3da151$export$f672e0b6f7222cd7).apply(void 0, (0, $2us1u._)(appliedMiddleware));
    };
    var isWithMiddleware = $ca04af99794d5fdc$export$9dd1fb32974da385(withMiddleware, $ca04af99794d5fdc$var$matchInstance(instanceId));
    var middleware = function(api) {
        return function(next) {
            return function(action) {
                if (isWithMiddleware(action)) {
                    addMiddleware.apply(void 0, (0, $2us1u._)(action.payload));
                    return api.dispatch;
                }
                return getFinalMiddleware(api)(next)(action);
            };
        };
    };
    return {
        middleware: middleware,
        addMiddleware: addMiddleware,
        withMiddleware: withMiddleware,
        instanceId: instanceId
    };
};
var $ca04af99794d5fdc$var$isSliceLike = function(maybeSliceLike) {
    return "reducerPath" in maybeSliceLike && typeof maybeSliceLike.reducerPath === "string";
};
var $ca04af99794d5fdc$var$getReducers = function(slices) {
    return slices.flatMap(function(sliceOrMap) {
        return $ca04af99794d5fdc$var$isSliceLike(sliceOrMap) ? [
            [
                sliceOrMap.reducerPath,
                sliceOrMap.reducer
            ]
        ] : Object.entries(sliceOrMap);
    });
};
var $ca04af99794d5fdc$var$ORIGINAL_STATE = Symbol.for("rtk-state-proxy-original");
var $ca04af99794d5fdc$var$isStateProxy = function(value) {
    return !!value && !!value[$ca04af99794d5fdc$var$ORIGINAL_STATE];
};
var $ca04af99794d5fdc$var$stateProxyMap = /* @__PURE__ */ new WeakMap();
var $ca04af99794d5fdc$var$createStateProxy = function(state, reducerMap, initialStateCache) {
    return $ca04af99794d5fdc$var$getOrInsertComputed($ca04af99794d5fdc$var$stateProxyMap, state, function() {
        return new Proxy(state, {
            get: function(target, prop, receiver) {
                if (prop === $ca04af99794d5fdc$var$ORIGINAL_STATE) return target;
                var result = Reflect.get(target, prop, receiver);
                if (typeof result === "undefined") {
                    var cached = initialStateCache[prop];
                    if (typeof cached !== "undefined") return cached;
                    var reducer = reducerMap[prop];
                    if (reducer) {
                        var reducerResult = reducer(void 0, {
                            type: $ca04af99794d5fdc$export$ac4959f4f1338dfc()
                        });
                        if (typeof reducerResult === "undefined") throw new Error($ca04af99794d5fdc$export$378fa86b259c0280(24));
                        initialStateCache[prop] = reducerResult;
                        return reducerResult;
                    }
                }
                return result;
            }
        });
    });
};
var $ca04af99794d5fdc$var$original = function(state) {
    if (!$ca04af99794d5fdc$var$isStateProxy(state)) throw new Error($ca04af99794d5fdc$export$378fa86b259c0280(25));
    return state[$ca04af99794d5fdc$var$ORIGINAL_STATE];
};
var $ca04af99794d5fdc$var$emptyObject = {};
var $ca04af99794d5fdc$var$noopReducer = function() {
    var state = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : $ca04af99794d5fdc$var$emptyObject;
    return state;
};
function $ca04af99794d5fdc$export$a3734c7614660b9() {
    for(var _len = arguments.length, slices = new Array(_len), _key = 0; _key < _len; _key++){
        slices[_key] = arguments[_key];
    }
    var reducerMap = Object.fromEntries($ca04af99794d5fdc$var$getReducers(slices));
    var getReducer = function() {
        return Object.keys(reducerMap).length ? (0, $20ec22595b3da151$export$66e4520cdb265d18)(reducerMap) : $ca04af99794d5fdc$var$noopReducer;
    };
    var reducer = getReducer();
    function combinedReducer(state, action) {
        return reducer(state, action);
    }
    combinedReducer.withLazyLoadedSlices = function() {
        return combinedReducer;
    };
    var initialStateCache = {};
    var inject = function(slice) {
        var config = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
        var reducerPath = slice.reducerPath, reducerToInject = slice.reducer;
        var currentReducer = reducerMap[reducerPath];
        if (!config.overrideExisting && currentReducer && currentReducer !== reducerToInject) return combinedReducer;
        if (config.overrideExisting && currentReducer !== reducerToInject) delete initialStateCache[reducerPath];
        reducerMap[reducerPath] = reducerToInject;
        reducer = getReducer();
        return combinedReducer;
    };
    var selector = Object.assign(function makeSelector(selectorFn, selectState) {
        return function selector2(state) {
            for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++){
                args[_key - 1] = arguments[_key];
            }
            return selectorFn.apply(void 0, [
                $ca04af99794d5fdc$var$createStateProxy(selectState ? selectState.apply(void 0, [
                    state
                ].concat((0, $2us1u._)(args))) : state, reducerMap, initialStateCache)
            ].concat((0, $2us1u._)(args)));
        };
    }, {
        original: $ca04af99794d5fdc$var$original
    });
    return Object.assign(combinedReducer, {
        inject: inject,
        selector: selector
    });
}
// src/formatProdErrorMessage.ts
function $ca04af99794d5fdc$export$378fa86b259c0280(code) {
    return "Minified Redux Toolkit error #".concat(code, "; visit https://redux-toolkit.js.org/Errors?code=").concat(code, " for the full message or use the non-minified dev environment for full errors. ");
}


// Creating a slice for cart-related state
var $8fe106648971a0a5$var$cartSlice = (0, $ca04af99794d5fdc$export$4d8d9bd83c24ae8b)({
    // Name of the slice (used as a key in the Redux store)
    name: "cart",
    // Initial state of the cart
    initialState: {
        items: []
    },
    // Reducer functions to update the cart state
    reducers: {
        // Adds a new item to the cart
        // action.payload contains the item data
        addItem: function(state, action) {
            state.items.push(action.payload);
        },
        // Removes the last item from the cart
        removeItem: function(state) {
            state.items.pop();
        },
        // Clears all items from the cart
        // originalState = ["pizza"]
        clearCart: function(state, action) {
            //   state.items.length = 0;
            return {
                items: []
            };
        }
    }
});
var $8fe106648971a0a5$var$_cartSlice_actions = $8fe106648971a0a5$var$cartSlice.actions;
var $8fe106648971a0a5$export$fb9705de59d96855 = $8fe106648971a0a5$var$_cartSlice_actions.addItem, $8fe106648971a0a5$export$fe2d9b4e03920b4c = $8fe106648971a0a5$var$_cartSlice_actions.removeItem, $8fe106648971a0a5$export$810121176e3e3671 = $8fe106648971a0a5$var$_cartSlice_actions.clearCart;
var // Export reducer to update the Redux store
$8fe106648971a0a5$export$2e2bcd8739ae039 = $8fe106648971a0a5$var$cartSlice.reducer;


var $eda82bff2a7d3f82$var$MenuItem = function(param) {
    var menuInfo = param.menuInfo, _param_showAddButton = param.showAddButton, showAddButton = _param_showAddButton === void 0 ? true : _param_showAddButton;
    var _ratings_aggregatedRating;
    if (!menuInfo) return null;
    var IMG_URL = "https://media-assets.swiggy.com/swiggy/image/upload/fl_lossy,f_auto,q_auto,w_300,h_300,c_fit/";
    var name = menuInfo.name, price = menuInfo.price, description = menuInfo.description, imageId = menuInfo.imageId, _menuInfo_ratings = menuInfo.ratings, ratings = _menuInfo_ratings === void 0 ? {} : _menuInfo_ratings;
    var dispatch = (0, $d7d37dc522b09008$export$8ad76b76a4c905f8)();
    return /*#__PURE__*/ (0, $iD4WH.jsxs)("li", {
        role: "button",
        tabIndex: 0,
        className: " my-7 flex justify-between gap-8 py-5 px-7 bg-white  rounded-3xl  shadow-[0_6px_14px_-6px_rgba(0,0,0,0.18)] hover:shadow-[0_10px_20px_-8px_rgba(0,0,0,0.28)]  cursor-pointer transition-shadow duration-300 ease-in-out  font-['Segoe_UI',Tahoma,Geneva,Verdana,sans-serif] ",
        children: [
            /*#__PURE__*/ (0, $iD4WH.jsxs)("div", {
                className: "flex-1",
                children: [
                    /*#__PURE__*/ (0, $iD4WH.jsx)("h4", {
                        className: "text-lg font-bold text-[#242323]",
                        children: name
                    }),
                    price && /*#__PURE__*/ (0, $iD4WH.jsxs)("p", {
                        className: "mt-1 font-medium",
                        children: [
                            "\u20B9",
                            (price / 100).toFixed(2),
                            "/_ only"
                        ]
                    }),
                    (ratings === null || ratings === void 0 ? void 0 : (_ratings_aggregatedRating = ratings.aggregatedRating) === null || _ratings_aggregatedRating === void 0 ? void 0 : _ratings_aggregatedRating.rating) && /*#__PURE__*/ (0, $iD4WH.jsxs)("p", {
                        className: "mt-1",
                        children: [
                            ratings.aggregatedRating.rating,
                            " \u2B50 (",
                            ratings.aggregatedRating.ratingCountV2,
                            ")"
                        ]
                    }),
                    description && /*#__PURE__*/ (0, $iD4WH.jsx)("p", {
                        className: "mt-2 pr-10 text-[#242323] text-sm leading-relaxed",
                        children: description
                    })
                ]
            }),
            imageId && /*#__PURE__*/ (0, $iD4WH.jsxs)("div", {
                className: "relative",
                children: [
                    /*#__PURE__*/ (0, $iD4WH.jsx)("img", {
                        src: IMG_URL + imageId,
                        alt: name,
                        className: " w-[140px] h-[120px] object-cover rounded-[15px] shadow-[0_8px_12px_rgba(0,0,0,0.2)] "
                    }),
                    showAddButton && /*#__PURE__*/ (0, $iD4WH.jsx)("button", {
                        onClick: function() {
                            return dispatch((0, $8fe106648971a0a5$export$fb9705de59d96855)(menuInfo));
                        },
                        className: " absolute -bottom-3 left-1/2 -translate-x-1/2 bg-white text-green-600 font-bold px-6 py-1 rounded-lg shadow-md hover:shadow-lg active:scale-95 transition ",
                        children: "ADD +"
                    })
                ]
            })
        ]
    });
};
var $eda82bff2a7d3f82$export$2e2bcd8739ae039 = $eda82bff2a7d3f82$var$MenuItem;


var $47c5ed635e286aeb$var$ItemCategory = function(param) {
    var data = param.data, isOpen = param.isOpen, onToggle = param.onToggle, addToCart = param.addToCart;
    var title = data.title, _data_itemCards = data.itemCards, itemCards = _data_itemCards === void 0 ? [] : _data_itemCards;
    return /*#__PURE__*/ (0, $iD4WH.jsxs)("div", {
        className: "mb-4 bg-gray-100 rounded-xl shadow-sm",
        children: [
            /*#__PURE__*/ (0, $iD4WH.jsxs)("div", {
                onClick: onToggle,
                className: "flex justify-between items-center px-6 py-4 cursor-pointer",
                children: [
                    /*#__PURE__*/ (0, $iD4WH.jsxs)("h2", {
                        className: "text-lg font-bold text-black",
                        children: [
                            title,
                            " (",
                            itemCards.length,
                            ")"
                        ]
                    }),
                    /*#__PURE__*/ (0, $iD4WH.jsx)("div", {
                        className: "w-7 h-7 flex items-center justify-center bg-black rounded-full",
                        children: /*#__PURE__*/ (0, $iD4WH.jsx)("img", {
                            width: "30",
                            height: "30",
                            src: "https://img.icons8.com/sf-regular-filled/48/circled-chevron-up.png",
                            alt: "toggle-arrow",
                            className: "transition-transform duration-300 ".concat(isOpen ? "rotate-180" : "rotate-0")
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, $iD4WH.jsx)("div", {
                className: "border-t border-gray-300 mx-6"
            }),
            isOpen && /*#__PURE__*/ (0, $iD4WH.jsx)("div", {
                className: "px-6 py-3",
                children: itemCards.map(function(item, index) {
                    var _item_card, _item_card_info, _item_card1;
                    var _item_card_info_id;
                    return /*#__PURE__*/ (0, $iD4WH.jsx)((0, $eda82bff2a7d3f82$export$2e2bcd8739ae039), {
                        menuInfo: item === null || item === void 0 ? void 0 : (_item_card = item.card) === null || _item_card === void 0 ? void 0 : _item_card.info,
                        addToCart: addToCart
                    }, (_item_card_info_id = item === null || item === void 0 ? void 0 : (_item_card1 = item.card) === null || _item_card1 === void 0 ? void 0 : (_item_card_info = _item_card1.info) === null || _item_card_info === void 0 ? void 0 : _item_card_info.id) !== null && _item_card_info_id !== void 0 ? _item_card_info_id : index);
                })
            })
        ]
    });
};
var $47c5ed635e286aeb$export$2e2bcd8739ae039 = $47c5ed635e286aeb$var$ItemCategory;



var $2nwvT = parcelRequire("2nwvT");

var $dQFEZ = parcelRequire("dQFEZ");
var $44dabe239e0cbff3$exports = {};
$44dabe239e0cbff3$exports = JSON.parse('{"id":1,"statusCode":0,"data":{"statusMessage":"done successfully","cards":[{"card":{"card":{"@type":"type.googleapis.com/swiggy.gandalf.widgets.v2.TextBoxV2","text":"Oh!Hunger","headerStyling":{"textColor":"text_Highest_Emphasis","textVariant":"header_H3_Black"}}}},{"card":{"card":{"@type":"type.googleapis.com/swiggy.gandalf.widgets.v2.RestaurantBlTab","tabs":[{"id":"Order Online","title":"Order Online"}]}}},{"card":{"card":{"@type":"type.googleapis.com/swiggy.presentation.food.v2.Restaurant","info":{"id":"666909","name":"Oh!Hunger","city":"Delhi","slugs":{"restaurant":"oh!hunger-karol-bagh-karol-bagh","city":"delhi"},"uniqueId":"e51e6528-4859-48c8-8fed-e84c17dc2d76","cloudinaryImageId":"d270f97263e5e0a99cb99137e4a58c8b","locality":"Chuna Mandi","areaName":"Paharganj","costForTwo":"25000","costForTwoMessage":"\u20B9250 for two","cuisines":["Fast Food","Snacks"],"avgRating":4.2,"feeDetails":{"restaurantId":"666909","fees":[{}]},"parentId":"400023","avgRatingString":"4.2","totalRatingsString":"2.9K+ ratings","sla":{"restaurantId":"666909","deliveryTime":29,"minDeliveryTime":25,"maxDeliveryTime":30,"lastMileTravel":2.1,"serviceability":"SERVICEABLE","stressFactor":1,"rainMode":"RAIN_MODE_NONE","longDistance":"LONG_DISTANCE_NOT_LONG_DISTANCE","zoneId":96,"slaString":"25-30 MINS","lastMileTravelString":"2.1 km","iconType":"ICON_TYPE_EMPTY"},"availability":{"nextCloseTime":"2025-12-26 00:00:00","visibility":true,"opened":true,"restaurantClosedMeta":{}},"aggregatedDiscountInfo":{"header":"Get every item @ 59","shortDescriptionList":[{"meta":"Get every item @ 59","discountType":"FinalPrice","operationType":"RESTAURANT"},{"meta":"Flat \u20B9100 off on orders above \u20B9199","discountType":"Flat","operationType":"RESTAURANT"}],"descriptionList":[{"meta":"Get every item @ 59","discountType":"FinalPrice","operationType":"RESTAURANT"},{"meta":"Flat \u20B9100 off on orders above \u20B9199 | Use code FLAT100","discountType":"Flat","operationType":"RESTAURANT"}],"visible":true},"badges":{},"slugString":"oh!hunger-karol-bagh-karol-bagh","multiOutlet":true,"isOpen":true,"labels":[{"title":"Timings","message":"null"},{"title":"Address","message":"1723, GF, Gali Pratap, Chuna Mandi, Paharganj New Delhi , KAROL BAGH, Central, Delhi-110055"},{"title":"Cuisines","message":"Fast Food,Snacks"}],"totalRatings":2900,"aggregatedDiscountInfoV2":{"header":"Get every item @ 59","shortDescriptionList":[{"meta":"Get every item @ 59","discountType":"FinalPrice","operationType":"RESTAURANT"},{"meta":"Flat \u20B9100 off on orders above \u20B9199","discountType":"Flat","operationType":"RESTAURANT"}],"descriptionList":[{"meta":"Get every item @ 59","discountType":"FinalPrice","operationType":"RESTAURANT"},{"meta":"Flat \u20B9100 off on orders above \u20B9199 | Use code FLAT100","discountType":"Flat","operationType":"RESTAURANT"}],"couponDetailsCta":"View coupon details"},"type":"F","nudgeBanners":[{"priority":9,"discountInfo":{"discountType":"FinalPrice","value":109},"unlockedMessage":"Deal of the Day unlocked!","minItemCount":1,"maxItemCount":1,"type":"SILD","nudgeTagInfo":{"title":"Deal of the Day","fontName":"FONT_NAME_CONDENSED_BOLD"},"logoCtx":{},"movComputationType":"MOV_COMPUTATION_TYPE_DISCOUNTED_PRICE"}],"headerBanner":{"url":"swiggy://webview?is_external=false&webview_url=https://www.swiggy.com/restaurant-info/666909"},"ratingSlab":"RATING_SLAB_5","orderabilityCommunication":{"title":{},"subTitle":{},"message":{},"customIcon":{},"commsStyling":{}},"hasBestsellerItems":true,"cartOrderabilityNudgeBanner":{"parameters":{},"presentation":{}},"latLong":"28.641069,77.209671","backgroundImageOverlayInfo":{},"featuredSectionInfo":{},"requestContexts":["enable_ecosaver","99store"]},"analytics":{}},"relevance":{"type":"RELEVANCE_TYPE_CHECK_ORDERABILITY_AND_SHOW_MENU_OFFER_NUDGE","sectionId":"MENU_ITEM_CART_UPDATE_POP_CROUTON"}}},{"card":{"card":{"@type":"type.googleapis.com/swiggy.gandalf.widgets.v2.GridWidget","layout":{"rows":1,"columns":5,"horizontalScrollEnabled":true,"itemSpacing":12,"lineSpacing":10,"widgetPadding":{},"containerStyle":{"containerPadding":{"left":10,"right":10,"bottom":16}}},"id":"offerCollectionWidget_UX4","gridElements":{"infoWithStyle":{"@type":"type.googleapis.com/swiggy.presentation.food.v2.OfferInfoWithStyle","offers":[{"info":{"header":"50% OFF","offerTag":"DEAL OF DAY","offerTagColor":"#E46D47","offerIds":["3d3deff4-5f75-4cc2-b1d7-dca34271ee04"],"expiryTime":"1970-01-01T00:56:06Z","offerType":"offers","restId":"666909","offerLogo":"offers/DealRush_Offer_Icon.png","descriptionTextColor":"#7302060C","showExpiryTimer":true,"primaryDescription":"5 DEALS LEFT"},"cta":{"type":"OFFER_HALF_CARD"}},{"info":{"header":"FLAT \u20B9100 OFF","offerTag":"FLAT DEAL","offerTagColor":"#E46D47","offerIds":["f609cd84-fb53-43da-912e-ba9bccf494d7"],"expiryTime":"1970-01-01T00:00:00Z","couponCode":"USE FLAT100","description":"ABOVE \u20B9199","offerType":"offers","restId":"666909","offerLogo":"offers/generic","descriptionTextColor":"#7302060C","primaryDescription":"USE FLAT100"},"cta":{"type":"OFFER_HALF_CARD"}},{"info":{"header":"FLAT \u20B9125 OFF","offerTag":"FLAT DEAL","offerTagColor":"#E46D47","offerIds":["112e0e28-548a-474f-89cb-7cebbe4343fa"],"expiryTime":"1970-01-01T00:00:00Z","couponCode":"USE FLAT125","description":"ABOVE \u20B9249","offerType":"offers","restId":"666909","offerLogo":"offers/generic","descriptionTextColor":"#7302060C","primaryDescription":"USE FLAT125"},"cta":{"type":"OFFER_HALF_CARD"}},{"info":{"header":"50% OFF UPTO \u20B9100","offerTagColor":"#E46D47","offerIds":["32bf37ac-aa33-4293-bed3-41a512ad2b25"],"expiryTime":"1970-01-01T00:00:00Z","couponCode":"USE TRYNEW","description":"ABOVE \u20B9179","offerType":"offers","restId":"666909","offerLogo":"offers/generic","descriptionTextColor":"#7302060C","primaryDescription":"USE TRYNEW"},"cta":{"type":"OFFER_HALF_CARD"}},{"info":{"header":"FLAT \u20B9200 OFF","offerTag":"FLAT DEAL","offerTagColor":"#E46D47","offerIds":["801c250e-4858-420a-a764-6a0802835b40"],"expiryTime":"1970-01-01T00:00:00Z","couponCode":"USE FLAT200","description":"ABOVE \u20B9649","offerType":"offers","restId":"666909","offerLogo":"offers/generic","descriptionTextColor":"#7302060C","primaryDescription":"USE FLAT200"},"cta":{"type":"OFFER_HALF_CARD"}}],"habitMilestoneInfo":{"callout":{}},"loyaltyDiscoverPresentationInfo":{"logoCtx":{}}}}}}},{"groupedCard":{"cardGroupMap":{"REGULAR":{"cards":[{"card":{"card":{"@type":"type.googleapis.com/swiggy.presentation.food.v2.MenuVegFilterAndBadge","badges":{},"vegOnlyDetails":{"imageId":"AutoVegOnly_qkjowj","title":"Showing only vegetarian options.","description":"Tap on the VEG ONLY button to turn off the setting"},"topRatedFilter":{"attributes":{"displayText":"Ratings 4.0+"}},"kidsCategoryFilter":{"attributes":{"displayText":"Kids Favourites","tooltip":{"enabled":true,"displayText":"Kids Favourites Filter applied. Remove this filter to see the full Menu."}}},"vegFilter":{"attributes":{"displayText":"VEG"}},"nonvegFilter":{"attributes":{"displayText":"NONVEG"}}},"relevance":{"type":"RELEVANCE_TYPE_ON_MENU_FILTER_TOGGLED","sectionId":"MENU_FILTER_TOGGLE"}}},{"card":{"card":{"@type":"type.googleapis.com/swiggy.presentation.food.v2.ItemCategory","title":"99 Store","itemCards":[{"card":{"@type":"type.googleapis.com/swiggy.presentation.food.v2.Dish","info":{"id":"129746211","name":"Potato & Vegetable Sandwich (brown Bread)","category":"Sandwiches","description":"Potato sandwich?s made with aloo tikki, vegetables & combination of sauces","imageId":"FOOD_CATALOG/IMAGES/CMS/2024/9/30/29a17544-0e40-45ea-b0cf-10b94df2b25b_925269ce-dcdc-483b-96e3-4b67c094b23c.jpg","inStock":1,"isVeg":1,"price":19900,"finalPrice":9900,"variants":{},"variantsV2":{},"itemAttribute":{"vegClassifier":"VEG"},"ribbon":{"text":"Bestseller","textColor":"#ffffff","topBackgroundColor":"#d53d4c","bottomBackgroundColor":"#b02331"},"type":"ITEM","offerTags":[{"matchText":"SILD"}],"itemBadge":{},"badgesV2":{},"itemNudgeType":"FinalPrice","isBestseller":true,"ratings":{"aggregatedRating":{"rating":"4.6","ratingCount":"113 ratings","ratingCountV2":"113"},"ratingsPresentationConfig":{"bgGradient":{"colours":["#C8F9E5","#00FFFFFF"],"gradientDirection":"GRADIENT_DIRECTION_LEFT_TO_RIGHT"},"ratingIconColor":"rating_very_good","ratingTextColor":"rating_very_good","ratingCountTextColor":"rating_very_good","ratingFontName":"FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD","ratingCountFontName":"FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"}},"itemPriceStrikeOff":true,"cartContext":"quick_prep_widget","offerIds":["7201da4b-5963-4a8d-8ca4-d5ee6abdec2c"],"size":{"width":0.5,"height":0.9},"isNinetyninestoreItem":true,"parentId":"75385694"},"analytics":{},"hideRestaurantDetails":true}},{"card":{"@type":"type.googleapis.com/swiggy.presentation.food.v2.Dish","info":{"id":"111576930","name":"Tandoori Paneer Grilled Sandwich (brown Bread)","category":"Sandwiches","description":"Soft paneer marinated with curd and spices. Loaded with exotic vegetables.","imageId":"b5bb7ff584ad97aebc3a08fba8e29bed","inStock":1,"isVeg":1,"price":20900,"finalPrice":10900,"variants":{},"variantsV2":{},"itemAttribute":{"vegClassifier":"VEG"},"ribbon":{"text":"Bestseller","textColor":"#ffffff","topBackgroundColor":"#d53d4c","bottomBackgroundColor":"#b02331"},"type":"ITEM","offerTags":[{"matchText":"SILD"}],"itemBadge":{},"badgesV2":{},"itemNudgeType":"FinalPrice","isBestseller":true,"ratings":{"aggregatedRating":{"rating":"4.4","ratingCount":"308 ratings","ratingCountV2":"308"},"ratingsPresentationConfig":{"bgGradient":{"colours":["#C8F9E5","#00FFFFFF"],"gradientDirection":"GRADIENT_DIRECTION_LEFT_TO_RIGHT"},"ratingIconColor":"rating_very_good","ratingTextColor":"rating_very_good","ratingCountTextColor":"rating_very_good","ratingFontName":"FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD","ratingCountFontName":"FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"}},"itemPriceStrikeOff":true,"cartContext":"quick_prep_widget","offerIds":["fcc54975-da56-490d-8df7-cdf8a5843fdb"],"size":{"width":0.5,"height":0.9},"isNinetyninestoreItem":true,"parentId":"62480122"},"analytics":{},"hideRestaurantDetails":true}}],"subtitleSuffix":{},"subtitleColor":"highlight","categoryId":"1234567","widgetType":"WIDGET_TYPE_DISH_FIRST","categoryStyle":{"layout":{"rows":1,"columns":2,"itemSpacing":16,"containerStyle":{"containerPadding":{"left":16,"top":8,"right":16,"bottom":12}}},"itemStyle":{"width":{"type":"TYPE_RELATIVE","value":0.5,"reference":"RELATIVE_DIMENSION_REFERENCE_CONTAINER_WIDTH"},"height":{"type":"TYPE_RELATIVE","value":0.9,"reference":"RELATIVE_DIMENSION_REFERENCE_WIDTH"}}},"headerStyle":{"padding":{"left":16,"top":16,"right":16,"bottom":16},"titleColor":"text_color_highest_emphasis","titleFontName":"FONT_NAME_SUB_HEADER_S1_BOLD","imageStyle":{"width":{},"height":{}},"gradientStyle":{}},"dividerStyle":{"color":"#1502060C","height":1,"padding":{"left":16,"right":16}},"titleCreative":{"creativeId":"affordable/Menu%20widget%20-%20Title%20badge%20-%203.png","style":{"width":{"type":"TYPE_ABSOLUTE","value":84},"height":{"type":"TYPE_ABSOLUTE","value":25}}},"subtitleCreative":{"creativeId":"99store/Category%20subtext.png?updatedAt=1756989067080","style":{"width":{"type":"TYPE_ABSOLUTE","value":246},"height":{"type":"TYPE_ABSOLUTE","value":25}}}}}},{"card":{"card":{"@type":"type.googleapis.com/swiggy.presentation.food.v2.ItemCategory","title":"Recommended","itemCards":[{"card":{"@type":"type.googleapis.com/swiggy.presentation.food.v2.Dish","info":{"id":"111576930","name":"Tandoori Paneer Grilled Sandwich (brown Bread)","category":"Sandwiches","description":"Soft paneer marinated with curd and spices. Loaded with exotic vegetables.","imageId":"b5bb7ff584ad97aebc3a08fba8e29bed","inStock":1,"isVeg":1,"price":20900,"finalPrice":10900,"variants":{},"variantsV2":{},"itemAttribute":{"vegClassifier":"VEG"},"ribbon":{"text":"Bestseller","textColor":"#ffffff","topBackgroundColor":"#d53d4c","bottomBackgroundColor":"#b02331"},"showImage":true,"type":"ITEM","offerTags":[{"matchText":"SILD"}],"itemBadge":{},"badgesV2":{},"itemNudgeType":"FinalPrice","isBestseller":true,"ratings":{"aggregatedRating":{"rating":"4.4","ratingCount":"308 ratings","ratingCountV2":"308"},"ratingsPresentationConfig":{"bgGradient":{"colours":["#C8F9E5","#00FFFFFF"],"gradientDirection":"GRADIENT_DIRECTION_LEFT_TO_RIGHT"},"ratingIconColor":"rating_very_good","ratingTextColor":"rating_very_good","ratingCountTextColor":"rating_very_good","ratingFontName":"FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD","ratingCountFontName":"FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"}},"itemPriceStrikeOff":true,"cartContext":"quick_prep","offerIds":["fcc54975-da56-490d-8df7-cdf8a5843fdb"],"size":{"width":0.5,"height":0.9},"isNinetyninestoreItem":true,"parentId":"62480122"},"restaurant":{"info":{"id":"666909","parentId":"400023","sla":{"serviceability":"NON_SERVICEABLE","iconType":"ICON_TYPE_EMPTY"},"availability":{},"badges":{},"aggregatedDiscountInfoV2":{},"badgesV2":{},"differentiatedUi":{"displayType":"ADS_UI_DISPLAY_TYPE_ENUM_DEFAULT","differentiatedUiMediaDetails":{"mediaType":"ADS_MEDIA_ENUM_IMAGE"}},"reviewsSummary":{},"displayType":"RESTAURANT_DISPLAY_TYPE_DEFAULT","restaurantOfferPresentationInfo":{},"dishStyle":{"socialMarkerStyle":[{"socialMarkerType":"SOCIAL_MARKER_TYPE_HIGH_PROTEIN","title":"Protein Rich","textStyle":"FONT_NAME_V2_BODY3_NEUTRAL_BOLD","textColor":"brand_proteinator_primary"},{"socialMarkerType":"SOCIAL_MARKER_TYPE_BESTSELLER","title":"Bestseller","textStyle":"FONT_NAME_V2_BODY3_NEUTRAL_BOLD","textColor":"color_swiggy_one"}]}}},"hideRestaurantDetails":true}},{"card":{"@type":"type.googleapis.com/swiggy.presentation.food.v2.Dish","info":{"id":"108832043","name":"Classic Maggi","category":"Maggi & Momos","description":"Classic maggi with added extra vegetables & Spices.","imageId":"285a763faec0781c1f8944f808821627","inStock":1,"isVeg":1,"price":8900,"variants":{},"variantsV2":{},"itemAttribute":{"vegClassifier":"VEG"},"ribbon":{"text":"Bestseller","textColor":"#ffffff","topBackgroundColor":"#d53d4c","bottomBackgroundColor":"#b02331"},"showImage":true,"type":"ITEM","itemBadge":{},"badgesV2":{},"isBestseller":true,"ratings":{"aggregatedRating":{"rating":"4.2","ratingCount":"476 ratings","ratingCountV2":"476"},"ratingsPresentationConfig":{"bgGradient":{"colours":["#C8F9E5","#00FFFFFF"],"gradientDirection":"GRADIENT_DIRECTION_LEFT_TO_RIGHT"},"ratingIconColor":"rating_very_good","ratingTextColor":"rating_very_good","ratingCountTextColor":"rating_very_good","ratingFontName":"FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD","ratingCountFontName":"FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"}},"itemPriceStrikeOff":true,"size":{"width":0.5,"height":0.9},"parentId":"62480066"},"restaurant":{"info":{"id":"666909","parentId":"400023","sla":{"serviceability":"NON_SERVICEABLE","iconType":"ICON_TYPE_EMPTY"},"availability":{},"badges":{},"aggregatedDiscountInfoV2":{},"badgesV2":{},"differentiatedUi":{"displayType":"ADS_UI_DISPLAY_TYPE_ENUM_DEFAULT","differentiatedUiMediaDetails":{"mediaType":"ADS_MEDIA_ENUM_IMAGE"}},"reviewsSummary":{},"displayType":"RESTAURANT_DISPLAY_TYPE_DEFAULT","restaurantOfferPresentationInfo":{},"dishStyle":{"socialMarkerStyle":[{"socialMarkerType":"SOCIAL_MARKER_TYPE_HIGH_PROTEIN","title":"Protein Rich","textStyle":"FONT_NAME_V2_BODY3_NEUTRAL_BOLD","textColor":"brand_proteinator_primary"},{"socialMarkerType":"SOCIAL_MARKER_TYPE_BESTSELLER","title":"Bestseller","textStyle":"FONT_NAME_V2_BODY3_NEUTRAL_BOLD","textColor":"color_swiggy_one"}]}}},"hideRestaurantDetails":true}},{"card":{"@type":"type.googleapis.com/swiggy.presentation.food.v2.Dish","info":{"id":"108831984","name":"Poha With Sev","category":"All Day Breakfast","description":"Traditional Indian Breakfast made with flattened rice, onions, peanuts and flavored with basic spices and herbs served with medium spicy sev.","imageId":"7a0ba771f71c9f995a4a83a00497b8e5","inStock":1,"isVeg":1,"price":15900,"variants":{},"variantsV2":{},"addons":[{"groupId":"169394261","groupName":"Extra For Any","choices":[{"id":"122678749","name":"Nimbu Pani","price":6900,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"122678729","name":"Jaljeera","price":6900,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"122678736","name":"Raita","price":4900,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"122678743","name":"Gulab Jamun 2 Pcs","price":7900,"inStock":1,"isVeg":1,"isEnabled":1}],"maxAddons":1,"maxFreeAddons":-1}],"itemAttribute":{"vegClassifier":"VEG"},"ribbon":{"text":"Bestseller","textColor":"#ffffff","topBackgroundColor":"#d53d4c","bottomBackgroundColor":"#b02331"},"showImage":true,"type":"ITEM","itemBadge":{},"badgesV2":{},"isBestseller":true,"ratings":{"aggregatedRating":{"rating":"4.3","ratingCount":"103 ratings","ratingCountV2":"103"},"ratingsPresentationConfig":{"bgGradient":{"colours":["#C8F9E5","#00FFFFFF"],"gradientDirection":"GRADIENT_DIRECTION_LEFT_TO_RIGHT"},"ratingIconColor":"rating_very_good","ratingTextColor":"rating_very_good","ratingCountTextColor":"rating_very_good","ratingFontName":"FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD","ratingCountFontName":"FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"}},"itemPriceStrikeOff":true,"size":{"width":0.5,"height":0.9},"parentId":"62480108"},"restaurant":{"info":{"id":"666909","parentId":"400023","sla":{"serviceability":"NON_SERVICEABLE","iconType":"ICON_TYPE_EMPTY"},"availability":{},"badges":{},"aggregatedDiscountInfoV2":{},"badgesV2":{},"differentiatedUi":{"displayType":"ADS_UI_DISPLAY_TYPE_ENUM_DEFAULT","differentiatedUiMediaDetails":{"mediaType":"ADS_MEDIA_ENUM_IMAGE"}},"reviewsSummary":{},"displayType":"RESTAURANT_DISPLAY_TYPE_DEFAULT","restaurantOfferPresentationInfo":{},"dishStyle":{"socialMarkerStyle":[{"socialMarkerType":"SOCIAL_MARKER_TYPE_HIGH_PROTEIN","title":"Protein Rich","textStyle":"FONT_NAME_V2_BODY3_NEUTRAL_BOLD","textColor":"brand_proteinator_primary"},{"socialMarkerType":"SOCIAL_MARKER_TYPE_BESTSELLER","title":"Bestseller","textStyle":"FONT_NAME_V2_BODY3_NEUTRAL_BOLD","textColor":"color_swiggy_one"}]}}},"hideRestaurantDetails":true}},{"card":{"@type":"type.googleapis.com/swiggy.presentation.food.v2.Dish","info":{"id":"129746211","name":"Potato & Vegetable Sandwich (brown Bread)","category":"Sandwiches","description":"Potato sandwich?s made with aloo tikki, vegetables & combination of sauces","imageId":"FOOD_CATALOG/IMAGES/CMS/2024/9/30/29a17544-0e40-45ea-b0cf-10b94df2b25b_925269ce-dcdc-483b-96e3-4b67c094b23c.jpg","inStock":1,"isVeg":1,"price":19900,"finalPrice":9900,"variants":{},"variantsV2":{},"itemAttribute":{"vegClassifier":"VEG"},"ribbon":{"text":"Bestseller","textColor":"#ffffff","topBackgroundColor":"#d53d4c","bottomBackgroundColor":"#b02331"},"showImage":true,"type":"ITEM","offerTags":[{"matchText":"SILD"}],"itemBadge":{},"badgesV2":{},"itemNudgeType":"FinalPrice","isBestseller":true,"ratings":{"aggregatedRating":{"rating":"4.6","ratingCount":"113 ratings","ratingCountV2":"113"},"ratingsPresentationConfig":{"bgGradient":{"colours":["#C8F9E5","#00FFFFFF"],"gradientDirection":"GRADIENT_DIRECTION_LEFT_TO_RIGHT"},"ratingIconColor":"rating_very_good","ratingTextColor":"rating_very_good","ratingCountTextColor":"rating_very_good","ratingFontName":"FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD","ratingCountFontName":"FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"}},"itemPriceStrikeOff":true,"cartContext":"quick_prep","offerIds":["7201da4b-5963-4a8d-8ca4-d5ee6abdec2c"],"size":{"width":0.5,"height":0.9},"isNinetyninestoreItem":true,"parentId":"75385694"},"restaurant":{"info":{"id":"666909","parentId":"400023","sla":{"serviceability":"NON_SERVICEABLE","iconType":"ICON_TYPE_EMPTY"},"availability":{},"badges":{},"aggregatedDiscountInfoV2":{},"badgesV2":{},"differentiatedUi":{"displayType":"ADS_UI_DISPLAY_TYPE_ENUM_DEFAULT","differentiatedUiMediaDetails":{"mediaType":"ADS_MEDIA_ENUM_IMAGE"}},"reviewsSummary":{},"displayType":"RESTAURANT_DISPLAY_TYPE_DEFAULT","restaurantOfferPresentationInfo":{},"dishStyle":{"socialMarkerStyle":[{"socialMarkerType":"SOCIAL_MARKER_TYPE_HIGH_PROTEIN","title":"Protein Rich","textStyle":"FONT_NAME_V2_BODY3_NEUTRAL_BOLD","textColor":"brand_proteinator_primary"},{"socialMarkerType":"SOCIAL_MARKER_TYPE_BESTSELLER","title":"Bestseller","textStyle":"FONT_NAME_V2_BODY3_NEUTRAL_BOLD","textColor":"color_swiggy_one"}]}}},"hideRestaurantDetails":true}},{"card":{"@type":"type.googleapis.com/swiggy.presentation.food.v2.Dish","info":{"id":"111576922","name":"Chicken Tikka Grilled Sandwich (brown Bread)","category":"Sandwiches","description":"Made with layers of?tandoori chicken, Vegetables and a homemade spicy mayonnaise dressing.","imageId":"ed102873ace7fcd6f5b9784db1a30387","inStock":1,"price":22900,"finalPrice":8900,"variants":{},"variantsV2":{},"itemAttribute":{"vegClassifier":"NONVEG"},"ribbon":{"text":"Bestseller","textColor":"#ffffff","topBackgroundColor":"#d53d4c","bottomBackgroundColor":"#b02331"},"showImage":true,"type":"ITEM","offerTags":[{"matchText":"SILD"}],"itemBadge":{},"badgesV2":{},"itemNudgeType":"FinalPrice","isBestseller":true,"ratings":{"aggregatedRating":{"rating":"4.4","ratingCount":"136 ratings","ratingCountV2":"136"},"ratingsPresentationConfig":{"bgGradient":{"colours":["#C8F9E5","#00FFFFFF"],"gradientDirection":"GRADIENT_DIRECTION_LEFT_TO_RIGHT"},"ratingIconColor":"rating_very_good","ratingTextColor":"rating_very_good","ratingCountTextColor":"rating_very_good","ratingFontName":"FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD","ratingCountFontName":"FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"}},"itemPriceStrikeOff":true,"offerIds":["9caf6a85-3e4e-42da-ae21-f9705c6593d3"],"size":{"width":0.5,"height":0.9},"parentId":"63848610","offerCategory":"OFFER_CATEGORY_DEAL_RUSH","offerHeader":"Only till","offerSubHeader":"10:00 AM"},"restaurant":{"info":{"id":"666909","parentId":"400023","sla":{"serviceability":"NON_SERVICEABLE","iconType":"ICON_TYPE_EMPTY"},"availability":{},"badges":{},"aggregatedDiscountInfoV2":{},"badgesV2":{},"differentiatedUi":{"displayType":"ADS_UI_DISPLAY_TYPE_ENUM_DEFAULT","differentiatedUiMediaDetails":{"mediaType":"ADS_MEDIA_ENUM_IMAGE"}},"reviewsSummary":{},"displayType":"RESTAURANT_DISPLAY_TYPE_DEFAULT","restaurantOfferPresentationInfo":{},"dishStyle":{"socialMarkerStyle":[{"socialMarkerType":"SOCIAL_MARKER_TYPE_HIGH_PROTEIN","title":"Protein Rich","textStyle":"FONT_NAME_V2_BODY3_NEUTRAL_BOLD","textColor":"brand_proteinator_primary"},{"socialMarkerType":"SOCIAL_MARKER_TYPE_BESTSELLER","title":"Bestseller","textStyle":"FONT_NAME_V2_BODY3_NEUTRAL_BOLD","textColor":"color_swiggy_one"}]}}},"hideRestaurantDetails":true}},{"card":{"@type":"type.googleapis.com/swiggy.presentation.food.v2.Dish","info":{"id":"111576931","name":"Adarak Wali Chai (mini Flask Serves 2-3)","category":"Beverages","description":"Ginger tea or adrak wali chai is?a warming, spiced and fragrant Indian tea made with fresh ginger roots.","imageId":"90cea1cd1b6eff5cf637e34c7c218564","inStock":1,"isVeg":1,"price":14900,"variants":{},"variantsV2":{},"itemAttribute":{"vegClassifier":"VEG"},"ribbon":{"text":"Bestseller","textColor":"#ffffff","topBackgroundColor":"#d53d4c","bottomBackgroundColor":"#b02331"},"showImage":true,"type":"ITEM","itemBadge":{},"badgesV2":{},"isBestseller":true,"ratings":{"aggregatedRating":{"rating":"4.4","ratingCount":"124 ratings","ratingCountV2":"124"},"ratingsPresentationConfig":{"bgGradient":{"colours":["#C8F9E5","#00FFFFFF"],"gradientDirection":"GRADIENT_DIRECTION_LEFT_TO_RIGHT"},"ratingIconColor":"rating_very_good","ratingTextColor":"rating_very_good","ratingCountTextColor":"rating_very_good","ratingFontName":"FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD","ratingCountFontName":"FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"}},"itemPriceStrikeOff":true,"size":{"width":0.5,"height":0.9},"parentId":"62480032"},"restaurant":{"info":{"id":"666909","parentId":"400023","sla":{"serviceability":"NON_SERVICEABLE","iconType":"ICON_TYPE_EMPTY"},"availability":{},"badges":{},"aggregatedDiscountInfoV2":{},"badgesV2":{},"differentiatedUi":{"displayType":"ADS_UI_DISPLAY_TYPE_ENUM_DEFAULT","differentiatedUiMediaDetails":{"mediaType":"ADS_MEDIA_ENUM_IMAGE"}},"reviewsSummary":{},"displayType":"RESTAURANT_DISPLAY_TYPE_DEFAULT","restaurantOfferPresentationInfo":{},"dishStyle":{"socialMarkerStyle":[{"socialMarkerType":"SOCIAL_MARKER_TYPE_HIGH_PROTEIN","title":"Protein Rich","textStyle":"FONT_NAME_V2_BODY3_NEUTRAL_BOLD","textColor":"brand_proteinator_primary"},{"socialMarkerType":"SOCIAL_MARKER_TYPE_BESTSELLER","title":"Bestseller","textStyle":"FONT_NAME_V2_BODY3_NEUTRAL_BOLD","textColor":"color_swiggy_one"}]}}},"hideRestaurantDetails":true}},{"card":{"@type":"type.googleapis.com/swiggy.presentation.food.v2.Dish","info":{"id":"108831975","name":"Mumbai Street Style Pav Bhaji","category":"All Day Breakfast","description":"Mumbai street food made of a spicy mashed vegetable curry served topped with a dollop of butter along with soft dinner roll.","imageId":"c9950bf23deeb3f297046ff0e236e75f","inStock":1,"isVeg":1,"price":19900,"finalPrice":7900,"variants":{},"variantsV2":{},"addons":[{"groupId":"169394263","groupName":"Extra Add Ons","choices":[{"id":"122678746","name":"Raita","price":4900,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"122678738","name":"Jaljeera","price":6900,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"122678731","name":"Bhaji","price":12900,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"122678725","name":"Nimbu Pani","price":6900,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"122678750","name":"Pav 2 Pcs","price":6900,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"122678735","name":"Gulab Jamun 2 Pcs","price":7900,"isVeg":1,"isEnabled":1}],"maxAddons":1,"maxFreeAddons":-1}],"itemAttribute":{"vegClassifier":"VEG"},"ribbon":{"text":"Bestseller","textColor":"#ffffff","topBackgroundColor":"#d53d4c","bottomBackgroundColor":"#b02331"},"showImage":true,"type":"ITEM","offerTags":[{"matchText":"SILD"}],"itemBadge":{},"badgesV2":{},"itemNudgeType":"FinalPrice","isBestseller":true,"ratings":{"aggregatedRating":{"rating":"4.4","ratingCount":"227 ratings","ratingCountV2":"227"},"ratingsPresentationConfig":{"bgGradient":{"colours":["#C8F9E5","#00FFFFFF"],"gradientDirection":"GRADIENT_DIRECTION_LEFT_TO_RIGHT"},"ratingIconColor":"rating_very_good","ratingTextColor":"rating_very_good","ratingCountTextColor":"rating_very_good","ratingFontName":"FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD","ratingCountFontName":"FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"}},"itemPriceStrikeOff":true,"offerIds":["ddb29a66-004d-473d-a6fd-0e9b88a39632"],"size":{"width":0.5,"height":0.9},"parentId":"62480098","offerCategory":"OFFER_CATEGORY_DEAL_RUSH","offerHeader":"Only till","offerSubHeader":"10:00 AM"},"restaurant":{"info":{"id":"666909","parentId":"400023","sla":{"serviceability":"NON_SERVICEABLE","iconType":"ICON_TYPE_EMPTY"},"availability":{},"badges":{},"aggregatedDiscountInfoV2":{},"badgesV2":{},"differentiatedUi":{"displayType":"ADS_UI_DISPLAY_TYPE_ENUM_DEFAULT","differentiatedUiMediaDetails":{"mediaType":"ADS_MEDIA_ENUM_IMAGE"}},"reviewsSummary":{},"displayType":"RESTAURANT_DISPLAY_TYPE_DEFAULT","restaurantOfferPresentationInfo":{},"dishStyle":{"socialMarkerStyle":[{"socialMarkerType":"SOCIAL_MARKER_TYPE_HIGH_PROTEIN","title":"Protein Rich","textStyle":"FONT_NAME_V2_BODY3_NEUTRAL_BOLD","textColor":"brand_proteinator_primary"},{"socialMarkerType":"SOCIAL_MARKER_TYPE_BESTSELLER","title":"Bestseller","textStyle":"FONT_NAME_V2_BODY3_NEUTRAL_BOLD","textColor":"color_swiggy_one"}]}}},"hideRestaurantDetails":true}},{"card":{"@type":"type.googleapis.com/swiggy.presentation.food.v2.Dish","info":{"id":"129746208","name":"Cheese & Corn Sandwich (brown Bread)","category":"Sandwiches","description":"Corn sandwich is a filled primarily with sweet corn & Cheese along with other spices.","imageId":"FOOD_CATALOG/IMAGES/CMS/2024/9/30/268f6aab-1a71-4044-bcff-4647a866ebf7_38270eec-4094-4f1d-a1a6-5a2b24be1d16.jpg","inStock":1,"isVeg":1,"price":19900,"finalPrice":7900,"variants":{},"variantsV2":{},"itemAttribute":{"vegClassifier":"VEG"},"ribbon":{"text":"Bestseller","textColor":"#ffffff","topBackgroundColor":"#d53d4c","bottomBackgroundColor":"#b02331"},"showImage":true,"type":"ITEM","offerTags":[{"matchText":"SILD"}],"itemBadge":{},"badgesV2":{},"itemNudgeType":"FinalPrice","isBestseller":true,"ratings":{"aggregatedRating":{"rating":"4.2","ratingCount":"59 ratings","ratingCountV2":"59"},"ratingsPresentationConfig":{"bgGradient":{"colours":["#C8F9E5","#00FFFFFF"],"gradientDirection":"GRADIENT_DIRECTION_LEFT_TO_RIGHT"},"ratingIconColor":"rating_very_good","ratingTextColor":"rating_very_good","ratingCountTextColor":"rating_very_good","ratingFontName":"FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD","ratingCountFontName":"FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"}},"itemPriceStrikeOff":true,"offerIds":["ddb29a66-004d-473d-a6fd-0e9b88a39632"],"size":{"width":0.5,"height":0.9},"parentId":"75385692","offerCategory":"OFFER_CATEGORY_DEAL_RUSH","offerHeader":"Only till","offerSubHeader":"10:00 AM"},"restaurant":{"info":{"id":"666909","parentId":"400023","sla":{"serviceability":"NON_SERVICEABLE","iconType":"ICON_TYPE_EMPTY"},"availability":{},"badges":{},"aggregatedDiscountInfoV2":{},"badgesV2":{},"differentiatedUi":{"displayType":"ADS_UI_DISPLAY_TYPE_ENUM_DEFAULT","differentiatedUiMediaDetails":{"mediaType":"ADS_MEDIA_ENUM_IMAGE"}},"reviewsSummary":{},"displayType":"RESTAURANT_DISPLAY_TYPE_DEFAULT","restaurantOfferPresentationInfo":{},"dishStyle":{"socialMarkerStyle":[{"socialMarkerType":"SOCIAL_MARKER_TYPE_HIGH_PROTEIN","title":"Protein Rich","textStyle":"FONT_NAME_V2_BODY3_NEUTRAL_BOLD","textColor":"brand_proteinator_primary"},{"socialMarkerType":"SOCIAL_MARKER_TYPE_BESTSELLER","title":"Bestseller","textStyle":"FONT_NAME_V2_BODY3_NEUTRAL_BOLD","textColor":"color_swiggy_one"}]}}},"hideRestaurantDetails":true}},{"card":{"@type":"type.googleapis.com/swiggy.presentation.food.v2.Dish","info":{"id":"117716238","name":"Egg Roll","category":"Rolls","description":"Indian style egg rolled in a bread.","imageId":"40486f92274e4e01e18e94bbe59505f2","inStock":1,"price":9900,"variants":{},"variantsV2":{},"addons":[{"groupId":"125599020","groupName":"Addon Egg","choices":[{"id":"107814090","name":"1 Egg","price":2900,"inStock":1,"isEnabled":1},{"id":"107814091","name":"2 Egg","price":4900,"inStock":1,"isEnabled":1}],"maxAddons":1,"maxFreeAddons":-1},{"groupId":"125599022","groupName":"Choice Of Filling","choices":[{"id":"107814092","name":"Soya Filling","price":7900,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"107814093","name":"Paneer Tikka","price":9900,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"107814094","name":"Chicken Tikka","price":9900,"inStock":1,"isEnabled":1},{"id":"107814095","name":"Malai Tikka","price":9900,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"107814096","name":"Mutton Masala","price":12900,"isEnabled":1}],"maxAddons":1,"maxFreeAddons":-1},{"groupId":"125599025","groupName":"Choice Of Drinks","choices":[{"id":"107814097","name":"Ice Tea","price":8900,"inStock":1,"isVeg":1,"isEnabled":1}],"maxAddons":1,"maxFreeAddons":-1},{"groupId":"125599026","groupName":"Choice Of Sweet","choices":[{"id":"107814098","name":"Gulab Jamun 1 Pc","price":4900,"inStock":1,"isVeg":1,"isEnabled":1}],"maxAddons":1,"maxFreeAddons":-1}],"itemAttribute":{"vegClassifier":"NONVEG"},"ribbon":{},"showImage":true,"type":"ITEM","itemBadge":{},"badgesV2":{},"ratings":{"aggregatedRating":{"rating":"4.2","ratingCount":"182 ratings","ratingCountV2":"182"},"ratingsPresentationConfig":{"bgGradient":{"colours":["#C8F9E5","#00FFFFFF"],"gradientDirection":"GRADIENT_DIRECTION_LEFT_TO_RIGHT"},"ratingIconColor":"rating_very_good","ratingTextColor":"rating_very_good","ratingCountTextColor":"rating_very_good","ratingFontName":"FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD","ratingCountFontName":"FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"}},"itemPriceStrikeOff":true,"size":{"width":0.5,"height":0.9},"parentId":"65727901"},"restaurant":{"info":{"id":"666909","parentId":"400023","sla":{"serviceability":"NON_SERVICEABLE","iconType":"ICON_TYPE_EMPTY"},"availability":{},"badges":{},"aggregatedDiscountInfoV2":{},"badgesV2":{},"differentiatedUi":{"displayType":"ADS_UI_DISPLAY_TYPE_ENUM_DEFAULT","differentiatedUiMediaDetails":{"mediaType":"ADS_MEDIA_ENUM_IMAGE"}},"reviewsSummary":{},"displayType":"RESTAURANT_DISPLAY_TYPE_DEFAULT","restaurantOfferPresentationInfo":{},"dishStyle":{"socialMarkerStyle":[{"socialMarkerType":"SOCIAL_MARKER_TYPE_HIGH_PROTEIN","title":"Protein Rich","textStyle":"FONT_NAME_V2_BODY3_NEUTRAL_BOLD","textColor":"brand_proteinator_primary"},{"socialMarkerType":"SOCIAL_MARKER_TYPE_BESTSELLER","title":"Bestseller","textStyle":"FONT_NAME_V2_BODY3_NEUTRAL_BOLD","textColor":"color_swiggy_one"}]}}},"hideRestaurantDetails":true}},{"card":{"@type":"type.googleapis.com/swiggy.presentation.food.v2.Dish","info":{"id":"108832046","name":"Egg Bhurji Maggi","category":"Maggi & Momos","description":"Made with Indian style scrambled egg.","imageId":"e44004aac4df3a9d5f4e483a22a59d33","inStock":1,"price":16900,"variants":{},"variantsV2":{},"itemAttribute":{"vegClassifier":"NONVEG"},"ribbon":{},"showImage":true,"type":"ITEM","itemBadge":{},"badgesV2":{},"ratings":{"aggregatedRating":{"rating":"4.0","ratingCount":"45 ratings","ratingCountV2":"45"},"ratingsPresentationConfig":{"bgGradient":{"colours":["#C8F9E5","#00FFFFFF"],"gradientDirection":"GRADIENT_DIRECTION_LEFT_TO_RIGHT"},"ratingIconColor":"rating_very_good","ratingTextColor":"rating_very_good","ratingCountTextColor":"rating_very_good","ratingFontName":"FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD","ratingCountFontName":"FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"}},"itemPriceStrikeOff":true,"size":{"width":0.5,"height":0.9},"parentId":"62480071"},"restaurant":{"info":{"id":"666909","parentId":"400023","sla":{"serviceability":"NON_SERVICEABLE","iconType":"ICON_TYPE_EMPTY"},"availability":{},"badges":{},"aggregatedDiscountInfoV2":{},"badgesV2":{},"differentiatedUi":{"displayType":"ADS_UI_DISPLAY_TYPE_ENUM_DEFAULT","differentiatedUiMediaDetails":{"mediaType":"ADS_MEDIA_ENUM_IMAGE"}},"reviewsSummary":{},"displayType":"RESTAURANT_DISPLAY_TYPE_DEFAULT","restaurantOfferPresentationInfo":{},"dishStyle":{"socialMarkerStyle":[{"socialMarkerType":"SOCIAL_MARKER_TYPE_HIGH_PROTEIN","title":"Protein Rich","textStyle":"FONT_NAME_V2_BODY3_NEUTRAL_BOLD","textColor":"brand_proteinator_primary"},{"socialMarkerType":"SOCIAL_MARKER_TYPE_BESTSELLER","title":"Bestseller","textStyle":"FONT_NAME_V2_BODY3_NEUTRAL_BOLD","textColor":"color_swiggy_one"}]}}},"hideRestaurantDetails":true}},{"card":{"@type":"type.googleapis.com/swiggy.presentation.food.v2.Dish","info":{"id":"108832044","name":"Peri Peri Maggi","category":"Maggi & Momos","description":"Made with extra dose of peri peri sauce.","imageId":"6575e3e347e27529cb84c0906d4b0a7c","inStock":1,"isVeg":1,"price":13900,"variants":{},"variantsV2":{},"itemAttribute":{"vegClassifier":"VEG"},"ribbon":{},"showImage":true,"type":"ITEM","itemBadge":{},"badgesV2":{},"ratings":{"aggregatedRating":{"rating":"4.1","ratingCount":"161 ratings","ratingCountV2":"161"},"ratingsPresentationConfig":{"bgGradient":{"colours":["#C8F9E5","#00FFFFFF"],"gradientDirection":"GRADIENT_DIRECTION_LEFT_TO_RIGHT"},"ratingIconColor":"rating_very_good","ratingTextColor":"rating_very_good","ratingCountTextColor":"rating_very_good","ratingFontName":"FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD","ratingCountFontName":"FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"}},"itemPriceStrikeOff":true,"size":{"width":0.5,"height":0.9},"parentId":"62480107"},"restaurant":{"info":{"id":"666909","parentId":"400023","sla":{"serviceability":"NON_SERVICEABLE","iconType":"ICON_TYPE_EMPTY"},"availability":{},"badges":{},"aggregatedDiscountInfoV2":{},"badgesV2":{},"differentiatedUi":{"displayType":"ADS_UI_DISPLAY_TYPE_ENUM_DEFAULT","differentiatedUiMediaDetails":{"mediaType":"ADS_MEDIA_ENUM_IMAGE"}},"reviewsSummary":{},"displayType":"RESTAURANT_DISPLAY_TYPE_DEFAULT","restaurantOfferPresentationInfo":{},"dishStyle":{"socialMarkerStyle":[{"socialMarkerType":"SOCIAL_MARKER_TYPE_HIGH_PROTEIN","title":"Protein Rich","textStyle":"FONT_NAME_V2_BODY3_NEUTRAL_BOLD","textColor":"brand_proteinator_primary"},{"socialMarkerType":"SOCIAL_MARKER_TYPE_BESTSELLER","title":"Bestseller","textStyle":"FONT_NAME_V2_BODY3_NEUTRAL_BOLD","textColor":"color_swiggy_one"}]}}},"hideRestaurantDetails":true}},{"card":{"@type":"type.googleapis.com/swiggy.presentation.food.v2.Dish","info":{"id":"108832047","name":"Chicken Keema Maggi","category":"Maggi & Momos","description":"Made with Spicy Chicken keema.","imageId":"0779117a4136f19ef1e07aa57e05205b","inStock":1,"price":18900,"finalPrice":7900,"variants":{},"variantsV2":{},"itemAttribute":{"vegClassifier":"NONVEG"},"ribbon":{},"showImage":true,"type":"ITEM","offerTags":[{"matchText":"SILD"}],"itemBadge":{},"badgesV2":{},"itemNudgeType":"FinalPrice","ratings":{"aggregatedRating":{"rating":"4.1","ratingCount":"57 ratings","ratingCountV2":"57"},"ratingsPresentationConfig":{"bgGradient":{"colours":["#C8F9E5","#00FFFFFF"],"gradientDirection":"GRADIENT_DIRECTION_LEFT_TO_RIGHT"},"ratingIconColor":"rating_very_good","ratingTextColor":"rating_very_good","ratingCountTextColor":"rating_very_good","ratingFontName":"FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD","ratingCountFontName":"FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"}},"itemPriceStrikeOff":true,"offerIds":["ddb29a66-004d-473d-a6fd-0e9b88a39632"],"size":{"width":0.5,"height":0.9},"parentId":"62480050","offerCategory":"OFFER_CATEGORY_DEAL_RUSH","offerHeader":"Only till","offerSubHeader":"10:00 AM"},"restaurant":{"info":{"id":"666909","parentId":"400023","sla":{"serviceability":"NON_SERVICEABLE","iconType":"ICON_TYPE_EMPTY"},"availability":{},"badges":{},"aggregatedDiscountInfoV2":{},"badgesV2":{},"differentiatedUi":{"displayType":"ADS_UI_DISPLAY_TYPE_ENUM_DEFAULT","differentiatedUiMediaDetails":{"mediaType":"ADS_MEDIA_ENUM_IMAGE"}},"reviewsSummary":{},"displayType":"RESTAURANT_DISPLAY_TYPE_DEFAULT","restaurantOfferPresentationInfo":{},"dishStyle":{"socialMarkerStyle":[{"socialMarkerType":"SOCIAL_MARKER_TYPE_HIGH_PROTEIN","title":"Protein Rich","textStyle":"FONT_NAME_V2_BODY3_NEUTRAL_BOLD","textColor":"brand_proteinator_primary"},{"socialMarkerType":"SOCIAL_MARKER_TYPE_BESTSELLER","title":"Bestseller","textStyle":"FONT_NAME_V2_BODY3_NEUTRAL_BOLD","textColor":"color_swiggy_one"}]}}},"hideRestaurantDetails":true}},{"card":{"@type":"type.googleapis.com/swiggy.presentation.food.v2.Dish","info":{"id":"113821110","name":"Penne Alfredo Pasta With Garlic Bread","category":"Continental","description":"The?Alfredo Pasta?is an Italian?pasta?dish made using fresh penne?pasta, vegetables combined with butter, cream and cheese.","imageId":"15f579ecdf022bf645f073b8a9283ac4","inStock":1,"isVeg":1,"price":29900,"variants":{},"variantsV2":{},"addons":[{"groupId":"124897968","groupName":"Add Ons","choices":[{"id":"107558175","name":"3 Pcs Of Chicken Meatballs","price":12900,"inStock":1,"isEnabled":1},{"id":"107558176","name":"3 Pcs Of Mutton Meatballs","price":17900,"inStock":1,"isEnabled":1}],"maxAddons":2,"maxFreeAddons":-1}],"itemAttribute":{"vegClassifier":"VEG"},"ribbon":{},"showImage":true,"type":"ITEM","itemBadge":{},"badgesV2":{},"ratings":{"aggregatedRating":{"rating":"4.5","ratingCount":"21 ratings","ratingCountV2":"21"},"ratingsPresentationConfig":{"bgGradient":{"colours":["#C8F9E5","#00FFFFFF"],"gradientDirection":"GRADIENT_DIRECTION_LEFT_TO_RIGHT"},"ratingIconColor":"rating_very_good","ratingTextColor":"rating_very_good","ratingCountTextColor":"rating_very_good","ratingFontName":"FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD","ratingCountFontName":"FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"}},"itemPriceStrikeOff":true,"size":{"width":0.5,"height":0.9},"parentId":"65541010"},"restaurant":{"info":{"id":"666909","parentId":"400023","sla":{"serviceability":"NON_SERVICEABLE","iconType":"ICON_TYPE_EMPTY"},"availability":{},"badges":{},"aggregatedDiscountInfoV2":{},"badgesV2":{},"differentiatedUi":{"displayType":"ADS_UI_DISPLAY_TYPE_ENUM_DEFAULT","differentiatedUiMediaDetails":{"mediaType":"ADS_MEDIA_ENUM_IMAGE"}},"reviewsSummary":{},"displayType":"RESTAURANT_DISPLAY_TYPE_DEFAULT","restaurantOfferPresentationInfo":{},"dishStyle":{"socialMarkerStyle":[{"socialMarkerType":"SOCIAL_MARKER_TYPE_HIGH_PROTEIN","title":"Protein Rich","textStyle":"FONT_NAME_V2_BODY3_NEUTRAL_BOLD","textColor":"brand_proteinator_primary"},{"socialMarkerType":"SOCIAL_MARKER_TYPE_BESTSELLER","title":"Bestseller","textStyle":"FONT_NAME_V2_BODY3_NEUTRAL_BOLD","textColor":"color_swiggy_one"}]}}},"hideRestaurantDetails":true}},{"card":{"@type":"type.googleapis.com/swiggy.presentation.food.v2.Dish","info":{"id":"113821108","name":"Spaghetti Alfredo Pasta With Garlic Bread","category":"Continental","description":"The?Alfredo Pasta?is an Italian?pasta?dish made using fresh Spaghetti?pasta, vegetables combined with butter, cream and cheese.","imageId":"203fb6f02f3cae0fa745f962c00a8c74","inStock":1,"isVeg":1,"price":29900,"variants":{},"variantsV2":{},"addons":[{"groupId":"124897967","groupName":"Add Ons","choices":[{"id":"107558175","name":"3 Pcs Of Chicken Meatballs","price":12900,"inStock":1,"isEnabled":1},{"id":"107558176","name":"3 Pcs Of Mutton Meatballs","price":17900,"inStock":1,"isEnabled":1}],"maxAddons":2,"maxFreeAddons":-1}],"itemAttribute":{"vegClassifier":"VEG"},"ribbon":{},"showImage":true,"type":"ITEM","itemBadge":{},"badgesV2":{},"ratings":{"aggregatedRating":{"rating":"3.9","ratingCount":"44 ratings","ratingCountV2":"44"},"ratingsPresentationConfig":{"bgGradient":{"colours":["#D9EFEC","#00FFFFFF"],"gradientDirection":"GRADIENT_DIRECTION_LEFT_TO_RIGHT"},"ratingIconColor":"rating_medium","ratingTextColor":"rating_medium","ratingCountTextColor":"rating_medium","ratingFontName":"FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD","ratingCountFontName":"FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"}},"itemPriceStrikeOff":true,"size":{"width":0.5,"height":0.9},"parentId":"65541012"},"restaurant":{"info":{"id":"666909","parentId":"400023","sla":{"serviceability":"NON_SERVICEABLE","iconType":"ICON_TYPE_EMPTY"},"availability":{},"badges":{},"aggregatedDiscountInfoV2":{},"badgesV2":{},"differentiatedUi":{"displayType":"ADS_UI_DISPLAY_TYPE_ENUM_DEFAULT","differentiatedUiMediaDetails":{"mediaType":"ADS_MEDIA_ENUM_IMAGE"}},"reviewsSummary":{},"displayType":"RESTAURANT_DISPLAY_TYPE_DEFAULT","restaurantOfferPresentationInfo":{},"dishStyle":{"socialMarkerStyle":[{"socialMarkerType":"SOCIAL_MARKER_TYPE_HIGH_PROTEIN","title":"Protein Rich","textStyle":"FONT_NAME_V2_BODY3_NEUTRAL_BOLD","textColor":"brand_proteinator_primary"},{"socialMarkerType":"SOCIAL_MARKER_TYPE_BESTSELLER","title":"Bestseller","textStyle":"FONT_NAME_V2_BODY3_NEUTRAL_BOLD","textColor":"color_swiggy_one"}]}}},"hideRestaurantDetails":true}},{"card":{"@type":"type.googleapis.com/swiggy.presentation.food.v2.Dish","info":{"id":"108832045","name":"Cheese & Jalapeno Maggi","category":"Maggi & Momos","description":"Made with Cheese & Jalapeno.","imageId":"1b194491d06902dc12b533739256afd8","inStock":1,"isVeg":1,"price":15900,"variants":{},"variantsV2":{},"itemAttribute":{"vegClassifier":"VEG"},"ribbon":{},"showImage":true,"type":"ITEM","itemBadge":{},"badgesV2":{},"ratings":{"aggregatedRating":{"rating":"4.3","ratingCount":"40 ratings","ratingCountV2":"40"},"ratingsPresentationConfig":{"bgGradient":{"colours":["#C8F9E5","#00FFFFFF"],"gradientDirection":"GRADIENT_DIRECTION_LEFT_TO_RIGHT"},"ratingIconColor":"rating_very_good","ratingTextColor":"rating_very_good","ratingCountTextColor":"rating_very_good","ratingFontName":"FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD","ratingCountFontName":"FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"}},"itemPriceStrikeOff":true,"size":{"width":0.5,"height":0.9},"parentId":"62480044"},"restaurant":{"info":{"id":"666909","parentId":"400023","sla":{"serviceability":"NON_SERVICEABLE","iconType":"ICON_TYPE_EMPTY"},"availability":{},"badges":{},"aggregatedDiscountInfoV2":{},"badgesV2":{},"differentiatedUi":{"displayType":"ADS_UI_DISPLAY_TYPE_ENUM_DEFAULT","differentiatedUiMediaDetails":{"mediaType":"ADS_MEDIA_ENUM_IMAGE"}},"reviewsSummary":{},"displayType":"RESTAURANT_DISPLAY_TYPE_DEFAULT","restaurantOfferPresentationInfo":{},"dishStyle":{"socialMarkerStyle":[{"socialMarkerType":"SOCIAL_MARKER_TYPE_HIGH_PROTEIN","title":"Protein Rich","textStyle":"FONT_NAME_V2_BODY3_NEUTRAL_BOLD","textColor":"brand_proteinator_primary"},{"socialMarkerType":"SOCIAL_MARKER_TYPE_BESTSELLER","title":"Bestseller","textStyle":"FONT_NAME_V2_BODY3_NEUTRAL_BOLD","textColor":"color_swiggy_one"}]}}},"hideRestaurantDetails":true}},{"card":{"@type":"type.googleapis.com/swiggy.presentation.food.v2.Dish","info":{"id":"117716241","name":"Takatak Paneer Tikka Roll","category":"Rolls","description":"Made with tandoori paneer, onion, capsicum, cocktail of sauces & Indian spices.","imageId":"193ac982ad8ac0c9bbc20921686ffa01","inStock":1,"isVeg":1,"price":22900,"finalPrice":8900,"variants":{},"variantsV2":{},"addons":[{"groupId":"125599047","groupName":"Addon Egg","choices":[{"id":"107814090","name":"1 Egg","price":2900,"inStock":1,"isEnabled":1},{"id":"107814091","name":"2 Egg","price":4900,"inStock":1,"isEnabled":1}],"maxAddons":1,"maxFreeAddons":-1},{"groupId":"125599048","groupName":"Choice Of Filling","choices":[{"id":"107814092","name":"Soya Filling","price":7900,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"107814093","name":"Paneer Tikka","price":9900,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"107814094","name":"Chicken Tikka","price":9900,"inStock":1,"isEnabled":1},{"id":"107814095","name":"Malai Tikka","price":9900,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"107814096","name":"Mutton Masala","price":12900,"isEnabled":1}],"maxAddons":1,"maxFreeAddons":-1},{"groupId":"125599049","groupName":"Choice Of Drinks","choices":[{"id":"107814097","name":"Ice Tea","price":8900,"inStock":1,"isVeg":1,"isEnabled":1}],"maxAddons":1,"maxFreeAddons":-1},{"groupId":"125599050","groupName":"Choice Of Sweet","choices":[{"id":"107814098","name":"Gulab Jamun 1 Pc","price":4900,"inStock":1,"isVeg":1,"isEnabled":1}],"maxAddons":1,"maxFreeAddons":-1}],"itemAttribute":{"vegClassifier":"VEG"},"ribbon":{},"showImage":true,"type":"ITEM","offerTags":[{"matchText":"SILD"}],"itemBadge":{},"badgesV2":{},"itemNudgeType":"FinalPrice","ratings":{"aggregatedRating":{"rating":"3.9","ratingCount":"40 ratings","ratingCountV2":"40"},"ratingsPresentationConfig":{"bgGradient":{"colours":["#D9EFEC","#00FFFFFF"],"gradientDirection":"GRADIENT_DIRECTION_LEFT_TO_RIGHT"},"ratingIconColor":"rating_medium","ratingTextColor":"rating_medium","ratingCountTextColor":"rating_medium","ratingFontName":"FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD","ratingCountFontName":"FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"}},"itemPriceStrikeOff":true,"offerIds":["9caf6a85-3e4e-42da-ae21-f9705c6593d3"],"size":{"width":0.5,"height":0.9},"parentId":"67273352","offerCategory":"OFFER_CATEGORY_DEAL_RUSH","offerHeader":"Only till","offerSubHeader":"10:00 AM"},"restaurant":{"info":{"id":"666909","parentId":"400023","sla":{"serviceability":"NON_SERVICEABLE","iconType":"ICON_TYPE_EMPTY"},"availability":{},"badges":{},"aggregatedDiscountInfoV2":{},"badgesV2":{},"differentiatedUi":{"displayType":"ADS_UI_DISPLAY_TYPE_ENUM_DEFAULT","differentiatedUiMediaDetails":{"mediaType":"ADS_MEDIA_ENUM_IMAGE"}},"reviewsSummary":{},"displayType":"RESTAURANT_DISPLAY_TYPE_DEFAULT","restaurantOfferPresentationInfo":{},"dishStyle":{"socialMarkerStyle":[{"socialMarkerType":"SOCIAL_MARKER_TYPE_HIGH_PROTEIN","title":"Protein Rich","textStyle":"FONT_NAME_V2_BODY3_NEUTRAL_BOLD","textColor":"brand_proteinator_primary"},{"socialMarkerType":"SOCIAL_MARKER_TYPE_BESTSELLER","title":"Bestseller","textStyle":"FONT_NAME_V2_BODY3_NEUTRAL_BOLD","textColor":"color_swiggy_one"}]}}},"hideRestaurantDetails":true}},{"card":{"@type":"type.googleapis.com/swiggy.presentation.food.v2.Dish","info":{"id":"110617185","name":"Rajma & Rice","category":"Indian Meal","description":"Made with protein rich kidney beans. Served with rice.","imageId":"2d72335d0004cedb54725a02a530e6ef","inStock":1,"isVeg":1,"price":23900,"variants":{},"variantsV2":{},"itemAttribute":{"vegClassifier":"VEG"},"ribbon":{},"showImage":true,"type":"ITEM","itemBadge":{},"badgesV2":{},"ratings":{"aggregatedRating":{"rating":"4.4","ratingCount":"29 ratings","ratingCountV2":"29"},"ratingsPresentationConfig":{"bgGradient":{"colours":["#C8F9E5","#00FFFFFF"],"gradientDirection":"GRADIENT_DIRECTION_LEFT_TO_RIGHT"},"ratingIconColor":"rating_very_good","ratingTextColor":"rating_very_good","ratingCountTextColor":"rating_very_good","ratingFontName":"FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD","ratingCountFontName":"FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"}},"itemPriceStrikeOff":true,"size":{"width":0.5,"height":0.9},"parentId":"63685388"},"restaurant":{"info":{"id":"666909","parentId":"400023","sla":{"serviceability":"NON_SERVICEABLE","iconType":"ICON_TYPE_EMPTY"},"availability":{},"badges":{},"aggregatedDiscountInfoV2":{},"badgesV2":{},"differentiatedUi":{"displayType":"ADS_UI_DISPLAY_TYPE_ENUM_DEFAULT","differentiatedUiMediaDetails":{"mediaType":"ADS_MEDIA_ENUM_IMAGE"}},"reviewsSummary":{},"displayType":"RESTAURANT_DISPLAY_TYPE_DEFAULT","restaurantOfferPresentationInfo":{},"dishStyle":{"socialMarkerStyle":[{"socialMarkerType":"SOCIAL_MARKER_TYPE_HIGH_PROTEIN","title":"Protein Rich","textStyle":"FONT_NAME_V2_BODY3_NEUTRAL_BOLD","textColor":"brand_proteinator_primary"},{"socialMarkerType":"SOCIAL_MARKER_TYPE_BESTSELLER","title":"Bestseller","textStyle":"FONT_NAME_V2_BODY3_NEUTRAL_BOLD","textColor":"color_swiggy_one"}]}}},"hideRestaurantDetails":true}},{"card":{"@type":"type.googleapis.com/swiggy.presentation.food.v2.Dish","info":{"id":"110876020","name":"Sabudana Khichdi","category":"All Day Breakfast","description":"Made with tapioca pearls, whole spices, roasted peanuts, potatoes and fresh curry leaves.","imageId":"a3e91009b0a3a84b28adaf15a5128967","inStock":1,"isVeg":1,"price":19900,"finalPrice":7900,"variants":{},"variantsV2":{},"addons":[{"groupId":"169394260","groupName":"Extra For Any","choices":[{"id":"122678749","name":"Nimbu Pani","price":6900,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"122678729","name":"Jaljeera","price":6900,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"122678736","name":"Raita","price":4900,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"122678743","name":"Gulab Jamun 2 Pcs","price":7900,"inStock":1,"isVeg":1,"isEnabled":1}],"maxAddons":1,"maxFreeAddons":-1}],"itemAttribute":{"vegClassifier":"VEG"},"ribbon":{},"showImage":true,"type":"ITEM","offerTags":[{"matchText":"SILD"}],"itemBadge":{},"badgesV2":{},"itemNudgeType":"FinalPrice","ratings":{"aggregatedRating":{"rating":"3.9","ratingCount":"77 ratings","ratingCountV2":"77"},"ratingsPresentationConfig":{"bgGradient":{"colours":["#D9EFEC","#00FFFFFF"],"gradientDirection":"GRADIENT_DIRECTION_LEFT_TO_RIGHT"},"ratingIconColor":"rating_medium","ratingTextColor":"rating_medium","ratingCountTextColor":"rating_medium","ratingFontName":"FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD","ratingCountFontName":"FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"}},"itemPriceStrikeOff":true,"offerIds":["ddb29a66-004d-473d-a6fd-0e9b88a39632"],"size":{"width":0.5,"height":0.9},"parentId":"63591707","offerCategory":"OFFER_CATEGORY_DEAL_RUSH","offerHeader":"Only till","offerSubHeader":"10:00 AM"},"restaurant":{"info":{"id":"666909","parentId":"400023","sla":{"serviceability":"NON_SERVICEABLE","iconType":"ICON_TYPE_EMPTY"},"availability":{},"badges":{},"aggregatedDiscountInfoV2":{},"badgesV2":{},"differentiatedUi":{"displayType":"ADS_UI_DISPLAY_TYPE_ENUM_DEFAULT","differentiatedUiMediaDetails":{"mediaType":"ADS_MEDIA_ENUM_IMAGE"}},"reviewsSummary":{},"displayType":"RESTAURANT_DISPLAY_TYPE_DEFAULT","restaurantOfferPresentationInfo":{},"dishStyle":{"socialMarkerStyle":[{"socialMarkerType":"SOCIAL_MARKER_TYPE_HIGH_PROTEIN","title":"Protein Rich","textStyle":"FONT_NAME_V2_BODY3_NEUTRAL_BOLD","textColor":"brand_proteinator_primary"},{"socialMarkerType":"SOCIAL_MARKER_TYPE_BESTSELLER","title":"Bestseller","textStyle":"FONT_NAME_V2_BODY3_NEUTRAL_BOLD","textColor":"color_swiggy_one"}]}}},"hideRestaurantDetails":true}},{"card":{"@type":"type.googleapis.com/swiggy.presentation.food.v2.Dish","info":{"id":"113821103","name":"Chicken Kurket [6 Pcs]","category":"Continental","description":"Chicken kurket?are deep fried, stuffed with minced chicken, Potato and spices coated in crispy breadcrumbs.","imageId":"9ee3be8226ddd34bf17d221d0952b298","inStock":1,"price":19900,"variants":{},"variantsV2":{},"itemAttribute":{"vegClassifier":"NONVEG"},"ribbon":{},"showImage":true,"type":"ITEM","itemBadge":{},"badgesV2":{},"ratings":{"aggregatedRating":{"rating":"4.2","ratingCount":"72 ratings","ratingCountV2":"72"},"ratingsPresentationConfig":{"bgGradient":{"colours":["#C8F9E5","#00FFFFFF"],"gradientDirection":"GRADIENT_DIRECTION_LEFT_TO_RIGHT"},"ratingIconColor":"rating_very_good","ratingTextColor":"rating_very_good","ratingCountTextColor":"rating_very_good","ratingFontName":"FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD","ratingCountFontName":"FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"}},"itemPriceStrikeOff":true,"size":{"width":0.5,"height":0.9},"parentId":"65541007"},"restaurant":{"info":{"id":"666909","parentId":"400023","sla":{"serviceability":"NON_SERVICEABLE","iconType":"ICON_TYPE_EMPTY"},"availability":{},"badges":{},"aggregatedDiscountInfoV2":{},"badgesV2":{},"differentiatedUi":{"displayType":"ADS_UI_DISPLAY_TYPE_ENUM_DEFAULT","differentiatedUiMediaDetails":{"mediaType":"ADS_MEDIA_ENUM_IMAGE"}},"reviewsSummary":{},"displayType":"RESTAURANT_DISPLAY_TYPE_DEFAULT","restaurantOfferPresentationInfo":{},"dishStyle":{"socialMarkerStyle":[{"socialMarkerType":"SOCIAL_MARKER_TYPE_HIGH_PROTEIN","title":"Protein Rich","textStyle":"FONT_NAME_V2_BODY3_NEUTRAL_BOLD","textColor":"brand_proteinator_primary"},{"socialMarkerType":"SOCIAL_MARKER_TYPE_BESTSELLER","title":"Bestseller","textStyle":"FONT_NAME_V2_BODY3_NEUTRAL_BOLD","textColor":"color_swiggy_one"}]}}},"hideRestaurantDetails":true}},{"card":{"@type":"type.googleapis.com/swiggy.presentation.food.v2.Dish","info":{"id":"111576928","name":"Shredded Chicken Cold Sandwich (brown Bread)","category":"Sandwiches","description":"Made with shredded chicken, mayo, vegetables, flavored with salt & paper.","imageId":"a5d546677bb738f7d33c88b4130424b4","inStock":1,"price":23900,"variants":{},"variantsV2":{},"itemAttribute":{"vegClassifier":"NONVEG"},"ribbon":{},"showImage":true,"type":"ITEM","itemBadge":{},"badgesV2":{},"ratings":{"aggregatedRating":{"rating":"4.7","ratingCount":"24 ratings","ratingCountV2":"24"},"ratingsPresentationConfig":{"bgGradient":{"colours":["#C8F9E5","#00FFFFFF"],"gradientDirection":"GRADIENT_DIRECTION_LEFT_TO_RIGHT"},"ratingIconColor":"rating_very_good","ratingTextColor":"rating_very_good","ratingCountTextColor":"rating_very_good","ratingFontName":"FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD","ratingCountFontName":"FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"}},"itemPriceStrikeOff":true,"size":{"width":0.5,"height":0.9},"parentId":"62480117"},"restaurant":{"info":{"id":"666909","parentId":"400023","sla":{"serviceability":"NON_SERVICEABLE","iconType":"ICON_TYPE_EMPTY"},"availability":{},"badges":{},"aggregatedDiscountInfoV2":{},"badgesV2":{},"differentiatedUi":{"displayType":"ADS_UI_DISPLAY_TYPE_ENUM_DEFAULT","differentiatedUiMediaDetails":{"mediaType":"ADS_MEDIA_ENUM_IMAGE"}},"reviewsSummary":{},"displayType":"RESTAURANT_DISPLAY_TYPE_DEFAULT","restaurantOfferPresentationInfo":{},"dishStyle":{"socialMarkerStyle":[{"socialMarkerType":"SOCIAL_MARKER_TYPE_HIGH_PROTEIN","title":"Protein Rich","textStyle":"FONT_NAME_V2_BODY3_NEUTRAL_BOLD","textColor":"brand_proteinator_primary"},{"socialMarkerType":"SOCIAL_MARKER_TYPE_BESTSELLER","title":"Bestseller","textStyle":"FONT_NAME_V2_BODY3_NEUTRAL_BOLD","textColor":"color_swiggy_one"}]}}},"hideRestaurantDetails":true}}],"type":"CATEGORY_TYPE_RECOMMENDED","widgetType":"WIDGET_TYPE_DISH_FIRST","categoryStyle":{"layout":{"rows":1,"columns":2,"horizontalScrollEnabled":true,"itemSpacing":16,"containerStyle":{"containerPadding":{"left":16,"top":12,"right":16,"bottom":12}}},"itemStyle":{"width":{"type":"TYPE_RELATIVE","value":0.5,"reference":"RELATIVE_DIMENSION_REFERENCE_CONTAINER_WIDTH"},"height":{"type":"TYPE_RELATIVE","value":1,"reference":"RELATIVE_DIMENSION_REFERENCE_WIDTH"}},"supportEvenItemsOnly":true},"headerStyle":{"padding":{"left":16,"top":16,"right":16,"bottom":16},"titleColor":"text_color_highest_emphasis","titleFontName":"FONT_NAME_SUB_HEADER_S1_BOLD","imageStyle":{"width":{},"height":{}},"gradientStyle":{}},"dividerStyle":{"color":"#1502060C","height":1,"padding":{"left":16,"right":16}}}}},{"card":{"card":{"@type":"type.googleapis.com/swiggy.presentation.food.v2.ItemCategory","title":"All Day Breakfast","itemCards":[{"card":{"@type":"type.googleapis.com/swiggy.presentation.food.v2.Dish","info":{"id":"108831984","name":"Poha With Sev","category":"All Day Breakfast","description":"Traditional Indian Breakfast made with flattened rice, onions, peanuts and flavored with basic spices and herbs served with medium spicy sev.","imageId":"7a0ba771f71c9f995a4a83a00497b8e5","inStock":1,"isVeg":1,"price":15900,"variants":{},"variantsV2":{},"addons":[{"groupId":"169394261","groupName":"Extra For Any","choices":[{"id":"122678749","name":"Nimbu Pani","price":6900,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"122678729","name":"Jaljeera","price":6900,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"122678736","name":"Raita","price":4900,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"122678743","name":"Gulab Jamun 2 Pcs","price":7900,"inStock":1,"isVeg":1,"isEnabled":1}],"maxAddons":1,"maxFreeAddons":-1}],"itemAttribute":{"vegClassifier":"VEG"},"ribbon":{"text":"Bestseller","textColor":"#ffffff","topBackgroundColor":"#d53d4c","bottomBackgroundColor":"#b02331"},"type":"ITEM","itemBadge":{},"badgesV2":{},"isBestseller":true,"ratings":{"aggregatedRating":{"rating":"4.3","ratingCount":"103 ratings","ratingCountV2":"103"},"ratingsPresentationConfig":{"bgGradient":{"colours":["#C8F9E5","#00FFFFFF"],"gradientDirection":"GRADIENT_DIRECTION_LEFT_TO_RIGHT"},"ratingIconColor":"rating_very_good","ratingTextColor":"rating_very_good","ratingCountTextColor":"rating_very_good","ratingFontName":"FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD","ratingCountFontName":"FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"}},"itemPriceStrikeOff":true,"size":{"width":0.46,"height":1},"parentId":"62480108"},"analytics":{},"hideRestaurantDetails":true}},{"card":{"@type":"type.googleapis.com/swiggy.presentation.food.v2.Dish","info":{"id":"108831975","name":"Mumbai Street Style Pav Bhaji","category":"All Day Breakfast","description":"Mumbai street food made of a spicy mashed vegetable curry served topped with a dollop of butter along with soft dinner roll.","imageId":"c9950bf23deeb3f297046ff0e236e75f","inStock":1,"isVeg":1,"price":19900,"finalPrice":7900,"variants":{},"variantsV2":{},"addons":[{"groupId":"169394263","groupName":"Extra Add Ons","choices":[{"id":"122678746","name":"Raita","price":4900,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"122678738","name":"Jaljeera","price":6900,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"122678731","name":"Bhaji","price":12900,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"122678725","name":"Nimbu Pani","price":6900,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"122678750","name":"Pav 2 Pcs","price":6900,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"122678735","name":"Gulab Jamun 2 Pcs","price":7900,"isVeg":1,"isEnabled":1}],"maxAddons":1,"maxFreeAddons":-1}],"itemAttribute":{"vegClassifier":"VEG"},"ribbon":{"text":"Bestseller","textColor":"#ffffff","topBackgroundColor":"#d53d4c","bottomBackgroundColor":"#b02331"},"type":"ITEM","offerTags":[{"matchText":"SILD"}],"itemBadge":{},"badgesV2":{},"itemNudgeType":"FinalPrice","isBestseller":true,"ratings":{"aggregatedRating":{"rating":"4.4","ratingCount":"227 ratings","ratingCountV2":"227"},"ratingsPresentationConfig":{"bgGradient":{"colours":["#C8F9E5","#00FFFFFF"],"gradientDirection":"GRADIENT_DIRECTION_LEFT_TO_RIGHT"},"ratingIconColor":"rating_very_good","ratingTextColor":"rating_very_good","ratingCountTextColor":"rating_very_good","ratingFontName":"FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD","ratingCountFontName":"FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"}},"itemPriceStrikeOff":true,"offerIds":["ddb29a66-004d-473d-a6fd-0e9b88a39632"],"size":{"width":0.46,"height":1},"parentId":"62480098","offerCategory":"OFFER_CATEGORY_DEAL_RUSH","offerHeader":"Only till","offerSubHeader":"10:00 AM"},"analytics":{},"hideRestaurantDetails":true}},{"card":{"@type":"type.googleapis.com/swiggy.presentation.food.v2.Dish","info":{"id":"110876024","name":"Hot N Healthy Steamed Black Chana","category":"All Day Breakfast","description":"Super healthy Steamed chana garnished with indian herbs & spices.","imageId":"bbdea2b52905e1c5c2a4aec21547cbca","inStock":1,"isVeg":1,"price":10900,"variants":{},"variantsV2":{},"itemAttribute":{"vegClassifier":"VEG"},"ribbon":{"text":"Bestseller","textColor":"#ffffff","topBackgroundColor":"#d53d4c","bottomBackgroundColor":"#b02331"},"type":"ITEM","itemBadge":{},"badgesV2":{},"isBestseller":true,"ratings":{"aggregatedRating":{"rating":"4.6","ratingCount":"101 ratings","ratingCountV2":"101"},"ratingsPresentationConfig":{"bgGradient":{"colours":["#C8F9E5","#00FFFFFF"],"gradientDirection":"GRADIENT_DIRECTION_LEFT_TO_RIGHT"},"ratingIconColor":"rating_very_good","ratingTextColor":"rating_very_good","ratingCountTextColor":"rating_very_good","ratingFontName":"FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD","ratingCountFontName":"FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"}},"itemPriceStrikeOff":true,"size":{"width":0.46,"height":1},"parentId":"62480078"},"analytics":{},"hideRestaurantDetails":true}},{"card":{"@type":"type.googleapis.com/swiggy.presentation.food.v2.Dish","info":{"id":"108831976","name":"Vada Pav (2 Pcs)","category":"All Day Breakfast","description":"Savory dinner roll stuffed with fried mashed and spiced potato fritters.","imageId":"be79240af2f5d877e381e7fd055b219a","inStock":1,"isVeg":1,"price":10900,"finalPrice":3900,"variants":{},"variantsV2":{},"addons":[{"groupId":"169394265","groupName":"Extra For Vada Pav","choices":[{"id":"122678730","name":"Jaljeera","price":6900,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"122678742","name":"Gulab Jamun 2 Pcs","price":7900,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"122678748","name":"Nembu Pani","price":6900,"inStock":1,"isVeg":1,"isEnabled":1}],"maxAddons":1,"maxFreeAddons":-1}],"itemAttribute":{"vegClassifier":"VEG"},"ribbon":{"text":"Bestseller","textColor":"#ffffff","topBackgroundColor":"#d53d4c","bottomBackgroundColor":"#b02331"},"type":"ITEM","offerTags":[{"matchText":"SILD"}],"itemBadge":{},"badgesV2":{},"itemNudgeType":"FinalPrice","isBestseller":true,"ratings":{"aggregatedRating":{"rating":"4.5","ratingCount":"254 ratings","ratingCountV2":"254"},"ratingsPresentationConfig":{"bgGradient":{"colours":["#C8F9E5","#00FFFFFF"],"gradientDirection":"GRADIENT_DIRECTION_LEFT_TO_RIGHT"},"ratingIconColor":"rating_very_good","ratingTextColor":"rating_very_good","ratingCountTextColor":"rating_very_good","ratingFontName":"FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD","ratingCountFontName":"FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"}},"itemPriceStrikeOff":true,"offerIds":["e0dbebae-461e-4fc0-a7d0-8ba51f921c60"],"size":{"width":0.46,"height":1},"parentId":"62480127","offerCategory":"OFFER_CATEGORY_DEAL_RUSH","offerHeader":"Only till","offerSubHeader":"10:00 AM"},"analytics":{},"hideRestaurantDetails":true}},{"card":{"@type":"type.googleapis.com/swiggy.presentation.food.v2.Dish","info":{"id":"108832038","name":"Bun Maska","category":"All Day Breakfast","description":"Bun & Butter","imageId":"6ac88422b882ed756f48020cebd8e5a5","inStock":1,"isVeg":1,"price":4900,"variants":{},"variantsV2":{},"itemAttribute":{"vegClassifier":"VEG"},"ribbon":{},"type":"ITEM","itemBadge":{},"badgesV2":{},"ratings":{"aggregatedRating":{"rating":"4.1","ratingCount":"190 ratings","ratingCountV2":"190"},"ratingsPresentationConfig":{"bgGradient":{"colours":["#C8F9E5","#00FFFFFF"],"gradientDirection":"GRADIENT_DIRECTION_LEFT_TO_RIGHT"},"ratingIconColor":"rating_very_good","ratingTextColor":"rating_very_good","ratingCountTextColor":"rating_very_good","ratingFontName":"FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD","ratingCountFontName":"FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"}},"itemPriceStrikeOff":true,"size":{"width":0.46,"height":1},"parentId":"62480042"},"analytics":{},"hideRestaurantDetails":true}},{"card":{"@type":"type.googleapis.com/swiggy.presentation.food.v2.Dish","info":{"id":"108831977","name":"Egg Bhurji With Pav","category":"All Day Breakfast","description":"Indian style spiced scrambled egg served with dinner roll.","imageId":"20c333611bdc4969b1a37de4f30887f9","inStock":1,"price":15900,"variants":{},"variantsV2":{},"addons":[{"groupId":"169394264","groupName":"Extra For Bhurji Pav","choices":[{"id":"122678723","name":"Pav 2 Pcs","price":6900,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"122678733","name":"Raita","price":4900,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"122678727","name":"Jaljeera","price":6900,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"122678753","name":"Egg Bhurji","price":7900,"inStock":1,"isEnabled":1},{"id":"122678747","name":"Nimbu Pani","price":6900,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"122678740","name":"Gulab Jamun 2 Pcs","price":7900,"inStock":1,"isVeg":1,"isEnabled":1}],"maxAddons":1,"maxFreeAddons":-1}],"itemAttribute":{"vegClassifier":"NONVEG"},"ribbon":{},"type":"ITEM","itemBadge":{},"badgesV2":{},"ratings":{"aggregatedRating":{"rating":"4.1","ratingCount":"53 ratings","ratingCountV2":"53"},"ratingsPresentationConfig":{"bgGradient":{"colours":["#C8F9E5","#00FFFFFF"],"gradientDirection":"GRADIENT_DIRECTION_LEFT_TO_RIGHT"},"ratingIconColor":"rating_very_good","ratingTextColor":"rating_very_good","ratingCountTextColor":"rating_very_good","ratingFontName":"FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD","ratingCountFontName":"FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"}},"itemPriceStrikeOff":true,"size":{"width":0.46,"height":1},"parentId":"62480072"},"analytics":{},"hideRestaurantDetails":true}},{"card":{"@type":"type.googleapis.com/swiggy.presentation.food.v2.Dish","info":{"id":"108831979","name":"Idili Sambar","category":"All Day Breakfast","description":"Steamed spongy rice cake paired with a spicy and tangy","imageId":"cf72cb7bff86a1c532419cd20cb76709","inStock":1,"isVeg":1,"price":10900,"variants":{},"variantsV2":{},"addons":[{"groupId":"169394266","groupName":"Extra","choices":[{"id":"122678721","name":"Idli 2 Pcs","price":5900,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"122678732","name":"Extra Tomoto & Coconut Chutney","price":3900,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"122678744","name":"Nimbu Pani","price":6900,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"122678739","name":"Gulab Jamun 2 Pcs","price":7900,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"122678726","name":"Jaljeera","price":6900,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"122678751","name":"Extra Sambar","price":5900,"inStock":1,"isVeg":1,"isEnabled":1}],"maxAddons":1,"maxFreeAddons":-1}],"itemAttribute":{"vegClassifier":"VEG"},"ribbon":{},"type":"ITEM","itemBadge":{},"badgesV2":{},"ratings":{"aggregatedRating":{"rating":"3.9","ratingCount":"149 ratings","ratingCountV2":"149"},"ratingsPresentationConfig":{"bgGradient":{"colours":["#D9EFEC","#00FFFFFF"],"gradientDirection":"GRADIENT_DIRECTION_LEFT_TO_RIGHT"},"ratingIconColor":"rating_medium","ratingTextColor":"rating_medium","ratingCountTextColor":"rating_medium","ratingFontName":"FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD","ratingCountFontName":"FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"}},"itemPriceStrikeOff":true,"size":{"width":0.46,"height":1},"parentId":"62480081"},"analytics":{},"hideRestaurantDetails":true}},{"card":{"@type":"type.googleapis.com/swiggy.presentation.food.v2.Dish","info":{"id":"108831985","name":"Upma With Chutney","category":"All Day Breakfast","description":"Traditional south Indian breakfast dish made by simmering roasted rava in tempered & spiced boiling water served with coconut chutney","imageId":"6aabdefd1067624a6eeb49ce11195933","inStock":1,"isVeg":1,"price":15900,"variants":{},"variantsV2":{},"addons":[{"groupId":"169394259","groupName":"Extra For Any","choices":[{"id":"122678749","name":"Nimbu Pani","price":6900,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"122678729","name":"Jaljeera","price":6900,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"122678736","name":"Raita","price":4900,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"122678743","name":"Gulab Jamun 2 Pcs","price":7900,"inStock":1,"isVeg":1,"isEnabled":1}],"maxAddons":1,"maxFreeAddons":-1}],"itemAttribute":{"vegClassifier":"VEG"},"ribbon":{},"type":"ITEM","itemBadge":{},"badgesV2":{},"ratings":{"aggregatedRating":{"rating":"4.4","ratingCount":"60 ratings","ratingCountV2":"60"},"ratingsPresentationConfig":{"bgGradient":{"colours":["#C8F9E5","#00FFFFFF"],"gradientDirection":"GRADIENT_DIRECTION_LEFT_TO_RIGHT"},"ratingIconColor":"rating_very_good","ratingTextColor":"rating_very_good","ratingCountTextColor":"rating_very_good","ratingFontName":"FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD","ratingCountFontName":"FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"}},"itemPriceStrikeOff":true,"size":{"width":0.46,"height":1},"parentId":"62480126"},"analytics":{},"hideRestaurantDetails":true}},{"card":{"@type":"type.googleapis.com/swiggy.presentation.food.v2.Dish","info":{"id":"110876020","name":"Sabudana Khichdi","category":"All Day Breakfast","description":"Made with tapioca pearls, whole spices, roasted peanuts, potatoes and fresh curry leaves.","imageId":"a3e91009b0a3a84b28adaf15a5128967","inStock":1,"isVeg":1,"price":19900,"finalPrice":7900,"variants":{},"variantsV2":{},"addons":[{"groupId":"169394260","groupName":"Extra For Any","choices":[{"id":"122678749","name":"Nimbu Pani","price":6900,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"122678729","name":"Jaljeera","price":6900,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"122678736","name":"Raita","price":4900,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"122678743","name":"Gulab Jamun 2 Pcs","price":7900,"inStock":1,"isVeg":1,"isEnabled":1}],"maxAddons":1,"maxFreeAddons":-1}],"itemAttribute":{"vegClassifier":"VEG"},"ribbon":{},"type":"ITEM","offerTags":[{"matchText":"SILD"}],"itemBadge":{},"badgesV2":{},"itemNudgeType":"FinalPrice","ratings":{"aggregatedRating":{"rating":"3.9","ratingCount":"77 ratings","ratingCountV2":"77"},"ratingsPresentationConfig":{"bgGradient":{"colours":["#D9EFEC","#00FFFFFF"],"gradientDirection":"GRADIENT_DIRECTION_LEFT_TO_RIGHT"},"ratingIconColor":"rating_medium","ratingTextColor":"rating_medium","ratingCountTextColor":"rating_medium","ratingFontName":"FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD","ratingCountFontName":"FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"}},"itemPriceStrikeOff":true,"offerIds":["ddb29a66-004d-473d-a6fd-0e9b88a39632"],"size":{"width":0.46,"height":1},"parentId":"63591707","offerCategory":"OFFER_CATEGORY_DEAL_RUSH","offerHeader":"Only till","offerSubHeader":"10:00 AM"},"analytics":{},"hideRestaurantDetails":true}},{"card":{"@type":"type.googleapis.com/swiggy.presentation.food.v2.Dish","info":{"id":"108831989","name":"Hummus Falafel","category":"All Day Breakfast","description":"Falafels & Hummus are?a middle eastern food made from chickpeas, spices, and herbs.","imageId":"660ae199256911f27d40ca7541175a66","inStock":1,"isVeg":1,"price":21900,"variants":{},"variantsV2":{},"addons":[{"groupId":"169394268","groupName":"Esxtra For Hummus Falafel","choices":[{"id":"122678722","name":"Nimbu Pani","price":6900,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"122678741","name":"Extra Falafe","price":12500,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"122678752","name":"Jaljeera","price":6900,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"122678720","name":"Gulab Jamun 2 Pcs","price":7900,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"122678728","name":"Extra Hummus","price":12500,"inStock":1,"isVeg":1,"isEnabled":1}],"maxAddons":1,"maxFreeAddons":-1}],"itemAttribute":{"vegClassifier":"VEG"},"ribbon":{},"type":"ITEM","itemBadge":{},"badgesV2":{},"ratings":{"aggregatedRating":{"rating":"3.9","ratingCount":"39 ratings","ratingCountV2":"39"},"ratingsPresentationConfig":{"bgGradient":{"colours":["#D9EFEC","#00FFFFFF"],"gradientDirection":"GRADIENT_DIRECTION_LEFT_TO_RIGHT"},"ratingIconColor":"rating_medium","ratingTextColor":"rating_medium","ratingCountTextColor":"rating_medium","ratingFontName":"FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD","ratingCountFontName":"FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"}},"itemPriceStrikeOff":true,"size":{"width":0.46,"height":1},"parentId":"62480079"},"analytics":{},"hideRestaurantDetails":true}},{"card":{"@type":"type.googleapis.com/swiggy.presentation.food.v2.Dish","info":{"id":"108831986","name":"Bisi Belle Bath","category":"All Day Breakfast","description":"Bisi bele bath?is a flavorsome, spicy and slightly tangy meal made with lentils, rice, mixed vegetables and a super aromatic spice powder.","imageId":"0f89c68a7c8a9ecf89490ca22b2ef5e3","inStock":1,"isVeg":1,"price":20900,"variants":{},"variantsV2":{},"addons":[{"groupId":"169394267","groupName":"Extra For Bisi Belle Bath","choices":[{"id":"122678734","name":"Jaljeera","price":6900,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"122678745","name":"Gulab Jamun 2 Pcs","price":7900,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"122678724","name":"Jaggery, Pickle & Papad Churi","price":3900,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"122678737","name":"Nimbu Pani","price":6900,"inStock":1,"isVeg":1,"isEnabled":1}],"maxAddons":1,"maxFreeAddons":-1}],"itemAttribute":{"vegClassifier":"VEG"},"ribbon":{},"type":"ITEM","itemBadge":{},"badgesV2":{},"ratings":{"aggregatedRating":{"rating":"4.9","ratingCount":"13 ratings","ratingCountV2":"13"},"ratingsPresentationConfig":{"bgGradient":{"colours":["#C8F9E5","#00FFFFFF"],"gradientDirection":"GRADIENT_DIRECTION_LEFT_TO_RIGHT"},"ratingIconColor":"rating_very_good","ratingTextColor":"rating_very_good","ratingCountTextColor":"rating_very_good","ratingFontName":"FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD","ratingCountFontName":"FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"}},"itemPriceStrikeOff":true,"size":{"width":0.46,"height":1},"parentId":"62480039"},"analytics":{},"hideRestaurantDetails":true}},{"card":{"@type":"type.googleapis.com/swiggy.presentation.food.v2.Dish","info":{"id":"108832039","name":"Bun Omelet","category":"All Day Breakfast","description":"Egg?omelette, stuffed in?bun.","imageId":"7e5255da515a8a07a459b55e60a400d9","inStock":1,"price":14900,"variants":{},"variantsV2":{},"itemAttribute":{"vegClassifier":"NONVEG"},"ribbon":{},"type":"ITEM","itemBadge":{},"badgesV2":{},"ratings":{"aggregatedRating":{"rating":"3.6","ratingCount":"32 ratings","ratingCountV2":"32"},"ratingsPresentationConfig":{"bgGradient":{"colours":["#D9EFEC","#00FFFFFF"],"gradientDirection":"GRADIENT_DIRECTION_LEFT_TO_RIGHT"},"ratingIconColor":"rating_medium","ratingTextColor":"rating_medium","ratingCountTextColor":"rating_medium","ratingFontName":"FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD","ratingCountFontName":"FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"}},"itemPriceStrikeOff":true,"size":{"width":0.46,"height":1},"parentId":"62480043"},"analytics":{},"hideRestaurantDetails":true}},{"card":{"@type":"type.googleapis.com/swiggy.presentation.food.v2.Dish","info":{"id":"108831988","name":"Hot Cup Corn Snack","category":"All Day Breakfast","description":"Made with?boiled corns, butter, lemon juice and spices?like chaat masala, garam masala, and chili powder.","imageId":"dfc4b0ebe350e8411d59b78d4545cd76","inStock":1,"isVeg":1,"price":10900,"variants":{},"variantsV2":{},"itemAttribute":{"vegClassifier":"VEG"},"ribbon":{},"type":"ITEM","itemBadge":{},"badgesV2":{},"ratings":{"aggregatedRating":{"rating":"4.3","ratingCount":"76 ratings","ratingCountV2":"76"},"ratingsPresentationConfig":{"bgGradient":{"colours":["#C8F9E5","#00FFFFFF"],"gradientDirection":"GRADIENT_DIRECTION_LEFT_TO_RIGHT"},"ratingIconColor":"rating_very_good","ratingTextColor":"rating_very_good","ratingCountTextColor":"rating_very_good","ratingFontName":"FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD","ratingCountFontName":"FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"}},"itemPriceStrikeOff":true,"size":{"width":0.46,"height":1},"parentId":"62480077"},"analytics":{},"hideRestaurantDetails":true}},{"card":{"@type":"type.googleapis.com/swiggy.presentation.food.v2.Dish","info":{"id":"108831980","name":"Sambar Vada","category":"All Day Breakfast","description":"Donut shaped lentil fritters?that are fluffy, crispy, soft and delicious paired with a spicy and tangy?sambar served with coconut & red chutney.","imageId":"026d87c4bb43727ea3b19411020f148b","inStock":1,"isVeg":1,"price":10900,"finalPrice":3900,"variants":{},"variantsV2":{},"addons":[{"groupId":"169394262","groupName":"Extra","choices":[{"id":"122678721","name":"Idli 2 Pcs","price":5900,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"122678732","name":"Extra Tomoto & Coconut Chutney","price":3900,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"122678744","name":"Nimbu Pani","price":6900,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"122678739","name":"Gulab Jamun 2 Pcs","price":7900,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"122678726","name":"Jaljeera","price":6900,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"122678751","name":"Extra Sambar","price":5900,"inStock":1,"isVeg":1,"isEnabled":1}],"maxAddons":1,"maxFreeAddons":-1}],"itemAttribute":{"vegClassifier":"VEG"},"ribbon":{},"type":"ITEM","offerTags":[{"matchText":"SILD"}],"itemBadge":{},"badgesV2":{},"itemNudgeType":"FinalPrice","ratings":{"aggregatedRating":{"rating":"4.1","ratingCount":"103 ratings","ratingCountV2":"103"},"ratingsPresentationConfig":{"bgGradient":{"colours":["#C8F9E5","#00FFFFFF"],"gradientDirection":"GRADIENT_DIRECTION_LEFT_TO_RIGHT"},"ratingIconColor":"rating_very_good","ratingTextColor":"rating_very_good","ratingCountTextColor":"rating_very_good","ratingFontName":"FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD","ratingCountFontName":"FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"}},"itemPriceStrikeOff":true,"offerIds":["e0dbebae-461e-4fc0-a7d0-8ba51f921c60"],"size":{"width":0.46,"height":1},"parentId":"62480116","offerCategory":"OFFER_CATEGORY_DEAL_RUSH","offerHeader":"Only till","offerSubHeader":"10:00 AM"},"analytics":{},"hideRestaurantDetails":true}}],"subtitleSuffix":{},"image":"7a0ba771f71c9f995a4a83a00497b8e5","categoryId":"32222325","widgetType":"WIDGET_TYPE_DISH_FIRST","categoryStyle":{"layout":{}},"headerStyle":{"padding":{"left":16,"top":16,"right":16,"bottom":16},"titleColor":"text_color_highest_emphasis","titleFontName":"FONT_NAME_SUB_HEADER_S1_BOLD","imageStyle":{"width":{},"height":{}},"gradientStyle":{}},"dividerStyle":{"color":"#1502060C","height":1,"padding":{"left":16,"right":16}}}}},{"card":{"card":{"@type":"type.googleapis.com/swiggy.presentation.food.v2.ItemCategory","title":"Sandwiches","itemCards":[{"card":{"@type":"type.googleapis.com/swiggy.presentation.food.v2.Dish","info":{"id":"111576930","name":"Tandoori Paneer Grilled Sandwich (brown Bread)","category":"Sandwiches","description":"Soft paneer marinated with curd and spices. Loaded with exotic vegetables.","imageId":"b5bb7ff584ad97aebc3a08fba8e29bed","inStock":1,"isVeg":1,"price":20900,"finalPrice":10900,"variants":{},"variantsV2":{},"itemAttribute":{"vegClassifier":"VEG"},"ribbon":{"text":"Bestseller","textColor":"#ffffff","topBackgroundColor":"#d53d4c","bottomBackgroundColor":"#b02331"},"type":"ITEM","offerTags":[{"matchText":"SILD"}],"itemBadge":{},"badgesV2":{},"itemNudgeType":"FinalPrice","isBestseller":true,"ratings":{"aggregatedRating":{"rating":"4.4","ratingCount":"308 ratings","ratingCountV2":"308"},"ratingsPresentationConfig":{"bgGradient":{"colours":["#C8F9E5","#00FFFFFF"],"gradientDirection":"GRADIENT_DIRECTION_LEFT_TO_RIGHT"},"ratingIconColor":"rating_very_good","ratingTextColor":"rating_very_good","ratingCountTextColor":"rating_very_good","ratingFontName":"FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD","ratingCountFontName":"FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"}},"itemPriceStrikeOff":true,"cartContext":"quick_prep","offerIds":["fcc54975-da56-490d-8df7-cdf8a5843fdb"],"size":{"width":0.46,"height":1},"isNinetyninestoreItem":true,"parentId":"62480122"},"analytics":{},"hideRestaurantDetails":true}},{"card":{"@type":"type.googleapis.com/swiggy.presentation.food.v2.Dish","info":{"id":"129746211","name":"Potato & Vegetable Sandwich (brown Bread)","category":"Sandwiches","description":"Potato sandwich?s made with aloo tikki, vegetables & combination of sauces","imageId":"FOOD_CATALOG/IMAGES/CMS/2024/9/30/29a17544-0e40-45ea-b0cf-10b94df2b25b_925269ce-dcdc-483b-96e3-4b67c094b23c.jpg","inStock":1,"isVeg":1,"price":19900,"finalPrice":9900,"variants":{},"variantsV2":{},"itemAttribute":{"vegClassifier":"VEG"},"ribbon":{"text":"Bestseller","textColor":"#ffffff","topBackgroundColor":"#d53d4c","bottomBackgroundColor":"#b02331"},"type":"ITEM","offerTags":[{"matchText":"SILD"}],"itemBadge":{},"badgesV2":{},"itemNudgeType":"FinalPrice","isBestseller":true,"ratings":{"aggregatedRating":{"rating":"4.6","ratingCount":"113 ratings","ratingCountV2":"113"},"ratingsPresentationConfig":{"bgGradient":{"colours":["#C8F9E5","#00FFFFFF"],"gradientDirection":"GRADIENT_DIRECTION_LEFT_TO_RIGHT"},"ratingIconColor":"rating_very_good","ratingTextColor":"rating_very_good","ratingCountTextColor":"rating_very_good","ratingFontName":"FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD","ratingCountFontName":"FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"}},"itemPriceStrikeOff":true,"cartContext":"quick_prep","offerIds":["7201da4b-5963-4a8d-8ca4-d5ee6abdec2c"],"size":{"width":0.46,"height":1},"isNinetyninestoreItem":true,"parentId":"75385694"},"analytics":{},"hideRestaurantDetails":true}},{"card":{"@type":"type.googleapis.com/swiggy.presentation.food.v2.Dish","info":{"id":"111576922","name":"Chicken Tikka Grilled Sandwich (brown Bread)","category":"Sandwiches","description":"Made with layers of?tandoori chicken, Vegetables and a homemade spicy mayonnaise dressing.","imageId":"ed102873ace7fcd6f5b9784db1a30387","inStock":1,"price":22900,"finalPrice":8900,"variants":{},"variantsV2":{},"itemAttribute":{"vegClassifier":"NONVEG"},"ribbon":{"text":"Bestseller","textColor":"#ffffff","topBackgroundColor":"#d53d4c","bottomBackgroundColor":"#b02331"},"type":"ITEM","offerTags":[{"matchText":"SILD"}],"itemBadge":{},"badgesV2":{},"itemNudgeType":"FinalPrice","isBestseller":true,"ratings":{"aggregatedRating":{"rating":"4.4","ratingCount":"136 ratings","ratingCountV2":"136"},"ratingsPresentationConfig":{"bgGradient":{"colours":["#C8F9E5","#00FFFFFF"],"gradientDirection":"GRADIENT_DIRECTION_LEFT_TO_RIGHT"},"ratingIconColor":"rating_very_good","ratingTextColor":"rating_very_good","ratingCountTextColor":"rating_very_good","ratingFontName":"FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD","ratingCountFontName":"FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"}},"itemPriceStrikeOff":true,"offerIds":["9caf6a85-3e4e-42da-ae21-f9705c6593d3"],"size":{"width":0.46,"height":1},"parentId":"63848610","offerCategory":"OFFER_CATEGORY_DEAL_RUSH","offerHeader":"Only till","offerSubHeader":"10:00 AM"},"analytics":{},"hideRestaurantDetails":true}},{"card":{"@type":"type.googleapis.com/swiggy.presentation.food.v2.Dish","info":{"id":"129746208","name":"Cheese & Corn Sandwich (brown Bread)","category":"Sandwiches","description":"Corn sandwich is a filled primarily with sweet corn & Cheese along with other spices.","imageId":"FOOD_CATALOG/IMAGES/CMS/2024/9/30/268f6aab-1a71-4044-bcff-4647a866ebf7_38270eec-4094-4f1d-a1a6-5a2b24be1d16.jpg","inStock":1,"isVeg":1,"price":19900,"finalPrice":7900,"variants":{},"variantsV2":{},"itemAttribute":{"vegClassifier":"VEG"},"ribbon":{"text":"Bestseller","textColor":"#ffffff","topBackgroundColor":"#d53d4c","bottomBackgroundColor":"#b02331"},"type":"ITEM","offerTags":[{"matchText":"SILD"}],"itemBadge":{},"badgesV2":{},"itemNudgeType":"FinalPrice","isBestseller":true,"ratings":{"aggregatedRating":{"rating":"4.2","ratingCount":"59 ratings","ratingCountV2":"59"},"ratingsPresentationConfig":{"bgGradient":{"colours":["#C8F9E5","#00FFFFFF"],"gradientDirection":"GRADIENT_DIRECTION_LEFT_TO_RIGHT"},"ratingIconColor":"rating_very_good","ratingTextColor":"rating_very_good","ratingCountTextColor":"rating_very_good","ratingFontName":"FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD","ratingCountFontName":"FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"}},"itemPriceStrikeOff":true,"offerIds":["ddb29a66-004d-473d-a6fd-0e9b88a39632"],"size":{"width":0.46,"height":1},"parentId":"75385692","offerCategory":"OFFER_CATEGORY_DEAL_RUSH","offerHeader":"Only till","offerSubHeader":"10:00 AM"},"analytics":{},"hideRestaurantDetails":true}},{"card":{"@type":"type.googleapis.com/swiggy.presentation.food.v2.Dish","info":{"id":"111576928","name":"Shredded Chicken Cold Sandwich (brown Bread)","category":"Sandwiches","description":"Made with shredded chicken, mayo, vegetables, flavored with salt & paper.","imageId":"a5d546677bb738f7d33c88b4130424b4","inStock":1,"price":23900,"variants":{},"variantsV2":{},"itemAttribute":{"vegClassifier":"NONVEG"},"ribbon":{},"type":"ITEM","itemBadge":{},"badgesV2":{},"ratings":{"aggregatedRating":{"rating":"4.7","ratingCount":"24 ratings","ratingCountV2":"24"},"ratingsPresentationConfig":{"bgGradient":{"colours":["#C8F9E5","#00FFFFFF"],"gradientDirection":"GRADIENT_DIRECTION_LEFT_TO_RIGHT"},"ratingIconColor":"rating_very_good","ratingTextColor":"rating_very_good","ratingCountTextColor":"rating_very_good","ratingFontName":"FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD","ratingCountFontName":"FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"}},"itemPriceStrikeOff":true,"size":{"width":0.46,"height":1},"parentId":"62480117"},"analytics":{},"hideRestaurantDetails":true}},{"card":{"@type":"type.googleapis.com/swiggy.presentation.food.v2.Dish","info":{"id":"129746209","name":"Soya Tikka Sandwich (brown Bread)","category":"Sandwiches","description":"Soya sandwich made with soya chunk along with tangy tikka gravy.","imageId":"FOOD_CATALOG/IMAGES/CMS/2024/9/30/afbeb5f5-9b45-4110-8c55-300ac4501166_cb852a67-d930-44ef-b4dc-6bce4aa39723.jpg","inStock":1,"isVeg":1,"price":19900,"finalPrice":7900,"variants":{},"variantsV2":{},"itemAttribute":{"vegClassifier":"VEG"},"ribbon":{},"type":"ITEM","offerTags":[{"matchText":"SILD"}],"itemBadge":{},"badgesV2":{},"itemNudgeType":"FinalPrice","ratings":{"aggregatedRating":{"rating":"4.3","ratingCount":"8 ratings","ratingCountV2":"8"},"ratingsPresentationConfig":{"bgGradient":{"colours":["#C8F9E5","#00FFFFFF"],"gradientDirection":"GRADIENT_DIRECTION_LEFT_TO_RIGHT"},"ratingIconColor":"rating_very_good","ratingTextColor":"rating_very_good","ratingCountTextColor":"rating_very_good","ratingFontName":"FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD","ratingCountFontName":"FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"}},"itemPriceStrikeOff":true,"offerIds":["ddb29a66-004d-473d-a6fd-0e9b88a39632"],"size":{"width":0.46,"height":1},"parentId":"75385695","offerCategory":"OFFER_CATEGORY_DEAL_RUSH","offerHeader":"Only till","offerSubHeader":"10:00 AM"},"analytics":{},"hideRestaurantDetails":true}},{"card":{"@type":"type.googleapis.com/swiggy.presentation.food.v2.Dish","info":{"id":"129746210","name":"Mushroom & Corn Sandwich (brown Bread)","category":"Sandwiches","description":"Made with?ushroom & sweet?orn?long with tikka gravy.","imageId":"FOOD_CATALOG/IMAGES/CMS/2024/9/30/cf21e401-e64c-4bc3-be34-25e6e6e3b8ab_936df9ee-6481-40c3-81bf-64ee6832d6ab.jpg","inStock":1,"isVeg":1,"price":22900,"finalPrice":8900,"variants":{},"variantsV2":{},"itemAttribute":{"vegClassifier":"VEG"},"ribbon":{},"type":"ITEM","offerTags":[{"matchText":"SILD"}],"itemBadge":{},"badgesV2":{},"itemNudgeType":"FinalPrice","ratings":{"aggregatedRating":{"rating":"4.6","ratingCount":"6 ratings","ratingCountV2":"6"},"ratingsPresentationConfig":{"bgGradient":{"colours":["#C8F9E5","#00FFFFFF"],"gradientDirection":"GRADIENT_DIRECTION_LEFT_TO_RIGHT"},"ratingIconColor":"rating_very_good","ratingTextColor":"rating_very_good","ratingCountTextColor":"rating_very_good","ratingFontName":"FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD","ratingCountFontName":"FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"}},"itemPriceStrikeOff":true,"offerIds":["9caf6a85-3e4e-42da-ae21-f9705c6593d3"],"size":{"width":0.46,"height":1},"parentId":"75385693","offerCategory":"OFFER_CATEGORY_DEAL_RUSH","offerHeader":"Only till","offerSubHeader":"10:00 AM"},"analytics":{},"hideRestaurantDetails":true}}],"subtitleSuffix":{},"image":"b5bb7ff584ad97aebc3a08fba8e29bed","categoryId":"32222331","widgetType":"WIDGET_TYPE_DISH_FIRST","categoryStyle":{"layout":{}},"headerStyle":{"padding":{"left":16,"top":16,"right":16,"bottom":16},"titleColor":"text_color_highest_emphasis","titleFontName":"FONT_NAME_SUB_HEADER_S1_BOLD","imageStyle":{"width":{},"height":{}},"gradientStyle":{}},"dividerStyle":{"color":"#1502060C","height":1,"padding":{"left":16,"right":16}}}}},{"card":{"card":{"@type":"type.googleapis.com/swiggy.presentation.food.v2.ItemCategory","title":"Maggi & Momos","itemCards":[{"card":{"@type":"type.googleapis.com/swiggy.presentation.food.v2.Dish","info":{"id":"108832043","name":"Classic Maggi","category":"Maggi & Momos","description":"Classic maggi with added extra vegetables & Spices.","imageId":"285a763faec0781c1f8944f808821627","inStock":1,"isVeg":1,"price":8900,"variants":{},"variantsV2":{},"itemAttribute":{"vegClassifier":"VEG"},"ribbon":{"text":"Bestseller","textColor":"#ffffff","topBackgroundColor":"#d53d4c","bottomBackgroundColor":"#b02331"},"type":"ITEM","itemBadge":{},"badgesV2":{},"isBestseller":true,"ratings":{"aggregatedRating":{"rating":"4.2","ratingCount":"476 ratings","ratingCountV2":"476"},"ratingsPresentationConfig":{"bgGradient":{"colours":["#C8F9E5","#00FFFFFF"],"gradientDirection":"GRADIENT_DIRECTION_LEFT_TO_RIGHT"},"ratingIconColor":"rating_very_good","ratingTextColor":"rating_very_good","ratingCountTextColor":"rating_very_good","ratingFontName":"FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD","ratingCountFontName":"FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"}},"itemPriceStrikeOff":true,"size":{"width":0.46,"height":1},"parentId":"62480066"},"analytics":{},"hideRestaurantDetails":true}},{"card":{"@type":"type.googleapis.com/swiggy.presentation.food.v2.Dish","info":{"id":"108832046","name":"Egg Bhurji Maggi","category":"Maggi & Momos","description":"Made with Indian style scrambled egg.","imageId":"e44004aac4df3a9d5f4e483a22a59d33","inStock":1,"price":16900,"variants":{},"variantsV2":{},"itemAttribute":{"vegClassifier":"NONVEG"},"ribbon":{},"type":"ITEM","itemBadge":{},"badgesV2":{},"ratings":{"aggregatedRating":{"rating":"4.0","ratingCount":"45 ratings","ratingCountV2":"45"},"ratingsPresentationConfig":{"bgGradient":{"colours":["#C8F9E5","#00FFFFFF"],"gradientDirection":"GRADIENT_DIRECTION_LEFT_TO_RIGHT"},"ratingIconColor":"rating_very_good","ratingTextColor":"rating_very_good","ratingCountTextColor":"rating_very_good","ratingFontName":"FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD","ratingCountFontName":"FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"}},"itemPriceStrikeOff":true,"size":{"width":0.46,"height":1},"parentId":"62480071"},"analytics":{},"hideRestaurantDetails":true}},{"card":{"@type":"type.googleapis.com/swiggy.presentation.food.v2.Dish","info":{"id":"108832044","name":"Peri Peri Maggi","category":"Maggi & Momos","description":"Made with extra dose of peri peri sauce.","imageId":"6575e3e347e27529cb84c0906d4b0a7c","inStock":1,"isVeg":1,"price":13900,"variants":{},"variantsV2":{},"itemAttribute":{"vegClassifier":"VEG"},"ribbon":{},"type":"ITEM","itemBadge":{},"badgesV2":{},"ratings":{"aggregatedRating":{"rating":"4.1","ratingCount":"161 ratings","ratingCountV2":"161"},"ratingsPresentationConfig":{"bgGradient":{"colours":["#C8F9E5","#00FFFFFF"],"gradientDirection":"GRADIENT_DIRECTION_LEFT_TO_RIGHT"},"ratingIconColor":"rating_very_good","ratingTextColor":"rating_very_good","ratingCountTextColor":"rating_very_good","ratingFontName":"FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD","ratingCountFontName":"FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"}},"itemPriceStrikeOff":true,"size":{"width":0.46,"height":1},"parentId":"62480107"},"analytics":{},"hideRestaurantDetails":true}},{"card":{"@type":"type.googleapis.com/swiggy.presentation.food.v2.Dish","info":{"id":"129106823","name":"Mutton Momos (6 Pcs)","category":"Maggi & Momos","description":"Made with ground mutton & vegetables, Served with eggless mayonnaise & spicy momos sauce","imageId":"FOOD_CATALOG/IMAGES/CMS/2024/5/15/817334af-b53e-4522-9b6c-2abfd7d17252_2c29a4bb-cc3c-45d5-909c-242e450ab65d.jpg","inStock":1,"price":24900,"variants":{},"variantsV2":{},"itemAttribute":{"vegClassifier":"NONVEG"},"ribbon":{},"type":"ITEM","itemBadge":{},"badgesV2":{},"ratings":{"aggregatedRating":{"rating":"2.7","ratingCount":"4 ratings","ratingCountV2":"4"},"ratingsPresentationConfig":{"bgGradient":{"colours":["#FFF0CD","#00FFFFFF"],"gradientDirection":"GRADIENT_DIRECTION_LEFT_TO_RIGHT"},"ratingIconColor":"rating_low","ratingTextColor":"rating_low","ratingCountTextColor":"rating_low","ratingFontName":"FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD","ratingCountFontName":"FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"}},"itemPriceStrikeOff":true,"size":{"width":0.46,"height":1},"parentId":"74991087"},"analytics":{},"hideRestaurantDetails":true}},{"card":{"@type":"type.googleapis.com/swiggy.presentation.food.v2.Dish","info":{"id":"108832047","name":"Chicken Keema Maggi","category":"Maggi & Momos","description":"Made with Spicy Chicken keema.","imageId":"0779117a4136f19ef1e07aa57e05205b","inStock":1,"price":18900,"finalPrice":7900,"variants":{},"variantsV2":{},"itemAttribute":{"vegClassifier":"NONVEG"},"ribbon":{},"type":"ITEM","offerTags":[{"matchText":"SILD"}],"itemBadge":{},"badgesV2":{},"itemNudgeType":"FinalPrice","ratings":{"aggregatedRating":{"rating":"4.1","ratingCount":"57 ratings","ratingCountV2":"57"},"ratingsPresentationConfig":{"bgGradient":{"colours":["#C8F9E5","#00FFFFFF"],"gradientDirection":"GRADIENT_DIRECTION_LEFT_TO_RIGHT"},"ratingIconColor":"rating_very_good","ratingTextColor":"rating_very_good","ratingCountTextColor":"rating_very_good","ratingFontName":"FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD","ratingCountFontName":"FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"}},"itemPriceStrikeOff":true,"offerIds":["ddb29a66-004d-473d-a6fd-0e9b88a39632"],"size":{"width":0.46,"height":1},"parentId":"62480050","offerCategory":"OFFER_CATEGORY_DEAL_RUSH","offerHeader":"Only till","offerSubHeader":"10:00 AM"},"analytics":{},"hideRestaurantDetails":true}},{"card":{"@type":"type.googleapis.com/swiggy.presentation.food.v2.Dish","info":{"id":"111576915","name":"Chicken Momos Steam (6 Pcs)","category":"Maggi & Momos","description":"Made with chicken & other vegetables, Served with eggless mayonnaise & spicy momos sauce.","imageId":"1597c6b8c31da30d670e696b09eed5d3","inStock":1,"price":18900,"finalPrice":7900,"variants":{},"variantsV2":{},"itemAttribute":{"vegClassifier":"NONVEG"},"ribbon":{},"type":"ITEM","offerTags":[{"matchText":"SILD"}],"itemBadge":{},"badgesV2":{},"itemNudgeType":"FinalPrice","ratings":{"aggregatedRating":{"rating":"3.0","ratingCount":"23 ratings","ratingCountV2":"23"},"ratingsPresentationConfig":{"bgGradient":{"colours":["#D9EFEC","#00FFFFFF"],"gradientDirection":"GRADIENT_DIRECTION_LEFT_TO_RIGHT"},"ratingIconColor":"rating_medium","ratingTextColor":"rating_medium","ratingCountTextColor":"rating_medium","ratingFontName":"FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD","ratingCountFontName":"FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"}},"itemPriceStrikeOff":true,"offerIds":["ddb29a66-004d-473d-a6fd-0e9b88a39632"],"size":{"width":0.46,"height":1},"parentId":"62741852","offerCategory":"OFFER_CATEGORY_DEAL_RUSH","offerHeader":"Only till","offerSubHeader":"10:00 AM"},"analytics":{},"hideRestaurantDetails":true}},{"card":{"@type":"type.googleapis.com/swiggy.presentation.food.v2.Dish","info":{"id":"111576918","name":"Paneer Momos Steam (6 Pcs)","category":"Maggi & Momos","description":"Made with Paneer & other vegetables, served with eggless mayonnaise & spicy momos sauce.","imageId":"789b986dafa18d9c554b0b98e0de03c0","inStock":1,"isVeg":1,"price":16900,"variants":{},"variantsV2":{},"itemAttribute":{"vegClassifier":"VEG"},"ribbon":{},"type":"ITEM","itemBadge":{},"badgesV2":{},"ratings":{"aggregatedRating":{"rating":"4.5","ratingCount":"39 ratings","ratingCountV2":"39"},"ratingsPresentationConfig":{"bgGradient":{"colours":["#C8F9E5","#00FFFFFF"],"gradientDirection":"GRADIENT_DIRECTION_LEFT_TO_RIGHT"},"ratingIconColor":"rating_very_good","ratingTextColor":"rating_very_good","ratingCountTextColor":"rating_very_good","ratingFontName":"FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD","ratingCountFontName":"FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"}},"itemPriceStrikeOff":true,"size":{"width":0.46,"height":1},"parentId":"62741862"},"analytics":{},"hideRestaurantDetails":true}},{"card":{"@type":"type.googleapis.com/swiggy.presentation.food.v2.Dish","info":{"id":"108832045","name":"Cheese & Jalapeno Maggi","category":"Maggi & Momos","description":"Made with Cheese & Jalapeno.","imageId":"1b194491d06902dc12b533739256afd8","inStock":1,"isVeg":1,"price":15900,"variants":{},"variantsV2":{},"itemAttribute":{"vegClassifier":"VEG"},"ribbon":{},"type":"ITEM","itemBadge":{},"badgesV2":{},"ratings":{"aggregatedRating":{"rating":"4.3","ratingCount":"40 ratings","ratingCountV2":"40"},"ratingsPresentationConfig":{"bgGradient":{"colours":["#C8F9E5","#00FFFFFF"],"gradientDirection":"GRADIENT_DIRECTION_LEFT_TO_RIGHT"},"ratingIconColor":"rating_very_good","ratingTextColor":"rating_very_good","ratingCountTextColor":"rating_very_good","ratingFontName":"FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD","ratingCountFontName":"FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"}},"itemPriceStrikeOff":true,"size":{"width":0.46,"height":1},"parentId":"62480044"},"analytics":{},"hideRestaurantDetails":true}},{"card":{"@type":"type.googleapis.com/swiggy.presentation.food.v2.Dish","info":{"id":"129106822","name":"Soya Momos (6 Pcs)","category":"Maggi & Momos","description":"Made with soya chunks & vegetables, Served with eggless mayonnaise & spicy momos sauce","imageId":"FOOD_CATALOG/IMAGES/CMS/2024/5/15/baa9bc1e-659e-4b71-b81f-5e1e9bf6e956_79a3f5dc-2c6d-4853-a8bc-bd9aa25fda07.jpg","inStock":1,"isVeg":1,"price":16900,"variants":{},"variantsV2":{},"itemAttribute":{"vegClassifier":"VEG"},"ribbon":{},"type":"ITEM","itemBadge":{},"badgesV2":{},"ratings":{"aggregatedRating":{"rating":"3.6","ratingCount":"9 ratings","ratingCountV2":"9"},"ratingsPresentationConfig":{"bgGradient":{"colours":["#D9EFEC","#00FFFFFF"],"gradientDirection":"GRADIENT_DIRECTION_LEFT_TO_RIGHT"},"ratingIconColor":"rating_medium","ratingTextColor":"rating_medium","ratingCountTextColor":"rating_medium","ratingFontName":"FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD","ratingCountFontName":"FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"}},"itemPriceStrikeOff":true,"size":{"width":0.46,"height":1},"parentId":"74991088"},"analytics":{},"hideRestaurantDetails":true}},{"card":{"@type":"type.googleapis.com/swiggy.presentation.food.v2.Dish","info":{"id":"111576921","name":"Veg Momos Steam (6 Pcs)","category":"Maggi & Momos","description":"Made with cabbage & other vegetables, served with eggless mayonnaise & spicy momos sauce.","imageId":"7ac268d2e4d9f2c9880ad4ce8f93ba16","inStock":1,"isVeg":1,"price":14900,"variants":{},"variantsV2":{},"itemAttribute":{"vegClassifier":"VEG"},"ribbon":{},"type":"ITEM","itemBadge":{},"badgesV2":{},"ratings":{"aggregatedRating":{"rating":"4.5","ratingCount":"23 ratings","ratingCountV2":"23"},"ratingsPresentationConfig":{"bgGradient":{"colours":["#C8F9E5","#00FFFFFF"],"gradientDirection":"GRADIENT_DIRECTION_LEFT_TO_RIGHT"},"ratingIconColor":"rating_very_good","ratingTextColor":"rating_very_good","ratingCountTextColor":"rating_very_good","ratingFontName":"FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD","ratingCountFontName":"FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"}},"itemPriceStrikeOff":true,"size":{"width":0.46,"height":1},"parentId":"62741866"},"analytics":{},"hideRestaurantDetails":true}}],"subtitleSuffix":{},"image":"285a763faec0781c1f8944f808821627","categoryId":"43092088","widgetType":"WIDGET_TYPE_DISH_FIRST","categoryStyle":{"layout":{}},"headerStyle":{"padding":{"left":16,"top":16,"right":16,"bottom":16},"titleColor":"text_color_highest_emphasis","titleFontName":"FONT_NAME_SUB_HEADER_S1_BOLD","imageStyle":{"width":{},"height":{}},"gradientStyle":{}},"dividerStyle":{"color":"#1502060C","height":1,"padding":{"left":16,"right":16}}}}},{"card":{"card":{"@type":"type.googleapis.com/swiggy.presentation.food.v2.ItemCategory","title":"Continental","itemCards":[{"card":{"@type":"type.googleapis.com/swiggy.presentation.food.v2.Dish","info":{"id":"129964645","name":"Baked Mutton Meatballs (indian Style)","category":"Continental","description":"Baked Mutton meatballs made with ground mutton and a mixture of Indian spices, Served with Mint sauce","inStock":1,"price":34900,"variants":{},"variantsV2":{},"itemAttribute":{"vegClassifier":"NONVEG"},"ribbon":{},"type":"ITEM","itemBadge":{},"badgesV2":{},"ratings":{"aggregatedRating":{}},"itemPriceStrikeOff":true,"size":{"width":0.46,"height":1},"parentId":"75543669"},"analytics":{},"hideRestaurantDetails":true}},{"card":{"@type":"type.googleapis.com/swiggy.presentation.food.v2.Dish","info":{"id":"113821108","name":"Spaghetti Alfredo Pasta With Garlic Bread","category":"Continental","description":"The?Alfredo Pasta?is an Italian?pasta?dish made using fresh Spaghetti?pasta, vegetables combined with butter, cream and cheese.","imageId":"203fb6f02f3cae0fa745f962c00a8c74","inStock":1,"isVeg":1,"price":29900,"variants":{},"variantsV2":{},"addons":[{"groupId":"124897967","groupName":"Add Ons","choices":[{"id":"107558175","name":"3 Pcs Of Chicken Meatballs","price":12900,"inStock":1,"isEnabled":1},{"id":"107558176","name":"3 Pcs Of Mutton Meatballs","price":17900,"inStock":1,"isEnabled":1}],"maxAddons":2,"maxFreeAddons":-1}],"itemAttribute":{"vegClassifier":"VEG"},"ribbon":{},"type":"ITEM","itemBadge":{},"badgesV2":{},"ratings":{"aggregatedRating":{"rating":"3.9","ratingCount":"44 ratings","ratingCountV2":"44"},"ratingsPresentationConfig":{"bgGradient":{"colours":["#D9EFEC","#00FFFFFF"],"gradientDirection":"GRADIENT_DIRECTION_LEFT_TO_RIGHT"},"ratingIconColor":"rating_medium","ratingTextColor":"rating_medium","ratingCountTextColor":"rating_medium","ratingFontName":"FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD","ratingCountFontName":"FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"}},"itemPriceStrikeOff":true,"size":{"width":0.46,"height":1},"parentId":"65541012"},"analytics":{},"hideRestaurantDetails":true}},{"card":{"@type":"type.googleapis.com/swiggy.presentation.food.v2.Dish","info":{"id":"113821104","name":"Spaghetti Red Sauce Pasta With Garlic Bread","category":"Continental","description":"Red sauce spaghetti pasta is doused in?tomato sauce?and cooked in a seasoning of herbs parmesan cheese & spices.","imageId":"e3fb65783d48fef03717acbb11630408","inStock":1,"isVeg":1,"price":29900,"variants":{},"variantsV2":{},"addons":[{"groupId":"124897965","groupName":"Add Ons","choices":[{"id":"107558175","name":"3 Pcs Of Chicken Meatballs","price":12900,"inStock":1,"isEnabled":1},{"id":"107558176","name":"3 Pcs Of Mutton Meatballs","price":17900,"inStock":1,"isEnabled":1}],"maxAddons":2,"maxFreeAddons":-1}],"itemAttribute":{"vegClassifier":"VEG"},"ribbon":{},"type":"ITEM","itemBadge":{},"badgesV2":{},"ratings":{"aggregatedRating":{"rating":"2.9","ratingCount":"26 ratings","ratingCountV2":"26"},"ratingsPresentationConfig":{"bgGradient":{"colours":["#FFF0CD","#00FFFFFF"],"gradientDirection":"GRADIENT_DIRECTION_LEFT_TO_RIGHT"},"ratingIconColor":"rating_low","ratingTextColor":"rating_low","ratingCountTextColor":"rating_low","ratingFontName":"FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD","ratingCountFontName":"FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"}},"itemPriceStrikeOff":true,"size":{"width":0.46,"height":1},"parentId":"65541013"},"analytics":{},"hideRestaurantDetails":true}},{"card":{"@type":"type.googleapis.com/swiggy.presentation.food.v2.Dish","info":{"id":"113821110","name":"Penne Alfredo Pasta With Garlic Bread","category":"Continental","description":"The?Alfredo Pasta?is an Italian?pasta?dish made using fresh penne?pasta, vegetables combined with butter, cream and cheese.","imageId":"15f579ecdf022bf645f073b8a9283ac4","inStock":1,"isVeg":1,"price":29900,"variants":{},"variantsV2":{},"addons":[{"groupId":"124897968","groupName":"Add Ons","choices":[{"id":"107558175","name":"3 Pcs Of Chicken Meatballs","price":12900,"inStock":1,"isEnabled":1},{"id":"107558176","name":"3 Pcs Of Mutton Meatballs","price":17900,"inStock":1,"isEnabled":1}],"maxAddons":2,"maxFreeAddons":-1}],"itemAttribute":{"vegClassifier":"VEG"},"ribbon":{},"type":"ITEM","itemBadge":{},"badgesV2":{},"ratings":{"aggregatedRating":{"rating":"4.5","ratingCount":"21 ratings","ratingCountV2":"21"},"ratingsPresentationConfig":{"bgGradient":{"colours":["#C8F9E5","#00FFFFFF"],"gradientDirection":"GRADIENT_DIRECTION_LEFT_TO_RIGHT"},"ratingIconColor":"rating_very_good","ratingTextColor":"rating_very_good","ratingCountTextColor":"rating_very_good","ratingFontName":"FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD","ratingCountFontName":"FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"}},"itemPriceStrikeOff":true,"size":{"width":0.46,"height":1},"parentId":"65541010"},"analytics":{},"hideRestaurantDetails":true}},{"card":{"@type":"type.googleapis.com/swiggy.presentation.food.v2.Dish","info":{"id":"113821107","name":"Penne Red Sauce Pasta With Garlic Bread","category":"Continental","description":"Red sauce penne pasta is doused in?tomato sauce?and cooked in a seasoning of herbs parmesan cheese & spices.","imageId":"86467e130667db245fc9601a5b30c9d4","inStock":1,"isVeg":1,"price":29900,"variants":{},"variantsV2":{},"addons":[{"groupId":"124897966","groupName":"Add Ons","choices":[{"id":"107558175","name":"3 Pcs Of Chicken Meatballs","price":12900,"inStock":1,"isEnabled":1},{"id":"107558176","name":"3 Pcs Of Mutton Meatballs","price":17900,"inStock":1,"isEnabled":1}],"maxAddons":2,"maxFreeAddons":-1}],"itemAttribute":{"vegClassifier":"VEG"},"ribbon":{},"type":"ITEM","itemBadge":{},"badgesV2":{},"ratings":{"aggregatedRating":{"rating":"3.1","ratingCount":"29 ratings","ratingCountV2":"29"},"ratingsPresentationConfig":{"bgGradient":{"colours":["#D9EFEC","#00FFFFFF"],"gradientDirection":"GRADIENT_DIRECTION_LEFT_TO_RIGHT"},"ratingIconColor":"rating_medium","ratingTextColor":"rating_medium","ratingCountTextColor":"rating_medium","ratingFontName":"FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD","ratingCountFontName":"FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"}},"itemPriceStrikeOff":true,"size":{"width":0.46,"height":1},"parentId":"65541011"},"analytics":{},"hideRestaurantDetails":true}},{"card":{"@type":"type.googleapis.com/swiggy.presentation.food.v2.Dish","info":{"id":"118222515","name":"Baked Chicken Meatballs Indian Style (8 Pcs)","category":"Continental","description":"Baked Chicken meatballs made with ground chicken and a mixture of Indian spices, Served with Mint sauce.","imageId":"e52171e6b0a992cfadce8cddff627900","inStock":1,"price":24900,"variants":{},"variantsV2":{},"itemAttribute":{"vegClassifier":"NONVEG"},"ribbon":{},"type":"ITEM","itemBadge":{},"badgesV2":{},"ratings":{"aggregatedRating":{"rating":"4.9","ratingCount":"16 ratings","ratingCountV2":"16"},"ratingsPresentationConfig":{"bgGradient":{"colours":["#C8F9E5","#00FFFFFF"],"gradientDirection":"GRADIENT_DIRECTION_LEFT_TO_RIGHT"},"ratingIconColor":"rating_very_good","ratingTextColor":"rating_very_good","ratingCountTextColor":"rating_very_good","ratingFontName":"FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD","ratingCountFontName":"FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"}},"itemPriceStrikeOff":true,"size":{"width":0.46,"height":1},"parentId":"67797310"},"analytics":{},"hideRestaurantDetails":true}},{"card":{"@type":"type.googleapis.com/swiggy.presentation.food.v2.Dish","info":{"id":"113821103","name":"Chicken Kurket [6 Pcs]","category":"Continental","description":"Chicken kurket?are deep fried, stuffed with minced chicken, Potato and spices coated in crispy breadcrumbs.","imageId":"9ee3be8226ddd34bf17d221d0952b298","inStock":1,"price":19900,"variants":{},"variantsV2":{},"itemAttribute":{"vegClassifier":"NONVEG"},"ribbon":{},"type":"ITEM","itemBadge":{},"badgesV2":{},"ratings":{"aggregatedRating":{"rating":"4.2","ratingCount":"72 ratings","ratingCountV2":"72"},"ratingsPresentationConfig":{"bgGradient":{"colours":["#C8F9E5","#00FFFFFF"],"gradientDirection":"GRADIENT_DIRECTION_LEFT_TO_RIGHT"},"ratingIconColor":"rating_very_good","ratingTextColor":"rating_very_good","ratingCountTextColor":"rating_very_good","ratingFontName":"FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD","ratingCountFontName":"FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"}},"itemPriceStrikeOff":true,"size":{"width":0.46,"height":1},"parentId":"65541007"},"analytics":{},"hideRestaurantDetails":true}},{"card":{"@type":"type.googleapis.com/swiggy.presentation.food.v2.Dish","info":{"id":"113821106","name":"Jalapeno Cheese Balls [6 Pcs]","category":"Continental","description":"Jalapeno cheese balls?are deep fried, melted cheese balls stuffed with diced jalape?os and coated in crispy breadcrumbs.","imageId":"98800940915ef180861f47ee0d77522e","inStock":1,"isVeg":1,"price":17900,"variants":{},"variantsV2":{},"itemAttribute":{"vegClassifier":"VEG"},"ribbon":{},"type":"ITEM","itemBadge":{},"badgesV2":{},"ratings":{"aggregatedRating":{"rating":"3.9","ratingCount":"25 ratings","ratingCountV2":"25"},"ratingsPresentationConfig":{"bgGradient":{"colours":["#D9EFEC","#00FFFFFF"],"gradientDirection":"GRADIENT_DIRECTION_LEFT_TO_RIGHT"},"ratingIconColor":"rating_medium","ratingTextColor":"rating_medium","ratingCountTextColor":"rating_medium","ratingFontName":"FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD","ratingCountFontName":"FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"}},"itemPriceStrikeOff":true,"size":{"width":0.46,"height":1},"parentId":"65541009"},"analytics":{},"hideRestaurantDetails":true}}],"subtitleSuffix":{},"image":"203fb6f02f3cae0fa745f962c00a8c74","categoryId":"33505198","widgetType":"WIDGET_TYPE_DISH_FIRST","categoryStyle":{"layout":{}},"headerStyle":{"padding":{"left":16,"top":16,"right":16,"bottom":16},"titleColor":"text_color_highest_emphasis","titleFontName":"FONT_NAME_SUB_HEADER_S1_BOLD","imageStyle":{"width":{},"height":{}},"gradientStyle":{}},"dividerStyle":{"color":"#1502060C","height":1,"padding":{"left":16,"right":16}}}}},{"card":{"card":{"@type":"type.googleapis.com/swiggy.presentation.food.v2.ItemCategory","title":"Indian Meal","itemCards":[{"card":{"@type":"type.googleapis.com/swiggy.presentation.food.v2.Dish","info":{"id":"110617192","name":"Bihar Special Champaran Mutton & Rice","category":"Indian Meal","description":"Made with juicy mutton & mix of indian spices, Served with rice.","imageId":"58530a64fcb2663b9e37dbd2310abf42","inStock":1,"price":35900,"variants":{},"variantsV2":{},"itemAttribute":{"vegClassifier":"NONVEG"},"ribbon":{},"type":"ITEM","itemBadge":{},"badgesV2":{},"ratings":{"aggregatedRating":{"rating":"3.6","ratingCount":"21 ratings","ratingCountV2":"21"},"ratingsPresentationConfig":{"bgGradient":{"colours":["#D9EFEC","#00FFFFFF"],"gradientDirection":"GRADIENT_DIRECTION_LEFT_TO_RIGHT"},"ratingIconColor":"rating_medium","ratingTextColor":"rating_medium","ratingCountTextColor":"rating_medium","ratingFontName":"FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD","ratingCountFontName":"FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"}},"itemPriceStrikeOff":true,"size":{"width":0.46,"height":1},"parentId":"63685377"},"analytics":{},"hideRestaurantDetails":true}},{"card":{"@type":"type.googleapis.com/swiggy.presentation.food.v2.Dish","info":{"id":"110617191","name":"Punjabi Chicken Curry & Rice","category":"Indian Meal","description":"Punjabi style cooked chicken, Served with rice","imageId":"64352b29e04bc4fa7c94860ddcc3c2df","inStock":1,"price":30900,"variants":{},"variantsV2":{},"itemAttribute":{"vegClassifier":"NONVEG"},"ribbon":{},"type":"ITEM","itemBadge":{},"badgesV2":{},"ratings":{"aggregatedRating":{"rating":"3.6","ratingCount":"4 ratings","ratingCountV2":"4"},"ratingsPresentationConfig":{"bgGradient":{"colours":["#D9EFEC","#00FFFFFF"],"gradientDirection":"GRADIENT_DIRECTION_LEFT_TO_RIGHT"},"ratingIconColor":"rating_medium","ratingTextColor":"rating_medium","ratingCountTextColor":"rating_medium","ratingFontName":"FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD","ratingCountFontName":"FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"}},"itemPriceStrikeOff":true,"size":{"width":0.46,"height":1},"parentId":"63685387"},"analytics":{},"hideRestaurantDetails":true}},{"card":{"@type":"type.googleapis.com/swiggy.presentation.food.v2.Dish","info":{"id":"110617190","name":"Murg Makhani & Rice","category":"Indian Meal","description":"Indian curry made with a base of a spiced tomato & butter gravy. Served with rice.","imageId":"c20d8e0dc4364bc36555637a0d97814e","inStock":1,"price":30900,"variants":{},"variantsV2":{},"itemAttribute":{"vegClassifier":"NONVEG"},"ribbon":{},"type":"ITEM","itemBadge":{},"badgesV2":{},"ratings":{"aggregatedRating":{"rating":"1.8","ratingCount":"3 ratings","ratingCountV2":"3"},"ratingsPresentationConfig":{"bgGradient":{"colours":["#FFF0CD","#00FFFFFF"],"gradientDirection":"GRADIENT_DIRECTION_LEFT_TO_RIGHT"},"ratingIconColor":"rating_low","ratingTextColor":"rating_low","ratingCountTextColor":"rating_low","ratingFontName":"FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD","ratingCountFontName":"FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"}},"itemPriceStrikeOff":true,"size":{"width":0.46,"height":1},"parentId":"63685383"},"analytics":{},"hideRestaurantDetails":true}},{"card":{"@type":"type.googleapis.com/swiggy.presentation.food.v2.Dish","info":{"id":"110617187","name":"Paneer Masala & Rice","category":"Indian Meal","description":"Paneer Masala?is a creamy gravy made with butter, tomatoes, and paneer. Served with rice.","imageId":"f600ee6d050f85fcbd0c0d07d3c23312","inStock":1,"isVeg":1,"price":29900,"variants":{},"variantsV2":{},"itemAttribute":{"vegClassifier":"VEG"},"ribbon":{},"type":"ITEM","itemBadge":{},"badgesV2":{},"ratings":{"aggregatedRating":{}},"itemPriceStrikeOff":true,"size":{"width":0.46,"height":1},"parentId":"63685385"},"analytics":{},"hideRestaurantDetails":true}},{"card":{"@type":"type.googleapis.com/swiggy.presentation.food.v2.Dish","info":{"id":"110617188","name":"Dal Makhani & Rice","category":"Indian Meal","description":"Black lentils & red kidney beans are slow cooked with spices, butter & cream. Served with rice.","imageId":"289bb06017c12c8e60180a4754c45cdc","inStock":1,"isVeg":1,"price":27900,"variants":{},"variantsV2":{},"itemAttribute":{"vegClassifier":"VEG"},"ribbon":{},"type":"ITEM","itemBadge":{},"badgesV2":{},"ratings":{"aggregatedRating":{"rating":"2.9","ratingCount":"4 ratings","ratingCountV2":"4"},"ratingsPresentationConfig":{"bgGradient":{"colours":["#FFF0CD","#00FFFFFF"],"gradientDirection":"GRADIENT_DIRECTION_LEFT_TO_RIGHT"},"ratingIconColor":"rating_low","ratingTextColor":"rating_low","ratingCountTextColor":"rating_low","ratingFontName":"FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD","ratingCountFontName":"FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"}},"itemPriceStrikeOff":true,"size":{"width":0.46,"height":1},"parentId":"63685379"},"analytics":{},"hideRestaurantDetails":true}},{"card":{"@type":"type.googleapis.com/swiggy.presentation.food.v2.Dish","info":{"id":"110617185","name":"Rajma & Rice","category":"Indian Meal","description":"Made with protein rich kidney beans. Served with rice.","imageId":"2d72335d0004cedb54725a02a530e6ef","inStock":1,"isVeg":1,"price":23900,"variants":{},"variantsV2":{},"itemAttribute":{"vegClassifier":"VEG"},"ribbon":{},"type":"ITEM","itemBadge":{},"badgesV2":{},"ratings":{"aggregatedRating":{"rating":"4.4","ratingCount":"29 ratings","ratingCountV2":"29"},"ratingsPresentationConfig":{"bgGradient":{"colours":["#C8F9E5","#00FFFFFF"],"gradientDirection":"GRADIENT_DIRECTION_LEFT_TO_RIGHT"},"ratingIconColor":"rating_very_good","ratingTextColor":"rating_very_good","ratingCountTextColor":"rating_very_good","ratingFontName":"FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD","ratingCountFontName":"FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"}},"itemPriceStrikeOff":true,"size":{"width":0.46,"height":1},"parentId":"63685388"},"analytics":{},"hideRestaurantDetails":true}},{"card":{"@type":"type.googleapis.com/swiggy.presentation.food.v2.Dish","info":{"id":"110617186","name":"Yellow Dal Tadka Rice","category":"Indian Meal","description":"Yellow dal made with indian spices with a tempering made of ghee & served with rice.","imageId":"a76b030a9169f823df03838da39abf3f","inStock":1,"isVeg":1,"price":22900,"variants":{},"variantsV2":{},"itemAttribute":{"vegClassifier":"VEG"},"ribbon":{},"type":"ITEM","itemBadge":{},"badgesV2":{},"ratings":{"aggregatedRating":{"rating":"3.7","ratingCount":"10 ratings","ratingCountV2":"10"},"ratingsPresentationConfig":{"bgGradient":{"colours":["#D9EFEC","#00FFFFFF"],"gradientDirection":"GRADIENT_DIRECTION_LEFT_TO_RIGHT"},"ratingIconColor":"rating_medium","ratingTextColor":"rating_medium","ratingCountTextColor":"rating_medium","ratingFontName":"FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD","ratingCountFontName":"FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"}},"itemPriceStrikeOff":true,"size":{"width":0.46,"height":1},"parentId":"63685391"},"analytics":{},"hideRestaurantDetails":true}}],"subtitleSuffix":{},"image":"58530a64fcb2663b9e37dbd2310abf42","categoryId":"32222328","widgetType":"WIDGET_TYPE_DISH_FIRST","categoryStyle":{"layout":{}},"headerStyle":{"padding":{"left":16,"top":16,"right":16,"bottom":16},"titleColor":"text_color_highest_emphasis","titleFontName":"FONT_NAME_SUB_HEADER_S1_BOLD","imageStyle":{"width":{},"height":{}},"gradientStyle":{}},"dividerStyle":{"color":"#1502060C","height":1,"padding":{"left":16,"right":16}}}}},{"card":{"card":{"@type":"type.googleapis.com/swiggy.presentation.food.v2.ItemCategory","title":"Beverages","itemCards":[{"card":{"@type":"type.googleapis.com/swiggy.presentation.food.v2.Dish","info":{"id":"111576931","name":"Adarak Wali Chai (mini Flask Serves 2-3)","category":"Beverages","description":"Ginger tea or adrak wali chai is?a warming, spiced and fragrant Indian tea made with fresh ginger roots.","imageId":"90cea1cd1b6eff5cf637e34c7c218564","inStock":1,"isVeg":1,"price":14900,"variants":{},"variantsV2":{},"itemAttribute":{"vegClassifier":"VEG"},"ribbon":{"text":"Bestseller","textColor":"#ffffff","topBackgroundColor":"#d53d4c","bottomBackgroundColor":"#b02331"},"type":"ITEM","itemBadge":{},"badgesV2":{},"isBestseller":true,"ratings":{"aggregatedRating":{"rating":"4.4","ratingCount":"124 ratings","ratingCountV2":"124"},"ratingsPresentationConfig":{"bgGradient":{"colours":["#C8F9E5","#00FFFFFF"],"gradientDirection":"GRADIENT_DIRECTION_LEFT_TO_RIGHT"},"ratingIconColor":"rating_very_good","ratingTextColor":"rating_very_good","ratingCountTextColor":"rating_very_good","ratingFontName":"FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD","ratingCountFontName":"FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"}},"itemPriceStrikeOff":true,"size":{"width":0.46,"height":1},"parentId":"62480032"},"analytics":{},"hideRestaurantDetails":true}},{"card":{"@type":"type.googleapis.com/swiggy.presentation.food.v2.Dish","info":{"id":"111576935","name":"Masala Chai (mini Flask Serves 2-3)","category":"Beverages","description":"Made with a mix of Indian spices.","imageId":"26ced5b40fa5493a757e8afd44ad334f","inStock":1,"isVeg":1,"price":14900,"variants":{},"variantsV2":{},"itemAttribute":{"vegClassifier":"VEG"},"ribbon":{},"type":"ITEM","itemBadge":{},"badgesV2":{},"ratings":{"aggregatedRating":{"rating":"3.9","ratingCount":"39 ratings","ratingCountV2":"39"},"ratingsPresentationConfig":{"bgGradient":{"colours":["#D9EFEC","#00FFFFFF"],"gradientDirection":"GRADIENT_DIRECTION_LEFT_TO_RIGHT"},"ratingIconColor":"rating_medium","ratingTextColor":"rating_medium","ratingCountTextColor":"rating_medium","ratingFontName":"FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD","ratingCountFontName":"FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"}},"itemPriceStrikeOff":true,"size":{"width":0.46,"height":1},"parentId":"62480093"},"analytics":{},"hideRestaurantDetails":true}},{"card":{"@type":"type.googleapis.com/swiggy.presentation.food.v2.Dish","info":{"id":"111576934","name":"Green Tea (mini Flask Serves 2-3)","category":"Beverages","description":"Made solely from the leaves of the camellia sinensis plan - Green tea has one of the highest concentrations of antioxidants of any tea","imageId":"3a964663226e31e492e7d4acb3ec5066","inStock":1,"isVeg":1,"price":14900,"variants":{},"variantsV2":{},"itemAttribute":{"vegClassifier":"VEG"},"ribbon":{},"type":"ITEM","itemBadge":{},"badgesV2":{},"ratings":{"aggregatedRating":{}},"itemPriceStrikeOff":true,"size":{"width":0.46,"height":1},"parentId":"62480074"},"analytics":{},"hideRestaurantDetails":true}},{"card":{"@type":"type.googleapis.com/swiggy.presentation.food.v2.Dish","info":{"id":"111576932","name":"Black Coffee (mini Flask Serves 2-3)","category":"Beverages","description":"Served without milk","imageId":"e7d37233c9656ed84b79b11e99c3b240","inStock":1,"isVeg":1,"price":14900,"variants":{},"variantsV2":{},"itemAttribute":{"vegClassifier":"VEG"},"ribbon":{},"type":"ITEM","itemBadge":{},"badgesV2":{},"ratings":{"aggregatedRating":{"rating":"3.5","ratingCount":"8 ratings","ratingCountV2":"8"},"ratingsPresentationConfig":{"bgGradient":{"colours":["#D9EFEC","#00FFFFFF"],"gradientDirection":"GRADIENT_DIRECTION_LEFT_TO_RIGHT"},"ratingIconColor":"rating_medium","ratingTextColor":"rating_medium","ratingCountTextColor":"rating_medium","ratingFontName":"FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD","ratingCountFontName":"FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"}},"itemPriceStrikeOff":true,"size":{"width":0.46,"height":1},"parentId":"62480040"},"analytics":{},"hideRestaurantDetails":true}},{"card":{"@type":"type.googleapis.com/swiggy.presentation.food.v2.Dish","info":{"id":"111576933","name":"Black Tea (mini Flask Serves 2-3)","category":"Beverages","description":"Served without milk.","imageId":"e4fbd4e28803655def2bb60b226e0f1f","inStock":1,"isVeg":1,"price":14900,"variants":{},"variantsV2":{},"itemAttribute":{"vegClassifier":"VEG"},"ribbon":{},"type":"ITEM","itemBadge":{},"badgesV2":{},"ratings":{"aggregatedRating":{"rating":"5.0","ratingCount":"1 rating","ratingCountV2":"1"},"ratingsPresentationConfig":{"bgGradient":{"colours":["#C8F9E5","#00FFFFFF"],"gradientDirection":"GRADIENT_DIRECTION_LEFT_TO_RIGHT"},"ratingIconColor":"rating_very_good","ratingTextColor":"rating_very_good","ratingCountTextColor":"rating_very_good","ratingFontName":"FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD","ratingCountFontName":"FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"}},"itemPriceStrikeOff":true,"size":{"width":0.46,"height":1},"parentId":"62480041"},"analytics":{},"hideRestaurantDetails":true}},{"card":{"@type":"type.googleapis.com/swiggy.presentation.food.v2.Dish","info":{"id":"115218226","name":"Lemon Iced Tea","category":"Beverages","description":"Made with black tea, lemon juice, sugar, water, and ice","imageId":"d9f99755e0312ac72bd520d040c04f6a","inStock":1,"isVeg":1,"price":9900,"variants":{},"variantsV2":{},"itemAttribute":{"vegClassifier":"VEG"},"ribbon":{},"type":"ITEM","itemBadge":{},"badgesV2":{},"ratings":{"aggregatedRating":{"rating":"3.6","ratingCount":"26 ratings","ratingCountV2":"26"},"ratingsPresentationConfig":{"bgGradient":{"colours":["#D9EFEC","#00FFFFFF"],"gradientDirection":"GRADIENT_DIRECTION_LEFT_TO_RIGHT"},"ratingIconColor":"rating_medium","ratingTextColor":"rating_medium","ratingCountTextColor":"rating_medium","ratingFontName":"FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD","ratingCountFontName":"FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"}},"itemPriceStrikeOff":true,"size":{"width":0.46,"height":1},"parentId":"66258506"},"analytics":{},"hideRestaurantDetails":true}},{"card":{"@type":"type.googleapis.com/swiggy.presentation.food.v2.Dish","info":{"id":"108832066","name":"Nimbu Paani","category":"Beverages","description":"Indian style lemonade made with fresh lemon juice and sugar with a touch of spices.","imageId":"d73949d2f64ab41d3051959f89792354","inStock":1,"isVeg":1,"price":6900,"variants":{},"variantsV2":{},"itemAttribute":{"vegClassifier":"VEG"},"ribbon":{},"type":"ITEM","itemBadge":{},"badgesV2":{},"ratings":{"aggregatedRating":{"rating":"3.9","ratingCount":"51 ratings","ratingCountV2":"51"},"ratingsPresentationConfig":{"bgGradient":{"colours":["#D9EFEC","#00FFFFFF"],"gradientDirection":"GRADIENT_DIRECTION_LEFT_TO_RIGHT"},"ratingIconColor":"rating_medium","ratingTextColor":"rating_medium","ratingCountTextColor":"rating_medium","ratingFontName":"FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD","ratingCountFontName":"FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"}},"itemPriceStrikeOff":true,"size":{"width":0.46,"height":1},"parentId":"62480099"},"analytics":{},"hideRestaurantDetails":true}},{"card":{"@type":"type.googleapis.com/swiggy.presentation.food.v2.Dish","info":{"id":"108832067","name":"Jaljeera","category":"Beverages","description":"Jaljeera?is a tangy Indian beverage made using cilantro, mint, and spices.","imageId":"68f4547d4d56b0f23ceca45bc5eb96ef","inStock":1,"isVeg":1,"price":6900,"variants":{},"variantsV2":{},"itemAttribute":{"vegClassifier":"VEG"},"ribbon":{},"type":"ITEM","itemBadge":{},"badgesV2":{},"ratings":{"aggregatedRating":{"rating":"4.0","ratingCount":"34 ratings","ratingCountV2":"34"},"ratingsPresentationConfig":{"bgGradient":{"colours":["#C8F9E5","#00FFFFFF"],"gradientDirection":"GRADIENT_DIRECTION_LEFT_TO_RIGHT"},"ratingIconColor":"rating_very_good","ratingTextColor":"rating_very_good","ratingCountTextColor":"rating_very_good","ratingFontName":"FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD","ratingCountFontName":"FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"}},"itemPriceStrikeOff":true,"size":{"width":0.46,"height":1},"parentId":"62480083"},"analytics":{},"hideRestaurantDetails":true}},{"card":{"@type":"type.googleapis.com/swiggy.presentation.food.v2.Dish","info":{"id":"108832062","name":"Masala Chach","category":"Beverages","description":"Refreshing buttermilk lightly spiced.","imageId":"df8643bf393190543318e4ae78c85b0d","inStock":1,"isVeg":1,"price":6900,"variants":{},"variantsV2":{},"itemAttribute":{"vegClassifier":"VEG"},"ribbon":{},"type":"ITEM","itemBadge":{},"badgesV2":{},"ratings":{"aggregatedRating":{"rating":"3.7","ratingCount":"23 ratings","ratingCountV2":"23"},"ratingsPresentationConfig":{"bgGradient":{"colours":["#D9EFEC","#00FFFFFF"],"gradientDirection":"GRADIENT_DIRECTION_LEFT_TO_RIGHT"},"ratingIconColor":"rating_medium","ratingTextColor":"rating_medium","ratingCountTextColor":"rating_medium","ratingFontName":"FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD","ratingCountFontName":"FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"}},"itemPriceStrikeOff":true,"size":{"width":0.46,"height":1},"parentId":"62480092"},"analytics":{},"hideRestaurantDetails":true}}],"subtitleSuffix":{},"image":"90cea1cd1b6eff5cf637e34c7c218564","categoryId":"32222333","widgetType":"WIDGET_TYPE_DISH_FIRST","categoryStyle":{"layout":{}},"headerStyle":{"padding":{"left":16,"top":16,"right":16,"bottom":16},"titleColor":"text_color_highest_emphasis","titleFontName":"FONT_NAME_SUB_HEADER_S1_BOLD","imageStyle":{"width":{},"height":{}},"gradientStyle":{}},"dividerStyle":{"color":"#1502060C","height":1,"padding":{"left":16,"right":16}}}}},{"card":{"card":{"@type":"type.googleapis.com/swiggy.presentation.food.v2.ItemCategory","title":"Rolls","itemCards":[{"card":{"@type":"type.googleapis.com/swiggy.presentation.food.v2.Dish","info":{"id":"117716238","name":"Egg Roll","category":"Rolls","description":"Indian style egg rolled in a bread.","imageId":"40486f92274e4e01e18e94bbe59505f2","inStock":1,"price":9900,"variants":{},"variantsV2":{},"addons":[{"groupId":"125599020","groupName":"Addon Egg","choices":[{"id":"107814090","name":"1 Egg","price":2900,"inStock":1,"isEnabled":1},{"id":"107814091","name":"2 Egg","price":4900,"inStock":1,"isEnabled":1}],"maxAddons":1,"maxFreeAddons":-1},{"groupId":"125599022","groupName":"Choice Of Filling","choices":[{"id":"107814092","name":"Soya Filling","price":7900,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"107814093","name":"Paneer Tikka","price":9900,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"107814094","name":"Chicken Tikka","price":9900,"inStock":1,"isEnabled":1},{"id":"107814095","name":"Malai Tikka","price":9900,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"107814096","name":"Mutton Masala","price":12900,"isEnabled":1}],"maxAddons":1,"maxFreeAddons":-1},{"groupId":"125599025","groupName":"Choice Of Drinks","choices":[{"id":"107814097","name":"Ice Tea","price":8900,"inStock":1,"isVeg":1,"isEnabled":1}],"maxAddons":1,"maxFreeAddons":-1},{"groupId":"125599026","groupName":"Choice Of Sweet","choices":[{"id":"107814098","name":"Gulab Jamun 1 Pc","price":4900,"inStock":1,"isVeg":1,"isEnabled":1}],"maxAddons":1,"maxFreeAddons":-1}],"itemAttribute":{"vegClassifier":"NONVEG"},"ribbon":{},"type":"ITEM","itemBadge":{},"badgesV2":{},"ratings":{"aggregatedRating":{"rating":"4.2","ratingCount":"182 ratings","ratingCountV2":"182"},"ratingsPresentationConfig":{"bgGradient":{"colours":["#C8F9E5","#00FFFFFF"],"gradientDirection":"GRADIENT_DIRECTION_LEFT_TO_RIGHT"},"ratingIconColor":"rating_very_good","ratingTextColor":"rating_very_good","ratingCountTextColor":"rating_very_good","ratingFontName":"FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD","ratingCountFontName":"FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"}},"itemPriceStrikeOff":true,"size":{"width":0.46,"height":1},"parentId":"65727901"},"analytics":{},"hideRestaurantDetails":true}},{"card":{"@type":"type.googleapis.com/swiggy.presentation.food.v2.Dish","info":{"id":"117716239","name":"Chatpata Chicken Tikka Roll","category":"Rolls","description":"Boneless chicken marinated in a blend of Indian spices and curd, grilled and served on a wrap.","imageId":"6fb2d58ae007624ac957f7667a8b0118","inStock":1,"price":23900,"variants":{},"variantsV2":{},"addons":[{"groupId":"125599030","groupName":"Addon Egg","choices":[{"id":"107814090","name":"1 Egg","price":2900,"inStock":1,"isEnabled":1},{"id":"107814091","name":"2 Egg","price":4900,"inStock":1,"isEnabled":1}],"maxAddons":1,"maxFreeAddons":-1},{"groupId":"125599032","groupName":"Choice Of Filling","choices":[{"id":"107814092","name":"Soya Filling","price":7900,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"107814093","name":"Paneer Tikka","price":9900,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"107814094","name":"Chicken Tikka","price":9900,"inStock":1,"isEnabled":1},{"id":"107814095","name":"Malai Tikka","price":9900,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"107814096","name":"Mutton Masala","price":12900,"isEnabled":1}],"maxAddons":1,"maxFreeAddons":-1},{"groupId":"125599033","groupName":"Choice Of Drinks","choices":[{"id":"107814097","name":"Ice Tea","price":8900,"inStock":1,"isVeg":1,"isEnabled":1}],"maxAddons":1,"maxFreeAddons":-1},{"groupId":"125599035","groupName":"Choice Of Sweet","choices":[{"id":"107814098","name":"Gulab Jamun 1 Pc","price":4900,"inStock":1,"isVeg":1,"isEnabled":1}],"maxAddons":1,"maxFreeAddons":-1}],"itemAttribute":{"vegClassifier":"NONVEG"},"ribbon":{},"type":"ITEM","itemBadge":{},"badgesV2":{},"ratings":{"aggregatedRating":{"rating":"3.1","ratingCount":"46 ratings","ratingCountV2":"46"},"ratingsPresentationConfig":{"bgGradient":{"colours":["#D9EFEC","#00FFFFFF"],"gradientDirection":"GRADIENT_DIRECTION_LEFT_TO_RIGHT"},"ratingIconColor":"rating_medium","ratingTextColor":"rating_medium","ratingCountTextColor":"rating_medium","ratingFontName":"FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD","ratingCountFontName":"FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"}},"itemPriceStrikeOff":true,"size":{"width":0.46,"height":1},"parentId":"67273347"},"analytics":{},"hideRestaurantDetails":true}},{"card":{"@type":"type.googleapis.com/swiggy.presentation.food.v2.Dish","info":{"id":"117716237","name":"Makhmali Malai Tikka Roll","category":"Rolls","description":"Chicken Malai Tikka Roll is made with tendered chicken tossed in onion, pepper and sauces.","imageId":"32c7351759aed181df5a580105185723","inStock":1,"price":24900,"variants":{},"variantsV2":{},"addons":[{"groupId":"125599010","groupName":"Addon Egg","choices":[{"id":"107814090","name":"1 Egg","price":2900,"inStock":1,"isEnabled":1},{"id":"107814091","name":"2 Egg","price":4900,"inStock":1,"isEnabled":1}],"maxAddons":1,"maxFreeAddons":-1},{"groupId":"125599012","groupName":"Choice Of Filling","choices":[{"id":"107814092","name":"Soya Filling","price":7900,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"107814093","name":"Paneer Tikka","price":9900,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"107814094","name":"Chicken Tikka","price":9900,"inStock":1,"isEnabled":1},{"id":"107814095","name":"Malai Tikka","price":9900,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"107814096","name":"Mutton Masala","price":12900,"isEnabled":1}],"maxAddons":1,"maxFreeAddons":-1},{"groupId":"125599014","groupName":"Choice Of Drinks","choices":[{"id":"107814097","name":"Ice Tea","price":8900,"inStock":1,"isVeg":1,"isEnabled":1}],"maxAddons":1,"maxFreeAddons":-1},{"groupId":"125599016","groupName":"Choice Of Sweet","choices":[{"id":"107814098","name":"Gulab Jamun 1 Pc","price":4900,"inStock":1,"isVeg":1,"isEnabled":1}],"maxAddons":1,"maxFreeAddons":-1}],"itemAttribute":{"vegClassifier":"NONVEG"},"ribbon":{},"type":"ITEM","itemBadge":{},"badgesV2":{},"ratings":{"aggregatedRating":{"rating":"3.2","ratingCount":"13 ratings","ratingCountV2":"13"},"ratingsPresentationConfig":{"bgGradient":{"colours":["#D9EFEC","#00FFFFFF"],"gradientDirection":"GRADIENT_DIRECTION_LEFT_TO_RIGHT"},"ratingIconColor":"rating_medium","ratingTextColor":"rating_medium","ratingCountTextColor":"rating_medium","ratingFontName":"FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD","ratingCountFontName":"FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"}},"itemPriceStrikeOff":true,"size":{"width":0.46,"height":1},"parentId":"67273349"},"analytics":{},"hideRestaurantDetails":true}},{"card":{"@type":"type.googleapis.com/swiggy.presentation.food.v2.Dish","info":{"id":"117716241","name":"Takatak Paneer Tikka Roll","category":"Rolls","description":"Made with tandoori paneer, onion, capsicum, cocktail of sauces & Indian spices.","imageId":"193ac982ad8ac0c9bbc20921686ffa01","inStock":1,"isVeg":1,"price":22900,"finalPrice":8900,"variants":{},"variantsV2":{},"addons":[{"groupId":"125599047","groupName":"Addon Egg","choices":[{"id":"107814090","name":"1 Egg","price":2900,"inStock":1,"isEnabled":1},{"id":"107814091","name":"2 Egg","price":4900,"inStock":1,"isEnabled":1}],"maxAddons":1,"maxFreeAddons":-1},{"groupId":"125599048","groupName":"Choice Of Filling","choices":[{"id":"107814092","name":"Soya Filling","price":7900,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"107814093","name":"Paneer Tikka","price":9900,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"107814094","name":"Chicken Tikka","price":9900,"inStock":1,"isEnabled":1},{"id":"107814095","name":"Malai Tikka","price":9900,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"107814096","name":"Mutton Masala","price":12900,"isEnabled":1}],"maxAddons":1,"maxFreeAddons":-1},{"groupId":"125599049","groupName":"Choice Of Drinks","choices":[{"id":"107814097","name":"Ice Tea","price":8900,"inStock":1,"isVeg":1,"isEnabled":1}],"maxAddons":1,"maxFreeAddons":-1},{"groupId":"125599050","groupName":"Choice Of Sweet","choices":[{"id":"107814098","name":"Gulab Jamun 1 Pc","price":4900,"inStock":1,"isVeg":1,"isEnabled":1}],"maxAddons":1,"maxFreeAddons":-1}],"itemAttribute":{"vegClassifier":"VEG"},"ribbon":{},"type":"ITEM","offerTags":[{"matchText":"SILD"}],"itemBadge":{},"badgesV2":{},"itemNudgeType":"FinalPrice","ratings":{"aggregatedRating":{"rating":"3.9","ratingCount":"40 ratings","ratingCountV2":"40"},"ratingsPresentationConfig":{"bgGradient":{"colours":["#D9EFEC","#00FFFFFF"],"gradientDirection":"GRADIENT_DIRECTION_LEFT_TO_RIGHT"},"ratingIconColor":"rating_medium","ratingTextColor":"rating_medium","ratingCountTextColor":"rating_medium","ratingFontName":"FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD","ratingCountFontName":"FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"}},"itemPriceStrikeOff":true,"offerIds":["9caf6a85-3e4e-42da-ae21-f9705c6593d3"],"size":{"width":0.46,"height":1},"parentId":"67273352","offerCategory":"OFFER_CATEGORY_DEAL_RUSH","offerHeader":"Only till","offerSubHeader":"10:00 AM"},"analytics":{},"hideRestaurantDetails":true}},{"card":{"@type":"type.googleapis.com/swiggy.presentation.food.v2.Dish","info":{"id":"129712500","name":"Mushroom Tikka Roll","category":"Rolls","description":"Mushroom marinated & cooked with Tikka gravy","imageId":"FOOD_CATALOG/IMAGES/CMS/2024/5/15/fce4e4ce-496f-4486-9b32-431119fb197b_af6e1683-f0bd-49df-b9aa-f3972c140593.jpg","inStock":1,"isVeg":1,"price":24900,"variants":{},"variantsV2":{},"itemAttribute":{"vegClassifier":"VEG"},"ribbon":{},"type":"ITEM","itemBadge":{},"badgesV2":{},"ratings":{"aggregatedRating":{"rating":"4.0","ratingCount":"1 rating","ratingCountV2":"1"},"ratingsPresentationConfig":{"bgGradient":{"colours":["#C8F9E5","#00FFFFFF"],"gradientDirection":"GRADIENT_DIRECTION_LEFT_TO_RIGHT"},"ratingIconColor":"rating_very_good","ratingTextColor":"rating_very_good","ratingCountTextColor":"rating_very_good","ratingFontName":"FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD","ratingCountFontName":"FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"}},"itemPriceStrikeOff":true,"size":{"width":0.46,"height":1},"parentId":"75339031"},"analytics":{},"hideRestaurantDetails":true}},{"card":{"@type":"type.googleapis.com/swiggy.presentation.food.v2.Dish","info":{"id":"117716240","name":"Spicy Soya Roll","category":"Rolls","description":"Chatpata masaledar soya chap is cooked with crunchy onions & capsicums along with sauces and spices","imageId":"116a1be7d390cfc92340f365ecddc2f5","inStock":1,"isVeg":1,"price":19900,"finalPrice":7900,"variants":{},"variantsV2":{},"addons":[{"groupId":"125599039","groupName":"Addon Egg","choices":[{"id":"107814090","name":"1 Egg","price":2900,"inStock":1,"isEnabled":1},{"id":"107814091","name":"2 Egg","price":4900,"inStock":1,"isEnabled":1}],"maxAddons":1,"maxFreeAddons":-1},{"groupId":"125599041","groupName":"Choice Of Filling","choices":[{"id":"107814092","name":"Soya Filling","price":7900,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"107814093","name":"Paneer Tikka","price":9900,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"107814094","name":"Chicken Tikka","price":9900,"inStock":1,"isEnabled":1},{"id":"107814095","name":"Malai Tikka","price":9900,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"107814096","name":"Mutton Masala","price":12900,"isEnabled":1}],"maxAddons":1,"maxFreeAddons":-1},{"groupId":"125599043","groupName":"Choice Of Drinks","choices":[{"id":"107814097","name":"Ice Tea","price":8900,"inStock":1,"isVeg":1,"isEnabled":1}],"maxAddons":1,"maxFreeAddons":-1},{"groupId":"125599046","groupName":"Choice Of Sweet","choices":[{"id":"107814098","name":"Gulab Jamun 1 Pc","price":4900,"inStock":1,"isVeg":1,"isEnabled":1}],"maxAddons":1,"maxFreeAddons":-1}],"itemAttribute":{"vegClassifier":"VEG"},"ribbon":{},"type":"ITEM","offerTags":[{"matchText":"SILD"}],"itemBadge":{},"badgesV2":{},"itemNudgeType":"FinalPrice","ratings":{"aggregatedRating":{"rating":"3.9","ratingCount":"34 ratings","ratingCountV2":"34"},"ratingsPresentationConfig":{"bgGradient":{"colours":["#D9EFEC","#00FFFFFF"],"gradientDirection":"GRADIENT_DIRECTION_LEFT_TO_RIGHT"},"ratingIconColor":"rating_medium","ratingTextColor":"rating_medium","ratingCountTextColor":"rating_medium","ratingFontName":"FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD","ratingCountFontName":"FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"}},"itemPriceStrikeOff":true,"offerIds":["ddb29a66-004d-473d-a6fd-0e9b88a39632"],"size":{"width":0.46,"height":1},"parentId":"67273351","offerCategory":"OFFER_CATEGORY_DEAL_RUSH","offerHeader":"Only till","offerSubHeader":"10:00 AM"},"analytics":{},"hideRestaurantDetails":true}},{"card":{"@type":"type.googleapis.com/swiggy.presentation.food.v2.Dish","info":{"id":"129712499","name":"Corn Tikka Roll","category":"Rolls","description":"Mushroom marinated & cooked with Tikka gravy","imageId":"FOOD_CATALOG/IMAGES/CMS/2024/5/15/70b0b508-084c-4370-8cbd-cdc5f54ab9dc_4ceeffbb-ba0f-4703-b342-686c08130417.jpg","inStock":1,"isVeg":1,"price":20900,"variants":{},"variantsV2":{},"itemAttribute":{"vegClassifier":"VEG"},"ribbon":{},"type":"ITEM","itemBadge":{},"badgesV2":{},"ratings":{"aggregatedRating":{"rating":"3.0","ratingCount":"1 rating","ratingCountV2":"1"},"ratingsPresentationConfig":{"bgGradient":{"colours":["#D9EFEC","#00FFFFFF"],"gradientDirection":"GRADIENT_DIRECTION_LEFT_TO_RIGHT"},"ratingIconColor":"rating_medium","ratingTextColor":"rating_medium","ratingCountTextColor":"rating_medium","ratingFontName":"FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD","ratingCountFontName":"FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"}},"itemPriceStrikeOff":true,"size":{"width":0.46,"height":1},"parentId":"75339030"},"analytics":{},"hideRestaurantDetails":true}}],"subtitleSuffix":{},"image":"40486f92274e4e01e18e94bbe59505f2","categoryId":"35917596","widgetType":"WIDGET_TYPE_DISH_FIRST","categoryStyle":{"layout":{}},"headerStyle":{"padding":{"left":16,"top":16,"right":16,"bottom":16},"titleColor":"text_color_highest_emphasis","titleFontName":"FONT_NAME_SUB_HEADER_S1_BOLD","imageStyle":{"width":{},"height":{}},"gradientStyle":{}},"dividerStyle":{"color":"#1502060C","height":1,"padding":{"left":16,"right":16}}}}},{"card":{"card":{"@type":"type.googleapis.com/swiggy.presentation.food.v2.ItemCategory","title":"Biryani","itemCards":[{"card":{"@type":"type.googleapis.com/swiggy.presentation.food.v2.Dish","info":{"id":"108832028","name":"Hydrabadi Mutton Biryani","category":"Biryani","description":"Hyderabadi mutton biryani?is a classic dish made by layering rice over slow cooked mutton gravy, served with raita.","imageId":"06f78747a4dc200867b3f2e63dae3258","inStock":1,"price":39900,"variants":{},"variantsV2":{},"itemAttribute":{"vegClassifier":"NONVEG"},"ribbon":{},"type":"ITEM","itemBadge":{},"badgesV2":{},"ratings":{"aggregatedRating":{"rating":"4.5","ratingCount":"9 ratings","ratingCountV2":"9"},"ratingsPresentationConfig":{"bgGradient":{"colours":["#C8F9E5","#00FFFFFF"],"gradientDirection":"GRADIENT_DIRECTION_LEFT_TO_RIGHT"},"ratingIconColor":"rating_very_good","ratingTextColor":"rating_very_good","ratingCountTextColor":"rating_very_good","ratingFontName":"FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD","ratingCountFontName":"FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"}},"itemPriceStrikeOff":true,"size":{"width":0.46,"height":1},"parentId":"62480080"},"analytics":{},"hideRestaurantDetails":true}},{"card":{"@type":"type.googleapis.com/swiggy.presentation.food.v2.Dish","info":{"id":"108832029","name":"Lucknowi Chicken Biryani","category":"Biryani","description":"Awadhi chicken biryani (also known as?Lucknowi chicken biryani) made with long grain basmati rice, chicken, and mild spices, served with raita.","imageId":"f1655bcbe411daeb454363e71156e0a6","inStock":1,"price":34900,"variants":{},"variantsV2":{},"itemAttribute":{"vegClassifier":"NONVEG"},"ribbon":{},"type":"ITEM","itemBadge":{},"badgesV2":{},"ratings":{"aggregatedRating":{"rating":"3.5","ratingCount":"17 ratings","ratingCountV2":"17"},"ratingsPresentationConfig":{"bgGradient":{"colours":["#D9EFEC","#00FFFFFF"],"gradientDirection":"GRADIENT_DIRECTION_LEFT_TO_RIGHT"},"ratingIconColor":"rating_medium","ratingTextColor":"rating_medium","ratingCountTextColor":"rating_medium","ratingFontName":"FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD","ratingCountFontName":"FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"}},"itemPriceStrikeOff":true,"size":{"width":0.46,"height":1},"parentId":"62480088"},"analytics":{},"hideRestaurantDetails":true}},{"card":{"@type":"type.googleapis.com/swiggy.presentation.food.v2.Dish","info":{"id":"108832032","name":"Paneer Tikka Biryani","category":"Biryani","description":"Tandoori paneer biryani is a flavorful biryani, It is a vegetarian\'s delight cooked by marinating paneer with spices, served with raita.","imageId":"fc996d0fe0553e4e434f465dce54d166","inStock":1,"isVeg":1,"price":34900,"variants":{},"variantsV2":{},"itemAttribute":{"vegClassifier":"VEG"},"ribbon":{},"type":"ITEM","itemBadge":{},"badgesV2":{},"ratings":{"aggregatedRating":{"rating":"2.9","ratingCount":"17 ratings","ratingCountV2":"17"},"ratingsPresentationConfig":{"bgGradient":{"colours":["#FFF0CD","#00FFFFFF"],"gradientDirection":"GRADIENT_DIRECTION_LEFT_TO_RIGHT"},"ratingIconColor":"rating_low","ratingTextColor":"rating_low","ratingCountTextColor":"rating_low","ratingFontName":"FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD","ratingCountFontName":"FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"}},"itemPriceStrikeOff":true,"size":{"width":0.46,"height":1},"parentId":"62480103"},"analytics":{},"hideRestaurantDetails":true}},{"card":{"@type":"type.googleapis.com/swiggy.presentation.food.v2.Dish","info":{"id":"108832033","name":"Veg Biryani","category":"Biryani","description":"Vegetable biryani?is an aromatic rice dish made with basmati rice, spices & mixed veggies, served with raita.","imageId":"85fe8713d465212368a759fd82863d41","inStock":1,"isVeg":1,"price":29900,"variants":{},"variantsV2":{},"itemAttribute":{"vegClassifier":"VEG"},"ribbon":{},"type":"ITEM","itemBadge":{},"badgesV2":{},"ratings":{"aggregatedRating":{"rating":"4.8","ratingCount":"23 ratings","ratingCountV2":"23"},"ratingsPresentationConfig":{"bgGradient":{"colours":["#C8F9E5","#00FFFFFF"],"gradientDirection":"GRADIENT_DIRECTION_LEFT_TO_RIGHT"},"ratingIconColor":"rating_very_good","ratingTextColor":"rating_very_good","ratingCountTextColor":"rating_very_good","ratingFontName":"FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD","ratingCountFontName":"FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"}},"itemPriceStrikeOff":true,"size":{"width":0.46,"height":1},"parentId":"24998455"},"analytics":{},"hideRestaurantDetails":true}}],"subtitleSuffix":{},"image":"06f78747a4dc200867b3f2e63dae3258","categoryId":"32222327","widgetType":"WIDGET_TYPE_DISH_FIRST","categoryStyle":{"layout":{}},"headerStyle":{"padding":{"left":16,"top":16,"right":16,"bottom":16},"titleColor":"text_color_highest_emphasis","titleFontName":"FONT_NAME_SUB_HEADER_S1_BOLD","imageStyle":{"width":{},"height":{}},"gradientStyle":{}},"dividerStyle":{"color":"#1502060C","height":1,"padding":{"left":16,"right":16}}}}},{"card":{"card":{"@type":"type.googleapis.com/swiggy.presentation.food.v2.ItemCategory","title":"Burger","itemCards":[{"card":{"@type":"type.googleapis.com/swiggy.presentation.food.v2.Dish","info":{"id":"108831990","name":"Tikki Burger","category":"Burger","description":"Crisp golden potato patties are sandwiched between burger buns and then topped with veggies & Sauce.","imageId":"c34689260ba758fa6729c73892cec78e","inStock":1,"isVeg":1,"price":7900,"finalPrice":2900,"variants":{},"variantsV2":{},"addons":[{"groupId":"125119891","groupName":"Add On","choices":[{"id":"107652393","name":"Cheese Slice","price":2500,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"107652394","name":"Add Aloo Patty","price":4900,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"107652395","name":"Add Fries","price":8900,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"107652396","name":"Ice Tea","price":8900,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"107652397","name":"Gulab Jamun 2 Pcs","price":8900,"inStock":1,"isVeg":1,"isEnabled":1}],"maxAddons":5,"maxFreeAddons":-1}],"itemAttribute":{"vegClassifier":"VEG"},"ribbon":{},"type":"ITEM","offerTags":[{"matchText":"SILD"}],"itemBadge":{},"badgesV2":{},"itemNudgeType":"FinalPrice","ratings":{"aggregatedRating":{"rating":"4.0","ratingCount":"286 ratings","ratingCountV2":"286"},"ratingsPresentationConfig":{"bgGradient":{"colours":["#C8F9E5","#00FFFFFF"],"gradientDirection":"GRADIENT_DIRECTION_LEFT_TO_RIGHT"},"ratingIconColor":"rating_very_good","ratingTextColor":"rating_very_good","ratingCountTextColor":"rating_very_good","ratingFontName":"FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD","ratingCountFontName":"FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"}},"itemPriceStrikeOff":true,"offerIds":["a927ada4-b889-4406-b5e9-0ab4d390cdac"],"size":{"width":0.46,"height":1},"parentId":"62480125","offerCategory":"OFFER_CATEGORY_DEAL_RUSH","offerHeader":"Only till","offerSubHeader":"10:00 AM"},"analytics":{},"hideRestaurantDetails":true}},{"card":{"@type":"type.googleapis.com/swiggy.presentation.food.v2.Dish","info":{"id":"108831995","name":"Chicken & Cheese Burger","category":"Burger","description":"Crispy?fried chicken?fillet, loaded with vegetables & Cheese.","imageId":"66602c7ebb7c295599d0cf412aa6dbf5","inStock":1,"price":15900,"variants":{},"variantsV2":{},"addons":[{"groupId":"125119893","groupName":"Add On","choices":[{"id":"107652398","name":"Cheese Slice","price":2500,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"107652399","name":"Add Chicken Patty","price":7900,"inStock":1,"isEnabled":1},{"id":"107652400","name":"Add Fries","price":8900,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"107652401","name":"Ice Tea","price":8900,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"107652402","name":"Gulab Jamun 2 Pcs","price":8900,"inStock":1,"isVeg":1,"isEnabled":1}],"maxAddons":5,"maxFreeAddons":-1}],"itemAttribute":{"vegClassifier":"NONVEG"},"ribbon":{},"type":"ITEM","itemBadge":{},"badgesV2":{},"ratings":{"aggregatedRating":{"rating":"3.4","ratingCount":"26 ratings","ratingCountV2":"26"},"ratingsPresentationConfig":{"bgGradient":{"colours":["#D9EFEC","#00FFFFFF"],"gradientDirection":"GRADIENT_DIRECTION_LEFT_TO_RIGHT"},"ratingIconColor":"rating_medium","ratingTextColor":"rating_medium","ratingCountTextColor":"rating_medium","ratingFontName":"FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD","ratingCountFontName":"FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"}},"itemPriceStrikeOff":true,"size":{"width":0.46,"height":1},"parentId":"62480046"},"analytics":{},"hideRestaurantDetails":true}},{"card":{"@type":"type.googleapis.com/swiggy.presentation.food.v2.Dish","info":{"id":"108831996","name":"Chicken Tikka Burger","category":"Burger","description":"Juicy and spicy pieces of chicken tikka, layered with fresh veggies and delicious sauces.","imageId":"d128d68ffbabd2bc5275af907aa9c7d9","inStock":1,"price":16900,"finalPrice":6900,"variants":{},"variantsV2":{},"addons":[{"groupId":"125119892","groupName":"Add On","choices":[{"id":"107652398","name":"Cheese Slice","price":2500,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"107652399","name":"Add Chicken Patty","price":7900,"inStock":1,"isEnabled":1},{"id":"107652400","name":"Add Fries","price":8900,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"107652401","name":"Ice Tea","price":8900,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"107652402","name":"Gulab Jamun 2 Pcs","price":8900,"inStock":1,"isVeg":1,"isEnabled":1}],"maxAddons":5,"maxFreeAddons":-1}],"itemAttribute":{"vegClassifier":"NONVEG"},"ribbon":{},"type":"ITEM","offerTags":[{"matchText":"SILD"}],"itemBadge":{},"badgesV2":{},"itemNudgeType":"FinalPrice","ratings":{"aggregatedRating":{"rating":"4.1","ratingCount":"12 ratings","ratingCountV2":"12"},"ratingsPresentationConfig":{"bgGradient":{"colours":["#C8F9E5","#00FFFFFF"],"gradientDirection":"GRADIENT_DIRECTION_LEFT_TO_RIGHT"},"ratingIconColor":"rating_very_good","ratingTextColor":"rating_very_good","ratingCountTextColor":"rating_very_good","ratingFontName":"FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD","ratingCountFontName":"FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"}},"itemPriceStrikeOff":true,"offerIds":["568345f1-a79e-4493-bbc4-6f6099228ce8"],"size":{"width":0.46,"height":1},"parentId":"62480056","offerCategory":"OFFER_CATEGORY_DEAL_RUSH","offerHeader":"Only till","offerSubHeader":"10:00 AM"},"analytics":{},"hideRestaurantDetails":true}},{"card":{"@type":"type.googleapis.com/swiggy.presentation.food.v2.Dish","info":{"id":"111576911","name":"BBQ Chicken Burger","category":"Burger","description":"Crispy?fried chicken?fillet, loaded with vegatables & flavor of BBQ sauce.","imageId":"1062c924c7bc54924fabf06a93da3400","inStock":1,"price":14900,"finalPrice":5900,"variants":{},"variantsV2":{},"addons":[{"groupId":"125119894","groupName":"Add On","choices":[{"id":"107652398","name":"Cheese Slice","price":2500,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"107652399","name":"Add Chicken Patty","price":7900,"inStock":1,"isEnabled":1},{"id":"107652400","name":"Add Fries","price":8900,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"107652401","name":"Ice Tea","price":8900,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"107652402","name":"Gulab Jamun 2 Pcs","price":8900,"inStock":1,"isVeg":1,"isEnabled":1}],"maxAddons":5,"maxFreeAddons":-1}],"itemAttribute":{"vegClassifier":"NONVEG"},"ribbon":{},"type":"ITEM","offerTags":[{"matchText":"SILD"}],"itemBadge":{},"badgesV2":{},"itemNudgeType":"FinalPrice","ratings":{"aggregatedRating":{"rating":"3.3","ratingCount":"23 ratings","ratingCountV2":"23"},"ratingsPresentationConfig":{"bgGradient":{"colours":["#D9EFEC","#00FFFFFF"],"gradientDirection":"GRADIENT_DIRECTION_LEFT_TO_RIGHT"},"ratingIconColor":"rating_medium","ratingTextColor":"rating_medium","ratingCountTextColor":"rating_medium","ratingFontName":"FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD","ratingCountFontName":"FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"}},"itemPriceStrikeOff":true,"offerIds":["3d3deff4-5f75-4cc2-b1d7-dca34271ee04"],"size":{"width":0.46,"height":1},"parentId":"62480037","offerCategory":"OFFER_CATEGORY_DEAL_RUSH","offerHeader":"Only till","offerSubHeader":"10:00 AM"},"analytics":{},"hideRestaurantDetails":true}},{"card":{"@type":"type.googleapis.com/swiggy.presentation.food.v2.Dish","info":{"id":"108831992","name":"Paneer Tikki Burger","category":"Burger","description":"Made with juicy paneer patty along with fresh greens.","imageId":"c80eb19d908c65625740321b3dccf111","inStock":1,"isVeg":1,"price":12900,"finalPrice":4900,"variants":{},"variantsV2":{},"addons":[{"groupId":"125119896","groupName":"Add On","choices":[{"id":"107652403","name":"Cheese Slice","price":2500,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"107652404","name":"Add Paneer Patty","price":7900,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"107652405","name":"Add Fries","price":8900,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"107652406","name":"Ice Tea","price":8900,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"107652407","name":"Gulab Jamun 2 Pcs","price":8900,"inStock":1,"isVeg":1,"isEnabled":1}],"maxAddons":5,"maxFreeAddons":-1}],"itemAttribute":{"vegClassifier":"VEG"},"ribbon":{},"type":"ITEM","offerTags":[{"matchText":"SILD"}],"itemBadge":{},"badgesV2":{},"itemNudgeType":"FinalPrice","ratings":{"aggregatedRating":{"rating":"3.8","ratingCount":"45 ratings","ratingCountV2":"45"},"ratingsPresentationConfig":{"bgGradient":{"colours":["#D9EFEC","#00FFFFFF"],"gradientDirection":"GRADIENT_DIRECTION_LEFT_TO_RIGHT"},"ratingIconColor":"rating_medium","ratingTextColor":"rating_medium","ratingCountTextColor":"rating_medium","ratingFontName":"FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD","ratingCountFontName":"FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"}},"itemPriceStrikeOff":true,"offerIds":["3d684d37-7a44-4113-b6ca-806845f4afe2"],"size":{"width":0.46,"height":1},"parentId":"62480106","offerCategory":"OFFER_CATEGORY_DEAL_RUSH","offerHeader":"Only till","offerSubHeader":"10:00 AM"},"analytics":{},"hideRestaurantDetails":true}},{"card":{"@type":"type.googleapis.com/swiggy.presentation.food.v2.Dish","info":{"id":"108831993","name":"Juicy Chicken Burger","category":"Burger","description":"Crispy?fried chicken?fillet slathered with a special?burger?sauce & vegetables.","imageId":"d400e637c1c718fb4cba69622c1b0afc","inStock":1,"price":13900,"variants":{},"variantsV2":{},"addons":[{"groupId":"125119895","groupName":"Add On","choices":[{"id":"107652398","name":"Cheese Slice","price":2500,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"107652399","name":"Add Chicken Patty","price":7900,"inStock":1,"isEnabled":1},{"id":"107652400","name":"Add Fries","price":8900,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"107652401","name":"Ice Tea","price":8900,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"107652402","name":"Gulab Jamun 2 Pcs","price":8900,"inStock":1,"isVeg":1,"isEnabled":1}],"maxAddons":5,"maxFreeAddons":-1}],"itemAttribute":{"vegClassifier":"NONVEG"},"ribbon":{},"type":"ITEM","itemBadge":{},"badgesV2":{},"ratings":{"aggregatedRating":{"rating":"3.7","ratingCount":"42 ratings","ratingCountV2":"42"},"ratingsPresentationConfig":{"bgGradient":{"colours":["#D9EFEC","#00FFFFFF"],"gradientDirection":"GRADIENT_DIRECTION_LEFT_TO_RIGHT"},"ratingIconColor":"rating_medium","ratingTextColor":"rating_medium","ratingCountTextColor":"rating_medium","ratingFontName":"FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD","ratingCountFontName":"FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"}},"itemPriceStrikeOff":true,"size":{"width":0.46,"height":1},"parentId":"62480084"},"analytics":{},"hideRestaurantDetails":true}},{"card":{"@type":"type.googleapis.com/swiggy.presentation.food.v2.Dish","info":{"id":"108831991","name":"Veggie Delight Burger","category":"Burger","description":"This larger than life veggie burger is?loaded with fresh greens and vegetable patty.","imageId":"04213b86ebfc9e25b26b2a109222a28b","inStock":1,"isVeg":1,"price":8900,"finalPrice":3900,"variants":{},"variantsV2":{},"addons":[{"groupId":"125119897","groupName":"Add On","choices":[{"id":"107652408","name":"Cheese Slice","price":2500,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"107652409","name":"Add Veggie Patty","price":5900,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"107652410","name":"Add Fries","price":8900,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"107652411","name":"Ice Tea","price":8900,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"107652412","name":"Gulab Jamun 2 Pcs","price":8900,"inStock":1,"isVeg":1,"isEnabled":1}],"maxAddons":5,"maxFreeAddons":-1}],"itemAttribute":{"vegClassifier":"VEG"},"ribbon":{},"type":"ITEM","offerTags":[{"matchText":"SILD"}],"itemBadge":{},"badgesV2":{},"itemNudgeType":"FinalPrice","ratings":{"aggregatedRating":{"rating":"3.6","ratingCount":"122 ratings","ratingCountV2":"122"},"ratingsPresentationConfig":{"bgGradient":{"colours":["#D9EFEC","#00FFFFFF"],"gradientDirection":"GRADIENT_DIRECTION_LEFT_TO_RIGHT"},"ratingIconColor":"rating_medium","ratingTextColor":"rating_medium","ratingCountTextColor":"rating_medium","ratingFontName":"FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD","ratingCountFontName":"FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"}},"itemPriceStrikeOff":true,"offerIds":["e0dbebae-461e-4fc0-a7d0-8ba51f921c60"],"size":{"width":0.46,"height":1},"parentId":"62480131","offerCategory":"OFFER_CATEGORY_DEAL_RUSH","offerHeader":"Only till","offerSubHeader":"10:00 AM"},"analytics":{},"hideRestaurantDetails":true}}],"subtitleSuffix":{},"image":"c34689260ba758fa6729c73892cec78e","categoryId":"32222326","widgetType":"WIDGET_TYPE_DISH_FIRST","categoryStyle":{"layout":{}},"headerStyle":{"padding":{"left":16,"top":16,"right":16,"bottom":16},"titleColor":"text_color_highest_emphasis","titleFontName":"FONT_NAME_SUB_HEADER_S1_BOLD","imageStyle":{"width":{},"height":{}},"gradientStyle":{}},"dividerStyle":{"color":"#1502060C","height":1,"padding":{"left":16,"right":16}}}}},{"card":{"card":{"@type":"type.googleapis.com/swiggy.presentation.food.v2.ItemCategory","title":"Snacks","itemCards":[{"card":{"@type":"type.googleapis.com/swiggy.presentation.food.v2.Dish","info":{"id":"129964646","name":"Chicken Cutlet 4 Pcs","category":"Snacks","description":"Made with boneless chicken & Indian spices, Served with mint sauce","imageId":"FOOD_CATALOG/IMAGES/CMS/2024/5/15/3a6030eb-ef1a-4292-8dfb-66a0d36e52c7_a2910980-0f80-47a1-b176-55bd2dd25b81.jpg","inStock":1,"price":24900,"variants":{},"variantsV2":{},"itemAttribute":{"vegClassifier":"NONVEG"},"ribbon":{},"type":"ITEM","itemBadge":{},"badgesV2":{},"ratings":{"aggregatedRating":{"rating":"3.7","ratingCount":"13 ratings","ratingCountV2":"13"},"ratingsPresentationConfig":{"bgGradient":{"colours":["#D9EFEC","#00FFFFFF"],"gradientDirection":"GRADIENT_DIRECTION_LEFT_TO_RIGHT"},"ratingIconColor":"rating_medium","ratingTextColor":"rating_medium","ratingCountTextColor":"rating_medium","ratingFontName":"FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD","ratingCountFontName":"FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"}},"itemPriceStrikeOff":true,"size":{"width":0.46,"height":1},"parentId":"75543670"},"analytics":{},"hideRestaurantDetails":true}},{"card":{"@type":"type.googleapis.com/swiggy.presentation.food.v2.Dish","info":{"id":"108832057","name":"Fries","category":"Snacks","description":"Classic salted fries.","imageId":"e97ee544cf54bf2a3bd215fd4f88cb73","inStock":1,"isVeg":1,"price":8900,"finalPrice":3900,"variants":{},"variantsV2":{},"itemAttribute":{"vegClassifier":"VEG"},"ribbon":{},"type":"ITEM","offerTags":[{"matchText":"SILD"}],"itemBadge":{},"badgesV2":{},"itemNudgeType":"FinalPrice","ratings":{"aggregatedRating":{"rating":"4.1","ratingCount":"167 ratings","ratingCountV2":"167"},"ratingsPresentationConfig":{"bgGradient":{"colours":["#C8F9E5","#00FFFFFF"],"gradientDirection":"GRADIENT_DIRECTION_LEFT_TO_RIGHT"},"ratingIconColor":"rating_very_good","ratingTextColor":"rating_very_good","ratingCountTextColor":"rating_very_good","ratingFontName":"FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD","ratingCountFontName":"FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"}},"itemPriceStrikeOff":true,"offerIds":["e0dbebae-461e-4fc0-a7d0-8ba51f921c60"],"size":{"width":0.46,"height":1},"parentId":"62480073","offerCategory":"OFFER_CATEGORY_DEAL_RUSH","offerHeader":"Only till","offerSubHeader":"10:00 AM"},"analytics":{},"hideRestaurantDetails":true}},{"card":{"@type":"type.googleapis.com/swiggy.presentation.food.v2.Dish","info":{"id":"129964647","name":"Veg Cutlet 4 Pcs","category":"Snacks","description":"Made with mixed vegetables, herbs and spices, Served with mint sauce","imageId":"FOOD_CATALOG/IMAGES/CMS/2024/5/15/88f5db7f-62d9-4f55-bc28-da8dc40a306f_f21f8fb6-4b05-4d96-8c0b-4602ed829107.jpg","inStock":1,"isVeg":1,"price":16900,"variants":{},"variantsV2":{},"itemAttribute":{"vegClassifier":"VEG"},"ribbon":{},"type":"ITEM","itemBadge":{},"badgesV2":{},"ratings":{"aggregatedRating":{"rating":"4.1","ratingCount":"12 ratings","ratingCountV2":"12"},"ratingsPresentationConfig":{"bgGradient":{"colours":["#C8F9E5","#00FFFFFF"],"gradientDirection":"GRADIENT_DIRECTION_LEFT_TO_RIGHT"},"ratingIconColor":"rating_very_good","ratingTextColor":"rating_very_good","ratingCountTextColor":"rating_very_good","ratingFontName":"FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD","ratingCountFontName":"FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"}},"itemPriceStrikeOff":true,"size":{"width":0.46,"height":1},"parentId":"75543671"},"analytics":{},"hideRestaurantDetails":true}},{"card":{"@type":"type.googleapis.com/swiggy.presentation.food.v2.Dish","info":{"id":"108832058","name":"Mexican Salsa Fries","category":"Snacks","description":"Salted fries served with tangy aalsa sauce","imageId":"14c9261a694bf9d76324f9cf89894f0c","inStock":1,"isVeg":1,"price":14900,"variants":{},"variantsV2":{},"itemAttribute":{"vegClassifier":"VEG"},"ribbon":{},"type":"ITEM","itemBadge":{},"badgesV2":{},"ratings":{"aggregatedRating":{"rating":"2.3","ratingCount":"8 ratings","ratingCountV2":"8"},"ratingsPresentationConfig":{"bgGradient":{"colours":["#FFF0CD","#00FFFFFF"],"gradientDirection":"GRADIENT_DIRECTION_LEFT_TO_RIGHT"},"ratingIconColor":"rating_low","ratingTextColor":"rating_low","ratingCountTextColor":"rating_low","ratingFontName":"FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD","ratingCountFontName":"FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"}},"itemPriceStrikeOff":true,"size":{"width":0.46,"height":1},"parentId":"63333585"},"analytics":{},"hideRestaurantDetails":true}},{"card":{"@type":"type.googleapis.com/swiggy.presentation.food.v2.Dish","info":{"id":"131545818","name":"Potato Wedges","category":"Snacks","description":"Delicious golden-brown wedges are perfectly crispy on the outside and soft on the inside, Served with mint sauce","imageId":"FOOD_CATALOG/IMAGES/CMS/2024/5/15/56195c0b-bd91-49bf-bd05-cd1cb9456772_b4266453-503d-4484-b24c-1fe5dced067a.jpg","inStock":1,"isVeg":1,"price":14900,"variants":{},"variantsV2":{},"itemAttribute":{"vegClassifier":"VEG"},"ribbon":{},"type":"ITEM","itemBadge":{},"badgesV2":{},"ratings":{"aggregatedRating":{"rating":"3.8","ratingCount":"5 ratings","ratingCountV2":"5"},"ratingsPresentationConfig":{"bgGradient":{"colours":["#D9EFEC","#00FFFFFF"],"gradientDirection":"GRADIENT_DIRECTION_LEFT_TO_RIGHT"},"ratingIconColor":"rating_medium","ratingTextColor":"rating_medium","ratingCountTextColor":"rating_medium","ratingFontName":"FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD","ratingCountFontName":"FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"}},"itemPriceStrikeOff":true,"size":{"width":0.46,"height":1},"parentId":"76540606"},"analytics":{},"hideRestaurantDetails":true}}],"subtitleSuffix":{},"image":"FOOD_CATALOG/IMAGES/CMS/2024/5/15/3a6030eb-ef1a-4292-8dfb-66a0d36e52c7_a2910980-0f80-47a1-b176-55bd2dd25b81.jpg","categoryId":"32222329","widgetType":"WIDGET_TYPE_DISH_FIRST","categoryStyle":{"layout":{}},"headerStyle":{"padding":{"left":16,"top":16,"right":16,"bottom":16},"titleColor":"text_color_highest_emphasis","titleFontName":"FONT_NAME_SUB_HEADER_S1_BOLD","imageStyle":{"width":{},"height":{}},"gradientStyle":{}},"dividerStyle":{"color":"#1502060C","height":1,"padding":{"left":16,"right":16}}}}},{"card":{"card":{"@type":"type.googleapis.com/swiggy.presentation.food.v2.ItemCategory","title":"Fasting Meals","itemCards":[{"card":{"@type":"type.googleapis.com/swiggy.presentation.food.v2.Dish","info":{"id":"126381353","name":"Sabutdana Vada","category":"Fasting Meals","description":"Made With Tapioca Pearls (Sago), Roasted Peanuts, Boiled Potatoes And Herbs Served Along With Raita","imageId":"FOOD_CATALOG/IMAGES/CMS/2024/5/15/6841ae8a-c22b-4a3e-8a25-39c8e4e3f654_74905ce8-345f-4eb7-9ad0-e521b2ae17c3.jpg","inStock":1,"isVeg":1,"price":19900,"finalPrice":7900,"variants":{},"variantsV2":{},"itemAttribute":{"vegClassifier":"VEG"},"ribbon":{},"type":"ITEM","offerTags":[{"matchText":"SILD"}],"itemBadge":{},"badgesV2":{},"itemNudgeType":"FinalPrice","ratings":{"aggregatedRating":{"rating":"4.9","ratingCount":"13 ratings","ratingCountV2":"13"},"ratingsPresentationConfig":{"bgGradient":{"colours":["#C8F9E5","#00FFFFFF"],"gradientDirection":"GRADIENT_DIRECTION_LEFT_TO_RIGHT"},"ratingIconColor":"rating_very_good","ratingTextColor":"rating_very_good","ratingCountTextColor":"rating_very_good","ratingFontName":"FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD","ratingCountFontName":"FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"}},"itemPriceStrikeOff":true,"offerIds":["ddb29a66-004d-473d-a6fd-0e9b88a39632"],"size":{"width":0.46,"height":1},"parentId":"73124158","offerCategory":"OFFER_CATEGORY_DEAL_RUSH","offerHeader":"Only till","offerSubHeader":"10:00 AM"},"analytics":{},"hideRestaurantDetails":true}},{"card":{"@type":"type.googleapis.com/swiggy.presentation.food.v2.Dish","info":{"id":"126381360","name":"Sabudaba Khichdi","category":"Fasting Meals","description":"Sabudana Ki Khichdi Is A Delicious Dish Of Tapioca Pearls (Sago) Made With Potatoes & Peanuts Served Along With Raita","imageId":"FOOD_CATALOG/IMAGES/CMS/2024/5/15/108d8a4b-55dd-4de2-a110-996a06233f0b_c45e0324-a4f6-4aa6-af88-ff18ac09e5a5.jpg","inStock":1,"isVeg":1,"price":19900,"finalPrice":7900,"variants":{},"variantsV2":{},"itemAttribute":{"vegClassifier":"VEG"},"ribbon":{},"type":"ITEM","offerTags":[{"matchText":"SILD"}],"itemBadge":{},"badgesV2":{},"itemNudgeType":"FinalPrice","ratings":{"aggregatedRating":{"rating":"4.1","ratingCount":"15 ratings","ratingCountV2":"15"},"ratingsPresentationConfig":{"bgGradient":{"colours":["#C8F9E5","#00FFFFFF"],"gradientDirection":"GRADIENT_DIRECTION_LEFT_TO_RIGHT"},"ratingIconColor":"rating_very_good","ratingTextColor":"rating_very_good","ratingCountTextColor":"rating_very_good","ratingFontName":"FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD","ratingCountFontName":"FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"}},"itemPriceStrikeOff":true,"offerIds":["ddb29a66-004d-473d-a6fd-0e9b88a39632"],"size":{"width":0.46,"height":1},"parentId":"73124157","offerCategory":"OFFER_CATEGORY_DEAL_RUSH","offerHeader":"Only till","offerSubHeader":"10:00 AM"},"analytics":{},"hideRestaurantDetails":true}},{"card":{"@type":"type.googleapis.com/swiggy.presentation.food.v2.Dish","info":{"id":"126381349","name":"Aloo Chat","category":"Fasting Meals","description":"Crispy Potato Pieces Seasoned With Very Few Spices, Fresh Herbs And Drizzled Lemon Juice On Top.","imageId":"FOOD_CATALOG/IMAGES/CMS/2024/5/15/ec527d18-a2f8-4242-aa91-9409975a9d16_7ca1acb7-0c0b-406f-a5c2-f647ad205f04.jpg","inStock":1,"isVeg":1,"price":14900,"variants":{},"variantsV2":{},"itemAttribute":{"vegClassifier":"VEG"},"ribbon":{},"type":"ITEM","itemBadge":{},"badgesV2":{},"ratings":{"aggregatedRating":{"rating":"4.0","ratingCount":"4 ratings","ratingCountV2":"4"},"ratingsPresentationConfig":{"bgGradient":{"colours":["#C8F9E5","#00FFFFFF"],"gradientDirection":"GRADIENT_DIRECTION_LEFT_TO_RIGHT"},"ratingIconColor":"rating_very_good","ratingTextColor":"rating_very_good","ratingCountTextColor":"rating_very_good","ratingFontName":"FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD","ratingCountFontName":"FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"}},"itemPriceStrikeOff":true,"size":{"width":0.46,"height":1},"parentId":"73124154"},"analytics":{},"hideRestaurantDetails":true}}],"subtitleSuffix":{},"image":"FOOD_CATALOG/IMAGES/CMS/2024/5/15/6841ae8a-c22b-4a3e-8a25-39c8e4e3f654_74905ce8-345f-4eb7-9ad0-e521b2ae17c3.jpg","categoryId":"41334237","widgetType":"WIDGET_TYPE_DISH_FIRST","categoryStyle":{"layout":{}},"headerStyle":{"padding":{"left":16,"top":16,"right":16,"bottom":16},"titleColor":"text_color_highest_emphasis","titleFontName":"FONT_NAME_SUB_HEADER_S1_BOLD","imageStyle":{"width":{},"height":{}},"gradientStyle":{}},"dividerStyle":{"color":"#1502060C","height":1,"padding":{"left":16,"right":16}}}}},{"card":{"card":{"@type":"type.googleapis.com/swiggy.presentation.food.v2.ItemCategory","title":"Dessert","itemCards":[{"card":{"@type":"type.googleapis.com/swiggy.presentation.food.v2.Dish","info":{"id":"118074121","name":"Moong Dal Halwa","category":"Dessert","description":"Made moong, milk, sugar and nuts.","imageId":"7d4459f5940e478219f94c03cf02eb9a","inStock":1,"isVeg":1,"price":12900,"variants":{},"variantsV2":{},"itemAttribute":{"vegClassifier":"VEG"},"ribbon":{},"type":"ITEM","itemBadge":{},"badgesV2":{},"ratings":{"aggregatedRating":{"rating":"4.2","ratingCount":"23 ratings","ratingCountV2":"23"},"ratingsPresentationConfig":{"bgGradient":{"colours":["#C8F9E5","#00FFFFFF"],"gradientDirection":"GRADIENT_DIRECTION_LEFT_TO_RIGHT"},"ratingIconColor":"rating_very_good","ratingTextColor":"rating_very_good","ratingCountTextColor":"rating_very_good","ratingFontName":"FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD","ratingCountFontName":"FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"}},"itemPriceStrikeOff":true,"size":{"width":0.46,"height":1},"parentId":"67576596"},"analytics":{},"hideRestaurantDetails":true}},{"card":{"@type":"type.googleapis.com/swiggy.presentation.food.v2.Dish","info":{"id":"113304427","name":"Kheer (cold) (150 Gm)","category":"Dessert","description":"A chilled south Asian dessert mate from rice milk, dry fruit & sugar","imageId":"7a3e64f9704406337c4a8395a1e77ebd","inStock":1,"isVeg":1,"price":12900,"variants":{},"variantsV2":{},"itemAttribute":{"vegClassifier":"VEG"},"ribbon":{},"type":"ITEM","itemBadge":{},"badgesV2":{},"ratings":{"aggregatedRating":{"rating":"4.9","ratingCount":"15 ratings","ratingCountV2":"15"},"ratingsPresentationConfig":{"bgGradient":{"colours":["#C8F9E5","#00FFFFFF"],"gradientDirection":"GRADIENT_DIRECTION_LEFT_TO_RIGHT"},"ratingIconColor":"rating_very_good","ratingTextColor":"rating_very_good","ratingCountTextColor":"rating_very_good","ratingFontName":"FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD","ratingCountFontName":"FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"}},"itemPriceStrikeOff":true,"size":{"width":0.46,"height":1},"parentId":"65286896"},"analytics":{},"hideRestaurantDetails":true}},{"card":{"@type":"type.googleapis.com/swiggy.presentation.food.v2.Dish","info":{"id":"111576936","name":"Gulab Jamun (2 Pcs)","category":"Dessert","description":"Fried dough balls that are soaked in a sweet, sticky sugar syrup","imageId":"d185664d5ef4e5fd8baa369382a1edd1","inStock":1,"isVeg":1,"price":8900,"variants":{},"variantsV2":{},"itemAttribute":{"vegClassifier":"VEG"},"ribbon":{},"type":"ITEM","itemBadge":{},"badgesV2":{},"ratings":{"aggregatedRating":{"rating":"3.8","ratingCount":"29 ratings","ratingCountV2":"29"},"ratingsPresentationConfig":{"bgGradient":{"colours":["#D9EFEC","#00FFFFFF"],"gradientDirection":"GRADIENT_DIRECTION_LEFT_TO_RIGHT"},"ratingIconColor":"rating_medium","ratingTextColor":"rating_medium","ratingCountTextColor":"rating_medium","ratingFontName":"FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD","ratingCountFontName":"FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"}},"itemPriceStrikeOff":true,"size":{"width":0.46,"height":1},"parentId":"62480075"},"analytics":{},"hideRestaurantDetails":true}}],"subtitleSuffix":{},"image":"7d4459f5940e478219f94c03cf02eb9a","categoryId":"32222334","widgetType":"WIDGET_TYPE_DISH_FIRST","categoryStyle":{"layout":{}},"headerStyle":{"padding":{"left":16,"top":16,"right":16,"bottom":16},"titleColor":"text_color_highest_emphasis","titleFontName":"FONT_NAME_SUB_HEADER_S1_BOLD","imageStyle":{"width":{},"height":{}},"gradientStyle":{}},"dividerStyle":{"color":"#1502060C","height":1,"padding":{"left":16,"right":16}}}}},{"card":{"card":{"@type":"type.googleapis.com/swiggy.gandalf.widgets.v2.GridWidget","header":{"title":"Try these featured restaurants!","headerStyling":{"padding":{"left":20,"top":24,"bottom":16},"titleSize":18,"subtitleSize":14,"titleColor":"#3e4152","titleFontName":"FONT_NAME_ALL_CAPS_AC1"}},"layout":{"rows":1,"columns":6,"horizontalScrollEnabled":true,"widgetPadding":{},"containerStyle":{"containerPadding":{"left":8,"right":12,"bottom":16}},"scrollBar":{"scrollThumbColor":"#E46D47","scrollTrackColor":"#E4E4E4","width":54,"height":4,"scrollStyling":{"padding":{"top":6,"bottom":24}}},"backgroundColor":"#F1F8FF","widgetBorderStyle":{"top":{"color":"#E7F4FD","height":1},"bottom":{"color":"#E7F4FD","height":1},"left":{},"right":{}},"widgetTheme":{"defaultMode":{"backgroundColour":"#F0F0F5","theme":"THEME_TYPE_LIGHT"},"darkMode":{"backgroundColour":"#1B3028","theme":"THEME_TYPE_DARK"}}},"id":"adsOnlyMenuSimilarRestaurantWidgetUX4","gridElements":{"infoWithStyle":{"@type":"type.googleapis.com/swiggy.presentation.food.v2.SimilarRestaurantsInfoWithStyle","restaurants":[{"info":{"id":"218676","name":"Chai Point","cloudinaryImageId":"RX_THUMBNAIL/IMAGES/VENDOR/2025/6/26/f3cb6247-bdad-4c38-9a4e-4f2cfdc503b9_218676.jpg","locality":"Connaught Place","areaName":"Connaught Place","costForTwo":"\u20B9150 for two","cuisines":["Bakery","Beverages","Maharashtrian","Snacks","Street Food","South Indian","Punjabi","Chaat","Indian","American"],"avgRating":4.4,"parentId":"1607","avgRatingString":"4.4","totalRatingsString":"8.3K+","adTrackingId":"cid=c2fa6272-c42a-4869-9dec-81334ef5a240~p=0~adgrpid=c2fa6272-c42a-4869-9dec-81334ef5a240#ag3~mp=SWIGGY_IN~bl=FOOD~aet=RESTAURANT~aeid=218676~plpr=HOME#SIMILAR_ENTITY~eid=381a043a-b857-4add-b3be-6c0e89474011~srvts=1766115234172~arid=666909","sla":{"deliveryTime":24,"lastMileTravel":1.6,"serviceability":"SERVICEABLE","slaString":"20-25 mins","lastMileTravelString":"1.6 km","iconType":"ICON_TYPE_EMPTY"},"availability":{"nextCloseTime":"2025-12-20 05:29:00","opened":true},"badges":{},"isOpen":true,"badgesV2":{"entityBadges":{"textBased":{},"imageBased":{},"textExtendedBadges":{}}},"aggregatedDiscountInfoV3":{"header":"ITEMS","subHeader":"AT \u20B979","logoCtx":{"text":"BENEFITS"}},"differentiatedUi":{"displayType":"ADS_UI_DISPLAY_TYPE_ENUM_DEFAULT","differentiatedUiMediaDetails":{"mediaType":"ADS_MEDIA_ENUM_IMAGE"}},"reviewsSummary":{},"displayType":"RESTAURANT_DISPLAY_TYPE_DEFAULT","restaurantOfferPresentationInfo":{},"externalRatings":{"aggregatedRating":{"rating":"4.3","ratingCount":"1.3K+"},"source":"GOOGLE","sourceIconImageId":"v1704440323/google_ratings/rating_google_tag"},"ratingsDisplayPreference":"RATINGS_DISPLAY_PREFERENCE_SHOW_SWIGGY","campaignId":"c2fa6272-c42a-4869-9dec-81334ef5a240"},"analytics":{"screenName":"ux4-home-page","context":"{\\"adTrackingId\\":\\"cid=c2fa6272-c42a-4869-9dec-81334ef5a240~p=0~adgrpid=c2fa6272-c42a-4869-9dec-81334ef5a240#ag3~mp=SWIGGY_IN~bl=FOOD~aet=RESTAURANT~aeid=218676~plpr=HOME#SIMILAR_ENTITY~eid=381a043a-b857-4add-b3be-6c0e89474011~srvts=1766115234172~arid=666909~wn=adsOnlyMenuSimilarRestaurantWidget~wn=adsOnlyMenuSimilarRestaurantWidget\\",\\"tid\\":\\"1dc8dfbd-09b9-4970-88af-f1bda78b7b47\\"}","objectValue":"218676","impressionObjectName":"impression-similar-restaurant-item-ad","clickObjectName":"click-similar-restaurant-item-ad"}},{"info":{"id":"697263","name":"Handi 47","cloudinaryImageId":"f60a0596a76581b140ea724a02b7805b","locality":"Lakshmi Narayan St","areaName":"Karol Bagh","costForTwo":"\u20B9300 for two","cuisines":["North Indian"],"avgRating":4.2,"parentId":"417357","avgRatingString":"4.2","totalRatingsString":"791","adTrackingId":"cid=8646849f-b580-488f-bd7f-0a96829d32a0~p=1~adgrpid=8646849f-b580-488f-bd7f-0a96829d32a0#ag1~mp=SWIGGY_IN~bl=FOOD~aet=RESTAURANT~aeid=697263~plpr=HOME#SIMILAR_ENTITY~eid=2b6b355f-5b18-4cac-93ec-ca32374103d4~srvts=1766115234172~arid=666909","sla":{"deliveryTime":32,"lastMileTravel":2.8,"serviceability":"SERVICEABLE","slaString":"30-40 mins","lastMileTravelString":"2.8 km","iconType":"ICON_TYPE_EMPTY"},"availability":{"nextCloseTime":"2025-12-26 00:00:00","opened":true},"badges":{},"isOpen":true,"badgesV2":{"entityBadges":{"imageBased":{},"textExtendedBadges":{},"textBased":{}}},"aggregatedDiscountInfoV3":{"header":"50% OFF","logoCtx":{"text":"BENEFITS"},"footerText":"3 DEALS LEFT","secondaryHeaderType":"SECONDARY_HEADER_TYPE_USAGE_LIMIT_OFFER"},"differentiatedUi":{"displayType":"ADS_UI_DISPLAY_TYPE_ENUM_DEFAULT","differentiatedUiMediaDetails":{"mediaType":"ADS_MEDIA_ENUM_IMAGE"}},"reviewsSummary":{},"displayType":"RESTAURANT_DISPLAY_TYPE_DEFAULT","restaurantOfferPresentationInfo":{},"externalRatings":{"aggregatedRating":{"rating":"--"}},"ratingsDisplayPreference":"RATINGS_DISPLAY_PREFERENCE_SHOW_SWIGGY","campaignId":"8646849f-b580-488f-bd7f-0a96829d32a0"},"analytics":{"screenName":"ux4-home-page","context":"{\\"adTrackingId\\":\\"cid=8646849f-b580-488f-bd7f-0a96829d32a0~p=1~adgrpid=8646849f-b580-488f-bd7f-0a96829d32a0#ag1~mp=SWIGGY_IN~bl=FOOD~aet=RESTAURANT~aeid=697263~plpr=HOME#SIMILAR_ENTITY~eid=2b6b355f-5b18-4cac-93ec-ca32374103d4~srvts=1766115234172~arid=666909~wn=adsOnlyMenuSimilarRestaurantWidget~wn=adsOnlyMenuSimilarRestaurantWidget\\",\\"tid\\":\\"1dc8dfbd-09b9-4970-88af-f1bda78b7b47\\"}","objectValue":"697263","impressionObjectName":"impression-similar-restaurant-item-ad","clickObjectName":"click-similar-restaurant-item-ad"}},{"info":{"id":"939876","name":"Chai Dilli","cloudinaryImageId":"RX_THUMBNAIL/IMAGES/VENDOR/2024/8/12/de90ab66-072f-4d03-98d8-d13c644a0650_939876.jpg","locality":"OLD RAJINDER NAGAR","areaName":"Karol Bagh","costForTwo":"\u20B9200 for two","cuisines":["Beverages","Pizzas","Pastas","Fast Food","Burgers"],"avgRating":4.3,"veg":true,"parentId":"551143","avgRatingString":"4.3","totalRatingsString":"183","adTrackingId":"cid=922a7ba2-ba8a-44dd-b8ba-9cbcc34ec1ac~p=2~adgrpid=922a7ba2-ba8a-44dd-b8ba-9cbcc34ec1ac#ag1~mp=SWIGGY_IN~bl=FOOD~aet=RESTAURANT~aeid=939876~plpr=HOME#SIMILAR_ENTITY~eid=bb2d9362-ed66-4dca-af1e-6ccd6435a7e3~srvts=1766115234172~arid=666909","sla":{"deliveryTime":33,"lastMileTravel":5,"serviceability":"SERVICEABLE","slaString":"30-35 mins","lastMileTravelString":"5.0 km","iconType":"ICON_TYPE_EMPTY"},"availability":{"nextCloseTime":"2025-12-19 23:59:00","opened":true},"badges":{"imageBadges":[{"imageId":"v1695133679/badges/Pure_Veg111.png","description":"pureveg"}]},"isOpen":true,"badgesV2":{"entityBadges":{"imageBased":{"badgeObject":[{"attributes":{"description":"pureveg","imageId":"v1695133679/badges/Pure_Veg111.png"}}]},"textExtendedBadges":{},"textBased":{}}},"aggregatedDiscountInfoV3":{"header":"ITEMS","subHeader":"AT \u20B919","logoCtx":{"text":"BENEFITS"}},"differentiatedUi":{"displayType":"ADS_UI_DISPLAY_TYPE_ENUM_DEFAULT","differentiatedUiMediaDetails":{"mediaType":"ADS_MEDIA_ENUM_IMAGE"}},"reviewsSummary":{},"displayType":"RESTAURANT_DISPLAY_TYPE_DEFAULT","restaurantOfferPresentationInfo":{},"externalRatings":{"aggregatedRating":{"rating":"--"}},"ratingsDisplayPreference":"RATINGS_DISPLAY_PREFERENCE_SHOW_SWIGGY","campaignId":"922a7ba2-ba8a-44dd-b8ba-9cbcc34ec1ac"},"analytics":{"screenName":"ux4-home-page","context":"{\\"adTrackingId\\":\\"cid=922a7ba2-ba8a-44dd-b8ba-9cbcc34ec1ac~p=2~adgrpid=922a7ba2-ba8a-44dd-b8ba-9cbcc34ec1ac#ag1~mp=SWIGGY_IN~bl=FOOD~aet=RESTAURANT~aeid=939876~plpr=HOME#SIMILAR_ENTITY~eid=bb2d9362-ed66-4dca-af1e-6ccd6435a7e3~srvts=1766115234172~arid=666909~wn=adsOnlyMenuSimilarRestaurantWidget~wn=adsOnlyMenuSimilarRestaurantWidget\\",\\"tid\\":\\"1dc8dfbd-09b9-4970-88af-f1bda78b7b47\\"}","objectValue":"939876","impressionObjectName":"impression-similar-restaurant-item-ad","clickObjectName":"click-similar-restaurant-item-ad"}},{"info":{"id":"112346","name":"Aunty\'s Paranthe","cloudinaryImageId":"l8d63zn3czlht54ykil0","locality":"KAROL BAGH near bangal chicken corner","areaName":"Karol Bagh","costForTwo":"\u20B9200 for two","cuisines":["North Indian","South Indian"],"avgRating":4.2,"parentId":"15487","avgRatingString":"4.2","totalRatingsString":"9.8K+","adTrackingId":"cid=f770f9dd-7bce-4daa-b237-6f260d100516~p=3~adgrpid=f770f9dd-7bce-4daa-b237-6f260d100516#ag1~mp=SWIGGY_IN~bl=FOOD~aet=RESTAURANT~aeid=112346~plpr=HOME#SIMILAR_ENTITY~eid=0b52f14b-0401-48d0-8305-f50fb8e292de~srvts=1766115234172~arid=666909","sla":{"deliveryTime":37,"lastMileTravel":4.7,"serviceability":"SERVICEABLE","slaString":"35-40 mins","lastMileTravelString":"4.7 km","iconType":"ICON_TYPE_EMPTY"},"availability":{"nextCloseTime":"2025-12-19 15:00:00","opened":true},"badges":{},"isOpen":true,"badgesV2":{"entityBadges":{"textBased":{},"imageBased":{},"textExtendedBadges":{}}},"aggregatedDiscountInfoV3":{"header":"50% OFF","logoCtx":{"text":"BENEFITS"},"footerText":"3 DEALS LEFT","secondaryHeaderType":"SECONDARY_HEADER_TYPE_USAGE_LIMIT_OFFER"},"differentiatedUi":{"displayType":"ADS_UI_DISPLAY_TYPE_ENUM_DEFAULT","differentiatedUiMediaDetails":{"mediaType":"ADS_MEDIA_ENUM_IMAGE"}},"reviewsSummary":{},"displayType":"RESTAURANT_DISPLAY_TYPE_DEFAULT","restaurantOfferPresentationInfo":{},"externalRatings":{"aggregatedRating":{"rating":"3.1","ratingCount":"49"},"source":"GOOGLE","sourceIconImageId":"v1704440323/google_ratings/rating_google_tag"},"ratingsDisplayPreference":"RATINGS_DISPLAY_PREFERENCE_SHOW_SWIGGY","campaignId":"f770f9dd-7bce-4daa-b237-6f260d100516"},"analytics":{"screenName":"ux4-home-page","context":"{\\"adTrackingId\\":\\"cid=f770f9dd-7bce-4daa-b237-6f260d100516~p=3~adgrpid=f770f9dd-7bce-4daa-b237-6f260d100516#ag1~mp=SWIGGY_IN~bl=FOOD~aet=RESTAURANT~aeid=112346~plpr=HOME#SIMILAR_ENTITY~eid=0b52f14b-0401-48d0-8305-f50fb8e292de~srvts=1766115234172~arid=666909~wn=adsOnlyMenuSimilarRestaurantWidget~wn=adsOnlyMenuSimilarRestaurantWidget\\",\\"tid\\":\\"1dc8dfbd-09b9-4970-88af-f1bda78b7b47\\"}","objectValue":"112346","impressionObjectName":"impression-similar-restaurant-item-ad","clickObjectName":"click-similar-restaurant-item-ad"}},{"info":{"id":"1221537","name":"Boba Bhai - Bubble Tea & Korean Street Food","cloudinaryImageId":"RX_THUMBNAIL/IMAGES/VENDOR/2025/12/4/f156aec5-4281-45c6-be50-75861b8740d0_1221537.JPG","locality":"Patel Nagar","areaName":"East Patel Nagar","costForTwo":"\u20B9200 for two","cuisines":["Bubble Tea","Burger","Korean","Beverages","Fast Food","Juice and shake"],"avgRating":4.6,"parentId":"361235","avgRatingString":"4.6","totalRatingsString":"45","adTrackingId":"cid=7b0032b1-c921-4b20-be3d-5dfe53206357~p=4~adgrpid=7b0032b1-c921-4b20-be3d-5dfe53206357#ag4~mp=SWIGGY_IN~bl=FOOD~aet=RESTAURANT~aeid=1221537~plpr=HOME#SIMILAR_ENTITY~eid=73f493b1-14c3-4408-9eb8-dfcd963a8764~srvts=1766115234172~arid=666909","sla":{"deliveryTime":41,"lastMileTravel":6.8,"serviceability":"SERVICEABLE","slaString":"40-45 mins","lastMileTravelString":"6.8 km","iconType":"ICON_TYPE_EMPTY"},"availability":{"nextCloseTime":"2025-12-26 00:00:00","opened":true},"badges":{},"isOpen":true,"badgesV2":{"entityBadges":{"imageBased":{},"textExtendedBadges":{},"textBased":{}}},"aggregatedDiscountInfoV3":{"header":"ITEMS","subHeader":"AT \u20B9115","logoCtx":{"text":"BENEFITS"}},"differentiatedUi":{"displayType":"ADS_UI_DISPLAY_TYPE_ENUM_DEFAULT","differentiatedUiMediaDetails":{"mediaType":"ADS_MEDIA_ENUM_IMAGE"}},"reviewsSummary":{},"displayType":"RESTAURANT_DISPLAY_TYPE_DEFAULT","isNewlyOnboarded":true,"restaurantOfferPresentationInfo":{},"externalRatings":{"aggregatedRating":{"rating":"--"}},"ratingsDisplayPreference":"RATINGS_DISPLAY_PREFERENCE_SHOW_SWIGGY","campaignId":"7b0032b1-c921-4b20-be3d-5dfe53206357"},"analytics":{"screenName":"ux4-home-page","context":"{\\"adTrackingId\\":\\"cid=7b0032b1-c921-4b20-be3d-5dfe53206357~p=4~adgrpid=7b0032b1-c921-4b20-be3d-5dfe53206357#ag4~mp=SWIGGY_IN~bl=FOOD~aet=RESTAURANT~aeid=1221537~plpr=HOME#SIMILAR_ENTITY~eid=73f493b1-14c3-4408-9eb8-dfcd963a8764~srvts=1766115234172~arid=666909~wn=adsOnlyMenuSimilarRestaurantWidget~wn=adsOnlyMenuSimilarRestaurantWidget\\",\\"tid\\":\\"1dc8dfbd-09b9-4970-88af-f1bda78b7b47\\"}","objectValue":"1221537","impressionObjectName":"impression-similar-restaurant-item-ad","clickObjectName":"click-similar-restaurant-item-ad"}},{"info":{"id":"375547","name":"Josie\'s Coffee House","cloudinaryImageId":"gx8s42xrhtgawdv5l0tp","locality":"Rajinder Nagar","areaName":"Karol Bagh","costForTwo":"\u20B9300 for two","cuisines":["Beverages","Juices","Desserts"],"avgRating":4.4,"parentId":"111546","avgRatingString":"4.4","totalRatingsString":"981","adTrackingId":"cid=d3c58928-824e-4e06-b85c-7255714d0787~p=5~adgrpid=d3c58928-824e-4e06-b85c-7255714d0787#ag1~mp=SWIGGY_IN~bl=FOOD~aet=RESTAURANT~aeid=375547~plpr=HOME#SIMILAR_ENTITY~eid=17a2942e-8aa8-4647-ba54-67e6fcb53a5d~srvts=1766115234172~arid=666909","sla":{"deliveryTime":39,"lastMileTravel":5,"serviceability":"SERVICEABLE","slaString":"35-40 mins","lastMileTravelString":"5.0 km","iconType":"ICON_TYPE_EMPTY"},"availability":{"nextCloseTime":"2025-12-20 00:30:00","opened":true},"badges":{},"isOpen":true,"badgesV2":{"entityBadges":{"textBased":{},"imageBased":{},"textExtendedBadges":{}}},"aggregatedDiscountInfoV3":{"header":"50% OFF","logoCtx":{"text":"BENEFITS"},"footerText":"3 DEALS LEFT","secondaryHeaderType":"SECONDARY_HEADER_TYPE_USAGE_LIMIT_OFFER"},"differentiatedUi":{"displayType":"ADS_UI_DISPLAY_TYPE_ENUM_DEFAULT","differentiatedUiMediaDetails":{"mediaType":"ADS_MEDIA_ENUM_IMAGE"}},"reviewsSummary":{},"displayType":"RESTAURANT_DISPLAY_TYPE_DEFAULT","restaurantOfferPresentationInfo":{},"externalRatings":{"aggregatedRating":{"rating":"4.3","ratingCount":"686"},"source":"GOOGLE","sourceIconImageId":"v1704440323/google_ratings/rating_google_tag"},"ratingsDisplayPreference":"RATINGS_DISPLAY_PREFERENCE_SHOW_SWIGGY","campaignId":"d3c58928-824e-4e06-b85c-7255714d0787"},"analytics":{"screenName":"ux4-home-page","context":"{\\"adTrackingId\\":\\"cid=d3c58928-824e-4e06-b85c-7255714d0787~p=5~adgrpid=d3c58928-824e-4e06-b85c-7255714d0787#ag1~mp=SWIGGY_IN~bl=FOOD~aet=RESTAURANT~aeid=375547~plpr=HOME#SIMILAR_ENTITY~eid=17a2942e-8aa8-4647-ba54-67e6fcb53a5d~srvts=1766115234172~arid=666909~wn=adsOnlyMenuSimilarRestaurantWidget~wn=adsOnlyMenuSimilarRestaurantWidget\\",\\"tid\\":\\"1dc8dfbd-09b9-4970-88af-f1bda78b7b47\\"}","objectValue":"375547","impressionObjectName":"impression-similar-restaurant-item-ad","clickObjectName":"click-similar-restaurant-item-ad"}}],"widgetType":"WIDGET_TYPE_SRW","style":{}}}}}},{"card":{"card":{"@type":"type.googleapis.com/swiggy.presentation.food.v2.RestaurantLicenseInfo","type":"FSSAI","imageId":"fssai_final_edss9i","text":["License No. 13322005000901"]}}},{"card":{"card":{"@type":"type.googleapis.com/swiggy.presentation.food.v2.RestaurantAddress","name":"Oh!Hunger","area":"Paharganj","completeAddress":"1723, GF, Gali Pratap, Chuna Mandi, Paharganj New Delhi , KAROL BAGH, Central, Delhi-110055"}}}]}}}}],"firstOffsetRequest":true,"isQCLink":false},"tid":"1dc8dfbd-09b9-4970-88af-f1bda78b7b47","sid":"omwacd0d-0b54-4961-83b7-93696c74cc8c","deviceId":"4ca02714-b64e-01a4-087c-5853e40864e6","csrfToken":"ZGrrFfk8gIza-ncHx5TLi-Esw39hosN9I20Uon7E"}');


var $013aad5aab8528fa$var$useRestaurantMenu = function(resId) {
    var _useState = (0, $2nwvT._)((0, $dQFEZ.useState)(null), 2), resInfo = _useState[0], setResInfo = _useState[1];
    var _useState1 = (0, $2nwvT._)((0, $dQFEZ.useState)([]), 2), resMenu = _useState1[0], setResMenu = _useState1[1];
    (0, $dQFEZ.useEffect)(function() {
        var _swiggyAPI_data_cards, _swiggyAPI_data, _swiggyAPI_data_cards_find_groupedCard_cardGroupMap_REGULAR_cards_filter, _swiggyAPI_data_cards_find_groupedCard_cardGroupMap_REGULAR_cards, _swiggyAPI_data_cards_find_groupedCard_cardGroupMap_REGULAR, _swiggyAPI_data_cards_find_groupedCard_cardGroupMap, _swiggyAPI_data_cards_find_groupedCard, _swiggyAPI_data_cards_find, _swiggyAPI_data_cards1, _swiggyAPI_data1;
        if (!resId) return;
        // 🔹 Restaurant Info
        var restaurantInfo = (0, (/*@__PURE__*/$parcel$interopDefault($44dabe239e0cbff3$exports))) === null || (0, (/*@__PURE__*/$parcel$interopDefault($44dabe239e0cbff3$exports))) === void 0 ? void 0 : (_swiggyAPI_data = (0, (/*@__PURE__*/$parcel$interopDefault($44dabe239e0cbff3$exports))).data) === null || _swiggyAPI_data === void 0 ? void 0 : (_swiggyAPI_data_cards = _swiggyAPI_data.cards) === null || _swiggyAPI_data_cards === void 0 ? void 0 : _swiggyAPI_data_cards.find(function(item) {
            var _item_card_card_type, _item_card_card, _item_card;
            return item === null || item === void 0 ? void 0 : (_item_card = item.card) === null || _item_card === void 0 ? void 0 : (_item_card_card = _item_card.card) === null || _item_card_card === void 0 ? void 0 : (_item_card_card_type = _item_card_card["@type"]) === null || _item_card_card_type === void 0 ? void 0 : _item_card_card_type.includes("food.v2.Restaurant");
        });
        // 🔹 Menu Categories
        var menuCategories = ((0, (/*@__PURE__*/$parcel$interopDefault($44dabe239e0cbff3$exports))) === null || (0, (/*@__PURE__*/$parcel$interopDefault($44dabe239e0cbff3$exports))) === void 0 ? void 0 : (_swiggyAPI_data1 = (0, (/*@__PURE__*/$parcel$interopDefault($44dabe239e0cbff3$exports))).data) === null || _swiggyAPI_data1 === void 0 ? void 0 : (_swiggyAPI_data_cards1 = _swiggyAPI_data1.cards) === null || _swiggyAPI_data_cards1 === void 0 ? void 0 : (_swiggyAPI_data_cards_find = _swiggyAPI_data_cards1.find(function(card) {
            return card === null || card === void 0 ? void 0 : card.groupedCard;
        })) === null || _swiggyAPI_data_cards_find === void 0 ? void 0 : (_swiggyAPI_data_cards_find_groupedCard = _swiggyAPI_data_cards_find.groupedCard) === null || _swiggyAPI_data_cards_find_groupedCard === void 0 ? void 0 : (_swiggyAPI_data_cards_find_groupedCard_cardGroupMap = _swiggyAPI_data_cards_find_groupedCard.cardGroupMap) === null || _swiggyAPI_data_cards_find_groupedCard_cardGroupMap === void 0 ? void 0 : (_swiggyAPI_data_cards_find_groupedCard_cardGroupMap_REGULAR = _swiggyAPI_data_cards_find_groupedCard_cardGroupMap.REGULAR) === null || _swiggyAPI_data_cards_find_groupedCard_cardGroupMap_REGULAR === void 0 ? void 0 : (_swiggyAPI_data_cards_find_groupedCard_cardGroupMap_REGULAR_cards = _swiggyAPI_data_cards_find_groupedCard_cardGroupMap_REGULAR.cards) === null || _swiggyAPI_data_cards_find_groupedCard_cardGroupMap_REGULAR_cards === void 0 ? void 0 : (_swiggyAPI_data_cards_find_groupedCard_cardGroupMap_REGULAR_cards_filter = _swiggyAPI_data_cards_find_groupedCard_cardGroupMap_REGULAR_cards.filter(function(card) {
            var _card_card_card_type, _card_card_card, _card_card;
            return card === null || card === void 0 ? void 0 : (_card_card = card.card) === null || _card_card === void 0 ? void 0 : (_card_card_card = _card_card.card) === null || _card_card_card === void 0 ? void 0 : (_card_card_card_type = _card_card_card["@type"]) === null || _card_card_card_type === void 0 ? void 0 : _card_card_card_type.includes("ItemCategory");
        })) === null || _swiggyAPI_data_cards_find_groupedCard_cardGroupMap_REGULAR_cards_filter === void 0 ? void 0 : _swiggyAPI_data_cards_find_groupedCard_cardGroupMap_REGULAR_cards_filter.map(function(category) {
            var _category_card_card, _category_card, _category_card_card1, _category_card1, _category_card_card2, _category_card2;
            return {
                categoryId: category === null || category === void 0 ? void 0 : (_category_card = category.card) === null || _category_card === void 0 ? void 0 : (_category_card_card = _category_card.card) === null || _category_card_card === void 0 ? void 0 : _category_card_card.categoryId,
                title: category === null || category === void 0 ? void 0 : (_category_card1 = category.card) === null || _category_card1 === void 0 ? void 0 : (_category_card_card1 = _category_card1.card) === null || _category_card_card1 === void 0 ? void 0 : _category_card_card1.title,
                itemCards: (category === null || category === void 0 ? void 0 : (_category_card2 = category.card) === null || _category_card2 === void 0 ? void 0 : (_category_card_card2 = _category_card2.card) === null || _category_card_card2 === void 0 ? void 0 : _category_card_card2.itemCards) || []
            };
        })) || [];
        setResInfo(restaurantInfo);
        setResMenu(menuCategories);
    }, [
        resId
    ]);
    return {
        resInfo: resInfo,
        resMenu: resMenu
    };
};
var $013aad5aab8528fa$export$2e2bcd8739ae039 = $013aad5aab8528fa$var$useRestaurantMenu;


var $df4a656ccc867bbd$var$RestaurantMenu = function() {
    var _resInfo_card_card, _resInfo_card;
    var resId = (0, $8c3ad80f8a436e0f$export$99eaa27ddbbb95ef)().resId;
    var _useRestaurantMenu = (0, $013aad5aab8528fa$export$2e2bcd8739ae039)(resId), resInfo = _useRestaurantMenu.resInfo, resMenu = _useRestaurantMenu.resMenu;
    var _useState = (0, $2nwvT._)((0, $dQFEZ.useState)(null), 2), openIndex = _useState[0], setOpenIndex = _useState[1];
    if (!resInfo) return /*#__PURE__*/ (0, $iD4WH.jsx)((0, $45d0d9be49de331f$export$2e2bcd8739ae039), {});
    var _ref = (resInfo === null || resInfo === void 0 ? void 0 : (_resInfo_card = resInfo.card) === null || _resInfo_card === void 0 ? void 0 : (_resInfo_card_card = _resInfo_card.card) === null || _resInfo_card_card === void 0 ? void 0 : _resInfo_card_card.info) || {}, name = _ref.name, _ref_cuisines = _ref.cuisines, cuisines = _ref_cuisines === void 0 ? [] : _ref_cuisines, costForTwoMessage = _ref.costForTwoMessage, avgRating = _ref.avgRating, _ref_sla = _ref.sla, sla = _ref_sla === void 0 ? {} : _ref_sla, areaName = _ref.areaName;
    return /*#__PURE__*/ (0, $iD4WH.jsx)("div", {
        className: "min-h-screen bg-gray-100",
        children: /*#__PURE__*/ (0, $iD4WH.jsxs)("div", {
            className: "max-w-[900px] mx-auto px-4 py-6 pb-24",
            children: [
                /*#__PURE__*/ (0, $iD4WH.jsxs)("div", {
                    className: "bg-white rounded-2xl shadow-md p-6 mb-6 text-center",
                    children: [
                        /*#__PURE__*/ (0, $iD4WH.jsx)("h1", {
                            className: "text-2xl font-bold text-gray-800",
                            children: name
                        }),
                        /*#__PURE__*/ (0, $iD4WH.jsx)("p", {
                            className: "text-gray-600 mt-1",
                            children: cuisines.join(", ")
                        }),
                        /*#__PURE__*/ (0, $iD4WH.jsxs)("div", {
                            className: "flex flex-col items-center gap-2 mt-3 text-sm",
                            children: [
                                /*#__PURE__*/ (0, $iD4WH.jsxs)("span", {
                                    className: "px-3 py-1 bg-green-100 text-green-700 rounded-full font-semibold",
                                    children: [
                                        "\u2B50 ",
                                        avgRating
                                    ]
                                }),
                                /*#__PURE__*/ (0, $iD4WH.jsx)("span", {
                                    className: "text-gray-700",
                                    children: costForTwoMessage
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $iD4WH.jsxs)("p", {
                            className: "text-sm text-gray-500 mt-3",
                            children: [
                                sla === null || sla === void 0 ? void 0 : sla.minDeliveryTime,
                                "-",
                                sla === null || sla === void 0 ? void 0 : sla.maxDeliveryTime,
                                " mins \u2022 ",
                                areaName
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $iD4WH.jsx)("div", {
                    className: "bg-white rounded-2xl shadow overflow-hidden",
                    children: resMenu === null || resMenu === void 0 ? void 0 : resMenu.map(function(category, index) {
                        return /*#__PURE__*/ (0, $iD4WH.jsx)((0, $47c5ed635e286aeb$export$2e2bcd8739ae039), {
                            data: category,
                            isOpen: openIndex === index,
                            onToggle: function() {
                                return setOpenIndex(openIndex === index ? null : index);
                            }
                        }, index);
                    })
                })
            ]
        })
    });
};
var $df4a656ccc867bbd$export$2e2bcd8739ae039 = $df4a656ccc867bbd$var$RestaurantMenu;




var $iD4WH = parcelRequire("iD4WH");



var $5e84a52189ece5b1$var$Cart = function() {
    var cartItems = (0, $d7d37dc522b09008$export$2105062e25df4afe)(function(store) {
        return store.cart.items;
    });
    var dispatch = (0, $d7d37dc522b09008$export$8ad76b76a4c905f8)();
    return /*#__PURE__*/ (0, $iD4WH.jsxs)("div", {
        className: "min-h-screen bg-gray-50 py-10",
        children: [
            /*#__PURE__*/ (0, $iD4WH.jsx)("h1", {
                className: "text-4xl font-extrabold text-center mb-8",
                children: "\uD83D\uDED2 Your Cart"
            }),
            /*#__PURE__*/ (0, $iD4WH.jsxs)("div", {
                className: "w-10/12 md:w-8/12 lg:w-6/12 mx-auto bg-white rounded-2xl shadow-lg p-6",
                children: [
                    cartItems.length > 0 && /*#__PURE__*/ (0, $iD4WH.jsx)("div", {
                        className: "flex justify-center mb-6",
                        children: /*#__PURE__*/ (0, $iD4WH.jsx)("button", {
                            onClick: function() {
                                return dispatch((0, $8fe106648971a0a5$export$810121176e3e3671)());
                            },
                            className: "px-10 py-3 text-lg font-bold rounded-full bg-red-500 text-white hover:bg-red-600 active:scale-95 transition-all duration-200 shadow-md",
                            children: "Clear Cart"
                        })
                    }),
                    cartItems.length === 0 ? /*#__PURE__*/ (0, $iD4WH.jsxs)("div", {
                        className: "text-center py-10",
                        children: [
                            /*#__PURE__*/ (0, $iD4WH.jsx)("p", {
                                className: "text-xl text-gray-500 mb-3",
                                children: "Your cart is empty "
                            }),
                            /*#__PURE__*/ (0, $iD4WH.jsx)("p", {
                                className: "text-gray-400",
                                children: "Discover delicious items and add them to your cart!"
                            })
                        ]
                    }) : /*#__PURE__*/ (0, $iD4WH.jsx)("ul", {
                        className: "space-y-4",
                        children: cartItems.map(function(item, index) {
                            return /*#__PURE__*/ (0, $iD4WH.jsx)((0, $eda82bff2a7d3f82$export$2e2bcd8739ae039), {
                                menuInfo: item
                            }, (item === null || item === void 0 ? void 0 : item.id) || "cart-item-".concat(index));
                        })
                    })
                ]
            })
        ]
    });
};
var $5e84a52189ece5b1$export$2e2bcd8739ae039 = $5e84a52189ece5b1$var$Cart;




// Import configureStore from Redux Toolkit
// configureStore is the modern way to create a Redux store


// Creating the Redux store here
// Currently the store is empty because no reducer is passed
// Without reducers, the store does not hold or manage any state
var $87bd7f5e302073ee$var$appStore = (0, $ca04af99794d5fdc$export$7d8a5b498da695ac)({
    reducer: {
        cart: (0, $8fe106648971a0a5$export$2e2bcd8739ae039)
    }
});
var // Exporting the store
// So that the entire application can access it using the Provider
$87bd7f5e302073ee$export$2e2bcd8739ae039 = $87bd7f5e302073ee$var$appStore;



var $5ea17fa7399efe4b$var$Grocery = /*#__PURE__*/ (0, $dQFEZ.lazy)(function() {
    return (parcelRequire("4EGqz"));
});
/* ================= APP LAYOUT ================= */ var $5ea17fa7399efe4b$var$AppLayout = function() {
    var _useState = (0, $2nwvT._)((0, $dQFEZ.useState)(""), 2), userName = _useState[0], setUserName = _useState[1];
    (0, $dQFEZ.useEffect)(function() {
        setUserName("Riyanshu Sharma");
    }, []);
    return /*#__PURE__*/ (0, $iD4WH.jsx)((0, $d7d37dc522b09008$export$2881499e37b75b9a), {
        store: (0, $87bd7f5e302073ee$export$2e2bcd8739ae039),
        children: /*#__PURE__*/ (0, $iD4WH.jsxs)((0, $bec8559dd543f601$export$2e2bcd8739ae039).Provider, {
            value: {
                loggedInUser: userName,
                setUserName: setUserName
            },
            children: [
                /*#__PURE__*/ (0, $iD4WH.jsx)((0, $32ef10a07f569689$export$2e2bcd8739ae039), {}),
                /*#__PURE__*/ (0, $iD4WH.jsx)((0, $8c3ad80f8a436e0f$export$910ae8079b2c2852), {})
            ]
        })
    });
};
/* ================= ROUTER ================= */ var $5ea17fa7399efe4b$var$appRouter = (0, $fc41d09ddc03e3ec$export$1f3f55432a00e06d)([
    {
        path: "/",
        element: /*#__PURE__*/ (0, $iD4WH.jsx)($5ea17fa7399efe4b$var$AppLayout, {}),
        errorElement: /*#__PURE__*/ (0, $iD4WH.jsx)((0, $6723dc5d2e485afc$export$2e2bcd8739ae039), {}),
        children: [
            {
                path: "/",
                element: /*#__PURE__*/ (0, $iD4WH.jsx)((0, $cc0ae36f17da6a6a$export$2e2bcd8739ae039), {})
            },
            {
                path: "/about",
                element: /*#__PURE__*/ (0, $iD4WH.jsx)((0, $babf9d9b4d58e8a0$export$2e2bcd8739ae039), {})
            },
            {
                path: "/contact",
                element: /*#__PURE__*/ (0, $iD4WH.jsx)((0, $7dbfc2620234cc5c$export$2e2bcd8739ae039), {})
            },
            {
                path: "/cart",
                element: /*#__PURE__*/ (0, $iD4WH.jsx)((0, $5e84a52189ece5b1$export$2e2bcd8739ae039), {})
            },
            {
                path: "/grocery",
                element: /*#__PURE__*/ (0, $iD4WH.jsx)((0, $dQFEZ.Suspense), {
                    fallback: /*#__PURE__*/ (0, $iD4WH.jsx)((0, $45d0d9be49de331f$export$2e2bcd8739ae039), {}),
                    children: /*#__PURE__*/ (0, $iD4WH.jsx)($5ea17fa7399efe4b$var$Grocery, {})
                })
            },
            {
                path: "/restaurants/:resId",
                element: /*#__PURE__*/ (0, $iD4WH.jsx)((0, $df4a656ccc867bbd$export$2e2bcd8739ae039), {})
            }
        ]
    }
]);
/* ================= RENDER ================= */ var $5ea17fa7399efe4b$var$root = (0, (/*@__PURE__*/$parcel$interopDefault($8dbfa3fee6dc40a7$exports))).createRoot(document.getElementById("root"));
$5ea17fa7399efe4b$var$root.render(/*#__PURE__*/ (0, $iD4WH.jsx)((0, $fc41d09ddc03e3ec$export$323e4fc2fa4753fb), {
    router: $5ea17fa7399efe4b$var$appRouter
}));

})();
//# sourceMappingURL=path0.a4169656.js.map
